_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[101,27,28,29],{

/***/ "+2AQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_SELLER_EMAIL; });
/* unused harmony export SET_SALESMAN_ID */
/* unused harmony export UNSET_SALESMAN_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setSalesmanID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return unsetSalesmanID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sellerInfoReducer; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rJ95");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var GET_SELLER_EMAIL = 'GET_SELLER_EMAIL';
var SET_SALESMAN_ID = 'SET_SALESMAN_ID';
var UNSET_SALESMAN_ID = 'UNSET_SALESMAN_ID';
var setSalesmanID = function setSalesmanID(payload) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(SET_SALESMAN_ID, payload);
};
var unsetSalesmanID = function unsetSalesmanID() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(UNSET_SALESMAN_ID);
};
var initialState = {
  email: null,
  salesmanID: ''
};
var sellerInfoReducer = function sellerInfoReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case GET_SELLER_EMAIL:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          email: action.payload.sellerInfo ? action.payload.sellerInfo.email : null
        });
      }

    case SET_SALESMAN_ID:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          salesmanID: action.payload
        });
      }

    case UNSET_SALESMAN_ID:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          salesmanID: ''
        });
      }

    default:
      return state;
  }
};

/***/ }),

/***/ "+7q0":
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__("eN33"),
    defineProperty = __webpack_require__("Pz+s"),
    identity = __webpack_require__("zWgn");

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ "+pJz":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),

/***/ "/+ub":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var fails = __webpack_require__("fhLv");
var createElement = __webpack_require__("a4SZ");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "/ExG":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("l6h7");

var functionToString = Function.toString;

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "/WwO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useScriptLoader; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var cachedScripts = [];
function useScriptLoader(scriptUrl) {
  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(cachedScripts.includes(scriptUrl)),
      scriptLoaded = _useState[0],
      setScriptLoaded = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(false),
      scriptLoadingFailed = _useState2[0],
      setScriptLoadingFailed = _useState2[1];

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    if (scriptLoaded) {
      return;
    }

    var script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;
    new Promise(function (resolve, reject) {
      script.addEventListener('load', function () {
        return resolve(scriptUrl);
      });
      script.addEventListener('error', function (e) {
        return reject(e);
      });
    }).then(function () {
      cachedScripts.push(scriptUrl);
      setScriptLoaded(true);
    })["catch"](function () {
      script.remove();
      setScriptLoadingFailed(true);
    }); // $FlowFixMe

    document.body.appendChild(script);
  }, [scriptUrl]);
  return {
    scriptLoaded: scriptLoaded,
    scriptLoadingFailed: scriptLoadingFailed
  };
}

/***/ }),

/***/ "04nu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UPDATE_SELECTED_TRANSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_ADDITIONAL_TRANSPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_ADDITIONAL_TRANSPORTS_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_ADDITIONAL_TRANSPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SEARCH_CRITERIA_TRANSPORTS; });
/* unused harmony export SET_FILTERED_ADDITIONAL_TRANSPORTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TOGGLE_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DISABLE_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UNSELECT_ADDITIONAL_TRANSPORTS_FILTER_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UPDATE_FILTERED_RESULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SORT_ADDITIONAL_TRANSPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return clearAdditionalTransports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return fetchAdditionalTransports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isSameJourney; });
/* unused harmony export isSameTransport */
/* unused harmony export disableAdditionalTransportFilters */
/* unused harmony export toggleAdditionalTransportFilter */
/* unused harmony export unselectAdditionalTransportsFilterCategory */
/* unused harmony export updateAdditionalTransportsSort */
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nnRT");
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("70jX");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("rJ95");
/* harmony import */ var _booking_selector__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("uL19");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("NLwV");
/* harmony import */ var _transports_transports_reducer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("Fk4B");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}










var CLEAR_ADDITIONAL_TRANSPORTS = 'CLEAR_ADDITIONAL_TRANSPORTS';
var FETCH_ADDITIONAL_TRANSPORTS = 'FETCH_ADDITIONAL_TRANSPORTS';
var SEARCH_CRITERIA_TRANSPORTS = 'SEARCH_CRITERIA_TRANSPORTS';
var CREATE_ADDITIONAL_TRANSPORTS_FILTERS = 'CREATE_ADDITIONAL_TRANSPORTS_FILTERS';
var SET_FILTERED_ADDITIONAL_TRANSPORTS = 'SET_FILTERED_ADDITIONAL_TRANSPORTS';
var TOGGLE_FILTER = 'TOGGLE_FILTER';
var DISABLE_FILTERS = 'DISABLE_FILTERS';
var UNSELECT_ADDITIONAL_TRANSPORTS_FILTER_CATEGORY = 'UNSELECT_ADDITIONAL_TRANSPORTS_FILTER_CATEGORY';
var UPDATE_FILTERED_RESULTS = 'UPDATE_FILTERED_RESULTS';
var SORT_ADDITIONAL_TRANSPORTS = 'SORT_ADDITIONAL_TRANSPORTS';
var UPDATE_SELECTED_TRANSPORT = 'UPDATE_SELECTED_TRANSPORT';

function _toggleFilter(filter, getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(TOGGLE_FILTER, {
    additionalTransports: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_7__[/* getAdditionalTransports */ "f"])(getState()),
    filter: filter
  });
}

function _disableFilters(filters, getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(DISABLE_FILTERS, {
    additionalTransports: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_7__[/* getAdditionalTransports */ "f"])(getState()),
    filters: filters
  });
}

function _unselectFiltersCategory(category, getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(UNSELECT_ADDITIONAL_TRANSPORTS_FILTER_CATEGORY, {
    additionalTransports: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_7__[/* getAdditionalTransports */ "f"])(getState()),
    category: category
  });
}

function _updateFilteredTransports(getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(UPDATE_FILTERED_RESULTS, {
    additionalTransports: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_7__[/* getAdditionalTransports */ "f"])(getState()),
    filters: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_7__[/* getAdditionalTransportsFilters */ "h"])(getState())
  });
}

function _runAdditionalTransportsQuery(_ref) {
  var proposalId = _ref.proposalId,
      appContext = _ref.appContext,
      searchCriterias = _ref.searchCriterias;
  var query = "\n    {\n      additionalTransports(proposalId : \"".concat(proposalId, "\" ").concat(searchCriterias ? ", searchCriteria: ".concat(Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_8__[/* graphqlify */ "d"])(searchCriterias)) : '', ") {\n        inbound { \n          transportInfo {\n            id\n            isMultiTransport\n            price {\n              ...priceDetails\n            }\n            totalDifferentialPrice {\n              ...priceDetails\n            }\n            way\n          }\n          journey {\n            ...transportsDetails \n          }\n        }\n        outboundList {  \n          transportInfo {\n            id\n            isMultiTransport\n            price {\n              ...priceDetails\n            }\n            totalDifferentialPrice {\n              ...priceDetails\n            }\n            way\n          }\n          journey {\n            ...transportsDetails \n          }\n        }\n       \n      }\n    }\n    ").concat(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_3__[/* transportDetailsFragment */ "q"], "\n    ").concat(Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_3__[/* getPriceDetailFragment */ "h"])(appContext.locale), "\n  ");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].runNoCacheQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__[/* PROPOSAL_GET_ADDITIONAL_TRANSPORT */ "od"]
  });
}

function updateAdditionalTransportsSort(sorter) {
  return function (dispatch, getState) {
    var additionalTransports = Object(_booking_selector__WEBPACK_IMPORTED_MODULE_7__[/* getAdditionalTransports */ "f"])(getState());
    var filters = Object(_booking_selector__WEBPACK_IMPORTED_MODULE_7__[/* getAdditionalTransportsFilters */ "h"])(getState());
    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(SORT_ADDITIONAL_TRANSPORTS, {
      additionalTransports: additionalTransports,
      filters: filters,
      sorter: sorter
    }));
  };
}

function clearAdditionalTransports() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(CLEAR_ADDITIONAL_TRANSPORTS);
}

var formatProposalLegacyTransportAsAlternative = function formatProposalLegacyTransportAsAlternative(_ref2) {
  var _proposal$price, _proposal$price$total, _proposal$price2, _proposal$price2$tota, _proposal$price3, _proposal$price3$tota, _proposal$price4, _proposal$price4$tota, _proposal$transports, _proposal$transports2;

  var proposal = _ref2.proposal,
      appContext = _ref2.appContext;

  if (!proposal) {
    return null;
  }

  var transportInfo = {
    id: proposal.id,
    // this id is added for unit testing - proposal id is not similar to AdditionalTransport id
    price: Object(_transports_transports_reducer__WEBPACK_IMPORTED_MODULE_9__[/* getTotalDifferentialPrice */ "b"])((_proposal$price = proposal.price) === null || _proposal$price === void 0 ? void 0 : (_proposal$price$total = _proposal$price.total) === null || _proposal$price$total === void 0 ? void 0 : _proposal$price$total.value, (_proposal$price2 = proposal.price) === null || _proposal$price2 === void 0 ? void 0 : (_proposal$price2$tota = _proposal$price2.totalWithoutTransport) === null || _proposal$price2$tota === void 0 ? void 0 : _proposal$price2$tota.value, appContext.locale),
    totalDifferentialPrice: Object(_transports_transports_reducer__WEBPACK_IMPORTED_MODULE_9__[/* getTotalDifferentialPrice */ "b"])((_proposal$price3 = proposal.price) === null || _proposal$price3 === void 0 ? void 0 : (_proposal$price3$tota = _proposal$price3.totalWithoutTransport) === null || _proposal$price3$tota === void 0 ? void 0 : _proposal$price3$tota.value, (_proposal$price4 = proposal.price) === null || _proposal$price4 === void 0 ? void 0 : (_proposal$price4$tota = _proposal$price4.totalWithoutTransport) === null || _proposal$price4$tota === void 0 ? void 0 : _proposal$price4$tota.value, appContext.locale)
  };
  return {
    inbound: {
      transportInfo: _objectSpread(_objectSpread({}, transportInfo), {}, {
        way: 'INBOUND'
      }),
      journey: proposal === null || proposal === void 0 ? void 0 : (_proposal$transports = proposal.transports) === null || _proposal$transports === void 0 ? void 0 : _proposal$transports.inbound
    },
    outboundList: [{
      transportInfo: _objectSpread(_objectSpread({}, transportInfo), {}, {
        way: 'OUTBOUND'
      }),
      journey: proposal === null || proposal === void 0 ? void 0 : (_proposal$transports2 = proposal.transports) === null || _proposal$transports2 === void 0 ? void 0 : _proposal$transports2.outbound
    }]
  };
};

var isSameJourney = function isSameJourney(firstTransport, secondTransport) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (firstTransport && firstTransport.journey && secondTransport && secondTransport.journey) {
    var _firstTransport$journ, _secondTransport$jour, _firstTransport$journ2, _secondTransport$jour2;

    var firstTravelSections = (_firstTransport$journ = firstTransport.journey) === null || _firstTransport$journ === void 0 ? void 0 : _firstTransport$journ.travelSections;
    var secondTravelSections = (_secondTransport$jour = secondTransport.journey) === null || _secondTransport$jour === void 0 ? void 0 : _secondTransport$jour.travelSections;
    var haveSameTravelSections = (firstTravelSections === null || firstTravelSections === void 0 ? void 0 : firstTravelSections.length) === (secondTravelSections === null || secondTravelSections === void 0 ? void 0 : secondTravelSections.length) && ((firstTravelSections === null || firstTravelSections === void 0 ? void 0 : firstTravelSections.length) === 0 || firstTravelSections.every(function (currentValue, index) {
      var selectedValue = secondTravelSections[index];
      return lodash_isEqual__WEBPACK_IMPORTED_MODULE_2___default()(currentValue, selectedValue);
    }));
    var haveSameDurationInMin = ((_firstTransport$journ2 = firstTransport.journey) === null || _firstTransport$journ2 === void 0 ? void 0 : _firstTransport$journ2.durationInMin) === ((_secondTransport$jour2 = secondTransport.journey) === null || _secondTransport$jour2 === void 0 ? void 0 : _secondTransport$jour2.durationInMin);
    return haveSameTravelSections && haveSameDurationInMin;
  }

  return defaultValue;
};

var isSameTransport = function isSameTransport(_ref3) {
  var transportId = _ref3.transportId,
      currentTransport = _ref3.currentTransport,
      selectedTransport = _ref3.selectedTransport,
      _ref3$defaultValue = _ref3.defaultValue,
      defaultValue = _ref3$defaultValue === void 0 ? true : _ref3$defaultValue;

  if (currentTransport && selectedTransport) {
    var sameInbound = isSameJourney(currentTransport === null || currentTransport === void 0 ? void 0 : currentTransport.inbound, selectedTransport === null || selectedTransport === void 0 ? void 0 : selectedTransport.inbound, defaultValue);

    if (sameInbound && transportId) {
      var _selectedTransport$ou;

      var currentOutbound = currentTransport === null || currentTransport === void 0 ? void 0 : currentTransport.outboundList[0];
      var selectedOutbound = selectedTransport === null || selectedTransport === void 0 ? void 0 : (_selectedTransport$ou = selectedTransport.outboundList) === null || _selectedTransport$ou === void 0 ? void 0 : _selectedTransport$ou.find(function (transport) {
        return transport.transportInfo.id === transportId;
      });
      return currentOutbound && selectedOutbound ? isSameJourney(currentOutbound, selectedOutbound, false) : false;
    }

    return sameInbound;
  }

  return defaultValue;
};

function fetchAdditionalTransports(_ref4) {
  var proposal = _ref4.proposal,
      appContext = _ref4.appContext,
      searchCriterias = _ref4.searchCriterias;
  return function (dispatch) {
    dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(FETCH_ADDITIONAL_TRANSPORTS));
    var defaultTransport = formatProposalLegacyTransportAsAlternative({
      proposal: proposal,
      appContext: appContext
    });
    return _runAdditionalTransportsQuery({
      proposalId: proposal.id,
      appContext: appContext,
      searchCriterias: searchCriterias
    }).then(function (_ref5) {
      var additionalTransports = _ref5.additionalTransports;
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(SEARCH_CRITERIA_TRANSPORTS, searchCriterias));
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__["resolve"])(FETCH_ADDITIONAL_TRANSPORTS), {
        additionalTransports: additionalTransports,
        selectedTransport: defaultTransport
      }));
    }, function (error) {
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__["reject"])(FETCH_ADDITIONAL_TRANSPORTS), error));
    });
  };
}

function toggleAdditionalTransportFilter(filter) {
  return function (dispatch, getState) {
    dispatch(_toggleFilter(filter, getState));
    dispatch(_updateFilteredTransports(getState));
  };
}

function disableAdditionalTransportFilters(filters) {
  return function (dispatch, getState) {
    dispatch(_disableFilters(filters, getState));
    dispatch(_updateFilteredTransports(getState));
  };
}

function unselectAdditionalTransportsFilterCategory(category) {
  return function (dispatch, getState) {
    dispatch(_unselectFiltersCategory(category, getState));
    dispatch(_updateFilteredTransports(getState));
  };
}



/***/ }),

/***/ "05L9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WEB_CALLBACK_LINK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WEB_CALLBACK_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FooterContacts; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_tracking_footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("9sjr");
/* harmony import */ var _utils_regex_RegexHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("9BC+");
/* harmony import */ var _frameworks_block_link_BlockLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Onl6");
/* harmony import */ var _widgets_webcallback_WebCallbackBlockLink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("39HS");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;






var WEB_CALLBACK_LINK = 'callMeBack';
var WEB_CALLBACK_ENABLED = _config__WEBPACK_IMPORTED_MODULE_1___default.a.get('freespee.enabled');
var FooterContacts = function FooterContacts(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;
  return __jsx("div", {
    className: "pt-px20 relative w-full z-1 lg:border-b-1 border-gray-dark md:pb-px20"
  }, __jsx("ul", {
    className: "reset-list flex flex-col md:flex-row md:justify-between md:-mx-px5"
  }, items.map(function (_ref2) {
    var href = _ref2.href,
        text = _ref2.text,
        type = _ref2.type;
    var texts = (text || []).map(function (txt) {
      // the phone number is always written in ltr, even in he-IL (which is rtl)
      return Object(_utils_regex_RegexHelper__WEBPACK_IMPORTED_MODULE_3__[/* isPhoneNumber */ "c"])(txt) ? __jsx("span", {
        dir: "ltr"
      }, txt) : txt;
    });
    return __jsx("li", {
      className: "border-b-1 md:border-b-0 border-gray-dark mb-px10 md:mb-0 md:mx-px5 pb-px10 md:pb-0 last-child-mb-0 last-child-border-b-0",
      key: type
    }, type === WEB_CALLBACK_LINK && WEB_CALLBACK_ENABLED ? __jsx(_widgets_webcallback_WebCallbackBlockLink__WEBPACK_IMPORTED_MODULE_5__[/* WebCallbackBlockLink */ "a"], {
      icon: type,
      trackingData: {
        actionGA: 'footer'
      },
      texts: texts,
      theme: "default"
    }) : __jsx(_frameworks_block_link_BlockLink__WEBPACK_IMPORTED_MODULE_4__[/* BlockLink */ "a"], {
      icon: type,
      target: "_blank",
      texts: texts,
      trackingData: {
        actionGA: 'footer',
        labelGA: Object(_utils_tracking_footer__WEBPACK_IMPORTED_MODULE_2__[/* formatFooterLabelName */ "a"])(type)
      },
      url: href
    }));
  })));
};

/***/ }),

/***/ "06Jt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_ADDITIONAL_ACCOMMODATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_ADDITIONAL_ACCOMMODATIONS; });
/* unused harmony export SET_FILTERED_ADDITIONAL_ACCOMMODATIONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TOGGLE_ACCOMMODATIONS_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UPDATE_FILTERED_ACCOMMODATIONS_RESULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return clearAdditionalAccommodations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchAdditionalAccommodations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return toggleAdditionalAccommodationFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return unselectAdditionalAccommodationsFilterCategory; });
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("70jX");
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("oL6k");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("rJ95");
/* harmony import */ var _booking_selector__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("uL19");









var CLEAR_ADDITIONAL_ACCOMMODATIONS = 'CLEAR_ADDITIONAL_ACCOMMODATIONS';
var FETCH_ADDITIONAL_ACCOMMODATIONS = 'FETCH_ADDITIONAL_ACCOMMODATIONS';
var CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS = 'CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS';
var SET_FILTERED_ADDITIONAL_ACCOMMODATIONS = 'SET_FILTERED_ADDITIONAL_ACCOMMODATIONS';
var TOGGLE_ACCOMMODATIONS_FILTER = 'TOGGLE_ACCOMMODATIONS_FILTER';
var UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY = 'UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY';
var UPDATE_FILTERED_ACCOMMODATIONS_RESULTS = 'UPDATE_FILTERED_ACCOMMODATIONS_RESULTS';

function _getSelectedProposal(state) {
  if (!state) return null;
  var proposals = Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getProposals */ "u"])(state) || [];
  var resort = Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getCurrentResort */ "l"])(state);
  var selectedProposal = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["find"])(proposals, {
    id: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getSelectedProposalId */ "z"])(state)
  }) || Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_3__[/* getDefaultProposal */ "f"])(proposals, resort);
  return selectedProposal;
}

function _createAdditionalAccommodationsFilters(_ref) {
  var proposal = _ref.proposal,
      resort = _ref.resort,
      getState = _ref.getState,
      i18n = _ref.i18n,
      shouldPreselectFilters = _ref.shouldPreselectFilters;
  var state = getState();
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS, {
    additionalAccommodations: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getAdditionalAccommodations */ "c"])(state),
    selectedProposal: proposal,
    i18n: i18n,
    shouldPreselectFilters: shouldPreselectFilters,
    resort: resort
  });
}

function _toggleFilter(filter, getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(TOGGLE_ACCOMMODATIONS_FILTER, {
    additionalAccommodations: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getAdditionalAccommodations */ "c"])(getState()),
    selectedProposal: _getSelectedProposal(getState()),
    filter: filter
  });
}

function _unselectFiltersCategory(category, getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY, {
    additionalAccommodations: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getAdditionalAccommodations */ "c"])(getState()),
    selectedProposal: _getSelectedProposal(getState()),
    category: category
  });
}

function _updateFilterAccommodations(getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(UPDATE_FILTERED_ACCOMMODATIONS_RESULTS, {
    additionalAccommodations: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getAdditionalAccommodations */ "c"])(getState()),
    selectedProposal: _getSelectedProposal(getState()),
    filters: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getAdditionalAccommodationsFilters */ "e"])(getState())
  });
}

function _runAdditionalAccommodationsQuery(_ref2) {
  var proposalId = _ref2.proposalId,
      appContext = _ref2.appContext,
      duration = _ref2.duration,
      _ref2$selectedRate = _ref2.selectedRate,
      selectedRate = _ref2$selectedRate === void 0 ? '' : _ref2$selectedRate,
      _ref2$roomsArrangemen = _ref2.roomsArrangement,
      roomsArrangement = _ref2$roomsArrangemen === void 0 ? [] : _ref2$roomsArrangemen;
  var query = "\n    {\n      additionalAccommodations(proposalId: \"".concat(proposalId, "\", roomsArrangement:").concat(Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_4__[/* graphqlify */ "d"])(roomsArrangement), ") {\n        id\n        totalDifferentialPrice(selectedRate: \"").concat(selectedRate, "\") {\n          ...priceDetails\n        }\n        differentialPriceByNight(nightsNumber: ").concat(duration, ", selectedRate: \"").concat(selectedRate, "\") {\n          formattedValue(precision: 0)\n          value\n        }\n        remainingStock\n        accommodations {\n          id\n          categories { id label }\n          category\n          categoryId\n          comfortType\n          connectingRoom\n          description\n          label\n          maxCapacity\n          roomType\n          media {\n            photos {\n              url\n            }\n          }\n          minCapacity\n          occupation\n          quantity\n          occupancies {\n            baby_count\n          }\n          outsideFacilities {\n            id\n            label\n          }\n          bathroomEquipments {\n            id\n            label\n          }\n          equipments {\n            id\n            label\n          }\n          services { id label }\n          strengths { id label }\n          surface\n          view { id label }\n          reducedMobilityAccess\n          attendeesDistribution {\n            id\n            quantity\n            attendees {\n              id\n              type\n              birthdate\n              customerId\n            }\n          }\n        }\n      }\n      config {\n        filters {\n          configuration {\n            categoryTitle\n            simpleRoom\n            simpleRooms\n            separatedRooms\n            separatedRooms3\n          }\n          comfort {\n            categoryTitle\n          }\n          extraFeatures {\n            categoryTitle\n          }\n          reducedMobility\n        }\n      }\n    }\n    ").concat(Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_2__[/* getPriceDetailFragment */ "h"])(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(appContext, 'locale')), "\n  ");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"].runNoCacheQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_6__[/* PROPOSAL_GET_ADDITIONAL_ACCOMMODATIONS */ "nd"]
  });
}

function clearAdditionalAccommodations() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(CLEAR_ADDITIONAL_ACCOMMODATIONS);
}

function fetchAdditionalAccommodations(_ref3) {
  var proposal = _ref3.proposal,
      resort = _ref3.resort,
      appContext = _ref3.appContext,
      _ref3$roomsArrangemen = _ref3.roomsArrangement,
      roomsArrangement = _ref3$roomsArrangemen === void 0 ? [] : _ref3$roomsArrangemen,
      _ref3$shouldPreselect = _ref3.shouldPreselectFilters,
      shouldPreselectFilters = _ref3$shouldPreselect === void 0 ? true : _ref3$shouldPreselect;
  var id = proposal.id,
      duration = proposal.duration,
      selectedRate = proposal.price.selectedRate;
  return function (dispatch, getState) {
    dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(FETCH_ADDITIONAL_ACCOMMODATIONS));
    return _runAdditionalAccommodationsQuery({
      proposalId: id,
      appContext: appContext,
      duration: duration,
      selectedRate: selectedRate,
      roomsArrangement: roomsArrangement
    }).then(function (_ref4) {
      var additionalAccommodations = _ref4.additionalAccommodations,
          i18n = _ref4.config;
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_ADDITIONAL_ACCOMMODATIONS), {
        additionalAccommodations: additionalAccommodations
      }));
      dispatch(_createAdditionalAccommodationsFilters({
        proposal: proposal,
        resort: resort,
        getState: getState,
        i18n: i18n,
        shouldPreselectFilters: shouldPreselectFilters
      }));
      dispatch(_updateFilterAccommodations(getState));
    })["catch"](function (error) {
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["reject"])(FETCH_ADDITIONAL_ACCOMMODATIONS), error));
    });
  };
}

function toggleAdditionalAccommodationFilter(filter) {
  return function (dispatch, getState) {
    dispatch(_toggleFilter(filter, getState));
    dispatch(_updateFilterAccommodations(getState));
  };
}

function unselectAdditionalAccommodationsFilterCategory(category) {
  return function (dispatch, getState) {
    dispatch(_unselectFiltersCategory(category, getState));
    dispatch(_updateFilterAccommodations(getState));
  };
}



/***/ }),

/***/ "0JpG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useGQL; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Ub5k");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var noop = function noop(e) {
  return e;
};

function reducer(state, action) {
  switch (action.type) {
    case 'loading':
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: true
      });

    case 'data':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: action.data,
        isLoading: false
      });

    case 'error':
      return _objectSpread(_objectSpread({}, state), {}, {
        error: action.error,
        isLoading: false
      });

    default:
      throw new Error("Unknown action type! [".concat(action.type, "]"));
  }
}

function useGQL() {
  for (var _len = arguments.length, queries = new Array(_len), _key = 0; _key < _len; _key++) {
    queries[_key] = arguments[_key];
  }

  var initialState = {
    data: null,
    error: null,
    isLoading: true
  };

  var _useReducer = Object(react__WEBPACK_IMPORTED_MODULE_1__["useReducer"])(reducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_1__["useContext"])(_client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"]);
  Object(react__WEBPACK_IMPORTED_MODULE_1__["useEffect"])(function () {
    dispatch({
      type: 'loading'
    });
    var promises = queries.filter(function (query) {
      return !query.ignore;
    }).map(function (_ref) {
      var query = _ref.query,
          _ref$cache = _ref.cache,
          cache = _ref$cache === void 0 ? false : _ref$cache,
          _ref$map = _ref.map,
          map = _ref$map === void 0 ? noop : _ref$map,
          queryOptions = _ref.queryOptions,
          catchCallback = _ref["catch"];
      var promise = cache ? _graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, queryOptions) : _graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runNoCacheQuery(query, appContext, queryOptions);

      if (catchCallback) {
        return promise.then(map)["catch"](catchCallback);
      }

      return promise.then(map);
    });
    Promise.all(promises).then(function (datas) {
      var data = queries.length === 1 ? datas[0] : datas.reduce(function (acc, item) {
        return _objectSpread(_objectSpread({}, acc), item);
      }, {});
      dispatch({
        type: 'data',
        data: data
      });
    })["catch"](function (error) {
      dispatch({
        type: 'error',
        error: error
      });
    });
  }, queries.map(function (q) {
    return q.query + (q.ignore ? 'T' : 'F');
  })); // useEffect run at each render on the react lifecycle. Here the useEffect should run only if the query OR the ignore param change!
  // $FlowFixMe

  return state;
}

/***/ }),

/***/ "0x7Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Toast; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _portal_Portal_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("Yd/I");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("/Mt0");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("qBqs");
/* harmony import */ var _portal_Portal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("3uBn");
/* harmony import */ var _text_Text__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("qqKu");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var Toast = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_1__["forwardRef"])(function (props, ref) {
  var _classnames;

  var _useResponsive = Object(_utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_7__[/* useResponsive */ "b"])(),
      isAppMounted = _useResponsive.isAppMounted;

  if (!isAppMounted) {
    return null;
  }

  var className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].WATER_GREEN : _props$color,
      _props$icon = props.icon,
      icon = _props$icon === void 0 ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].CONFIRMATION : _props$icon,
      _props$label = props.label,
      label = _props$label === void 0 ? '' : _props$label,
      onClose = props.onClose,
      _props$portalName = props.portalName,
      portalName = _props$portalName === void 0 ? _portal_Portal_constants__WEBPACK_IMPORTED_MODULE_5__[/* OVER_BOT */ "d"] : _props$portalName,
      style = props.style,
      visible = props.visible;

  if (!visible) {
    return null;
  }

  return __jsx(_portal_Portal__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"], {
    name: portalName
  }, __jsx("button", {
    "aria-disabled": !visible,
    "aria-hidden": !visible,
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, 'bg-white fixed flex font-bold items-center p-px5 reset-button rtl:right-0 rounded-small transition-all', (_classnames = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_classnames, "text-".concat(String(color)), color), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_classnames, 'rtl:translate-x-100', !visible), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_classnames, 'rtl:mr-px40 shadow-md', visible), _classnames)),
    "data-testid": "Toast",
    onClick: onClose,
    ref: ref,
    style: _objectSpread({
      top: 150,
      width: 280
    }, style),
    tabIndex: visible ? 0 : -1,
    type: "button"
  }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_8__[/* Icon */ "a"], {
    className: "flex-shrink-0 m-px5",
    name: icon,
    width: "1.875rem"
  }), __jsx(_text_Text__WEBPACK_IMPORTED_MODULE_10__[/* Text */ "a"], {
    className: "flex-1 rtl:mr-px25 p-px5",
    text: Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "g"])(label)
  }), __jsx("div", {
    className: "absolute leading-none p-px10 rtl:right-0 top-0"
  }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_8__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].CROSS,
    width: "0.625rem"
  }))));
});

/***/ }),

/***/ "1P7A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFormattedLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCursorClass; });
function getFormattedLabel() {
  var placeholder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var isRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!placeholder) return '';
  return isRequired ? "".concat(placeholder, "*") : placeholder;
}
function getCursorClass(_ref) {
  var hasPointer = _ref.hasPointer,
      isDisabled = _ref.isDisabled,
      isLoading = _ref.isLoading,
      isReadOnly = _ref.isReadOnly;
  if (isDisabled) return 'cursor-not-allowed';
  if (isReadOnly) return 'cursor-default';
  if (isLoading) return 'cursor-wait';
  return hasPointer ? 'cursor-pointer' : '';
}

/***/ }),

/***/ "1Wgj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActiveIndexes; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("pWxA");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("pKEY");
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react_lazyload__WEBPACK_IMPORTED_MODULE_10__);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




var ActiveIndexes = /*#__PURE__*/function (_Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(ActiveIndexes, _Component);

  var _super = _createSuper(ActiveIndexes);

  function ActiveIndexes() {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(this, ActiveIndexes);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_this), "state", {
      activeIndexes: _this.props.activeIndexes || [],
      isPristine: true,
      lastIndex: 0
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_this), "clear", function () {
      _this.setState(function (prevState) {
        if (prevState.activeIndexes.length) return {
          activeIndexes: []
        };
      });
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_this), "update", function (index) {
      var _this$props$onUpdate = _this.props.onUpdate,
          onUpdate = _this$props$onUpdate === void 0 ? lodash__WEBPACK_IMPORTED_MODULE_9__["noop"] : _this$props$onUpdate;
      var activeIndexes = _this.state.activeIndexes;
      var newActiveIndexes = activeIndexes.includes(index) ? _this.removeIndex(activeIndexes, index) : _this.addIndex(activeIndexes, index);

      _this.setState({
        activeIndexes: newActiveIndexes,
        isPristine: false,
        lastIndex: index
      }, function () {
        onUpdate(index);
        Object(react_lazyload__WEBPACK_IMPORTED_MODULE_10__["forceCheck"])();
      });
    });

    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(ActiveIndexes, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props$activeInd = this.props.activeIndexes,
          activeIndexes = _this$props$activeInd === void 0 ? [] : _this$props$activeInd;

      if (!Object(lodash__WEBPACK_IMPORTED_MODULE_9__["isEqual"])(prevProps.activeIndexes, activeIndexes)) {
        var lastIndex = activeIndexes[activeIndexes.length - 1];
        this.setState({
          activeIndexes: activeIndexes,
          lastIndex: lastIndex >= 0 ? lastIndex : prevState.lastIndex
        });
      }
    }
  }, {
    key: "addIndex",
    value: function addIndex(activeIndexes, index) {
      var hasMultipleIndexEnabled = this.props.hasMultipleIndexEnabled;

      if (hasMultipleIndexEnabled) {
        return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(activeIndexes), [index]);
      }

      return [index];
    }
  }, {
    key: "removeIndex",
    value: function removeIndex(activeIndexes, index) {
      var hasNoIndexEnabled = this.props.hasNoIndexEnabled;

      if (hasNoIndexEnabled || activeIndexes.length > 1) {
        return Object(lodash__WEBPACK_IMPORTED_MODULE_9__["pull"])(activeIndexes, index);
      }

      return activeIndexes;
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        activeIndexes: this.state.activeIndexes,
        clear: this.clear,
        isPristine: this.state.isPristine,
        lastIndex: this.state.lastIndex,
        update: this.update
      });
    }
  }]);

  return ActiveIndexes;
}(react__WEBPACK_IMPORTED_MODULE_8__["Component"]);

Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(ActiveIndexes, "defaultProps", {
  activeIndexes: [],
  hasMultipleIndexEnabled: false,
  hasNoIndexEnabled: false
});

/***/ }),

/***/ "1YFU":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "1a7w":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__("wEFx");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "1bWg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setKids; });
/* unused harmony export updateKid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resetKids; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setKidsWithoutClearProposals; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wQ38");
/* eslint-disable flowtype/no-weak-types */



function setKids(kids) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_KIDS */ "c"], {
    kids: kids
  });
}

function setKidsWithoutClearProposals(kids) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS */ "d"], {
    kids: kids
  });
}

function resetKids() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_RESET_KIDS */ "b"]);
}

function updateKid(index, valuesToUpdate) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_UPDATE_KID */ "e"], {
    index: index,
    valuesToUpdate: valuesToUpdate
  });
}



/***/ }),

/***/ "1m4l":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("x90g");
var getOwnPropertyNamesModule = __webpack_require__("8D46");
var getOwnPropertySymbolsModule = __webpack_require__("qPLk");
var anObject = __webpack_require__("ep/x");

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "1tzK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isChineseLocale; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("qFX+");


function isChineseLocale(locale) {
  return locale === _constants__WEBPACK_IMPORTED_MODULE_0__[/* LOCALES */ "a"].EN_CN || locale === _constants__WEBPACK_IMPORTED_MODULE_0__[/* LOCALES */ "a"].ZH_CN;
}



/***/ }),

/***/ "2CYk":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("1YFU");

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),

/***/ "2N/j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOOKING_ENGINE_ENTRIES; });
/* unused harmony export BOOKING_TRACKING_UPSELL_REVENUE */
var BOOKING_ENGINE_ENTRIES = {
  PRICE_CALENDAR: 'PriceCalendar',
  PRICE_REMOTE: 'PriceRemote',
  QUICK_SEARCH: 'QuickSearch',
  CRUISE_BOOKING: 'CruiseBooking'
};
var BOOKING_TRACKING_UPSELL_REVENUE = 'BOOKING_TRACKING_UPSELL_REVENUE';

/***/ }),

/***/ "34at":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return goToHash; });
/* harmony import */ var _widgets_navigation_Navigation_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1cDg");
/* eslint-env browser */

function goToHash(hash) {
  var scrollUnderNav = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var behavior = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'auto';
  /* In mobile context, navBar is on top of the content of the page so hash scroll goes under the nav */

  function scrollUnderNavBar() {
    var navBar = document.getElementsByClassName(_widgets_navigation_Navigation_constants__WEBPACK_IMPORTED_MODULE_0__[/* NAVIGATION_OFFSET_SELECTOR */ "b"])[0];

    if (navBar) {
      document.documentElement.scrollTop -= navBar.clientHeight;
    }
  }

  if (hash) {
    var hashName = hash.split('#')[1];
    setTimeout(function () {
      var element = document.getElementById(hashName);

      if (element) {
        element.scrollIntoView({
          behavior: behavior
        });
      }

      if (scrollUnderNav) {
        scrollUnderNavBar();
      }
    }, 100);
  }
}

/***/ }),

/***/ "39HS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WebCallbackBlockLink; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_block_link_BlockLink_themes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("uRnh");
/* harmony import */ var _WebCallbackTrigger__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("PZXw");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;






var WebCallbackBlockLink = function WebCallbackBlockLink(_ref) {
  var icon = _ref.icon,
      texts = _ref.texts,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      trackingData = _ref.trackingData;
  return __jsx(_WebCallbackTrigger__WEBPACK_IMPORTED_MODULE_5__[/* WebCallbackTrigger */ "a"], {
    trackingData: trackingData,
    theme: theme
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_3__[/* Icon */ "a"], {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('flex-shrink-0', _frameworks_block_link_BlockLink_themes__WEBPACK_IMPORTED_MODULE_4__[/* themes */ "a"][theme].thIcon),
    name: icon,
    width: _frameworks_block_link_BlockLink_themes__WEBPACK_IMPORTED_MODULE_4__[/* themes */ "a"][theme].thIconWidth
  }), __jsx("span", {
    className: "rtl:text-left"
  }, texts.map(function (text, idx) {
    return __jsx("div", {
      className: Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(_frameworks_block_link_BlockLink_themes__WEBPACK_IMPORTED_MODULE_4__[/* themes */ "a"][theme], "customText".concat(idx), ''),
      key: text
    }, text);
  })));
};

/***/ }),

/***/ "3B0E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("igjW");
/* harmony import */ var _router_routerContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("BncX");
/* harmony import */ var _logger_logger__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("zytj");






var __jsx = react__WEBPACK_IMPORTED_MODULE_6__["createElement"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}






var errorBoundary = function errorBoundary(Component) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_React$Component) {
    Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(ErrorBoundary, _React$Component);

    var _super = _createSuper(ErrorBoundary);

    function ErrorBoundary(props) {
      var _this;

      Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(this, ErrorBoundary);

      _this = _super.call(this, props);
      _this.state = {
        error: null
      };
      return _this;
    }

    Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(ErrorBoundary, [{
      key: "componentDidCatch",
      value: function componentDidCatch(error, info) {
        _logger_logger__WEBPACK_IMPORTED_MODULE_9__["default"].error(error);
        this.setState(function (previousState) {
          return _objectSpread(_objectSpread({}, previousState), {}, {
            error: {
              error: error,
              info: info
            }
          });
        });
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        var error = this.state.error;

        if (error && Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_7__[/* isStrictlyProductionEnv */ "f"])()) {
          this.context.history.pushRoute('/500');
        }
      }
    }, {
      key: "render",
      value: function render() {
        var error = this.state.error;

        if (error !== null) {
          return null;
        }

        return __jsx(Component, this.props);
      }
    }]);

    return ErrorBoundary;
  }(react__WEBPACK_IMPORTED_MODULE_6__["Component"]), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_class, "contextType", _router_routerContext__WEBPACK_IMPORTED_MODULE_8__[/* routerContext */ "a"]), _temp;
};

/* harmony default export */ __webpack_exports__["a"] = (errorBoundary);

/***/ }),

/***/ "3K/D":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("nJrx");
var create = __webpack_require__("Znn2");
var definePropertyModule = __webpack_require__("87KK");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "3LIW":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("4I0e");
var classofRaw = __webpack_require__("XywU");
var wellKnownSymbol = __webpack_require__("nJrx");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),

/***/ "3dm5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("4I0e");
var classof = __webpack_require__("3LIW");

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "4+vj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPertimmDateFormat */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatPertimmDate; });
/* unused harmony export loadFacetingTopCountries */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadOffsetSell; });
/* unused harmony export loadProducts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return loadProductsWithIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return searchWithFacets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadPrices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadChildcareAvailabilities; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zygG");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_pertimm_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("y316");
/* harmony import */ var _utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("jw1E");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("kNiU");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("sW3P");
/* harmony import */ var _utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("L73y");
/* harmony import */ var _utils_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("KL6I");




function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}











var PERTIMM_ENGLISH_SPEAKING_LOCALE = 'en';
function getPertimmDateFormat(locale) {
  return (locale === null || locale === void 0 ? void 0 : locale.slice(0, 2)) === PERTIMM_ENGLISH_SPEAKING_LOCALE ? 'YYYY/MM/DD' : 'DD/MM/YYYY';
}
function formatPertimmDate(departureDate, locale) {
  var format = getPertimmDateFormat(locale);
  return departureDate.isValid() ? departureDate.format(format) : '';
}

function getResortThumbnailArgsConfig(appContext) {
  var query = "query {\n    config {\n      thumbnails {\n        tourDurationPlaceholder\n        cruiseTimingPlaceholder\n        cruiseDurationPlaceholder\n        dateFormat\n      }\n    }\n  }";
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* STATE_SEARCH_PRODUCT_CONFIG */ "Jd"]
  });
}

function getAllProductsInfo(_ref) {
  var appContext = _ref.appContext,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options,
      _ref$ids = _ref.ids,
      ids = _ref$ids === void 0 ? [] : _ref$ids;
  var cmsContent = appContext.cmsContent,
      cmsRelease = appContext.cmsRelease;
  var _options$offerId = options.offerId,
      offerId = _options$offerId === void 0 ? '' : _options$offerId,
      _options$offerName = options.offerName,
      offerName = _options$offerName === void 0 ? '' : _options$offerName,
      _options$productIds = options.productIds,
      productIds = _options$productIds === void 0 ? [] : _options$productIds;
  return getResortThumbnailArgsConfig(appContext).then(function (data) {
    var resortThumbnailQueryArgs = _objectSpread({
      content: cmsContent,
      release: cmsRelease,
      offerName: offerName,
      offerId: offerId
    }, data.config.thumbnails);

    var allProductsId = productIds.length ? ids.filter(function (id) {
      return productIds.includes(id);
    }) : ids;
    var query = "query {\n      resorts(resortIds : [\"".concat(allProductsId.join('","'), "\"]) {\n        ").concat(Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(resortThumbnailQueryArgs, {
      withoutPrice: true
    }), "\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* STATE_SEARCH_PRODUCTS */ "Hd"]
    });
  });
}

function loadFacetingTopCountries(_ref2) {
  var appContext = _ref2.appContext;
  var query = "query {\n    config {\n      faceting {\n        topCountries {\n          enabled\n           title\n           items {\n             id\n           }\n        }\n      }\n    }\n  }";
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* STATE_SEARCH_FACETING_TOP_COUNTRIES */ "Fd"]
  });
}
function loadOffsetSell(_ref3) {
  var appContext = _ref3.appContext;
  var query = "\n    query {\n      locale {\n        joyviewOffsetSell\n        resortOffsetSell\n      }\n    }\n  ";
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* STATE_SEARCH_OFFSET_SELL */ "Gd"]
  });
}
function loadProducts(_ref4) {
  var appContext = _ref4.appContext,
      options = _ref4.options;
  return Object(_utils_pertimm_client__WEBPACK_IMPORTED_MODULE_5__[/* getIdsFromProducts */ "a"])(appContext).then(function (ids) {
    return getAllProductsInfo({
      appContext: appContext,
      options: options,
      ids: ids
    });
  });
}
function loadProductsWithIds(_ref5) {
  var appContext = _ref5.appContext,
      productIds = _ref5.productIds;
  return getAllProductsInfo({
    appContext: appContext,
    options: {},
    ids: productIds
  });
}
function searchWithFacets(_ref6) {
  var criteria = _ref6.criteria,
      options = _ref6.options,
      appContext = _ref6.appContext;
  var facetingTopCountriesPromise = loadFacetingTopCountries({
    appContext: appContext
  });
  var productsPromise = loadProducts({
    appContext: appContext,
    options: options
  });
  var userIsSeller = Object(_utils_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_12__[/* isSeller */ "g"])(appContext); // $FlowFixMe

  var searchPromise = Object(_utils_pertimm_client__WEBPACK_IMPORTED_MODULE_5__[/* searchWithFacets */ "c"])({
    criteria: _objectSpread(_objectSpread({}, criteria), {}, {
      tripDuration: userIsSeller ? null : criteria.tripDuration
    }),
    appContext: appContext
  });
  return Promise.all([facetingTopCountriesPromise, productsPromise, searchPromise]).then(function (_ref7) {
    var _ref8 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref7, 3),
        facetingTopCountriesInfo = _ref8[0],
        productsInfo = _ref8[1],
        pertimmResults = _ref8[2];

    var facetingTopCountries = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(facetingTopCountriesInfo, 'config.faceting.topCountries');
    var filteredProducts = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(pertimmResults, 'answers', []).reduce(function (acc, result) {
      var resultProductId = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(result, 'meta.product_id[0]');
      var resort = productsInfo.resorts.find(function (_ref9) {
        var id = _ref9.id;
        return id === resultProductId;
      });
      var isAllAttendeeAllowed = !!resort && (!criteria.kids || criteria.kids.every(function (_ref10) {
        var birthdate = _ref10.birthdate;
        return Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_9__[/* getKidAgeInMonths */ "e"])({
          birthdate: birthdate,
          departureDate: criteria.departureDate
        }) >= resort.minAuthorizedAge.value;
      }));
      return resort && isAllAttendeeAllowed ? [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(acc), [resort]) : acc;
    }, []);
    var sortedFilteredProducts = criteria.productIds && criteria.productIds.length > 0 ? criteria.productIds.map(function (id) {
      return filteredProducts.find(function (product) {
        return product.id === id;
      });
    }) : filteredProducts;
    return _objectSpread(_objectSpread({
      facetingTopCountries: facetingTopCountries
    }, pertimmResults), {}, {
      query: criteria.query || '',
      search: {
        products: sortedFilteredProducts.filter(Boolean)
      }
    });
  });
}

function getTransportArgs(criteria) {
  var departureCityFilter = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(criteria, 'filters', []).find(function (filter) {
    return filter.id === _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_10__[/* DEPARTURE_CITY_FACET_ID */ "i"];
  });
  var selectedDepartureCity = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(departureCityFilter, 'name');

  switch (selectedDepartureCity) {
    case 'NO':
      return {
        forceWithoutTransport: true,
        departureCity: ''
      };

    case undefined:
      return {
        forceWithoutTransport: false,
        departureCity: ''
      };

    default:
      return {
        forceWithoutTransport: false,
        departureCity: selectedDepartureCity
      };
  }
}

function loadPrices(_ref11) {
  var appContext = _ref11.appContext,
      _ref11$criteria = _ref11.criteria,
      criteria = _ref11$criteria === void 0 ? {} : _ref11$criteria,
      withFlexibility = _ref11.withFlexibility;
  var _criteria$offerName = criteria.offerName,
      offerName = _criteria$offerName === void 0 ? '' : _criteria$offerName,
      _criteria$offerId = criteria.offerId,
      offerId = _criteria$offerId === void 0 ? '' : _criteria$offerId,
      _criteria$productIds = criteria.productIds,
      productIds = _criteria$productIds === void 0 ? [] : _criteria$productIds,
      duration = criteria.duration;

  var _getTransportArgs = getTransportArgs(criteria),
      departureCity = _getTransportArgs.departureCity,
      forceWithoutTransport = _getTransportArgs.forceWithoutTransport;

  var date = Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__[/* formatTimestampDate */ "c"])(criteria.departureDate, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_10__[/* DATE_FORMAT */ "f"]) || '';
  var dateStart = Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__[/* formatTimestampDate */ "c"])(criteria.minDate, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_10__[/* DATE_FORMAT */ "f"]) || '';
  var dateEnd = Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__[/* formatTimestampDate */ "c"])(criteria.maxDate, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_10__[/* DATE_FORMAT */ "f"]) || '';
  var hasDateRange = dateStart && dateEnd && (!date || withFlexibility);
  var query = "\n    query {\n      resorts(\n        optimizedPriceCalls: true,\n        ".concat(date ? "date: \"".concat(date, "\",") : '', "\n        ").concat(hasDateRange ? "dateStart: \"".concat(dateStart, "\",") : '', "\n        ").concat(hasDateRange ? "dateEnd: \"".concat(dateEnd, "\",") : '', "\n        resortIds: [\"").concat(productIds.join('","'), "\"],\n        departureCity: \"").concat(departureCity, "\",\n        duration: ").concat(String(duration || null), ",\n        offerName: \"").concat(offerName, "\",\n        offerId: \"").concat(offerId, "\",\n        forceWithoutTransport: ").concat(String(forceWithoutTransport), ",\n      ) {\n        id\n        ").concat(Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_6__[/* getPriceFields */ "c"])(Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_6__[/* cleanupArgs */ "a"])({
    optimizedPriceCalls: true,
    resortIds: productIds,
    departureCity: departureCity,
    duration: duration || undefined,
    // for flow: criteria duration can be null, but cleanupArgs doesn't accept null as parameter.
    offerName: offerName,
    offerId: offerId,
    forceWithoutTransport: forceWithoutTransport,
    content: appContext.cmsContent,
    release: appContext.cmsRelease,
    date: date,
    dateStart: dateStart,
    dateEnd: dateEnd
  })), "\n      }\n    }\n  ");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* STATE_SEARCH_PRODUCT_PRICE */ "Kd"]
  });
}
function loadChildcareAvailabilities(_ref12) {
  var appContext = _ref12.appContext,
      _ref12$criteria = _ref12.criteria,
      criteria = _ref12$criteria === void 0 ? {} : _ref12$criteria;
  var _criteria$productIds2 = criteria.productIds,
      productIds = _criteria$productIds2 === void 0 ? [] : _criteria$productIds2,
      arrivalDate = criteria.departureDate,
      duration = criteria.duration,
      kids = criteria.kids;

  if (!kids || kids.length === 0) {
    return Promise.resolve();
  }

  var query = "\n    query {\n      childcareSearch(\n        arrival_date: \"".concat(Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__[/* formatTimestampDate */ "c"])(arrivalDate, 'YYYYMMDD') || '', "\",\n        product_ids: [\"").concat(productIds.join('","'), "\"],\n        concerned_attendees_birthdates: [\"").concat(kids.map(function (_ref13) {
    var birthdate = _ref13.birthdate;
    return Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__[/* formatTimestampDate */ "c"])(birthdate, 'YYYYMMDD');
  }).join('","'), "\"],\n        duration: ").concat(String(duration || null), ",\n      ) {\n        id\n        productId,\n        availability,\n        isIncluded,\n        ageMin,\n        ageMax\n        remainingStock\n      }\n    }\n  ");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* STATE_SEARCH_PRODUCT_CHILDCARE */ "Id"]
  });
}

/***/ }),

/***/ "4/4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Tabs; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/utils/keyCodes.js
var keyCodes = __webpack_require__("05v4");

// EXTERNAL MODULE: ./src/client/components/utils/tabs/tabs.util.js
var tabs_util = __webpack_require__("GzVq");

// EXTERNAL MODULE: ./src/client/components/utils/tabs/tabs.hoc.jsx
var tabs_hoc = __webpack_require__("lW4u");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/frameworks/active-indexes/ActiveIndexes.jsx
var ActiveIndexes = __webpack_require__("1Wgj");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// EXTERNAL MODULE: ./src/client/components/frameworks/tab-header/TabHeader.jsx + 1 modules
var TabHeader = __webpack_require__("ZKlR");

// CONCATENATED MODULE: ./src/client/components/frameworks/tabs/Tabs.themes.js

var Tabs_themes_themes = function themes(_ref) {
  var isScrollable = _ref.isScrollable;
  return {
    "default": {
      thHeader: '',
      thList: 'pb-px10',
      thListItem: classnames_default()({
        'flex-grow': !isScrollable
      }),
      thSlot: 'pb-px10',
      thBody: '-mt-px10 pt-px20'
    },
    clean: {
      thHeader: 'border-b-1 items-stretch',
      thList: 'whitespace-no-wrap',
      thListItem: 'decorator-separator-left',
      thSlot: 'flex items-center rtl:border-r-1',
      thBody: '-m-px py-px20'
    },
    rounded: {
      thHeader: '',
      thScrollable: 'flex-1',
      thList: '',
      thListItem: 'flex-1',
      thSlot: '',
      thBody: 'bg-white border-1 border-t-0 rounded-tiny'
    },
    simple: {
      thHeader: '',
      thList: 'pb-px10',
      thListItem: classnames_default()('mx-px5', {
        'flex-grow': !isScrollable
      }),
      thSlot: 'pb-px10',
      thBody: ''
    },
    lite: {
      thHeader: 'mb-px20',
      thList: '-mx-px5 flex-grow',
      thListItem: classnames_default()('mx-px5', {
        'flex-none': isScrollable
      }),
      thSlot: ''
    },
    flat: {
      thBody: 'bg-white border-1 border-gray-light p-px20 rounded-tiny relative -mt-px shadow-diffuse',
      thHeader: 'items-center',
      thList: '',
      thListItem: '',
      thSlot: 'flex-shrink-0'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/tabs/Tabs.jsx



var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var Tabs_Tabs = function _Tabs(_ref) {
  var areAllCollapsable = _ref.areAllCollapsable,
      bgColor = _ref.bgColor,
      className = _ref.className,
      collapseIconName = _ref.collapseIconName,
      containerSize = _ref.containerSize,
      expandIconName = _ref.expandIconName,
      hasBackground = _ref.hasBackground,
      isContainerWide = _ref.isContainerWide,
      isContentUnmountedOnCollapse = _ref.isContentUnmountedOnCollapse,
      _ref$initialSelectedI = _ref.initialSelectedItem,
      initialSelectedItem = _ref$initialSelectedI === void 0 ? 0 : _ref$initialSelectedI,
      id = _ref.id,
      isScrollable = _ref.isScrollable,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      onSelect = _ref.onSelect,
      onTabClick = _ref.onTabClick,
      scrollForwardLabel = _ref.scrollForwardLabel,
      scrollBackwardLabel = _ref.scrollBackwardLabel,
      slotLeft = _ref.slotLeft,
      slotRight = _ref.slotRight,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  if (!items.length) {
    return null;
  }

  var refsArray = [];
  var _themes$theme = Tabs_themes_themes({
    isScrollable: isScrollable
  })[theme],
      thBody = _themes$theme.thBody,
      thHeader = _themes$theme.thHeader,
      thList = _themes$theme.thList,
      thListItem = _themes$theme.thListItem,
      thScrollable = _themes$theme.thScrollable,
      thSlot = _themes$theme.thSlot;

  var tabUpdate = function tabUpdate(idx, update) {
    update(idx);
    refsArray[idx] && refsArray[idx].focus();
  };

  var _onKeyDown = function onKeyDown(_ref2) {
    var e = _ref2.e,
        index = _ref2.index,
        update = _ref2.update;

    if (items.length > 1) {
      var lastItem = items.length - 1;

      switch (e.which) {
        case keyCodes["c" /* ARROW_RIGHT */]:
        case keyCodes["a" /* ARROW_DOWN */]:
          e.preventDefault();
          tabUpdate(index === lastItem ? 0 : index + 1, update);
          break;

        case keyCodes["b" /* ARROW_LEFT */]:
        case keyCodes["d" /* ARROW_UP */]:
          e.preventDefault();
          tabUpdate(index === 0 ? lastItem : index - 1, update);
          break;

        case keyCodes["h" /* HOME */]:
          e.preventDefault();
          tabUpdate(0, update);
          break;

        case keyCodes["e" /* END */]:
          e.preventDefault();
          tabUpdate(lastItem, update);
          break;

        default:
      }
    }
  };

  var tabsCount = items.filter(Boolean).length;
  return __jsx(ActiveIndexes["a" /* ActiveIndexes */], {
    activeIndexes: [initialSelectedItem],
    hasNoIndexEnabled: areAllCollapsable,
    onUpdate: onSelect
  }, function (_ref3) {
    var update = _ref3.update,
        activeIndexes = _ref3.activeIndexes,
        lastIndex = _ref3.lastIndex;
    var els = items.filter(Boolean).map(function (_ref4, index) {
      var customHeader = _ref4.customHeader,
          _ref4$header = _ref4.header,
          header = _ref4$header === void 0 ? {} : _ref4$header,
          headerId = _ref4.headerId,
          panelId = _ref4.panelId;

      var onClick = function onClick() {
        tabUpdate(index, update);
        onTabClick === null || onTabClick === void 0 ? void 0 : onTabClick(headerId, index);
      };

      var isActive = activeIndexes.includes(index);

      var setRef = function setRef(ref) {
        refsArray[index] = ref;
      };

      var title = header.title,
          rest = Object(objectWithoutProperties["a" /* default */])(header, ["title"]);

      var headerProps = _objectSpread(_objectSpread({}, rest), {}, {
        controlsId: panelId,
        id: headerId,
        isActive: isActive,
        isDisabled: tabsCount <= 1,
        onClick: onClick,
        onKeyDown: function onKeyDown(e) {
          return _onKeyDown({
            e: e,
            index: index,
            update: update
          });
        },
        style: isRTL && isScrollable ? {
          direction: 'rtl'
        } : null,
        tabIndex: isActive || index === lastIndex ? 0 : -1
      });

      if (Object(lodash["isFunction"])(customHeader)) {
        return customHeader(headerProps, setRef);
      }

      return __jsx(TabHeader["a" /* TabHeader */], Object(esm_extends["a" /* default */])({}, headerProps, {
        className: thListItem,
        collapseIconName: collapseIconName,
        expandIconName: expandIconName,
        key: headerId,
        ref: setRef,
        role: "tab",
        style: isRTL && isScrollable ? {
          direction: 'rtl'
        } : null,
        theme: theme
      }), title);
    });

    var tabsList = __jsx("div", {
      className: classnames_default()('reset-list flex w-full', thList),
      role: "tablist"
    }, els);

    return __jsx("section", {
      className: className,
      id: id,
      "data-cs-override-id": "Tabs" // ContentSquare must ignore this id see https://docs.contentsquare.com/uxa-fr/#ignorer-remplacer-ou-ajouter-un-id
      ,
      "data-testid": "tabs"
    }, __jsx(SiteContainer["a" /* SiteContainer */], {
      isWide: isContainerWide,
      size: containerSize
    }, __jsx("div", {
      className: classnames_default()('flex', thHeader)
    }, slotLeft && __jsx("div", {
      className: thSlot
    }, slotLeft), isScrollable ? __jsx(Scrollable["a" /* Scrollable */], {
      backwardLabel: scrollBackwardLabel,
      className: thScrollable,
      forwardLabel: scrollForwardLabel,
      hasShadow: true,
      navPosition: "side"
    }, tabsList) : tabsList, slotRight && __jsx("div", {
      className: thSlot
    }, slotRight))), __jsx("div", {
      "data-testid": "tabs-items-container",
      className: classnames_default()(Object(defineProperty["a" /* default */])({}, Object(tabs_util["a" /* getTabsBackgroundClasses */])(hasBackground, bgColor), activeIndexes.length > 0 && !activeIndexes.includes(-1)), thBody)
    }, items.filter(Boolean).map(function (_ref5, index) {
      var content = _ref5.content,
          headerId = _ref5.headerId,
          panelId = _ref5.panelId;
      var isActive = activeIndexes.includes(index);
      return (!isContentUnmountedOnCollapse || isActive) && __jsx("div", {
        "aria-hidden": !isActive,
        "aria-labelledby": headerId,
        className: classnames_default()({
          'h-0 invisible overflow-hidden pointer-events-none': !isActive,
          fadeIn: isActive
        }),
        "data-cs-override-id": "Tabs-panel" // ContentSquare must ignore this id see https://docs.contentsquare.com/uxa-fr/#ignorer-remplacer-ou-ajouter-un-id
        ,
        id: panelId,
        key: panelId,
        role: "tabpanel",
        "data-testid": "tabs-item-".concat(index, "-content")
      }, __jsx(SiteContainer["a" /* SiteContainer */], {
        isWide: isContainerWide,
        size: containerSize
      }, react["Children"].map(content, function (el, i) {
        return el ? /*#__PURE__*/Object(react["cloneElement"])(el, {
          key: "".concat(panelId, "-").concat(i)
        }) : null;
      })));
    })));
  });
};

var Tabs = Object(tabs_hoc["a" /* withOpenAndScrollToHash */])(Tabs_Tabs);

/***/ }),

/***/ "45Yg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRIP_INFORMATION_SET_FLEXIBILITY; });
var TRIP_INFORMATION_SET_FLEXIBILITY = 'TRIP_INFORMATION_SET_FLEXIBILITY';

/***/ }),

/***/ "47Eh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export shouldHideServicesPage */
/* unused harmony export shouldHideTransportPage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getStepIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFilteredBreadcrumbPages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return navigateInBookingEngine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllProposalsIdWithAlternative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return redirectToOidc; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _components_widgets_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("z8xc");
/* harmony import */ var _components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("aWOT");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_graphql_client_cacheFront__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ESA2");
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("oL6k");
/* harmony import */ var _utils_resort_resortUtils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("1qsz");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("nv//");
/* harmony import */ var _utils_ple_utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("6jSF");



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}













var JOYVIEW_ROOM_ONLY = _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].PACKAGES.JOYVIEW_ROOM_ONLY;
var BASE_PATH = '/booking/';
var shouldHideServicesPage = function shouldHideServicesPage(selectedProposal, resort) {
  return !Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_10__[/* hasChildcare */ "q"])(selectedProposal) && !resort.isJoyview && selectedProposal.additionalServices.childcares.length === 0 || resort.isJoyview && !selectedProposal.alternativePackages && selectedProposal.packageId === JOYVIEW_ROOM_ONLY;
};
var shouldHideTransportPage = function shouldHideTransportPage(selectedProposal) {
  return !Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_10__[/* hasTransfer */ "t"])(selectedProposal) && !Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(selectedProposal, 'transports');
};
var getStepIndex = function getStepIndex(steps, bookingStep) {
  return steps.findIndex(function (step) {
    return step.name === bookingStep;
  });
}; // eslint-disable-next-line max-params

var getFilteredBreadcrumbPages = function getFilteredBreadcrumbPages(_ref) {
  var selectedProposal = _ref.selectedProposal,
      resort = _ref.resort,
      i18n = _ref.i18n,
      isActivitiesViewFeatureFlipped = _ref.isActivitiesViewFeatureFlipped,
      isOptionHoldOnlyFeatureFlipped = _ref.isOptionHoldOnlyFeatureFlipped,
      _ref$isSeller = _ref.isSeller,
      isSeller = _ref$isSeller === void 0 ? false : _ref$isSeller,
      _ref$isCmta = _ref.isCmta,
      isCmta = _ref$isCmta === void 0 ? false : _ref$isCmta,
      _ref$isDelCredere = _ref.isDelCredere,
      isDelCredere = _ref$isDelCredere === void 0 ? false : _ref$isDelCredere;
  var isRecommendedTransportSelected = selectedProposal.transports && Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_10__[/* isRecommendedTransport */ "y"])(selectedProposal.transports, selectedProposal.id);
  var activitiesView = isActivitiesViewFeatureFlipped && (selectedProposal.additionalServices.activities.some(function (activity) {
    var _activity$productInfo;

    return ((_activity$productInfo = activity.productInfo) === null || _activity$productInfo === void 0 ? void 0 : _activity$productInfo.isIncluded) === false;
  }) || selectedProposal.additionalServices.rentals.length > 0) ? {
    name: 'activities',
    path: "".concat(BASE_PATH, "activities"),
    actionGA: 'activities',
    labelGA: 'validateActivities',
    basePriceGALabel: 'basePriceActivities',
    icon: Object(_utils_resort_resortUtils__WEBPACK_IMPORTED_MODULE_11__[/* isWinterMountainResort */ "a"])(resort) ? _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].SKI : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].GOLF,
    showIcon: true,
    title: i18n.booking.activities.pageTitle,
    seoTitle: i18n.booking.activities.seo.title,
    gridSize: 'large'
  } : null;
  var isJoyview = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(resort, 'isJoyview');
  var breadcrumbPages = [{
    name: 'accommodation',
    path: "".concat(BASE_PATH, "accommodation"),
    eventPageName: 'accommodations',
    actionGA: 'accommodation',
    labelGA: 'validateAccommodation',
    basePriceGALabel: 'basePriceAccommodation',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].ACCOMODATIONS,
    showIcon: true,
    title: Object(_components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_7__[/* tAlt */ "b"])({
      resortKeyPath: 'booking.accommodation.pageTitle',
      cruiseKeyPath: 'booking.accommodation.pageTitleCruise',
      resort: resort
    }),
    seoTitle: i18n.booking.accommodation.seo.title,
    gridSize: 'large'
  }, _objectSpread(_objectSpread({
    name: 'transport',
    path: "".concat(BASE_PATH, "transport"),
    actionGA: 'transport',
    labelGA: 'validateTransport'
  }, Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(selectedProposal, 'transports') ? {
    icon: Object(_components_widgets_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_6__[/* getTransportIcon */ "l"])(Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(selectedProposal, 'transports.inbound'), Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(selectedProposal, 'transports.outbound')),
    title: isRecommendedTransportSelected ? i18n.booking.transport.transportPageTitle : i18n.booking.transport.additionalTransports.transportSelection,
    seoTitle: i18n.booking.transport.seo.title,
    basePriceGALabel: 'basePriceTransport'
  } : {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].TRANSFER,
    title: i18n.booking.transport.transferPageTitle,
    seoTitle: i18n.booking.transport.transfer.seo.title,
    basePriceGALabel: 'basePriceTransfer'
  }), {}, {
    showIcon: true,
    isToBeHidden: shouldHideTransportPage(selectedProposal),
    gridSize: 'large'
  }), {
    name: 'services',
    path: "".concat(BASE_PATH, "services"),
    actionGA: isJoyview ? 'allInclusive' : 'service',
    labelGA: isJoyview ? 'validateAllInclusive' : 'validateServices',
    basePriceGALabel: 'basePriceServices',
    icon: isJoyview ? _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].DATE_PLUS : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].CHILDREN,
    showIcon: true,
    title: isJoyview ? i18n.booking.services.pageTitleJoyview : i18n.booking.services.pageTitleChildcare,
    seoTitle: i18n.booking.services.seo.title,
    isToBeHidden: shouldHideServicesPage(selectedProposal, resort),
    gridSize: isJoyview ? 'small' : 'large'
  }, {
    name: 'participants',
    path: "".concat(BASE_PATH, "participants"),
    actionGA: 'participant',
    labelGA: 'validateParticipants',
    basePriceGALabel: 'basePricePaymentParticipants',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].CONTACT,
    showIcon: true,
    title: i18n.booking.participants.pageTitle,
    seoTitle: i18n.booking.participants.seo.title,
    gridSize: 'large'
  }, {
    name: 'summary',
    path: "".concat(BASE_PATH, "summary"),
    actionGA: 'summary',
    labelGA: 'validateSummary',
    basePriceGALabel: 'basePriceSummary',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].SUMMARY,
    showIcon: true,
    title: isCmta ? Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "g"])('booking.partners.summary.pageTitle') : Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "g"])('booking.summary.pageTitle'),
    seoTitle: i18n.booking.summary.seo.title,
    gridSize: 'large'
  }];
  if (activitiesView) breadcrumbPages.splice(3, 0, activitiesView); // adds the banking step if the optionHoldOnly featureFlip is disabled

  if (!isOptionHoldOnlyFeatureFlipped) breadcrumbPages.push({
    name: 'banking',
    eventPageName: isSeller && isDelCredere ? 'banking_Ducroire' : 'banking',
    path: "".concat(BASE_PATH, "banking"),
    actionGA: isSeller && isDelCredere ? 'bankingDucroire' : 'banking',
    labelGA: 'validateBanking',
    basePriceGALabel: 'basePricePaymentBanking',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].CREDIT_CARD,
    showIcon: !isSeller || isCmta,
    title: i18n.booking.banking.pageTitle,
    seoTitle: i18n.booking.banking.seo.title
  }); // $FlowFixMe Absolutely no clue of why

  return Object(lodash__WEBPACK_IMPORTED_MODULE_2__["reject"])(breadcrumbPages, 'isToBeHidden');
};
var navigateInBookingEngine = function navigateInBookingEngine(_ref2) {
  var location = _ref2.location,
      history = _ref2.history,
      _ref2$replace = _ref2.replace,
      replace = _ref2$replace === void 0 ? false : _ref2$replace;
  var nextUri = location instanceof urijs__WEBPACK_IMPORTED_MODULE_3___default.a ? location : Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_12__[/* convertLocationToURI */ "c"])(location);
  var fileName = nextUri.filename();
  var shownUri = nextUri.clone();
  nextUri.pathname('/booking').setQuery('bookingStep', fileName);
  var nextUrl = nextUri.resource().toString();
  var shownUrl = shownUri.resource().toString();

  if (replace) {
    return history.replace(nextUrl, shownUrl);
  }

  return history.push(nextUrl, shownUrl);
};
var getAllProposalsIdWithAlternative = function getAllProposalsIdWithAlternative(proposal) {
  return [proposal.id].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(proposal.alternativePackages ? proposal.alternativePackages.map(function (alternativePackage) {
    return alternativePackage.proposalId;
  }) : []));
};
var redirectToOidc = function redirectToOidc(appContext) {
  var locale = appContext.locale,
      isSeller = appContext.isSeller,
      isCmta = appContext.isCmta;
  var redirectPath = new urijs__WEBPACK_IMPORTED_MODULE_3___default.a(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["windowWrapper"].getLocation()).pathname();

  if (true) {
    var redirectUri = new urijs__WEBPACK_IMPORTED_MODULE_3___default.a(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["windowWrapper"].getOrigin()).path(redirectPath).query(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["windowWrapper"].getLocationPart('search')).hash(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["windowWrapper"].getLocationPart('hash')).toString();
    Object(_utils_graphql_client_cacheFront__WEBPACK_IMPORTED_MODULE_9__[/* clearAllCacheFront */ "a"])();
    _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["windowWrapper"].setLocation(isSeller ? Object(_utils_ple_utils__WEBPACK_IMPORTED_MODULE_13__[/* buildSellerSigninUrl */ "e"])({
      locale: locale,
      redirectUri: redirectUri,
      isCmta: isCmta
    }) : Object(_utils_ple_utils__WEBPACK_IMPORTED_MODULE_13__[/* buildSigninUrl */ "f"])({
      locale: locale,
      redirectUri: redirectUri
    }));
  }
};

/***/ }),

/***/ "47go":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
}(this, function () {
    var STATE_OUTPUT       = 0,
        STATE_HTML         = 1,
        STATE_PRE_COMMENT  = 2,
        STATE_COMMENT      = 3,
        WHITESPACE         = /\s/,
        ALLOWED_TAGS_REGEX = /<(\w*)>/g;

    function striptags(html, allowableTags) {
        var html = html || '',
            state = STATE_OUTPUT,
            depth = 0,
            output = '',
            tagBuffer = '',
            inQuote = false,
            i, length, c;

        if (typeof allowableTags === 'string') {
            // Parse the string into an array of tags
            allowableTags = parseAllowableTags(allowableTags);
        } else if (!Array.isArray(allowableTags)) {
            // If it is not an array, explicitly set to null
            allowableTags = null;
        }

        for (i = 0, length = html.length; i < length; i++) {
            c = html[i];

            switch (c) {
                case '<': {
                    // ignore '<' if inside a quote
                    if (inQuote) {
                        break;
                    }

                    // '<' followed by a space is not a valid tag, continue
                    if (html[i + 1] == ' ') {
                        consumeCharacter(c);
                        break;
                    }

                    // change to STATE_HTML
                    if (state == STATE_OUTPUT) {
                        state = STATE_HTML;

                        consumeCharacter(c);
                        break;
                    }

                    // ignore additional '<' characters when inside a tag
                    if (state == STATE_HTML) {
                        depth++;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                case '>': {
                    // something like this is happening: '<<>>'
                    if (depth) {
                        depth--;
                        break;
                    }

                    // ignore '>' if inside a quote
                    if (inQuote) {
                        break;
                    }

                    // an HTML tag was closed
                    if (state == STATE_HTML) {
                        inQuote = state = 0;

                        if (allowableTags) {
                            tagBuffer += '>';
                            flushTagBuffer();
                        }

                        break;
                    }

                    // '<!' met its ending '>'
                    if (state == STATE_PRE_COMMENT) {
                        inQuote = state = 0;
                        tagBuffer = '';
                        break;
                    }

                    // if last two characters were '--', then end comment
                    if (state == STATE_COMMENT &&
                        html[i - 1] == '-' &&
                        html[i - 2] == '-') {

                        inQuote = state = 0;
                        tagBuffer = '';
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                // catch both single and double quotes
                case '"':
                case '\'': {
                    if (state == STATE_HTML) {
                        if (inQuote == c) {
                            // end quote found
                            inQuote = false;
                        } else if (!inQuote) {
                            // start quote only if not already in one
                            inQuote = c;
                        }
                    }

                    consumeCharacter(c);
                    break;
                }

                case '!': {
                    if (state == STATE_HTML &&
                        html[i - 1] == '<') {

                        // looks like we might be starting a comment
                        state = STATE_PRE_COMMENT;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                case '-': {
                    // if the previous two characters were '!-', this is a comment
                    if (state == STATE_PRE_COMMENT &&
                        html[i - 1] == '-' &&
                        html[i - 2] == '!') {

                        state = STATE_COMMENT;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                case 'E':
                case 'e': {
                    // check for DOCTYPE, because it looks like a comment and isn't
                    if (state == STATE_PRE_COMMENT &&
                        html.substr(i - 6, 7).toLowerCase() == 'doctype') {

                        state = STATE_HTML;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                default: {
                    consumeCharacter(c);
                }
            }
        }

        function consumeCharacter(c) {
            if (state == STATE_OUTPUT) {
                output += c;
            } else if (allowableTags && state == STATE_HTML) {
                tagBuffer += c;
            }
        }

        function flushTagBuffer() {
            var normalized = '',
                nonWhitespaceSeen = false,
                i, length, c;

            normalizeTagBuffer:
            for (i = 0, length = tagBuffer.length; i < length; i++) {
                c = tagBuffer[i].toLowerCase();

                switch (c) {
                    case '<': {
                        break;
                    }

                    case '>': {
                        break normalizeTagBuffer;
                    }

                    case '/': {
                        nonWhitespaceSeen = true;
                        break;
                    }

                    default: {
                        if (!c.match(WHITESPACE)) {
                            nonWhitespaceSeen = true;
                            normalized += c;
                        } else if (nonWhitespaceSeen) {
                            break normalizeTagBuffer;
                        }
                    }
                }
            }

            if (allowableTags.indexOf(normalized) !== -1) {
                output += tagBuffer;
            }

            tagBuffer = '';
        }

        return output;
    }

    /**
     * Return an array containing tags that are allowed to pass through the
     * algorithm.
     *
     * @param string allowableTags A string of tags to allow (e.g. "<b><strong>").
     * @return array|null An array of allowed tags or null if none.
     */
    function parseAllowableTags(allowableTags) {
        var tagsArray = [],
            match;

        while ((match = ALLOWED_TAGS_REGEX.exec(allowableTags)) !== null) {
            tagsArray.push(match[1]);
        }

        return tagsArray.length !== 0 ? tagsArray : null;
    }

    return striptags;
}));


/***/ }),

/***/ "4A3Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ AsyncLoader_AsyncLoader; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/label/SpinnerLabel.jsx
var SpinnerLabel = __webpack_require__("4SQ0");

// CONCATENATED MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.themes.js
var themes = {
  "default": {
    thRoot: 'flex justify-center h-full items-center'
  },
  labeled: {
    thRoot: 'flex flex-col justify-center items-center my-0 mx-auto text-center',
    thRootStyle: {
      width: '20rem'
    },
    thLabel: 'inline'
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.jsx

var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var AsyncLoader_AsyncLoader = function AsyncLoader(_ref) {
  var className = _ref.className,
      label = _ref.label,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? icons["a" /* ICONS */].TRIDENT1 : _ref$icon,
      iconSize = _ref.iconSize,
      style = _ref.style,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted;

  if (!isAppMounted) {
    return null;
  }

  var _themes$theme = themes[theme],
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot,
      thRootStyle = _themes$theme.thRootStyle;
  return __jsx("div", {
    className: classnames_default()(className, thRoot),
    style: _objectSpread(_objectSpread({}, thRootStyle), style)
  }, __jsx(Spinner["a" /* Spinner */], {
    iconName: icon,
    iconSize: iconSize
  }), __jsx(SpinnerLabel["a" /* SpinnerLabel */], {
    className: thLabel,
    label: label
  }));
};

/***/ }),

/***/ "4I0e":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("nJrx");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "4SQ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpinnerLabel; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


var SpinnerLabel = function SpinnerLabel(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, 'text-center font-brand leading-normal max-w-4/5 sm:max-w-3/5 mt-px20 text-blue text-xl', {
      'sr-only': !label
    }),
    "aria-live": "polite"
  }, label ? label : 'Loading');
};

/***/ }),

/***/ "4XHd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResortSummary; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _views_booking_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("taV1");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_template_string_TemplateString__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Ohju");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;








var PRODUCT_TYPES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].PRODUCT_TYPES;
var ResortSummary = function ResortSummary(_ref) {
  var _ref$extendedDataset = _ref.extendedDataset,
      extendedDataset = _ref$extendedDataset === void 0 ? false : _ref$extendedDataset,
      resort = _ref.resort;
  var destination = resort.destination,
      _resort$name = resort.name,
      name = _resort$name === void 0 ? '' : _resort$name,
      _resort$title = resort.title,
      title = _resort$title === void 0 ? '' : _resort$title,
      type = resort.type;
  var values = {
    resort: type === PRODUCT_TYPES.CRUISE ? title : name,
    country: type === PRODUCT_TYPES.CRUISE ? name : destination.country
  };
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('PackagePriceSummary-section', {
      'PackagePriceSummary-section--extended': extendedDataset
    }),
    "data-testid": _views_booking_constants__WEBPACK_IMPORTED_MODULE_2__[/* CRITERIA_SELECTORS */ "o"].PRODUCT
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "a"], {
    className: "PackagePriceSummary-icon",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].BLUE,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].TRIDENT1,
    width: "1.875rem"
  }), __jsx(_frameworks_template_string_TemplateString__WEBPACK_IMPORTED_MODULE_7__[/* TemplateString */ "a"], {
    template: "{resort}{country}",
    values: values,
    valuesClassName: {
      resort: 'PackagePriceSummary-resort'
    }
  }));
};

/***/ }),

/***/ "4gXF":
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "4jPf":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),

/***/ "4oK2":
/***/ (function(module, exports, __webpack_require__) {

var encode = __webpack_require__("BRr/"),
    decode = __webpack_require__("oW49");

exports.decode = function(data, level){
	return (!level || level <= 0 ? decode.XML : decode.HTML)(data);
};

exports.decodeStrict = function(data, level){
	return (!level || level <= 0 ? decode.XML : decode.HTMLStrict)(data);
};

exports.encode = function(data, level){
	return (!level || level <= 0 ? encode.XML : encode.HTML)(data);
};

exports.encodeXML = encode.XML;

exports.encodeHTML4 =
exports.encodeHTML5 =
exports.encodeHTML  = encode.HTML;

exports.decodeXML =
exports.decodeXMLStrict = decode.XML;

exports.decodeHTML4 =
exports.decodeHTML5 =
exports.decodeHTML = decode.HTML;

exports.decodeHTML4Strict =
exports.decodeHTML5Strict =
exports.decodeHTMLStrict = decode.HTMLStrict;

exports.escape = encode.escape;


/***/ }),

/***/ "5LiQ":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("dNjr");
var toLength = __webpack_require__("DOIJ");
var toAbsoluteIndex = __webpack_require__("Jm8J");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "5WP5":
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__("dnX/");

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),

/***/ "5h8T":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var propertyIsEnumerableModule = __webpack_require__("z7Vv");
var createPropertyDescriptor = __webpack_require__("OouP");
var toIndexedObject = __webpack_require__("dNjr");
var toPrimitive = __webpack_require__("pfAP");
var has = __webpack_require__("DZWw");
var IE8_DOM_DEFINE = __webpack_require__("/+ub");

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "5iaM":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("oMzG");

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "5pZ8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return remToPx; });
function remToPx(rem) {
  var _document;

  if ((_document = document) === null || _document === void 0 ? void 0 : _document.documentElement) {
    var fontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    return Number.isNaN(fontSize) ? rem * 16 : rem * fontSize;
  }

  return rem * 16;
}

/***/ }),

/***/ "5q4R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AttendeesSummary; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("UCZK");
/* harmony import */ var _views_booking_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("taV1");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_label_labelUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("WGoB");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("qBqs");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;








var AttendeesSummary = function AttendeesSummary(_ref) {
  var adults = _ref.adults,
      _ref$extendedDataset = _ref.extendedDataset,
      extendedDataset = _ref$extendedDataset === void 0 ? false : _ref$extendedDataset,
      kids = _ref.kids;
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('PackagePriceSummary-section', {
      'PackagePriceSummary-section--extended': extendedDataset
    }),
    "data-testid": _views_booking_constants__WEBPACK_IMPORTED_MODULE_3__[/* CRITERIA_SELECTORS */ "o"].ATTENDEES
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__[/* Icon */ "a"], {
    className: "PackagePriceSummary-icon",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].BLUE,
    hasRtl: true,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].USERS,
    width: "1.875rem"
  }), __jsx("span", null, __jsx("div", {
    className: "PackagePriceSummary-guestsItem",
    key: "adults"
  }, __jsx("span", {
    className: "PackagePriceSummary-guestsNumber"
  }, adults), " ".concat(Object(_utils_label_labelUtils__WEBPACK_IMPORTED_MODULE_5__[/* pluralizeLabel */ "d"])(Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "g"])('booking.common.adult'), Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "g"])('booking.common.adults'), adults))), kids > 0 ? __jsx("div", {
    className: "PackagePriceSummary-guestsItem",
    key: "children"
  }, __jsx("span", {
    className: "PackagePriceSummary-guestsNumber"
  }, kids), " ".concat(Object(_utils_label_labelUtils__WEBPACK_IMPORTED_MODULE_5__[/* pluralizeLabel */ "d"])(Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "g"])('booking.common.child'), Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "g"])('booking.common.children'), kids))) : null));
};

/***/ }),

/***/ "60DJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("C8GU").charAt;
var InternalStateModule = __webpack_require__("9jKB");
var defineIterator = __webpack_require__("ZiN6");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "6CUh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var pollWrapper = exports.pollWrapper = function pollWrapper(_ref) {
  var request = _ref.request,
      pollingPeriod = _ref.pollingPeriod,
      shouldStop = _ref.shouldStop;

  var canceled = false;
  var cancel = function cancel() {
    canceled = true;
  };

  var poll = function poll(resolve, reject) {
    if (canceled) {
      reject(new Error('Polling has been manually canceled'));
      return;
    }

    request().then(function (response) {
      if (shouldStop(response)) {
        resolve(response);
      } else {
        setTimeout(function () {
          poll(resolve, reject);
        }, pollingPeriod);
      }
    }).catch(function (error) {
      return reject(error);
    });
  };

  return { future: new Promise(poll), cancel: cancel };
};

exports.default = pollWrapper;

/***/ }),

/***/ "6XIJ":
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ "7Pat":
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__("+7q0"),
    shortOut = __webpack_require__("kG2z");

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ "7Z8V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLOSE_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OPEN_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return closeToast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return openToast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return showTemporaryToast; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");

var CLOSE_TOAST = 'CLOSE_TOAST';
var OPEN_TOAST = 'OPEN_TOAST';

function openToast(toastLabel, className, style) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(OPEN_TOAST, {
    className: className,
    toastLabel: toastLabel,
    style: style
  });
}

function closeToast() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(CLOSE_TOAST);
}

var showTemporaryToast = function showTemporaryToast(_ref) {
  var className = _ref.className,
      style = _ref.style,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 2000 : _ref$timeout,
      toastLabel = _ref.toastLabel;
  return function (dispatch) {
    return Promise.resolve(dispatch(openToast(toastLabel, className, style))).then(function () {
      setTimeout(function () {
        return dispatch(closeToast());
      }, timeout);
    });
  };
};



/***/ }),

/***/ "7hcC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResortListContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useResortList; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var ResortListContext = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_0__["createContext"])({
  resortList: [],
  setResortList: function setResortList() {}
});
var useResortList = function useResortList() {
  var context = Object(react__WEBPACK_IMPORTED_MODULE_0__["useContext"])(ResortListContext);

  if (context === undefined) {
    throw new Error('useResortList must be used within a ResortListContext.Provider');
  }

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    context.setResortList();
  }, []);
  return context.resortList;
};

/***/ }),

/***/ "8+jV":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("SRps");
var store = __webpack_require__("l6h7");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.15.2',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "87KK":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var IE8_DOM_DEFINE = __webpack_require__("/+ub");
var anObject = __webpack_require__("ep/x");
var toPrimitive = __webpack_require__("pfAP");

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "8D46":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("M4Qz");
var enumBugKeys = __webpack_require__("WSQK");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "8PLQ":
/***/ (function(module) {

module.exports = JSON.parse("{\"Aacute\":\"Á\",\"aacute\":\"á\",\"Abreve\":\"Ă\",\"abreve\":\"ă\",\"ac\":\"∾\",\"acd\":\"∿\",\"acE\":\"∾̳\",\"Acirc\":\"Â\",\"acirc\":\"â\",\"acute\":\"´\",\"Acy\":\"А\",\"acy\":\"а\",\"AElig\":\"Æ\",\"aelig\":\"æ\",\"af\":\"⁡\",\"Afr\":\"𝔄\",\"afr\":\"𝔞\",\"Agrave\":\"À\",\"agrave\":\"à\",\"alefsym\":\"ℵ\",\"aleph\":\"ℵ\",\"Alpha\":\"Α\",\"alpha\":\"α\",\"Amacr\":\"Ā\",\"amacr\":\"ā\",\"amalg\":\"⨿\",\"amp\":\"&\",\"AMP\":\"&\",\"andand\":\"⩕\",\"And\":\"⩓\",\"and\":\"∧\",\"andd\":\"⩜\",\"andslope\":\"⩘\",\"andv\":\"⩚\",\"ang\":\"∠\",\"ange\":\"⦤\",\"angle\":\"∠\",\"angmsdaa\":\"⦨\",\"angmsdab\":\"⦩\",\"angmsdac\":\"⦪\",\"angmsdad\":\"⦫\",\"angmsdae\":\"⦬\",\"angmsdaf\":\"⦭\",\"angmsdag\":\"⦮\",\"angmsdah\":\"⦯\",\"angmsd\":\"∡\",\"angrt\":\"∟\",\"angrtvb\":\"⊾\",\"angrtvbd\":\"⦝\",\"angsph\":\"∢\",\"angst\":\"Å\",\"angzarr\":\"⍼\",\"Aogon\":\"Ą\",\"aogon\":\"ą\",\"Aopf\":\"𝔸\",\"aopf\":\"𝕒\",\"apacir\":\"⩯\",\"ap\":\"≈\",\"apE\":\"⩰\",\"ape\":\"≊\",\"apid\":\"≋\",\"apos\":\"'\",\"ApplyFunction\":\"⁡\",\"approx\":\"≈\",\"approxeq\":\"≊\",\"Aring\":\"Å\",\"aring\":\"å\",\"Ascr\":\"𝒜\",\"ascr\":\"𝒶\",\"Assign\":\"≔\",\"ast\":\"*\",\"asymp\":\"≈\",\"asympeq\":\"≍\",\"Atilde\":\"Ã\",\"atilde\":\"ã\",\"Auml\":\"Ä\",\"auml\":\"ä\",\"awconint\":\"∳\",\"awint\":\"⨑\",\"backcong\":\"≌\",\"backepsilon\":\"϶\",\"backprime\":\"‵\",\"backsim\":\"∽\",\"backsimeq\":\"⋍\",\"Backslash\":\"∖\",\"Barv\":\"⫧\",\"barvee\":\"⊽\",\"barwed\":\"⌅\",\"Barwed\":\"⌆\",\"barwedge\":\"⌅\",\"bbrk\":\"⎵\",\"bbrktbrk\":\"⎶\",\"bcong\":\"≌\",\"Bcy\":\"Б\",\"bcy\":\"б\",\"bdquo\":\"„\",\"becaus\":\"∵\",\"because\":\"∵\",\"Because\":\"∵\",\"bemptyv\":\"⦰\",\"bepsi\":\"϶\",\"bernou\":\"ℬ\",\"Bernoullis\":\"ℬ\",\"Beta\":\"Β\",\"beta\":\"β\",\"beth\":\"ℶ\",\"between\":\"≬\",\"Bfr\":\"𝔅\",\"bfr\":\"𝔟\",\"bigcap\":\"⋂\",\"bigcirc\":\"◯\",\"bigcup\":\"⋃\",\"bigodot\":\"⨀\",\"bigoplus\":\"⨁\",\"bigotimes\":\"⨂\",\"bigsqcup\":\"⨆\",\"bigstar\":\"★\",\"bigtriangledown\":\"▽\",\"bigtriangleup\":\"△\",\"biguplus\":\"⨄\",\"bigvee\":\"⋁\",\"bigwedge\":\"⋀\",\"bkarow\":\"⤍\",\"blacklozenge\":\"⧫\",\"blacksquare\":\"▪\",\"blacktriangle\":\"▴\",\"blacktriangledown\":\"▾\",\"blacktriangleleft\":\"◂\",\"blacktriangleright\":\"▸\",\"blank\":\"␣\",\"blk12\":\"▒\",\"blk14\":\"░\",\"blk34\":\"▓\",\"block\":\"█\",\"bne\":\"=⃥\",\"bnequiv\":\"≡⃥\",\"bNot\":\"⫭\",\"bnot\":\"⌐\",\"Bopf\":\"𝔹\",\"bopf\":\"𝕓\",\"bot\":\"⊥\",\"bottom\":\"⊥\",\"bowtie\":\"⋈\",\"boxbox\":\"⧉\",\"boxdl\":\"┐\",\"boxdL\":\"╕\",\"boxDl\":\"╖\",\"boxDL\":\"╗\",\"boxdr\":\"┌\",\"boxdR\":\"╒\",\"boxDr\":\"╓\",\"boxDR\":\"╔\",\"boxh\":\"─\",\"boxH\":\"═\",\"boxhd\":\"┬\",\"boxHd\":\"╤\",\"boxhD\":\"╥\",\"boxHD\":\"╦\",\"boxhu\":\"┴\",\"boxHu\":\"╧\",\"boxhU\":\"╨\",\"boxHU\":\"╩\",\"boxminus\":\"⊟\",\"boxplus\":\"⊞\",\"boxtimes\":\"⊠\",\"boxul\":\"┘\",\"boxuL\":\"╛\",\"boxUl\":\"╜\",\"boxUL\":\"╝\",\"boxur\":\"└\",\"boxuR\":\"╘\",\"boxUr\":\"╙\",\"boxUR\":\"╚\",\"boxv\":\"│\",\"boxV\":\"║\",\"boxvh\":\"┼\",\"boxvH\":\"╪\",\"boxVh\":\"╫\",\"boxVH\":\"╬\",\"boxvl\":\"┤\",\"boxvL\":\"╡\",\"boxVl\":\"╢\",\"boxVL\":\"╣\",\"boxvr\":\"├\",\"boxvR\":\"╞\",\"boxVr\":\"╟\",\"boxVR\":\"╠\",\"bprime\":\"‵\",\"breve\":\"˘\",\"Breve\":\"˘\",\"brvbar\":\"¦\",\"bscr\":\"𝒷\",\"Bscr\":\"ℬ\",\"bsemi\":\"⁏\",\"bsim\":\"∽\",\"bsime\":\"⋍\",\"bsolb\":\"⧅\",\"bsol\":\"\\\\\",\"bsolhsub\":\"⟈\",\"bull\":\"•\",\"bullet\":\"•\",\"bump\":\"≎\",\"bumpE\":\"⪮\",\"bumpe\":\"≏\",\"Bumpeq\":\"≎\",\"bumpeq\":\"≏\",\"Cacute\":\"Ć\",\"cacute\":\"ć\",\"capand\":\"⩄\",\"capbrcup\":\"⩉\",\"capcap\":\"⩋\",\"cap\":\"∩\",\"Cap\":\"⋒\",\"capcup\":\"⩇\",\"capdot\":\"⩀\",\"CapitalDifferentialD\":\"ⅅ\",\"caps\":\"∩︀\",\"caret\":\"⁁\",\"caron\":\"ˇ\",\"Cayleys\":\"ℭ\",\"ccaps\":\"⩍\",\"Ccaron\":\"Č\",\"ccaron\":\"č\",\"Ccedil\":\"Ç\",\"ccedil\":\"ç\",\"Ccirc\":\"Ĉ\",\"ccirc\":\"ĉ\",\"Cconint\":\"∰\",\"ccups\":\"⩌\",\"ccupssm\":\"⩐\",\"Cdot\":\"Ċ\",\"cdot\":\"ċ\",\"cedil\":\"¸\",\"Cedilla\":\"¸\",\"cemptyv\":\"⦲\",\"cent\":\"¢\",\"centerdot\":\"·\",\"CenterDot\":\"·\",\"cfr\":\"𝔠\",\"Cfr\":\"ℭ\",\"CHcy\":\"Ч\",\"chcy\":\"ч\",\"check\":\"✓\",\"checkmark\":\"✓\",\"Chi\":\"Χ\",\"chi\":\"χ\",\"circ\":\"ˆ\",\"circeq\":\"≗\",\"circlearrowleft\":\"↺\",\"circlearrowright\":\"↻\",\"circledast\":\"⊛\",\"circledcirc\":\"⊚\",\"circleddash\":\"⊝\",\"CircleDot\":\"⊙\",\"circledR\":\"®\",\"circledS\":\"Ⓢ\",\"CircleMinus\":\"⊖\",\"CirclePlus\":\"⊕\",\"CircleTimes\":\"⊗\",\"cir\":\"○\",\"cirE\":\"⧃\",\"cire\":\"≗\",\"cirfnint\":\"⨐\",\"cirmid\":\"⫯\",\"cirscir\":\"⧂\",\"ClockwiseContourIntegral\":\"∲\",\"CloseCurlyDoubleQuote\":\"”\",\"CloseCurlyQuote\":\"’\",\"clubs\":\"♣\",\"clubsuit\":\"♣\",\"colon\":\":\",\"Colon\":\"∷\",\"Colone\":\"⩴\",\"colone\":\"≔\",\"coloneq\":\"≔\",\"comma\":\",\",\"commat\":\"@\",\"comp\":\"∁\",\"compfn\":\"∘\",\"complement\":\"∁\",\"complexes\":\"ℂ\",\"cong\":\"≅\",\"congdot\":\"⩭\",\"Congruent\":\"≡\",\"conint\":\"∮\",\"Conint\":\"∯\",\"ContourIntegral\":\"∮\",\"copf\":\"𝕔\",\"Copf\":\"ℂ\",\"coprod\":\"∐\",\"Coproduct\":\"∐\",\"copy\":\"©\",\"COPY\":\"©\",\"copysr\":\"℗\",\"CounterClockwiseContourIntegral\":\"∳\",\"crarr\":\"↵\",\"cross\":\"✗\",\"Cross\":\"⨯\",\"Cscr\":\"𝒞\",\"cscr\":\"𝒸\",\"csub\":\"⫏\",\"csube\":\"⫑\",\"csup\":\"⫐\",\"csupe\":\"⫒\",\"ctdot\":\"⋯\",\"cudarrl\":\"⤸\",\"cudarrr\":\"⤵\",\"cuepr\":\"⋞\",\"cuesc\":\"⋟\",\"cularr\":\"↶\",\"cularrp\":\"⤽\",\"cupbrcap\":\"⩈\",\"cupcap\":\"⩆\",\"CupCap\":\"≍\",\"cup\":\"∪\",\"Cup\":\"⋓\",\"cupcup\":\"⩊\",\"cupdot\":\"⊍\",\"cupor\":\"⩅\",\"cups\":\"∪︀\",\"curarr\":\"↷\",\"curarrm\":\"⤼\",\"curlyeqprec\":\"⋞\",\"curlyeqsucc\":\"⋟\",\"curlyvee\":\"⋎\",\"curlywedge\":\"⋏\",\"curren\":\"¤\",\"curvearrowleft\":\"↶\",\"curvearrowright\":\"↷\",\"cuvee\":\"⋎\",\"cuwed\":\"⋏\",\"cwconint\":\"∲\",\"cwint\":\"∱\",\"cylcty\":\"⌭\",\"dagger\":\"†\",\"Dagger\":\"‡\",\"daleth\":\"ℸ\",\"darr\":\"↓\",\"Darr\":\"↡\",\"dArr\":\"⇓\",\"dash\":\"‐\",\"Dashv\":\"⫤\",\"dashv\":\"⊣\",\"dbkarow\":\"⤏\",\"dblac\":\"˝\",\"Dcaron\":\"Ď\",\"dcaron\":\"ď\",\"Dcy\":\"Д\",\"dcy\":\"д\",\"ddagger\":\"‡\",\"ddarr\":\"⇊\",\"DD\":\"ⅅ\",\"dd\":\"ⅆ\",\"DDotrahd\":\"⤑\",\"ddotseq\":\"⩷\",\"deg\":\"°\",\"Del\":\"∇\",\"Delta\":\"Δ\",\"delta\":\"δ\",\"demptyv\":\"⦱\",\"dfisht\":\"⥿\",\"Dfr\":\"𝔇\",\"dfr\":\"𝔡\",\"dHar\":\"⥥\",\"dharl\":\"⇃\",\"dharr\":\"⇂\",\"DiacriticalAcute\":\"´\",\"DiacriticalDot\":\"˙\",\"DiacriticalDoubleAcute\":\"˝\",\"DiacriticalGrave\":\"`\",\"DiacriticalTilde\":\"˜\",\"diam\":\"⋄\",\"diamond\":\"⋄\",\"Diamond\":\"⋄\",\"diamondsuit\":\"♦\",\"diams\":\"♦\",\"die\":\"¨\",\"DifferentialD\":\"ⅆ\",\"digamma\":\"ϝ\",\"disin\":\"⋲\",\"div\":\"÷\",\"divide\":\"÷\",\"divideontimes\":\"⋇\",\"divonx\":\"⋇\",\"DJcy\":\"Ђ\",\"djcy\":\"ђ\",\"dlcorn\":\"⌞\",\"dlcrop\":\"⌍\",\"dollar\":\"$\",\"Dopf\":\"𝔻\",\"dopf\":\"𝕕\",\"Dot\":\"¨\",\"dot\":\"˙\",\"DotDot\":\"⃜\",\"doteq\":\"≐\",\"doteqdot\":\"≑\",\"DotEqual\":\"≐\",\"dotminus\":\"∸\",\"dotplus\":\"∔\",\"dotsquare\":\"⊡\",\"doublebarwedge\":\"⌆\",\"DoubleContourIntegral\":\"∯\",\"DoubleDot\":\"¨\",\"DoubleDownArrow\":\"⇓\",\"DoubleLeftArrow\":\"⇐\",\"DoubleLeftRightArrow\":\"⇔\",\"DoubleLeftTee\":\"⫤\",\"DoubleLongLeftArrow\":\"⟸\",\"DoubleLongLeftRightArrow\":\"⟺\",\"DoubleLongRightArrow\":\"⟹\",\"DoubleRightArrow\":\"⇒\",\"DoubleRightTee\":\"⊨\",\"DoubleUpArrow\":\"⇑\",\"DoubleUpDownArrow\":\"⇕\",\"DoubleVerticalBar\":\"∥\",\"DownArrowBar\":\"⤓\",\"downarrow\":\"↓\",\"DownArrow\":\"↓\",\"Downarrow\":\"⇓\",\"DownArrowUpArrow\":\"⇵\",\"DownBreve\":\"̑\",\"downdownarrows\":\"⇊\",\"downharpoonleft\":\"⇃\",\"downharpoonright\":\"⇂\",\"DownLeftRightVector\":\"⥐\",\"DownLeftTeeVector\":\"⥞\",\"DownLeftVectorBar\":\"⥖\",\"DownLeftVector\":\"↽\",\"DownRightTeeVector\":\"⥟\",\"DownRightVectorBar\":\"⥗\",\"DownRightVector\":\"⇁\",\"DownTeeArrow\":\"↧\",\"DownTee\":\"⊤\",\"drbkarow\":\"⤐\",\"drcorn\":\"⌟\",\"drcrop\":\"⌌\",\"Dscr\":\"𝒟\",\"dscr\":\"𝒹\",\"DScy\":\"Ѕ\",\"dscy\":\"ѕ\",\"dsol\":\"⧶\",\"Dstrok\":\"Đ\",\"dstrok\":\"đ\",\"dtdot\":\"⋱\",\"dtri\":\"▿\",\"dtrif\":\"▾\",\"duarr\":\"⇵\",\"duhar\":\"⥯\",\"dwangle\":\"⦦\",\"DZcy\":\"Џ\",\"dzcy\":\"џ\",\"dzigrarr\":\"⟿\",\"Eacute\":\"É\",\"eacute\":\"é\",\"easter\":\"⩮\",\"Ecaron\":\"Ě\",\"ecaron\":\"ě\",\"Ecirc\":\"Ê\",\"ecirc\":\"ê\",\"ecir\":\"≖\",\"ecolon\":\"≕\",\"Ecy\":\"Э\",\"ecy\":\"э\",\"eDDot\":\"⩷\",\"Edot\":\"Ė\",\"edot\":\"ė\",\"eDot\":\"≑\",\"ee\":\"ⅇ\",\"efDot\":\"≒\",\"Efr\":\"𝔈\",\"efr\":\"𝔢\",\"eg\":\"⪚\",\"Egrave\":\"È\",\"egrave\":\"è\",\"egs\":\"⪖\",\"egsdot\":\"⪘\",\"el\":\"⪙\",\"Element\":\"∈\",\"elinters\":\"⏧\",\"ell\":\"ℓ\",\"els\":\"⪕\",\"elsdot\":\"⪗\",\"Emacr\":\"Ē\",\"emacr\":\"ē\",\"empty\":\"∅\",\"emptyset\":\"∅\",\"EmptySmallSquare\":\"◻\",\"emptyv\":\"∅\",\"EmptyVerySmallSquare\":\"▫\",\"emsp13\":\" \",\"emsp14\":\" \",\"emsp\":\" \",\"ENG\":\"Ŋ\",\"eng\":\"ŋ\",\"ensp\":\" \",\"Eogon\":\"Ę\",\"eogon\":\"ę\",\"Eopf\":\"𝔼\",\"eopf\":\"𝕖\",\"epar\":\"⋕\",\"eparsl\":\"⧣\",\"eplus\":\"⩱\",\"epsi\":\"ε\",\"Epsilon\":\"Ε\",\"epsilon\":\"ε\",\"epsiv\":\"ϵ\",\"eqcirc\":\"≖\",\"eqcolon\":\"≕\",\"eqsim\":\"≂\",\"eqslantgtr\":\"⪖\",\"eqslantless\":\"⪕\",\"Equal\":\"⩵\",\"equals\":\"=\",\"EqualTilde\":\"≂\",\"equest\":\"≟\",\"Equilibrium\":\"⇌\",\"equiv\":\"≡\",\"equivDD\":\"⩸\",\"eqvparsl\":\"⧥\",\"erarr\":\"⥱\",\"erDot\":\"≓\",\"escr\":\"ℯ\",\"Escr\":\"ℰ\",\"esdot\":\"≐\",\"Esim\":\"⩳\",\"esim\":\"≂\",\"Eta\":\"Η\",\"eta\":\"η\",\"ETH\":\"Ð\",\"eth\":\"ð\",\"Euml\":\"Ë\",\"euml\":\"ë\",\"euro\":\"€\",\"excl\":\"!\",\"exist\":\"∃\",\"Exists\":\"∃\",\"expectation\":\"ℰ\",\"exponentiale\":\"ⅇ\",\"ExponentialE\":\"ⅇ\",\"fallingdotseq\":\"≒\",\"Fcy\":\"Ф\",\"fcy\":\"ф\",\"female\":\"♀\",\"ffilig\":\"ﬃ\",\"fflig\":\"ﬀ\",\"ffllig\":\"ﬄ\",\"Ffr\":\"𝔉\",\"ffr\":\"𝔣\",\"filig\":\"ﬁ\",\"FilledSmallSquare\":\"◼\",\"FilledVerySmallSquare\":\"▪\",\"fjlig\":\"fj\",\"flat\":\"♭\",\"fllig\":\"ﬂ\",\"fltns\":\"▱\",\"fnof\":\"ƒ\",\"Fopf\":\"𝔽\",\"fopf\":\"𝕗\",\"forall\":\"∀\",\"ForAll\":\"∀\",\"fork\":\"⋔\",\"forkv\":\"⫙\",\"Fouriertrf\":\"ℱ\",\"fpartint\":\"⨍\",\"frac12\":\"½\",\"frac13\":\"⅓\",\"frac14\":\"¼\",\"frac15\":\"⅕\",\"frac16\":\"⅙\",\"frac18\":\"⅛\",\"frac23\":\"⅔\",\"frac25\":\"⅖\",\"frac34\":\"¾\",\"frac35\":\"⅗\",\"frac38\":\"⅜\",\"frac45\":\"⅘\",\"frac56\":\"⅚\",\"frac58\":\"⅝\",\"frac78\":\"⅞\",\"frasl\":\"⁄\",\"frown\":\"⌢\",\"fscr\":\"𝒻\",\"Fscr\":\"ℱ\",\"gacute\":\"ǵ\",\"Gamma\":\"Γ\",\"gamma\":\"γ\",\"Gammad\":\"Ϝ\",\"gammad\":\"ϝ\",\"gap\":\"⪆\",\"Gbreve\":\"Ğ\",\"gbreve\":\"ğ\",\"Gcedil\":\"Ģ\",\"Gcirc\":\"Ĝ\",\"gcirc\":\"ĝ\",\"Gcy\":\"Г\",\"gcy\":\"г\",\"Gdot\":\"Ġ\",\"gdot\":\"ġ\",\"ge\":\"≥\",\"gE\":\"≧\",\"gEl\":\"⪌\",\"gel\":\"⋛\",\"geq\":\"≥\",\"geqq\":\"≧\",\"geqslant\":\"⩾\",\"gescc\":\"⪩\",\"ges\":\"⩾\",\"gesdot\":\"⪀\",\"gesdoto\":\"⪂\",\"gesdotol\":\"⪄\",\"gesl\":\"⋛︀\",\"gesles\":\"⪔\",\"Gfr\":\"𝔊\",\"gfr\":\"𝔤\",\"gg\":\"≫\",\"Gg\":\"⋙\",\"ggg\":\"⋙\",\"gimel\":\"ℷ\",\"GJcy\":\"Ѓ\",\"gjcy\":\"ѓ\",\"gla\":\"⪥\",\"gl\":\"≷\",\"glE\":\"⪒\",\"glj\":\"⪤\",\"gnap\":\"⪊\",\"gnapprox\":\"⪊\",\"gne\":\"⪈\",\"gnE\":\"≩\",\"gneq\":\"⪈\",\"gneqq\":\"≩\",\"gnsim\":\"⋧\",\"Gopf\":\"𝔾\",\"gopf\":\"𝕘\",\"grave\":\"`\",\"GreaterEqual\":\"≥\",\"GreaterEqualLess\":\"⋛\",\"GreaterFullEqual\":\"≧\",\"GreaterGreater\":\"⪢\",\"GreaterLess\":\"≷\",\"GreaterSlantEqual\":\"⩾\",\"GreaterTilde\":\"≳\",\"Gscr\":\"𝒢\",\"gscr\":\"ℊ\",\"gsim\":\"≳\",\"gsime\":\"⪎\",\"gsiml\":\"⪐\",\"gtcc\":\"⪧\",\"gtcir\":\"⩺\",\"gt\":\">\",\"GT\":\">\",\"Gt\":\"≫\",\"gtdot\":\"⋗\",\"gtlPar\":\"⦕\",\"gtquest\":\"⩼\",\"gtrapprox\":\"⪆\",\"gtrarr\":\"⥸\",\"gtrdot\":\"⋗\",\"gtreqless\":\"⋛\",\"gtreqqless\":\"⪌\",\"gtrless\":\"≷\",\"gtrsim\":\"≳\",\"gvertneqq\":\"≩︀\",\"gvnE\":\"≩︀\",\"Hacek\":\"ˇ\",\"hairsp\":\" \",\"half\":\"½\",\"hamilt\":\"ℋ\",\"HARDcy\":\"Ъ\",\"hardcy\":\"ъ\",\"harrcir\":\"⥈\",\"harr\":\"↔\",\"hArr\":\"⇔\",\"harrw\":\"↭\",\"Hat\":\"^\",\"hbar\":\"ℏ\",\"Hcirc\":\"Ĥ\",\"hcirc\":\"ĥ\",\"hearts\":\"♥\",\"heartsuit\":\"♥\",\"hellip\":\"…\",\"hercon\":\"⊹\",\"hfr\":\"𝔥\",\"Hfr\":\"ℌ\",\"HilbertSpace\":\"ℋ\",\"hksearow\":\"⤥\",\"hkswarow\":\"⤦\",\"hoarr\":\"⇿\",\"homtht\":\"∻\",\"hookleftarrow\":\"↩\",\"hookrightarrow\":\"↪\",\"hopf\":\"𝕙\",\"Hopf\":\"ℍ\",\"horbar\":\"―\",\"HorizontalLine\":\"─\",\"hscr\":\"𝒽\",\"Hscr\":\"ℋ\",\"hslash\":\"ℏ\",\"Hstrok\":\"Ħ\",\"hstrok\":\"ħ\",\"HumpDownHump\":\"≎\",\"HumpEqual\":\"≏\",\"hybull\":\"⁃\",\"hyphen\":\"‐\",\"Iacute\":\"Í\",\"iacute\":\"í\",\"ic\":\"⁣\",\"Icirc\":\"Î\",\"icirc\":\"î\",\"Icy\":\"И\",\"icy\":\"и\",\"Idot\":\"İ\",\"IEcy\":\"Е\",\"iecy\":\"е\",\"iexcl\":\"¡\",\"iff\":\"⇔\",\"ifr\":\"𝔦\",\"Ifr\":\"ℑ\",\"Igrave\":\"Ì\",\"igrave\":\"ì\",\"ii\":\"ⅈ\",\"iiiint\":\"⨌\",\"iiint\":\"∭\",\"iinfin\":\"⧜\",\"iiota\":\"℩\",\"IJlig\":\"Ĳ\",\"ijlig\":\"ĳ\",\"Imacr\":\"Ī\",\"imacr\":\"ī\",\"image\":\"ℑ\",\"ImaginaryI\":\"ⅈ\",\"imagline\":\"ℐ\",\"imagpart\":\"ℑ\",\"imath\":\"ı\",\"Im\":\"ℑ\",\"imof\":\"⊷\",\"imped\":\"Ƶ\",\"Implies\":\"⇒\",\"incare\":\"℅\",\"in\":\"∈\",\"infin\":\"∞\",\"infintie\":\"⧝\",\"inodot\":\"ı\",\"intcal\":\"⊺\",\"int\":\"∫\",\"Int\":\"∬\",\"integers\":\"ℤ\",\"Integral\":\"∫\",\"intercal\":\"⊺\",\"Intersection\":\"⋂\",\"intlarhk\":\"⨗\",\"intprod\":\"⨼\",\"InvisibleComma\":\"⁣\",\"InvisibleTimes\":\"⁢\",\"IOcy\":\"Ё\",\"iocy\":\"ё\",\"Iogon\":\"Į\",\"iogon\":\"į\",\"Iopf\":\"𝕀\",\"iopf\":\"𝕚\",\"Iota\":\"Ι\",\"iota\":\"ι\",\"iprod\":\"⨼\",\"iquest\":\"¿\",\"iscr\":\"𝒾\",\"Iscr\":\"ℐ\",\"isin\":\"∈\",\"isindot\":\"⋵\",\"isinE\":\"⋹\",\"isins\":\"⋴\",\"isinsv\":\"⋳\",\"isinv\":\"∈\",\"it\":\"⁢\",\"Itilde\":\"Ĩ\",\"itilde\":\"ĩ\",\"Iukcy\":\"І\",\"iukcy\":\"і\",\"Iuml\":\"Ï\",\"iuml\":\"ï\",\"Jcirc\":\"Ĵ\",\"jcirc\":\"ĵ\",\"Jcy\":\"Й\",\"jcy\":\"й\",\"Jfr\":\"𝔍\",\"jfr\":\"𝔧\",\"jmath\":\"ȷ\",\"Jopf\":\"𝕁\",\"jopf\":\"𝕛\",\"Jscr\":\"𝒥\",\"jscr\":\"𝒿\",\"Jsercy\":\"Ј\",\"jsercy\":\"ј\",\"Jukcy\":\"Є\",\"jukcy\":\"є\",\"Kappa\":\"Κ\",\"kappa\":\"κ\",\"kappav\":\"ϰ\",\"Kcedil\":\"Ķ\",\"kcedil\":\"ķ\",\"Kcy\":\"К\",\"kcy\":\"к\",\"Kfr\":\"𝔎\",\"kfr\":\"𝔨\",\"kgreen\":\"ĸ\",\"KHcy\":\"Х\",\"khcy\":\"х\",\"KJcy\":\"Ќ\",\"kjcy\":\"ќ\",\"Kopf\":\"𝕂\",\"kopf\":\"𝕜\",\"Kscr\":\"𝒦\",\"kscr\":\"𝓀\",\"lAarr\":\"⇚\",\"Lacute\":\"Ĺ\",\"lacute\":\"ĺ\",\"laemptyv\":\"⦴\",\"lagran\":\"ℒ\",\"Lambda\":\"Λ\",\"lambda\":\"λ\",\"lang\":\"⟨\",\"Lang\":\"⟪\",\"langd\":\"⦑\",\"langle\":\"⟨\",\"lap\":\"⪅\",\"Laplacetrf\":\"ℒ\",\"laquo\":\"«\",\"larrb\":\"⇤\",\"larrbfs\":\"⤟\",\"larr\":\"←\",\"Larr\":\"↞\",\"lArr\":\"⇐\",\"larrfs\":\"⤝\",\"larrhk\":\"↩\",\"larrlp\":\"↫\",\"larrpl\":\"⤹\",\"larrsim\":\"⥳\",\"larrtl\":\"↢\",\"latail\":\"⤙\",\"lAtail\":\"⤛\",\"lat\":\"⪫\",\"late\":\"⪭\",\"lates\":\"⪭︀\",\"lbarr\":\"⤌\",\"lBarr\":\"⤎\",\"lbbrk\":\"❲\",\"lbrace\":\"{\",\"lbrack\":\"[\",\"lbrke\":\"⦋\",\"lbrksld\":\"⦏\",\"lbrkslu\":\"⦍\",\"Lcaron\":\"Ľ\",\"lcaron\":\"ľ\",\"Lcedil\":\"Ļ\",\"lcedil\":\"ļ\",\"lceil\":\"⌈\",\"lcub\":\"{\",\"Lcy\":\"Л\",\"lcy\":\"л\",\"ldca\":\"⤶\",\"ldquo\":\"“\",\"ldquor\":\"„\",\"ldrdhar\":\"⥧\",\"ldrushar\":\"⥋\",\"ldsh\":\"↲\",\"le\":\"≤\",\"lE\":\"≦\",\"LeftAngleBracket\":\"⟨\",\"LeftArrowBar\":\"⇤\",\"leftarrow\":\"←\",\"LeftArrow\":\"←\",\"Leftarrow\":\"⇐\",\"LeftArrowRightArrow\":\"⇆\",\"leftarrowtail\":\"↢\",\"LeftCeiling\":\"⌈\",\"LeftDoubleBracket\":\"⟦\",\"LeftDownTeeVector\":\"⥡\",\"LeftDownVectorBar\":\"⥙\",\"LeftDownVector\":\"⇃\",\"LeftFloor\":\"⌊\",\"leftharpoondown\":\"↽\",\"leftharpoonup\":\"↼\",\"leftleftarrows\":\"⇇\",\"leftrightarrow\":\"↔\",\"LeftRightArrow\":\"↔\",\"Leftrightarrow\":\"⇔\",\"leftrightarrows\":\"⇆\",\"leftrightharpoons\":\"⇋\",\"leftrightsquigarrow\":\"↭\",\"LeftRightVector\":\"⥎\",\"LeftTeeArrow\":\"↤\",\"LeftTee\":\"⊣\",\"LeftTeeVector\":\"⥚\",\"leftthreetimes\":\"⋋\",\"LeftTriangleBar\":\"⧏\",\"LeftTriangle\":\"⊲\",\"LeftTriangleEqual\":\"⊴\",\"LeftUpDownVector\":\"⥑\",\"LeftUpTeeVector\":\"⥠\",\"LeftUpVectorBar\":\"⥘\",\"LeftUpVector\":\"↿\",\"LeftVectorBar\":\"⥒\",\"LeftVector\":\"↼\",\"lEg\":\"⪋\",\"leg\":\"⋚\",\"leq\":\"≤\",\"leqq\":\"≦\",\"leqslant\":\"⩽\",\"lescc\":\"⪨\",\"les\":\"⩽\",\"lesdot\":\"⩿\",\"lesdoto\":\"⪁\",\"lesdotor\":\"⪃\",\"lesg\":\"⋚︀\",\"lesges\":\"⪓\",\"lessapprox\":\"⪅\",\"lessdot\":\"⋖\",\"lesseqgtr\":\"⋚\",\"lesseqqgtr\":\"⪋\",\"LessEqualGreater\":\"⋚\",\"LessFullEqual\":\"≦\",\"LessGreater\":\"≶\",\"lessgtr\":\"≶\",\"LessLess\":\"⪡\",\"lesssim\":\"≲\",\"LessSlantEqual\":\"⩽\",\"LessTilde\":\"≲\",\"lfisht\":\"⥼\",\"lfloor\":\"⌊\",\"Lfr\":\"𝔏\",\"lfr\":\"𝔩\",\"lg\":\"≶\",\"lgE\":\"⪑\",\"lHar\":\"⥢\",\"lhard\":\"↽\",\"lharu\":\"↼\",\"lharul\":\"⥪\",\"lhblk\":\"▄\",\"LJcy\":\"Љ\",\"ljcy\":\"љ\",\"llarr\":\"⇇\",\"ll\":\"≪\",\"Ll\":\"⋘\",\"llcorner\":\"⌞\",\"Lleftarrow\":\"⇚\",\"llhard\":\"⥫\",\"lltri\":\"◺\",\"Lmidot\":\"Ŀ\",\"lmidot\":\"ŀ\",\"lmoustache\":\"⎰\",\"lmoust\":\"⎰\",\"lnap\":\"⪉\",\"lnapprox\":\"⪉\",\"lne\":\"⪇\",\"lnE\":\"≨\",\"lneq\":\"⪇\",\"lneqq\":\"≨\",\"lnsim\":\"⋦\",\"loang\":\"⟬\",\"loarr\":\"⇽\",\"lobrk\":\"⟦\",\"longleftarrow\":\"⟵\",\"LongLeftArrow\":\"⟵\",\"Longleftarrow\":\"⟸\",\"longleftrightarrow\":\"⟷\",\"LongLeftRightArrow\":\"⟷\",\"Longleftrightarrow\":\"⟺\",\"longmapsto\":\"⟼\",\"longrightarrow\":\"⟶\",\"LongRightArrow\":\"⟶\",\"Longrightarrow\":\"⟹\",\"looparrowleft\":\"↫\",\"looparrowright\":\"↬\",\"lopar\":\"⦅\",\"Lopf\":\"𝕃\",\"lopf\":\"𝕝\",\"loplus\":\"⨭\",\"lotimes\":\"⨴\",\"lowast\":\"∗\",\"lowbar\":\"_\",\"LowerLeftArrow\":\"↙\",\"LowerRightArrow\":\"↘\",\"loz\":\"◊\",\"lozenge\":\"◊\",\"lozf\":\"⧫\",\"lpar\":\"(\",\"lparlt\":\"⦓\",\"lrarr\":\"⇆\",\"lrcorner\":\"⌟\",\"lrhar\":\"⇋\",\"lrhard\":\"⥭\",\"lrm\":\"‎\",\"lrtri\":\"⊿\",\"lsaquo\":\"‹\",\"lscr\":\"𝓁\",\"Lscr\":\"ℒ\",\"lsh\":\"↰\",\"Lsh\":\"↰\",\"lsim\":\"≲\",\"lsime\":\"⪍\",\"lsimg\":\"⪏\",\"lsqb\":\"[\",\"lsquo\":\"‘\",\"lsquor\":\"‚\",\"Lstrok\":\"Ł\",\"lstrok\":\"ł\",\"ltcc\":\"⪦\",\"ltcir\":\"⩹\",\"lt\":\"<\",\"LT\":\"<\",\"Lt\":\"≪\",\"ltdot\":\"⋖\",\"lthree\":\"⋋\",\"ltimes\":\"⋉\",\"ltlarr\":\"⥶\",\"ltquest\":\"⩻\",\"ltri\":\"◃\",\"ltrie\":\"⊴\",\"ltrif\":\"◂\",\"ltrPar\":\"⦖\",\"lurdshar\":\"⥊\",\"luruhar\":\"⥦\",\"lvertneqq\":\"≨︀\",\"lvnE\":\"≨︀\",\"macr\":\"¯\",\"male\":\"♂\",\"malt\":\"✠\",\"maltese\":\"✠\",\"Map\":\"⤅\",\"map\":\"↦\",\"mapsto\":\"↦\",\"mapstodown\":\"↧\",\"mapstoleft\":\"↤\",\"mapstoup\":\"↥\",\"marker\":\"▮\",\"mcomma\":\"⨩\",\"Mcy\":\"М\",\"mcy\":\"м\",\"mdash\":\"—\",\"mDDot\":\"∺\",\"measuredangle\":\"∡\",\"MediumSpace\":\" \",\"Mellintrf\":\"ℳ\",\"Mfr\":\"𝔐\",\"mfr\":\"𝔪\",\"mho\":\"℧\",\"micro\":\"µ\",\"midast\":\"*\",\"midcir\":\"⫰\",\"mid\":\"∣\",\"middot\":\"·\",\"minusb\":\"⊟\",\"minus\":\"−\",\"minusd\":\"∸\",\"minusdu\":\"⨪\",\"MinusPlus\":\"∓\",\"mlcp\":\"⫛\",\"mldr\":\"…\",\"mnplus\":\"∓\",\"models\":\"⊧\",\"Mopf\":\"𝕄\",\"mopf\":\"𝕞\",\"mp\":\"∓\",\"mscr\":\"𝓂\",\"Mscr\":\"ℳ\",\"mstpos\":\"∾\",\"Mu\":\"Μ\",\"mu\":\"μ\",\"multimap\":\"⊸\",\"mumap\":\"⊸\",\"nabla\":\"∇\",\"Nacute\":\"Ń\",\"nacute\":\"ń\",\"nang\":\"∠⃒\",\"nap\":\"≉\",\"napE\":\"⩰̸\",\"napid\":\"≋̸\",\"napos\":\"ŉ\",\"napprox\":\"≉\",\"natural\":\"♮\",\"naturals\":\"ℕ\",\"natur\":\"♮\",\"nbsp\":\" \",\"nbump\":\"≎̸\",\"nbumpe\":\"≏̸\",\"ncap\":\"⩃\",\"Ncaron\":\"Ň\",\"ncaron\":\"ň\",\"Ncedil\":\"Ņ\",\"ncedil\":\"ņ\",\"ncong\":\"≇\",\"ncongdot\":\"⩭̸\",\"ncup\":\"⩂\",\"Ncy\":\"Н\",\"ncy\":\"н\",\"ndash\":\"–\",\"nearhk\":\"⤤\",\"nearr\":\"↗\",\"neArr\":\"⇗\",\"nearrow\":\"↗\",\"ne\":\"≠\",\"nedot\":\"≐̸\",\"NegativeMediumSpace\":\"​\",\"NegativeThickSpace\":\"​\",\"NegativeThinSpace\":\"​\",\"NegativeVeryThinSpace\":\"​\",\"nequiv\":\"≢\",\"nesear\":\"⤨\",\"nesim\":\"≂̸\",\"NestedGreaterGreater\":\"≫\",\"NestedLessLess\":\"≪\",\"NewLine\":\"\\n\",\"nexist\":\"∄\",\"nexists\":\"∄\",\"Nfr\":\"𝔑\",\"nfr\":\"𝔫\",\"ngE\":\"≧̸\",\"nge\":\"≱\",\"ngeq\":\"≱\",\"ngeqq\":\"≧̸\",\"ngeqslant\":\"⩾̸\",\"nges\":\"⩾̸\",\"nGg\":\"⋙̸\",\"ngsim\":\"≵\",\"nGt\":\"≫⃒\",\"ngt\":\"≯\",\"ngtr\":\"≯\",\"nGtv\":\"≫̸\",\"nharr\":\"↮\",\"nhArr\":\"⇎\",\"nhpar\":\"⫲\",\"ni\":\"∋\",\"nis\":\"⋼\",\"nisd\":\"⋺\",\"niv\":\"∋\",\"NJcy\":\"Њ\",\"njcy\":\"њ\",\"nlarr\":\"↚\",\"nlArr\":\"⇍\",\"nldr\":\"‥\",\"nlE\":\"≦̸\",\"nle\":\"≰\",\"nleftarrow\":\"↚\",\"nLeftarrow\":\"⇍\",\"nleftrightarrow\":\"↮\",\"nLeftrightarrow\":\"⇎\",\"nleq\":\"≰\",\"nleqq\":\"≦̸\",\"nleqslant\":\"⩽̸\",\"nles\":\"⩽̸\",\"nless\":\"≮\",\"nLl\":\"⋘̸\",\"nlsim\":\"≴\",\"nLt\":\"≪⃒\",\"nlt\":\"≮\",\"nltri\":\"⋪\",\"nltrie\":\"⋬\",\"nLtv\":\"≪̸\",\"nmid\":\"∤\",\"NoBreak\":\"⁠\",\"NonBreakingSpace\":\" \",\"nopf\":\"𝕟\",\"Nopf\":\"ℕ\",\"Not\":\"⫬\",\"not\":\"¬\",\"NotCongruent\":\"≢\",\"NotCupCap\":\"≭\",\"NotDoubleVerticalBar\":\"∦\",\"NotElement\":\"∉\",\"NotEqual\":\"≠\",\"NotEqualTilde\":\"≂̸\",\"NotExists\":\"∄\",\"NotGreater\":\"≯\",\"NotGreaterEqual\":\"≱\",\"NotGreaterFullEqual\":\"≧̸\",\"NotGreaterGreater\":\"≫̸\",\"NotGreaterLess\":\"≹\",\"NotGreaterSlantEqual\":\"⩾̸\",\"NotGreaterTilde\":\"≵\",\"NotHumpDownHump\":\"≎̸\",\"NotHumpEqual\":\"≏̸\",\"notin\":\"∉\",\"notindot\":\"⋵̸\",\"notinE\":\"⋹̸\",\"notinva\":\"∉\",\"notinvb\":\"⋷\",\"notinvc\":\"⋶\",\"NotLeftTriangleBar\":\"⧏̸\",\"NotLeftTriangle\":\"⋪\",\"NotLeftTriangleEqual\":\"⋬\",\"NotLess\":\"≮\",\"NotLessEqual\":\"≰\",\"NotLessGreater\":\"≸\",\"NotLessLess\":\"≪̸\",\"NotLessSlantEqual\":\"⩽̸\",\"NotLessTilde\":\"≴\",\"NotNestedGreaterGreater\":\"⪢̸\",\"NotNestedLessLess\":\"⪡̸\",\"notni\":\"∌\",\"notniva\":\"∌\",\"notnivb\":\"⋾\",\"notnivc\":\"⋽\",\"NotPrecedes\":\"⊀\",\"NotPrecedesEqual\":\"⪯̸\",\"NotPrecedesSlantEqual\":\"⋠\",\"NotReverseElement\":\"∌\",\"NotRightTriangleBar\":\"⧐̸\",\"NotRightTriangle\":\"⋫\",\"NotRightTriangleEqual\":\"⋭\",\"NotSquareSubset\":\"⊏̸\",\"NotSquareSubsetEqual\":\"⋢\",\"NotSquareSuperset\":\"⊐̸\",\"NotSquareSupersetEqual\":\"⋣\",\"NotSubset\":\"⊂⃒\",\"NotSubsetEqual\":\"⊈\",\"NotSucceeds\":\"⊁\",\"NotSucceedsEqual\":\"⪰̸\",\"NotSucceedsSlantEqual\":\"⋡\",\"NotSucceedsTilde\":\"≿̸\",\"NotSuperset\":\"⊃⃒\",\"NotSupersetEqual\":\"⊉\",\"NotTilde\":\"≁\",\"NotTildeEqual\":\"≄\",\"NotTildeFullEqual\":\"≇\",\"NotTildeTilde\":\"≉\",\"NotVerticalBar\":\"∤\",\"nparallel\":\"∦\",\"npar\":\"∦\",\"nparsl\":\"⫽⃥\",\"npart\":\"∂̸\",\"npolint\":\"⨔\",\"npr\":\"⊀\",\"nprcue\":\"⋠\",\"nprec\":\"⊀\",\"npreceq\":\"⪯̸\",\"npre\":\"⪯̸\",\"nrarrc\":\"⤳̸\",\"nrarr\":\"↛\",\"nrArr\":\"⇏\",\"nrarrw\":\"↝̸\",\"nrightarrow\":\"↛\",\"nRightarrow\":\"⇏\",\"nrtri\":\"⋫\",\"nrtrie\":\"⋭\",\"nsc\":\"⊁\",\"nsccue\":\"⋡\",\"nsce\":\"⪰̸\",\"Nscr\":\"𝒩\",\"nscr\":\"𝓃\",\"nshortmid\":\"∤\",\"nshortparallel\":\"∦\",\"nsim\":\"≁\",\"nsime\":\"≄\",\"nsimeq\":\"≄\",\"nsmid\":\"∤\",\"nspar\":\"∦\",\"nsqsube\":\"⋢\",\"nsqsupe\":\"⋣\",\"nsub\":\"⊄\",\"nsubE\":\"⫅̸\",\"nsube\":\"⊈\",\"nsubset\":\"⊂⃒\",\"nsubseteq\":\"⊈\",\"nsubseteqq\":\"⫅̸\",\"nsucc\":\"⊁\",\"nsucceq\":\"⪰̸\",\"nsup\":\"⊅\",\"nsupE\":\"⫆̸\",\"nsupe\":\"⊉\",\"nsupset\":\"⊃⃒\",\"nsupseteq\":\"⊉\",\"nsupseteqq\":\"⫆̸\",\"ntgl\":\"≹\",\"Ntilde\":\"Ñ\",\"ntilde\":\"ñ\",\"ntlg\":\"≸\",\"ntriangleleft\":\"⋪\",\"ntrianglelefteq\":\"⋬\",\"ntriangleright\":\"⋫\",\"ntrianglerighteq\":\"⋭\",\"Nu\":\"Ν\",\"nu\":\"ν\",\"num\":\"#\",\"numero\":\"№\",\"numsp\":\" \",\"nvap\":\"≍⃒\",\"nvdash\":\"⊬\",\"nvDash\":\"⊭\",\"nVdash\":\"⊮\",\"nVDash\":\"⊯\",\"nvge\":\"≥⃒\",\"nvgt\":\">⃒\",\"nvHarr\":\"⤄\",\"nvinfin\":\"⧞\",\"nvlArr\":\"⤂\",\"nvle\":\"≤⃒\",\"nvlt\":\"<⃒\",\"nvltrie\":\"⊴⃒\",\"nvrArr\":\"⤃\",\"nvrtrie\":\"⊵⃒\",\"nvsim\":\"∼⃒\",\"nwarhk\":\"⤣\",\"nwarr\":\"↖\",\"nwArr\":\"⇖\",\"nwarrow\":\"↖\",\"nwnear\":\"⤧\",\"Oacute\":\"Ó\",\"oacute\":\"ó\",\"oast\":\"⊛\",\"Ocirc\":\"Ô\",\"ocirc\":\"ô\",\"ocir\":\"⊚\",\"Ocy\":\"О\",\"ocy\":\"о\",\"odash\":\"⊝\",\"Odblac\":\"Ő\",\"odblac\":\"ő\",\"odiv\":\"⨸\",\"odot\":\"⊙\",\"odsold\":\"⦼\",\"OElig\":\"Œ\",\"oelig\":\"œ\",\"ofcir\":\"⦿\",\"Ofr\":\"𝔒\",\"ofr\":\"𝔬\",\"ogon\":\"˛\",\"Ograve\":\"Ò\",\"ograve\":\"ò\",\"ogt\":\"⧁\",\"ohbar\":\"⦵\",\"ohm\":\"Ω\",\"oint\":\"∮\",\"olarr\":\"↺\",\"olcir\":\"⦾\",\"olcross\":\"⦻\",\"oline\":\"‾\",\"olt\":\"⧀\",\"Omacr\":\"Ō\",\"omacr\":\"ō\",\"Omega\":\"Ω\",\"omega\":\"ω\",\"Omicron\":\"Ο\",\"omicron\":\"ο\",\"omid\":\"⦶\",\"ominus\":\"⊖\",\"Oopf\":\"𝕆\",\"oopf\":\"𝕠\",\"opar\":\"⦷\",\"OpenCurlyDoubleQuote\":\"“\",\"OpenCurlyQuote\":\"‘\",\"operp\":\"⦹\",\"oplus\":\"⊕\",\"orarr\":\"↻\",\"Or\":\"⩔\",\"or\":\"∨\",\"ord\":\"⩝\",\"order\":\"ℴ\",\"orderof\":\"ℴ\",\"ordf\":\"ª\",\"ordm\":\"º\",\"origof\":\"⊶\",\"oror\":\"⩖\",\"orslope\":\"⩗\",\"orv\":\"⩛\",\"oS\":\"Ⓢ\",\"Oscr\":\"𝒪\",\"oscr\":\"ℴ\",\"Oslash\":\"Ø\",\"oslash\":\"ø\",\"osol\":\"⊘\",\"Otilde\":\"Õ\",\"otilde\":\"õ\",\"otimesas\":\"⨶\",\"Otimes\":\"⨷\",\"otimes\":\"⊗\",\"Ouml\":\"Ö\",\"ouml\":\"ö\",\"ovbar\":\"⌽\",\"OverBar\":\"‾\",\"OverBrace\":\"⏞\",\"OverBracket\":\"⎴\",\"OverParenthesis\":\"⏜\",\"para\":\"¶\",\"parallel\":\"∥\",\"par\":\"∥\",\"parsim\":\"⫳\",\"parsl\":\"⫽\",\"part\":\"∂\",\"PartialD\":\"∂\",\"Pcy\":\"П\",\"pcy\":\"п\",\"percnt\":\"%\",\"period\":\".\",\"permil\":\"‰\",\"perp\":\"⊥\",\"pertenk\":\"‱\",\"Pfr\":\"𝔓\",\"pfr\":\"𝔭\",\"Phi\":\"Φ\",\"phi\":\"φ\",\"phiv\":\"ϕ\",\"phmmat\":\"ℳ\",\"phone\":\"☎\",\"Pi\":\"Π\",\"pi\":\"π\",\"pitchfork\":\"⋔\",\"piv\":\"ϖ\",\"planck\":\"ℏ\",\"planckh\":\"ℎ\",\"plankv\":\"ℏ\",\"plusacir\":\"⨣\",\"plusb\":\"⊞\",\"pluscir\":\"⨢\",\"plus\":\"+\",\"plusdo\":\"∔\",\"plusdu\":\"⨥\",\"pluse\":\"⩲\",\"PlusMinus\":\"±\",\"plusmn\":\"±\",\"plussim\":\"⨦\",\"plustwo\":\"⨧\",\"pm\":\"±\",\"Poincareplane\":\"ℌ\",\"pointint\":\"⨕\",\"popf\":\"𝕡\",\"Popf\":\"ℙ\",\"pound\":\"£\",\"prap\":\"⪷\",\"Pr\":\"⪻\",\"pr\":\"≺\",\"prcue\":\"≼\",\"precapprox\":\"⪷\",\"prec\":\"≺\",\"preccurlyeq\":\"≼\",\"Precedes\":\"≺\",\"PrecedesEqual\":\"⪯\",\"PrecedesSlantEqual\":\"≼\",\"PrecedesTilde\":\"≾\",\"preceq\":\"⪯\",\"precnapprox\":\"⪹\",\"precneqq\":\"⪵\",\"precnsim\":\"⋨\",\"pre\":\"⪯\",\"prE\":\"⪳\",\"precsim\":\"≾\",\"prime\":\"′\",\"Prime\":\"″\",\"primes\":\"ℙ\",\"prnap\":\"⪹\",\"prnE\":\"⪵\",\"prnsim\":\"⋨\",\"prod\":\"∏\",\"Product\":\"∏\",\"profalar\":\"⌮\",\"profline\":\"⌒\",\"profsurf\":\"⌓\",\"prop\":\"∝\",\"Proportional\":\"∝\",\"Proportion\":\"∷\",\"propto\":\"∝\",\"prsim\":\"≾\",\"prurel\":\"⊰\",\"Pscr\":\"𝒫\",\"pscr\":\"𝓅\",\"Psi\":\"Ψ\",\"psi\":\"ψ\",\"puncsp\":\" \",\"Qfr\":\"𝔔\",\"qfr\":\"𝔮\",\"qint\":\"⨌\",\"qopf\":\"𝕢\",\"Qopf\":\"ℚ\",\"qprime\":\"⁗\",\"Qscr\":\"𝒬\",\"qscr\":\"𝓆\",\"quaternions\":\"ℍ\",\"quatint\":\"⨖\",\"quest\":\"?\",\"questeq\":\"≟\",\"quot\":\"\\\"\",\"QUOT\":\"\\\"\",\"rAarr\":\"⇛\",\"race\":\"∽̱\",\"Racute\":\"Ŕ\",\"racute\":\"ŕ\",\"radic\":\"√\",\"raemptyv\":\"⦳\",\"rang\":\"⟩\",\"Rang\":\"⟫\",\"rangd\":\"⦒\",\"range\":\"⦥\",\"rangle\":\"⟩\",\"raquo\":\"»\",\"rarrap\":\"⥵\",\"rarrb\":\"⇥\",\"rarrbfs\":\"⤠\",\"rarrc\":\"⤳\",\"rarr\":\"→\",\"Rarr\":\"↠\",\"rArr\":\"⇒\",\"rarrfs\":\"⤞\",\"rarrhk\":\"↪\",\"rarrlp\":\"↬\",\"rarrpl\":\"⥅\",\"rarrsim\":\"⥴\",\"Rarrtl\":\"⤖\",\"rarrtl\":\"↣\",\"rarrw\":\"↝\",\"ratail\":\"⤚\",\"rAtail\":\"⤜\",\"ratio\":\"∶\",\"rationals\":\"ℚ\",\"rbarr\":\"⤍\",\"rBarr\":\"⤏\",\"RBarr\":\"⤐\",\"rbbrk\":\"❳\",\"rbrace\":\"}\",\"rbrack\":\"]\",\"rbrke\":\"⦌\",\"rbrksld\":\"⦎\",\"rbrkslu\":\"⦐\",\"Rcaron\":\"Ř\",\"rcaron\":\"ř\",\"Rcedil\":\"Ŗ\",\"rcedil\":\"ŗ\",\"rceil\":\"⌉\",\"rcub\":\"}\",\"Rcy\":\"Р\",\"rcy\":\"р\",\"rdca\":\"⤷\",\"rdldhar\":\"⥩\",\"rdquo\":\"”\",\"rdquor\":\"”\",\"rdsh\":\"↳\",\"real\":\"ℜ\",\"realine\":\"ℛ\",\"realpart\":\"ℜ\",\"reals\":\"ℝ\",\"Re\":\"ℜ\",\"rect\":\"▭\",\"reg\":\"®\",\"REG\":\"®\",\"ReverseElement\":\"∋\",\"ReverseEquilibrium\":\"⇋\",\"ReverseUpEquilibrium\":\"⥯\",\"rfisht\":\"⥽\",\"rfloor\":\"⌋\",\"rfr\":\"𝔯\",\"Rfr\":\"ℜ\",\"rHar\":\"⥤\",\"rhard\":\"⇁\",\"rharu\":\"⇀\",\"rharul\":\"⥬\",\"Rho\":\"Ρ\",\"rho\":\"ρ\",\"rhov\":\"ϱ\",\"RightAngleBracket\":\"⟩\",\"RightArrowBar\":\"⇥\",\"rightarrow\":\"→\",\"RightArrow\":\"→\",\"Rightarrow\":\"⇒\",\"RightArrowLeftArrow\":\"⇄\",\"rightarrowtail\":\"↣\",\"RightCeiling\":\"⌉\",\"RightDoubleBracket\":\"⟧\",\"RightDownTeeVector\":\"⥝\",\"RightDownVectorBar\":\"⥕\",\"RightDownVector\":\"⇂\",\"RightFloor\":\"⌋\",\"rightharpoondown\":\"⇁\",\"rightharpoonup\":\"⇀\",\"rightleftarrows\":\"⇄\",\"rightleftharpoons\":\"⇌\",\"rightrightarrows\":\"⇉\",\"rightsquigarrow\":\"↝\",\"RightTeeArrow\":\"↦\",\"RightTee\":\"⊢\",\"RightTeeVector\":\"⥛\",\"rightthreetimes\":\"⋌\",\"RightTriangleBar\":\"⧐\",\"RightTriangle\":\"⊳\",\"RightTriangleEqual\":\"⊵\",\"RightUpDownVector\":\"⥏\",\"RightUpTeeVector\":\"⥜\",\"RightUpVectorBar\":\"⥔\",\"RightUpVector\":\"↾\",\"RightVectorBar\":\"⥓\",\"RightVector\":\"⇀\",\"ring\":\"˚\",\"risingdotseq\":\"≓\",\"rlarr\":\"⇄\",\"rlhar\":\"⇌\",\"rlm\":\"‏\",\"rmoustache\":\"⎱\",\"rmoust\":\"⎱\",\"rnmid\":\"⫮\",\"roang\":\"⟭\",\"roarr\":\"⇾\",\"robrk\":\"⟧\",\"ropar\":\"⦆\",\"ropf\":\"𝕣\",\"Ropf\":\"ℝ\",\"roplus\":\"⨮\",\"rotimes\":\"⨵\",\"RoundImplies\":\"⥰\",\"rpar\":\")\",\"rpargt\":\"⦔\",\"rppolint\":\"⨒\",\"rrarr\":\"⇉\",\"Rrightarrow\":\"⇛\",\"rsaquo\":\"›\",\"rscr\":\"𝓇\",\"Rscr\":\"ℛ\",\"rsh\":\"↱\",\"Rsh\":\"↱\",\"rsqb\":\"]\",\"rsquo\":\"’\",\"rsquor\":\"’\",\"rthree\":\"⋌\",\"rtimes\":\"⋊\",\"rtri\":\"▹\",\"rtrie\":\"⊵\",\"rtrif\":\"▸\",\"rtriltri\":\"⧎\",\"RuleDelayed\":\"⧴\",\"ruluhar\":\"⥨\",\"rx\":\"℞\",\"Sacute\":\"Ś\",\"sacute\":\"ś\",\"sbquo\":\"‚\",\"scap\":\"⪸\",\"Scaron\":\"Š\",\"scaron\":\"š\",\"Sc\":\"⪼\",\"sc\":\"≻\",\"sccue\":\"≽\",\"sce\":\"⪰\",\"scE\":\"⪴\",\"Scedil\":\"Ş\",\"scedil\":\"ş\",\"Scirc\":\"Ŝ\",\"scirc\":\"ŝ\",\"scnap\":\"⪺\",\"scnE\":\"⪶\",\"scnsim\":\"⋩\",\"scpolint\":\"⨓\",\"scsim\":\"≿\",\"Scy\":\"С\",\"scy\":\"с\",\"sdotb\":\"⊡\",\"sdot\":\"⋅\",\"sdote\":\"⩦\",\"searhk\":\"⤥\",\"searr\":\"↘\",\"seArr\":\"⇘\",\"searrow\":\"↘\",\"sect\":\"§\",\"semi\":\";\",\"seswar\":\"⤩\",\"setminus\":\"∖\",\"setmn\":\"∖\",\"sext\":\"✶\",\"Sfr\":\"𝔖\",\"sfr\":\"𝔰\",\"sfrown\":\"⌢\",\"sharp\":\"♯\",\"SHCHcy\":\"Щ\",\"shchcy\":\"щ\",\"SHcy\":\"Ш\",\"shcy\":\"ш\",\"ShortDownArrow\":\"↓\",\"ShortLeftArrow\":\"←\",\"shortmid\":\"∣\",\"shortparallel\":\"∥\",\"ShortRightArrow\":\"→\",\"ShortUpArrow\":\"↑\",\"shy\":\"­\",\"Sigma\":\"Σ\",\"sigma\":\"σ\",\"sigmaf\":\"ς\",\"sigmav\":\"ς\",\"sim\":\"∼\",\"simdot\":\"⩪\",\"sime\":\"≃\",\"simeq\":\"≃\",\"simg\":\"⪞\",\"simgE\":\"⪠\",\"siml\":\"⪝\",\"simlE\":\"⪟\",\"simne\":\"≆\",\"simplus\":\"⨤\",\"simrarr\":\"⥲\",\"slarr\":\"←\",\"SmallCircle\":\"∘\",\"smallsetminus\":\"∖\",\"smashp\":\"⨳\",\"smeparsl\":\"⧤\",\"smid\":\"∣\",\"smile\":\"⌣\",\"smt\":\"⪪\",\"smte\":\"⪬\",\"smtes\":\"⪬︀\",\"SOFTcy\":\"Ь\",\"softcy\":\"ь\",\"solbar\":\"⌿\",\"solb\":\"⧄\",\"sol\":\"/\",\"Sopf\":\"𝕊\",\"sopf\":\"𝕤\",\"spades\":\"♠\",\"spadesuit\":\"♠\",\"spar\":\"∥\",\"sqcap\":\"⊓\",\"sqcaps\":\"⊓︀\",\"sqcup\":\"⊔\",\"sqcups\":\"⊔︀\",\"Sqrt\":\"√\",\"sqsub\":\"⊏\",\"sqsube\":\"⊑\",\"sqsubset\":\"⊏\",\"sqsubseteq\":\"⊑\",\"sqsup\":\"⊐\",\"sqsupe\":\"⊒\",\"sqsupset\":\"⊐\",\"sqsupseteq\":\"⊒\",\"square\":\"□\",\"Square\":\"□\",\"SquareIntersection\":\"⊓\",\"SquareSubset\":\"⊏\",\"SquareSubsetEqual\":\"⊑\",\"SquareSuperset\":\"⊐\",\"SquareSupersetEqual\":\"⊒\",\"SquareUnion\":\"⊔\",\"squarf\":\"▪\",\"squ\":\"□\",\"squf\":\"▪\",\"srarr\":\"→\",\"Sscr\":\"𝒮\",\"sscr\":\"𝓈\",\"ssetmn\":\"∖\",\"ssmile\":\"⌣\",\"sstarf\":\"⋆\",\"Star\":\"⋆\",\"star\":\"☆\",\"starf\":\"★\",\"straightepsilon\":\"ϵ\",\"straightphi\":\"ϕ\",\"strns\":\"¯\",\"sub\":\"⊂\",\"Sub\":\"⋐\",\"subdot\":\"⪽\",\"subE\":\"⫅\",\"sube\":\"⊆\",\"subedot\":\"⫃\",\"submult\":\"⫁\",\"subnE\":\"⫋\",\"subne\":\"⊊\",\"subplus\":\"⪿\",\"subrarr\":\"⥹\",\"subset\":\"⊂\",\"Subset\":\"⋐\",\"subseteq\":\"⊆\",\"subseteqq\":\"⫅\",\"SubsetEqual\":\"⊆\",\"subsetneq\":\"⊊\",\"subsetneqq\":\"⫋\",\"subsim\":\"⫇\",\"subsub\":\"⫕\",\"subsup\":\"⫓\",\"succapprox\":\"⪸\",\"succ\":\"≻\",\"succcurlyeq\":\"≽\",\"Succeeds\":\"≻\",\"SucceedsEqual\":\"⪰\",\"SucceedsSlantEqual\":\"≽\",\"SucceedsTilde\":\"≿\",\"succeq\":\"⪰\",\"succnapprox\":\"⪺\",\"succneqq\":\"⪶\",\"succnsim\":\"⋩\",\"succsim\":\"≿\",\"SuchThat\":\"∋\",\"sum\":\"∑\",\"Sum\":\"∑\",\"sung\":\"♪\",\"sup1\":\"¹\",\"sup2\":\"²\",\"sup3\":\"³\",\"sup\":\"⊃\",\"Sup\":\"⋑\",\"supdot\":\"⪾\",\"supdsub\":\"⫘\",\"supE\":\"⫆\",\"supe\":\"⊇\",\"supedot\":\"⫄\",\"Superset\":\"⊃\",\"SupersetEqual\":\"⊇\",\"suphsol\":\"⟉\",\"suphsub\":\"⫗\",\"suplarr\":\"⥻\",\"supmult\":\"⫂\",\"supnE\":\"⫌\",\"supne\":\"⊋\",\"supplus\":\"⫀\",\"supset\":\"⊃\",\"Supset\":\"⋑\",\"supseteq\":\"⊇\",\"supseteqq\":\"⫆\",\"supsetneq\":\"⊋\",\"supsetneqq\":\"⫌\",\"supsim\":\"⫈\",\"supsub\":\"⫔\",\"supsup\":\"⫖\",\"swarhk\":\"⤦\",\"swarr\":\"↙\",\"swArr\":\"⇙\",\"swarrow\":\"↙\",\"swnwar\":\"⤪\",\"szlig\":\"ß\",\"Tab\":\"\\t\",\"target\":\"⌖\",\"Tau\":\"Τ\",\"tau\":\"τ\",\"tbrk\":\"⎴\",\"Tcaron\":\"Ť\",\"tcaron\":\"ť\",\"Tcedil\":\"Ţ\",\"tcedil\":\"ţ\",\"Tcy\":\"Т\",\"tcy\":\"т\",\"tdot\":\"⃛\",\"telrec\":\"⌕\",\"Tfr\":\"𝔗\",\"tfr\":\"𝔱\",\"there4\":\"∴\",\"therefore\":\"∴\",\"Therefore\":\"∴\",\"Theta\":\"Θ\",\"theta\":\"θ\",\"thetasym\":\"ϑ\",\"thetav\":\"ϑ\",\"thickapprox\":\"≈\",\"thicksim\":\"∼\",\"ThickSpace\":\"  \",\"ThinSpace\":\" \",\"thinsp\":\" \",\"thkap\":\"≈\",\"thksim\":\"∼\",\"THORN\":\"Þ\",\"thorn\":\"þ\",\"tilde\":\"˜\",\"Tilde\":\"∼\",\"TildeEqual\":\"≃\",\"TildeFullEqual\":\"≅\",\"TildeTilde\":\"≈\",\"timesbar\":\"⨱\",\"timesb\":\"⊠\",\"times\":\"×\",\"timesd\":\"⨰\",\"tint\":\"∭\",\"toea\":\"⤨\",\"topbot\":\"⌶\",\"topcir\":\"⫱\",\"top\":\"⊤\",\"Topf\":\"𝕋\",\"topf\":\"𝕥\",\"topfork\":\"⫚\",\"tosa\":\"⤩\",\"tprime\":\"‴\",\"trade\":\"™\",\"TRADE\":\"™\",\"triangle\":\"▵\",\"triangledown\":\"▿\",\"triangleleft\":\"◃\",\"trianglelefteq\":\"⊴\",\"triangleq\":\"≜\",\"triangleright\":\"▹\",\"trianglerighteq\":\"⊵\",\"tridot\":\"◬\",\"trie\":\"≜\",\"triminus\":\"⨺\",\"TripleDot\":\"⃛\",\"triplus\":\"⨹\",\"trisb\":\"⧍\",\"tritime\":\"⨻\",\"trpezium\":\"⏢\",\"Tscr\":\"𝒯\",\"tscr\":\"𝓉\",\"TScy\":\"Ц\",\"tscy\":\"ц\",\"TSHcy\":\"Ћ\",\"tshcy\":\"ћ\",\"Tstrok\":\"Ŧ\",\"tstrok\":\"ŧ\",\"twixt\":\"≬\",\"twoheadleftarrow\":\"↞\",\"twoheadrightarrow\":\"↠\",\"Uacute\":\"Ú\",\"uacute\":\"ú\",\"uarr\":\"↑\",\"Uarr\":\"↟\",\"uArr\":\"⇑\",\"Uarrocir\":\"⥉\",\"Ubrcy\":\"Ў\",\"ubrcy\":\"ў\",\"Ubreve\":\"Ŭ\",\"ubreve\":\"ŭ\",\"Ucirc\":\"Û\",\"ucirc\":\"û\",\"Ucy\":\"У\",\"ucy\":\"у\",\"udarr\":\"⇅\",\"Udblac\":\"Ű\",\"udblac\":\"ű\",\"udhar\":\"⥮\",\"ufisht\":\"⥾\",\"Ufr\":\"𝔘\",\"ufr\":\"𝔲\",\"Ugrave\":\"Ù\",\"ugrave\":\"ù\",\"uHar\":\"⥣\",\"uharl\":\"↿\",\"uharr\":\"↾\",\"uhblk\":\"▀\",\"ulcorn\":\"⌜\",\"ulcorner\":\"⌜\",\"ulcrop\":\"⌏\",\"ultri\":\"◸\",\"Umacr\":\"Ū\",\"umacr\":\"ū\",\"uml\":\"¨\",\"UnderBar\":\"_\",\"UnderBrace\":\"⏟\",\"UnderBracket\":\"⎵\",\"UnderParenthesis\":\"⏝\",\"Union\":\"⋃\",\"UnionPlus\":\"⊎\",\"Uogon\":\"Ų\",\"uogon\":\"ų\",\"Uopf\":\"𝕌\",\"uopf\":\"𝕦\",\"UpArrowBar\":\"⤒\",\"uparrow\":\"↑\",\"UpArrow\":\"↑\",\"Uparrow\":\"⇑\",\"UpArrowDownArrow\":\"⇅\",\"updownarrow\":\"↕\",\"UpDownArrow\":\"↕\",\"Updownarrow\":\"⇕\",\"UpEquilibrium\":\"⥮\",\"upharpoonleft\":\"↿\",\"upharpoonright\":\"↾\",\"uplus\":\"⊎\",\"UpperLeftArrow\":\"↖\",\"UpperRightArrow\":\"↗\",\"upsi\":\"υ\",\"Upsi\":\"ϒ\",\"upsih\":\"ϒ\",\"Upsilon\":\"Υ\",\"upsilon\":\"υ\",\"UpTeeArrow\":\"↥\",\"UpTee\":\"⊥\",\"upuparrows\":\"⇈\",\"urcorn\":\"⌝\",\"urcorner\":\"⌝\",\"urcrop\":\"⌎\",\"Uring\":\"Ů\",\"uring\":\"ů\",\"urtri\":\"◹\",\"Uscr\":\"𝒰\",\"uscr\":\"𝓊\",\"utdot\":\"⋰\",\"Utilde\":\"Ũ\",\"utilde\":\"ũ\",\"utri\":\"▵\",\"utrif\":\"▴\",\"uuarr\":\"⇈\",\"Uuml\":\"Ü\",\"uuml\":\"ü\",\"uwangle\":\"⦧\",\"vangrt\":\"⦜\",\"varepsilon\":\"ϵ\",\"varkappa\":\"ϰ\",\"varnothing\":\"∅\",\"varphi\":\"ϕ\",\"varpi\":\"ϖ\",\"varpropto\":\"∝\",\"varr\":\"↕\",\"vArr\":\"⇕\",\"varrho\":\"ϱ\",\"varsigma\":\"ς\",\"varsubsetneq\":\"⊊︀\",\"varsubsetneqq\":\"⫋︀\",\"varsupsetneq\":\"⊋︀\",\"varsupsetneqq\":\"⫌︀\",\"vartheta\":\"ϑ\",\"vartriangleleft\":\"⊲\",\"vartriangleright\":\"⊳\",\"vBar\":\"⫨\",\"Vbar\":\"⫫\",\"vBarv\":\"⫩\",\"Vcy\":\"В\",\"vcy\":\"в\",\"vdash\":\"⊢\",\"vDash\":\"⊨\",\"Vdash\":\"⊩\",\"VDash\":\"⊫\",\"Vdashl\":\"⫦\",\"veebar\":\"⊻\",\"vee\":\"∨\",\"Vee\":\"⋁\",\"veeeq\":\"≚\",\"vellip\":\"⋮\",\"verbar\":\"|\",\"Verbar\":\"‖\",\"vert\":\"|\",\"Vert\":\"‖\",\"VerticalBar\":\"∣\",\"VerticalLine\":\"|\",\"VerticalSeparator\":\"❘\",\"VerticalTilde\":\"≀\",\"VeryThinSpace\":\" \",\"Vfr\":\"𝔙\",\"vfr\":\"𝔳\",\"vltri\":\"⊲\",\"vnsub\":\"⊂⃒\",\"vnsup\":\"⊃⃒\",\"Vopf\":\"𝕍\",\"vopf\":\"𝕧\",\"vprop\":\"∝\",\"vrtri\":\"⊳\",\"Vscr\":\"𝒱\",\"vscr\":\"𝓋\",\"vsubnE\":\"⫋︀\",\"vsubne\":\"⊊︀\",\"vsupnE\":\"⫌︀\",\"vsupne\":\"⊋︀\",\"Vvdash\":\"⊪\",\"vzigzag\":\"⦚\",\"Wcirc\":\"Ŵ\",\"wcirc\":\"ŵ\",\"wedbar\":\"⩟\",\"wedge\":\"∧\",\"Wedge\":\"⋀\",\"wedgeq\":\"≙\",\"weierp\":\"℘\",\"Wfr\":\"𝔚\",\"wfr\":\"𝔴\",\"Wopf\":\"𝕎\",\"wopf\":\"𝕨\",\"wp\":\"℘\",\"wr\":\"≀\",\"wreath\":\"≀\",\"Wscr\":\"𝒲\",\"wscr\":\"𝓌\",\"xcap\":\"⋂\",\"xcirc\":\"◯\",\"xcup\":\"⋃\",\"xdtri\":\"▽\",\"Xfr\":\"𝔛\",\"xfr\":\"𝔵\",\"xharr\":\"⟷\",\"xhArr\":\"⟺\",\"Xi\":\"Ξ\",\"xi\":\"ξ\",\"xlarr\":\"⟵\",\"xlArr\":\"⟸\",\"xmap\":\"⟼\",\"xnis\":\"⋻\",\"xodot\":\"⨀\",\"Xopf\":\"𝕏\",\"xopf\":\"𝕩\",\"xoplus\":\"⨁\",\"xotime\":\"⨂\",\"xrarr\":\"⟶\",\"xrArr\":\"⟹\",\"Xscr\":\"𝒳\",\"xscr\":\"𝓍\",\"xsqcup\":\"⨆\",\"xuplus\":\"⨄\",\"xutri\":\"△\",\"xvee\":\"⋁\",\"xwedge\":\"⋀\",\"Yacute\":\"Ý\",\"yacute\":\"ý\",\"YAcy\":\"Я\",\"yacy\":\"я\",\"Ycirc\":\"Ŷ\",\"ycirc\":\"ŷ\",\"Ycy\":\"Ы\",\"ycy\":\"ы\",\"yen\":\"¥\",\"Yfr\":\"𝔜\",\"yfr\":\"𝔶\",\"YIcy\":\"Ї\",\"yicy\":\"ї\",\"Yopf\":\"𝕐\",\"yopf\":\"𝕪\",\"Yscr\":\"𝒴\",\"yscr\":\"𝓎\",\"YUcy\":\"Ю\",\"yucy\":\"ю\",\"yuml\":\"ÿ\",\"Yuml\":\"Ÿ\",\"Zacute\":\"Ź\",\"zacute\":\"ź\",\"Zcaron\":\"Ž\",\"zcaron\":\"ž\",\"Zcy\":\"З\",\"zcy\":\"з\",\"Zdot\":\"Ż\",\"zdot\":\"ż\",\"zeetrf\":\"ℨ\",\"ZeroWidthSpace\":\"​\",\"Zeta\":\"Ζ\",\"zeta\":\"ζ\",\"zfr\":\"𝔷\",\"Zfr\":\"ℨ\",\"ZHcy\":\"Ж\",\"zhcy\":\"ж\",\"zigrarr\":\"⇝\",\"zopf\":\"𝕫\",\"Zopf\":\"ℤ\",\"Zscr\":\"𝒵\",\"zscr\":\"𝓏\",\"zwj\":\"‍\",\"zwnj\":\"‌\"}");

/***/ }),

/***/ "8zGh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Flipper; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;

var Flipper = function Flipper(_ref) {
  var description = _ref.description,
      value = _ref.value;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(value),
      oldValue = _useState[0],
      setOldValue = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(value),
      latestValue = _useState2[0],
      setLatestValue = _useState2[1];

  var _useState3 = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(''),
      transition = _useState3[0],
      setTransition = _useState3[1];

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    setOldValue(latestValue);
    setLatestValue(value);

    if (value !== latestValue) {
      setTransition('flipperLeave');
    }
  }, [value]);
  return __jsx("span", {
    "data-testid": value,
    className: "relative"
  }, !!description && __jsx("span", {
    className: "sr-only",
    "data-testid": "srOnly"
  }, description), __jsx("span", {
    className: "text-center ".concat(transition),
    "data-testid": "Flipper-value",
    key: transition,
    onAnimationEnd: function onAnimationEnd(event) {
      switch (event.animationName) {
        case 'flipperLeave':
          setTransition('flipperEnter');
          break;

        case 'flipperEnter':
          setTransition('flipperEnter');
          break;

        default:
          break;
      }
    }
  }, transition === 'flipperLeave' ? oldValue : latestValue));
};

/***/ }),

/***/ "9BC+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isPhoneNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return emailRegex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPhoneRegex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return salesmanIDRegex; });
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_0__);
 // WARNING: iF this file is growing too much, think of replacing it with a library like Validator.js

function isPhoneNumber(stringToTest) {
  return /^[\d\s()+-.]+$/.test(stringToTest.trim());
}

var emailRegex = new RegExp(/^[_A-Za-z0-9-+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/);
var salesmanIDRegex = new RegExp(/(^\d{6,8}$|^$)/);

var getPhoneRegex = function getPhoneRegex(locale) {
  var _domainsService$getDo, _domainsService$getDo2;

  return new RegExp(((_domainsService$getDo = _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_0___default.a.getDomain(locale)) === null || _domainsService$getDo === void 0 ? void 0 : (_domainsService$getDo2 = _domainsService$getDo.fields) === null || _domainsService$getDo2 === void 0 ? void 0 : _domainsService$getDo2.phoneNumber) || /^ *\+? *(?:[ \-()\.\/]*[0-9][ \-()\.\/]*){6,12}$/);
};



/***/ }),

/***/ "9TP6":
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__("OBn4"),
    noop = __webpack_require__("nnm9"),
    setToArray = __webpack_require__("XlL0");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ "9YYj":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("nJrx");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "9jKB":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("Uqkn");
var global = __webpack_require__("HnW7");
var isObject = __webpack_require__("1YFU");
var createNonEnumerableProperty = __webpack_require__("g51W");
var objectHas = __webpack_require__("DZWw");
var shared = __webpack_require__("l6h7");
var sharedKey = __webpack_require__("mmil");
var hiddenKeys = __webpack_require__("qXr/");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (objectHas(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "9sjr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatFooterLabelName; });
var CSS_TRACKING_MAPPING = {
  phoneBubble: 'clickToCall',
  callMeBack: 'webCallBack'
};
function formatFooterLabelName(id) {
  return CSS_TRACKING_MAPPING.hasOwnProperty(id) ? CSS_TRACKING_MAPPING[id] : id;
}

/***/ }),

/***/ "A+R+":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("4gXF");

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "A/WM":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var classNames = (function () {
		// don't inherit from Object so we can skip hasOwnProperty check later
		// http://stackoverflow.com/questions/15518328/creating-js-object-with-object-createnull#answer-21079232
		function StorageObject() {}
		StorageObject.prototype = Object.create(null);

		function _parseArray (resultSet, array) {
			var length = array.length;

			for (var i = 0; i < length; ++i) {
				_parse(resultSet, array[i]);
			}
		}

		var hasOwn = {}.hasOwnProperty;

		function _parseNumber (resultSet, num) {
			resultSet[num] = true;
		}

		function _parseObject (resultSet, object) {
			for (var k in object) {
				if (hasOwn.call(object, k)) {
					// set value to false instead of deleting it to avoid changing object structure
					// https://www.smashingmagazine.com/2012/11/writing-fast-memory-efficient-javascript/#de-referencing-misconceptions
					resultSet[k] = !!object[k];
				}
			}
		}

		var SPACE = /\s+/;
		function _parseString (resultSet, str) {
			var array = str.split(SPACE);
			var length = array.length;

			for (var i = 0; i < length; ++i) {
				resultSet[array[i]] = true;
			}
		}

		function _parse (resultSet, arg) {
			if (!arg) return;
			var argType = typeof arg;

			// 'foo bar'
			if (argType === 'string') {
				_parseString(resultSet, arg);

			// ['foo', 'bar', ...]
			} else if (Array.isArray(arg)) {
				_parseArray(resultSet, arg);

			// { 'foo': true, ... }
			} else if (argType === 'object') {
				_parseObject(resultSet, arg);

			// '130'
			} else if (argType === 'number') {
				_parseNumber(resultSet, arg);
			}
		}

		function _classNames () {
			// don't leak arguments
			// https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
			var len = arguments.length;
			var args = Array(len);
			for (var i = 0; i < len; i++) {
				args[i] = arguments[i];
			}

			var classSet = new StorageObject();
			_parseArray(classSet, args);

			var list = [];

			for (var k in classSet) {
				if (classSet[k]) {
					list.push(k)
				}
			}

			return list.join(' ');
		}

		return _classNames;
	})();

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ "A5Hi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ SliderHandler_SliderHandler; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/utils/keyCodes.js
var keyCodes = __webpack_require__("05v4");

// CONCATENATED MODULE: ./src/client/components/frameworks/slider-handler/SliderHandler.helper.js
function getIndexInRange(index, max) {
  if (index < 0) {
    return 0;
  }

  return index < max ? index : max;
}
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./src/client/components/frameworks/slider-handler/SliderHandlerItems.jsx
var __jsx = react_default.a.createElement;

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */


// $FlowFixMe
var SliderHandlerItems = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  var children = props.children,
      className = props.className,
      hasControls = props.hasControls,
      isSwiping = props.isSwiping,
      itemPercentSize = props.itemPercentSize,
      onSwipeEnd = props.onSwipeEnd,
      onSwipeMove = props.onSwipeMove,
      onSwipeStart = props.onSwipeStart,
      position = props.position;
  return __jsx("div", {
    className: classnames_default()(className, 'overflow-hidden'),
    ref: ref,
    tabIndex: hasControls ? 0 : -1
  }, __jsx("div", {
    className: classnames_default()('flex h-full will-change-transform', {
      'transition-transform': !isSwiping
    }),
    style: {
      transform: "translate(".concat(position, "%, 0)"),
      WebkitTapHighlightColor: 'transparent'
    },
    onTouchStart: onSwipeStart,
    onTouchMove: onSwipeMove,
    onTouchEnd: onSwipeEnd
  }, react["Children"].map(children, function (child, idx) {
    return __jsx("div", {
      "aria-hidden": child.props.ariaHidden,
      className: "max-w-full will-change-transform",
      key: idx,
      style: {
        minWidth: "".concat(itemPercentSize, "%"),
        maxWidth: "".concat(itemPercentSize, "%")
      },
      tabIndex: child.props.tabIndex
    }, child);
  })));
});
// CONCATENATED MODULE: ./src/client/components/frameworks/slider-handler/SliderHandler.jsx







var SliderHandler_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






var SliderHandler_SliderHandler = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(SliderHandler, _Component);

  var _super = _createSuper(SliderHandler);

  function SliderHandler(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, SliderHandler);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onNext", function (event) {
      if (event) {
        event.preventDefault();
      }

      var _this$state = _this.state,
          maxIndex = _this$state.maxIndex,
          index = _this$state.index;

      var i = index + _this.getStep();

      if (i > maxIndex) {
        i = _this.props.hasInfiniteScroll ? 0 : maxIndex;
      }

      _this.goToIndex(i, _this.props.onNext);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onPrevious", function (event) {
      if (event) {
        event.preventDefault();
      }

      var _this$state2 = _this.state,
          maxIndex = _this$state2.maxIndex,
          index = _this$state2.index;
      var min = 0;

      var i = index - _this.getStep();

      if (i < min) {
        i = _this.props.hasInfiniteScroll ? maxIndex + i + 1 : min;
      }

      _this.goToIndex(i, _this.props.onPrevious);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onKeyUp", function (event) {
      var isRTL = _this.state.isRTL;

      if (_this.props.hasKeyboardSupport) {
        switch (event.which) {
          case keyCodes["c" /* ARROW_RIGHT */]:
            event.stopPropagation();
            isRTL ? _this.onPrevious(event) : _this.onNext(event);
            break;

          case keyCodes["b" /* ARROW_LEFT */]:
            event.stopPropagation();
            isRTL ? _this.onNext(event) : _this.onPrevious(event);
            break;

          default:
        }
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onSwipeStart", function (event) {
      if (_this.props.hasSwipeSupport) {
        event.stopPropagation();

        var swipeStart = _this.getSwipeX(event);

        var slideWidth = _this.sliderRef.current ? _this.sliderRef.current.offsetWidth : 0;

        _this.setState(function (_ref) {
          var lastIndex = _ref.lastIndex;
          return {
            slideWidth: slideWidth,
            isSwiping: true,
            swipeStart: swipeStart,
            swipeX: lastIndex,
            swipeStartTime: new Date()
          };
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onSwipeMove", function (event) {
      if (_this.props.hasSwipeSupport) {
        event.stopPropagation();

        var x = _this.getSwipeX(event);

        _this.setState(function (prevState) {
          var prevItemsToRender = prevState.itemsToRender,
              lastIndex = prevState.lastIndex,
              swipeStart = prevState.swipeStart,
              slideWidth = prevState.slideWidth,
              maxIndex = prevState.maxIndex,
              isRTL = prevState.isRTL;
          var offset = swipeStart - x;
          var percentageOffset = offset / slideWidth;
          var swipeX = isRTL ? lastIndex - percentageOffset : lastIndex + percentageOffset;
          var index = getIndexInRange(Math.round(swipeX), maxIndex);

          var itemsToRender = _this.getItemsToRender(prevItemsToRender, index, _this.props.nbItemsToShow);

          return _objectSpread({
            swipeX: getIndexInRange(swipeX, maxIndex)
          }, itemsToRender && {
            itemsToRender: itemsToRender
          });
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onSwipeEnd", function (event) {
      if (_this.props.hasSwipeSupport) {
        event.stopPropagation();

        _this.setState(function (prevState) {
          var prevItemsToRender = prevState.itemsToRender,
              lastIndex = prevState.lastIndex,
              swipeStartTime = prevState.swipeStartTime,
              swipeX = prevState.swipeX,
              maxIndex = prevState.maxIndex;

          var step = _this.getStep();

          var timeElapsed = new Date().getTime() - swipeStartTime.getTime();
          var offset = lastIndex - swipeX;
          var velocity = Math.round(offset / timeElapsed * 10000);
          var index = Math.round(swipeX);

          if (Math.abs(velocity) > 5) {
            index = velocity < 0 ? lastIndex + step : lastIndex - step;
          }

          var itemsToRender = _this.getItemsToRender(prevItemsToRender, index, _this.props.nbItemsToShow);

          return _objectSpread({
            index: getIndexInRange(index, maxIndex),
            isSwiping: false,
            swipeStart: 0,
            swipeX: 0
          }, itemsToRender && {
            itemsToRender: itemsToRender
          });
        }, function () {
          var _this$state3 = _this.state,
              index = _this$state3.index,
              lastIndex = _this$state3.lastIndex;
          var _this$props = _this.props,
              onPrevious = _this$props.onPrevious,
              onNext = _this$props.onNext;

          if (index < lastIndex && onPrevious) {
            onPrevious();
          } else if (index > lastIndex && onNext) {
            onNext();
          }

          _this.setState(function () {
            return {
              lastIndex: index
            };
          });
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "isItemVisible", function (itemIndex) {
      var index = _this.state.index;
      return itemIndex >= index && itemIndex < index + _this.props.nbItemsToShow;
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "shouldRenderItem", function (itemIndex) {
      return !_this.props.hasLazyload || _this.state.itemsToRender[itemIndex];
    });

    _this.sliderRef = /*#__PURE__*/Object(react["createRef"])();
    _this.state = _this.initState(props);
    return _this;
  }

  Object(createClass["a" /* default */])(SliderHandler, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props2 = this.props,
          hasAutoplay = _this$props2.hasAutoplay,
          hasKeyboardSupport = _this$props2.hasKeyboardSupport;

      if (hasKeyboardSupport && this.sliderRef.current) {
        this.sliderRef.current.addEventListener('keyup', this.onKeyUp, false);
      }

      if (hasAutoplay) {
        this.intervalId = setInterval(function () {
          return _this2.onNext();
        }, 3000);
      }

      if (Object(lodash["get"])(document, 'documentElement.dir', 'ltr') === 'rtl') {
        this.setState({
          isRTL: true
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var hasKeyboardSupport = this.props.hasKeyboardSupport;

      if (hasKeyboardSupport && this.sliderRef.current) {
        this.sliderRef.current.removeEventListener('keyup', this.onKeyUp, false);
      }

      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    }
  }, {
    key: "initState",
    value: function initState(props) {
      var hasLazyload = props.hasLazyload,
          initialIndex = props.initialIndex,
          items = props.items,
          nbItemsToShow = props.nbItemsToShow;
      var itemsCount = items.length;
      var maxIndex = itemsCount < nbItemsToShow ? 0 : itemsCount - nbItemsToShow;
      var index = getIndexInRange(initialIndex, maxIndex);
      var initialItemsToRender = Array(itemsCount).fill(!hasLazyload, 0, itemsCount);
      var itemsToRender = this.getItemsToRender(initialItemsToRender, index, nbItemsToShow);
      return {
        index: index,
        isSwiping: false,
        isRTL: false,
        itemsCount: itemsCount,
        itemsToRender: itemsToRender,
        lastIndex: index,
        maxIndex: maxIndex,
        slideWidth: 0,
        swipeStart: 0,
        swipeStartTime: new Date(),
        swipeX: 0
      };
    }
  }, {
    key: "getItemsToRender",
    value: function getItemsToRender(itemsToRender, index, nbItemsToShow) {
      var hasLazyload = this.props.hasLazyload;
      var step = this.getStep();
      var minRange = index - step;
      var maxRange = index + nbItemsToShow + step;
      var newItemToRender = itemsToRender.map(function (isRendered, itemIndex) {
        return isRendered || Object(lodash["inRange"])(itemIndex, minRange, maxRange);
      });

      if (!hasLazyload || itemsToRender.every(function (isRendered) {
        return isRendered;
      }) || Object(lodash["isEqual"])(itemsToRender, newItemToRender)) {
        return itemsToRender;
      }

      return newItemToRender;
    }
  }, {
    key: "getStep",
    value: function getStep() {
      var _this$props$nbItemsTo = this.props.nbItemsToScroll,
          nbItemsToScroll = _this$props$nbItemsTo === void 0 ? 1 : _this$props$nbItemsTo;
      return nbItemsToScroll > 0 ? nbItemsToScroll : 1;
    } // Slide

  }, {
    key: "getItemPosition",
    value: function getItemPosition() {
      var _this$state4 = this.state,
          index = _this$state4.index,
          swipeX = _this$state4.swipeX,
          isSwiping = _this$state4.isSwiping,
          isRTL = _this$state4.isRTL;
      var x = isSwiping ? swipeX : index;
      var posX = x * 100 / this.props.nbItemsToShow;
      return isRTL ? posX : -posX;
    }
  }, {
    key: "goToIndex",
    value: function goToIndex(index) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : lodash["noop"];
      this.setState(function (prevState) {
        var itemsToRender = _this3.getItemsToRender(prevState.itemsToRender, index, _this3.props.nbItemsToShow);

        return {
          index: index,
          itemsToRender: itemsToRender,
          lastIndex: index
        };
      }, callback);
    } // Events handlers

  }, {
    key: "getSwipeX",
    // Swipe
    value: function getSwipeX(event) {
      return event.touches[0].pageX;
    }
  }, {
    key: "isFirstItemVisible",
    value: function isFirstItemVisible() {
      return this.isItemVisible(0);
    }
  }, {
    key: "isLastItemVisible",
    value: function isLastItemVisible() {
      var itemsCount = this.state.itemsCount;
      return this.isItemVisible(itemsCount - 1);
    }
  }, {
    key: "hasControls",
    value: function hasControls() {
      return this.state.itemsCount > this.props.nbItemsToShow;
    }
  }, {
    key: "render",
    // render
    value: function render() {
      var _this4 = this;

      var _this$state5 = this.state,
          index = _this$state5.index,
          isSwiping = _this$state5.isSwiping,
          itemsCount = _this$state5.itemsCount;
      if (!itemsCount) return null;
      var _this$props3 = this.props,
          children = _this$props3.children,
          className = _this$props3.className,
          hasInfiniteScroll = _this$props3.hasInfiniteScroll,
          items = _this$props3.items,
          nbItemsToShow = _this$props3.nbItemsToShow;
      var hasControls = this.hasControls();

      var itemsNode = SliderHandler_jsx(SliderHandlerItems, {
        className: className,
        hasControls: hasControls,
        isSwiping: isSwiping,
        itemPercentSize: 100 / nbItemsToShow,
        onSwipeEnd: this.onSwipeEnd,
        onSwipeMove: this.onSwipeMove,
        onSwipeStart: this.onSwipeStart,
        position: this.getItemPosition(),
        ref: this.sliderRef
      }, items.map(function (item, idx) {
        return _this4.shouldRenderItem(idx) ? /*#__PURE__*/Object(react["cloneElement"])(item, {
          'aria-hidden': !_this4.isItemVisible(idx),
          tabIndex: -1
        }) : null;
      }).filter(Boolean));

      var childrenProps = {
        hasControls: hasControls,
        index: index,
        isNextControlDisabled: !hasInfiniteScroll && this.isLastItemVisible(),
        isPreviousControlDisabled: !hasInfiniteScroll && this.isFirstItemVisible(),
        itemsNode: itemsNode,
        onNext: this.onNext,
        onPrevious: this.onPrevious
      };
      return children(childrenProps);
    }
  }]);

  return SliderHandler;
}(react["Component"]);

Object(defineProperty["a" /* default */])(SliderHandler_SliderHandler, "defaultProps", {
  initialIndex: 0,
  nbItemsToScroll: 1,
  nbItemsToShow: 1
});

/***/ }),

/***/ "AZSF":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("nJrx");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "AbLU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return usePrevious; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var usePrevious = function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  var ref = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])(); // Store current value in ref

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    ref.current = value;
  }, [value]); // Only re-run if value changes
  // Return previous value (happens before update in useEffect above)

  return ref.current;
};

/***/ }),

/***/ "AnR0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "q", function() { return /* binding */ setPromoCode; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ addAccommodation; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ addTransport; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ proposals_action_addAdditionalService; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ proposals_action_deleteAdditionalServices; });
__webpack_require__.d(__webpack_exports__, "t", function() { return /* binding */ updateAttendees; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ clearProposals; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ fetchProposalsAndRedirect; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ fetchProposalsById; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ proposals_action_fetchSelectedProposalPayment; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* binding */ proposals_action_saveCustomerProposalsHandler; });
__webpack_require__.d(__webpack_exports__, "u", function() { return /* binding */ updateInsurances; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ deleteInsurances; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* binding */ setNoInsurances; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ proposals_action_prepareBe; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ displayToastOnContextShare; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ editCriteriaFetchProposals; });
__webpack_require__.d(__webpack_exports__, "r", function() { return /* binding */ simpleFetchProposals; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* binding */ proposals_action_saveDonationToProposals; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ proposals_action_addOrReplaceAdditionalServices; });
__webpack_require__.d(__webpack_exports__, "s", function() { return /* binding */ proposals_action_switchProposalsOffers; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/index.js
var tracking_api = __webpack_require__("d1HQ");

// EXTERNAL MODULE: ./src/client/tracking/tracking-storage-api/index.js
var tracking_storage_api = __webpack_require__("K0Lv");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngine.query.js
var BookingEngine_query = __webpack_require__("MAH5");

// EXTERNAL MODULE: ./src/utils/booking-engine-pages/BookingPagesUtils.js
var BookingPagesUtils = __webpack_require__("rcxx");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var faceting_constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./src/utils/uri/redirectUtils.js
var redirectUtils = __webpack_require__("k9PE");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./src/utils/graphql-query-helper/booking/proposal/proposalQuery.js
var proposalQuery = __webpack_require__("70jX");

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/utils/graphql-query-helper/booking/attendees/attendeesQuery.js
var attendeesQuery = __webpack_require__("Bujb");

// EXTERNAL MODULE: ./src/utils/graphql/index.js
var graphql = __webpack_require__("NLwV");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// CONCATENATED MODULE: ./src/utils/graphql-query-helper/booking/insurances/insurancesQuery.js






function updateInsurancesMutation(proposalId, insuranceId, attendees, appContext) {
  return graphqlClient["a" /* default */].runNoCacheQuery("\n    mutation {\n      modifyInsurances (\n      proposalId: \"".concat(proposalId, "\",\n      insuranceId: \"").concat(insuranceId, "\",\n      attendees:   ").concat(Object(graphql["d" /* graphqlify */])(attendees), "\n     ) {\n        proposal {\n          id\n          ").concat(Object(proposalQuery["m" /* proposalPriceQuery */])(), "\n          ").concat(Object(proposalQuery["i" /* insurancesQuery */])(), "\n          ").concat(Object(proposalQuery["g" /* getPaymentScheduleRequest */])(appContext), "\n        }\n        errors {\n          errorKey\n          errorValue\n          errorCode\n        }\n      }\n    }\n    ").concat(Object(proposalQuery["h" /* getPriceDetailFragment */])(Object(lodash["get"])(appContext, 'locale')), "\n    "), appContext, {
    requestName: requestDictionary["xd" /* PROPOSAL_UPDATE_INSURANCES */]
  });
}

function deleteInsurancesMutation(proposalId, insuranceId, appContext) {
  return graphqlClient["a" /* default */].runNoCacheQuery("\n    mutation {\n      deleteInsurances (\n      proposalId: \"".concat(proposalId, "\",\n      insuranceId: \"").concat(insuranceId, "\",\n     ) {\n        proposal {\n          id\n          ").concat(Object(proposalQuery["m" /* proposalPriceQuery */])(), "\n          ").concat(Object(proposalQuery["i" /* insurancesQuery */])(), "\n          ").concat(Object(proposalQuery["g" /* getPaymentScheduleRequest */])(appContext), "\n        }\n        errors {\n          errorKey\n          errorValue\n          errorCode\n        }\n      }\n    }\n    ").concat(Object(proposalQuery["h" /* getPriceDetailFragment */])(Object(lodash["get"])(appContext, 'locale')), "\n    "), appContext, {
    requestName: requestDictionary["md" /* PROPOSAL_DELETE_INSURANCES */]
  });
}


// EXTERNAL MODULE: ./src/client/store/booking/constants.js
var booking_constants = __webpack_require__("2N/j");

// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/client/store/trip-date-criteria/storeHelper.js
var storeHelper = __webpack_require__("Mn1B");

// EXTERNAL MODULE: ./src/client/store/trip-information/adults/constants.js
var adults_constants = __webpack_require__("ORYz");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var trip_information_storeHelper = __webpack_require__("Jsmy");

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./logger/logger.js
var logger = __webpack_require__("zytj");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/store/cms/cms.actions.js
var cms_actions = __webpack_require__("pP7N");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/constants.js
var proposals_constants = __webpack_require__("UIAR");

// CONCATENATED MODULE: ./src/client/store/booking/proposals/proposals.action.js



var _BOOKING_ENGINE_ENTRY;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


























var BOOKING_ENGINE_ENTRY_TRACKING_LABELS = (_BOOKING_ENGINE_ENTRY = {}, Object(defineProperty["a" /* default */])(_BOOKING_ENGINE_ENTRY, booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_CALENDAR, 'calendarPrice'), Object(defineProperty["a" /* default */])(_BOOKING_ENGINE_ENTRY, booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_REMOTE, 'remotePrice'), Object(defineProperty["a" /* default */])(_BOOKING_ENGINE_ENTRY, booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].QUICK_SEARCH, 'quickSearch'), Object(defineProperty["a" /* default */])(_BOOKING_ENGINE_ENTRY, booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].CRUISE_BOOKING, 'cruiseBooking'), _BOOKING_ENGINE_ENTRY);

function setPromoCode(proposalId, params, appContext) {
  return Object(createAction["a" /* createOptimisticAction */])(proposals_constants["w" /* SET_PROMO_CODE */], {}, {
    optimist: true,
    promise: Object(proposalQuery["k" /* promoCodeProposalMutation */])(_objectSpread({
      proposalId: proposalId
    }, params), appContext)
  });
}

function fetchProposalsById(_ref) {
  var proposalsId = _ref.proposalsId,
      appContext = _ref.appContext,
      shouldRequestPayment = _ref.shouldRequestPayment,
      adultsAttendeesIds = _ref.adultsAttendeesIds,
      kidsAttendeesIds = _ref.kidsAttendeesIds;
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */], {}, {
      optimist: true,
      promise: Object(BookingEngine_query["c" /* proposalsByIdQuery */])({
        proposalsId: proposalsId,
        shouldRequestPayment: shouldRequestPayment,
        adultsAttendeesIds: adultsAttendeesIds,
        kidsAttendeesIds: kidsAttendeesIds,
        fetchActivityCategories: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayActivities')
      }, appContext)
    }));
  };
}
/*
  ATTENTION:
  Les valeurs par défaut de departureCity et duration sont mises dans le CMS,
  on ne peut donc pas récupérer les valeurs du store
 */


function fetchProposalsAndRedirect(params, additionalTrackingParams, appContext, _ref2) {
  var queryParams = _ref2.queryParams;
  return function (dispatch, getState) {
    var _queryParams$kids, _queryParams$kids$spl;

    var state = getState();
    var adults = Object(trip_information_storeHelper["a" /* getAdults */])(state) || [];
    var kids = Object(trip_information_storeHelper["c" /* getKids */])(state) || [];
    var maxPaxByUser = appContext.isSeller ? faceting_constants["x" /* MAX_PAX_SELLER */] : faceting_constants["w" /* MAX_PAX */];
    var nbKids = appContext.isSeller ? ((_queryParams$kids = queryParams.kids) === null || _queryParams$kids === void 0 ? void 0 : (_queryParams$kids$spl = _queryParams$kids.split('_')) === null || _queryParams$kids$spl === void 0 ? void 0 : _queryParams$kids$spl.length) || 0 : kids.length;
    var nbAdults = appContext.isSeller ? Number(queryParams.number_of_adults) : Object(trip_information_storeHelper["b" /* getAdultsNumber */])(state);
    var numberAttendees = nbAdults + nbKids;
    var intArrivalDate = params.newArrivalDate ? params.newArrivalDate : Object(storeHelper["a" /* getArrivalDate */])(state) || Object(apiDate["l" /* timestampToApiDate */])(state.tripCriteria.departureDate);
    var redirectUri = Object(sellerUtils["e" /* getSigninURIWithRedirection */])({
      locale: appContext.locale,
      proposalId: null,
      step: null,
      isCmta: appContext.isCmta
    });
    if (!intArrivalDate) return;
    var arrivalDate = intArrivalDate.toString();

    var proposalParams = _objectSpread(_objectSpread({
      arrivalDate: arrivalDate,
      kids: kids,
      adults: adults,
      numberAttendees: numberAttendees === 0 || numberAttendees > maxPaxByUser ? adults_constants["a" /* DEFAULT_ADULTS_NB */] : numberAttendees,
      fetchActivityCategories: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayActivities')
    }, appContext.isSeller ? {
      salesNetworkId: queryParams.cxo_sales_network_id
    } : null), params);

    var payload = {
      globalLoaderLabel: params.globalLoaderLabel,
      bookingEngineEntry: params.bookingEngineEntry
    };
    var promise = Promise.all([Object(proposalQuery["n" /* proposalsQuery */])(proposalParams, appContext), dispatch(Object(cms_actions["c" /* getBookingEngineI18n */])(appContext))]).then(function (_ref3) {
      var _proposals$errors, _proposals$errors$;

      var _ref4 = Object(slicedToArray["a" /* default */])(_ref3, 1),
          response = _ref4[0];

      var proposals = response.proposals;
      var isFetchProposalsFailed = Object(proposalUtils["s" /* hasFetchProposalsFailed */])(proposals);

      if (!isFetchProposalsFailed) {
        setTimeout(function () {
          var bookingUrl = Object(BookingPagesUtils["i" /* getBookingEngineUri */])(BookingPagesUtils["a" /* PAGE_BE_ACCOMMODATION */], proposals.proposals || [], proposals.resort, undefined, queryParams); // $FlowFixMe

          redirectUtils["a" /* default */].redirectTo()(bookingUrl);
        }, 0);
      }

      var errorCode = proposals === null || proposals === void 0 ? void 0 : (_proposals$errors = proposals.errors) === null || _proposals$errors === void 0 ? void 0 : (_proposals$errors$ = _proposals$errors[0]) === null || _proposals$errors$ === void 0 ? void 0 : _proposals$errors$.errorCode;
      tracking_api["b" /* setDataLayer */]({
        categoryGA: 'resort',
        actionGA: BOOKING_ENGINE_ENTRY_TRACKING_LABELS[params.bookingEngineEntry],
        labelGA: isFetchProposalsFailed ? "errorCheckPrices".concat(errorCode ? "_".concat(Object(lodash["snakeCase"])(errorCode).toUpperCase()) : '') : 'checkPrices'
      }, appContext);
      return response;
    });
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["j" /* FETCH_PROPOSALS */], payload, {
      optimist: true,
      promise: promise,
      redirect_uri: redirectUri
    }));
  };
}

function editCriteriaFetchProposals(criteria, proposalsLoderLabel, appContext, location) {
  return function (dispatch, getState) {
    var search = criteria.search,
        departure = criteria.departure,
        attendees = criteria.attendees,
        departureCity = criteria.departureCity;
    var payload = {
      globalLoaderLabel: proposalsLoderLabel
    };
    var state = getState();
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["l" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */], payload, {
      optimist: true,
      promise: Object(proposalQuery["n" /* proposalsQuery */])(_objectSpread({
        productId: search.value,
        arrivalDate: moment_default()(departure.date).format('YYYYMMDD'),
        duration: departure.duration,
        departureCity: departureCity.value,
        numberAttendees: attendees.adults + attendees.kids.length,
        adults: new Array(attendees.adults).fill({}),
        // $FlowFixMe
        kids: attendees.kids,
        isJoyView: criteria.isJoyView,
        fetchActivityCategories: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayActivities'),
        adultsAttendeesIds: state.tripInformation.adults.map(function (_ref5) {
          var neolid = _ref5.neolid;
          return neolid;
        }).filter(Boolean),
        kidsAttendeesIds: state.tripInformation.kids.map(function (_ref6) {
          var neolid = _ref6.neolid;
          return neolid;
        }).filter(Boolean)
      }, appContext.isSeller ? {
        salesNetworkId: location.queryParams.cxo_sales_network_id
      } : null), appContext)
    }));
  };
}

function simpleFetchProposals(criterias, proposalsLoaderLabel, appContext, location) {
  var productId = criterias.productId,
      arrivalDate = criterias.arrivalDate,
      duration = criterias.duration,
      attendees = criterias.attendees,
      departureCity = criterias.departureCity,
      bookingEngineEntry = criterias.bookingEngineEntry;
  var payload = {
    globalLoaderLabel: proposalsLoaderLabel,
    bookingEngineEntry: bookingEngineEntry
  };
  return Object(createAction["a" /* createOptimisticAction */])(proposals_constants["j" /* FETCH_PROPOSALS */], payload, {
    optimist: true,
    promise: Object(proposalQuery["n" /* proposalsQuery */])(_objectSpread({
      productId: productId,
      arrivalDate: arrivalDate,
      duration: duration,
      departureCity: departureCity,
      numberAttendees: attendees.adults + attendees.kids.length,
      adults: new Array(attendees.adults).fill({}),
      // $FlowFixMe
      kids: attendees.kids,
      fetchActivityCategories: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayActivities')
    }, appContext.isSeller ? {
      salesNetworkId: location.queryParams.cxo_sales_network_id
    } : null), appContext)
  });
}

function addTransport(transportId, proposalsId, isJoyview, appContext, globalLoaderLabel, toastLabel) {
  return function (dispatch) {
    // TODO show a toast if error
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["e" /* ADD_TRANSPORT */], {
      globalLoaderLabel: globalLoaderLabel,
      toastLabel: toastLabel,
      transportId: transportId
    }, {
      optimist: true,
      promise: Object(proposalQuery["c" /* addTransportMutation */])(transportId, proposalsId, isJoyview, appContext)
    }));
  };
}

function displayToastOnContextShare(toastLabel) {
  return {
    type: proposals_constants["i" /* DISPLAY_TOAST_ON_CONTEXT_SHARE */],
    payload: {
      toastLabel: toastLabel
    }
  };
}

function addAccommodation(_ref7) {
  var arrangement = _ref7.arrangement,
      proposalsId = _ref7.proposalsId,
      isJoyview = _ref7.isJoyview,
      appContext = _ref7.appContext,
      globalLoaderLabel = _ref7.globalLoaderLabel,
      toastLabel = _ref7.toastLabel;
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["a" /* ADD_ACCOMMODATION */], {
      globalLoaderLabel: globalLoaderLabel,
      toastLabel: toastLabel
    }, {
      optimist: true,
      promise: Object(proposalQuery["a" /* addAccommodationMutation */])(arrangement, proposalsId, isJoyview, appContext)
    }));
  };
}

function updateAttendees(_ref8) {
  var proposalId = _ref8.proposalId,
      attendees = _ref8.attendees,
      appContext = _ref8.appContext;
  return function (dispatch) {
    return Object(attendeesQuery["b" /* updateAttendeesMutation */])({
      proposalId: proposalId,
      attendees: attendees,
      appContext: appContext
    }).then(function (data) {
      // $FlowFixMe it can be modifyAttendeesSellerMultipleFamilies or modifyAttendees
      var payload = Object.values(data)[0];
      var errors = payload.errors;

      if (errors) {
        // We don't do anything specific with the errors, but this will let us display per field errors
        logger["default"].error(errors[0]);
        var error = new Error('Unhandled field form error'); // $FlowFixMe we need the errorCode for tracking

        error.errors = errors;
        throw error;
      }

      var neolaneId = Object(lodash["get"])(payload, 'proposal.attendees.list[0].customerId');

      var cookieToSet = _objectSpread(_objectSpread({}, tracking_storage_api["a" /* get */](constants["d" /* BE_TRACKING */])), {}, {
        neolaneId: neolaneId,
        BE_customerStatus: payload.customerStatus
      });

      tracking_storage_api["b" /* set */](cookieToSet);
      dispatch(Object(createAction["b" /* default */])(proposals_constants["z" /* UPDATE_ATTENDEES */], payload));
    });
  };
}

function updateInsurances(proposalId, insuranceId, attendees, app) {
  return function (dispatch) {
    return updateInsurancesMutation(proposalId, insuranceId, attendees, app).then(function (payload) {
      dispatch(Object(createAction["b" /* default */])(proposals_constants["A" /* UPDATE_INSURANCES */], payload));
      dispatch(Object(createAction["b" /* default */])(proposals_constants["n" /* INSURANCE_ADDED */]));
    });
  };
}

function deleteInsurances(proposalId, insuranceId, app) {
  return function (dispatch) {
    return deleteInsurancesMutation(proposalId, insuranceId, app).then(function (payload) {
      dispatch(Object(createAction["b" /* default */])(proposals_constants["g" /* DELETE_INSURANCES */], payload));
      dispatch(Object(createAction["b" /* default */])(proposals_constants["o" /* INSURANCE_DELETED */]));
    });
  };
}

function setNoInsurances() {
  return function (dispatch) {
    dispatch(Object(createAction["b" /* default */])(proposals_constants["o" /* INSURANCE_DELETED */]));
  };
}

function clearProposals() {
  return Object(createAction["b" /* default */])(proposals_constants["f" /* CLEAR_PROPOSALS */]);
}

var proposals_action_fetchSelectedProposalPayment = function fetchSelectedProposalPayment(selectedProposal, appContext) {
  return Object(createAction["a" /* createOptimisticAction */])(proposals_constants["m" /* FETCH_SELECTED_PROPOSAL_PAYMENT */], {
    selectedProposalId: selectedProposal.id
  }, {
    optimist: true,
    promise: Object(proposalQuery["f" /* fetchPayment */])(selectedProposal.id, appContext)
  });
};

var proposals_action_saveCustomerProposalsHandler = function saveCustomerProposalsHandler(proposalId, appContext, customerId) {
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["u" /* SAVE_CUSTOMER_PROPOSAL */], {}, {
      optimist: true,
      promise: Object(sellerUtils["j" /* saveCustomerProposal */])(proposalId, appContext, customerId)
    }));
  };
};

var proposals_action_addOrReplaceAdditionalServices = function addOrReplaceAdditionalServices(_ref9) {
  var proposalIds = _ref9.proposalIds,
      attendees = _ref9.attendees,
      _ref9$showNotificatio = _ref9.showNotification,
      showNotification = _ref9$showNotificatio === void 0 ? false : _ref9$showNotificatio,
      appContext = _ref9.appContext;
  return function (dispatch, getState) {
    var proposal = Object(booking_selector["k" /* getCurrentProposal */])(getState());
    var servicesIds = attendees.map(function (_ref10) {
      var productInfoId = _ref10.productInfoId;
      return productInfoId;
    });
    var additionalServicesValues = Object.values(proposal.additionalServices);
    var isUpdatingAlreadyReservedService = additionalServicesValues.some(function (oldServices) {
      return (// $FlowFixMe
        oldServices.some(function (_ref11) {
          var pricingInfo = _ref11.pricingInfo;
          return servicesIds.includes(pricingInfo.id) && pricingInfo.isPartiallyRented;
        })
      );
    });
    var newReservedServiceToastLabel = additionalServicesValues.some(function (oldServices) {
      return (// $FlowFixMe
        oldServices.some(function (_ref12) {
          var pricingInfo = _ref12.pricingInfo;
          return servicesIds.includes(pricingInfo.id) && pricingInfo.type === 'RENTAL';
        })
      );
    }) ? 'booking.activities.skiEquipment.newEquipmentSelection' : 'booking.activities.newActivitySelection';
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["B" /* UPDATE_SERVICES */], showNotification ? {
      toastLabel: isUpdatingAlreadyReservedService ? 'booking.activities.activityUpdate' : newReservedServiceToastLabel
    } : {}, {
      optimist: true,
      promise: Object(proposalQuery["o" /* putServicesMutation */])(proposalIds, attendees, appContext)
    }));
  };
};

var proposals_action_deleteAdditionalServices = function deleteAdditionalServices(_ref13) {
  var proposalIds = _ref13.proposalIds,
      serviceIds = _ref13.serviceIds,
      attendeeIds = _ref13.attendeeIds,
      _ref13$showNotificati = _ref13.showNotification,
      showNotification = _ref13$showNotificati === void 0 ? false : _ref13$showNotificati,
      overloadForSpecificProposalIds = _ref13.overloadForSpecificProposalIds,
      appContext = _ref13.appContext;
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["h" /* DELETE_SERVICE */], showNotification ? {
      toastLabel: 'booking.activities.activityUpdate'
    } : {}, {
      optimist: true,
      promise: Object(proposalQuery["e" /* deleteServicesMutation */])({
        proposalIds: proposalIds,
        serviceIds: serviceIds,
        attendeeIds: attendeeIds,
        overloadForSpecificProposalIds: overloadForSpecificProposalIds,
        appContext: appContext
      })
    }));
  };
};

var proposals_action_addAdditionalService = function addAdditionalService(_ref14) {
  var proposalIds = _ref14.proposalIds,
      serviceId = _ref14.serviceId,
      attendeeIds = _ref14.attendeeIds,
      schedules = _ref14.schedules,
      _ref14$showNotificati = _ref14.showNotification,
      showNotification = _ref14$showNotificati === void 0 ? false : _ref14$showNotificati,
      overloadForSpecificProposalIds = _ref14.overloadForSpecificProposalIds,
      appContext = _ref14.appContext;
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["c" /* ADD_SERVICE */], showNotification ? {
      toastLabel: 'booking.activities.activityUpdate'
    } : {}, {
      optimist: true,
      promise: Object(proposalQuery["b" /* addServiceMutation */])({
        proposalIds: proposalIds,
        serviceId: serviceId,
        attendeeIds: attendeeIds,
        schedules: schedules,
        overloadForSpecificProposalIds: overloadForSpecificProposalIds,
        appContext: appContext
      })
    }));
  };
};

var proposals_action_prepareBe = function prepareBe(payload) {
  return Object(createAction["b" /* default */])(proposals_constants["p" /* PREPARE_BE */], payload);
};

var proposals_action_saveDonationToProposals = function saveDonationToProposals(donation) {
  return function (dispatch) {
    dispatch({
      type: proposals_constants["v" /* SAVE_DONATION_TO_PROPOSALS */],
      payload: donation
    });
  };
};

var proposals_action_switchProposalsOffers = function switchProposalsOffers(offers, appContext) {
  return function (dispatch, getState) {
    var state = getState();
    var proposals = Object(booking_selector["B" /* proposalsSelector */])(state); // TODO : remove filter when proposals array in store is fixed and does not include a random object

    var proposalsIds = proposals.map(function (_ref15) {
      var id = _ref15.id;
      return id;
    }).filter(function (id) {
      return !!id;
    });
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["y" /* SWITCH_PROPOSALS_OFFERS */], {}, {
      optimist: true,
      promise: Object(proposalQuery["p" /* switchProposalsOffers */])(proposalsIds, offers, appContext)
    }));
  };
};



/***/ }),

/***/ "BGO8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Childcare_Childcare; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/widgets/service-block/ServiceBlock.jsx
var ServiceBlock = __webpack_require__("oOGh");

// EXTERNAL MODULE: ./src/client/components/utils/product/product.utils.js
var product_utils = __webpack_require__("C9cF");

// CONCATENATED MODULE: ./src/client/components/widgets/childcare/ChildcareServiceBlock.jsx

var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var ChildcareServiceBlock_mapOpeningHours = function mapOpeningHours(_ref) {
  var start = _ref.start,
      end = _ref.end;
  var formattedStart = Object(apiDate["f" /* formatApiTime */])(start, 'LT').toLowerCase();
  var formattedEnd = Object(apiDate["f" /* formatApiTime */])(end, 'LT').toLowerCase();
  return Object(src_i18n["g" /* t */])('booking.services.childcare.openingHours', {
    ' opening_hours - start ': formattedStart,
    ' opening_hours - end ': formattedEnd
  });
};

var getOpeningHours = function getOpeningHours(openingHours) {
  if (!(openingHours === null || openingHours === void 0 ? void 0 : openingHours.length)) {
    return '';
  }

  return openingHours.map(ChildcareServiceBlock_mapOpeningHours).join(' ');
};

var ChildcareServiceBlock_mapClosingDays = function mapClosingDays(closingDay) {
  var formattedClosingDay = moment_default()().day(closingDay).format('dddd');
  return Object(lodash["capitalize"])(formattedClosingDay);
};

var ChildcareServiceBlock_getClosingDays = function getClosingDays(closingWeekdays) {
  if (!(closingWeekdays === null || closingWeekdays === void 0 ? void 0 : closingWeekdays.length)) {
    return '';
  } // eslint-disable-next-line camelcase


  var closing_weekdays = closingWeekdays.map(ChildcareServiceBlock_mapClosingDays).join(', ');
  return Object(src_i18n["g" /* t */])('booking.services.childcare.closingDays', {
    closing_weekdays: closing_weekdays
  });
};

var getDurationDescription = function getDurationDescription(_ref2) {
  var openingHours = _ref2.openingHours,
      closingWeekdays = _ref2.closingWeekdays;
  var openingHoursLabel = getOpeningHours(openingHours);
  var closedDaysLabel = ChildcareServiceBlock_getClosingDays(closingWeekdays);

  if (openingHoursLabel && closedDaysLabel) {
    return "".concat(openingHoursLabel, " ").concat(closedDaysLabel);
  }

  if (openingHoursLabel) {
    return openingHoursLabel;
  }

  if (closedDaysLabel) {
    return closedDaysLabel;
  }

  return null;
};

var ChildcareServiceBlock_WarningNotice = function WarningNotice(_ref3) {
  var childcare = _ref3.childcare,
      type = _ref3.type,
      realtimeStock = _ref3.realtimeStock,
      currentlyLoadingChildren = _ref3.currentlyLoadingChildren;
  var remainingStock = childcare.remainingStock;

  if (!remainingStock || currentlyLoadingChildren === undefined || currentlyLoadingChildren.includes(childcare.childId)) {
    return null;
  }

  if (realtimeStock && childcare.ageInMonths.min === 4) {
    remainingStock -= realtimeStock.addedBabies;
  }

  if (realtimeStock && childcare.ageInMonths.min === 24) {
    remainingStock -= realtimeStock.addedPetits;
  }

  if (type === 'add') {
    return __jsx("div", {
      className: "flex items-center justify-center text-warning mb-px10",
      "data-testid": "urgentisationBlock"
    }, remainingStock <= 10 && __jsx(Icon["a" /* Icon */], {
      "data-testid": "urgentisationBlock-icon",
      className: "ServiceBlock-icon-urgentisation m-px5",
      name: icons["a" /* ICONS */].WARNING,
      width: "1.5em"
    }), __jsx("div", {
      className: "ServiceBlock-urgentisation",
      "data-testid": "urgentisationBlock-label"
    }, remainingStock <= 10 ? Object(src_i18n["g" /* t */])('booking.services.childcare.childcareAvailabilities', {
      count: remainingStock
    }) : Object(src_i18n["g" /* t */])('booking.services.childcare.urgentisation')));
  }

  return null;
};

// tag showing for last 10 availabilities
var ChildcareServiceBlock_LastAvailabilitiesTag = function LastAvailabilitiesTag(_ref4) {
  var realtimeStock = _ref4.realtimeStock,
      _ref4$childcare = _ref4.childcare,
      isIncluded = _ref4$childcare.isIncluded,
      isPaid = _ref4$childcare.isPaid,
      ageInMonths = _ref4$childcare.ageInMonths,
      type = _ref4.type;
  if (type === 'full' || type === 'remove' || isIncluded || isPaid || realtimeStock && (ageInMonths.min === 4 && realtimeStock.babies > 10 || ageInMonths.min === 24 && realtimeStock.petits > 10)) return null;
  return __jsx("div", {
    className: "absolute bg-orange bottom-0 m-px10 p-px10 text-sm text-white uppercase"
  }, Object(src_i18n["g" /* t */])('booking.services.childcare.lastAvailabilities'));
};

var ChildcareServiceBlock_ChildcareServiceBlock = function ChildcareServiceBlock(_ref5) {
  var className = _ref5.className,
      dataCsOverrideId = _ref5.dataCsOverrideId,
      i18n = _ref5.i18n,
      isIncluded = _ref5.isIncluded,
      childcare = _ref5.childcare,
      childBirthdateMessage = _ref5.childBirthdateMessage,
      onCtaClick = _ref5.onCtaClick,
      type = _ref5.type,
      realtimeStock = _ref5.realtimeStock,
      currentlyLoadingChildren = _ref5.currentlyLoadingChildren,
      shouldTrack = _ref5.shouldTrack;
  return __jsx("div", {
    className: className
  }, __jsx("div", {
    "data-testid": "ChildcareServiceBlock-childBirthdateMessage"
  }, childBirthdateMessage), __jsx(ServiceBlock["a" /* ServiceBlock */], {
    equipment: {
      label: childcare.label,
      longDescription: childcare.description
    },
    header: {
      label: isIncluded ? Object(src_i18n["g" /* t */])('booking.childcarePopIn.includedChildcare') : Object(src_i18n["g" /* t */])('booking.childcarePopIn.onDemandChildcare'),
      color: isIncluded ? '#005589' : '#b95e06',
      icon: isIncluded ? icons["a" /* ICONS */].ALL_INCLUSIVE : icons["a" /* ICONS */].ON_DEMAND,
      header: 'large'
    },
    slots: [{
      icon: icons["a" /* ICONS */].DURATION,
      label: getDurationDescription(childcare),
      key: 'duration-description'
    }, {
      icon: icons["a" /* ICONS */].DATE_STAR,
      label: Object(product_utils["e" /* getServiceAgesLabel */])(childcare.ageInMonths, i18n),
      key: 'date-star'
    }].filter(function (slot) {
      return slot.label;
    }),
    button: onCtaClick ? _objectSpread({
      dataCsOverrideId: dataCsOverrideId,
      onClick: onCtaClick
    }, type === 'full' && {
      label: Object(src_i18n["g" /* t */])('booking.services.childcare.childcareFull')
    }) : undefined,
    dataSelector: "Childcare",
    addLabel: Object(src_i18n["g" /* t */])('booking.services.childcare.addChildcare'),
    removeLabel: Object(src_i18n["g" /* t */])('booking.services.childcare.removeChildcare'),
    includedLabel: Object(src_i18n["g" /* t */])('common.included'),
    price: childcare.price.formattedValueRounded,
    image: childcare.images[0],
    type: type,
    intro: !isIncluded ? Object(src_i18n["g" /* t */])('booking.services.childcare.babyClubMedReassurance') : undefined,
    urgentisation: childcare.isIncluded || childcare.isPaid ? undefined : __jsx(ChildcareServiceBlock_WarningNotice, {
      childcare: childcare,
      type: type,
      realtimeStock: realtimeStock,
      currentlyLoadingChildren: currentlyLoadingChildren
    }),
    isValidated: ['disabled', 'remove', 'full', 'none'].includes(type),
    i18n: i18n,
    trackingData: shouldTrack ? {
      categoryGA: 'bookingEngine',
      actionGA: 'service',
      labelGA: function labelGA(action) {
        return "".concat(action, "Childcare");
      }
    } : undefined,
    lastAvailabilities: __jsx(ChildcareServiceBlock_LastAvailabilitiesTag, {
      realtimeStock: realtimeStock,
      childcare: childcare,
      type: type
    })
  }));
};
// EXTERNAL MODULE: ./src/client/components/widgets/childcare/childcare.helper.js
var childcare_helper = __webpack_require__("YVWi");

// CONCATENATED MODULE: ./src/client/components/widgets/childcare/Childcare.jsx


var Childcare_jsx = react_default.a.createElement;

function Childcare_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Childcare_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Childcare_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Childcare_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var types = {
  CHILDCARE_UNSUBSCRIBE: 'CHILDCARE_UNSUBSCRIBE',
  CHILDCARE_SUBSCRIBE: 'CHILDCARE_SUBSCRIBE',
  CHILDCARE_ENDED_LOADING: 'CHILDCARE_ENDED_LOADING'
};

var Childcare_childBlocksReducer = function childBlocksReducer(state, action) {
  switch (action.type) {
    case types.CHILDCARE_UNSUBSCRIBE:
      {
        // on remove
        if (action.payload && action.payload.ageInMonths.min === 4) return Childcare_objectSpread(Childcare_objectSpread({}, state), {}, {
          babiesChildcareStock: state.babiesChildcareStock + 1,
          sessionAddedBabiesChildcaresNumber: state.sessionAddedBabiesChildcaresNumber - 1,
          childrenLoading: [].concat(Object(toConsumableArray["a" /* default */])(state.childrenLoading), [action.payload.childId])
        });
        if (action.payload && action.payload.ageInMonths.min === 24) return Childcare_objectSpread(Childcare_objectSpread({}, state), {}, {
          petitChildcareStock: state.petitChildcareStock + 1,
          sessionAddedYoungstersChildcaresNumber: state.sessionAddedYoungstersChildcaresNumber - 1,
          childrenLoading: [].concat(Object(toConsumableArray["a" /* default */])(state.childrenLoading), [action.payload.childId])
        });
        break;
      }

    case types.CHILDCARE_SUBSCRIBE:
      {
        if (action.payload && action.payload.ageInMonths.min === 4) return Childcare_objectSpread(Childcare_objectSpread({}, state), {}, {
          babiesChildcareStock: state.babiesChildcareStock - 1,
          sessionAddedBabiesChildcaresNumber: state.sessionAddedBabiesChildcaresNumber + 1,
          childrenLoading: [].concat(Object(toConsumableArray["a" /* default */])(state.childrenLoading), [action.payload.childId])
        });
        if (action.payload && action.payload.ageInMonths.min === 24) return Childcare_objectSpread(Childcare_objectSpread({}, state), {}, {
          petitChildcareStock: state.petitChildcareStock - 1,
          sessionAddedYoungstersChildcaresNumber: state.sessionAddedYoungstersChildcaresNumber + 1,
          childrenLoading: [].concat(Object(toConsumableArray["a" /* default */])(state.childrenLoading), [action.payload.childId])
        });
        break;
      }

    case types.CHILDCARE_ENDED_LOADING:
      {
        if (action.payload && (action.payload.ageInMonths.min === 4 || action.payload.ageInMonths.min === 24)) return Childcare_objectSpread(Childcare_objectSpread({}, state), {}, {
          childrenLoading: Object(toConsumableArray["a" /* default */])(state.childrenLoading.filter(function (el) {
            return el !== action.payload.childId;
          }))
        });
        break;
      }

    default:
      {
        return state;
      }
  }
};

var Childcare_Childcare = function Childcare(_ref) {
  var childcareAdditionalServices = _ref.childcareAdditionalServices,
      proposals = _ref.proposals,
      i18n = _ref.i18n,
      isCondensed = _ref.isCondensed,
      _ref$childrenCount = _ref.childrenCount,
      childrenCount = _ref$childrenCount === void 0 ? 0 : _ref$childrenCount,
      deleteChildcare = _ref.deleteChildcare,
      addChildcare = _ref.addChildcare,
      attendees = _ref.attendees,
      children = _ref.children,
      _ref$shouldTrack = _ref.shouldTrack,
      shouldTrack = _ref$shouldTrack === void 0 ? true : _ref$shouldTrack;
  var childcareList = Object(childcare_helper["b" /* formatAdditionalServicesChildcareToOldChildcareFormat */])(childcareAdditionalServices); // babyInfos //childrenInfos (API)

  var _childrenCountByChild = Object(childcare_helper["a" /* childrenCountByChildcare */])(childcareAdditionalServices),
      babyRemainingStock = _childrenCountByChild.babyInfos.remainingStock,
      youngsterRemainingStock = _childrenCountByChild.youngsterInfos.remainingStock;

  var _includedAndNotInclud = Object(childcare_helper["i" /* includedAndNotIncludedChildcares */])(childcareList),
      includedChildcares = _includedAndNotInclud.includedChildcares,
      notIncludedChildcares = _includedAndNotInclud.notIncludedChildcares; // count already added childcares (refresh Case for Ex)


  var sessionAddedBabiesChildcaresNumber = notIncludedChildcares.filter(function (childcare) {
    return childcare.isRented === true && childcare.ageInMonths.min === 4;
  }).length;
  var sessionAddedYoungstersChildcaresNumber = notIncludedChildcares.filter(function (childcare) {
    return childcare.isRented === true && childcare.ageInMonths.min === 24;
  }).length; // initialisation

  var _useReducer = Object(react["useReducer"])( // $FlowFixMe
  Childcare_childBlocksReducer, {
    childrenLoading: [],
    babiesChildcareStock: babyRemainingStock ? babyRemainingStock - sessionAddedBabiesChildcaresNumber : 0,
    petitChildcareStock: youngsterRemainingStock ? youngsterRemainingStock - sessionAddedYoungstersChildcaresNumber : 0,
    sessionAddedBabiesChildcaresNumber: sessionAddedBabiesChildcaresNumber,
    sessionAddedYoungstersChildcaresNumber: sessionAddedYoungstersChildcaresNumber
  }),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  if (childrenCount === 0) {
    return null;
  }

  var getChildBirthDateMessage = function getChildBirthDateMessage(childAttendeeId) {
    var currentKid = Object(childcare_helper["d" /* getCurrentChild */])(attendees, childAttendeeId);

    if (currentKid && currentKid.firstName && currentKid.lastName) {
      return Object(src_i18n["g" /* t */])('booking.services.childcare.firstnameLastnameBornOn', {
        lastName: currentKid.lastName,
        firstName: currentKid.firstName,
        birthdate: Object(childcare_helper["f" /* getFormatDate */])(Childcare_objectSpread(Childcare_objectSpread({}, currentKid), {}, {
          birthdate: Object(apiDate["l" /* timestampToApiDate */])(currentKid.birthdate)
        }), Object(src_i18n["g" /* t */])('common.dateFormatTechnicalID'))
      });
    }

    return Object(src_i18n["g" /* t */])('booking.services.childcare.forWhatKid', {
      birthdate: Object(childcare_helper["f" /* getFormatDate */])(currentKid, Object(src_i18n["g" /* t */])('common.dateFormatTechnicalID'))
    });
  };

  return Childcare_jsx("div", {
    className: "PackageChildcare"
  }, childcareAdditionalServices.length === 0 ? Childcare_jsx("div", {
    "data-selector": "PackageInfoSection-noChildcareMessage"
  }, Childcare_jsx(Notification["a" /* Notification */], {
    color: colors["a" /* COLORS */].AMBER,
    hasBorder: true,
    text: Object(src_i18n["g" /* t */])('booking.services.childcare.noChildcareMessage')
  })) : Childcare_jsx("div", null, Childcare_jsx(Title["a" /* Title */], {
    className: "mb-px10 w-full md:whitespace-no-wrap",
    color: colors["a" /* COLORS */].BLUE,
    theme: "title-sans-4"
  }, Object(src_i18n["g" /* t */])('booking.services.childcare.childcareTitle', {
    number: childcareList.length
  })), !!notIncludedChildcares.length && Childcare_jsx("div", {
    className: "flex flex-wrap mb-px20 -mx-px10"
  }, notIncludedChildcares.map(function (childcare, index) {
    return Childcare_jsx(ChildcareServiceBlock_ChildcareServiceBlock, {
      className: classnames_default()('p-px10 w-full', {
        ' sm:w-1/2 md:w-1/3': !isCondensed
      }),
      key: childcare.childId,
      i18n: i18n,
      isIncluded: childcare.isManuallyIncluded,
      childcare: childcare,
      childBirthdateMessage: getChildBirthDateMessage(childcare.childId),
      onCtaClick: function onCtaClick() {
        var overloadChildcareIdForChalet = proposals && Object(childcare_helper["g" /* getOverloadChildcareDataForChalet */])({
          proposals: proposals,
          currentChildcareId: childcare.id,
          currentChildId: childcare.childId
        });

        if (childcare.isRented) {
          dispatch({
            type: types.CHILDCARE_UNSUBSCRIBE,
            payload: childcare
          });
          return deleteChildcare({
            childcareId: childcare.id,
            attendeeId: childcare.childId,
            startDate: childcare.startDate,
            endDate: childcare.endDate,
            overloadChildcareIdForChalet: overloadChildcareIdForChalet
          }).catch(function () {
            dispatch({
              type: types.CHILDCARE_SUBSCRIBE,
              payload: childcare
            });
          }).finally(function () {
            dispatch({
              type: types.CHILDCARE_ENDED_LOADING,
              payload: childcare
            });
          });
        }

        dispatch({
          type: types.CHILDCARE_SUBSCRIBE,
          payload: childcare
        });
        return addChildcare({
          childcareId: childcare.id,
          attendeeId: childcare.childId,
          startDate: childcare.startDate,
          endDate: childcare.endDate,
          overloadChildcareIdForChalet: overloadChildcareIdForChalet
        }).catch(function () {
          dispatch({
            type: types.CHILDCARE_UNSUBSCRIBE,
            payload: childcare
          });
        }).finally(function () {
          dispatch({
            type: types.CHILDCARE_ENDED_LOADING,
            payload: childcare
          });
        });
      },
      realtimeStock: state && (state.babiesChildcareStock !== undefined || state.petitChildcareStock !== undefined) ? {
        babies: state.babiesChildcareStock,
        petits: state.petitChildcareStock,
        addedBabies: state.sessionAddedBabiesChildcaresNumber,
        addedPetits: state.sessionAddedYoungstersChildcaresNumber
      } : undefined,
      type: Object(childcare_helper["c" /* getCtaType */])(childcare, state),
      currentlyLoadingChildren: state && state.childrenLoading,
      shouldTrack: shouldTrack,
      dataCsOverrideId: "Childcare-".concat(index)
    });
  })), children, !!includedChildcares.length && Childcare_jsx("div", {
    className: "flex flex-wrap -mx-px10"
  }, includedChildcares.map(function (childcare, index) {
    return Childcare_jsx(ChildcareServiceBlock_ChildcareServiceBlock, {
      className: classnames_default()('p-px10 w-full', {
        ' sm:w-1/2 md:w-1/3': !isCondensed
      }),
      key: childcare.childId,
      i18n: i18n,
      isIncluded: true,
      childcare: childcare,
      childBirthdateMessage: getChildBirthDateMessage(childcare.childId),
      currentlyLoadingChildren: state && state.childrenLoading,
      shouldTrack: shouldTrack,
      type: "disabled",
      dataCsOverrideId: "Childcare-".concat(index)
    });
  }))));
};

/***/ }),

/***/ "BRr/":
/***/ (function(module, exports, __webpack_require__) {

var inverseXML = getInverseObj(__webpack_require__("ZLJe")),
    xmlReplacer = getInverseReplacer(inverseXML);

exports.XML = getInverse(inverseXML, xmlReplacer);

var inverseHTML = getInverseObj(__webpack_require__("8PLQ")),
    htmlReplacer = getInverseReplacer(inverseHTML);

exports.HTML = getInverse(inverseHTML, htmlReplacer);

function getInverseObj(obj){
	return Object.keys(obj).sort().reduce(function(inverse, name){
		inverse[obj[name]] = "&" + name + ";";
		return inverse;
	}, {});
}

function getInverseReplacer(inverse){
	var single = [],
	    multiple = [];

	Object.keys(inverse).forEach(function(k){
		if(k.length === 1){
			single.push("\\" + k);
		} else {
			multiple.push(k);
		}
	});

	//TODO add ranges
	multiple.unshift("[" + single.join("") + "]");

	return new RegExp(multiple.join("|"), "g");
}

var re_nonASCII = /[^\0-\x7F]/g,
    re_astralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;

function singleCharReplacer(c){
	return "&#x" + c.charCodeAt(0).toString(16).toUpperCase() + ";";
}

function astralReplacer(c){
	// http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	var high = c.charCodeAt(0);
	var low  = c.charCodeAt(1);
	var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
	return "&#x" + codePoint.toString(16).toUpperCase() + ";";
}

function getInverse(inverse, re){
	function func(name){
		return inverse[name];
	}

	return function(data){
		return data
				.replace(re, func)
				.replace(re_astralSymbols, astralReplacer)
				.replace(re_nonASCII, singleCharReplacer);
	};
}

var re_xmlChars = getInverseReplacer(inverseXML);

function escapeXML(data){
	return data
			.replace(re_xmlChars, singleCharReplacer)
			.replace(re_astralSymbols, astralReplacer)
			.replace(re_nonASCII, singleCharReplacer);
}

exports.escape = escapeXML;


/***/ }),

/***/ "BU6i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return WECHAT_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PAYMENT_METHOD_CREDIT_CARD_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CYBERSOURCE_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ECYBERSOURCE_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return HIPAY_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ESSPSCT_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ESSPSDD_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return NODELCRERE_TRANSFER_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return NODELCRERE_CHEQUE_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return HIPAY_CMTA_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return EGLOBALCOLLECT_PSP_ID; });
/* unused harmony export OGONE_CMTA_PSP_ID */
/* unused harmony export OGONE_PSP_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PAYMENT_METHOD_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BANK_TRANSFER_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHEQUE_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREDIT_CARD_LABEL; });
var WECHAT_PSP_ID = 'M99BILLW';
var PAYMENT_METHOD_CREDIT_CARD_CATEGORY = 'CreditCard';
var CYBERSOURCE_PSP_ID = 'MCYBERSOURCE';
var ECYBERSOURCE_PSP_ID = 'ECYBERSOURCE';
var HIPAY_PSP_ID = 'MHIPAY';
var ESSPSCT_PSP_ID = 'ESSPSCT'; // TRANSFER

var ESSPSDD_PSP_ID = 'ESSPSDD'; // DEBIT

var NODELCRERE_TRANSFER_PSP_ID = 'NODELCRERE_TRANSFER'; // TRANSFER

var NODELCRERE_CHEQUE_PSP_ID = 'NODELCRERE_CHEQUE'; // DEBIT

var HIPAY_CMTA_PSP_ID = 'EHIPAYCMTA';
var EGLOBALCOLLECT_PSP_ID = 'EGLOBALCOLLECT'; // DEBIT

var OGONE_CMTA_PSP_ID = 'MOGONE';
var OGONE_PSP_ID = 'EOGONE';
var PAYMENT_METHOD_LABEL = 'paymentMethodLabel';
var BANK_TRANSFER_LABEL = 'Bank Transfer';
var CHEQUE_LABEL = 'Cheque';
var CREDIT_CARD_LABEL = 'Credit Card';

/***/ }),

/***/ "Bcqe":
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__("RNvQ"),
    isObject = __webpack_require__("tQYX");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ "Bg8+":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("L1Xj");

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ "Bujb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateAttendeesMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return queryBookingAttendees; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("NLwV");
/* harmony import */ var _proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("70jX");
/* harmony import */ var _request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("CcNa");
/* harmony import */ var _date_apiDate__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ldK3");
/* harmony import */ var _seller_sellerUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("KL6I");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}








var ATTENDEE_SCHEMA_PROPERTIES = ['id', 'gmNumber', 'lastName', 'firstName', 'unicodeLastName', 'unicodeFirstName', 'birthdate', 'email', 'mobile', 'optinSms', 'optinMail', 'optinFosun', 'optinEmail', 'optinPhone', 'optinClubmedPlus', 'civility', 'identityNumber', 'passport', 'customerId', 'address', 'mainContactId', 'isChild'];
/**
 * Remove all properties that don't match GQL Schema Otherwise the mutation fails
 */

var removeUselessProperties = function removeUselessProperties(attendee) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["pick"])(attendee, ATTENDEE_SCHEMA_PROPERTIES);
};
/**
 * Connected customer experience : Put attendees
 */


function updateAttendeesMutation(_ref) {
  var proposalId = _ref.proposalId,
      attendees = _ref.attendees,
      appContext = _ref.appContext;
  var formatedAttendees = attendees.map(function (attendee) {
    return removeUselessProperties(_objectSpread(_objectSpread({}, attendee), {}, {
      customerId: attendee.neolid,
      birthdate: Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_6__[/* timestampToApiDate */ "l"])(attendee.birthdate),
      passport: !Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isEmpty"])(attendee.passport) ? _objectSpread(_objectSpread({}, attendee.passport), {}, {
        expirationDate: Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_6__[/* timestampToApiDate */ "l"])(attendee.passport.expirationDate),
        issuingDate: Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_6__[/* timestampToApiDate */ "l"])(attendee.passport.issuingDate)
      }) : undefined
    }));
  });
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      ".concat(Object(_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_7__[/* isSellerAndInMultiplesFamiliesContext */ "h"])(appContext, attendees) ? 'modifyAttendeesSellerMultipleFamilies' : 'modifyAttendees', " (\n      proposalId: \"").concat(proposalId, "\",\n      attendees: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_3__[/* graphqlify */ "d"])(formatedAttendees), "\n     ) {\n        proposal {\n          id\n          attendees {\n            list {\n              id\n              customerId\n            }\n          }\n          ").concat(Object(_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_4__[/* proposalPriceQuery */ "m"])(), "\n          ").concat(Object(_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_4__[/* getPaymentScheduleRequest */ "g"])(appContext), "\n        }\n        ").concat(appContext.isDirectCxo || appContext.isIndirectCxo ? '' : 'customerStatus', "\n        errors {\n          errorKey\n          errorValue\n          errorCode\n        }\n        ").concat(appContext.isDirectCxo || appContext.isIndirectCxo ? "attendees {\n                id\n                gmNumber\n                customerId\n              }" : '', "\n      }\n    }\n    ").concat(Object(_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_4__[/* getPriceDetailFragment */ "h"])(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__[/* PROPOSAL_UPDATE_ATTENDEES */ "wd"]
  });
}

var queryBookingAttendees = function queryBookingAttendees(bookingId) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery("query {\n    bookingAttendees(bookingId: ".concat(bookingId, ") {\n      civility\n      gmNumber\n      customerId\n      identityNumber\n      mainContact\n      lastName\n      unicodeLastName\n      firstName\n      unicodeFirstName\n      email\n      birthdate\n    }\n  }"));
};



/***/ }),

/***/ "C56r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__("mplc");
var isObject = __webpack_require__("1YFU");

var slice = [].slice;
var factories = {};

var construct = function (C, argsLength, args) {
  if (!(argsLength in factories)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func -- we have no proper alternatives, IE8- only
    factories[argsLength] = Function('C,a', 'return new C(' + list.join(',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = slice.call(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = partArgs.concat(slice.call(arguments));
    return this instanceof boundFunction ? construct(fn, args.length, args) : fn.apply(that, args);
  };
  if (isObject(fn.prototype)) boundFunction.prototype = fn.prototype;
  return boundFunction;
};


/***/ }),

/***/ "C8GU":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("j2ob");
var requireObjectCoercible = __webpack_require__("4gXF");

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "C9cF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IS_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IS_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IS_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getProductBadgeIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getServiceAgesLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getServiceAgesLabelTranslateOptions; });
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _color_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("UCZK");


var IS_DISABLED = 'isDisabled';
var IS_ENABLED = 'isEnabled';
var IS_SELECTED = 'isSelected';

var getProductBadgeIcon = function getProductBadgeIcon(_ref) {
  var badgeIcon = _ref.badgeIcon,
      color = _ref.color,
      comfortLabel = _ref.comfortLabel;
  return {
    alt: comfortLabel || '',
    color: _color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].WHITE,
    colorBg: color,
    colorBorder: color,
    iconName: badgeIcon
  };
};

function getServiceAgesLabel(ageInMonths, i18n) {
  var min = ageInMonths.min,
      max = ageInMonths.max;

  if (min > 23) {
    return Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["messageFormat"])(i18n.booking.services.childcare.kidsAgeInYears).format({
      min: Math.floor(min / 12),
      max: max ? Math.floor(max / 12) : ''
    });
  }

  if (min < 23 && max && max > 23) {
    return Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["messageFormat"])(i18n.booking.services.childcare.kidsAgeInMonthsAndYears).format({
      min: min,
      max: Math.floor(max / 12)
    });
  }

  return Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["messageFormat"])(i18n.booking.services.childcare.kidsAgeInMonths).format({
    min: min,
    max: max
  });
}

function getServiceAgesLabelTranslateOptions(ageInMonths) {
  var min = ageInMonths.min,
      max = ageInMonths.max;

  if (min > 23) {
    return ['booking.services.childcare.kidsAgeInYears', {
      min: Math.floor(min / 12),
      max: max ? Math.floor(max / 12) : ''
    }];
  }

  if (min < 23 && max && max > 23) {
    return ['booking.services.childcare.kidsAgeInMonthsAndYears', {
      min: min,
      max: Math.floor(max / 12)
    }];
  }

  return ['booking.services.childcare.kidsAgeInMonths', {
    min: min,
    // $FlowFixMe 🤬
    max: max
  }];
}



/***/ }),

/***/ "CGO5":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("87KK").f;
var has = __webpack_require__("DZWw");
var wellKnownSymbol = __webpack_require__("nJrx");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "CwJu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filterAccommodations; });
/* unused harmony export sortAccommodations */
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("lZ21");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




function sortAccommodations(accommodationsSets) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["sortBy"])(accommodationsSets, function (set) {
    // sort accommodations by comfort level: Standard, Deluxe, Suite
    return _utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_2__[/* ACCOMMODATION_COMFORT_ORDER */ "a"].indexOf(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(set, 'accommodations[0].categoryId'));
  }).map(function (set, index) {
    // accommodationSetNumber was set to index + 1 in accommodationsSetsReducer
    // need to be updated after filtering & sorting
    return _objectSpread(_objectSpread({}, set), {}, {
      accommodationSetNumber: index + 1
    });
  });
}

function filterAccommodations(proposal, accommodationsSets) {
  var proposalAccommodations = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(proposal, 'accommodations', []); // remove additional accommodation if already exists in selected proposal

  var filteredAccommodations = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["reject"])(accommodationsSets, function (_ref) {
    var accommodations = _ref.accommodations;
    return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isEqual"])(accommodations, proposalAccommodations);
  }); // sort additional accommodations by comfort level: Standard, Deluxe, Suite

  return sortAccommodations(filteredAccommodations);
}



/***/ }),

/***/ "DOIJ":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("j2ob");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "DQFb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageSlideShow; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("u/u4");
/* harmony import */ var _arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Gy6l");
/* harmony import */ var _backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("NZxu");
/* harmony import */ var _image_Image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("0IQ5");
/* harmony import */ var _slider_handler_SliderHandler__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("A5Hi");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;







var ImageSlideShow = function ImageSlideShow(_ref) {
  var className = _ref.className,
      closeLabel = _ref.closeLabel,
      galleryLabel = _ref.galleryLabel,
      _ref$groupKey = _ref.groupKey,
      groupKey = _ref$groupKey === void 0 ? 'thumbnails' : _ref$groupKey,
      hasControlsOnHover = _ref.hasControlsOnHover,
      hasFullScreenMode = _ref.hasFullScreenMode,
      hasInfiniteScroll = _ref.hasInfiniteScroll,
      hasInsetBorder = _ref.hasInsetBorder,
      hasLazyLoading = _ref.hasLazyLoading,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      nextLabel = _ref.nextLabel,
      previousLabel = _ref.previousLabel,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === void 0 ? _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].XL : _ref$ratio,
      _ref$ratioDisplay = _ref.ratioDisplay,
      ratioDisplay = _ref$ratioDisplay === void 0 ? 1 : _ref$ratioDisplay;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(false),
      isFullScreen = _useState[0],
      setIsFullScreen = _useState[1];

  if (!media.length) {
    return null;
  }

  var gk = hasFullScreenMode ? null : groupKey;
  var ItemTagName = hasFullScreenMode ? 'button' : 'div';
  var itemProps = hasFullScreenMode ? {
    className: 'reset-button block w-full h-full',
    onClick: function onClick() {
      return setIsFullScreen(true);
    },
    type: 'button'
  } : {
    className: 'h-full'
  };
  var items = media.map(function (_ref2) {
    var _ref2$alt = _ref2.alt,
        alt = _ref2$alt === void 0 ? '' : _ref2$alt,
        src = _ref2.src;
    return src ? __jsx(ItemTagName, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
      key: src
    }, itemProps), __jsx(_image_Image__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"], {
      altMsg: alt,
      groupKey: gk,
      hasInsetBorder: hasInsetBorder,
      hasLazyLoading: hasLazyLoading,
      imageUrl: src,
      key: src,
      ratioKey: ratio,
      ratioDisplay: ratioDisplay
    })) : null;
  }).filter(Boolean);
  return __jsx(_slider_handler_SliderHandler__WEBPACK_IMPORTED_MODULE_7__[/* SliderHandler */ "a"], {
    hasInfiniteScroll: hasInfiniteScroll,
    hasKeyboardSupport: true,
    hasLazyload: true,
    hasSwipeSupport: true,
    items: items
  }, function (_ref3) {
    var hasControls = _ref3.hasControls,
        isNextControlDisabled = _ref3.isNextControlDisabled,
        isPreviousControlDisabled = _ref3.isPreviousControlDisabled,
        itemsNode = _ref3.itemsNode,
        onNext = _ref3.onNext,
        onPrevious = _ref3.onPrevious;
    return __jsx("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, 'group relative')
    }, itemsNode, hasControls && __jsx("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('transition-opacity will-change-transform absolute flex items-center justify-between max-w-site m-auto inset-0 pointer-events-none px-px10 sm:px-px20 w-full z-2', {
        'group-hover:opacity-100 opacity-0': hasControlsOnHover
      }),
      "data-testid": "ImageSlideShow-controls-parent"
    }, !isPreviousControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_4__[/* ArrowButton */ "a"], {
      className: "rtl:mr-auto pointer-events-auto shadow-sm z-2",
      label: previousLabel,
      onClick: onPrevious
    }), !isNextControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_4__[/* ArrowButton */ "a"], {
      className: "rtl:ml-auto pointer-events-auto shadow-sm z-2",
      label: nextLabel,
      onClick: onNext,
      rotation: 180
    })), hasFullScreenMode && isFullScreen && __jsx(_backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_5__[/* Backdrop */ "a"], {
      ariaLabel: galleryLabel,
      closeLabel: closeLabel,
      hasCloseButton: true,
      onClose: function onClose() {
        return setIsFullScreen(false);
      }
    }, __jsx("div", {
      className: "relative w-full"
    }, itemsNode, hasControls && __jsx("div", {
      className: "absolute flex items-center justify-between m-auto inset-0 pointer-events-none px-px10 sm:px-px20 w-full"
    }, !isPreviousControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_4__[/* ArrowButton */ "a"], {
      className: "rtl:mr-auto pointer-events-auto shadow-sm z-2",
      label: previousLabel,
      onClick: onPrevious
    }), !isNextControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_4__[/* ArrowButton */ "a"], {
      className: "rtl:ml-auto pointer-events-auto shadow-sm z-2",
      label: nextLabel,
      onClick: onNext,
      rotation: 180
    })))));
  });
};

/***/ }),

/***/ "DZWw":
/***/ (function(module, exports, __webpack_require__) {

var toObject = __webpack_require__("A+R+");

var hasOwnProperty = {}.hasOwnProperty;

module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty.call(toObject(it), key);
};


/***/ }),

/***/ "Dbuu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ MoreTransports_MoreTransports; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: ./src/client/components/utils/identifiers/constants.js
var constants = __webpack_require__("YZTm");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js + 115 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: ./src/client/router/useRouter.js
var useRouter = __webpack_require__("7jla");

// EXTERNAL MODULE: ./src/client/components/frameworks/tabs/Tabs.jsx + 1 modules
var Tabs = __webpack_require__("4/4b");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/routes/constants.js
var routes_constants = __webpack_require__("dNxv");

// EXTERNAL MODULE: ./src/client/store/booking/additional-transports/additionalTransports.action.js
var additionalTransports_action = __webpack_require__("04nu");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/FormikInput.jsx + 16 modules
var FormikInput = __webpack_require__("/HC4");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/widgets/transports-search-engine/DirectFlightsCheckBox.jsx
var __jsx = react_default.a.createElement;







var DirectFlightsCheckBox_StyledCheckBox = function StyledCheckBox(isChecked) {
  return __jsx("div", {
    className: "flex items-center mb-px10 md:mb-0"
  }, __jsx("span", {
    style: {
      width: '1.25rem',
      height: '1.25rem'
    },
    className: "block border border-gray flex-shrink-0 leading-one p-px5 rtl:mr-px10 rounded-small"
  }, !!isChecked && __jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].BLUE,
    name: icons["a" /* ICONS */].CHECK,
    width: "1em"
  })), __jsx("span", {
    className: "block leading-one"
  }, Object(src_i18n["g" /* t */])('booking.transport.criteria.directFlights')));
};

var DirectFlightsCheckBox_DirectFlightsCheckBox = function DirectFlightsCheckBox(_ref) {
  var onClick = _ref.onClick;
  return __jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "directFlights",
    name: "directFlights",
    onClick: onClick,
    placeholderComponent: DirectFlightsCheckBox_StyledCheckBox,
    type: "checkbox"
  });
};
// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// CONCATENATED MODULE: ./src/client/components/widgets/transports-search-engine/TransportsSearchEngine.utils.js

var TransportsSearchEngine_utils_isFlightSearchAllowed = function isFlightSearchAllowed(appContext) {
  if (appContext.isSeller) {
    var seller = appContext.isCmta ? 'cmta' : 'cxo';
    return !Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)("booking.transport.trip.".concat(seller, ".hideFlightSearch"));
  }

  return !Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.transport.trip.hideFlightSearch');
};
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/widgets/transport-details/transportUtils.js
var transportUtils = __webpack_require__("z8xc");

// EXTERNAL MODULE: ./src/utils/transport/additionalTransports.constants.js
var additionalTransports_constants = __webpack_require__("dGB2");

// EXTERNAL MODULE: ./src/utils/label/labelUtils.js
var labelUtils = __webpack_require__("WGoB");

// CONCATENATED MODULE: ./src/client/components/widgets/transports-search-engine/TransportsSearchForm.jsx


var TransportsSearchForm_jsx = react_default.a.createElement;














var flightClassesAvailableToSearch = [additionalTransports_constants["g" /* FLIGHT_CLASS_ECO */], additionalTransports_constants["f" /* FLIGHT_CLASS_BUSINESS */], additionalTransports_constants["i" /* FLIGHT_CLASS_FIRST */], additionalTransports_constants["j" /* FLIGHT_CLASS_PREMIUM */], additionalTransports_constants["h" /* FLIGHT_CLASS_EMERALD */], additionalTransports_constants["e" /* FLIGHT_CLASS_ALIZEE */]];

// TODO: A better solution would be refactoring FormikInput to handle multiple themes
var TransportsSearchForm_FlatInput = function FlatInput(_ref) {
  var iconName = _ref.iconName,
      isDisabled = _ref.isDisabled,
      onClick = _ref.onClick,
      otherProps = Object(objectWithoutProperties["a" /* default */])(_ref, ["iconName", "isDisabled", "onClick"]);

  return TransportsSearchForm_jsx("div", {
    className: classnames_default()('md:rtl:mr-px10 mb-px10 md:mb-0 md:flex-1 rounded-tiny rtl:pl-px10 flex text-base items-center border-1 border-gray-medium text-gray-darker', {
      'opacity-50': isDisabled
    }),
    onMouseDown: onClick
  }, TransportsSearchForm_jsx(Icon["a" /* Icon */], {
    className: "flex-shrink-0 rtl:mr-px10",
    color: colors["a" /* COLORS */].GRAY_DARKER,
    name: iconName,
    width: "1rem"
  }), TransportsSearchForm_jsx(FormikInput["a" /* FormikInput */], Object(esm_extends["a" /* default */])({
    hideErrorMessage: true,
    isDisabled: isDisabled
  }, otherProps)));
};

var TransportsSearchForm_TransportsSearchForm = function TransportsSearchForm(_ref2) {
  var _travelSections, _travelSections$;

  var getTrackingData = _ref2.getTrackingData,
      proposal = _ref2.proposal;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var trackClick = Object(useTracking["a" /* useTracking */])();
  var travelSections = proposal.transports.inbound.travelSections;
  var arrival = (_travelSections = travelSections[travelSections.length - 1]) === null || _travelSections === void 0 ? void 0 : _travelSections.arrival;
  var departure = (_travelSections$ = travelSections[0]) === null || _travelSections$ === void 0 ? void 0 : _travelSections$.departure;

  var buildFlightClassOption = function buildFlightClassOption(value) {
    return {
      value: value,
      name: Object(src_i18n["g" /* t */])("common.transport.transportClass.".concat(transportUtils["c" /* TRANSPORT_CLASS_TO_I18N */][value]))
    };
  };

  var flightClassOptions = flightClassesAvailableToSearch.map(buildFlightClassOption);
  return TransportsSearchForm_jsx("div", {
    className: "flex flex-col md:flex-row flex-wrap justify-between items-stretch",
    "data-testid": "TransportsSearchForm"
  }, isTablet ? null : TransportsSearchForm_jsx(DirectFlightsCheckBox_DirectFlightsCheckBox, {
    onClick: function onClick() {
      return trackClick(getTrackingData('DirectFLights'));
    }
  }), TransportsSearchForm_jsx(TransportsSearchForm_FlatInput, {
    customClasses: "bg-white capitalize w-full appearance-none outline-none ",
    iconName: icons["a" /* ICONS */].COMPASS,
    name: "departure",
    isDisabled: true,
    options: [// TODO: Should be replaced by a real cities list coming from the API... When API is ready...
    {
      value: departure.cityId,
      name: Object(labelUtils["c" /* getTravelSectionSummary */])({
        travelSection: departure
      })
    }, {
      value: arrival.cityId,
      name: Object(labelUtils["c" /* getTravelSectionSummary */])({
        travelSection: arrival
      })
    }],
    type: "select"
  }), TransportsSearchForm_jsx(TransportsSearchForm_FlatInput, {
    customClasses: "bg-white capitalize w-full appearance-none outline-none",
    iconName: icons["a" /* ICONS */].COMPASS,
    name: "arrival",
    isDisabled: true,
    options: [// TODO: Should be replaced by a real cities list coming from the API... When API is ready...
    {
      value: departure.cityId,
      name: Object(labelUtils["c" /* getTravelSectionSummary */])({
        travelSection: departure
      })
    }, {
      value: arrival.cityId,
      name: Object(labelUtils["c" /* getTravelSectionSummary */])({
        travelSection: arrival
      })
    }],
    type: "select"
  }), TransportsSearchForm_jsx(TransportsSearchForm_FlatInput, {
    customClasses: "bg-white w-full",
    dateFormat: "DD MMM",
    hasArrowDown: true,
    iconName: icons["a" /* ICONS */].DATE,
    isDisabled: true,
    name: "dates",
    type: "datepicker"
  }), TransportsSearchForm_jsx(TransportsSearchForm_FlatInput, {
    customClasses: "bg-white border-0 w-full rounded-tiny appearance-none outline-none rtl:pr-px40",
    hideImageValidation: true,
    iconName: icons["a" /* ICONS */].BUSINESS_CLASS,
    name: "flightClass",
    options: flightClassOptions,
    type: "select",
    onClick: function onClick() {
      trackClick(getTrackingData('Class'));
    }
  }), TransportsSearchForm_jsx(Button["a" /* Button */], {
    className: "text-sm cursor-pointer",
    colorBg: colors["a" /* COLORS */].BOOKING,
    colorBorder: colors["a" /* COLORS */].BOOKING,
    isLoading: false,
    style: {
      width: isTablet ? '11.25rem' : '100%',
      height: '2.5rem'
    },
    trackingData: getTrackingData('Apply'),
    type: "submit"
  }, Object(src_i18n["g" /* t */])('remote.searchAction')));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx + 1 modules
var TextLink = __webpack_require__("jD8k");

// CONCATENATED MODULE: ./src/client/components/widgets/transports-search-engine/TripCriteriaSummary.jsx

var TripCriteriaSummary_jsx = react_default.a.createElement;









var TripCriteriaSummary_TripCriteriaSummary = function TripCriteriaSummary(_ref) {
  var onClick = _ref.onClick,
      proposal = _ref.proposal;
  var criterias = Object(es["e" /* useSelector */])(booking_selector["x" /* getSearchCriteriaTransports */]) || [];

  var _criterias = Object(slicedToArray["a" /* default */])(criterias, 1),
      inboundCriteria = _criterias[0];

  var adultsCount = proposal.attendees.adults.length;
  var kidsCount = proposal.attendees.children.length;
  var travelSections = proposal.transports.inbound.travelSections;
  var arrival = travelSections[travelSections.length - 1].arrival;
  var departure = travelSections[0].departure;
  var from = moment_default()(proposal.arrivalDate).format('DD MMM');
  var to = moment_default()(proposal.departureDate).format('DD MMM');
  return TripCriteriaSummary_jsx("div", {
    className: "flex flex-col md:flex-row shadow-diffuse w-full bg-white rounded-tiny border-1 border-gray-light px-px20 py-px10 text-base mb-px30",
    "data-testid": "TripCriteriaSummary"
  }, TripCriteriaSummary_jsx("span", {
    className: "capitalize rtl:mr-px20 text-gray-darker font-bold leading-tight"
  }, "".concat(Object(labelUtils["c" /* getTravelSectionSummary */])({
    travelSection: departure
  }), " - ").concat(Object(labelUtils["c" /* getTravelSectionSummary */])({
    travelSection: arrival
  }))), TripCriteriaSummary_jsx("div", {
    className: "flex-grow text-gray-medium md:inline my-px10 md:m-0",
    dir: "auto"
  }, TripCriteriaSummary_jsx("span", {
    className: "rtl:mr-px10"
  }, "".concat(from, " - ").concat(to)), TripCriteriaSummary_jsx("ul", {
    className: "inline m-0 p-0"
  }, TripCriteriaSummary_jsx("li", {
    className: "capitalize inline-block list-disc rtl:mr-px10"
  }, Object(labelUtils["b" /* getAttendeesSummary */])({
    adultsCount: adultsCount,
    kidsCount: kidsCount
  })), TripCriteriaSummary_jsx("li", {
    className: "inline-block list-disc rtl:mr-px10"
  }, proposal.duration ? Object(src_i18n["g" /* t */])('booking.transport.roundTrip') : Object(src_i18n["g" /* t */])('booking.transport.singleTrip')), TripCriteriaSummary_jsx("li", {
    className: "capitalize inline-block list-disc rtl:mr-px10 "
  }, Object(transportUtils["g" /* getClassLabel */])({
    travelSections: travelSections,
    inboundCriteria: inboundCriteria
  })))), TripCriteriaSummary_jsx(TextLink["a" /* TextLink */], {
    color: colors["a" /* COLORS */].TURQUOISE,
    iconRightName: null,
    label: Object(src_i18n["g" /* t */])('booking.editCriteria.buttonLabel'),
    onClick: onClick,
    theme: "simple"
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/transports-search-engine/TripInformation.jsx
var TripInformation_jsx = react_default.a.createElement;






var TripInformation_TripInformation = function TripInformation(_ref) {
  var title = _ref.title,
      proposalId = _ref.proposalId;

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isTablet = _useContext.isTablet;

  return TripInformation_jsx("div", {
    className: "flex flex-col md:flex-row"
  }, TripInformation_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-px40 block",
    color: colors["a" /* COLORS */].GRAY_LIGHT,
    name: icons["a" /* ICONS */].TRANSPORT,
    width: isTablet ? 'calc(50rem/16)' : 'calc(26rem/16)'
  }), TripInformation_jsx("div", {
    className: "mt-px10 md:m-0"
  }, TripInformation_jsx("p", {
    className: "font-sans font-bold text-md text-blue m-0"
  }, title), TripInformation_jsx("div", {
    className: "flex flex-col md:flex-row items-baseline mt-px10 md:m-0 "
  }, TripInformation_jsx("div", {
    className: "font-sans text-base m-0"
  }, TripInformation_jsx("span", null, Object(src_i18n["g" /* t */])('booking.transport.trip.information')), TripInformation_jsx("p", {
    className: "md:inline"
  }, TripInformation_jsx("span", {
    className: "md:px-px5"
  }, Object(src_i18n["g" /* t */])('booking.transport.trip.referenceNumberInformation')), TripInformation_jsx("span", {
    className: "font-bold text-blue text-base"
  }, proposalId))), TripInformation_jsx("p", {
    className: "mt-px5 md:m-0"
  }, TripInformation_jsx(Icon["a" /* Icon */], {
    className: "md:rtl:ml-px10",
    color: colors["a" /* COLORS */].EMERALD,
    name: icons["a" /* ICONS */].PHONE_BUBBLE,
    width: "1.5rem"
  }), TripInformation_jsx("span", {
    className: "text-emerald font-bold text-lg"
  }, Object(src_i18n["g" /* t */])('travelAdvisor.phoneNumber'))))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/transports-search-engine/TransportsSearchEngine.jsx
var TransportsSearchEngine_jsx = react_default.a.createElement;




















var getTripCriteria = function getTripCriteria(_ref) {
  var _travelSections, _travelSections$, _travelSections$2, _travelSections$2$tra;

  var proposal = _ref.proposal,
      searchCriterias = _ref.searchCriterias;
  var travelSections = proposal.transports.inbound.travelSections;
  var arrival = (_travelSections = travelSections[travelSections.length - 1]) === null || _travelSections === void 0 ? void 0 : _travelSections.arrival;
  var departure = (_travelSections$ = travelSections[0]) === null || _travelSections$ === void 0 ? void 0 : _travelSections$.departure;
  var searchCriteriaInbound = searchCriterias && searchCriterias[0];
  return {
    arrival: arrival.cityId,
    departure: departure.cityId,
    dates: {
      from: proposal.arrivalDate,
      to: proposal.departureDate
    },
    directFlights: false,
    flightClass: (searchCriteriaInbound === null || searchCriteriaInbound === void 0 ? void 0 : searchCriteriaInbound.flightClass) || ((_travelSections$2 = travelSections[0]) === null || _travelSections$2 === void 0 ? void 0 : (_travelSections$2$tra = _travelSections$2.transport) === null || _travelSections$2$tra === void 0 ? void 0 : _travelSections$2$tra.class)
  };
};

var TransportsSearchEngine_TransportsSearchEngine = function TransportsSearchEngine(_ref2) {
  var _proposal$transports, _proposal$transports$;

  var proposal = _ref2.proposal;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useState = Object(react["useState"])(isTablet),
      isCheckBoxDisplayed = _useState[0],
      setIsCheckBoxDisplayed = _useState[1];

  var _useState2 = Object(react["useState"])(!appContext.isSeller),
      isSummaryDisplayed = _useState2[0],
      setIsSummaryDisplayed = _useState2[1];

  var trackClick = Object(useTracking["a" /* useTracking */])();
  var dispatch = Object(es["d" /* useDispatch */])();
  var searchCriterias = Object(es["e" /* useSelector */])(booking_selector["x" /* getSearchCriteriaTransports */]);
  var isTrainOnly = Object(lodash["every"])((_proposal$transports = proposal.transports) === null || _proposal$transports === void 0 ? void 0 : (_proposal$transports$ = _proposal$transports.inbound) === null || _proposal$transports$ === void 0 ? void 0 : _proposal$transports$.travelSections, ['transport.type', 'TRAIN']);

  if (isTrainOnly || !TransportsSearchEngine_utils_isFlightSearchAllowed(appContext)) {
    return null;
  }

  var getTrackingData = function getTrackingData(tab) {
    return function (action) {
      var isInComparatorView = location.pathname.includes(routes_constants["d" /* COMPARATOR_URL */]);
      var actionGA = isInComparatorView ? 'compare' : 'transport';
      var categoryGA = isInComparatorView ? 'search' : 'bookingEngine';
      var labelGAPrefix = isInComparatorView ? 'customTransport' : 'moreTransport';
      var labelGA = "".concat(labelGAPrefix, "_editCriteria");

      if (action) {
        labelGA += "_".concat(action);
      }

      if (tab) {
        labelGA += "_".concat(tab);
      }

      return {
        actionGA: actionGA,
        categoryGA: categoryGA,
        labelGA: labelGA,
        versionBooking: 'responsive'
      };
    };
  };

  var hideSummary = function hideSummary() {
    setIsSummaryDisplayed(false);
    var getTrackingDataForNoTab = getTrackingData();
    trackClick(getTrackingDataForNoTab());
  };

  var toggleCheckBoxVisibility = function toggleCheckBoxVisibility(tabIndex) {
    // Direct flights checkbox should be displayed only with search form (first tab)
    if (tabIndex === 0 && !isCheckBoxDisplayed && isTablet) {
      setIsCheckBoxDisplayed(true);
    }

    if (tabIndex > 0 && isCheckBoxDisplayed && isTablet) {
      setIsCheckBoxDisplayed(false);
    }
  };

  var getTrackingDataForRoundTrip = getTrackingData('roundTrip');
  var roundTripTab = {
    content: TransportsSearchEngine_jsx(TransportsSearchForm_TransportsSearchForm, {
      getTrackingData: getTrackingDataForRoundTrip,
      proposal: proposal
    }),
    header: {
      title: Object(src_i18n["g" /* t */])('booking.transport.roundTrip')
    },
    headerId: 'roundTripHeader',
    panelId: 'roundTripPanel'
  };
  var singleTripTab = {
    content: TransportsSearchEngine_jsx(TripInformation_TripInformation, {
      proposalId: proposal.id,
      title: Object(src_i18n["g" /* t */])('booking.transport.labelSingleTrip')
    }),
    header: {
      title: Object(src_i18n["g" /* t */])('booking.transport.singleTrip')
    },
    headerId: 'singleTripHeader',
    panelId: 'singleTripPanel'
  };
  var multiDestinationTripTab = {
    content: TransportsSearchEngine_jsx(TripInformation_TripInformation, {
      proposalId: proposal.id,
      title: Object(src_i18n["g" /* t */])('booking.transport.labelMultiDestination')
    }),
    header: {
      title: Object(src_i18n["g" /* t */])('booking.transport.multiDestination')
    },
    headerId: 'multiDestinationHeader',
    panelId: 'multiDestinationPanel'
  };
  var tabsItems = [roundTripTab];

  if (!appContext.isSeller) {
    tabsItems.push(singleTripTab, multiDestinationTripTab);
  }

  var handleSubmit = function handleSubmit(_ref3) {
    var directFlights = _ref3.directFlights,
        flightClass = _ref3.flightClass,
        dates = _ref3.dates,
        departure = _ref3.departure,
        arrival = _ref3.arrival;
    var newSearchCriteria = [{
      departure: {
        locationId: departure,
        date: dates.from
      },
      arrival: {
        locationId: arrival
      },
      flightClass: flightClass,
      maxConnections: directFlights ? 0 : undefined
    }, {
      departure: {
        locationId: arrival,
        date: dates.to
      },
      arrival: {
        locationId: departure
      },
      flightClass: flightClass,
      maxConnections: directFlights ? 0 : undefined
    }];
    dispatch(Object(additionalTransports_action["l" /* fetchAdditionalTransports */])({
      proposal: proposal,
      appContext: appContext,
      searchCriterias: newSearchCriteria
    }));
  };

  return isSummaryDisplayed ? TransportsSearchEngine_jsx(TripCriteriaSummary_TripCriteriaSummary, {
    onClick: hideSummary,
    proposal: proposal
  }) : TransportsSearchEngine_jsx(formik_esm["d" /* Formik */], {
    initialValues: getTripCriteria({
      proposal: proposal,
      searchCriterias: searchCriterias
    }),
    onSubmit: handleSubmit
  }, TransportsSearchEngine_jsx(formik_esm["c" /* Form */], null, TransportsSearchEngine_jsx(Tabs["a" /* Tabs */], {
    bgColor: colors["a" /* COLORS */].WHITE,
    containerSize: "mini",
    hasBackground: true,
    isContainerWide: false,
    isContentUnmountedOnCollapse: true,
    items: tabsItems,
    onSelect: toggleCheckBoxVisibility,
    slotRight: isCheckBoxDisplayed ? TransportsSearchEngine_jsx(DirectFlightsCheckBox_DirectFlightsCheckBox, {
      onClick: function onClick() {
        trackClick(getTrackingDataForRoundTrip('DirectFLights'));
      }
    }) : null,
    theme: "flat"
  })));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/layer/Layer.jsx + 4 modules
var Layer = __webpack_require__("U2fG");

// EXTERNAL MODULE: ./src/client/components/widgets/layer-header-proposal/LayerHeaderProposal.jsx
var LayerHeaderProposal = __webpack_require__("U/+3");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.jsx + 1 modules
var AsyncLoader = __webpack_require__("4A3Y");

// EXTERNAL MODULE: ./src/client/components/widgets/confirmation/Confirmation.jsx
var Confirmation = __webpack_require__("Fmrk");

// EXTERNAL MODULE: ./src/client/components/frameworks/slider-handler/SliderHandler.jsx + 2 modules
var SliderHandler = __webpack_require__("A5Hi");

// EXTERNAL MODULE: ./src/client/components/utils/style/style.util.js
var style_util = __webpack_require__("5pZ8");

// EXTERNAL MODULE: ./src/client/components/widgets/paginate/Paginate.jsx + 1 modules
var Paginate = __webpack_require__("aGPO");

// EXTERNAL MODULE: ./src/client/components/widgets/be-transport-details/inner-transport-details/InnerTransportDetails.jsx + 4 modules
var InnerTransportDetails = __webpack_require__("UhMs");

// EXTERNAL MODULE: ./src/client/components/frameworks/strip-button/StripButton.jsx + 1 modules
var StripButton = __webpack_require__("ZpYc");

// CONCATENATED MODULE: ./src/client/components/widgets/plane-ticket/PlaneTicket.jsx
var PlaneTicket_jsx = react_default.a.createElement;

/*
 * * More Transport page [find transport page] (Recommended flight & Alternative flights )
 */





var PlaneTicket_PlaneTicket = function PlaneTicket(_ref) {
  var _transport$transportI;

  var button = _ref.button,
      className = _ref.className,
      _ref$dataTestid = _ref.dataTestid,
      dataTestid = _ref$dataTestid === void 0 ? 'PlaneTicket' : _ref$dataTestid,
      i18n = _ref.i18n,
      maxHeight = _ref.maxHeight,
      noBusinessClassAvailable = _ref.noBusinessClassAvailable,
      price = _ref.price,
      proposalNumber = _ref.proposalNumber,
      tabIndex = _ref.tabIndex,
      transport = _ref.transport;
  return PlaneTicket_jsx("div", {
    className: classnames_default()(className, 'relative rounded-tiny z-0'),
    "data-testid": dataTestid,
    style: {
      maxHeight: maxHeight
    }
  }, proposalNumber && PlaneTicket_jsx("div", {
    className: "absolute bottom-full -mb-px mx-px10 z-1"
  }, PlaneTicket_jsx(StripButton["a" /* StripButton */], {
    className: "font-brand text-xs",
    height: 20
  }, Object(src_i18n["g" /* t */])('common.proposalLabel'), "\xA0", proposalNumber)), PlaneTicket_jsx(InnerTransportDetails["a" /* InnerTransportDetails */], {
    button: button,
    flight: transport === null || transport === void 0 ? void 0 : transport.journey,
    i18n: i18n,
    isSearchPage: true,
    noBusinessClassAvailable: noBusinessClassAvailable,
    price: price,
    tabIndex: tabIndex || 0,
    way: transport === null || transport === void 0 ? void 0 : (_transport$transportI = transport.transportInfo) === null || _transport$transportI === void 0 ? void 0 : _transport$transportI.way
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/index.js
var tracking_api = __webpack_require__("d1HQ");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/AdditionalTransports.tracking.js


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var FLIGHT = {
  INBOUND: 'Inbound',
  OUTBOUND: 'Outbound'
};

function getCategoryAction(isComparatorView) {
  return {
    categoryGA: isComparatorView ? 'search' : 'bookingEngine',
    actionGA: isComparatorView ? 'compare' : 'transport'
  };
}

var AdditionalTransports_tracking_trackClickFilter = function trackClickFilter(appContext, filterName, flight, isComparatorView) {
  var filterType = filterName;

  if (filterName === 'connectionCities') {
    filterType = 'layoversCity';
  }

  if (filterName === 'departureArrival') {
    filterType = 'schedule';
  }

  var labelPrefix = isComparatorView ? 'customTransport_filter' : 'moreTransport_filter';
  tracking_api["b" /* setDataLayer */](_objectSpread(_objectSpread({
    event: tracking_constants["h" /* EVENT_GA */],
    versionBooking: 'responsive'
  }, getCategoryAction(isComparatorView)), {}, {
    labelGA: "".concat(labelPrefix, "_").concat(filterType, "_").concat(flight),
    valueGA: '0',
    nonInteraction: '0'
  }), appContext);
};
var AdditionalTransports_tracking_trackClickSelection = function trackClickSelection(appContext, flight, isComparatorView, isRecommendedFlight) {
  var originPrefix = isComparatorView ? 'customTransport' : 'moreTransport';
  var recommendedPrefix = isRecommendedFlight ? 'Recommendation' : 'OtherProposal';
  var labelPrefix = "".concat(originPrefix, "_").concat(recommendedPrefix);
  tracking_api["b" /* setDataLayer */](_objectSpread(_objectSpread({
    event: tracking_constants["h" /* EVENT_GA */],
    versionBooking: 'responsive'
  }, getCategoryAction(isComparatorView)), {}, {
    labelGA: "".concat(labelPrefix, "_").concat(flight),
    valueGA: '0',
    nonInteraction: '0'
  }), appContext);
};
// EXTERNAL MODULE: ./src/client/components/widgets/double-col-layer/DoubleColLayer.jsx
var DoubleColLayer = __webpack_require__("obLz");

// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/list/AdditionalTransportsList.jsx

var AdditionalTransportsList_jsx = react_default.a.createElement;




















function getGenericRecommendedLabel(isInbound) {
  return isInbound ? Object(src_i18n["g" /* t */])('booking.transport.additionalTransports.inboundRecommendationLabel') : Object(src_i18n["g" /* t */])('booking.transport.additionalTransports.outboundRecommendationLabel');
}

function getRecommendedLabel(isInbound, isPlane) {
  if (isPlane) {
    return isInbound ? Object(src_i18n["g" /* t */])('booking.transport.additionalTransports.inboundRecommendationDesktopLabel') : Object(src_i18n["g" /* t */])('booking.transport.additionalTransports.outboundRecommendationDesktopLabel');
  }

  return getGenericRecommendedLabel(isInbound);
}

function getGenericOthersLabel(isInbound) {
  return isInbound ? Object(src_i18n["g" /* t */])('booking.transport.additionalTransports.inboundOthersLabel') : Object(src_i18n["g" /* t */])('booking.transport.additionalTransports.outboundOthersLabel');
}

function getOthersDesktopLabel(isInbound, isPlane) {
  if (isPlane) {
    return isInbound ? Object(src_i18n["g" /* t */])('booking.transport.additionalTransports.inboundOthersDesktopLabel') : Object(src_i18n["g" /* t */])('booking.transport.additionalTransports.outboundOthersDesktopLabel');
  }

  return getGenericOthersLabel(isInbound);
}

var AdditionalTransportsList_getTrainSelectedTransport = function getTrainSelectedTransport(isInbound) {
  return isInbound ? Object(src_i18n["g" /* t */])('booking.transport.additionalTransports.inboundSelectionMobileLabel') : Object(src_i18n["g" /* t */])('booking.transport.additionalTransports.outboundSelectionMobileLabel');
};

function getMobileButtonLabels(isInbound, isSelectedRecommended) {
  return {
    leftButtonLabel: isSelectedRecommended ? getGenericRecommendedLabel(isInbound) : AdditionalTransportsList_getTrainSelectedTransport(isInbound),
    rightButtonLabel: getGenericOthersLabel(isInbound)
  };
}

function getRecommendedOrSelectedDesktopLabel(isInbound, isSelectedRecommended, isPlane) {
  var recommendedLabel = getRecommendedLabel(isInbound, isPlane);
  var desktopSelectedLabel = isInbound ? Object(src_i18n["g" /* t */])('booking.transport.additionalTransports.inboundSelectionDesktopLabel') : Object(src_i18n["g" /* t */])('booking.transport.additionalTransports.outboundSelectionDesktopLabel');
  var selectedTransportLabel = isPlane ? desktopSelectedLabel : AdditionalTransportsList_getTrainSelectedTransport(isInbound);
  return isSelectedRecommended ? recommendedLabel : selectedTransportLabel;
}

var AdditionalTransportsList_AdditionalTransportsList = function AdditionalTransportsList(_ref) {
  var _selectedTransport$tr, _selectedTransport$jo, _selectedTransport$tr2, _selectedTransport$tr3, _selectedTransport$tr4, _selectedTransport$tr5, _selectedTransport$tr6;

  var i18n = _ref.i18n,
      onAddTransport = _ref.onAddTransport,
      noBusinessClassAvailable = _ref.noBusinessClassAvailable,
      alternativeTransports = _ref.alternativeTransports,
      isSelectedRecommended = _ref.isSelectedRecommended,
      selectedTransport = _ref.selectedTransport;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var _useSelector = Object(es["e" /* useSelector */])(booking_selector["f" /* getAdditionalTransports */]),
      selectedTransportId = _useSelector.selectedTransportId;

  var isInbound = !selectedTransport || (selectedTransport === null || selectedTransport === void 0 ? void 0 : (_selectedTransport$tr = selectedTransport.transportInfo) === null || _selectedTransport$tr === void 0 ? void 0 : _selectedTransport$tr.way) === 'INBOUND';
  var isPlane = Object(transportUtils["n" /* hasOnlyPlanes */])(selectedTransport === null || selectedTransport === void 0 ? void 0 : (_selectedTransport$jo = selectedTransport.journey) === null || _selectedTransport$jo === void 0 ? void 0 : _selectedTransport$jo.travelSections);
  var isComparatorView = location.pathname === '/comparator'; // Top page header has a height of 5rem

  var headerHeight = Object(style_util["a" /* remToPx */])(5); // Title above transportation detail has a height of 4rem.
  // Button beneath transportation detail has a height of 4rem.

  var titleAndButtonHeights = Object(style_util["a" /* remToPx */])(4) * 2;
  var isClientSide = true;
  var maxHeight = isClientSide && isTablet ? window.innerHeight - headerHeight - titleAndButtonHeights : undefined;
  var iterationNumber = 5;

  var _useState = Object(react["useState"])(iterationNumber),
      forceInitialShowingItemsNumber = _useState[0],
      setForceInitialShowingItemsNumber = _useState[1];

  var saveSelectedFlights = function saveSelectedFlights(transportId) {
    var isDefaultTransport = transportId === selectedTransport.transportInfo.id;
    var clickOnRecommended = isDefaultTransport ? isSelectedRecommended : false;
    AdditionalTransports_tracking_trackClickSelection(appContext, isInbound ? 'Inbound' : 'Outbound', isComparatorView, clickOnRecommended);
    onAddTransport(transportId);
  };

  return AdditionalTransportsList_jsx("div", null, !selectedTransportId && isInbound && (alternativeTransports === null || alternativeTransports === void 0 ? void 0 : alternativeTransports.length) === 0 ? AdditionalTransportsList_jsx(SiteContainer["a" /* SiteContainer */], null, AdditionalTransportsList_jsx(Confirmation["a" /* Confirmation */], {
    icon: isPlane ? icons["a" /* ICONS */].CIRCLED_PLANE : icons["a" /* ICONS */].TRAIN,
    status: "neutral",
    text: Object(src_i18n["g" /* t */])('booking.transport.additionalTransports.noAdditionalTransportAvailableDescription'),
    title: Object(src_i18n["g" /* t */])('booking.transport.additionalTransports.noAdditionalTransportAvailableTitle')
  })) : AdditionalTransportsList_jsx(react["Fragment"], null, AdditionalTransportsList_jsx(DoubleColLayer["a" /* DoubleColLayer */], Object(esm_extends["a" /* default */])({}, getMobileButtonLabels(isInbound, isSelectedRecommended), {
    initialActiveCol: isInbound ? DoubleColLayer["b" /* END_COL_CMP */] : DoubleColLayer["d" /* START_COL_CMP */]
  }), AdditionalTransportsList_jsx(DoubleColLayer["e" /* StartCol */], null, isTablet && AdditionalTransportsList_jsx("div", {
    className: classnames_default()('mb-px10', {
      'text-emerald': isSelectedRecommended,
      'text-blue': !isSelectedRecommended
    })
  }, AdditionalTransportsList_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-px10",
    name: icons["a" /* ICONS */].CHECK,
    width: "0.8rem"
  }), AdditionalTransportsList_jsx("span", {
    className: "font-bold text-md"
  }, getRecommendedOrSelectedDesktopLabel(isInbound, isSelectedRecommended, isPlane))), AdditionalTransportsList_jsx("div", {
    className: "mb-px10 overflow-y-auto",
    "data-testid": "recommended_inbound_".concat(selectedTransport === null || selectedTransport === void 0 ? void 0 : (_selectedTransport$tr2 = selectedTransport.transportInfo) === null || _selectedTransport$tr2 === void 0 ? void 0 : _selectedTransport$tr2.id)
  }, AdditionalTransportsList_jsx(PlaneTicket_PlaneTicket, {
    button: {
      color: colors["a" /* COLORS */].BLUE,
      label: Object(src_i18n["g" /* t */])('common.confirm'),
      minWidth: isInbound ? '12rem' : '7rem',
      onClick: function onClick() {
        return saveSelectedFlights(selectedTransport === null || selectedTransport === void 0 ? void 0 : selectedTransport.transportInfo.id);
      }
    },
    dataTestid: "AdditionalTransportOption",
    i18n: i18n,
    maxHeight: maxHeight
    /* $FlowFixMe : proposal has transport in this step */
    ,
    price: !isInbound ? {
      /* $FlowFixMe : proposal has transport in this step */
      value: selectedTransport === null || selectedTransport === void 0 ? void 0 : (_selectedTransport$tr3 = selectedTransport.transportInfo) === null || _selectedTransport$tr3 === void 0 ? void 0 : (_selectedTransport$tr4 = _selectedTransport$tr3.totalDifferentialPrice) === null || _selectedTransport$tr4 === void 0 ? void 0 : _selectedTransport$tr4.value,

      /* $FlowFixMe : proposal has transport in this step */
      formattedValue: selectedTransport === null || selectedTransport === void 0 ? void 0 : (_selectedTransport$tr5 = selectedTransport.transportInfo) === null || _selectedTransport$tr5 === void 0 ? void 0 : (_selectedTransport$tr6 = _selectedTransport$tr5.totalDifferentialPrice) === null || _selectedTransport$tr6 === void 0 ? void 0 : _selectedTransport$tr6.formattedValue
    } : undefined
    /* $FlowFixMe : proposal has transport in this step */
    ,
    transport: selectedTransport
  }))), AdditionalTransportsList_jsx(DoubleColLayer["c" /* EndCol */], null, isTablet && AdditionalTransportsList_jsx("div", {
    className: "mb-px30 text-turquoise text-md font-bold"
  }, (alternativeTransports === null || alternativeTransports === void 0 ? void 0 : alternativeTransports.length) || 0, " ", getOthersDesktopLabel(isInbound, isPlane)), AdditionalTransportsList_jsx(Paginate["a" /* Paginate */], {
    seeMoreLabel: Object(src_i18n["g" /* t */])('booking.transport.additionalTransports.otherProposals'),
    iterationNumber: iterationNumber,
    setForceInitialShowingItemsNumber: setForceInitialShowingItemsNumber,
    forceInitialShowingItemsNumber: !isTablet ? forceInitialShowingItemsNumber : 0
  }, alternativeTransports === null || alternativeTransports === void 0 ? void 0 : alternativeTransports.map(function (transport, index) {
    return AdditionalTransportsList_jsx(PlaneTicket_PlaneTicket, {
      button: {
        color: colors["a" /* COLORS */].TURQUOISE,
        label: Object(src_i18n["g" /* t */])('booking.transport.planeTicket.CTASelectTransportLabel'),
        minWidth: '7rem',
        onClick: function onClick() {
          return saveSelectedFlights(transport === null || transport === void 0 ? void 0 : transport.transportInfo.id);
        }
      },
      className: "mb-px30",
      dataTestid: "AdditionalTransportOption",
      i18n: i18n,
      key: transport === null || transport === void 0 ? void 0 : transport.transportInfo.id,
      noBusinessClassAvailable: noBusinessClassAvailable,
      price: {
        /* $FlowFixMe : proposal has transport in this step */
        value: transport === null || transport === void 0 ? void 0 : transport.transportInfo.totalDifferentialPrice.value,

        /* $FlowFixMe : proposal has transport in this step */
        formattedValue: transport === null || transport === void 0 ? void 0 : transport.transportInfo.totalDifferentialPrice.formattedValue
      },
      proposalNumber: index + 1,
      tabIndex: index,
      transport: transport
    });
  }))))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/AdditionalTransportsWrapper.jsx
var AdditionalTransportsWrapper_jsx = react_default.a.createElement;













var TRANSPORT_COMPANIES_LOGOS = [{
  url: 'https://ns.clubmed.com/it/2018/be/transport/airfrance.png',
  alt: 'Air France'
}, {
  url: 'https://ns.clubmed.com/it/2018/be/transport/flyemirates.png',
  alt: 'Fly Emirates'
}, {
  url: 'https://ns.clubmed.com/it/2018/be/transport/aircaraibes.png',
  alt: 'Air Caraïbes'
}, {
  alt: 'Singapore Airlines',
  url: 'https://ns.clubmed.com/it/2018/be/transport/singaporeairlines.png'
}, {
  url: 'https://ns.clubmed.com/it/2018/be/transport/qatarairways.png',
  alt: 'Qatar Airways'
}]; // hardcoded for now, there wasn't a compelling enough argument why this should be dynamic

var AdditionalTransportsWrapper_AdditionalTransportsWrapper = function AdditionalTransportsWrapper(_ref) {
  var alternativeTransports = _ref.alternativeTransports,
      i18n = _ref.i18n,
      isSelectedRecommended = _ref.isSelectedRecommended,
      onClose = _ref.onClose,
      onSubmit = _ref.onSubmit,
      selectedTransport = _ref.selectedTransport;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var error = Object(es["e" /* useSelector */])(booking_selector["g" /* getAdditionalTransportsError */]);
  var isLoading = Object(es["e" /* useSelector */])(booking_selector["s" /* getIsLoadingAdditionalTransports */]);
  var searchCriteriaInbound = Object(es["e" /* useSelector */])(booking_selector["y" /* getSearchCriteriaTransportsInbound */]); // searching for business class flight & receiving only economy class flights

  var noBusinessClassAvailability = (searchCriteriaInbound === null || searchCriteriaInbound === void 0 ? void 0 : searchCriteriaInbound.flightClass) === additionalTransports_constants["f" /* FLIGHT_CLASS_BUSINESS */] && !(alternativeTransports === null || alternativeTransports === void 0 ? void 0 : alternativeTransports.some(function (transport) {
    return transport.journey.travelSections.find(function (travelSection) {
      return travelSection.transport.class === additionalTransports_constants["f" /* FLIGHT_CLASS_BUSINESS */];
    });
  }));
  return AdditionalTransportsWrapper_jsx("div", {
    className: "mt-px30 relative z-1"
  }, isLoading && AdditionalTransportsWrapper_jsx(react["Fragment"], null, AdditionalTransportsWrapper_jsx(AsyncLoader["a" /* AsyncLoader */], {
    icon: icons["a" /* ICONS */].STANDALONE_MAGNIFYING_GLASS,
    iconSize: "3rem",
    label: Object(src_i18n["g" /* t */])('booking.transport.additionalTransports.loaderLabel'),
    style: {
      marginTop: '18vh'
    },
    theme: "labeled"
  }), AdditionalTransportsWrapper_jsx("div", {
    className: "m-auto mt-px30",
    style: {
      width: '12.5rem'
    }
  }, AdditionalTransportsWrapper_jsx(SliderHandler["a" /* SliderHandler */], {
    hasAutoplay: true,
    hasInfiniteScroll: true,
    hasLazyload: true,
    items: TRANSPORT_COMPANIES_LOGOS.map(function (medium) {
      return AdditionalTransportsWrapper_jsx("img", {
        alt: medium.alt,
        className: "w-full",
        key: medium.url,
        src: medium.url
      });
    })
  }, function (_ref2) {
    var itemsNode = _ref2.itemsNode;
    return itemsNode;
  }))), !isLoading && Object(lodash["isEmpty"])(error) && AdditionalTransportsWrapper_jsx(AdditionalTransportsList_AdditionalTransportsList, {
    alternativeTransports: alternativeTransports,
    appContext: appContext,
    i18n: i18n,
    isSelectedRecommended: isSelectedRecommended,
    noBusinessClassAvailable: noBusinessClassAvailability,
    onAddTransport: onSubmit,
    onClose: onClose,
    selectedTransport: selectedTransport
  }), !isLoading && !Object(lodash["isEmpty"])(error) && AdditionalTransportsWrapper_jsx(SiteContainer["a" /* SiteContainer */], null, AdditionalTransportsWrapper_jsx(Confirmation["a" /* Confirmation */], {
    status: "error",
    text: Object(src_i18n["g" /* t */])("booking.".concat(appContext.isCmta ? 'partners' : 'common.layer', ".unknownErrorDescription")),
    title: Object(src_i18n["g" /* t */])('booking.common.layer.unknownErrorTitle')
  })));
};
// EXTERNAL MODULE: ./src/client/store/toast/toast.actions.js
var toast_actions = __webpack_require__("7Z8V");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-feedback/FormFeedback.jsx
var FormFeedback = __webpack_require__("DwNm");

// EXTERNAL MODULE: ./src/client/components/widgets/be-transport-details/inner-transport-details/InnerTransportDetailsHeader.jsx
var InnerTransportDetailsHeader = __webpack_require__("iTz8");

// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/selection-wizard/TransportSelectionWizard.jsx

var TransportSelectionWizard_jsx = react_default.a.createElement;











var WIZARD_TABS = {
  LEFT: 'left',
  RIGHT: 'right'
};

var TransportSelectionWizard_TransportSelectionWizardComponent = function TransportSelectionWizardComponent(_ref, wizardRef) {
  var _selectedTransport$in, _flightProp$transport, _flightProp$arrival, _flightProp$departure, _flightProp$arrival2, _flightProp$departure2, _flightProp$arrival3, _flightProp$departure3, _flightProp$arrival4, _flightProp$departure4;

  var children = _ref.children,
      _ref$isInboundSelecte = _ref.isInboundSelected,
      isInboundSelected = _ref$isInboundSelecte === void 0 ? false : _ref$isInboundSelecte,
      selectedTransport = _ref.selectedTransport,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;

  var _useState = Object(react["useState"])(WIZARD_TABS.LEFT),
      activeTab = _useState[0],
      setActiveTab = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      displayOutboundError = _useState2[0],
      setDisplayOutboundError = _useState2[1];

  var flightProp = {};

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  Object(react["useEffect"])(function () {
    // reinitialize active tab when a search has been launched
    if (!isInboundSelected) {
      setActiveTab(WIZARD_TABS.LEFT);
    }
  }, [isInboundSelected]);

  var toggle = function toggle(tab) {
    setDisplayOutboundError(false);

    if (tab) {
      setActiveTab(tab);
    } else {
      var toActivate = activeTab === WIZARD_TABS.LEFT ? WIZARD_TABS.RIGHT : WIZARD_TABS.LEFT;
      setActiveTab(toActivate);
    }
  };

  var inactiveStyle = {
    backgroundColor: '#fcfcfc',
    borderColor: '#dfdfdf'
  };

  if (selectedTransport === null || selectedTransport === void 0 ? void 0 : (_selectedTransport$in = selectedTransport.inbound) === null || _selectedTransport$in === void 0 ? void 0 : _selectedTransport$in.journey) {
    var firstSection = selectedTransport.inbound.journey.travelSections[0];

    var _selectedTransport$in2 = selectedTransport.inbound.journey.travelSections.slice(-1),
        _selectedTransport$in3 = Object(slicedToArray["a" /* default */])(_selectedTransport$in2, 1),
        lastSection = _selectedTransport$in3[0];

    flightProp.departure = firstSection.departure;
    flightProp.arrival = lastSection.arrival;
    flightProp.transport = firstSection.transport;
  }

  if (isLoading) {
    return children({
      activeTab: activeTab,
      toggle: toggle
    });
  }

  var transportType = flightProp === null || flightProp === void 0 ? void 0 : (_flightProp$transport = flightProp.transport) === null || _flightProp$transport === void 0 ? void 0 : _flightProp$transport.type;
  var transportIcon = null;

  if (isDesktop) {
    var _selectedTransport$in4, _selectedTransport$ou;

    transportIcon = Object(transportUtils["l" /* getTransportIcon */])(selectedTransport === null || selectedTransport === void 0 ? void 0 : (_selectedTransport$in4 = selectedTransport.inbound) === null || _selectedTransport$in4 === void 0 ? void 0 : _selectedTransport$in4.journey, selectedTransport === null || selectedTransport === void 0 ? void 0 : (_selectedTransport$ou = selectedTransport.outboundList[0]) === null || _selectedTransport$ou === void 0 ? void 0 : _selectedTransport$ou.journey);
  }

  var isLeft = activeTab === WIZARD_TABS.LEFT;
  var isOutboundDisabled = isLeft && !isInboundSelected;
  return TransportSelectionWizard_jsx("div", {
    ref: wizardRef
  }, TransportSelectionWizard_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "md:my-px30"
  }, displayOutboundError && TransportSelectionWizard_jsx(FormFeedback["a" /* FormFeedback */], {
    isError: true,
    message: Object(src_i18n["g" /* t */])('booking.transport.additionalTransports.selectionInformation')
  }), TransportSelectionWizard_jsx("div", {
    className: classnames_default()('flex left-0 w-full z-3 mb-px15')
  }, TransportSelectionWizard_jsx(Button["a" /* Button */], {
    color: colors["a" /* COLORS */].GRAY,
    theme: "selectionWizard",
    className: "rounded-l-tiny w-1/2",
    onClick: function onClick() {
      return setActiveTab(WIZARD_TABS.LEFT);
    },
    enabled: isLeft,
    style: !isLeft ? inactiveStyle : {}
  }, TransportSelectionWizard_jsx(InnerTransportDetailsHeader["a" /* InnerTransportDetailsHeader */], {
    arrivalLabel: Object(labelUtils["a" /* capitalizeName */])((flightProp === null || flightProp === void 0 ? void 0 : (_flightProp$arrival = flightProp.arrival) === null || _flightProp$arrival === void 0 ? void 0 : _flightProp$arrival.airportLabel) || ''),
    departureLabel: Object(labelUtils["a" /* capitalizeName */])((flightProp === null || flightProp === void 0 ? void 0 : (_flightProp$departure = flightProp.departure) === null || _flightProp$departure === void 0 ? void 0 : _flightProp$departure.airportLabel) || ''),
    arrivalId: flightProp === null || flightProp === void 0 ? void 0 : (_flightProp$arrival2 = flightProp.arrival) === null || _flightProp$arrival2 === void 0 ? void 0 : _flightProp$arrival2.id,
    departureId: flightProp === null || flightProp === void 0 ? void 0 : (_flightProp$departure2 = flightProp.departure) === null || _flightProp$departure2 === void 0 ? void 0 : _flightProp$departure2.id,
    transportType: transportType,
    transportIcon: transportIcon,
    isSearchPage: true,
    isInbound: true
  })), TransportSelectionWizard_jsx(Button["a" /* Button */], {
    color: colors["a" /* COLORS */].GRAY,
    theme: "selectionWizard",
    className: classnames_default()('rounded-r-tiny border-l-0 w-1/2', {
      'text-gray-dark': isOutboundDisabled
    }),
    onClick: function onClick() {
      if (!isOutboundDisabled) {
        setActiveTab(WIZARD_TABS.RIGHT);
      } else {
        setDisplayOutboundError(true);
      }
    },
    enabled: !isLeft,
    style: isLeft ? inactiveStyle : {}
  }, TransportSelectionWizard_jsx(InnerTransportDetailsHeader["a" /* InnerTransportDetailsHeader */], {
    departureLabel: Object(labelUtils["a" /* capitalizeName */])((flightProp === null || flightProp === void 0 ? void 0 : (_flightProp$arrival3 = flightProp.arrival) === null || _flightProp$arrival3 === void 0 ? void 0 : _flightProp$arrival3.airportLabel) || ''),
    arrivalLabel: Object(labelUtils["a" /* capitalizeName */])((flightProp === null || flightProp === void 0 ? void 0 : (_flightProp$departure3 = flightProp.departure) === null || _flightProp$departure3 === void 0 ? void 0 : _flightProp$departure3.airportLabel) || ''),
    departureId: flightProp === null || flightProp === void 0 ? void 0 : (_flightProp$arrival4 = flightProp.arrival) === null || _flightProp$arrival4 === void 0 ? void 0 : _flightProp$arrival4.id,
    arrivalId: flightProp === null || flightProp === void 0 ? void 0 : (_flightProp$departure4 = flightProp.departure) === null || _flightProp$departure4 === void 0 ? void 0 : _flightProp$departure4.id,
    transportType: transportType,
    transportIcon: transportIcon,
    isDisabled: isOutboundDisabled,
    isSearchPage: true
  })))), children({
    activeTab: activeTab,
    toggle: toggle
  }));
}; // $FlowFixMe


var TransportSelectionWizard = /*#__PURE__*/Object(react["forwardRef"])(TransportSelectionWizard_TransportSelectionWizardComponent);
// EXTERNAL MODULE: /opt/webapp/node_modules/shortid/index.js
var shortid = __webpack_require__("MIfU");
var shortid_default = /*#__PURE__*/__webpack_require__.n(shortid);

// EXTERNAL MODULE: ./src/client/components/frameworks/drop-down/DropDown.jsx + 1 modules
var DropDown = __webpack_require__("U6GL");

// EXTERNAL MODULE: ./src/client/components/widgets/filter-option/FilterOption.jsx + 2 modules
var FilterOption = __webpack_require__("bmBr");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// CONCATENATED MODULE: ./src/client/components/widgets/transport-filters/departure-arrival-chooser/DepartureArrivalChooser.jsx

var DepartureArrivalChooser_jsx = react_default.a.createElement;










var LEAVE_FILTER_TYPE = 'leave';
var ARRIVE_FILTER_TYPE = 'arrive';
var DepartureArrivalChooser_DepartureArrivalChooser = function DepartureArrivalChooser(_ref) {
  var departureArrivalOptions = _ref.departureArrivalOptions,
      i18n = _ref.i18n,
      inbound = _ref.inbound,
      onClickItem = _ref.onClickItem,
      selectedOptions = _ref.selectedOptions;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var _useState = Object(react["useState"])(LEAVE_FILTER_TYPE),
      filterType = _useState[0],
      setFilterType = _useState[1];

  var _useState2 = Object(react["useState"])(departureArrivalOptions.filter(function (option) {
    return option.value.group === filterType;
  })),
      currentFilters = _useState2[0],
      setCurrentFilters = _useState2[1];

  var isOptionActive = function isOptionActive(option) {
    return selectedOptions.includes(option.value);
  };

  var changeFilters = function changeFilters(newFilterType) {
    setFilterType(newFilterType);
    setCurrentFilters(departureArrivalOptions.filter(function (option) {
      return option.value.group === newFilterType;
    }));
  };

  var altType = filterType === LEAVE_FILTER_TYPE ? ARRIVE_FILTER_TYPE : LEAVE_FILTER_TYPE;
  return DepartureArrivalChooser_jsx("div", {
    className: "sm:flex sm:items-center w-full"
  }, DepartureArrivalChooser_jsx("div", {
    className: "px-px15 sm:px-0 mb-px10 sm:mb-0",
    style: {
      minWidth: '15rem'
    }
  }, DepartureArrivalChooser_jsx(DropDown["a" /* DropDown */], {
    hasCloseOnClick: true,
    renderTrigger: function renderTrigger(handler) {
      return DepartureArrivalChooser_jsx("button", {
        className: "cursor-pointer flex items-center reset-button text-base",
        onClick: handler,
        type: "button"
      }, DepartureArrivalChooser_jsx(TemplateString["a" /* TemplateString */], {
        template: inbound ? i18n.inboundLabel : i18n.outboundLabel,
        values: {
          label: Object(lodash["get"])(i18n, filterType)
        },
        valuesClassName: {
          label: 'font-bold text-blue'
        }
      }), DepartureArrivalChooser_jsx(Icon["a" /* Icon */], {
        className: "rtl:ml-px5",
        color: colors["a" /* COLORS */].BLUE,
        name: icons["a" /* ICONS */].SELECT,
        width: "0.625rem"
      }));
    }
  }, function () {
    return DepartureArrivalChooser_jsx("button", {
      className: "py-px5 reset-button rtl:text-right w-full",
      onClick: function onClick(e) {
        e.stopPropagation();
        changeFilters(altType);
      },
      type: "button"
    }, i18n[altType]);
  })), (currentFilters === null || currentFilters === void 0 ? void 0 : currentFilters.length) && DepartureArrivalChooser_jsx("div", {
    className: "flex-1 rtl:sm:ml-px50"
  }, DepartureArrivalChooser_jsx("ul", {
    className: "sm:flex sm:flex-wrap -m-px5 reset-list"
  }, currentFilters.map(function (filter) {
    return DepartureArrivalChooser_jsx("li", {
      className: "p-px5 sm:w-1/4 md:w-1/6",
      key: filter.id
    }, DepartureArrivalChooser_jsx(FilterOption["a" /* FilterOption */], Object(esm_extends["a" /* default */])({}, filter, {
      className: isTablet ? 'h-full text-blue shadow-diffuse w-full' : '',
      isButton: isTablet,
      isDisabled: !filter.matched,
      isSelected: isOptionActive(filter),
      label: Object(labelUtils["a" /* capitalizeName */])(filter.label),
      onChange: function onChange() {
        onClickItem(filter);
      }
    })));
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/transport-filters/TransportFilters.utils.js



var TransportFilters_utils_jsx = react_default.a.createElement;

function TransportFilters_utils_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function TransportFilters_utils_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      TransportFilters_utils_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      TransportFilters_utils_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}








function timeRangeValueToString(_ref) {
  var hours = _ref.hours,
      minutes = _ref.minutes;
  return "".concat(hours, ":").concat(minutes < 10 ? "0".concat(minutes) : minutes);
}

function geIntValue(time) {
  return time.hours * 60 + time.minutes;
}

function timeRangeToString(time) {
  return "".concat(timeRangeValueToString(time.start), " - ").concat(timeRangeValueToString(time.end));
}

function isTimeBefore(time, refTime) {
  return geIntValue(time) < geIntValue(refTime);
}

function isTimeAfter(time, refTime) {
  return geIntValue(time) >= geIntValue(refTime);
}

function isTimeInRange(time, timeRange) {
  var _time$split = time.split(':'),
      _time$split2 = Object(slicedToArray["a" /* default */])(_time$split, 2),
      hours = _time$split2[0],
      minutes = _time$split2[1];

  var timeRangeValue = {
    hours: parseInt(hours, 10),
    minutes: parseInt(minutes, 10)
  };
  return isTimeAfter(timeRangeValue, timeRange.start) && isTimeBefore(timeRangeValue, timeRange.end);
}

var applyFilterCompanies = function applyFilterCompanies(transports, filters) {
  var result = transports.filter(function (alternativeJourney) {
    if (filters.companies && filters.companies.length > 0) {
      return alternativeJourney.journey.travelSections.some(function (section) {
        return filters.companies.includes(section.transport.companyOperator.id);
      });
    }

    return true;
  });
  return result;
};

var applyFilterLayovers = function applyFilterLayovers(transports, filters) {
  var result = transports.filter(function (alternativeJourney) {
    if (filters.layovers && filters.layovers.length > 0) {
      var nbLayovers = alternativeJourney.journey.travelSections.length - 1;
      return filters.layovers.includes(nbLayovers);
    }

    return true;
  });
  return result;
};

var TransportFilters_utils_applyFilterConnectionCities = function applyFilterConnectionCities(transports, filters) {
  var result = transports.filter(function (alternativeJourney) {
    if (filters.connectionCities && filters.connectionCities.length > 0) {
      var hasLayovers = alternativeJourney.journey.travelSections.length - 1 > 0;

      if (!hasLayovers) {
        return false;
      }

      var transportConnectionCities = alternativeJourney.journey.travelSections.map(function (section) {
        return section.arrival.id;
      }); // the last one is the destination, not a connection

      transportConnectionCities.pop();
      return !Object(lodash["isEmpty"])(Object(lodash["intersection"])(transportConnectionCities, filters.connectionCities));
    }

    return true;
  });
  return result;
};

var applyFilterDepartureArrival = function applyFilterDepartureArrival(transports, filters) {
  var result = transports.filter(function (alternativeJourney) {
    if (filters.departureArrival && filters.departureArrival.length > 0) {
      return filters.departureArrival.some(function (filterValue) {
        var section = filterValue.group === 'leave' ? alternativeJourney.journey.travelSections[0] : alternativeJourney.journey.travelSections[alternativeJourney.journey.travelSections.length - 1];
        var transportDate = section[filterValue.group === 'leave' ? 'departure' : 'arrival'];
        return isTimeInRange(transportDate.time, filterValue);
      });
    }

    return true;
  });
  return result;
};

var TransportFilters_utils_applyFilter = function applyFilter(transports, filters) {
  var filteredTransports = applyFilterCompanies(transports, filters);
  filteredTransports = applyFilterLayovers(filteredTransports, filters);
  filteredTransports = TransportFilters_utils_applyFilterConnectionCities(filteredTransports, filters);
  filteredTransports = applyFilterDepartureArrival(filteredTransports, filters);
  return filteredTransports;
};

var TransportFilters_utils_reduceWithNbOccurences = function reduceWithNbOccurences(options) {
  var groupCount = Object(lodash["countBy"])(options, 'value');
  return Object(lodash["uniqBy"])(options, 'value').map(function (opt) {
    return TransportFilters_utils_objectSpread(TransportFilters_utils_objectSpread({}, opt), {}, {
      matched: groupCount[opt.value]
    });
  });
};

var TransportFilters_utils_buildCompaniesOptions = function buildCompaniesOptions(transports) {
  var allOptions = transports.reduce(function (options, transport) {
    transport.journey.travelSections.forEach(function (section) {
      options.push({
        id: shortid_default.a.generate(),
        imageSrc: section.transport.companyOperator.logo,
        label: section.transport.companyOperator.label,
        matched: 0,
        value: section.transport.companyOperator.id
      });
    });
    return options;
  }, []);
  return TransportFilters_utils_reduceWithNbOccurences(allOptions);
};
var TransportFilters_utils_buildLayoversOptions = function buildLayoversOptions(transports) {
  var iconSize = '3rem';
  var allOptions = transports.reduce(function (options, transport) {
    var nbLayovers = transport.journey.travelSections.length - 1;

    switch (nbLayovers) {
      case 0:
        options.push({
          iconName: additionalTransports_constants["o" /* ZERO_LAYOVERS_ICON */],
          iconSize: iconSize,
          id: shortid_default.a.generate(),
          isIconNotSquare: true,
          label: Object(src_i18n["g" /* t */])('filters.layovers.direct'),
          matched: 0,
          value: nbLayovers
        });
        break;

      case 1:
        options.push({
          iconName: additionalTransports_constants["l" /* ONE_LAYOVERS_ICON */],
          iconSize: iconSize,
          id: shortid_default.a.generate(),
          isIconNotSquare: true,
          label: "".concat(nbLayovers, " ").concat(Object(src_i18n["g" /* t */])('filters.layovers.stop.label_1')),
          matched: 0,
          value: nbLayovers
        });
        break;

      default:
        options.push({
          iconName: additionalTransports_constants["n" /* TWO_LAYOVERS_ICON */],
          iconSize: iconSize,
          id: shortid_default.a.generate(),
          isIconNotSquare: true,
          label: "".concat(nbLayovers, " ").concat(Object(src_i18n["g" /* t */])('filters.layovers.stop.label_n')),
          matched: 0,
          value: nbLayovers
        });
        break;
    }

    return options;
  }, []);
  return TransportFilters_utils_reduceWithNbOccurences(allOptions);
};
var TransportFilters_utils_buildConnectionCitiesOptions = function buildConnectionCitiesOptions(transports) {
  var allOptions = transports.reduce(function (options, transport) {
    transport.journey.travelSections.forEach(function (section, index) {
      var isLastSection = transport.journey.travelSections.length - 1 === index;

      if (!isLastSection) {
        options.push({
          id: shortid_default.a.generate(),
          label: section.arrival.airportLabel,
          matched: 0,
          subLabel: section.arrival.id,
          value: section.arrival.id
        });
      }
    });
    return options;
  }, []);
  return TransportFilters_utils_reduceWithNbOccurences(allOptions);
};
var TransportFilters_utils_buildDepartureArrivalOptions = function buildDepartureArrivalOptions(transports, i18n) {
  var timeRanges = Object(lodash["get"])(i18n, 'filters.departureArrival.timeRanges') || [];
  var departureArrivalOptionGroups = ['leave', 'arrive'];
  return departureArrivalOptionGroups.reduce(function (allOptions, group) {
    return [].concat(Object(toConsumableArray["a" /* default */])(allOptions), Object(toConsumableArray["a" /* default */])(timeRanges.map(function (timeRange) {
      var value = TransportFilters_utils_objectSpread({
        group: group
      }, timeRange);

      return {
        iconName: timeRange.icon,
        id: shortid_default.a.generate(),
        label: timeRange.label,
        matched: applyFilterDepartureArrival(transports, {
          departureArrival: [value]
        }).length,
        subLabel: timeRangeToString(timeRange),
        value: value
      };
    })));
  }, []).filter(function (_ref2) {
    var matched = _ref2.matched;
    return matched;
  });
};
var TransportFilters_utils_buildFilters = function buildFilters(transports, i18n, inbound) {
  var companiesOptions = TransportFilters_utils_buildCompaniesOptions(transports);
  var layoversOptions = TransportFilters_utils_buildLayoversOptions(transports);
  var connectionCitiesOptions = TransportFilters_utils_buildConnectionCitiesOptions(transports);
  var departureArrivalOptions = TransportFilters_utils_buildDepartureArrivalOptions(transports, i18n);
  return [{
    id: 'companies',
    label: Object(src_i18n["g" /* t */])('filters.companiesCategoryTitle'),
    options: companiesOptions
  }, {
    id: 'layovers',
    label: Object(src_i18n["g" /* t */])('filters.layovers.categoryTitle'),
    options: layoversOptions
  }, {
    id: 'connectionCities',
    label: Object(src_i18n["g" /* t */])('filters.layovers.stop.connectionCities'),
    options: connectionCitiesOptions
  }, {
    id: 'departureArrival',
    label: Object(src_i18n["g" /* t */])('filters.departureArrival.categoryTitle'),
    options: departureArrivalOptions,
    customRender: function customRender(options, selectedOptions, onClick) {
      return TransportFilters_utils_jsx(DepartureArrivalChooser_DepartureArrivalChooser, {
        departureArrivalOptions: options,
        onClickItem: onClick,
        i18n: Object(lodash["get"])(i18n, 'filters.departureArrival'),
        inbound: inbound,
        selectedOptions: selectedOptions
      });
    }
  }];
};
// EXTERNAL MODULE: ./src/client/components/widgets/filters-bar/FiltersBar.jsx + 3 modules
var FiltersBar = __webpack_require__("jFIS");

// CONCATENATED MODULE: ./src/client/components/widgets/filters/Filters.jsx
var Filters_jsx = react_default.a.createElement;




var Filters_Filters = function Filters(_ref) {
  var applyFilter = _ref.applyFilter,
      caption = _ref.caption,
      children = _ref.children,
      className = _ref.className,
      _ref$dataTestid = _ref.dataTestid,
      dataTestid = _ref$dataTestid === void 0 ? 'Filters' : _ref$dataTestid,
      _ref$filters = _ref.filters,
      filters = _ref$filters === void 0 ? [] : _ref$filters,
      isLoading = _ref.isLoading,
      items = _ref.items,
      notes = _ref.notes,
      onClick = _ref.onClick,
      _ref$portalName = _ref.portalName,
      portalName = _ref$portalName === void 0 ? 'Filters-portal' : _ref$portalName;

  var _useState = Object(react["useState"])({}),
      value = _useState[0],
      setValue = _useState[1];

  var _useState2 = Object(react["useState"])(items),
      filteredItems = _useState2[0],
      setFilteredItems = _useState2[1];

  Object(react["useEffect"])(function () {
    // reset filtered list and filter when the initial items changes
    setValue({});
    setFilteredItems(items);
  }, [items]);

  if (isLoading || Object(lodash["isEmpty"])(filters)) {
    return children({
      filteredItems: filteredItems
    });
  }

  return Filters_jsx(react["Fragment"], null, Filters_jsx(FiltersBar["a" /* FiltersBar */], {
    caption: caption,
    className: className,
    dataTestid: dataTestid,
    filters: filters,
    onChange: function onChange(name, options) {
      if (value) {
        value[name] = options;
        setValue(value);
        setFilteredItems(applyFilter(items, value));
      }
    },
    onClick: onClick,
    portalName: portalName
  }), Filters_jsx(SiteContainer["a" /* SiteContainer */], null, notes && Filters_jsx("div", {
    className: "mt-px15 text-sm text-gray"
  }, notes), children({
    filteredItems: filteredItems
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/transport-filters/TransportFilters.jsx


var TransportFilters_jsx = react_default.a.createElement;







var TransportFilters_TransportFilters = function TransportFilters(_ref) {
  var isInbound = _ref.isInbound,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["isInbound"]);

  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var isComparatorView = location.pathname === '/comparator';
  return TransportFilters_jsx(Filters_Filters, Object(esm_extends["a" /* default */])({}, rest, {
    applyFilter: TransportFilters_utils_applyFilter,
    caption: Object(src_i18n["g" /* t */])('filters.label'),
    className: "relative z-1",
    dataTestid: "TransportFilters",
    notes: Object(src_i18n["g" /* t */])('booking.transport.luggageInformation'),
    onClick: function onClick(name) {
      AdditionalTransports_tracking_trackClickFilter(appContext, name, isInbound ? FLIGHT.INBOUND : FLIGHT.OUTBOUND, isComparatorView);
    },
    portalName: "TransportFilterOptions"
  }));
};
// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/layers/LayerIcons.jsx
var LayerIcons_jsx = react_default.a.createElement;



var LayerIcons_LayerIcons = function LayerIcons() {
  return LayerIcons_jsx("div", {
    className: "absolute bg-gray-lighter inset-0 pointer-events-none text-gray-light z-0"
  }, LayerIcons_jsx("div", {
    className: "bottom-0 fixed left-0 sm:mb-0 -translate-x-50",
    style: {
      marginBottom: -100
    }
  }, LayerIcons_jsx(Icon["a" /* Icon */], {
    isNotSquare: true,
    name: icons["a" /* ICONS */].PLANE_AND_CIRCLE,
    rotation: 180,
    width: "25rem"
  })), LayerIcons_jsx("div", {
    className: "fixed sm:mt-0 right-0 top-0 translate-x-50",
    style: {
      marginTop: -100
    }
  }, LayerIcons_jsx(Icon["a" /* Icon */], {
    isNotSquare: true,
    name: icons["a" /* ICONS */].PLANE_AND_CIRCLE,
    width: "25rem"
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/layers/AdditionalTransportsLayerUtils.js

var AdditionalTransportsLayerUtils_isTrainOnly = function isTrainOnly(alternativeTransports) {
  var allSections = alternativeTransports.reduce(function (sections, alternativeTransport) {
    return sections.concat(alternativeTransport.journey.travelSections);
  }, []);
  return Object(lodash["every"])(allSections, ['transport.type', 'TRAIN']);
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/layers/DesktopLayer.jsx

var DesktopLayer_jsx = react_default.a.createElement;






















var alternativeTransportToTransport = function alternativeTransportToTransport(alternativeTransport) {
  return {
    inbound: alternativeTransport.inbound.journey,
    outbound: alternativeTransport.outboundList[0].journey
  };
};
var DesktopLayer_DesktopLayer = function DesktopLayer(_ref) {
  var proposal = _ref.proposal,
      resort = _ref.resort,
      onClose = _ref.onClose,
      onSubmit = _ref.onSubmit,
      i18n = _ref.i18n,
      errorTitle = _ref.errorTitle;
  var dispatch = Object(es["d" /* useDispatch */])();
  var layerRef = Object(react["useRef"])(null);
  var wizardRef = Object(react["useRef"])(null);

  var _useSelector = Object(es["e" /* useSelector */])(booking_selector["f" /* getAdditionalTransports */]),
      alternativeTransports = _useSelector.alternativeTransports,
      selectedTransport = _useSelector.selectedTransport,
      selectedTransportId = _useSelector.selectedTransportId;

  var isLoading = Object(es["e" /* useSelector */])(booking_selector["s" /* getIsLoadingAdditionalTransports */]);
  var inboundList = alternativeTransports ? alternativeTransports.map(function (_ref2) {
    var inbound = _ref2.inbound;
    return inbound;
  }) : [];
  var hideBlock = isLoading || !!errorTitle || !(inboundList === null || inboundList === void 0 ? void 0 : inboundList.length);
  var isSelectedRecommended = !hideBlock && selectedTransport && selectedTransport.inbound && Object(proposalUtils["y" /* isRecommendedTransport */])(alternativeTransportToTransport(selectedTransport), proposal.id);

  var _useState = Object(react["useState"])(true),
      shouldDisplaySearchEngine = _useState[0],
      setShouldDisplaySearchEngine = _useState[1];

  var layerTitle = Object(src_i18n["g" /* t */])('booking.transport.additionalTransports.layerTitle');

  var getOutboundSelection = function getOutboundSelection(isSelected) {
    var outboundList = Object(toConsumableArray["a" /* default */])(selectedTransport === null || selectedTransport === void 0 ? void 0 : selectedTransport.outboundList);

    var outbound = outboundList.shift();

    if (isSelected) {
      return outbound;
    }

    return outboundList;
  };

  return DesktopLayer_jsx(Layer["b" /* Layer */], {
    ariaLabel: layerTitle,
    ariaLabelledby: constants["e" /* ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP */],
    buttonLeft: {
      iconName: icons["a" /* ICONS */].LEFT_ARROW,
      label: Object(src_i18n["g" /* t */])('common.backNavigation'),
      onClick: onClose
    },
    closeLabel: Object(src_i18n["g" /* t */])('common.close'),
    hasContainerHeader: true,
    header: DesktopLayer_jsx(LayerHeaderProposal["a" /* LayerHeaderProposal */], {
      id: constants["e" /* ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP */],
      layerTitle: layerTitle,
      proposal: proposal,
      totalPrice: Object(src_i18n["g" /* t */])('booking.transport.additionalTransports.totalPrice')
    }),
    onClose: onClose,
    ref: layerRef
  }, DesktopLayer_jsx(LayerIcons_LayerIcons, null), shouldDisplaySearchEngine && !isLoading && DesktopLayer_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "my-px30"
  }, DesktopLayer_jsx(TransportsSearchEngine_TransportsSearchEngine, {
    proposal: proposal
  })), !!errorTitle && !isLoading && DesktopLayer_jsx(SiteContainer["a" /* SiteContainer */], null, DesktopLayer_jsx(Title["a" /* Title */], {
    className: "mx-px25 mt-px30",
    theme: "title-sans-4"
  }, errorTitle)), DesktopLayer_jsx(TransportSelectionWizard, {
    isInboundSelected: !!selectedTransportId,
    isLoading: hideBlock,
    ref: wizardRef,
    selectedTransport: selectedTransport
  }, function (_ref3) {
    var activeTab = _ref3.activeTab,
        toggle = _ref3.toggle;
    var isInbound = activeTab === WIZARD_TABS.LEFT;

    var handleSubmit = function handleSubmit(transportId) {
      if (isInbound) {
        Object(scrollToElement["b" /* scrollToRef */])(layerRef.current, -Layer["a" /* LAYER_HEADER_HEIGHT */], wizardRef.current);
        dispatch(Object(toast_actions["e" /* showTemporaryToast */])({
          className: 'font-normal text-initial',
          color: colors["a" /* COLORS */].EMERALD,
          style: {
            fontWeight: 'normal',
            top: 94,
            width: 370
          },
          toastLabel: Object(src_i18n["g" /* t */])('booking.transport.additionalTransports.inboundConfirmation.outboundSelection')
        }));
        dispatch({
          type: additionalTransports_action["j" /* UPDATE_SELECTED_TRANSPORT */],
          payload: {
            selectedTransportId: transportId
          }
        });
        toggle();
      } else {
        onSubmit(transportId);
      }
    };

    var currentTransport = isInbound ? selectedTransport === null || selectedTransport === void 0 ? void 0 : selectedTransport.inbound : getOutboundSelection(true);
    var currentAlternativeTransports = isInbound ? inboundList : getOutboundSelection(false);

    if (!isLoading && currentAlternativeTransports.length !== 0) {
      setShouldDisplaySearchEngine(!AdditionalTransportsLayerUtils_isTrainOnly(currentAlternativeTransports));
    }

    var filters = TransportFilters_utils_buildFilters(currentAlternativeTransports, i18n, isInbound);
    return DesktopLayer_jsx(react["Fragment"], null, DesktopLayer_jsx(TransportFilters_TransportFilters, {
      filters: filters,
      isInbound: isInbound,
      isLoading: hideBlock,
      items: currentAlternativeTransports
    }, function (_ref4) {
      var filteredItems = _ref4.filteredItems;
      return DesktopLayer_jsx(AdditionalTransportsWrapper_AdditionalTransportsWrapper, {
        alternativeTransports: filteredItems,
        i18n: i18n,
        isSelectedRecommended: isSelectedRecommended,
        onClose: onClose,
        onSubmit: handleSubmit,
        resort: resort,
        selectedTransport: currentTransport
      });
    }));
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.jsx
var Portal = __webpack_require__("3uBn");

// CONCATENATED MODULE: ./src/client/components/widgets/additional-transports/layers/MobileLayer.jsx

var MobileLayer_jsx = react_default.a.createElement;
























var MobileLayer_MobileLayer = function MobileLayer(_ref) {
  var proposal = _ref.proposal,
      resort = _ref.resort,
      onClose = _ref.onClose,
      onSubmit = _ref.onSubmit,
      i18n = _ref.i18n,
      errorTitle = _ref.errorTitle;
  var dispatch = Object(es["d" /* useDispatch */])();

  var _useSelector = Object(es["e" /* useSelector */])(booking_selector["f" /* getAdditionalTransports */]),
      alternativeTransports = _useSelector.alternativeTransports,
      selectedTransport = _useSelector.selectedTransport,
      selectedTransportId = _useSelector.selectedTransportId;

  var isLoading = Object(es["e" /* useSelector */])(booking_selector["s" /* getIsLoadingAdditionalTransports */]);
  var inboundList = alternativeTransports ? alternativeTransports.map(function (_ref2) {
    var inbound = _ref2.inbound;
    return inbound;
  }) : [];
  var hideBlock = isLoading || !!errorTitle || !(inboundList === null || inboundList === void 0 ? void 0 : inboundList.length);
  var isSelectedRecommended = !hideBlock && selectedTransport && selectedTransport.inbound && Object(proposalUtils["y" /* isRecommendedTransport */])(alternativeTransportToTransport(selectedTransport), proposal.id);

  var _useState = Object(react["useState"])(true),
      shouldDisplaySearchEngine = _useState[0],
      setShouldDisplaySearchEngine = _useState[1];

  var layerTitle = Object(src_i18n["g" /* t */])('booking.transport.additionalTransports.layerTitle');

  var getOutboundSelection = function getOutboundSelection(isSelected) {
    var outboundList = Object(toConsumableArray["a" /* default */])(selectedTransport === null || selectedTransport === void 0 ? void 0 : selectedTransport.outboundList);

    var outbound = outboundList.shift();

    if (isSelected) {
      return outbound;
    }

    return outboundList;
  };

  return MobileLayer_jsx(Portal["a" /* default */], null, MobileLayer_jsx(Layer["b" /* Layer */], {
    ariaLabel: layerTitle,
    ariaLabelledby: constants["f" /* ID_LAYER_HEADER__BE__TRANSPORTS_MOBILE */],
    buttonLeft: {
      label: Object(src_i18n["g" /* t */])('common.backNavigation'),
      iconName: icons["a" /* ICONS */].LEFT_ARROW,
      onClick: onClose
    },
    closeLabel: Object(src_i18n["g" /* t */])('common.close'),
    hasContainerHeader: true,
    header: MobileLayer_jsx(LayerHeaderProposal["a" /* LayerHeaderProposal */], {
      id: constants["f" /* ID_LAYER_HEADER__BE__TRANSPORTS_MOBILE */],
      proposal: proposal,
      layerTitle: layerTitle,
      totalPrice: Object(src_i18n["g" /* t */])('booking.transport.additionalTransports.totalPrice')
    }),
    onClose: onClose
  }, MobileLayer_jsx(LayerIcons_LayerIcons, null), shouldDisplaySearchEngine && !isLoading && MobileLayer_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "my-px30"
  }, MobileLayer_jsx(TransportsSearchEngine_TransportsSearchEngine, {
    proposal: proposal
  })), MobileLayer_jsx(TransportSelectionWizard, {
    isInboundSelected: !!selectedTransportId,
    isLoading: hideBlock,
    selectedTransport: selectedTransport
  }, function (_ref3) {
    var activeTab = _ref3.activeTab,
        toggle = _ref3.toggle;
    var isInbound = activeTab === WIZARD_TABS.LEFT;

    var handleSubmit = function handleSubmit(transportId) {
      if (isInbound) {
        Object(scrollToElement["a" /* scrollToElement */])('[data-testid="SiteContainer"]', 200);
        dispatch(Object(toast_actions["e" /* showTemporaryToast */])({
          className: 'font-normal text-initial',
          color: colors["a" /* COLORS */].EMERALD,
          style: {
            fontWeight: 'normal',
            right: -30,
            top: 94,
            width: 358
          },
          toastLabel: Object(src_i18n["g" /* t */])('booking.transport.additionalTransports.inboundConfirmation.outboundSelection')
        }));
        dispatch({
          type: additionalTransports_action["j" /* UPDATE_SELECTED_TRANSPORT */],
          payload: {
            selectedTransportId: transportId
          }
        });
        toggle();
      } else {
        onSubmit(transportId);
      }
    };

    var currentTransport = isInbound ? selectedTransport === null || selectedTransport === void 0 ? void 0 : selectedTransport.inbound : getOutboundSelection(true);
    var currentAlternativeTransports = isInbound ? inboundList : getOutboundSelection(false);

    if (!isLoading && currentAlternativeTransports.length !== 0) {
      setShouldDisplaySearchEngine(!AdditionalTransportsLayerUtils_isTrainOnly(currentAlternativeTransports));
    }

    var filters = TransportFilters_utils_buildFilters(currentAlternativeTransports, i18n, isInbound);
    return MobileLayer_jsx(react["Fragment"], null, errorTitle && !isLoading && MobileLayer_jsx(Title["a" /* Title */], {
      className: "mx-px25 mt-px30",
      theme: "title-sans-4"
    }, errorTitle), MobileLayer_jsx(TransportFilters_TransportFilters, {
      filters: filters,
      isInbound: isInbound,
      isLoading: hideBlock,
      items: currentAlternativeTransports
    }, function (_ref4) {
      var filteredItems = _ref4.filteredItems;
      return MobileLayer_jsx(AdditionalTransportsWrapper_AdditionalTransportsWrapper, {
        alternativeTransports: filteredItems,
        i18n: i18n,
        isSelectedRecommended: isSelectedRecommended,
        onClose: onClose,
        onSubmit: handleSubmit,
        resort: resort,
        selectedTransport: currentTransport
      });
    }));
  })));
};
// CONCATENATED MODULE: ./src/client/views/booking/transport/more-transports/MoreTransports.jsx
var MoreTransports_jsx = react_default.a.createElement;

/**
 * * More transports modal [find transport page]
 */









var MoreTransports_MoreTransports = function MoreTransports(_ref) {
  var proposal = _ref.proposal,
      resort = _ref.resort,
      onCloseLayer = _ref.onCloseLayer,
      _ref$onSubmit = _ref.onSubmit,
      onSubmit = _ref$onSubmit === void 0 ? function (transportId) {
    return onCloseLayer(true, transportId);
  } : _ref$onSubmit,
      i18n = _ref.i18n;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var error = Object(es["e" /* useSelector */])(booking_selector["g" /* getAdditionalTransportsError */]);

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isTablet = _useContext.isTablet;

  var dispatch = Object(es["d" /* useDispatch */])();
  Object(react["useEffect"])(function () {
    dispatch(Object(additionalTransports_action["l" /* fetchAdditionalTransports */])({
      proposal: proposal,
      appContext: appContext
    }));
    return function () {
      dispatch(Object(additionalTransports_action["k" /* clearAdditionalTransports */])());
    };
  }, [proposal.id]);
  var errorTitle = error ? Object(src_i18n["g" /* t */])('booking.transport.additionalTransports.unknownErrorHeaderTitle') : undefined;

  if (!isTablet) {
    return MoreTransports_jsx(MobileLayer_MobileLayer, {
      onClose: function onClose(proposalId) {
        return onCloseLayer(false, proposalId);
      },
      onSubmit: onSubmit,
      proposal: proposal,
      resort: resort,
      i18n: i18n,
      errorTitle: errorTitle
    });
  }

  return MoreTransports_jsx(DesktopLayer_DesktopLayer, {
    onClose: function onClose(proposalId) {
      return onCloseLayer(false, proposalId);
    },
    onSubmit: onSubmit,
    proposal: proposal,
    resort: resort,
    i18n: i18n,
    errorTitle: errorTitle
  });
};

/***/ }),

/***/ "De8U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlternativePackages; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("uDfI");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("sRdV");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _paid_service_PaidService_jsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("o8kQ");
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("MWZw");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("UCZK");
/* harmony import */ var _store_booking_booking_selector__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("uL19");
/* harmony import */ var _AlternativePackageToolTip__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("bn3Y");


var _MAPPING_PACKAGE_INFO;

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;










var _constants$PACKAGES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].PACKAGES,
    JOYVIEW_ROOM_ONLY = _constants$PACKAGES.JOYVIEW_ROOM_ONLY,
    JOYVIEW_ALL_INCLUSIVE = _constants$PACKAGES.JOYVIEW_ALL_INCLUSIVE,
    JOYVIEW_FOOD_AND_BEVERAGES = _constants$PACKAGES.JOYVIEW_FOOD_AND_BEVERAGES;
var MAPPING_PACKAGE_INFOS = (_MAPPING_PACKAGE_INFO = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_MAPPING_PACKAGE_INFO, JOYVIEW_ALL_INCLUSIVE, {
  title: 'PAIBlockTitle',
  icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].ALL_INCLUSIVE,
  color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_8__[/* COLORS */ "a"].BLUE,
  imageUrl: 'https://ns.clubmed.com/it/2019/be/joyview/Images.jpg',
  labelGA: 'AllInclusive'
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_MAPPING_PACKAGE_INFO, JOYVIEW_FOOD_AND_BEVERAGES, {
  title: 'FFBBlockTitle',
  icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].DISHES,
  color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_8__[/* COLORS */ "a"].ORANGE,
  imageUrl: 'https://ns.clubmed.com/it/2019/be/joyview/FFB-JoyVIew.png',
  labelGA: 'FoodBeverage'
}), _MAPPING_PACKAGE_INFO);

var getCtaType = function getCtaType(selectedProposal, packageId, basePackage) {
  if (!selectedProposal.alternativePackages || basePackage === packageId) {
    return 'included';
  }

  if (selectedProposal.packageId === packageId) {
    return 'remove';
  }

  return 'add';
};

var findAlternativeProposalByPackage = function findAlternativeProposalByPackage(alternativePackages, packageId) {
  return alternativePackages.find(function (bundle) {
    return bundle.packageId === packageId;
  });
};

var AlternativePackages = function AlternativePackages(_ref) {
  var _selectedProposal$pac;

  var selectedProposal = _ref.selectedProposal,
      selectProposal = _ref.selectProposal,
      i18n = _ref.i18n,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? 'row' : _ref$layout,
      allProposals = _ref.allProposals;
  var allProposalsFromStore = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(_store_booking_booking_selector__WEBPACK_IMPORTED_MODULE_9__[/* proposalsSelector */ "B"]);

  if ((!allProposals || !allProposals.length) && !allProposalsFromStore.length) {
    throw new Error('AlternativePackages should have allProposals props provided or the store should contains proposals');
  }

  var basePackage = (allProposals || allProposalsFromStore)[0].packageId;
  var trackClick = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_4__[/* useTracking */ "a"])({
    categoryGA: 'bookingEngine',
    actionGA: 'allInclusive'
  }); // $FlowFixMe always found

  var RONPackage = selectedProposal === null || selectedProposal === void 0 ? void 0 : (_selectedProposal$pac = selectedProposal.packages) === null || _selectedProposal$pac === void 0 ? void 0 : _selectedProposal$pac.find(function (selectedProposalPackage) {
    return (selectedProposalPackage === null || selectedProposalPackage === void 0 ? void 0 : selectedProposalPackage.id) === JOYVIEW_ROOM_ONLY;
  });
  return (// $FlowFixMe package always defined here when the resort is joyview
    selectedProposal.packages.filter(function (bundle) {
      return bundle && bundle.id !== JOYVIEW_ROOM_ONLY && (selectedProposal.alternativePackages && findAlternativeProposalByPackage(selectedProposal.alternativePackages, bundle.id) || bundle.id === selectedProposal.packageId);
    }) // $FlowFixMe package always defined here, we filtered it just before
    .map(function (otherPackage, index, mappedArray) {
      var packageInfos = MAPPING_PACKAGE_INFOS[otherPackage.id]; // if there is no alternativePackage that means that it's already selected and that we want to reset the package

      var alternativePackage;

      if (selectedProposal.alternativePackages) {
        alternativePackage = findAlternativeProposalByPackage(selectedProposal.alternativePackages, otherPackage.id) || selectedProposal.alternativePackages[0];
      }

      return __jsx(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], {
        key: otherPackage.id
      }, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_7__[/* Title */ "a"], {
        className: "mb-px20",
        color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_8__[/* COLORS */ "a"].BLUE,
        theme: "title-sans-4"
      }, i18n.booking.services[packageInfos.title]), __jsx(_paid_service_PaidService_jsx__WEBPACK_IMPORTED_MODULE_6__[/* PaidService */ "a"], {
        icon: packageInfos.icon,
        headColor: packageInfos.color,
        label: otherPackage.label,
        text: otherPackage.description,
        ctaType: getCtaType(selectedProposal, otherPackage.id, basePackage),
        tooltip: {
          dataSelector: 'JoyviewUpsellTooltip',
          children: __jsx("div", {
            className: "RoomOnlyUpsell-popinContent"
          }, __jsx(_AlternativePackageToolTip__WEBPACK_IMPORTED_MODULE_10__[/* AlternativePackageToolTip */ "a"], {
            bundle: RONPackage
          }), __jsx(_AlternativePackageToolTip__WEBPACK_IMPORTED_MODULE_10__[/* AlternativePackageToolTip */ "a"], {
            bundle: otherPackage
          })),
          modalProps: {
            ariaLabel: otherPackage.label,
            closeLabel: i18n.common.close
          }
        },
        onClick: function onClick() {
          var add = selectedProposal.packageId !== otherPackage.id;
          var labelGA = (add ? 'add' : 'remove') + packageInfos.labelGA;
          trackClick({
            labelGA: labelGA
          });
          return selectProposal(alternativePackage && alternativePackage.proposalId);
        },
        price: alternativePackage && alternativePackage.upsellPrice,
        addLabel: i18n.booking.common.add,
        removeLabel: i18n.booking.common.remove,
        includedLabel: i18n.booking.common.included,
        imageUrl: packageInfos.imageUrl,
        layout: layout
      }), index < mappedArray.length - 1 && __jsx("div", {
        className: "text-xl text-center sm:mt-px40 sm:mb-0 mt-px20 mb-px15"
      }, i18n.booking.services.JVPackagesOr));
    })
  );
};

/***/ }),

/***/ "DuXo":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ "Dz6/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ BottomNavbarLayer_BottomNavbarLayer; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/frameworks/backdrop/Backdrop.jsx + 1 modules
var Backdrop = __webpack_require__("NZxu");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.jsx
var Portal = __webpack_require__("3uBn");

// EXTERNAL MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx + 1 modules
var TextLink = __webpack_require__("jD8k");

// EXTERNAL MODULE: ./src/client/components/frameworks/flipper/Flipper.jsx
var Flipper = __webpack_require__("8zGh");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// CONCATENATED MODULE: ./src/client/components/widgets/bottom-navbar-layer/InstalmentPrice.jsx
var __jsx = react_default.a.createElement;



var InstalmentPrice_InstalmentPrice = function InstalmentPrice(_ref) {
  var formattedPrice = _ref.formattedPrice;

  var _useContext = Object(react["useContext"])(ReactAppContext["a" /* default */]),
      locale = _useContext.locale;

  var priceToDisplay = Object(price_util["b" /* getInstalmentPrice */])(formattedPrice, locale);
  return priceToDisplay ? __jsx("span", {
    className: "block font-sans leading-one mt-px5 text-xs text-emerald"
  }, priceToDisplay) : null;
};
// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// CONCATENATED MODULE: ./src/client/components/widgets/bottom-navbar-layer/SelectedRate.jsx
var SelectedRate_jsx = react_default.a.createElement;




var FLEX_RATES = dist["constants"].FLEX_RATES;
var SelectedRate_SelectedRate = function SelectedRate(_ref) {
  var price = _ref.price;
  var isNRR = price.selectedRate === FLEX_RATES.NRR;
  return SelectedRate_jsx("span", {
    className: classnames_default()('mt-px5 block text-xs leading-one text-center', {
      'text-gray-darker': isNRR
    }, {
      'text-emerald': !isNRR
    })
  }, isNRR ? Object(i18n["g" /* t */])('booking.accommodation.packageContent.nonRefundableRateLabel') : Object(i18n["g" /* t */])('booking.accommodation.packageContent.standardLabel'));
};
// CONCATENATED MODULE: ./src/client/components/widgets/bottom-navbar-layer/BottomNavbarTotalPrice.jsx
var BottomNavbarTotalPrice_jsx = react_default.a.createElement;






var BottomNavbarTotalPrice_BottomNavbarTotalPrice = function BottomNavbarTotalPrice(_ref) {
  var _price$total;

  var isPriceLoading = _ref.isPriceLoading,
      price = _ref.price,
      showPrice = _ref.showPrice;

  if (!showPrice) {
    return null;
  }

  var shouldDisplayPriceWithoutDiscount = price && price.totalWithoutDiscount && price.totalWithoutDiscount.formattedValue &&
  /* $FlowFixMe: totalWithoutDiscount is FormattedPrice and has value property... I don't know why flow is angry :/ */
  price.totalWithoutDiscount.value > price.total.value;
  return isPriceLoading ? BottomNavbarTotalPrice_jsx(Spinner["a" /* Spinner */], {
    size: "small"
  }) : BottomNavbarTotalPrice_jsx(react["Fragment"], null, shouldDisplayPriceWithoutDiscount ? BottomNavbarTotalPrice_jsx("span", {
    className: "flex font-bold line-through rtl:mr-px10 px-px5 relative text-grenadine text-sm lg:text-md",
    "data-testid": "BookingBottomNavbar-initialPrice"
  }, BottomNavbarTotalPrice_jsx(Flipper["a" /* Flipper */], {
    description: Object(i18n["g" /* t */])('price.format.unitInitialTotalPerTrip')
    /* $FlowFixMe: totalWithoutDiscount is true if shouldDisplayPriceWithoutDiscount is true, it's a ProposalPriceDonation at this point */
    ,
    value: price.totalWithoutDiscount.formattedValue || ''
  })) : null, BottomNavbarTotalPrice_jsx("span", {
    className: "flex flex-col pt-px5"
  }, BottomNavbarTotalPrice_jsx(Flipper["a" /* Flipper */], {
    description: Object(i18n["g" /* t */])('price.format.unitTotalPerTrip'),
    value: (price === null || price === void 0 ? void 0 : (_price$total = price.total) === null || _price$total === void 0 ? void 0 : _price$total.formattedValue) || ''
  }), !!(price && price.hasFlexRates && price.selectedRate) && BottomNavbarTotalPrice_jsx(SelectedRate_SelectedRate, {
    price: price
  }), !!(price && Object(i18n["d" /* getKeyValue */])('common.price.displayInstalmentsPrice')) && BottomNavbarTotalPrice_jsx(InstalmentPrice_InstalmentPrice, {
    formattedPrice: price.total
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/bottom-navbar-layer/SvgButtonBorder.jsx
var SvgButtonBorder_jsx = react_default.a.createElement;

var SvgButtonBorder = function SvgButtonBorder(_ref) {
  var position = _ref.position,
      isBrowserGreaterThanS = _ref.isBrowserGreaterThanS;
  return isBrowserGreaterThanS ? SvgButtonBorder_jsx("svg", {
    className: "BookingBottomNavbar-receiptButtonBorder BookingBottomNavbar-receiptButtonBorder--".concat(position),
    width: "28px",
    height: "50px",
    viewBox: "0 0 28 50",
    version: "1.1"
  }, SvgButtonBorder_jsx("defs", null, SvgButtonBorder_jsx("path", {
    d: "M23,48.9946747 L4.58732292,48.9946747 L15.3661314,14.602176 C16.4118457,11.2655617 19.5033568,8.99467468 23,8.99467468 L23,48.9946747 Z",
    id: "path-1"
  }), SvgButtonBorder_jsx("filter", {
    x: "-51.6%",
    y: "-33.8%",
    width: "203.2%",
    height: "147.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, SvgButtonBorder_jsx("feOffset", {
    dx: "0",
    dy: "-4",
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), SvgButtonBorder_jsx("feGaussianBlur", {
    stdDeviation: "2.5",
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), SvgButtonBorder_jsx("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  }))), SvgButtonBorder_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, SvgButtonBorder_jsx("g", {
    id: "Rectangle-3"
  }, SvgButtonBorder_jsx("use", {
    fill: "black",
    fillOpacity: "1",
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), SvgButtonBorder_jsx("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })))) : SvgButtonBorder_jsx("svg", {
    className: "BookingBottomNavbar-receiptButtonBorder BookingBottomNavbar-receiptButtonBorder--".concat(position),
    width: "21px",
    height: "35px",
    viewBox: "0 0 21 35"
  }, SvgButtonBorder_jsx("defs", null, SvgButtonBorder_jsx("path", {
    d: "M16.0952461,33.9946747 L4.58732292,33.9946747 L11.3240782,12.499363 C11.9776496,10.413979 13.9098441,8.99467468 16.0952461,8.99467468 L16.0952461,33.9946747 Z",
    id: "path-3"
  }), SvgButtonBorder_jsx("filter", {
    x: "-82.6%",
    y: "-54.0%",
    width: "265.1%",
    height: "176.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, SvgButtonBorder_jsx("feOffset", {
    dx: "0",
    dy: "-4",
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), SvgButtonBorder_jsx("feGaussianBlur", {
    stdDeviation: "2.5",
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), SvgButtonBorder_jsx("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  }))), SvgButtonBorder_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, SvgButtonBorder_jsx("g", {
    id: "Rectangle-3"
  }, SvgButtonBorder_jsx("use", {
    fill: "black",
    fillOpacity: "1",
    filter: "url(#filter-3)",
    xlinkHref: "#path-3"
  }), SvgButtonBorder_jsx("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/bottom-navbar-layer/BottomNavbarLayer.jsx
var BottomNavbarLayer_jsx = react_default.a.createElement;

/* eslint-env browser */














var BottomNavbarLayer_BottomNavbarLayer = function BottomNavbarLayer(_ref) {
  var openLabel = _ref.openLabel,
      closeLabel = _ref.closeLabel,
      continueAction = _ref.continueAction,
      forwardRef = _ref.forwardRef,
      hideContinueButton = _ref.hideContinueButton,
      previousAction = _ref.previousAction,
      price = _ref.price,
      showPanelProp = _ref.showPanel,
      isPriceLoading = _ref.isPriceLoading,
      children = _ref.children,
      _ref$continueLabel = _ref.continueLabel,
      continueLabel = _ref$continueLabel === void 0 ? '' : _ref$continueLabel,
      backLabel = _ref.backLabel,
      portalPosition = _ref.portalPosition,
      trackClickOpenReceipt = _ref.trackClickOpenReceipt,
      trackClickCloseReceipt = _ref.trackClickCloseReceipt,
      toggleReceiptPanelProp = _ref.toggleReceiptPanel,
      dataSelector = _ref.dataSelector,
      closeLayer = _ref.closeLayer,
      showCloseLayerBtn = _ref.showCloseLayerBtn,
      closeLayerLabel = _ref.closeLayerLabel,
      continueBtn = _ref.continueBtn,
      shouldCloseAllLayers = _ref.shouldCloseAllLayers,
      onCloseAllLayers = _ref.onCloseAllLayers,
      nextPage = _ref.nextPage,
      previousPage = _ref.previousPage;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted,
      isBrowserGreaterThan = _useResponsive.isBrowserGreaterThan;

  var _useState = Object(react["useState"])(false),
      showPanel = _useState[0],
      setShowPanel = _useState[1];

  if (!isAppMounted) {
    return null;
  }

  var toggleReceiptPanel = function toggleReceiptPanel() {
    if (!showPanel && !showPanelProp) {
      trackClickOpenReceipt();
    } else {
      trackClickCloseReceipt();
    }

    if (showPanelProp && toggleReceiptPanelProp) {
      toggleReceiptPanelProp();
    } else {
      setShowPanel(!showPanel);
    }
  };

  var closeAllLayer = function closeAllLayer() {
    closeLayer && closeLayer();
    showPanel && setShowPanel(!showPanel);
  };

  if (shouldCloseAllLayers && showPanel) {
    closeAllLayer();
    onCloseAllLayers && onCloseAllLayers();
  }

  var closeLayerAndHidePanel = function closeLayerAndHidePanel() {
    setShowPanel(false);

    if (showPanelProp && toggleReceiptPanelProp) {
      toggleReceiptPanelProp();
    }
  };

  var isOpen = showPanel || showPanelProp;
  var showCloseLayerLink = showCloseLayerBtn || showPanel;
  var isBrowserGreaterThanS = isBrowserGreaterThan.S;
  return BottomNavbarLayer_jsx(react_default.a.Fragment, null, BottomNavbarLayer_jsx(Portal["a" /* default */], {
    name: portalPosition
  }, BottomNavbarLayer_jsx("div", {
    className: "bg-white bottom-0 fixed left-0 rounded-t shadow-md w-full z-2",
    ref: forwardRef
  }, BottomNavbarLayer_jsx("div", {
    className: "BookingBottomNavbar-content flex flex-wrap md:items-center justify-between md:justify-center m-auto md:px-px20 relative"
  }, BottomNavbarLayer_jsx("p", {
    id: "totalPriceDescription",
    className: "reset-paragraph w-full lg:w-auto border-0 border-b border-solid border-gray-light lg:border-0 flex justify-center items-center font-bold leading-one text-blue lg:text-4xl text-xl BookingBottomNavbar-price"
  }, BottomNavbarLayer_jsx(BottomNavbarTotalPrice_BottomNavbarTotalPrice, {
    showPrice: !!closeLayerLabel || !showPanel && !showPanelProp,
    price: price,
    isPriceLoading: isPriceLoading
  })), backLabel && BottomNavbarLayer_jsx("div", {
    className: "md:absolute flex md:rtl:left-0"
  }, BottomNavbarLayer_jsx(Button["a" /* Button */], {
    ariaLabel: previousPage ? Object(i18n["g" /* t */])('common.backTo', {
      previousPage: previousPage
    }) : null,
    color: colors["a" /* COLORS */].GRAY_DARKER,
    colorBg: colors["a" /* COLORS */].WHITE,
    colorBorder: colors["a" /* COLORS */].WHITE,
    dataTestId: "BookingBottomNavbar-backNavigation",
    iconLeft: {
      name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
      hasRtl: true,
      rotation: 180
    },
    minWidth: "initial",
    onClick: previousAction
  }, backLabel)), BottomNavbarLayer_jsx("div", null, BottomNavbarLayer_jsx("button", {
    className: "BookingBottomNavbar-receiptButton",
    onClick: toggleReceiptPanel,
    "data-testid": "receiptbutton",
    type: "button",
    "aria-describedby": "totalPriceDescription"
  }, BottomNavbarLayer_jsx(SvgButtonBorder, {
    position: "left",
    isBrowserGreaterThanS: isBrowserGreaterThanS
  }), BottomNavbarLayer_jsx("div", {
    className: "BookingBottomNavbar-receiptButtonText"
  }, BottomNavbarLayer_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].BLUE,
    name: isOpen ? icons["a" /* ICONS */].CROSS : icons["a" /* ICONS */].RECEIPT,
    width: "1rem"
  }), BottomNavbarLayer_jsx("span", {
    className: "rtl:ml-px10 text-underline-under underline",
    "data-testid": "BookingBottomNavbar-receiptButtonLabel"
  }, isOpen ? closeLabel : openLabel)), BottomNavbarLayer_jsx(SvgButtonBorder, {
    position: "right",
    isBrowserGreaterThanS: isBrowserGreaterThanS
  }))), BottomNavbarLayer_jsx("div", {
    className: "md:absolute md:bottom-0 flex flex-1 font-bold items-center justify-end md:m-auto px-px15 md:rtl:right-0 md:top-0",
    "data-testid": "BookingBottomNavbar-continueNavigation",
    style: closeLayerLabel ? {} : {
      width: 'calc(220rem / 16)'
    }
  }, showCloseLayerLink && closeLayerLabel && BottomNavbarLayer_jsx(TextLink["a" /* TextLink */], {
    color: colors["a" /* COLORS */].BLUE,
    className: "mx-px10 underline",
    iconRightName: "",
    label: closeLayerLabel,
    onClick: closeAllLayer
  }), BottomNavbarLayer_jsx("div", {
    className: classnames_default()({
      'w-full': !closeLayerLabel || !showCloseLayerLink,
      'opacity-0 pointer-events-none': hideContinueButton
    }),
    style: {
      maxWidth: 'calc(220rem / 16)'
    }
  }, continueBtn || BottomNavbarLayer_jsx(Button["a" /* Button */], {
    ariaLabel: nextPage ? Object(i18n["g" /* t */])('common.continueTo', {
      nextPage: nextPage
    }) : null,
    className: "font-bold text-xl w-full",
    colorBg: colors["a" /* COLORS */].BOOKING,
    colorBorder: colors["a" /* COLORS */].BOOKING,
    dataSelector: dataSelector || 'BookingBottomNavbar-button-continue',
    dataTestId: "withA11yButtonContinue",
    isDisabled: isPriceLoading,
    minWidth: "0",
    onClick: continueAction,
    size: "large"
  }, continueLabel)))))), isOpen ? BottomNavbarLayer_jsx(Backdrop["a" /* Backdrop */], {
    closeLabel: closeLabel,
    hasCloseButton: true,
    onClose: closeLayerAndHidePanel,
    opacity: 0.7,
    portalName: portalPosition,
    theme: "lite"
  }, BottomNavbarLayer_jsx("div", {
    className: "h-full relative w-full z-1",
    "data-testid": "BookingBottomNavbar-receiptContainer"
  }, BottomNavbarLayer_jsx("div", {
    className: "BookingBottomNavbar-receiptDummyClose absolute cursor-pointer inset-x-0 top-0",
    "data-testid": "BookingBottomNavbar-receiptDummyClose",
    onClick: closeLayerAndHidePanel
  }), BottomNavbarLayer_jsx("div", {
    className: "BookingBottomNavbar-receipt absolute bg-gray-lighter flex flex-col inset-0 overflow-y-scroll py-px20 scrolling-touch rounded-t"
  }, BottomNavbarLayer_jsx("div", {
    className: "BookingBottomNavbar-receiptDetails flex-grow"
  }, children)))) : null);
};
BottomNavbarLayer_BottomNavbarLayer.defaultProps = {
  hideContinueButton: false,
  trackClickOpenReceipt: lodash["noop"],
  trackClickCloseReceipt: lodash["noop"]
};

/***/ }),

/***/ "E3ZW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_CUSTOMER_SEARCH_RESULT; });
/* unused harmony export UNSET_CUSTOMER_SEARCH_RESULT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return customerSearch; });
var SET_CUSTOMER_SEARCH_RESULT = 'SET_CUSTOMER_SEARCH_RESULT';
var UNSET_CUSTOMER_SEARCH_RESULT = 'UNSET_CUSTOMER_SEARCH_RESULT';
var initialState = {};
var customerSearch = function customerSearch() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_CUSTOMER_SEARCH_RESULT:
      return action.payload;

    case UNSET_CUSTOMER_SEARCH_RESULT:
      return initialState;

    default:
      return state;
  }
};

/***/ }),

/***/ "ENE1":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("IBsm");

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ "EWLr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClickOutside; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var ClickOutside = function ClickOutside(_ref) {
  var children = _ref.children,
      className = _ref.className,
      onClick = _ref.onClick,
      _ref$shard = _ref.shard,
      shard = _ref$shard === void 0 ? {} : _ref$shard,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["children", "className", "onClick", "shard"]);

  var ref = Object(react__WEBPACK_IMPORTED_MODULE_2__["useRef"])(null);
  Object(react__WEBPACK_IMPORTED_MODULE_2__["useEffect"])(function () {
    var onClickOutside = function onClickOutside(e) {
      var current = ref.current;
      var shardElement = shard.current;
      var clickedElement = e.target;

      if (current && !current.contains(clickedElement)) {
        if (shardElement) {
          return !shardElement.contains(clickedElement) ? onClick() : undefined;
        }

        onClick();
      }
    };

    document.addEventListener('click', onClickOutside);
    return function () {
      document.removeEventListener('click', onClickOutside);
    };
  }, [children]);
  return __jsx("div", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    className: className,
    ref: ref
  }), children);
};

/***/ }),

/***/ "Ed3r":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-object-getownpropertynames -- safe */
var toIndexedObject = __webpack_require__("dNjr");
var $getOwnPropertyNames = __webpack_require__("8D46").f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "EgxT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RENTAL_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return groupRentalsByCategories; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fGyu");
/* harmony import */ var _components_widgets_services_layer_serviceLayer_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("X7tq");



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var RENTAL_LABELS = {
  activity_search_criterion_skiing_snowboarding: 'skiing',
  activity_search_criterion_snowboard: 'snowboard',
  activity_search_criterion_snow_shoe_walks: 'hiking'
};
var groupRentalsByCategories = function groupRentalsByCategories(rentals) {
  return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(rentals).sort(function (rental1, rental2) {
    return rental2.productInfo.id.localeCompare(rental1.productInfo.id);
  }).reduce(function (groupedRentals, rental) {
    var groupIndex = groupedRentals.findIndex(function (_ref) {
      var id = _ref.id;
      return id === rental.productInfo.useCase.id;
    });
    var productInfo = rental.productInfo,
        pricingInfo = rental.pricingInfo;

    if (groupIndex !== -1) {
      // $FlowFixMe 🤷‍
      groupedRentals[groupIndex].subCategories.push({
        productInfo: productInfo,
        pricingInfo: pricingInfo
      });
      return groupedRentals;
    }

    return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(groupedRentals), [{
      id: rental.productInfo.useCase.id,
      label: rental.productInfo.useCase.label,
      // $FlowFixMe 🤷‍
      subCategories: [{
        productInfo: productInfo,
        pricingInfo: pricingInfo
      }]
    }]);
  }, []).sort(function (groupedRental1, groupedRental2) {
    var _servicesConfiguratio, _servicesConfiguratio2;

    return (((_servicesConfiguratio = _components_widgets_services_layer_serviceLayer_utils__WEBPACK_IMPORTED_MODULE_2__[/* servicesConfiguration */ "a"][groupedRental1.id]) === null || _servicesConfiguratio === void 0 ? void 0 : _servicesConfiguratio.order) || 100) < (((_servicesConfiguratio2 = _components_widgets_services_layer_serviceLayer_utils__WEBPACK_IMPORTED_MODULE_2__[/* servicesConfiguration */ "a"][groupedRental2.id]) === null || _servicesConfiguratio2 === void 0 ? void 0 : _servicesConfiguratio2.order) || 10) ? -1 : 1;
  }).map(function (groupedRentalsByCategory) {
    return _objectSpread(_objectSpread({}, groupedRentalsByCategory), {}, {
      subCategories: groupedRentalsByCategory.subCategories.sort(function (rental1, rental2) {
        return rental1.productInfo.typeId < rental2.productInfo.typeId ? -1 : 1;
      }).reduce(function (groupedRentalsBySubCategory, rental) {
        var groupIndex = groupedRentalsBySubCategory.findIndex(function (_ref2) {
          var label = _ref2.label;
          return label === rental.productInfo.typeLabel;
        });

        if (groupIndex !== -1) {
          groupedRentalsBySubCategory[groupIndex].services.push(rental);
          return groupedRentalsBySubCategory;
        }

        return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(groupedRentalsBySubCategory), [{
          label: rental.productInfo.typeLabel,
          services: [rental]
        }]);
      }, [])
    });
  });
};

/***/ }),

/***/ "ExLU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ FlexRates_getFlexRatesOptions; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FlexRates_FlexRates; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/radio-button/RadioButton.jsx
var RadioButton = __webpack_require__("zwQs");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx + 1 modules
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/tooltip/Tooltip.jsx
var Tooltip = __webpack_require__("i3Ve");

// CONCATENATED MODULE: ./src/client/components/widgets/flex-rates/FlexRates.themes.js


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var small = {
  thTitle: 'font-bold mb-px10 reset-paragraph text-blue text-center text-lg w-full',
  thNrr: 'mb-px10'
};
var medium = {
  thRoot: 'sm:flex sm:flex-wrap',
  thTitle: classnames_default()(small.thTitle, 'sm:flex-none sm:mb-px20'),
  thNrr: classnames_default()(small.thNrr, 'sm:flex-1 sm:mb-0 sm:rtl:mr-px20'),
  thStandard: classnames_default()(small.thStandard, 'sm:flex-1')
};
var themes = {
  "default": small,
  medium: medium,
  large: _objectSpread(_objectSpread({}, medium), {}, {
    thTitle: classnames_default()(medium.thTitle, 'md:flex-1 md:rtl:mr-px20 md:text-initial')
  })
};
// CONCATENATED MODULE: ./src/client/components/widgets/flex-rates/FlexRates.jsx


var __jsx = react_default.a.createElement;














var FLEX_RATES = dist["constants"].FLEX_RATES;
var FlexRates_getFlexRatesOptions = function getFlexRatesOptions(_ref, appContext, theme) {
  var price = _ref.price,
      alternativePrice = _ref.alternativePrice;
  var options = [];

  if (!Object(lodash["isEmpty"])(alternativePrice)) {
    var rateDiff = Object(proposalUtils["l" /* getPriceDiff */])(alternativePrice.total.value, price.total.value, appContext.locale, price.currency); // $FlowFixMe

    var priceOffers = (price.discounts || []).filter(function (_ref2) {
      var offerId = _ref2.offerId;
      return !!offerId;
    }).map(function (_ref3) {
      var offerId = _ref3.offerId;
      return offerId;
    }); // $FlowFixMe

    var alternativePriceOffers = (alternativePrice.discounts || []).filter(function (_ref4) {
      var offerId = _ref4.offerId;
      return !!offerId;
    }).map(function (_ref5) {
      var offerId = _ref5.offerId;
      return offerId;
    });
    var nrrOffers = price.selectedRate === FLEX_RATES.NRR ? priceOffers : alternativePriceOffers;
    var standardOffers = price.selectedRate === FLEX_RATES.STANDARD ? priceOffers : alternativePriceOffers;
    var nonRefundableRate = {
      bullets: [Object(i18n["g" /* t */])('booking.accommodation.packageContent.nonRefundableRateBestPrice'), Object(i18n["g" /* t */])('booking.accommodation.packageContent.nonRefundableRateCancellation')],
      className: themes[theme].thNrr,
      color: colors["a" /* COLORS */].BLUE,
      dataTestId: 'flexRates-nrr',
      id: FLEX_RATES.NRR,
      offers: nrrOffers,
      price: price.selectedRate === FLEX_RATES.NRR ? Object(i18n["g" /* t */])('common.included') : rateDiff,
      title: Object(i18n["g" /* t */])('booking.accommodation.packageContent.nonRefundableRateLabel'),
      tooltipContent: Object(i18n["g" /* t */])('booking.accommodation.packageContent.nonRefundableRateLegal')
    };
    var standardRate = {
      bullets: [Object(i18n["g" /* t */])('booking.accommodation.packageContent.standardBestPrice'), Object(i18n["g" /* t */])('booking.accommodation.packageContent.standardCancellation')],
      className: themes[theme].thStandard,
      color: colors["a" /* COLORS */].EMERALD,
      dataTestId: 'flexRates-standard',
      id: FLEX_RATES.STANDARD,
      offers: standardOffers,
      price: price.selectedRate === FLEX_RATES.STANDARD ? Object(i18n["g" /* t */])('common.included') : rateDiff,
      title: Object(i18n["g" /* t */])('booking.accommodation.packageContent.standardLabel'),
      tooltipContent: Object(i18n["g" /* t */])('booking.accommodation.packageContent.standardLegal')
    };
    options.push(nonRefundableRate, standardRate);
  }

  return options;
};
var FlexRates_FlexRates = function FlexRates(_ref6) {
  var className = _ref6.className,
      isLoading = _ref6.isLoading,
      proposal = _ref6.proposal,
      selectedRate = _ref6.selectedRate,
      setSelectedRate = _ref6.setSelectedRate,
      switchOffers = _ref6.switchOffers,
      _ref6$theme = _ref6.theme,
      theme = _ref6$theme === void 0 ? 'default' : _ref6$theme;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]); // We use selectedRate instead price.selectedRate for better UX during radio button switch
  // Otherwise, radio button won't switch until proposals update finishes

  var options = FlexRates_getFlexRatesOptions(proposal, appContext, theme);
  Object(react["useEffect"])(function () {
    if (proposal.price.selectedRate !== selectedRate) {
      setSelectedRate(proposal.price.selectedRate);
    }
  }, [proposal.price.selectedRate]);
  var _themes$theme = themes[theme],
      thRoot = _themes$theme.thRoot,
      thTitle = _themes$theme.thTitle;
  return __jsx("div", {
    className: classnames_default()(className, thRoot)
  }, __jsx("p", {
    className: thTitle
  }, Object(i18n["g" /* t */])('booking.accommodation.packageContent.chooseFlexibility')), options.map(function (option) {
    return __jsx(FlexRates_Rate, Object(esm_extends["a" /* default */])({}, option, {
      isChecked: option.id === selectedRate,
      isLoading: isLoading,
      key: option.title,
      onClick: function onClick() {
        if (!switchOffers) {
          setSelectedRate(option.id);
        } else if (option.id !== proposal.price.selectedRate) {
          // $FlowFixMe is alternativePrice is defined offers cannot be undefined
          switchOffers(option.offers);
          setSelectedRate(option.id);
        }
      }
    }));
  }));
};

var FlexRates_Rate = function Rate(_ref7) {
  var bullets = _ref7.bullets,
      className = _ref7.className,
      color = _ref7.color,
      dataTestId = _ref7.dataTestId,
      isChecked = _ref7.isChecked,
      isLoading = _ref7.isLoading,
      _onClick = _ref7.onClick,
      price = _ref7.price,
      title = _ref7.title,
      tooltipContent = _ref7.tooltipContent;
  var rootRef = Object(react["useRef"])();
  return __jsx("button", {
    className: classnames_default()(className, 'border-1 border-solid cursor-pointer flex flex-wrap py-px20 px-px30 md:px-px20 reset-button rounded-tiny text-initial', Object(defineProperty["a" /* default */])({
      'border-gray-medium': !isChecked
    }, "border-".concat(color, " shadow-inset"), isChecked)),
    "data-testid": dataTestId,
    onClick: function onClick(event) {
      // prevent click inside the modal to select the rate
      if (rootRef.current && rootRef.current.contains(event.target)) {
        _onClick();
      }
    },
    ref: rootRef,
    type: "button"
  }, __jsx("div", {
    className: "flex items-baseline w-full"
  }, __jsx(RadioButton["a" /* RadioButton */], {
    className: "rtl:mr-px10",
    color: color,
    isChecked: isChecked,
    isDisabled: isLoading
  }), __jsx("p", {
    className: "font-brand reset-paragraph text-md text-".concat(color)
  }, title), __jsx(Tooltip["a" /* Tooltip */] // $FlowFixMe does not understand children prop comes from nested cmp
  , {
    modalProps: {
      ariaLabel: title,
      closeLabel: Object(i18n["g" /* t */])('common.close'),
      size: 'small'
    },
    renderTrigger: function renderTrigger(toggle) {
      return __jsx("button", {
        className: "leading-none rtl:ml-px20 reset-button",
        "data-testid": "flexRatesTooltipTrigger",
        onClick: function onClick(e) {
          // prevent click on the tooltip icon to select the rate
          e.stopPropagation();
          e.preventDefault();
          toggle();
        },
        type: "button"
      }, __jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].TOOLTIP,
        width: "1rem",
        color: color
      }));
    }
  }, __jsx("div", {
    "data-testid": "flexRatesTooltipContent"
  }, __jsx(Text["a" /* Text */], {
    className: "p-px20",
    color: colors["a" /* COLORS */].GRAY_DARKER,
    text: tooltipContent,
    theme: "text-sans-2"
  })))), __jsx("ul", {
    className: "mb-px20 rtl:ml-px30 reset-list text-md w-full"
  }, bullets.map(function (bullet) {
    return __jsx("li", {
      key: bullet,
      className: "flex items-baseline"
    }, __jsx(Icon["a" /* Icon */], {
      className: "flex-shrink-0 rtl:mr-px10",
      color: color,
      name: icons["a" /* ICONS */].STRAIGHT_CHECK,
      width: "0.75rem"
    }), bullet);
  })), __jsx("p", {
    className: "font-bold reset-paragraph self-end text-center text-lg text-".concat(color, " w-full")
  }, price));
};

/***/ }),

/***/ "F9U4":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");
var classof = __webpack_require__("XywU");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "FK6w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClosableLayer; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_graphql_client_cacheFront__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ESA2");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("nv//");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("SPKZ");
/* harmony import */ var _router_useRouter__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("7jla");
/* harmony import */ var _frameworks_layer_Layer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("U2fG");



var __jsx = react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement;







var closeLayer = function closeLayer(_ref) {
  var history = _ref.history,
      cleanUrl = _ref.cleanUrl,
      location = _ref.location,
      forceRefreshOnClose = _ref.forceRefreshOnClose;
  var newUri = cleanUrl(location);

  if (forceRefreshOnClose) {
    Object(_utils_graphql_client_cacheFront__WEBPACK_IMPORTED_MODULE_4__[/* clearAllCacheFront */ "a"])();
    window.location = newUri;
  } else {
    history.pushRoute(newUri, undefined, {
      shallow: true
    });
  }
};

var ClosableLayer = function ClosableLayer(props) {
  var children = props.children,
      params = props.params,
      close = props.close,
      forceRefreshOnClose = props.forceRefreshOnClose,
      theme = props.theme,
      layerProps = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(props, ["children", "params", "close", "forceRefreshOnClose", "theme"]);

  var _useRouter = Object(_router_useRouter__WEBPACK_IMPORTED_MODULE_7__[/* useRouter */ "a"])(),
      location = _useRouter.location,
      history = _useRouter.history;

  var openLayer = location.queryParams.openLayer;
  var showLayer = openLayer === props.name;

  var cleanUrl = function cleanUrl(loc) {
    return Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_5__[/* convertLocationToURI */ "c"])(loc).clone().removeSearch(['openLayer'].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(params || []))).resource();
  };

  var onClose = function onClose() {
    closeLayer({
      history: history,
      cleanUrl: cleanUrl,
      location: location,
      forceRefreshOnClose: forceRefreshOnClose
    });
    if (props.onClose) props.onClose();
  };

  Object(react__WEBPACK_IMPORTED_MODULE_3__["useEffect"])(function () {
    if (close) {
      close(onClose);
    }
  }, []);
  return showLayer ? __jsx(_frameworks_layer_Layer__WEBPACK_IMPORTED_MODULE_8__[/* Layer */ "b"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, layerProps, {
    buttonLeft: props.hideButtonLeft ? null : {
      label: props.backLabel,
      iconName: props.iconName || _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].LEFT_ARROW,
      onClick: props.onBack || onClose
    },
    onClose: onClose,
    theme: theme
  }), children) : null;
};

/***/ }),

/***/ "FRew":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ AccommodationsTabs_AccommodationsTabs; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/store/booking/selected-proposal-id/selectedProposalId.action.js
var selectedProposalId_action = __webpack_require__("uGNg");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/tracking-storage-api/index.js
var tracking_storage_api = __webpack_require__("K0Lv");

// EXTERNAL MODULE: ./src/client/router/useRouter.js
var useRouter = __webpack_require__("7jla");

// EXTERNAL MODULE: ./src/client/components/widgets/accommodations/BookingAccommodations.jsx + 18 modules
var BookingAccommodations = __webpack_require__("cuVd");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/tabs/Tabs.jsx + 1 modules
var Tabs = __webpack_require__("4/4b");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/utils/proposal/constants.js
var proposal_constants = __webpack_require__("tI+f");

// EXTERNAL MODULE: ./src/utils/accommodation/accommodation.constants.js
var accommodation_constants = __webpack_require__("lZ21");

// CONCATENATED MODULE: ./src/client/views/booking/accommodation/proposal-accommodation-title/ProposalAccommodationTitleUtils.js






function getAccommodationTitle(proposal, resort) {
  var accommodations = Object(toConsumableArray["a" /* default */])(proposal.accommodations).sort(proposalUtils["b" /* compareAccommodationsByComfort */]).reverse();

  var category = Object(lodash["get"])(accommodations, '[0].category', '');
  var comfort = Object(lodash["get"])(accommodations, '[0].comfortType', '');
  var label = Object(lodash["get"])(accommodations, '[0].label', '');
  var isVillettaRoom = resort.id.toLowerCase() === proposal_constants["a" /* CEFALU_RESORT */].toLowerCase() && accommodation_constants["f" /* VILLETA_ROOM_REGEX */].test(Object(lodash["get"])(accommodations, '[0].id', ''));
  return isVillettaRoom ? (label || comfort || category).toUpperCase() : (comfort || category).toUpperCase();
}


// CONCATENATED MODULE: ./src/client/views/booking/accommodation/proposal-accommodation-title/ProposalAccommodationTitle.themes.js
var themes = {
  "default": {
    thRoot: 'flex flex-col sm:flex-row py-px10 sm:py-px20 px-px5 sm:px-px20 text-base sm:text-md',
    thTitle: 'font-brand text-gray-darker uppercase',
    thLabel: 'font-bold font-sans sm:rtl:ml-px10 text-blue'
  },
  column: {
    thRoot: 'flex flex-col py-px10 px-px5 text-base',
    thTitle: 'font-brand text-gray-darker uppercase',
    thLabel: 'font-bold font-sans text-blue'
  }
};
// CONCATENATED MODULE: ./src/client/views/booking/accommodation/proposal-accommodation-title/ProposalAccommodationTitle.jsx
var __jsx = react_default.a.createElement;



var ProposalAccommodationTitle_ProposalAccommodationTitle = function ProposalAccommodationTitle(_ref) {
  var includedLabel = _ref.includedLabel,
      priceLabel = _ref.priceLabel,
      proposal = _ref.proposal,
      resort = _ref.resort,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var _themes$theme = themes[theme],
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot,
      thTitle = _themes$theme.thTitle;
  return __jsx("div", {
    "data-testid": "ProposalAccommodationTitle",
    className: thRoot
  }, __jsx("span", {
    className: thTitle
  }, getAccommodationTitle(proposal, resort)), __jsx("span", {
    className: thLabel
  }, priceLabel || includedLabel));
};
// CONCATENATED MODULE: ./src/client/views/booking/accommodation/AccommodationsTabs.jsx


var AccommodationsTabs_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var AccommodationsTabs_AccommodationsTabs = function AccommodationsTabs(_ref) {
  var button = _ref.button,
      isComparatorView = _ref.isComparatorView,
      isLoading = _ref.isLoading,
      proposals = _ref.proposals,
      resort = _ref.resort,
      selectedProposal = _ref.selectedProposal,
      selectedRate = _ref.selectedRate,
      selectProposal = _ref.selectProposal,
      setSelectedRate = _ref.setSelectedRate,
      switchOffers = _ref.switchOffers,
      tabTheme = _ref.tabTheme;

  var _useContext = Object(react["useContext"])(ReactAppContext["a" /* default */]),
      locale = _useContext.locale;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location,
      history = _useRouter.history;

  var updateUpsellRevenue = function updateUpsellRevenue() {
    var upsellRevenue = selectedProposal.price.total.value - Math.min.apply(Math, Object(toConsumableArray["a" /* default */])(proposals.map(function (_ref2) {
      var value = _ref2.price.total.value;
      return value;
    })));
    /*
      We need this information on BookingConfirmationView.
      To handle external payment provider redirection we have to store it outside of redux
     */

    tracking_storage_api["b" /* set */](_objectSpread(_objectSpread({}, tracking_storage_api["a" /* get */](constants["d" /* BE_TRACKING */])), {}, {
      upsellRevenue: upsellRevenue
    }));
  };

  Object(react["useEffect"])(function () {
    updateUpsellRevenue();
  }, [selectedProposal]);

  var onProposalSelection = function onProposalSelection(itemIndex) {
    var proposal = proposals[itemIndex];

    if ((proposal === null || proposal === void 0 ? void 0 : proposal.id) && !proposal.errorCode) {
      selectProposal(proposal.id, location, history);
    }
  };

  var initialSelectedItem = Math.max(0, proposals.indexOf(selectedProposal));
  var selectedProposalPrice = Object(proposalUtils["p" /* getTotalValue */])(selectedProposal);
  var proposalsLength = proposals.length;
  var items = Object(proposalUtils["n" /* getResolvedProposals */])(proposals).map(function (proposal) {
    var formatedPrice = Object(proposalUtils["l" /* getPriceDiff */])(Object(proposalUtils["p" /* getTotalValue */])(proposal), selectedProposalPrice, locale, selectedProposal.price.currency);
    return {
      header: {
        title: AccommodationsTabs_jsx(ProposalAccommodationTitle_ProposalAccommodationTitle, {
          includedLabel: Object(i18n["g" /* t */])('booking.accommodation.packageContent.included'),
          numberOfTabs: proposalsLength,
          priceLabel: formatedPrice,
          proposal: proposal,
          resort: resort,
          theme: tabTheme
        })
      },
      content: [AccommodationsTabs_jsx(BookingAccommodations["a" /* BookingAccommodations */], {
        accommodations: proposal.accommodations,
        isLoading: isLoading,
        key: proposal.id,
        proposal: proposal,
        resort: resort,
        selectedRate: selectedRate,
        setSelectedRate: setSelectedRate,
        switchOffers: switchOffers,
        theme: isComparatorView ? 'default' : 'large'
      })]
    };
  });
  return AccommodationsTabs_jsx(Tabs["a" /* Tabs */], {
    initialSelectedItem: initialSelectedItem,
    isContainerWide: true,
    items: items,
    onSelect: onProposalSelection,
    slotRight: button ? AccommodationsTabs_jsx("button", {
      className: "bg-turquoise hover:bg-turquoise-active border-1 border-solid border-gray-light flex h-full items-center justify-center leading-none p-px20 sm:px-px25 reset-button text-white transition-colors",
      onClick: button.onClick,
      type: "button"
    }, AccommodationsTabs_jsx(Icon["a" /* Icon */], {
      name: icons["a" /* ICONS */].PLUS,
      width: "1em"
    }), AccommodationsTabs_jsx("span", {
      className: "sr-only"
    }, button.label)) : null,
    theme: "rounded"
  });
};



/***/ }),

/***/ "Fk4B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTotalDifferentialPrice; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_sortBy__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("u6DZ");
/* harmony import */ var lodash_sortBy__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_sortBy__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_unionWith__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("fO+d");
/* harmony import */ var lodash_unionWith__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_unionWith__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _additionalTransports_action__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("04nu");
/* harmony import */ var _utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("wz9x");



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}








var getTotalDifferentialPrice = function getTotalDifferentialPrice() {
  var price1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var price2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var locale = arguments.length > 2 ? arguments[2] : undefined;
  var diff = price1 - price2;
  return {
    value: diff,
    formattedValue: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_8__[/* formatAmountForLocale */ "b"])(diff, locale)
  };
};
var sortPath = 'inbound.transportInfo.price.value';

var updateAlternativeTransports = function updateAlternativeTransports(_ref) {
  var selectedTransportId = _ref.selectedTransportId,
      state = _ref.state; // we do not change this value to keep track of the proposal's selected transport

  var proposalTransport = _objectSpread({}, state.proposalTransport); // fetched Alternative transports from api


  var previousAlternativeTransports = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(state.alternativeTransports); // current selected which also is the first recommended


  var currentSelectedTransport = _objectSpread({}, state.selectedTransport); // searching by id


  var selectedInboundInAlternative = previousAlternativeTransports.find(function (_ref2) {
    var inbound = _ref2.inbound;
    return inbound.transportInfo.id === selectedTransportId;
  }); // if it's not an alternative then we have selected the current selected (in the right)

  var newSelectedTransport = selectedInboundInAlternative || currentSelectedTransport;
  var proposalInAlternative = false;
  var currenAlternativeTransports = previousAlternativeTransports.map(function (_ref3) {
    var inbound = _ref3.inbound,
        outboundList = _ref3.outboundList,
        transportNumber = _ref3.transportNumber;

    if (Object(_additionalTransports_action__WEBPACK_IMPORTED_MODULE_7__[/* isSameJourney */ "m"])(inbound, proposalTransport.inbound)) {
      proposalInAlternative = true; // the same selected recommended and alternative should have the same outboundlist

      var sameOutboundList = lodash_sortBy__WEBPACK_IMPORTED_MODULE_4___default()(lodash_unionWith__WEBPACK_IMPORTED_MODULE_5___default()(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(proposalTransport.outboundList), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(outboundList), _additionalTransports_action__WEBPACK_IMPORTED_MODULE_7__[/* isSameJourney */ "m"]), sortPath); // if the proposal's transport was selected && there's a similar inbound in alternative transports

      if (Object(_additionalTransports_action__WEBPACK_IMPORTED_MODULE_7__[/* isSameJourney */ "m"])(proposalTransport.inbound, newSelectedTransport.inbound)) {
        newSelectedTransport.outboundList = sameOutboundList;
      }

      return {
        inbound: inbound,
        outboundList: sameOutboundList,
        transportNumber: transportNumber
      };
    }

    return {
      inbound: inbound,
      outboundList: outboundList,
      transportNumber: transportNumber
    };
  });

  if (!proposalInAlternative && proposalTransport.inbound.transportInfo.id !== newSelectedTransport.inbound.transportInfo.id) {
    // after selecting an inbound, if the proposal's transport is not in the list we should add it to be able to find it afterwards
    currenAlternativeTransports.push(proposalTransport);
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    // keep selectedTransportId in redux store
    selectedTransportId: selectedTransportId,
    selectedTransport: newSelectedTransport,
    alternativeTransports: Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(lodash_sortBy__WEBPACK_IMPORTED_MODULE_4___default()(currenAlternativeTransports, sortPath))
  });
};

var initialState = {
  alternativeTransports: [],
  selectedTransport: {},
  selectedTransportId: null
};

var hasAvailabilityCheckedWithAmadeus = function hasAvailabilityCheckedWithAmadeus(transport) {
  return (// the flight class should always be present, even for clubmed charter for which we have almost no data
    !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default()(lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(transport, 'inbound.journey.travelSections.0.transport.class'))
  );
};

function transportsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(action, 'type')) {
    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_6__["resolve"])(_additionalTransports_action__WEBPACK_IMPORTED_MODULE_7__[/* FETCH_ADDITIONAL_TRANSPORTS */ "d"]):
      var _action$payload = action.payload,
          additionalTransports = _action$payload.additionalTransports,
          selectedTransport = _action$payload.selectedTransport;
      var alternativeTransports = lodash_sortBy__WEBPACK_IMPORTED_MODULE_4___default()(additionalTransports.filter(hasAvailabilityCheckedWithAmadeus), sortPath).map(function (transport, index) {
        return _objectSpread(_objectSpread({}, transport), {}, {
          transportNumber: index + 1
        });
      });
      return {
        selectedTransport: selectedTransport,
        proposalTransport: selectedTransport,
        alternativeTransports: alternativeTransports,
        selectedTransportId: null
      };

    case _additionalTransports_action__WEBPACK_IMPORTED_MODULE_7__[/* UPDATE_SELECTED_TRANSPORT */ "j"]:
      var selectedTransportId = action.payload.selectedTransportId;
      return updateAlternativeTransports({
        selectedTransportId: selectedTransportId,
        state: state
      });

    default:
      return state;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (transportsReducer);

/***/ }),

/***/ "Fmrk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Confirmation; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("qqKu");
/* harmony import */ var _frameworks_text_link_TextLink__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("jD8k");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;









var getDefaultIcon = function getDefaultIcon(status) {
  return status === 'success' ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].CONFIRMATION : _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].WARNING;
};

var Confirmation = function Confirmation(_ref) {
  var _ref$button = _ref.button,
      button = _ref$button === void 0 ? {} : _ref$button,
      className = _ref.className,
      icon = _ref.icon,
      link = _ref.link,
      status = _ref.status,
      text = _ref.text,
      title = _ref.title;

  if (!status || !title) {
    return null;
  }

  var colors = {
    error: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].RED,
    neutral: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].BLUE,
    success: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].EMERALD
  };
  var iconName = icon ? icon : getDefaultIcon(status);
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, 'flex items-start sm:items-center sm:px-px20 py-px20'),
    "data-testid": "Confirmation"
  }, __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('leading-none rtl:mr-px20 text-sm sm:text-xl', "text-".concat(colors[status]))
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "a"], {
    name: iconName,
    width: "4em"
  })), __jsx("div", {
    className: "flex-auto"
  }, __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('font-bold text-md sm:text-xl', "text-".concat(colors[status]))
  }, title), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_7__[/* Text */ "a"], {
    text: text
  }), __jsx("div", {
    className: "flex flex-col-reverse\tsm:flex-row sm:items-start"
  }, __jsx(_frameworks_text_link_TextLink__WEBPACK_IMPORTED_MODULE_8__[/* TextLink */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, link, {
    className: "mt-px10 sm:rtl:mr-auto"
  })), button && button.children && __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_5__[/* Button */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, button, {
    className: "my-px10"
  }), button.children))));
};

/***/ }),

/***/ "FuvW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return trackClick; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("829J");
/* harmony import */ var _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("d1HQ");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



function trackClick(labelGA, appContext) {
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_2__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({}, _tracking_constants__WEBPACK_IMPORTED_MODULE_1__[/* GA_DEFAULT_PAYLOAD */ "i"]), {}, {
    versionBooking: 'responsive',
    categoryGA: 'bookingEngine',
    actionGA: 'summary',
    labelGA: labelGA
  }), appContext);
}

/***/ }),

/***/ "GJxp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "listen", function() { return /* binding */ index_es_listen; });
__webpack_require__.d(__webpack_exports__, "subscribe", function() { return /* binding */ index_es_subscribe; });
__webpack_require__.d(__webpack_exports__, "unsubscribe", function() { return /* binding */ index_es_unsubscribe; });

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/assign.js
var lodash_assign = __webpack_require__("whR3");
var assign_default = /*#__PURE__*/__webpack_require__.n(lodash_assign);

// EXTERNAL MODULE: /opt/webapp/node_modules/eventemitter3/index.js
var eventemitter3 = __webpack_require__("Gpi5");
var eventemitter3_default = /*#__PURE__*/__webpack_require__.n(eventemitter3);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/lib/supportPassiveEvent.js
/* global window */

var passiveSupported = false; // eslint-disable-line import/no-mutable-exports

if (typeof window !== 'undefined') {
  try {
    var supportPassiveEvent_options = Object.defineProperty({}, 'passive', {
      get: function get() {
        passiveSupported = true;
      }
    });

    window.addEventListener('test', null, supportPassiveEvent_options);
    window.removeEventListener('test', null, supportPassiveEvent_options);
  } catch (err) {} // eslint-disable-line no-empty
}

/* harmony default export */ var supportPassiveEvent = (passiveSupported);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/globalVars.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */




/* harmony default export */ var globalVars = ({
  connections: {},
  EE: new eventemitter3_default.a(),
  enableResizeInfo: false,
  enableScrollInfo: false,
  listeners: {},
  removers: [],
  supportPassiveEvent: supportPassiveEvent
});

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/lib/listen.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */




var listen_supportPassiveEvent = globalVars.supportPassiveEvent;


var defaultEventOption = {
  capture: false,
  passive: false
};

/**
 * Cross-browser addEventListener.
 * @method listen
 * @param {Object} target - The target to add event listener.
 * @param {String} eventType - The event type.
 * @param {Function} handler - The event handler.
 * @param {Object} handler - The options object that specifies
 * characteristics about the event listener.
 * @return {Object} The object to be able to remove the handler.
 */
function listen(target, eventType, handler, options) {
  var add = 'addEventListener';
  var _remove = 'removeEventListener';
  var type = eventType;

  var eventOptions = listen_supportPassiveEvent ? assign_default()({}, defaultEventOption, options) : false;

  if (!target.addEventListener && target.attachEvent) {
    add = 'attachEvent';
    _remove = 'detachEvent';
    type = 'on' + eventType;
  }
  target[add](type, handler, eventOptions);

  return {
    remove: function remove() {
      target[_remove](eventType, handler);
    }
  };
}

/* harmony default export */ var lib_listen = (listen);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/lib/leIE8.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global navigator, parseFloat */

// less then or equal to IE8
var leIE8 = false; // eslint-disable-line import/no-mutable-exports

if (typeof navigator !== 'undefined') {
  var matches = navigator.userAgent.match(/MSIE (\d+\.\d+)/);
  if (matches) {
    leIE8 = parseFloat(matches[1], 10) < 9;
  }
}

/* harmony default export */ var lib_leIE8 = (leIE8);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/clone.js
var clone = __webpack_require__("zr3P");
var clone_default = /*#__PURE__*/__webpack_require__.n(clone);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/throttle.js
var lodash_throttle = __webpack_require__("Bcqe");
var throttle_default = /*#__PURE__*/__webpack_require__.n(lodash_throttle);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/AugmentedEvent.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global window, document */



var resize = { // eslint-disable-line prefer-const
  width: 0,
  height: 0
};
var AugmentedEvent_scroll = { // eslint-disable-line prefer-const
  delta: 0,
  top: 0
};
var touch = { // eslint-disable-line prefer-const
  axisIntention: '',
  startX: 0,
  startY: 0,
  deltaX: 0,
  deltaY: 0
};

var INTENTION_THRESHOLD = 5;

var getXY = function getXY(pos) {
  var t = { x: 0, y: 0 }; // eslint-disable-line prefer-const
  var docBody = document.body;
  var docEl = document.documentElement;

  if (pos.pageX || pos.pageY) {
    t.x = pos.pageX;
    t.y = pos.pageY;
  } else {
    t.x = pos.clientX + docBody.scrollLeft + docEl.scrollLeft;
    t.y = pos.clientY + docBody.scrollTop + docEl.scrollTop;
  }

  return t;
};

/**
 * ArgmentedEvent will hold some global information, such like window scroll postion,
 * so that those information is only calculated once.
 * @param {Object} option - The option for SyntheticEvent
 */

var AugmentedEvent_AugmentedEvent = function () {
  function AugmentedEvent() {
    var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, AugmentedEvent);

    var mainType = (option.mainType || '').toLowerCase();
    var subType = (option.subType || '').toLowerCase();

    this.mainType = mainType;
    this.subType = subType;
    this.type = mainType + subType.charAt(0).toUpperCase() + subType.slice(1) || '';
    this.scroll = AugmentedEvent_scroll;
    this.resize = resize;
    this.touch = touch;
  }

  _createClass(AugmentedEvent, [{
    key: 'update',
    value: function update(e) {
      var mainType = this.mainType,
          subType = this.subType;

      var docEl = document.documentElement;

      if (globalVars.enableScrollInfo && (mainType === 'scroll' || mainType === 'touchmove')) {
        var top = docEl.scrollTop + document.body.scrollTop;
        // Prevent delta from being 0
        if (top !== this.scroll.top) {
          this.scroll.delta = top - this.scroll.top;
          this.scroll.top = top;
        }
      }
      if (globalVars.enableResizeInfo && mainType === 'resize') {
        this.resize.width = window.innerWidth || docEl.clientWidth;
        this.resize.height = window.innerHeight || docEl.clientHeight;
      }
      if (globalVars.enableTouchInfo && e.touches && (mainType === 'touchstart' || mainType === 'touchmove' || mainType === 'touchend')) {
        var pos = void 0;
        var absX = void 0;
        var absY = void 0;
        if (mainType === 'touchstart' || subType === 'start') {
          pos = getXY(e.touches[0]);
          this.touch.axisIntention = '';
          this.touch.startX = pos.x;
          this.touch.startY = pos.y;
          this.touch.deltaX = 0;
          this.touch.deltaY = 0;
        } else if (mainType === 'touchmove') {
          pos = getXY(e.touches[0]);
          this.touch.deltaX = pos.x - this.touch.startX;
          this.touch.deltaY = pos.y - this.touch.startY;
          if (this.touch.axisIntention === '') {
            absX = Math.abs(this.touch.deltaX);
            absY = Math.abs(this.touch.deltaY);
            if (absX > INTENTION_THRESHOLD && absX >= absY) {
              this.touch.axisIntention = 'x';
            } else if (absY > INTENTION_THRESHOLD && absY > absX) {
              this.touch.axisIntention = 'y';
            }
          }
        }
      }
    }
  }]);

  return AugmentedEvent;
}();

/* harmony default export */ var dist_es_AugmentedEvent = (AugmentedEvent_AugmentedEvent);

// EXTERNAL MODULE: /opt/webapp/node_modules/raf/index.js
var raf = __webpack_require__("0xii");
var raf_default = /*#__PURE__*/__webpack_require__.n(raf);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/lib/rAFThrottle.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */



var getTime = Date.now ||
/* istanbul ignore next */function () {
  return new Date().getTime();
};

function rAFThrottle(func) {
  var throttle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;

  var context = void 0;
  var args = void 0;
  var last = 0;
  var requestId = 0;

  var later = function later() {
    var now = getTime();
    var remaining = throttle - (now - last);

    if (remaining <= 0) {
      last = now;
      requestId = 0;
      func.apply(context, args);
    } else {
      requestId = raf_default()(later);
    }
  };

  return function throttledFunc() {
    context = this;
    args = arguments; // eslint-disable-line prefer-rest-params

    if (!requestId) {
      requestId = raf_default()(later);
    }
  };
}

/* harmony default export */ var lib_rAFThrottle = (rAFThrottle);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/constants.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var EVENT_END_DELAY = 100;
var DEFAULT_THROTTLE_RATE = 50;

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/mainEventConnectors.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global window, document, setTimeout */











// constants


var connections = globalVars.connections,
    EE = globalVars.EE,
    listeners = globalVars.listeners,
    removers = globalVars.removers;

// global variables

var doc = void 0;
var win = void 0;
var body = void 0;
var hashId = 0;

if (typeof window !== 'undefined') {
  win = window;
  doc = win.document || document;
  body = doc.body;
}

function getHash(domNode) {
  return domNode.id || 'target-id-' + hashId++; // eslint-disable-line
}

/**
 * Connect a throttled event to a throttled main event, and return an event remover.
 * The number of connections to a throttled main event will be kept. If all throttled events
 * are removed, then remove throttled main event.
 * @method connectThrottle
 * @param {String} throttledEvent - A throttled event
 * @param {Function} cb - Callback function
 * @param {Object} ctx - The "this"
 * @param {String} throttledMainEvent - A throttled main event
 * @return {Object} An event remover
 */
function connectThrottle(throttledEvent, cb, ctx, throttledMainEvent) {
  EE.on(throttledEvent, cb || noop_default.a, ctx);
  throttledMainEvent = throttledMainEvent || throttledEvent;
  connections[throttledMainEvent] = (connections[throttledMainEvent] || 0) + 1;
  return {
    _type: throttledEvent,
    _cb: cb,
    _ctx: ctx,
    unsubscribe: function unsubscribe() {
      if (!this._type) {
        return;
      }

      EE.removeListener(throttledEvent, cb, ctx);
      connections[throttledMainEvent]--;
      if (connections[throttledMainEvent] === 0) {
        listeners[throttledMainEvent].remove();
        listeners[throttledMainEvent] = undefined;
      }

      this._type = undefined;
      this._cb = undefined;
      this._ctx = undefined;

      // remove the remover from removers array
      for (var i = removers.length - 1; i >= 0; i--) {
        var remover = removers[i];
        if (remover === this) {
          removers.splice(i, 1);
          break;
        }
      }
    }
  };
}

/**
 * Connect to event, event start and event end.
 * @method connectContinuousEvent
 * @param {Object} target - The target of a main event, window or document.
 * @param {String} mainEvent - A browser event, like scroll or resize.
 * @param {String} event - A subscribe event.
 * @param {Object} eventOptions - An options pass to event listener
 */
function connectContinuousEvent(target, mainEvent, event) {
  return function throttleEvent(throttleRate, cb, options, eventOptions) {
    var context = options.context;
    var domTarget = options.target;
    var domId = domTarget && getHash(domTarget);
    var targetPart = domId ? ':' + domId : '';

    var throttledStartEvent = mainEvent + 'Start:' + throttleRate + targetPart;
    var throttledEndEvent = mainEvent + 'End:' + throttleRate + targetPart;
    var throttledMainEvent = mainEvent + ':' + throttleRate + targetPart;
    var throttledEvent = event + ':' + throttleRate + targetPart;

    var remover = connectThrottle(throttledEvent, cb, context, throttledMainEvent);
    removers.push(remover);

    if (listeners[throttledMainEvent]) {
      return remover;
    }

    var ae = {
      start: new dist_es_AugmentedEvent({ mainType: mainEvent, subType: 'start' }), // start
      main: new dist_es_AugmentedEvent({ mainType: mainEvent }), // main
      end: new dist_es_AugmentedEvent({ mainType: mainEvent, subType: 'end' })
    };

    // No throttle for throttleRate = 0
    // end
    if (throttleRate === 'raf') {
      throttleRate = 16; // Set as a number for setTimeout later.
      handler = lib_rAFThrottle(handler);
    } else if (throttleRate > 0) {
      handler = throttle_default()(handler, throttleRate);
    }

    var timer = void 0;
    function endCallback(e) {
      ae.end.update(e);
      EE.emit(throttledEndEvent, e, ae.end);
      timer = null;
    }
    function handler(e) {
      if (!timer) {
        ae.start.update(e);
        EE.emit(throttledStartEvent, e, ae.start);
      }
      clearTimeout(timer);

      ae.main.update(e);
      EE.emit(throttledMainEvent, e, ae.main);
      if (!lib_leIE8) {
        timer = setTimeout(endCallback.bind(null, e), throttleRate + EVENT_END_DELAY);
      } else {
        // For browser less then and equal to IE8, event object need to be cloned for setTimeout.
        timer = setTimeout(function () {
          endCallback(clone_default()(e));
        }, throttleRate + EVENT_END_DELAY);
      }
    }

    listeners[throttledMainEvent] = lib_listen(domTarget || target, mainEvent, handler, eventOptions);
    return remover;
  };
}

function connectDiscreteEvent(target, event) {
  return function throttleEvent(throttleRate, cb, options, eventOptions) {
    var context = options.context;
    var domTarget = options.target;
    var domId = domTarget && getHash(domTarget);

    // no throttling for discrete event
    var throttledEvent = event + ':0' + (domId ? ':' + domId : '');

    var remover = connectThrottle(throttledEvent, cb, context);
    removers.push(remover);

    if (listeners[throttledEvent]) {
      return remover;
    }

    var ae = new dist_es_AugmentedEvent({ mainType: event });

    function handler(e) {
      ae.update(e);
      EE.emit(throttledEvent, e, ae);
    }

    listeners[throttledEvent] = lib_listen(domTarget || target, event, handler, eventOptions);
    return remover;
  };
}

/* harmony default export */ var mainEventConnectors = ({
  scrollStart: connectContinuousEvent(win, 'scroll', 'scrollStart'),
  scrollEnd: connectContinuousEvent(win, 'scroll', 'scrollEnd'),
  scroll: connectContinuousEvent(win, 'scroll', 'scroll'),
  resizeStart: connectContinuousEvent(win, 'resize', 'resizeStart'),
  resizeEnd: connectContinuousEvent(win, 'resize', 'resizeEnd'),
  resize: connectContinuousEvent(win, 'resize', 'resize'),
  visibilitychange: connectDiscreteEvent(doc, 'visibilitychange'),
  touchmoveStart: connectContinuousEvent(body, 'touchmove', 'touchmoveStart'),
  touchmoveEnd: connectContinuousEvent(body, 'touchmove', 'touchmoveEnd'),
  touchmove: connectContinuousEvent(body, 'touchmove', 'touchmove'),
  touchstart: connectDiscreteEvent(body, 'touchstart'),
  touchend: connectDiscreteEvent(body, 'touchend')
});

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/subscribe.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


 // less then or equal to IE8


// constants


/**
 * Subscribe to UI events.
 * @method subscribe
 * @param {String} type - The type of event.
 * @param {Function} cb - The callback function.
 * @param {Object} options.context - The caller.
 * @param {Number} options.throttleRate - The amount of time for throttling.
 * @param {Boolean} options.useRAF - Use rAF for throttling if true.
 * @param {Object} options.eventOptions - Option to pass to event listener
 * @return {Object} The object with unsubscribe function.
 */
function subscribe(type, cb) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var useRAF = options.useRAF || false;
  var throttleRate = parseInt(options.throttleRate, 10);
  var eventOptions = options.eventOptions;

  if (isNaN(throttleRate)) {
    throttleRate = DEFAULT_THROTTLE_RATE;
  }

  if (useRAF) {
    throttleRate = 'raf';
  }

  // turn off throttle if the browser is IE8 or less, because window.event will be reset
  // when using any delayed function, i.g., setTimeout, or rAF.
  if (lib_leIE8) {
    throttleRate = 0;
  }

  // once those variables enabled, then never disabled.
  globalVars.enableScrollInfo = globalVars.enableScrollInfo || options.enableScrollInfo || false;
  globalVars.enableResizeInfo = globalVars.enableResizeInfo || options.enableResizeInfo || false;
  globalVars.enableTouchInfo = globalVars.enableTouchInfo || options.enableTouchInfo || false;

  return mainEventConnectors[type](throttleRate, cb, options, eventOptions);
}

/* harmony default export */ var dist_es_subscribe = (subscribe);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/unsubscribe.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */



var unsubscribe_removers = globalVars.removers;

/**
 * Unsubscribe to UI events.
 * @method unsubscribe
 * @param {String} type - The type of event.
 * @param {Function} cb - The callback function.
 */

function unsubscribe(type, cb) {
  var remover = void 0;
  for (var i = unsubscribe_removers.length - 1; i >= 0; i -= 1) {
    remover = unsubscribe_removers[i];
    if (remover._cb === cb && remover._type.indexOf(type) >= 0) {
      remover.unsubscribe();
      unsubscribe_removers.splice(i, 1);
    }
  }
}

/* harmony default export */ var dist_es_unsubscribe = (unsubscribe);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/index.es.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */





var IS_CLIENT = typeof window !== 'undefined';

function warn() {
  if (false) {}
}

var index_es_listen = IS_CLIENT ? lib_listen : warn;
var index_es_subscribe = IS_CLIENT ? dist_es_subscribe : warn;
var index_es_unsubscribe = IS_CLIENT ? dist_es_unsubscribe : warn;


/***/ }),

/***/ "Gpi5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */
function addListener(emitter, event, fn, context, once) {
  if (typeof fn !== 'function') {
    throw new TypeError('The listener must be a function');
  }

  var listener = new EE(fn, context || emitter, once)
    , evt = prefix ? prefix + event : event;

  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
  else emitter._events[evt] = [emitter._events[evt], listener];

  return emitter;
}

/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */
function clearEvent(emitter, evt) {
  if (--emitter._eventsCount === 0) emitter._events = new Events();
  else delete emitter._events[evt];
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */
EventEmitter.prototype.listeners = function listeners(event) {
  var evt = prefix ? prefix + event : event
    , handlers = this._events[evt];

  if (!handlers) return [];
  if (handlers.fn) return [handlers.fn];

  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
    ee[i] = handlers[i].fn;
  }

  return ee;
};

/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */
EventEmitter.prototype.listenerCount = function listenerCount(event) {
  var evt = prefix ? prefix + event : event
    , listeners = this._events[evt];

  if (!listeners) return 0;
  if (listeners.fn) return 1;
  return listeners.length;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  return addListener(this, event, fn, context, false);
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  return addListener(this, event, fn, context, true);
};

/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    clearEvent(this, evt);
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
      listeners.fn === fn &&
      (!once || listeners.once) &&
      (!context || listeners.context === context)
    ) {
      clearEvent(this, evt);
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
        listeners[i].fn !== fn ||
        (once && !listeners[i].once) ||
        (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else clearEvent(this, evt);
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) clearEvent(this, evt);
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),

/***/ "GzVq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTabsBackgroundClasses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTabsMainId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTabsItemIds; });
/* harmony import */ var _utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("m1JM");
/* harmony import */ var _color_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("UCZK");


var getTabsBackgroundClasses = function getTabsBackgroundClasses() {
  var hasBackground = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].GRAY_LIGHTER;
  return hasBackground ? "bg-".concat(color, " border-b-1 border-t-1 border-gray-light") : '';
};
var getTabsMainId = function getTabsMainId() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var list = items.filter(Boolean).map(function (_ref) {
    var header = _ref.header,
        title = _ref.title;
    return header && Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_0__[/* cleanupId */ "a"])(header.title) || title && Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_0__[/* cleanupId */ "a"])(title);
  }).filter(Boolean);
  return Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_0__[/* generateUniqueId */ "b"])(list, 'tabs-');
};
var getTabsItemIds = function getTabsItemIds(_ref2) {
  var id = _ref2.id,
      title = _ref2.title,
      index = _ref2.index,
      mainId = _ref2.mainId;
  var headerId = id || Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_0__[/* generateUniqueId */ "b"])([mainId, Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_0__[/* cleanupId */ "a"])(title), "".concat(index)], 'tabs-header-');
  var panelId = Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_0__[/* generateUniqueId */ "b"])([mainId, Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_0__[/* cleanupId */ "a"])(title), id && "".concat(id), "".concat(index)], 'tabs-panel-');
  return [headerId, panelId];
};

/***/ }),

/***/ "HKx7":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var definePropertyModule = __webpack_require__("87KK");
var anObject = __webpack_require__("ep/x");
var objectKeys = __webpack_require__("X95k");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "Hapo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FlightSummary; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_className_className_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("wJdf");
/* harmony import */ var _transportUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("z8xc");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("qBqs");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("SPKZ");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;








var FlightSummary = function FlightSummary(_ref) {
  var _classNames;

  var _ref$moduleName = _ref.moduleName,
      moduleName = _ref$moduleName === void 0 ? 'TransportDetails' : _ref$moduleName,
      way = _ref.way,
      departureFullName = _ref.departureFullName,
      arrivalFullName = _ref.arrivalFullName,
      date = _ref.date,
      transportIcon = _ref.transportIcon,
      i18n = _ref.i18n,
      _ref$isInline = _ref.isInline,
      isInline = _ref$isInline === void 0 ? false : _ref$isInline;
  var wayLabel = Object(_transportUtils__WEBPACK_IMPORTED_MODULE_6__[/* getWayLabel */ "m"])(i18n, way);
  var computeClass = Object(_utils_className_className_util__WEBPACK_IMPORTED_MODULE_5__[/* getClassModuler */ "a"])(moduleName);
  var flightSummaryLabel = "".concat(i18n.common.transport.from, " ").concat(departureFullName, " ").concat(i18n.common.transport.to, " ").concat(arrivalFullName);
  var datePattern = i18n.common.transport.onDate;
  var dateFormated = datePattern ? Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["messageFormat"])(datePattern).format({
    date: "".concat(Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_4__[/* momentFromApiDate */ "h"])(date).format(i18n.common.verboseDateFormatTechnicalID))
  }) : '';
  var isTrain = transportIcon === _utils_icon_icons__WEBPACK_IMPORTED_MODULE_8__[/* ICONS */ "a"].TRAIN;
  var isBoat = transportIcon === _utils_icon_icons__WEBPACK_IMPORTED_MODULE_8__[/* ICONS */ "a"].BOAT;
  var isPlane = transportIcon === _utils_icon_icons__WEBPACK_IMPORTED_MODULE_8__[/* ICONS */ "a"].TRANSPORT;
  var iconClasses = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_classNames = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_classNames, computeClass('flight-summary-icon'), isPlane), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_classNames, computeClass("flight-summary-icon-".concat(way.toLowerCase())), isPlane), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_classNames, computeClass('train-summary-icon'), isTrain), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_classNames, computeClass("train-summary-icon-".concat(way.toLowerCase())), isTrain), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_classNames, computeClass('boat-summary-icon'), isBoat), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_classNames, computeClass("boat-summary-icon-".concat(way.toLowerCase())), isBoat), _classNames));
  return __jsx("div", {
    className: computeClass('flight-summary')
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__[/* Icon */ "a"], {
    className: iconClasses,
    dataTestid: transportIcon || undefined,
    name: transportIcon,
    width: ""
  }), __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(computeClass('flight-summary-text'), 'text-base rtl:ml-px20')
  }, isInline ? __jsx("div", null, __jsx("span", {
    className: computeClass('emphasize')
  }, wayLabel, ":\xA0"), "".concat(flightSummaryLabel, " ").concat(dateFormated === null || dateFormated === void 0 ? void 0 : dateFormated.toLowerCase())) : __jsx(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null, __jsx("div", {
    "data-testid": "flight-summary-text"
  }, __jsx("span", {
    className: computeClass('emphasize')
  }, wayLabel, ":"), "\xA0", flightSummaryLabel), __jsx("div", {
    "data-testid": "flight-summary-date"
  }, dateFormated))));
};

/***/ }),

/***/ "HnW7":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq")))

/***/ }),

/***/ "Hv+8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return trackDelCredereBanking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return trackNavigation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return trackSaveCriteria; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return trackShareContextDesktopPopin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return trackShareContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return trackShareContextMobilePopin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return trackPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resetTrackingStorageBE; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("829J");
/* harmony import */ var _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("K0Lv");
/* harmony import */ var _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("d1HQ");
/* harmony import */ var _utils_booking_engine_pages_BookingPagesUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("rcxx");
/* harmony import */ var _utils_date_apiDate_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_tracking_resort__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("zCbR");
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("taV1");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}











function storeTracking(params) {
  var resortTrackingProps = _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_4__[/* get */ "a"](_tracking_constants__WEBPACK_IMPORTED_MODULE_3__[/* BE_TRACKING */ "d"]);

  var bookingCriteriaProps = _objectSpread(_objectSpread({}, Object(lodash__WEBPACK_IMPORTED_MODULE_2__["omit"])(resortTrackingProps, 'children')), params);

  _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_4__[/* set */ "b"](bookingCriteriaProps);
}

function trackDelCredereBanking(dataObject, appContext) {
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_5__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({}, _constants_js__WEBPACK_IMPORTED_MODULE_9__[/* BE_GA_DEFAULT_PAYLOAD */ "c"]), {}, {
    event: 'eventGA',
    versionBooking: 'responsive',
    categoryGA: 'bookingEngine',
    actionGA: 'bankingDucroire',
    valueGA: 0,
    nonInteraction: 0
  }, dataObject), appContext);
}
function trackNavigation(actionGA, labelGA, appContext) {
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_5__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({}, _constants_js__WEBPACK_IMPORTED_MODULE_9__[/* BE_GA_DEFAULT_PAYLOAD */ "c"]), {}, {
    versionBooking: 'responsive',
    categoryGA: 'bookingEngine',
    actionGA: actionGA,
    labelGA: labelGA
  }), appContext);
}
function trackSaveCriteria(actionGA, labelGA, appContext) {
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_5__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({}, _constants_js__WEBPACK_IMPORTED_MODULE_9__[/* BE_GA_DEFAULT_PAYLOAD */ "c"]), {}, {
    versionBooking: 'responsive',
    categoryGA: 'saveMyCriteria',
    actionGA: actionGA,
    labelGA: labelGA
  }), appContext);
}
function trackShareContextDesktopPopin(actionGA, appContext) {
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_5__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({}, _constants_js__WEBPACK_IMPORTED_MODULE_9__[/* BE_GA_DEFAULT_PAYLOAD */ "c"]), {}, {
    versionBooking: 'responsive',
    labelGA: 'shareValidate',
    actionGA: actionGA
  }), appContext);
}
function trackShareContext(actionGA, appContext) {
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_5__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({}, _constants_js__WEBPACK_IMPORTED_MODULE_9__[/* BE_GA_DEFAULT_PAYLOAD */ "c"]), {}, {
    versionBooking: 'responsive',
    labelGA: 'shareClick',
    actionGA: actionGA
  }), appContext);
}
function trackShareContextMobilePopin(actionGA, socialNetworkName, appContext) {
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_5__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({}, _constants_js__WEBPACK_IMPORTED_MODULE_9__[/* BE_GA_DEFAULT_PAYLOAD */ "c"]), {}, {
    versionBooking: 'responsive',
    labelGA: "shareValidate_".concat(socialNetworkName),
    actionGA: actionGA
  }), appContext);
}
function trackPage(trackingParams, appContext) {
  var _objectSpread2, _userInfo$loyaltyProg;

  var basePriceLabel = trackingParams.basePriceLabel,
      pageName = trackingParams.pageName,
      resort = trackingParams.resort,
      proposals = trackingParams.proposals,
      userInfo = trackingParams.userInfo,
      selectedProposal = trackingParams.selectedProposal,
      leadScore = trackingParams.leadScore,
      _trackingParams$custo = trackingParams.customEventName,
      customEventName = _trackingParams$custo === void 0 ? null : _trackingParams$custo,
      _trackingParams$isCom = trackingParams.isComingFromComparator,
      isComingFromComparator = _trackingParams$isCom === void 0 ? false : _trackingParams$isCom;
  var transportDeparture = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(selectedProposal.transports, 'inbound.travelSections[0].departure', {});
  var storedTracking = _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_4__[/* get */ "a"](_tracking_constants__WEBPACK_IMPORTED_MODULE_3__[/* BE_TRACKING */ "d"]);
  var departureDate = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(selectedProposal, 'departureDate', null);
  var departureDateTimestamp = Object(_utils_date_apiDate_js__WEBPACK_IMPORTED_MODULE_7__[/* apiDateToTimestamp */ "d"])(departureDate);
  var computedPageName = pageName === _utils_booking_engine_pages_BookingPagesUtils__WEBPACK_IMPORTED_MODULE_6__[/* PAGE_BE_SERVICES */ "e"] && resort.isJoyview ? _utils_booking_engine_pages_BookingPagesUtils__WEBPACK_IMPORTED_MODULE_6__[/* PAGE_BE_SERVICES_ALL_INCLUSIVE */ "f"] : pageName;

  var trackingDataToStore = _objectSpread((_objectSpread2 = {
    resortCode: resort.id,
    resortName: resort.name,
    resortTrident: resort.comfort,
    resortCountry: resort.destination.country,
    resortRegion: resort.destination.area,
    resortAdult: selectedProposal.adultsCount,
    resortChildren: selectedProposal.childrenCount,
    resortDefaultPrice: Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(resort, 'price.initialPrice.value'),
    resortDepartureCityCode: transportDeparture.cityId || 'WITHOUT TRANSPORT',
    resortDepartureCityName: transportDeparture.label,
    resortDepartureDate: selectedProposal.arrivalDate,
    resortNightNumber: selectedProposal.duration,
    resortOldPrice: Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(resort, 'price.initialPrice.value'),
    resortSeasonType: Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(resort, 'seasonName'),
    resortTotalParticipant: selectedProposal.childrenCount + selectedProposal.adultsCount,
    resortTransport: selectedProposal.transports ? 'with Transport' : 'without Transport',
    resortUrlImage: resort.image,
    versionBooking: 'responsive',
    resortSeason: departureDateTimestamp && Object(_utils_tracking_resort__WEBPACK_IMPORTED_MODULE_8__[/* isSummer */ "e"])(new Date(departureDateTimestamp)) ? 'Summer' : 'Winter',
    resortYearSeason: moment__WEBPACK_IMPORTED_MODULE_1___default()(departureDate, 'YYYYMMDD').format('YYYY')
  }, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_objectSpread2, basePriceLabel, proposals[0].price.total.value), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_objectSpread2, "contextNumber", selectedProposal.id), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_objectSpread2, "currencyCode", selectedProposal.price.currency), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_objectSpread2, "upsellExcursion", selectedProposal.additionalServices.activities.some(function (_ref) {
    var pricingInfo = _ref.pricingInfo;
    return pricingInfo.isPartiallyRented;
  }) ? 'yes' : 'no'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_objectSpread2, "BE_customerStatus", storedTracking.BE_customerStatus), _objectSpread2), leadScore ? {
    leadScore: leadScore
  } : null);

  storeTracking(trackingDataToStore);
  var hasNoActivitiesAvailable = selectedProposal.additionalServices.activities.length === 0;
  var shouldShowShooking = isComingFromComparator && (pageName === 'activities' || hasNoActivitiesAvailable && pageName === 'participants');
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_5__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({}, shouldShowShooking && {
    shooking: 'yes'
  }), {}, {
    categoryGA: _constants_js__WEBPACK_IMPORTED_MODULE_9__[/* BE_CATEGORY_GA */ "a"],
    locale: appContext.locale,
    event: customEventName || computedPageName,
    fidelityStatus: (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$loyaltyProg = userInfo.loyaltyProgram) === null || _userInfo$loyaltyProg === void 0 ? void 0 : _userInfo$loyaltyProg.status) || '',
    valueGA: 0,
    nonInteraction: 0,
    pageName: "BE_".concat(computedPageName),
    siteSection: 'Booking Engine'
  }, trackingDataToStore), appContext);
}
var resetTrackingStorageBE = function resetTrackingStorageBE() {
  storeTracking({
    BE_customerStatus: null
  });
};

/***/ }),

/***/ "I1fX":
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__("6XIJ");

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ "I2c1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("dNjr");
var addToUnscopables = __webpack_require__("3K/D");
var Iterators = __webpack_require__("oa0l");
var InternalStateModule = __webpack_require__("9jKB");
var defineIterator = __webpack_require__("ZiN6");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "I7/a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useAutoScrollToError; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("RUiN");

 // scroll to error after a submit and a validation

var useAutoScrollToError = function useAutoScrollToError(formik) {
  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    var isSubmitting = formik.isSubmitting,
        isValidating = formik.isValidating,
        isValid = formik.isValid;
    var formikErrored = '.formik-errored';

    if (isSubmitting && !isValidating && !isValid) {
      Object(_utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_1__[/* scrollToElement */ "a"])(formikErrored);
      var firstErroredElement = document.querySelector(formikErrored);
      firstErroredElement && firstErroredElement.focus();
    }
  });
};

/***/ }),

/***/ "ICjN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return asyncPolling; });
/* harmony import */ var poll_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6CUh");
/* harmony import */ var poll_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(poll_js__WEBPACK_IMPORTED_MODULE_0__);


function asyncPolling(config) {
  var startOfPoll = new Date();
  var timeout = config.timeout || 120000; // 2min

  var _pollWrapper = Object(poll_js__WEBPACK_IMPORTED_MODULE_0__["pollWrapper"])({
    request: function request() {
      return config.pollingFunction();
    },
    pollingPeriod: config.delay,
    shouldStop: function shouldStop(response) {
      var pollDuration = new Date() - startOfPoll;

      if (pollDuration > timeout) {
        throw new Error('Request timeout');
      }

      return !config.shouldPollAgain(response);
    }
  }),
      future = _pollWrapper.future;

  return future.then(function (response) {
    return config.onResponse(response);
  });
}



/***/ }),

/***/ "IYAN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("LTtw");
var global = __webpack_require__("HnW7");
var isForced = __webpack_require__("wxLG");
var redefine = __webpack_require__("L1Xj");
var InternalMetadataModule = __webpack_require__("wKkN");
var iterate = __webpack_require__("ZuH9");
var anInstance = __webpack_require__("V/va");
var isObject = __webpack_require__("1YFU");
var fails = __webpack_require__("fhLv");
var checkCorrectnessOfIteration = __webpack_require__("AZSF");
var setToStringTag = __webpack_require__("CGO5");
var inheritIfRequired = __webpack_require__("XmKO");

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var nativeMethod = NativePrototype[KEY];
    redefine(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        nativeMethod.call(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        nativeMethod.call(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced(
    CONSTRUCTOR_NAME,
    typeof NativeConstructor != 'function' || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.REQUIRED = true;
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, Constructor, CONSTRUCTOR_NAME);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),

/***/ "JE8a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mergeAndSortActivityCategoriesWithActivitiesBookable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatLabelForGA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getServiceCmsKeyPath; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var mergeAndSortActivityCategoriesWithActivitiesBookable = function mergeAndSortActivityCategoriesWithActivitiesBookable(activityCategories, availableActivities, onlyBookableServices) {
  return (// $FlowFixMe
    activityCategories.map(function (activityCategory) {
      return _objectSpread(_objectSpread({}, activityCategory), {}, {
        services: activityCategory.activities.map(function (activity) {
          var _availableActivities$;

          return {
            productInfo: activity,
            pricingInfo: availableActivities ? // productInfo can be null sometimes 😭
            (_availableActivities$ = availableActivities.find(function (_ref) {
              var productInfo = _ref.productInfo;
              return (productInfo || {}).id === activity.id;
            })) === null || _availableActivities$ === void 0 ? void 0 : _availableActivities$.pricingInfo : undefined
          };
        }).filter(function (_ref2) {
          var pricingInfo = _ref2.pricingInfo;
          return !!pricingInfo || !onlyBookableServices;
        }).sort(function (activity1, activity2) {
          if (activity1.pricingInfo && !activity2.pricingInfo) {
            return -1;
          }

          if (!activity1.pricingInfo && activity2.pricingInfo) {
            return 1;
          }

          if (activity1.productInfo.isIncluded && !activity2.productInfo.isIncluded) {
            return 1;
          }

          return -1;
        })
      });
    }).filter(function (_ref3) {
      var services = _ref3.services;
      return services.length;
    })
  );
};
var formatLabelForGA = function formatLabelForGA(label) {
  return label.replace(/\s/g, '-').replace(/,/g, '');
};
var getServiceCmsKeyPath = function getServiceCmsKeyPath(serviceType) {
  switch (serviceType) {
    case 'LAND_SPORT':
    case 'WATER_SPORT':
    case 'WINTER_SPORT':
      return 'sportActivities';

    case 'RENTAL':
      return 'skiEquipment';

    case 'EXCURSION':
      return 'excursions';

    case 'WELLNESS':
      return 'wellness';

    default:
      return '';
  }
};

/***/ }),

/***/ "JPie":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("aWzz");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var focus_lock_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("R6jJ");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("s5tn");






var AutoFocusInside = function AutoFocusInside(_ref) {
  var disabled = _ref.disabled,
      children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, Object(_util__WEBPACK_IMPORTED_MODULE_4__[/* inlineProp */ "b"])(focus_lock_constants__WEBPACK_IMPORTED_MODULE_3__[/* FOCUS_AUTO */ "b"], !disabled), {
    className: className
  }), children);
};

AutoFocusInside.propTypes =  false ? undefined : {};
AutoFocusInside.defaultProps = {
  disabled: false,
  className: undefined
};
/* harmony default export */ __webpack_exports__["a"] = (AutoFocusInside);

/***/ }),

/***/ "JaD2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mapCatalogIntoDepartureCities; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var entities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("4oK2");
/* harmony import */ var entities__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(entities__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("sW3P");




var mapCatalogIntoDepartureCities = function mapCatalogIntoDepartureCities(_ref) {
  var catalogs = _ref.catalogs,
      noTransportLabel = _ref.noTransportLabel;
  var departureCities = [{
    label: noTransportLabel,
    value: 'NO'
  }].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(catalogs.find(function (_ref2) {
    var id = _ref2.id;
    return id === _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__[/* DEPARTURE_CITY_FACET_ID */ "i"];
  }), 'list', []).map(function (departureCity) {
    return {
      value: departureCity.filter,
      label: Object(entities__WEBPACK_IMPORTED_MODULE_2__["decodeHTML"])(departureCity.i18n)
    };
  }) // the pertimm api return a without transport in the middle of the list but we want it first
  .filter(function (_ref3) {
    var value = _ref3.value;
    return value !== 'NO';
  })));
  return departureCities;
};

/***/ }),

/***/ "Jcrg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FormControl_FormControl; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/form/form.util.js
var form_util = __webpack_require__("1P7A");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./node_modules/classnames/dedupe.js
var dedupe = __webpack_require__("A/WM");
var dedupe_default = /*#__PURE__*/__webpack_require__.n(dedupe);

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/form-control/FormControl.themes.js



var DEFAULT_SIZES = {
  small: 32,
  medium: 42,
  large: 52
};
var themes = {
  "default": function _default(props) {
    var bgTransparent = props.bgTransparent,
        hasValidationIcon = props.hasValidationIcon,
        isActive = props.isActive,
        isDisabled = props.isDisabled,
        isFilled = props.isFilled,
        isReadOnly = props.isReadOnly,
        _props$size = props.size,
        size = _props$size === void 0 ? 'medium' : _props$size,
        _props$validationStat = props.validationState,
        validationState = _props$validationStat === void 0 ? 'NOT_VALIDATED' : _props$validationStat;
    var hasDefaultStyle = validationState === 'NOT_VALIDATED' && !isActive && !isFilled && !isDisabled;
    var hasActiveStyle = validationState === 'NOT_VALIDATED' && isActive && !isDisabled && !isFilled;
    var hasValidStyle = validationState === 'IS_VALID' && !isFilled && !isDisabled;
    var hasInvalidStyle = validationState === 'IS_INVALID' && !isFilled && !isDisabled;
    var hasFilledStyle = isFilled && !isDisabled;
    var iconTheme = dedupe_default()('flex items-center justify-center', {
      'text-current': !hasFilledStyle,
      'text-gray-medium': isDisabled
    });
    var validationIconName = null;

    if (hasValidationIcon && (hasValidStyle || hasInvalidStyle)) {
      validationIconName = hasValidStyle ? icons["a" /* ICONS */].CHECK : icons["a" /* ICONS */].CROSS;
    }

    return {
      thLabel: 'block font-bold pb-px5 text-gray-darker text-sm transition-color',
      thField: dedupe_default()('border-1 flex outline-custom px-px10 relative rounded-tiny transition-colors', Object(form_util["a" /* getCursorClass */])(props), {
        'button-medium': size === 'medium',
        'button-default': size === 'large',
        'bg-gray-lighter border-gray-lighter': isDisabled,
        'bg-white border-gray-medium': hasDefaultStyle && !bgTransparent,
        'bg-transparent border-gray-medium': hasDefaultStyle && !!bgTransparent,
        'focus-within:border-blue text-gray-darker focus-within:text-blue': hasDefaultStyle && !isReadOnly,
        'bg-white border-blue text-blue': hasActiveStyle,
        'bg-white border-success': hasValidStyle,
        'bg-white border-danger': hasInvalidStyle,
        'bg-blue border-blue text-white': hasFilledStyle
      }),
      thFieldStyle: {
        height: DEFAULT_SIZES[size]
      },
      thIconLeft: dedupe_default()(iconTheme, 'rtl:pr-px10'),
      thIconRight: dedupe_default()(iconTheme, 'rtl:pl-px10'),
      thInput: 'flex flex-1 relative',
      thLoader: 'flex items-center justify-center leading-none rtl:pl-px10',
      thSpinnerColor: hasFilledStyle ? 'current' : 'blue',
      thClearButton: dedupe_default()('reset-button leading-none rtl:pl-px10 transition-color', {
        'text-gray-medium': !hasFilledStyle,
        'text-current': hasFilledStyle
      }),
      thClearIconSize: '0.625rem',
      thValidationIcon: dedupe_default()('flex items-center justify-center pl-px10 text-xs transition-all', {
        'text-success': hasValidStyle,
        'text-danger': hasInvalidStyle
      }),
      thValidationIconSize: '1em',
      thValidationIconName: validationIconName,
      thNotes: 'mt-px pt-px text-sm text-gray-medium'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/form-control/FormControl.jsx
var __jsx = react_default.a.createElement;







var FormControl_FormControl = function FormControl(_ref) {
  var bgTransparent = _ref.bgTransparent,
      children = _ref.children,
      className = _ref.className,
      dir = _ref.dir,
      hasClear = _ref.hasClear,
      _ref$hasValidationIco = _ref.hasValidationIcon,
      hasValidationIcon = _ref$hasValidationIco === void 0 ? true : _ref$hasValidationIco,
      iconLeft = _ref.iconLeft,
      iconRight = _ref.iconRight,
      id = _ref.id,
      isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      isFilled = _ref.isFilled,
      isLoading = _ref.isLoading,
      isReadOnly = _ref.isReadOnly,
      isRequired = _ref.isRequired,
      label = _ref.label,
      notes = _ref.notes,
      onClear = _ref.onClear,
      size = _ref.size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      validationState = _ref.validationState;

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme]({
    bgTransparent: bgTransparent,
    hasValidationIcon: hasValidationIcon,
    isActive: isActive,
    isDisabled: isDisabled,
    isFilled: isFilled,
    isReadOnly: isReadOnly,
    size: size,
    validationState: validationState
  }),
      thClearButton = _themes$theme.thClearButton,
      thClearIconSize = _themes$theme.thClearIconSize,
      thField = _themes$theme.thField,
      thFieldStyle = _themes$theme.thFieldStyle,
      thIconLeft = _themes$theme.thIconLeft,
      thIconRight = _themes$theme.thIconRight,
      thInput = _themes$theme.thInput,
      thLabel = _themes$theme.thLabel,
      thLoader = _themes$theme.thLoader,
      thNotes = _themes$theme.thNotes,
      thSpinnerColor = _themes$theme.thSpinnerColor,
      thValidationIcon = _themes$theme.thValidationIcon,
      thValidationIconName = _themes$theme.thValidationIconName,
      thValidationIconSize = _themes$theme.thValidationIconSize;

  return __jsx("div", {
    className: className,
    dir: dir
  }, !!label && __jsx("label", {
    className: thLabel,
    htmlFor: id
  }, Object(lodash["isString"])(label) ? Object(form_util["b" /* getFormattedLabel */])(label, isRequired) : label), __jsx("div", {
    className: thField,
    style: thFieldStyle
  }, !!iconLeft && __jsx("div", {
    className: thIconLeft
  }, __jsx(Icon["a" /* Icon */], {
    name: iconLeft,
    width: "0.875rem"
  })), __jsx("div", {
    className: thInput
  }, children, isLoading && !isDisabled && !isReadOnly && __jsx("div", {
    className: thLoader
  }, __jsx(Spinner["a" /* Spinner */], {
    color: thSpinnerColor,
    size: "small"
  })), hasClear && !isDisabled && !isLoading && !isReadOnly && __jsx("button", {
    className: thClearButton,
    "data-testid": "FormControlClear",
    onClick: onClear,
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thClearIconSize
  }))), !!iconRight && __jsx("div", {
    className: thIconRight
  }, __jsx(Icon["a" /* Icon */], {
    name: iconRight
  })), thValidationIconName && __jsx("span", {
    className: thValidationIcon
  }, __jsx(Icon["a" /* Icon */], {
    name: thValidationIconName,
    width: thValidationIconSize
  }))), !!notes && __jsx("div", {
    className: thNotes,
    "data-testid": "FormControlNotes"
  }, notes));
};

/***/ }),

/***/ "Jm8J":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("j2ob");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "JpEK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("fhLv");
var getPrototypeOf = __webpack_require__("yvHl");
var createNonEnumerableProperty = __webpack_require__("g51W");
var has = __webpack_require__("DZWw");
var wellKnownSymbol = __webpack_require__("nJrx");
var IS_PURE = __webpack_require__("SRps");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if ((!IS_PURE || NEW_ITERATOR_PROTOTYPE) && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "K3M/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActivitiesLayer; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ActivitiesContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("oMJB");
/* harmony import */ var _services_layer_ServicesContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("tjZu");
/* harmony import */ var _services_layer_ServicesLayer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("eu64");
/* harmony import */ var _Activities_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("JE8a");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("kiXb");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;






var ActivitiesLayer = function ActivitiesLayer(_ref) {
  var i18n = _ref.i18n,
      activitiesCategories = _ref.activitiesCategories,
      initialActivitiesCategoryIdToShow = _ref.initialActivitiesCategoryIdToShow,
      currentCategoryId = _ref.currentCategoryId;

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_0__["useContext"])(_ActivitiesContext__WEBPACK_IMPORTED_MODULE_1__[/* ActivitiesContext */ "a"]),
      trackingData = _useContext.trackingData,
      availableActivities = _useContext.availableActivities,
      onlyBookableServices = _useContext.onlyBookableServices,
      attendeesList = _useContext.attendeesList,
      updateService = _useContext.updateService,
      currency = _useContext.currency;

  var activityCategoriesWithActivitiesBookable = Object(_Activities_utils__WEBPACK_IMPORTED_MODULE_4__[/* mergeAndSortActivityCategoriesWithActivitiesBookable */ "c"])(activitiesCategories, availableActivities, onlyBookableServices);
  return __jsx(_services_layer_ServicesContext__WEBPACK_IMPORTED_MODULE_2__[/* ServicesContext */ "a"].Provider, {
    value: {
      attendeesList: attendeesList,
      updateService: updateService,
      currency: currency,
      trackingData: trackingData,
      isPriceForAdultOnly: true,
      scheduleReservationMessage: Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "g"])('booking.activities.sportActivities.changeSchedule'),
      currentCategoryId: currentCategoryId
    }
  }, __jsx(_services_layer_ServicesLayer__WEBPACK_IMPORTED_MODULE_3__[/* ServicesLayer */ "a"], {
    i18n: i18n,
    services: activityCategoriesWithActivitiesBookable,
    initialCategoryIdToShow: initialActivitiesCategoryIdToShow
  }));
};

/***/ }),

/***/ "K7hX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EVENT_TYPE_IFRAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IframeCallbackView; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QsI/");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _routes_constants_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("dNxv");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("829J");







var EVENT_TYPE_IFRAME = 'paymentIframe';
var IframeCallbackView = function IframeCallbackView(iframeMessage) {
  var parentWindow = _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["windowWrapper"].get('parent');

  if (parentWindow) {
    parentWindow.postMessage(iframeMessage, '*');
  }

  return null;
};

var getInitialProps = /*#__PURE__*/function () {
  var _ref2 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee(_ref) {
    var req, _req$query, callbackUrl, paymentId, providerResponse;

    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            req = _ref.req;

            if (!req) {
              _context.next = 4;
              break;
            }

            _req$query = req.query, callbackUrl = _req$query.callbackUrl, paymentId = _req$query.paymentId, providerResponse = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_req$query, ["callbackUrl", "paymentId"]);
            return _context.abrupt("return", {
              eventType: EVENT_TYPE_IFRAME,
              callbackUrl: callbackUrl,
              paymentId: paymentId,
              providerResponse: providerResponse
            });

          case 4:
            return _context.abrupt("return", undefined);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getInitialProps(_x) {
    return _ref2.apply(this, arguments);
  };
}();

IframeCallbackView.getInitialProps = getInitialProps;
IframeCallbackView.pageId = _routes_constants_js__WEBPACK_IMPORTED_MODULE_5__[/* IFRAME_CALLBACK_PAGE_ID */ "h"];
IframeCallbackView.pageType = _tracking_constants__WEBPACK_IMPORTED_MODULE_6__[/* STATIC_PAGE_TYPES */ "w"].BE;
IframeCallbackView.disableFooter = true;
IframeCallbackView.disableHeader = true;

/***/ }),

/***/ "KxdP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFilters; });
/* unused harmony export COMFORT_CATEGORY */
/* unused harmony export EXTRA_FEATURES_CATEGORY */
/* unused harmony export CONFIGURATION_CATEGORY */
/* unused harmony export matchConfiguration */
/* unused harmony export matchComfort */
/* unused harmony export matchExtraFeatures */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createFilters; });
/* unused harmony export createConfigurationFilters */
/* unused harmony export createComfortFilters */
/* unused harmony export createExtraFeaturesFilters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return unselectCategory; });
/* unused harmony export REDUCED_MOBILITY_FILTER_ID */
/* unused harmony export matchExtraFeaturesReducedMobility */
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fGyu");
/* harmony import */ var shortid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("MIfU");
/* harmony import */ var shortid__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(shortid__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("h/fj");
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("lZ21");
/* harmony import */ var _components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("aWOT");



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}







var COMFORT_CATEGORY = 'accommodations';
var EXTRA_FEATURES_CATEGORY = 'extra';
var CONFIGURATION_CATEGORY = 'configuration';
var REDUCED_MOBILITY_FILTER_ID = 'reduced_mobility_access';

var getOptions = function getOptions(v, c) {
  return v.filter(function (_ref) {
    var category = _ref.category;
    return category === c;
  }).map(function (o) {
    var _o$meta, _o$meta2;

    return {
      iconName: (_o$meta = o.meta) === null || _o$meta === void 0 ? void 0 : _o$meta.icon,
      id: o.id,
      isDisabled: !o.matchedOccurrences,
      isSelected: o.selected,
      label: (_o$meta2 = o.meta) === null || _o$meta2 === void 0 ? void 0 : _o$meta2.label,
      matched: o.matchedOccurrences || 0,
      value: o.value
    };
  });
};

var getFilters = function getFilters(i18n, resort) {
  var filterValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return [{
    id: COMFORT_CATEGORY,
    label: Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(i18n, 'filters.comfort.categoryTitle'),
    options: getOptions(filterValues, COMFORT_CATEGORY)
  }, {
    id: CONFIGURATION_CATEGORY,
    label: Object(_components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_7__[/* tAlt */ "b"])({
      cruiseKeyPath: 'filters.configuration.categoryTitleCruise',
      resort: resort,
      resortKeyPath: 'filters.configuration.categoryTitle'
    }),
    options: getOptions(filterValues, CONFIGURATION_CATEGORY)
  }, {
    id: EXTRA_FEATURES_CATEGORY,
    label: Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(i18n, 'filters.extraFeatures.categoryTitle'),
    options: getOptions(filterValues, EXTRA_FEATURES_CATEGORY)
  }];
};

var matchConfiguration = function matchConfiguration(accommodations, roomType) {
  return accommodations.some(function (accommodation) {
    return accommodation.roomType === roomType;
  });
};

var matchComfort = function matchComfort(accommodations, categoryId) {
  return accommodations.some(function (accommodation) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(accommodation, 'categories').find(function (category) {
      return Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(category, 'id') === categoryId;
    });
  });
};

var matchExtraFeatures = function matchExtraFeatures(accommodations, strengthId) {
  return accommodations.some(function (accommodation) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(accommodation, 'view.id', null) === strengthId || Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(accommodation, 'strengths', []).find(function (strength) {
      return Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(strength, 'id') === strengthId;
    });
  });
};

var matchExtraFeaturesReducedMobility = function matchExtraFeaturesReducedMobility(accommodations) {
  return accommodations.some(function (accommodation) {
    return accommodation.reducedMobilityAccess;
  });
};

function createConfigurationFilters(accommodationsSets, resort) {
  var accommodations = Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["pipe"])([Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["map"])(Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["path"])('accommodations')), lodash_fp__WEBPACK_IMPORTED_MODULE_4__["flatten"], Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["uniqBy"])('roomType')])(accommodationsSets);
  return accommodations.map(function (_ref2) {
    var roomType = _ref2.roomType;
    return {
      id: shortid__WEBPACK_IMPORTED_MODULE_2___default.a.generate(),
      category: CONFIGURATION_CATEGORY,
      match: matchConfiguration,
      meta: {
        label: Object(_components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_7__[/* tAlt */ "b"])({
          resortKeyPath: "filters.configuration.".concat(_utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_6__[/* ROOM_TYPE */ "e"][roomType]),
          cruiseKeyPath: "filters.configuration.".concat(_utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_6__[/* CABIN_TYPE */ "b"][roomType]),
          resort: resort
        }),
        icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"][roomType]
      },
      path: 'accommodations',
      selected: false,
      value: roomType
    };
  });
}

function createComfortFilters(accommodationsSets) {
  var accommodations = Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["pipe"])([Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["map"])(Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["path"])('accommodations')), lodash_fp__WEBPACK_IMPORTED_MODULE_4__["flatten"], lodash_fp__WEBPACK_IMPORTED_MODULE_4__["compact"], Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["uniqBy"])('categoryId')])(accommodationsSets);
  var comfortSeen = [];
  return accommodations.map(function (accommodation) {
    /**
     * in some cases we have differents categories with same comfort type
     * it causes a duplicate filter
     * Concat comfort type & category, as label for teh second one
     */
    var comfortType = accommodation.comfortType,
        category = accommodation.category;
    var label = comfortSeen.includes(comfortType) ? "".concat(comfortType, " ").concat(category) : comfortType || category;
    comfortSeen.push(accommodation.comfortType);
    return {
      id: shortid__WEBPACK_IMPORTED_MODULE_2___default.a.generate(),
      category: COMFORT_CATEGORY,
      match: matchComfort,
      meta: {
        label: label
      },
      path: 'accommodations',
      selected: false,
      value: accommodation.categoryId
    };
  });
}

function createExtraFeaturesFilters(accommodationsSets, i18n) {
  var accommodations = Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["pipe"])([Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["map"])(Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["path"])('accommodations')), lodash_fp__WEBPACK_IMPORTED_MODULE_4__["flatten"], Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["uniqBy"])('id')])(accommodationsSets);
  var strengths = Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["pipe"])([Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["map"])(Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["path"])('strengths')), lodash_fp__WEBPACK_IMPORTED_MODULE_4__["flatten"], lodash_fp__WEBPACK_IMPORTED_MODULE_4__["compact"], Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["uniqBy"])('id')])(accommodations);
  var views = Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["pipe"])([Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["map"])(Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["path"])('view')), lodash_fp__WEBPACK_IMPORTED_MODULE_4__["compact"], Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["uniqBy"])('id')])(accommodations);
  var reducedMobityAccess = accommodations.some(function (accommodation) {
    return accommodation.reducedMobilityAccess;
  }) ? [{
    id: REDUCED_MOBILITY_FILTER_ID,
    label: i18n.filters.reducedMobility
  }] : [];
  var features = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(strengths), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(views), reducedMobityAccess);
  return features.map(function (feature) {
    return {
      id: shortid__WEBPACK_IMPORTED_MODULE_2___default.a.generate(),
      category: EXTRA_FEATURES_CATEGORY,
      match: feature.id === REDUCED_MOBILITY_FILTER_ID ? matchExtraFeaturesReducedMobility : matchExtraFeatures,
      meta: {
        label: feature.label,
        icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"][feature.id],
        iconClassName: "icon--".concat(feature.id),
        iconInheritColor: true
      },
      path: 'accommodations',
      selected: false,
      value: feature.id
    };
  });
}

function createFilters(accommodationsSets, i18n, resort) {
  return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(createExtraFeaturesFilters(accommodationsSets, i18n)), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(createConfigurationFilters(accommodationsSets, resort)), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(createComfortFilters(accommodationsSets)));
}

function unselectCategory(filters) {
  return function (category) {
    return filters.map(function (filter) {
      return _objectSpread(_objectSpread({}, filter), {}, {
        selected: filter.category === category ? false : filter.selected
      });
    });
  };
}



/***/ }),

/***/ "L1Xj":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var createNonEnumerableProperty = __webpack_require__("g51W");
var has = __webpack_require__("DZWw");
var setGlobal = __webpack_require__("edYw");
var inspectSource = __webpack_require__("/ExG");
var InternalStateModule = __webpack_require__("9jKB");

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var state;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) {
      createNonEnumerableProperty(value, 'name', key);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "LFxm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__("Bg8+");
var getWeakData = __webpack_require__("wKkN").getWeakData;
var anObject = __webpack_require__("ep/x");
var isObject = __webpack_require__("1YFU");
var anInstance = __webpack_require__("V/va");
var iterate = __webpack_require__("ZuH9");
var ArrayIterationModule = __webpack_require__("VrMI");
var $has = __webpack_require__("DZWw");
var InternalStateModule = __webpack_require__("9jKB");

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
var find = ArrayIterationModule.find;
var findIndex = ArrayIterationModule.findIndex;
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (store) {
  return store.frozen || (store.frozen = new UncaughtFrozenStore());
};

var UncaughtFrozenStore = function () {
  this.entries = [];
};

var findUncaughtFrozen = function (store, key) {
  return find(store.entries, function (it) {
    return it[0] === key;
  });
};

UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.entries.push([key, value]);
  },
  'delete': function (key) {
    var index = findIndex(this.entries, function (it) {
      return it[0] === key;
    });
    if (~index) this.entries.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        id: id++,
        frozen: undefined
      });
      if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var data = getWeakData(anObject(key), true);
      if (data === true) uncaughtFrozenStore(state).set(key, value);
      else data[state.id] = value;
      return that;
    };

    redefineAll(C.prototype, {
      // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
      // https://tc39.es/ecma262/#sec-weakset.prototype.delete
      'delete': function (key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
        return data && $has(data, state.id) && delete data[state.id];
      },
      // `{ WeakMap, WeakSet }.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.has
      // https://tc39.es/ecma262/#sec-weakset.prototype.has
      has: function has(key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state).has(key);
        return data && $has(data, state.id);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // `WeakMap.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.get
      get: function get(key) {
        var state = getInternalState(this);
        if (isObject(key)) {
          var data = getWeakData(key);
          if (data === true) return uncaughtFrozenStore(state).get(key);
          return data ? data[state.id] : undefined;
        }
      },
      // `WeakMap.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.set
      set: function set(key, value) {
        return define(this, key, value);
      }
    } : {
      // `WeakSet.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-weakset.prototype.add
      add: function add(value) {
        return define(this, value, true);
      }
    });

    return C;
  }
};


/***/ }),

/***/ "LGTM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ MoreRooms_MoreRooms; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/store/booking/additional-accommodations/filters/filterUtils.js
var filterUtils = __webpack_require__("KxdP");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/store/booking/additional-accommodations/additionalAccommodations.action.js
var additionalAccommodations_action = __webpack_require__("06Jt");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js + 115 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: /opt/webapp/node_modules/yup/lib/index.js
var lib = __webpack_require__("luEP");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-feedback/FormFeedback.jsx
var FormFeedback = __webpack_require__("DwNm");

// EXTERNAL MODULE: ./src/client/components/widgets/accommodations/attendees-distribution/AttendeesDistributionUtils.js
var AttendeesDistributionUtils = __webpack_require__("Y6/E");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var storeHelper = __webpack_require__("Jsmy");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/capsule/Capsule.jsx + 1 modules
var Capsule = __webpack_require__("jldR");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/FormikInput.jsx + 16 modules
var FormikInput = __webpack_require__("/HC4");

// CONCATENATED MODULE: ./src/client/components/widgets/additional-accommodations/rooms-manager/AttendeeOption.jsx
var __jsx = react_default.a.createElement;






var AttendeeOption_AttendeeOption = function AttendeeOption(_ref) {
  var attendee = _ref.attendee,
      roomId = _ref.roomId;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var type = attendee.type,
      firstName = attendee.firstName,
      lastName = attendee.lastName,
      index = attendee.index;
  var attendeeLabel;

  switch (type.toUpperCase()) {
    case AttendeesDistributionUtils["a" /* ATTENDEE_CATEGORIES */].CHILD:
      attendeeLabel = "".concat(Object(src_i18n["g" /* t */])('booking.common.child'), " ").concat(index + 1);
      break;

    case AttendeesDistributionUtils["a" /* ATTENDEE_CATEGORIES */].BABY:
      attendeeLabel = "".concat(Object(src_i18n["g" /* t */])('booking.common.baby'), " ").concat(index + 1);
      break;

    case AttendeesDistributionUtils["a" /* ATTENDEE_CATEGORIES */].ADULT:
    default:
      attendeeLabel = "".concat(Object(src_i18n["g" /* t */])('booking.common.adult'), " ").concat(index + 1);
  }

  var attendeeName = Object(sellerUtils["g" /* isSeller */])(appContext) && firstName && lastName ? "".concat(firstName, " ").concat(lastName) : null;
  return __jsx("div", {
    className: "flex items-center w-1/2"
  }, __jsx(FormikInput["a" /* FormikInput */], {
    type: "radio",
    name: "attendees.".concat(attendee.id),
    isRequired: true,
    value: "room-".concat(roomId),
    label: __jsx(react["Fragment"], null, __jsx("div", {
      className: "capitalize text-md text-gray-darker"
    }, attendeeLabel), attendeeName && __jsx("div", {
      className: "capitalize text-gray-dark text-sm"
    }, attendeeName.toLocaleLowerCase()))
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-accommodations/rooms-manager/RoomConfigurator.jsx

var RoomConfigurator_jsx = react_default.a.createElement;


 // import { type DistributionAttendeesByCategory } from 'Components/widgets/accommodations/attendees-distribution/AttendeesDistributionUtils';








var ALL_COMFORT_OPTION = 'all';
var RoomConfigurator_RoomConfigurator = function RoomConfigurator(_ref) {
  var _formik$values;

  var roomNumber = _ref.roomNumber,
      roomId = _ref.roomId,
      comforts = _ref.comforts,
      attendees = _ref.attendees,
      onClose = _ref.onClose,
      formik = _ref.formik;
  var roomIdentifier = "room-".concat(roomId);

  var isComfortSelected = function isComfortSelected(comfortId) {
    return formik.values.comforts[roomIdentifier] && formik.values.comforts[roomIdentifier].includes(comfortId);
  };

  var lastAttendeesValues = Object(react["useRef"])({});
  var attendeesValues = (_formik$values = formik.values) === null || _formik$values === void 0 ? void 0 : _formik$values.attendees;
  Object(react["useEffect"])(function () {
    var _Object$keys;

    if ((_Object$keys = Object.keys(attendeesValues)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) {
      lastAttendeesValues.current = attendeesValues;
    }
  }, [JSON.stringify(attendeesValues)]);

  var selectComfort = function selectComfort(comfortId) {
    var allComfortIds = comforts.map(function (_ref2) {
      var id = _ref2.id;
      return id;
    });

    if (!formik.values.comforts[roomIdentifier]) {
      var comfortsToAdd = comfortId === ALL_COMFORT_OPTION ? [].concat(Object(toConsumableArray["a" /* default */])(allComfortIds), [ALL_COMFORT_OPTION]) : [comfortId];
      formik.setFieldValue("comforts.".concat(roomIdentifier), comfortsToAdd);
    } else if (formik.values.comforts[roomIdentifier].includes(comfortId)) {
      var filteredComforts = formik.values.comforts[roomIdentifier].filter(function (id) {
        return id !== comfortId && id !== ALL_COMFORT_OPTION;
      });

      var _comfortsToAdd = comfortId === ALL_COMFORT_OPTION ? [] : filteredComforts;

      formik.setFieldValue("comforts.".concat(roomIdentifier), _comfortsToAdd);
    } else {
      var _comfortsToAdd2 = comfortId === ALL_COMFORT_OPTION ? [].concat(Object(toConsumableArray["a" /* default */])(allComfortIds), [ALL_COMFORT_OPTION]) : [].concat(Object(toConsumableArray["a" /* default */])(formik.values.comforts[roomIdentifier]), [comfortId]);

      formik.setFieldValue("comforts.".concat(roomIdentifier), _comfortsToAdd2);
    }
  };

  var _getAttendeesByDistri = Object(AttendeesDistributionUtils["c" /* getAttendeesByDistributionCategory */])(attendees),
      adults = _getAttendeesByDistri.adults,
      children = _getAttendeesByDistri.children,
      babies = _getAttendeesByDistri.babies;

  return RoomConfigurator_jsx("div", {
    className: "w-1/3 pr-px15 pb-px15",
    "data-testid": roomIdentifier
  }, RoomConfigurator_jsx(Capsule["a" /* Capsule */], null, RoomConfigurator_jsx("div", {
    className: "p-px15 h-72 min-h-full"
  }, roomNumber > 1 ? RoomConfigurator_jsx("button", {
    "data-testid": "delete-".concat(roomIdentifier),
    type: "button",
    onClick: onClose,
    className: "float-right bg-transparent p-0"
  }, RoomConfigurator_jsx(Icon["a" /* Icon */], {
    className: "shadow cursor-pointer font-bold border-1 border-red rounded-half p-px5 bg-red",
    color: colors["a" /* COLORS */].WHITE,
    name: icons["a" /* ICONS */].CROSS,
    width: "1.25rem"
  })) : null, RoomConfigurator_jsx("div", {
    className: "flex border-b-1 border-gray-light pb-px10"
  }, RoomConfigurator_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ACCOMODATIONS,
    color: colors["a" /* COLORS */].BLUE,
    width: "2.5rem",
    className: "mr-px20"
  }), RoomConfigurator_jsx("div", {
    className: "text-dark-lighter text-xl leading-loose"
  }, Object(src_i18n["g" /* t */])('booking.accommodation.moreRooms.seller.roomNumber', {
    n: roomNumber
  }))), RoomConfigurator_jsx("div", {
    className: "flex flex-wrap my-px15"
  }, RoomConfigurator_jsx(formik_esm["b" /* Field */], {
    type: "select",
    name: "comforts.room-".concat(roomId)
  }, function () {
    return RoomConfigurator_jsx(react["Fragment"], null, comforts.map(function (comfort) {
      return RoomConfigurator_jsx("option", {
        key: comfort.id,
        className: classnames_default()('p-px5 text-base border-1 rounded-small cursor-pointer mr-px10 border-blue', {
          'text-blue bg-white': !isComfortSelected(comfort.id),
          'text-white bg-blue': isComfortSelected(comfort.id)
        }),
        value: comfort.id,
        onClick: function onClick() {
          return selectComfort(comfort.id);
        }
      }, comfort.type);
    }), RoomConfigurator_jsx("option", {
      className: classnames_default()('p-px5 text-base border-1 rounded-small cursor-pointer mr-px10 border-blue', {
        'text-blue bg-white': !isComfortSelected(ALL_COMFORT_OPTION),
        'text-white bg-blue': isComfortSelected(ALL_COMFORT_OPTION)
      }),
      value: ALL_COMFORT_OPTION,
      onClick: function onClick() {
        return selectComfort(ALL_COMFORT_OPTION);
      }
    }, Object(src_i18n["g" /* t */])('booking.accommodation.moreRooms.seller.allRoomComfort')));
  })), RoomConfigurator_jsx("div", {
    className: "flex flex-wrap"
  }, adults.map(function (attendee) {
    return RoomConfigurator_jsx(AttendeeOption_AttendeeOption, {
      attendee: attendee,
      roomId: roomId,
      key: attendee.id
    });
  }), children.map(function (attendee) {
    return RoomConfigurator_jsx(AttendeeOption_AttendeeOption, {
      attendee: attendee,
      roomId: roomId,
      key: attendee.id
    });
  }), babies.map(function (attendee) {
    return RoomConfigurator_jsx(AttendeeOption_AttendeeOption, {
      attendee: attendee,
      roomId: roomId,
      key: attendee.id
    });
  })))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-accommodations/rooms-manager/AddRoomBloc.jsx
var AddRoomBloc_jsx = react_default.a.createElement;





var AddRoomBloc_AddRoomBloc = function AddRoomBloc(_ref) {
  var onClick = _ref.onClick;
  return AddRoomBloc_jsx("div", {
    className: "w-1/3 pr-px15 pb-px15"
  }, AddRoomBloc_jsx("div", {
    className: "h-64 min-h-full p-px15 border-1 border-gray-light border-dashed rounded-small"
  }, AddRoomBloc_jsx("button", {
    type: "button",
    "data-testid": "addRoom",
    onClick: onClick,
    className: "float-right bg-transparent p-0"
  }, AddRoomBloc_jsx(Icon["a" /* Icon */], {
    className: "cursor-pointer font-bold border-1 border-emerald rounded-half p-px5 bg-emerald",
    color: colors["a" /* COLORS */].WHITE,
    name: icons["a" /* ICONS */].PLUS,
    width: "1.25rem"
  })), AddRoomBloc_jsx("span", {
    "data-testid": "addRoomSpan",
    className: "font-bold text-s bloc text-gray-darker"
  }, Object(src_i18n["g" /* t */])('booking.accommodation.moreRooms.seller.addRoom'))));
};
// EXTERNAL MODULE: ./src/utils/accommodation/accommodation.constants.js
var accommodation_constants = __webpack_require__("lZ21");

// CONCATENATED MODULE: ./src/client/components/widgets/additional-accommodations/rooms-manager/roomsManager.utils.js



var roomsManager_utils_getRoomComforts = function getRoomComforts(resort) {
  var singleRooms = resort.accommodations.filter(function (_ref) {
    var connectingRoom = _ref.connectingRoom;
    return !connectingRoom;
  });
  var comforts = singleRooms.reduce(function (result, accommodation) {
    if (!result[accommodation.comfortId]) {
      result[accommodation.comfortId] = {
        id: accommodation.comfortId,
        type: accommodation.comfortType,
        categories: []
      };
    }

    if (!result[accommodation.comfortId].categories.includes(accommodation.categoryId)) {
      result[accommodation.comfortId].categories.push(accommodation.categoryId);
    }

    return result;
  }, {}); // $FlowFixMe

  return Object.values(comforts).sort(function (comfort1, comfort2) {
    return (// $FlowFixMe comfort has always categories
      accommodation_constants["a" /* ACCOMMODATION_COMFORT_ORDER */].indexOf(comfort1.categories[0]) - // $FlowFixMe comfort has always categories
      accommodation_constants["a" /* ACCOMMODATION_COMFORT_ORDER */].indexOf(comfort2.categories[0])
    );
  });
};
var roomsManager_utils_processFormValues = function processFormValues(values, attendeesList, comfortsWithCategories) {
  var rooms = attendeesList.reduce(function (roomsData, attendee) {
    var attendeeRoom = values.attendees[attendee.id];

    if (attendeeRoom) {
      if (!roomsData[attendeeRoom]) {
        var roomComfortIds = values.comforts[attendeeRoom] || comfortsWithCategories.map(function (_ref2) {
          var id = _ref2.id;
          return id;
        });
        var comfortCategories = roomComfortIds.reduce(function (allCategories, roomComfortId) {
          var roomComfort = comfortsWithCategories.find(function (_ref3) {
            var id = _ref3.id;
            return roomComfortId === id;
          });
          return roomComfort ? [].concat(Object(toConsumableArray["a" /* default */])(allCategories), Object(toConsumableArray["a" /* default */])(roomComfort.categories)) : allCategories;
        }, []);
        roomsData[attendeeRoom] = {
          attendees: [],
          hasAdults: false,
          comfortCategories: comfortCategories
        };
      }

      roomsData[attendeeRoom].hasAdults = roomsData[attendeeRoom].hasAdults || attendee.type === AttendeesDistributionUtils["a" /* ATTENDEE_CATEGORIES */].ADULT;
      roomsData[attendeeRoom].attendees.push({
        id: attendee.id
      });
    }

    return roomsData;
  }, {}); // $FlowFixMe

  return Object.values(rooms);
};
var roomsManager_utils_getInitialFormValues = function getInitialFormValues(proposal, comfortsWithCategories) {
  var accommodations = proposal.accommodations,
      accommodationsCount = proposal.accommodationsCount,
      attendees = proposal.attendees; // case of two identical accommodations

  if (accommodations.length < accommodationsCount) {
    var adults = attendees.adults,
        children = attendees.children;
    var values = {
      attendees: {},
      comforts: {}
    };

    for (var i = 0; i < accommodationsCount; i++) {
      var roomIdentifier = "room-".concat(i + 1);
      var adult = adults[i];

      if (adult) {
        values.attendees[adult.id] = roomIdentifier;
      }

      var child = children[i];

      if (child) {
        values.attendees[child.id] = roomIdentifier;
      }

      var selectedComfort = comfortsWithCategories.find(function (comfort) {
        return comfort.categories.includes(accommodations[0].categoryId);
      });

      if (selectedComfort) {
        values.comforts[roomIdentifier] = [selectedComfort.id];
      }
    }

    var missingAdults = Object(toConsumableArray["a" /* default */])(adults);

    missingAdults.splice(0, accommodationsCount);

    var missingChildren = Object(toConsumableArray["a" /* default */])(children);

    missingChildren.splice(0, accommodationsCount);
    var missingAttendees = [].concat(Object(toConsumableArray["a" /* default */])(missingAdults), Object(toConsumableArray["a" /* default */])(missingChildren)); // Put missing attendees in a random room

    missingAttendees.forEach(function (attendee) {
      var randomRoomNumber = Math.ceil(Math.random() * accommodationsCount);
      values.attendees[attendee.id] = "room-".concat(randomRoomNumber);
    });
    return values;
  } // case of two different accommodations


  return proposal.accommodations.reduce(function (values, accommodation, index) {
    var _accommodation$attend;

    var attendeesFromList = (accommodation === null || accommodation === void 0 ? void 0 : (_accommodation$attend = accommodation.attendeesDistribution) === null || _accommodation$attend === void 0 ? void 0 : _accommodation$attend.attendees) || Object(toConsumableArray["a" /* default */])(attendees.list);

    var roomIdentifier = "room-".concat(index + 1);
    var selectedComfort = comfortsWithCategories.find(function (comfort) {
      return comfort.categories.includes(accommodation.categoryId);
    });

    if (selectedComfort) {
      values.comforts[roomIdentifier] = [selectedComfort.id];
    }

    attendeesFromList.forEach(function (attendee) {
      values.attendees[attendee.id] = roomIdentifier;
    });
    return values;
  }, {
    attendees: {},
    comforts: {}
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-accommodations/rooms-manager/RoomsManager.jsx



var RoomsManager_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var ADD_ROOM_ACTION = 'addRoom';
var DELETE_ROOM_ACTION = 'deleteRoom';

var RoomsManager_reducer = function reducer(state, action) {
  switch (action.type) {
    case ADD_ROOM_ACTION:
      return _objectSpread(_objectSpread({}, state), {}, {
        rooms: [].concat(Object(toConsumableArray["a" /* default */])(state.rooms), [{
          id: state.nextRoomId
        }]),
        nextRoomId: state.nextRoomId + 1
      });

    case DELETE_ROOM_ACTION:
      return _objectSpread(_objectSpread({}, state), {}, {
        rooms: state.rooms.filter(function (_ref) {
          var id = _ref.id;
          return id !== action.payload.roomId;
        })
      });

    default:
      return state;
  }
};

var RoomsManager_RoomsManager = function RoomsManager(_ref2) {
  var resort = _ref2.resort,
      proposal = _ref2.proposal,
      _onSubmit = _ref2.onSubmit;
  var tripAttendees = Object(es["e" /* useSelector */])(storeHelper["d" /* tripInformationSelector */]);
  var connectedUser = Object(es["e" /* useSelector */])(booking_selector["j" /* getConnectedUserInfoSelector */]);
  var attendeesWithUserInfos = Object(booking_selector["a" /* addUserInfosToAttendees */])(proposal.attendees, tripAttendees, connectedUser);
  var attendeesWithDistributionData = Object(AttendeesDistributionUtils["b" /* addDistributionDataToAttendees */])([].concat(Object(toConsumableArray["a" /* default */])(attendeesWithUserInfos.adults), Object(toConsumableArray["a" /* default */])(attendeesWithUserInfos.children)), proposal.arrivalDate);
  var initialRooms = [];

  for (var roomId = 1; roomId <= proposal.accommodationsCount; roomId++) {
    initialRooms.push({
      id: roomId
    });
  }

  var _useReducer = Object(react["useReducer"])(RoomsManager_reducer, {
    rooms: initialRooms,
    nextRoomId: initialRooms.length + 1
  }),
      rooms = _useReducer[0].rooms,
      dispatch = _useReducer[1];

  var attendeesShape = attendeesWithDistributionData.reduce(function (schema, attendee) {
    schema[attendee.id] = lib["string"]().min(1).required();
    return schema;
  }, {});
  var validationSchema = lib["object"]().shape({
    attendees: lib["object"]().shape(attendeesShape)
  });
  var comfortsWithCategories = roomsManager_utils_getRoomComforts(resort);
  var initialValues = roomsManager_utils_getInitialFormValues(proposal, comfortsWithCategories);
  var initialRoomsConfiguration = roomsManager_utils_processFormValues(initialValues, attendeesWithDistributionData, comfortsWithCategories);
  return RoomsManager_jsx(formik_esm["d" /* Formik */], {
    initialValues: initialValues,
    onSubmit: function onSubmit(values, _ref3) {
      var setStatus = _ref3.setStatus;
      var roomsToSubmit = roomsManager_utils_processFormValues(values, attendeesWithDistributionData, comfortsWithCategories);
      var isAdultMissing = roomsToSubmit.some(function (room) {
        return !room.hasAdults;
      });
      setStatus({
        adultMissingError: isAdultMissing
      });

      if (!isAdultMissing) {
        var body = roomsToSubmit.map(function (room) {
          return {
            attendees: room.attendees,
            categories: room.comfortCategories
          };
        });

        _onSubmit(body);
      }
    },
    isInitialValid: initialRoomsConfiguration && initialRoomsConfiguration.length && initialRoomsConfiguration.every(function (room) {
      return room.hasAdults;
    }),
    validationSchema: validationSchema,
    render: function render(formik) {
      return RoomsManager_jsx("div", {
        "data-testid": "RoomsManager-wrapper"
      }, RoomsManager_jsx("div", {
        className: "py-px40 text-center font-bold text-blue text-5xl"
      }, Object(src_i18n["g" /* t */])('booking.accommodation.moreRooms.seller.roomManagementTitle')), RoomsManager_jsx("div", null, RoomsManager_jsx("div", {
        className: "py-px20 font-bold text-blue text-xl"
      }, Object(src_i18n["g" /* t */])('booking.accommodation.moreRooms.seller.roomManagementSubtitle')), RoomsManager_jsx("div", {
        className: "flex flex-wrap"
      }, rooms.map(function (_ref4, index) {
        var id = _ref4.id;
        return RoomsManager_jsx(RoomConfigurator_RoomConfigurator, {
          attendees: attendeesWithDistributionData,
          comforts: comfortsWithCategories,
          formik: formik,
          key: id,
          roomNumber: index + 1,
          roomId: id,
          onClose: function onClose() {
            // remove attendees values from the removed room
            var reassignRemovedAttendeesToRoom1 = Object.fromEntries(Object.entries(formik.values.attendees).map(function (_ref5) {
              var _ref6 = Object(slicedToArray["a" /* default */])(_ref5, 2),
                  attendeeId = _ref6[0],
                  selectedRoomId = _ref6[1];

              return selectedRoomId === "room-".concat(id) ? [attendeeId, 'room-1'] : [attendeeId, selectedRoomId];
            }));
            formik.setFieldValue('attendees', reassignRemovedAttendeesToRoom1);
            dispatch({
              type: DELETE_ROOM_ACTION,
              payload: {
                roomId: id
              }
            });
          }
        });
      }), rooms.length < proposal.attendees.adults.length ? RoomsManager_jsx(AddRoomBloc_AddRoomBloc, {
        onClick: function onClick() {
          dispatch({
            type: ADD_ROOM_ACTION
          });
        }
      }) : null)), formik.status && formik.status.adultMissingError && RoomsManager_jsx(FormFeedback["a" /* FormFeedback */], {
        className: "justify-center",
        isError: true,
        message: Object(src_i18n["g" /* t */])('booking.accommodation.moreRooms.seller.kidErrorMessage')
      }), RoomsManager_jsx("div", {
        className: "flex justify-center"
      }, RoomsManager_jsx(Button["a" /* Button */], {
        colorBg: colors["a" /* COLORS */].TURQUOISE,
        colorBorder: colors["a" /* COLORS */].TURQUOISE,
        isDisabled: !formik.isValid,
        dataTestId: "searchMoreRooms",
        trackingData: {
          versionBooking: 'responsive',
          categoryGA: 'bookingEngine',
          actionGA: 'moreRooms',
          labelGA: 'CTA_RoomManagement'
        },
        onClick: formik.submitForm
      }, Object(src_i18n["g" /* t */])('booking.accommodation.moreRooms.seller.seeProposals'))));
    }
  });
};
// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/utils/booking/bookingUtils.js
var bookingUtils = __webpack_require__("aWOT");

// EXTERNAL MODULE: ./src/client/components/utils/identifiers/constants.js
var constants = __webpack_require__("YZTm");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-stickynode/dist/Sticky.js
var Sticky = __webpack_require__("Phb7");
var Sticky_default = /*#__PURE__*/__webpack_require__.n(Sticky);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/widgets/flex-rates/FlexRates.jsx + 1 modules
var FlexRates = __webpack_require__("ExLU");

// EXTERNAL MODULE: ./src/client/components/widgets/navigation/Navigation.constants.js
var Navigation_constants = __webpack_require__("1cDg");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/proposals.action.js + 1 modules
var proposals_action = __webpack_require__("AnR0");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/index.js
var tracking_api = __webpack_require__("d1HQ");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngine.utils.js
var BookingEngine_utils = __webpack_require__("47Eh");

// EXTERNAL MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.jsx + 1 modules
var AsyncLoader = __webpack_require__("4A3Y");

// EXTERNAL MODULE: ./src/client/components/widgets/filters-bar/FiltersBar.jsx + 3 modules
var FiltersBar = __webpack_require__("jFIS");

// EXTERNAL MODULE: ./src/client/components/widgets/additional-accommodations/AdditionalAccommodationsUtils.js
var AdditionalAccommodationsUtils = __webpack_require__("CwJu");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// CONCATENATED MODULE: ./src/client/components/widgets/additional-accommodations/AdditionalAccommodations.tracking.js


function AdditionalAccommodations_tracking_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function AdditionalAccommodations_tracking_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      AdditionalAccommodations_tracking_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      AdditionalAccommodations_tracking_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




function trackSelectRoom(accommodationsSet, appContext) {
  var categoryId = Object(lodash["get"])(accommodationsSet, 'accommodations[0].categoryId');
  tracking_api["b" /* setDataLayer */](AdditionalAccommodations_tracking_objectSpread(AdditionalAccommodations_tracking_objectSpread({}, tracking_constants["i" /* GA_DEFAULT_PAYLOAD */]), {}, {
    versionBooking: 'responsive',
    categoryGA: 'bookingEngine',
    actionGA: 'moreRooms',
    labelGA: "confirmRoom_".concat(tracking_constants["q" /* PROPOSAL_CATEGORIES */][categoryId])
  }), appContext);
}
// EXTERNAL MODULE: ./src/client/components/widgets/confirmation/Confirmation.jsx
var Confirmation = __webpack_require__("Fmrk");

// EXTERNAL MODULE: ./src/client/components/utils/style/style.util.js
var style_util = __webpack_require__("5pZ8");

// EXTERNAL MODULE: ./src/client/components/widgets/accommodations/BookingAccommodations.jsx + 18 modules
var BookingAccommodations = __webpack_require__("cuVd");

// EXTERNAL MODULE: ./src/client/components/widgets/double-col-layer/DoubleColLayer.jsx
var DoubleColLayer = __webpack_require__("obLz");

// EXTERNAL MODULE: ./src/client/components/widgets/paginate/Paginate.jsx + 1 modules
var Paginate = __webpack_require__("aGPO");

// EXTERNAL MODULE: ./src/client/components/frameworks/strip-button/StripButton.jsx + 1 modules
var StripButton = __webpack_require__("ZpYc");

// CONCATENATED MODULE: ./src/client/components/widgets/additional-accommodations/list/AdditionalAccommodationsListUtils.js


function getNbAccommodations(accommodationsSet) {
  return Object(lodash["get"])(accommodationsSet, 'accommodations', []).reduce(function (acc, accommodation) {
    return acc + Object(lodash["get"])(accommodation, 'quantity', 0);
  }, 0);
}


// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// CONCATENATED MODULE: ./src/client/components/widgets/additional-accommodations/list/PriceLabel.jsx
var PriceLabel_jsx = react_default.a.createElement;





var PriceLabel_PriceLabel = function PriceLabel(_ref) {
  var _i18n$booking, _i18n$booking$accommo, _i18n$booking$accommo2, _i18n$booking2, _i18n$booking2$accomm, _i18n$booking2$accomm2;

  var accommodationsSet = _ref.accommodationsSet,
      i18n = _ref.i18n,
      proposal = _ref.proposal;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var differentialPrice = accommodationsSet.differentialPriceByNight || {};
  var totalDifferentialPrice = accommodationsSet.totalDifferentialPrice || {};
  var shouldDisplayPricePerNightB2C = i18n === null || i18n === void 0 ? void 0 : (_i18n$booking = i18n.booking) === null || _i18n$booking === void 0 ? void 0 : (_i18n$booking$accommo = _i18n$booking.accommodation) === null || _i18n$booking$accommo === void 0 ? void 0 : (_i18n$booking$accommo2 = _i18n$booking$accommo.moreRooms) === null || _i18n$booking$accommo2 === void 0 ? void 0 : _i18n$booking$accommo2.displayPricePerNight_B2C;
  var shouldDisplayPricePerNightB2B = i18n === null || i18n === void 0 ? void 0 : (_i18n$booking2 = i18n.booking) === null || _i18n$booking2 === void 0 ? void 0 : (_i18n$booking2$accomm = _i18n$booking2.accommodation) === null || _i18n$booking2$accomm === void 0 ? void 0 : (_i18n$booking2$accomm2 = _i18n$booking2$accomm.moreRooms) === null || _i18n$booking2$accomm2 === void 0 ? void 0 : _i18n$booking2$accomm2.displayPricePerNight_B2B;
  var shouldDisplayPricePerNight = !Object(sellerUtils["g" /* isSeller */])(appContext) && shouldDisplayPricePerNightB2C || Object(sellerUtils["g" /* isSeller */])(appContext) && shouldDisplayPricePerNightB2B;
  var label = null;

  if (shouldDisplayPricePerNight) {
    if (differentialPrice.value !== 0) {
      label = PriceLabel_jsx("span", {
        className: "rtl:ml-px5",
        "data-testid": "AdditionalAccommodationsList-itemPriceLabel-itemPricePerNightLabel"
      }, Object(src_i18n["g" /* t */])('booking.accommodation.moreRooms.perNight'));
    } else {
      label = PriceLabel_jsx("span", {
        className: "rtl:ml-px5",
        "data-testid": "AdditionalAccommodationsList-itemPriceLabel-itemPriceMentions"
      }, Object(src_i18n["g" /* t */])('booking.accommodation.moreRooms.includedRoom'));
    }
  } else if (totalDifferentialPrice.value === 0) {
    label = PriceLabel_jsx("span", {
      className: "rtl:ml-px5",
      "data-testid": "AdditionalAccommodationsList-itemPriceLabel-itemPriceMentions"
    }, Object(src_i18n["g" /* t */])('booking.accommodation.moreRooms.includedRoom'));
  }

  var locale = appContext.locale;

  var _ref2 = shouldDisplayPricePerNight ? differentialPrice : totalDifferentialPrice,
      price = _ref2.value;

  return PriceLabel_jsx("div", {
    className: "font-bold text-lg text-turquoise",
    "data-testid": "AdditionalAccommodationsList-itemPriceLabel"
  }, Object(proposalUtils["g" /* getFormatedPriceByLocale */])(price, locale, proposal.price.currency), label);
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-accommodations/list/AdditionalAccommodationsList.jsx
var AdditionalAccommodationsList_jsx = react_default.a.createElement;














var AdditionalAccommodationsList_AdditionalAccommodationsList = function AdditionalAccommodationsList(_ref) {
  var accommodationsSets = _ref.accommodationsSets,
      filteredAccommodationSets = _ref.filteredAccommodationSets,
      i18n = _ref.i18n,
      onAddAccommodation = _ref.onAddAccommodation,
      proposal = _ref.proposal,
      resort = _ref.resort,
      selectedRate = _ref.selectedRate,
      setSelectedRate = _ref.setSelectedRate;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet; // TODO: Remove after fixing related tests


  var deprecatedDataSelector = 'AdditionalAccommodationsList';
  var headerHeight = Object(style_util["a" /* remToPx */])(5);
  var titleAndButtonHeights = Object(style_util["a" /* remToPx */])(5) * 2;
  var iterationNumber = 5;

  var _useState = Object(react["useState"])(iterationNumber),
      forceInitialShowingItemsNumber = _useState[0],
      setForceInitialShowingItemsNumber = _useState[1];

  return accommodationsSets.length > 0 && AdditionalAccommodationsList_jsx(DoubleColLayer["a" /* DoubleColLayer */], {
    leftButtonLabel: Object(src_i18n["g" /* t */])('booking.accommodation.moreRooms.roomRecommendation'),
    rightButtonLabel: "".concat(Object(src_i18n["g" /* t */])('booking.accommodation.moreRooms.otherProposals'), " (").concat(filteredAccommodationSets.length, "\n    )"),
    initialActiveCol: isTablet ? DoubleColLayer["d" /* START_COL_CMP */] : DoubleColLayer["b" /* END_COL_CMP */]
  }, AdditionalAccommodationsList_jsx(DoubleColLayer["e" /* StartCol */], null, AdditionalAccommodationsList_jsx("h3", {
    className: "hidden sm:flex font-bold font-sans items-center mb-px20 reset-heading text-emerald text-md"
  }, AdditionalAccommodationsList_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-px5",
    name: icons["a" /* ICONS */].CHECK,
    width: "0.8em"
  }), Object(src_i18n["g" /* t */])('booking.accommodation.moreRooms.roomRecommendation')), AdditionalAccommodationsList_jsx("div", {
    className: "bg-white border-1 border-gray-light rounded-tiny"
  }, AdditionalAccommodationsList_jsx("div", {
    className: "overflow-y-auto",
    style: {
      maxHeight: isTablet ? "calc(100vh - ".concat(headerHeight, "px - ").concat(titleAndButtonHeights, "px)") : undefined
    }
  }, AdditionalAccommodationsList_jsx(BookingAccommodations["a" /* BookingAccommodations */], {
    accommodations: proposal.accommodations,
    isInMoreRoomLayer: true,
    proposal: proposal,
    resort: resort,
    selectedRate: selectedRate,
    setSelectedRate: setSelectedRate,
    theme: "medium"
  })), AdditionalAccommodationsList_jsx("div", {
    className: "border-t-1 flex items-center justify-center p-px20"
  }, AdditionalAccommodationsList_jsx(Button["a" /* Button */], {
    colorBg: colors["a" /* COLORS */].BLUE,
    colorBorder: colors["a" /* COLORS */].BLUE,
    onClick: onAddAccommodation ? onAddAccommodation() : undefined
  }, Object(src_i18n["g" /* t */])('common.confirm'))))), AdditionalAccommodationsList_jsx(DoubleColLayer["c" /* EndCol */], {
    dataTestId: "AdditionalAccommodationsList"
  }, AdditionalAccommodationsList_jsx("h3", {
    className: "font-bold font-sans hidden sm:block mb-px40 reset-heading text-md text-turquoise"
  }, filteredAccommodationSets.length, "\xA0", Object(src_i18n["g" /* t */])('booking.accommodation.moreRooms.otherProposals')), AdditionalAccommodationsList_jsx(Paginate["a" /* Paginate */], {
    forceInitialShowingItemsNumber: !isTablet ? forceInitialShowingItemsNumber : 0,
    iterationNumber: iterationNumber,
    seeMoreLabel: Object(src_i18n["g" /* t */])('booking.accommodation.moreRooms.otherProposals'),
    setForceInitialShowingItemsNumber: setForceInitialShowingItemsNumber
  }, filteredAccommodationSets.map(function (accommodationsSet) {
    return AdditionalAccommodationsList_jsx("div", {
      className: "bg-white border-1 border-gray-light mb-px40 relative rounded-tiny z-0",
      "data-testid": "AdditionalAccommodationOption",
      key: accommodationsSet.id
    }, AdditionalAccommodationsList_jsx("div", {
      className: "absolute bottom-full mx-px10 z-1"
    }, AdditionalAccommodationsList_jsx(StripButton["a" /* StripButton */], {
      className: "font-brand text-xs",
      height: 20
    }, Object(src_i18n["g" /* t */])('common.proposalLabel'), "\xA0", accommodationsSet.accommodationSetNumber)), AdditionalAccommodationsList_jsx(BookingAccommodations["a" /* BookingAccommodations */], {
      accommodations: accommodationsSet.accommodations,
      accommodationsCount: getNbAccommodations(accommodationsSet),
      isInMoreRoomLayer: true,
      proposal: proposal,
      remainingStock: accommodationsSet.remainingStock,
      resort: resort,
      selectedRate: selectedRate,
      setSelectedRate: setSelectedRate,
      theme: "medium"
    }), AdditionalAccommodationsList_jsx("div", {
      className: "border-t-1 flex items-center justify-end p-px20",
      "data-testid": "".concat(deprecatedDataSelector, "-itemFooter")
    }, AdditionalAccommodationsList_jsx(PriceLabel_PriceLabel, {
      accommodationsSet: accommodationsSet,
      i18n: i18n,
      proposal: proposal
    }), AdditionalAccommodationsList_jsx(Button["a" /* Button */], {
      className: "rtl:ml-px10 w-auto",
      colorBg: colors["a" /* COLORS */].TURQUOISE,
      colorBorder: colors["a" /* COLORS */].TURQUOISE,
      dataTestId: "".concat(deprecatedDataSelector, "-select"),
      onClick: onAddAccommodation ? onAddAccommodation(accommodationsSet.id) : undefined
    }, Object(src_i18n["g" /* t */])('booking.accommodation.moreRooms.selectNewRoom'))));
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-accommodations/list/AdditionalAccommodationsListWrapper.jsx
var AdditionalAccommodationsListWrapper_jsx = react_default.a.createElement;








var AdditionalAccommodationsListWrapper_AdditionalAccommodationsListWrapper = function AdditionalAccommodationsListWrapper(_ref) {
  var error = _ref.error,
      proposal = _ref.proposal,
      accommodationsSets = _ref.accommodationsSets,
      filteredAccommodationSets = _ref.filteredAccommodationSets,
      onAddAccommodation = _ref.onAddAccommodation,
      resort = _ref.resort,
      i18n = _ref.i18n,
      isDataFetched = _ref.isDataFetched,
      selectedRate = _ref.selectedRate,
      setSelectedRate = _ref.setSelectedRate;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var _useContext = Object(react["useContext"])(ReactAppContext["a" /* default */]),
      isCmta = _useContext.isCmta;

  if (Object(lodash["isEmpty"])(error)) {
    return AdditionalAccommodationsListWrapper_jsx(react["Fragment"], null, isDataFetched && accommodationsSets.length === 0 && AdditionalAccommodationsListWrapper_jsx("div", {
      className: "max-w-site-small mb-px40 mx-auto"
    }, AdditionalAccommodationsListWrapper_jsx(Confirmation["a" /* Confirmation */], {
      icon: icons["a" /* ICONS */].CIRCLED_ACCOMMODATION,
      status: "neutral",
      text: Object(src_i18n["g" /* t */])('booking.accommodation.moreRooms.noMoreRoomsAvailableDescription'),
      title: Object(src_i18n["g" /* t */])('booking.accommodation.moreRooms.noMoreRoomsAvailableTitle')
    })), AdditionalAccommodationsListWrapper_jsx(AdditionalAccommodationsList_AdditionalAccommodationsList, {
      i18n: i18n,
      accommodationsSets: accommodationsSets,
      filteredAccommodationSets: filteredAccommodationSets,
      proposal: proposal,
      onAddAccommodation: onAddAccommodation,
      isDesktop: isDesktop,
      resort: resort,
      selectedRate: selectedRate,
      setSelectedRate: setSelectedRate
    }));
  }

  return AdditionalAccommodationsListWrapper_jsx("div", {
    className: "max-w-site-small mx-auto"
  }, AdditionalAccommodationsListWrapper_jsx(Confirmation["a" /* Confirmation */], {
    status: "error",
    text: Object(src_i18n["g" /* t */])("booking.".concat(isCmta ? 'partners.transport' : 'common.layer', ".unknownErrorDescription")),
    title: Object(src_i18n["g" /* t */])('booking.common.layer.unknownErrorTitle')
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-accommodations/AdditionalAccommodations.jsx
var AdditionalAccommodations_jsx = react_default.a.createElement;






















var AdditionalAccommodations_AdditionalAccommodations = function AdditionalAccommodations(_ref) {
  var filters = _ref.filters,
      filterValues = _ref.filterValues,
      i18n = _ref.i18n,
      _ref$loaderStyle = _ref.loaderStyle,
      loaderStyle = _ref$loaderStyle === void 0 ? {
    marginTop: '25vh'
  } : _ref$loaderStyle,
      onClose = _ref.onClose,
      _ref$onSubmit = _ref.onSubmit,
      onSubmit = _ref$onSubmit === void 0 ? lodash["noop"] : _ref$onSubmit,
      _ref$processChangeAcc = _ref.processChangeAccommodation,
      processChangeAccommodation = _ref$processChangeAcc === void 0 ? true : _ref$processChangeAcc,
      proposal = _ref.proposal,
      resort = _ref.resort,
      selectedRate = _ref.selectedRate,
      setSelectedRate = _ref.setSelectedRate,
      switchOffers = _ref.switchOffers;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var dispatch = Object(es["d" /* useDispatch */])();

  var _useState = Object(react["useState"])(false),
      isSticky = _useState[0],
      setIsSticky = _useState[1];

  var isLoading = Object(es["e" /* useSelector */])(booking_selector["r" /* getIsLoadingAdditionalAccommodations */]) || false;
  var accommodationsSets = Object(es["e" /* useSelector */])(booking_selector["c" /* getAdditionalAccommodations */]) || [];
  var filteredAccommodationSets = Object(es["e" /* useSelector */])(booking_selector["p" /* getFilteredAdditionalAccommodationsSets */]);
  var error = Object(es["e" /* useSelector */])(booking_selector["d" /* getAdditionalAccommodationsError */]);
  var isDataFetched = Object(es["e" /* useSelector */])(function (state) {
    return state.booking.additionalAccommodations.isDataFetched;
  });
  var options = Object(FlexRates["b" /* getFlexRatesOptions */])(proposal, appContext, 'medium');
  var selectedOption = options.find(function (option) {
    return option.id === selectedRate;
  });
  var withoutProposalAccommodationSets = Object(AdditionalAccommodationsUtils["a" /* filterAccommodations */])(proposal, accommodationsSets) || [];

  var handleAddAccommodation = function handleAddAccommodation(accommodationId) {
    return function () {
      if (!accommodationId) {
        return onClose();
      } // $FlowFixMe there's always an AccommodationsSet


      var accommodationSet = Object(lodash["find"])(withoutProposalAccommodationSets, {
        id: accommodationId
      });
      var arrangement = accommodationSet.accommodations.map(function (_ref2) {
        var attendeesDistribution = _ref2.attendeesDistribution;
        return attendeesDistribution;
      }).filter(Boolean);

      if (!processChangeAccommodation) {
        return onSubmit(arrangement);
      }

      trackSelectRoom(accommodationSet, appContext);
      onSubmit(proposal.id);
      dispatch(Object(proposals_action["a" /* addAccommodation */])({
        arrangement: arrangement,
        globalLoaderLabel: i18n.booking.accommodation.moreRooms.loaderLabelUpdate,
        isJoyview: resort.isJoyview,
        proposalsId: Object(BookingEngine_utils["a" /* getAllProposalsIdWithAlternative */])(proposal),
        toastLabel: Object(bookingUtils["b" /* tAlt */])({
          cruiseKeyPath: 'booking.accommodation.newCabinSelection',
          resort: resort,
          resortKeyPath: 'booking.accommodation.newRoomSelection'
        }),
        appContext: appContext
      })).then(function () {
        if (selectedRate !== proposal.price.selectedRate) {
          // $FlowFixMe offers always defined
          switchOffers(selectedOption.offers);
        }
      });
    };
  };

  Object(react["useEffect"])(function () {
    setTimeout(function () {
      var target = document.querySelector('[data-scroll-anchor="loaderAdditionalAccommodations"]');

      if (target) {
        target.scrollIntoView(); // the header is on top of the element that we targeted, so we have to scroll down the height of the header

        var container = document.querySelector('.scroll-y');

        if (container) {
          container.scrollTop -= Navigation_constants["e" /* heights */].NAVIGATION_LARGE_HEIGHT;
        }
      }
    }, 100);
  }, [isLoading]);
  var onStateChange = Object(react["useCallback"])(function (status) {
    setIsSticky(status.status !== Sticky_default.a.STATUS_ORIGINAL);
  }, []);
  return isLoading ? AdditionalAccommodations_jsx(AsyncLoader["a" /* AsyncLoader */], {
    "data-scroll-anchor": "loaderAdditionalAccommodations",
    icon: icons["a" /* ICONS */].STANDALONE_MAGNIFYING_GLASS,
    iconSize: "3rem",
    label: Object(bookingUtils["b" /* tAlt */])({
      cruiseKeyPath: 'booking.accommodation.moreRooms.moreCabinLoaderLabel',
      resort: resort,
      resortKeyPath: 'booking.accommodation.moreRooms.moreRoomLoaderLabel'
    }),
    style: loaderStyle,
    theme: "labeled"
  }) : AdditionalAccommodations_jsx(react["Fragment"], null, AdditionalAccommodations_jsx(Sticky_default.a, {
    className: "mt-px15 md:mt-px30",
    enabled: isTablet,
    innerZ: 2,
    onStateChange: onStateChange,
    top: 60
  }, AdditionalAccommodations_jsx(FiltersBar["a" /* FiltersBar */], {
    caption: Object(src_i18n["g" /* t */])('filters.label'),
    dataTestid: "AccommodationsFilters",
    forceClose: isSticky,
    filters: filters,
    isLarge: isSticky,
    onChange: function onChange(name, opts, updatedValue) {
      if (filterValues && updatedValue) {
        var f = filterValues.find(function (v) {
          return v.value === updatedValue;
        });
        dispatch(Object(additionalAccommodations_action["i" /* toggleAdditionalAccommodationFilter */])(f));
      }
    },
    onClear: function onClear(name) {
      dispatch(Object(additionalAccommodations_action["j" /* unselectAdditionalAccommodationsFilterCategory */])(name));
    },
    onClick: function onClick(name) {
      Object(tracking_api["b" /* setDataLayer */])({
        actionGA: 'moreRooms',
        labelGA: "filter_".concat(name),
        versionBooking: 'responsive'
      }, appContext, 'bookingEngine');
    },
    portalName: "AccommodationsFilterOptions"
  })), AdditionalAccommodations_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "mt-px30"
  }, AdditionalAccommodations_jsx(AdditionalAccommodationsListWrapper_AdditionalAccommodationsListWrapper, {
    accommodationsSets: withoutProposalAccommodationSets,
    error: error,
    filteredAccommodationSets: filteredAccommodationSets,
    i18n: i18n,
    isDataFetched: isDataFetched,
    onAddAccommodation: handleAddAccommodation,
    proposal: proposal,
    resort: resort,
    selectedRate: selectedRate,
    setSelectedRate: setSelectedRate
  })));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/layer/Layer.jsx + 4 modules
var Layer = __webpack_require__("U2fG");

// EXTERNAL MODULE: ./src/client/components/widgets/layer-header-proposal/LayerHeaderProposal.jsx
var LayerHeaderProposal = __webpack_require__("U/+3");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.jsx
var Portal = __webpack_require__("3uBn");

// CONCATENATED MODULE: ./src/client/components/widgets/additional-accommodations/layers/AdditionalAccommodationsLayer.jsx
var AdditionalAccommodationsLayer_jsx = react_default.a.createElement;









var AdditionalAccommodationsLayer_AdditionalAccommodationsLayer = function AdditionalAccommodationsLayer(_ref) {
  var children = _ref.children,
      filters = _ref.filters,
      filterValues = _ref.filterValues,
      i18n = _ref.i18n,
      onClose = _ref.onClose,
      onSubmit = _ref.onSubmit,
      _ref$processChangeAcc = _ref.processChangeAccommodation,
      processChangeAccommodation = _ref$processChangeAcc === void 0 ? true : _ref$processChangeAcc,
      proposal = _ref.proposal,
      resort = _ref.resort,
      selectedRate = _ref.selectedRate,
      setSelectedRate = _ref.setSelectedRate,
      switchOffers = _ref.switchOffers;
  var layerTitle = Object(bookingUtils["b" /* tAlt */])({
    cruiseKeyPath: 'booking.accommodation.moreRooms.modifyHeaderTitleCruise',
    resort: resort,
    resortKeyPath: 'booking.accommodation.moreRooms.modifyHeaderTitle'
  });
  return AdditionalAccommodationsLayer_jsx(Portal["a" /* default */], null, AdditionalAccommodationsLayer_jsx(Layer["b" /* Layer */], {
    ariaLabel: layerTitle,
    ariaLabelledby: constants["a" /* ID_LAYER_HEADER__BE__ACCOMMODATIONS */],
    buttonLeft: {
      iconName: icons["a" /* ICONS */].LEFT_ARROW,
      label: Object(src_i18n["g" /* t */])('common.backNavigation'),
      onClick: onClose
    },
    closeLabel: Object(src_i18n["g" /* t */])('common.close'),
    hasContainerHeader: true,
    header: AdditionalAccommodationsLayer_jsx(LayerHeaderProposal["a" /* LayerHeaderProposal */], {
      id: constants["a" /* ID_LAYER_HEADER__BE__ACCOMMODATIONS */],
      layerTitle: layerTitle,
      proposal: proposal,
      totalPrice: Object(src_i18n["g" /* t */])('booking.accommodation.moreRooms.totalPackagePriceLabel')
    }),
    onClose: onClose
  }, children, AdditionalAccommodationsLayer_jsx(AdditionalAccommodations_AdditionalAccommodations, {
    filters: filters,
    filterValues: filterValues,
    i18n: i18n,
    loaderStyle: {
      marginTop: '10vh'
    },
    onClose: onClose,
    onSubmit: onSubmit,
    processChangeAccommodation: processChangeAccommodation,
    proposal: proposal,
    resort: resort,
    selectedRate: selectedRate,
    setSelectedRate: setSelectedRate,
    switchOffers: switchOffers
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-accommodations/layers/SellerLayer.jsx
var SellerLayer_jsx = react_default.a.createElement;










var SellerLayer_SellerLayer = function SellerLayer(props) {
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var dispatch = Object(es["d" /* useDispatch */])();

  var _useState = Object(react["useState"])(props.proposal.attendees.adults.length === 1),
      hasAllAccommodations = _useState[0],
      setHasAllAccommodations = _useState[1];

  Object(react["useEffect"])(function () {
    if (props.proposal.attendees.adults.length === 1) {
      dispatch(Object(additionalAccommodations_action["h" /* fetchAdditionalAccommodations */])({
        appContext: appContext,
        proposal: props.proposal,
        resort: props.resort
      }));
    }

    return function () {
      dispatch(Object(additionalAccommodations_action["g" /* clearAdditionalAccommodations */])());
    };
  }, [props.proposal.attendees.adults.length]);
  return SellerLayer_jsx(AdditionalAccommodationsLayer_AdditionalAccommodationsLayer, props, SellerLayer_jsx(SiteContainer["a" /* SiteContainer */], null, props.proposal.attendees.adults.length > 1 && SellerLayer_jsx(RoomsManager_RoomsManager, {
    onSubmit: function onSubmit(roomsArrangement) {
      dispatch(Object(additionalAccommodations_action["h" /* fetchAdditionalAccommodations */])({
        appContext: appContext,
        proposal: props.proposal,
        resort: props.resort,
        roomsArrangement: roomsArrangement,
        shouldPreselectFilters: false
      }));
      setHasAllAccommodations(false);
    },
    proposal: props.proposal,
    resort: props.resort
  }), SellerLayer_jsx("div", {
    className: "mt-px80 mb-px30 text-center font-bold text-blue text-5xl"
  }, Object(src_i18n["g" /* t */])('booking.accommodation.moreRooms.seller.roomProposalTitle')), !hasAllAccommodations && SellerLayer_jsx("div", {
    className: "flex justify-center mt-px30",
    "data-testid": "AllAccommodations-button"
  }, SellerLayer_jsx(Button["a" /* Button */], {
    colorBg: colors["a" /* COLORS */].TURQUOISE,
    colorBorder: colors["a" /* COLORS */].TURQUOISE,
    trackingData: {
      actionGA: 'moreRooms',
      categoryGA: 'bookingEngine',
      labelGA: 'CTA_RoomsProposal',
      versionBooking: 'responsive'
    },
    dataTestId: "searchAllMoreRooms",
    onClick: function onClick() {
      dispatch(Object(additionalAccommodations_action["h" /* fetchAdditionalAccommodations */])({
        appContext: appContext,
        proposal: props.proposal,
        resort: props.resort
      }));
      setHasAllAccommodations(true);
    }
  }, Object(src_i18n["g" /* t */])('booking.accommodation.moreRooms.seller.seeAllProposals')))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/additional-accommodations/layers/UserLayer.jsx
var UserLayer_jsx = react_default.a.createElement;





var UserLayer_UserLayer = function UserLayer(props) {
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var dispatch = Object(es["d" /* useDispatch */])();
  Object(react["useEffect"])(function () {
    dispatch(Object(additionalAccommodations_action["h" /* fetchAdditionalAccommodations */])({
      appContext: appContext,
      proposal: props.proposal,
      resort: props.resort
    }));
    return function () {
      dispatch(Object(additionalAccommodations_action["g" /* clearAdditionalAccommodations */])());
    };
  }, []);
  return UserLayer_jsx(AdditionalAccommodationsLayer_AdditionalAccommodationsLayer, props);
};
// CONCATENATED MODULE: ./src/client/views/booking/accommodation/more-rooms/MoreRooms.jsx
var MoreRooms_jsx = react_default.a.createElement;







var MoreRooms_MoreRooms = function MoreRooms(_ref) {
  var i18n = _ref.i18n,
      onClose = _ref.onClose,
      onSubmit = _ref.onSubmit,
      _ref$processChangeAcc = _ref.processChangeAccommodation,
      processChangeAccommodation = _ref$processChangeAcc === void 0 ? true : _ref$processChangeAcc,
      proposal = _ref.proposal,
      resort = _ref.resort,
      switchOffers = _ref.switchOffers;

  var _useContext = Object(react["useContext"])(ReactAppContext["a" /* default */]),
      isSeller = _useContext.isSeller;

  var _useState = Object(react["useState"])(proposal.price.selectedRate),
      selectedRate = _useState[0],
      setSelectedRate = _useState[1];

  var filterValues = Object(es["e" /* useSelector */])(booking_selector["e" /* getAdditionalAccommodationsFilters */]);
  var filters = Object(filterUtils["b" /* getFilters */])(i18n, resort, filterValues || []);
  var props = {
    filters: filters,
    filterValues: filterValues,
    i18n: i18n,
    onClose: onClose,
    onSubmit: onSubmit,
    processChangeAccommodation: processChangeAccommodation,
    proposal: proposal,
    resort: resort,
    selectedRate: selectedRate,
    setSelectedRate: setSelectedRate,
    switchOffers: switchOffers
  };
  return isSeller ? MoreRooms_jsx(SellerLayer_SellerLayer, props) : MoreRooms_jsx(UserLayer_UserLayer, props);
};

/***/ }),

/***/ "LR4h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ LabeledIconsList_LabeledIconsList; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/labeled-icons-list/LabeledIconsList.themes.js
var themes = {
  "default": {
    thRoot: 'flex justify-center',
    thListRoot: 'reset-list flex flex-row py-px10',
    thListWidth: 'w-1/2',
    thItem: 'flex-1 font-bold font-sans leading-normal text-center text-current text-sm',
    thItemNth: 'border-l-1',
    thIcon: 'flex items-center justify-center leading-none',
    thIconWidth: '2.625rem',
    thLabels: 'mb-0 mt-px10 mx-px10'
  },
  list: {
    thRoot: 'flex',
    thListRoot: 'reset-list flex flex-col flex-wrap -mx-px10',
    thListWidth: 'w-1/2',
    thItem: 'flex items-start p-px10',
    thIcon: 'flex flex-shrink-0 items-center justify-center leading-none',
    thIconWidth: '1.375rem',
    thLabels: 'font-sans leading-normal px-px10 text-base text-gray-darker'
  },
  listCondensed: {
    thRoot: 'flex',
    thListRoot: 'reset-list flex flex-col flex-wrap -mx-px10',
    thListWidth: 'w-1/2',
    thItem: 'flex items-start p-px10',
    thIcon: 'flex flex-shrink-0 items-center justify-center leading-none',
    thIconWidth: '1.375rem',
    thLabels: 'font-sans leading-normal px-px10 text-base text-gray-darker'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/labeled-icons-list/LabeledIconsList.jsx



var __jsx = react_default.a.createElement;







var LabeledIconsList_LabeledIconsListItems = function LabeledIconsListItems(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref$color,
      isMoreThanOneList = _ref.isMoreThanOneList,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      _ref$withNthBorder = _ref.withNthBorder,
      withNthBorder = _ref$withNthBorder === void 0 ? false : _ref$withNthBorder;
  var _themes$theme = themes[theme],
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thItem = _themes$theme.thItem,
      thItemNth = _themes$theme.thItemNth,
      thLabels = _themes$theme.thLabels,
      thListRoot = _themes$theme.thListRoot,
      thListWidth = _themes$theme.thListWidth;
  return __jsx("ul", {
    className: classnames_default()("text-".concat(color), thListRoot, Object(defineProperty["a" /* default */])({}, thListWidth, isMoreThanOneList))
  }, items.map(function (_ref2, idx) {
    var icon = _ref2.icon,
        labels = _ref2.labels;
    return __jsx("li", {
      className: classnames_default()(thItem, Object(defineProperty["a" /* default */])({}, thItemNth, withNthBorder || idx > 0)),
      "data-testid": "LabeledIconsList-item",
      key: idx
    }, __jsx("div", {
      className: thIcon
    }, __jsx(Icon["a" /* Icon */], {
      name: icon,
      width: thIconWidth,
      alt: (labels || []).join('/')
    })), !!labels.length && __jsx("div", {
      className: thLabels
    }, labels.map(function (label) {
      return __jsx("div", {
        "data-testid": "LabeledIconsList-label",
        key: label
      }, label);
    })));
  }));
};

var LabeledIconsList_LabeledIconsList = function LabeledIconsList(props) {
  var _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items;

  if (!items.length) {
    return null;
  }

  var thRoot = themes[theme].thRoot;
  var splitItems = Object(lodash["chunk"])(Object(toConsumableArray["a" /* default */])(items), Math.ceil(items.length / 2));
  var isMoreThanOneList = splitItems.length > 1;
  return __jsx("div", {
    className: thRoot
  }, splitItems.map(function (splitItem, idx) {
    return __jsx(LabeledIconsList_LabeledIconsListItems, Object(esm_extends["a" /* default */])({}, props, {
      key: idx,
      isMoreThanOneList: isMoreThanOneList,
      items: splitItem,
      withNthBorder: idx !== 0
    }));
  }));
};

/***/ }),

/***/ "LTtw":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var getOwnPropertyDescriptor = __webpack_require__("5h8T").f;
var createNonEnumerableProperty = __webpack_require__("g51W");
var redefine = __webpack_require__("L1Xj");
var setGlobal = __webpack_require__("edYw");
var copyConstructorProperties = __webpack_require__("sfoL");
var isForced = __webpack_require__("wxLG");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "LhnV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TermsAndConditions; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ljKo");
/* harmony import */ var _frameworks_form_feedback_FormFeedback__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DwNm");
/* harmony import */ var _frameworks_capsule_Capsule__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jldR");
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("MWZw");
/* harmony import */ var _frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("/HC4");
/* harmony import */ var _utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("RUiN");
/* harmony import */ var _utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("aWOT");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("UCZK");
/* harmony import */ var _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("BU6i");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("kiXb");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;











var TermsAndConditions = function TermsAndConditions(_ref) {
  var i18n = _ref.i18n,
      shouldDisplayDonationTerms = _ref.shouldDisplayDonationTerms,
      shouldSubmitFormOnAccept = _ref.shouldSubmitFormOnAccept,
      isDisabled = _ref.isDisabled,
      _ref$hasNoPaymentMeth = _ref.hasNoPaymentMethods,
      hasNoPaymentMethods = _ref$hasNoPaymentMeth === void 0 ? false : _ref$hasNoPaymentMeth;
  var formik = Object(formik__WEBPACK_IMPORTED_MODULE_1__[/* useFormikContext */ "e"])();
  var legalMessage = Object(_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_7__[/* getCGVFromLegalInfos */ "a"])(i18n.bookingProcess);

  var submitFormOnAccept = function submitFormOnAccept(_ref2) {
    var currentTarget = _ref2.currentTarget;
    var shouldProceedToSubmit = currentTarget.checked && (!shouldDisplayDonationTerms || formik.values.termsAndConditions.donation || formik.values.termsAndConditions.cgv);

    if (shouldSubmitFormOnAccept && shouldProceedToSubmit && formik.values.paymentMethodId) {
      // submit form if asked and all the cgv are checked and a paymentMethodId is selected
      // should wait for validation to be done
      setTimeout(formik.submitForm, 0);
    }

    if (hasNoPaymentMethods && shouldProceedToSubmit && formik.values.paymentProviderId === _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_9__[/* HIPAY_PSP_ID */ "j"]) {
      setTimeout(function () {
        formik.submitForm();
        Object(_utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_6__[/* scrollToElement */ "a"])('#payment-form-iframe');
      }, 500);
    }
  };

  var hasCGVOrDonationError = formik.errors.termsAndConditions && formik.touched.termsAndConditions && (formik.errors.termsAndConditions.cgv && formik.touched.termsAndConditions.cgv || formik.errors.termsAndConditions.donation && formik.touched.termsAndConditions.donation);
  return __jsx(react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_4__[/* Title */ "a"], {
    className: "mb-px10",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_8__[/* COLORS */ "a"].BLUE,
    id: "termsAndConditionsTitleId",
    theme: "title-sans-4"
  }, legalMessage.label), __jsx(_frameworks_capsule_Capsule__WEBPACK_IMPORTED_MODULE_3__[/* Capsule */ "a"], null, __jsx("div", {
    className: "p-px20"
  }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_5__[/* FormikInput */ "a"], {
    ariaDescribedBy: "termsAndConditions-cgv-error",
    type: "checkbox",
    name: "termsAndConditions.cgv",
    label: __jsx(react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, __jsx("span", null, legalMessage.description), __jsx("br", null), __jsx("span", null, Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "g"])('booking.banking.termsAndConditions.acceptCGV'), ' ', __jsx("a", {
      className: "underline text-inherit",
      rel: "noreferrer noopener",
      target: "_blank",
      href: legalMessage.url
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "g"])('booking.banking.termsAndConditions.termsOfSales')))),
    isDisabled: isDisabled,
    isRequired: true,
    onChange: submitFormOnAccept
  }), shouldDisplayDonationTerms && __jsx("div", {
    className: "mt-px20"
  }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_5__[/* FormikInput */ "a"], {
    type: "checkbox",
    name: "termsAndConditions.donation",
    label: __jsx(react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "g"])('booking.banking.donation.acceptCGU'), ' ', __jsx("a", {
      className: "underline text-inherit",
      rel: "noreferrer noopener",
      target: "_blank",
      href: Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "g"])('booking.banking.donation.linkDonationTerms')
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "g"])('booking.banking.donation.donationTerms'))),
    isDisabled: isDisabled,
    isRequired: true,
    onChange: submitFormOnAccept
  })))), hasCGVOrDonationError && __jsx("div", {
    id: "termsAndConditions-cgv-error",
    "aria-live": "polite"
  }, __jsx(_frameworks_form_feedback_FormFeedback__WEBPACK_IMPORTED_MODULE_2__[/* FormFeedback */ "a"], {
    isError: true,
    message: Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "g"])('booking.banking.termsAndConditions.errorMessage')
  })));
};

/***/ }),

/***/ "LoHR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChildcareOnDemandEquipmentCapsule; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _frameworks_capsule_Capsule_jsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jldR");
/* harmony import */ var _frameworks_icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_collapse_panel_CollapsePanel_jsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("gA51");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_product_product_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("C9cF");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0__["createElement"];







/* eslint no-use-before-define: 0 */

var EQUIPMENT_ID_MAPPING = [{
  identifier: '_baby_sitting',
  matchedIcon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].BABYSITTING
}, {
  identifier: '_pyjamas_club',
  matchedIcon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].PAJAMAS
}, {
  identifier: '_teen_spa',
  matchedIcon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].SPA
}, {
  identifier: '_swimming_lessons',
  matchedIcon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].SWIMMINGPOOL
}, {
  identifier: '_pleasures_of_snow_course',
  matchedIcon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].SKI
}];

function getOnDemandEquipmentCapsuleIcon(id) {
  var iconName;
  EQUIPMENT_ID_MAPPING.forEach(function (item) {
    if (id.toLowerCase().includes(item.identifier)) {
      iconName = item.matchedIcon;
    }
  });
  return iconName;
}

function getEquipmentHeader(activity, props) {
  return __jsx("div", {
    className: "flex items-center"
  }, __jsx(_frameworks_icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_2__[/* Icon */ "a"], {
    name: getOnDemandEquipmentCapsuleIcon(activity.id) || _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].TRIDENT1,
    width: "calc(30rem / 16)",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].BLUE,
    className: "rtl:mr-px15 flex-shrink-0"
  }), __jsx("div", {
    className: "ChildcareOnDemandEquipmentCapsule-equipmentHeaderText"
  }, __jsx("div", {
    className: "ChildcareOnDemandEquipmentCapsule-equipmentHeaderLabel font-bold text-blue"
  }, activity.label), activity.ageInMonths ? __jsx("div", {
    className: "text-sm font-normal"
  }, Object(_utils_product_product_utils__WEBPACK_IMPORTED_MODULE_6__[/* getServiceAgesLabel */ "e"])(activity.ageInMonths, props.i18n)) : null));
}

function ChildcareOnDemandEquipmentCapsule(props) {
  return __jsx(_frameworks_capsule_Capsule_jsx__WEBPACK_IMPORTED_MODULE_1__[/* Capsule */ "a"], {
    header: "large",
    color: "#b95e06",
    label: props.i18n.booking.childcarePopIn.onDemandChildcare
  }, __jsx("div", {
    className: "text-base"
  }, __jsx("div", {
    className: "p-px20 font-bold"
  }, props.i18n.booking.services.childcare.additionalServicesReassuranceMessage), __jsx("div", null, props.activities.map(function (activity) {
    return __jsx("div", {
      key: activity.id,
      className: "font-bold border-t-1 border-gray-light"
    }, __jsx(_frameworks_collapse_panel_CollapsePanel_jsx__WEBPACK_IMPORTED_MODULE_3__[/* CollapsePanel */ "a"], {
      title: getEquipmentHeader(activity, props),
      theme: "limpidSmall",
      expandIconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].BOLDER_ARROW_FORTH_DOWN,
      collapseIconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].BOLDER_ARROW_FORTH_DOWN
    }, __jsx("div", {
      className: "leading-tight p-px20 pt-0"
    }, __jsx("div", {
      className: "flex font-normal"
    }, activity.description))));
  }))));
}

/***/ }),

/***/ "M3jp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterTransport; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_spinner_Spinner__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("7amT");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;







var FilterTransport = function FilterTransport(_ref) {
  var changeDepartureCity = _ref.changeDepartureCity,
      className = _ref.className,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'FilterTransport' : _ref$dataTestId,
      departureCity = _ref.departureCity,
      isDisabled = _ref.isDisabled,
      isLoading = _ref.isLoading,
      optionsDepartureCities = _ref.optionsDepartureCities,
      _ref$reassurance = _ref.reassurance,
      reassurance = _ref$reassurance === void 0 ? [] : _ref$reassurance,
      _ref$withIntroduction = _ref.withIntroduction,
      withIntroduction = _ref$withIntroduction === void 0 ? true : _ref$withIntroduction;
  var value = departureCity ? departureCity : '';
  var loading = isLoading || optionsDepartureCities.length === 0;
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, 'flex flex-col'),
    "data-testid": "FilterTransport"
  }, __jsx("div", {
    className: "border-b-1 p-px20 pb-px10"
  }, withIntroduction && __jsx("p", {
    className: "font-brand mb-px10 reset-paragraph text-base text-blue text-center"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "g"])('faceting.transport.introduction')), !!reassurance && !!reassurance.length && __jsx("ul", {
    className: "mb-px20 reset-list"
  }, reassurance.map(function (_ref2) {
    var iconName = _ref2.iconName,
        label = _ref2.label;
    return __jsx("li", {
      className: "flex items-center py-px5 text-sm",
      key: label
    }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__[/* Icon */ "a"], {
      className: "flex-shrink-0 rtl:mr-px10",
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].BLUE,
      name: iconName,
      width: "1.25rem"
    }), label);
  })), __jsx("p", {
    className: "font-bold reset-paragraph text-sm"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "g"])('faceting.when.from'))), loading ? __jsx("div", {
    className: "flex-1 flex items-center justify-center leading-none p-px20"
  }, __jsx(_frameworks_spinner_Spinner__WEBPACK_IMPORTED_MODULE_6__[/* Spinner */ "a"], {
    size: "small"
  })) : __jsx("ul", {
    className: "flex-1 lg:flex-none px-px20 py-px10 max-h-none lg:max-h-50vh overflow-y-auto reset-list text-base"
  }, optionsDepartureCities.map(function (o) {
    return __jsx("li", {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()({
        'font-bold text-success': o.value === value
      }),
      key: o.value
    }, __jsx("label", {
      className: "cursor-pointer flex items-baseline justify-between py-px5",
      htmlFor: o.value
    }, __jsx("input", {
      checked: o.value === value,
      className: "hidden",
      "data-testid": "".concat(dataTestId, "-").concat(o.value),
      disabled: o.isDisabled || isDisabled,
      id: o.value,
      name: "TransportSelectFilter",
      onChange: function onChange(e) {
        return changeDepartureCity(e.target.value);
      },
      type: "radio",
      value: o.value
    }), o.label, o.value === value && __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__[/* Icon */ "a"], {
      name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].CHECK,
      width: "0.625rem"
    })));
  })));
};

/***/ }),

/***/ "M4Qz":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("DZWw");
var toIndexedObject = __webpack_require__("dNjr");
var indexOf = __webpack_require__("5LiQ").indexOf;
var hiddenKeys = __webpack_require__("qXr/");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "MRpX":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var setPrototypeOf = __webpack_require__("iBXc");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});


/***/ }),

/***/ "MU85":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("3LIW");
var Iterators = __webpack_require__("oa0l");
var wellKnownSymbol = __webpack_require__("nJrx");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "MaE1":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");

module.exports = global;


/***/ }),

/***/ "Mn1B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getArrivalDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureDate; });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);


var tripDateCriteriaSelector = function tripDateCriteriaSelector(_ref) {
  var tripDateCriteria = _ref.tripDateCriteria;
  return tripDateCriteria || {};
};

var getArrivalDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripDateCriteriaSelector, function (_ref2) {
  var arrivalDate = _ref2.arrivalDate;
  return arrivalDate;
});
var getDepartureDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripDateCriteriaSelector, function (_ref3) {
  var departureDate = _ref3.departureDate;
  return departureDate;
});


/***/ }),

/***/ "MwrP":
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__("4uJK"),
    getTag = __webpack_require__("kkM+"),
    isArguments = __webpack_require__("bvyN"),
    isArray = __webpack_require__("wxYD"),
    isArrayLike = __webpack_require__("9y2L"),
    isBuffer = __webpack_require__("3ajY"),
    isPrototype = __webpack_require__("CbIe"),
    isTypedArray = __webpack_require__("Qd2C");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),

/***/ "NPTU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ SeeMore_SeeMore; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/widgets/navigation/Navigation.constants.js
var Navigation_constants = __webpack_require__("1cDg");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/see-more/SeeMore.themes.js
var COLLAPSED_OVERLAY_HEIGHT = 50;
var themes = {
  "default": {
    thBlurStyle: {
      height: COLLAPSED_OVERLAY_HEIGHT,
      backgroundImage: 'linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #ffffff 100%)'
    },
    thButton: 'reset-button mt-px10 text-base text-gray-darker focus:text-blue hover:text-blue transition-color underline'
  },
  gray: {
    thBlurStyle: {
      height: COLLAPSED_OVERLAY_HEIGHT,
      backgroundImage: 'linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #f7f7f7 100%)'
    },
    thButton: 'reset-button mt-px10 text-base text-gray-darker focus:text-blue hover:text-blue transition-color underline'
  },
  deepBlue: {
    thBlurStyle: {
      height: COLLAPSED_OVERLAY_HEIGHT,
      backgroundImage: 'linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, hsla(216, 100%, 18%, 1) 100%)'
    },
    thButton: 'reset-button mt-px10 text-base text-white transition-color underline'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/see-more/SeeMore.jsx

var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var SeeMore_SeeMore = function SeeMore(_ref) {
  var children = _ref.children,
      className = _ref.className,
      classNameButton = _ref.classNameButton,
      _ref$hasNoScrollOnCol = _ref.hasNoScrollOnCollapse,
      hasNoScrollOnCollapse = _ref$hasNoScrollOnCol === void 0 ? false : _ref$hasNoScrollOnCol,
      _ref$isCollapseEnable = _ref.isCollapseEnabled,
      isCollapseEnabled = _ref$isCollapseEnable === void 0 ? true : _ref$isCollapseEnable,
      _ref$offsetScrollSele = _ref.offsetScrollSelector,
      offsetScrollSelector = _ref$offsetScrollSele === void 0 ? Navigation_constants["b" /* NAVIGATION_OFFSET_SELECTOR */] : _ref$offsetScrollSele,
      _onClick = _ref.onClick,
      _ref$seeLessLabel = _ref.seeLessLabel,
      seeLessLabel = _ref$seeLessLabel === void 0 ? Object(i18n["g" /* t */])('common.loadLess') : _ref$seeLessLabel,
      _ref$seeMoreLabel = _ref.seeMoreLabel,
      seeMoreLabel = _ref$seeMoreLabel === void 0 ? Object(i18n["g" /* t */])('common.loadMore') : _ref$seeMoreLabel,
      _ref$seeMoreSize = _ref.seeMoreSize,
      seeMoreSize = _ref$seeMoreSize === void 0 ? 120 : _ref$seeMoreSize,
      _ref$seeMoreSizeToler = _ref.seeMoreSizeTolerance,
      seeMoreSizeTolerance = _ref$seeMoreSizeToler === void 0 ? 30 : _ref$seeMoreSizeToler,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useState = Object(react["useState"])(0),
      height = _useState[0],
      setHeight = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isCollapsable = _useState2[0],
      setIsCollapsable = _useState2[1];

  var _useState3 = Object(react["useState"])(false),
      isExpanded = _useState3[0],
      setIsExpanded = _useState3[1];

  var ref = Object(react["useRef"])(null);
  var seeMoreSizeTolerated = seeMoreSize + seeMoreSizeTolerance;
  Object(react["useEffect"])(function () {
    var _ref$current;

    if (children && (ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.clientHeight) && ref.current.clientHeight > seeMoreSizeTolerated) {
      setHeight(ref.current.clientHeight);
    }
  }, [children, ref]);
  Object(react["useEffect"])(function () {
    if (height > seeMoreSizeTolerated) {
      setIsCollapsable(true);
    }
  }, [height]);

  if (!react["Children"].count(children)) {
    return null;
  }

  if (!isCollapseEnabled) {
    return children;
  }

  var _themes$theme = themes[theme],
      thBlurStyle = _themes$theme.thBlurStyle,
      thButton = _themes$theme.thButton;
  return __jsx("div", {
    className: className
  }, __jsx("div", {
    className: "overflow-hidden relative transition-heights",
    ref: ref,
    style: isCollapsable ? {
      height: isExpanded ? height : seeMoreSize
    } : null
  }, children, isCollapsable && __jsx("div", {
    className: classnames_default()('absolute bottom-0 w-full', {
      'opacity-0': isExpanded,
      'opacity-100': !isExpanded
    }),
    style: _objectSpread(_objectSpread({}, thBlurStyle), {}, {
      height: isExpanded ? 0 : thBlurStyle.height
    })
  })), isCollapsable && __jsx("div", {
    className: classNameButton
  }, __jsx("button", {
    className: thButton,
    onClick: function onClick(e) {
      setIsExpanded(!isExpanded);
      _onClick && _onClick(e);

      if (isExpanded && !hasNoScrollOnCollapse) {
        Object(scrollToElement["a" /* scrollToElement */])(ref.current, 300, ".".concat(offsetScrollSelector));
      }
    },
    type: "button"
  }, isExpanded ? seeLessLabel : seeMoreLabel, __jsx(Icon["a" /* Icon */], {
    className: "mx-px5",
    name: isExpanded ? icons["a" /* ICONS */].MINUS : icons["a" /* ICONS */].PLUS,
    width: "0.7em"
  }))));
};

/***/ }),

/***/ "Ndl3":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__("9y2L"),
    isObjectLike = __webpack_require__("tLQN");

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ "O94r":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ "ORYz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRIP_INFORMATION_SET_ADULTS_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TRIP_INFORMATION_UPDATE_ADULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_ATTENDEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ADULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_ADULTS_NB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_ADULT_VALUE; });
var TRIP_INFORMATION_SET_ADULTS_NUMBER = 'TRIP_INFORMATION_SET_ADULTS_NUMBER';
var TRIP_INFORMATION_UPDATE_ADULT = 'TRIP_INFORMATION_UPDATE_ADULT';
var SET_ATTENDEES = 'SET_ATTENDEES';
var SET_ADULTS = 'SET_ADULTS';
var DEFAULT_ADULTS_NB = 2;
var DEFAULT_ADULT_VALUE = {
  birthdate: undefined,
  civility: undefined,
  firstName: undefined,
  lastName: undefined,
  unicodeFirstName: undefined,
  unicodeLastName: undefined,
  neolid: undefined
};

/***/ }),

/***/ "OfKG":
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__("c7Qd");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ "Onl6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlockLink; });
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("sRHE");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _tracking_track_click_TrackClick__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("NJJ8");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("qBqs");
/* harmony import */ var _BlockLink_themes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("uRnh");





var __jsx = react__WEBPACK_IMPORTED_MODULE_5___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }







var BlockLink = /*#__PURE__*/function (_PureComponent) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(BlockLink, _PureComponent);

  var _super = _createSuper(BlockLink);

  function BlockLink() {
    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(this, BlockLink);

    return _super.apply(this, arguments);
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(BlockLink, [{
    key: "renderTexts",
    value: function renderTexts() {
      var texts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var classes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var _this$props$theme = this.props.theme,
          theme = _this$props$theme === void 0 ? 'default' : _this$props$theme;
      return texts.filter(function (text) {
        return !Object(lodash__WEBPACK_IMPORTED_MODULE_6__["isEmpty"])(text);
      }).map(function (text, idx) {
        return __jsx("div", {
          className: classnames__WEBPACK_IMPORTED_MODULE_7___default()(classes, _BlockLink_themes__WEBPACK_IMPORTED_MODULE_10__[/* themes */ "a"][theme]["thCustomText".concat(idx)]),
          "data-testid": "BlockLink-text",
          key: idx
        }, text);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          icon = _this$props.icon,
          _this$props$onClick = _this$props.onClick,
          onClick = _this$props$onClick === void 0 ? function () {} : _this$props$onClick,
          _this$props$secondary = _this$props.secondaryTexts,
          secondaryTexts = _this$props$secondary === void 0 ? [] : _this$props$secondary,
          _this$props$target = _this$props.target,
          target = _this$props$target === void 0 ? '_blank' : _this$props$target,
          _this$props$texts = _this$props.texts,
          texts = _this$props$texts === void 0 ? [] : _this$props$texts,
          _this$props$theme2 = _this$props.theme,
          theme = _this$props$theme2 === void 0 ? 'default' : _this$props$theme2,
          trackingData = _this$props.trackingData,
          _this$props$url = _this$props.url,
          url = _this$props$url === void 0 ? '' : _this$props$url;
      var title = (texts || []).filter(function (t) {
        return typeof t === 'string';
      }).join(' ');
      var linkTarget = url.startsWith('tel:') ? '' : target;
      var _themes$theme = _BlockLink_themes__WEBPACK_IMPORTED_MODULE_10__[/* themes */ "a"][theme],
          thIcon = _themes$theme.thIcon,
          thIconWidth = _themes$theme.thIconWidth,
          thRoot = _themes$theme.thRoot,
          thTexts = _themes$theme.thTexts,
          thSText = _themes$theme.thSText;
      return !!texts.length || icon ? __jsx(_tracking_track_click_TrackClick__WEBPACK_IMPORTED_MODULE_8__[/* TrackClick */ "a"], {
        as: "a",
        className: classnames__WEBPACK_IMPORTED_MODULE_7___default()(className, thRoot),
        href: url,
        onClick: onClick,
        rel: "noopener noreferrer",
        target: linkTarget,
        title: title,
        trackingData: trackingData
      }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_9__[/* Icon */ "a"], {
        className: classnames__WEBPACK_IMPORTED_MODULE_7___default()('flex-shrink-0', thIcon),
        name: icon,
        width: thIconWidth
      }), !!texts.length && __jsx("span", {
        className: thTexts
      }, this.renderTexts(texts), this.renderTexts(secondaryTexts, thSText))) : null;
    }
  }]);

  return BlockLink;
}(react__WEBPACK_IMPORTED_MODULE_5__["PureComponent"]);

/***/ }),

/***/ "OouP":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "PCgT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GridCell; });
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("I6kL");






var __jsx = react__WEBPACK_IMPORTED_MODULE_6___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






function getClass(prop, key, css) {
  // $FlowFixMe
  return prop.hasOwnProperty(key) && Object(lodash__WEBPACK_IMPORTED_MODULE_8__["isInteger"])(prop[key]) && prop[key] > 0 ? " ".concat(key).concat(css).concat(prop[key]) : '';
}

function getResponsiveClasses(_ref) {
  var _ref$cols = _ref.cols,
      cols = _ref$cols === void 0 ? _utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_9__[/* DEFAULT_CELL_COLS */ "b"] : _ref$cols,
      _ref$offsets = _ref.offsets,
      offsets = _ref$offsets === void 0 ? {} : _ref$offsets;

  var cellCols = _objectSpread(_objectSpread({}, _utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_9__[/* DEFAULT_CELL_COLS */ "b"]), cols);

  return Object.keys(_utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_9__[/* BREAKPOINTS */ "a"]).map(function (key) {
    return getClass(cellCols, _utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_9__[/* BREAKPOINTS */ "a"][key], '-GridCell--') + getClass(offsets, _utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_9__[/* BREAKPOINTS */ "a"][key], '-GridCell--offset-');
  }).join('');
}

var GridCell = /*#__PURE__*/function (_React$Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(GridCell, _React$Component);

  var _super = _createSuper(GridCell);

  function GridCell() {
    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(this, GridCell);

    return _super.apply(this, arguments);
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(GridCell, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          id = _this$props.id;
      if (!react__WEBPACK_IMPORTED_MODULE_6__["Children"].count(children)) return null;
      return __jsx("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_7___default()(className, 'flex-1 max-w-full', "GridCell".concat(getResponsiveClasses(this.props))),
        id: id
      }, children);
    }
  }]);

  return GridCell;
}(react__WEBPACK_IMPORTED_MODULE_6___default.a.Component);

/***/ }),

/***/ "PZXw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ WebCallbackTrigger; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/identifiers/constants.js
var constants = __webpack_require__("YZTm");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/context/pageContext.js
var context_pageContext = __webpack_require__("RPju");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// EXTERNAL MODULE: ./src/client/components/frameworks/side-panel/SidePanel.jsx + 1 modules
var SidePanel = __webpack_require__("p7XS");

// EXTERNAL MODULE: ./src/client/components/frameworks/block-link/BlockLink.themes.js
var BlockLink_themes = __webpack_require__("uRnh");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js + 115 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/widgets/webcallback/WebCallbackFields.jsx

var __jsx = react_default.a.createElement;





function GroupedSelect(_ref) {
  var fieldName = _ref.fieldName,
      position = _ref.position,
      width = _ref.width,
      options = _ref.options,
      onChange = _ref.onChange;
  return __jsx(formik_esm["b" /* Field */], {
    name: fieldName
  }, function (_ref2) {
    var field = _ref2.field,
        errors = _ref2.form.errors;
    return __jsx("div", {
      className: classnames_default()("relative inline-block w-".concat(width, " border-1 overflow-hidden"), {
        'border-r-0': position === 'left',
        'rounded-l-small': position === 'left',
        'rounded-r-small': position === 'right',
        'border-success': !errors[field.name],
        'border-danger': errors[field.name]
      })
    }, __jsx("select", Object(esm_extends["a" /* default */])({
      autoComplete: "off",
      className: "reset-input reset-select relative text-current w-full bg-white p-px10"
    }, field, onChange ? {
      onChange: onChange
    } : null), options.map(function (_ref3) {
      var value = _ref3.value,
          name = _ref3.name;
      return __jsx("option", {
        key: name,
        value: value
      }, name);
    })), __jsx("div", {
      className: "absolute flex h-full items-center top-0 rtl:right-0 pointer-events-none px-px10 text-current"
    }, __jsx(Icon["a" /* Icon */], {
      name: icons["a" /* ICONS */].SELECT,
      width: "0.75rem"
    })));
  });
}
function GroupedInput(_ref4) {
  var fieldName = _ref4.fieldName,
      position = _ref4.position,
      width = _ref4.width,
      _ref4$type = _ref4.type,
      type = _ref4$type === void 0 ? 'text' : _ref4$type,
      _ref4$required = _ref4.required,
      required = _ref4$required === void 0 ? false : _ref4$required;
  return __jsx(formik_esm["b" /* Field */], {
    name: fieldName
  }, function (_ref5) {
    var field = _ref5.field,
        _ref5$form = _ref5.form,
        touched = _ref5$form.touched,
        errors = _ref5$form.errors;
    return __jsx("input", Object(esm_extends["a" /* default */])({
      type: type,
      required: required
    }, field, {
      className: classnames_default()("outline-none shadows-none inline-block w-".concat(width, " p-px10 align-top text-current bg-white border-1"), {
        'border-r-0': position === 'left',
        'rounded-l-small': position === 'left',
        'rounded-r-small': position === 'right',
        'border-gray-medium': !touched[field.name],
        'border-success': touched[field.name] && !errors[field.name],
        'border-danger': touched[field.name] && errors[field.name]
      })
    }));
  });
}
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// CONCATENATED MODULE: ./src/client/components/widgets/webcallback/WebCallbackForm.utils.js




/* eslint-disable space-before-function-paren */






var ACCOUNT_ID = config_default.a.get('freespee.accountId');
var AGENT_NUMBER = config_default.a.get('freespee.agentNumber');
var AGENT_NUMBER_ID = config_default.a.get('freespee.agentNumberId');
var CALLER_ID = config_default.a.get('freespee.callerId') || '';
var CUSTOMER_ID = config_default.a.get('freespee.customerId');
var FREESPEE_DATE_FORMAT = 'YYYY-MM-DD';
var FREESPEE_TIME_FORMAT = 'HH:mm:ss';
var FREESPEE_DATETIME_FORMAT = "".concat(FREESPEE_DATE_FORMAT, " ").concat(FREESPEE_TIME_FORMAT);
var DISPLAY_TIME_FORMAT = 'HH:mm';
var RETRIES = '2';
var RETRY_INTERVAL = '120';
var ASAP_TIME = 'ASAP';
var CALLBACK_STATUS = {
  UNSCHEDULED: 'unscheduled',
  SCHEDULED: 'scheduled',
  ERROR: 'error'
};
var PHONE_PREFIXES = [{
  countryCode: 'AL',
  value: 355,
  name: '+355 (AL)'
}, {
  countryCode: 'AR',
  value: 54,
  name: '+54 (AR)'
}, {
  countryCode: 'AT',
  value: 43,
  name: '+43 (AT)'
}, {
  countryCode: 'AU',
  value: 61,
  name: '+61 (AU)'
}, {
  countryCode: 'BA',
  value: 387,
  name: '+387 (BA)'
}, {
  countryCode: 'BE',
  value: 32,
  name: '+32 (BE)'
}, {
  countryCode: 'BG',
  value: 359,
  name: '+359 (BG)'
}, {
  countryCode: 'BR',
  value: 55,
  name: '+55 (BR)'
}, {
  countryCode: 'CA',
  value: 1,
  name: '+1 (CA)'
}, {
  countryCode: 'CH',
  value: 41,
  name: '+41 (CH)'
}, {
  countryCode: 'CL',
  value: 56,
  name: '+56 (CL)'
}, {
  countryCode: 'CN',
  value: 86,
  name: '+86 (CN)'
}, {
  countryCode: 'CY',
  value: 357,
  name: '+357 (CY)'
}, {
  countryCode: 'CZ',
  value: 420,
  name: '+420 (CZ)'
}, {
  countryCode: 'DE',
  value: 49,
  name: '+49 (DE)'
}, {
  countryCode: 'DK',
  value: 45,
  name: '+45 (DK)'
}, {
  countryCode: 'EE',
  value: 372,
  name: '+372 (EE)'
}, {
  countryCode: 'EG',
  value: 20,
  name: '+20 (EG)'
}, {
  countryCode: 'ES',
  value: 34,
  name: '+34 (ES)'
}, {
  countryCode: 'FI',
  value: 358,
  name: '+358 (FI)'
}, {
  countryCode: 'FR',
  value: 33,
  name: '+33 (FR)'
}, {
  countryCode: 'GB',
  value: 44,
  name: '+44 (GB)'
}, {
  countryCode: 'GI',
  value: 350,
  name: '+350 (GI)'
}, {
  countryCode: 'GR',
  value: 30,
  name: '+30 (GR)'
}, {
  countryCode: 'HK',
  value: 852,
  name: '+852 (HK)'
}, {
  countryCode: 'HR',
  value: 385,
  name: '+385 (HR)'
}, {
  countryCode: 'HU',
  value: 36,
  name: '+36 (HU)'
}, {
  countryCode: 'IE',
  value: 353,
  name: '+353 (IE)'
}, {
  countryCode: 'IL',
  value: 972,
  name: '+972 (IL)'
}, {
  countryCode: 'IN',
  value: 91,
  name: '+91 (IN)'
}, {
  countryCode: 'IR',
  value: 98,
  name: '+98 (IR)'
}, {
  countryCode: 'IS',
  value: 354,
  name: '+354 (IS)'
}, {
  countryCode: 'IT',
  value: 39,
  name: '+39 (IT)'
}, {
  countryCode: 'JP',
  value: 81,
  name: '+81 (JP)'
}, {
  countryCode: 'LB',
  value: 961,
  name: '+961 (LB)'
}, {
  countryCode: 'LT',
  value: 370,
  name: '+370 (LT)'
}, {
  countryCode: 'LU',
  value: 352,
  name: '+352 (LU)'
}, {
  countryCode: 'LV',
  value: 371,
  name: '+371 (LV)'
}, {
  countryCode: 'MC',
  value: 377,
  name: '+377 (MC)'
}, {
  countryCode: 'MD',
  value: 373,
  name: '+373 (MD)'
}, {
  countryCode: 'MT',
  value: 356,
  name: '+356 (MT)'
}, {
  countryCode: 'MX',
  value: 52,
  name: '+52 (MX)'
}, {
  countryCode: 'NL',
  value: 31,
  name: '+31 (NL)'
}, {
  countryCode: 'NO',
  value: 47,
  name: '+47 (NO)'
}, {
  countryCode: 'NZ',
  value: 64,
  name: '+64 (NZ)'
}, {
  countryCode: 'PA',
  value: 507,
  name: '+507 (PA)'
}, {
  countryCode: 'PE',
  value: 51,
  name: '+51 (PE)'
}, {
  countryCode: 'PK',
  value: 92,
  name: '+92 (PK)'
}, {
  countryCode: 'PL',
  value: 48,
  name: '+48 (PL)'
}, {
  countryCode: 'PT',
  value: 351,
  name: '+351 (PT)'
}, {
  countryCode: 'RO',
  value: 40,
  name: '+40 (RO)'
}, {
  countryCode: 'RS',
  value: 381,
  name: '+381 (RS)'
}, {
  countryCode: 'RU',
  value: 7,
  name: '+7 (RU)'
}, {
  countryCode: 'SE',
  value: 46,
  name: '+46 (SE)'
}, {
  countryCode: 'SG',
  value: 65,
  name: '+65 (SG)'
}, {
  countryCode: 'SI',
  value: 386,
  name: '+386 (SI)'
}, {
  countryCode: 'SK',
  value: 421,
  name: '+421 (SK)'
}, {
  countryCode: 'TH',
  value: 66,
  name: '+66 (TH)'
}, {
  countryCode: 'TR',
  value: 90,
  name: '+90 (TR)'
}, {
  countryCode: 'US',
  value: 1,
  name: '+1 (US)'
}, {
  countryCode: 'ZA',
  value: 27,
  name: '+27 (ZA)'
}];

function hasNameInSlots(slots, name) {
  return slots.some(function (slot) {
    return slot.name === name;
  });
}

var WebCallbackForm_utils_getTimeSlots = function getTimeSlots(_ref) {
  var openingTimesPerDay = _ref.openingTimesPerDay,
      i18n = _ref.i18n;
  if (!openingTimesPerDay) return [];
  var openDays = Object.keys(openingTimesPerDay);
  var asap = i18n.asap,
      today = i18n.today,
      tomorrow = i18n.tomorrow;
  var maxDaysInTheFuture = 7;

  var daysOfWeek = Object(toConsumableArray["a" /* default */])(Array(maxDaysInTheFuture).keys()).map(function (day) {
    return moment_default()().utc().add(day, 'd').locale('en').format('ddd').toLowerCase();
  });

  return Object(toConsumableArray["a" /* default */])(Array(maxDaysInTheFuture).keys()).filter(function (day) {
    var dayOfWeek = moment_default()().utc().add(day, 'd').locale('en').format('ddd');
    return openDays.includes(dayOfWeek.toLowerCase());
  }).map(function (day, idx) {
    var slots = [];
    var dayLabel = daysOfWeek[day];
    var openingTimes = openingTimesPerDay[dayLabel];
    var now = moment_default.a.utc().add(day, 'd');
    var dayOfWeek = now.calendar(null, {
      sameDay: "[".concat(Object(lodash["upperFirst"])(today), "]"),
      nextDay: "[".concat(Object(lodash["upperFirst"])(tomorrow), "]"),
      nextWeek: 'dddd',
      sameElse: 'dddd'
    });
    openingTimes === null || openingTimes === void 0 ? void 0 : openingTimes.forEach(function (openingTime) {
      var _openingTime$from$spl = openingTime.from.split(':'),
          _openingTime$from$spl2 = Object(slicedToArray["a" /* default */])(_openingTime$from$spl, 2),
          beginHour = _openingTime$from$spl2[0],
          beginMinute = _openingTime$from$spl2[1];

      var begin = moment_default.a.utc().startOf('day').hour(parseInt(beginHour, 10)).minute(parseInt(beginMinute, 10));

      var _openingTime$to$split = openingTime.to.split(':'),
          _openingTime$to$split2 = Object(slicedToArray["a" /* default */])(_openingTime$to$split, 2),
          endHour = _openingTime$to$split2[0],
          endMinute = _openingTime$to$split2[1];

      var end = moment_default.a.utc().startOf('day').hour(parseInt(endHour, 10)).minute(parseInt(endMinute, 10));
      var current = begin;

      if (idx === 0) {
        current = moment_default.a.max(now, begin).add(1, 'h').startOf('h');

        if (!hasNameInSlots(slots, Object(lodash["upperFirst"])(asap))) {
          slots.push({
            value: ASAP_TIME,
            name: Object(lodash["upperFirst"])(asap)
          });
        }
      }

      while (current.isBefore(end)) {
        var value = current.format(FREESPEE_DATETIME_FORMAT);
        var slotStart = current.format(DISPLAY_TIME_FORMAT);
        current.add(30, 'm');
        var slotEnd = current.format(DISPLAY_TIME_FORMAT);
        var name = "".concat(slotStart, " - ").concat(slotEnd);

        if (!hasNameInSlots(slots, name)) {
          slots.push({
            value: value,
            name: name
          });
        }
      }
    });
    return {
      value: now.format(FREESPEE_DATE_FORMAT),
      name: Object(lodash["upperFirst"])(dayOfWeek),
      slots: slots
    };
  });
};

function concatIntervalsPerDay(openingTimesPerDay, weekday) {
  var _weekday$intervals;

  if (!(weekday === null || weekday === void 0 ? void 0 : weekday.intervals)) return openingTimesPerDay;
  var openingTimeInterval = weekday === null || weekday === void 0 ? void 0 : (_weekday$intervals = weekday.intervals) === null || _weekday$intervals === void 0 ? void 0 : _weekday$intervals.map(function (interval) {
    return {
      from: interval === null || interval === void 0 ? void 0 : interval.openingTime,
      to: interval === null || interval === void 0 ? void 0 : interval.closingTime
    };
  });

  if (openingTimesPerDay[weekday === null || weekday === void 0 ? void 0 : weekday.day]) {
    openingTimesPerDay[weekday === null || weekday === void 0 ? void 0 : weekday.day] = openingTimesPerDay[weekday === null || weekday === void 0 ? void 0 : weekday.day].concat(openingTimeInterval);
  } else {
    openingTimesPerDay[weekday === null || weekday === void 0 ? void 0 : weekday.day] = openingTimeInterval;
  }

  return openingTimesPerDay;
}

var fetchOpeningHours = /*#__PURE__*/function () {
  var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref2, appContext) {
    var setOpeningTimesPerDay, query, data, _openingTimesPerDay;

    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setOpeningTimesPerDay = _ref2.setOpeningTimesPerDay;
            query = "query {\n    webCallbackHours(customerId: \"".concat(CUSTOMER_ID, "\") {\n      weekdays {\n        day\n        intervals {\n          openingTime\n          closingTime\n        }\n      }\n    }\n  }");
            _context.prev = 2;
            _context.next = 5;
            return graphqlClient["a" /* default */].runQuery(query, appContext, {
              requestName: requestDictionary["Pd" /* WIDGET_WEBCALLBACK_OPENING_HOURS */]
            });

          case 5:
            data = _context.sent;
            _openingTimesPerDay = data.webCallbackHours.weekdays.reduce(concatIntervalsPerDay, {});
            if (_openingTimesPerDay && !Object(lodash["isEmpty"])(_openingTimesPerDay)) setOpeningTimesPerDay(_openingTimesPerDay);
            _context.next = 12;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](2);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 10]]);
  }));

  return function fetchOpeningHours(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();
var submitCallback = /*#__PURE__*/function () {
  var _ref5 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2(_ref4, appContext) {
    var scheduled, requesterNumber, setCallbackStatus, setSubmitting, schedule, query, _yield$graphQLClient$, webCallback;

    return regenerator_default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            scheduled = _ref4.scheduled, requesterNumber = _ref4.requesterNumber, setCallbackStatus = _ref4.setCallbackStatus, setSubmitting = _ref4.setSubmitting;
            schedule = scheduled ? "\"".concat(scheduled, "\"") : 'null';
            query = "mutation {\n    webCallback(\n      agentNumber: \"".concat(AGENT_NUMBER, "\",\n      callerId: \"").concat(CALLER_ID, "\",\n      customerId: \"").concat(CUSTOMER_ID, "\",\n      webCallbackInput: {\n        requesterNumber: \"").concat(requesterNumber, "\",\n        scheduled: ").concat(schedule, ",\n        retries: ").concat(RETRIES, ",\n        retryInterval: ").concat(RETRY_INTERVAL, "\n      }) {\n      ... on WebCallback {\n        id\n        type\n        agentNumber\n        callerId\n        requesterNumber\n        retries\n        retryInterval\n      }\n      ... on WebCallbackError {\n        errorCode\n        errorDescription\n        errorKey\n        errorValue        \n      }\n    }\n  }");
            _context2.prev = 3;
            _context2.next = 6;
            return graphqlClient["a" /* default */].runNoCacheQuery(query, appContext, {
              requestName: requestDictionary["Qd" /* WIDGET_WEBCALLBACK_SCHEDULE_CALL */]
            });

          case 6:
            _yield$graphQLClient$ = _context2.sent;
            webCallback = _yield$graphQLClient$.webCallback;

            if (webCallback.errorCode) {
              setCallbackStatus(CALLBACK_STATUS.ERROR);
            } else {
              setCallbackStatus(CALLBACK_STATUS.SCHEDULED);
            }

            _context2.next = 14;
            break;

          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](3);
            setCallbackStatus(CALLBACK_STATUS.ERROR);

          case 14:
            _context2.prev = 14;
            setSubmitting(false);
            return _context2.finish(14);

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 11, 14, 17]]);
  }));

  return function submitCallback(_x3, _x4) {
    return _ref5.apply(this, arguments);
  };
}();
var requestCallback = function requestCallback(_ref6) {
  var scheduled = _ref6.scheduled,
      requesterNumber = _ref6.requesterNumber,
      requesterNumberPrefix = _ref6.requesterNumberPrefix,
      setCallbackStatus = _ref6.setCallbackStatus,
      setSubmitting = _ref6.setSubmitting;

  try {
    window.__fs_dncs_instance.requestCallback(ACCOUNT_ID, // AVD_ID
    AGENT_NUMBER_ID, // Answering_number_id
    requesterNumberPrefix, // Country_code
    requesterNumber, // customer_phonenr
    CALLER_ID, // caller_id
    {}, // custom_*
    scheduled ? scheduled : null, // call_time,
    function (ref, data) {
      var status = data.status,
          callId = data.call_uuid;

      if (status === 'ok' && callId) {
        setCallbackStatus(CALLBACK_STATUS.SCHEDULED);
      } else {
        setCallbackStatus(CALLBACK_STATUS.ERROR);
      }

      setSubmitting(false);
    }, null, RETRIES // retries
    );
  } catch (error) {
    setCallbackStatus(CALLBACK_STATUS.ERROR);
    setSubmitting(false);
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/webcallback/WebCallbackForm.jsx


var WebCallbackForm_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var DEFAULT_OPENING_TIME = '10:00:00';
var DEFAULT_CLOSING_TIME = '18:00:00';
var DEFAULT_OPENING_TIMES_PER_DAY = {
  mon: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  tue: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  wed: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  thu: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  fri: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  sat: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  sun: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }]
};
function WebCallbackForm(_ref) {
  var _currentDay$slots, _currentDay$slots$;

  var callbackStatus = _ref.callbackStatus,
      setCallbackStatus = _ref.setCallbackStatus,
      trackingData = _ref.trackingData;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);
  var track = Object(useTracking["a" /* useTracking */])(); // These are UTC times, like what Freespee returns in from_time, to_time.

  var _useState = Object(react["useState"])(DEFAULT_OPENING_TIMES_PER_DAY),
      openingTimesPerDay = _useState[0],
      setOpeningTimesPerDay = _useState[1];

  var timeSlots = Object(react["useMemo"])(function () {
    return WebCallbackForm_utils_getTimeSlots({
      openingTimesPerDay: openingTimesPerDay,
      i18n: {
        asap: Object(src_i18n["g" /* t */])('common.dateTime.asap'),
        today: Object(src_i18n["g" /* t */])('common.dateTime.today'),
        tomorrow: Object(src_i18n["g" /* t */])('common.dateTime.tomorrow')
      }
    });
  }, [openingTimesPerDay]);

  var _timeSlots = Object(slicedToArray["a" /* default */])(timeSlots, 1),
      initialDay = _timeSlots[0];

  var _useState2 = Object(react["useState"])(initialDay),
      currentDay = _useState2[0],
      setCurrentDay = _useState2[1];

  Object(react["useEffect"])(function () {
    fetchOpeningHours({
      setOpeningTimesPerDay: setOpeningTimesPerDay
    }, appContext);
  }, []);
  Object(react["useEffect"])(function () {
    var _timeSlots2 = Object(slicedToArray["a" /* default */])(timeSlots, 1),
        newDay = _timeSlots2[0];

    setCurrentDay(newDay);
  }, [timeSlots]);
  if (!currentDay) return null;
  var localPhonePrefix = PHONE_PREFIXES.find(function (prefix) {
    var country = appContext.locale.split('-')[1];
    return country === prefix.countryCode;
  });
  var initialPhonePrefix = localPhonePrefix || PHONE_PREFIXES.find(function (prefix) {
    return prefix.countryCode === 'FR';
  }) || {};

  var changeDay = function changeDay(event, setFieldValue) {
    var dayValue = event.target.value;
    var newDay = timeSlots.find(function (slot) {
      return slot.value === dayValue;
    });

    if (newDay) {
      setCurrentDay(newDay);
      setFieldValue('slotDay', newDay.value, false);
    }
  };

  return WebCallbackForm_jsx(formik_esm["d" /* Formik */], {
    initialValues: {
      slotDay: currentDay.value,
      slotTime: currentDay === null || currentDay === void 0 ? void 0 : (_currentDay$slots = currentDay.slots) === null || _currentDay$slots === void 0 ? void 0 : (_currentDay$slots$ = _currentDay$slots[0]) === null || _currentDay$slots$ === void 0 ? void 0 : _currentDay$slots$.value,
      phonePrefix: initialPhonePrefix.value,
      phoneNumber: ''
    },
    validate: function validate(_ref2) {
      var phoneNumber = _ref2.phoneNumber;
      var errors = {};

      if (!phoneNumber) {
        errors.phoneNumber = 'Phone number is required';
      } // https://www.twilio.com/docs/glossary/what-e164


      if (!/^[1-9]\d{1,14}$/.test(phoneNumber)) {
        errors.phoneNumber = 'Phone number is not valid';
      }

      return errors;
    },
    onSubmit: function onSubmit(formValues, _ref3) {
      var setSubmitting = _ref3.setSubmitting;
      var slotTime = formValues.slotTime,
          phonePrefix = formValues.phonePrefix,
          phoneNumber = formValues.phoneNumber;
      requestCallback({
        scheduled: slotTime === ASAP_TIME ? null : slotTime,
        requesterNumber: "+".concat(phonePrefix).concat(phoneNumber),
        requesterNumberPrefix: phonePrefix,
        setCallbackStatus: setCallbackStatus,
        setSubmitting: setSubmitting
      });
      track(_objectSpread({
        categoryGA: pageContext.pageId,
        labelGA: tracking_constants["B" /* WEB_CALLBACK_SUBMIT */]
      }, trackingData));
    }
  }, function (_ref4) {
    var isValid = _ref4.isValid,
        isSubmitting = _ref4.isSubmitting,
        setFieldValue = _ref4.setFieldValue;
    var isDisabled = callbackStatus !== CALLBACK_STATUS.UNSCHEDULED || !isValid;
    return WebCallbackForm_jsx(formik_esm["c" /* Form */], {
      "data-testid": "web-callback-form",
      className: "h-full"
    }, WebCallbackForm_jsx("div", {
      className: "flex flex-col justify-between h-full w-full bg-gray-200"
    }, WebCallbackForm_jsx("div", {
      className: "w-full bg-ardoise",
      style: {
        backgroundImage: "url(\"".concat(Object(src_i18n["g" /* t */])('webCallback.picture'), "\")"),
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        height: '150px'
      }
    }), WebCallbackForm_jsx("div", {
      className: "flex-auto px-px25 py-px20"
    }, WebCallbackForm_jsx("h3", {
      className: "my-0",
      id: constants["w" /* ID_MODAL_HEADER__SHOPPING__WEBCALLBACK_TRIGGER */]
    }, Object(src_i18n["g" /* t */])('webCallback.title')), WebCallbackForm_jsx("p", null, Object(src_i18n["g" /* t */])('webCallback.subtitle')), callbackStatus !== CALLBACK_STATUS.UNSCHEDULED ? WebCallbackForm_jsx(Notification["a" /* Notification */], {
      color: callbackStatus === CALLBACK_STATUS.SCHEDULED ? colors["a" /* COLORS */].SUCCESS : colors["a" /* COLORS */].WARNING,
      hasBorder: true,
      icon: callbackStatus === CALLBACK_STATUS.SCHEDULED ? icons["a" /* ICONS */].SMALL_CIRCLE_CHECK : icons["a" /* ICONS */].CIRCLED_CROSS,
      iconWidth: "1rem"
    }, WebCallbackForm_jsx("p", {
      className: "m-0 text-base text-".concat(callbackStatus === CALLBACK_STATUS.SCHEDULED ? colors["a" /* COLORS */].SUCCESS : colors["a" /* COLORS */].WARNING)
    }, callbackStatus === CALLBACK_STATUS.SCHEDULED ? Object(src_i18n["g" /* t */])('webCallback.successMessage') : Object(src_i18n["g" /* t */])('webCallback.errorMessage'))) : WebCallbackForm_jsx(react["Fragment"], null, WebCallbackForm_jsx("div", {
      className: "inline-block w-full md:w-3/5 mb-px10 md:pr-px10"
    }, WebCallbackForm_jsx("label", {
      className: "block w-full p-px5 text-sm"
    }, Object(src_i18n["g" /* t */])('webCallback.timeLabel')), WebCallbackForm_jsx(GroupedSelect, {
      fieldName: "slotDay",
      position: "left",
      width: "2/5" // $FlowFixMe
      ,
      options: timeSlots,
      onChange: function onChange(e) {
        return changeDay(e, setFieldValue);
      }
    }), WebCallbackForm_jsx(GroupedSelect, {
      fieldName: "slotTime",
      position: "right",
      width: "3/5" // $FlowFixMe
      ,
      options: currentDay.slots
    })), WebCallbackForm_jsx("div", {
      className: "inline-block w-full md:w-2/5 mb-px10"
    }, WebCallbackForm_jsx("label", {
      className: "block w-full p-px5 text-sm"
    }, Object(src_i18n["g" /* t */])('webCallback.phoneLabel')), WebCallbackForm_jsx(GroupedSelect, {
      fieldName: "phonePrefix",
      position: "left",
      width: "1/2",
      options: PHONE_PREFIXES
    }), WebCallbackForm_jsx(GroupedInput, {
      fieldName: "phoneNumber",
      position: "right",
      width: "1/2",
      type: "tel",
      required: true
    })))), WebCallbackForm_jsx("div", {
      className: "flex justify-end px-px25 w-full",
      style: {
        minHeight: '3.75rem'
      }
    }, callbackStatus === CALLBACK_STATUS.UNSCHEDULED ? WebCallbackForm_jsx(Button["a" /* Button */], {
      className: "self-center w-full md:w-1/2 text-center",
      type: "submit",
      isLoading: isSubmitting,
      isDisabled: isDisabled
    }, Object(src_i18n["g" /* t */])('webCallback.callToAction')) : null)));
  });
}
// CONCATENATED MODULE: ./src/client/components/widgets/webcallback/WebCallbackTrigger.jsx

var WebCallbackTrigger_jsx = react_default.a.createElement;

function WebCallbackTrigger_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function WebCallbackTrigger_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { WebCallbackTrigger_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { WebCallbackTrigger_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














function WebCallbackTrigger(_ref) {
  var trackingData = _ref.trackingData,
      children = _ref.children,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isTablet = _useContext.isTablet,
      isAppMounted = _useContext.isAppMounted;

  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);
  var track = Object(useTracking["a" /* useTracking */])();

  var _useState = Object(react["useState"])(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = Object(react["useState"])(CALLBACK_STATUS.UNSCHEDULED),
      callbackStatus = _useState2[0],
      setCallbackStatus = _useState2[1];

  var webCallbackModal = isOpen ? WebCallbackTrigger_jsx(Modal["a" /* Modal */], {
    ariaLabel: Object(src_i18n["g" /* t */])('webCallback.title'),
    ariaLabelledby: constants["w" /* ID_MODAL_HEADER__SHOPPING__WEBCALLBACK_TRIGGER */],
    closeLabel: Object(src_i18n["g" /* t */])('common.close'),
    onClose: function onClose() {
      return setIsOpen(false);
    }
  }, WebCallbackTrigger_jsx(WebCallbackForm, {
    callbackStatus: callbackStatus,
    setCallbackStatus: setCallbackStatus,
    trackingData: trackingData
  })) : null;

  var webCallbackDrawer = WebCallbackTrigger_jsx(SidePanel["a" /* SidePanel */], {
    ariaLabel: Object(src_i18n["g" /* t */])('webCallback.title'),
    ariaLabelledby: constants["w" /* ID_MODAL_HEADER__SHOPPING__WEBCALLBACK_TRIGGER */],
    closeLabel: Object(src_i18n["g" /* t */])('common.close'),
    isExpanded: isOpen,
    onClose: function onClose() {
      return setIsOpen(false);
    }
  }, WebCallbackTrigger_jsx("div", {
    className: "h-full w-full fadeIn"
  }, WebCallbackTrigger_jsx(WebCallbackForm, {
    callbackStatus: callbackStatus,
    setCallbackStatus: setCallbackStatus,
    trackingData: trackingData
  })));

  var webCallbackPopin = isTablet ? webCallbackModal : webCallbackDrawer;
  return WebCallbackTrigger_jsx(react["Fragment"], null, isAppMounted ? webCallbackPopin : null, WebCallbackTrigger_jsx("button", {
    type: "button",
    className: classnames_default()(BlockLink_themes["a" /* themes */][theme].thRoot, 'bg-transparent'),
    onClick: function onClick() {
      setCallbackStatus(CALLBACK_STATUS.UNSCHEDULED);
      setIsOpen(true);

      if (isOpen === false && trackingData) {
        track(WebCallbackTrigger_objectSpread({
          categoryGA: pageContext.pageId,
          labelGA: tracking_constants["A" /* WEB_CALLBACK_OPEN */]
        }, trackingData));
      }
    }
  }, children));
}

/***/ }),

/***/ "Phb7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

/* global window, document */


__webpack_require__("ZVqJ");

__webpack_require__("vuE1");

__webpack_require__("qs2G");

__webpack_require__("i2OK");

__webpack_require__("5iaM");

__webpack_require__("I2c1");

__webpack_require__("60DJ");

__webpack_require__("QRET");

__webpack_require__("bMl7");

__webpack_require__("zSnQ");

__webpack_require__("MRpX");

__webpack_require__("ieZH");

var _react = _interopRequireWildcard(__webpack_require__("ERkP"));

var _propTypes = _interopRequireDefault(__webpack_require__("aWzz"));

var _subscribeUiEvent = __webpack_require__("GJxp");

var _classnames = _interopRequireDefault(__webpack_require__("O94r"));

var _shallowequal = _interopRequireDefault(__webpack_require__("Pu0A"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// constants
var STATUS_ORIGINAL = 0; // The default status, locating at the original position.

var STATUS_RELEASED = 1; // The released status, locating at somewhere on document but not default one.

var STATUS_FIXED = 2; // The sticky status, locating fixed to the top or the bottom of screen.

var TRANSFORM_PROP = 'transform'; // global variable for all instances

var doc;
var docBody;
var docEl;
var canEnableTransforms = true; // Use transform by default, so no Sticky on lower-end browser when no Modernizr

var M;
var scrollDelta = 0;
var win;
var winHeight = -1;

var Sticky = /*#__PURE__*/function (_Component) {
  _inherits(Sticky, _Component);

  var _super = _createSuper(Sticky);

  function Sticky(props, context) {
    var _this;

    _classCallCheck(this, Sticky);

    _this = _super.call(this, props, context);
    _this.handleResize = _this.handleResize.bind(_assertThisInitialized(_this));
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_this));
    _this.handleScrollStart = _this.handleScrollStart.bind(_assertThisInitialized(_this));
    _this.delta = 0;
    _this.stickyTop = 0;
    _this.stickyBottom = 0;
    _this.frozen = false;
    _this.skipNextScrollEvent = false;
    _this.scrollTop = -1;
    _this.bottomBoundaryTarget;
    _this.topTarget;
    _this.subscribers;
    _this.state = {
      top: 0,
      // A top offset from viewport top where Sticky sticks to when scrolling up
      bottom: 0,
      // A bottom offset from viewport top where Sticky sticks to when scrolling down
      width: 0,
      // Sticky width
      height: 0,
      // Sticky height
      x: 0,
      // The original x of Sticky
      y: 0,
      // The original y of Sticky
      topBoundary: 0,
      // The top boundary on document
      bottomBoundary: Infinity,
      // The bottom boundary on document
      status: STATUS_ORIGINAL,
      // The Sticky status
      pos: 0,
      // Real y-axis offset for rendering position-fixed and position-relative
      activated: false // once browser info is available after mounted, it becomes true to avoid checksum error

    };
    return _this;
  }

  _createClass(Sticky, [{
    key: "getTargetHeight",
    value: function getTargetHeight(target) {
      return target && target.offsetHeight || 0;
    }
  }, {
    key: "getTopPosition",
    value: function getTopPosition(top) {
      // a top argument can be provided to override reading from the props
      top = top || this.props.top || 0;

      if (typeof top === 'string') {
        if (!this.topTarget) {
          this.topTarget = doc.querySelector(top);
        }

        top = this.getTargetHeight(this.topTarget);
      }

      return top;
    }
  }, {
    key: "getTargetBottom",
    value: function getTargetBottom(target) {
      if (!target) {
        return -1;
      }

      var rect = target.getBoundingClientRect();
      return this.scrollTop + rect.bottom;
    }
  }, {
    key: "getBottomBoundary",
    value: function getBottomBoundary(bottomBoundary) {
      // a bottomBoundary can be provided to avoid reading from the props
      var boundary = bottomBoundary || this.props.bottomBoundary; // TODO, bottomBoundary was an object, depricate it later.

      if (_typeof(boundary) === 'object') {
        boundary = boundary.value || boundary.target || 0;
      }

      if (typeof boundary === 'string') {
        if (!this.bottomBoundaryTarget) {
          this.bottomBoundaryTarget = doc.querySelector(boundary);
        }

        boundary = this.getTargetBottom(this.bottomBoundaryTarget);
      }

      return boundary && boundary > 0 ? boundary : Infinity;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.setState({
        status: STATUS_ORIGINAL,
        pos: 0
      });
    }
  }, {
    key: "release",
    value: function release(pos) {
      this.setState({
        status: STATUS_RELEASED,
        pos: pos - this.state.y
      });
    }
  }, {
    key: "fix",
    value: function fix(pos) {
      this.setState({
        status: STATUS_FIXED,
        pos: pos
      });
    }
    /**
     * Update the initial position, width, and height. It should update whenever children change.
     * @param {Object} options optional top and bottomBoundary new values
     */

  }, {
    key: "updateInitialDimension",
    value: function updateInitialDimension(options) {
      options = options || {};

      if (!this.outerElement || !this.innerElement) {
        return;
      }

      var outerRect = this.outerElement.getBoundingClientRect();
      var innerRect = this.innerElement.getBoundingClientRect();
      var width = outerRect.width || outerRect.right - outerRect.left;
      var height = innerRect.height || innerRect.bottom - innerRect.top;
      ;
      var outerY = outerRect.top + this.scrollTop;
      this.setState({
        top: this.getTopPosition(options.top),
        bottom: Math.min(this.state.top + height, winHeight),
        width: width,
        height: height,
        x: outerRect.left,
        y: outerY,
        bottomBoundary: this.getBottomBoundary(options.bottomBoundary),
        topBoundary: outerY
      });
    }
  }, {
    key: "handleResize",
    value: function handleResize(e, ae) {
      if (this.props.shouldFreeze()) {
        return;
      }

      winHeight = ae.resize.height;
      this.updateInitialDimension();
      this.update();
    }
  }, {
    key: "handleScrollStart",
    value: function handleScrollStart(e, ae) {
      this.frozen = this.props.shouldFreeze();

      if (this.frozen) {
        return;
      }

      if (this.scrollTop === ae.scroll.top) {
        // Scroll position hasn't changed,
        // do nothing
        this.skipNextScrollEvent = true;
      } else {
        this.scrollTop = ae.scroll.top;
        this.updateInitialDimension();
      }
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(e, ae) {
      // Scroll doesn't need to be handled
      if (this.skipNextScrollEvent) {
        this.skipNextScrollEvent = false;
        return;
      }

      scrollDelta = ae.scroll.delta;
      this.scrollTop = ae.scroll.top;
      this.update();
    }
    /**
     * Update Sticky position.
     */

  }, {
    key: "update",
    value: function update() {
      var disabled = !this.props.enabled || this.state.bottomBoundary - this.state.topBoundary <= this.state.height || this.state.width === 0 && this.state.height === 0;

      if (disabled) {
        if (this.state.status !== STATUS_ORIGINAL) {
          this.reset();
        }

        return;
      }

      var delta = scrollDelta; // "top" and "bottom" are the positions that this.state.top and this.state.bottom project
      // on document from viewport.

      var top = this.scrollTop + this.state.top;
      var bottom = this.scrollTop + this.state.bottom; // There are 2 principles to make sure Sticky won't get wrong so much:
      // 1. Reset Sticky to the original postion when "top" <= topBoundary
      // 2. Release Sticky to the bottom boundary when "bottom" >= bottomBoundary

      if (top <= this.state.topBoundary) {
        // #1
        this.reset();
      } else if (bottom >= this.state.bottomBoundary) {
        // #2
        this.stickyBottom = this.state.bottomBoundary;
        this.stickyTop = this.stickyBottom - this.state.height;
        this.release(this.stickyTop);
      } else {
        if (this.state.height > winHeight - this.state.top) {
          // In this case, Sticky is higher then viewport minus top offset
          switch (this.state.status) {
            case STATUS_ORIGINAL:
              this.release(this.state.y);
              this.stickyTop = this.state.y;
              this.stickyBottom = this.stickyTop + this.state.height;
            // Commentting out "break" is on purpose, because there is a chance to transit to FIXED
            // from ORIGINAL when calling window.scrollTo().
            // break;

            case STATUS_RELEASED:
              // If "top" and "bottom" are inbetween stickyTop and stickyBottom, then Sticky is in
              // RELEASE status. Otherwise, it changes to FIXED status, and its bottom sticks to
              // viewport bottom when scrolling down, or its top sticks to viewport top when scrolling up.
              this.stickyBottom = this.stickyTop + this.state.height;

              if (delta > 0 && bottom > this.stickyBottom) {
                this.fix(this.state.bottom - this.state.height);
              } else if (delta < 0 && top < this.stickyTop) {
                this.fix(this.state.top);
              }

              break;

            case STATUS_FIXED:
              var toRelease = true;
              var pos = this.state.pos;
              var height = this.state.height; // In regular cases, when Sticky is in FIXED status,
              // 1. it's top will stick to the screen top,
              // 2. it's bottom will stick to the screen bottom,
              // 3. if not the cases above, then it's height gets changed

              if (delta > 0 && pos === this.state.top) {
                // case 1, and scrolling down
                this.stickyTop = top - delta;
                this.stickyBottom = this.stickyTop + height;
              } else if (delta < 0 && pos === this.state.bottom - height) {
                // case 2, and scrolling up
                this.stickyBottom = bottom - delta;
                this.stickyTop = this.stickyBottom - height;
              } else if (pos !== this.state.bottom - height && pos !== this.state.top) {
                // case 3
                // This case only happens when Sticky's bottom sticks to the screen bottom and
                // its height gets changed. Sticky should be in RELEASE status and update its
                // sticky bottom by calculating how much height it changed.
                var deltaHeight = pos + height - this.state.bottom;
                this.stickyBottom = bottom - delta + deltaHeight;
                this.stickyTop = this.stickyBottom - height;
              } else {
                toRelease = false;
              }

              if (toRelease) {
                this.release(this.stickyTop);
              }

              break;
          }
        } else {
          // In this case, Sticky is shorter then viewport minus top offset
          // and will always fix to the top offset of viewport
          this.fix(this.state.top);
        }
      }

      this.delta = delta;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      if (prevState.status !== this.state.status && this.props.onStateChange) {
        this.props.onStateChange({
          status: this.state.status
        });
      }

      var arePropsChanged = !(0, _shallowequal.default)(this.props, prevProps);

      if (arePropsChanged) {
        // if the props for enabling are toggled, then trigger the update or reset depending on the current props
        if (prevProps.enabled !== this.props.enabled) {
          if (this.props.enabled) {
            this.setState({
              activated: true
            }, function () {
              _this2.updateInitialDimension();

              _this2.update();
            });
          } else {
            this.setState({
              activated: false
            }, function () {
              _this2.reset();
            });
          }
        } // if the top or bottomBoundary props were changed, then trigger the update
        else if (prevProps.top !== this.props.top || prevProps.bottomBoundary !== this.props.bottomBoundary) {
            this.updateInitialDimension();
            this.update();
          }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var subscribers = this.subscribers || [];

      for (var i = subscribers.length - 1; i >= 0; i--) {
        this.subscribers[i].unsubscribe();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // Only initialize the globals if this is the first
      // time this component type has been mounted
      if (!win) {
        win = window;
        doc = document;
        docEl = doc.documentElement;
        docBody = doc.body;
        winHeight = win.innerHeight || docEl.clientHeight;
        M = window.Modernizr; // No Sticky on lower-end browser when no Modernizr

        if (M && M.prefixed) {
          canEnableTransforms = M.csstransforms3d;
          TRANSFORM_PROP = M.prefixed('transform');
        }
      } // when mount, the scrollTop is not necessary on the top


      this.scrollTop = docBody.scrollTop + docEl.scrollTop;

      if (this.props.enabled) {
        this.setState({
          activated: true
        });
        this.updateInitialDimension();
        this.update();
      } // bind the listeners regardless if initially enabled - allows the component to toggle sticky functionality


      this.subscribers = [(0, _subscribeUiEvent.subscribe)('scrollStart', this.handleScrollStart.bind(this), {
        useRAF: true
      }), (0, _subscribeUiEvent.subscribe)('scroll', this.handleScroll.bind(this), {
        useRAF: true,
        enableScrollInfo: true
      }), (0, _subscribeUiEvent.subscribe)('resize', this.handleResize.bind(this), {
        enableResizeInfo: true
      })];
    }
  }, {
    key: "translate",
    value: function translate(style, pos) {
      var enableTransforms = canEnableTransforms && this.props.enableTransforms;

      if (enableTransforms && this.state.activated) {
        style[TRANSFORM_PROP] = 'translate3d(0,' + Math.round(pos) + 'px,0)';
      } else {
        style.top = pos + 'px';
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !this.props.shouldFreeze() && !((0, _shallowequal.default)(this.props, nextProps) && (0, _shallowequal.default)(this.state, nextState));
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this3 = this;

      // TODO, "overflow: auto" prevents collapse, need a good way to get children height
      var innerStyle = {
        position: this.state.status === STATUS_FIXED ? 'fixed' : 'relative',
        top: this.state.status === STATUS_FIXED ? '0px' : '',
        zIndex: this.props.innerZ
      };
      var outerStyle = {}; // always use translate3d to enhance the performance

      this.translate(innerStyle, this.state.pos);

      if (this.state.status !== STATUS_ORIGINAL) {
        innerStyle.width = this.state.width + 'px';
        outerStyle.height = this.state.height + 'px';
      }

      var outerClasses = (0, _classnames.default)('sticky-outer-wrapper', this.props.className, (_classNames = {}, _defineProperty(_classNames, this.props.activeClass, this.state.status === STATUS_FIXED), _defineProperty(_classNames, this.props.releasedClass, this.state.status === STATUS_RELEASED), _classNames));
      var innerClasses = (0, _classnames.default)('sticky-inner-wrapper', this.props.innerClass, _defineProperty({}, this.props.innerActiveClass, this.state.status === STATUS_FIXED));
      var children = this.props.children;
      return /*#__PURE__*/_react.default.createElement("div", {
        ref: function ref(outer) {
          _this3.outerElement = outer;
        },
        className: outerClasses,
        style: outerStyle
      }, /*#__PURE__*/_react.default.createElement("div", {
        ref: function ref(inner) {
          _this3.innerElement = inner;
        },
        className: innerClasses,
        style: innerStyle
      }, typeof children === 'function' ? children({
        status: this.state.status
      }) : children));
    }
  }]);

  return Sticky;
}(_react.Component);

Sticky.displayName = 'Sticky';
Sticky.defaultProps = {
  shouldFreeze: function shouldFreeze() {
    return false;
  },
  enabled: true,
  top: 0,
  bottomBoundary: 0,
  enableTransforms: true,
  activeClass: 'active',
  releasedClass: 'released',
  onStateChange: null,
  innerClass: '',
  innerActiveClass: ''
};
/**
 * @param {Bool} enabled A switch to enable or disable Sticky.
 * @param {String/Number} top A top offset px for Sticky. Could be a selector representing a node
 *        whose height should serve as the top offset.
 * @param {String/Number} bottomBoundary A bottom boundary px on document where Sticky will stop.
 *        Could be a selector representing a node whose bottom should serve as the bottom boudary.
 */

Sticky.propTypes = {
  enabled: _propTypes.default.bool,
  top: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  bottomBoundary: _propTypes.default.oneOfType([_propTypes.default.object, // TODO, may remove
  _propTypes.default.string, _propTypes.default.number]),
  enableTransforms: _propTypes.default.bool,
  activeClass: _propTypes.default.string,
  releasedClass: _propTypes.default.string,
  innerClass: _propTypes.default.string,
  innerActiveClass: _propTypes.default.string,
  className: _propTypes.default.string,
  onStateChange: _propTypes.default.func,
  shouldFreeze: _propTypes.default.func,
  innerZ: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Sticky.STATUS_ORIGINAL = STATUS_ORIGINAL;
Sticky.STATUS_RELEASED = STATUS_RELEASED;
Sticky.STATUS_FIXED = STATUS_FIXED;
module.exports = Sticky;

/***/ }),

/***/ "Pu0A":
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ "Q4oW":
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__("zKkv"),
    createBaseEach = __webpack_require__("bz5b");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ "QPdA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("pWxA");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("m1JM");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("SPKZ");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("qBqs");
/* harmony import */ var _spinner_Spinner__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("7amT");








var __jsx = react__WEBPACK_IMPORTED_MODULE_8___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable clubmed/no-fake-component */






var defaultProps = {
  isActive: false,
  isLoading: false,
  isReadOnly: false,
  isRequired: false,
  validationState: 'NOT_VALIDATED',
  generateUniqueId: true,
  scrollSelector: ''
};
/* DEPRECATED : DO NOT USE ANYMORE */

function formField(Component) {
  var FormField = /*#__PURE__*/function (_React$Component) {
    Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(FormField, _React$Component);

    var _super = _createSuper(FormField);

    function FormField() {
      var _this;

      Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(this, FormField);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_this), "state", {
        isActive: false,
        hasValue: !!(_this.props.defaultValue || _this.props.value)
      });

      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_this), "setActive", function () {
        _this.setState({
          isActive: true
        });
      });

      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_this), "unsetActive", function () {
        _this.setState({
          isActive: false
        });
      });

      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_this), "onClear", function () {
        _this.unsetActive();

        if (_this.props.onClear) {
          _this.props.onClear();
        }
      });

      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_this), "onChange", function (value) {
        _this.setState({
          hasValue: value !== ''
        });

        if (_this.props.onChange) {
          _this.props.onChange(value);
        }
      });

      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_this), "getValidationState", function () {
        var validationState = _this.props.validationState;
        var hasValue = _this.state.hasValue;
        return validationState === 'IS_VALID' && !hasValue ? 'NOT_VALIDATED' : validationState;
      });

      return _this;
    }

    Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(FormField, [{
      key: "renderInput",
      value: function renderInput(id) {
        var _this$props = this.props,
            icon = _this$props.icon,
            isDisabled = _this$props.isDisabled,
            isLoading = _this$props.isLoading,
            isReadOnly = _this$props.isReadOnly;
        var isActive = this.state.isActive;
        var validationState = this.getValidationState();
        var active = isActive || this.props.isActive;
        var isValid = validationState === 'IS_VALID' && !isDisabled;
        var isInvalid = validationState === 'IS_INVALID' && !isDisabled;
        return __jsx("div", {
          className: classnames__WEBPACK_IMPORTED_MODULE_9___default()('flex overflow-hidden outline-custom rounded-tiny transition-all', {
            'border-1': !isReadOnly,
            'bg-white': !isReadOnly && !isDisabled,
            'bg-gray-light': isDisabled && !isReadOnly,
            'border-blue': isActive && !isDisabled && validationState === 'NOT_VALIDATED',
            'border-success': isValid,
            'border-danger': isInvalid
          }),
          onBlur: this.unsetActive,
          onFocus: this.setActive
        }, __jsx(Component, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, this.props, id ? {
          id: id
        } : null, {
          onClear: this.onClear,
          onChange: this.onChange,
          height: "2.6875rem"
        })), isLoading && !isDisabled && !isReadOnly && __jsx("div", {
          className: "flex items-center justify-center leading-none rtl:pr-px10"
        }, __jsx(_spinner_Spinner__WEBPACK_IMPORTED_MODULE_13__[/* Spinner */ "a"], {
          size: "small"
        })), !!icon && __jsx("span", {
          className: classnames__WEBPACK_IMPORTED_MODULE_9___default()('flex items-center justify-center -order-1 px-px5 transition-all', {
            'bg-gray-light text-gray-dark': !active,
            'bg-blue text-white': active,
            'bg-success text-white': isValid,
            'bg-danger text-white': isInvalid
          }),
          style: {
            width: '2.6875rem',
            minWidth: '2.6875rem',
            height: '2.6875rem'
          }
        }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_12__[/* Icon */ "a"], {
          name: icon,
          width: "1em"
        })), (isValid || isInvalid) && __jsx("span", {
          className: classnames__WEBPACK_IMPORTED_MODULE_9___default()('flex items-center justify-center px-px10 text-xs transition-all', {
            'text-success': isValid,
            'text-danger': isInvalid
          })
        }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_12__[/* Icon */ "a"], {
          name: isValid ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_11__[/* ICONS */ "a"].CHECK : _utils_icon_icons__WEBPACK_IMPORTED_MODULE_11__[/* ICONS */ "a"].CROSS,
          width: "1em"
        })));
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            className = _this$props2.className,
            isRequired = _this$props2.isRequired,
            label = _this$props2.label,
            notes = _this$props2.notes,
            scrollSelector = _this$props2.scrollSelector;
        var id = this.props.generateUniqueId ? Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_10__[/* generateUniqueId */ "b"])([this.props.id, this.props.dataSelector]) : this.props.id;
        return __jsx("div", {
          className: classnames__WEBPACK_IMPORTED_MODULE_9___default()(className, scrollSelector, 'flex flex-col')
        }, !!label && __jsx("label", {
          className: classnames__WEBPACK_IMPORTED_MODULE_9___default()('flex font-bold items-center mb-px5 text-sm text-gray-darker transition-all'),
          htmlFor: id
        }, "".concat(label).concat(isRequired ? '*' : '')), this.renderInput(id), !!notes && __jsx("span", {
          className: "mt-px10 text-gray-darker text-sm"
        }, notes));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(props) {
        return {
          hasValue: !!(props.defaultValue || props.value)
        };
      }
    }]);

    return FormField;
  }(react__WEBPACK_IMPORTED_MODULE_8___default.a.Component);

  Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(FormField, "displayName", 'FormField');

  Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(FormField, "defaultProps", defaultProps);

  return FormField;
}

/* harmony default export */ __webpack_exports__["a"] = (formField);

/***/ }),

/***/ "QRET":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var DOMIterables = __webpack_require__("YQkA");
var ArrayIteratorMethods = __webpack_require__("I2c1");
var createNonEnumerableProperty = __webpack_require__("g51W");
var wellKnownSymbol = __webpack_require__("nJrx");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),

/***/ "QknU":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("x90g");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "Qy1q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CriteriaFieldWrapper; });
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("pWxA");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("/Mt0");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_drop_down_DropDown__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("U6GL");
/* harmony import */ var _frameworks_layer_Layer__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("U2fG");







var __jsx = react__WEBPACK_IMPORTED_MODULE_7__["createElement"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }







var CriteriaFieldWrapper = /*#__PURE__*/function (_React$Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(CriteriaFieldWrapper, _React$Component);

  var _super = _createSuper(CriteriaFieldWrapper);

  function CriteriaFieldWrapper() {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(this, CriteriaFieldWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_this), "state", {
      shouldShowLayer: false
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_this), "openCriteriaMobile", function () {
      _this.setState({
        shouldShowLayer: true
      });
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_this), "closeCriteria", function () {
      _this.setState({
        shouldShowLayer: false
      });
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_this), "cancelCriteria", function () {
      if (_this.props.onCancel) {
        _this.props.onCancel();
      }

      _this.closeCriteria();
    });

    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(CriteriaFieldWrapper, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          renderTrigger = _this$props.renderTrigger,
          title = _this$props.title;
      return __jsx(_utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].Consumer, null, function (_ref) {
        var isBrowserGreaterThan = _ref.isBrowserGreaterThan;

        if (isBrowserGreaterThan.S) {
          return __jsx(_frameworks_drop_down_DropDown__WEBPACK_IMPORTED_MODULE_11__[/* DropDown */ "a"], {
            className: "flex-1 w-full",
            contentStyle: {
              width: 350
            },
            onClose: _this2.cancelCriteria,
            renderTrigger: renderTrigger,
            theme: "hollow"
          }, children);
        }

        return __jsx(react__WEBPACK_IMPORTED_MODULE_7__["Fragment"], null, renderTrigger(_this2.openCriteriaMobile, _this2.state.shouldShowLayer), _this2.state.shouldShowLayer ? __jsx(_frameworks_layer_Layer__WEBPACK_IMPORTED_MODULE_12__[/* Layer */ "b"], {
          ariaLabel: title,
          buttonLeft: {
            iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_8__[/* ICONS */ "a"].LEFT_ARROW,
            label: Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "g"])('common.backNavigation'),
            onClick: _this2.cancelCriteria
          },
          closeLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "g"])('common.close'),
          hasAnimateEnter: true,
          onClose: _this2.cancelCriteria
        }, __jsx("div", {
          className: "flex flex-col"
        }, children(_this2.closeCriteria, true))) : null);
      });
    }
  }]);

  return CriteriaFieldWrapper;
}(react__WEBPACK_IMPORTED_MODULE_7__["Component"]);

/***/ }),

/***/ "R2jv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return START_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return startLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return endLoading; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");

var START_LOADING = 'START_LOADING';
var END_LOADING = 'END_LOADING';

function endLoading() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(END_LOADING, {});
}

function startLoading(globalLoaderLabel, isNavigation) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(START_LOADING, {
    globalLoaderLabel: globalLoaderLabel,
    isNavigation: isNavigation
  });
}



/***/ }),

/***/ "R3TX":
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__("zWgn"),
    overRest = __webpack_require__("UAs9"),
    setToString = __webpack_require__("7Pat");

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ "R5u7":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("pPzx"),
    isArrayLike = __webpack_require__("9y2L"),
    isIndex = __webpack_require__("pnw1"),
    isObject = __webpack_require__("tQYX");

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ "RBO1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDepartureCity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureDate; });
/* unused harmony export getMainContactOptinEmail */
/* unused harmony export getMainContactOptinSms */
/* unused harmony export getMainContactOptinFosun */
/* unused harmony export getMainContactOptinMail */
/* unused harmony export getMainContactOptinPhone */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTripDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTripFlexibility; });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);


var tripCriteriaSelector = function tripCriteriaSelector(_ref) {
  var tripCriteria = _ref.tripCriteria;
  return tripCriteria || {};
};

var mainContactSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref2) {
  var mainContact = _ref2.mainContact;
  return mainContact || {};
});
var getDepartureCity = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref3) {
  var departureCity = _ref3.departureCity;
  return departureCity;
});
var getDepartureDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref4) {
  var departureDate = _ref4.departureDate;
  return departureDate;
});
var getMainContactOptinEmail = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref5) {
  var optinEmail = _ref5.optinEmail;
  return optinEmail;
});
var getMainContactOptinSms = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref6) {
  var optinSms = _ref6.optinSms;
  return optinSms;
});
var getMainContactOptinMail = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref7) {
  var optinMail = _ref7.optinMail;
  return optinMail;
});
var getMainContactOptinPhone = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref8) {
  var optinPhone = _ref8.optinPhone;
  return optinPhone;
});
var getMainContactOptinFosun = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref9) {
  var optinFosun = _ref9.optinFosun;
  return optinFosun;
});
var getTripDuration = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref10) {
  var duration = _ref10.duration;
  return duration;
});
var getTripFlexibility = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref11) {
  var flexibility = _ref11.flexibility;
  return flexibility;
});


/***/ }),

/***/ "RNvQ":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("tQYX"),
    now = __webpack_require__("ENE1"),
    toNumber = __webpack_require__("nvU9");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ "RZpO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Link; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/index.js
var tracking_api = __webpack_require__("d1HQ");

// CONCATENATED MODULE: ./src/client/components/frameworks/link/Link.tracking.js


function tracking(actionGA, labelGA, appContext) {
  Object(tracking_api["b" /* setDataLayer */])({
    event: constants["h" /* EVENT_GA */],
    versionBooking: 'responsive',
    categoryGA: 'bookingEngine',
    actionGA: actionGA,
    labelGA: labelGA,
    valueGA: '0',
    nonInteraction: '0'
  }, appContext);
}
// CONCATENATED MODULE: ./src/client/components/frameworks/link/Link.jsx
var __jsx = react["createElement"];





var Link = /*#__PURE__*/react["forwardRef"](function (props, ref) {
  var className = props.className,
      actionGA = props.actionGA,
      labelGA = props.labelGA,
      _onClick = props.onClick,
      icon = props.icon,
      label = props.label;
  var appContext = react["useContext"](ReactAppContext["a" /* default */]);
  if (!label) return __jsx("div", {
    className: "relative text-center"
  });
  return __jsx("div", {
    className: classnames_default()(className, 'relative text-center')
  }, __jsx("button", {
    className: "Link-button",
    onClick: function onClick() {
      if (actionGA && labelGA) {
        tracking(actionGA, labelGA, appContext);
      }

      _onClick();
    },
    ref: ref,
    type: "button"
  }, icon && __jsx(Icon["a" /* Icon */], {
    className: "Link-icon",
    name: icon,
    width: "1.5625rem"
  }), __jsx("span", {
    className: icon && 'Link-label'
  }, label)));
});

/***/ }),

/***/ "RqHf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mixedToMoment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return dateToInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dateDiff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return maxDatepickerDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return minDatepickerDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closedDaysFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getDisabledDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bestPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return lastRoom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return flattenPrices; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _store_calendar_calendar_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("VtPb");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("sW3P");





var mixedToMoment = function mixedToMoment(mixedDate) {
  return moment__WEBPACK_IMPORTED_MODULE_2___default()(mixedDate);
};
var dateToInt = function dateToInt(d) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYYMMDD';
  return parseInt(mixedToMoment(d).format(format), 10);
};
var dateDiff = function dateDiff(day1, day2) {
  return Math.abs(moment__WEBPACK_IMPORTED_MODULE_2___default()(day2).diff(moment__WEBPACK_IMPORTED_MODULE_2___default()(day1), 'days'));
};
var maxDatepickerDate = function maxDatepickerDate() {
  return moment__WEBPACK_IMPORTED_MODULE_2___default()().add(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_4__[/* DEPARTURE_DATE_MAX_DATE */ "k"]).toDate();
};
var minDatepickerDate = function minDatepickerDate() {
  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return moment__WEBPACK_IMPORTED_MODULE_2___default()().add({
    days: offset
  }).toDate();
};

function daysWithoutDepartureFactory(resolver, fromDate, toDate) {
  return function (day) {
    var _resolver = resolver(dateToInt(day)),
        _resolver$exclusivity = _resolver.exclusivity,
        exclusivity = _resolver$exclusivity === void 0 ? false : _resolver$exclusivity,
        _resolver$noFlight = _resolver.noFlight,
        noFlight = _resolver$noFlight === void 0 ? false : _resolver$noFlight,
        _resolver$full = _resolver.full,
        full = _resolver$full === void 0 ? false : _resolver$full;

    var available = !exclusivity && !noFlight && !full;

    if (!fromDate && !toDate) {
      return !available;
    }

    if (fromDate && !toDate) {
      return false;
    }

    var dayIsSelected = fromDate && toDate && dateToInt(day) >= dateToInt(fromDate) && dateToInt(day) <= dateToInt(toDate);
    return !dayIsSelected && !available;
  };
}

var daysWithNoAvailabilityFactory = function daysWithNoAvailabilityFactory(resolver) {
  return function (day) {
    var data = resolver(dateToInt(day));
    return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isEmpty"])(data) || data.noAvailability;
  };
};

var closedDaysFactory = function closedDaysFactory(resolver, fromDate, toDate) {
  return function (day) {
    var _resolver2 = resolver(dateToInt(day)),
        _resolver2$closed = _resolver2.closed,
        closed = _resolver2$closed === void 0 ? false : _resolver2$closed;

    if (!fromDate && !toDate) {
      return closed;
    }

    if (fromDate && !toDate) {
      return false;
    }

    var dayIsSelected = fromDate && toDate && dateToInt(day) >= dateToInt(fromDate) && dateToInt(day) <= dateToInt(toDate);
    return !dayIsSelected && closed;
  };
};

var unavailableReturnDaysFactory = function unavailableReturnDaysFactory(fromDate) {
  var durations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return function (day) {
    if (day < fromDate) return false;
    var duration = dateDiff(day, fromDate); // rule of max 30 days of reservation

    if (duration > 30) return true;
    return !!duration && !durations.includes(duration);
  };
};

function getDisabledDays(_ref) {
  var from = _ref.from,
      isSeller = _ref.isSeller,
      optionsDuration = _ref.optionsDuration,
      openingDates = _ref.openingDates,
      prices = _ref.prices,
      resolvePrice = _ref.resolvePrice,
      to = _ref.to;
  var disabledDays = [];
  var pricesIds = Object.keys(prices || {});
  var hasPrices = pricesIds.length > 0;
  var allClosedDays = pricesIds.filter(function (priceKey) {
    return prices && prices[priceKey].closed;
  }).map(function (priceKey) {
    return parseInt(priceKey, 10);
  });

  if (hasPrices) {
    var dayIsWithoutDeparture = daysWithoutDepartureFactory(resolvePrice, from, to);
    var dayIsClosed = closedDaysFactory(resolvePrice, from, to);
    var dayIsWithoutData = daysWithNoAvailabilityFactory(resolvePrice);
    disabledDays.push(dayIsWithoutDeparture);
    disabledDays.push(dayIsClosed);
    disabledDays.push(dayIsWithoutData);
  }

  if (from && !to) {
    var fromDay = dateToInt(from);
    var closedDaysAfterFromDay = allClosedDays.filter(function (closedDay) {
      return closedDay > fromDay;
    });
    var firstClosedDay = hasPrices && closedDaysAfterFromDay.length > 0 && Math.min.apply(null, closedDaysAfterFromDay);
    disabledDays.push({
      before: moment__WEBPACK_IMPORTED_MODULE_2___default()(from).toDate(),
      after: firstClosedDay ? moment__WEBPACK_IMPORTED_MODULE_2___default()(firstClosedDay.toString()).toDate() : moment__WEBPACK_IMPORTED_MODULE_2___default()(from).add(30, 'days').toDate()
    });
  }

  if (from && !to && !Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isEmpty"])(optionsDuration) && !isSeller) {
    disabledDays.push(unavailableReturnDaysFactory(from, optionsDuration));
  }

  if (openingDates === null || openingDates === void 0 ? void 0 : openingDates.length) {
    disabledDays.push.apply(disabledDays, Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(Object(_store_calendar_calendar_helper__WEBPACK_IMPORTED_MODULE_3__[/* getClosingDatesRanges */ "b"])(openingDates)));
  }

  return disabledDays;
}
function bestPrice(resolver) {
  return function (day) {
    var id = dateToInt(day);

    var _ref2 = resolver && resolver(id) || {
      isBestPrice: false
    },
        isBestPrice = _ref2.isBestPrice;

    return isBestPrice;
  };
}
var lastRoom = function lastRoom(resolver) {
  return function (day) {
    var id = dateToInt(day);

    var _ref3 = resolver && resolver(id) || {
      lastAvailability: false
    },
        lastAvailability = _ref3.lastAvailability;

    return lastAvailability;
  };
};
function flattenPrices(prices) {
  var pricesIds = Object.keys(prices);
  return pricesIds.map(function (priceId) {
    return prices[priceId].oldPrice;
  }).join();
}

/***/ }),

/***/ "SRps":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "U/+3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LayerHeaderProposal; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("/Mt0");
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("oL6k");
/* harmony import */ var _utils_transport_transportUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("pdPG");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





var getTransportSummary = function getTransportSummary(proposal) {
  var currentTransport = proposal.transports;
  var inboundDeparture = Object(_utils_transport_transportUtils__WEBPACK_IMPORTED_MODULE_3__[/* getInboundDeparture */ "a"])(currentTransport);
  var outboundDeparture = Object(_utils_transport_transportUtils__WEBPACK_IMPORTED_MODULE_3__[/* getOutboundDeparture */ "b"])(currentTransport);
  var departureSummary = Object(_utils_transport_transportUtils__WEBPACK_IMPORTED_MODULE_3__[/* getTravelSectionBoundSummary */ "d"])(inboundDeparture);
  var arrivalSummary = Object(_utils_transport_transportUtils__WEBPACK_IMPORTED_MODULE_3__[/* getTravelSectionBoundSummary */ "d"])(outboundDeparture);
  return departureSummary && arrivalSummary ? "".concat(departureSummary, " - ").concat(arrivalSummary) : '';
};

var getProposalSummary = function getProposalSummary(proposal, dateFormat) {
  var arrivalDate = Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_2__[/* getFormattedArrivalDate */ "h"])(proposal, dateFormat);
  var departureDate = Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_2__[/* getFormattedDepartureDate */ "i"])(proposal, dateFormat);
  return "".concat(arrivalDate, " - ").concat(departureDate);
};

var LayerHeaderProposal = function LayerHeaderProposal(_ref) {
  var id = _ref.id,
      numberResults = _ref.numberResults,
      proposal = _ref.proposal,
      _ref$layerTitle = _ref.layerTitle,
      layerTitle = _ref$layerTitle === void 0 ? '' : _ref$layerTitle,
      dateFormat = _ref.dateFormat,
      _ref$totalPrice = _ref.totalPrice,
      totalPrice = _ref$totalPrice === void 0 ? '' : _ref$totalPrice;

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_0__["useContext"])(_utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]),
      isDesktop = _useContext.isDesktop,
      isTablet = _useContext.isTablet;

  var summary = proposal.transports ? getTransportSummary(proposal) : getProposalSummary(proposal, dateFormat);
  return __jsx("div", {
    className: "flex items-end leading-one"
  }, isDesktop && __jsx("span", {
    className: "font-bold mx-mx10 rtl:mr-auto text-gray-dark text-md",
    "data-testid": "LayerHeaderProposal-summary"
  }, summary), __jsx("span", {
    className: "flex-1 font-bold mx-px10 self-center text-blue text-center text-lg",
    "data-testid": "LayerHeaderProposal-title",
    id: id
  }, layerTitle, numberResults && __jsx("span", {
    className: "text-sm text-gray-dark"
  }, "\xA0(", numberResults, ")")), isTablet && __jsx("span", {
    className: "mx-px10 rtl:ml-auto"
  }, __jsx("span", {
    className: "font-bold text-gray-dark text-md",
    "data-testid": "LayerHeaderProposal-totalLabel"
  }, totalPrice), __jsx("span", {
    className: "font-bold rtl:ml-px10 text-blue text-xl",
    "data-testid": "LayerHeaderProposal-total"
  }, Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_2__[/* getTotalPriceFormatted */ "o"])(proposal))));
};

/***/ }),

/***/ "U6GL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ DropDown_DropDown; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/utils/keyCodes.js
var keyCodes = __webpack_require__("05v4");

// CONCATENATED MODULE: ./src/client/components/frameworks/drop-down/DropDown.themes.js
var themes = {
  "default": {
    thBody: 'arrow-up arrow-white arrow-bg arrow-bg-gray-light bg-white border-1 border-light-gray mt-px15 p-px10 shadow-lg'
  },
  hollow: {
    thBody: 'arrow-up arrow-large arrow-white arrow-bg arrow-bg-gray-light bg-white border-1 border-gray-light mt-px20 rounded-small shadow-lg'
  },
  solid: {
    thBody: 'bg-white'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/drop-down/DropDown.jsx







var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






var DropDown_DropDown = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(DropDown, _Component);

  var _super = _createSuper(DropDown);

  function DropDown(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, DropDown);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "rootRef", /*#__PURE__*/Object(react["createRef"])());

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "contentRef", /*#__PURE__*/Object(react["createRef"])());

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "expand", function () {
      _this.setState({
        isExpanded: true
      }, _this.toggleEventListeners);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "collapse", function () {
      if (_this.props.onClose) {
        _this.props.onClose();
      }

      if (!_this.props.unmountsOnClose) {
        _this.setState({
          isExpanded: false
        }, _this.toggleEventListeners);
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onKeyDown", function (e) {
      if (e.keyCode === keyCodes["g" /* ESCAPE */]) {
        _this.collapse();
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClickOutside", function (e) {
      if (!_this.contentRef || // $FlowFixMe
      _this.contentRef.current.contains(e.target) || // $FlowFixMe
      _this.rootRef.current.contains(e.target) || // $FlowFixMe
      Object(lodash["get"])(_this.props, 'rootRef.current') && _this.props.rootRef.current.contains(e.target) || e.button && e.button !== 0) {
        return;
      }

      _this.collapse();
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "toggle", function () {
      _this.setState(function (prevState) {
        return {
          isExpanded: !prevState.isExpanded
        };
      }, _this.toggleEventListeners);
    });

    _this.state = {
      isExpanded: props.isExpanded || false
    };
    return _this;
  }

  Object(createClass["a" /* default */])(DropDown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.state.isExpanded) {
        this.addEventListeners();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isExpanded) {
        this.removeEventListeners();
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.isExpanded !== this.props.isExpanded) {
        this.setState({
          isExpanded: nextProps.isExpanded
        }, this.toggleEventListeners);
      }
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      if (true) {
        document.addEventListener('mouseup', this.onClickOutside, false);
        document.addEventListener('touchstart', this.onClickOutside, false);
        document.addEventListener('keydown', this.onKeyDown, false);
      }
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      if (true) {
        document.removeEventListener('mouseup', this.onClickOutside, false);
        document.removeEventListener('touchstart', this.onClickOutside, false);
        document.removeEventListener('keydown', this.onKeyDown, false);
      }
    }
  }, {
    key: "toggleEventListeners",
    value: function toggleEventListeners() {
      if (this.state.isExpanded) {
        this.addEventListeners();
      } else {
        this.removeEventListeners();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          contentStyle = _this$props.contentStyle,
          hasCloseOnClick = _this$props.hasCloseOnClick,
          renderTrigger = _this$props.renderTrigger,
          theme = _this$props.theme;
      var thBody = themes[theme].thBody;
      return __jsx("div", {
        className: classnames_default()(className, 'inline-block relative'),
        ref: this.rootRef
      }, renderTrigger && renderTrigger(this.toggle, this.state.isExpanded), this.state.isExpanded && __jsx("div", {
        className: classnames_default()('absolute left-1/2 min-w-full w-full -translate-x-50 z-4', thBody),
        "data-testid": "DropDown-body",
        onClick: hasCloseOnClick ? this.collapse : null,
        ref: this.contentRef,
        style: contentStyle
      }, children(this.toggle, this.state.isExpanded)));
    }
  }]);

  return DropDown;
}(react["Component"]);

Object(defineProperty["a" /* default */])(DropDown_DropDown, "defaultProps", {
  isExpanded: false,
  theme: 'default',
  unmountsOnClose: false
});

/***/ }),

/***/ "UAs9":
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__("zaNA");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ "UIAR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_ACCOMMODATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_ACCOMMODATION_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADD_TRANSFER_TO_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ADD_TRANSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return UPDATE_ATTENDEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CLEAR_PROPOSALS; });
/* unused harmony export LOAD_PROPOSAL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_PROPOSALS_BY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_SELECTED_PROPOSAL_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return REMOVE_TRANSFER_FROM_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SET_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SAVE_CUSTOMER_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return UPDATE_INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DELETE_INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return PREPARE_BE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DISPLAY_TOAST_ON_CONTEXT_SHARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_PROPOSALS_FROM_EDIT_CRITERIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SAVE_DONATION_TO_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SET_PROMO_CODE; });
/* unused harmony export SET_PROMO_CODE_FAILURE_STATUS */
/* unused harmony export SET_PROMO_CODE_SUCCESS_STATUS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return UPDATE_SERVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DELETE_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SWITCH_PROPOSALS_OFFERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PRICE_COUNTER_PROPOSAL_MAX_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return PRICE_COUNTER_PROPOSAL_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return INSURANCE_ADDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return INSURANCE_DELETED; });
var ADD_ACCOMMODATION = 'ADD_ACCOMMODATION';
var ADD_ACCOMMODATION_ERROR = 'ADD_ACCOMMODATION_ERROR';
var ADD_TRANSFER_TO_PROPOSALS = 'ADD_TRANSFER_TO_PROPOSALS';
var ADD_TRANSPORT = 'ADD_TRANSPORT';
var UPDATE_ATTENDEES = 'UPDATE_ATTENDEES';
var CLEAR_PROPOSALS = 'CLEAR_PROPOSALS';
var LOAD_PROPOSAL = 'LOAD_PROPOSAL';
var FETCH_PROPOSALS = 'FETCH_PROPOSALS';
var FETCH_PROPOSALS_BY_ID = 'FETCH_PROPOSALS_BY_ID';
var FETCH_SELECTED_PROPOSAL_PAYMENT = 'FETCH_SELECTED_PROPOSAL_PAYMENT';
var REMOVE_TRANSFER_FROM_PROPOSALS = 'REMOVE_TRANSFER_FROM_PROPOSALS';
var SET_PROPOSALS = 'SET_PROPOSALS';
var SAVE_CUSTOMER_PROPOSAL = 'SAVE_CUSTOMER_PROPOSAL';
var UPDATE_INSURANCES = 'UPDATE_INSURANCES';
var DELETE_INSURANCES = 'DELETE_INSURANCES';
var PREPARE_BE = 'PREPARE_BE';
var DISPLAY_TOAST_ON_CONTEXT_SHARE = 'DISPLAY_TOAST_ON_CONTEXT_SHARE';
var FETCH_PROPOSALS_FROM_EDIT_CRITERIA = 'FETCH_PROPOSALS_FROM_EDIT_CRITERIA';
var SAVE_DONATION_TO_PROPOSALS = 'SAVE_DONATION_TO_PROPOSALS';
var SET_PROMO_CODE = 'SET_PROMO_CODE';
var SET_PROMO_CODE_FAILURE_STATUS = 'failure';
var SET_PROMO_CODE_SUCCESS_STATUS = 'success';
var UPDATE_SERVICES = 'UPDATE_SERVICES';
var ADD_SERVICE = 'ADD_SERVICE';
var DELETE_SERVICE = 'DELETE_SERVICE';
var SWITCH_PROPOSALS_OFFERS = 'SWITCH_PROPOSALS_OFFERS';
var PRICE_COUNTER_PROPOSAL_MAX_THRESHOLD = 30;
var PRICE_COUNTER_PROPOSAL_THRESHOLD = 10;
var PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD = 30;
var INSURANCE_ADDED = 'INSURANCE_DELETED';
var INSURANCE_DELETED = 'INSURANCE_ADDED';

/***/ }),

/***/ "UhMs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InnerTransportDetails; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__("yjkv");
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/utils/label/labelUtils.js
var labelUtils = __webpack_require__("WGoB");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/ContactInfoUtils.js + 1 modules
var ContactInfoUtils = __webpack_require__("ZHrn");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/widgets/transport-details/transportUtils.js
var transportUtils = __webpack_require__("z8xc");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx + 1 modules
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/tooltip/Tooltip.jsx
var Tooltip = __webpack_require__("i3Ve");

// EXTERNAL MODULE: ./src/client/components/frameworks/collapse-panel/CollapsePanel.jsx + 1 modules
var CollapsePanel = __webpack_require__("gA51");

// CONCATENATED MODULE: ./src/client/components/widgets/be-transport-details/inner-transport-details/LineOfDots.jsx
var __jsx = react_default.a.createElement;


var Square = function Square(_ref) {
  var margin = _ref.margin;
  return __jsx("div", {
    className: "bg-gray-medium-dark",
    style: {
      height: '3px',
      width: '2px',
      margin: margin || '3px 3px 2px 2px'
    }
  });
};

var dotSize = {
  height: '6px',
  width: '6px'
};
function LineOfDots() {
  return __jsx("div", {
    "data-testid": "LineOfDots"
  }, __jsx("div", {
    className: "rounded-half mb-px5 bg-gray-medium-dark",
    style: dotSize
  }), __jsx(Square, {
    margin: "5px 3px 2px 2px"
  }), __jsx(Square, null), __jsx(Square, null), __jsx(Square, null), __jsx(Square, null), __jsx(Square, null), __jsx(Square, {
    margin: "3px 3px 5px 2px"
  }), __jsx("div", {
    className: "rounded-half mt-px5 bg-gray-medium-dark",
    style: dotSize
  }));
}
// CONCATENATED MODULE: ./src/client/components/widgets/be-transport-details/inner-transport-details/InnerTransportCollapsePanel.jsx
var InnerTransportCollapsePanel_jsx = react_default.a.createElement;










function InnerTransportCollapsePanel(_ref) {
  var _flight$travelSection;

  var flight = _ref.flight,
      tabIndex = _ref.tabIndex;

  var _useState = Object(react["useState"])(false),
      expandedDetails = _useState[0],
      setExpandedDetails = _useState[1];

  var toggleDetails = function toggleDetails() {
    setExpandedDetails(function (wasExpanded) {
      return !wasExpanded;
    });
  };

  var getTransportClassLabel = function getTransportClassLabel(transportClass) {
    return Object(src_i18n["g" /* t */])("common.transport.transportClass.".concat(transportUtils["c" /* TRANSPORT_CLASS_TO_I18N */][transportClass]));
  };

  return InnerTransportCollapsePanel_jsx(CollapsePanel["a" /* CollapsePanel */], {
    collapseIconName: icons["a" /* ICONS */].SELECT_UP,
    collapseLabel: Object(src_i18n["g" /* t */])('common.loadLess'),
    expandIconName: icons["a" /* ICONS */].SELECT,
    expandLabel: Object(src_i18n["g" /* t */])('common.loadMore'),
    isExpanded: expandedDetails,
    theme: "liteFlexible",
    loadMoreButtonPosition: "bottom"
  }, InnerTransportCollapsePanel_jsx("div", {
    className: "px-px20 pt-px20 border-t-1 w-full mt-px15 relative",
    onClick: toggleDetails,
    onKeyDown: toggleDetails,
    role: "button",
    tabIndex: tabIndex
  }, flight === null || flight === void 0 ? void 0 : (_flight$travelSection = flight.travelSections) === null || _flight$travelSection === void 0 ? void 0 : _flight$travelSection.map(function (travelSection, index) {
    var _flight$travelSection2, _travelSection$depart, _travelSection$depart2, _travelSection$arriva, _travelSection$transp, _travelSection$transp2, _travelSection$transp3, _travelSection$transp4, _travelSection$transp5, _travelSection$transp6;

    var isFirst = index === 0;
    var isLast = index === (flight === null || flight === void 0 ? void 0 : (_flight$travelSection2 = flight.travelSections) === null || _flight$travelSection2 === void 0 ? void 0 : _flight$travelSection2.length) - 1;
    return InnerTransportCollapsePanel_jsx("div", {
      "data-testid": "TravelSection",
      key: travelSection.transport.travelNumber
    }, !isFirst && (travelSection.stopDurationInMin || travelSection.connectionDurationInMin ? InnerTransportCollapsePanel_jsx("div", {
      "data-testid": "EscalDuration",
      className: "p-px20 border-1 border-gray-light bg-gray-lighter w-full my-px20 text-base font-bold rounded-tiny"
    }, Object(transportUtils["p" /* transformMinutesInHours */])(travelSection.stopDurationInMin || travelSection.connectionDurationInMin), ' ', "- ", travelSection === null || travelSection === void 0 ? void 0 : (_travelSection$depart = travelSection.departure) === null || _travelSection$depart === void 0 ? void 0 : _travelSection$depart.id) : InnerTransportCollapsePanel_jsx("div", {
      className: "h-8"
    })), InnerTransportCollapsePanel_jsx("div", {
      className: classnames_default()('absolute mt-px10', {
        'mt-px15': !isFirst && travelSection.stopDurationInMin === 0
      })
    }, InnerTransportCollapsePanel_jsx(LineOfDots, null)), InnerTransportCollapsePanel_jsx("div", null, InnerTransportCollapsePanel_jsx("div", {
      className: classnames_default()({
        'font-bold': isFirst
      }, 'my-px10 rtl:ml-px25')
    }, Object(transportUtils["e" /* formatTime */])(travelSection.departure.time, Object(src_i18n["g" /* t */])('common.timeFormat')), " \u2014", ' ', Object(labelUtils["a" /* capitalizeName */])(travelSection.departure.airportLabel || ''), " (", (_travelSection$depart2 = travelSection.departure) === null || _travelSection$depart2 === void 0 ? void 0 : _travelSection$depart2.id, ")"), InnerTransportCollapsePanel_jsx("div", {
      className: "text-sm text-gray-medium-dark rtl:ml-px25 h-4"
    }), InnerTransportCollapsePanel_jsx("div", {
      className: "".concat(isLast ? 'font-bold' : '', " my-px10 rtl:ml-px25")
    }, Object(transportUtils["e" /* formatTime */])(travelSection.arrival.time, Object(src_i18n["g" /* t */])('common.timeFormat')), " \u2014", ' ', Object(labelUtils["a" /* capitalizeName */])(travelSection.arrival.airportLabel || ''), " (", (_travelSection$arriva = travelSection.arrival) === null || _travelSection$arriva === void 0 ? void 0 : _travelSection$arriva.id, ")"), InnerTransportCollapsePanel_jsx("div", {
      className: "text-sm text-gray-medium-dark flex items-center rtl:ml-px25"
    }, "".concat(travelSection === null || travelSection === void 0 ? void 0 : (_travelSection$transp = travelSection.transport) === null || _travelSection$transp === void 0 ? void 0 : (_travelSection$transp2 = _travelSection$transp.companyExploiter) === null || _travelSection$transp2 === void 0 ? void 0 : _travelSection$transp2.id, "  ").concat(travelSection === null || travelSection === void 0 ? void 0 : (_travelSection$transp3 = travelSection.transport) === null || _travelSection$transp3 === void 0 ? void 0 : _travelSection$transp3.travelNumber), " ".concat(Object(labelUtils["a" /* capitalizeName */])(travelSection === null || travelSection === void 0 ? void 0 : (_travelSection$transp4 = travelSection.transport) === null || _travelSection$transp4 === void 0 ? void 0 : (_travelSection$transp5 = _travelSection$transp4.companyExploiter) === null || _travelSection$transp5 === void 0 ? void 0 : _travelSection$transp5.label), " \u2014 ").concat(getTransportClassLabel(travelSection === null || travelSection === void 0 ? void 0 : travelSection.transport.class)), (travelSection === null || travelSection === void 0 ? void 0 : (_travelSection$transp6 = travelSection.transport) === null || _travelSection$transp6 === void 0 ? void 0 : _travelSection$transp6.baggage) && InnerTransportCollapsePanel_jsx(react["Fragment"], null, InnerTransportCollapsePanel_jsx(Icon["a" /* Icon */], {
      className: "mx-px10 -mt-px5 flex items-center",
      color: colors["a" /* COLORS */].BLUE,
      dataTestid: "baggage-icon",
      id: "baggage-icon",
      name: icons["a" /* ICONS */].BAGGAGE,
      width: "1.1rem"
    }), InnerTransportCollapsePanel_jsx("span", {
      "data-testid": "weightAndQuantity"
    }, InnerTransportCollapsePanel_jsx("span", {
      className: "font-bold text-gray-medium-dark"
    }, travelSection === null || travelSection === void 0 ? void 0 : travelSection.transport.baggage.quantity, (travelSection === null || travelSection === void 0 ? void 0 : travelSection.transport.baggage.weight) && "x".concat(travelSection === null || travelSection === void 0 ? void 0 : travelSection.transport.baggage.weight)), "/".concat(Object(src_i18n["g" /* t */])('common.transport.weightPerPersonLabel')))))));
  })));
}
// EXTERNAL MODULE: ./src/client/components/widgets/be-transport-details/inner-transport-details/InnerTransportDetailsHeader.jsx
var InnerTransportDetailsHeader = __webpack_require__("iTz8");

// CONCATENATED MODULE: ./src/client/components/widgets/be-transport-details/inner-transport-details/InnerTransportDetailsLogo.jsx
var InnerTransportDetailsLogo_jsx = react_default.a.createElement;





var SNCF_ID = 'SNC'; // additional verfication for SNCF logo

function InnerTransportDetailsLogo(_ref) {
  var companyOperator = _ref.companyOperator,
      manyCompanies = _ref.manyCompanies,
      isComparator = _ref.isComparator;

  if (manyCompanies) {
    return (// generic logo if many travelSections with different companies
      InnerTransportDetailsLogo_jsx("div", {
        className: classnames_default()(isComparator ? 'w-1/2' : 'w-1/2 md:w-1/3'),
        "data-testid": "InnerTransportDetailsLogoIcon"
      }, InnerTransportDetailsLogo_jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].MULTIPLE_COMPANIES,
        width: "2rem",
        className: "-my-px5"
      }))
    );
  }

  return companyOperator ? InnerTransportDetailsLogo_jsx("div", {
    className: classnames_default()(isComparator ? 'w-1/2' : 'w-1/2 md:w-1/3')
  }, InnerTransportDetailsLogo_jsx("img", {
    src: companyOperator.logo // SNCF logo is shaped differently than other logos and should have a specific width
    ,
    width: companyOperator.id === SNCF_ID ? 65 : 110,
    alt: companyOperator.label
  }), companyOperator.id !== SNCF_ID && InnerTransportDetailsLogo_jsx("div", {
    className: "text-sm"
  }, Object(labelUtils["a" /* capitalizeName */])(companyOperator.label))) : null;
}
// CONCATENATED MODULE: ./src/client/components/widgets/be-transport-details/inner-transport-details/InnerTransportDetails.themes.js
var themes = function themes() {
  return {
    "default": {
      thWrapper: 'w-full md:w-1/2',
      thInnerWrapper: 'md:min-h-32 px-px20 pt-px20',
      thDateTime: 'md:block hidden w-2/3',
      thSecondDateTime: 'block md:hidden w-full py-px15',
      thTwoLine: 'w-1/2 md:w-1/5',
      thSecondTwoLine: 'w-full md:w-3/5',
      thSecondLine: 'mt-px10 md:mt-px25 flex-col md:flex-row flex w-full justify-between',
      thOperatedBy: 'w-full md:w-1/3',
      thRecommendedByWrapper: 'w-full md:w-1/5 flex-col md:flex-row',
      thRecommendedByInner: 'pt-px25 md:pt-0 flex flex-row items-start',
      thRecommendedBy: 'flex md:flex-row items-center flex-col',
      thRecommendedByText: 'w-full md:w-30 mb-px10 md:mb-0 text-base font-bold mr-px5 mx-px5 text-left'
    },
    comparator: {
      thWrapper: 'w-full',
      thInnerWrapper: 'min-h-auto px-px20 pt-px20',
      thDateTime: 'hidden w-2/3',
      thSecondDateTime: 'block w-full py-px15',
      thTwoLine: 'w-1/2',
      thSecondTwoLine: 'w-full',
      thSecondLine: 'mt-px10 flex-col flex w-full justify-between',
      thOperatedBy: 'w-full',
      thRecommendedByWrapper: 'w-full flex-col',
      thRecommendedByInner: 'pt-px25 flex flex-row items-start',
      thRecommendedBy: 'flex items-center flex-col',
      thRecommendedByText: 'w-full mb-px10 text-base font-bold mr-px5 mx-px5 text-left'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/widgets/be-transport-details/inner-transport-details/InnerTransportDetails.jsx

var InnerTransportDetails_jsx = react_default.a.createElement;




















function TwoLineSection(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      plus = _ref.plus,
      subtitle = _ref.subtitle,
      title = _ref.title;
  return InnerTransportDetails_jsx("div", {
    className: classnames_default()(className, 'flex flex-col')
  }, InnerTransportDetails_jsx("div", {
    className: "font-bold flex items-center text-base"
  }, title, !!plus && InnerTransportDetails_jsx("span", {
    className: "bg-blue px-px5 rtl:ml-px5 text-sm text-white"
  }, "+ ", Object(src_i18n["g" /* t */])('common.dateTime.day', {
    count: plus
  }))), InnerTransportDetails_jsx("div", {
    className: "text-gray-medium-dark text-sm "
  }, subtitle));
}

function getCompaniesNames() {
  var travelSections = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var allCompanies = travelSections.reduce(function (companies, section) {
    var _section$transport$co;

    if ((_section$transport$co = section.transport.companyExploiter) === null || _section$transport$co === void 0 ? void 0 : _section$transport$co.id) {
      companies.push(section.transport.companyExploiter);
    }

    return companies;
  }, []);
  return uniqBy_default()(allCompanies, 'id').map(function (company) {
    return Object(labelUtils["a" /* capitalizeName */])(company.label);
  });
}

function InnerTransportDetails(_ref2) {
  var _flight$travelSection, _getOptinsInfos$theo, _flightProp$departure, _flightProp$arrival, _flightProp$departure2, _flightProp$arrival2, _flightProp$arrival5, _flightProp$departure5, _flightProp$arrival6, _flightProp$departure6, _flightProp$transport, _flightProp$transport2, _flightProp$departure7, _flightProp$arrival7, _flightProp$transport3, _flightProp$transport4;

  var button = _ref2.button,
      flight = _ref2.flight,
      _ref2$isComparator = _ref2.isComparator,
      isComparator = _ref2$isComparator === void 0 ? false : _ref2$isComparator,
      _ref2$isSearchPage = _ref2.isSearchPage,
      isSearchPage = _ref2$isSearchPage === void 0 ? false : _ref2$isSearchPage,
      tabIndex = _ref2.tabIndex,
      price = _ref2.price,
      _ref2$transportIcon = _ref2.transportIcon,
      transportIcon = _ref2$transportIcon === void 0 ? icons["a" /* ICONS */].TRANSPORT : _ref2$transportIcon,
      noBusinessClassAvailable = _ref2.noBusinessClassAvailable,
      _ref2$isSelectedRecom = _ref2.isSelectedRecommended,
      isSelectedRecommended = _ref2$isSelectedRecom === void 0 ? true : _ref2$isSelectedRecom,
      way = _ref2.way,
      i18n = _ref2.i18n;
  var flightProp = {};
  var isInbound = way === 'INBOUND';
  var airportIds = [];
  var theme = isComparator ? 'comparator' : 'default';

  if ((flight === null || flight === void 0 ? void 0 : (_flight$travelSection = flight.travelSections) === null || _flight$travelSection === void 0 ? void 0 : _flight$travelSection.length) > 0) {
    var firstSection = flight.travelSections[0];

    var _flight$travelSection2 = flight.travelSections.slice(-1),
        _flight$travelSection3 = Object(slicedToArray["a" /* default */])(_flight$travelSection2, 1),
        lastSection = _flight$travelSection3[0];

    flightProp.departure = firstSection.departure;
    flightProp.arrival = lastSection.arrival;
    flightProp.transport = firstSection.transport;
    flightProp.stops = flight.travelSections.length - 1;
    flight.travelSections.forEach(function (flightNode, index) {
      if (index !== 0) {
        var _flightNode$departure;

        airportIds.push(flightNode === null || flightNode === void 0 ? void 0 : (_flightNode$departure = flightNode.departure) === null || _flightNode$departure === void 0 ? void 0 : _flightNode$departure.id);
      }
    });
  }

  var theoDescription = (_getOptinsInfos$theo = Object(ContactInfoUtils["l" /* getOptinsInfos */])(i18n === null || i18n === void 0 ? void 0 : i18n.bookingProcess).theo) === null || _getOptinsInfos$theo === void 0 ? void 0 : _getOptinsInfos$theo.description;
  var stopsLabel = Object(src_i18n["g" /* t */])('common.transport.connections');

  if (flightProp.stops === 0) {
    stopsLabel = Object(src_i18n["g" /* t */])('filters.layovers.direct');
  } else if (flightProp.stops === 1) {
    stopsLabel = Object(src_i18n["g" /* t */])('common.transport.connection');
  }

  var arrivalDaysAfter = Object(transportUtils["h" /* getDiffAbsoluteDays */])((_flightProp$departure = flightProp.departure) === null || _flightProp$departure === void 0 ? void 0 : _flightProp$departure.date, (_flightProp$arrival = flightProp.arrival) === null || _flightProp$arrival === void 0 ? void 0 : _flightProp$arrival.date);

  var formatDate = function formatDate(date, format) {
    return Object(labelUtils["a" /* capitalizeName */])(Object(apiDate["h" /* momentFromApiDate */])(date).format(format || Object(src_i18n["g" /* t */])('common.verboseDateFormatTechnicalID')));
  };

  var isPlane = Object(transportUtils["n" /* hasOnlyPlanes */])(flight === null || flight === void 0 ? void 0 : flight.travelSections);
  var departureTime = Object(transportUtils["e" /* formatTime */])(flightProp === null || flightProp === void 0 ? void 0 : (_flightProp$departure2 = flightProp.departure) === null || _flightProp$departure2 === void 0 ? void 0 : _flightProp$departure2.time, Object(src_i18n["g" /* t */])('common.timeFormat')) || '';
  var arrivalTime = Object(transportUtils["e" /* formatTime */])(flightProp === null || flightProp === void 0 ? void 0 : (_flightProp$arrival2 = flightProp.arrival) === null || _flightProp$arrival2 === void 0 ? void 0 : _flightProp$arrival2.time, Object(src_i18n["g" /* t */])('common.timeFormat')) || '';
  var companiesNames = getCompaniesNames(flight === null || flight === void 0 ? void 0 : flight.travelSections);
  var hasManyCompanies = companiesNames.length > 1;
  var isCharter = flight === null || flight === void 0 ? void 0 : flight.travelSections.some(function (_ref3) {
    var isClubmedTransport = _ref3.isClubmedTransport;
    return isClubmedTransport;
  });

  var Warnings = function Warnings(_ref4) {
    var _flightProp$arrival3;

    var className = _ref4.className;
    return [noBusinessClassAvailable && InnerTransportDetails_jsx("div", {
      className: classnames_default()(className, 'w-full'),
      key: "0"
    }, InnerTransportDetails_jsx(Notification["a" /* Notification */], {
      className: "my-px10 p-px10 w-full",
      color: colors["a" /* COLORS */].ORANGE,
      dataTestId: "noBusinessClassAvailabilityNotification",
      hasBorder: true,
      icon: icons["a" /* ICONS */].WARNING,
      iconWidth: "1.5rem"
    }, InnerTransportDetails_jsx(Text["a" /* Text */], {
      color: colors["a" /* COLORS */].ORANGE,
      text: Object(src_i18n["g" /* t */])('booking.form.warnings.transport.additionalTransports.noBusinessClassAvailability'),
      theme: "text-sans-8"
    }))), !!arrivalDaysAfter && InnerTransportDetails_jsx("div", {
      className: classnames_default()('w-full', className),
      key: "1"
    }, InnerTransportDetails_jsx(Notification["a" /* Notification */], {
      className: "my-px10 p-px10 w-full",
      color: colors["a" /* COLORS */].ORANGE,
      dataTestId: "ArrivalDaysAfterNotification",
      hasBorder: true,
      icon: icons["a" /* ICONS */].WARNING,
      iconWidth: "1.3rem"
    }, InnerTransportDetails_jsx(Text["a" /* Text */], {
      text: Object(src_i18n["g" /* t */])('booking.form.warnings.transport.additionalTransports.flightJ1', {
        date: formatDate(flightProp === null || flightProp === void 0 ? void 0 : (_flightProp$arrival3 = flightProp.arrival) === null || _flightProp$arrival3 === void 0 ? void 0 : _flightProp$arrival3.date)
      }),
      color: colors["a" /* COLORS */].ORANGE
    }))), (flight === null || flight === void 0 ? void 0 : flight.cancellationPolicyType) === 'WEBTHEO' && InnerTransportDetails_jsx("div", {
      className: classnames_default()(className, 'w-full'),
      key: "2"
    }, InnerTransportDetails_jsx(Notification["a" /* Notification */], {
      className: "my-px10 p-px10 w-full",
      color: colors["a" /* COLORS */].BLUE,
      dataTestId: "TheoCancellationPolicyNotification",
      hasBorder: true,
      iconWidth: "1.5rem"
    }, InnerTransportDetails_jsx(Text["a" /* Text */], {
      color: colors["a" /* COLORS */].BLUE,
      text: theoDescription
    })))];
  };

  var DateAndTimeSection = function DateAndTimeSection(_ref5) {
    var _flightProp$departure3, _flightProp$arrival4, _flightProp$departure4;

    var className = _ref5.className;
    return InnerTransportDetails_jsx(TwoLineSection, {
      className: className,
      plus: arrivalDaysAfter,
      subtitle: arrivalDaysAfter ? InnerTransportDetails_jsx(react["Fragment"], null, formatDate(flightProp === null || flightProp === void 0 ? void 0 : (_flightProp$departure3 = flightProp.departure) === null || _flightProp$departure3 === void 0 ? void 0 : _flightProp$departure3.date, Object(src_i18n["g" /* t */])('booking.priceDetails.packagePrice.dateFormat')), ' - ', InnerTransportDetails_jsx("span", {
        className: "text-blue"
      }, formatDate(flightProp === null || flightProp === void 0 ? void 0 : (_flightProp$arrival4 = flightProp.arrival) === null || _flightProp$arrival4 === void 0 ? void 0 : _flightProp$arrival4.date, Object(src_i18n["g" /* t */])('booking.priceDetails.packagePrice.dateFormat')))) : formatDate(flightProp === null || flightProp === void 0 ? void 0 : (_flightProp$departure4 = flightProp.departure) === null || _flightProp$departure4 === void 0 ? void 0 : _flightProp$departure4.date),
      title: "".concat(departureTime, " \u2014 ").concat(arrivalTime)
    });
  };

  var _themes$theme = themes()[theme],
      thDateTime = _themes$theme.thDateTime,
      thInnerWrapper = _themes$theme.thInnerWrapper,
      thOperatedBy = _themes$theme.thOperatedBy,
      thRecommendedBy = _themes$theme.thRecommendedBy,
      thRecommendedByInner = _themes$theme.thRecommendedByInner,
      thRecommendedByText = _themes$theme.thRecommendedByText,
      thSecondDateTime = _themes$theme.thSecondDateTime,
      thSecondLine = _themes$theme.thSecondLine;
  var recommendedLabel = isPlane ? Object(src_i18n["g" /* t */])('booking.transport.transportRecommendationLabel') : Object(src_i18n["g" /* t */])('booking.transport.otherTransportRecommendationLabel');
  return InnerTransportDetails_jsx("div", {
    className: classnames_default()(isComparator || isSearchPage ? 'w-full' : 'w-full md:w-1/2'),
    "data-testid": "Flight-details"
  }, !isSearchPage && InnerTransportDetails_jsx(InnerTransportDetailsHeader["a" /* InnerTransportDetailsHeader */], {
    arrivalLabel: Object(labelUtils["a" /* capitalizeName */])((flightProp === null || flightProp === void 0 ? void 0 : (_flightProp$arrival5 = flightProp.arrival) === null || _flightProp$arrival5 === void 0 ? void 0 : _flightProp$arrival5.airportLabel) || ''),
    departureLabel: Object(labelUtils["a" /* capitalizeName */])((flightProp === null || flightProp === void 0 ? void 0 : (_flightProp$departure5 = flightProp.departure) === null || _flightProp$departure5 === void 0 ? void 0 : _flightProp$departure5.airportLabel) || ''),
    arrivalId: flightProp === null || flightProp === void 0 ? void 0 : (_flightProp$arrival6 = flightProp.arrival) === null || _flightProp$arrival6 === void 0 ? void 0 : _flightProp$arrival6.id,
    departureId: flightProp === null || flightProp === void 0 ? void 0 : (_flightProp$departure6 = flightProp.departure) === null || _flightProp$departure6 === void 0 ? void 0 : _flightProp$departure6.id,
    isInbound: isInbound,
    transportIcon: transportIcon,
    transportType: flightProp === null || flightProp === void 0 ? void 0 : (_flightProp$transport = flightProp.transport) === null || _flightProp$transport === void 0 ? void 0 : _flightProp$transport.type,
    isComparator: isComparator,
    isSearchPage: isSearchPage
  }), InnerTransportDetails_jsx("div", {
    className: "bg-white border-1 border-gray-light rounded-tiny shadow-diffuse"
  }, InnerTransportDetails_jsx("div", {
    className: thInnerWrapper
  }, InnerTransportDetails_jsx("div", {
    className: "flex flex-row w-full"
  }, InnerTransportDetails_jsx(InnerTransportDetailsLogo, {
    companyOperator: flightProp === null || flightProp === void 0 ? void 0 : (_flightProp$transport2 = flightProp.transport) === null || _flightProp$transport2 === void 0 ? void 0 : _flightProp$transport2.companyOperator,
    manyCompanies: hasManyCompanies,
    isComparator: isComparator
  }), InnerTransportDetails_jsx("div", {
    className: classnames_default()({
      'w-1/2': isComparator
    }, 'flex justify-between w-1/2 md:w-2/3')
  }, InnerTransportDetails_jsx(DateAndTimeSection, {
    className: thDateTime
  }), InnerTransportDetails_jsx(TwoLineSection, {
    title: "".concat(flightProp === null || flightProp === void 0 ? void 0 : (_flightProp$departure7 = flightProp.departure) === null || _flightProp$departure7 === void 0 ? void 0 : _flightProp$departure7.id, " \u2014 ").concat(flightProp === null || flightProp === void 0 ? void 0 : (_flightProp$arrival7 = flightProp.arrival) === null || _flightProp$arrival7 === void 0 ? void 0 : _flightProp$arrival7.id),
    subtitle: (flight === null || flight === void 0 ? void 0 : flight.durationInMin) && Object(transportUtils["p" /* transformMinutesInHours */])(flight === null || flight === void 0 ? void 0 : flight.durationInMin),
    className: classnames_default()(' items-end w-full md:w-1/3', {
      'md:w-full': isComparator
    })
  }))), InnerTransportDetails_jsx("div", {
    className: thSecondLine
  }, hasManyCompanies ? InnerTransportDetails_jsx("div", {
    className: thOperatedBy
  }, InnerTransportDetails_jsx("div", {
    className: "text-xs"
  }, Object(src_i18n["g" /* t */])('booking.transport.planeTicket.operatedBy'), ":"), InnerTransportDetails_jsx("div", {
    className: "text-xs"
  }, companiesNames.join(' - '))) : InnerTransportDetails_jsx("div", {
    className: thOperatedBy
  }, InnerTransportDetails_jsx("div", {
    className: "text-xs"
  }, Object(src_i18n["g" /* t */])('booking.transport.planeTicket.operatedBy'), ":"), InnerTransportDetails_jsx("div", {
    className: "text-xs"
  }, Object(labelUtils["a" /* capitalizeName */])(flightProp === null || flightProp === void 0 ? void 0 : (_flightProp$transport3 = flightProp.transport) === null || _flightProp$transport3 === void 0 ? void 0 : (_flightProp$transport4 = _flightProp$transport3.companyExploiter) === null || _flightProp$transport4 === void 0 ? void 0 : _flightProp$transport4.label))), InnerTransportDetails_jsx(DateAndTimeSection // Same component added twice for mobile display
  , {
    className: thSecondDateTime
  }), InnerTransportDetails_jsx("div", {
    className: classnames_default()('flex flex-col w-full', {
      'md:w-2/3 flex md:flex-row': !isComparator
    })
  }, InnerTransportDetails_jsx("div", {
    className: classnames_default()('flex flex-wrap flex-grow', {
      'md:w-2/5': !isComparator,
      'md:w-full': isComparator && !price
    })
  }, InnerTransportDetails_jsx(TwoLineSection, {
    title: flightProp.stops ? "".concat(flightProp.stops, " ").concat(stopsLabel) : stopsLabel,
    subtitle: airportIds.join(' - '),
    className: "whitespace-no-wrap mr-px5"
  }), InnerTransportDetails_jsx("div", {
    className: "text-gray-medium-dark text-base"
  }, Object(src_i18n["g" /* t */])("common.transport.transportClass.".concat(transportUtils["c" /* TRANSPORT_CLASS_TO_I18N */][flightProp.transport.class])))), InnerTransportDetails_jsx("div", {
    className: classnames_default()('flex flex-col md:flex-row flex-shrink mt-px15 md:mt-0 w-full', {
      'md:flex-col': isComparator
    })
  }, isSearchPage && InnerTransportDetails_jsx(Warnings, {
    className: "flex md:hidden"
  }), InnerTransportDetails_jsx("div", {
    className: "flex w-full"
  }, isSearchPage && !!price && InnerTransportDetails_jsx("div", {
    className: "flex flex-col mr-px15 self-center text-right text-turquoise w-1/2"
  }, InnerTransportDetails_jsx("span", {
    "data-testid": "AdditionalTransportsList-price",
    className: "font-bold w-full"
  }, price.value >= 0 && '+', price.formattedValue), InnerTransportDetails_jsx("span", {
    className: "text-sm"
  }, Object(src_i18n["g" /* t */])('booking.transport.additionalTransports.priceDifference'))), InnerTransportDetails_jsx("div", {
    className: classnames_default()(isSearchPage && !!price ? 'w-1/2' : 'w-full', isComparator ? 'flex-col w-full' : 'flex-col md:flex-row', 'flex items-center justify-end text-right text-sm')
  }, isSearchPage && button ? InnerTransportDetails_jsx("div", {
    className: "h-12 md:pt-0",
    "data-testid": "AdditionalTransportsList-buttonContainer"
  }, InnerTransportDetails_jsx(Button["a" /* Button */], {
    colorBg: button.color,
    colorBorder: button.color,
    dataTestId: "AdditionalTransportsList-ticketFooter-button",
    minWidth: button.minWidth,
    onClick: button.onClick
  }, button.label)) : InnerTransportDetails_jsx("div", {
    className: thRecommendedByInner
  }, InnerTransportDetails_jsx(Icon["a" /* Icon */], {
    className: "mr-px10",
    color: isSelectedRecommended ? 'emerald' : 'blue',
    name: icons["a" /* ICONS */].CHECK,
    style: {
      marginTop: '3px'
    },
    width: "0.75rem"
  }), InnerTransportDetails_jsx("div", {
    className: thRecommendedBy
  }, InnerTransportDetails_jsx("div", {
    className: classnames_default()(thRecommendedByText, isSelectedRecommended ? 'text-emerald' : 'text-blue')
  }, isSelectedRecommended ? recommendedLabel : Object(src_i18n["g" /* t */])('booking.transport.transportSelectionLabel')), isSelectedRecommended && InnerTransportDetails_jsx(Tooltip["a" /* Tooltip */], {
    modalProps: {
      closeLabel: Object(src_i18n["g" /* t */])('common.close'),
      size: 'small',
      children: null
    },
    renderTrigger: function renderTrigger(toggle) {
      return InnerTransportDetails_jsx("button", {
        className: "reset-button mx-px5",
        onClick: toggle,
        type: "button"
      }, InnerTransportDetails_jsx(Icon["a" /* Icon */], {
        color: "blue",
        name: icons["a" /* ICONS */].TOOLTIP,
        width: "1.2rem"
      }));
    }
  }, InnerTransportDetails_jsx("div", {
    className: "p-px20"
  }, InnerTransportDetails_jsx(Text["a" /* Text */], {
    className: "mb-px10 text-sm",
    text: Object(src_i18n["g" /* t */])(isPlane ? 'booking.transport.transportRecommendationInformation' : 'booking.transport.otherTransportRecommendationInformation')
  })))))))))), isSearchPage && InnerTransportDetails_jsx(Warnings, {
    className: "hidden md:flex"
  }), isCharter && InnerTransportDetails_jsx(Notification["a" /* Notification */], {
    className: "my-px10",
    hasBorder: true,
    iconWidth: "1.55rem",
    color: colors["a" /* COLORS */].BLUE
  }, InnerTransportDetails_jsx(Text["a" /* Text */], {
    text: Object(src_i18n["g" /* t */])('booking.transport.charterTransportLabel'),
    color: colors["a" /* COLORS */].BLUE
  }))), InnerTransportDetails_jsx(InnerTransportCollapsePanel, {
    flight: flight,
    tabIndex: tabIndex
  })));
}

/***/ }),

/***/ "UnYQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChildcareIncludedEquipmentCapsule; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _frameworks_capsule_collapse_lists_CapsuleCollapseLists_jsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("d4In");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("SPKZ");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;



function ChildcareIncludedEquipmentCapsule(props) {
  return __jsx(_frameworks_capsule_collapse_lists_CapsuleCollapseLists_jsx__WEBPACK_IMPORTED_MODULE_1__[/* CapsuleCollapseLists */ "a"], {
    header: {
      iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].ALL_INCLUSIVE,
      title: props.i18n.common.allInclusive
    },
    lists: (props.facilities || []).map(function (facility) {
      return {
        title: facility.subtitle ? facility.subtitle : facility.label,
        items: (facility.equipments || []).map(function (equipment) {
          return {
            iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"][equipment.id],
            label: equipment.label
          };
        })
      };
    })
  });
}

/***/ }),

/***/ "Uqkn":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var inspectSource = __webpack_require__("/ExG");

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "V/va":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};


/***/ }),

/***/ "VBBE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextSeeMore; });
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _see_more_SeeMore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("NPTU");
/* harmony import */ var _text_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("qqKu");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;



var TextSeeMore = function TextSeeMore(_ref) {
  var className = _ref.className,
      hasNoScrollOnCollapse = _ref.hasNoScrollOnCollapse,
      isCollapseEnabled = _ref.isCollapseEnabled,
      offsetScrollSelector = _ref.offsetScrollSelector,
      onClick = _ref.onClick,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      seeMoreSize = _ref.seeMoreSize,
      seeMoreTheme = _ref.seeMoreTheme,
      textProps = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, ["className", "hasNoScrollOnCollapse", "isCollapseEnabled", "offsetScrollSelector", "onClick", "seeLessLabel", "seeMoreLabel", "seeMoreSize", "seeMoreTheme"]);

  return __jsx(_see_more_SeeMore__WEBPACK_IMPORTED_MODULE_2__[/* SeeMore */ "a"], {
    className: className,
    hasNoScrollOnCollapse: hasNoScrollOnCollapse,
    isCollapseEnabled: isCollapseEnabled,
    offsetScrollSelector: offsetScrollSelector,
    onClick: onClick,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel,
    seeMoreSize: seeMoreSize,
    theme: seeMoreTheme
  }, __jsx(_text_Text__WEBPACK_IMPORTED_MODULE_3__[/* Text */ "a"], textProps));
};

/***/ }),

/***/ "VHif":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Badge_Badge; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/badge/Badge.themes.js

var variants = {
  diamond: {
    root: ' rotate-45',
    item: ' -rotate-45'
  },
  pill: {
    root: ' rounded-full',
    item: ''
  }
};
var themes = {
  "default": function _default(_ref) {
    var _ref$colorBg = _ref.colorBg,
        colorBg = _ref$colorBg === void 0 ? colors["a" /* COLORS */].BLUE : _ref$colorBg,
        _ref$colorBorder = _ref.colorBorder,
        colorBorder = _ref$colorBorder === void 0 ? colors["a" /* COLORS */].BLUE : _ref$colorBorder,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref$color,
        hasShadow = _ref.hasShadow,
        variant = _ref.variant;
    return {
      thRoot: "bg-".concat(colorBg, " border-").concat(colorBorder, " text-").concat(color, " border-2 flex-none inline-flex items-center justify-center leading-none overflow-hidden relative").concat(hasShadow ? ' shadow' : '').concat(variant ? variants[variant].root : ''),
      thImage: "absolute inset-0 ".concat(variant ? variants[variant].item : ''),
      thIcon: "absolute flex items-center justify-center inset-0".concat(variant ? variants[variant].item : ''),
      thIconSize: '65%',
      thLabel: "absolute flex items-center justify-center leading-tight overflow-hidden inset-0 text-center ".concat(variant ? variants[variant].item : ''),
      thLabelStyle: {
        fontSize: '1em'
      }
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/badge/Badge.jsx
var __jsx = react_default.a.createElement;





var Badge_Badge = function Badge(_ref) {
  var alt = _ref.alt,
      className = _ref.className,
      colorBg = _ref.colorBg,
      colorBorder = _ref.colorBorder,
      color = _ref.color,
      hasShadow = _ref.hasShadow,
      iconName = _ref.iconName,
      iconSize = _ref.iconSize,
      imageSrc = _ref.imageSrc,
      label = _ref.label,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 50 : _ref$size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      variant = _ref.variant;

  if (!iconName && !imageSrc && !label) {
    return null;
  }

  var _themes$theme = themes[theme]({
    colorBg: colorBg,
    colorBorder: colorBorder,
    color: color,
    hasShadow: hasShadow,
    variant: variant
  }),
      thIcon = _themes$theme.thIcon,
      thIconSize = _themes$theme.thIconSize,
      thImage = _themes$theme.thImage,
      thLabel = _themes$theme.thLabel,
      thLabelStyle = _themes$theme.thLabelStyle,
      thRoot = _themes$theme.thRoot;

  var styles = {
    width: size,
    height: size
  };
  var imageSize = {
    w: size,
    h: size
  };
  return __jsx("div", {
    className: classnames_default()(className, thRoot),
    style: styles
  }, !!imageSrc && __jsx("div", {
    className: thImage
  }, __jsx(Image["b" /* default */], {
    altMsg: alt,
    forceImage: true,
    imageUrl: imageSrc,
    mandatoryWidthAndHeight: imageSize
  })), !!iconName && __jsx("div", {
    className: thIcon
  }, __jsx(Icon["a" /* Icon */], {
    alt: alt,
    name: iconName,
    width: iconSize || thIconSize
  })), !!label && __jsx("div", {
    className: thLabel,
    style: thLabelStyle
  }, label));
};

/***/ }),

/***/ "VO7D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setAdultsNumber; });
/* unused harmony export updateAdult */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setAttendees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setAdults; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ORYz");



function setAdultsNumber(adultsNumber) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_ADULTS_NUMBER */ "e"], {
    adultsNumber: adultsNumber
  });
}

function updateAdult(index, valuesToUpdate) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_UPDATE_ADULT */ "f"], {
    index: index,
    valuesToUpdate: valuesToUpdate
  });
}

function setAttendees(payload) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* SET_ATTENDEES */ "d"], payload);
}

function setAdults(payload) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* SET_ADULTS */ "c"], payload);
}



/***/ }),

/***/ "VrMI":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("mwRp");
var IndexedObject = __webpack_require__("F9U4");
var toObject = __webpack_require__("A+R+");
var toLength = __webpack_require__("DOIJ");
var arraySpeciesCreate = __webpack_require__("kjCq");

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_OUT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterOut
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterOut` method
  // https://github.com/tc39/proposal-array-filtering
  filterOut: createMethod(7)
};


/***/ }),

/***/ "VtPb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INITIAL_MONTH; });
/* unused harmony export calendarQuery */
/* unused harmony export bookableDatesQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return queryFetchCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return queryFetchBookableDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDefaultSelectedMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSelectedMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPricesByDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getClosingDatesRanges; });
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_uri_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Sj1w");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("nv//");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ldK3");






var NO_TRANSPORT_VALUE = 'NO';
var DATE_FORMAT = 'YYYYMM';
var INITIAL_MONTH = 0;
function calendarQuery(args) {
  var resortId = args.resortId,
      duration = args.duration,
      departureCity = args.departureCity,
      urgentisationRate = args.urgentisationRate;
  return "\n      calendar(resortId: \"".concat(resortId, "\", duration: \"").concat(duration, "\", departureCity: \"").concat(departureCity, "\") {\n        basePrice {\n          currency\n          bestPrice {\n            value\n            currency\n            formattedValue\n          }\n          initialPrice {\n            value\n            currency\n            formattedValue\n          }\n          unit\n        }\n        blocks {\n          hasPrice\n          id\n          name\n          price {\n            value\n            currency\n            formattedValue\n          }\n          shortName\n          year\n        }\n        firstAvailableMonthIndex\n        months {\n          id\n          days {\n            dayContent {\n              arrivalDate\n              availability\n              canGoToBooking\n              id\n              isCurrentMonth\n              name\n              number\n              offer(urgentisationRate: ").concat(urgentisationRate, ")\n              shortName\n            }\n            priceConfig {\n              bestPrice(forceAdultPerTrip: true) { value formattedValue }\n              currency\n              initialPrice(forceAdultPerTrip: true) { value formattedValue }\n              isBestPriceMonth\n              termsAndConditions {\n                accommodationComfortLabel\n                departureCity {\n                  value\n                  name\n                }\n                departureDate\n                duration\n                numberOfAdults\n              }\n              rawUnit\n              unit\n            }\n          }\n        }\n        weekDays\n      }\n    ");
}
function bookableDatesQuery(_ref) {
  var departureCity = _ref.departureCity,
      departureDate = _ref.departureDate,
      lastDate = _ref.lastDate,
      productId = _ref.productId;
  return "\n    bookableDates(productId: \"".concat(productId, "\", departureDate: \"").concat(departureDate, "\", lastDate: \"").concat(lastDate, "\", departureCity: \"").concat(departureCity, "\") {\n      months {\n        id\n        days {\n          id\n          availabilities {\n            status\n            durations\n          }\n        }\n      }\n    }\n  ");
}
function queryFetchCalendar(appContext, options) {
  var locale = appContext.locale;
  var _options$resortId = options.resortId,
      resortId = _options$resortId === void 0 ? '' : _options$resortId,
      _options$transport = options.transport,
      transport = _options$transport === void 0 ? '' : _options$transport,
      duration = options.duration,
      urgentisationRate = options.urgentisationRate;
  var calendarQueryArgs = {
    locale: locale,
    resortId: resortId,
    departureCity: transport || NO_TRANSPORT_VALUE,
    duration: duration,
    urgentisationRate: urgentisationRate
  };
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery("query {".concat(calendarQuery(calendarQueryArgs), "}"), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* STATE_PRODUCT_CALENDAR */ "Cd"]
  }).then(function (_ref2) {
    var calendar = _ref2.calendar;
    return {
      calendar: calendar
    };
  });
}
function queryFetchBookableDates(appContext, options) {
  var _options$productId = options.productId,
      productId = _options$productId === void 0 ? '' : _options$productId,
      _options$departureDat = options.departureDate,
      departureDate = _options$departureDat === void 0 ? '' : _options$departureDat,
      _options$departureCit = options.departureCity,
      departureCity = _options$departureCit === void 0 ? '' : _options$departureCit,
      _options$lastDate = options.lastDate,
      lastDate = _options$lastDate === void 0 ? '' : _options$lastDate;
  var bookableDatesQueryArs = {
    productId: productId,
    departureDate: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__[/* timestampToApiDate */ "l"])(departureDate || '') || '',
    lastDate: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__[/* timestampToApiDate */ "l"])(lastDate || '') || '',
    departureCity: departureCity
  };
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery("query {".concat(bookableDatesQuery(bookableDatesQueryArs), "}"), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* STATE_PRODUCT_BOOKABLE_DATES */ "Bd"]
  }).then(function (_ref3) {
    var bookableDates = _ref3.bookableDates;
    return {
      bookableDates: bookableDates
    };
  });
}
function getDefaultSelectedMonth() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var momentDate = value ? moment__WEBPACK_IMPORTED_MODULE_0___default()(value, format) : moment__WEBPACK_IMPORTED_MODULE_0___default()();
  return parseInt(momentDate.format(DATE_FORMAT), 10);
}
function getSelectedMonth(calendar, previousSelectedMonth) {
  var _calendar$months; // The query date param prevails


  var dateQueryParam = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_4__[/* getSpecificQueryParam */ "j"])(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_3__[/* QUERY_DEPARTURE_DATE */ "f"]);

  if (dateQueryParam) {
    return getDefaultSelectedMonth(dateQueryParam);
  }

  var firstCalendarMonth = ((_calendar$months = calendar.months) === null || _calendar$months === void 0 ? void 0 : _calendar$months[0].id) || getDefaultSelectedMonth();
  var firstAvailableMonthIndex = calendar.firstAvailableMonthIndex || INITIAL_MONTH;
  var firstAvailableMonth = parseInt(moment__WEBPACK_IMPORTED_MODULE_0___default()(firstCalendarMonth, DATE_FORMAT).add(firstAvailableMonthIndex, 'months').format(DATE_FORMAT), 10); // The previously selected month remains selected unless the first available dates are later

  if (previousSelectedMonth > firstAvailableMonth) {
    return previousSelectedMonth;
  }

  return firstAvailableMonth;
}
function getPricesByDays(calendar) {
  var prices = {};

  if (calendar.months) {
    calendar.months.forEach(function (_ref4) {
      var days = _ref4.days;

      if (days) {
        days.forEach(function (_ref5) {
          var _priceConfig$termsAnd, _priceConfig$termsAnd2;

          var dayContent = _ref5.dayContent,
              priceConfig = _ref5.priceConfig;

          var _ref6 = dayContent || {},
              availability = _ref6.availability,
              id = _ref6.id,
              offer = _ref6.offer;

          var isBestPrice = priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.isBestPriceMonth;
          var unit = priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.unit;
          var departureCityValue = (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$termsAnd = priceConfig.termsAndConditions) === null || _priceConfig$termsAnd === void 0 ? void 0 : (_priceConfig$termsAnd2 = _priceConfig$termsAnd.departureCity) === null || _priceConfig$termsAnd2 === void 0 ? void 0 : _priceConfig$termsAnd2.value) || NO_TRANSPORT_VALUE;

          if (id) {
            var _priceConfig$termsAnd3, _priceConfig$termsAnd4, _priceConfig$initialP, _priceConfig$bestPric, _priceConfig$bestPric2;

            var closed = availability === 'closed';
            var exclusivity = availability === 'exclusivity';
            var noDeparture = availability === 'noDeparture';
            var noFlight = availability === 'noFlight';
            var full = availability === 'full';
            var noAvailability = availability === '';
            var available = availability === 'available' || availability === 'unknown';
            var lastAvailability = offer === 'urgentisation';
            prices[id] = {
              availability: availability,
              available: available,
              closed: closed,
              currency: priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.currency,
              departureCity: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$termsAnd3 = priceConfig.termsAndConditions) === null || _priceConfig$termsAnd3 === void 0 ? void 0 : (_priceConfig$termsAnd4 = _priceConfig$termsAnd3.departureCity) === null || _priceConfig$termsAnd4 === void 0 ? void 0 : _priceConfig$termsAnd4.name) || '',
              exclusivity: exclusivity,
              full: full,
              hasTransport: departureCityValue !== NO_TRANSPORT_VALUE,
              isBestPrice: isBestPrice,
              lastAvailability: lastAvailability,
              noAvailability: noAvailability,
              noDeparture: noDeparture,
              noFlight: noFlight,
              oldPrice: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$initialP = priceConfig.initialPrice) === null || _priceConfig$initialP === void 0 ? void 0 : _priceConfig$initialP.formattedValue) || null,
              price: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$bestPric = priceConfig.bestPrice) === null || _priceConfig$bestPric === void 0 ? void 0 : _priceConfig$bestPric.formattedValue) || null,
              priceValue: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$bestPric2 = priceConfig.bestPrice) === null || _priceConfig$bestPric2 === void 0 ? void 0 : _priceConfig$bestPric2.value) || null,
              unit: unit
            };
          }
        });
      }
    });
  }

  return prices;
}
var getClosingDatesRanges = function getClosingDatesRanges(openingDatesRanges) {
  return openingDatesRanges.sort(function (date1, date2) {
    return Number(date1.opening) - Number(date2.opening);
  }).map(function (openingDate, index, openingDates) {
    var _openingDates;

    return {
      after: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__[/* momentFromApiDate */ "h"])(openingDate.closing).toDate(),
      before: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__[/* momentFromApiDate */ "h"])(((_openingDates = openingDates[index + 1]) === null || _openingDates === void 0 ? void 0 : _openingDates.opening) || openingDates[0].opening).toDate()
    };
  });
};

/***/ }),

/***/ "W+NJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputButton_InputButton; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-button/InputButton.themes.js


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var InputButton_themes_defaultTheme = function defaultTheme(_ref) {
  var _classnames;

  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].SUCCESS : _ref$color,
      isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      isFilled = _ref.isFilled,
      isLoading = _ref.isLoading;
  return {
    thRoot: classnames_default()('border-1 flex items-stretch rounded-tiny text-base transition-colors', (_classnames = {
      'bg-white border-gray-light text-gray-darker focus-within:border-blue hover:border-blue focus-within:text-blue hover:text-blue': !isActive && !isFilled && !isDisabled,
      'bg-white border-blue text-blue': isActive && !isFilled && !isDisabled
    }, Object(defineProperty["a" /* default */])(_classnames, "bg-white border-".concat(color, " text-gray-darker"), isFilled && !isDisabled), Object(defineProperty["a" /* default */])(_classnames, 'bg-gray-lighter border-gray-light text-gray-medium', isDisabled), Object(defineProperty["a" /* default */])(_classnames, 'pointer-events-none', isLoading), _classnames)),
    thHeightStyle: {
      minHeight: '3.125rem',
      // IE11 needs a height in addition to minHeight to center vertically.
      height: '1px'
    },
    thButton: 'reset-button flex items-center flex-1 justify-center overflow-hidden text-current text-initial',
    thIcon: classnames_default()('flex-shrink-0 lg:mx-px10', Object(defineProperty["a" /* default */])({
      'text-blue': isActive && !isFilled && !isDisabled
    }, "text-".concat(color), isFilled && !isDisabled)),
    thIconSize: '1.125rem',
    thLoader: 'px-px10 flex-shrink-0',
    thSpinnerColor: isFilled ? 'current' : 'blue',
    thIconSelect: classnames_default()('hidden lg:inline-block md:flex-shrink-0 mx-px10 transition-transform', {
      'rotate-180': isActive && !isDisabled
    }),
    thClear: 'reset-button px-px10 flex-shrink-0 text-current',
    thClearSize: '0.625rem',
    thSwitchButton: 'flex items-center reset-button',
    thSwitch: classnames_default()('bg-current border-1 border-current hidden lg:flex leading-none mx-px10 overflow-hidden rounded-tiny transition-all', {
      'text-gray-light': !isFilled,
      'text-success': isFilled
    }),
    thSwitchStyle: {
      width: 40,
      height: 20
    },
    thSwitchToggler: classnames_default()('bg-white flex font-bold items-center justify-center leading-none rounded-tiny text-center text-xs transition-all w-1/2', {
      'text-success rtl:translate-x-100': isFilled,
      'text-gray-light': !isFilled
    })
  };
};

var InputButton_themes_themes = function themes(props) {
  var _classnames4;

  var d = InputButton_themes_defaultTheme(props);
  return {
    "default": d,
    calendar: _objectSpread(_objectSpread({}, d), {}, {
      thIcon: classnames_default()('flex-shrink-0 mx-px10', Object(defineProperty["a" /* default */])({
        'text-blue': props.isActive && !props.isFilled && !props.isDisabled
      }, "text-".concat(props.color), props.isFilled && !props.isDisabled)),
      thIconSelect: classnames_default()('inline-block mx-px10 transition-transform', {
        'rotate-180': props.isActive && !props.isDisabled
      }),
      thSwitch: classnames_default()('bg-current border-1 border-current flex leading-none mx-px10 overflow-hidden rounded-tiny transition-all', {
        'text-gray-light': !props.isFilled,
        'text-success': props.isFilled
      })
    }),
    filter: _objectSpread(_objectSpread({}, d), {}, {
      thRoot: classnames_default()('border-1 flex items-stretch rounded-tiny text-base transition-colors', (_classnames4 = {
        'bg-white text-gray-darker': !props.isDisabled
      }, Object(defineProperty["a" /* default */])(_classnames4, "border-gray-light focus-within:border-".concat(props.color, " hover:border-").concat(props.color), !props.isActive && !props.isFilled && !props.isDisabled), Object(defineProperty["a" /* default */])(_classnames4, "border-".concat(props.color), props.isActive && !props.isFilled && !props.isDisabled), Object(defineProperty["a" /* default */])(_classnames4, 'border-success', props.isFilled && !props.isDisabled), Object(defineProperty["a" /* default */])(_classnames4, 'bg-gray-lighter border-gray-light pointer-events-none text-gray-medium', props.isDisabled), Object(defineProperty["a" /* default */])(_classnames4, 'pointer-events-none', props.isLoading), _classnames4)),
      thButton: 'reset-button flex items-center flex-1 justify-between overflow-hidden text-current text-initial',
      thHeightStyle: _objectSpread(_objectSpread({}, d.thHeightStyle), {}, {
        minHeight: '2.5rem'
      }),
      thIconSelect: classnames_default()('inline-block md:flex-shrink-0 mx-px10 transition-transform', {
        'rotate-180': props.isActive && !props.isDisabled
      })
    }),
    remote: _objectSpread(_objectSpread({}, d), {}, {
      thHeightStyle: _objectSpread(_objectSpread({}, d.thHeightStyle), {}, {
        minHeight: '3.625rem'
      })
    })
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-button/InputButton.jsx
var __jsx = react_default.a.createElement;






var InputButton_InputButton = function InputButton(_ref) {
  var children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      dataTestId = _ref.dataTestId,
      _ref$hasSwitch = _ref.hasSwitch,
      hasSwitch = _ref$hasSwitch === void 0 ? false : _ref$hasSwitch,
      iconName = _ref.iconName,
      isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      isFilled = _ref.isFilled,
      isLoading = _ref.isLoading,
      onClear = _ref.onClear,
      onClick = _ref.onClick,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      title = _ref.title;
  var _themes$theme = InputButton_themes_themes({
    color: color,
    isActive: isActive,
    isDisabled: isDisabled,
    isFilled: isFilled,
    isLoading: isLoading
  })[theme],
      thButton = _themes$theme.thButton,
      thClear = _themes$theme.thClear,
      thClearSize = _themes$theme.thClearSize,
      thHeightStyle = _themes$theme.thHeightStyle,
      thIcon = _themes$theme.thIcon,
      thIconSelect = _themes$theme.thIconSelect,
      thIconSize = _themes$theme.thIconSize,
      thLoader = _themes$theme.thLoader,
      thRoot = _themes$theme.thRoot,
      thSpinnerColor = _themes$theme.thSpinnerColor,
      thSwitch = _themes$theme.thSwitch,
      thSwitchButton = _themes$theme.thSwitchButton,
      thSwitchStyle = _themes$theme.thSwitchStyle,
      thSwitchToggler = _themes$theme.thSwitchToggler;

  if (!iconName && !children) {
    return null;
  }

  var hasClear = onClear && !isLoading && !isDisabled && isFilled;
  return __jsx("div", {
    className: classnames_default()(className, thRoot)
  }, __jsx("button", {
    className: thButton,
    "data-testid": dataTestId,
    disabled: isDisabled,
    onClick: onClick,
    style: thHeightStyle,
    title: title,
    type: "button"
  }, !!iconName && __jsx(Icon["a" /* Icon */], {
    className: thIcon,
    color: "none",
    name: iconName,
    width: thIconSize
  }), children, !hasClear && !hasSwitch && !isLoading && __jsx(Icon["a" /* Icon */], {
    className: thIconSelect,
    name: icons["a" /* ICONS */].SELECT,
    width: ".625rem"
  }), isLoading && __jsx(Spinner["a" /* Spinner */], {
    className: thLoader,
    color: thSpinnerColor,
    size: "small"
  })), !hasSwitch && hasClear && __jsx("button", {
    "data-testid": "InputButtonClear",
    className: thClear,
    disabled: isDisabled,
    onClick: onClear,
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thClearSize
  })), hasSwitch && __jsx("button", {
    className: thSwitchButton,
    "data-testid": "InputButtonClear",
    onClick: hasClear ? onClear : onClick,
    type: "button"
  }, __jsx("span", {
    className: thSwitch,
    style: thSwitchStyle
  }, __jsx("span", {
    "aria-hidden": true,
    className: thSwitchToggler
  }, isFilled ? '|' : 'O'))));
};

/***/ }),

/***/ "WSQK":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "WzQP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GridRow; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("I6kL");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;




function getResponsiveClasses(grid) {
  return Object.keys(_utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"]).map(function (key) {
    if (grid.hasOwnProperty(key)) {
      return " ".concat(_utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"][key], "-GridRow--").concat(grid[_utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"][key]]); // fit, full, 1of2, 1of3
    }
  }).join('');
}

function GridRow(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$grid = _ref.grid,
      grid = _ref$grid === void 0 ? {} : _ref$grid,
      _ref$hasLeftGutters = _ref.hasLeftGutters,
      hasLeftGutters = _ref$hasLeftGutters === void 0 ? true : _ref$hasLeftGutters,
      _ref$hasTopGutters = _ref.hasTopGutters,
      hasTopGutters = _ref$hasTopGutters === void 0 ? true : _ref$hasTopGutters;
  if (!react__WEBPACK_IMPORTED_MODULE_0__["Children"].count(children)) return null;
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, 'flex flex-wrap', {
      'GridRow--leftGutters': hasLeftGutters,
      'GridRow--topGutters': hasTopGutters
    }, getResponsiveClasses(grid))
  }, children);
}

/***/ }),

/***/ "X0en":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AllInclusiveList; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UCZK");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_capsule_Capsule__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("jldR");
/* harmony import */ var _frameworks_tooltip_Tooltip__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("i3Ve");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1__["createElement"];

/* eslint-disable no-duplicate-imports */







var AllInclusiveList = function AllInclusiveList(_ref) {
  var i18n = _ref.i18n,
      items = _ref.items,
      _ref$trackOpenTooltip = _ref.trackOpenTooltip,
      trackOpenTooltip = _ref$trackOpenTooltip === void 0 ? function () {} : _ref$trackOpenTooltip;
  return __jsx(_frameworks_capsule_Capsule__WEBPACK_IMPORTED_MODULE_6__[/* Capsule */ "a"], {
    label: i18n.common.allInclusive,
    header: "large"
  }, items.map(function (_ref2) {
    var icon = _ref2.icon,
        title = _ref2.title,
        description = _ref2.description,
        tooltip = _ref2.tooltip;
    return __jsx("div", {
      className: "AllInclusiveList-item flex items-center text-md py-px15 px-px20",
      key: title || ''
    }, __jsx("div", {
      className: "AllInclusiveList-itemContent flex w-full"
    }, __jsx("div", {
      className: "AllInclusiveList-icon flex flex-col justify-center"
    }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__[/* Icon */ "a"], {
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].BLUE,
      name: icon,
      width: "2.125rem"
    })), __jsx("p", {
      className: "AllInclusiveList-label reset-paragraph flex flex-col justify-center"
    }, __jsx("span", null, !Object(lodash__WEBPACK_IMPORTED_MODULE_3__["isNil"])(title) && __jsx("span", {
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('AllInclusiveList-title', {
        'font-bold': description
      })
    }, title), description && __jsx("span", {
      className: "block text-base AllInclusiveList-description"
    }, description))), !Object(lodash__WEBPACK_IMPORTED_MODULE_3__["isNil"])(tooltip) && __jsx("div", {
      className: "AllInclusiveList-includedIcon flex flex-col justify-center"
    }, __jsx(_frameworks_tooltip_Tooltip__WEBPACK_IMPORTED_MODULE_7__[/* Tooltip */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
      renderTrigger: function renderTrigger(toggle) {
        return __jsx("button", {
          type: "button",
          onClick: function onClick() {
            trackOpenTooltip();
            toggle();
          },
          className: "reset-button AllInclusiveList-popinIcon"
        }, "?");
      }
    }, tooltip)))), __jsx("div", {
      className: "font-bold text-blue text-center",
      "data-testid": "AllInclusiveList-included"
    }, i18n.common.included));
  }));
};

/***/ }),

/***/ "X7tq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return servicesConfiguration; });
var servicesConfiguration = {
  activity_search_criterion_skiing_snowboarding: {
    image: 'https://ns.clubmed.com/it/2019/be/equipments/skiing.png',
    order: 1
  },
  activity_search_criterion_snowboard: {
    image: 'https://ns.clubmed.com/it/2019/be/equipments/snowboarding.png',
    order: 2
  },
  activity_search_criterion_snow_shoe_walks: {
    image: 'https://ns.clubmed.com/it/2019/be/equipments/snow-shoe-walks.png',
    order: 3
  }
};

/***/ }),

/***/ "X95k":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("M4Qz");
var enumBugKeys = __webpack_require__("WSQK");

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "XmKO":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("1YFU");
var setPrototypeOf = __webpack_require__("iBXc");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "XywU":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "Y6/E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ATTENDEE_CATEGORIES; });
/* unused harmony export getAttendeeCategory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAttendeesByDistributionCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addDistributionDataToAttendees; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var ATTENDEE_CATEGORIES = {
  BABY: 'BABY',
  CHILD: 'CHILD',
  ADULT: 'ADULT'
};
var getAttendeeCategory = function getAttendeeCategory(attendee, arrivalDate) {
  if (attendee.birthdate && moment__WEBPACK_IMPORTED_MODULE_1___default()(arrivalDate).diff(moment__WEBPACK_IMPORTED_MODULE_1___default()(attendee.birthdate), 'months') < 24) {
    return ATTENDEE_CATEGORIES.BABY;
  }

  if (attendee.birthdate && moment__WEBPACK_IMPORTED_MODULE_1___default()(arrivalDate).diff(moment__WEBPACK_IMPORTED_MODULE_1___default()(attendee.birthdate), 'months') >= 24 && moment__WEBPACK_IMPORTED_MODULE_1___default()(arrivalDate).diff(moment__WEBPACK_IMPORTED_MODULE_1___default()(attendee.birthdate), 'years') < 18) {
    return ATTENDEE_CATEGORIES.CHILD;
  }

  return ATTENDEE_CATEGORIES.ADULT;
};
var getAttendeesByDistributionCategory = function getAttendeesByDistributionCategory(attendees) {
  var sortAttendeesByIndex = function sortAttendeesByIndex(attendee1, attendee2) {
    return attendee1.index - attendee2.index;
  };

  return {
    adults: attendees.filter(function (_ref) {
      var type = _ref.type;
      return type.toUpperCase() === ATTENDEE_CATEGORIES.ADULT;
    }).sort(sortAttendeesByIndex),
    children: attendees.filter(function (_ref2) {
      var type = _ref2.type;
      return type.toUpperCase() === ATTENDEE_CATEGORIES.CHILD;
    }).sort(sortAttendeesByIndex),
    babies: attendees.filter(function (_ref3) {
      var type = _ref3.type;
      return type.toUpperCase() === ATTENDEE_CATEGORIES.BABY;
    }).sort(sortAttendeesByIndex)
  };
};
var addDistributionDataToAttendees = function addDistributionDataToAttendees(attendees, arrivalDate) {
  var distributionIndex = {
    ADULT: 0,
    CHILD: 0,
    BABY: 0
  };
  return attendees.map(function (attendee) {
    var type = getAttendeeCategory(attendee, arrivalDate);
    return _objectSpread(_objectSpread({}, attendee), {}, {
      type: type,
      index: distributionIndex[type]++
    });
  });
};

/***/ }),

/***/ "Y8c0":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var userAgent = __webpack_require__("xe/R");

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ "YKA5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TransportSummary; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("UCZK");
/* harmony import */ var _views_booking_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("taV1");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("qBqs");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;







var TransportSummary = function TransportSummary(_ref) {
  var departure = _ref.departure,
      _ref$extendedDataset = _ref.extendedDataset,
      extendedDataset = _ref$extendedDataset === void 0 ? false : _ref$extendedDataset,
      transportIcon = _ref.transportIcon;
  var noTransportIcon = _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].NO_TRANSPORT;
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('PackagePriceSummary-section', {
      'PackagePriceSummary-section--extended': extendedDataset
    }),
    "data-testid": _views_booking_constants__WEBPACK_IMPORTED_MODULE_3__[/* CRITERIA_SELECTORS */ "o"].TRANSPORT
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "a"], {
    className: "PackagePriceSummary-icon",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].BLUE,
    hasRtl: true,
    name: departure ? transportIcon : noTransportIcon,
    width: "1.875rem"
  }), departure ? __jsx("span", null, Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "g"])('common.transport.from'), ' ', __jsx("span", {
    className: "PackagePriceSummary-departure"
  }, departure)) : Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "g"])('booking.priceDetails.packagePrice.noTransport'));
};

/***/ }),

/***/ "YQkA":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "YSwF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArrivalDepartureDate; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("kiXb");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


var ArrivalDepartureDate = function ArrivalDepartureDate(_ref) {
  var arrivalDate = _ref.arrivalDate,
      departureDate = _ref.departureDate;
  return __jsx("div", {
    className: "block sm:hidden p-px10 mx-px10 text-base"
  }, __jsx("div", {
    className: "flex justify-between mb-px5"
  }, __jsx("span", null, Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "g"])('faceting.when.arrivalDateTitle')), __jsx("span", {
    className: "font-bold text-blue"
  }, arrivalDate ? arrivalDate : ' -')), __jsx("div", {
    className: "flex justify-between mb-px5"
  }, __jsx("span", null, Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "g"])('faceting.when.departureDateTitle')), __jsx("span", {
    className: "font-bold text-blue"
  }, departureDate ? departureDate : ' -')));
};

/***/ }),

/***/ "YVWi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatAdditionalServicesChildcareToOldChildcareFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return childrenCountByChildcare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCtaType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return includedAndNotIncludedChildcares; });
/* unused harmony export getFormattedPricePerDay */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return hasChildrenAgedXOrLess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCurrentChild; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCurrentKid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getFormatDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getOverloadChildcareDataForChalet; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fGyu");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("wz9x");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ldK3");



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var API_DATE_FORMAT = 'YYYYMMDD';

function getCtaType(childcare, childcareStockInfo) {
  if (childcare.isRented) {
    return 'remove';
  }

  if (childcare.isPaid) {
    return 'none';
  }

  if (childcareStockInfo) {
    var babiesChildcareStock = childcareStockInfo.babiesChildcareStock,
        petitChildcareStock = childcareStockInfo.petitChildcareStock,
        childrenLoading = childcareStockInfo.childrenLoading;

    if (childrenLoading && !childrenLoading.includes(childcare.childId) && (childcare.ageInMonths.min === 4 && babiesChildcareStock === 0 || // no more real time availability for babies
    childcare.ageInMonths.min === 24 && petitChildcareStock === 0) // no more real time availability for youngsters
    ) {
        return 'full';
      }
  }

  return 'add';
}

function getFormattedPricePerDay(price, tripDuration, locale) {
  var pricePerDay = price / tripDuration;
  return Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_4__[/* formatAmountForLocale */ "b"])(pricePerDay, locale);
}

function isChildAgedXOrLess(birthdate, targetAge) {
  return moment__WEBPACK_IMPORTED_MODULE_2___default()(birthdate, API_DATE_FORMAT).isAfter(moment__WEBPACK_IMPORTED_MODULE_2___default()().startOf('day').subtract(targetAge, 'years'));
}

function hasChildrenAgedXOrLess(attendees, targetAge) {
  return attendees.filter(function (attendee) {
    return isChildAgedXOrLess(attendee.birthdate, targetAge);
  }).length > 0;
}

function getCurrentChild(items, itemId) {
  return items.find(function (_ref) {
    var id = _ref.id;
    return id === itemId;
  });
} // $FlowFixMe Always found


function getCurrentKid(items, currentChild) {
  return items.find(function (item) {
    if (item.id) {
      return Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__[/* timestampToApiDate */ "l"])(item.birthdate) === currentChild.birthdate && item.id === currentChild.id;
    }

    if (item.neolid && currentChild.customerId) {
      return Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__[/* timestampToApiDate */ "l"])(item.birthdate) === currentChild.birthdate && item.neolid === currentChild.customerId;
    }

    return Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__[/* timestampToApiDate */ "l"])(item.birthdate) === currentChild.birthdate;
  });
}

function getFormatDate(item, message) {
  return Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__[/* formatApiDate */ "e"])(Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(item, 'birthdate', ''), message);
}

var childrenCountByChildcare = function childrenCountByChildcare(childcares) {
  var babyInfos = {
    number: 0,
    remainingStock: 0
  };
  var youngsterInfos = {
    number: 0,
    remainingStock: 0
  };
  childcares.map(function (childcare) {
    if (childcare.productInfo.ageInMonths.min === 24) {
      youngsterInfos.number = childcare.pricingInfo.schedules[0].attendees.length;
      youngsterInfos.remainingStock = childcare.pricingInfo.schedules[0].remainingStock;
    }

    if (childcare.productInfo.ageInMonths.min === 4) {
      babyInfos.number = childcare.pricingInfo.schedules[0].attendees.length;
      babyInfos.remainingStock = childcare.pricingInfo.schedules[0].remainingStock;
    }
  });
  return {
    babyInfos: babyInfos,
    youngsterInfos: youngsterInfos
  };
};

var formatAdditionalServicesChildcareToOldChildcareFormat = function formatAdditionalServicesChildcareToOldChildcareFormat(childcares) {
  return childcares.reduce(function (acc, childcare) {
    return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(acc), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(childcare.pricingInfo.schedules[0].attendees.map(function (_ref2) {
      var _childcare$productInf;

      var id = _ref2.id,
          isRented = _ref2.isRented,
          isPaid = _ref2.isPaid;
      return _objectSpread(_objectSpread({}, childcare.productInfo), {}, {
        productId: (_childcare$productInf = childcare.productInfo) === null || _childcare$productInf === void 0 ? void 0 : _childcare$productInf.id,
        isRented: isRented,
        isPaid: isPaid,
        startDate: childcare.pricingInfo.schedules[0].startDate,
        endDate: childcare.pricingInfo.schedules[0].endDate,
        childId: id,
        id: childcare.pricingInfo.id,
        isIncluded: childcare.pricingInfo.isIncluded,
        isManuallyIncluded: childcare.pricingInfo.isManuallyIncluded,
        price: childcare.pricingInfo.price,
        remainingStock: childcare.pricingInfo.schedules[0].remainingStock
      });
    })));
  }, []) // sort childcare by attendee ID to always keep the same order
  .sort(function (childcare1, childcare2) {
    return childcare1.id.localeCompare(childcare2.id);
  });
};

var includedAndNotIncludedChildcares = function includedAndNotIncludedChildcares(childcareList) {
  return childcareList.reduce(function (acc, childcare) {
    if (childcare.isIncluded) {
      acc.includedChildcares.push(childcare);
    } else {
      acc.notIncludedChildcares.push(childcare);
    }

    return acc;
  }, {
    includedChildcares: [],
    notIncludedChildcares: []
  });
};

var getOverloadChildcareDataForChalet = function getOverloadChildcareDataForChalet(_ref3) {
  var proposals = _ref3.proposals,
      currentChildcareId = _ref3.currentChildcareId,
      currentChildId = _ref3.currentChildId;

  if (proposals.every(function (_ref4) {
    var additionalServices = _ref4.additionalServices;
    return additionalServices.childcares.some(function (_ref5) {
      var pricingInfo = _ref5.pricingInfo;
      return pricingInfo.id === currentChildcareId && pricingInfo.schedules[0].attendees.some(function (_ref6) {
        var id = _ref6.id;
        return id === currentChildId;
      });
    });
  })) {
    return;
  }

  var proposalsWithDifferentChildcare = proposals.filter(function (_ref7) {
    var additionalServices = _ref7.additionalServices;
    return !additionalServices.childcares.some(function (_ref8) {
      var pricingInfo = _ref8.pricingInfo;
      return pricingInfo.id === currentChildcareId && pricingInfo.schedules[0].attendees.some(function (_ref9) {
        var id = _ref9.id;
        return id === currentChildId;
      });
    });
  });
  return {
    proposalIds: proposalsWithDifferentChildcare.map(function (_ref10) {
      var id = _ref10.id;
      return id;
    }),
    serviceIds: [proposalsWithDifferentChildcare[0].additionalServices.childcares.find(function (_ref11) {
      var pricingInfo = _ref11.pricingInfo;
      return pricingInfo.schedules[0].attendees.some(function (_ref12) {
        var id = _ref12.id;
        return id === currentChildId;
      });
    } // $FlowFixMe always found
    ).pricingInfo.id]
  };
};



/***/ }),

/***/ "YjXp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputSwitch_InputSwitch; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/shortid/index.js
var shortid = __webpack_require__("MIfU");
var shortid_default = /*#__PURE__*/__webpack_require__.n(shortid);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/form/form.util.js
var form_util = __webpack_require__("1P7A");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.themes.js


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var DEFAULT_SIZES = {
  small: 15,
  medium: 23,
  large: 23
};
var themes = {
  "default": function _default(props) {
    var color = props.color,
        isChecked = props.isChecked,
        isDisabled = props.isDisabled,
        isReadOnly = props.isReadOnly,
        size = props.size,
        validationState = props.validationState;
    return {
      thRoot: 'flex items-center',
      thLabel: classnames_default()('flex items-center text-base px-px10', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props)), {
        'font-bold text-blue text-lg': size === 'large',
        'text-success': validationState === 'IS_VALID' && !isReadOnly && !isDisabled,
        'text-danger': validationState === 'IS_INVALID' && !isReadOnly && !isDisabled
      }),
      thChecked: classnames_default()('leading-none bg-white border-1 border-solid border-gray-medium flex-shrink-0 p-px rounded-tiny', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props)), {
        'text-blue': isChecked,
        'bg-gray-light opacity-25': isDisabled
      }),
      thCheckedStyle: {
        width: DEFAULT_SIZES[size],
        height: DEFAULT_SIZES[size]
      },
      thLoading: 'rtl:ml-px10 flex items-center leading-none',
      thSwitch: classnames_default()('reset-button border-2 flex items-center transition-all', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props)), Object(defineProperty["a" /* default */])({
        'bg-gray-light border-gray-light': isDisabled,
        'bg-gray-darker border-gray-darker': !isChecked && !isDisabled
      }, "bg-".concat(color, " border-").concat(color), isChecked && !isDisabled)),
      thSwitchStyle: {
        width: 58,
        padding: '0 1px',
        height: 30,
        borderRadius: 30
      },
      thSwitchToggler: classnames_default()('bg-white block leading-none flex items-center justify-center rounded-half transition-all', Object(defineProperty["a" /* default */])({
        'rtl:translate-x-100': isChecked
      }, "text-".concat(color), isChecked && !isDisabled)),
      thSwitchTogglerStyle: {
        width: 28,
        height: 28
      }
    };
  },
  bubble: function bubble(props) {
    var isChecked = props.isChecked,
        isDisabled = props.isDisabled,
        isReadOnly = props.isReadOnly,
        validationState = props.validationState;
    return {
      thRoot: 'relative',
      thLabel: classnames_default()('flex items-center justify-center shadow border-1 rounded py-px10 px-px20 text-base text-center transition-colors', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props)), {
        'bg-white': !isDisabled,
        'bg-gray-light border-gray-light opacity-50': isDisabled,
        'border-gray-light': !isChecked && validationState === 'NOT_VALIDATED',
        'border-current text-blue': isChecked && validationState === 'NOT_VALIDATED' && !isReadOnly && !isDisabled,
        'border-current text-success': validationState === 'IS_VALID' && !isReadOnly && !isDisabled,
        'border-current text-danger': validationState === 'IS_INVALID' && !isReadOnly && !isDisabled
      }),
      thChecked: 'hidden',
      thLoading: 'absolute flex h-full items-center leading-none left-1/2 -translate-x-50'
    };
  },
  bubble2: function bubble2(props) {
    var isChecked = props.isChecked,
        isDisabled = props.isDisabled,
        isReadOnly = props.isReadOnly,
        validationState = props.validationState;
    return {
      thRoot: 'relative',
      thLabel: classnames_default()('flex items-center justify-center border-1 rounded py-px5 px-px5 text-base text-center transition-colors', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props)), {
        'bg-white': !isChecked,
        'border-gray-light opacity-50': isDisabled && !isChecked,
        'border-gray-light': !isChecked && validationState === 'NOT_VALIDATED',
        'border-blue text-white bg-blue': isChecked && validationState === 'NOT_VALIDATED' && !isReadOnly && !isDisabled,
        'border-current text-success': validationState === 'IS_VALID' && !isReadOnly && !isDisabled,
        'border-current text-danger': validationState === 'IS_INVALID' && !isReadOnly && !isDisabled,
        'border-blue text-white bg-blue opacity-50': isDisabled && isChecked
      }),
      thChecked: 'hidden',
      thLoading: 'absolute flex h-full items-center leading-none left-1/2 -translate-x-50'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.jsx







var __jsx = react_default.a.createElement;

function InputSwitch_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function InputSwitch_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { InputSwitch_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { InputSwitch_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }











var InputSwitch_InputSwitch = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(InputSwitch, _Component);

  var _super = _createSuper(InputSwitch);

  function InputSwitch(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputSwitch);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function () {
      var _this$props = _this.props,
          isDisabled = _this$props.isDisabled,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          _this$props$name = _this$props.name,
          name = _this$props$name === void 0 ? '' : _this$props$name,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? lodash["noop"] : _this$props$onChange,
          _this$props$value = _this$props.value,
          value = _this$props$value === void 0 ? '' : _this$props$value;

      if (!isReadOnly && !isDisabled && !isLoading) {
        var isChecked = !_this.state.isChecked;

        _this.setState({
          isChecked: isChecked
        }, function () {
          return onChange(name, isChecked, value);
        });
      }
    });

    _this.state = {
      isChecked: props.isChecked || false
    };
    return _this;
  }

  Object(createClass["a" /* default */])(InputSwitch, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isChecked !== this.props.isChecked) {
        this.setState({
          isChecked: this.props.isChecked
        });
      }
    }
  }, {
    key: "getIcon",
    value: function getIcon() {
      var _this$props2 = this.props,
          _this$props2$iconChec = _this$props2.iconChecked,
          iconChecked = _this$props2$iconChec === void 0 ? null : _this$props2$iconChec,
          _this$props2$iconUnCh = _this$props2.iconUnChecked,
          iconUnChecked = _this$props2$iconUnCh === void 0 ? null : _this$props2$iconUnCh;
      return this.state.isChecked ? iconChecked : iconUnChecked;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          ariaDescribedby = _this$props3.ariaDescribedby,
          ariaLabelledby = _this$props3.ariaLabelledby,
          className = _this$props3.className,
          _this$props3$id = _this$props3.id,
          id = _this$props3$id === void 0 ? "InputSwitch_".concat(shortid_default.a.generate()) : _this$props3$id,
          inputTestId = _this$props3.inputTestId,
          isDisabled = _this$props3.isDisabled,
          isLoading = _this$props3.isLoading,
          isReadOnly = _this$props3.isReadOnly,
          isRequired = _this$props3.isRequired,
          isSwitch = _this$props3.isSwitch,
          label = _this$props3.label,
          labelClassName = _this$props3.labelClassName,
          name = _this$props3.name,
          onClick = _this$props3.onClick,
          theme = _this$props3.theme,
          value = _this$props3.value,
          dataTestId = _this$props3.dataTestId;
      var isChecked = this.state.isChecked;

      var _themes$theme = themes[theme](InputSwitch_objectSpread({
        isChecked: isChecked
      }, this.props)),
          thChecked = _themes$theme.thChecked,
          thCheckedStyle = _themes$theme.thCheckedStyle,
          thLabel = _themes$theme.thLabel,
          thLoading = _themes$theme.thLoading,
          thRoot = _themes$theme.thRoot,
          thSwitch = _themes$theme.thSwitch,
          thSwitchStyle = _themes$theme.thSwitchStyle,
          thSwitchToggler = _themes$theme.thSwitchToggler,
          thSwitchTogglerStyle = _themes$theme.thSwitchTogglerStyle;

      return __jsx("div", {
        "data-testid": dataTestId,
        className: classnames_default()(className, thRoot)
      }, isSwitch ? __jsx("button", {
        "aria-checked": isChecked,
        "aria-describedby": ariaDescribedby,
        "aria-disabled": isDisabled,
        "aria-labelledby": ariaLabelledby,
        className: thSwitch,
        "data-testid": id,
        onClick: this.onChange,
        role: "checkbox",
        style: thSwitchStyle,
        type: "button"
      }, __jsx("span", {
        className: thSwitchToggler,
        style: thSwitchTogglerStyle
      }, isChecked ? __jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].CHECK
      }) : __jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].CROSS,
        width: "0.7rem"
      }))) : __jsx("button", {
        "aria-checked": isChecked,
        "aria-describedby": ariaDescribedby,
        "aria-disabled": isDisabled,
        "aria-labelledby": ariaLabelledby,
        className: classnames_default()('reset-button', thChecked),
        "data-testid": id,
        disabled: isDisabled,
        onClick: this.onChange,
        role: "checkbox",
        style: thCheckedStyle,
        type: "button"
      }, __jsx(Icon["a" /* Icon */], {
        name: this.getIcon(),
        width: "100%"
      })), __jsx("input", {
        checked: isChecked,
        className: "hidden",
        disabled: isDisabled,
        id: id,
        "data-testid": inputTestId,
        label: label,
        name: name,
        onChange: this.onChange,
        onClick: onClick,
        required: isRequired,
        type: "checkbox",
        value: value
      }), isLoading && !isDisabled && !isReadOnly && __jsx("div", {
        className: thLoading
      }, __jsx(Spinner["a" /* Spinner */], {
        size: "small"
      })), !!label && __jsx("label", {
        className: classnames_default()(labelClassName, thLabel),
        htmlFor: id
      }, Object(lodash["isString"])(label) ? Object(form_util["b" /* getFormattedLabel */])(label, isRequired) : label));
    }
  }]);

  return InputSwitch;
}(react["Component"]);

Object(defineProperty["a" /* default */])(InputSwitch_InputSwitch, "defaultProps", {
  color: colors["a" /* COLORS */].BLUE,
  iconChecked: icons["a" /* ICONS */].CHECK,
  iconUnChecked: null,
  isDisabled: false,
  isLoading: false,
  size: 'medium',
  theme: 'default',
  validationState: 'NOT_VALIDATED'
});

/***/ }),

/***/ "YpBQ":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("y/9h"),
    isFlattenable = __webpack_require__("oCTG");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ "ZHrn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ ContactInfoUtils_getOptinsInfos; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ ContactInfoUtils_getInitialAttendeesList; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ ContactInfoUtils_getInitialFormValues; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ getAddressValidators; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ ContactInfoUtils_getValidators; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ addressSchemaSort; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ ContactInfoUtils_getAdultCivilities; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ ContactInfoUtils_getHeaderContactInfoTitle; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ cleanUselessAttendeesValues; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ ContactInfoUtils_getGmNumbersOptions; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ ContactInfoUtils_findDuplicateAttendees; });
__webpack_require__.d(__webpack_exports__, "r", function() { return /* binding */ ContactInfoUtils_trackAttendeesFormError; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* binding */ submitOption; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* binding */ submitOptionFromProposal; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ getLegalInputInformation; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* binding */ renderErrorUpdatingAttendees; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ getAllAttendeesIds; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* binding */ ContactInfoUtils_shouldHideField; });

// UNUSED EXPORTS: isChild, getCNILLegalMessage, getLegalInformation, shouldDisplayLegalInformation

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("fYnN");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/yup/lib/index.js
var lib = __webpack_require__("luEP");

// EXTERNAL MODULE: ../domains-service/dist/index.js
var dist = __webpack_require__("g/E1");

// CONCATENATED MODULE: ./src/client/components/widgets/participants/utils.js
var STRICT_REGEX = /[.-]/g;
var NON_STRICT_REGEX = /[^\d]/g;
var REJECT_CPF_LIST = ['00000000000', '11111111111', '22222222222', '33333333333', '44444444444', '55555555555', '66666666666', '77777777777', '88888888888', '99999999999'];
function digitsVerifier(numbers) {
  var numberList = numbers.split('').map(function (number) {
    return parseInt(number, 10);
  });
  var modulo = numberList.length + 1;
  var multiplied = numberList.map(function (number, index) {
    return number * (modulo - index);
  });
  var mod = multiplied.reduce(function (buffer, number) {
    return buffer + number;
  }) % 11;
  return mod < 2 ? 0 : 11 - mod;
}
function isValidCPF(cpf) {
  var isStrict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var stripped = strip(cpf, isStrict); // CPF must be defined

  if (!stripped) {
    return false;
  } // CPF must have 11 chars


  if (stripped.length !== 11) {
    return false;
  }

  if (REJECT_CPF_LIST.includes(stripped)) {
    return false;
  }

  var numbers = stripped.substr(0, 9);
  numbers += digitsVerifier(numbers);
  numbers += digitsVerifier(numbers);
  return numbers.substr(-2) === stripped.substr(-2);
}
function strip(cpf) {
  var isStrict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var regex = isStrict ? STRICT_REGEX : NON_STRICT_REGEX;
  return (cpf || '').toString().replace(regex, '');
}
// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/PaymentInfo.const.js
var PaymentInfo_const = __webpack_require__("BU6i");

// EXTERNAL MODULE: ./src/utils/uri/redirectUtils.js
var redirectUtils = __webpack_require__("k9PE");

// EXTERNAL MODULE: ./src/routes/routeBuilder.js
var routeBuilder = __webpack_require__("U2CP");

// EXTERNAL MODULE: ./src/utils/status-code/statusCode.constants.js
var statusCode_constants = __webpack_require__("PSHn");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/utils/legal-information/legalInformationIds.constants.js
var legalInformationIds_constants = __webpack_require__("y5Lu");

// EXTERNAL MODULE: ./src/utils/locale/constants.js
var constants = __webpack_require__("qFX+");

// EXTERNAL MODULE: ./src/utils/context/contextUtils.js
var contextUtils = __webpack_require__("igjW");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/regex/RegexHelper.js
var RegexHelper = __webpack_require__("9BC+");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/constants.js
var contact_info_constants = __webpack_require__("ZOp8");

// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/ContactInfoUtils.js




var _this = undefined;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




















function getCNILLegalMessage() {
  var legalMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var cnilLegalMessage = legalMessages.find(function (legalMessage) {
    return legalMessage.id === contact_info_constants["a" /* CNIL_LEGAL_MESSAGE_ID */];
  });
  return cnilLegalMessage && Object(lodash["pick"])(cnilLegalMessage, ['label', 'description', 'required']);
}

function getLegalInputInformation() {
  var legalMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var id = arguments.length > 1 ? arguments[1] : undefined;
  return legalMessages.find(function (legalMessage) {
    return legalMessage.id === id;
  });
}

function getLegalInformation(beLegalInfos) {
  return function (id) {
    return (beLegalInfos || []).find(function (legalInfo) {
      return legalInfo.id === id;
    });
  };
}

var ContactInfoUtils_getOptinsInfos = function getOptinsInfos(bookingProcess) {
  var getLegalInfo = getLegalInformation(bookingProcess);
  return {
    email: getLegalInfo(legalInformationIds_constants["b" /* EMAIL_OPTIN */]),
    sms: getLegalInfo(legalInformationIds_constants["l" /* SMS_OPTIN */]),
    mail: getLegalInfo(legalInformationIds_constants["e" /* MAIL_OPTIN */]),
    fosun: getLegalInfo(legalInformationIds_constants["c" /* FOSUN_PARTNERS */]),
    phone: getLegalInfo(legalInformationIds_constants["j" /* PHONE_OPTIN */]),
    clubmedPlus: getLegalInfo(legalInformationIds_constants["a" /* CLUBMED_PLUS */]),
    theo: getLegalInfo(legalInformationIds_constants["m" /* THEO */])
  };
};

function shouldDisplayLegalInformation(beLegalInfos) {
  var getLegalInfo = getLegalInformation(beLegalInfos);
  return function (id) {
    return !!getLegalInfo(id);
  };
}

function _getOptionSubmissionRequest(appContext, params, hasSaveOption, isChequeOrTransferPaymentLabel, salesmanID) {
  return "\n    mutation {\n      bookings(\n        proposalId: \"".concat(params.proposalId, "\"\n        ").concat(hasSaveOption || isChequeOrTransferPaymentLabel ? 'bookingStatus: OPTION' : 'bookingStatus: PENDING_PAYMENT', "\n        ").concat(params.sellerEmail ? "sellerEmail: \"".concat(params.sellerEmail, "\"") : '', "\n        ").concat(salesmanID ? "salesmanID: \"".concat(salesmanID, "\"") : '', "\n      ) {\n        bookingId\n      }\n    }");
}

function submitOptionFromProposal(appContext, sellerEmail, selectedProposalId, productId, hasSaveOption, salesmanID, hasNoRedirection) {
  var redirectTo = redirectUtils["a" /* default */].redirectToUri();
  return function (proposal) {
    var params = {
      proposalId: (proposal === null || proposal === void 0 ? void 0 : proposal.id) || '',
      sellerEmail: sellerEmail
    };
    var paymentMethodLabel = js_cookie_default.a.get(PaymentInfo_const["n" /* PAYMENT_METHOD_LABEL */]);
    var isChequeOrTransferPaymentLabel = paymentMethodLabel === PaymentInfo_const["b" /* CHEQUE_LABEL */] || paymentMethodLabel === PaymentInfo_const["a" /* BANK_TRANSFER_LABEL */]; // hide by default the salesmanID warning message if we have a not empty salesmanID

    if (appContext.isSeller) {
      js_cookie_default.a.set("".concat(contact_info_constants["f" /* SALESMAN_ID_WARNING_MESSAGE */], "-").concat(selectedProposalId), salesmanID === '' ? 'show' : 'hide', {
        secure: !Object(contextUtils["d" /* isStrictlyDevelopmentEnv */])()
      });
    }

    var queryWithSalesmanID = _getOptionSubmissionRequest(appContext, params, hasSaveOption, isChequeOrTransferPaymentLabel, salesmanID);

    var queryWithoutSalesmanID = _getOptionSubmissionRequest(appContext, params, hasSaveOption, isChequeOrTransferPaymentLabel);

    var handleSuccess = function handleSuccess(response) {
      !hasNoRedirection && redirectTo(Object(routeBuilder["a" /* buildUrl */])('optionConfirmation', {
        status: statusCode_constants["a" /* STATUS_CODE_200 */]
      }, _objectSpread({
        bi: Object(lodash["get"])(response, 'bookings.bookingId', ''),
        selectedProposalId: selectedProposalId,
        productId: productId
      }, hasSaveOption && {
        hasSaveOption: hasSaveOption
      })))();
    };

    var handleError = function handleError(error) {
      var status = Object(lodash["get"])(error, 'errors[0].responseBody.status_code', statusCode_constants["b" /* STATUS_CODE_400 */]);
      var error_code = Object(lodash["get"])(error, 'errors[0].responseBody.errors[0].error_code', 'BOOKING_UNAVAILABLE');
      var error_description = Object(lodash["get"])(error, 'errors[0].responseBody.errors[0].error_description');

      if (status === statusCode_constants["b" /* STATUS_CODE_400 */] && error_code === contact_info_constants["i" /* WRONG_SALESMAN_ID */]) {
        // hide the salesmanID warning message if we have a wrong salesmanId on the confirmation page
        js_cookie_default.a.set("".concat(contact_info_constants["f" /* SALESMAN_ID_WARNING_MESSAGE */], "-").concat(selectedProposalId), 'show', {
          secure: !Object(contextUtils["d" /* isStrictlyDevelopmentEnv */])()
        });
        return graphqlClient["a" /* default */].runNoCacheQuery(queryWithoutSalesmanID, appContext, {
          requestName: requestDictionary["vd" /* PROPOSAL_UPDATE */]
        }).then(handleSuccess)["catch"](handleError);
      } else {
        !hasNoRedirection && redirectTo(Object(routeBuilder["a" /* buildUrl */])('optionConfirmationError', {
          status: status,
          error_code: error_code,
          error_description: error_description
        }, {
          selectedProposalId: selectedProposalId,
          productId: productId
        }))();
      }
    };

    return graphqlClient["a" /* default */].runNoCacheQuery(queryWithSalesmanID, appContext, {
      requestName: requestDictionary["vd" /* PROPOSAL_UPDATE */]
    }).then(handleSuccess)["catch"](handleError);
  };
}

function submitOption(appContext, location, sellerEmail, hasSaveOption, salesmanID) {
  var _location$queryParams = location.queryParams,
      selectedProposalId = _location$queryParams.selectedProposalId,
      productId = _location$queryParams.product;
  return submitOptionFromProposal(appContext, sellerEmail, selectedProposalId, productId, hasSaveOption, salesmanID);
}

function renderErrorUpdatingAttendees(statusCode, i18n) {
  var message = '';

  switch (statusCode) {
    case statusCode_constants["f" /* STATUS_CODE_500 */]:
    case statusCode_constants["c" /* STATUS_CODE_401 */]:
      message = Object(lodash["get"])(i18n, 'booking.form.errors.technicalErrorParticipants');
      break;

    default:
      message = Object(lodash["get"])(i18n, 'booking.form.errorLabel');
      break;
  }

  return message;
}

var getAttendeeId = function getAttendeeId(_ref) {
  var neolid = _ref.neolid;
  return neolid;
};

var getAllAttendeesIds = function getAllAttendeesIds(_ref2) {
  var adults = _ref2.adults,
      kids = _ref2.kids;
  var allAttendeesIds = {};

  if (adults.length > 0) {
    allAttendeesIds.adultsAttendeesIds = adults.map(getAttendeeId).filter(Boolean);
  }

  if (kids.length > 0) {
    allAttendeesIds.kidsAttendeesIds = kids.map(getAttendeeId).filter(Boolean);
  }

  return allAttendeesIds;
};

var ContactInfoUtils_getInitialAttendeesList = function getInitialAttendeesList(_ref3) {
  var attendees = _ref3.attendees,
      connectedUserInfo = _ref3.connectedUserInfo; // defined the default lastName to that of connectedUser

  var adults = attendees.adults.map(function (adult, index) {
    return _objectSpread(_objectSpread({}, adult), {}, {
      lastName: connectedUserInfo && !adult.lastName ? connectedUserInfo.lastName : adult.lastName,
      isMain: index === 0 || !!adult.gmNumber && index === attendees.adults.findIndex(function (_ref4) {
        var gmNumber = _ref4.gmNumber;
        return gmNumber === adult.gmNumber;
      })
    });
  }); // defined the default lastName to this of connectedUser

  var children = attendees.children.map(function (child) {
    return _objectSpread(_objectSpread({}, child), {}, {
      lastName: connectedUserInfo && !child.lastName ? connectedUserInfo.lastName : child.lastName
    });
  });
  return {
    adults: adults,
    children: children,
    all: [].concat(Object(toConsumableArray["a" /* default */])(adults.map(function (adult, index) {
      return _objectSpread(_objectSpread({}, adult), {}, {
        attendeeIndex: index
      });
    })), Object(toConsumableArray["a" /* default */])(children.map(function (child, index) {
      return _objectSpread(_objectSpread({}, child), {}, {
        attendeeIndex: index,
        isChild: true
      });
    })))
  };
};
var ContactInfoUtils_getInitialFormValues = function getInitialFormValues(_ref5) {
  var i18n = _ref5.i18n,
      initialAttendeesList = _ref5.initialAttendeesList,
      connectedUserInfo = _ref5.connectedUserInfo,
      hasAddress = _ref5.hasAddress,
      nationalityFieldRules = _ref5.nationalityFieldRules,
      locale = _ref5.locale,
      sellerEmail = _ref5.sellerEmail;
  var showOnlyCountryCode = i18n.booking.participants.postalAddress.displayCountryFieldOnly;
  var optins = ContactInfoUtils_getOptinsInfos(i18n.bookingProcess); // The opt-ins show are configurable from the CMS, but we also don't show them for identified
  // users who already checked them

  var getOptinValue = function getOptinValue(optin, optinName, userInfo) {
    if (!optin) {
      return;
    } // in case of a connected user return undefined to not show it if already checked


    if (connectedUserInfo[optinName] === true) {
      return undefined;
    }

    if (userInfo[optinName] !== undefined) {
      return userInfo[optinName];
    }

    return optin.preChecked;
  };

  return {
    seller: {
      email: sellerEmail
    },
    // $FlowFixMe temporarily disabled: waiting for clic evolv
    adults: initialAttendeesList.adults.map(function (adult) {
      var _i18n$booking, _i18n$booking$partici, _i18n$booking$partici2, _i18n$booking$partici3, _i18n$booking$partici4;

      return _objectSpread(_objectSpread(_objectSpread({
        civility: (i18n === null || i18n === void 0 ? void 0 : (_i18n$booking = i18n.booking) === null || _i18n$booking === void 0 ? void 0 : (_i18n$booking$partici = _i18n$booking.participants) === null || _i18n$booking$partici === void 0 ? void 0 : (_i18n$booking$partici2 = _i18n$booking$partici.civilities) === null || _i18n$booking$partici2 === void 0 ? void 0 : (_i18n$booking$partici3 = _i18n$booking$partici2.adult) === null || _i18n$booking$partici3 === void 0 ? void 0 : (_i18n$booking$partici4 = _i18n$booking$partici3[0]) === null || _i18n$booking$partici4 === void 0 ? void 0 : _i18n$booking$partici4.value) || ''
      }, adult), {}, {
        passport: _objectSpread(_objectSpread({}, adult.passport), nationalityFieldRules && (nationalityFieldRules.concernedAttendees === 'all' || adult.isMain) && (!adult.passport || !adult.passport.nationality) ? {
          nationality: 'RU'
        } : {}),
        birthdate: typeof adult.birthdate === 'number' ? adult.birthdate : Object(apiDate["d" /* apiDateToTimestamp */])(adult.birthdate),
        address: adult.isMain && hasAddress ? _objectSpread(_objectSpread({}, showOnlyCountryCode ? null : adult.address), {}, {
          countryCode: Object(lodash["get"])(adult.address, 'countryCode', locale.split('-')[1])
        }) : undefined
      }, adult.isMain ? {
        optinEmail: getOptinValue(optins.email, 'optinEmail', adult),
        optinSms: getOptinValue(optins.sms, 'optinSms', adult),
        optinMail: getOptinValue(optins.mail, 'optinMail', adult),
        optinFosun: getOptinValue(optins.fosun, 'optinFosun', adult),
        optinPhone: getOptinValue(optins.phone, 'optinPhone', adult),
        optinClubmedPlus: getOptinValue(optins.clubmedPlus, 'optinClubmedPlus', adult),
        legalAgreement: false,
        checkAll: false
      } : null), {}, {
        // clear user info we don't want to store in the form state and in the store
        isMain: undefined,
        mainContactId: !adult.gmNumber && initialAttendeesList.adults[0].neolid ? initialAttendeesList.adults[0].neolid : '-1' // temporarily disabled: waiting for clic evolv

      });
    }),
    // $FlowFixMe temporarily disabled: waiting for clic evolv
    children: initialAttendeesList.children.map(function (child) {
      return _objectSpread(_objectSpread({}, child), {}, {
        passport: _objectSpread(_objectSpread({}, child.passport), nationalityFieldRules && nationalityFieldRules.concernedAttendees === 'all' && (!child.passport || !child.passport.nationality) ? {
          nationality: 'RU'
        } : {}),
        birthdate: typeof child.birthdate === 'number' ? child.birthdate : Object(apiDate["d" /* apiDateToTimestamp */])(child.birthdate),
        mainContactId: !child.gmNumber && initialAttendeesList.adults[0].neolid ? initialAttendeesList.adults[0].neolid : '-1' // temporarily disabled: waiting for clic evolv

      });
    })
  };
};
function getAddressValidators(addressSchema) {
  var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref6$withRequired = _ref6.withRequired,
      withRequired = _ref6$withRequired === void 0 ? true : _ref6$withRequired,
      message = _ref6.message;

  return addressSchema.reduce(function (addressValidators, fieldValidation) {
    var rule = lib["string"]();
    fieldValidation.validators.forEach(function (validator) {
      switch (validator.name) {
        case 'pattern':
          rule = rule.matches(validator.value, message);
          break;

        case 'minLength':
          rule = rule.transform(function (value) {
            return value === '' ? undefined : value;
          }, message).min(validator.value, message);
          break;

        case 'maxLength':
          rule = rule.max(validator.value, message);
          break;

        default:
          // eslint-disable-next-line no-console
          console.error("Cannot handle rule ".concat(validator.name));
      }
    });

    if (withRequired) {
      if (fieldValidation.required) {
        rule = rule.required();
      }
    }

    return _objectSpread(_objectSpread({}, addressValidators), {}, Object(defineProperty["a" /* default */])({}, fieldValidation.name, rule));
  }, {});
}
var ContactInfoUtils_getValidators = function getValidators(_ref7) {
  var nationality = _ref7.nationality,
      identityNumberInformation = _ref7.identityNumberInformation,
      addressSchema = _ref7.addressSchema,
      passportInformation = _ref7.passportInformation,
      expirationDate = _ref7.expirationDate,
      issuingDate = _ref7.issuingDate,
      locale = _ref7.locale,
      departureDate = _ref7.departureDate,
      arrivalDate = _ref7.arrivalDate,
      adultCivilities = _ref7.adultCivilities,
      childCivilities = _ref7.childCivilities,
      userIsSeller = _ref7.userIsSeller;
  var strictNameValidator = lib["string"]().matches(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/);
  var baseWordValidator = strictNameValidator.matches(/^[\x20-\xFF]+$/); // ASCII

  var phoneRegex = Object(RegexHelper["b" /* getPhoneRegex */])(locale);
  var rawValidators = {
    adultCivilities: lib["string"]().oneOf(adultCivilities).required(),
    childCivilities: lib["string"]().oneOf(childCivilities).required(),
    firstName: baseWordValidator.max(20).required(),
    lastName: baseWordValidator.max(30).required(),
    unicodeFirstName: strictNameValidator.max(100).required(),
    unicodeLastName: strictNameValidator.max(100).required(),
    adultBirthDate: lib["date"]().transform(function (value, initialValue) {
      return initialValue ? new Date(initialValue) : initialValue;
    }).max(moment_default()().subtract(contact_info_constants["j" /* YEAR_OF_MAJORITY */], 'y')).min(moment_default()().subtract(contact_info_constants["c" /* MAX_AGE */], 'y')).required(),
    childBirthDate: lib["date"]().transform(function (value, initialValue) {
      return initialValue ? new Date(initialValue) : initialValue;
    }).max(moment_default()()).min(moment_default()().subtract(contact_info_constants["j" /* YEAR_OF_MAJORITY */], 'y')).required(),
    email: lib["string"]().matches(RegexHelper["a" /* emailRegex */]).required(),
    mobile: lib["string"]().matches(phoneRegex).required(),
    emailNotRequired: lib["string"]().email(),
    mobileNotRequired: lib["string"]().transform(function (v) {
      return !v ? undefined : v;
    }) // transform to undefined when empty string to pass the regex
    .matches(phoneRegex),
    documentNumber: function () {
      if (!passportInformation) {
        return;
      }

      var rule = lib["string"]().transform(function (value, initialValue) {
        return initialValue ? initialValue.replace(/ /g, '') : initialValue;
      }).matches(/[a-zA-Z0-9]{6,30}/, {
        excludeEmptyString: true
      });
      return passportInformation.required && !userIsSeller ? rule.required() : rule;
    }(),
    expirationDate: function () {
      if (!expirationDate) {
        return;
      }

      var rule = lib["mixed"]().transform(function (value, initialValue) {
        return initialValue ? new Date(initialValue) : initialValue;
      }).test('', '', function (value) {
        //<< optionnal for seller >> && << cms .required - expirationDate at least one day after departure for user >>
        if (expirationDate.required && !userIsSeller && !value || (!expirationDate.required || userIsSeller) && value && value <= moment_default()(departureDate).add(1, 'd') || expirationDate.required && !userIsSeller && !value) {
          return false;
        }

        return true;
      });
      return rule;
    }(),
    issuingDate: function () {
      if (!issuingDate) {
        return;
      }

      var rule = lib["mixed"]().transform(function (value, initialValue) {
        return initialValue ? new Date(initialValue) : initialValue;
      }).test('', '', function (value) {
        //<< optionnal for seller >> && << cms .required - issuingDate at least one day before arrival for user >>
        if (issuingDate.required && !userIsSeller && !value || (!issuingDate.required || userIsSeller) && value && value >= moment_default()(arrivalDate).subtract(1, 'd')) {
          return false;
        }

        return true;
      });
      return rule;
    }(),
    nationality: function () {
      if (!nationality) {
        return;
      }

      var rule = lib["string"]();
      return nationality.required && !userIsSeller ? rule.required() : rule;
    }(),
    identityNumber: function () {
      if (!identityNumberInformation) {
        return;
      }

      var brazilCpfRule = lib["string"]().test('', '', function (value) {
        value && value.replace(/ /g, '');

        if (value.length < 11 || value.length > 14 || !isValidCPF(value)) {
          // $FlowFixMe should use the function syntax instead of the arrow, but it only works this way
          return _this.createError();
        }
      });
      var rule = lib["string"]().transform(function (value, initialValue) {
        return initialValue ? initialValue.replace(/ /g, '') : initialValue;
      }).min(6).max(30);
      var finalRule = locale === constants["a" /* LOCALES */].PT_BR ? brazilCpfRule : rule;
      return identityNumberInformation.required ? finalRule.required() : finalRule;
    }(),
    legalAgreement: lib["mixed"]().oneOf([true]).required(),
    gmNumber: lib["string"]().required(),
    salesmanID: lib["string"]().matches(RegexHelper["d" /* salesmanIDRegex */])
  }; // $FlowFixMe

  return _objectSpread(_objectSpread({}, rawValidators), {}, {
    address: getAddressValidators(addressSchema)
  });
};
var addressSchemaOrder = ['streetNumber', 'streetName', 'zipCode', 'city', 'additionalInformation1', 'additionalInformation2', 'addOn', 'town', 'stateOrDistrict', 'countryCode'];
var addressSchemaSort = function addressSchemaSort(schema1, schema2) {
  return addressSchemaOrder.indexOf(schema1.name) - addressSchemaOrder.indexOf(schema2.name);
};
var ContactInfoUtils_getAdultCivilities = function getAdultCivilities(defaultCivilities, locale) {
  var adultCivilities = Object(dist["getAdultsCivilities"])(locale);
  return Object(lodash["isEmpty"])(adultCivilities) ? defaultCivilities : adultCivilities;
};
var ContactInfoUtils_getHeaderContactInfoTitle = function getHeaderContactInfoTitle(_ref8) {
  var i18n = _ref8.i18n,
      isValid = _ref8.isValid,
      isMain = _ref8.isMain,
      isChild = _ref8.isChild,
      displayUnicodeFields = _ref8.displayUnicodeFields,
      formValues = _ref8.formValues,
      attendeeIdentifier = _ref8.attendeeIdentifier,
      attendeeIndex = _ref8.attendeeIndex;

  if (isValid) {
    if (displayUnicodeFields) {
      return "".concat(Object(lodash["get"])(formValues, "".concat(attendeeIdentifier, ".unicodeFirstName")), " ").concat(Object(lodash["get"])(formValues, "".concat(attendeeIdentifier, ".unicodeLastName")));
    }

    return "".concat(Object(lodash["get"])(formValues, "".concat(attendeeIdentifier, ".firstName")), " ").concat(Object(lodash["get"])(formValues, "".concat(attendeeIdentifier, ".lastName")));
  }

  if (isMain) {
    return i18n.booking.participants.personnalInfosHeader.title;
  }

  if (isChild) {
    return "".concat(i18n.booking.participants.otherKidsInfosHeader.title, " ").concat(attendeeIndex + 1);
  }

  return "".concat(i18n.booking.participants.otherAdultsInfosHeader.title, " ").concat(attendeeIndex);
};
var cleanUselessAttendeesValues = function cleanUselessAttendeesValues(_ref9) {
  var adults = _ref9.adults,
      children = _ref9.children;
  return {
    children: children,
    // clear legalAgreement, it's not need in the store it's just to block the form
    adults: adults.map(function (adult) {
      return _objectSpread(_objectSpread({}, adult), {}, {
        legalAgreement: undefined
      });
    })
  };
};
var ContactInfoUtils_isChild = function isChild(attendeeIdentifier) {
  return attendeeIdentifier.includes('children');
};
var ContactInfoUtils_getGmNumbersOptions = function getGmNumbersOptions(_ref10) {
  var formik = _ref10.formik,
      i18n = _ref10.i18n,
      previousGmNumberOptions = _ref10.previousGmNumberOptions; // we use a negative gmNumber to know that it's a new gm

  var newGmNumber = -1;
  return [].concat(Object(toConsumableArray["a" /* default */])([].concat(Object(toConsumableArray["a" /* default */])(formik.values.adults), Object(toConsumableArray["a" /* default */])(formik.values.children)).reduce(function (accGmNumbersOptions, attendee, index) {
    if (!attendee.gmNumber && !attendee.mainContactId) {
      return accGmNumbersOptions;
    }

    var _attendee$firstName = attendee.firstName,
        firstName = _attendee$firstName === void 0 ? '' : _attendee$firstName,
        _attendee$lastName = attendee.lastName,
        lastName = _attendee$lastName === void 0 ? '' : _attendee$lastName;
    var gmNumbersOptionsIndex = accGmNumbersOptions.findIndex(function (_ref11) {
      var gmNumber = _ref11.gmNumber,
          value = _ref11.value;
      return gmNumber === attendee.gmNumber || value === attendee.mainContactId;
    });

    if (gmNumbersOptionsIndex > -1) {
      accGmNumbersOptions[gmNumbersOptionsIndex].name += ", ".concat(firstName, " ").concat(lastName);
      return accGmNumbersOptions;
    }

    if (!attendee.gmNumber && attendee.mainContactId < 0) {
      var previousNewHouseholdOption = previousGmNumberOptions.find(function (_ref12) {
        var gmNumber = _ref12.gmNumber;
        return gmNumber === attendee.mainContactId;
      });
      /**
       * if the main contact of a previously created new household is deleted (=> the user change his household)
       * and there is other attendees on this household, we prevent this household to be in the options
       * and we will reset them later in the provider
       */

      if (previousNewHouseholdOption && previousNewHouseholdOption.mainContactIndex !== index) {
        return accGmNumbersOptions;
      } // when a new household is created update the id for a potential next-one


      newGmNumber--;
      return [].concat(Object(toConsumableArray["a" /* default */])(accGmNumbersOptions), [{
        mainContactIndex: index,
        gmNumber: attendee.mainContactId,
        value: attendee.mainContactId,
        name: "".concat(i18n.booking.participants.labels.gmNumber, " ").concat(lastName, " - ").concat(firstName, " ").concat(lastName)
      }]);
    }

    return [].concat(Object(toConsumableArray["a" /* default */])(accGmNumbersOptions), [{
      gmNumber: attendee.gmNumber,
      value: attendee.neolid,
      name: "".concat(attendee.gmNumber, " - ").concat(firstName, " ").concat(lastName)
    }]);
  }, [// select placeholder
  {
    name: i18n.booking.participants.labels.selectGmNumber,
    value: '',
    gmNumber: null
  }])), [{
    // select new household action option
    name: i18n.booking.participants.labels.createGmNumber,
    value: newGmNumber
  }]);
};

var ContactInfoUtils_shouldHideField = function shouldHideField(_ref13) {
  var connectedUserInfo = _ref13.connectedUserInfo,
      userIsSeller = _ref13.userIsSeller,
      formInitialValues = _ref13.formInitialValues,
      fieldName = _ref13.fieldName,
      attendeeIdentifier = _ref13.attendeeIdentifier,
      fieldNameConnectedUserOverride = _ref13.fieldNameConnectedUserOverride;

  if (connectedUserInfo && (fieldNameConnectedUserOverride && connectedUserInfo[fieldNameConnectedUserOverride] || connectedUserInfo[fieldName])) {
    return true;
  } // if the attendee has a gmNumber he is identified and if he has a value for the field
  // we don't want to permit the seller to modified the field #11741


  return !!(userIsSeller && Object(lodash["get"])(formInitialValues, "".concat(attendeeIdentifier, ".neolid")) && Object(lodash["get"])(formInitialValues, "".concat(attendeeIdentifier, ".").concat(fieldName)));
};

var ContactInfoUtils_findDuplicateAttendees = function findDuplicateAttendees(attendees) {
  var duplicates = attendees.reduce(function (acc, _ref14, index) {
    var birthdate = _ref14.birthdate,
        lastName = _ref14.lastName,
        firstName = _ref14.firstName;

    if (birthdate && lastName && firstName) {
      var key = "".concat(birthdate).concat(lastName).concat(firstName).toLocaleLowerCase();

      if (acc[key]) {
        acc[key].push(index);
      } else {
        acc[key] = [index];
      }
    }

    return acc;
  }, {});
  Object.keys(duplicates).forEach(function (key) {
    if (duplicates[key].length < 2) {
      delete duplicates[key];
    }
  }); // $FlowFixMe return indexes of duplicate attendees

  return Object(lodash["flatten"])(Object.values(duplicates));
};
var ContactInfoUtils_trackAttendeesFormError = function trackAttendeesFormError(track, formik) {
  var _formik$errors, _formik$errors2;

  var duplicatedAttendeeFieldsInError = ['firstName', 'lastName', 'birthdate'];
  var hasDuplicatedAttendeesErrorAlreadyBeenTracked = false;
  var formErrors = [].concat(Object(toConsumableArray["a" /* default */])(((_formik$errors = formik.errors) === null || _formik$errors === void 0 ? void 0 : _formik$errors.adults) || []), Object(toConsumableArray["a" /* default */])(((_formik$errors2 = formik.errors) === null || _formik$errors2 === void 0 ? void 0 : _formik$errors2.children) || []));
  formErrors.forEach(function (error) {
    if (!error) {
      // formik.errors.adults and formik.errors.children (when they are present) are the same size
      // as formik.values.adults and formik.values.children with undefined at that index if there
      // is no error for this attendee
      return;
    }

    var errorEntries = Object.entries(error);
    errorEntries.forEach(function (_ref15) {
      var _ref16 = Object(slicedToArray["a" /* default */])(_ref15, 2),
          field = _ref16[0],
          errorValue = _ref16[1]; // when there is a duplicated attendees error,
      // firstName, lastName and birthdate are set in error whose value is true
      // when the field is in error for an other reason, the error value is an error message


      var isDuplicatedAttendeeError = duplicatedAttendeeFieldsInError.includes(field) && errorValue === true;

      if (isDuplicatedAttendeeError && !hasDuplicatedAttendeesErrorAlreadyBeenTracked) {
        hasDuplicatedAttendeesErrorAlreadyBeenTracked = true;
        track({
          categoryGA: 'bookingEngine',
          actionGA: 'participant',
          labelGA: 'error_sameAttendees'
        });
      }

      if (!isDuplicatedAttendeeError) {
        if (Object(lodash["isObject"])(errorValue)) {
          var nestedFieldsInError = Object.keys(errorValue);
          nestedFieldsInError.forEach(function (nestedField) {
            track({
              categoryGA: 'bookingEngine',
              actionGA: 'participant',
              labelGA: "error_fieldError_".concat(nestedField)
            });
          });
        } else {
          track({
            categoryGA: 'bookingEngine',
            actionGA: 'participant',
            labelGA: "error_fieldError_".concat(field)
          });
        }
      }
    });
  });
};


/***/ }),

/***/ "ZKlR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TabHeader; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/tab-header/TabHeader.themes.js


var themes = {
  clean: function clean(props) {
    var color = props.color,
        isActive = props.isActive;
    var currentColor = color || colors["a" /* COLORS */].TURQUOISE;
    return {
      thBody: 'flex h-full items-center',
      thChildren: 'flex-auto flex font-bold items-center justify-center leading-one text-sm md:text-md',
      thIcon: 'flex-shrink-0 rtl:mr-px10',
      thIconWidth: '1em',
      thRoot: "".concat(isActive ? "text-".concat(currentColor) : "text-gray-darker focus:text-".concat(currentColor, " hover:text-").concat(currentColor), " px-px15 py-px10 transition-color"),
      thToggleIcon: "flex-shrink-0 leading-none text-gray-dark rtl:ml-px10 ".concat(isActive ? 'rotate-360' : 'rotate-0'),
      thToggleIconWidth: '0.75rem'
    };
  },
  "default": function _default(props) {
    var color = props.color,
        isActive = props.isActive;
    var currentColor = color || colors["a" /* COLORS */].BLUE;
    return {
      thBody: 'flex h-full items-center py-px15 px-px10',
      thChildren: 'flex-grow flex items-center justify-center leading-one px-px10 text-white',
      thIcon: 'flex-shrink-0 rtl:mr-px10',
      thIconWidth: '1em',
      thRoot: "bg-current ".concat(isActive ? "text-".concat(currentColor, "-active arrow-down arrow-").concat(currentColor, "-active") : "text-".concat(currentColor, " focus:text-").concat(currentColor, "-active hover:text-").concat(currentColor, "-active"), " text-base text-center transition-color w-full"),
      thToggleIcon: "flex-shrink-0 leading-none text-white rtl:ml-px10 ".concat(isActive ? 'rotate-360' : 'rotate-0'),
      thToggleIconWidth: '0.625rem'
    };
  },
  rounded: function rounded(_ref) {
    var isActive = _ref.isActive;
    return {
      thRoot: classnames_default()('border-1 border-gray-light border-solid rounded-t-tiny', {
        'bg-gray-lighter': !isActive,
        'bg-white border-b-0 arrow-down-top arrow-turquoise': isActive
      }),
      thBody: 'flex items-center justify-between',
      thChildren: 'flex-1 flex items-center justify-center',
      thIcon: 'flex-shrink-0 rtl:mr-px10',
      thIconWidth: '1em',
      thToggleIcon: 'flex-shrink-0 text-blue',
      thToggleIconWidth: '0.75rem'
    };
  },
  flat: function flat(_ref2) {
    var isActive = _ref2.isActive;
    return {
      thBody: classnames_default()('border-t-1 border-l-1 border-r-1 flex h-full items-center p-px10 md:px-px20 md:py-px10 transition-colors', {
        'bg-white border-b-white': isActive,
        'bg-gray-lighter border-b-1': !isActive
      }),
      thChildren: classnames_default()('justify-center flex-grow flex font-brand items-center leading-tight text-blue text-sm md:text-lg', {
        'opacity-50': !isActive
      }),
      thIcon: '',
      thIconWidth: '',
      thRoot: classnames_default()('overflow-hidden rounded-tiny', {
        'z-2': isActive
      }),
      thToggleIcon: '',
      thToggleIconWidth: ''
    };
  },
  simple: function simple(props) {
    var color = props.color,
        isActive = props.isActive;
    var currentColor = color || colors["a" /* COLORS */].TURQUOISE;
    return {
      thRoot: "".concat(isActive ? "text-".concat(currentColor, " border-").concat(currentColor, " arrow-down arrow-").concat(currentColor) : "text-white hover:text-".concat(currentColor, " border-gray-light hover:border-").concat(currentColor), " bg-current border-1 flex-initial font-bold rounded text-sm text-center transition-colors uppercase"),
      thBody: "flex h-full items-center p-px10 ".concat(isActive ? 'text-white' : 'text-gray-darker focus:text-white hover:text-white transition-color'),
      thChildren: 'flex-grow flex items-center justify-center p-px10',
      thIcon: 'flex-shrink-0 rtl:mr-px10',
      thIconWidth: '1em',
      thToggleIcon: 'flex-shrink-0 leading-none m-px10',
      thToggleIconWidth: '0.625rem'
    };
  },
  lite: function lite(props) {
    var color = props.color,
        isActive = props.isActive;
    var currentColor = color || colors["a" /* COLORS */].GRAY_DARKER;
    return {
      thBody: 'flex items-center',
      thIcon: 'flex-shrink-0 rtl:mr-px10',
      thIconWidth: '1em',
      thRoot: classnames_default()("py-px5 px-px10 rounded-tiny text-".concat(currentColor, " text-md transition-bg-color"), {
        'bg-white': !isActive,
        'bg-overlay-blue-10 font-bold': isActive
      }),
      thToggleIcon: 'flex-shrink-0 leading-none m-px10',
      thToggleIconWidth: '0.625rem'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/tab-header/TabHeader.jsx


var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







// $FlowFixMe
var TabHeader = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  var children = props.children,
      className = props.className,
      collapseIconName = props.collapseIconName,
      controlsId = props.controlsId,
      _props$dataTestId = props.dataTestId,
      dataTestId = _props$dataTestId === void 0 ? 'tab-header' : _props$dataTestId,
      expandIconName = props.expandIconName,
      iconName = props.iconName,
      id = props.id,
      isAccordion = props.isAccordion,
      isActive = props.isActive,
      isDisabled = props.isDisabled,
      _onClick = props.onClick,
      onKeyDown = props.onKeyDown,
      role = props.role,
      style = props.style,
      tabIndex = props.tabIndex,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      trackingData = props.trackingData;
  var track = !isActive && trackingData ? Object(useTracking["a" /* useTracking */])(trackingData) : lodash["noop"];

  var _themes$theme = themes[theme](props),
      thBody = _themes$theme.thBody,
      thChildren = _themes$theme.thChildren,
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thRoot = _themes$theme.thRoot,
      thToggleIcon = _themes$theme.thToggleIcon,
      thToggleIconWidth = _themes$theme.thToggleIconWidth;

  var toggleIcon = isActive ? collapseIconName : expandIconName;

  var aria = _objectSpread(_objectSpread({}, controlsId ? {
    'aria-controls': controlsId
  } : null), isAccordion ? {
    'aria-expanded': isActive
  } : {
    'aria-selected': isActive
  });

  return __jsx("button", Object(esm_extends["a" /* default */])({}, aria, {
    className: classnames_default()(className, 'reset-button', thRoot),
    "data-cs-override-id": "TabHeader" // ContentSquare must ignore this id see https://docs.contentsquare.com/uxa-fr/#ignorer-remplacer-ou-ajouter-un-id
    ,
    "data-testid": dataTestId,
    disabled: isDisabled,
    onClick: function onClick() {
      _onClick && _onClick();
      track({});
    },
    onKeyDown: onKeyDown,
    id: id,
    ref: ref,
    role: role,
    style: style,
    tabIndex: tabIndex,
    type: "button"
  }), __jsx("div", {
    className: thBody
  }, __jsx("div", {
    className: thChildren
  }, !!iconName && __jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: iconName,
    width: thIconWidth
  }), children), !!toggleIcon && __jsx(Icon["a" /* Icon */], {
    className: thToggleIcon,
    name: toggleIcon,
    width: thToggleIconWidth
  })));
});

/***/ }),

/***/ "ZLJe":
/***/ (function(module) {

module.exports = JSON.parse("{\"amp\":\"&\",\"apos\":\"'\",\"gt\":\">\",\"lt\":\"<\",\"quot\":\"\\\"\"}");

/***/ }),

/***/ "ZS6v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductPriceInfo; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("qqKu");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;







var ProductPriceInfo = function ProductPriceInfo(_ref) {
  var city = _ref.city,
      endDate = _ref.endDate,
      hasTransport = _ref.hasTransport,
      isCruise = _ref.isCruise,
      isJoyview = _ref.isJoyview,
      isTour = _ref.isTour,
      onClick = _ref.onClick,
      startDate = _ref.startDate,
      unit = _ref.unit;
  var isAllInclusive = !isJoyview && !isTour; // eslint-disable-next-line no-nested-ternary

  var buttonLabel = isTour ? Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('resort.pricePopin.buttonTourLabel') : isCruise ? Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('resort.pricePopin.buttonCruiseLabel') : Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('resort.pricePopin.buttonLabel');
  return __jsx(react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_6__[/* Text */ "a"], {
    className: "p-px20",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].GRAY_DARKER,
    text: [hasTransport ? Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('resort.pricePopin.startingPriceDescriptionWithTransport', {
      unit: unit,
      city: city,
      endDate: endDate,
      startDate: startDate
    }) : Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('resort.pricePopin.startingPriceDescriptionWithoutTransport', {
      endDate: endDate,
      startDate: startDate,
      unit: unit
    }), Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('resort.pricePopin.roomAvailability')].join(' '),
    theme: "text-sans-2"
  }), (isAllInclusive || isJoyview || onClick) && __jsx("div", {
    className: "flex flex-col items-center border-t-1 border-gray-light p-px20"
  }, isAllInclusive && __jsx("p", {
    className: "flex flex-col sm:flex-row sm:flex-wrap sm:justify-center max-w-full reset-paragraph text-center text-gray-darker text-sm"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('resort.pricePopin.priceIsLabel'), ' ', __jsx("span", {
    className: "font-brand rtl:ml-px5 text-blue text-md"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__[/* Icon */ "a"], {
    className: "-mt-px5 rtl:mr-px5",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].BLUE,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].ALL_INCLUSIVE,
    width: "1.2rem"
  }), Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "g"])('resort.startingPrice.allInclusive'))), isJoyview && __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__[/* Icon */ "a"], {
    className: "-mt-px5 rtl:mr-px5",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].WATER_GREEN,
    isNotSquare: true,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].CLUBMED_JOYVIEW,
    width: "10rem"
  }), onClick && __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_4__[/* Button */ "a"], {
    className: "mt-px10",
    colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].BOOKING,
    colorBorder: _utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].BOOKING,
    dataTestId: "ProductPriceInfo-button",
    onClick: onClick
  }, buttonLabel)));
};

/***/ }),

/***/ "ZVqJ":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var getBuiltIn = __webpack_require__("x90g");
var aFunction = __webpack_require__("mplc");
var anObject = __webpack_require__("ep/x");
var isObject = __webpack_require__("1YFU");
var create = __webpack_require__("Znn2");
var bind = __webpack_require__("C56r");
var fails = __webpack_require__("fhLv");

var nativeConstruct = getBuiltIn('Reflect', 'construct');

// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});
var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ "ZiN6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("LTtw");
var createIteratorConstructor = __webpack_require__("oScl");
var getPrototypeOf = __webpack_require__("yvHl");
var setPrototypeOf = __webpack_require__("iBXc");
var setToStringTag = __webpack_require__("CGO5");
var createNonEnumerableProperty = __webpack_require__("g51W");
var redefine = __webpack_require__("L1Xj");
var wellKnownSymbol = __webpack_require__("nJrx");
var IS_PURE = __webpack_require__("SRps");
var Iterators = __webpack_require__("oa0l");
var IteratorsCore = __webpack_require__("JpEK");

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),

/***/ "Znn2":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("ep/x");
var defineProperties = __webpack_require__("HKx7");
var enumBugKeys = __webpack_require__("WSQK");
var hiddenKeys = __webpack_require__("qXr/");
var html = __webpack_require__("QknU");
var documentCreateElement = __webpack_require__("a4SZ");
var sharedKey = __webpack_require__("mmil");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject -- old IE */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ "ZpYc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ StripButton_StripButton; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/strip-button/StripButton.themes.js

var StripButton_themes_themes = function themes(_ref) {
  var color = _ref.color,
      colorBorder = _ref.colorBorder,
      onClick = _ref.onClick,
      orientation = _ref.orientation;
  return {
    "default": {
      thRoot: classnames_default()('flex relative', {
        'reset-button': onClick
      }),
      thInner: "bg-".concat(color, " border-").concat(orientation === 'top' ? 't' : 'b', "-1 border-").concat(colorBorder, " -m").concat(orientation === 'top' ? 'x' : '', "-px overflow-hidden px-px5 stripButton-text p").concat(orientation === 'top' ? 't' : 'b', "-px5 text-center whitespace-no-wrap")
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/strip-button/StripButton.jsx

var __jsx = react_default.a.createElement;





var StripButton_StripButtonSvg = function StripButtonSvg(_ref) {
  var className = _ref.className,
      color = _ref.color,
      colorBorder = _ref.colorBorder,
      height = _ref.height,
      hasBottomOrientation = _ref.hasBottomOrientation;
  return __jsx("svg", {
    className: classnames_default()(className, 'fill-current', "text-".concat(color)),
    viewBox: "0 0 15 30",
    height: height,
    style: {
      flexBasis: height / 2
    }
  }, __jsx("g", null, __jsx("g", {
    transform: "translate(-61.000000, ".concat(hasBottomOrientation ? -155.5 : -156.5, ")")
  }, __jsx("g", {
    transform: "translate(66.000000, 166.000000)"
  }, __jsx("g", null, __jsx("g", null, __jsx("path", {
    d: "M10,21H-5L2.8-3.6C3.9-6.8,6.8-9,10-9"
  })))))), __jsx("g", null, __jsx("g", {
    transform: "translate(-61.000000, ".concat(hasBottomOrientation ? -155.5 : -156.5, ")")
  }, __jsx("g", {
    transform: "translate(66.000000, 166.000000)"
  }, __jsx("g", null, __jsx("g", null, __jsx("path", {
    style: {
      strokeWidth: '1px'
    },
    className: "fill-transparent stroke-current text-".concat(colorBorder),
    d: "M-5,21L2.8-3.6C3.9-6.8,6.8-9,10-9"
  })))))));
};

var StripButton_StripButton = function StripButton(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref2$color,
      _ref2$colorBorder = _ref2.colorBorder,
      colorBorder = _ref2$colorBorder === void 0 ? colors["a" /* COLORS */].GRAY_LIGHT : _ref2$colorBorder,
      _ref2$dataTestId = _ref2.dataTestId,
      dataTestId = _ref2$dataTestId === void 0 ? 'strip-button' : _ref2$dataTestId,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? 30 : _ref2$height,
      onClick = _ref2.onClick,
      _ref2$orientation = _ref2.orientation,
      orientation = _ref2$orientation === void 0 ? 'top' : _ref2$orientation,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'default' : _ref2$theme;

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = StripButton_themes_themes({
    color: color,
    colorBorder: colorBorder,
    onClick: onClick,
    orientation: orientation
  })[theme],
      thInner = _themes$theme.thInner,
      thRoot = _themes$theme.thRoot;
  var hasBottomOrientation = orientation === 'bottom';
  var svgProps = {
    color: color,
    colorBorder: colorBorder,
    height: height,
    hasBottomOrientation: hasBottomOrientation
  };
  var TagName = onClick ? 'button' : 'div';
  var btnProps = onClick ? {
    onClick: onClick,
    type: 'button'
  } : null;
  return __jsx(TagName, Object(esm_extends["a" /* default */])({
    className: classnames_default()(className, thRoot),
    "data-testid": dataTestId
  }, btnProps), __jsx(StripButton_StripButtonSvg, Object(esm_extends["a" /* default */])({
    className: hasBottomOrientation ? '-scale-y-1 rtl:-scale-y-1' : 'rtl:-scale-x-1'
  }, svgProps)), __jsx("span", {
    className: thInner,
    style: {
      height: height
    }
  }, children), __jsx(StripButton_StripButtonSvg, Object(esm_extends["a" /* default */])({
    className: hasBottomOrientation ? '-scale-1 rtl:-scale-1' : '-scale-x-1 rtl:translate-x-0'
  }, svgProps)));
};

/***/ }),

/***/ "ZuH9":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("ep/x");
var isArrayIteratorMethod = __webpack_require__("zcYo");
var toLength = __webpack_require__("DOIJ");
var bind = __webpack_require__("mwRp");
var getIteratorMethod = __webpack_require__("MU85");
var iteratorClose = __webpack_require__("yUod");

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator);
      throw error;
    }
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};


/***/ }),

/***/ "a2Xc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BeTransportDetails; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_className_className_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("wJdf");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UCZK");
/* harmony import */ var _frameworks_notification_Notification__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("VO9w");
/* harmony import */ var _transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("z8xc");
/* harmony import */ var _inner_transport_details_InnerTransportDetails__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("UhMs");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;







var moduleName = 'TransportDetails';
var INBOUND = 'INBOUND'; // departure

var OUTBOUND = 'OUTBOUND'; // arrival

function BeTransportDetails(_ref) {
  var button = _ref.button,
      price = _ref.price,
      i18n = _ref.i18n,
      isComparator = _ref.isComparator,
      isSearchPage = _ref.isSearchPage,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? 'column' : _ref$layout,
      noBusinessClassAvailable = _ref.noBusinessClassAvailable,
      inBoundFlight = _ref.inBoundFlight,
      outBoundFlight = _ref.outBoundFlight,
      isSelectedRecommended = _ref.isSelectedRecommended;
  var computeClass = Object(_utils_className_className_util__WEBPACK_IMPORTED_MODULE_2__[/* getClassModuler */ "a"])(moduleName);
  var hasSchedules = Object(_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_5__[/* tripsHaveSchedules */ "q"])(inBoundFlight, outBoundFlight);
  var isPlaneTicket = Object(_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_5__[/* isTransportPlaneTicket */ "o"])(inBoundFlight, outBoundFlight);
  var transportIcon = Object(_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_5__[/* getTransportIcon */ "l"])(inBoundFlight, outBoundFlight);

  if (!inBoundFlight && !outBoundFlight) {
    return __jsx(_frameworks_notification_Notification__WEBPACK_IMPORTED_MODULE_4__[/* Notification */ "a"], {
      hasBorder: true,
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].DANGER,
      text: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "g"])('common.transport.errors.displayErrorDescription')
    });
  }

  return __jsx("div", {
    className: Object(_utils_className_className_util__WEBPACK_IMPORTED_MODULE_2__[/* getClassWithModifiers */ "b"])(moduleName, [layout]),
    "data-testid": moduleName
  }, !hasSchedules ? __jsx(_frameworks_notification_Notification__WEBPACK_IMPORTED_MODULE_4__[/* Notification */ "a"], {
    className: "my-px20",
    hasBorder: true,
    iconWidth: "1.55rem",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].AMBER,
    title: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "g"])('common.transport.warnings.reassuranceTitle'),
    text: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "g"])('common.transport.warnings.reassuranceMessageNoInformation')
  }) : null, __jsx("div", {
    className: computeClass('flights')
  }, inBoundFlight && __jsx(_inner_transport_details_InnerTransportDetails__WEBPACK_IMPORTED_MODULE_6__[/* InnerTransportDetails */ "a"], {
    button: button,
    flight: inBoundFlight,
    i18n: i18n,
    isComparator: isComparator,
    isPlaneTicket: isPlaneTicket,
    isSearchPage: isSearchPage,
    moduleName: moduleName,
    transportIcon: transportIcon,
    way: INBOUND,
    tabIndex: -1,
    noBusinessClassAvailable: noBusinessClassAvailable,
    isSelectedRecommended: isSelectedRecommended,
    price: price
  }), !isComparator && !isSearchPage && __jsx("div", {
    className: "hidden md:flex h-72",
    style: {
      width: '2%'
    }
  }, __jsx("div", {
    className: "h-2 w-full self-center border-t-1 border-b-1 border-indigo-600"
  })), outBoundFlight && __jsx(_inner_transport_details_InnerTransportDetails__WEBPACK_IMPORTED_MODULE_6__[/* InnerTransportDetails */ "a"], {
    button: button,
    flight: outBoundFlight,
    i18n: i18n,
    isComparator: isComparator,
    isPlaneTicket: isPlaneTicket,
    isSearchPage: isSearchPage,
    moduleName: moduleName,
    transportIcon: transportIcon,
    way: OUTBOUND,
    tabIndex: 0,
    noBusinessClassAvailable: noBusinessClassAvailable,
    isSelectedRecommended: isSelectedRecommended,
    price: price
  })));
}

/***/ }),

/***/ "a4SZ":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var isObject = __webpack_require__("1YFU");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "aGPO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Paginate_Paginate; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// CONCATENATED MODULE: ./src/hooks/use-paginate/usePaginate.js

var usePaginate_usePaginate = function usePaginate(_ref) {
  var _ref$iterationNumber = _ref.iterationNumber,
      iterationNumber = _ref$iterationNumber === void 0 ? 5 : _ref$iterationNumber,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$forceInitialShow = _ref.forceInitialShowingItemsNumber,
      forceInitialShowingItemsNumber = _ref$forceInitialShow === void 0 ? 0 : _ref$forceInitialShow;
  var totalOfItems = items.length;

  var _useReducer = Object(react["useReducer"])(function (state) {
    var newNumberOfItemsToShow = state + iterationNumber;
    return newNumberOfItemsToShow > totalOfItems ? totalOfItems : newNumberOfItemsToShow;
  }, iterationNumber),
      showThisNumberOfItems = _useReducer[0],
      setShowThisNumberOfItems = _useReducer[1];

  var forcedOrNotShowingItemNumber = forceInitialShowingItemsNumber || showThisNumberOfItems;
  var itemsToShow = items.slice(0, forcedOrNotShowingItemNumber);
  var itemsShowing = forcedOrNotShowingItemNumber < totalOfItems ? forcedOrNotShowingItemNumber : totalOfItems;
  return {
    paginatedItems: itemsToShow,
    totalOfItems: totalOfItems,
    itemsShowing: itemsShowing,
    seeMoreAction: setShowThisNumberOfItems,
    shouldShowSeeMore: totalOfItems > itemsToShow.length
  };
};
// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// CONCATENATED MODULE: ./src/client/components/widgets/paginate/Paginate.jsx
var __jsx = react_default.a.createElement;





var Paginate_Paginate = function Paginate(_ref) {
  var children = _ref.children,
      iterationNumber = _ref.iterationNumber,
      forceInitialShowingItemsNumber = _ref.forceInitialShowingItemsNumber,
      seeMoreLabel = _ref.seeMoreLabel,
      setForceInitialShowingItemsNumber = _ref.setForceInitialShowingItemsNumber;

  var _usePaginate = usePaginate_usePaginate({
    items: children,
    iterationNumber: iterationNumber,
    forceInitialShowingItemsNumber: forceInitialShowingItemsNumber
  }),
      paginatedItems = _usePaginate.paginatedItems,
      itemsShowing = _usePaginate.itemsShowing,
      totalOfItems = _usePaginate.totalOfItems,
      seeMoreAction = _usePaginate.seeMoreAction,
      shouldShowSeeMore = _usePaginate.shouldShowSeeMore;

  var onClickHandler = function onClickHandler() {
    seeMoreAction();
    setForceInitialShowingItemsNumber && setForceInitialShowingItemsNumber(forceInitialShowingItemsNumber + iterationNumber);
  };

  return __jsx(react["Fragment"], null, paginatedItems, shouldShowSeeMore && __jsx("div", {
    className: "mt-px20 text-center",
    "data-testid": "paginated-seeMoreBlock"
  }, __jsx("p", {
    className: "mb-px10 reset-paragraph text-base text-blue"
  }, Object(i18n["g" /* t */])('booking.accommodation.moreRooms.numberOfProposalsSeen', {
    number: itemsShowing,
    totalProposalsNumber: totalOfItems
  })), __jsx("div", {
    className: "mb-px20 mx-auto",
    style: {
      width: '180px',
      height: '2px',
      background: 'rgba(0,85,137,0.1)'
    }
  }, __jsx("div", {
    className: "bg-blue transition-width",
    style: {
      width: itemsShowing / totalOfItems * 100 + '%',
      height: '2px'
    }
  })), __jsx(Button["a" /* Button */], {
    color: colors["a" /* COLORS */].BLUE,
    colorBg: colors["a" /* COLORS */].WHITE,
    colorBorder: colors["a" /* COLORS */].BLUE,
    onClick: onClickHandler
  }, seeMoreLabel)));
};

/***/ }),

/***/ "aMaj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCallbackURIFromProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isIframePayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getIframeCallbackUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCancelCallbackURI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return shouldApprovePayment; });
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _routes_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("dNxv");
/* harmony import */ var _uri_uriUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("nv//");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("hi3+");





var DEFAULT_CALLBACK_PATH = '/pr';
var DEFAULT_CANCEL_CALLBACK_PATH = "".concat(DEFAULT_CALLBACK_PATH, "/cancel");
var POLLING_CALLBACK_PATH = '/payment-notification';
var POLLING_PROVIDERS = [_constants__WEBPACK_IMPORTED_MODULE_4__[/* PAYMENT_ID_WECHAT */ "i"]];
var SHORTENED_LOCALE_QUERY_PARAM = 'l';

function getCallbackURIFromProvider(providerId, appContext, location) {
  var callbackPath = POLLING_PROVIDERS.indexOf(providerId) !== -1 ? POLLING_CALLBACK_PATH : DEFAULT_CALLBACK_PATH;
  return Object(_uri_uriUtils__WEBPACK_IMPORTED_MODULE_3__[/* convertLocationToURI */ "c"])(location).path(callbackPath).query('').setQuery(location.queryParams.hasOwnProperty(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["appQueryParameters"].legacy.be) ? _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["appQueryParameters"].legacy.be : null).setQuery(SHORTENED_LOCALE_QUERY_PARAM, appContext.locale).setQuery('isCmta', appContext.isCmta ? 'true' : 'false').toString();
}

function getCancelCallbackURI(appContext, location) {
  return Object(_uri_uriUtils__WEBPACK_IMPORTED_MODULE_3__[/* convertLocationToURI */ "c"])(location).path(DEFAULT_CANCEL_CALLBACK_PATH).query('').setQuery(SHORTENED_LOCALE_QUERY_PARAM, appContext.locale).toString();
}

function shouldApprovePayment(providerId) {
  return !!_config__WEBPACK_IMPORTED_MODULE_1___default.a.get("psp.".concat(providerId.toLowerCase(), ".approve"));
}

function isIframePayment(providerId) {
  return !!_config__WEBPACK_IMPORTED_MODULE_1___default.a.get("psp.".concat(providerId.toLowerCase(), ".iframe"));
}

function getIframeCallbackUrl(location) {
  return Object(_uri_uriUtils__WEBPACK_IMPORTED_MODULE_3__[/* convertLocationToURI */ "c"])(location).path(_routes_constants__WEBPACK_IMPORTED_MODULE_2__[/* IFRAME_CALLBACK_URL */ "i"]).query('').toString();
}



/***/ }),

/***/ "aMgh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCodeFromStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStatusFromCode; });
var values = {
  OPTION: 'o',
  VALIDATED: 'v',
  PACKAGE_UPGRADE: 'p',
  ADDITIONAL_SERVICE: 'a',
  PICK_YOUR_ROOM: 'y',
  UNKNOWN: 'u',
  CART: 'c'
};
var reverseValues = Object.keys(values).reduce(function (acc, key) {
  acc[values[key]] = key;
  return acc;
}, {});
function getCodeFromStatus(status) {
  return values[status] || values.UNKNOWN;
}
function getStatusFromCode(code) {
  return reverseValues[code] || null;
}

/***/ }),

/***/ "bFjY":
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__("Q4oW"),
    isArrayLike = __webpack_require__("9y2L");

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ "bMl7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("HnW7");
var redefineAll = __webpack_require__("Bg8+");
var InternalMetadataModule = __webpack_require__("wKkN");
var collection = __webpack_require__("IYAN");
var collectionWeak = __webpack_require__("LFxm");
var isObject = __webpack_require__("1YFU");
var enforceIternalState = __webpack_require__("9jKB").enforce;
var NATIVE_WEAK_MAP = __webpack_require__("Uqkn");

var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible = Object.isExtensible;
var InternalWeakMap;

var wrapper = function (init) {
  return function WeakMap() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
};

// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $WeakMap = module.exports = collection('WeakMap', wrapper, collectionWeak);

// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
  InternalMetadataModule.REQUIRED = true;
  var WeakMapPrototype = $WeakMap.prototype;
  var nativeDelete = WeakMapPrototype['delete'];
  var nativeHas = WeakMapPrototype.has;
  var nativeGet = WeakMapPrototype.get;
  var nativeSet = WeakMapPrototype.set;
  redefineAll(WeakMapPrototype, {
    'delete': function (key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeDelete.call(this, key) || state.frozen['delete'](key);
      } return nativeDelete.call(this, key);
    },
    has: function has(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas.call(this, key) || state.frozen.has(key);
      } return nativeHas.call(this, key);
    },
    get: function get(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas.call(this, key) ? nativeGet.call(this, key) : state.frozen.get(key);
      } return nativeGet.call(this, key);
    },
    set: function set(key, value) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        nativeHas.call(this, key) ? nativeSet.call(this, key, value) : state.frozen.set(key, value);
      } else nativeSet.call(this, key, value);
      return this;
    }
  });
}


/***/ }),

/***/ "bbLz":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/booking",
      function () {
        return __webpack_require__("xfxu");
      }
    ]);
  

/***/ }),

/***/ "bmBr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FilterOption_FilterOption; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/check-button/CheckButton.themes.js



var CheckButton_themes_themes = function themes(_ref) {
  var _classnames2;

  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].SUCCESS : _ref$color,
      isChecked = _ref.isChecked,
      isDisabled = _ref.isDisabled;
  return {
    "default": {
      thRoot: classnames_default()('border-1 border-solid flex flex-col font-bold items-center justify-center p-px10 relative reset-button rounded-tiny text-base transition-colors', Object(defineProperty["a" /* default */])({
        'bg-white': !isDisabled,
        'border-gray-medium bg-gray-lighter cursor-not-allowed': isDisabled,
        'border-gray-light': !isChecked
      }, "border-".concat(color), isChecked && !isDisabled)),
      thIcon: classnames_default()('absolute m-px5 top-0 rtl:right-0', (_classnames2 = {}, Object(defineProperty["a" /* default */])(_classnames2, "text-".concat(color), !isDisabled), Object(defineProperty["a" /* default */])(_classnames2, 'text-gray-medium', isDisabled), _classnames2)),
      thIconWidth: '0.625rem'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/check-button/CheckButton.jsx
var __jsx = react_default.a.createElement;





var CheckButton_CheckButton = function CheckButton(_ref) {
  var children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      isChecked = _ref.isChecked,
      isDisabled = _ref.isDisabled,
      onClick = _ref.onClick,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var _themes$theme = CheckButton_themes_themes({
    color: color,
    isChecked: isChecked,
    isDisabled: isDisabled
  })[theme],
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thRoot = _themes$theme.thRoot;
  return __jsx("button", {
    "aria-checked": isChecked,
    "aria-disabled": isDisabled,
    className: classnames_default()(className, thRoot),
    onClick: !isDisabled && onClick,
    role: "checkbox",
    type: "button"
  }, isChecked && __jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: icons["a" /* ICONS */].CHECK,
    width: thIconWidth
  }), children);
};
// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.jsx + 1 modules
var InputSwitch = __webpack_require__("YjXp");

// CONCATENATED MODULE: ./src/client/components/widgets/filter-option/FilterOption.jsx
var FilterOption_jsx = react_default.a.createElement;




var FilterOption_FilterOption = function FilterOption(_ref) {
  var className = _ref.className,
      iconName = _ref.iconName,
      iconSize = _ref.iconSize,
      id = _ref.id,
      imageSrc = _ref.imageSrc,
      isButton = _ref.isButton,
      isDisabled = _ref.isDisabled,
      isIconNotSquare = _ref.isIconNotSquare,
      isSelected = _ref.isSelected,
      label = _ref.label,
      matched = _ref.matched,
      name = _ref.name,
      _onChange = _ref.onChange,
      subLabel = _ref.subLabel,
      value = _ref.value;
  return isButton ? FilterOption_jsx(CheckButton_CheckButton, {
    className: className,
    isChecked: isSelected,
    isDisabled: isDisabled,
    onClick: function onClick() {
      return _onChange(value);
    }
  }, iconName && FilterOption_jsx(Icon["a" /* Icon */], {
    className: "mb-px5",
    hasRtl: true,
    isNotSquare: isIconNotSquare,
    name: iconName,
    width: iconSize || '1.5rem'
  }), imageSrc && FilterOption_jsx("img", {
    alt: "",
    className: "mb-px5 w-4/5",
    src: imageSrc,
    style: {
      maxWidth: '6.25rem'
    }
  }), label, subLabel && FilterOption_jsx("span", {
    className: "text-gray-dark text-sm"
  }, subLabel), FilterOption_jsx("span", {
    className: "text-gray-darker text-sm"
  }, "(", matched, ")")) : FilterOption_jsx(InputSwitch["a" /* InputSwitch */], {
    className: className,
    id: id,
    isChecked: isSelected,
    isDisabled: isDisabled,
    label: FilterOption_jsx(react["Fragment"], null, iconName && FilterOption_jsx(Icon["a" /* Icon */], {
      className: "rtl:mr-px5 text-blue",
      name: iconName,
      width: "1.5rem"
    }), label, "\xA0", subLabel && FilterOption_jsx("span", {
      className: "text-gray-dark text-sm"
    }, subLabel), "\xA0", FilterOption_jsx("span", {
      className: "text-gray-dark text-sm"
    }, "(", matched, ")")),
    name: name,
    onChange: function onChange() {
      return _onChange(value);
    },
    value: value
  });
};

/***/ }),

/***/ "bn3Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlternativePackageToolTip; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _frameworks_image_Image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("0IQ5");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("qqKu");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;



var AlternativePackageToolTip = function AlternativePackageToolTip(_ref) {
  var bundle = _ref.bundle;
  return __jsx("div", {
    className: "RoomOnlyUpsell-popinColumn"
  }, __jsx(_frameworks_image_Image__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"], {
    imageUrl: bundle.image,
    ratioKey: "L"
  }), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_2__[/* Text */ "a"], {
    className: "p-px10",
    text: bundle.description
  }));
};

/***/ }),

/***/ "bvtl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ResortBlockHeader_ResortBlockHeader; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/router/useRouter.js
var useRouter = __webpack_require__("7jla");

// EXTERNAL MODULE: ./src/client/components/frameworks/badge/Badge.jsx + 1 modules
var Badge = __webpack_require__("VHif");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/className/className.util.js
var className_util = __webpack_require__("wJdf");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/product/product.utils.js
var product_utils = __webpack_require__("C9cF");

// EXTERNAL MODULE: ./src/client/components/widgets/exclusive-collection-badge/ECBadge.jsx
var ECBadge = __webpack_require__("Itgl");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/utils/uri/constants.js
var constants = __webpack_require__("Sj1w");

// CONCATENATED MODULE: ./src/client/components/widgets/resort-block-header/ResortBlockHeader.themes.js
var themes = {
  light: {
    thRoot: 'bg-white border-1 border-solid border-gray-light md:flex md:items-center relative text-gray-darker',
    thLink: 'flex md:flex-1 items-center no-underline p-px10 text-base text-md text-gray-darker',
    thBadges: 'flex leading-none -mx-px5',
    thNames: 'md:flex md:items-center rtl:ml-px10 overflow-hidden',
    thIconHeight: 56,
    thName: 'font-brand text-lg md:text-2xl truncate',
    thCountry: 'md:decorator-dash font-bold md:rtl:ml-px10 text-base md:text-md truncate uppercase',
    thArrow: 'hidden md:block rtl:ml-px15',
    thChildren: 'border-t-1 md:border-t-0 p-px10'
  },
  headerLite: {
    thRoot: 'flex',
    thLink: 'flex md:flex-1 items-center no-underline text-base text-md text-gray-darker',
    thBadges: 'flex flex-none leading-none -mx-px5',
    thNames: 'flex-none rtl:ml-px10 overflow-hidden',
    thIconHeight: 34,
    thName: 'font-brand leading-tight text-base truncate',
    thCountry: 'leading-tight text-xs truncate uppercase',
    thArrow: 'hidden'
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/resort-block-header/ResortBlockHeader.jsx


var __jsx = react_default.a.createElement;















var PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES;

function getQueryParamValue(name, location) {
  return location === null || location === void 0 ? void 0 : location.queryParams[name];
}

function buildUrl(appContext, locale, resort, location) {
  if (!(resort === null || resort === void 0 ? void 0 : resort.href)) {
    return undefined;
  }

  var url = new URI_default.a(resort.href);

  if (appContext.availableLocales && Object.keys(appContext.availableLocales).length > 1 && locale) {
    // we only keep locale in url if we have at least two availables locales
    url.addQuery({
      locale: locale
    });
  }

  var departureDateQueryParam = getQueryParamValue(constants["f" /* QUERY_DEPARTURE_DATE */], location);

  if (departureDateQueryParam) {
    url.addQuery(Object(defineProperty["a" /* default */])({}, constants["f" /* QUERY_DEPARTURE_DATE */], departureDateQueryParam));
  }

  var departureDurationQueryParam = getQueryParamValue(constants["g" /* QUERY_DURATION */], location);

  if (departureDurationQueryParam) {
    url.addQuery(Object(defineProperty["a" /* default */])({}, constants["g" /* QUERY_DURATION */], departureDurationQueryParam));
  }

  var departureCityQueryParam = getQueryParamValue(constants["k" /* QUERY_TRANSPORT */], location);

  if (departureCityQueryParam) {
    url.addQuery(Object(defineProperty["a" /* default */])({}, constants["k" /* QUERY_TRANSPORT */], departureCityQueryParam));
  }

  return url.toString() ? dist["url"].normalizeUrl(url.toString()) : undefined;
}

var ResortBlockHeader_ResortBlockHeader = function ResortBlockHeader(_ref) {
  var _resort$destination;

  var children = _ref.children,
      _ref$dataSelector = _ref.dataSelector,
      dataSelector = _ref$dataSelector === void 0 ? 'ResortBlockHeader' : _ref$dataSelector,
      destinationsLabel = _ref.destinationsLabel,
      hasBackIcon = _ref.hasBackIcon,
      locale = _ref.locale,
      onClick = _ref.onClick,
      queryParamsToIgnore = _ref.queryParamsToIgnore,
      resort = _ref.resort,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'light' : _ref$theme;
  var hasChildrenClass = children ? 'hasChildren' : '';
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var destinations = destinationsLabel && resort.departureCity && resort.arrivalCity && Object(dist["messageFormat"])(destinationsLabel).format({
    departureCity: resort.departureCity,
    arrivalCity: resort.arrivalCity
  });
  var badgeIcon = Object(product_utils["d" /* getProductBadgeIcon */])(resort);
  var _themes$theme = themes[theme],
      thArrow = _themes$theme.thArrow,
      thBadges = _themes$theme.thBadges,
      thChildren = _themes$theme.thChildren,
      thCountry = _themes$theme.thCountry,
      thIconHeight = _themes$theme.thIconHeight,
      thLink = _themes$theme.thLink,
      thName = _themes$theme.thName,
      thNames = _themes$theme.thNames,
      thRoot = _themes$theme.thRoot;
  return __jsx("div", {
    className: classnames_default()(Object(className_util["b" /* getClassWithModifiers */])('ResortBlockHeader', [theme, hasChildrenClass]), thRoot)
  }, __jsx(DynamicLink["a" /* default */], {
    className: thLink,
    "data-selector": dataSelector,
    onClick: onClick,
    queryParamsToIgnore: queryParamsToIgnore,
    url: buildUrl(appContext, locale, resort, location)
  }, hasBackIcon && __jsx("div", {
    className: "leading-none rtl:-ml-px10 rtl:mr-px10 text-sm"
  }, __jsx(Icon["a" /* Icon */], {
    hasRtl: true,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH_LEFT,
    width: "1em"
  })), __jsx("div", {
    className: thBadges
  }, __jsx(Badge["a" /* Badge */], Object(esm_extends["a" /* default */])({}, badgeIcon, {
    className: "mx-px5",
    size: thIconHeight
  })), resort.isExplicitEC && (badgeIcon === null || badgeIcon === void 0 ? void 0 : badgeIcon.iconName) && __jsx("span", {
    className: "font-brand leading-none text-base self-center"
  }, "&"), resort.isExplicitEC && __jsx(ECBadge["a" /* ECBadge */], {
    className: "flex-none mx-px5",
    height: thIconHeight
  })), __jsx("div", {
    className: thNames
  }, __jsx("div", {
    className: thName,
    "data-testid": "ResortBlockHeader-resort"
  }, resort.type === PRODUCT_TYPES.CRUISE && !destinations ? resort.title : resort === null || resort === void 0 ? void 0 : resort.name), __jsx("div", {
    className: thCountry,
    "data-testid": "ResortBlockHeader-country"
  }, resort.type === PRODUCT_TYPES.CRUISE ? destinations || resort.name : resort === null || resort === void 0 ? void 0 : (_resort$destination = resort.destination) === null || _resort$destination === void 0 ? void 0 : _resort$destination.country)), (resort === null || resort === void 0 ? void 0 : resort.href) && __jsx(Icon["a" /* Icon */], {
    className: thArrow,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    width: "0.5rem"
  })), children && __jsx("div", {
    className: thChildren
  }, children));
};

/***/ }),

/***/ "bz5b":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__("9y2L");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ "c7Qd":
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__("DuXo"),
    baseIsNaN = __webpack_require__("z9Jh"),
    strictIndexOf = __webpack_require__("n1QJ");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ "cGFA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getValidationStateFromKid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getValidationStateFromKids; });
/* unused harmony export updateValidationStateForKid */
/* unused harmony export addOrRemoveKidFromValidationState */
/* unused harmony export addOrRemoveKidFromKidsList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasKidWithoutAValidBirthdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasOnlyValidKids; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return invalidateNotValidatedKids; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wQ38");
/* harmony import */ var _facetingUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("kNiU");
/* harmony import */ var _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("45yR");




var getValidationStateFromKid = function getValidationStateFromKid(kid, isKidBirthdateRequired) {
  if (typeof kid !== 'object') {
    return _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_INVALID */ "a"];
  }

  if (!kid.birthdate) {
    return isKidBirthdateRequired ? _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_INVALID */ "a"] : _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* NOT_VALIDATED */ "c"];
  }

  return typeof kid === 'object' && Object(_facetingUtils__WEBPACK_IMPORTED_MODULE_2__[/* isKidMinor */ "g"])(kid.birthdate) ? _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_VALID */ "b"] : _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_INVALID */ "a"];
};
var getValidationStateFromKids = function getValidationStateFromKids() {
  var kids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return kids.map(function (kid) {
    return getValidationStateFromKid(kid);
  });
};
var updateValidationStateForKid = function updateValidationStateForKid(_ref) {
  var index = _ref.index,
      kid = _ref.kid,
      _ref$kidsValidationSt = _ref.kidsValidationState,
      kidsValidationState = _ref$kidsValidationSt === void 0 ? [] : _ref$kidsValidationSt;
  var validationState = getValidationStateFromKid(kid);
  return kidsValidationState.map(function (kidValidation, indexKid) {
    var isNewKid = kidValidation === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* NOT_VALIDATED */ "c"];
    var kidNeedsValidation = !!kid.birthdate || !isNewKid;
    return indexKid === index && kidNeedsValidation ? validationState : kidValidation;
  });
};
var addOrRemoveKidFromValidationState = function addOrRemoveKidFromValidationState(_ref2) {
  var _ref2$currentState = _ref2.currentState,
      currentState = _ref2$currentState === void 0 ? [] : _ref2$currentState,
      kidsNumber = _ref2.kidsNumber;

  if (kidsNumber > currentState.length) {
    return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(currentState), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(Array(kidsNumber - currentState.length).fill(_client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_1__[/* VALIDATION_STATE_ENUM */ "f"].notvalidated)));
  }

  if (kidsNumber < currentState.length) {
    return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(currentState.slice(0, kidsNumber));
  }

  return currentState;
};
var addOrRemoveKidFromKidsList = function addOrRemoveKidFromKidsList(args) {
  var _args$kids = args.kids,
      kids = _args$kids === void 0 ? [] : _args$kids,
      kidsNumber = args.kidsNumber;

  if (kidsNumber > kids.length) {
    return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(kids).concat(Array(kidsNumber - kids.length).fill().map(function () {
      return _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_1__[/* DEFAULT_KID_VALUE */ "a"];
    }));
  }

  if (kidsNumber < kids.length) {
    return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(kids.slice(0, kidsNumber));
  }

  return kids;
};
var hasKidWithoutAValidBirthdate = function hasKidWithoutAValidBirthdate(kidsValidationState) {
  return Boolean(kidsValidationState && kidsValidationState.find(function (kid) {
    return kid === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_INVALID */ "a"];
  }));
};
var hasOnlyValidKids = function hasOnlyValidKids(kidsValidationState) {
  return kidsValidationState.every(function (kid) {
    return kid === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_VALID */ "b"];
  });
};
var invalidateNotValidatedKids = function invalidateNotValidatedKids(kidsValidationState) {
  return kidsValidationState.reduce(function (acc, current) {
    if (current === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* NOT_VALIDATED */ "c"]) {
      return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(acc), [_client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_INVALID */ "a"]]);
    }

    return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(acc), [current]);
  }, []);
};

/***/ }),

/***/ "cHMM":
/***/ (function(module, exports, __webpack_require__) {

var decodeMap = __webpack_require__("tRRp");

module.exports = decodeCodePoint;

// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
function decodeCodePoint(codePoint){

	if((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF){
		return "\uFFFD";
	}

	if(codePoint in decodeMap){
		codePoint = decodeMap[codePoint];
	}

	var output = "";

	if(codePoint > 0xFFFF){
		codePoint -= 0x10000;
		output += String.fromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
		codePoint = 0xDC00 | codePoint & 0x3FF;
	}

	output += String.fromCharCode(codePoint);
	return output;
}


/***/ }),

/***/ "cb6o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAccommodationProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return aggregateIconList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBabyBedIconItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCapacityIconItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getSurfaceIconItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getOutsideFacilitiesIconItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getViewIconItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getNbBabies; });
/* unused harmony export hasLowStock */
/* unused harmony export getAccommodationCategoryComfortIndex */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getBestAccommodation; });
/* unused harmony export getBestAccommodationCategory */
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("h/fj");
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("oL6k");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("lZ21");
/* harmony import */ var _utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("aWOT");









var ATTENDEE_CATEGORIES = {
  BABY: 'BABY',
  CHILD: 'CHILD',
  ADULT: 'ADULT'
};
var ICONS_ROOM_TYPE = {
  CONNECTING_ROOMS: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].CONNECTING_ROOMS,
  SEPARATE_ROOMS_3: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].SEPARATE_ROOMS_3,
  SEPARATE_ROOMS: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].SEPARATE_ROOMS,
  SINGLE_ROOM: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].SINGLE_ROOM
};

function getCapacityIconItem(capacity) {
  var label = Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "g"])('booking.accommodation.packageContent.numberPeople');

  if (!capacity || !label) {
    return null;
  }

  return {
    icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].PEOPLE,
    labels: [Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "g"])('booking.accommodation.packageContent.capacityOfPeople'), Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["messageFormat"])(label).format({
      count: capacity
    })]
  };
}

function getSurfaceIconItem(roomType, resort, surface) {
  return {
    icon: ICONS_ROOM_TYPE[roomType] || null,
    labels: [Object(_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_8__[/* tAlt */ "b"])({
      resortKeyPath: "booking.accommodation.packageContent.configuration.".concat(_utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_7__[/* CORRESPONDANCE_ROOM_TYPE */ "c"][roomType]),
      cruiseKeyPath: "booking.accommodation.packageContent.configuration.".concat(_utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_7__[/* CORRESPONDENCE_CABIN_TYPE */ "d"][roomType]),
      resort: resort
    }), surface || roomType && ' ' || '']
  };
}

function getNbBabies(occupancies) {
  if (!occupancies) return 0;
  return occupancies.reduce(function () {
    var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var occupancy = arguments.length > 1 ? arguments[1] : undefined;
    return acc + occupancy.baby_count;
  }, 0);
}

function getBabyBedIconItem(babyCount) {
  if (babyCount <= 0) return null;
  var label = babyCount > 1 ? Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "g"])('booking.accommodation.packageContent.babyBedincludedPlural') : Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "g"])('booking.accommodation.packageContent.babyBedincluded');
  return {
    icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].baby_bed,
    labels: [label]
  };
}

function getOutsideFacilitiesIconItem(outsideFacilities) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(outsideFacilities, '[0].label') ? {
    icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"][Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(outsideFacilities[0], 'id')] || _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].TRIDENT1,
    labels: [outsideFacilities[0].label]
  } : null;
}

function getViewIconItem(view) {
  return view ? {
    icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"][Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(view, 'id')] || _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].TRIDENT1,
    labels: [view.label]
  } : null;
}

function aggregateIconList(strengths, surface, capacity, outsideFacility, view, babyBed) {
  // add a "strengths slot" for each missing item
  var maxStrengths = 3 - [view, capacity, babyBed, outsideFacility].filter(function (item) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(item, 'labels.0');
  }).length;
  var strengthsItems = (strengths || []).slice(0, Math.max(maxStrengths, 0)).map(function (strength) {
    return {
      icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"][Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(strength, 'id')] || _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].TRIDENT1,
      labels: [Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(strength, 'label') || '']
    };
  });
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["compact"])([surface, capacity, outsideFacility, babyBed].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(strengthsItems), [view])).filter(function (_ref) {
    var _ref$labels = _ref.labels,
        labels = _ref$labels === void 0 ? [] : _ref$labels;
    return labels.length && labels[0];
  });
}

function hasLowStock(threshold, stock) {
  return stock <= threshold;
}

function getAccommodationCategoryComfortIndex(category) {
  return _utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_7__[/* ACCOMMODATION_COMFORT_ORDER */ "a"].indexOf(category.id);
}

function getBestAccommodationCategory(categories) {
  if (categories.length === 1) {
    return categories[0];
  }

  return Object(lodash_fp__WEBPACK_IMPORTED_MODULE_2__["flow"])(Object(lodash_fp__WEBPACK_IMPORTED_MODULE_2__["sortBy"])(getAccommodationCategoryComfortIndex), lodash_fp__WEBPACK_IMPORTED_MODULE_2__["last"])(categories);
}

function getBestAccommodation(accommodations) {
  return Object(lodash_fp__WEBPACK_IMPORTED_MODULE_2__["flow"])(Object(lodash_fp__WEBPACK_IMPORTED_MODULE_2__["sortBy"])(function (_ref2) {
    var categoryId = _ref2.categoryId;
    return _utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_7__[/* ACCOMMODATION_COMFORT_ORDER */ "a"].indexOf(categoryId);
  }), lodash_fp__WEBPACK_IMPORTED_MODULE_2__["last"] // $FlowFixMe issue with lodash typings
  )(accommodations);
}

var getAccommodationRoomsProps = function getAccommodationRoomsProps(_ref3) {
  var _ref3$accommodations = _ref3.accommodations,
      accommodations = _ref3$accommodations === void 0 ? [] : _ref3$accommodations,
      accommodationsCount = _ref3.accommodationsCount,
      proposal = _ref3.proposal,
      remainingStock = _ref3.remainingStock,
      resort = _ref3.resort,
      attendeesWithDistributionData = _ref3.attendeesWithDistributionData;

  var sortedAccommodations = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(accommodations).sort(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_4__[/* compareAccommodationsByComfort */ "b"]);

  var sortedAttendees = {
    adults: attendeesWithDistributionData.filter(function (_ref4) {
      var type = _ref4.type;
      return type === ATTENDEE_CATEGORIES.ADULT;
    }),
    babies: attendeesWithDistributionData.filter(function (_ref5) {
      var type = _ref5.type;
      return type === ATTENDEE_CATEGORIES.BABY;
    }),
    children: attendeesWithDistributionData.filter(function (_ref6) {
      var type = _ref6.type;
      return type === ATTENDEE_CATEGORIES.CHILD;
    })
  };
  return sortedAccommodations.map(function (a) {
    var _a$attendeesDistribut, _proposal$attendees, _proposal$attendees$a, _proposal$attendees2, _proposal$attendees2$, _a$media, _proposal$attendees3, _proposal$attendees3$;

    var attendeesIds = (((_a$attendeesDistribut = a.attendeesDistribution) === null || _a$attendeesDistribut === void 0 ? void 0 : _a$attendeesDistribut.attendees) || []).map(function (at) {
      return at.id;
    });
    return {
      bathroomEquipments: a.bathroomEquipments,
      description: a.description,
      distribution: (sortedAccommodations.length > 1 || a.quantity > 1) && !!attendeesIds.length ? {
        adults: sortedAttendees.adults.filter(function (at) {
          return attendeesIds.includes(at.id);
        }),
        babies: sortedAttendees.babies.filter(function (at) {
          return attendeesIds.includes(at.id);
        }),
        children: sortedAttendees.children.filter(function (at) {
          return attendeesIds.includes(at.id);
        })
      } : null,
      equipments: a.equipments,
      hasArrangement: accommodations.length !== (accommodationsCount ? accommodationsCount : proposal.accommodationsCount),
      hasDistribution: sortedAccommodations.length > 1 && !!attendeesIds.length,
      hasSharedRoom: (((_proposal$attendees = proposal.attendees) === null || _proposal$attendees === void 0 ? void 0 : (_proposal$attendees$a = _proposal$attendees.adults) === null || _proposal$attendees$a === void 0 ? void 0 : _proposal$attendees$a.length) || 0) + (((_proposal$attendees2 = proposal.attendees) === null || _proposal$attendees2 === void 0 ? void 0 : (_proposal$attendees2$ = _proposal$attendees2.children) === null || _proposal$attendees2$ === void 0 ? void 0 : _proposal$attendees2$.length) || 0) === 1 && resort.id === 'KEMC',
      id: a.id,
      images: (((_a$media = a.media) === null || _a$media === void 0 ? void 0 : _a$media.photos) || []).map(function (m) {
        return {
          src: m.url
        };
      }),
      name: a.label,
      infosList: aggregateIconList(a.strengths, getSurfaceIconItem(a.roomType, resort, a.surface), // $FlowFixMe
      getOutsideFacilitiesIconItem(a.outsideFacilities), getViewIconItem(a.view), getBabyBedIconItem(getNbBabies(a.occupancies))),
      isBestFamilyDeal: (a.familyRoom || a.connectingRoom) && ((_proposal$attendees3 = proposal.attendees) === null || _proposal$attendees3 === void 0 ? void 0 : (_proposal$attendees3$ = _proposal$attendees3.children) === null || _proposal$attendees3$ === void 0 ? void 0 : _proposal$attendees3$.length) > 0,
      isCabin: resort.isCruise,
      isPremium: Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_4__[/* isPremiumAccommodation */ "x"])(a),
      outsideFacilities: a.outsideFacilities,
      quantity: a.quantity,
      services: a.services,
      stock: remainingStock ? remainingStock : proposal.remainingStock || 0
    };
  });
};

var getAccommodationProps = function getAccommodationProps(_ref7) {
  var _ref7$accommodations = _ref7.accommodations,
      accommodations = _ref7$accommodations === void 0 ? [] : _ref7$accommodations,
      accommodationsCount = _ref7.accommodationsCount,
      proposal = _ref7.proposal,
      resort = _ref7.resort,
      remainingStock = _ref7.remainingStock,
      attendeesWithDistributionData = _ref7.attendeesWithDistributionData;
  var rooms = getAccommodationRoomsProps({
    accommodations: accommodations,
    accommodationsCount: accommodationsCount,
    attendeesWithDistributionData: attendeesWithDistributionData,
    proposal: proposal,
    remainingStock: remainingStock,
    resort: resort
  });
  return {
    hasFlexRates: proposal.price.hasFlexRates,
    isCabin: resort.isCruise,
    proposal: proposal,
    rooms: rooms,
    stock: remainingStock ? remainingStock : proposal.remainingStock || 0
  };
};


/***/ }),

/***/ "cjjV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EMAIL_PATTERN", function() { return EMAIL_PATTERN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GM_NUMBER_PATTERN", function() { return GM_NUMBER_PATTERN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "email", function() { return email; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "firstName", function() { return firstName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lastName", function() { return lastName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unicodeFirstName", function() { return unicodeFirstName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unicodeLastName", function() { return unicodeLastName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "notContainsUnicode", function() { return notContainsUnicode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "strictName", function() { return strictName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ASCII", function() { return ASCII; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "minLength", function() { return minLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "haveLength", function() { return haveLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maxLength", function() { return maxLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "regexp", function() { return regexp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enum", function() { return enum1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "phoneNumber", function() { return phoneNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mandatory", function() { return mandatory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "date", function() { return date; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "minAge", function() { return minAge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maxAge", function() { return maxAge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gmNumber", function() { return gmNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inRange", function() { return inRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "legalAgreement", function() { return legalAgreement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "optionalBirthdate", function() { return optionalBirthdate; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_regex_RegexHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("9BC+");



var EMAIL_PATTERN = /^(?!.*@.*\.{2})[^\s@]+@[^\s@]+\.[^\s@.]+$/;
var GM_NUMBER_PATTERN = /^[0-9]{0,9}$/;
var UNICODE_CHAR_REGEXP = /[^\u0000-\u00ff]/;

function _regexp(reg) {
  return function (value) {
    return reg.test(value);
  };
}

function _minLength(length) {
  return function (value) {
    return value.length >= length;
  };
}

function _maxLength(length) {
  return function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return value.length <= length;
  };
}

function _haveLength(length) {
  return function (value) {
    return value.length === length;
  };
}

function _enum(values) {
  return function (value) {
    return values.indexOf(value) !== -1;
  };
}

function _mandatory() {
  return function (value) {
    return !!value;
  };
}

function _checkDate(format) {
  return function (dateToCheck) {
    return !!(dateToCheck && format && moment__WEBPACK_IMPORTED_MODULE_1___default()(dateToCheck, format, true).isValid());
  };
}

function _getAge(birthday, birthdayFormat, onDate, onDateFormat) {
  var fromDate = onDate && onDateFormat ? moment__WEBPACK_IMPORTED_MODULE_1___default()(onDate, onDateFormat) : moment__WEBPACK_IMPORTED_MODULE_1___default()();
  return fromDate.diff(moment__WEBPACK_IMPORTED_MODULE_1___default()(birthday, birthdayFormat), 'years', true);
}

function _notContainsUnicode(str) {
  return !UNICODE_CHAR_REGEXP.test(str);
}

function _inRange(min, max) {
  return function (value) {
    return value >= min && value <= max;
  };
}
/* Validators */


var email = {
  name: 'email',
  isValid: _regexp(EMAIL_PATTERN)
};
var firstName = {
  name: 'firstName',
  isValid: function isValid(value) {
    return _maxLength(20)(value) && _notContainsUnicode(value);
  }
};
var lastName = {
  name: 'lastName',
  isValid: function isValid(value) {
    return _maxLength(30)(value) && _notContainsUnicode(value);
  }
};
var notContainsUnicode = {
  name: 'notContainsUnicode',
  isValid: function isValid(value) {
    return _notContainsUnicode(value);
  }
};
var unicodeFirstName = {
  name: 'unicodeFirstName',
  isValid: _maxLength(100)
};
var unicodeLastName = {
  name: 'unicodeLastName',
  isValid: _maxLength(100)
};
var strictName = {
  name: 'strictName',
  isValid: function isValid(value) {
    return _mandatory()(value) && _regexp(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/)(value);
  }
};
var ASCII = {
  name: 'ASCII',
  isValid: _regexp(/^[\x20-\xFF]+$/)
};

function minLength(length) {
  return {
    name: 'minLength',
    isValid: _minLength(length)
  };
}

function haveLength(length) {
  return {
    name: 'haveLength',
    isValid: _haveLength(length)
  };
}

function maxLength(length) {
  return {
    name: 'maxLength',
    isValid: _maxLength(length)
  };
}

function regexp(exp) {
  return {
    name: 'regexp',
    isValid: _regexp(exp)
  };
}

function enum1() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return {
    name: 'enum',
    isValid: _enum(values)
  };
}

function phoneNumber(locale) {
  var phoneRegexp = Object(_utils_regex_RegexHelper__WEBPACK_IMPORTED_MODULE_2__[/* getPhoneRegex */ "b"])(locale);
  return {
    name: 'phoneNumber',
    isValid: _regexp(phoneRegexp)
  };
}

function mandatory() {
  return {
    name: 'mandatory',
    isValid: _mandatory()
  };
}

function date(format) {
  return {
    name: 'date',
    isValid: _checkDate(format)
  };
}

var optionalBirthdate = function optionalBirthdate(_ref) {
  var ageRequired = _ref.ageRequired,
      birthdayFormat = _ref.birthdayFormat,
      onDate = _ref.onDate,
      onDateFormat = _ref.onDateFormat;
  return {
    name: 'optionalBirthdate',
    isValid: function isValid(birthdate) {
      return !birthdate || birthdayFormat && moment__WEBPACK_IMPORTED_MODULE_1___default()(birthdate, birthdayFormat, true).isValid() && Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isNumber"])(ageRequired) && _checkDate(birthdayFormat)(birthdate) && _getAge(birthdate, birthdayFormat, onDate, onDateFormat) >= ageRequired;
    }
  };
};

function minAge(_ref2) {
  var ageRequired = _ref2.ageRequired,
      birthdayFormat = _ref2.birthdayFormat,
      onDate = _ref2.onDate,
      onDateFormat = _ref2.onDateFormat;
  return {
    name: 'minAge',
    isValid: function isValid(birthday) {
      return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isNumber"])(ageRequired) && _checkDate(birthdayFormat)(birthday) && _getAge(birthday, birthdayFormat, onDate, onDateFormat) >= ageRequired;
    }
  };
}

function maxAge() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      ageRequired = _ref3.ageRequired,
      birthdayFormat = _ref3.birthdayFormat,
      onDate = _ref3.onDate,
      onDateFormat = _ref3.onDateFormat;

  return {
    name: 'maxAge',
    isValid: function isValid(birthday) {
      return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isNumber"])(ageRequired) && _checkDate(birthdayFormat)(birthday) && _getAge(birthday, birthdayFormat, onDate, onDateFormat) < ageRequired;
    }
  };
}

function inRange(min, max) {
  return {
    name: 'inRange',
    isValid: _inRange(min, max)
  };
}

var gmNumber = {
  name: 'gmNumber',
  isValid: function isValid(value) {
    return _regexp(GM_NUMBER_PATTERN)(value);
  }
};

function legalAgreement(required) {
  return {
    name: 'legalAgreement',
    // if legalAgreement is not required, return true to bypass validation
    isValid: function isValid(value) {
      return required ? value === true : true;
    }
  };
}



/***/ }),

/***/ "cuVd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ BookingAccommodations_BookingAccommodations; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/components/widgets/accommodations/attendees-distribution/AttendeesDistributionUtils.js
var AttendeesDistributionUtils = __webpack_require__("Y6/E");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var storeHelper = __webpack_require__("Jsmy");

// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// CONCATENATED MODULE: ./src/client/components/utils/accommodation/accommodation.utils.js
var REMAINING_STOCK_LIMIT = 10;
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/labeled-icons-list/LabeledIconsList.jsx + 1 modules
var LabeledIconsList = __webpack_require__("LR4h");

// EXTERNAL MODULE: ./src/client/components/frameworks/see-more/SeeMore.jsx + 1 modules
var SeeMore = __webpack_require__("NPTU");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx + 1 modules
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-room/arrangement/AccommodationRoomArrangement.jsx
var __jsx = react_default.a.createElement;





var AccommodationRoomArrangement_AccommodationRoomArrangement = function AccommodationRoomArrangement(_ref) {
  var className = _ref.className,
      _ref$isCabin = _ref.isCabin,
      isCabin = _ref$isCabin === void 0 ? false : _ref$isCabin;
  return __jsx("div", {
    className: classnames_default()(className, 'border-1 border-blue flex font-sans items-center px-px10 py-px5 rounded-tiny text-blue text-sm')
  }, __jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-px10",
    name: icons["a" /* ICONS */].LIGHTBULB,
    width: "2em"
  }), isCabin ? Object(i18n["g" /* t */])('booking.accommodation.cabinArrangementYourChoiceMessage') : Object(i18n["g" /* t */])('booking.accommodation.roomArrangementYourChoiceMessage'));
};
// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-room/availability/AccommodationRoomAvailability.themes.js


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var small = {
  thRoot: 'flex flex-wrap items-center leading-tight reset-paragraph text-emerald text-base',
  thIconLast: 'rtl:mr-px10',
  thLastLabel: 'bg-orange font-bold rtl:mr-px10 p-px5 text-sm text-white w-auto',
  thIconLastSize: '1em',
  thStock: 'flex items-center min-w-1/2 mt-px5 text-orange text-sm w-auto',
  thIcon: 'rtl:ml-px10',
  thIconSize: '0.75em'
};
var themes = {
  "default": small,
  medium: _objectSpread({}, small),
  large: _objectSpread(_objectSpread({}, small), {}, {
    thRoot: classnames_default()(small.thRoot, 'md:text-md'),
    thLastLabel: classnames_default()(small.thLastLabel, 'md:text-base md:rtl:mr-px20'),
    thStock: classnames_default()(small.thStock, 'md:min-w-0 md:mt-0 md:text-base')
  })
};
// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-room/availability/AccommodationRoomAvailability.jsx
var AccommodationRoomAvailability_jsx = react_default.a.createElement;







var AccommodationRoomAvailability_AccommodationRoomAvailability = function AccommodationRoomAvailability(_ref) {
  var className = _ref.className,
      _ref$isCabin = _ref.isCabin,
      isCabin = _ref$isCabin === void 0 ? false : _ref$isCabin,
      _ref$stock = _ref.stock,
      stock = _ref$stock === void 0 ? REMAINING_STOCK_LIMIT + 1 : _ref$stock,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var _themes$theme = themes[theme],
      thIcon = _themes$theme.thIcon,
      thIconLast = _themes$theme.thIconLast,
      thIconLastSize = _themes$theme.thIconLastSize,
      thIconSize = _themes$theme.thIconSize,
      thLastLabel = _themes$theme.thLastLabel,
      thRoot = _themes$theme.thRoot,
      thStock = _themes$theme.thStock;
  return AccommodationRoomAvailability_jsx("p", {
    className: classnames_default()(className, thRoot)
  }, stock <= REMAINING_STOCK_LIMIT ? AccommodationRoomAvailability_jsx(react["Fragment"], null, stock > 0 && AccommodationRoomAvailability_jsx("span", {
    className: thLastLabel
  }, isCabin ? Object(i18n["g" /* t */])('booking.accommodation.lastAvailabilityCabins') : Object(i18n["g" /* t */])('booking.accommodation.lastAvailability')), AccommodationRoomAvailability_jsx("span", {
    className: thStock
  }, AccommodationRoomAvailability_jsx(Icon["a" /* Icon */], {
    className: thIconLast,
    name: icons["a" /* ICONS */].WARNING,
    width: thIconLastSize
  }), Object(i18n["g" /* t */])('booking.accommodation.roomAvailabilities', {
    numberOfRoomsLeft: stock
  }))) : AccommodationRoomAvailability_jsx(react["Fragment"], null, Object(i18n["g" /* t */])('booking.accommodation.available'), AccommodationRoomAvailability_jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: icons["a" /* ICONS */].CHECK,
    width: thIconSize
  })));
};
// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-room/distribution/AccommodationRoomDistribution.jsx
var AccommodationRoomDistribution_jsx = react_default.a.createElement;







var MESSAGES = {
  CABIN: {
    SELLER: 'booking.accommodation.cabinArrangementMessageB2B',
    NOT_SELLER: 'booking.accommodation.cabinArrangementMessage'
  },
  DEFFAULT: {
    SELLER: 'booking.partners.accommodation.roomArrangementMessage',
    NOT_SELLER: 'booking.accommodation.roomArrangementMessage'
  }
};
var LABELS = {
  ADULT: 'booking.common.adult',
  BABY: 'booking.common.baby',
  CHILD: 'booking.common.child'
};
var AccommodationRoomDistribution_AccommodationRoomDistribution = function AccommodationRoomDistribution(_ref) {
  var className = _ref.className,
      distribution = _ref.distribution,
      isCabin = _ref.isCabin;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  if (!distribution) {
    return null;
  }

  var NODE = isCabin ? MESSAGES.CABIN : MESSAGES.DEFFAULT;
  var msg = Object(sellerUtils["g" /* isSeller */])(appContext) ? NODE.SELLER : NODE.NOT_SELLER;
  var adults = distribution.adults,
      babies = distribution.babies,
      children = distribution.children;
  return AccommodationRoomDistribution_jsx("div", {
    className: classnames_default()(className, '')
  }, AccommodationRoomDistribution_jsx("ul", {
    className: "flex items-end flex-wrap -mx-px5 mb-px5 reset-list"
  }, [adults, babies, children].filter(Boolean).map(function (d) {
    return d.map(function (_ref2, i) {
      var firstName = _ref2.firstName,
          id = _ref2.id,
          lastName = _ref2.lastName,
          _ref2$type = _ref2.type,
          type = _ref2$type === void 0 ? 'ADULT' : _ref2$type;
      return AccommodationRoomDistribution_jsx("li", {
        className: "p-px5 text-base text-blue",
        key: id
      }, AccommodationRoomDistribution_jsx(Icon["a" /* Icon */], {
        className: "rtl:mr-px5",
        name: icons["a" /* ICONS */].USER,
        width: type === 'ADULT' ? '1.3em' : '1em'
      }), Object(i18n["g" /* t */])(LABELS[type]), " ", i + 1, Object(sellerUtils["g" /* isSeller */])(appContext) && firstName && lastName ? AccommodationRoomDistribution_jsx("span", {
        className: "capitalize rtl:ml-px10"
      }, "".concat(firstName, " ").concat(lastName).toLocaleLowerCase()) : null);
    });
  })), AccommodationRoomDistribution_jsx("p", {
    className: "font-sans reset-paragraph text-blue text-sm"
  }, Object(i18n["g" /* t */])(msg)));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-room/infos/AccommodationRoomInfos.themes.js


function AccommodationRoomInfos_themes_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function AccommodationRoomInfos_themes_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      AccommodationRoomInfos_themes_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      AccommodationRoomInfos_themes_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var AccommodationRoomInfos_themes_small = {
  thList: 'reset-list flex text-xs',
  thListItem: 'flex-none px-px5 w-1/4',
  thItem: 'border-1 border-blue flex flex-col h-full items-center justify-center font-bold font-sans leading-normal overflow-hidden p-px10 px-0 rounded-tiny text-blue text-center text-current text-xs',
  thIcon: 'mb-px10',
  thIconWidth: '2em',
  thText: 'leading-tight w-full'
};
var AccommodationRoomInfos_themes_themes = {
  "default": AccommodationRoomInfos_themes_small,
  medium: AccommodationRoomInfos_themes_objectSpread(AccommodationRoomInfos_themes_objectSpread({}, AccommodationRoomInfos_themes_small), {}, {
    thListItem: classnames_default()(AccommodationRoomInfos_themes_small.thListItem, 'sm:w-1/5'),
    thItem: classnames_default()(AccommodationRoomInfos_themes_small.thItem, 'sm:px-px5 md:px-px10 md:py-px30 md:text-sm')
  }),
  large: {
    thList: AccommodationRoomInfos_themes_small.thList,
    thListItem: classnames_default()(AccommodationRoomInfos_themes_small.thListItem, 'md:w-1/6'),
    thItem: classnames_default()(AccommodationRoomInfos_themes_small.thItem, 'sm:px-px5 md:px-px10 md:py-px30 md:text-sm'),
    thIcon: AccommodationRoomInfos_themes_small.thIcon,
    thIconWidth: AccommodationRoomInfos_themes_small.thIconWidth,
    thText: AccommodationRoomInfos_themes_small.thText
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-room/infos/AccommodationRoomInfos.jsx
var AccommodationRoomInfos_jsx = react_default.a.createElement;





var WIDTH = 108;
var AccommodationRoomInfos_AccommodationRoomInfos = function AccommodationRoomInfos(_ref) {
  var className = _ref.className,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var _themes$theme = AccommodationRoomInfos_themes_themes[theme],
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thItem = _themes$theme.thItem,
      thList = _themes$theme.thList,
      thListItem = _themes$theme.thListItem,
      thText = _themes$theme.thText;
  return AccommodationRoomInfos_jsx(Scrollable["a" /* Scrollable */], {
    backwardLabel: Object(i18n["g" /* t */])('common.scrollBackward'),
    className: className,
    deltaScrollFactorClick: WIDTH,
    elementWidth: WIDTH,
    forwardLabel: Object(i18n["g" /* t */])('common.scrollForward'),
    navPosition: "center"
  }, AccommodationRoomInfos_jsx("ul", {
    className: thList
  }, items.map(function (_ref2, idx) {
    var icon = _ref2.icon,
        _ref2$labels = _ref2.labels,
        labels = _ref2$labels === void 0 ? [] : _ref2$labels;
    return AccommodationRoomInfos_jsx("li", {
      className: thListItem,
      key: idx,
      style: {
        width: items.length > 4 ? WIDTH : null
      }
    }, AccommodationRoomInfos_jsx("div", {
      className: thItem
    }, AccommodationRoomInfos_jsx(Icon["a" /* Icon */], {
      className: thIcon,
      name: icon,
      width: thIconWidth
    }), labels.map(function (label) {
      return AccommodationRoomInfos_jsx("div", {
        className: thText,
        key: label
      }, label);
    })));
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-room/shared-room/AccommodationRoomSharedRoom.jsx
var AccommodationRoomSharedRoom_jsx = react_default.a.createElement;





var AccommodationRoomSharedRoom_AccommodationRoomSharedRoom = function AccommodationRoomSharedRoom(_ref) {
  var className = _ref.className;
  return AccommodationRoomSharedRoom_jsx("div", {
    className: classnames_default()(className, 'border-1 border-blue flex font-sans items-center px-px10 py-px5 rounded-tiny text-blue text-sm')
  }, AccommodationRoomSharedRoom_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-px10",
    name: icons["a" /* ICONS */].SHARED_ROOM,
    width: "2.5em"
  }), Object(i18n["g" /* t */])('booking.accommodation.sharedRooms'));
};
// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/image-slideshow/ImageSlideShow.jsx
var ImageSlideShow = __webpack_require__("DQFb");

// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-room/slideshow/AccommodationRoomSlideshow.jsx
var AccommodationRoomSlideshow_jsx = react_default.a.createElement;






var AccommodationRoomSlideshow_AccommodationRoomSlideshow = function AccommodationRoomSlideshow(_ref) {
  var accommodationName = _ref.accommodationName,
      className = _ref.className,
      _ref$images = _ref.images,
      images = _ref$images === void 0 ? [] : _ref$images;

  if (!(images === null || images === void 0 ? void 0 : images.length)) {
    return null;
  }

  var roomGallery = Object(i18n["g" /* t */])('common.galleries.roomGallery');
  var gallery = Object(i18n["g" /* t */])('common.galleries.gallery');
  return images.length > 0 ? AccommodationRoomSlideshow_jsx(ImageSlideShow["a" /* ImageSlideShow */], {
    className: className,
    closeLabel: Object(i18n["g" /* t */])('common.close'),
    galleryLabel: accommodationName && roomGallery ? Object(dist["messageFormat"])(roomGallery).format({
      roomName: accommodationName
    }) : gallery,
    hasFullScreenMode: true,
    hasInfiniteScroll: true,
    hasLazyLoading: false,
    media: images,
    nextLabel: Object(i18n["g" /* t */])('common.next'),
    previousLabel: Object(i18n["g" /* t */])('common.previous'),
    ratio: ratios_utils["a" /* default */].XL
  }) : AccommodationRoomSlideshow_jsx(Image["b" /* default */], {
    ratioKey: ratios_utils["a" /* default */].XL,
    hasLazyLoading: false
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-room/tag/AccommodationRoomTag.jsx
var AccommodationRoomTag_jsx = react_default.a.createElement;


var AccommodationRoomTag_AccommodationRoomTag = function AccommodationRoomTag(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return AccommodationRoomTag_jsx("div", {
    className: classnames_default()(className, 'bg-white font-bold px-px10 py-px5 rounded-small text-grenadine text-sm top-0 uppercase')
  }, label);
};
// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-room/title/AccommodationRoomTitle.jsx
var AccommodationRoomTitle_jsx = react_default.a.createElement;




var AccommodationRoomTitle_AccommodationRoomTitle = function AccommodationRoomTitle(_ref) {
  var className = _ref.className,
      name = _ref.name,
      _ref$quantity = _ref.quantity,
      quantity = _ref$quantity === void 0 ? 1 : _ref$quantity;
  return AccommodationRoomTitle_jsx("h3", {
    className: classnames_default()(className, 'flex font-brand font-normal items-baseline leading-tight reset-heading text-blue text-xl')
  }, name, !!quantity && quantity > 1 && AccommodationRoomTitle_jsx(TemplateString["a" /* TemplateString */], {
    className: "font-brand rtl:ml-px20 text-lg text-gray-darker whitespace-no-wrap",
    template: Object(i18n["g" /* t */])('booking.accommodation.packageContent.numberOfSameRooms'),
    valuesClassName: {
      count: 'text-2xl'
    },
    values: {
      count: quantity
    }
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-room/AccommodationRoom.themes.js


function AccommodationRoom_themes_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function AccommodationRoom_themes_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      AccommodationRoom_themes_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      AccommodationRoom_themes_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var AccommodationRoom_themes_small = {
  thHeader: 'md:py-px10',
  thSlideshowBlock: 'relative mb-px10',
  thSlideshow: 'overflow-hidden rounded-tiny',
  thTag: 'absolute m-px10 rtl:right-0 z-1',
  thContent: 'pb-px10',
  thInfos: 'mb-px10 -mx-px5',
  thTitle: 'mb-px5',
  thAvailability: 'mb-px10',
  thHeaderElements: 'hidden',
  thDesc: 'mb-px10',
  thDistribution: 'mb-px10',
  thArrangement: 'mb-px10',
  thShared: 'mb-px10',
  thSeemore: 'w-full',
  thSeemoreBtn: 'rtl:ml-auto rtl:text-right',
  thSeemoreContent: 'flex flex-wrap',
  thDetail: 'pb-px10 w-full',
  thDetailTitle: 'mb-px10',
  thDetailListTheme: 'listCondensed'
};
var AccommodationRoom_themes_themes = {
  "default": AccommodationRoom_themes_small,
  medium: AccommodationRoom_themes_small,
  large: AccommodationRoom_themes_objectSpread(AccommodationRoom_themes_objectSpread({}, AccommodationRoom_themes_small), {}, {
    thRoot: 'sm:flex sm:flex-row sm:flex-wrap',
    thHeader: 'sm:hidden',
    thSlideshowBlock: classnames_default()(AccommodationRoom_themes_small.thSlideshowBlock, 'sm:rtl:pr-px10 sm:w-1/2 md:w-2/5'),
    thTag: classnames_default()(AccommodationRoom_themes_small.thTag, 'sm:mx-px20'),
    thContent: classnames_default()(AccommodationRoom_themes_small.thContent, 'flex flex-col justify-between sm:pb-0 sm:rtl:pl-px10 sm:w-1/2 md:w-3/5'),
    thHeaderElements: classnames_default()(AccommodationRoom_themes_small.thHeaderElements, 'sm:block'),
    thInfos: classnames_default()(AccommodationRoom_themes_small.thInfos, 'sm:order-last'),
    thSeemoreContent: classnames_default()(AccommodationRoom_themes_small.thSeemoreContent, 'sm:-mx-px10'),
    thDetail: classnames_default()(AccommodationRoom_themes_small.thDetail, 'sm:p-px10 sm:w-1/2'),
    thDetailListTheme: 'listCondensed'
  })
};
// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-room/AccommodationRoom.jsx
var AccommodationRoom_jsx = react_default.a.createElement;


















var AccommodationRoom_Detail = function Detail(_ref) {
  var isPremium = _ref.isPremium,
      items = _ref.items,
      theme = _ref.theme,
      title = _ref.title;
  return (items === null || items === void 0 ? void 0 : items.length) ? AccommodationRoom_jsx("div", {
    className: classnames_default()(AccommodationRoom_themes_themes[theme].thDetail, {
      'order-first': isPremium
    })
  }, AccommodationRoom_jsx(Title["a" /* Title */], {
    className: AccommodationRoom_themes_themes[theme].thDetailTitle,
    hLevel: 3,
    theme: "title-sans-3"
  }, title), AccommodationRoom_jsx(LabeledIconsList["a" /* LabeledIconsList */], {
    items: items.map(function (_ref2) {
      var id = _ref2.id,
          label = _ref2.label;
      return {
        icon: icons["a" /* ICONS */][id] || icons["a" /* ICONS */].TRIDENT1,
        labels: [label]
      };
    }),
    theme: AccommodationRoom_themes_themes[theme].thDetailListTheme
  })) : null;
};

var AccommodationRoom_AccommodationRoom = function AccommodationRoom(_ref3) {
  var _ref3$bathroomEquipme = _ref3.bathroomEquipments,
      bathroomEquipments = _ref3$bathroomEquipme === void 0 ? [] : _ref3$bathroomEquipme,
      className = _ref3.className,
      description = _ref3.description,
      distribution = _ref3.distribution,
      _ref3$equipments = _ref3.equipments,
      equipments = _ref3$equipments === void 0 ? [] : _ref3$equipments,
      _ref3$hasArrangement = _ref3.hasArrangement,
      hasArrangement = _ref3$hasArrangement === void 0 ? false : _ref3$hasArrangement,
      _ref3$hasDistribution = _ref3.hasDistribution,
      hasDistribution = _ref3$hasDistribution === void 0 ? false : _ref3$hasDistribution,
      _ref3$hasSharedRoom = _ref3.hasSharedRoom,
      hasSharedRoom = _ref3$hasSharedRoom === void 0 ? false : _ref3$hasSharedRoom,
      id = _ref3.id,
      images = _ref3.images,
      infosList = _ref3.infosList,
      _ref3$isBestFamilyDea = _ref3.isBestFamilyDeal,
      isBestFamilyDeal = _ref3$isBestFamilyDea === void 0 ? false : _ref3$isBestFamilyDea,
      _ref3$isCabin = _ref3.isCabin,
      isCabin = _ref3$isCabin === void 0 ? false : _ref3$isCabin,
      _ref3$isPremium = _ref3.isPremium,
      isPremium = _ref3$isPremium === void 0 ? false : _ref3$isPremium,
      name = _ref3.name,
      _ref3$outsideFaciliti = _ref3.outsideFacilities,
      outsideFacilities = _ref3$outsideFaciliti === void 0 ? [] : _ref3$outsideFaciliti,
      quantity = _ref3.quantity,
      _ref3$services = _ref3.services,
      services = _ref3$services === void 0 ? [] : _ref3$services,
      stock = _ref3.stock,
      _ref3$theme = _ref3.theme,
      theme = _ref3$theme === void 0 ? 'default' : _ref3$theme;
  var _themes$theme = AccommodationRoom_themes_themes[theme],
      thArrangement = _themes$theme.thArrangement,
      thAvailability = _themes$theme.thAvailability,
      thContent = _themes$theme.thContent,
      thDesc = _themes$theme.thDesc,
      thDistribution = _themes$theme.thDistribution,
      thHeader = _themes$theme.thHeader,
      thHeaderElements = _themes$theme.thHeaderElements,
      thInfos = _themes$theme.thInfos,
      thRoot = _themes$theme.thRoot,
      thSeemore = _themes$theme.thSeemore,
      thSeemoreBtn = _themes$theme.thSeemoreBtn,
      thSeemoreContent = _themes$theme.thSeemoreContent,
      thShared = _themes$theme.thShared,
      thSlideshowBlock = _themes$theme.thSlideshowBlock,
      thSlideshow = _themes$theme.thSlideshow,
      thTag = _themes$theme.thTag,
      thTitle = _themes$theme.thTitle;
  return AccommodationRoom_jsx("div", {
    className: classnames_default()(className, thRoot),
    id: id
  }, AccommodationRoom_jsx("div", {
    className: thHeader
  }, AccommodationRoom_jsx(AccommodationRoomTitle_AccommodationRoomTitle, {
    className: thTitle,
    name: name,
    quantity: quantity
  }), AccommodationRoom_jsx(AccommodationRoomAvailability_AccommodationRoomAvailability, {
    className: thAvailability,
    isCabin: isCabin,
    stock: stock,
    theme: theme
  })), AccommodationRoom_jsx("div", {
    className: thSlideshowBlock
  }, AccommodationRoom_jsx(AccommodationRoomSlideshow_AccommodationRoomSlideshow, {
    accommodationName: name,
    className: thSlideshow,
    images: images
  }), isBestFamilyDeal && AccommodationRoom_jsx(AccommodationRoomTag_AccommodationRoomTag, {
    className: thTag,
    label: Object(i18n["g" /* t */])('booking.accommodation.bestFamilyDealLabel')
  })), AccommodationRoom_jsx("div", {
    className: thContent
  }, AccommodationRoom_jsx(AccommodationRoomInfos_AccommodationRoomInfos, {
    className: thInfos,
    items: infosList,
    theme: theme
  }), AccommodationRoom_jsx("div", null, AccommodationRoom_jsx("div", {
    className: thHeaderElements
  }, AccommodationRoom_jsx(AccommodationRoomTitle_AccommodationRoomTitle, {
    className: thTitle,
    name: name,
    quantity: quantity
  }), AccommodationRoom_jsx(AccommodationRoomAvailability_AccommodationRoomAvailability, {
    className: thAvailability,
    isCabin: isCabin,
    stock: stock,
    theme: theme
  })), AccommodationRoom_jsx(Text["a" /* Text */], {
    text: description,
    className: thDesc
  }), hasDistribution && AccommodationRoom_jsx(AccommodationRoomDistribution_AccommodationRoomDistribution, {
    className: thDistribution,
    distribution: distribution,
    isCabin: isCabin
  }), hasArrangement && AccommodationRoom_jsx(AccommodationRoomArrangement_AccommodationRoomArrangement, {
    className: thArrangement,
    isCabin: isCabin
  }), hasSharedRoom && AccommodationRoom_jsx(AccommodationRoomSharedRoom_AccommodationRoomSharedRoom, {
    className: thShared
  }))), AccommodationRoom_jsx(SeeMore["a" /* SeeMore */], {
    className: thSeemore,
    classNameButton: thSeemoreBtn,
    isCollapseEnabled: true,
    seeMoreLabel: Object(i18n["g" /* t */])('booking.accommodation.packageContent.showFullDescription'),
    seeLessLabel: Object(i18n["g" /* t */])('booking.accommodation.packageContent.lessDetails'),
    seeMoreSize: 80
  }, AccommodationRoom_jsx("div", {
    className: thSeemoreContent
  }, AccommodationRoom_jsx(AccommodationRoom_Detail, {
    items: equipments,
    theme: theme,
    title: Object(i18n["g" /* t */])('booking.accommodation.packageContent.equipment')
  }), AccommodationRoom_jsx(AccommodationRoom_Detail, {
    items: bathroomEquipments,
    theme: theme,
    title: Object(i18n["g" /* t */])('booking.accommodation.packageContent.bathroomEquipments')
  }), AccommodationRoom_jsx(AccommodationRoom_Detail, {
    isPremium: isPremium,
    items: services,
    theme: theme,
    title: Object(i18n["g" /* t */])('booking.accommodation.packageContent.services')
  }), AccommodationRoom_jsx(AccommodationRoom_Detail, {
    items: outsideFacilities,
    theme: theme,
    title: Object(i18n["g" /* t */])('booking.accommodation.packageContent.outsideEquipments')
  }))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/flex-rates/FlexRates.jsx + 1 modules
var FlexRates = __webpack_require__("ExLU");

// CONCATENATED MODULE: ./src/client/components/widgets/accommodation/header/AccommodationHeader.themes.js


function AccommodationHeader_themes_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function AccommodationHeader_themes_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      AccommodationHeader_themes_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      AccommodationHeader_themes_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var AccommodationHeader_themes_small = {
  thRecap: 'mb-px5',
  thAttendees: 'font-bold reset-paragraph text-sm',
  thAttendeesNumbers: 'font-bold text-blue',
  thRooms: 'font-brand reset-paragraph text-lg text-blue',
  thAlert: 'border-1 border-blue flex font-sans items-center px-px10 py-px5 rounded-tiny text-blue text-xs'
};
var AccommodationHeader_themes_themes = {
  "default": AccommodationHeader_themes_small,
  medium: AccommodationHeader_themes_small,
  large: AccommodationHeader_themes_objectSpread(AccommodationHeader_themes_objectSpread({}, AccommodationHeader_themes_small), {}, {
    thRoot: 'flex flex-wrap items-center',
    thRecap: classnames_default()(AccommodationHeader_themes_small.thRecap, 'sm:mb-0 sm:rtl:pr-px20 w-full sm:w-2/5'),
    thAttendees: classnames_default()(AccommodationHeader_themes_small.thAttendees, 'text-sm md:text-base'),
    thRooms: classnames_default()(AccommodationHeader_themes_small.thRooms, 'sm:text-xl md:text-2xl'),
    thAlert: classnames_default()(AccommodationHeader_themes_small.thAlert, 'sm:text-sm md:text-base w-full sm:w-3/5')
  })
};
// CONCATENATED MODULE: ./src/client/components/widgets/accommodation/header/AccommodationHeader.jsx
var AccommodationHeader_jsx = react_default.a.createElement;








var AccommodationHeader_AccommodationHeader = function AccommodationHeader(_ref) {
  var className = _ref.className,
      _ref$isCabin = _ref.isCabin,
      isCabin = _ref$isCabin === void 0 ? false : _ref$isCabin,
      numberOfAdults = _ref.numberOfAdults,
      numberOfBabies = _ref.numberOfBabies,
      numberOfChildren = _ref.numberOfChildren,
      numberOfRooms = _ref.numberOfRooms,
      stock = _ref.stock,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var _themes$theme = AccommodationHeader_themes_themes[theme],
      thAlert = _themes$theme.thAlert,
      thAttendees = _themes$theme.thAttendees,
      thAttendeesNumbers = _themes$theme.thAttendeesNumbers,
      thRecap = _themes$theme.thRecap,
      thRooms = _themes$theme.thRooms,
      thRoot = _themes$theme.thRoot;
  return AccommodationHeader_jsx("div", {
    className: classnames_default()(className, thRoot)
  }, AccommodationHeader_jsx("div", {
    className: thRecap
  }, AccommodationHeader_jsx("p", {
    className: thAttendees
  }, Object(i18n["g" /* t */])('booking.accommodation.proposalFor'), ' ', AccommodationHeader_jsx("span", {
    className: thAttendeesNumbers
  }, ["".concat(numberOfAdults, " ").concat(numberOfAdults > 1 ? Object(i18n["g" /* t */])('booking.common.adults') : Object(i18n["g" /* t */])('booking.common.adult')), numberOfBabies ? "".concat(numberOfBabies, " ").concat(numberOfBabies > 1 ? Object(i18n["g" /* t */])('booking.common.babies') : Object(i18n["g" /* t */])('booking.common.baby')) : null, numberOfChildren ? "".concat(numberOfChildren, " ").concat(numberOfChildren > 1 ? Object(i18n["g" /* t */])('booking.common.children') : Object(i18n["g" /* t */])('booking.common.child')) : null].filter(Boolean).join(' - '))), AccommodationHeader_jsx("p", {
    className: thRooms
  }, numberOfRooms, " ", Object(i18n["g" /* t */])('booking.accommodation.packageContent.separatedRooms')), stock <= REMAINING_STOCK_LIMIT && AccommodationHeader_jsx(AccommodationRoomAvailability_AccommodationRoomAvailability, {
    isCabin: isCabin,
    stock: stock,
    theme: theme
  })), !isCabin && AccommodationHeader_jsx("div", {
    className: thAlert
  }, AccommodationHeader_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-px10",
    name: icons["a" /* ICONS */].SEPARATED_BUILDINGS,
    width: "2.5em"
  }), Object(i18n["g" /* t */])('booking.accommodation.separatedRooms')));
};
// CONCATENATED MODULE: ./src/client/components/widgets/accommodation/separator/AccommodationSeparator.jsx
var AccommodationSeparator_jsx = react_default.a.createElement;


var AccommodationSeparator_AccommodationSeparator = function AccommodationSeparator(_ref) {
  var className = _ref.className;
  return AccommodationSeparator_jsx("div", {
    className: classnames_default()(className, 'flex items-center justify-center')
  }, AccommodationSeparator_jsx("div", {
    className: "block border-0 border-dashed border-gray-light border-t-1 h-px m-0 p-0 w-full"
  }), AccommodationSeparator_jsx("div", {
    className: "bg-blue font-brand inline-block leading-one mx-px10 px-px10 py-px5 rounded-tiny text-white text-2xl"
  }, "&"), AccommodationSeparator_jsx("div", {
    className: "block border-0 border-dashed border-gray-light border-t-1 h-px m-0 p-0 w-full"
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/accommodation/Accommodation.themes.js

var Accommodation_themes_small = {
  thSeparated: 'border-b-1 border-gray-light p-px10',
  thRoom: 'p-px10',
  thFlexRates: 'border-t-1 border-gray-light p-px10'
};
var Accommodation_themes_themes = {
  "default": Accommodation_themes_small,
  medium: Accommodation_themes_small,
  large: {
    thSeparated: classnames_default()(Accommodation_themes_small.thSeparated, 'sm:p-px20'),
    thRoom: classnames_default()(Accommodation_themes_small.thRoom, 'sm:p-px20'),
    thFlexRates: classnames_default()(Accommodation_themes_small.thFlexRates, 'sm:p-px20')
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/accommodation/Accommodation.jsx

var Accommodation_jsx = react_default.a.createElement;







var Accommodation_Accommodation = function Accommodation(_ref) {
  var className = _ref.className,
      _ref$hasFlexRates = _ref.hasFlexRates,
      hasFlexRates = _ref$hasFlexRates === void 0 ? false : _ref$hasFlexRates,
      _ref$isCabin = _ref.isCabin,
      isCabin = _ref$isCabin === void 0 ? false : _ref$isCabin,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      proposal = _ref.proposal,
      _ref$rooms = _ref.rooms,
      rooms = _ref$rooms === void 0 ? [] : _ref$rooms,
      selectedRate = _ref.selectedRate,
      setSelectedRate = _ref.setSelectedRate,
      stock = _ref.stock,
      switchOffers = _ref.switchOffers,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var _themes$theme = Accommodation_themes_themes[theme],
      thFlexRates = _themes$theme.thFlexRates,
      thRoom = _themes$theme.thRoom,
      thSeparated = _themes$theme.thSeparated;
  var counters = isCabin ? null : rooms.reduce(function (t, r) {
    var _r$distribution, _r$distribution$adult, _r$distribution2, _r$distribution2$babi, _r$distribution3, _r$distribution3$chil;

    return {
      adults: t.adults + (((_r$distribution = r.distribution) === null || _r$distribution === void 0 ? void 0 : (_r$distribution$adult = _r$distribution.adults) === null || _r$distribution$adult === void 0 ? void 0 : _r$distribution$adult.length) || 0),
      babies: t.babies + (((_r$distribution2 = r.distribution) === null || _r$distribution2 === void 0 ? void 0 : (_r$distribution2$babi = _r$distribution2.babies) === null || _r$distribution2$babi === void 0 ? void 0 : _r$distribution2$babi.length) || 0),
      children: t.children + (((_r$distribution3 = r.distribution) === null || _r$distribution3 === void 0 ? void 0 : (_r$distribution3$chil = _r$distribution3.children) === null || _r$distribution3$chil === void 0 ? void 0 : _r$distribution3$chil.length) || 0),
      rooms: t.rooms + r.quantity
    };
  }, {
    adults: 0,
    babies: 0,
    children: 0,
    rooms: 0
  });
  return Accommodation_jsx("div", {
    className: className,
    "data-testid": "Accommodation"
  }, counters && counters.rooms > 1 && Accommodation_jsx(AccommodationHeader_AccommodationHeader, {
    className: thSeparated,
    isCabin: isCabin,
    numberOfAdults: counters.adults,
    numberOfBabies: counters.babies,
    numberOfChildren: counters.children,
    numberOfRooms: counters.rooms,
    stock: stock,
    theme: theme
  }), rooms.map(function (room, i) {
    return Accommodation_jsx(react["Fragment"], {
      key: room.id
    }, i > 0 && Accommodation_jsx(AccommodationSeparator_AccommodationSeparator, null), Accommodation_jsx(AccommodationRoom_AccommodationRoom, Object(esm_extends["a" /* default */])({}, room, {
      className: thRoom,
      stock: counters && counters.rooms > 1 && stock > 0 ? REMAINING_STOCK_LIMIT + 1 : stock,
      theme: theme
    })));
  }), hasFlexRates && Accommodation_jsx(FlexRates["a" /* FlexRates */], {
    className: thFlexRates,
    isLoading: isLoading,
    proposal: proposal,
    selectedRate: selectedRate,
    setSelectedRate: setSelectedRate,
    switchOffers: switchOffers,
    theme: theme
  }));
};
// EXTERNAL MODULE: ./src/client/components/widgets/accommodations/BookingAccommodationsUtils.js
var BookingAccommodationsUtils = __webpack_require__("cb6o");

// CONCATENATED MODULE: ./src/client/components/widgets/accommodations/BookingAccommodations.jsx



var BookingAccommodations_jsx = react_default.a.createElement;

function BookingAccommodations_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function BookingAccommodations_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { BookingAccommodations_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { BookingAccommodations_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var BookingAccommodations_BookingAccommodations = function BookingAccommodations(_ref) {
  var _ref$accommodations = _ref.accommodations,
      accommodations = _ref$accommodations === void 0 ? [] : _ref$accommodations,
      accommodationsCount = _ref.accommodationsCount,
      _ref$isInMoreRoomLaye = _ref.isInMoreRoomLayer,
      isInMoreRoomLayer = _ref$isInMoreRoomLaye === void 0 ? false : _ref$isInMoreRoomLaye,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      proposal = _ref.proposal,
      remainingStock = _ref.remainingStock,
      resort = _ref.resort,
      selectedRate = _ref.selectedRate,
      setSelectedRate = _ref.setSelectedRate,
      switchOffers = _ref.switchOffers,
      theme = _ref.theme;
  var tripAttendees = Object(es["e" /* useSelector */])(storeHelper["d" /* tripInformationSelector */]);
  var connectedUser = Object(es["e" /* useSelector */])(booking_selector["j" /* getConnectedUserInfoSelector */]);

  var _addUserInfosToAttend = Object(booking_selector["a" /* addUserInfosToAttendees */])(proposal.attendees, tripAttendees, connectedUser),
      adults = _addUserInfosToAttend.adults,
      children = _addUserInfosToAttend.children;

  var attendeesWithInfos = [].concat(Object(toConsumableArray["a" /* default */])(adults), Object(toConsumableArray["a" /* default */])(children));

  var sortedAccommodations = Object(toConsumableArray["a" /* default */])(accommodations).sort(proposalUtils["b" /* compareAccommodationsByComfort */]);

  var arrangementAttendees = sortedAccommodations.reduce(function (attendeesList, accommodation) {
    if (accommodation.attendeesDistribution && accommodation.attendeesDistribution.attendees) {
      return [].concat(Object(toConsumableArray["a" /* default */])(attendeesList), Object(toConsumableArray["a" /* default */])(accommodation.attendeesDistribution.attendees));
    }

    return Object(toConsumableArray["a" /* default */])(attendeesList);
  }, []);
  /**
   * On accommodations view, when accommodations have arrangement, we would like to have index related
   * to accommodations order (first accommodation attendees with first indexes)
   */

  var sortedAttendeesWithInfos = !isInMoreRoomLayer && arrangementAttendees && arrangementAttendees.length ? arrangementAttendees.map(function (attendee) {
    var attendeeData = attendeesWithInfos.find(function (_ref2) {
      var id = _ref2.id;
      return attendee.id === id;
    }) || {}; // $FlowFixMe: flow cannot handle this spread...

    return BookingAccommodations_objectSpread(BookingAccommodations_objectSpread({}, attendee), attendeeData);
  }) : attendeesWithInfos;
  var attendeesWithDistributionData = Object(AttendeesDistributionUtils["b" /* addDistributionDataToAttendees */])(sortedAttendeesWithInfos, proposal.arrivalDate);
  return BookingAccommodations_jsx(Accommodation_Accommodation, Object(esm_extends["a" /* default */])({}, Object(BookingAccommodationsUtils["b" /* getAccommodationProps */])({
    accommodations: accommodations,
    accommodationsCount: accommodationsCount,
    attendeesWithDistributionData: attendeesWithDistributionData,
    proposal: proposal,
    remainingStock: remainingStock,
    resort: resort
  }), {
    isLoading: isLoading,
    selectedRate: selectedRate,
    setSelectedRate: setSelectedRate,
    switchOffers: switchOffers,
    theme: theme
  }));
};

/***/ }),

/***/ "cuXy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TransferSidebar; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("SPKZ");
/* harmony import */ var _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("UCZK");
/* harmony import */ var _components_frameworks_capsule_Capsule__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jldR");
/* harmony import */ var _components_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qBqs");
/* harmony import */ var _components_frameworks_image_Image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("0IQ5");
/* harmony import */ var _components_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("qqKu");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Ub5k");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("kiXb");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;









var TransferSidebar = function TransferSidebar(props) {
  var _React$useContext = react__WEBPACK_IMPORTED_MODULE_0___default.a.useContext(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"]),
      isCmta = _React$useContext.isCmta;

  var i18n = props.i18n.common.transport.transfer;
  var sellerPickUpDescription = Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "g"])('booking.partners.transfer.pickUpDescription');
  var sellerWaitingTime = Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "g"])('booking.partners.transfer.waitingTime');
  return __jsx(_components_frameworks_capsule_Capsule__WEBPACK_IMPORTED_MODULE_3__[/* Capsule */ "a"], {
    header: "none"
  }, __jsx(_components_frameworks_image_Image__WEBPACK_IMPORTED_MODULE_5__[/* default */ "b"], {
    imageUrl: "https://i.imgur.com/xuEabF1.jpg",
    mandatoryWidthAndHeight: {
      w: 280,
      h: 170
    }
  }), __jsx("div", {
    className: "border-b-1 border-gray-light p-px20 text-base"
  }, __jsx("div", {
    className: "font-bold pb-px10 text-blue"
  }, i18n.title), __jsx("div", {
    className: "pb-px15"
  }, isCmta ? sellerPickUpDescription : i18n.pickUpDescription), __jsx("div", null, __jsx(_components_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_4__[/* Icon */ "a"], {
    className: "align-middle rtl:mr-px10",
    color: _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].BLUE,
    name: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].COMPASS,
    width: "1.3125rem"
  }), i18n.arrivalPoint), __jsx("div", {
    className: "pt-px10"
  }, __jsx(_components_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_4__[/* Icon */ "a"], {
    className: "align-middle rtl:mr-px10",
    color: _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].BLUE,
    name: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].TRANSFER,
    width: "1.3125rem"
  }), i18n.roundTrip)), __jsx("div", {
    className: "p-px20"
  }, __jsx(_components_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_6__[/* Text */ "a"], {
    color: _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].GRAY_DARKER,
    text: "**".concat(i18n.note, "** ").concat(isCmta ? sellerWaitingTime : i18n.waitingTime),
    theme: "text-sans-2"
  })));
};

/***/ }),

/***/ "d4In":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ CapsuleCollapseLists_CapsuleCollapseLists; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/capsule/Capsule.jsx + 1 modules
var Capsule = __webpack_require__("jldR");

// EXTERNAL MODULE: ./src/client/components/frameworks/collapse-panel/CollapsePanel.jsx + 1 modules
var CollapsePanel = __webpack_require__("gA51");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// CONCATENATED MODULE: ./src/client/components/frameworks/capsule-collapse-lists/CapsuleCollapseLists.themes.js

var themes = {
  "default": {
    thMessage: 'decorator-border-bottom-list font-bold p-px20 text-base',
    thCollapse: 'decorator-border-bottom-list border-gray-light',
    thCollapseTheme: 'limpidSmall',
    thCollapseIconCollapse: icons["a" /* ICONS */].BOLDER_ARROW_FORTH_DOWN,
    thCollapseIconExpand: icons["a" /* ICONS */].BOLDER_ARROW_FORTH_DOWN,
    thItems: 'reset-list pb-px20 text-base',
    thItem: 'flex items-center px-px20 py-px5',
    thItemIcon: 'flex-shrink-0 rtl:mr-px15 text-blue',
    thItemIconWidth: '1.5rem',
    thItemLabel: 'flex-1'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/capsule-collapse-lists/CapsuleCollapseLists.jsx
var __jsx = react_default.a.createElement;





var CapsuleCollapseLists_CapsuleCollapseLists = function CapsuleCollapseLists(_ref) {
  var className = _ref.className,
      _ref$header = _ref.header,
      header = _ref$header === void 0 ? {} : _ref$header,
      _ref$lists = _ref.lists,
      lists = _ref$lists === void 0 ? [] : _ref$lists,
      message = _ref.message,
      style = _ref.style,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  if (!lists || !lists.length) {
    return null;
  }

  var _themes$theme = themes[theme],
      thCollapse = _themes$theme.thCollapse,
      thCollapseIconCollapse = _themes$theme.thCollapseIconCollapse,
      thCollapseIconExpand = _themes$theme.thCollapseIconExpand,
      thCollapseTheme = _themes$theme.thCollapseTheme,
      thItems = _themes$theme.thItems,
      thItem = _themes$theme.thItem,
      thItemIcon = _themes$theme.thItemIcon,
      thItemIconWidth = _themes$theme.thItemIconWidth,
      thItemLabel = _themes$theme.thItemLabel,
      thMessage = _themes$theme.thMessage;
  return __jsx(Capsule["a" /* Capsule */], {
    additionalStyle: {
      root: style
    },
    className: className,
    color: header.color,
    header: "large",
    icon: header.iconName,
    label: header.title
  }, !!message && __jsx("div", {
    className: thMessage
  }, message), lists.map(function (el, index) {
    var _el$items;

    return !!((_el$items = el.items) === null || _el$items === void 0 ? void 0 : _el$items.length) && __jsx(CollapsePanel["a" /* CollapsePanel */], {
      className: thCollapse,
      collapseIconName: thCollapseIconCollapse,
      expandIconName: thCollapseIconExpand,
      isExpanded: index === 0,
      key: el.title,
      theme: thCollapseTheme,
      title: el.title
    }, __jsx("ul", {
      className: thItems
    }, el.items.map(function (_ref2) {
      var iconName = _ref2.iconName,
          label = _ref2.label;
      return __jsx("li", {
        className: thItem,
        key: label
      }, __jsx(Icon["a" /* Icon */], {
        className: thItemIcon,
        name: iconName,
        width: thItemIconWidth
      }), __jsx("span", {
        className: thItemLabel
      }, label));
    })));
  }));
};

/***/ }),

/***/ "d8Tx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ PackagePriceSummary_PackagePriceSummary; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/widgets/transport-details/transportUtils.js
var transportUtils = __webpack_require__("z8xc");

// EXTERNAL MODULE: ./src/client/components/widgets/package/price/DateSummary.jsx
var DateSummary = __webpack_require__("tF/N");

// EXTERNAL MODULE: ./src/client/components/widgets/package/price/ResortSummary.jsx
var ResortSummary = __webpack_require__("4XHd");

// EXTERNAL MODULE: ./src/client/components/widgets/package/price/AttendeesSummary.jsx
var AttendeesSummary = __webpack_require__("5q4R");

// EXTERNAL MODULE: ./src/client/components/widgets/package/price/TransportSummary.jsx
var TransportSummary = __webpack_require__("YKA5");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// CONCATENATED MODULE: ./src/client/components/widgets/package/price/PackagePriceSummarySection.jsx
var __jsx = react_default.a.createElement;





var PackagePriceSummarySection_PackagePriceSummarySection = function PackagePriceSummarySection(_ref) {
  var extendedDataset = _ref.extendedDataset,
      icon = _ref.icon,
      template = _ref.template,
      type = _ref.type,
      values = _ref.values;
  return __jsx("div", {
    className: classnames_default()('PackagePriceSummary-section', {
      'PackagePriceSummary-section--extended': extendedDataset
    }),
    "data-selector": "PricingTableSummary-".concat(type, "Section")
  }, __jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].BLUE,
    name: icon.name,
    className: "PackagePriceSummary-icon",
    width: "1.875rem",
    hasRtl: icon.hasRtl
  }), __jsx(TemplateString["a" /* TemplateString */], {
    template: template,
    values: values,
    valuesClassName: {
      duration: 'font-bold text-blue'
    }
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/package/price/PackagePriceSummary.jsx
var PackagePriceSummary_jsx = react["createElement"];












var PackagePriceSummary_PackagePriceSummary = function PackagePriceSummary(props) {
  var _props$extendedDatase = props.extendedDataset,
      extendedDataset = _props$extendedDatase === void 0 ? false : _props$extendedDatase,
      proposal = props.proposal,
      resort = props.resort,
      _props$shouldShowReso = props.shouldShowResort,
      shouldShowResort = _props$shouldShowReso === void 0 ? false : _props$shouldShowReso;
  var dateFormat = Object(i18n["g" /* t */])('booking.priceDetails.packagePrice.dateFormat');
  var arrivalDepartureDate = {
    arrivalDate: Object(proposalUtils["h" /* getFormattedArrivalDate */])(proposal, dateFormat),
    departureDate: Object(proposalUtils["i" /* getFormattedDepartureDate */])(proposal, dateFormat)
  };
  var transportIcon = Object(transportUtils["l" /* getTransportIcon */])(Object(lodash["get"])(proposal, 'transports.inbound'), Object(lodash["get"])(proposal, 'transports.outbound'));
  return PackagePriceSummary_jsx("div", {
    className: classnames_default()('PackagePriceSummary', {
      'PackagePriceSummary--extended': extendedDataset
    })
  }, PackagePriceSummary_jsx("div", {
    className: classnames_default()('PackagePriceSummary-sections', {
      'PackagePriceSummary-sections--extended': extendedDataset
    })
  }, shouldShowResort && resort && PackagePriceSummary_jsx(ResortSummary["a" /* ResortSummary */], {
    resort: resort,
    extendedDataset: extendedDataset
  }), PackagePriceSummary_jsx(DateSummary["a" /* DateSummary */], {
    extendedDataset: extendedDataset,
    template: Object(i18n["g" /* t */])('booking.priceDetails.packagePrice.departureDateFormat'),
    values: arrivalDepartureDate
  }), (!resort || !shouldShowResort) && PackagePriceSummary_jsx(PackagePriceSummarySection_PackagePriceSummarySection, {
    type: "duration",
    icon: {
      name: icons["a" /* ICONS */].DURATION,
      hasRtl: true
    },
    template: Object(i18n["g" /* t */])('booking.priceDetails.packagePrice.journeyDurationFormat'),
    values: {
      duration: Object(lodash["get"])(props, 'proposal.duration')
    },
    extendedDataset: extendedDataset
  }), PackagePriceSummary_jsx(AttendeesSummary["a" /* AttendeesSummary */], {
    adults: proposal.adultsCount,
    kids: proposal.childrenCount,
    extendedDataset: extendedDataset
  }), PackagePriceSummary_jsx(TransportSummary["a" /* TransportSummary */], {
    extendedDataset: extendedDataset,
    departure: Object(lodash["get"])(proposal, 'transports.inbound.travelSections[0].departure.label'),
    transportIcon: transportIcon
  }), extendedDataset && PackagePriceSummary_jsx(react["Fragment"], null, Object(proposalUtils["u" /* hasTransportOrTransferSelected */])(proposal) && PackagePriceSummary_jsx(PackagePriceSummarySection_PackagePriceSummarySection, {
    type: "transfer",
    icon: {
      name: icons["a" /* ICONS */].TRANSFER,
      hasRtl: true
    },
    template: Object(i18n["g" /* t */])('booking.priceDetails.packagePrice.withPrestation'),
    values: {
      prestation: Object(i18n["g" /* t */])('booking.priceDetails.packagePrice.transfer')
    },
    extendedDataset: true
  }), Object(proposalUtils["q" /* hasChildcare */])(proposal) && PackagePriceSummary_jsx(PackagePriceSummarySection_PackagePriceSummarySection, {
    type: "childcare",
    icon: {
      name: icons["a" /* ICONS */].CHILDREN,
      hasRtl: true
    },
    template: Object(i18n["g" /* t */])('booking.priceDetails.packagePrice.withPrestation'),
    values: {
      prestation: Object(i18n["g" /* t */])('booking.priceDetails.packagePrice.childcare')
    },
    extendedDataset: true
  }))));
};

/***/ }),

/***/ "dGB2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CABIN_CLASS_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COMPANIES_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return LAYOVERS_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return TIME_RANGES_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CABIN_CLASS_ECO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CABIN_CLASS_BUSINESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FLIGHT_CLASS_ECO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FLIGHT_CLASS_BUSINESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FLIGHT_CLASS_ALIZEE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FLIGHT_CLASS_EMERALD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FLIGHT_CLASS_FIRST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FLIGHT_CLASS_PREMIUM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ZERO_LAYOVERS_ICON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ONE_LAYOVERS_ICON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return TWO_LAYOVERS_ICON; });
var CABIN_CLASS_CATEGORY = 'cabinClass';
var COMPANIES_CATEGORY = 'companies';
var LAYOVERS_CATEGORY = 'layovers';
var TIME_RANGES_CATEGORY = 'timeRanges';
var CABIN_CLASS_ECO = 'ECO';
var CABIN_CLASS_BUSINESS = 'BUSINESS';
var FLIGHT_CLASS_ECO = 'ECO';
var FLIGHT_CLASS_BUSINESS = 'BUS';
var FLIGHT_CLASS_ALIZEE = 'EC+';
var FLIGHT_CLASS_EMERALD = 'DIB';
var FLIGHT_CLASS_FIRST = 'FIR';
var FLIGHT_CLASS_PREMIUM = 'PRE';
var ZERO_LAYOVERS_ICON = 'noStop';
var ONE_LAYOVERS_ICON = '1Stop';
var TWO_LAYOVERS_ICON = '2Stops';

/***/ }),

/***/ "dNjr":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("F9U4");
var requireObjectCoercible = __webpack_require__("4gXF");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "dnX/":
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__("a88S");

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),

/***/ "eHpp":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("H87J"),
    baseGet = __webpack_require__("w2Tz"),
    baseIteratee = __webpack_require__("S3pA"),
    baseMap = __webpack_require__("bFjY"),
    baseSortBy = __webpack_require__("4jPf"),
    baseUnary = __webpack_require__("SU8Q"),
    compareMultiple = __webpack_require__("5WP5"),
    identity = __webpack_require__("zWgn"),
    isArray = __webpack_require__("wxYD");

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),

/***/ "eN33":
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ "edYw":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var createNonEnumerableProperty = __webpack_require__("g51W");

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "ep/x":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("1YFU");

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),

/***/ "eu64":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ServicesLayer_ServicesLayer; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-waypoint/es/index.js
var react_waypoint_es = __webpack_require__("lTvC");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/views/booking/receipt/paid-services-list/paidService.constants.js
var paidService_constants = __webpack_require__("VawQ");

// EXTERNAL MODULE: ./src/client/views/booking/activities/chooseEquipment/ChooseEquipement.utils.js
var ChooseEquipement_utils = __webpack_require__("EgxT");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/widgets/activities-layer/Activities.utils.js
var Activities_utils = __webpack_require__("JE8a");

// EXTERNAL MODULE: ./src/client/components/utils/string/string.util.js
var string_util = __webpack_require__("tX1K");

// EXTERNAL MODULE: ./src/client/components/widgets/services-layer/ServicesContext.js
var ServicesContext = __webpack_require__("tjZu");

// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./logger/index.js
var logger = __webpack_require__("m0zD");
var logger_default = /*#__PURE__*/__webpack_require__.n(logger);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/widgets/service-block/ServiceBlock.jsx
var ServiceBlock = __webpack_require__("oOGh");

// EXTERNAL MODULE: ./src/client/components/utils/product/product.utils.js
var product_utils = __webpack_require__("C9cF");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js + 115 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// EXTERNAL MODULE: ./src/utils/currency-config-for-locale/currencyConfigForLocale.js
var currencyConfigForLocale = __webpack_require__("wz9x");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/FormikInput.jsx + 16 modules
var FormikInput = __webpack_require__("/HC4");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// CONCATENATED MODULE: ./src/client/components/widgets/reservation-block/reservationBlock.utils.js




var MORNING = 'MORNING';
var AFTERNOON_BEFORE_5PM = 'AFTERNOON_BEFORE_5PM';
var AFTERNOON_AFTER_5PM = 'AFTERNOON_AFTER_5PM';
var getSlotKey = function getSlotKey(_ref) {
  var slotName = _ref.slotName,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      attendeeId = _ref.attendeeId;
  return "".concat(slotName, "-").concat(startDate, "-").concat(endDate, "-").concat(attendeeId);
};
var reservationBlock_utils_getAttendeeLabel = function getAttendeeLabel(attendeesList, attendeeId, appContext) {
  var _ref2 = attendeesList.find(function (_ref3) {
    var id = _ref3.id;
    return id === attendeeId;
  }) || {},
      unicodeFirstName = _ref2.unicodeFirstName,
      firstName = _ref2.firstName,
      unicodeLastName = _ref2.unicodeLastName,
      lastName = _ref2.lastName,
      birthdate = _ref2.birthdate,
      isChild = _ref2.isChild;

  var attendeeFirstName = (unicodeFirstName === null || unicodeFirstName === void 0 ? void 0 : unicodeFirstName.trim()) || (firstName === null || firstName === void 0 ? void 0 : firstName.trim()) || '';
  var attendeeLastName = (unicodeLastName === null || unicodeLastName === void 0 ? void 0 : unicodeLastName.trim()) || (lastName === null || lastName === void 0 ? void 0 : lastName.trim()) || '';
  var attendeelabel = "".concat(String(attendeeFirstName)).concat(attendeeFirstName ? ' ' : '').concat(String(attendeeLastName));

  if (attendeelabel && Object(sellerUtils["g" /* isSeller */])(appContext) && isChild) {
    attendeelabel += " (".concat(Object(apiDate["e" /* formatApiDate */])(birthdate, Object(src_i18n["g" /* t */])('common.dateFormatTechnicalID')), ")");
  }

  return isChild && birthdate && !attendeelabel ? Object(src_i18n["g" /* t */])('booking.services.childcare.forWhatKid', {
    birthdate: Object(apiDate["e" /* formatApiDate */])(birthdate, Object(src_i18n["g" /* t */])('common.dateFormatTechnicalID'))
  }) : attendeelabel || "".concat(Object(src_i18n["g" /* t */])('booking.common.adult'), " ").concat(Object(string_util["g" /* upperCaseLetterToInt */])(attendeeId));
};
// CONCATENATED MODULE: ./src/client/components/widgets/reservation-block/DateSchedule.jsx
var __jsx = react_default.a.createElement;


var DateSchedule_DateSchedule = function DateSchedule(_ref) {
  var date = _ref.date;
  var momentDate = moment_default()(date);
  return __jsx("div", {
    className: "flex flex-col text-center"
  }, __jsx("div", null, momentDate.format('MMM').toUpperCase()), __jsx("div", {
    className: "text-base"
  }, momentDate.format('dd').toUpperCase()), __jsx("div", null, momentDate.format('DD')));
};
// CONCATENATED MODULE: ./src/client/components/widgets/reservation-block/ReservationSlotsStep.jsx

var ReservationSlotsStep_jsx = react_default.a.createElement;










var slotNotAvailable = {
  isPaid: false,
  isSelected: false,
  isDisabled: true
};
function ReservationSlotsStep(_ref) {
  var formik = _ref.formik;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useContext = Object(react["useContext"])(ServicesContext["a" /* ServicesContext */]),
      attendeesList = _useContext.attendeesList;

  return ReservationSlotsStep_jsx(react["Fragment"], null, // $FlowFixMe
  Object.entries(formik.values.attendees).map( // $FlowFixMe
  function (_ref2) {
    var _ref3 = Object(slicedToArray["a" /* default */])(_ref2, 2),
        attendeeId = _ref3[0],
        _ref3$ = _ref3[1],
        selected = _ref3$.selected,
        schedules = _ref3$.schedules;

    if (!selected) {
      return null;
    }

    var attendeeSelectedSchedules = schedules.filter(function (_ref4) {
      var isSelected = _ref4.isSelected,
          isPaid = _ref4.isPaid;
      return isSelected || isPaid;
    });
    attendeeSelectedSchedules.forEach(function (schedule) {
      // ugly fix #97990
      schedule.isSelected = true;
    });
    return ReservationSlotsStep_jsx(react["Fragment"], {
      key: attendeeId
    }, ReservationSlotsStep_jsx("div", {
      className: "my-px10"
    }, ReservationSlotsStep_jsx(Icon["a" /* Icon */], {
      name: icons["a" /* ICONS */].USER,
      width: "calc(15rem / 16)",
      className: "mr-px10"
    }), ReservationSlotsStep_jsx("span", null, reservationBlock_utils_getAttendeeLabel(attendeesList, attendeeId, appContext))), attendeeSelectedSchedules.map(function (_ref5, index) {
      var startDate = _ref5.startDate,
          endDate = _ref5.endDate;

      var _ref6 = formik.values.slots[getSlotKey({
        slotName: MORNING,
        startDate: startDate,
        endDate: endDate,
        attendeeId: attendeeId
      })] || slotNotAvailable,
          isMorningPaid = _ref6.isPaid,
          isMorningDisabled = _ref6.isDisabled;

      var _ref7 = formik.values.slots[getSlotKey({
        slotName: AFTERNOON_BEFORE_5PM,
        startDate: startDate,
        endDate: endDate,
        attendeeId: attendeeId
      })] || slotNotAvailable,
          isAfternoonPaid = _ref7.isPaid,
          isAfternoonDisabled = _ref7.isDisabled;

      var _ref8 = formik.values.slots[getSlotKey({
        slotName: AFTERNOON_AFTER_5PM,
        startDate: startDate,
        endDate: endDate,
        attendeeId: attendeeId
      })] || slotNotAvailable,
          isEveningPaid = _ref8.isPaid,
          isEveningDisabled = _ref8.isDisabled;

      var SLOTS = [{
        type: MORNING,
        isPaid: isMorningPaid,
        isDisabled: isMorningDisabled,
        title: 'morningTitle',
        subtitle: 'morningSubtitle'
      }, {
        type: AFTERNOON_BEFORE_5PM,
        isPaid: isAfternoonPaid,
        isDisabled: isAfternoonDisabled,
        title: 'afternoonTitle',
        subtitle: 'afternoonSubtitle'
      }, {
        type: AFTERNOON_AFTER_5PM,
        isPaid: isEveningPaid,
        isDisabled: isEveningDisabled,
        title: 'eveningTitle',
        subtitle: 'eveningSubtitle'
      }];
      return ReservationSlotsStep_jsx("div", {
        className: "flex",
        key: index
      }, ReservationSlotsStep_jsx("div", {
        className: "flex flex-col items-stretch border rounded-small mr-px10 mb-px10 py-px5 px-px10 text-xs font-bold border-blue bg-blue text-white"
      }, ReservationSlotsStep_jsx(DateSchedule_DateSchedule, {
        date: startDate
      }), startDate !== endDate && ReservationSlotsStep_jsx(react["Fragment"], null, ReservationSlotsStep_jsx("div", {
        className: "mx-px10"
      }, Object(src_i18n["g" /* t */])('memberSpace.upsell.activity.popinAddSchedules')), ReservationSlotsStep_jsx(DateSchedule_DateSchedule, {
        date: endDate
      }))), SLOTS.map(function (_ref9) {
        var type = _ref9.type,
            isDisabled = _ref9.isDisabled,
            isPaid = _ref9.isPaid,
            title = _ref9.title,
            subtitle = _ref9.subtitle;
        var attendeeSlotInputName = "slots.".concat(getSlotKey({
          slotName: type,
          startDate: startDate,
          endDate: endDate,
          attendeeId: attendeeId
        }), ".isSelected");
        return ReservationSlotsStep_jsx(FormikInput["a" /* FormikInput */], {
          isDisabled: isDisabled || isPaid,
          name: attendeeSlotInputName,
          type: "checkbox",
          className: "ReservationBlockStep-InputContainer items-stretch flex-grow",
          key: attendeeSlotInputName,
          placeholderComponent: function placeholderComponent(isChecked) {
            return ReservationSlotsStep_jsx("div", {
              className: classnames_default()('flex flex-col flex-grow justify-center items-stretch border rounded-small mr-px10 mb-px10 py-px5 px-px10 text-xs text-center', {
                'border-gray-light text-gray-darker': !isChecked && !isPaid,
                'border-blue bg-blue text-white': isChecked || isPaid,
                'italic opacity-50': isDisabled || isPaid
              })
            }, ReservationSlotsStep_jsx("div", {
              className: "font-bold uppercase"
            }, Object(src_i18n["g" /* t */])("booking.activities.timeSlot.".concat(title))), ReservationSlotsStep_jsx("div", {
              className: "text-xs"
            }, Object(src_i18n["g" /* t */])("booking.activities.timeSlot.".concat(subtitle))));
          }
        });
      }));
    }));
  }));
}
// CONCATENATED MODULE: ./src/client/components/widgets/reservation-block/ReservationScheduleStep.jsx

var ReservationScheduleStep_jsx = react_default.a.createElement;












var ReservationScheduleStep_ReservationScheduleStep = function ReservationScheduleStep(_ref) {
  var formik = _ref.formik,
      attendees = _ref.attendees;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useContext = Object(react["useContext"])(ServicesContext["a" /* ServicesContext */]),
      attendeesList = _useContext.attendeesList,
      showRentAllSchedules = _useContext.showRentAllSchedules,
      scheduleReservationMessage = _useContext.scheduleReservationMessage;

  Object(react["useEffect"])(function () {
    formik.validateForm();
    Object.entries(formik.values.attendees) // $FlowFixMe
    .filter(function (_ref2) {
      var _ref3 = Object(slicedToArray["a" /* default */])(_ref2, 2),
          selected = _ref3[1].selected;

      return !selected;
    }).forEach(function (_ref4) {
      var _ref5 = Object(slicedToArray["a" /* default */])(_ref4, 1),
          attendeeId = _ref5[0];

      formik.values.attendees[attendeeId].schedules.forEach(function (_ref6, scheduleIndex) {
        var isSelected = _ref6.isSelected;

        if (!isSelected) {
          return;
        }

        formik.setFieldValue("attendees.".concat(attendeeId, ".schedules[").concat(scheduleIndex, "].isSelected"), false);
      });
    });
    return function () {
      // when the component is unmount the validation is not triggered and the confirm button can stay disabled
      formik.validateForm();
    };
  }, []);
  var hasPaidSchedules = attendees.some(function (attendee) {
    return attendee.schedules.some(function (_ref7) {
      var timeSlots = _ref7.timeSlots;
      return timeSlots.some(function (_ref8) {
        var isPaid = _ref8.isPaid;
        return isPaid;
      });
    });
  });
  return ReservationScheduleStep_jsx(react["Fragment"], null, scheduleReservationMessage && ReservationScheduleStep_jsx("div", {
    className: "ml-px30 text-sm text-blue font-bold"
  }, scheduleReservationMessage), // $FlowFixMe
  !hasPaidSchedules && // $FlowFixMe
  Object.values(formik.values.attendees).filter(function (_ref9) {
    var selected = _ref9.selected;
    return selected;
  }).length > 1 && ReservationScheduleStep_jsx("div", {
    className: "mt-px15"
  }, ReservationScheduleStep_jsx(FormikInput["a" /* FormikInput */], {
    type: "checkbox",
    name: "sameScheduleForAll",
    label: Object(src_i18n["g" /* t */])('booking.activities.skiEquipment.sameScheduleAllParticipants'),
    onChange: function onChange(_ref10) {
      var target = _ref10.target;

      if (!target.checked) {
        return;
      }

      Object.keys(formik.values.attendees).forEach(function (attendeeId) {
        if (attendeeId === 'A') {
          return null;
        }

        formik.values.attendees[attendeeId].schedules.forEach(function (_, scheduleIndex) {
          // hack to fix weired formik bug when calling setFieldValue in onChange
          // @see https://github.com/jaredpalmer/formik/issues/2059
          dist["windowWrapper"].requestAnimationFrame(function () {
            formik.setFieldValue("attendees.".concat(attendeeId, ".schedules[").concat(scheduleIndex, "].isSelected"), formik.values.attendees.A.schedules[scheduleIndex].isSelected);
            formik.setFieldValue("wholeDurationOfStay.".concat(attendeeId), formik.values.wholeDurationOfStay.A);
          });
        });
      });
    }
  })), // $FlowFixMe
  Object.entries(formik.values.attendees).map( // $FlowFixMe
  function (_ref11) {
    var _ref12 = Object(slicedToArray["a" /* default */])(_ref11, 2),
        attendeeId = _ref12[0],
        _ref12$ = _ref12[1],
        selected = _ref12$.selected,
        schedules = _ref12$.schedules;

    if (!selected) {
      return null;
    }

    var attendeeSelectedSchedules = schedules.filter(function (_ref13) {
      var isSelected = _ref13.isSelected;
      return isSelected;
    });
    return ReservationScheduleStep_jsx("div", {
      key: attendeeId,
      className: "mt-px20 pt-px20 border-t border-gray-light"
    }, ReservationScheduleStep_jsx("div", null, ReservationScheduleStep_jsx(Icon["a" /* Icon */], {
      name: icons["a" /* ICONS */].USER,
      width: "calc(15rem / 16)",
      className: "mr-px10"
    }), reservationBlock_utils_getAttendeeLabel(attendeesList, attendeeId, appContext), showRentAllSchedules && ReservationScheduleStep_jsx(FormikInput["a" /* FormikInput */], {
      name: "wholeDurationOfStay.".concat(attendeeId),
      type: "checkbox",
      label: Object(src_i18n["g" /* t */])('booking.activities.skiEquipment.wholeDurationOfStay'),
      onChange: function onChange(_ref14) {
        var target = _ref14.target;
        schedules.forEach(function (_, scheduleIndex) {
          dist["windowWrapper"].requestAnimationFrame(function () {
            if (!formik.values.attendees[attendeeId].schedules[scheduleIndex].isPaid) {
              formik.setFieldValue("attendees.".concat(attendeeId, ".schedules[").concat(scheduleIndex, "].isSelected"), target.checked);
            }
          });

          if (!formik.values.sameScheduleForAll) {
            return;
          }

          Object.keys(formik.values.attendees).forEach(function (otherAttendeeId) {
            if (otherAttendeeId === attendeeId) {
              return null;
            }

            dist["windowWrapper"].requestAnimationFrame(function () {
              formik.setFieldValue("attendees.".concat(otherAttendeeId, ".schedules[").concat(scheduleIndex, "].isSelected"), target.checked);
              formik.setFieldValue("wholeDurationOfStay.".concat(otherAttendeeId), target.checked);
            });
          });
        });
      }
    })), ReservationScheduleStep_jsx("div", {
      className: "flex flex-wrap mt-px10"
    }, schedules.map(function (_ref15, scheduleIndex) {
      var startDate = _ref15.startDate,
          endDate = _ref15.endDate;
      var overlap = attendeeSelectedSchedules.some(function (attendeeSelectedSchedule) {
        return (attendeeSelectedSchedule.startDate !== startDate || attendeeSelectedSchedule.endDate !== endDate) && [Object(apiDate["h" /* momentFromApiDate */])(attendeeSelectedSchedule.startDate), Object(apiDate["h" /* momentFromApiDate */])(attendeeSelectedSchedule.endDate)].some(function (date) {
          return date.isBetween(Object(apiDate["h" /* momentFromApiDate */])(startDate), Object(apiDate["h" /* momentFromApiDate */])(endDate)) || date.isSame(Object(apiDate["h" /* momentFromApiDate */])(startDate)) || date.isSame(Object(apiDate["h" /* momentFromApiDate */])(endDate));
        });
      });
      var isDisabled = formik.values.attendees[attendeeId].schedules[scheduleIndex].isPaid || overlap;
      return ReservationScheduleStep_jsx(FormikInput["a" /* FormikInput */], {
        key: "".concat(startDate).concat(endDate),
        isDisabled: isDisabled,
        type: "checkbox",
        name: "attendees.".concat(attendeeId, ".schedules[").concat(scheduleIndex, "].isSelected"),
        onChange: function onChange(e) {
          var allSchedulesWillBeChecked = formik.values.attendees[attendeeId].schedules.filter(function (_ref16) {
            var isSelected = _ref16.isSelected;
            return isSelected;
          }).length === schedules.length - 1 && e.target.checked; // hack to fix weired formik bug when calling setFieldValue in onChange
          // @see https://github.com/jaredpalmer/formik/issues/2059

          dist["windowWrapper"].requestAnimationFrame(function () {
            formik.setFieldValue("wholeDurationOfStay.".concat(attendeeId), allSchedulesWillBeChecked);
          });

          if (!formik.values.sameScheduleForAll) {
            return;
          }

          Object.keys(formik.values.attendees).forEach(function (otherAttendeeId) {
            if (otherAttendeeId === attendeeId) {
              return null;
            }

            dist["windowWrapper"].requestAnimationFrame(function () {
              formik.setFieldValue("attendees.".concat(otherAttendeeId, ".schedules[").concat(scheduleIndex, "].isSelected"), e.target.checked);
              formik.setFieldValue("wholeDurationOfStay.".concat(otherAttendeeId), allSchedulesWillBeChecked);
            });
          });
        },
        placeholderComponent: function placeholderComponent(isChecked) {
          return ReservationScheduleStep_jsx("div", {
            "data-testid": "reservationScheduleDay",
            className: classnames_default()('flex items-center border rounded-small mr-px10 mb-px10 py-px5 px-px10 text-xs font-bold', {
              'border-gray-light text-gray-darker': !isChecked,
              'border-blue bg-blue text-white': isChecked,
              'italic opacity-50': isDisabled
            })
          }, ReservationScheduleStep_jsx(DateSchedule_DateSchedule, {
            date: startDate
          }), startDate !== endDate && ReservationScheduleStep_jsx(react["Fragment"], null, ReservationScheduleStep_jsx("div", {
            className: "mx-px10"
          }, Object(src_i18n["g" /* t */])('memberSpace.upsell.activity.popinAddSchedules')), ReservationScheduleStep_jsx(DateSchedule_DateSchedule, {
            date: endDate
          })));
        }
      });
    })));
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/reservation-block/ReservationBlock.jsx


var ReservationBlock_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable no-shadow */


















var TIMESLOT_REGEX = /([a-z0-9_]+)-([0-9]{8})-([0-9]{8})-([a-z])/;
var STEPS = {
  SCHEDULES: 'SCHEDULES',
  ATTENDEES: 'ATTENDEES',
  SLOTS: 'SLOTS'
};
var ReservationBlock_ReservationBlock = function ReservationBlock(_ref) {
  var headerLabel = _ref.headerLabel,
      introductionLabel = _ref.introductionLabel,
      rentButtonLabel = _ref.rentButtonLabel,
      onSubmit = _ref.onSubmit,
      service = _ref.service;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useContext = Object(react["useContext"])(ServicesContext["a" /* ServicesContext */]),
      attendeesList = _useContext.attendeesList,
      currency = _useContext.currency;

  var _useState = Object(react["useState"])(STEPS.ATTENDEES),
      showStep = _useState[0],
      setShowStep = _useState[1];

  var hasMultiSlots = service.schedules.some(function (schedule) {
    return schedule.slots.length > 1;
  });
  var schedules = service.schedules.sort(function (a, b) {
    return Number(a.startDate) - Number(b.startDate);
  });
  var serviceType = service.type; // Same type for all services

  var hasMultiSchedules = schedules.length > 1;
  var attendees = service.attendees,
      productInfoId = service.id;
  var hasReservedSchedule = service.attendees.some(function (attendee) {
    return attendee.schedules.some(function (_ref2) {
      var isPartiallyRented = _ref2.isPartiallyRented;
      return isPartiallyRented;
    });
  });
  var initialFormValues = {
    sameScheduleForAll: false,
    attendees: attendees.reduce(function (initialValues, _ref3) {
      var id = _ref3.id,
          price = _ref3.price,
          schedules = _ref3.schedules;
      return _objectSpread(_objectSpread({}, initialValues), {}, Object(defineProperty["a" /* default */])({}, id, {
        selected: schedules.some(function (schedule) {
          return schedule.isPartiallyPaid;
        }) || schedules.some(function (schedule) {
          return schedule.isPartiallyRented;
        }),
        isPaid: schedules.every(function (schedule) {
          return schedule.isFullyPaid;
        }),
        price: price.value,
        schedules: schedules.map(function (schedule) {
          var commonValues = {
            isPaid: schedule.isPartiallyPaid,
            isFullyPaid: schedule.isFullyPaid,
            startDate: schedule.startDate,
            endDate: schedule.endDate,
            timeSlots: schedule.timeSlots.map(function (slot) {
              return slot.slotName;
            })
          };
          return hasMultiSchedules ? _objectSpread({
            isSelected: schedule.isPartiallyRented || schedule.isPartiallyPaid
          }, commonValues) : _objectSpread({
            isSelected: true
          }, commonValues);
        })
      }));
    }, {}),
    wholeDurationOfStay: attendees.reduce(function (wholeDurationOfStay, _ref4) {
      var id = _ref4.id,
          schedules = _ref4.schedules;
      return _objectSpread(_objectSpread({}, wholeDurationOfStay), {}, Object(defineProperty["a" /* default */])({}, id, schedules.every(function (schedule) {
        return schedule.isFullyRented;
      })));
    }, {}),
    slots: attendees.reduce(function (slots, attendee) {
      var id = attendee.id;
      return attendee.schedules.reduce(function (accumulatedSchedules, schedule) {
        var startDate = schedule.startDate,
            endDate = schedule.endDate,
            timeSlots = schedule.timeSlots;
        return timeSlots.reduce(function (accumulatedSlots, _ref5) {
          var slotName = _ref5.slotName,
              serviceId = _ref5.id,
              isPaid = _ref5.isPaid,
              isRented = _ref5.isRented,
              price = _ref5.price;
          accumulatedSlots[getSlotKey({
            slotName: slotName,
            startDate: startDate,
            endDate: endDate,
            attendeeId: id
          })] = {
            productInfoId: productInfoId,
            serviceId: serviceId,
            isSelected: isPaid || isRented,
            isPaid: isPaid,
            price: price.value
          };
          return accumulatedSlots;
        }, accumulatedSchedules);
      }, slots);
    }, {})
  };

  var validateForm = function validateForm(formValues) {
    var errors = {};

    if (showStep === STEPS.ATTENDEES && (!hasReservedSchedule || hasMultiSchedules || hasMultiSlots) && // $FlowFixMe
    !Object.values(formValues.attendees).some(function (_ref6) {
      var selected = _ref6.selected,
          isPaid = _ref6.isPaid;
      return selected && !isPaid;
    })) {
      errors.attendees = true;
    }

    if (hasMultiSchedules && showStep === STEPS.SCHEDULES && (!hasReservedSchedule || hasMultiSlots) && !Object.values(formValues.attendees).every( // $FlowFixMe
    function (_ref7) {
      var selected = _ref7.selected,
          attendeeSchedules = _ref7.schedules;
      return !selected || selected && Object.values(attendeeSchedules).some( // $FlowFixMe :'(
      function (_ref8) {
        var isSelected = _ref8.isSelected;
        return isSelected;
      }) || Object.values(attendeeSchedules).every( // $FlowFixMe :'(
      function (_ref9) {
        var isFullyPaid = _ref9.isFullyPaid;
        return isFullyPaid;
      });
    })) {
      errors.schedules = true;
    }

    if (showStep === STEPS.SLOTS) {
      if (!hasReservedSchedule && (!Object.entries(formValues.slots).length === 0 || // $FlowFixMe
      !Object.values(formValues.slots).some(function (_ref10) {
        var isSelected = _ref10.isSelected,
            isPaid = _ref10.isPaid;
        return isSelected && !isPaid;
      }))) {
        errors.slots = true;
      }
    }

    return errors;
  };

  var handleFormSubmit = function handleFormSubmit(values) {
    var serviceIds = [];
    var attendeeIds = [];
    var attendeesReservations = Object.entries(values.slots).reduce(function (attendeesReservations, _ref11) {
      var _ref12 = Object(slicedToArray["a" /* default */])(_ref11, 2),
          slotKey = _ref12[0],
          slot = _ref12[1];

      var timeSlotRegex = new RegExp(TIMESLOT_REGEX, 'gi'); // $FlowFixMe

      var _timeSlotRegex$exec = timeSlotRegex.exec(slotKey),
          _timeSlotRegex$exec2 = Object(slicedToArray["a" /* default */])(_timeSlotRegex$exec, 5),
          timeSlotStartDate = _timeSlotRegex$exec2[2],
          timeSlotEndDate = _timeSlotRegex$exec2[3],
          timeSlotCustomerId = _timeSlotRegex$exec2[4]; // $FlowFixMe


      if (!serviceIds.includes(slot.serviceId)) {
        // $FlowFixMe
        serviceIds.push(slot.serviceId);
      }

      if (!attendeeIds.includes(timeSlotCustomerId)) {
        attendeeIds.push(timeSlotCustomerId);
      }

      var attendee = values.attendees[timeSlotCustomerId];
      var currentSchedule = attendee.schedules.find(function (_ref13) {
        var startDate = _ref13.startDate,
            endDate = _ref13.endDate;
        return startDate === timeSlotStartDate && endDate === timeSlotEndDate;
      });

      if (attendee.selected && attendee.schedules.length === 1 || attendee.selected && currentSchedule.isSelected && ( // $FlowFixMe
      currentSchedule.timeSlots.length === 1 || slot.isSelected)) {
        var schedule = {
          startDate: timeSlotStartDate,
          endDate: timeSlotEndDate,
          // $FlowFixMe
          slots: [slot.serviceId]
        };
        var attendeeIndex = attendeesReservations.findIndex(function (_ref14) {
          var customerId = _ref14.customerId;
          return customerId === timeSlotCustomerId;
        });

        if (attendeeIndex === -1) {
          attendeesReservations.push({
            customerId: timeSlotCustomerId,
            productInfoId: productInfoId,
            schedules: [schedule]
          });
        } else {
          var scheduleIndex = attendeesReservations[attendeeIndex].schedules.findIndex(function (schedule) {
            return schedule.startDate === timeSlotStartDate && schedule.endDate === timeSlotEndDate;
          });

          if (scheduleIndex === -1) {
            attendeesReservations[attendeeIndex].schedules.push(schedule);
          } else {
            attendeesReservations[attendeeIndex].schedules[scheduleIndex].slots.push( // $FlowFixMe
            slot.serviceId);
          }
        }
      }

      return attendeesReservations;
    }, []);
    onSubmit(attendeesReservations, serviceIds, attendeeIds);
  };

  var getTotalPriceReserved = function getTotalPriceReserved(formValues) {
    if ((hasMultiSlots && showStep === STEPS.SLOTS || !hasMultiSlots && hasMultiSchedules && showStep === STEPS.SCHEDULES || !hasMultiSlots && !hasMultiSchedules && showStep === STEPS.ATTENDEES) && formValues.slots) {
      return service.attendees.reduce(function (totalPrice, attendee) {
        return totalPrice + attendee.schedules.reduce(function (priceAttendeeSchedule, schedule) {
          return priceAttendeeSchedule + schedule.timeSlots.reduce(function (price, _ref15) {
            var _formValues$attendees;

            var slotName = _ref15.slotName,
                slotPrice = _ref15.price;
            var _formValues$slots$get = formValues.slots[getSlotKey({
              slotName: slotName,
              startDate: schedule.startDate,
              endDate: schedule.endDate,
              attendeeId: attendee.id
            })],
                isSlotPaid = _formValues$slots$get.isPaid,
                isSlotSelected = _formValues$slots$get.isSelected;
            var isAttendeeSelected = formValues.attendees[attendee.id].selected;
            var isScheduleSelected = (_formValues$attendees = formValues.attendees[attendee.id].schedules.find(function (s) {
              return s.startDate === schedule.startDate && s.endDate === schedule.endDate;
            })) === null || _formValues$attendees === void 0 ? void 0 : _formValues$attendees.isSelected;
            var attendeePrice = isAttendeeSelected && isScheduleSelected && (!hasMultiSlots && hasMultiSchedules && showStep === STEPS.SCHEDULES || !hasMultiSlots && !hasMultiSchedules && showStep === STEPS.ATTENDEES || hasMultiSlots && isSlotSelected && !isSlotPaid) ? slotPrice.value : 0;
            return price + attendeePrice;
          }, 0);
        }, 0);
      }, 0);
    }

    return 0;
  };

  return ReservationBlock_jsx("div", {
    className: "PopInParticipants"
  }, ReservationBlock_jsx("div", {
    className: "PopInParticipants-header"
  }, headerLabel), ReservationBlock_jsx("div", {
    className: "PopInParticipants-step"
  }, ReservationBlock_jsx(formik_esm["d" /* Formik */], {
    initialValues: initialFormValues,
    isInitialValid: Object.keys(validateForm(initialFormValues)).length === 0,
    validate: validateForm,
    onSubmit: handleFormSubmit
  }, function (formik) {
    var totalPrice = getTotalPriceReserved(formik.values);
    return ReservationBlock_jsx("div", {
      className: "PopInParticipants-stepContent"
    }, ReservationBlock_jsx("div", {
      className: classnames_default()('PopInParticipants-introduction', {
        'text-blue': showStep === STEPS.ATTENDEES,
        'text-gray-dark': showStep === STEPS.SCHEDULES
      })
    }, hasMultiSchedules && ReservationBlock_jsx(react["Fragment"], null, "1", ReservationBlock_jsx("span", {
      className: "PopInParticipants-introduction--small"
    }, "/", hasMultiSlots ? 3 : 2), ReservationBlock_jsx("span", null, "\xA0-\xA0")), introductionLabel, showStep === STEPS.SCHEDULES && ReservationBlock_jsx("span", {
      onClick: function onClick() {
        return setShowStep(STEPS.ATTENDEES);
      },
      className: "cursor-pointer whitespace-no-wrap text-blue-active ml-px10"
    }, ReservationBlock_jsx(Icon["a" /* Icon */], {
      name: icons["a" /* ICONS */].PEN,
      width: "calc(20rem / 16)",
      className: "PopInParticipants-editButtonIcon"
    }), ReservationBlock_jsx("span", {
      className: "underline"
    }, Object(src_i18n["g" /* t */])('common.edit')))), ReservationBlock_jsx(lib["UnmountClosed"], {
      isOpened: showStep === STEPS.ATTENDEES
    }, attendees.map(function (attendee) {
      return ReservationBlock_jsx("div", {
        key: attendee.id,
        className: "PopInParticipants-section"
      }, ReservationBlock_jsx(FormikInput["a" /* FormikInput */], {
        type: "checkbox",
        name: "attendees.".concat(attendee.id, ".selected"),
        isDisabled: attendee.schedules.every(function (_ref16) {
          var isFullyPaid = _ref16.isFullyPaid;
          return isFullyPaid;
        }),
        label: ReservationBlock_jsx("div", {
          className: "flex justify-between"
        }, reservationBlock_utils_getAttendeeLabel(attendeesList, attendee.id, appContext), ReservationBlock_jsx("span", {
          className: "text-blue px-px10"
        }, attendee.price.formattedValue)),
        onChange: function onChange(_ref17) {
          var target = _ref17.target;

          if (!target.checked) {
            // make sure alls slots are unchecked on attendee unselection
            Object.keys(formik.values.slots).forEach(function (slotKey) {
              var timeSlotRegex = new RegExp(TIMESLOT_REGEX, 'gi'); // $FlowFixMe

              var _timeSlotRegex$exec3 = timeSlotRegex.exec(slotKey),
                  _timeSlotRegex$exec4 = Object(slicedToArray["a" /* default */])(_timeSlotRegex$exec3, 5),
                  timeSlotCustomerId = _timeSlotRegex$exec4[4];

              if (timeSlotCustomerId && timeSlotCustomerId === attendee.id) {
                formik.setFieldValue("slots.".concat(slotKey, ".isSelected"), false);
              }
            });
          }
        }
      }));
    })), hasMultiSchedules && showStep !== STEPS.ATTENDEES && ReservationBlock_jsx("div", {
      className: "text-blue PopInParticipants-introduction -mx-px20 px-px20 mt-px15 pt-px15 border-t border-gray-light"
    }, "2", ReservationBlock_jsx("span", {
      className: "PopInParticipants-introduction--small"
    }, "/", hasMultiSlots ? 3 : 2), ReservationBlock_jsx("span", null, "\xA0-\xA0"), Object(src_i18n["g" /* t */])("booking.activities.".concat(Object(Activities_utils["b" /* getServiceCmsKeyPath */])(serviceType), ".registrationDates")), showStep === STEPS.SLOTS && ReservationBlock_jsx("span", {
      onClick: function onClick() {
        return setShowStep(STEPS.SCHEDULES);
      },
      className: "cursor-pointer whitespace-no-wrap text-blue-active ml-px10"
    }, ReservationBlock_jsx(Icon["a" /* Icon */], {
      name: icons["a" /* ICONS */].PEN,
      width: "calc(20rem / 16)",
      className: "PopInParticipants-editButtonIcon"
    }), ReservationBlock_jsx("span", {
      className: "underline"
    }, Object(src_i18n["g" /* t */])('common.edit')))), ReservationBlock_jsx(lib["UnmountClosed"], {
      isOpened: showStep === STEPS.SCHEDULES
    }, ReservationBlock_jsx(ReservationScheduleStep_ReservationScheduleStep, {
      formik: formik,
      attendees: attendees
    })), showStep === STEPS.SLOTS && ReservationBlock_jsx("div", {
      className: "text-blue PopInParticipants-introduction -mx-px20 px-px20 mt-px15 pt-px15 border-t border-gray-light"
    }, "3", ReservationBlock_jsx("span", {
      className: "PopInParticipants-introduction--small"
    }, "/3"), ReservationBlock_jsx("span", null, "\xA0-\xA0"), Object(src_i18n["g" /* t */])('booking.activities.timeSlot.title')), ReservationBlock_jsx(lib["UnmountClosed"], {
      isOpened: showStep === STEPS.SLOTS
    }, ReservationBlock_jsx(ReservationSlotsStep, {
      formik: formik
    })), ReservationBlock_jsx(Button["a" /* Button */], {
      dataTestId: "ReservationBlock-validationBtn",
      className: classnames_default()('PopInParticipants-cta mx-auto', {
        'mt-px20': showStep === STEPS.SCHEDULES
      }),
      colorBg: colors["a" /* COLORS */].TURQUOISE,
      isDisabled: !formik.isValid,
      onClick: function onClick() {
        if (hasMultiSchedules && showStep === STEPS.ATTENDEES && // $FlowFixMe
        Object.values(formik.values.attendees).some(function (_ref18) {
          var selected = _ref18.selected;
          return selected;
        })) {
          setShowStep(STEPS.SCHEDULES);
          formik.setErrors({
            schedules: true
          });
        } else if (showStep === STEPS.SCHEDULES && hasMultiSlots) {
          setShowStep(STEPS.SLOTS);
          formik.setErrors({
            slots: true
          });
        } else if (!formik.dirty) {
          // if the user has not touch the form we just call onSubmit with no value (to close the pop-in)
          // $FlowFixMe
          onSubmit();
        } else {
          formik.submitForm();
        }
      }
    }, hasMultiSchedules && showStep === STEPS.ATTENDEES ? Object(src_i18n["g" /* t */])("booking.activities.".concat(Object(Activities_utils["b" /* getServiceCmsKeyPath */])(serviceType), ".chooseWhen")) : ReservationBlock_jsx(react["Fragment"], null, totalPrice > 0 ? ReservationBlock_jsx(TemplateString["a" /* TemplateString */], {
      template: rentButtonLabel,
      values: {
        price: Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(totalPrice, appContext.locale, currency)
      }
    }) : Object(src_i18n["g" /* t */])('booking.common.validate'))));
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/reservation-block/PopInReservationBlock.jsx


var PopInReservationBlock_jsx = react_default.a.createElement;




var PopInReservationBlock_PopInReservationBlock = function PopInReservationBlock(_ref) {
  var onClose = _ref.onClose,
      _onSubmit = _ref.onSubmit,
      otherProps = Object(objectWithoutProperties["a" /* default */])(_ref, ["onClose", "onSubmit"]);

  return PopInReservationBlock_jsx(Modal["a" /* Modal */], {
    ariaLabel: otherProps.headerLabel,
    closeLabel: Object(src_i18n["g" /* t */])('common.close'),
    onClose: onClose,
    size: "small"
  }, PopInReservationBlock_jsx(ReservationBlock_ReservationBlock, Object(esm_extends["a" /* default */])({}, otherProps, {
    onSubmit: function onSubmit(service, serviceIds, attendeeIds) {
      if (service) {
        _onSubmit(service, serviceIds, attendeeIds);
      }

      onClose();
    }
  })));
};
// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// CONCATENATED MODULE: ./src/client/components/widgets/activities-layer/services-list/ServiceWrapper.jsx




var ServiceWrapper_jsx = react_default.a.createElement;














var ServiceWrapper_ServiceWrapper = function ServiceWrapper(_ref) {
  var _resort$activityCateg, _activityCategories$f;

  var subCategoryId = _ref.subCategoryId,
      productInfo = _ref.productInfo,
      i18n = _ref.i18n,
      pricingInfo = _ref.pricingInfo,
      track = _ref.track;

  var _useContext = Object(react["useContext"])(ReactAppContext["a" /* default */]),
      locale = _useContext.locale,
      isCmta = _useContext.isCmta;

  var _useContext2 = Object(react["useContext"])(ServicesContext["a" /* ServicesContext */]),
      updateService = _useContext2.updateService,
      hideAgeServiceSlot = _useContext2.hideAgeServiceSlot,
      isPriceForAdultOnly = _useContext2.isPriceForAdultOnly,
      currentCategoryId = _useContext2.currentCategoryId;

  var _useState = Object(react["useState"])(false),
      showPopInReservation = _useState[0],
      setShowPopInReservation = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      requestRunning = _useState2[0],
      setRequestRunning = _useState2[1];

  var resort = Object(es["e" /* useSelector */])(booking_selector["l" /* getCurrentResort */]);

  var _useSelector = Object(es["e" /* useSelector */])(booking_selector["k" /* getCurrentProposal */]),
      arrivalDate = _useSelector.arrivalDate,
      departureDate = _useSelector.departureDate;

  var activityCategories = resort === null || resort === void 0 ? void 0 : (_resort$activityCateg = resort.activityCategories) === null || _resort$activityCateg === void 0 ? void 0 : _resort$activityCateg.leisure;
  var currentActivitySubCategories = activityCategories === null || activityCategories === void 0 ? void 0 : (_activityCategories$f = activityCategories.find(function (activityCategory) {
    return activityCategory.id === currentCategoryId;
  })) === null || _activityCategories$f === void 0 ? void 0 : _activityCategories$f.subCategories;
  var currentActivitySubCategory = currentActivitySubCategories === null || currentActivitySubCategories === void 0 ? void 0 : currentActivitySubCategories.find(function (_ref2) {
    var id = _ref2.id;
    return id === subCategoryId;
  });

  var getServiceAgeLabel = function getServiceAgeLabel(service) {
    if (!service.ageInMonths || !service.ageInMonths.min) {
      return Object(src_i18n["g" /* t */])('booking.activities.forAllAges');
    }

    if (service.ageInMonths.max) {
      // $FlowFixMe stupid flow
      return Object(product_utils["e" /* getServiceAgesLabel */])(service.ageInMonths, i18n);
    }

    if (service.ageInMonths.min < 23) {
      return Object(src_i18n["g" /* t */])('booking.activities.ageFromMonths', {
        amount: service.ageInMonths.min
      });
    }

    return Object(src_i18n["g" /* t */])('booking.activities.ageFrom', {
      age: Math.floor(service.ageInMonths.min / 12)
    });
  };

  var startingPricePerAdult = pricingInfo && Object(currencyConfigForLocale["a" /* formatAmount */])(pricingInfo.startingPricePerAdult.value, pricingInfo.startingPricePerAdult.currency, locale);

  var getDisabledLabel = function getDisabledLabel() {
    var _ref3 = currentActivitySubCategory || {},
        startDate = _ref3.startDate,
        endDate = _ref3.endDate;

    if (productInfo.isIncluded) {
      return Object(src_i18n["g" /* t */])('common.included');
    }

    if (startDate && endDate && moment_default()(arrivalDate).isAfter(startDate) && moment_default()(departureDate).isAfter(endDate)) {
      return Object(src_i18n["g" /* t */])('booking.activities.unavailableActivity');
    }

    return Object(src_i18n["g" /* t */])("booking".concat(isCmta ? '.partners' : '', ".activities.bookInResort"));
  };

  return ServiceWrapper_jsx(react["Fragment"], null, ServiceWrapper_jsx(ServiceBlock["a" /* ServiceBlock */], Object(esm_extends["a" /* default */])({
    className: "mx-px10",
    isPriceForAdultOnly: isPriceForAdultOnly,
    i18n: i18n,
    isValidated: pricingInfo && (pricingInfo.isPartiallyRented || pricingInfo.isPartiallyPaid),
    header: productInfo.isIncluded ? {
      label: Object(src_i18n["g" /* t */])('booking.childcarePopIn.includedChildcare'),
      color: '#005589',
      icon: icons["a" /* ICONS */].ALL_INCLUSIVE,
      header: 'large'
    } : {
      label: Object(src_i18n["g" /* t */])('booking.childcarePopIn.onDemandChildcare'),
      color: '#b95e06',
      icon: icons["a" /* ICONS */].ON_DEMAND,
      header: 'large'
    },
    equipment: {
      label: productInfo.label,
      longDescription: productInfo.description || productInfo.practiceLevelDescription ? // this div is need to don't degrade the animation framerate of serviceBlock's collapse
      ServiceWrapper_jsx("div", null, productInfo.description && ServiceWrapper_jsx("div", {
        className: "pt-px15"
      }, ServiceWrapper_jsx("div", {
        className: "text-blue font-bold"
      }, Object(src_i18n["g" /* t */])('booking.activities.descriptionTitle'), " :"), ServiceWrapper_jsx("div", null, productInfo.description)), productInfo.practiceLevelDescription && ServiceWrapper_jsx("div", {
        className: "pt-px15"
      }, ServiceWrapper_jsx("div", {
        className: "text-blue font-bold"
      }, Object(src_i18n["g" /* t */])('booking.activities.levelTitle')), ServiceWrapper_jsx("div", null, productInfo.practiceLevelDescription))) : undefined
    },
    slots: [].concat(Object(toConsumableArray["a" /* default */])(productInfo.durationDescription ? [{
      icon: icons["a" /* ICONS */].DURATION,
      label: productInfo.durationDescription
    }] : []), Object(toConsumableArray["a" /* default */])(productInfo.practiceLevels && productInfo.practiceLevels.length > 0 ? [{
      icon: icons["a" /* ICONS */].LEVEL,
      label: productInfo.practiceLevels[0].label
    }] : []), Object(toConsumableArray["a" /* default */])(productInfo.sizes && productInfo.sizes.min ? [{
      icon: icons["a" /* ICONS */].SIZE,
      label: "".concat(productInfo.sizes.min).concat(productInfo.sizes.max ? ' - ' + productInfo.sizes.max : '', " ").concat(productInfo.sizes.unit)
    }] : []), Object(toConsumableArray["a" /* default */])(!hideAgeServiceSlot ? [{
      icon: icons["a" /* ICONS */].DATE_STAR,
      label: getServiceAgeLabel(productInfo)
    }] : [])),
    style: {
      width: 'calc(280rem / 16)'
    }
  }, pricingInfo ? {
    addLabel: Object(src_i18n["g" /* t */])('booking.common.addPrice', {
      price: startingPricePerAdult
    }),
    removeLabel: Object(src_i18n["g" /* t */])('booking.common.editPrice', {
      price: Object(currencyConfigForLocale["a" /* formatAmount */])(pricingInfo.rentedAmount.value, pricingInfo.rentedAmount.currency, locale)
    }),
    type: pricingInfo.isPartiallyRented ? 'edit' : pricingInfo.isFullyPaid && 'none' || 'add',
    button: {
      onClick: function onClick() {
        track(pricingInfo.isPartiallyRented);
        setShowPopInReservation(true);
      },
      isLoading: requestRunning
    }
  } : {
    type: 'disabled',
    button: {
      label: getDisabledLabel()
    }
  })), pricingInfo && showPopInReservation && ServiceWrapper_jsx(PopInReservationBlock_PopInReservationBlock, {
    onClose: function onClose() {
      return setShowPopInReservation(false);
    },
    onSubmit: /*#__PURE__*/function () {
      var _ref4 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(updatedService, serviceIds, attendeeIds) {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setRequestRunning(true);
                _context.prev = 1;
                _context.next = 4;
                return updateService(updatedService, pricingInfo, serviceIds, attendeeIds);

              case 4:
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](1);
                logger_default.a.error(_context.t0);

              case 9:
                _context.prev = 9;
                setRequestRunning(false);
                return _context.finish(9);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 6, 9, 12]]);
      }));

      return function (_x, _x2, _x3) {
        return _ref4.apply(this, arguments);
      };
    }(),
    service: pricingInfo,
    headerLabel: productInfo.label,
    introductionLabel: Object(src_i18n["g" /* t */])("booking.activities.".concat(Object(Activities_utils["b" /* getServiceCmsKeyPath */])(pricingInfo.type), ".registration")),
    rentButtonLabel: Object(src_i18n["g" /* t */])('booking.common.addPrice')
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/activities-layer/services-list/ServicesScrollable.jsx
var ServicesScrollable_jsx = react_default.a.createElement;










var ServicesScrollable_ServicesScrollable = function ServicesScrollable(_ref) {
  var services = _ref.services,
      categoryLabel = _ref.categoryLabel,
      subCategoryId = _ref.subCategoryId,
      i18n = _ref.i18n;

  var _useContext = Object(react["useContext"])(ServicesContext["a" /* ServicesContext */]),
      trackingData = _useContext.trackingData;

  var _track = Object(useTracking["a" /* useTracking */])(trackingData);

  return ServicesScrollable_jsx(Scrollable["a" /* Scrollable */], {
    backwardLabel: Object(src_i18n["g" /* t */])('common.scrollBackward'),
    forwardLabel: Object(src_i18n["g" /* t */])('common.scrollForward'),
    navPosition: "center",
    hasNoMouseWheelScroll: true
  }, ServicesScrollable_jsx("div", {
    className: "flex py-px15",
    "data-testid": "ActivitiesScrollable_".concat(Object(Activities_utils["a" /* formatLabelForGA */])(categoryLabel))
  }, services.map(function (service) {
    return ServicesScrollable_jsx(ServiceWrapper_ServiceWrapper, {
      key: service.productInfo.id,
      subCategoryId: subCategoryId,
      productInfo: service.productInfo,
      pricingInfo: service.pricingInfo,
      i18n: i18n,
      track: function track(isEditing) {
        if (!service.pricingInfo) {
          return;
        }

        var category = service.pricingInfo.type.toLowerCase();

        if (category === paidService_constants["a" /* PAID_SERVICE */].RENTAL) {
          _track({
            labelGA: "".concat(ChooseEquipement_utils["a" /* RENTAL_LABELS */][service.productInfo.useCase.id], "_").concat( // $FlowFixMe 🤬🤬🤬🤬🤬🤬🤬
            service.pricingInfo.isPartiallyRented ? 'edit' : 'add', "_").concat(service.productInfo.typeId)
          });
        } else {
          _track({
            labelGA: "".concat(isEditing ? 'editActivity' : 'addActivity', "_").concat(Object(string_util["d" /* snakeToCamel */])(category || ''))
          });
        }
      }
    });
  })));
};
// EXTERNAL MODULE: ./src/client/store/toast/toast.actions.js
var toast_actions = __webpack_require__("7Z8V");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/frameworks/tabs/Tabs.jsx + 1 modules
var Tabs = __webpack_require__("4/4b");

// EXTERNAL MODULE: ./src/client/components/widgets/services-layer/serviceLayer.utils.js
var serviceLayer_utils = __webpack_require__("X7tq");

// CONCATENATED MODULE: ./src/client/components/widgets/services-layer/ServicesLayer.jsx

var ServicesLayer_jsx = react_default.a.createElement;













var MAX_AGE_IN_MONTHS_FOR_CHILD_EQUIPMENT = 144;
var ServicesLayer_ServicesLayer = function ServicesLayer(_ref) {
  var i18n = _ref.i18n,
      services = _ref.services,
      initialCategoryIdToShow = _ref.initialCategoryIdToShow,
      _ref$hasBackgroundMas = _ref.hasBackgroundMask,
      hasBackgroundMask = _ref$hasBackgroundMas === void 0 ? true : _ref$hasBackgroundMas;

  var _useContext = Object(react["useContext"])(ServicesContext["a" /* ServicesContext */]),
      trackingData = _useContext.trackingData;

  var dispatch = Object(es["d" /* useDispatch */])();
  var serviceCategoriesBlocks = Object(react["useRef"])({});
  var track = Object(useTracking["a" /* useTracking */])(trackingData);

  var _useState = Object(react["useState"])(initialCategoryIdToShow || services[0] && services[0].id),
      currentServiceCategoryId = _useState[0],
      setCurrentActivityId = _useState[1];

  var scrollTActivity = function scrollTActivity(activityId) {
    serviceCategoriesBlocks.current[activityId].scrollIntoView();
  };

  Object(react["useEffect"])(function () {
    if (initialCategoryIdToShow) {
      scrollTActivity(currentServiceCategoryId);
    }

    return function () {
      dispatch({
        type: toast_actions["a" /* CLOSE_TOAST */]
      });
    };
  }, []); // prevent the waypoint to fire multiple time with wrong value when the user click on a category
  // and instant scroll to it

  var debouncedSetCurrentActivityId = Object(lodash["debounce"])(function (activityIdCategoryId) {
    setCurrentActivityId(activityIdCategoryId);
  }, 0, {
    leading: true,
    trailing: false
  }); // $FlowFixMe always found

  var currentServiceCategory = services.find(function (_ref2) {
    var id = _ref2.id;
    return id === currentServiceCategoryId;
  });
  return ServicesLayer_jsx("div", {
    className: "ActivitiesList"
  }, ServicesLayer_jsx("div", {
    className: "ActivitiesList-wrapper"
  }, ServicesLayer_jsx("div", {
    className: "ActivitiesList-header",
    style: {
      backgroundImage: "".concat(hasBackgroundMask ? 'linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)),' : '', "url(").concat(serviceLayer_utils["a" /* servicesConfiguration */][currentServiceCategory.id] ? serviceLayer_utils["a" /* servicesConfiguration */][currentServiceCategory.id].image : currentServiceCategory.imageUrl, ")")
    }
  }, services.map(function (serviceCategory) {
    return ServicesLayer_jsx("button", {
      key: serviceCategory.id,
      type: "button",
      onClick: function onClick() {
        setCurrentActivityId(serviceCategory.id);
        scrollTActivity(serviceCategory.id);
        track({
          labelGA: serviceCategory.label.toLowerCase()
        });
      },
      className: classnames_default()('reset-button font-brand text-white px-px30 pt-px20 pb-px15 text-left text-2xl underline whitespace-no-wrap md:whitespace-normal leading-one z-1', {
        'bg-blue no-underline text-4xl': serviceCategory.id === currentServiceCategoryId
      })
    }, serviceCategory.label || Object(src_i18n["g" /* t */])('booking.activities.otherActivities'));
  })), ServicesLayer_jsx("div", {
    className: "ActivitiesList-sectionsContent"
  }, ServicesLayer_jsx("div", {
    className: "ActivitiesList-sectionsContent-container"
  }, services.map(function (serviceCategory) {
    if (serviceCategory.subCategories) {
      return ServicesLayer_jsx("div", {
        key: serviceCategory.id,
        ref: function ref(_ref5) {
          return serviceCategoriesBlocks.current[serviceCategory.id] = _ref5;
        }
      }, ServicesLayer_jsx(react_waypoint_es["a" /* Waypoint */], {
        onEnter: function onEnter() {
          debouncedSetCurrentActivityId(serviceCategory.id);
        },
        bottomOffset: "80%"
      }), serviceCategory.subCategories.map(function (serviceSubCategory) {
        var adultsActivities = serviceSubCategory.services.filter(function (_ref3) {
          var productInfo = _ref3.productInfo;
          return !productInfo.ageInMonths.max || productInfo.ageInMonths.max > MAX_AGE_IN_MONTHS_FOR_CHILD_EQUIPMENT;
        });
        var childrenActivities = serviceSubCategory.services.filter(function (_ref4) {
          var productInfo = _ref4.productInfo;
          return productInfo.ageInMonths.max && productInfo.ageInMonths.max <= MAX_AGE_IN_MONTHS_FOR_CHILD_EQUIPMENT;
        });
        return ServicesLayer_jsx("div", {
          className: "pb-px15",
          key: serviceSubCategory.label
        }, ServicesLayer_jsx("div", {
          className: "ServiceBlocks-itemHeader"
        }, ServicesLayer_jsx("div", {
          className: "ServiceBlocks-headerItemLabel"
        }, serviceSubCategory.label || Object(src_i18n["g" /* t */])('booking.activities.otherActivities')), ServicesLayer_jsx("div", {
          className: "ServiceBlocks-headerCategoryLabel"
        }, serviceCategory.label)), ServicesLayer_jsx(Tabs["a" /* Tabs */], {
          isScrollable: true,
          theme: "simple",
          iconExpand: false,
          iconCollapse: false,
          items: [].concat(Object(toConsumableArray["a" /* default */])(adultsActivities.length > 0 ? [{
            header: {
              title: Object(src_i18n["g" /* t */])('booking.common.adult'),
              style: {
                minWidth: '10rem'
              }
            },
            content: [ServicesLayer_jsx(ServicesScrollable_ServicesScrollable, {
              key: "adultsActivities",
              i18n: i18n,
              services: adultsActivities,
              categoryLabel: serviceSubCategory.label
            })]
          }] : []), Object(toConsumableArray["a" /* default */])(childrenActivities.length > 0 ? [{
            header: {
              title: Object(src_i18n["g" /* t */])('booking.common.child'),
              style: {
                minWidth: '10rem'
              }
            },
            content: [ServicesLayer_jsx(ServicesScrollable_ServicesScrollable, {
              key: "childrenActivities",
              i18n: i18n,
              services: childrenActivities,
              categoryLabel: serviceSubCategory.label
            })]
          }] : []))
        }));
      }));
    } // this is just for flow


    if (!serviceCategory.services) {
      return null;
    }

    return ServicesLayer_jsx("div", {
      key: serviceCategory.id,
      ref: function ref(_ref6) {
        return serviceCategoriesBlocks.current[serviceCategory.id] = _ref6;
      }
    }, ServicesLayer_jsx(react_waypoint_es["a" /* Waypoint */], {
      onEnter: function onEnter() {
        debouncedSetCurrentActivityId(serviceCategory.id);
      },
      bottomOffset: "80%"
    }), ServicesLayer_jsx("div", {
      className: "pb-px15"
    }, ServicesLayer_jsx("div", {
      className: "flex items-center text-blue rtl:ml-px10"
    }, ServicesLayer_jsx("span", {
      className: "text-xl font-bold"
    }, serviceCategory.label || Object(src_i18n["g" /* t */])('booking.activities.otherActivities')), ServicesLayer_jsx("span", {
      className: "rtl:ml-px5 whitespace-no-wrap"
    }, "(", serviceCategory.services.length === 1 ? Object(src_i18n["g" /* t */])('booking.activities.oneActivity') : Object(dist["messageFormat"])(Object(src_i18n["g" /* t */])('booking.activities.activitiesAmount')).format({
      amount: serviceCategory.services.length
    }), ")")), ServicesLayer_jsx(ServicesScrollable_ServicesScrollable, {
      i18n: i18n,
      services: serviceCategory.services,
      categoryLabel: serviceCategory.label,
      subCategoryId: serviceCategory.id
    })));
  }), ServicesLayer_jsx("div", {
    className: "ActivitiesList-sectionsContent-offset"
  })))));
};

/***/ }),

/***/ "fO+d":
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__("YpBQ"),
    baseRest = __webpack_require__("R3TX"),
    baseUniq = __webpack_require__("s+R0"),
    isArrayLikeObject = __webpack_require__("Ndl3"),
    last = __webpack_require__("p1C/");

/**
 * This method is like `_.union` except that it accepts `comparator` which
 * is invoked to compare elements of `arrays`. Result values are chosen from
 * the first array in which the value occurs. The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.unionWith(objects, others, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
 */
var unionWith = baseRest(function(arrays) {
  var comparator = last(arrays);
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
});

module.exports = unionWith;


/***/ }),

/***/ "fhLv":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "g51W":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var definePropertyModule = __webpack_require__("87KK");
var createPropertyDescriptor = __webpack_require__("OouP");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "gA51":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ CollapsePanel_CollapsePanel; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/toggler/Toggler.jsx
var Toggler = __webpack_require__("7CPK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// EXTERNAL MODULE: ./src/utils/unique-id/uniqueId.js
var uniqueId = __webpack_require__("m1JM");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/collapse-panel/CollapsePanel.themes.js

var themes = {
  "default": function _default() {
    return {
      thRoot: 'fadeIn',
      thHeader: 'border-b-1 flex relative',
      thHeaderDecorator: 'absolute arrow-down arrow-large arrow-white arrow-bg arrow-bg-large arrow-bg-turquoise border-b-2 border-turquoise -mb-px opacity-0 bottom-0 rtl:left-0 w-full sm:w-1/5 sm:rtl:ml-px25 transition-opacity z-1',
      thHeaderDecoratorActive: 'opacity-100',
      thButton: 'reset-button flex items-center flex-1 max-w-full overflow-hidden py-px20 text-initial text-gray-darker hover:text-turquoise transition-color',
      thTitle: 'flex-1 flex items-center font-bold font-sans leading-tight max-w-full text-current text-xl',
      thTitleHasEllipsis: true,
      thTitleIconColor: colors["a" /* COLORS */].BLUE,
      thLabels: 'flex-shrink-0 font-bold flex items-center text-base text-blue uppercase whitespace-no-wrap',
      thLabel: 'hidden sm:inline-block',
      thLabelIcon: 'text-gray-darker transition-transform rtl:ml-px10',
      thLabelIconActive: 'rotate-180',
      thLabelIconWidth: '0.8125rem',
      thBody: 'overflow-hidden',
      thContent: 'overflow-hidden shadow-inner-bottom shadow-inner-top',
      thContentInner: 'py-px40'
    };
  },
  lite: function lite() {
    return {
      thRoot: 'fadeIn',
      thHeader: 'flex relative',
      thButton: 'reset-button flex items-center flex-1 max-w-full overflow-hidden pt-px10 pb-0 text-initial text-gray-darker hover:text-blue transition-color',
      thTitle: 'flex-1 max-w-full',
      thTitleHasEllipsis: true,
      thLabels: 'flex-shrink-0 flex items-center font-bold rtl:ml-auto text-blue text-base whitespace-no-wrap',
      thLabel: 'underline',
      thLabelIcon: 'rtl:ml-px10',
      thLabelIconWidth: '0.625rem',
      thContent: ' arrow-up arrow-large arrow-bg arrow-white arrow-bg-gray-light border-1 p-px20 mt-px20 shadow-md'
    };
  },
  liteFlexible: function liteFlexible() {
    return {
      thRoot: 'fadeIn',
      thHeader: 'flex relative',
      thButton: 'reset-button flex items-center flex-1 max-w-full overflow-hidden pt-px15 pb-0 text-initial text-gray-darker hover:text-blue transition-color',
      thTitle: 'flex-1 max-w-full',
      thTitleHasEllipsis: true,
      thLabels: 'w-full border-t-1 py-px15 flex items-center justify-center text-base text-gray-600',
      thLabel: 'underline',
      thLabelIcon: 'rtl:ml-px10',
      thLabelIconWidth: '0.625rem',
      thContent: 'flex',
      thContentInner: 'w-full'
    };
  },
  limpid: function limpid() {
    return {
      thRoot: 'fadeIn',
      thHeader: 'flex relative',
      thButton: 'reset-button flex items-center flex-1 max-w-full overflow-hidden text-initial text-gray-darker',
      thTitle: 'flex-1 max-w-full',
      thTitleHasEllipsis: true,
      thLabels: 'flex-shrink-0 font-bold flex items-center rtl:ml-auto text-base text-blue uppercase whitespace-no-wrap',
      thLabel: 'underline',
      thLabelIcon: 'text-gray-darker rtl:ml-px10',
      thLabelIconWidth: '0.625rem',
      thBody: 'overflow-hidden',
      thContent: 'overflow-hidden'
    };
  },
  limpidSmall: function limpidSmall() {
    return {
      thRoot: 'fadeIn',
      thHeader: 'flex relative text-base',
      thButton: 'reset-button flex items-center flex-1 max-w-full overflow-hidden p-px20 text-initial text-gray-darker',
      thTitle: 'flex-1 font-bold max-w-full',
      thTitleHasEllipsis: false,
      thLabels: 'flex-shrink-0 font-bold flex items-center rtl:ml-auto text-blue uppercase whitespace-no-wrap',
      thLabel: 'underline',
      thLabelIcon: 'text-gray-darker rtl:ml-px10',
      thLabelIconActive: 'rotate-180',
      thLabelIconWidth: '0.625rem',
      thBody: 'overflow-hidden',
      thContent: 'overflow-hidden'
    };
  },
  remote: function remote() {
    return {
      thRoot: 'fadeIn border-b-1',
      thHeader: 'py-px20 flex relative',
      thButton: 'reset-button flex items-center flex-1 max-w-full overflow-hidden text-initial text-gray-darker',
      thTitle: 'flex-1 flex items-center max-w-full',
      thTitleIcon: 'rtl:mr-px10',
      thTitleIconColor: colors["a" /* COLORS */].BLUE,
      thTitleIconSize: '1.375rem',
      thLabels: 'flex-shrink-0 font-bold flex items-center rtl:ml-auto text-base text-blue whitespace-no-wrap',
      thLabelIcon: 'text-gray-darker rtl:ml-px10',
      thLabelIconActive: 'rotate-180',
      thLabelIconWidth: '0.625rem',
      thBody: 'overflow-hidden',
      thContent: 'overflow-hidden',
      thInner: 'w-full'
    };
  },
  searchDestinationsFacet: function searchDestinationsFacet(_ref) {
    var isDesktop = _ref.isDesktop;
    return {
      thRoot: 'fadeIn flex-1 max-w-full border-0',
      thHeader: 'flex relative',
      thButton: 'reset-button flex items-center justify-center flex-1 max-w-full overflow-hidden pt-px10 pb-0 text-initial text-gray-darker transition-color',
      thTitle: 'flex-1 max-w-full',
      thTitleHasEllipsis: true,
      thLabels: 'flex-shrink-0 flex items-center justify-center text-base whitespace-no-wrap',
      thBody: '',
      thLabel: 'underline',
      thLabelIcon: 'rtl:ml-px10',
      thLabelIconWidth: '0.625rem',
      thContent: '',
      thContentInner: 'lg:flex',
      thCollapsedTagInitialStyle: {
        'min-height': isDesktop ? '26rem' : '52rem'
      },
      thSemiTransparentDivStyle: {
        position: 'absolute',
        bottom: '0',
        width: '100%',
        height: '100%',
        'pointer-events': 'none',
        background: "linear-gradient(to top, rgba(247, 247, 247, 1) 0%, rgba(247, 247, 247, 0) ".concat(isDesktop ? '30%' : '15%', ")")
      }
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/collapse-panel/CollapsePanel.jsx



var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var POSITIONS = {
  BOTTOM: 'bottom',
  TOP: 'top'
};

var hasLabels = function hasLabels(_ref, isActive) {
  var collapseIconName = _ref.collapseIconName,
      collapseLabel = _ref.collapseLabel,
      expandIconName = _ref.expandIconName,
      expandLabel = _ref.expandLabel;
  return isActive ? collapseIconName || collapseLabel : expandIconName || expandLabel;
};

var CollapsePanel_LoadMoreButton = function LoadMoreButton(_ref2) {
  var ariaId = _ref2.ariaId,
      isActive = _ref2.isActive,
      isDesktop = _ref2.isDesktop,
      toggle = _ref2.toggle,
      collapsePanelProps = Object(objectWithoutProperties["a" /* default */])(_ref2, ["ariaId", "isActive", "isDesktop", "toggle"]);

  var _collapsePanelProps$a = collapsePanelProps.as,
      HeaderTag = _collapsePanelProps$a === void 0 ? 'div' : _collapsePanelProps$a,
      collapseLabel = collapsePanelProps.collapseLabel,
      _collapsePanelProps$c = collapsePanelProps.collapseIconName,
      collapseIconName = _collapsePanelProps$c === void 0 ? icons["a" /* ICONS */].CROSS : _collapsePanelProps$c,
      expandLabel = collapsePanelProps.expandLabel,
      _collapsePanelProps$e = collapsePanelProps.expandIconName,
      expandIconName = _collapsePanelProps$e === void 0 ? icons["a" /* ICONS */].BOLDER_ARROW_FORTH_DOWN : _collapsePanelProps$e,
      iconName = collapsePanelProps.iconName,
      isExpanded = collapsePanelProps.isExpanded,
      noIcons = collapsePanelProps.noIcons,
      _collapsePanelProps$t = collapsePanelProps.theme,
      theme = _collapsePanelProps$t === void 0 ? 'default' : _collapsePanelProps$t,
      title = collapsePanelProps.title,
      trackingData = collapsePanelProps.trackingData;

  var _themes$theme = themes[theme]({
    isDesktop: isDesktop
  }),
      thButton = _themes$theme.thButton,
      thHeader = _themes$theme.thHeader,
      thHeaderDecorator = _themes$theme.thHeaderDecorator,
      thHeaderDecoratorActive = _themes$theme.thHeaderDecoratorActive,
      thLabels = _themes$theme.thLabels,
      thLabel = _themes$theme.thLabel,
      thLabelIcon = _themes$theme.thLabelIcon,
      thLabelIconActive = _themes$theme.thLabelIconActive,
      thLabelIconWidth = _themes$theme.thLabelIconWidth,
      thTitle = _themes$theme.thTitle,
      thTitleHasEllipsis = _themes$theme.thTitleHasEllipsis,
      thTitleIcon = _themes$theme.thTitleIcon,
      thTitleIconColor = _themes$theme.thTitleIconColor,
      thTitleIconSize = _themes$theme.thTitleIconSize;

  return __jsx(HeaderTag, {
    className: classnames_default()('reset-heading', thHeader)
  }, __jsx(TrackClick["a" /* TrackClick */], {
    as: "button",
    "aria-controls": ariaId,
    "aria-expanded": isActive,
    className: thButton,
    onClick: toggle,
    type: "button",
    trackingData: isExpanded ? null : trackingData
  }, !!title && __jsx("div", {
    className: thTitle
  }, __jsx(Icon["a" /* Icon */], {
    className: classnames_default()('rtl:mr-px10 flex-shrink-0', thTitleIcon),
    color: thTitleIconColor,
    name: iconName,
    width: thTitleIconSize || '1em'
  }), thTitleHasEllipsis ? __jsx("span", {
    className: "truncate w-full"
  }, title) : title), hasLabels(collapsePanelProps, isActive) && __jsx("div", {
    className: thLabels
  }, __jsx("span", {
    className: thLabel,
    "data-testid": "CollapsePanel-label"
  }, isActive ? collapseLabel : expandLabel), !noIcons && __jsx(Icon["a" /* Icon */], {
    className: classnames_default()(thLabelIcon, Object(defineProperty["a" /* default */])({}, thLabelIconActive, isActive)),
    name: isActive ? collapseIconName : expandIconName,
    width: thLabelIconWidth
  }))), (thHeaderDecorator || thHeaderDecoratorActive) && __jsx("div", {
    className: classnames_default()(thHeaderDecorator, Object(defineProperty["a" /* default */])({}, thHeaderDecoratorActive, isActive))
  }));
};

var CollapsePanel_CollapsePanel = function CollapsePanel(props) {
  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var _useState = Object(react["useState"])(props.isExpanded),
      isVisible = _useState[0],
      setVisible = _useState[1];

  if (!react["Children"].count(props.children)) {
    return null;
  }

  var children = props.children,
      className = props.className,
      _props$hasKeepCollaps = props.hasKeepCollapsedContent,
      hasKeepCollapsedContent = _props$hasKeepCollaps === void 0 ? true : _props$hasKeepCollaps,
      id = props.id,
      isExpanded = props.isExpanded,
      isSemiTransparent = props.isSemiTransparent,
      _props$loadMoreButton = props.loadMoreButtonPosition,
      loadMoreButtonPosition = _props$loadMoreButton === void 0 ? POSITIONS.TOP : _props$loadMoreButton,
      onClick = props.onClick,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      title = props.title;

  var _themes$theme2 = themes[theme]({
    isDesktop: isDesktop
  }),
      thBody = _themes$theme2.thBody,
      thCollapsedTagInitialStyle = _themes$theme2.thCollapsedTagInitialStyle,
      thContent = _themes$theme2.thContent,
      thContentInner = _themes$theme2.thContentInner,
      thRoot = _themes$theme2.thRoot,
      thSemiTransparentDivStyle = _themes$theme2.thSemiTransparentDivStyle;

  var ariaId = Object(uniqueId["b" /* generateUniqueId */])([id || title || ''], 'CollapsePanel_');
  var CollapsedTag = hasKeepCollapsedContent ? lib["Collapse"] : lib["UnmountClosed"];
  return __jsx(Toggler["a" /* Toggler */], {
    isActive: isExpanded,
    onToggle: onClick
  }, function (toggle, isActive) {
    return __jsx("section", {
      className: classnames_default()(className, thRoot),
      id: id
    }, loadMoreButtonPosition === POSITIONS.TOP && __jsx(CollapsePanel_LoadMoreButton, Object(esm_extends["a" /* default */])({}, props, {
      ariaId: ariaId,
      isActive: isActive,
      isDesktop: isDesktop,
      toggle: toggle
    })), __jsx("div", {
      "aria-hidden": !isActive,
      className: classnames_default()(thBody, {
        invisible: !isVisible
      }),
      id: ariaId
    }, __jsx(CollapsedTag, {
      initialStyle: isSemiTransparent ? _objectSpread({
        height: 'auto',
        overflow: 'initial'
      }, thCollapsedTagInitialStyle) : thCollapsedTagInitialStyle,
      isOpened: isActive,
      onWork: function onWork() {
        setVisible(true);
      },
      onRest: function onRest(_ref3) {
        var isFullyClosed = _ref3.isFullyClosed;
        setVisible(!isFullyClosed);
      }
    }, __jsx("div", {
      className: thContent
    }, __jsx("div", {
      className: thContentInner
    }, children), isSemiTransparent && !isActive && __jsx("div", {
      style: thSemiTransparentDivStyle
    })))), loadMoreButtonPosition === POSITIONS.BOTTOM && __jsx(CollapsePanel_LoadMoreButton, Object(esm_extends["a" /* default */])({}, props, {
      ariaId: ariaId,
      isActive: isActive,
      isDesktop: isDesktop,
      toggle: toggle
    })));
  });
};

/***/ }),

/***/ "gIGD":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("XywU");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),

/***/ "gX9k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTrackPaymentFunc; });
/* unused harmony export getPaymentData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getApproveRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPaymentErrorMessagePath; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fYnN");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _session_storage_api_sessionStorageApi__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("9NGo");
/* harmony import */ var _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("BU6i");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("829J");
/* harmony import */ var _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("K0Lv");
/* harmony import */ var _utils_payment_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("hi3+");
/* harmony import */ var _utils_proposal_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("tI+f");
/* harmony import */ var _utils_status_code_statusCode_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("PSHn");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("nv//");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}












var APPROVE_ROUTE = '/approve-payment';

function getPaymentData() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var id = arguments.length > 1 ? arguments[1] : undefined;
  return Object(lodash__WEBPACK_IMPORTED_MODULE_2__["find"])(items, {
    id: id
  }) || items[0];
}

function getPaymentErrorMessagePath(_ref) {
  var statusCode = _ref.statusCode,
      errorCode = _ref.errorCode,
      track = _ref.track;
  var trackingData = {
    categoryGA: 'bookingEngine',
    actionGA: 'banking',
    event: 'eventGA'
  };

  if (statusCode === _utils_status_code_statusCode_constants__WEBPACK_IMPORTED_MODULE_10__[/* STATUS_CODE_409 */ "e"]) {
    if (errorCode === 'BOOKING_ALREADY_EXISTS') {
      track(_objectSpread(_objectSpread({}, trackingData), {}, {
        labelGA: 'error_BOOKING_ALREADY_EXISTS'
      }));
      return 'booking.banking.aBookingAlreadyExists';
    }

    if (errorCode === 'BOOKING_UNAVAILABLE') {
      track(_objectSpread(_objectSpread({}, trackingData), {}, {
        labelGA: 'error_BOOKING_UNAVAILABLE'
      }));
    } else {
      track(_objectSpread(_objectSpread({}, trackingData), errorCode && {
        labelGA: "error_".concat(errorCode)
      }));
    } // (errorCode === 'BOOKING_UNAVAILABLE' || errorCode === undefined)


    return 'booking.banking.confirmation.itemOfTheBookingNotAvailable';
  }

  return 'booking.banking.paymentErrorMessage';
}

function getApproveRoute(_ref2) {
  var appContext = _ref2.appContext,
      location = _ref2.location,
      eventParams = _ref2.eventParams;
  return Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_11__[/* convertLocationToURI */ "c"])(location).path(APPROVE_ROUTE).query(eventParams).setQuery(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["appQueryParameters"].locale, appContext === null || appContext === void 0 ? void 0 : appContext.locale).toString();
}

var TRACKING_FULL_PAYMENT = 'full payment';
var TRACKING_DOWN_PAYMENT = 'down payment';
var getTrackPaymentFunc = function getTrackPaymentFunc(_ref3) {
  var proposal = _ref3.proposal,
      track = _ref3.track,
      donationAmount = _ref3.donationAmount;
  return function (_ref4) {
    var orderId = _ref4.orderId,
        isErrored = _ref4.isErrored,
        bookingId = _ref4.bookingId,
        amountToPay = _ref4.amountToPay,
        paymentMethodLabel = _ref4.paymentMethodLabel,
        paymentProviderId = _ref4.paymentProviderId;
    var fullPayment = amountToPay === proposal.price.total.value;
    var paymentPlan = fullPayment ? TRACKING_FULL_PAYMENT : TRACKING_DOWN_PAYMENT;
    var paymentMethod = paymentMethodLabel || js_cookie__WEBPACK_IMPORTED_MODULE_1___default.a.get(_PaymentInfo_const__WEBPACK_IMPORTED_MODULE_5__[/* PAYMENT_METHOD_LABEL */ "n"]) || _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_5__[/* CREDIT_CARD_LABEL */ "c"];
    track({
      orderID_PSP: orderId,
      labelGA: 'clickValidateBanking',
      paymentMethod: paymentMethod
    });
    track({
      labelGA: isErrored ? 'errorValidateBanking' : 'validateBanking',
      providerId: paymentProviderId,
      paymentPlan: paymentPlan
    });

    if (!isErrored) {
      var beTracking = _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_7__[/* get */ "a"](_tracking_constants__WEBPACK_IMPORTED_MODULE_6__[/* BE_TRACKING */ "d"]);
      var paymentTracking = {
        event: 'payment',
        basePriceConfirmation: proposal.price.total.value,
        paymentPlan: paymentPlan,
        paymentDeposit: fullPayment ? null : amountToPay,
        paymentType: paymentProviderId,
        transactionID: bookingId,
        orderID_PSP: orderId,
        paymentMethod: paymentMethod
      };

      var paymentTrackingProps = _objectSpread(_objectSpread({}, beTracking), paymentTracking);

      _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_7__[/* set */ "b"](paymentTrackingProps);
      /**
       * Store donation amount in session storage to show thanks message on booking confirmation page
       * It's not possible to use price_details api route : get /v1/customers/{customer_id}/bookings/{booking_id}/price_details
       * because it needs an authentication token, that we do not have for unauthenticated users
       */

      if (donationAmount) {
        Object(_session_storage_api_sessionStorageApi__WEBPACK_IMPORTED_MODULE_4__[/* setInSessionStorage */ "d"])(_utils_payment_constants__WEBPACK_IMPORTED_MODULE_8__[/* DONATION_STORAGE_KEY */ "f"], donationAmount);
      } // store, when the proposal is joyview, the upSell price of package, for confirmation tracking purpose


      if (proposal.alternativePackages && proposal.alternativePackages.length > 0) {
        var basePackage = proposal.alternativePackages.find(function (_ref5) {
          var packageId = _ref5.packageId;
          return packageId === _utils_proposal_constants__WEBPACK_IMPORTED_MODULE_9__[/* PACKAGE_ROOM_ONLY */ "h"];
        }) || // $FlowFixMe 🤬
        proposal.alternativePackages.find(function (_ref6) {
          var packageId = _ref6.packageId;
          return packageId === _utils_proposal_constants__WEBPACK_IMPORTED_MODULE_9__[/* PACKAGE_FOOD_AND_BEVERAGE */ "g"];
        });

        if (basePackage) {
          Object(_session_storage_api_sessionStorageApi__WEBPACK_IMPORTED_MODULE_4__[/* setInSessionStorage */ "d"])(_utils_payment_constants__WEBPACK_IMPORTED_MODULE_8__[/* JOYVIEW_UPSELL_STORAGE_KEY */ "h"], basePackage.upsellPrice.replace(/\D*/, ''));
        }
      }
    }
  };
};


/***/ }),

/***/ "hi3+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PAYMENT_STATUS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return PAYMENT_STATUS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PAYMENT_STATUS_LABEL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PAYMENT_STATUS_LABEL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return PAYMENT_STATUS_REFUSED_CM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return PAYMENT_STATUS_REFUSED_PSP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PAYMENT_STATUS_CANCELED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return PAYMENT_TYPE_BOOKING; });
/* unused harmony export PAYMENT_TYPE_OPTION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return API_PAYMENT_STATUS_SUCCESS; });
/* unused harmony export API_PAYMENT_STATUS_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return API_PAYMENT_STATUS_REFUSED_CM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return API_PAYMENT_STATUS_REFUSED_PSP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_PAYMENT_STATUS_PENDING; });
/* unused harmony export API_PAYMENT_STATUS_PENDING_PSP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_PAYMENT_STATUS_CANCELED; });
/* unused harmony export PAYMENT_ID_OGONE */
/* unused harmony export PAYMENT_ID_ALIPAY */
/* unused harmony export PAYMENT_ID_CUP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PAYMENT_ID_WECHAT; });
/* unused harmony export PAYMENT_ID_99BILL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DONATION_STORAGE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return JOYVIEW_UPSELL_STORAGE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return JOYVIEW_UPSELL_RON_PACKAGEID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PAYMENT_METHOD_ID_DIRECT_DEBIT; });
var PAYMENT_STATUS_SUCCESS = 'success';
var PAYMENT_STATUS_FAILURE = 'failure';
var PAYMENT_STATUS_LABEL_SUCCESS = 'SUCCESS';
var PAYMENT_STATUS_LABEL_FAILURE = 'FAILURE';
var PAYMENT_STATUS_REFUSED_CM = 'REFUSED_CM';
var PAYMENT_STATUS_REFUSED_PSP = 'REFUSED_PSP';
var PAYMENT_STATUS_CANCELED = 'CANCELED';
var PAYMENT_TYPE_BOOKING = 'BOOKING';
var PAYMENT_TYPE_OPTION = 'OPTION';
var API_PAYMENT_STATUS_SUCCESS = 'OK';
var API_PAYMENT_STATUS_FAILURE = 'FAILED';
var API_PAYMENT_STATUS_REFUSED_CM = 'REFUSED_CM';
var API_PAYMENT_STATUS_REFUSED_PSP = 'REFUSED_PSP';
var API_PAYMENT_STATUS_PENDING = 'PENDING';
var API_PAYMENT_STATUS_PENDING_PSP = 'PENDING_PSP';
var API_PAYMENT_STATUS_CANCELED = 'CANCELED';
var PAYMENT_ID_OGONE = 'EOGONE';
var PAYMENT_ID_ALIPAY = 'EALIPAY';
var PAYMENT_ID_CUP = 'ECUP';
var PAYMENT_ID_WECHAT = 'EWECHAT';
var PAYMENT_ID_99BILL = 'E99BILL';
var DONATION_STORAGE_KEY = 'donation';
var JOYVIEW_UPSELL_STORAGE_KEY = 'joyview_upsell';
var JOYVIEW_UPSELL_RON_PACKAGEID = 'RON';
var PAYMENT_METHOD_ID_DIRECT_DEBIT = 'AK';

/***/ }),

/***/ "i2OK":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("4I0e");
var redefine = __webpack_require__("L1Xj");
var toString = __webpack_require__("3dm5");

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "i3Ve":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tooltip; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Ub5k");
/* harmony import */ var _context_pageContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("RPju");
/* harmony import */ var _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("d1HQ");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("829J");
/* harmony import */ var _modal_Modal_jsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("EvYw");
/* harmony import */ var _toggler_Toggler_jsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("7CPK");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








function Tooltip(props) {
  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_2__["useContext"])(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"]);
  var pageContext = Object(react__WEBPACK_IMPORTED_MODULE_2__["useContext"])(_context_pageContext__WEBPACK_IMPORTED_MODULE_4__[/* ReactPageContext */ "a"]);
  var children = props.children,
      isExpanded = props.isExpanded,
      modalProps = props.modalProps,
      renderTrigger = props.renderTrigger,
      trackingData = props.trackingData;
  return __jsx(_toggler_Toggler_jsx__WEBPACK_IMPORTED_MODULE_8__[/* Toggler */ "a"], {
    isActive: isExpanded,
    onToggle: function onToggle(isActive) {
      if (trackingData && isActive) {
        _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_5__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({}, _tracking_constants__WEBPACK_IMPORTED_MODULE_6__[/* GA_DEFAULT_PAYLOAD */ "i"]), trackingData), appContext, pageContext.pageType);
      }
    }
  }, function (toggle, isActive) {
    return __jsx(react__WEBPACK_IMPORTED_MODULE_2__["Fragment"], null, renderTrigger(toggle, isActive), isActive && __jsx(_modal_Modal_jsx__WEBPACK_IMPORTED_MODULE_7__[/* Modal */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, modalProps, {
      onClose: toggle
    }), children));
  });
}

/***/ }),

/***/ "iBXc":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var anObject = __webpack_require__("ep/x");
var aPossiblePrototype = __webpack_require__("2CYk");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "iTz8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InnerTransportDetailsHeader; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("/Mt0");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qBqs");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("kiXb");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;






function InnerTransportDetailsHeader(_ref) {
  var arrivalId = _ref.arrivalId,
      arrivalLabel = _ref.arrivalLabel,
      isComparator = _ref.isComparator,
      isSearchPage = _ref.isSearchPage,
      isDisabled = _ref.isDisabled,
      departureId = _ref.departureId,
      departureLabel = _ref.departureLabel,
      _ref$isInbound = _ref.isInbound,
      isInbound = _ref$isInbound === void 0 ? false : _ref$isInbound,
      transportIcon = _ref.transportIcon,
      transportType = _ref.transportType;

  var _useResponsive = Object(_utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_3__[/* useResponsive */ "b"])(),
      isDesktop = _useResponsive.isDesktop;

  var wayLabel = isInbound ? Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "g"])('booking.transport.inbound') : Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "g"])('booking.transport.outbound');
  var isTrain = transportType === 'TRAIN';
  var isPlane = transportType === 'PLANE';
  var transportIconClass = !isPlane && !isInbound ? '-scale-x-1' : '';

  var getLabel = function getLabel() {
    if (isTrain) {
      return "".concat(departureLabel, " \u2014 ").concat(arrivalLabel);
    }

    if (!isSearchPage) {
      return "".concat(departureLabel, " \u2014 ").concat(arrivalLabel);
    }

    if (!isDesktop) {
      return "".concat(departureId, " \u2014 ").concat(arrivalId);
    }

    return "".concat(departureLabel, " (").concat(departureId, ") \u2014 ").concat(arrivalLabel, " (").concat(arrivalId, ")");
  };

  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('flex flex-col items-center justify-center pb-px5 md:py-px10', {
      'md:flex-row px:0 md:px-px10 md:items-left': !isComparator
    })
  }, isDesktop && transportIcon && __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_4__[/* Icon */ "a"], {
    className: transportIconClass,
    rotation: isInbound || !isPlane ? undefined : 90,
    name: transportIcon,
    width: isTrain ? '2rem' : '1.1rem',
    color: isDisabled ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].GRAY_DARK : _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].BLUE,
    dataTestid: "icon-".concat(transportIcon)
  }), __jsx("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(isComparator ? 'pb-px5 pt-px10' : 'pb-px5 md:pb-0 px-0 md:px-px10 text-base md:text-lg ', isTrain || isSearchPage ? 'pt-0' : !isComparator && 'pt-px10 md:pt-0', 'font-bold flex self-center', {
      'text-gray-dark': isDisabled
    })
  }, wayLabel === null || wayLabel === void 0 ? void 0 : wayLabel.toUpperCase()), __jsx("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('flex font-brand self-center text-base text-blue', !isComparator && 'md:text-md', isSearchPage && {
      'pt-px5 self-end text-base md:text-lg': isSearchPage,
      'text-blue': !isDisabled,
      'text-gray-dark': isDisabled,
      'self-center pt-0': !isDesktop
    })
  }, getLabel()));
}

/***/ }),

/***/ "ieZH":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var fails = __webpack_require__("fhLv");
var toObject = __webpack_require__("A+R+");
var nativeGetPrototypeOf = __webpack_require__("yvHl");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("xVJP");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ "igjW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentUri; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isProduction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isStrictlyProductionEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isStrictlyStagingEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isStrictlyIntegrationEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isStrictlyTestEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isStrictlyDevelopmentEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentLocale; });
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_2__);



function getCurrentUri(req) {
  return new urijs__WEBPACK_IMPORTED_MODULE_0___default.a(decodeURI(req.originalUrl)).protocol(req.protocol).host(req.get('host'));
}
function isProduction() {
  return _config__WEBPACK_IMPORTED_MODULE_2___default.a.get('DEPLOYMENT_ENV') === 'production';
}
function isStrictlyProductionEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && (cfg.get('DEPLOYMENT_ENV') === 'production' || cfg.get('DEPLOYMENT_ENV') === 'prod');
}
function isStrictlyStagingEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && cfg.get('DEPLOYMENT_ENV') === 'staging';
}
function isStrictlyIntegrationEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && cfg.get('DEPLOYMENT_ENV') === 'integration';
}
function isStrictlyTestEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'test';
}
function isStrictlyDevelopmentEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'development' || cfg.get('NODE_ENV') === 'dev';
}
function getCurrentLocale(requestedLocale, hostname) {
  if (requestedLocale) {
    return requestedLocale;
  }

  var domainServiceForHostname = _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1___default.a.forHostname(hostname);
  return domainServiceForHostname.getDefaultLocale();
}

/***/ }),

/***/ "j2ob":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "jD8k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TextLink_TextLink; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/text-link/TextLink.themes.js

var themes = {
  "default": function _default(_ref) {
    var _ref$color = _ref.color,
        color = _ref$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref$color;
    return {
      thIconWidth: '.7em',
      thRoot: "text-".concat(color, " font-bold font-sans leading-normal text-base focus:underline hover:underline"),
      thIconLeft: 'rtl:mr-px10',
      thIconRight: 'rtl:ml-px10'
    };
  },
  fancy: function fancy(_ref2) {
    var _ref2$color = _ref2.color,
        color = _ref2$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref2$color;
    return {
      thIconWidth: '0.4375rem',
      thRoot: "text-".concat(color, " font-bold font-sans leading-normal text-sm"),
      thLabel: '',
      thIconLeft: 'rtl:mr-px10',
      thIconRight: 'rtl:ml-px10'
    };
  },
  solid: function solid(_ref3) {
    var _ref3$color = _ref3.color,
        color = _ref3$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref3$color;
    return {
      thIconWidth: '1em',
      thRoot: "text-".concat(color, " bg-current font-bold font-sans leading-one p-px10 rounded-tiny text-base uppercase"),
      thLabel: 'text-white',
      thIconLeft: 'text-white rtl:mr-px10',
      thIconRight: 'text-white rtl:ml-px10'
    };
  },
  simple: function simple(_ref4) {
    var _ref4$color = _ref4.color,
        color = _ref4$color === void 0 ? colors["a" /* COLORS */].GRAY_DARKER : _ref4$color;
    return {
      thIconWidth: '1em',
      thRoot: "text-".concat(color, " font-sans leading-loose self-start text-base underline"),
      thIconLeft: 'rtl:mr-px10',
      thIconRight: 'rtl:ml-px10'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx

var __jsx = react_default.a.createElement;







var TextLink_TextLink = function TextLink(_ref) {
  var ariaHidden = _ref.ariaHidden,
      ariaLabel = _ref.ariaLabel,
      className = _ref.className,
      color = _ref.color,
      iconLeftName = _ref.iconLeftName,
      _ref$iconRightName = _ref.iconRightName,
      iconRightName = _ref$iconRightName === void 0 ? icons["a" /* ICONS */].BOLDER_ARROW_FORTH : _ref$iconRightName,
      isExternalLink = _ref.isExternalLink,
      label = _ref.label,
      onClick = _ref.onClick,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
      target = _ref.target,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      trackingData = _ref.trackingData,
      url = _ref.url;

  if (!label) {
    return null;
  }

  var _themes$theme = themes[theme]({
    color: color
  }),
      thIconLeft = _themes$theme.thIconLeft,
      thIconRight = _themes$theme.thIconRight,
      thIconWidth = _themes$theme.thIconWidth,
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot;

  return __jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({
    "aria-hidden": ariaHidden,
    "aria-label": ariaLabel,
    as: url ? DynamicLink["a" /* default */] : 'button',
    className: classnames_default()(className, 'reset-button inline-flex items-center', thRoot),
    onClick: onClick,
    tabIndex: tabIndex,
    target: target,
    trackingData: trackingData
  }, url ? {
    url: url,
    isExternalLink: isExternalLink
  } : {
    type: 'button'
  }), !!iconLeftName && __jsx(Icon["a" /* Icon */], {
    className: thIconLeft,
    hasRtl: true,
    name: iconLeftName,
    width: thIconWidth
  }), __jsx("span", {
    className: thLabel
  }, label), !!iconRightName && __jsx(Icon["a" /* Icon */], {
    className: thIconRight,
    hasRtl: true,
    name: iconRightName,
    width: thIconWidth
  }));
};

/***/ }),

/***/ "jFIS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FiltersBar_FiltersBar; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: ./src/client/components/frameworks/click-outside/ClickOutside.jsx
var ClickOutside = __webpack_require__("EWLr");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/client/components/widgets/filter-option/FilterOption.jsx + 2 modules
var FilterOption = __webpack_require__("bmBr");

// CONCATENATED MODULE: ./src/client/components/widgets/filter-options/FilterOptions.jsx

var __jsx = react_default.a.createElement;




var FilterOptions_FilterOptions = function FilterOptions(_ref) {
  var className = _ref.className,
      name = _ref.name,
      onChange = _ref.onChange,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  return __jsx("ul", {
    className: classnames_default()(className, 'sm:flex sm:flex-wrap -m-px5 reset-list')
  }, options.map(function (option) {
    return __jsx("li", {
      className: "p-px5 sm:w-1/4 md:w-1/6",
      key: option.id
    }, __jsx(FilterOption["a" /* FilterOption */], Object(esm_extends["a" /* default */])({}, option, {
      className: isTablet ? 'h-full text-blue shadow-diffuse w-full' : '',
      isButton: isTablet,
      name: name,
      onChange: onChange
    })));
  }));
};
// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-button/InputButton.jsx + 1 modules
var InputButton = __webpack_require__("W+NJ");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// CONCATENATED MODULE: ./src/client/components/widgets/filter-toggler/FilterToggler.jsx
var FilterToggler_jsx = react_default.a.createElement;





var FilterToggler_FilterToggler = function FilterToggler(_ref) {
  var children = _ref.children,
      className = _ref.className,
      isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      onClear = _ref.onClear,
      onClick = _ref.onClick,
      _ref$selectedOptionsN = _ref.selectedOptionsNumber,
      selectedOptionsNumber = _ref$selectedOptionsN === void 0 ? 0 : _ref$selectedOptionsN;
  return FilterToggler_jsx(InputButton["a" /* InputButton */], {
    className: className,
    color: colors["a" /* COLORS */].BLUE,
    isActive: isActive,
    isDisabled: isDisabled,
    isFilled: Boolean(selectedOptionsNumber),
    onClear: onClear,
    onClick: onClick,
    theme: "filter"
  }, FilterToggler_jsx("div", {
    className: "flex items-center flex-1 px-px20 py-px10 truncate"
  }, children, !!selectedOptionsNumber && FilterToggler_jsx(TemplateString["a" /* TemplateString */], {
    className: "sr-only",
    template: selectedOptionsNumber > 1 ? Object(i18n["g" /* t */])('common.selectedCriteriasLabel.n') : Object(i18n["g" /* t */])('common.selectedCriteriasLabel._1'),
    values: {
      count: selectedOptionsNumber.toString()
    }
  })));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.jsx
var Portal = __webpack_require__("3uBn");

// CONCATENATED MODULE: ./src/client/components/widgets/filter/Filter.jsx


var Filter_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var Filter_getInitialSelectedOptions = function getInitialSelectedOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return options.reduce(function (acc, o) {
    return o.isSelected ? [].concat(Object(toConsumableArray["a" /* default */])(acc), [o.value]) : acc;
  }, []);
};

var Filter_Filter = function Filter(_ref) {
  var className = _ref.className,
      customRender = _ref.customRender,
      _ref$forceClose = _ref.forceClose,
      forceClose = _ref$forceClose === void 0 ? false : _ref$forceClose,
      label = _ref.label,
      name = _ref.name,
      onChange = _ref.onChange,
      _onClear = _ref.onClear,
      _onClick = _ref.onClick,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      portalName = _ref.portalName;

  var _useState = Object(react["useState"])(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = Object(react["useState"])(Filter_getInitialSelectedOptions(options)),
      selectedOptions = _useState2[0],
      setSelectedOptions = _useState2[1];

  Object(react["useEffect"])(function () {
    if (isOpen && forceClose) {
      setIsOpen(false);
    }
  }, [forceClose]);
  Object(react["useEffect"])(function () {
    // reset selected when the options change
    setSelectedOptions(Filter_getInitialSelectedOptions(options));
  }, [options]);

  var toggleOption = function toggleOption(option) {
    var newOptions = Object(toConsumableArray["a" /* default */])(selectedOptions);

    var currentIdx = newOptions.indexOf(option.value);

    if (currentIdx >= 0) {
      newOptions.splice(currentIdx, 1);
    } else {
      newOptions.push(option.value);
    }

    setSelectedOptions(newOptions);
    onChange(name, newOptions, option.value);
  };

  return Filter_jsx(react["Fragment"], null, Filter_jsx(FilterToggler_FilterToggler, {
    className: className,
    isActive: isOpen,
    isDisabled: options.length === 0,
    onClear: function onClear() {
      setSelectedOptions([]);
      _onClear && _onClear(name);
    },
    onClick: function onClick() {
      setIsOpen(!isOpen);
      _onClick && _onClick(name);
    },
    selectedOptionsNumber: selectedOptions.length
  }, label), isOpen && Filter_jsx(Portal["a" /* default */], {
    name: portalName
  }, Filter_jsx(ClickOutside["a" /* ClickOutside */], {
    className: "bg-white border-1 border-light-gray -mt-px relative shadow-diffuse z-2",
    onClick: function onClick() {
      return setIsOpen(false);
    }
  }, customRender ? Filter_jsx("div", {
    className: "flex max-w-site mx-auto p-px15"
  }, customRender(options, selectedOptions, toggleOption)) : Filter_jsx("div", {
    className: "max-w-site mx-auto p-px15"
  }, Filter_jsx(FilterOptions_FilterOptions, {
    name: name,
    onChange: function onChange(v) {
      var clickedOption = options.find(function (opt) {
        return opt.value === v;
      });

      if (clickedOption) {
        toggleOption(clickedOption);
      }
    },
    options: options.map(function (o) {
      return _objectSpread(_objectSpread({}, o), {}, {
        isSelected: selectedOptions.includes(o.value),
        label: Filter_jsx("span", {
          className: "capitalize"
        }, o.label.toLowerCase())
      });
    })
  })))));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// CONCATENATED MODULE: ./src/client/components/widgets/filters-bar/FiltersBar.jsx
var FiltersBar_jsx = react_default.a.createElement;






var FiltersBar_FiltersBar = function FiltersBar(_ref) {
  var caption = _ref.caption,
      className = _ref.className,
      dataTestid = _ref.dataTestid,
      _ref$filters = _ref.filters,
      filters = _ref$filters === void 0 ? [] : _ref$filters,
      forceClose = _ref.forceClose,
      isLarge = _ref.isLarge,
      onChange = _ref.onChange,
      onClear = _ref.onClear,
      onClick = _ref.onClick,
      portalName = _ref.portalName;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var renderFilters = function renderFilters() {
    return filters.map(function (filter, i) {
      return FiltersBar_jsx(Filter_Filter, {
        className: classnames_default()('flex-1 m-px5', {
          'scroll-x-last-item-px10': i === filters.length - 1 && !isTablet
        }),
        customRender: filter.customRender,
        key: filter.id,
        forceClose: forceClose,
        label: filter.label,
        name: filter.id,
        onChange: onChange,
        onClear: onClear,
        onClick: onClick,
        options: filter.options,
        portalName: portalName
      });
    });
  };

  return FiltersBar_jsx(react["Fragment"], null, FiltersBar_jsx("div", {
    className: classnames_default()({
      'bg-white border-b-1 border-t-1 border-gray-light slideInTop': isLarge
    })
  }, FiltersBar_jsx(SiteContainer["a" /* SiteContainer */], {
    isWide: !isTablet
  }, FiltersBar_jsx("div", {
    className: classnames_default()(className, 'bg-white sm:flex items-center justify-between sm:px-px15 w-full', {
      'py-px5': isLarge,
      'border-b-1 sm:border-l-1 sm:border-r-1 border-t-1 border-gray-light py-px15 shadow-diffuse': !isLarge
    }),
    "data-testid": dataTestid
  }, caption && FiltersBar_jsx("div", {
    className: "font-bold mx-px10 sm:mx-px5 md:rtl:pr-px10 text-sm md:text-md"
  }, caption), isTablet ? renderFilters() : FiltersBar_jsx(Scrollable["a" /* Scrollable */], {
    childrenWrapperClassNames: "flex px-px5"
  }, renderFilters())))), FiltersBar_jsx("div", {
    id: portalName
  }));
};

/***/ }),

/***/ "jw1E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPriceFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cleanupArgs; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);


var generateCmsArgs = function generateCmsArgs(content, release) {
  return "content : \"".concat(content, "\" release : \"").concat(release, "\"");
};

var getPriceArgs = function getPriceArgs(args) {
  return ['offerId', 'offerName', 'date', 'dateStart', 'dateEnd', 'duration', 'departureCity', 'forceWithoutTransport', 'optimizedPriceCalls'].filter(function (key) {
    return args[key];
  }).map(function (key) {
    var value = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isString"])(args[key]) ? "\"".concat(args[key], "\"") : args[key];
    return [key, value];
  });
};

var buildPriceGraphqlArgs = function buildPriceGraphqlArgs(args) {
  return args.length ? "(".concat(args.map(function (priceArg) {
    return priceArg.join(' : ');
  }).join(' '), ")") : '';
};

function getPriceFields(args) {
  var content = args.content,
      release = args.release;
  var cmsArgs = generateCmsArgs(content, release);
  var priceArgs = buildPriceGraphqlArgs(getPriceArgs(args));
  return "\n    price ".concat(priceArgs, " {\n      bestPrice {\n        value\n        formattedValue\n      }\n      initialPrice {\n        value\n        formattedValue\n      }\n      unit(").concat(cmsArgs, ")\n      currency\n      termsAndConditions {\n        departureDate\n        duration\n        durationFormatted(").concat(cmsArgs, ")\n        numberOfAdults\n        departureCity {\n          value\n          name\n        }\n        accommodationComfortLabel\n      }\n    }");
}

function getThumbnailBaseFields(args) {
  var offerName = args.offerName,
      tourDurationPlaceholder = args.tourDurationPlaceholder,
      cruiseTimingPlaceholder = args.cruiseTimingPlaceholder,
      cruiseDurationPlaceholder = args.cruiseDurationPlaceholder,
      dateFormat = args.dateFormat,
      content = args.content,
      release = args.release; // use typeof string since we cannot be sure that there are no empty strings on the CMS

  var durationArgs = typeof tourDurationPlaceholder === 'string' && typeof cruiseDurationPlaceholder === 'string' ? "(message : \"".concat(tourDurationPlaceholder, "\", cruiseMessage : \"").concat(cruiseDurationPlaceholder, "\")") : '';
  var timingDescriptionArgs = typeof cruiseTimingPlaceholder === 'string' && typeof dateFormat === 'string' ? "(message : \"".concat(cruiseTimingPlaceholder, "\" dateFormat : \"").concat(dateFormat, "\")") : '';
  return "\n    badgeIcon\n    childcareDetails {\n      id\n      included\n    }\n    color\n    comfort\n    comfortLabel\n    destination {\n      area\n      country\n    }\n    duration".concat(durationArgs, "\n    href(offerName : \"").concat(offerName, "\")\n    id\n    images\n    isCruise\n    isDoubleSeason\n    isExclusiveCollection\n    isExplicitEC\n    isJoyview\n    isResort\n    isSummer\n    isTour\n    isVilla\n    isWinter\n    minAuthorizedAge {\n      value\n    }\n    name\n    openingStatus\n    rangeId\n    rangeLabel\n    resortId\n    seasonName\n    seasonTrad(").concat(generateCmsArgs(content, release), ")\n    thematics {\n      label\n    }\n    timingDescription").concat(timingDescriptionArgs, "\n    title\n    transportType\n    type");
}

function cleanupArgs(args) {
  return {
    content: args.content || '',
    release: args.release || '',
    cruiseTimingPlaceholder: args.cruiseTimingPlaceholder,
    cruiseDurationPlaceholder: args.cruiseDurationPlaceholder,
    date: args.date || '',
    dateFormat: args.dateFormat,
    departureCity: args.departureCity || '',
    duration: args.duration || null,
    dateStart: args.dateStart || '',
    dateEnd: args.dateEnd || '',
    forceWithoutTransport: !!args.forceWithoutTransport,
    offerId: args.offerId || '',
    offerName: args.offerName || '',
    optimizedPriceCalls: args.optimizedPriceCalls || false,
    tourDurationPlaceholder: args.tourDurationPlaceholder
  };
}

function makeResortThumbnailQuery(args, options) {
  var _ref = options || {},
      _ref$withoutPrice = _ref.withoutPrice,
      withoutPrice = _ref$withoutPrice === void 0 ? false : _ref$withoutPrice;

  var priceFields = !withoutPrice ? getPriceFields(cleanupArgs(args)) : '';
  return "".concat(getThumbnailBaseFields(cleanupArgs(args))).concat(priceFields);
}

/* harmony default export */ __webpack_exports__["b"] = (makeResortThumbnailQuery);

/***/ }),

/***/ "k9PE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("qm5D");
/* harmony import */ var _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_routes_nextRoutes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _client_components_frameworks_dynamic_link_DynamicLinkUtil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Mkub");



 // TODO This was a curried function. It should be just redirectTo(uri: string): void

function redirectTo(currentUrl) {
  return function (uri, options) {
    if (true) {
      var dynamicLinkHelper = new _client_components_frameworks_dynamic_link_DynamicLinkUtil__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"](currentUrl || window.location.href, uri);

      if (dynamicLinkHelper.isExternalUrl()) {
        _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["windowWrapper"].setLocation(uri);
      } else {
        var objectUri = new urijs__WEBPACK_IMPORTED_MODULE_1___default.a(uri); // next/router is not happy if you only pass him the query parameters. So get the pathname
        // when not provided

        if (objectUri.pathname() === '') {
          objectUri.pathname(window.location.pathname);
        }

        var currentUri = new urijs__WEBPACK_IMPORTED_MODULE_1___default.a(window.location.href);

        if (currentUri.resource() !== objectUri.resource()) {
          // URI().resource() prevent domain name to be passed to the history
          // http://domain/foo -> /foo
          // /foo -> /foo
          if (options === null || options === void 0 ? void 0 : options.shallow) {
            if (options.replace) {
              _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_0__["Router"].shallowReplaceRoute(objectUri.resource());
            } else {
              _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_0__["Router"].shallowPushRoute(objectUri.resource());
            }
          } else if (options === null || options === void 0 ? void 0 : options.replace) {
            _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_0__["Router"].replaceRoute(objectUri.resource());
          } else {
            _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_0__["Router"].pushRoute(objectUri.resource(), undefined, options);
          }
        }
      }
    }
  };
}

function redirectToUri() {
  return function (uri) {
    return function () {
      var redirectUri = new _client_components_frameworks_dynamic_link_DynamicLinkUtil__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"](_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["windowWrapper"].getLocation(), uri).toString();
      redirectTo()(redirectUri);
    };
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  redirectTo: redirectTo,
  redirectToUri: redirectToUri
});

/***/ }),

/***/ "kG2z":
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ "kNiU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return serializeKidsToQueryParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getKidAgeInMonths; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDepartureDateDisplayValue; });
/* unused harmony export findFacetCategoryById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatDepartureDateForStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getChildcareFacets; });
/* unused harmony export getChildren */
/* unused harmony export getFormattedDepartureDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDepartureCities; });
/* unused harmony export getSelectedDepartureCity */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isDateInThePast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isKidMinor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return unserializeKidsFromQueryParam; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("wQ38");
/* harmony import */ var _uri_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Sj1w");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("sW3P");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}







function findFacetCategoryById(facets, facetCategoryId) {
  return facets.find(function (facetCategory) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(facetCategory, 'id') === facetCategoryId;
  });
}

function _getFacetValues(facets, categoryId) {
  var category = findFacetCategoryById(facets, categoryId);
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(category, 'list', []);
}

function getChildcareFacets(facets) {
  return _getFacetValues(facets, _constants__WEBPACK_IMPORTED_MODULE_5__[/* CHILDCARE_FACET_ID */ "d"]);
}

function getDepartureCities(facets) {
  return _getFacetValues(facets, _constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_CITY_FACET_ID */ "i"]);
}

function getSelectedDepartureCity(facets) {
  var selectedCity = getDepartureCities(facets).find(function (facet) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(facet, 'selected');
  });
  return selectedCity ? Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(selectedCity, 'name') : null;
}

function formatDepartureDateForStore(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants__WEBPACK_IMPORTED_MODULE_5__[/* DATE_FORMAT */ "f"];
  return date !== null ? moment__WEBPACK_IMPORTED_MODULE_2___default()(date, format).valueOf() : null;
}

function getDepartureDateDisplayValue() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var momentDate = moment__WEBPACK_IMPORTED_MODULE_2___default()(date);
  return momentDate.isValid() ? momentDate.format(_constants__WEBPACK_IMPORTED_MODULE_5__[/* DATE_FORMAT */ "f"]) : '';
}

function isDateInThePast(timestampDate) {
  return timestampDate ? moment__WEBPACK_IMPORTED_MODULE_2___default()(timestampDate).isBefore() : false;
}

function getFormattedDepartureDate(date, dateFormat) {
  return date ? moment__WEBPACK_IMPORTED_MODULE_2___default()(date).format(dateFormat) : '';
}

function isKidMinor(birthdate) {
  if (!birthdate) {
    return false;
  }

  var minBirthdate = moment__WEBPACK_IMPORTED_MODULE_2___default()().subtract(18, 'years');
  var momentBirthdate = moment__WEBPACK_IMPORTED_MODULE_2___default()(birthdate);
  return momentBirthdate.isValid() && momentBirthdate.isBetween(minBirthdate, moment__WEBPACK_IMPORTED_MODULE_2___default()());
}

function getChildren(numberOfChildren, childrenBirthdates) {
  if (Number.isInteger(numberOfChildren) && numberOfChildren >= 0 && numberOfChildren <= _constants__WEBPACK_IMPORTED_MODULE_5__[/* KIDS_NUMBER_MAX */ "t"]) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["times"])(numberOfChildren, function (idx) {
      return childrenBirthdates && childrenBirthdates.length > idx ? {
        birthdate: moment__WEBPACK_IMPORTED_MODULE_2___default()(childrenBirthdates[idx], 'YYYYMMDD', true).valueOf(),
        childcareIncluded: false
      } : {
        childcareIncluded: false
      };
    });
  }

  return null;
}

function unserializeKidsFromQueryParam(value) {
  if (!value) return [];
  var kidsNumber = Number(value); // NOTE: DO NOT USE parseInt() !!! parseInt('2010-12-10c') will return 2010 ...

  if (kidsNumber > _constants__WEBPACK_IMPORTED_MODULE_5__[/* KIDS_NUMBER_MAX */ "t"]) {
    return [];
  }

  if (Number.isInteger(kidsNumber)) return new Array(kidsNumber).fill(_objectSpread({}, _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_3__[/* DEFAULT_KID_VALUE */ "a"]));
  var kids = value.split(_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_KIDS_DELIMITER */ "i"]).map(function (serializedKidString) {
    var hasChildcareFlag = serializedKidString.substr(-1) === _uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_CHILDCARE_FLAG */ "c"];
    var strBirthdate = serializedKidString.replace(_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_CHILDCARE_FLAG */ "c"], '');
    var birthdate = moment__WEBPACK_IMPORTED_MODULE_2___default()(strBirthdate, _uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_DATE_FORMAT */ "e"], true);
    var childcareIncluded = birthdate.isValid() ? hasChildcareFlag : _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_3__[/* DEFAULT_KID_VALUE */ "a"].childcareIncluded;
    return _objectSpread(_objectSpread({}, _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_3__[/* DEFAULT_KID_VALUE */ "a"]), {}, {
      childcareIncluded: childcareIncluded,
      birthdate: birthdate.isValid() ? birthdate.valueOf() : undefined
    });
  });
  return kids.length > _constants__WEBPACK_IMPORTED_MODULE_5__[/* KIDS_NUMBER_MAX */ "t"] ? [] : kids;
}
/**
 * Helper to serialize kids array as a URI query parameter.
 *
 * Example of returns:
 *
 * - `kids=1` (1 kid, no birthdate)
 * - `kids=2010-10-30` (1 kid, with birthdate)
 * - `kids=_` (2 kids)
 * - `kids=2010-10-30=_` (2 kids, 1 birthdate)
 * - `kids=2010-10-30c=___`
 * - `kids=2010-10-30c_2009-04-01!`
 */


var serializeKidsToQueryParam = function serializeKidsToQueryParam(params) {
  var kids = params.kids,
      kidsValidationState = params.kidsValidationState;
  var serializedKids = kids.map(function (_ref, index) {
    var birthdate = _ref.birthdate;

    if (!birthdate || !kidsValidationState || kidsValidationState[index] !== _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_3__[/* VALIDATION_STATE_ENUM */ "f"].valid) {
      return '';
    }

    var formattedBirthdate = moment__WEBPACK_IMPORTED_MODULE_2___default()(birthdate).format(_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_DATE_FORMAT */ "e"]);
    return formattedBirthdate;
  }).filter(function (birthdate) {
    return birthdate !== '';
  }); // Special case when there is only one kid, as we can't make a join('_') with only one item

  var serializedOutput = '';

  if (serializedKids.length === 1) {
    if (serializedKids.filter(Boolean).length === 0) {
      serializedOutput = '1';
    } // Return kid's birthdate


    if (serializedOutput !== '1') {
      serializedOutput = serializedKids.shift();
    }

    var childcareIncluded = kids.some(function (kid) {
      return kid.childcareIncluded;
    });

    if (childcareIncluded) {
      serializedOutput = "".concat(serializedOutput).concat(_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_CHILDCARE_FLAG */ "c"]);
    }

    return serializedOutput;
  }

  return serializedKids.join(_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_KIDS_DELIMITER */ "i"]);
};
var getKidAgeInMonths = function getKidAgeInMonths(_ref2) {
  var birthdate = _ref2.birthdate,
      departureDate = _ref2.departureDate;
  var defaultDepartureDate = moment__WEBPACK_IMPORTED_MODULE_2___default()().add(_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH */ "j"], 'months').valueOf();
  var b = birthdate ? moment__WEBPACK_IMPORTED_MODULE_2___default()(birthdate) : moment__WEBPACK_IMPORTED_MODULE_2___default()().subtract(8, 'y');
  return moment__WEBPACK_IMPORTED_MODULE_2___default()(departureDate || defaultDepartureDate).diff(b, 'months');
};


/***/ }),

/***/ "kWb8":
/***/ (function(module) {

module.exports = JSON.parse("{\"Aacute\":\"Á\",\"aacute\":\"á\",\"Acirc\":\"Â\",\"acirc\":\"â\",\"acute\":\"´\",\"AElig\":\"Æ\",\"aelig\":\"æ\",\"Agrave\":\"À\",\"agrave\":\"à\",\"amp\":\"&\",\"AMP\":\"&\",\"Aring\":\"Å\",\"aring\":\"å\",\"Atilde\":\"Ã\",\"atilde\":\"ã\",\"Auml\":\"Ä\",\"auml\":\"ä\",\"brvbar\":\"¦\",\"Ccedil\":\"Ç\",\"ccedil\":\"ç\",\"cedil\":\"¸\",\"cent\":\"¢\",\"copy\":\"©\",\"COPY\":\"©\",\"curren\":\"¤\",\"deg\":\"°\",\"divide\":\"÷\",\"Eacute\":\"É\",\"eacute\":\"é\",\"Ecirc\":\"Ê\",\"ecirc\":\"ê\",\"Egrave\":\"È\",\"egrave\":\"è\",\"ETH\":\"Ð\",\"eth\":\"ð\",\"Euml\":\"Ë\",\"euml\":\"ë\",\"frac12\":\"½\",\"frac14\":\"¼\",\"frac34\":\"¾\",\"gt\":\">\",\"GT\":\">\",\"Iacute\":\"Í\",\"iacute\":\"í\",\"Icirc\":\"Î\",\"icirc\":\"î\",\"iexcl\":\"¡\",\"Igrave\":\"Ì\",\"igrave\":\"ì\",\"iquest\":\"¿\",\"Iuml\":\"Ï\",\"iuml\":\"ï\",\"laquo\":\"«\",\"lt\":\"<\",\"LT\":\"<\",\"macr\":\"¯\",\"micro\":\"µ\",\"middot\":\"·\",\"nbsp\":\" \",\"not\":\"¬\",\"Ntilde\":\"Ñ\",\"ntilde\":\"ñ\",\"Oacute\":\"Ó\",\"oacute\":\"ó\",\"Ocirc\":\"Ô\",\"ocirc\":\"ô\",\"Ograve\":\"Ò\",\"ograve\":\"ò\",\"ordf\":\"ª\",\"ordm\":\"º\",\"Oslash\":\"Ø\",\"oslash\":\"ø\",\"Otilde\":\"Õ\",\"otilde\":\"õ\",\"Ouml\":\"Ö\",\"ouml\":\"ö\",\"para\":\"¶\",\"plusmn\":\"±\",\"pound\":\"£\",\"quot\":\"\\\"\",\"QUOT\":\"\\\"\",\"raquo\":\"»\",\"reg\":\"®\",\"REG\":\"®\",\"sect\":\"§\",\"shy\":\"­\",\"sup1\":\"¹\",\"sup2\":\"²\",\"sup3\":\"³\",\"szlig\":\"ß\",\"THORN\":\"Þ\",\"thorn\":\"þ\",\"times\":\"×\",\"Uacute\":\"Ú\",\"uacute\":\"ú\",\"Ucirc\":\"Û\",\"ucirc\":\"û\",\"Ugrave\":\"Ù\",\"ugrave\":\"ù\",\"uml\":\"¨\",\"Uuml\":\"Ü\",\"uuml\":\"ü\",\"Yacute\":\"Ý\",\"yacute\":\"ý\",\"yen\":\"¥\",\"yuml\":\"ÿ\"}");

/***/ }),

/***/ "kjCq":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("1YFU");
var isArray = __webpack_require__("gIGD");
var wellKnownSymbol = __webpack_require__("nJrx");

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),

/***/ "l5FB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["a"] = (/*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_0__["createContext"])({
  departureCities: [],
  setDepartureCities: function setDepartureCities() {}
}));

/***/ }),

/***/ "l6h7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var setGlobal = __webpack_require__("edYw");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "lCzM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Receipt_Receipt; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/views/booking/constants.js
var constants = __webpack_require__("taV1");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/utils/proposal/constants.js
var proposal_constants = __webpack_require__("tI+f");

// EXTERNAL MODULE: ./src/errors/errors.js + 4 modules
var errors = __webpack_require__("wNDy");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./src/client/views/booking/receipt/Receipt.utils.js
var Receipt_utils = __webpack_require__("vv41");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/widgets/all-inclusive-list/AllInclusiveList.jsx
var AllInclusiveList = __webpack_require__("X0en");

// EXTERNAL MODULE: ./src/client/components/frameworks/capsule/Capsule.jsx + 1 modules
var Capsule = __webpack_require__("jldR");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-validator-hoc/validationStates.js
var validationStates = __webpack_require__("45yR");

// CONCATENATED MODULE: ./src/client/components/widgets/edit-my-criteria/CriteriaProvider.jsx

var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var CriteriaContext = /*#__PURE__*/Object(react["createContext"])({
  criteria: {},
  initialCriteria: {},
  criteriaEdited: false,
  updateCriteria: function updateCriteria() {},
  updateEditing: function updateEditing() {},
  resetCriteria: function resetCriteria() {}
});

var reducer = function reducer(state, action) {
  switch (action.type) {
    case 'update':
      return _objectSpread(_objectSpread({}, state), {}, {
        criteriaEdited: true,
        criteria: _objectSpread(_objectSpread({}, state.criteria), action.payload)
      });

    case 'updateEditing':
      return _objectSpread(_objectSpread({}, state), {}, {
        criteriaEdited: action.payload
      });

    case 'resetCriteria':
      return _objectSpread(_objectSpread({}, state), {}, {
        criteriaEdited: false,
        criteria: _objectSpread({}, state.initialCriteria)
      });

    default:
      throw new Error("Tried to update the criteria with the unknown action ".concat(action.type));
  }
};

var CriteriaProvider_CriteriaProvider = function CriteriaProvider(_ref) {
  var proposal = _ref.proposal,
      resort = _ref.resort,
      children = _ref.children;
  var departureCityId = Object(lodash["get"])(proposal.transports, 'inbound.travelSections[0].departure.cityId', 'NO');
  var departureCityLabel = Object(lodash["get"])(proposal.transports, 'inbound.travelSections[0].departure.label', '');
  var initialCriteria = {
    search: {
      label: resort.name,
      value: resort.id,
      country: resort.destination.country,
      offsetSell: resort.offsetSell,
      openingDates: resort.openingDates || []
    },
    departure: {
      duration: proposal.duration,
      date: Object(apiDate["h" /* momentFromApiDate */])(proposal.arrivalDate)
    },
    attendees: {
      adults: proposal.attendees.adults.length,
      // $FlowFixMe birthdate is always defined in this case
      kids: proposal.attendees.children.map(function (_ref2) {
        var birthdate = _ref2.birthdate;
        return {
          birthdate: birthdate,
          status: validationStates["b" /* IS_VALID */],
          childcareIncluded: false
        };
      })
    },
    departureCity: {
      label: departureCityLabel,
      value: departureCityId
    }
  };
  var initialState = {
    criteriaEdited: false,
    criteria: initialCriteria,
    initialCriteria: initialCriteria
  }; // We use useReducer since we want to update only a part of the criteria, and its simpler
  // this way

  var _useReducer = Object(react["useReducer"])(reducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var value = Object(react["useMemo"])(function () {
    return {
      criteria: state.criteria,
      initialCriteria: state.initialCriteria,
      criteriaEdited: state.criteriaEdited,
      updateCriteria: function updateCriteria(updatedCriteriaSection) {
        return dispatch({
          type: 'update',
          payload: updatedCriteriaSection
        });
      },
      updateEditing: function updateEditing(criteriaEdited) {
        return dispatch({
          type: 'updateEditing',
          payload: criteriaEdited
        });
      },
      resetCriteria: function resetCriteria() {
        return dispatch({
          type: 'resetCriteria'
        });
      }
    };
  }, [state.criteria, state.criteriaEdited]);
  return __jsx(CriteriaContext.Provider, {
    value: value
  }, children);
};
var CriteriaConsumer = function CriteriaConsumer(_ref3) {
  var children = _ref3.children;
  return __jsx(CriteriaContext.Consumer, null, function (criteriaState) {
    if (!criteriaState) throw new Error('CriteriaConsumer was called without a Provider');
    return children(criteriaState);
  });
};
var CriteriaProvider_useCriteria = function useCriteria() {
  var context = Object(react["useContext"])(CriteriaContext);

  if (context === undefined) {
    throw new Error('useCriteria must be used within a CriteriaContext.Provider');
  }

  return context;
};
// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/proposals.action.js + 1 modules
var proposals_action = __webpack_require__("AnR0");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/router/withRouter.js
var withRouter = __webpack_require__("MGbB");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngine.tracking.js
var BookingEngine_tracking = __webpack_require__("Hv+8");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngine.utils.js
var BookingEngine_utils = __webpack_require__("47Eh");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/utils/booking-engine-pages/BookingPagesUtils.js
var BookingPagesUtils = __webpack_require__("rcxx");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var faceting_constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./src/client/store/trip-information/kids/kids.action.js
var kids_action = __webpack_require__("1bWg");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/Responsive.jsx
var Responsive = __webpack_require__("Gqxm");

// EXTERNAL MODULE: ./src/client/components/widgets/package/price/AttendeesSummary.jsx
var AttendeesSummary = __webpack_require__("5q4R");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-who/filter-who/FilterWho.jsx + 2 modules
var FilterWho = __webpack_require__("tUgU");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria-field-wrapper/CriteriaFieldWrapper.jsx
var CriteriaFieldWrapper = __webpack_require__("Qy1q");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/widgets/edit-my-criteria/criteria/EditMyCriteriaFieldWrapper.jsx
var EditMyCriteriaFieldWrapper_jsx = react_default.a.createElement;








var EditMyCriteriaFieldWrapper_EditMyCriteriaFieldWrapper = function EditMyCriteriaFieldWrapper(_ref) {
  var children = _ref.children,
      className = _ref.className,
      disableValidateButton = _ref.disableValidateButton,
      focusedFilterBtn = _ref.focusedFilterBtn,
      onClose = _ref.onClose,
      onValidate = _ref.onValidate,
      trackCriteriaClick = _ref.trackCriteriaClick,
      triggerComponent = _ref.triggerComponent;
  return EditMyCriteriaFieldWrapper_jsx(CriteriaFieldWrapper["a" /* CriteriaFieldWrapper */], {
    onCancel: onClose,
    renderTrigger: function renderTrigger(handler, isExpanded) {
      return EditMyCriteriaFieldWrapper_jsx("button", {
        "aria-expanded": isExpanded,
        className: classnames_default()(className, 'border-0 cursor-pointer flex flex-1 h-full items-center justify-between px-px20 py-px15 lg:py-px20 reset-button text-initial w-full'),
        onClick: function onClick() {
          trackCriteriaClick();
          handler();
        },
        ref: isExpanded ? focusedFilterBtn : undefined,
        type: "button"
      }, triggerComponent, EditMyCriteriaFieldWrapper_jsx(Icon["a" /* Icon */], {
        className: isExpanded ? 'rotate-180' : '',
        name: icons["a" /* ICONS */].SELECT,
        width: "1em"
      }));
    },
    title: Object(src_i18n["g" /* t */])('booking.editCriteria.buttonLabel')
  }, function (toggle) {
    return EditMyCriteriaFieldWrapper_jsx(react["Fragment"], null, children, EditMyCriteriaFieldWrapper_jsx("div", {
      className: "my-px20 text-center"
    }, EditMyCriteriaFieldWrapper_jsx(Button["a" /* Button */], {
      colorBg: colors["a" /* COLORS */].TURQUOISE,
      colorBorder: colors["a" /* COLORS */].TURQUOISE,
      dataSelector: "EditMyCriteriaDropDown-apply",
      isDisabled: disableValidateButton,
      dataTestId: "criteria-validation-button",
      onClick: function onClick() {
        toggle();
        onValidate();
      }
    }, Object(src_i18n["g" /* t */])('booking.editCriteria.validateCriteria'))));
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/edit-my-criteria/criteria/EditMyCriteriaAttendees.jsx







var EditMyCriteriaAttendees_jsx = react_default.a.createElement;

function EditMyCriteriaAttendees_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function EditMyCriteriaAttendees_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { EditMyCriteriaAttendees_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { EditMyCriteriaAttendees_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }











var EditMyCriteriaAttendees_EditMyCriteriaAttendees = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(_EditMyCriteriaAttendees, _Component);

  var _super = _createSuper(_EditMyCriteriaAttendees);

  function _EditMyCriteriaAttendees() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, _EditMyCriteriaAttendees);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      adults: _this.props.attendees.adults,
      kids: _this.props.attendees.kids
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "invalidateKidsBirthDate", function (kidIndex) {
      _this.setState({
        kids: _this.state.kids.map(function (kid, index) {
          return index === kidIndex ? EditMyCriteriaAttendees_objectSpread(EditMyCriteriaAttendees_objectSpread({}, kid), {}, {
            status: validationStates["a" /* IS_INVALID */]
          }) : kid;
        })
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "trackCLickOnField", function () {
      _this.props.trackCriteriaClick('attendees');
    });

    return _this;
  }

  Object(createClass["a" /* default */])(_EditMyCriteriaAttendees, [{
    key: "updateCriteriaAttendees",
    value: function updateCriteriaAttendees() {
      this.props.updateCriteriaField('attendees', {
        adults: this.state.adults,
        kids: this.state.kids
      });

      if (this.state.kids.length) {
        this.props.setKidsWithoutClearProposals(this.state.kids);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          attendees = _this$props.attendees,
          cancelEditingCriteria = _this$props.cancelEditingCriteria,
          className = _this$props.className,
          i18n = _this$props.i18n;
      var _this$state = this.state,
          adults = _this$state.adults,
          kids = _this$state.kids;
      var _i18n$booking$form = i18n.booking.form,
          dateFormat = _i18n$booking$form.dateFormat,
          dayPlaceholder = _i18n$booking$form.dayPlaceholder,
          monthPlaceholder = _i18n$booking$form.monthPlaceholder,
          yearPlaceholder = _i18n$booking$form.yearPlaceholder;
      return EditMyCriteriaAttendees_jsx(EditMyCriteriaFieldWrapper_EditMyCriteriaFieldWrapper, {
        className: className,
        disableValidateButton: kids.some(function (_ref) {
          var status = _ref.status;
          return status === validationStates["a" /* IS_INVALID */];
        }),
        i18n: i18n,
        onClose: cancelEditingCriteria,
        onValidate: function onValidate() {
          _this2.updateCriteriaAttendees();
        },
        trackCriteriaClick: this.trackCLickOnField,
        triggerComponent: EditMyCriteriaAttendees_jsx(AttendeesSummary["a" /* AttendeesSummary */], {
          adults: attendees.adults,
          kids: attendees.kids.length
        })
      }, EditMyCriteriaAttendees_jsx(FilterWho["a" /* FilterWho */], {
        addChildcareLabel: i18n.faceting.who.addChildcare,
        adultsLabel: i18n.faceting.who.adults,
        adultsNumber: adults,
        changeKid: function changeKid(kidNumber, newKid) {
          _this2.setState({
            kids: kids.map(function (kid, index) {
              return index === kidNumber ? EditMyCriteriaAttendees_objectSpread(EditMyCriteriaAttendees_objectSpread({}, newKid), {}, {
                status: validationStates["b" /* IS_VALID */]
              }) : kid;
            })
          });
        },
        changeKidsNumber: function changeKidsNumber(newKidNumber) {
          return _this2.setState({
            kids: new Array(newKidNumber).fill({
              status: validationStates["a" /* IS_INVALID */]
            }).map(function (kid, index) {
              return EditMyCriteriaAttendees_objectSpread(EditMyCriteriaAttendees_objectSpread({}, kid), kids[index]);
            })
          });
        },
        dateFormat: dateFormat,
        dayPlaceholder: dayPlaceholder,
        isShrink: this.props.responsive.isDesktop,
        kids: kids,
        kidsAgeLabel: i18n.faceting.who.ageSectionSubtitle,
        kidsAgeLimitLabel: i18n.faceting.who.kidsAgeLimit,
        kidsLabel: i18n.faceting.who.kids,
        kidsValidationState: kids.map(function (_ref2) {
          var status = _ref2.status;
          return status;
        }),
        label: i18n.faceting.who.subTitle,
        minAdultsNumber: faceting_constants["b" /* ADULTS_NUMBER_MIN */],
        monthPlaceholder: monthPlaceholder,
        setAdultsNumber: function setAdultsNumber(newAdultNumber) {
          return _this2.setState({
            adults: newAdultNumber
          });
        },
        updateOnInvalidBirthDate: true,
        validateKidsBirthdate: this.invalidateKidsBirthDate,
        yearPlaceholder: yearPlaceholder
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props) {
      var shouldResetCriteria = props.shouldResetCriteria,
          onCriteriaReset = props.onCriteriaReset,
          attendees = props.attendees;

      if (shouldResetCriteria) {
        onCriteriaReset();
        return {
          adults: attendees.adults,
          kids: attendees.kids
        };
      }

      return null;
    }
  }]);

  return _EditMyCriteriaAttendees;
}(react["Component"]);

var EditMyCriteriaAttendees = Object(es["c" /* connect */])(null, {
  setKidsWithoutClearProposals: kids_action["c" /* setKidsWithoutClearProposals */]
})(Object(Responsive["a" /* default */])(EditMyCriteriaAttendees_EditMyCriteriaAttendees));
// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-when/filter-when/FilterWhen.jsx + 1 modules
var FilterWhen = __webpack_require__("qLhN");

// EXTERNAL MODULE: ./src/client/components/widgets/package/price/DateSummary.jsx
var DateSummary = __webpack_require__("tF/N");

// CONCATENATED MODULE: ./src/client/components/widgets/edit-my-criteria/criteria/EditMyCriteriaDeparture.jsx







var EditMyCriteriaDeparture_jsx = react_default.a.createElement;

function EditMyCriteriaDeparture_createSuper(Derived) { var hasNativeReflectConstruct = EditMyCriteriaDeparture_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function EditMyCriteriaDeparture_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }







var EditMyCriteriaDeparture_EditMyCriteriaDeparture = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(EditMyCriteriaDeparture, _Component);

  var _super = EditMyCriteriaDeparture_createSuper(EditMyCriteriaDeparture);

  function EditMyCriteriaDeparture() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, EditMyCriteriaDeparture);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      date: _this.props.departure.date,
      duration: _this.props.departure.duration,
      openCalendarToDate: _this.props.departure.date
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "updateCriteriaDeparture", function () {
      _this.props.updateCriteriaField('departure', {
        date: _this.state.date,
        duration: _this.state.duration
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onValidate", function () {
      _this.updateCriteriaDeparture();
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClose", function () {
      var _this$props = _this.props,
          departure = _this$props.departure,
          cancelEditingCriteria = _this$props.cancelEditingCriteria;

      _this.setState({
        date: departure.date,
        duration: departure.duration,
        openCalendarToDate: departure.date
      });

      cancelEditingCriteria();
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "clearDepartureDate", function () {
      return _this.setState({
        date: null
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "clearTripDuration", function () {
      return _this.setState({
        duration: null
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "changeDepartureDate", function (value) {
      if (!value) {
        _this.setState({
          date: null,
          duration: null
        });
      } else {
        _this.setState({
          date: moment_default()(value, moment_default.a.defaultFormat),
          duration: null,
          openCalendarToDate: moment_default()(value)
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "changeTripDuration", function (duration) {
      if (duration) {
        _this.setState({
          duration: duration
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "trackClickOnField", function () {
      _this.props.trackCriteriaClick('departure');
    });

    return _this;
  }

  Object(createClass["a" /* default */])(EditMyCriteriaDeparture, [{
    key: "render",
    value: function render() {
      var _departure$date, _departure$date2;

      var _this$props2 = this.props,
          className = _this$props2.className,
          departure = _this$props2.departure,
          offsetSell = _this$props2.offsetSell,
          openingDates = _this$props2.openingDates,
          optionsDuration = _this$props2.optionsDuration;
      var dateFormat = Object(src_i18n["g" /* t */])('booking.priceDetails.packagePrice.dateFormat');
      var _this$state = this.state,
          date = _this$state.date,
          duration = _this$state.duration;
      var arrivalDate = ((_departure$date = departure.date) === null || _departure$date === void 0 ? void 0 : _departure$date.format(dateFormat)) || Object(src_i18n["g" /* t */])('faceting.when.arrivalDateTitle');
      var departureDate = ((_departure$date2 = departure.date) === null || _departure$date2 === void 0 ? void 0 : _departure$date2.clone().add(departure.duration, 'days').format(dateFormat)) || Object(src_i18n["g" /* t */])('faceting.when.departureDateTitle');
      var dateSummaryValues = {
        arrivalDate: arrivalDate,
        departureDate: departureDate
      };
      var dateSummaryTemplate = departure.date ? Object(src_i18n["g" /* t */])('booking.priceDetails.packagePrice.departureDateFormat') : '{arrivalDate} {departureDate}';
      return EditMyCriteriaDeparture_jsx(EditMyCriteriaFieldWrapper_EditMyCriteriaFieldWrapper, {
        className: className,
        disableValidateButton: !date || !duration,
        onClose: this.onClose,
        onValidate: this.onValidate,
        trackCriteriaClick: this.trackClickOnField,
        triggerComponent: EditMyCriteriaDeparture_jsx(DateSummary["a" /* DateSummary */], {
          as: "span",
          template: dateSummaryTemplate,
          values: dateSummaryValues
        })
      }, EditMyCriteriaDeparture_jsx(FilterWhen["a" /* FilterWhen */], {
        changeDepartureDate: this.changeDepartureDate,
        changeTripDuration: this.changeTripDuration,
        clearDepartureDate: this.clearDepartureDate,
        clearTripDuration: this.clearTripDuration,
        dateFormat: dateFormat,
        departureDate: date,
        duration: duration,
        offsetCalendar: offsetSell,
        openCalendarToDate: this.state.openCalendarToDate,
        openingDates: openingDates,
        optionsDuration: optionsDuration
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props) {
      var shouldResetCriteria = props.shouldResetCriteria,
          onCriteriaReset = props.onCriteriaReset,
          departure = props.departure;

      if (shouldResetCriteria) {
        onCriteriaReset();
        return {
          date: departure.date,
          openCalendarToDate: departure.date,
          duration: departure.duration
        };
      }

      return null;
    }
  }]);

  return EditMyCriteriaDeparture;
}(react["Component"]);
// EXTERNAL MODULE: ./src/client/context/ResortListContext.js
var ResortListContext = __webpack_require__("7hcC");

// EXTERNAL MODULE: ./src/client/components/widgets/resort-search-autocomplete/ResortSearchAutoComplete.jsx + 1 modules
var ResortSearchAutoComplete = __webpack_require__("xGvK");

// EXTERNAL MODULE: ./src/client/components/widgets/package/price/ResortSummary.jsx
var ResortSummary = __webpack_require__("4XHd");

// CONCATENATED MODULE: ./src/client/components/widgets/edit-my-criteria/criteria/EditMyCriteriaResort.jsx

var EditMyCriteriaResort_jsx = react_default.a.createElement;

function EditMyCriteriaResort_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function EditMyCriteriaResort_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { EditMyCriteriaResort_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { EditMyCriteriaResort_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var EditMyCriteriaResort_EditMyCriteriaResort = function EditMyCriteriaResort(_ref) {
  var defaultOffsetSell = _ref.defaultOffsetSell,
      updateCriteriaField = _ref.updateCriteriaField,
      trackCriteriaClick = _ref.trackCriteriaClick,
      cancelEditingCriteria = _ref.cancelEditingCriteria,
      focusedFilterBtn = _ref.focusedFilterBtn,
      i18n = _ref.i18n,
      search = _ref.search;
  var resortList = Object(ResortListContext["b" /* useResortList */])();

  var _useState = Object(react["useState"])({
    country: '',
    label: '',
    offsetSell: defaultOffsetSell,
    value: '',
    openingDates: []
  }),
      state = _useState[0],
      setState = _useState[1];

  var clearState = function clearState() {
    setState({
      country: '',
      label: '',
      offsetSell: defaultOffsetSell,
      value: '',
      openingDates: []
    });
  };

  var updateCriteriaSearch = function updateCriteriaSearch() {
    updateCriteriaField('search', {
      country: state.country,
      label: state.label,
      offsetSell: state.offsetSell,
      value: state.value,
      openingDates: state.openingDates
    }); // clear state after the end of the animation

    setTimeout(clearState, 200); // WTF ??
  };

  var trackCLickOnField = function trackCLickOnField() {
    trackCriteriaClick('search');
  };

  var onChangeSearch = function onChangeSearch(label) {
    setState(EditMyCriteriaResort_objectSpread(EditMyCriteriaResort_objectSpread({}, state), {}, {
      label: label
    }));
  };

  var onSelectSearch = function onSelectSearch(_ref2) {
    var id = _ref2.id,
        label = _ref2.label,
        offsetSell = _ref2.offsetSell,
        subLabel1 = _ref2.subLabel1,
        _ref2$openingDates = _ref2.openingDates,
        openingDates = _ref2$openingDates === void 0 ? [] : _ref2$openingDates;
    setState({
      country: subLabel1,
      label: label,
      offsetSell: offsetSell,
      value: id,
      openingDates: openingDates
    });
  };

  var inputResortId = 'ResortSearchAutoComplete';
  return EditMyCriteriaResort_jsx(EditMyCriteriaFieldWrapper_EditMyCriteriaFieldWrapper, {
    disableValidateButton: !state.value,
    focusedFilterBtn: focusedFilterBtn,
    i18n: i18n,
    onClose: function onClose() {
      clearState();
      cancelEditingCriteria();
    },
    onValidate: updateCriteriaSearch,
    trackCriteriaClick: trackCLickOnField,
    triggerComponent: EditMyCriteriaResort_jsx(ResortSummary["a" /* ResortSummary */], {
      resort: {
        destination: {
          country: search.country
        },
        name: search.label
      }
    })
  }, EditMyCriteriaResort_jsx("div", {
    className: "px-px15 py-px25"
  }, EditMyCriteriaResort_jsx("label", {
    className: "mb-px25 text-lg font-bold lg:text-center block",
    htmlFor: inputResortId
  }, Object(src_i18n["g" /* t */])('booking.editCriteria.resortChangeTitle')), EditMyCriteriaResort_jsx(ResortSearchAutoComplete["a" /* ResortSearchAutoComplete */], {
    autoFocus: true,
    inputId: inputResortId,
    isValid: false,
    onChange: onChangeSearch,
    onSelect: onSelectSearch,
    placeholder: Object(src_i18n["g" /* t */])('common.comparator.search'),
    resortList: resortList,
    search: state.label
  })));
};
// EXTERNAL MODULE: ./src/client/context/DepartureCitiesContext.js
var DepartureCitiesContext = __webpack_require__("l5FB");

// EXTERNAL MODULE: ./src/utils/pertimm-client/index.js + 1 modules
var pertimm_client = __webpack_require__("y316");

// EXTERNAL MODULE: ./src/client/components/widgets/transport-details/transportUtils.js
var transportUtils = __webpack_require__("z8xc");

// EXTERNAL MODULE: ./src/client/components/widgets/edit-my-criteria/utils.js
var utils = __webpack_require__("JaD2");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-transport/filter-transport/FilterTransport.jsx
var FilterTransport = __webpack_require__("M3jp");

// EXTERNAL MODULE: ./src/client/components/widgets/package/price/TransportSummary.jsx
var TransportSummary = __webpack_require__("YKA5");

// CONCATENATED MODULE: ./src/client/components/widgets/edit-my-criteria/criteria/EditMyCriteriaTransport.jsx







var EditMyCriteriaTransport_jsx = react_default.a.createElement;

function EditMyCriteriaTransport_createSuper(Derived) { var hasNativeReflectConstruct = EditMyCriteriaTransport_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function EditMyCriteriaTransport_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }










var EditMyCriteriaTransport_EditMyCriteriaTransport = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(EditMyCriteriaTransport, _Component);

  var _super = EditMyCriteriaTransport_createSuper(EditMyCriteriaTransport);

  function EditMyCriteriaTransport() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, EditMyCriteriaTransport);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      departureCityId: _this.props.departureCity.value,
      departureCityLabel: _this.props.departureCity.label
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "transportIcon", Object(transportUtils["l" /* getTransportIcon */])(Object(lodash["get"])(_this.props.proposal, 'transports.inbound'), Object(lodash["get"])(_this.props.proposal, 'transports.outbound')));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "trackCLickOnField", function () {
      _this.props.trackCriteriaClick('departureCity');
    });

    return _this;
  }

  Object(createClass["a" /* default */])(EditMyCriteriaTransport, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.context.departureCities.length === 0) {
        Object(pertimm_client["b" /* search */])({
          appContext: this.props.appContext
        }).then(function (_ref) {
          var catalogs = _ref.catalogs;

          _this2.context.setDepartureCities(Object(utils["a" /* mapCatalogIntoDepartureCities */])({
            catalogs: catalogs,
            noTransportLabel: _this2.props.i18n.booking.priceDetails.packagePrice.noTransport
          }));
        });
      }
    }
  }, {
    key: "updateCriteriaTransport",
    value: function updateCriteriaTransport() {
      this.props.updateCriteriaField('departureCity', {
        value: this.state.departureCityId,
        label: this.state.departureCityLabel
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          className = _this$props.className,
          i18n = _this$props.i18n,
          departureCity = _this$props.departureCity,
          cancelEditingCriteria = _this$props.cancelEditingCriteria;
      return EditMyCriteriaTransport_jsx(EditMyCriteriaFieldWrapper_EditMyCriteriaFieldWrapper, {
        className: className,
        i18n: i18n,
        onClose: function onClose() {
          _this3.setState({
            departureCityId: departureCity.value,
            departureCityLabel: departureCity.label
          });

          cancelEditingCriteria();
        },
        onValidate: function onValidate() {
          _this3.updateCriteriaTransport();
        },
        trackCriteriaClick: this.trackCLickOnField,
        triggerComponent: EditMyCriteriaTransport_jsx(TransportSummary["a" /* TransportSummary */], {
          departure: departureCity.value !== 'NO' ? departureCity.label : null,
          transportIcon: this.transportIcon
        })
      }, EditMyCriteriaTransport_jsx(FilterTransport["a" /* FilterTransport */], {
        changeDepartureCity: function changeDepartureCity(newDepartureCity) {
          _this3.setState({
            // $FlowFixMe
            departureCityId: newDepartureCity,
            departureCityLabel: Object(lodash["get"])(_this3.context.departureCities.find(function (_ref2) {
              var value = _ref2.value;
              return value === newDepartureCity;
            }), 'label')
          });
        },
        departureCity: this.state.departureCityId,
        optionsDepartureCities: this.context.departureCities,
        preselectDefault: false,
        reassurance: i18n.faceting.transport.reassurance
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props) {
      var shouldResetCriteria = props.shouldResetCriteria,
          onCriteriaReset = props.onCriteriaReset,
          departureCity = props.departureCity;

      if (shouldResetCriteria) {
        onCriteriaReset();
        return {
          departureCityId: departureCity.value,
          departureCityLabel: departureCity.label
        };
      }

      return null;
    }
  }]);

  return EditMyCriteriaTransport;
}(react["Component"]);

Object(defineProperty["a" /* default */])(EditMyCriteriaTransport_EditMyCriteriaTransport, "contextType", DepartureCitiesContext["a" /* default */]);
// CONCATENATED MODULE: ./src/client/components/widgets/edit-my-criteria/EditMyCriteria.jsx







var EditMyCriteria_jsx = react_default.a.createElement;

function EditMyCriteria_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function EditMyCriteria_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { EditMyCriteria_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { EditMyCriteria_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function EditMyCriteria_createSuper(Derived) { var hasNativeReflectConstruct = EditMyCriteria_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function EditMyCriteria_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




















var trackingMappingCriteria = {
  attendees: 'Participant',
  departure: 'Date',
  departureCity: 'Transport',
  search: 'Resort'
};

var EditMyCriteria_EditMyCriteria = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(EditMyCriteria, _Component);

  var _super = EditMyCriteria_createSuper(EditMyCriteria);

  function EditMyCriteria() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, EditMyCriteria);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      shouldResetCriteria: false
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "currentPage", Object(BookingEngine_utils["b" /* getFilteredBreadcrumbPages */])({
      i18n: _this.props.i18n,
      isActivitiesViewFeatureFlipped: _this.props.isActivitiesViewFeatureFlipped,
      isOptionHoldOnlyFeatureFlipped: _this.props.isOptionHoldOnlyFeatureFlipped,
      resort: _this.props.resort,
      selectedProposal: _this.props.proposal
    }).find(function (el) {
      return _this.props.location.pathname === el.path;
    }));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "searchNewProposals", function (criteria) {
      var _this$props = _this.props,
          actionGA = _this$props.actionGA,
          history = _this$props.history,
          location = _this$props.location,
          onEditCriteriaApply = _this$props.onEditCriteriaApply,
          onError = _this$props.onError,
          onFetchProposals = _this$props.onFetchProposals,
          prepareBe = _this$props.prepareBe;
      var proposalsLoaderLabel = _this.props.i18n.booking.form.proposalsLoaderLabel;
      Object(BookingEngine_tracking["c" /* trackNavigation */])(actionGA, 'editCriteria_apply', _this.context);

      if (moment_default()(criteria.departure.date).isBefore(moment_default()().add(criteria.search.offsetSell, 'd'), 'day')) {
        // $FlowFixMe there is no real error
        return onError([]);
      }

      onFetchProposals(EditMyCriteria_objectSpread(EditMyCriteria_objectSpread({}, criteria), {}, {
        isJoyView: _this.props.resort.isJoyview
      }), proposalsLoaderLabel, _this.context, location).then(function (_ref) {
        var proposals = _ref.proposals;
        var resort = proposals.resort;

        if (proposals.errors) {
          throw new errors["a" /* ApiException */](proposals.errors);
        }

        var queryParams = EditMyCriteria_objectSpread({
          editCriteriaWarning: 'true'
        }, location.queryParams);

        var bookingUrl = Object(BookingPagesUtils["i" /* getBookingEngineUri */])(BookingPagesUtils["a" /* PAGE_BE_ACCOMMODATION */], proposals.proposals, resort, proposals.proposals[0].id, queryParams);
        prepareBe({
          proposalId: proposals.proposals[0].id,
          proposals: proposals,
          resort: resort
        });
        onEditCriteriaApply(); // $FlowFixMe

        history.pushRoute(bookingUrl);
        window.scrollTo(0, 0);
      }).catch(function (err) {
        onError(err);
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "trackCLickOnCriteriaField", function (field) {
      var _this$props2 = _this.props,
          actionGA = _this$props2.actionGA,
          isEditing = _this$props2.isEditing,
          toggleEditCriteriaMode = _this$props2.toggleEditCriteriaMode;

      if (!isEditing) {
        toggleEditCriteriaMode();
      }

      Object(BookingEngine_tracking["c" /* trackNavigation */])(actionGA, "editCriteria_modify".concat(trackingMappingCriteria[field]), _this.context);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onCriteriaReset", function () {
      if (_this.state.shouldResetCriteria) {
        _this.setState({
          shouldResetCriteria: false
        });
      }
    });

    return _this;
  }

  Object(createClass["a" /* default */])(EditMyCriteria, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          focusedFilterBtn = _this$props3.focusedFilterBtn,
          i18n = _this$props3.i18n,
          isEditing = _this$props3.isEditing,
          proposal = _this$props3.proposal,
          resort = _this$props3.resort,
          toggleEditCriteriaMode = _this$props3.toggleEditCriteriaMode;
      var shouldResetCriteria = this.state.shouldResetCriteria;
      return EditMyCriteria_jsx(CriteriaConsumer, null, function (_ref2) {
        var _criteria$departure$d;

        var criteria = _ref2.criteria,
            initialCriteria = _ref2.initialCriteria,
            updateCriteria = _ref2.updateCriteria,
            resetCriteria = _ref2.resetCriteria,
            criteriaEdited = _ref2.criteriaEdited,
            updateEditing = _ref2.updateEditing;

        var shouldResetDeparture = function shouldResetDeparture(openingDates) {
          var departure = criteria.departure;

          if (openingDates.length === 0 || departure.date == null) {
            return false;
          }

          var returnalDate = departure.date.clone().add(departure.duration, 'd');
          var isInRangeDeparture = openingDates.some(function (_ref3) {
            var opening = _ref3.opening,
                closing = _ref3.closing;
            var momentOpening = Object(apiDate["h" /* momentFromApiDate */])(opening);
            var momentClosing = Object(apiDate["h" /* momentFromApiDate */])(closing);
            return (// $FlowFixMe flow static analisis doesn't get that we already check if departure.date is !null & !undefined
              departure.date.isBetween(momentOpening, momentClosing) && returnalDate.isBetween(momentOpening, momentClosing)
            );
          });
          return !isInRangeDeparture;
        };

        var getNewCriteria = function getNewCriteria(field, value) {
          if (field === 'search' && shouldResetDeparture(value.openingDates)) {
            var _ref4;

            return _ref4 = {}, Object(defineProperty["a" /* default */])(_ref4, field, value), Object(defineProperty["a" /* default */])(_ref4, "departure", {
              date: null,
              duration: null
            }), _ref4;
          }

          return Object(defineProperty["a" /* default */])({}, field, value);
        };

        var updateCriteriaField = function updateCriteriaField(field, value) {
          var actionGA = _this2.props.actionGA;
          Object(BookingEngine_tracking["c" /* trackNavigation */])(actionGA, "editCriteria_validate".concat(trackingMappingCriteria[field]), _this2.context);
          var newCriteria = getNewCriteria(field, value);
          updateCriteria(newCriteria);
          /**
           * Should calculate the new criteria here because criteriaState
           * will not pick the new value until the next render
           *  */

          var futurCriteria = EditMyCriteria_objectSpread(EditMyCriteria_objectSpread({}, criteria), newCriteria);

          if (Object(lodash["isEqual"])(initialCriteria, futurCriteria)) {
            toggleEditCriteriaMode();
            updateEditing(false);
          }
        };

        var cancelEditingCriteria = function cancelEditingCriteria() {
          toggleEditCriteriaMode();
          resetCriteria();

          _this2.setState({
            shouldResetCriteria: true
          });
        };

        return EditMyCriteria_jsx(react["Fragment"], null, EditMyCriteria_jsx(Capsule["a" /* Capsule */], {
          additionalStyle: {
            content: {
              overflow: 'visible'
            }
          }
        }, EditMyCriteria_jsx("div", {
          className: "flex flex-col lg:flex-row"
        }, EditMyCriteria_jsx(EditMyCriteriaResort_EditMyCriteriaResort, {
          appContext: _this2.context,
          cancelEditingCriteria: cancelEditingCriteria,
          defaultOffsetSell: resort.offsetSell,
          focusedFilterBtn: focusedFilterBtn,
          i18n: i18n,
          search: criteria.search,
          trackCriteriaClick: _this2.trackCLickOnCriteriaField,
          updateCriteriaField: updateCriteriaField
        }), EditMyCriteria_jsx(EditMyCriteriaDeparture_EditMyCriteriaDeparture, {
          key: ((_criteria$departure$d = criteria.departure.date) === null || _criteria$departure$d === void 0 ? void 0 : _criteria$departure$d.toString()) || 'empty-date',
          cancelEditingCriteria: cancelEditingCriteria,
          className: "border-t-1 lg:border-t-0 lg:border-l-1 border-gray-light border-solid",
          departure: criteria.departure,
          offsetSell: criteria.search.offsetSell,
          onCriteriaReset: _this2.onCriteriaReset,
          openingDates: criteria.search.openingDates,
          optionsDuration: i18n.faceting.when.durations,
          shouldResetCriteria: shouldResetCriteria,
          trackCriteriaClick: _this2.trackCLickOnCriteriaField,
          updateCriteriaField: updateCriteriaField
        }), EditMyCriteria_jsx(EditMyCriteriaAttendees, {
          attendees: criteria.attendees,
          className: "border-t-1 lg:border-t-0 lg:border-l-1 border-gray-light border-solid",
          cancelEditingCriteria: cancelEditingCriteria,
          i18n: i18n,
          onCriteriaReset: _this2.onCriteriaReset,
          shouldResetCriteria: shouldResetCriteria,
          trackCriteriaClick: _this2.trackCLickOnCriteriaField,
          updateCriteriaField: updateCriteriaField
        }), EditMyCriteria_jsx(EditMyCriteriaTransport_EditMyCriteriaTransport, {
          appContext: _this2.context,
          className: "border-t-1 lg:border-t-0 lg:border-l-1 border-gray-light border-solid",
          cancelEditingCriteria: cancelEditingCriteria,
          departureCity: criteria.departureCity,
          i18n: i18n,
          onCriteriaReset: _this2.onCriteriaReset,
          proposal: proposal,
          shouldResetCriteria: shouldResetCriteria,
          trackCriteriaClick: _this2.trackCLickOnCriteriaField,
          updateCriteriaField: updateCriteriaField
        }))), EditMyCriteria_jsx("div", {
          className: "mt-px10 text-center text-orange"
        }, criteriaEdited ? i18n.booking.editCriteria.alertMessage : EditMyCriteria_jsx(react["Fragment"], null, "\xA0")), isEditing && EditMyCriteria_jsx("div", {
          className: "mt-px20 text-center"
        }, EditMyCriteria_jsx("button", {
          className: "font-bold my-px10 reset-button text-turquoise underline",
          onClick: cancelEditingCriteria,
          type: "button"
        }, i18n.common.cancel), EditMyCriteria_jsx(Button["a" /* Button */], {
          className: "mx-px15 uppercase",
          colorBg: colors["a" /* COLORS */].TURQUOISE,
          colorBorder: colors["a" /* COLORS */].TURQUOISE,
          minWidth: "initial",
          onClick: function onClick() {
            return _this2.searchNewProposals(criteria);
          }
        }, i18n.common.apply)));
      });
    }
  }]);

  return EditMyCriteria;
}(react["Component"]);

Object(defineProperty["a" /* default */])(EditMyCriteria_EditMyCriteria, "contextType", ReactAppContext["a" /* default */]);

/* harmony default export */ var edit_my_criteria_EditMyCriteria = (Object(withRouter["a" /* withRouter */])(EditMyCriteria_EditMyCriteria));
// CONCATENATED MODULE: ./src/client/components/widgets/edit-my-criteria/EditMyCriteria.container.jsx



var mapDispatchToProps = {
  onFetchProposals: proposals_action["i" /* editCriteriaFetchProposals */],
  prepareBe: proposals_action["m" /* prepareBe */]
};
/* harmony default export */ var EditMyCriteria_container = (Object(es["c" /* connect */])(null, mapDispatchToProps)(edit_my_criteria_EditMyCriteria));
// EXTERNAL MODULE: ./src/client/components/frameworks/link/Link.jsx + 1 modules
var Link = __webpack_require__("RZpO");

// EXTERNAL MODULE: ./src/client/components/widgets/package/price/PackagePriceSummary.jsx + 1 modules
var PackagePriceSummary = __webpack_require__("d8Tx");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/views/booking/receipt/paid-services-list/paidService.constants.js
var paidService_constants = __webpack_require__("VawQ");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// CONCATENATED MODULE: ./src/client/views/booking/receipt/SellerCommission.jsx
var SellerCommission_jsx = react_default.a.createElement;





var SellerCommission_SellerCommission = function SellerCommission(_ref) {
  var proposal = _ref.proposal;

  var _useState = Object(react["useState"])(false),
      shownCommission = _useState[0],
      setShownCommission = _useState[1];

  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: 'confirmationDucroire',
    categoryGA: 'bookingEngine',
    siteSection: 'Booking Engine'
  });

  if (!proposal.sellerCommission) {
    return null;
  }

  return SellerCommission_jsx("div", {
    className: "border-t border-gray-light p-px10"
  }, shownCommission && SellerCommission_jsx("div", {
    className: "flex justify-between"
  }, SellerCommission_jsx("div", null, SellerCommission_jsx("div", {
    className: "text-gray-darker text-base"
  }, Object(src_i18n["g" /* t */])('booking.partners.fees.feesLabel')), SellerCommission_jsx("div", {
    className: "text-gray-medium text-sm"
  }, Object(src_i18n["g" /* t */])('booking.partners.fees.nonBindingInfo'))), SellerCommission_jsx("div", {
    className: "text-blue font-bold"
  }, proposal.sellerCommission.formattedValue)), SellerCommission_jsx(Button["a" /* Button */], {
    theme: "link",
    className: classnames_default()('w-full text-blue text-base underline', {
      'mt-px10': shownCommission
    }),
    onClick: function onClick() {
      !shownCommission && track({
        labelGA: 'SeeCommision',
        categoryGA: 'confirmationDucroire'
      });
      setShownCommission(function (shownCommissionState) {
        return !shownCommissionState;
      });
    }
  }, Object(src_i18n["g" /* t */])(shownCommission ? 'booking.partners.fees.hideLabel' : 'booking.partners.fees.showMoreLabel')));
};
// EXTERNAL MODULE: ./src/client/components/utils/booking/bookingUtils.js
var bookingUtils = __webpack_require__("aWOT");

// EXTERNAL MODULE: ./src/client/components/utils/className/className.util.js
var className_util = __webpack_require__("wJdf");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// CONCATENATED MODULE: ./src/client/views/booking/receipt/paid-services-list/CollapsibleItem.jsx
var CollapsibleItem_jsx = react_default.a.createElement;







function CollapsibleItem(_ref) {
  var additionalClass = _ref.additionalClass,
      title = _ref.title,
      children = _ref.children,
      details = _ref.details,
      subContent = _ref.subContent;

  var _useState = Object(react["useState"])(false),
      showDetails = _useState[0],
      setShowDetails = _useState[1];

  var collapsibleItemClassNames = Object(className_util["b" /* getClassWithModifiers */])('CollapsibleItem', [showDetails ? 'open' : null]);
  return CollapsibleItem_jsx("div", {
    className: classnames_default()(collapsibleItemClassNames, additionalClass)
  }, CollapsibleItem_jsx("div", {
    className: classnames_default()('CollapsibleItem-content', {
      'rtl:mr-px30': !details
    })
  }, children, details && CollapsibleItem_jsx("button", {
    "aria-expanded": showDetails,
    type: "button",
    className: "reset-button CollapsibleItem-detailsIconContainer",
    onClick: function onClick() {
      return setShowDetails(!showDetails);
    }
  }, CollapsibleItem_jsx(Icon["a" /* Icon */], {
    name: showDetails ? icons["a" /* ICONS */].CIRCLED_CROSS : icons["a" /* ICONS */].TOOLTIP,
    width: "1.25rem",
    className: "CollapsibleItem-detailsIcon"
  }), CollapsibleItem_jsx("span", {
    className: "sr-only"
  }, "".concat(title, " - ").concat(showDetails ? Object(src_i18n["g" /* t */])('common.loadLess') : Object(src_i18n["g" /* t */])('common.loadMore'))))), subContent && CollapsibleItem_jsx("div", {
    className: "CollapsibleItem-subContent"
  }, subContent), CollapsibleItem_jsx(lib["UnmountClosed"], {
    isOpened: showDetails
  }, CollapsibleItem_jsx("div", {
    className: "CollapsibleItem-details"
  }, details)));
}
// CONCATENATED MODULE: ./src/client/views/booking/receipt/paid-services-list/PaidServicesListItem.jsx
var PaidServicesListItem_jsx = react["createElement"];






var PaidServicesListItem_PaidServicesListItem = function PaidServicesListItem(_ref) {
  var titleClassModifier = _ref.titleClassModifier,
      color = _ref.color,
      icon = _ref.icon,
      title = _ref.title,
      subItems = _ref.subItems,
      price = _ref.price,
      details = _ref.details;
  var subContent = !Object(lodash["isEmpty"])(subItems) ? PaidServicesListItem_jsx(react["Fragment"], null, subItems.map(function (subItem) {
    return PaidServicesListItem_jsx("div", {
      key: subItem.title,
      className: "PaidServicesList-subItem"
    }, PaidServicesListItem_jsx("div", {
      className: "PaidServicesListItem-subItemTitle"
    }, subItem.title), PaidServicesListItem_jsx("div", {
      className: "PaidServicesListItem-subItemPrice"
    }, subItem.price));
  })) : null;
  return PaidServicesListItem_jsx(CollapsibleItem, {
    title: title,
    details: details,
    subContent: subContent,
    additionalClass: "PaidServicesListItem"
  }, PaidServicesListItem_jsx("div", {
    className: "PaidServicesListItem-section",
    style: {
      color: color
    }
  }, PaidServicesListItem_jsx("p", {
    className: classnames_default()('reset-paragraph', Object(className_util["b" /* getClassWithModifiers */])('PaidServicesListItem-itemTitle', [titleClassModifier]), {
      'font-brand': titleClassModifier === 'brandFont'
    })
  }, icon ? PaidServicesListItem_jsx(Icon["a" /* Icon */], {
    name: icon,
    className: "flex-shrink-0 PaidServicesList-itemIcon",
    width: "1.5625rem"
  }) : null, title), PaidServicesListItem_jsx("div", {
    className: "PaidServicesListItem-itemPrice",
    style: {
      color: color
    }
  }, price)));
};
// EXTERNAL MODULE: ./src/client/components/widgets/transport-details/flight-summary/FlightSummary.jsx
var FlightSummary = __webpack_require__("Hapo");

// EXTERNAL MODULE: ./src/utils/label/labelUtils.js
var labelUtils = __webpack_require__("WGoB");

// CONCATENATED MODULE: ./src/client/views/booking/receipt/paid-services-list/PaidServicesTransportDetails.jsx







var PaidServicesTransportDetails_jsx = react_default.a.createElement;

function PaidServicesTransportDetails_createSuper(Derived) { var hasNativeReflectConstruct = PaidServicesTransportDetails_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function PaidServicesTransportDetails_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






var PaidServicesTransportDetails_TransportDetails = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(TransportDetails, _React$Component);

  var _super = PaidServicesTransportDetails_createSuper(TransportDetails);

  function TransportDetails() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, TransportDetails);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "renderFlightSummary", function (way) {
      var _this$props = _this.props,
          i18n = _this$props.i18n,
          _this$props$transport = _this$props.transports,
          inbound = _this$props$transport.inbound,
          outbound = _this$props$transport.outbound;
      var transportIcon = Object(transportUtils["l" /* getTransportIcon */])(inbound, outbound);
      var flight = way === 'INBOUND' ? inbound : outbound;
      var start = flight.travelSections[0].departure;
      var end = flight.travelSections[flight.travelSections.length - 1].arrival;
      return PaidServicesTransportDetails_jsx(FlightSummary["a" /* FlightSummary */], {
        way: way,
        transportIcon: transportIcon,
        departureFullName: Object(labelUtils["a" /* capitalizeName */])(start.label),
        arrivalFullName: Object(labelUtils["a" /* capitalizeName */])(end.label),
        i18n: i18n,
        date: start.date
      });
    });

    return _this;
  }

  Object(createClass["a" /* default */])(TransportDetails, [{
    key: "render",
    value: function render() {
      return PaidServicesTransportDetails_jsx("div", null, this.renderFlightSummary('INBOUND'), this.renderFlightSummary('OUTBOUND'));
    }
  }]);

  return TransportDetails;
}(react_default.a.Component);

/* harmony default export */ var PaidServicesTransportDetails = (PaidServicesTransportDetails_TransportDetails);
// CONCATENATED MODULE: ./src/client/views/booking/receipt/paid-services-list/PaidServicesList.jsx
var PaidServicesList_jsx = react["createElement"];













var SUBSCRIPTION_FEE_TYPE = 'SUBSCRIPTION';
var PORT_TAXES_FEE_TYPE = 'PORT_TAXES';
var PaidServicesList_PaidServicesList = function PaidServicesList(_ref) {
  var i18n = _ref.i18n,
      proposal = _ref.proposal,
      items = _ref.items,
      resort = _ref.resort;

  var renderItem = function renderItem(item, index) {
    var priceDetails = i18n.booking.priceDetails;
    /**
     * /!\ When changing this file change src/client/components/widgets/proposal-pdf/price-details/PdfPaidServicesList.jsx too
     */

    switch (item.type) {
      case paidService_constants["a" /* PAID_SERVICE */].PACKAGE:
        return PaidServicesList_jsx(PaidServicesListItem_PaidServicesListItem, {
          key: index,
          title: priceDetails.holidayPackage,
          price: item.price
        });

      case paidService_constants["a" /* PAID_SERVICE */].ROOM:
        return PaidServicesList_jsx(PaidServicesListItem_PaidServicesListItem, {
          key: index,
          title: Object(bookingUtils["b" /* tAlt */])({
            resortKeyPath: 'booking.priceDetails.packagePrice.room',
            cruiseKeyPath: 'booking.priceDetails.packagePrice.cabin',
            resort: resort
          }),
          price: priceDetails.packagePrice.included,
          details: item.accommodationTitle
        });

      case paidService_constants["a" /* PAID_SERVICE */].BEST_RATE:
        return PaidServicesList_jsx("div", {
          key: index,
          className: "CollapsibleItem PaidServicesListItem-bestRate"
        }, PaidServicesList_jsx("span", null, item.value), PaidServicesList_jsx("div", {
          className: "bestRate-check"
        }, PaidServicesList_jsx(Icon["a" /* Icon */], {
          name: icons["a" /* ICONS */].CHECK,
          color: colors["a" /* COLORS */].WHITE
        })));

      case paidService_constants["a" /* PAID_SERVICE */].DISCOUNT:
        return PaidServicesList_jsx(PaidServicesListItem_PaidServicesListItem, {
          key: index,
          price: item.discount,
          title: item.offerName,
          titleClassModifier: "bold",
          color: "#c35078",
          details: item.details
        });

      case paidService_constants["a" /* PAID_SERVICE */].TRANSFER:
        return PaidServicesList_jsx(PaidServicesListItem_PaidServicesListItem, {
          key: index,
          price: item.price || priceDetails.packagePrice.included,
          title: priceDetails.packagePrice.transfer,
          details: item.details
        });

      case paidService_constants["a" /* PAID_SERVICE */].CHILDCARES:
        return PaidServicesList_jsx(PaidServicesListItem_PaidServicesListItem, {
          key: index,
          title: item.title,
          price: item.price,
          details: item.details
        });

      case paidService_constants["a" /* PAID_SERVICE */].TRANSPORT:
        return PaidServicesList_jsx(PaidServicesListItem_PaidServicesListItem, {
          key: index,
          title: priceDetails.packagePrice.transport,
          price: priceDetails.packagePrice.included,
          details: PaidServicesList_jsx(PaidServicesTransportDetails, {
            i18n: i18n,
            transports: item.transports
          })
        });

      case paidService_constants["a" /* PAID_SERVICE */].SKIPASS:
        return PaidServicesList_jsx(PaidServicesListItem_PaidServicesListItem, {
          key: index,
          title: priceDetails.packagePrice.skiPassIncluded,
          price: priceDetails.packagePrice.included,
          details: PaidServicesList_jsx("ul", null, PaidServicesList_jsx("li", null, priceDetails.packagePrice.skiPassInfo), PaidServicesList_jsx("li", null, priceDetails.packagePrice.skiLessonsInfo))
        });

      case paidService_constants["a" /* PAID_SERVICE */].ALL_INCLUSIVE:
        return PaidServicesList_jsx(PaidServicesListItem_PaidServicesListItem, {
          key: index,
          title: priceDetails.packagePrice.allInclusive,
          subItems: item.subItems,
          icon: icons["a" /* ICONS */].ALL_INCLUSIVE,
          color: "#005589",
          titleClassModifier: "brandFont",
          details: priceDetails.packagePrice.allInclusiveReassurance.description
        });

      case paidService_constants["a" /* PAID_SERVICE */].BREAKFAST:
        return PaidServicesList_jsx(PaidServicesListItem_PaidServicesListItem, {
          key: index,
          title: priceDetails.packagePrice.breakfastIncludedRon,
          price: priceDetails.packagePrice.included,
          details: priceDetails.packagePrice.joyview.breakfastIncluded
        });

      case paidService_constants["a" /* PAID_SERVICE */].FFB:
        return PaidServicesList_jsx(PaidServicesListItem_PaidServicesListItem, {
          key: index // $FlowFixMe always find
          ,
          title: Object(proposalUtils["k" /* getPackage */])(proposal, proposal_constants["g" /* PACKAGE_FOOD_AND_BEVERAGE */]).label,
          subItems: item.subItems,
          icon: icons["a" /* ICONS */].DISHES,
          color: "#cf4a2a",
          titleClassModifier: "brandFont",
          details: priceDetails.packagePrice.allInclusiveReassurance.description
        });

      case paidService_constants["a" /* PAID_SERVICE */].INSURANCE:
        return PaidServicesList_jsx(PaidServicesListItem_PaidServicesListItem, {
          key: index,
          title: item.value,
          price: item.price,
          details: item.details
        });

      case paidService_constants["a" /* PAID_SERVICE */].PROMO_CODE:
        return PaidServicesList_jsx(PaidServicesListItem_PaidServicesListItem, {
          key: index,
          title: priceDetails.promoCode.label || priceDetails.packagePrice.reduction,
          price: item.value
        });

      case paidService_constants["a" /* PAID_SERVICE */].FEES:
        var title;
        var details;

        if (item.feeType === SUBSCRIPTION_FEE_TYPE) {
          title = priceDetails.packagePrice.fees.annualMembershipFeesLabel;
          details = priceDetails.packagePrice.annualFeesInformation;
        } else if (item.feeType === PORT_TAXES_FEE_TYPE) {
          title = priceDetails.packagePrice.fees.portTaxesLabel;
          details = priceDetails.packagePrice.fees.portTaxesDescription;
        } else {
          title = priceDetails.packagePrice.fees.touristicTaxesLabel;
          details = priceDetails.packagePrice.fees.touristicTaxesDescription;
        }

        return PaidServicesList_jsx(PaidServicesListItem_PaidServicesListItem, {
          key: index,
          title: title,
          details: details,
          price: item.price
        });

      case paidService_constants["a" /* PAID_SERVICE */].RENTAL:
        return PaidServicesList_jsx(PaidServicesListItem_PaidServicesListItem, {
          key: index,
          title: priceDetails.packagePrice.skiEquipment,
          price: item.price
        });

      case paidService_constants["a" /* PAID_SERVICE */].EXCURSIONS:
        return PaidServicesList_jsx(PaidServicesListItem_PaidServicesListItem, {
          key: index,
          title: priceDetails.packagePrice.excursions,
          price: item.price
        });

      case paidService_constants["a" /* PAID_SERVICE */].SPORTS:
        return PaidServicesList_jsx(PaidServicesListItem_PaidServicesListItem, {
          key: "".concat(item.type, "-").concat(index),
          title: priceDetails.packagePrice.sportActivities,
          price: item.price
        });

      case paidService_constants["a" /* PAID_SERVICE */].DONATION:
        return PaidServicesList_jsx(PaidServicesListItem_PaidServicesListItem, {
          key: index,
          title: priceDetails.packagePrice.donation,
          price: item.value,
          details: priceDetails.packagePrice.donationInformation
        });

      case paidService_constants["a" /* PAID_SERVICE */].TOTAL_PRICE:
        var totalPrice = item.totalPrice,
            label = item.label;
        return PaidServicesList_jsx("div", {
          className: "CollapsibleItem PaidServicesListItem-totalPrice flex-col",
          key: index
        }, PaidServicesList_jsx("div", {
          className: "flex items-center w-full justify-between"
        }, PaidServicesList_jsx("span", {
          className: "title"
        }, label), PaidServicesList_jsx("div", {
          className: "PaidServicesListItem-totalPriceItem"
        }, PaidServicesList_jsx("span", {
          className: "actualPrice"
        }, totalPrice.formattedValue))), i18n.booking.priceDetails.packagePrice.fees.displayTaxesAndFeesIncludedMention && PaidServicesList_jsx("div", {
          className: "text-gray-medium text-sm"
        }, Object(src_i18n["g" /* t */])('booking.priceDetails.packagePrice.fees.taxesAndFeesIncludedLabel')));

      default:
        throw new Error("PaidServicesList cannot render items of type ".concat(item.type));
    }
  };

  return PaidServicesList_jsx(Capsule["a" /* Capsule */], null, items.map(renderItem), proposal.sellerCommission && PaidServicesList_jsx(SellerCommission_SellerCommission, {
    proposal: proposal
  }));
};
// CONCATENATED MODULE: ./src/client/views/booking/receipt/discount/Discount.jsx





var Discount_jsx = react["createElement"];

function Discount_createSuper(Derived) { var hasNativeReflectConstruct = Discount_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function Discount_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






var Discount_Discount = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(Discount, _React$Component);

  var _super = Discount_createSuper(Discount);

  function Discount() {
    Object(classCallCheck["a" /* default */])(this, Discount);

    return _super.apply(this, arguments);
  }

  Object(createClass["a" /* default */])(Discount, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this$props = this.props,
          i18n = _this$props.i18n,
          offer = _this$props.offer;
      var i18nDiscount = i18n.booking.summary.discount;
      var i18nDiscountNext = nextProps.i18n.booking.summary.discount;
      var offerNext = nextProps.offer;
      var hasDiscountLabelDisplayChanged = i18nDiscountNext.discountLabelDisplay !== i18nDiscount.discountLabelDisplay;
      var hasDiscountLabelChanged = i18nDiscountNext.discountLabel !== i18nDiscount.discountLabel;
      var hasDiscountSavedDisplayChanged = i18nDiscountNext.discountSavedDisplay !== i18nDiscount.discountSavedDisplay;
      var hasDiscountSavedChanged = i18nDiscountNext.discountSaved !== i18nDiscount.discountSaved;
      var hasDicountChanged = offerNext.discount !== offer.discount;
      var hasOfferNameChanged = offerNext.offerName !== offer.offerName;
      return hasOfferNameChanged || hasDicountChanged || hasDiscountSavedChanged || hasDiscountSavedDisplayChanged || hasDiscountLabelChanged || hasDiscountLabelDisplayChanged;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          i18n = _this$props2.i18n,
          offer = _this$props2.offer;
      var color = '#c35078';
      var _i18n$booking$summary = i18n.booking.summary.discount,
          discountLabelDisplay = _i18n$booking$summary.discountLabelDisplay,
          discountLabel = _i18n$booking$summary.discountLabel,
          discountSavedDisplay = _i18n$booking$summary.discountSavedDisplay,
          discountSaved = _i18n$booking$summary.discountSaved;
      var discount = offer.discount,
          offerName = offer.offerName; // Check also offer discount to be sure to have a value to display
      // and prevent an empty discount bloc

      if (!discountLabelDisplay || !discount) return null;
      var howMuchSaved = discountSavedDisplay ? "".concat(discount, " ").concat(discountSaved) : discount;
      var capsuleAdditionalStyle = {
        header: {
          height: '90px',
          overflowY: 'hidden'
        },
        icon: {
          position: 'absolute',
          transform: 'scale(5)',
          msTransform: 'scale(5)',
          transformOrigin: 'top',
          msTransformOrigin: 'top',
          top: '10px',
          opacity: '0.4',
          left: '35%'
        },
        label: {
          fontFamily: 'Trident, Trebuchet MS, Verdana, Arial, sans-serif',
          fontWeight: 'bold',
          fontSize: '28px'
        }
      };
      return Discount_jsx("section", {
        className: classnames_default()(className, 'font-sans')
      }, Discount_jsx(Capsule["a" /* Capsule */], {
        color: color,
        label: discountLabel,
        header: "large",
        icon: icons["a" /* ICONS */].PERCENTAGE,
        additionalStyle: capsuleAdditionalStyle
      }, Discount_jsx("div", {
        className: "Discount-section flex items-start mt-px5 p-px20"
      }, Discount_jsx("div", {
        className: "flex items-start"
      }, offerName), Discount_jsx("div", {
        className: "Discount-rate text-grenadine"
      }, howMuchSaved))));
    }
  }]);

  return Discount;
}(react["Component"]);

/* harmony default export */ var discount_Discount = (Discount_Discount);
// CONCATENATED MODULE: ./src/client/views/booking/receipt/ReceiptError.jsx
var ReceiptError_jsx = react_default.a.createElement;







var ReceiptError_ReceiptError = function ReceiptError(_ref) {
  var displayError = _ref.displayError,
      onClick = _ref.onClick,
      i18n = _ref.i18n;
  var errorMessage = Object(lodash["get"])(i18n, 'booking.editCriteria.errorMessage');

  if (Array.isArray(displayError.apiErrors)) {
    var isTransportError = displayError.apiErrors.some(function (err) {
      return Object(lodash["get"])(err, 'errorCode') === 'noTransport';
    });
    if (isTransportError) errorMessage = Object(lodash["get"])(i18n, 'booking.accommodation.errorMessages.noTransport');
  }

  return ReceiptError_jsx("div", {
    className: "flex flex-col items-center h-full justify-center"
  }, ReceiptError_jsx(Icon["a" /* Icon */], {
    className: "text-orange",
    name: icons["a" /* ICONS */].WARNING,
    width: "1.25rem"
  }), ReceiptError_jsx("div", {
    className: "text-orange m-px15 max-w-3/5 text-center"
  }, errorMessage), ReceiptError_jsx("div", {
    className: "justify-center m-px15"
  }, ReceiptError_jsx(Button["a" /* Button */], {
    colorBg: colors["a" /* COLORS */].TURQUOISE,
    colorBorder: colors["a" /* COLORS */].TURQUOISE,
    onClick: onClick
  }, Object(lodash["get"])(i18n, 'booking.editCriteria.backCriteria'))));
};
// CONCATENATED MODULE: ./src/client/views/booking/receipt/Receipt.jsx








var Receipt_jsx = react_default.a.createElement;

function Receipt_createSuper(Derived) { var hasNativeReflectConstruct = Receipt_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function Receipt_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }


























var Receipt_Receipt = /*#__PURE__*/function (_PureComponent) {
  Object(inherits["a" /* default */])(Receipt, _PureComponent);

  var _super = Receipt_createSuper(Receipt);

  function Receipt() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Receipt);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      displayError: null
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "getPriceCompositionModel", function () {
      var _this$props = _this.props,
          resort = _this$props.resort,
          i18n = _this$props.i18n,
          proposal = _this$props.proposal;
      return Object(Receipt_utils["c" /* getPriceCompositionModel */])({
        resort: resort,
        i18n: i18n,
        proposal: proposal,
        context: _this.context
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "resetDisplayError", function () {
      _this.setState({
        displayError: null
      });
    });

    return _this;
  }

  Object(createClass["a" /* default */])(Receipt, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var resortEditBlock = document.querySelector("[data-testid=\"".concat(this.props.criteriaOpened || constants["o" /* CRITERIA_SELECTORS */].PRODUCT, "\"]"));

      if (this.props.editCriteriaMode && resortEditBlock && this.props.isTablet) {
        // it's not a good practice but we don't have the choice #11068
        // $FlowFixMe
        resortEditBlock.click();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var resortEditBlock = document.querySelector("[data-testid=\"".concat(this.props.criteriaOpened || constants["o" /* CRITERIA_SELECTORS */].PRODUCT, "\"]"));
      var isEditBlockAlreadyOpen = !!document.querySelector('[data-testid="DropDown-body"]');

      if (this.props.editCriteriaMode && resortEditBlock && !isEditBlockAlreadyOpen && prevProps.editCriteriaMode !== this.props.editCriteriaMode && this.props.isTablet) {
        // it's not a good practice but we don't have the choice #11068
        // $FlowFixMe
        resortEditBlock.click();
      }
    }
  }, {
    key: "getAllInclusiveDetails",
    value: function getAllInclusiveDetails() {
      var i18n = Object(lodash["get"])(this.props, 'i18n.booking.accommodation.packageContent.allInclusiveReassurance');
      var iconMap = {
        bar: icons["a" /* ICONS */].BAR,
        cuisine: icons["a" /* ICONS */].DISHES,
        entertainment: icons["a" /* ICONS */].ENTERTAINMENT,
        sportAndActivities: icons["a" /* ICONS */].SPORT,
        wifiAccess: icons["a" /* ICONS */].WIFI
      }; // Add the icon for each perk and returns only the ones set to show

      var perkList = Object.entries(i18n) // $FlowFixMe entries forces mixed type
      .map(function (_ref) {
        var _ref2 = Object(slicedToArray["a" /* default */])(_ref, 2),
            perkName = _ref2[0],
            perk = _ref2[1];

        return {
          icon: iconMap[perkName],
          show: perk.show,
          title: perk.message
        };
      }).filter(function (perk) {
        return perk.show;
      });
      return perkList;
    }
  }, {
    key: "renderAllInclusiveDetails",
    value: function renderAllInclusiveDetails() {
      var editCriteriaMode = this.props.editCriteriaMode;
      return Receipt_jsx("div", {
        cols: {
          M: 4
        },
        className: editCriteriaMode ? 'pointer-events-none opacity-25 select-none' : ''
      }, Receipt_jsx(AllInclusiveList["a" /* AllInclusiveList */], {
        items: this.getAllInclusiveDetails(),
        i18n: Object(lodash["get"])(this.props, 'i18n')
      }));
    }
  }, {
    key: "renderJoyviewUpsell",
    value: function renderJoyviewUpsell() {
      var editCriteriaMode = this.props.editCriteriaMode;
      var packageId = this.props.proposal.packageId;
      var isRON = packageId === proposal_constants["h" /* PACKAGE_ROOM_ONLY */];
      return Receipt_jsx("div", {
        cols: {
          M: 4
        },
        className: editCriteriaMode ? 'pointer-events-none opacity-25 select-none' : ''
      }, Receipt_jsx(Capsule["a" /* Capsule */], {
        header: "auto",
        icon: isRON ? icons["a" /* ICONS */].JOYVIEW_HAND : icons["a" /* ICONS */].DISHES,
        label: Object(lodash["get"])(Object(proposalUtils["k" /* getPackage */])(this.props.proposal, packageId), 'label'),
        color: isRON ? '#007672' : '#cf4a2a'
      }, Receipt_jsx(CollapsibleItem, {
        title: this.props.i18n.booking.priceDetails.packagePrice.notIncluded,
        details: Object(lodash["get"])(this.props, 'i18n.booking.priceDetails.packagePrice.joyview.allInclusiveNotIncluded')
      }, Receipt_jsx("div", {
        className: "flex flex-1 font-brand justify-between",
        "data-testid": "Receipt-joyviewUpsell"
      }, Receipt_jsx(Icon["a" /* Icon */], {
        color: colors["a" /* COLORS */].BLUE,
        isNotSquare: true,
        name: icons["a" /* ICONS */].CLUBMED_ALL_INCLUSIVE_SMALL,
        width: "7.5rem"
      }), Receipt_jsx("span", null, this.props.i18n.booking.priceDetails.packagePrice.notIncluded)))));
    }
  }, {
    key: "getOffer",
    value: function getOffer() {
      var _this$props2 = this.props,
          i18n = _this$props2.i18n,
          proposal = _this$props2.proposal;
      var offerName = Object(Receipt_utils["b" /* getOfferNameWithNrrLabel */])(proposal, i18n);
      return {
        type: paidService_constants["a" /* PAID_SERVICE */].DISCOUNT,
        discount: Object(Receipt_utils["a" /* getFullPrice */])(Object(lodash["get"])(proposal, 'price.aggregateDiscountPromoCode.amount'), '-'),
        offerName: offerName ? offerName : i18n.booking.priceDetails.packagePrice.reduction
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          actionGA = _this$props3.actionGA,
          i18n = _this$props3.i18n,
          proposal = _this$props3.proposal,
          resort = _this$props3.resort,
          editCriteriaMode = _this$props3.editCriteriaMode,
          currentPage = _this$props3.currentPage,
          toggleEditCriteriaMode = _this$props3.toggleEditCriteriaMode,
          focusedFilterBtn = _this$props3.focusedFilterBtn,
          focusedModifyBtn = _this$props3.focusedModifyBtn;
      var isJoyview = Object(lodash["get"])(this.props.resort, 'isJoyview'); // $FlowFixMe flow doesn't understand the find refinement

      var discountOffer = this.getPriceCompositionModel().find(function (item) {
        return item.type === paidService_constants["a" /* PAID_SERVICE */].DISCOUNT;
      });
      var isEditCriteriaDisabled = currentPage === 'banking' || !toggleEditCriteriaMode || !actionGA;
      var displayEditCriteriaLink = !isEditCriteriaDisabled && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(this.context)('booking.editCriteria') && !editCriteriaMode;
      var isActivitiesViewFeatureFlipped = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(this.context)('booking.displayActivities');
      var isOptionHoldOnlyFeatureFlipped = (Object(featureFlippingUtils["a" /* isFeatureFlipped */])(this.context)('booking.optionHoldOnly') || this.context.isCmta && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(this.context)('booking.cmta.optionHoldOnly')) && proposal.price && proposal.price.currency !== 'MXN'; // We use the CriteriaProvider to be able to keep the state of the EditMyCriteria even after we
      // unmounted it, which happens after an error

      return Receipt_jsx(CriteriaProvider_CriteriaProvider, {
        proposal: proposal,
        resort: resort
      }, this.state.displayError ? Receipt_jsx("div", {
        className: "max-w-site-medium mx-auto"
      }, Receipt_jsx(ReceiptError_ReceiptError, {
        displayError: this.state.displayError,
        i18n: i18n,
        onClick: this.resetDisplayError
      })) : Receipt_jsx(react["Fragment"], null, Receipt_jsx("div", {
        className: "max-w-site-medium mb-px20 mx-auto"
      }, Receipt_jsx(Title["a" /* Title */], {
        className: "mb-px10",
        color: colors["a" /* COLORS */].BLUE,
        hLevel: 1,
        theme: "title-sans-4"
      }, Object(lodash["get"])(i18n, 'booking.priceDetails.packagePrice.yourStay')), isEditCriteriaDisabled ? Receipt_jsx(Capsule["a" /* Capsule */], null, Receipt_jsx(PackagePriceSummary["a" /* PackagePriceSummary */], {
        i18n: i18n,
        proposal: proposal,
        resort: resort,
        shouldShowResort: true
      })) : Receipt_jsx(EditMyCriteria_container, {
        actionGA: actionGA,
        isEditing: editCriteriaMode,
        i18n: i18n,
        focusedFilterBtn: focusedFilterBtn,
        proposal: proposal,
        resort: resort,
        onEditCriteriaApply: this.props.onEditCriteriaApply,
        onError: function onError(err) {
          _this2.setState({
            displayError: err
          });

          _this2.props.notifyParentNoResults && _this2.props.notifyParentNoResults();
        },
        toggleEditCriteriaMode: this.props.toggleEditCriteriaMode,
        isActivitiesViewFeatureFlipped: isActivitiesViewFeatureFlipped,
        isOptionHoldOnlyFeatureFlipped: isOptionHoldOnlyFeatureFlipped
      })), displayEditCriteriaLink && toggleEditCriteriaMode && Receipt_jsx("div", {
        className: "max-w-site-medium mb-px20 mx-auto"
      }, Receipt_jsx(Link["a" /* Link */], {
        icon: icons["a" /* ICONS */].PEN,
        label: i18n.common.modify,
        onClick: toggleEditCriteriaMode,
        ref: focusedModifyBtn
      })), Receipt_jsx("div", {
        className: classnames_default()('max-w-site-small mb-px20 mx-auto', {
          'pointer-events-none opacity-25 select-none': editCriteriaMode
        })
      }, Receipt_jsx(Title["a" /* Title */], {
        className: "mb-px10",
        color: colors["a" /* COLORS */].BLUE,
        theme: "title-sans-4"
      }, Object(lodash["get"])(i18n, "booking.priceDetails.packagePrice.".concat(!isJoyview || isJoyview && proposal.packageId === proposal_constants["f" /* PACKAGE_ALL_INCLUSIVE */] ? 'priceDetails' : 'priceDetailsRON'))), Receipt_jsx("div", {
        className: "flex flex-wrap -mx-px10"
      }, Receipt_jsx("div", {
        className: "p-px10 w-full sm:w-1/2"
      }, Receipt_jsx(PaidServicesList_PaidServicesList, {
        proposal: proposal,
        i18n: i18n // $FlowFixMe
        ,
        items: this.getPriceCompositionModel(),
        resort: resort
      })), discountOffer ? Receipt_jsx(discount_Discount, {
        className: "p-px10 w-full sm:w-1/2",
        i18n: i18n,
        offer: this.getOffer()
      }) : null, Receipt_jsx("div", {
        className: "p-px10 w-full sm:w-1/2"
      }, isJoyview && proposal.packageId !== proposal_constants["f" /* PACKAGE_ALL_INCLUSIVE */] ? this.renderJoyviewUpsell() : this.renderAllInclusiveDetails())))));
    }
  }]);

  return Receipt;
}(react["PureComponent"]);

Object(defineProperty["a" /* default */])(Receipt_Receipt, "contextType", ReactAppContext["a" /* default */]);

Object(defineProperty["a" /* default */])(Receipt_Receipt, "defaultProps", {
  criteriaOpened: constants["o" /* CRITERIA_SELECTORS */].PRODUCT,
  onEditCriteriaApply: function onEditCriteriaApply() {}
});

/***/ }),

/***/ "lTvC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Waypoint; });
/* harmony import */ var consolidated_events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("tsZ/");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("aWzz");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_is__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kvVz");
/* harmony import */ var react_is__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_is__WEBPACK_IMPORTED_MODULE_3__);





function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

/**
 * Attempts to parse the offset provided as a prop as a percentage. For
 * instance, if the component has been provided with the string "20%" as
 * a value of one of the offset props. If the value matches, then it returns
 * a numeric version of the prop. For instance, "20%" would become `0.2`.
 * If `str` isn't a percentage, then `undefined` will be returned.
 *
 * @param {string} str The value of an offset prop to be converted to a
 *   number.
 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
 *   was not a percentage.
 */
function parseOffsetAsPercentage(str) {
  if (str.slice(-1) === '%') {
    return parseFloat(str.slice(0, -1)) / 100;
  }

  return undefined;
}

/**
 * Attempts to parse the offset provided as a prop as a pixel value. If
 * parsing fails, then `undefined` is returned. Three examples of values that
 * will be successfully parsed are:
 * `20`
 * "20px"
 * "20"
 *
 * @param {string|number} str A string of the form "{number}" or "{number}px",
 *   or just a number.
 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
 *   was neither a number nor string ending in "px".
 */
function parseOffsetAsPixels(str) {
  if (!isNaN(parseFloat(str)) && isFinite(str)) {
    return parseFloat(str);
  }

  if (str.slice(-2) === 'px') {
    return parseFloat(str.slice(0, -2));
  }

  return undefined;
}

/**
 * @param {string|number} offset
 * @param {number} contextHeight
 * @return {number} A number representing `offset` converted into pixels.
 */

function computeOffsetPixels(offset, contextHeight) {
  var pixelOffset = parseOffsetAsPixels(offset);

  if (typeof pixelOffset === 'number') {
    return pixelOffset;
  }

  var percentOffset = parseOffsetAsPercentage(offset);

  if (typeof percentOffset === 'number') {
    return percentOffset * contextHeight;
  }

  return undefined;
}

var ABOVE = 'above';
var INSIDE = 'inside';
var BELOW = 'below';
var INVISIBLE = 'invisible';

function debugLog() {
  if (false) { var _console; }
}

/**
 * When an element's type is a string, it represents a DOM node with that tag name
 * https://facebook.github.io/react/blog/2015/12/18/react-components-elements-and-instances.html#dom-elements
 *
 * @param {React.element} Component
 * @return {bool} Whether the component is a DOM Element
 */
function isDOMElement(Component) {
  return typeof Component.type === 'string';
}

var errorMessage = '<Waypoint> needs a DOM element to compute boundaries. The child you passed is neither a ' + 'DOM element (e.g. <div>) nor does it use the innerRef prop.\n\n' + 'See https://goo.gl/LrBNgw for more info.';
/**
 * Raise an error if "children" is not a DOM Element and there is no ref provided to Waypoint
 *
 * @param {?React.element} children
 * @param {?HTMLElement} ref
 * @return {undefined}
 */

function ensureRefIsProvidedByChild(children, ref) {
  if (children && !isDOMElement(children) && !ref) {
    throw new Error(errorMessage);
  }
}

/**
 * @param {object} bounds An object with bounds data for the waypoint and
 *   scrollable parent
 * @return {string} The current position of the waypoint in relation to the
 *   visible portion of the scrollable parent. One of the constants `ABOVE`,
 *   `BELOW`, `INSIDE` or `INVISIBLE`.
 */

function getCurrentPosition(bounds) {
  if (bounds.viewportBottom - bounds.viewportTop === 0) {
    return INVISIBLE;
  } // top is within the viewport


  if (bounds.viewportTop <= bounds.waypointTop && bounds.waypointTop <= bounds.viewportBottom) {
    return INSIDE;
  } // bottom is within the viewport


  if (bounds.viewportTop <= bounds.waypointBottom && bounds.waypointBottom <= bounds.viewportBottom) {
    return INSIDE;
  } // top is above the viewport and bottom is below the viewport


  if (bounds.waypointTop <= bounds.viewportTop && bounds.viewportBottom <= bounds.waypointBottom) {
    return INSIDE;
  }

  if (bounds.viewportBottom < bounds.waypointTop) {
    return BELOW;
  }

  if (bounds.waypointTop < bounds.viewportTop) {
    return ABOVE;
  }

  return INVISIBLE;
}

var timeout;
var timeoutQueue = [];
function onNextTick(cb) {
  timeoutQueue.push(cb);

  if (!timeout) {
    timeout = setTimeout(function () {
      timeout = null; // Drain the timeoutQueue

      var item; // eslint-disable-next-line no-cond-assign

      while (item = timeoutQueue.shift()) {
        item();
      }
    }, 0);
  }

  var isSubscribed = true;
  return function unsubscribe() {
    if (!isSubscribed) {
      return;
    }

    isSubscribed = false;
    var index = timeoutQueue.indexOf(cb);

    if (index === -1) {
      return;
    }

    timeoutQueue.splice(index, 1);

    if (!timeoutQueue.length && timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
}

function resolveScrollableAncestorProp(scrollableAncestor) {
  // When Waypoint is rendered on the server, `window` is not available.
  // To make Waypoint easier to work with, we allow this to be specified in
  // string form and safely convert to `window` here.
  if (scrollableAncestor === 'window') {
    return global.window;
  }

  return scrollableAncestor;
}

var defaultProps = {
  debug: false,
  scrollableAncestor: undefined,
  children: undefined,
  topOffset: '0px',
  bottomOffset: '0px',
  horizontal: false,
  onEnter: function onEnter() {},
  onLeave: function onLeave() {},
  onPositionChange: function onPositionChange() {},
  fireOnRapidScroll: true
}; // Calls a function when you scroll to the element.

var Waypoint =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Waypoint, _React$PureComponent);

  function Waypoint(props) {
    var _this;

    _classCallCheck(this, Waypoint);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Waypoint).call(this, props));

    _this.refElement = function (e) {
      _this._ref = e;
    };

    return _this;
  }

  _createClass(Waypoint, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (!Waypoint.getWindow()) {
        return;
      } // this._ref may occasionally not be set at this time. To help ensure that
      // this works smoothly and to avoid layout thrashing, we want to delay the
      // initial execution until the next tick.


      this.cancelOnNextTick = onNextTick(function () {
        _this2.cancelOnNextTick = null;
        var _this2$props = _this2.props,
            children = _this2$props.children,
            debug = _this2$props.debug; // Berofe doing anything, we want to check that this._ref is avaliable in Waypoint

        ensureRefIsProvidedByChild(children, _this2._ref);
        _this2._handleScroll = _this2._handleScroll.bind(_this2);
        _this2.scrollableAncestor = _this2._findScrollableAncestor();

        if (false) {}

        _this2.scrollEventListenerUnsubscribe = Object(consolidated_events__WEBPACK_IMPORTED_MODULE_0__[/* addEventListener */ "a"])(_this2.scrollableAncestor, 'scroll', _this2._handleScroll, {
          passive: true
        });
        _this2.resizeEventListenerUnsubscribe = Object(consolidated_events__WEBPACK_IMPORTED_MODULE_0__[/* addEventListener */ "a"])(window, 'resize', _this2._handleScroll, {
          passive: true
        });

        _this2._handleScroll(null);
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this3 = this;

      if (!Waypoint.getWindow()) {
        return;
      }

      if (!this.scrollableAncestor) {
        // The Waypoint has not yet initialized.
        return;
      } // The element may have moved, so we need to recompute its position on the
      // page. This happens via handleScroll in a way that forces layout to be
      // computed.
      //
      // We want this to be deferred to avoid forcing layout during render, which
      // causes layout thrashing. And, if we already have this work enqueued, we
      // can just wait for that to happen instead of enqueueing again.


      if (this.cancelOnNextTick) {
        return;
      }

      this.cancelOnNextTick = onNextTick(function () {
        _this3.cancelOnNextTick = null;

        _this3._handleScroll(null);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!Waypoint.getWindow()) {
        return;
      }

      if (this.scrollEventListenerUnsubscribe) {
        this.scrollEventListenerUnsubscribe();
      }

      if (this.resizeEventListenerUnsubscribe) {
        this.resizeEventListenerUnsubscribe();
      }

      if (this.cancelOnNextTick) {
        this.cancelOnNextTick();
      }
    }
    /**
     * Traverses up the DOM to find an ancestor container which has an overflow
     * style that allows for scrolling.
     *
     * @return {Object} the closest ancestor element with an overflow style that
     *   allows for scrolling. If none is found, the `window` object is returned
     *   as a fallback.
     */

  }, {
    key: "_findScrollableAncestor",
    value: function _findScrollableAncestor() {
      var _this$props = this.props,
          horizontal = _this$props.horizontal,
          scrollableAncestor = _this$props.scrollableAncestor;

      if (scrollableAncestor) {
        return resolveScrollableAncestorProp(scrollableAncestor);
      }

      var node = this._ref;

      while (node.parentNode) {
        node = node.parentNode;

        if (node === document.body) {
          // We've reached all the way to the root node.
          return window;
        }

        var style = window.getComputedStyle(node);
        var overflowDirec = horizontal ? style.getPropertyValue('overflow-x') : style.getPropertyValue('overflow-y');
        var overflow = overflowDirec || style.getPropertyValue('overflow');

        if (overflow === 'auto' || overflow === 'scroll') {
          return node;
        }
      } // A scrollable ancestor element was not found, which means that we need to
      // do stuff on window.


      return window;
    }
    /**
     * @param {Object} event the native scroll event coming from the scrollable
     *   ancestor, or resize event coming from the window. Will be undefined if
     *   called by a React lifecyle method
     */

  }, {
    key: "_handleScroll",
    value: function _handleScroll(event) {
      if (!this._ref) {
        // There's a chance we end up here after the component has been unmounted.
        return;
      }

      var bounds = this._getBounds();

      var currentPosition = getCurrentPosition(bounds);
      var previousPosition = this._previousPosition;
      var _this$props2 = this.props,
          debug = _this$props2.debug,
          onPositionChange = _this$props2.onPositionChange,
          onEnter = _this$props2.onEnter,
          onLeave = _this$props2.onLeave,
          fireOnRapidScroll = _this$props2.fireOnRapidScroll;

      if (false) {} // Save previous position as early as possible to prevent cycles


      this._previousPosition = currentPosition;

      if (previousPosition === currentPosition) {
        // No change since last trigger
        return;
      }

      var callbackArg = {
        currentPosition: currentPosition,
        previousPosition: previousPosition,
        event: event,
        waypointTop: bounds.waypointTop,
        waypointBottom: bounds.waypointBottom,
        viewportTop: bounds.viewportTop,
        viewportBottom: bounds.viewportBottom
      };
      onPositionChange.call(this, callbackArg);

      if (currentPosition === INSIDE) {
        onEnter.call(this, callbackArg);
      } else if (previousPosition === INSIDE) {
        onLeave.call(this, callbackArg);
      }

      var isRapidScrollDown = previousPosition === BELOW && currentPosition === ABOVE;
      var isRapidScrollUp = previousPosition === ABOVE && currentPosition === BELOW;

      if (fireOnRapidScroll && (isRapidScrollDown || isRapidScrollUp)) {
        // If the scroll event isn't fired often enough to occur while the
        // waypoint was visible, we trigger both callbacks anyway.
        onEnter.call(this, {
          currentPosition: INSIDE,
          previousPosition: previousPosition,
          event: event,
          waypointTop: bounds.waypointTop,
          waypointBottom: bounds.waypointBottom,
          viewportTop: bounds.viewportTop,
          viewportBottom: bounds.viewportBottom
        });
        onLeave.call(this, {
          currentPosition: currentPosition,
          previousPosition: INSIDE,
          event: event,
          waypointTop: bounds.waypointTop,
          waypointBottom: bounds.waypointBottom,
          viewportTop: bounds.viewportTop,
          viewportBottom: bounds.viewportBottom
        });
      }
    }
  }, {
    key: "_getBounds",
    value: function _getBounds() {
      var _this$props3 = this.props,
          horizontal = _this$props3.horizontal,
          debug = _this$props3.debug;

      var _this$_ref$getBoundin = this._ref.getBoundingClientRect(),
          left = _this$_ref$getBoundin.left,
          top = _this$_ref$getBoundin.top,
          right = _this$_ref$getBoundin.right,
          bottom = _this$_ref$getBoundin.bottom;

      var waypointTop = horizontal ? left : top;
      var waypointBottom = horizontal ? right : bottom;
      var contextHeight;
      var contextScrollTop;

      if (this.scrollableAncestor === window) {
        contextHeight = horizontal ? window.innerWidth : window.innerHeight;
        contextScrollTop = 0;
      } else {
        contextHeight = horizontal ? this.scrollableAncestor.offsetWidth : this.scrollableAncestor.offsetHeight;
        contextScrollTop = horizontal ? this.scrollableAncestor.getBoundingClientRect().left : this.scrollableAncestor.getBoundingClientRect().top;
      }

      if (false) {}

      var _this$props4 = this.props,
          bottomOffset = _this$props4.bottomOffset,
          topOffset = _this$props4.topOffset;
      var topOffsetPx = computeOffsetPixels(topOffset, contextHeight);
      var bottomOffsetPx = computeOffsetPixels(bottomOffset, contextHeight);
      var contextBottom = contextScrollTop + contextHeight;
      return {
        waypointTop: waypointTop,
        waypointBottom: waypointBottom,
        viewportTop: contextScrollTop + topOffsetPx,
        viewportBottom: contextBottom - bottomOffsetPx
      };
    }
    /**
     * @return {Object}
     */

  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var children = this.props.children;

      if (!children) {
        // We need an element that we can locate in the DOM to determine where it is
        // rendered relative to the top of its context.
        return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("span", {
          ref: this.refElement,
          style: {
            fontSize: 0
          }
        });
      }

      if (isDOMElement(children) || Object(react_is__WEBPACK_IMPORTED_MODULE_3__["isForwardRef"])(children)) {
        var ref = function ref(node) {
          _this4.refElement(node);

          if (children.ref) {
            if (typeof children.ref === 'function') {
              children.ref(node);
            } else {
              children.ref.current = node;
            }
          }
        };

        return react__WEBPACK_IMPORTED_MODULE_2___default.a.cloneElement(children, {
          ref: ref
        });
      }

      return react__WEBPACK_IMPORTED_MODULE_2___default.a.cloneElement(children, {
        innerRef: this.refElement
      });
    }
  }]);

  return Waypoint;
}(react__WEBPACK_IMPORTED_MODULE_2___default.a.PureComponent);

if (false) {}

Waypoint.above = ABOVE;
Waypoint.below = BELOW;
Waypoint.inside = INSIDE;
Waypoint.invisible = INVISIBLE;

Waypoint.getWindow = function () {
  if (typeof window !== 'undefined') {
    return window;
  }

  return undefined;
};

Waypoint.defaultProps = defaultProps;
Waypoint.displayName = 'Waypoint';



/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq")))

/***/ }),

/***/ "lW4u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withOpenAndScrollToHash; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("zygG");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _tabs_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("GzVq");
/* harmony import */ var _scroll_scrollToHash__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("34at");



var __jsx = react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






function getWithIds(_ref) {
  var id = _ref.id,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;
  var mainId = id || Object(_tabs_util__WEBPACK_IMPORTED_MODULE_5__[/* getTabsMainId */ "c"])(items);
  var itemsWithIds = items.map(function (item, index) {
    var _getTabsItemIds = Object(_tabs_util__WEBPACK_IMPORTED_MODULE_5__[/* getTabsItemIds */ "b"])({
      id: item.id,
      index: index,
      mainId: mainId,
      title: item.header && item.header.title
    }),
        _getTabsItemIds2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_getTabsItemIds, 2),
        headerId = _getTabsItemIds2[0],
        panelId = _getTabsItemIds2[1];

    return _objectSpread(_objectSpread({}, item), {}, {
      headerId: headerId,
      panelId: panelId
    });
  });
  return [mainId, itemsWithIds];
}
/* scroll to Tabs or Accordion item #id and open it */


function withOpenAndScrollToHash(WrappedComponent) {
  return function OpenTabAndScrollToHash(props) {
    var _useState = Object(react__WEBPACK_IMPORTED_MODULE_3__["useState"])({
      initialSelectedItem: props.initialSelectedItem,
      initialSelectedItems: props.initialSelectedItems
    }),
        _useState$ = _useState[0],
        initialSelectedItem = _useState$.initialSelectedItem,
        initialSelectedItems = _useState$.initialSelectedItems,
        setIntialItems = _useState[1];

    var _getWithIds = getWithIds({
      id: props.id,
      items: props.items
    }),
        _getWithIds2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_getWithIds, 2),
        mainId = _getWithIds2[0],
        itemsWithIds = _getWithIds2[1];

    Object(react__WEBPACK_IMPORTED_MODULE_3__["useEffect"])(function () {
      var hash = _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["windowWrapper"].getLocationPart('hash');

      if (hash.length < 2) {
        setIntialItems({
          initialSelectedItem: props.initialSelectedItem,
          initialSelectedItems: props.initialSelectedItems
        });
        return;
      }

      var ids = itemsWithIds.map(function (_ref2) {
        var _ref2$headerId = _ref2.headerId,
            headerId = _ref2$headerId === void 0 ? '' : _ref2$headerId;
        return "#".concat(headerId);
      });
      var index = ids.indexOf(hash);

      if (index !== -1) {
        setIntialItems({
          initialSelectedItem: index,
          initialSelectedItems: [index]
        });
        setTimeout(function () {
          Object(_scroll_scrollToHash__WEBPACK_IMPORTED_MODULE_6__[/* goToHash */ "a"])(hash);
        }, 250);
      }
    }, [props.initialSelectedItem, props.initialSelectedItems]);
    return __jsx(WrappedComponent, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, props, {
      id: mainId,
      initialSelectedItems: initialSelectedItems,
      initialSelectedItem: initialSelectedItem,
      items: itemsWithIds,
      key: mainId // to reinitialize state when it is new tabs, see : https://fr.reactjs.org/blog/2018/06/07/you-probably-dont-need-derived-state.html#recommendation-fully-uncontrolled-component-with-a-key

    }));
  };
}

/***/ }),

/***/ "lr0Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaymentInfoContext; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
 // $FlowFixMe

var PaymentInfoContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createContext({
  isFreeDeposit: false
});

/***/ }),

/***/ "mamn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OverlaidActionProvider; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UCZK");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("e0Ti");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;




var OverlaidActionProvider = function OverlaidActionProvider(_ref) {
  var _ref$button = _ref.button,
      button = _ref$button === void 0 ? {} : _ref$button,
      children = _ref.children,
      _ref$dataSelector = _ref.dataSelector,
      dataSelector = _ref$dataSelector === void 0 ? 'OverlaidActionProvider' : _ref$dataSelector,
      label = _ref.label;
  var shouldRender = button.onClick && button.onClick !== lodash__WEBPACK_IMPORTED_MODULE_2__["noop"] || button.link;

  if (!shouldRender) {
    return null;
  }

  return __jsx(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null, __jsx("div", {
    "data-selector": "".concat(dataSelector, "--oapOuterContent")
  }, children), __jsx("div", {
    className: "flex flex-col items-center mt-px20"
  }, !!label && __jsx("div", {
    className: "font-brand text-blue text-xl",
    "data-selector": "".concat(dataSelector, "--oapLabel")
  }, label), __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_4__[/* Button */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    className: "m-px5",
    colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].TURQUOISE,
    colorBorder: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].TURQUOISE,
    dataSelector: "".concat(dataSelector, "-button")
  }, button), button.label)));
};

/***/ }),

/***/ "mmil":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("8+jV");
var uid = __webpack_require__("rvZv");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "mplc":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),

/***/ "mwRp":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("mplc");

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "n1QJ":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ "nJrx":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var shared = __webpack_require__("8+jV");
var has = __webpack_require__("DZWw");
var uid = __webpack_require__("rvZv");
var NATIVE_SYMBOL = __webpack_require__("wEFx");
var USE_SYMBOL_AS_UID = __webpack_require__("1a7w");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (NATIVE_SYMBOL && has(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "nnRT":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__("NYSw");

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ "nnm9":
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ "nvU9":
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__("I1fX"),
    isObject = __webpack_require__("tQYX"),
    isSymbol = __webpack_require__("a88S");

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ "o8kQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaidService; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("pWxA");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_className_className_util__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("wJdf");
/* harmony import */ var _utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("/Mt0");
/* harmony import */ var _frameworks_capsule_Capsule_jsx__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("jldR");
/* harmony import */ var _frameworks_icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_image_Image_jsx__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("0IQ5");
/* harmony import */ var _frameworks_tooltip_Tooltip_jsx__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("i3Ve");
/* harmony import */ var _frameworks_button_Button_jsx__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_text_Text_jsx__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("qqKu");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("SPKZ");








var __jsx = react__WEBPACK_IMPORTED_MODULE_8__["createElement"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable no-duplicate-imports */












var defaultProps = {
  icon: null,
  onClick: function onClick() {},
  label: '',
  subLabel: '',
  price: '',
  prestation: '',
  text: '',
  layout: 'row',
  reassurance: '',
  dataSelector: 'PaidService',
  ctaType: 'none',
  trackingContext: 'BookingPaidService',
  addLabel: '',
  removeLabel: '',
  trackOpenTooltip: function trackOpenTooltip() {},
  imageUrl: '',
  headColor: _utils_color_colors__WEBPACK_IMPORTED_MODULE_10__[/* COLORS */ "a"].BLUE,
  withLoader: true
};
var PaidService = /*#__PURE__*/function (_React$Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(PaidService, _React$Component);

  var _super = _createSuper(PaidService);

  function PaidService() {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(this, PaidService);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_this), "state", {
      isLoading: false,
      prevProps: _this.props
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_this), "handleClick", function () {
      if (_this.props.withLoader) {
        _this.setState({
          isLoading: true
        });
      }

      _this.props.onClick();
    });

    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(PaidService, [{
    key: "renderAddButton",
    value: function renderAddButton() {
      var _this$props = this.props,
          addLabel = _this$props.addLabel,
          prestation = _this$props.prestation,
          price = _this$props.price,
          ctaType = _this$props.ctaType,
          dataSelector = _this$props.dataSelector,
          getTrackingData = _this$props.getTrackingData;
      var label = price ? "".concat(addLabel, " ").concat(prestation, " +").concat(price) : addLabel;
      return __jsx(_frameworks_button_Button_jsx__WEBPACK_IMPORTED_MODULE_17__[/* Button */ "a"], {
        trackingData: getTrackingData ? getTrackingData('add') : undefined,
        onClick: this.handleClick,
        className: "w-full",
        color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_10__[/* COLORS */ "a"].WHITE,
        colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_10__[/* COLORS */ "a"].TURQUOISE,
        colorBorder: _utils_color_colors__WEBPACK_IMPORTED_MODULE_10__[/* COLORS */ "a"].TURQUOISE,
        isLoading: this.state.isLoading,
        dataSelector: "".concat(dataSelector, "-").concat(ctaType),
        isDisabled: ctaType === 'disabled'
      }, label);
    }
  }, {
    key: "renderRemoveButton",
    value: function renderRemoveButton() {
      var _this$props2 = this.props,
          removeLabel = _this$props2.removeLabel,
          prestation = _this$props2.prestation,
          price = _this$props2.price,
          ctaType = _this$props2.ctaType,
          dataSelector = _this$props2.dataSelector,
          getTrackingData = _this$props2.getTrackingData;
      var label = price ? "".concat(removeLabel, " ").concat(prestation, " -").concat(price) : removeLabel;
      return __jsx(_frameworks_button_Button_jsx__WEBPACK_IMPORTED_MODULE_17__[/* Button */ "a"], {
        trackingData: getTrackingData ? getTrackingData('add') : undefined,
        onClick: this.handleClick,
        isLoading: this.state.isLoading,
        className: "w-full",
        color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_10__[/* COLORS */ "a"].TURQUOISE,
        colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_10__[/* COLORS */ "a"].WHITE,
        colorBorder: _utils_color_colors__WEBPACK_IMPORTED_MODULE_10__[/* COLORS */ "a"].TURQUOISE,
        dataSelector: "".concat(dataSelector, "-").concat(ctaType)
      }, label);
    }
  }, {
    key: "renderIncludedIcon",
    value: function renderIncludedIcon() {
      return __jsx("span", {
        className: "PaidService-includedLabel font-brand"
      }, this.props.includedLabel);
    }
  }, {
    key: "renderCTA",
    value: function renderCTA() {
      switch (this.props.ctaType) {
        case 'add':
          return this.renderAddButton();

        case 'disabled':
          return this.renderAddButton();

        case 'remove':
          return this.renderRemoveButton();

        case 'included':
          return this.renderIncludedIcon();

        default:
          return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          icon = _this$props3.icon,
          label = _this$props3.label,
          subLabel = _this$props3.subLabel,
          tooltip = _this$props3.tooltip,
          text = _this$props3.text,
          reassurance = _this$props3.reassurance,
          ctaButton = _this$props3.ctaButton,
          trackOpenTooltip = _this$props3.trackOpenTooltip,
          imageUrl = _this$props3.imageUrl,
          layout = _this$props3.layout,
          headColor = _this$props3.headColor,
          withLoader = _this$props3.withLoader;
      return __jsx(_utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"].Consumer, null, function (responsive) {
        return __jsx(_frameworks_capsule_Capsule_jsx__WEBPACK_IMPORTED_MODULE_13__[/* Capsule */ "a"], {
          header: "none"
        }, __jsx("div", {
          className: Object(_utils_className_className_util__WEBPACK_IMPORTED_MODULE_11__[/* getClassWithModifiers */ "b"])('PaidService', [layout])
        }, responsive.isBrowserGreaterThan.XS && layout === 'row' && imageUrl ? __jsx("div", {
          className: Object(_utils_className_className_util__WEBPACK_IMPORTED_MODULE_11__[/* getClassWithModifiers */ "b"])('PaidService-pictureContainer', [layout])
        }, __jsx(_frameworks_image_Image_jsx__WEBPACK_IMPORTED_MODULE_15__[/* default */ "b"], {
          className: Object(_utils_className_className_util__WEBPACK_IMPORTED_MODULE_11__[/* getClassWithModifiers */ "b"])('PaidService-picture', [layout]),
          imageUrl: imageUrl,
          mandatoryWidthAndHeight: {
            w: '600',
            h: '428'
          },
          transformation: "resize"
        })) : null, __jsx("div", {
          className: Object(_utils_className_className_util__WEBPACK_IMPORTED_MODULE_11__[/* getClassWithModifiers */ "b"])('PaidService-content', [layout])
        }, __jsx("div", {
          className: Object(_utils_className_className_util__WEBPACK_IMPORTED_MODULE_11__[/* getClassWithModifiers */ "b"])('text-orange PaidService-header', [layout])
        }, __jsx(_frameworks_icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_14__[/* Icon */ "a"], {
          className: "PaidService-icon",
          color: headColor,
          name: icon,
          width: "2.125rem"
        }), __jsx("div", {
          className: Object(_utils_className_className_util__WEBPACK_IMPORTED_MODULE_11__[/* getClassWithModifiers */ "b"])('PaidService-labels', [layout])
        }, __jsx("span", {
          className: Object(_utils_className_className_util__WEBPACK_IMPORTED_MODULE_11__[/* getClassWithModifiers */ "b"])('PaidService-label', [layout])
        }, __jsx("span", {
          className: classnames__WEBPACK_IMPORTED_MODULE_9___default()("text-".concat(headColor), Object(_utils_className_className_util__WEBPACK_IMPORTED_MODULE_11__[/* getClassWithModifiers */ "b"])('PaidService-labelText', [layout]))
        }, label), _this2.props.children), subLabel ? __jsx("span", {
          className: "PaidService-subLabel"
        }, subLabel) : null), tooltip ? __jsx("div", {
          className: "PaidService-tooltipContainer"
        }, __jsx(_frameworks_tooltip_Tooltip_jsx__WEBPACK_IMPORTED_MODULE_16__[/* Tooltip */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, tooltip, {
          renderTrigger: function renderTrigger(toggle) {
            return __jsx("button", {
              "data-selector": tooltip.dataSelector,
              onClick: function onClick() {
                trackOpenTooltip();
                toggle();
              },
              className: "reset-button PackageExtraService-popinIcon text-blue",
              type: "button"
            }, __jsx(_frameworks_icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_14__[/* Icon */ "a"], {
              width: "1.25rem",
              name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_19__[/* ICONS */ "a"].TOOLTIP
            }));
          }
        }))) : null), (!responsive.isBrowserGreaterThan.XS || layout !== 'row') && imageUrl ? __jsx(_frameworks_image_Image_jsx__WEBPACK_IMPORTED_MODULE_15__[/* default */ "b"], {
          imageUrl: imageUrl,
          mandatoryWidthAndHeight: {
            w: '600',
            h: '428'
          },
          className: Object(_utils_className_className_util__WEBPACK_IMPORTED_MODULE_11__[/* getClassWithModifiers */ "b"])('PaidService-picture', [layout])
        }) : null, __jsx(_frameworks_text_Text_jsx__WEBPACK_IMPORTED_MODULE_18__[/* Text */ "a"], {
          className: Object(_utils_className_className_util__WEBPACK_IMPORTED_MODULE_11__[/* getClassWithModifiers */ "b"])('pt-px15 text-md PaidService-bulletpoints', [layout]),
          text: text
        }), __jsx("div", {
          className: Object(_utils_className_className_util__WEBPACK_IMPORTED_MODULE_11__[/* getClassWithModifiers */ "b"])('PaidService-footer', [layout])
        }, __jsx(_frameworks_text_Text_jsx__WEBPACK_IMPORTED_MODULE_18__[/* Text */ "a"], {
          className: Object(_utils_className_className_util__WEBPACK_IMPORTED_MODULE_11__[/* getClassWithModifiers */ "b"])('PaidService-reassurance pb-px10', [layout]),
          color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_10__[/* COLORS */ "a"].GRAY_DARKER,
          text: reassurance,
          theme: "text-sans-2"
        }), __jsx("div", {
          className: classnames__WEBPACK_IMPORTED_MODULE_9___default()(Object(_utils_className_className_util__WEBPACK_IMPORTED_MODULE_11__[/* getClassWithModifiers */ "b"])('PaidService-button', [layout]), {
            hasPicture: !!imageUrl || !withLoader
          })
        }, ctaButton || _this2.renderCTA())))));
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.ctaType !== prevState.prevProps.ctaType) {
        return {
          isLoading: false,
          prevProps: nextProps
        };
      }

      return null;
    }
  }]);

  return PaidService;
}(react__WEBPACK_IMPORTED_MODULE_8__["Component"]);

Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(PaidService, "defaultProps", defaultProps);

/***/ }),

/***/ "oCTG":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("Syyo"),
    isArguments = __webpack_require__("bvyN"),
    isArray = __webpack_require__("wxYD");

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ "oMzG":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("MaE1");
var has = __webpack_require__("DZWw");
var wrappedWellKnownSymbolModule = __webpack_require__("9YYj");
var defineProperty = __webpack_require__("87KK").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "oOGh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServiceBlock; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("pWxA");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_collapse__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("3OwS");
/* harmony import */ var react_collapse__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react_collapse__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _frameworks_capsule_Capsule_jsx__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("jldR");
/* harmony import */ var _frameworks_icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("qBqs");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("UCZK");
/* harmony import */ var _frameworks_button_Button_jsx__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("e0Ti");








var __jsx = react__WEBPACK_IMPORTED_MODULE_8__["createElement"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }









var defaultProps = {
  dataSelector: 'ServiceBlock',
  addLabel: '',
  removeLabel: '',
  includedLabel: '',
  price: ''
};
var ServiceBlock = /*#__PURE__*/function (_React$Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(ServiceBlock, _React$Component);

  var _super = _createSuper(ServiceBlock);

  function ServiceBlock() {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(this, ServiceBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_this), "state", {
      shouldDisplayMoreDetails: false,
      isLoading: false,
      isClickHandlerPromise: false
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_this), "handleClick", function () {
      var promise = _this.props.button && _this.props.button.onClick && _this.props.button.onClick();

      if (promise && 'then' in promise) {
        _this.showLoader();

        _this.setState({
          isClickHandlerPromise: true
        });

        promise.finally(function () {
          _this.hideLoader();
        });
      }
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_this), "toggleDisplayMoreDetails", function () {
      _this.setState(function (prevState) {
        return {
          shouldDisplayMoreDetails: !prevState.shouldDisplayMoreDetails
        };
      });
    });

    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(ServiceBlock, [{
    key: "showLoader",
    value: function showLoader() {
      this.setState({
        isLoading: true
      });
    }
  }, {
    key: "hideLoader",
    value: function hideLoader() {
      this.setState({
        isLoading: false
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.button && this.props.button && prevProps.button.isLoading !== this.props.button.isLoading && !this.state.isClickHandlerPromise) {
        this.setState({
          isLoading: this.props.button.isLoading
        });
      }
    }
  }, {
    key: "renderCTA",
    value: function renderCTA() {
      var _this2 = this;

      var _this$props = this.props,
          addLabel = _this$props.addLabel,
          removeLabel = _this$props.removeLabel,
          includedLabel = _this$props.includedLabel,
          price = _this$props.price,
          type = _this$props.type,
          _this$props$dataSelec = _this$props.dataSelector,
          dataSelector = _this$props$dataSelec === void 0 ? 'ServiceBlock' : _this$props$dataSelec,
          trackingData = _this$props.trackingData,
          _this$props$button = _this$props.button;
      _this$props$button = _this$props$button === void 0 ? {} : _this$props$button;
      var buttonLabel = _this$props$button.label,
          dataCsOverrideId = _this$props$button.dataCsOverrideId;
      var labelAdd = price ? "".concat(addLabel, " +").concat(price) : addLabel;
      var labelRemove = price ? "".concat(removeLabel, " -").concat(price) : removeLabel;
      var trackingDataProp = trackingData ? // $FlowFixMe
      _objectSpread(_objectSpread({}, trackingData), {}, {
        labelGA: typeof trackingData.labelGA === 'function' ? trackingData.labelGA(type) : trackingData.labelGA
      }) : undefined;

      switch (type) {
        case 'add':
          return __jsx(_frameworks_button_Button_jsx__WEBPACK_IMPORTED_MODULE_15__[/* Button */ "a"], {
            onClick: function onClick() {
              return _this2.handleClick();
            },
            className: "w-full",
            colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_14__[/* COLORS */ "a"].TURQUOISE,
            colorBorder: _utils_color_colors__WEBPACK_IMPORTED_MODULE_14__[/* COLORS */ "a"].TURQUOISE,
            isLoading: this.state.isLoading,
            dataSelector: "".concat(dataSelector, "-").concat(type),
            dataTestId: "".concat(dataSelector, "-").concat(type),
            trackingData: trackingDataProp,
            dataCsOverrideId: dataCsOverrideId
          }, labelAdd);

        case 'remove':
        case 'edit':
          return __jsx(_frameworks_button_Button_jsx__WEBPACK_IMPORTED_MODULE_15__[/* Button */ "a"], {
            onClick: function onClick() {
              return _this2.handleClick();
            },
            className: "w-full",
            isLoading: this.state.isLoading,
            color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_14__[/* COLORS */ "a"].TURQUOISE,
            colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_14__[/* COLORS */ "a"].WHITE,
            colorBorder: _utils_color_colors__WEBPACK_IMPORTED_MODULE_14__[/* COLORS */ "a"].TURQUOISE,
            dataSelector: "".concat(dataSelector, "-").concat(type),
            dataTestId: "".concat(dataSelector, "-").concat(type),
            trackingData: trackingDataProp,
            dataCsOverrideId: dataCsOverrideId
          }, labelRemove);

        case 'disabled':
          return __jsx(_frameworks_button_Button_jsx__WEBPACK_IMPORTED_MODULE_15__[/* Button */ "a"], {
            onClick: this.handleClick,
            className: "w-full",
            colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_14__[/* COLORS */ "a"].TURQUOISE,
            colorBorder: _utils_color_colors__WEBPACK_IMPORTED_MODULE_14__[/* COLORS */ "a"].TURQUOISE,
            isDisabled: true,
            dataSelector: "".concat(dataSelector, "-").concat(type),
            dataTestId: "".concat(dataSelector, "-").concat(type),
            dataCsOverrideId: dataCsOverrideId
          }, buttonLabel ? buttonLabel : includedLabel);

        case 'full':
          return __jsx(_frameworks_button_Button_jsx__WEBPACK_IMPORTED_MODULE_15__[/* Button */ "a"], {
            onClick: this.handleClick,
            className: "w-full",
            colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_14__[/* COLORS */ "a"].TURQUOISE,
            colorBorder: _utils_color_colors__WEBPACK_IMPORTED_MODULE_14__[/* COLORS */ "a"].TURQUOISE,
            isDisabled: true,
            dataSelector: "".concat(dataSelector, "-").concat(type),
            dataTestId: "".concat(dataSelector, "-").concat(type),
            dataCsOverrideId: dataCsOverrideId
          }, buttonLabel ? buttonLabel : includedLabel);

        default:
          return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          _this$props2$type = _this$props2.type,
          type = _this$props2$type === void 0 ? 'add' : _this$props2$type,
          equipment = _this$props2.equipment,
          button = _this$props2.button,
          i18n = _this$props2.i18n,
          image = _this$props2.image,
          slots = _this$props2.slots,
          header = _this$props2.header,
          intro = _this$props2.intro,
          urgentisation = _this$props2.urgentisation,
          lastAvailabilities = _this$props2.lastAvailabilities,
          isValidated = _this$props2.isValidated,
          isPriceForAdultOnly = _this$props2.isPriceForAdultOnly,
          style = _this$props2.style;
      var additionalStyle = {
        label: {
          fontSize: '14px'
        },
        icon: {
          display: 'flex',
          width: '1rem'
        }
      };
      return __jsx("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_9___default()(className, 'ServiceBlock'),
        style: style
      }, __jsx(_frameworks_capsule_Capsule_jsx__WEBPACK_IMPORTED_MODULE_11__[/* Capsule */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, header, {
        additionalStyle: additionalStyle
      }), image ? __jsx("div", {
        className: "ServiceBlock-pictureContainer"
      }, __jsx("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_9___default()('ServiceBlock-picture', {
          'ServiceBlock-picture--collapsed': this.state.shouldDisplayMoreDetails
        }),
        style: {
          backgroundImage: "url(".concat(image, ")")
        }
      }), !this.state.shouldDisplayMoreDetails ? lastAvailabilities : null) : null, __jsx("div", {
        className: "ServiceBlock-content font-sans"
      }, isValidated && type !== 'full' ? __jsx("div", {
        style: {
          position: 'relative'
        }
      }, __jsx("div", {
        style: {
          position: 'absolute',
          display: 'flex',
          top: '-26px',
          right: '-23px',
          left: '-23px',
          justifyContent: 'flex-end'
        }
      }, __jsx(_frameworks_icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_12__[/* Icon */ "a"], {
        name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_13__[/* ICONS */ "a"].SMALL_CIRCLE_CHECK,
        width: "calc(60rem / 16)",
        color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_14__[/* COLORS */ "a"].SUCCESS
      }))) : null, __jsx("div", {
        className: "ServiceBlock-label"
      }, equipment.label), slots ? __jsx("div", {
        className: "ServiceBlock-infos"
      }, slots.map(function (slot) {
        return __jsx("div", {
          className: "ServiceBlock-info",
          key: slot.key || slot.label,
          "data-testid": slot.key || slot.label
        }, __jsx(_frameworks_icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_12__[/* Icon */ "a"], {
          name: slot.icon,
          width: "calc(24rem / 16)",
          className: "ServiceBlock-icon",
          color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_14__[/* COLORS */ "a"].BLUE
        }), slot.label);
      })) : null, equipment.longDescription ? __jsx(react__WEBPACK_IMPORTED_MODULE_8__["Fragment"], null, __jsx(react_collapse__WEBPACK_IMPORTED_MODULE_10__["Collapse"], {
        isOpened: this.state.shouldDisplayMoreDetails
      }, intro ? __jsx("div", {
        className: "ServiceBlock-description"
      }, __jsx("br", null), intro) : null, typeof equipment.longDescription === 'string' ? equipment.longDescription.split('\n').map(function (item, index) {
        if (item) {
          return __jsx(react__WEBPACK_IMPORTED_MODULE_8__["Fragment"], {
            key: index
          }, __jsx("br", null), __jsx("div", {
            className: "ServiceBlock-description"
          }, item));
        }

        return null;
      }) : equipment.longDescription), __jsx("button", {
        type: "button",
        className: "reset-button ServiceBlock-moreDetailsButton",
        onClick: this.toggleDisplayMoreDetails
      }, this.state.shouldDisplayMoreDetails ? __jsx("div", null, this.props.i18n.common.loadLess, "\xA0", __jsx(_frameworks_icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_12__[/* Icon */ "a"], {
        name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_13__[/* ICONS */ "a"].MINUS,
        width: "0.625rem"
      })) : __jsx("div", null, this.props.i18n.common.loadMore, "\xA0", __jsx(_frameworks_icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_12__[/* Icon */ "a"], {
        name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_13__[/* ICONS */ "a"].PLUS,
        width: "0.625rem"
      })))) : null, urgentisation && type !== 'full' && __jsx("div", {
        className: "flex items-center justify-center",
        "data-testid": "urgentisationBlock"
      }, urgentisation), type === 'full' && i18n.booking.services.childcare.babySittingService !== '' && __jsx("div", {
        className: "ServiceBlock-babySittingService text-blue text-sm mb-px15"
      }, i18n.booking.services.childcare.babySittingService), this.renderCTA(), type !== 'disabled' && type !== 'full' && button ? __jsx("div", {
        className: "ServiceBlock-pricePerPerson"
      }, isPriceForAdultOnly ? i18n.booking.common.pricePerAdult : i18n.booking.common.pricePerPerson) : null)));
    }
  }]);

  return ServiceBlock;
}(react__WEBPACK_IMPORTED_MODULE_8__["Component"]);

Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(ServiceBlock, "defaultProps", defaultProps);

/***/ }),

/***/ "oScl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("JpEK").IteratorPrototype;
var create = __webpack_require__("Znn2");
var createPropertyDescriptor = __webpack_require__("OouP");
var setToStringTag = __webpack_require__("CGO5");
var Iterators = __webpack_require__("oa0l");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "oW49":
/***/ (function(module, exports, __webpack_require__) {

var entityMap = __webpack_require__("8PLQ"),
    legacyMap = __webpack_require__("kWb8"),
    xmlMap    = __webpack_require__("ZLJe"),
    decodeCodePoint = __webpack_require__("cHMM");

var decodeXMLStrict  = getStrictDecoder(xmlMap),
    decodeHTMLStrict = getStrictDecoder(entityMap);

function getStrictDecoder(map){
	var keys = Object.keys(map).join("|"),
	    replace = getReplacer(map);

	keys += "|#[xX][\\da-fA-F]+|#\\d+";

	var re = new RegExp("&(?:" + keys + ");", "g");

	return function(str){
		return String(str).replace(re, replace);
	};
}

var decodeHTML = (function(){
	var legacy = Object.keys(legacyMap)
		.sort(sorter);

	var keys = Object.keys(entityMap)
		.sort(sorter);

	for(var i = 0, j = 0; i < keys.length; i++){
		if(legacy[j] === keys[i]){
			keys[i] += ";?";
			j++;
		} else {
			keys[i] += ";";
		}
	}

	var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"),
	    replace = getReplacer(entityMap);

	function replacer(str){
		if(str.substr(-1) !== ";") str += ";";
		return replace(str);
	}

	//TODO consider creating a merged map
	return function(str){
		return String(str).replace(re, replacer);
	};
}());

function sorter(a, b){
	return a < b ? 1 : -1;
}

function getReplacer(map){
	return function replace(str){
		if(str.charAt(1) === "#"){
			if(str.charAt(2) === "X" || str.charAt(2) === "x"){
				return decodeCodePoint(parseInt(str.substr(3), 16));
			}
			return decodeCodePoint(parseInt(str.substr(2), 10));
		}
		return map[str.slice(1, -1)];
	};
}

module.exports = {
	XML: decodeXMLStrict,
	HTML: decodeHTML,
	HTMLStrict: decodeHTMLStrict
};

/***/ }),

/***/ "oWz2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputSelect_InputSelect; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/utils/unique-id/uniqueId.js
var uniqueId = __webpack_require__("m1JM");

// EXTERNAL MODULE: ./src/client/components/utils/form/form.util.js
var form_util = __webpack_require__("1P7A");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/form-control/FormControl.jsx + 1 modules
var FormControl = __webpack_require__("Jcrg");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-select/InputSelect.themes.js


var themes = {
  "default": function _default(props) {
    return {
      thInputWrapper: 'relative w-full',
      thInput: classnames_default()("reset-input reset-select h-full relative ".concat(props.mediumText ? 'text-md' : 'text-base', " text-gray-darker w-full"), Object(form_util["a" /* getCursorClass */])(props)),
      thPlaceholder: '',
      thCaret: classnames_default()('absolute flex h-full items-center rtl:pl-px10 pointer-events-none rtl:right-0 top-0', {
        'text-current': !props.isDisabled,
        'text-gray-darker': props.isDisabled
      })
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-select/InputSelect.jsx








var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }









var InputSelect_InputSelect = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(InputSelect, _Component);

  var _super = _createSuper(InputSelect);

  function InputSelect(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputSelect);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function (e) {
      var _this$props = _this.props,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          _this$props$name = _this$props.name,
          name = _this$props$name === void 0 ? '' : _this$props$name,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? lodash["noop"] : _this$props$onChange;

      if (!isReadOnly && !isLoading) {
        e.persist(); // $FlowFixMe

        var _value = e.target.value;

        _this.setState({
          value: _value
        }, function () {
          return onChange(name, _value);
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClear", function (e) {
      var _this$props$onClear = _this.props.onClear,
          onClear = _this$props$onClear === void 0 ? lodash["noop"] : _this$props$onClear;

      _this.setState({
        value: ''
      }, function () {
        return onClear(e);
      });
    });

    _this.state = {
      value: props.value || ''
    };
    return _this;
  }

  Object(createClass["a" /* default */])(InputSelect, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(_ref) {
      var value = _ref.value;
      this.setState(function (prevState) {
        if (prevState.value !== value) {
          return {
            value: value
          };
        }
      });
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var options = this.props.options;

      if (Object(lodash["isEmpty"])(options)) {
        return null;
      }

      return options.map(function (_ref2) {
        var isDisabled = _ref2.isDisabled,
            isSelected = _ref2.isSelected,
            label = _ref2.label,
            value = _ref2.value;
        return label ? __jsx("option", {
          disabled: isDisabled,
          key: label,
          label: label,
          selected: isSelected,
          value: value
        }, label) : null;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          bgTransparent = _this$props2.bgTransparent,
          caretIcon = _this$props2.caretIcon,
          className = _this$props2.className,
          hasClear = _this$props2.hasClear,
          iconLeft = _this$props2.iconLeft,
          iconRight = _this$props2.iconRight,
          _this$props2$id = _this$props2.id,
          id = _this$props2$id === void 0 ? Object(uniqueId["b" /* generateUniqueId */])([typeof this.props.label === 'string' ? this.props.label : ''], 'InputSelect_') : _this$props2$id,
          isDisabled = _this$props2.isDisabled,
          isFilled = _this$props2.isFilled,
          isLoading = _this$props2.isLoading,
          isReadOnly = _this$props2.isReadOnly,
          isRequired = _this$props2.isRequired,
          label = _this$props2.label,
          name = _this$props2.name,
          notes = _this$props2.notes,
          onBlur = _this$props2.onBlur,
          onClick = _this$props2.onClick,
          onFocus = _this$props2.onFocus,
          placeholder = _this$props2.placeholder,
          size = _this$props2.size,
          theme = _this$props2.theme,
          validationState = _this$props2.validationState,
          dataTestId = _this$props2.dataTestId,
          inputId = _this$props2.inputId;
      var value = this.state.value;
      var hasClearEnabled = Boolean(hasClear && this.state.value);
      var hasValue = Boolean(value);
      var placeholderFormatted = Object(form_util["b" /* getFormattedLabel */])(placeholder, isRequired);

      var _themes$theme = themes[theme](this.props),
          thCaret = _themes$theme.thCaret,
          thInput = _themes$theme.thInput,
          thInputWrapper = _themes$theme.thInputWrapper,
          thPlaceholder = _themes$theme.thPlaceholder;

      return __jsx(FormControl["a" /* FormControl */], {
        bgTransparent: bgTransparent,
        className: className,
        hasClear: hasClearEnabled,
        id: id,
        iconLeft: iconLeft,
        iconRight: iconRight,
        isDisabled: isDisabled,
        isFilled: isFilled && hasValue,
        isLoading: isLoading,
        isReadOnly: isReadOnly,
        isRequired: isRequired,
        label: label,
        notes: notes,
        onClear: this.onClear,
        size: size,
        theme: theme,
        validationState: validationState
      }, __jsx("div", {
        className: thInputWrapper
      }, __jsx("select", Object(esm_extends["a" /* default */])({
        className: thInput,
        disabled: Boolean(isDisabled || isLoading || isReadOnly),
        id: inputId ? inputId : id
      }, name ? {
        name: name
      } : null, {
        onBlur: onBlur,
        onChange: this.onChange,
        onClick: onClick,
        onFocus: onFocus,
        required: isRequired,
        value: value,
        "data-testid": dataTestId
      }), !!placeholderFormatted && __jsx("option", {
        className: thPlaceholder,
        label: placeholderFormatted,
        disabled: true,
        value: ""
      }, placeholderFormatted), this.getOptions()), !(isDisabled || isLoading || isReadOnly) && __jsx("div", {
        className: thCaret,
        "data-testid": "InputSelectCaret"
      }, __jsx(Icon["a" /* Icon */], {
        name: caretIcon,
        width: "0.625rem",
        dataTestid: caretIcon ? "caret-".concat(caretIcon) : ''
      }))));
    }
  }]);

  return InputSelect;
}(react["Component"]);

Object(defineProperty["a" /* default */])(InputSelect_InputSelect, "defaultProps", {
  caretIcon: icons["a" /* ICONS */].SELECT,
  options: [],
  size: 'medium',
  theme: 'default',
  mediumText: false
});

/***/ }),

/***/ "oa0l":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "obLz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return START_COL_CMP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return END_COL_CMP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return StartCol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EndCol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DoubleColLayer; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_style_style_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("5pZ8");
/* harmony import */ var _stylesheets_configs_tailwind_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Z79w");
/* harmony import */ var _stylesheets_configs_tailwind_config__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_stylesheets_configs_tailwind_config__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("/Mt0");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





var START_COL_CMP = 'StartCol';
var END_COL_CMP = 'EndCol';
var MARGIN_TOP = 0.875;
var HEADER_HEIGHT = 4;
var FIX_SCROLL_OFFSET = 2;
var StartCol = function StartCol(_ref) {
  var children = _ref.children,
      additionalClasses = _ref.additionalClasses,
      dataTestId = _ref.dataTestId,
      activeCol = _ref.activeCol,
      isTablet = _ref.isTablet,
      isColSticky = _ref.isColSticky;
  var startColRef = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])();
  var stickyStyle = isTablet && isColSticky ? {
    position: 'fixed',
    top: '5rem',

    /**
     * have fun
     * comparing max-width container to half viewport size minus padding
     * react will remove calc() and expose the result for us
     * leaving min(maxWidth, halfViewport)
     */
    maxWidth: "calc(".concat(_stylesheets_configs_tailwind_config__WEBPACK_IMPORTED_MODULE_3__["theme"].maxWidth.site, " / 2)"),
    width: "calc(50vw - ".concat(_stylesheets_configs_tailwind_config__WEBPACK_IMPORTED_MODULE_3__["theme"].padding['5'], ")")
  } : null;
  return activeCol === START_COL_CMP || isTablet ? __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('sm:w-1/2 mb-px20', additionalClasses, {
      'w-full': !isTablet
    }),
    "data-testid": dataTestId,
    style: stickyStyle,
    ref: startColRef
  }, children) : null;
};
var EndCol = function EndCol(_ref2) {
  var children = _ref2.children,
      additionalClasses = _ref2.additionalClasses,
      dataTestId = _ref2.dataTestId,
      activeCol = _ref2.activeCol,
      isTablet = _ref2.isTablet,
      isColSticky = _ref2.isColSticky;
  return activeCol === END_COL_CMP || isTablet ? __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('sm:w-1/2 sm:rtl:pl-px20 pb-px40', additionalClasses, {
      'w-full': !isTablet,
      'sm:rtl:ml-auto': isColSticky
    }),
    "data-testid": dataTestId
  }, children) : null;
};
StartCol.displayName = START_COL_CMP;
EndCol.displayName = END_COL_CMP;
var DoubleColLayer = function DoubleColLayer(_ref3) {
  var children = _ref3.children,
      _ref3$initialActiveCo = _ref3.initialActiveCol,
      initialActiveCol = _ref3$initialActiveCo === void 0 ? START_COL_CMP : _ref3$initialActiveCo,
      leftButtonLabel = _ref3.leftButtonLabel,
      rightButtonLabel = _ref3.rightButtonLabel;

  var _useResponsive = Object(_utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_4__[/* useResponsive */ "b"])(),
      isTablet = _useResponsive.isTablet;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(initialActiveCol),
      activeCol = _useState[0],
      setActiveCol = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(false),
      isSticky = _useState2[0],
      setIsSticky = _useState2[1];

  var _useState3 = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(0),
      currentScrollY = _useState3[0],
      setCurrentScrollY = _useState3[1];

  var stickyHeaderButtons = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])();
  var containerRef = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])();
  var layer = document.querySelector('[data-testid="Layer-body"]');
  var headerHeight = Object(_utils_style_style_util__WEBPACK_IMPORTED_MODULE_2__[/* remToPx */ "a"])(HEADER_HEIGHT); // Header height

  var marginTop = Object(_utils_style_style_util__WEBPACK_IMPORTED_MODULE_2__[/* remToPx */ "a"])(MARGIN_TOP); // Wrapper div has a parent with a margin of 0.875rem

  var baseScrollLimit = headerHeight + marginTop; // Reset active col when switching inbound/outbound

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    setActiveCol(initialActiveCol);
  }, [initialActiveCol]); //EasyComparison Mobile

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    var containerElement = containerRef.current;

    var handleScrollEasyComparison = function handleScrollEasyComparison() {
      var _containerElement$get;

      activeCol === END_COL_CMP && setCurrentScrollY(containerElement === null || containerElement === void 0 ? void 0 : (_containerElement$get = containerElement.getBoundingClientRect()) === null || _containerElement$get === void 0 ? void 0 : _containerElement$get.top);
    };

    if (!isTablet && layer) {
      layer.addEventListener('scroll', handleScrollEasyComparison);
    }

    return function () {
      if (!isTablet && layer) {
        layer.removeEventListener('scroll', handleScrollEasyComparison);
      }
    };
  }, [activeCol]); // Sticky Buttons

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    var containerElement = containerRef.current;

    var handleScroll = function handleScroll() {
      if (containerElement) {
        var _stickyHeaderButtons$;

        // When the buttons are "fixed", it is not calculated in wrapperElement dimensions anymore
        var scrollTop = (stickyHeaderButtons === null || stickyHeaderButtons === void 0 ? void 0 : (_stickyHeaderButtons$ = stickyHeaderButtons.current) === null || _stickyHeaderButtons$ === void 0 ? void 0 : _stickyHeaderButtons$.style.position) === 'fixed' ? baseScrollLimit + stickyHeaderButtons.current.getBoundingClientRect().height : baseScrollLimit;
        setIsSticky(containerElement.getBoundingClientRect().top <= scrollTop);
      }
    };

    if (layer) {
      layer.addEventListener('scroll', handleScroll);
    }

    return function () {
      if (layer) {
        layer.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);
  var childrenAsArray = react__WEBPACK_IMPORTED_MODULE_0__["Children"].toArray(children);
  var StartColCmp = childrenAsArray.find(function (_ref4) {
    var type = _ref4.type;
    return type.displayName === START_COL_CMP;
  });
  var EndColCmp = childrenAsArray.find(function (_ref5) {
    var type = _ref5.type;
    return type.displayName === END_COL_CMP;
  });

  if (react__WEBPACK_IMPORTED_MODULE_0__["Children"].count(children) !== 2 || !StartColCmp || !EndColCmp) {
    return null;
  }

  var isColSticky = isSticky && isTablet;
  var isHeaderSticky = isSticky && !isTablet;

  if (isHeaderSticky && stickyHeaderButtons.current) {
    stickyHeaderButtons.current.style.position = 'fixed';
    stickyHeaderButtons.current.style.top = '60px';
  }

  if (!isHeaderSticky && stickyHeaderButtons.current) {
    stickyHeaderButtons.current.style.position = 'static';
  }

  var childrenWithProps = react__WEBPACK_IMPORTED_MODULE_0__["Children"].map(children, function (child) {
    return /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_0__["cloneElement"])(child, {
      isColSticky: isColSticky,
      activeCol: activeCol,
      isTablet: isTablet
    });
  });

  var onClickHandler = function onClickHandler() {
    setActiveCol(END_COL_CMP);
    currentScrollY && // waiting for the col change Left / right
    setTimeout(function () {
      var _stickyHeaderButtons$2;

      layer === null || layer === void 0 ? void 0 : layer.scrollTo(0, Math.abs(currentScrollY) + // last scroll
      baseScrollLimit + (stickyHeaderButtons === null || stickyHeaderButtons === void 0 ? void 0 : (_stickyHeaderButtons$2 = stickyHeaderButtons.current) === null || _stickyHeaderButtons$2 === void 0 ? void 0 : _stickyHeaderButtons$2.getBoundingClientRect().height) + Object(_utils_style_style_util__WEBPACK_IMPORTED_MODULE_2__[/* remToPx */ "a"])(FIX_SCROLL_OFFSET));
    }, 0);
  };

  return __jsx("div", {
    ref: containerRef
  }, !isTablet && __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('flex mb-px40 z-3', {
      'bg-white border-b-1 border-gray-lighter inset-x-0 px-px20 py-px10 shadow-diffuse': isHeaderSticky
    }),
    ref: stickyHeaderButtons
  }, __jsx("button", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('border-0 border-r-1 border-solid border-gray-light flex-1 font-bold px-px20 reset-button text-base underline', {
      'no-underline text-emerald': activeCol === START_COL_CMP
    }),
    onClick: function onClick() {
      return setActiveCol(START_COL_CMP);
    },
    type: "button"
  }, leftButtonLabel), __jsx("button", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('flex-1 font-bold px-px20 reset-button text-base underline', {
      'no-underline text-turquoise': activeCol === END_COL_CMP
    }),
    onClick: onClickHandler,
    type: "button"
  }, rightButtonLabel)), __jsx("div", {
    className: "flex flex-row"
  }, childrenWithProps));
};

/***/ }),

/***/ "p1C/":
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ "p7XS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ SidePanel_SidePanel; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__("pKEY");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-focus-on/dist/es2015/Combination.js + 10 modules
var Combination = __webpack_require__("Qt1m");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-focus-lock/dist/es2015/AutoFocusInside.js
var AutoFocusInside = __webpack_require__("JPie");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.constants.js
var Portal_constants = __webpack_require__("Yd/I");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/body-locker/BodyLocker.jsx
var BodyLocker = __webpack_require__("DHMe");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.jsx
var Portal = __webpack_require__("3uBn");

// CONCATENATED MODULE: ./src/client/components/frameworks/side-panel/SidePanel.themes.js
var themes = {
  "default": {
    thRoot: 'bg-white',
    thCloseButton: 'reset-button bg-white cursor-pointer leading-none m-px20 p-px15 rounded-full text-gray-darker text-md',
    thCloseButtonLabel: 'sr-only'
  }
};
var POSITIONS_CLASSES = {
  top: {
    pin: 'inset-x-0 top-0',
    transform: '-translate-y-100',
    style: {
      maxHeight: 'calc(100% - 100px)'
    },
    button: 'bottom-0 rtl:right-0 rtl:slideInRight'
  },
  bottom: {
    pin: 'inset-x-0 bottom-0',
    transform: 'translate-y-100',
    style: {
      maxHeight: 'calc(100% - 100px)'
    },
    button: 'top-0 rtl:right-0 rtl:slideInRight'
  },
  left: {
    pin: 'inset-y-0 left-0',
    transform: '-translate-x-100',
    style: {
      maxWidth: 'calc(100vw - 100px)'
    },
    button: 'top-0 right-0'
  },
  right: {
    pin: 'inset-y-0 right-0',
    transform: 'translate-x-100',
    style: {
      maxWidth: 'calc(100vw - 100px)'
    },
    button: 'top-0 left-0'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/side-panel/SidePanel.jsx

var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var SidePanel_SidePanel = function SidePanel(_ref) {
  var _classnames;

  var ariaLabel = _ref.ariaLabel,
      ariaLabelledby = _ref.ariaLabelledby,
      _ref$backdropColor = _ref.backdropColor,
      backdropColor = _ref$backdropColor === void 0 ? '#000' : _ref$backdropColor,
      _ref$backdropOpacity = _ref.backdropOpacity,
      backdropOpacity = _ref$backdropOpacity === void 0 ? 0.8 : _ref$backdropOpacity,
      children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      height = _ref.height,
      isExpanded = _ref.isExpanded,
      onClose = _ref.onClose,
      _ref$portalName = _ref.portalName,
      portalName = _ref$portalName === void 0 ? Portal_constants["d" /* OVER_BOT */] : _ref$portalName,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'bottom' : _ref$position,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var sidePanelBodyref = Object(react["useRef"])();
  var onScroll = Object(lodash["throttle"])(function () {
    Object(lib["forceCheck"])();
  }, 250);
  Object(react["useEffect"])(function () {
    // $FlowFixMe
    sidePanelBodyref && sidePanelBodyref.current && sidePanelBodyref.current.addEventListener('scroll', onScroll);
    return function () {
      // $FlowFixMe
      sidePanelBodyref && sidePanelBodyref.current && sidePanelBodyref.current.removeEventListener('scroll', onScroll);
    };
  }, []);
  Object(react["useEffect"])(function () {
    if (isExpanded) {
      Object(lib["forceCheck"])();
    }
  }, [isExpanded]);

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thCloseButton = _themes$theme.thCloseButton,
      thCloseButtonLabel = _themes$theme.thCloseButtonLabel,
      thRoot = _themes$theme.thRoot;
  var positionClasses = POSITIONS_CLASSES[position];
  var closeBtnSidePanel = closeLabel && ariaLabel ? [closeLabel, ariaLabel].join(' ') : closeLabel;
  return __jsx(Portal["a" /* default */], {
    name: portalName
  }, __jsx(BodyLocker["a" /* BodyLocker */], {
    isLocked: isExpanded
  }, isExpanded && __jsx("div", {
    className: "fadeIn fixed h-screen inset-0",
    "data-testid": "SidePanel-backdrop",
    style: {
      backgroundColor: backdropColor,
      opacity: backdropOpacity
    }
  }), __jsx("div", {
    "aria-hidden": !isExpanded,
    "aria-label": ariaLabelledby ? null : ariaLabel,
    "aria-labelledby": ariaLabelledby,
    role: "dialog"
  }, __jsx("div", {
    role: "document"
  }, __jsx(Combination["a" /* FocusOn */], {
    allowPinchZoom: true,
    enabled: isExpanded,
    onClickOutside: onClose,
    onEscapeKey: onClose
  }, isExpanded && __jsx(AutoFocusInside["a" /* default */], null, __jsx("button", {
    className: classnames_default()('fixed z-2', thCloseButton, positionClasses.button),
    onClick: onClose,
    type: "button"
  }, closeBtnSidePanel && __jsx("span", {
    className: thCloseButtonLabel
  }, closeBtnSidePanel), __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "1em"
  }))), __jsx("aside", {
    className: classnames_default()(className, thRoot, positionClasses.pin, 'fixed h-full overflow-y-scroll transition-all w-full z-1', (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, positionClasses.transform, !isExpanded), Object(defineProperty["a" /* default */])(_classnames, 'translate-0', isExpanded), _classnames)),
    ref: sidePanelBodyref,
    style: _objectSpread({
      height: height
    }, positionClasses.style)
  }, isExpanded && children))))));
};

/***/ }),

/***/ "pP7N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_CMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setCms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_BOOKING_ENGINE_I18N; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBookingEngineI18n; });
/* harmony import */ var _views_booking_BookingEngineI18n_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9LZ4");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rJ95");


var SET_CMS = 'SET_CMS';
var setCms = function setCms(config, legalInformations) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(SET_CMS, {
    config: config,
    legalInformations: legalInformations
  });
};
var GET_BOOKING_ENGINE_I18N = 'GET_BOOKING_ENGINE_I18N';
var getBookingEngineI18n = function getBookingEngineI18n(appContext) {
  return function (dispatch) {
    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(GET_BOOKING_ENGINE_I18N, {}, {
      promise: Object(_views_booking_BookingEngineI18n_query__WEBPACK_IMPORTED_MODULE_0__[/* fetchBookingEngineI18nQuery */ "a"])(appContext)
    }));
  };
};

/***/ }),

/***/ "pdPG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getInboundDeparture; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getOutboundDeparture; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getProposalIdsAndOverloadForAdditionalServiceQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTravelSectionBoundSummary; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _date_apiDate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ldK3");



var DATE_FORMAT_BY_LOCALE = 'D MMMM YYYY';

function getOutboundDeparture(transport) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(transport, 'outbound.travelSections[0].departure');
}

function getInboundDeparture(transport) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(transport, 'inbound.travelSections[0].departure');
}

function getTravelSectionBoundSummary(travelBound) {
  var sectionBoundCityLabel = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(travelBound, 'label');
  var sectionBoundDate = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(travelBound, 'date');
  var formattedDate = sectionBoundDate && Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_2__[/* momentFromApiDate */ "h"])(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(travelBound, 'date', '')).format(DATE_FORMAT_BY_LOCALE);
  return sectionBoundCityLabel && formattedDate && "".concat(sectionBoundCityLabel, ", ").concat(formattedDate);
}

var getProposalIdsAndOverloadForAdditionalServiceQuery = function getProposalIdsAndOverloadForAdditionalServiceQuery(proposals, selectedTransfer) {
  var chaletTransfer;
  var proposalIdsToExclude = [];
  proposals.forEach(function (_ref) {
    var id = _ref.id,
        additionalServices = _ref.additionalServices;
    var differentTransfer = additionalServices.transfers.find(function (_ref2) {
      var productInfo = _ref2.productInfo;
      return productInfo.label === selectedTransfer.productInfo.label;
    });

    if (differentTransfer) {
      if (differentTransfer.pricingInfo.id !== selectedTransfer.pricingInfo.id) {
        var _chaletTransfer;

        chaletTransfer = {
          proposalIds: [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(((_chaletTransfer = chaletTransfer) === null || _chaletTransfer === void 0 ? void 0 : _chaletTransfer.proposalIds) || []), [id]),
          serviceId: differentTransfer.pricingInfo.id
        };
      }
    } else {
      proposalIdsToExclude.push(id);
    }
  });
  return {
    proposalIds: proposals.map(function (_ref3) {
      var id = _ref3.id;
      return id;
    }).filter(function (id) {
      return !proposalIdsToExclude.includes(id);
    }),
    overloadForSpecificProposalIds: chaletTransfer ? {
      proposalIds: chaletTransfer.proposalIds,
      serviceIds: [chaletTransfer.serviceId]
    } : undefined
  };
};



/***/ }),

/***/ "pfAP":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("1YFU");

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "ptRt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TransfersSection_TransfersSection; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/className/className.util.js
var className_util = __webpack_require__("wJdf");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-select/FormSelect.jsx
var FormSelect = __webpack_require__("rXTn");

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/capsule/Capsule.jsx + 1 modules
var Capsule = __webpack_require__("jldR");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx + 1 modules
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// CONCATENATED MODULE: ./src/client/components/widgets/package/transfers-section/TransferCapsule.jsx
var __jsx = react_default.a.createElement;










var TransferCapsule_TransferCapsule = function TransferCapsule(props) {
  var _React$useContext = react_default.a.useContext(ReactAppContext["a" /* default */]),
      isCmta = _React$useContext.isCmta;

  var i18n = props.i18n.common.transport.transfer;
  var sellerReassuranceTransportDetails = Object(src_i18n["g" /* t */])('booking.partners.transfer.reassuranceTransportDetails');
  var addedTransfer = props.addedTransfer,
      availableTransfers = props.availableTransfers;
  return __jsx(react["Fragment"], null, __jsx(Capsule["a" /* Capsule */], {
    header: "large",
    label: i18n.transferOnDemand,
    icon: "onDemand",
    color: "#b95e06"
  }, __jsx("div", {
    className: "border-b-1 border-gray-light p-px20 text-base"
  }, __jsx("div", {
    "data-selector": "".concat(props.dataSelector, "TransferLabel")
  }, i18n.introduction), __jsx("div", null, props.children), addedTransfer && addedTransfer.productInfo.durationInMinutes && addedTransfer.productInfo.vehicle.label ? __jsx("div", {
    className: "flex"
  }, __jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-px10",
    color: colors["a" /* COLORS */].BLUE,
    name: icons["a" /* ICONS */].DURATION,
    width: "1.325rem"
  }), __jsx(TemplateString["a" /* TemplateString */], {
    template: i18n.durationAndMeanOfTransportation,
    values: {
      duration_in_minutes: addedTransfer.productInfo.durationInMinutes,
      label: addedTransfer.productInfo.vehicle.label
    },
    valuesClassName: {
      duration_in_minutes: 'font-bold',
      label: 'font-bold'
    }
  })) : null), __jsx("div", {
    className: "p-px20"
  }, __jsx(Text["a" /* Text */], {
    color: colors["a" /* COLORS */].GRAY_DARKER,
    text: "**".concat(i18n.note, "** ").concat(addedTransfer ? addedTransfer.productInfo.description : availableTransfers[0].productInfo.description),
    theme: "text-sans-2"
  }))), addedTransfer ? __jsx(Notification["a" /* Notification */], {
    className: "mt-px10",
    color: colors["a" /* COLORS */].GRENADINE,
    hasBorder: true,
    title: isCmta ? sellerReassuranceTransportDetails : i18n.reassuranceTransportDetails
  }) : null);
};
// CONCATENATED MODULE: ./src/client/components/widgets/package/transfers-section/transferUtils.js


function getTransferOption(transfer) {
  return {
    value: Object(lodash["get"])(transfer, 'pricingInfo.id'),
    label: Object(lodash["get"])(transfer, 'productInfo.label')
  };
}

function getCtaType(state) {
  if (!Object(lodash["get"])(state, 'selectedTransfer')) {
    return 'disabled';
  }

  return Object(lodash["get"])(state, 'addedTransfer') ? 'remove' : 'add';
}

var transferUtils_getTransferOptions = function getTransferOptions(transfers, chooseTransfer) {
  if (Object(lodash["isEmpty"])(transfers)) {
    return [];
  }

  var emptyTransferOption = {
    value: '',
    label: chooseTransfer
  };
  return [emptyTransferOption].concat(transfers.map(getTransferOption));
};

var getTransferFromValue = function getTransferFromValue(transfers, value) {
  return (transfers || []).find(function (transfer) {
    return transfer.pricingInfo.id === value;
  });
};

var transferUtils_getTransfersWithLabel = function getTransfersWithLabel(transfers) {
  return (transfers || []).filter(function (transfer) {
    return Object(lodash["get"])(transfer, 'productInfo.label');
  });
};


// CONCATENATED MODULE: ./src/client/components/widgets/package/transfers-section/TransfersSection.jsx







var TransfersSection_jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }










var defaultProps = {
  availableTransfers: [],
  selectedTransfers: [],
  dataSelector: 'transfersSection',
  layout: 'row'
};
var TransfersSection_TransfersSection = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(TransfersSection, _React$Component);

  var _super = _createSuper(TransfersSection);

  function TransfersSection(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, TransfersSection);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleSelectChange", function (value) {
      _this.setState({
        selectedTransfer: getTransferFromValue(_this.state.validTransfers, value)
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onCtaClick", function () {
      var handler = _this.state.addedTransfer ? _this.props.removeTransfer : _this.props.addTransfer;

      _this.setState({
        isLoading: true
      });

      handler(Object(lodash["get"])(_this.state, 'selectedTransfer')).finally(function () {
        _this.setState({
          isLoading: false
        });
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "getExtraServiceI18n", function () {
      return {
        add: _this.props.i18n.booking.transport.transfer.addTransfer,
        remove: _this.props.i18n.booking.transport.transfer.removeTransfer
      };
    });

    _this.state = {
      validTransfers: transferUtils_getTransfersWithLabel(props.availableTransfers),
      addedTransfer: props.selectedTransfers[0],
      selectedTransfer: _this.getSelectedTransfer(props),
      isLoading: false
    };
    return _this;
  }

  Object(createClass["a" /* default */])(TransfersSection, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        validTransfers: transferUtils_getTransfersWithLabel(nextProps.availableTransfers),
        addedTransfer: nextProps.selectedTransfers[0],
        selectedTransfer: nextProps.selectedTransfers[0] || this.state.selectedTransfer,
        isLoading: nextProps.selectedTransfers !== this.props.selectedTransfers ? false : this.state.isLoading
      });
    }
  }, {
    key: "getSelectedTransfer",
    value: function getSelectedTransfer(props) {
      var validTransfers = transferUtils_getTransfersWithLabel(props.availableTransfers);
      var selectedTransfer = null;

      if (!Object(lodash["isEmpty"])(props.selectedTransfers)) {
        selectedTransfer = props.selectedTransfers[0];
      } else if (validTransfers.length === 1) {
        selectedTransfer = validTransfers[0];
      }

      return selectedTransfer;
    }
  }, {
    key: "renderAddButton",
    value: function renderAddButton() {
      var dataSelector = this.props.dataSelector;
      var ctaType = getCtaType(this.state);
      var addLabel = this.getExtraServiceI18n().add;
      var price = Object(lodash["get"])(this.state, 'selectedTransfer.pricingInfo.totalPrice.formattedValue');
      var label = price ? "".concat(addLabel, " +").concat(price) : addLabel;
      return TransfersSection_jsx(Button["a" /* Button */], {
        onClick: this.onCtaClick,
        className: Object(className_util["b" /* getClassWithModifiers */])('TransfersSection-transferCTA', [this.props.layout]),
        color: colors["a" /* COLORS */].WHITE,
        colorBg: colors["a" /* COLORS */].TURQUOISE,
        colorBorder: colors["a" /* COLORS */].TURQUOISE,
        isLoading: this.state.isLoading,
        dataSelector: "".concat(dataSelector, "-").concat(ctaType),
        isDisabled: ctaType === 'disabled'
      }, label);
    }
  }, {
    key: "renderRemoveButton",
    value: function renderRemoveButton() {
      var dataSelector = this.props.dataSelector;
      var ctaType = getCtaType(this.state);
      var removeLabel = this.getExtraServiceI18n().remove;
      var price = Object(lodash["get"])(this.state, 'selectedTransfer.pricingInfo.totalPrice.formattedValue');
      var label = price ? "".concat(removeLabel, " -").concat(price) : removeLabel;
      return TransfersSection_jsx(Button["a" /* Button */], {
        onClick: this.onCtaClick,
        className: Object(className_util["b" /* getClassWithModifiers */])('TransfersSection-transferCTA', [this.props.layout]),
        isLoading: this.state.isLoading,
        color: colors["a" /* COLORS */].TURQUOISE,
        colorBg: colors["a" /* COLORS */].WHITE,
        colorBorder: colors["a" /* COLORS */].TURQUOISE,
        dataSelector: "".concat(dataSelector, "-").concat(ctaType)
      }, label);
    }
  }, {
    key: "renderCTA",
    value: function renderCTA() {
      switch (getCtaType(this.state)) {
        case 'add':
          return this.renderAddButton();

        case 'disabled':
          return this.renderAddButton();

        case 'remove':
          return this.renderRemoveButton();

        default:
          return null;
      }
    }
  }, {
    key: "renderTransfers",
    value: function renderTransfers() {
      var isTransferAdded = !!this.state.addedTransfer;
      var isTransferSelected = !!this.state.selectedTransfer;
      var validationState = isTransferSelected && !isTransferAdded ? 'IS_VALID' : '';
      return TransfersSection_jsx("div", {
        className: "TransfersSection-form"
      }, TransfersSection_jsx("div", {
        className: "TransfersSection-select"
      }, isTransferAdded || this.state.validTransfers.length === 1 ? TransfersSection_jsx("div", {
        className: "TransfersSection-selectedTransfer",
        "data-selector": "".concat(this.props.dataSelector, "TransferLabel")
      }, Object(lodash["get"])(this.state, 'selectedTransfer.productInfo.label')) : TransfersSection_jsx(FormSelect["a" /* default */], {
        dataSelector: "".concat(this.props.dataSelector, "TransfersOptions"),
        onChange: this.handleSelectChange,
        options: transferUtils_getTransferOptions(this.state.validTransfers, this.props.i18n.booking.transport.transfer.chooseTransfer || 'Choose a transfer'),
        validationState: validationState,
        value: Object(lodash["get"])(this.state, 'selectedTransfer.pricingInfo.id')
      })), this.renderCTA());
    }
  }, {
    key: "render",
    value: function render() {
      if (Object(lodash["isEmpty"])(this.props.availableTransfers) && !this.state.selectedTransfer) {
        return null;
      }

      return TransfersSection_jsx(react_default.a.Fragment, null, !Object(lodash["isEmpty"])(this.state.validTransfers) ? TransfersSection_jsx("div", {
        "data-testid": "TransfersSection",
        "data-selector": "transfersSection"
      }, TransfersSection_jsx(TransferCapsule_TransferCapsule, {
        i18n: this.props.i18n,
        availableTransfers: this.props.availableTransfers,
        addedTransfer: this.state.addedTransfer,
        dataSelector: this.props.dataSelector
      }, this.renderTransfers())) : TransfersSection_jsx(Notification["a" /* Notification */], {
        hasBorder: true,
        color: colors["a" /* COLORS */].ORANGE,
        title: this.props.i18n.booking.form.errors.transferUnavailable
      }));
    }
  }]);

  return TransfersSection;
}(react_default.a.Component);

Object(defineProperty["a" /* default */])(TransfersSection_TransfersSection, "defaultProps", defaultProps);

/***/ }),

/***/ "pteD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TripDatePicker_TripDatePicker; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-day-picker/DayPicker.js
var DayPicker = __webpack_require__("nFOY");
var DayPicker_default = /*#__PURE__*/__webpack_require__.n(DayPicker);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/datepicker/Datepicker.utils.js
var Datepicker_utils = __webpack_require__("szYs");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/datepicker/DatepickerArrow.jsx
var __jsx = react_default.a.createElement;







var DatepickerArrow_DatepickerArrow = function DatepickerArrow(_ref) {
  var className = _ref.className,
      fromMonth = _ref.fromMonth,
      locale = _ref.locale,
      month = _ref.month,
      _ref$onPrevious = _ref.onPrevious,
      onPrevious = _ref$onPrevious === void 0 ? lodash["noop"] : _ref$onPrevious,
      _ref$onNext = _ref.onNext,
      onNext = _ref$onNext === void 0 ? lodash["noop"] : _ref$onNext,
      toMonth = _ref.toMonth;
  return __jsx("div", {
    className: className
  }, !DayPicker["DateUtils"].isSameMonth(month, fromMonth) ? __jsx("button", {
    className: "reset-button",
    "data-testid": "datepicker-arrow-prev",
    onClick: function onClick() {
      return onPrevious();
    },
    style: {
      width: 30,
      height: 30
    },
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].GRAY_DARKER,
    hasRtl: true,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    rotation: 180,
    width: "0.625rem"
  })) : __jsx("div", {
    style: {
      width: 30,
      height: 30
    }
  }), __jsx("span", {
    className: "flex-1"
  }, Object(Datepicker_utils["formatMonthTitle"])(month, locale)), !DayPicker["DateUtils"].isSameMonth(month, toMonth) ? __jsx("button", {
    className: "reset-button",
    "data-testid": "datepicker-arrow-next",
    onClick: function onClick() {
      return onNext();
    },
    style: {
      width: 30,
      height: 30
    },
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].GRAY_DARKER,
    hasRtl: true,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    width: "0.625rem"
  })) : __jsx("div", {
    style: {
      width: 30,
      height: 30
    }
  }));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/datepicker/DatepickerCaption.jsx
var DatepickerCaption_jsx = react_default.a.createElement;





var DatepickerCaption_DatepickerCaption = function DatepickerCaption(_ref) {
  var className = _ref.className,
      _ref$date = _ref.date,
      date = _ref$date === void 0 ? new Date() : _ref$date,
      fromMonth = _ref.fromMonth,
      hasNavigationByYear = _ref.hasNavigationByYear,
      onNext = _ref.onNext,
      onPrevious = _ref.onPrevious,
      toMonth = _ref.toMonth;

  if (!hasNavigationByYear) {
    return null;
  }

  var currentYear = date.getFullYear();
  var fromYear = fromMonth.getFullYear();
  var toYear = toMonth.getFullYear();
  return DatepickerCaption_jsx("div", {
    className: classnames_default()(className, 'flex items-center justify-between')
  }, currentYear > fromYear && DatepickerCaption_jsx("button", {
    className: "reset-button",
    onClick: function onClick() {
      return onPrevious();
    },
    style: {
      width: 30,
      height: 30
    },
    type: "button"
  }, DatepickerCaption_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].GRAY_DARKER,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    rotation: 180,
    width: "0.625rem"
  })), DatepickerCaption_jsx("span", {
    className: "flex-1"
  }, date.getFullYear(), " "), currentYear < toYear && DatepickerCaption_jsx("button", {
    className: "reset-button",
    onClick: function onClick() {
      return onNext();
    },
    style: {
      width: 30,
      height: 30
    },
    type: "button"
  }, DatepickerCaption_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].GRAY_DARKER,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    width: "0.625rem"
  })));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/datepicker/Datepicker.themes.js
var Datepicker_themes_themes = {
  "default": {
    thRoot: 'relative font-base font-bold text-center',
    thDayPicker: {
      container: 'relative sm:bg-white sm:rounded',
      // The container element
      wrapper: '',
      // The wrapper element, used for keyboard interaction
      interactionDisabled: '',
      // Added to the container when there's no interaction with the calendar
      navBar: 'flex items-center justify-between pb-px10',
      // The navigation bar with the arrows to switch between months
      navButtonPrev: '',
      // Button to switch to the previous month
      navButtonNext: '',
      // Button to switch to the next month
      navButtonInteractionDisabled: 'pointer-events-none cursor-default',
      // Added to the navbuttons when disabled with fromMonth/toMonth props
      months: 'flex -m-px10',
      // Container of the months table
      month: 'flex-1 p-px10',
      // The month's main table
      caption: 'font-bold mb-px20 text-center text-md text-gray-darker',
      // The caption element, containing the current month's name and year
      weekdays: '',
      // Table header displaying the weekdays names
      weekdaysRow: 'flex',
      // Table row displaying the weekdays names
      weekday: 'flex-1 text-base text-gray-medium uppercase',
      // Cell displaying the weekday name
      body: 'body border-l border-b border-gray-light',
      // Table's body with the weeks
      week: 'flex',
      // Table's row for each week
      day: 'cursor-pointer flex-1 flex flex-col items-center justify-center md:h-25 h-13 p-px5 text-base text-center transition-all border-t border-r border-gray-light',
      // The single day cell
      footer: 'mt-px10',
      // The calendar footer (only with todayButton prop)
      todayButton: 'text-blue focus:text-turquoise hover:text-turquoise text-sm reset-button',
      // The today button (only with todayButton prop)

      /* default modifiers */
      today: 'underline',
      // Added to the day's cell for the current day
      selected: 'bg-overlay-emerald-30 opacity-100 Datepicker-selected',
      // Added to the day's cell specified in the "selectedDays" prop
      disabled: 'cursor-default pointer-events-none text-gray-medium',
      // Added to the day's cell specified in the "disabledDays" prop
      outside: 'text-gray-light' // Added to the day's cell outside the current month

    },
    thDayStart: 'thDayStart bg-emerald-active text-white',
    thDayEnd: 'thDayEnd bg-emerald-active text-white',
    thDayMiddle: 'thDayMiddle bg-emerald text-white'
  },
  compact: {
    thRoot: 'relative font-base font-bold text-center',
    thDayPicker: {
      container: 'overflow-hidden relative sm:bg-white sm:rounded',
      // The container element
      wrapper: '',
      // The wrapper element, used for keyboard interaction
      interactionDisabled: '',
      // Added to the container when there's no interaction with the calendar
      navBar: 'flex items-center justify-between pb-px10',
      // The navigation bar with the arrows to switch between months
      navButtonPrev: '',
      // Button to switch to the previous month
      navButtonNext: '',
      // Button to switch to the next month
      navButtonInteractionDisabled: 'pointer-events-none cursor-default',
      // Added to the navbuttons when disabled with fromMonth/toMonth props
      months: 'flex -m-px10',
      // Container of the months table
      month: 'flex-1 p-px10',
      // The month's main table
      caption: 'font-bold mb-px20 text-center text-md text-gray-darker',
      // The caption element, containing the current month's name and year
      weekdays: '',
      // Table header displaying the weekdays names
      weekdaysRow: 'flex',
      // Table row displaying the weekdays names
      weekday: 'flex-1 text-base text-gray-medium uppercase',
      // Cell displaying the weekday name
      body: 'body',
      // Table's body with the weeks
      week: 'flex',
      // Table's row for each week
      day: 'cursor-pointer flex-1 flex flex-col items-center justify-center h-10 p-px5 text-base text-center transition-all',
      // The single day cell
      footer: 'mt-px10',
      // The calendar footer (only with todayButton prop)
      todayButton: 'text-blue focus:text-turquoise hover:text-turquoise text-sm reset-button',
      // The today button (only with todayButton prop)

      /* default modifiers */
      today: 'underline',
      // Added to the day's cell for the current day
      selected: 'bg-overlay-emerald-40 opacity-100 Datepicker-selected',
      // Added to the day's cell specified in the "selectedDays" prop
      disabled: 'cursor-default pointer-events-none text-gray-medium',
      // Added to the day's cell specified in the "disabledDays" prop
      outside: 'opacity-50' // Added to the day's cell outside the current month

    },
    thDayStart: 'bg-emerald rtl:rounded-l text-white',
    thDayEnd: 'bg-emerald rtl:rounded-r text-white',
    thDayMiddle: 'bg-emerald text-white'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/datepicker/Datepicker.jsx


var Datepicker_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










function isSelectingFirstDay(from, to, day) {
  var isBeforeFirstDay = Boolean(from && DayPicker["DateUtils"].isDayBefore(day, from));
  var isRangeSelected = Boolean(from && to);
  return !from || isBeforeFirstDay || isRangeSelected;
}

function isChangingSelection(from, to, day) {
  return Boolean(from && to && day >= from && day <= to);
}

function isSelectingSameDay(from, to, day) {
  return Boolean(from && !to && DayPicker["DateUtils"].isSameDay(from, day));
}

var Datepicker_Datepicker = function Datepicker(_ref) {
  var _objectSpread2;

  var className = _ref.className,
      maxDate = _ref.maxDate,
      minDate = _ref.minDate,
      navbarElement = _ref.navbarElement,
      hasNavigationByYear = _ref.hasNavigationByYear,
      initialMonth = _ref.initialMonth,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? moment_default.a.locale() : _ref$locale,
      renderDay = _ref.renderDay,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      _ref$customModifiers = _ref.customModifiers,
      customModifiers = _ref$customModifiers === void 0 ? {} : _ref$customModifiers,
      _ref$datePickerClassN = _ref.datePickerClassNames,
      datePickerClassNames = _ref$datePickerClassN === void 0 ? {} : _ref$datePickerClassN,
      _ref$disabledDays = _ref.disabledDays,
      disabledDays = _ref$disabledDays === void 0 ? [] : _ref$disabledDays,
      selectedDays = _ref.selectedDays,
      hasRangeMode = _ref.hasRangeMode,
      onSelect = _ref.onSelect,
      onMouseOver = _ref.onMouseOver,
      weekdayElement = _ref.weekdayElement;

  var _ref2 = !selectedDays || DayPicker["DateUtils"].isDate(selectedDays) ? {
    from: selectedDays,
    to: selectedDays
  } : selectedDays,
      from = _ref2.from,
      to = _ref2.to;

  var month = initialMonth || from || minDate || new Date();

  var _useState = Object(react["useState"])(null),
      hovered = _useState[0],
      setHovered = _useState[1];

  var _useState2 = Object(react["useState"])(month),
      activeMonth = _useState2[0],
      setActiveMonth = _useState2[1];

  Object(react["useEffect"])(function () {
    setActiveMonth(month);
  }, [moment_default()(month, moment_default.a.defaultFormat).format('YYYYMMDD')]);

  var handleDayClick = function handleDayClick(day, modifiers) {
    setHovered(null);

    if (onSelect) {
      if (!hasRangeMode) {
        onSelect({
          from: day,
          to: day,
          modifiers: modifiers
        });
      } else if (isSelectingFirstDay(from, to, day) || isChangingSelection(from, to, day)) {
        onSelect({
          from: day,
          to: null,
          modifiers: modifiers
        });
      } else if (isSelectingSameDay(from, to, day)) {
        onSelect({
          from: null,
          to: null,
          modifiers: modifiers
        });
      } else {
        onSelect({
          from: from,
          to: day,
          modifiers: modifiers
        });
      }
    }
  };

  var handleDayMouseEnter = function handleDayMouseEnter(day) {
    setHovered(day);

    if (onMouseOver) {
      onMouseOver(day);
    }
  };

  var handleDayMouseLeave = function handleDayMouseLeave() {
    setHovered(null);
  };

  var addMonthsInRange = function addMonthsInRange(date, number) {
    var targetMonth = moment_default()(date).add({
      months: number
    }).toDate();
    if (minDate && DayPicker["DateUtils"].isDayBefore(targetMonth, minDate)) return minDate;
    if (maxDate && DayPicker["DateUtils"].isDayAfter(targetMonth, maxDate)) return maxDate;
    return targetMonth;
  };

  var handleNextMonth = function handleNextMonth() {
    if (!activeMonth) return;
    setActiveMonth(addMonthsInRange(activeMonth, 1));
  };

  var handlePreviousMonth = function handlePreviousMonth() {
    if (!activeMonth) return;
    setActiveMonth(addMonthsInRange(activeMonth, -1));
  };

  var handleNextYear = function handleNextYear() {
    if (!activeMonth) return;
    setActiveMonth(addMonthsInRange(activeMonth, 12));
  };

  var handlePreviousYear = function handlePreviousYear() {
    if (!activeMonth) return;
    setActiveMonth(addMonthsInRange(activeMonth, -12));
  };

  var allDisabledDays = [].concat(Object(toConsumableArray["a" /* default */])(disabledDays), [{
    before: minDate,
    after: maxDate
  }]);
  var _themes$theme = Datepicker_themes_themes[theme],
      thDayEnd = _themes$theme.thDayEnd,
      thDayStart = _themes$theme.thDayStart,
      thDayMiddle = _themes$theme.thDayMiddle,
      thDayPicker = _themes$theme.thDayPicker,
      thRoot = _themes$theme.thRoot;
  var allSelectedDays = [from, {
    from: from,
    to: to || hovered
  }, hovered];

  var modifiers = _objectSpread(_objectSpread({}, customModifiers), {}, (_objectSpread2 = {}, Object(defineProperty["a" /* default */])(_objectSpread2, thDayStart, from), Object(defineProperty["a" /* default */])(_objectSpread2, thDayEnd, to), Object(defineProperty["a" /* default */])(_objectSpread2, thDayMiddle, hovered), _objectSpread2));

  return Datepicker_jsx("div", {
    className: classnames_default()(className, thRoot)
  }, Datepicker_jsx(DayPicker_default.a, {
    canChangeMonth: true,
    firstDayOfWeek: moment_default.a.localeData().firstDayOfWeek(),
    fixedWeeks: true,
    locale: locale,
    localeUtils: Datepicker_utils,
    showOutsideDays: true,
    showWeekDays: true,
    captionElement: Datepicker_jsx(DatepickerCaption_DatepickerCaption, {
      className: thDayPicker.caption,
      fromMonth: minDate,
      hasNavigationByYear: hasNavigationByYear,
      onNext: handleNextYear,
      onPrevious: handlePreviousYear,
      toMonth: maxDate
    }),
    classNames: _objectSpread(_objectSpread({}, thDayPicker), datePickerClassNames),
    disabledDays: allDisabledDays,
    fromMonth: minDate,
    initialMonth: initialMonth,
    modifiers: modifiers,
    month: activeMonth,
    navbarElement: navbarElement || Datepicker_jsx(DatepickerArrow_DatepickerArrow, {
      onNext: handleNextMonth,
      onPrevious: handlePreviousMonth,
      fromMonth: minDate,
      locale: locale,
      toMonth: maxDate
    }),
    onDayClick: handleDayClick,
    onDayMouseEnter: handleDayMouseEnter,
    onDayMouseLeave: handleDayMouseLeave,
    renderDay: renderDay,
    selectedDays: allSelectedDays,
    toMonth: maxDate,
    weekdayElement: weekdayElement
  }));
};
// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.themes.js

var TripDatePicker_themes_themes = function themes(_ref) {
  var isSelectable = _ref.isSelectable,
      isTablet = _ref.isTablet;
  return {
    "default": {
      thDay: classnames_default()("cursor-pointer flex-1 flex flex-col items-center justify-center ".concat(isTablet ? 'h-25' : 'h-13', " p-px5 text-base text-center transition-all border-t border-r border-gray-light relative"), {
        'text-black hover:text-white': isSelectable
      }),
      thDayMessage: 'hidden md:inline w-full font-normal text-sm',
      thDayNumber: classnames_default()('md:absolute top-0 left-0 md:p-px5 text-xs', {
        'font-normal md:text-sm': !isSelectable,
        'font-bold md:text-md': isSelectable
      }),
      thDayOldPrice: 'text-sm line-through hidden md:block',
      thDayPrice: 'text-sm md:text-md',
      thStatusMessage: 'hidden md:inline w-full font-normal',
      thFrom: 'hidden md:inline w-full font-normal'
    },
    compact: {
      thDay: 'cursor-pointer flex flex-1 flex-col items-center justify-start h-9 leading-tight p-px5 text-base text-center',
      thDayMessage: 'hidden',
      thDayNumber: '',
      thDayOldPrice: 'hidden',
      thDayPrice: 'mx-auto self-end block font-hairline text-xs',
      thStatusMessage: 'hidden',
      thFrom: 'hidden'
    }
  };
};
// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/client/components/widgets/product-price-info/ProductPriceInfo.jsx
var ProductPriceInfo = __webpack_require__("ZS6v");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayPriceDetails.jsx
var DayPriceDetails_jsx = react_default.a.createElement;





var DayPriceDetails_DayPriceDetails = function DayPriceDetails(_ref) {
  var day = _ref.day,
      duration = _ref.duration,
      departureCity = _ref.departureCity,
      hasTransport = _ref.hasTransport,
      isJoyview = _ref.isJoyview,
      shouldDisplayDetails = _ref.shouldDisplayDetails,
      unit = _ref.unit;

  var _useState = Object(react["useState"])(false),
      isVisible = _useState[0],
      setIsVisibleState = _useState[1];

  var setIsVisible = Object(lodash["debounce"])(function (visible) {
    setIsVisibleState(visible);
  }, 150);

  var setVisibile = function setVisibile() {
    if (!isVisible) {
      setIsVisible(true);
    }
  };

  var seInVisible = function seInVisible() {
    return setIsVisible(false);
  };

  Object(react["useEffect"])(function () {
    setIsVisible(shouldDisplayDetails);
  }, [shouldDisplayDetails]);
  var dateFormat = Object(i18n["g" /* t */])('resort.startingPrice.dateFormat');
  var startDate = moment_default()(day).format(dateFormat);
  var endDate = moment_default()(day).add({
    days: duration
  }).format(dateFormat);
  return DayPriceDetails_jsx(react["Fragment"], null, DayPriceDetails_jsx("div", {
    className: "absolute h-full inset-0 w-full z-3",
    onMouseOver: setVisibile,
    onMouseLeave: seInVisible
  }), isVisible && shouldDisplayDetails && DayPriceDetails_jsx("div", {
    className: "absolute font-normal left-1/2 text-initial top-0 -translate-x-50 z-2",
    style: {
      width: '25rem'
    }
  }, DayPriceDetails_jsx("div", {
    className: "absolute bottom-full fadeIn inset-x-0"
  }, DayPriceDetails_jsx("div", {
    className: "arrow-down arrow-large arrow-white bg-white filter-drop-shadow-after rounded-tiny shadow-md"
  }, DayPriceDetails_jsx(ProductPriceInfo["a" /* ProductPriceInfo */], {
    city: departureCity,
    endDate: endDate,
    hasTransport: hasTransport,
    isJoyview: isJoyview,
    startDate: startDate,
    unit: unit
  })))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayWithPrice.jsx
var DayWithPrice_jsx = react_default.a.createElement;








var COMPACT_MAX_CHARACTERS = 5;
var DayWithPrice_DayWithPrice = function DayWithPrice(_ref) {
  var day = _ref.day,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 7 : _ref$duration,
      _ref$hasInstalment = _ref.hasInstalment,
      hasInstalment = _ref$hasInstalment === void 0 ? false : _ref$hasInstalment,
      isJoyview = _ref.isJoyview,
      isLoading = _ref.isLoading,
      _ref$isSelectable = _ref.isSelectable,
      isSelectable = _ref$isSelectable === void 0 ? false : _ref$isSelectable,
      locale = _ref.locale,
      _ref$price = _ref.price,
      availability = _ref$price.availability,
      currency = _ref$price.currency,
      departureCity = _ref$price.departureCity,
      hasTransport = _ref$price.hasTransport,
      formattedPriceValue = _ref$price.price,
      oldPrice = _ref$price.oldPrice,
      unit = _ref$price.unit,
      priceValue = _ref$price.priceValue,
      shouldDisplayPrice = _ref.shouldDisplayPrice,
      shouldDisplaySelectedDepartureDateMessage = _ref.shouldDisplaySelectedDepartureDateMessage,
      shouldDisplayStatusMessage = _ref.shouldDisplayStatusMessage,
      shouldDisplayDetails = _ref.shouldDisplayDetails,
      theme = _ref.theme,
      withPriceDetails = _ref.withPriceDetails;
  var statusMessageKey = "booking.priceCalendar.priceStatus.".concat(availability);
  var _themes$theme = TripDatePicker_themes_themes({
    isSelectable: isSelectable
  })[theme],
      thDayMessage = _themes$theme.thDayMessage,
      thDayNumber = _themes$theme.thDayNumber,
      thDayOldPrice = _themes$theme.thDayOldPrice,
      thDayPrice = _themes$theme.thDayPrice,
      thStatusMessage = _themes$theme.thStatusMessage,
      thFrom = _themes$theme.thFrom;

  var getCompactPrice = function getCompactPrice(rawPrice) {
    var compactPrice = (rawPrice === null || rawPrice === void 0 ? void 0 : rawPrice.replace(/[\s|.,]/gi, '')) || '';
    return compactPrice.length <= COMPACT_MAX_CHARACTERS ? compactPrice : '';
  };

  var price = hasInstalment ? Object(price_util["b" /* getInstalmentPrice */])({
    currency: currency,
    formattedValue: formattedPriceValue,
    value: priceValue
  }, locale) : formattedPriceValue;
  return DayWithPrice_jsx(react["Fragment"], null, withPriceDetails && DayWithPrice_jsx(DayPriceDetails_DayPriceDetails, {
    duration: duration,
    departureCity: departureCity,
    hasTransport: hasTransport,
    isJoyview: isJoyview,
    shouldDisplayDetails: !!price && shouldDisplayDetails,
    day: day,
    unit: unit
  }), DayWithPrice_jsx("span", {
    className: thDayNumber
  }, moment_default()(day).format('D')), shouldDisplayStatusMessage && Object(i18n["e" /* has */])(statusMessageKey) && !isLoading && DayWithPrice_jsx("span", {
    className: thStatusMessage
  }, Object(i18n["g" /* t */])(statusMessageKey)), shouldDisplaySelectedDepartureDateMessage && DayWithPrice_jsx("div", {
    className: thDayMessage
  }, Object(i18n["g" /* t */])('booking.priceCalendar.selectedDepartureDateMessage'), ' ', DayWithPrice_jsx("div", {
    className: "mt-px5"
  }, Object(i18n["g" /* t */])('booking.priceCalendar.endDateMessage'))), isLoading && DayWithPrice_jsx(Spinner["a" /* Spinner */], {
    size: "tiny",
    color: colors["a" /* COLORS */].GRAY
  }), shouldDisplayPrice && !isLoading && DayWithPrice_jsx(react["Fragment"], null, !!price && DayWithPrice_jsx("span", {
    className: thFrom
  }, Object(i18n["g" /* t */])('price.format.from')), DayWithPrice_jsx("span", {
    "data-testid": "price",
    className: thDayPrice
  }, theme === 'compact' ? getCompactPrice(price) : price), price !== oldPrice && DayWithPrice_jsx("span", {
    className: thDayOldPrice
  }, oldPrice)));
};
// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.utils.js
var TripDatePicker_utils = __webpack_require__("RqHf");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.jsx




var TripDatePicker_jsx = react_default.a.createElement;















var selector = function selector(state) {
  var _state$calendar;

  return {
    isBookableDatesLoading: state === null || state === void 0 ? void 0 : (_state$calendar = state.calendar) === null || _state$calendar === void 0 ? void 0 : _state$calendar.bookableDatesLoading
  };
}; // $FlowFixMe


var Weekday = function Weekday(_ref) {
  var weekday = _ref.weekday,
      className = _ref.className,
      localeUtils = _ref.localeUtils,
      locale = _ref.locale;
  var weekdayName = localeUtils.formatWeekdayLong(weekday, locale);
  return TripDatePicker_jsx("div", {
    className: className,
    title: weekdayName
  }, weekdayName);
};

var TripDatePicker_TripDatePicker = function TripDatePicker(_ref2) {
  var _modifiers;

  var className = _ref2.className,
      departureDate = _ref2.departureDate,
      duration = _ref2.duration,
      hasInstalment = _ref2.hasInstalment,
      isJoyview = _ref2.isJoyview,
      navbarElement = _ref2.navbarElement,
      navigationByYear = _ref2.navigationByYear,
      offsetCalendar = _ref2.offsetCalendar,
      onDayMouseOver = _ref2.onDayMouseOver,
      onSelect = _ref2.onSelect,
      openCalendarToDate = _ref2.openCalendarToDate,
      openingDates = _ref2.openingDates,
      optionsDuration = _ref2.optionsDuration,
      prices = _ref2.prices,
      _ref2$selectedDays = _ref2.selectedDays,
      from = _ref2$selectedDays.from,
      to = _ref2$selectedDays.to,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'default' : _ref2$theme,
      withLongDayFormat = _ref2.withLongDayFormat,
      _ref2$withPriceDetail = _ref2.withPriceDetails,
      withPriceDetails = _ref2$withPriceDetail === void 0 ? false : _ref2$withPriceDetail,
      props = Object(objectWithoutProperties["a" /* default */])(_ref2, ["className", "departureDate", "duration", "hasInstalment", "isJoyview", "navbarElement", "navigationByYear", "offsetCalendar", "onDayMouseOver", "onSelect", "openCalendarToDate", "openingDates", "optionsDuration", "prices", "selectedDays", "theme", "withLongDayFormat", "withPriceDetails"]);

  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var _props$displayPrices = props.displayPrices,
      displayPrices = _props$displayPrices === void 0 ? Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('datePicker.displayPrices') : _props$displayPrices;

  var _useSelector = Object(es["e" /* useSelector */])(selector),
      isBookableDatesLoading = _useSelector.isBookableDatesLoading;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var onMouseOver = function onMouseOver(day) {
    onDayMouseOver && onDayMouseOver(day);
  };

  var pricesIds = Object.keys(prices || {});
  var flattenedPrices = prices ? Object(TripDatePicker_utils["e" /* flattenPrices */])(prices) : '';
  var hasPrices = pricesIds.length > 0;
  var doDisplayPricesInDatePicker = hasPrices && displayPrices;
  var resolvePrice = Object(react["useCallback"])(function (dayId) {
    return Object(lodash["get"])(prices, "[".concat(dayId, "]"), {});
  }, [flattenedPrices]);
  var isSeller = appContext.isSeller,
      locale = appContext.locale;
  var disabledDays = Object(react["useMemo"])(function () {
    return Object(TripDatePicker_utils["f" /* getDisabledDays */])({
      from: from,
      to: to,
      prices: prices,
      isSeller: isSeller,
      optionsDuration: optionsDuration,
      openingDates: openingDates,
      resolvePrice: resolvePrice
    });
  }, [from, isSeller, optionsDuration.join(), flattenedPrices, to]);
  var dayIsClosed = Object(react["useCallback"])(Object(TripDatePicker_utils["b" /* closedDaysFactory */])(resolvePrice, from, moment_default()(to).subtract(1, 'day').toDate()), [from, to, flattenedPrices]);
  var classColorGreen = 'text-emerald';
  var classColorOrange = 'text-orange';
  var modifiers = (_modifiers = {}, Object(defineProperty["a" /* default */])(_modifiers, classColorGreen, hasPrices ? Object(TripDatePicker_utils["a" /* bestPrice */])(resolvePrice) : []), Object(defineProperty["a" /* default */])(_modifiers, classColorOrange, hasPrices ? Object(TripDatePicker_utils["g" /* lastRoom */])(resolvePrice) : []), Object(defineProperty["a" /* default */])(_modifiers, "disabledDays", disabledDays), Object(defineProperty["a" /* default */])(_modifiers, 'pointer-events-none', function pointerEventsNone(day) {
    var dayIsSelected = from && to && Object(TripDatePicker_utils["d" /* dateToInt */])(day) >= Object(TripDatePicker_utils["d" /* dateToInt */])(from) && Object(TripDatePicker_utils["d" /* dateToInt */])(day) <= Object(TripDatePicker_utils["d" /* dateToInt */])(to);

    if (hasPrices && dayIsSelected) {
      return dayIsClosed(day);
    }
  }), _modifiers);
  var firstDateWithPrices = Object(react["useMemo"])(function () {
    var today = Object(TripDatePicker_utils["d" /* dateToInt */])(new Date());
    var dayWithPrice = pricesIds.find(function (pricesKey) {
      return Object(TripDatePicker_utils["d" /* dateToInt */])(moment_default()(pricesKey, apiDate["a" /* API_DATE_FORMAT */]).toDate()) > today && prices && prices[pricesKey].available;
    });
    return dayWithPrice || null;
  }, [flattenedPrices]);
  var firstDateOpened = Object(react["useMemo"])(function () {
    if (!Array.isArray(openingDates) || openingDates.length === 0) {
      return null;
    }

    var _openingDates = Object(slicedToArray["a" /* default */])(openingDates, 1),
        opening = _openingDates[0].opening;

    return opening;
  }, [openingDates]);
  var thDay = TripDatePicker_themes_themes({
    isTablet: isTablet
  })[theme].thDay; // If bookable dates are loading only define current or selected day as range

  var datesRange = isBookableDatesLoading ? {
    min: moment_default()(from).toDate(),
    max: moment_default()(from).toDate()
  } : {
    min: Object(TripDatePicker_utils["i" /* minDatepickerDate */])(offsetCalendar),
    max: Object(TripDatePicker_utils["h" /* maxDatepickerDate */])()
  };

  var _useState = Object(react["useState"])(openCalendarToDate),
      openCalendarDate = _useState[0],
      setOpenCalendarDate = _useState[1];

  Object(react["useEffect"])(function () {
    setOpenCalendarDate(openCalendarToDate);
  }, [moment_default()(openCalendarToDate).format(apiDate["a" /* API_DATE_FORMAT */])]);
  Object(react["useEffect"])(function () {
    if (from) {
      setOpenCalendarDate(from);
    }
  }, [moment_default()(from).format(apiDate["a" /* API_DATE_FORMAT */])]);
  var initialMonth = Object(react["useMemo"])(function () {
    return moment_default()(openCalendarDate || from || firstDateWithPrices || firstDateOpened || Object(TripDatePicker_utils["i" /* minDatepickerDate */])(offsetCalendar)).toDate();
  }, [moment_default()(openCalendarDate).format(apiDate["a" /* API_DATE_FORMAT */]), moment_default()(from).format(apiDate["a" /* API_DATE_FORMAT */]), moment_default()(firstDateWithPrices).format(apiDate["a" /* API_DATE_FORMAT */]), moment_default()(firstDateOpened).format(apiDate["a" /* API_DATE_FORMAT */]), offsetCalendar]);
  return TripDatePicker_jsx(Datepicker_Datepicker, Object(esm_extends["a" /* default */])({
    hasRangeMode: true,
    className: className,
    selectedDays: {
      from: from,
      to: to
    },
    disabledDays: disabledDays,
    customModifiers: modifiers,
    hasNavigationByYear: navigationByYear,
    minDate: datesRange.min,
    maxDate: datesRange.max,
    navbarElement: navbarElement,
    initialMonth: initialMonth,
    onSelect: onSelect,
    onMouseOver: onMouseOver,
    onFocus: onMouseOver,
    theme: theme,
    weekdayElement: withLongDayFormat ? TripDatePicker_jsx(Weekday, null) : undefined
  }, doDisplayPricesInDatePicker ? {
    // eslint-disable-next-line clubmed/no-fake-component
    renderDay: function renderDay(day, dayModifiers) {
      return TripDatePicker_jsx(DayWithPrice_DayWithPrice, {
        day: day,
        duration: duration,
        hasInstalment: hasInstalment,
        isSelectable: Boolean(!dayModifiers.disabledDays && from && !to && !DayPicker["DateUtils"].isSameDay(day, from)),
        isLoading: departureDate && isBookableDatesLoading && moment_default()(day).isAfter(departureDate) ? true : false,
        isJoyview: isJoyview,
        locale: locale,
        price: resolvePrice(Object(TripDatePicker_utils["d" /* dateToInt */])(day)),
        shouldDisplayPrice: hasPrices && !from,
        shouldDisplayStatusMessage: !from,
        shouldDisplayDetails: withPriceDetails && !!dayModifiers[Datepicker_themes_themes[theme].thDayPicker.selected] && !from && !to,
        shouldDisplaySelectedDepartureDateMessage: !!from && !to && moment_default()(from).isSame(day, 'day'),
        withPriceDetails: withPriceDetails,
        theme: theme
      });
    },
    datePickerClassNames: {
      day: thDay
    }
  } : null));
};

/***/ }),

/***/ "qFX+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOCALES; });
var LOCALES = {
  EN_CN: 'en-CN',
  PT_BR: 'pt-BR',
  ZH_CN: 'zh-CN',
  FR_FR: 'fr-FR'
};


/***/ }),

/***/ "qLhN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FilterWhen_FilterWhen; });

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-select/InputSelect.jsx + 1 modules
var InputSelect = __webpack_require__("oWz2");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.jsx + 7 modules
var TripDatePicker = __webpack_require__("pteD");

// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.utils.js
var TripDatePicker_utils = __webpack_require__("RqHf");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/flexibility/flexibility.constants.js
var flexibility_constants = __webpack_require__("45Yg");

// CONCATENATED MODULE: ./src/client/store/trip-criteria/flexibility/flexibility.action.js


function setFlexibility(value) {
  return Object(createAction["b" /* default */])(flexibility_constants["a" /* TRIP_INFORMATION_SET_FLEXIBILITY */], {
    value: value
  });
}
// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-when/filter-when/ArrivalDepartureDate.jsx
var ArrivalDepartureDate = __webpack_require__("YSwF");

// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-when/filter-when/FilterWhen.jsx
var __jsx = react_default.a.createElement;















var FilterWhen_PriceLegend = function PriceLegend() {
  return __jsx("div", {
    className: "content-start flex flex-wrap justify-center"
  }, __jsx("div", {
    className: "pl-px10 py-px5 text-center text-emerald text-sm"
  }, Object(i18n["g" /* t */])('faceting.when.bestPrice')), __jsx("div", {
    className: "pl-px10 py-px5 text-center text-orange text-sm"
  }, Object(i18n["g" /* t */])('faceting.when.lastAvailability')), __jsx("div", {
    className: "pl-px20 py-px5 text-center text-gray-light text-sm"
  }, Object(i18n["g" /* t */])('faceting.when.notAvailable')));
};

var FilterWhen_FilterWhen = function FilterWhen(_ref) {
  var changeDepartureDate = _ref.changeDepartureDate,
      changeTripDuration = _ref.changeTripDuration,
      dateFormat = _ref.dateFormat,
      _ref$defaultDuration = _ref.defaultDuration,
      defaultDuration = _ref$defaultDuration === void 0 ? 7 : _ref$defaultDuration,
      departureDate = _ref.departureDate,
      duration = _ref.duration,
      isSubmittable = _ref.isSubmittable,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      navigationByYear = _ref.navigationByYear,
      openCalendarToDate = _ref.openCalendarToDate,
      _ref$openingDates = _ref.openingDates,
      openingDates = _ref$openingDates === void 0 ? [] : _ref$openingDates,
      _ref$optionsDuration = _ref.optionsDuration,
      optionsDuration = _ref$optionsDuration === void 0 ? [] : _ref$optionsDuration,
      _ref$prices = _ref.prices,
      prices = _ref$prices === void 0 ? {} : _ref$prices,
      _ref$showDurationLabe = _ref.showDurationLabel,
      showDurationLabel = _ref$showDurationLabe === void 0 ? true : _ref$showDurationLabe,
      offsetCalendar = _ref.offsetCalendar,
      _ref$withFlexibility = _ref.withFlexibility,
      withFlexibility = _ref$withFlexibility === void 0 ? false : _ref$withFlexibility;
  var track = Object(useTracking["a" /* useTracking */])({});
  var dispatch = Object(es["d" /* useDispatch */])();
  var from = departureDate ? moment_default()(departureDate).toDate() : null;
  var to = from && duration ? moment_default()(from).add({
    days: duration
  }).toDate() : null;

  var _useState = Object(react["useState"])(from),
      hovered = _useState[0],
      setHovered = _useState[1];

  var computeDisplayedDuration = function computeDisplayedDuration() {
    var displayedDuration = from && (to || hovered) ? Object(TripDatePicker_utils["c" /* dateDiff */])(from, to || hovered || from) || duration || defaultDuration : 0;
    return displayedDuration || defaultDuration || 0;
  };

  var displayedDuration = computeDisplayedDuration();
  var flexibility = Object(es["e" /* useSelector */])(tripCriteria_selector["d" /* getTripFlexibility */]);
  Object(react["useEffect"])(function () {
    if (!departureDate) {
      setHovered(null);
    }
  }, [departureDate]);

  var onFlexibilityChange = function onFlexibilityChange(name, value) {
    var flexibilityValue = parseInt(value, 10);
    track({
      actionGA: 'smartCriterias',
      labelGA: "flexibility_".concat(flexibilityValue || 'none')
    });
    dispatch(setFlexibility(flexibilityValue));
  };

  var onDayMouseOver = function onDayMouseOver(day) {
    setHovered(day);
  };

  var onSelect = function onSelect(dates) {
    changeDepartureDate(dates.from);

    if (dates.from && dates.to) {
      var updatedDuration = Object(TripDatePicker_utils["c" /* dateDiff */])(dates.from, dates.to);
      changeTripDuration(updatedDuration);
    } else {
      changeTripDuration(null);
    }
  };

  var hasPrices = Object.keys(prices || {}).length > 0;
  var cls = ['bg-white border-1 border-gray-light mb-px10 mx-px20 p-px10 rounded', 'lg:border-0 md:mx-auto lg:m-px5 lg:mr-px5 lg:p-0 lg:rounded-none text-center'];
  var durationLabel = Object(dist["messageFormat"])({
    n: Object(i18n["g" /* t */])('faceting.when.durationPlural'),
    _0: '-',
    _1: Object(i18n["g" /* t */])('faceting.when.durationSingular')
  }).format({
    n: displayedDuration,
    count: displayedDuration
  });
  return __jsx("div", {
    "data-testid": "FilterWhen",
    className: "block p-px10 mb-px40 sm:m-0"
  }, label ? __jsx(react["Fragment"], null, isSubmittable ? __jsx("div", {
    className: "flex font-bold items-center text-left text-orange text-sm"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].WARNING,
    width: "2.5em",
    className: "flex mr-px10"
  }), __jsx("span", null, label)) : __jsx("div", {
    className: "font-bold lg:text-center text-lg"
  }, label)) : null, __jsx(ArrivalDepartureDate["a" /* ArrivalDepartureDate */], {
    arrivalDate: from && moment_default()(from).format(dateFormat),
    departureDate: to && moment_default()(to).format(dateFormat)
  }), __jsx("div", {
    className: cls.join(' ')
  }, showDurationLabel && !hasPrices ? __jsx("div", {
    className: "px-px20 py-px10 mb-px5 lg:px-px10 sm:border-b"
  }, __jsx("div", {
    className: "flex items-center justify-between mt-px5 text-base"
  }, __jsx("span", null, Object(i18n["g" /* t */])('faceting.when.duration')), __jsx("span", {
    "data-testid": "duration-label"
  }, durationLabel))) : null, hasPrices ? __jsx("div", {
    className: "sm:border-b border-gray-light py-px5 mb-px10 w-full"
  }, __jsx("div", {
    className: "text-center text-base"
  }, Object(i18n["g" /* t */])('faceting.when.pricesBasedOn'), ' ', __jsx("strong", {
    "data-testid": "prices-duration-label"
  }, durationLabel)), __jsx(FilterWhen_PriceLegend, null)) : null, __jsx(TripDatePicker["a" /* TripDatePicker */], {
    className: "pb-0",
    departureDate: departureDate,
    navigationByYear: navigationByYear,
    offsetCalendar: offsetCalendar,
    onDayMouseOver: onDayMouseOver,
    openCalendarToDate: openCalendarToDate,
    openingDates: openingDates,
    optionsDuration: optionsDuration,
    onSelect: onSelect,
    prices: prices,
    selectedDays: {
      from: from,
      to: to
    },
    theme: "compact"
  }), withFlexibility && __jsx("div", {
    className: "border-t py-px10"
  }, __jsx("span", {
    className: "flex font-bold font-sans mb-px5 text-base text-gray-darker"
  }, Object(i18n["g" /* t */])('faceting.flexibility.label')), __jsx(InputSelect["a" /* InputSelect */], {
    dataTestId: "flexibility-input",
    onChange: onFlexibilityChange,
    options: [{
      label: Object(i18n["g" /* t */])('faceting.flexibility.duration_0'),
      value: 0
    }, {
      label: Object(i18n["g" /* t */])('faceting.flexibility.duration_1'),
      value: 1
    }, {
      label: Object(i18n["g" /* t */])('faceting.flexibility.duration_3'),
      value: 3
    }, {
      label: Object(i18n["g" /* t */])('faceting.flexibility.duration_7'),
      value: 7
    }],
    value: flexibility
  }))));
};

/***/ }),

/***/ "qPLk":
/***/ (function(module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "qXr/":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "qs2G":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("LTtw");
var DESCRIPTORS = __webpack_require__("uGjT");
var global = __webpack_require__("HnW7");
var has = __webpack_require__("DZWw");
var isObject = __webpack_require__("1YFU");
var defineProperty = __webpack_require__("87KK").f;
var copyConstructorProperties = __webpack_require__("sfoL");

var NativeSymbol = global.Symbol;

if (DESCRIPTORS && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "rXTn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("pWxA");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _form_field_FormField__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("QPdA");







var __jsx = react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* DEPRECATED */



var defaultProps = {
  dataSelector: 'FormSelect',
  isDisabled: false,
  isRequired: false,
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  options: []
};
/* DEPRECATED : DO NOT USE ANYMORE */

var FormSelect = /*#__PURE__*/function (_React$Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(FormSelect, _React$Component);

  var _super = _createSuper(FormSelect);

  function FormSelect(props) {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(this, FormSelect);

    _this = _super.call(this, props);

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_this), "onChange", function (e) {
      e.persist();
      var value = e.target.value;

      _this.props.onChange(value);

      _this.setState({
        value: value
      });
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_this), "getOptions", function () {
      if (!_this.props.options.length) {
        return null;
      }

      return _this.props.options.map(function (_ref) {
        var label = _ref.label,
            value = _ref.value,
            isDisabled = _ref.isDisabled;
        return label.trim() ? __jsx("option", {
          disabled: isDisabled,
          key: value,
          label: label.trim(),
          value: value
        }, label) : null;
      });
    });

    _this.state = {
      value: props.value || ''
    };
    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(FormSelect, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(_ref2) {
      var value = _ref2.value;

      if (this.props.value !== value) {
        this.setState({
          value: value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var value = this.state.value;
      var _this$props = this.props,
          className = _this$props.className,
          dataSelector = _this$props.dataSelector,
          id = _this$props.id,
          isDisabled = _this$props.isDisabled,
          isLoading = _this$props.isLoading,
          isRequired = _this$props.isRequired,
          name = _this$props.name,
          onBlur = _this$props.onBlur,
          onFocus = _this$props.onFocus,
          placeholder = _this$props.placeholder;
      return __jsx("div", {
        className: "cursor-pointer flex-1 relative"
      }, __jsx("select", {
        className: classnames__WEBPACK_IMPORTED_MODULE_8___default()('reset-input reset-select bg-transparent py-px10 px-pw15 rtl:pr-px40 text-md w-full', {
          'text-gray-darker': value,
          'text-gray-dark': !value,
          'cursor-not-allowed': isDisabled,
          'cursor-progress': isLoading && !isDisabled
        }, className),
        "data-selector": dataSelector,
        "data-testid": dataSelector,
        disabled: isDisabled,
        id: id,
        name: name,
        onBlur: onBlur,
        onChange: this.onChange,
        onFocus: onFocus,
        required: isRequired,
        value: value
      }, !!placeholder && __jsx("option", {
        "data-testid": "FormSelectPlaceholder",
        label: placeholder.trim(),
        disabled: true,
        value: ""
      }, isRequired ? "".concat(placeholder, "*") : placeholder), this.getOptions()));
    }
  }]);

  return FormSelect;
}(react__WEBPACK_IMPORTED_MODULE_7___default.a.Component);

Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(FormSelect, "displayName", 'FormSelect');

FormSelect.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(_form_field_FormField__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(FormSelect));

/***/ }),

/***/ "rcxx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PAGE_BE_ACCOMMODATION; });
/* unused harmony export PAGE_BE_TRANSPORT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PAGE_BE_SERVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PAGE_BE_ACTIVITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PAGE_BE_SERVICES_ALL_INCLUSIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PAGE_BE_PARTICIPANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PAGE_BE_BANKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getBookingEngineUri; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getBookingCriteriaOffsetSell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return checkIsDepartureDateAvailaible; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("zjfJ");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("U2CP");
/* harmony import */ var _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("PIvV");
/* harmony import */ var _proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("oL6k");
/* harmony import */ var _request_requestDictionary__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("CcNa");




function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}






var PAGE_BE_ACCOMMODATION = 'accommodation';
var PAGE_BE_TRANSPORT = 'transport';
var PAGE_BE_SERVICES = 'services';
var PAGE_BE_ACTIVITIES = 'activities';
var PAGE_BE_SERVICES_ALL_INCLUSIVE = 'allInclusive';
var PAGE_BE_PARTICIPANTS = 'participants';
var PAGE_BE_BANKING = 'banking';
function getBookingEngineUri() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PAGE_BE_ACCOMMODATION;
  var proposals = arguments.length > 1 ? arguments[1] : undefined;
  var resort = arguments.length > 2 ? arguments[2] : undefined;
  var selectedProposalId = arguments.length > 3 ? arguments[3] : undefined;
  var otherQueryParameters = arguments.length > 4 ? arguments[4] : undefined;
  var proposalIds = proposals.map(function (proposal) {
    return proposal.id;
  });
  var defaultProposal = Object(_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_6__[/* getDefaultProposal */ "f"])(proposals, resort);

  var queryParams = _objectSpread(_objectSpread({}, otherQueryParameters), {}, {
    proposalIds: proposalIds,
    selectedProposalId: selectedProposalId || defaultProposal.id,
    coderesort: resort === null || resort === void 0 ? void 0 : resort.id
  });

  return _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_4__[/* buildUrl */ "a"]('booking', {
    page: page
  }, queryParams);
}
var getBookingCriteriaOffsetSell = /*#__PURE__*/function () {
  var _ref = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee(productId, appContext) {
    var getQuery, query;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getQuery = function getQuery() {
              return "query {\n                  bookingCriteria(productId: \"".concat(productId, "\") {\n                    offsetSell\n                  }\n            }");
            };

            query = getQuery();
            return _context.abrupt("return", _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"].runQuery(query, appContext, {
              requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_7__[/* CRITERIA_OFFSETSELL */ "f"]
            }));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getBookingCriteriaOffsetSell(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}(); // check if the departureDate comes after today plus the offsetSell (in days), which is defined by the API

var checkIsDepartureDateAvailaible = function checkIsDepartureDateAvailaible(departureDate, offsetSell) {
  return moment__WEBPACK_IMPORTED_MODULE_3___default()(departureDate).isBefore(moment__WEBPACK_IMPORTED_MODULE_3___default()().add(offsetSell, 'd'), 'day');
};

/***/ }),

/***/ "rvZv":
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "s+R0":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("JBn+"),
    arrayIncludes = __webpack_require__("OfKG"),
    arrayIncludesWith = __webpack_require__("sCL+"),
    cacheHas = __webpack_require__("S0iI"),
    createSet = __webpack_require__("9TP6"),
    setToArray = __webpack_require__("XlL0");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ "sCL+":
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ "sW3P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADULTS_ONLY_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADULTS_NUMBER_MIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return MAX_PAX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return MAX_PAX_SELLER; });
/* unused harmony export AREA_FACET_PREFIX_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHILDCARE_FACET_ID; });
/* unused harmony export COUNTRY_FACET_PREFIX_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DATE_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DEFAULT_DEPARTURE_CITY_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DEPARTURE_CITY_FACET_ID; });
/* unused harmony export DEPARTURE_DATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DEPARTURE_DATE_MAX_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DEPARTURE_DATE_MAX_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DEPARTURE_DATE_MIN_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DURATION_FACET; });
/* unused harmony export KIDS_FACET_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return KIDS_NUMBER_MAX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return LOCALE_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return MAX_NUMBER_OF_SELECTED_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return OFFER_ID_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return PRODUCT_FACET_ID; });
/* unused harmony export WHEN_FACET_ID */
/* unused harmony export WHERE_FACET_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVITIES_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DESTINATIONS_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COUNTRIES_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return TOP_COUNTRIES_FACET_LIST_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return TYPES_OF_STAY_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FACET_COMFORT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return QUERY_QUERY_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return PRODUCTS_TO_COMPARE_QUERY_PARAM; });
/* unused harmony export FACET_QUERY_PARAMS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DEFAULT_CHILDCARE_FACETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FILTERABLE_FACETS_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FILTERABLE_FACETS_TRACKING_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FILTERABLE_FACETS_TEMPLATE_CONFIG; });
/* unused harmony export FACETS */
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("SPKZ");


var ADULTS_ONLY_FACET_ID = 'facette_adult_only';
var ADULTS_NUMBER_MIN = 1;
var MAX_PAX = 6;
var MAX_PAX_SELLER = 8;
var AREA_FACET_PREFIX_ID = 'AREA';
var CHILDCARE_FACET_ID = 'facette_childcare_age_in_month';
var COUNTRY_FACET_PREFIX_ID = 'COUNTRY';
var DATE_FORMAT = 'YYYY-MM-DD';
var DEFAULT_DEPARTURE_CITY_VALUE = 'NO';
var DEPARTURE_CITY_FACET_ID = 'facette_departure_city';
var DEPARTURE_DATE = 'date';
var DEPARTURE_DATE_MAX_DATE = {
  years: 2
};
var DEPARTURE_DATE_MAX_FACET_ID = 'departure_date_max';
var DEPARTURE_DATE_MIN_FACET_ID = 'departure_date_min';
var DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH = 6;
var DURATION_FACET = 'facette_duration';
var KIDS_FACET_ID = 'facette_kids';
var KIDS_NUMBER_MAX = 5;
var LOCALE_FACET_ID = 'locale';
var MAX_NUMBER_OF_SELECTED_PRODUCTS = 3;
var OFFER_ID_FACET_ID = 'facette_offer_id';
var PRODUCT_FACET_ID = 'product_id';
var WHEN_FACET_ID = 'facette_when';
var WHERE_FACET_ID = 'facette_where';
var ACTIVITIES_FACET_ID = 'activities_tree';
var DESTINATIONS_FACET_ID = 'destinations_tree';
var COUNTRIES_FACET_ID = 'facette_destination_country';
var TOP_COUNTRIES_FACET_LIST_ID = 'facet_list_top_destination_countries';
var TYPES_OF_STAY_FACET_ID = 'facette_type';
var FACET_COMFORT_ID = 'facette_comfort_label';
var QUERY_QUERY_PARAM = 'search';
var PRODUCTS_TO_COMPARE_QUERY_PARAM = _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["appQueryParameters"].productsComparison.productIds;
var FACET_QUERY_PARAMS = [{
  id: 'destination',
  facetId: COUNTRIES_FACET_ID
}, {
  id: 'departure_city',
  facetId: DEPARTURE_CITY_FACET_ID
}];
var DEFAULT_CHILDCARE_FACETS = ['132-215', '24-47', '4-23', '48-131'];
var FILTERABLE_FACETS_IDS = [ACTIVITIES_FACET_ID, DESTINATIONS_FACET_ID, COUNTRIES_FACET_ID, TYPES_OF_STAY_FACET_ID, FACET_COMFORT_ID];
var FILTERABLE_FACETS_TRACKING_CONFIG = [{
  id: ACTIVITIES_FACET_ID,
  trackingPrefixLabel: 'activities'
}, {
  id: DESTINATIONS_FACET_ID,
  trackingPrefixLabel: 'destinations'
}, {
  id: COUNTRIES_FACET_ID,
  trackingPrefixLabel: 'destinations'
}, {
  id: TYPES_OF_STAY_FACET_ID,
  trackingPrefixLabel: 'typeofstay'
}, {
  id: FACET_COMFORT_ID,
  trackingPrefixLabel: 'comfort'
}];
var FILTERABLE_FACETS_TEMPLATE_CONFIG = [{
  id: DESTINATIONS_FACET_ID,
  dataLabel: 'where',
  iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].EARTH_PLANE,
  facetLists: [{
    deep: false,
    id: DESTINATIONS_FACET_ID,
    titleLabel: 'faceting.where.destinationTitle'
  }, {
    deep: false,
    id: COUNTRIES_FACET_ID,
    titleLabel: 'faceting.where.countriesTitle'
  }],
  titleLabel: 'faceting.where.title'
}, {
  id: ACTIVITIES_FACET_ID,
  dataLabel: 'activities',
  facetLists: [{
    deep: true,
    id: ACTIVITIES_FACET_ID
  }],
  iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].ACTIVITIES,
  titleLabel: 'faceting.activities.title'
}, {
  id: TYPES_OF_STAY_FACET_ID,
  dataLabel: 'typeofstay',
  facetLists: [{
    deep: false,
    id: TYPES_OF_STAY_FACET_ID,
    facetLabels: 'faceting.typesOfStay'
  }],
  iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].BEACH,
  titleLabel: 'faceting.typesOfStay.title',
  trackingPrefixLabel: 'typeofstay'
}, {
  id: FACET_COMFORT_ID,
  dataLabel: 'comfort',
  facetLists: [{
    deep: false,
    id: FACET_COMFORT_ID
  }],
  iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].TRIDENT1,
  titleLabel: 'faceting.comfort.title'
}];
var FACETS = {
  when: 'when',
  who: 'who',
  where: 'where'
};

/***/ }),

/***/ "sfoL":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("DZWw");
var ownKeys = __webpack_require__("1m4l");
var getOwnPropertyDescriptorModule = __webpack_require__("5h8T");
var definePropertyModule = __webpack_require__("87KK");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ "tF/N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateSummary; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("UCZK");
/* harmony import */ var _views_booking_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("taV1");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_template_string_TemplateString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Ohju");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;







var DateSummary = function DateSummary(_ref) {
  var _ref$extendedDataset = _ref.extendedDataset,
      extendedDataset = _ref$extendedDataset === void 0 ? false : _ref$extendedDataset,
      template = _ref.template,
      values = _ref.values,
      _ref$as = _ref.as,
      Comp = _ref$as === void 0 ? 'div' : _ref$as;
  return __jsx(Comp, {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('PackagePriceSummary-section', {
      'PackagePriceSummary-section--extended': extendedDataset
    }),
    "data-testid": _views_booking_constants__WEBPACK_IMPORTED_MODULE_3__[/* CRITERIA_SELECTORS */ "o"].DEPARTURE
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__[/* Icon */ "a"], {
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].BLUE,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].DATE,
    className: "PackagePriceSummary-icon",
    width: "1.875rem",
    hasRtl: true
  }), __jsx(_frameworks_template_string_TemplateString__WEBPACK_IMPORTED_MODULE_6__[/* TemplateString */ "a"], {
    template: template // $FlowFixMe
    ,
    values: values,
    valuesClassName: {
      arrivalDate: 'PackagePriceSummary-arrivalDate',
      departureDate: 'PackagePriceSummary-departureDate'
    }
  }));
};

/***/ }),

/***/ "tRRp":
/***/ (function(module) {

module.exports = JSON.parse("{\"0\":65533,\"128\":8364,\"130\":8218,\"131\":402,\"132\":8222,\"133\":8230,\"134\":8224,\"135\":8225,\"136\":710,\"137\":8240,\"138\":352,\"139\":8249,\"140\":338,\"142\":381,\"145\":8216,\"146\":8217,\"147\":8220,\"148\":8221,\"149\":8226,\"150\":8211,\"151\":8212,\"152\":732,\"153\":8482,\"154\":353,\"155\":8250,\"156\":339,\"158\":382,\"159\":376}");

/***/ }),

/***/ "tUgU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FilterWho_FilterWho; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./src/utils/faceting/facetingUtils.js
var facetingUtils = __webpack_require__("kNiU");

// EXTERNAL MODULE: ./src/utils/faceting/kidsValidationStateUtils.js
var kidsValidationStateUtils = __webpack_require__("cGFA");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-feedback/FormFeedback.jsx
var FormFeedback = __webpack_require__("DwNm");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/utils/unique-id/uniqueId.js
var uniqueId = __webpack_require__("m1JM");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/form-control/FormControl.jsx + 1 modules
var FormControl = __webpack_require__("Jcrg");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/form/form.util.js
var form_util = __webpack_require__("1P7A");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-date/InputDate.themes.js


var themes = {
  "default": function _default(props) {
    return {
      thInputWrapper: 'relative decorator-slash-separator flex-1 h-full',
      thInput: classnames_default()('reset-input h-full text-center text-current w-full', Object(form_util["a" /* getCursorClass */])(props))
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-date/InputDate.jsx








var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }







var DAY = 'd';
var MONTH = 'm';
var YEAR = 'y';
var DAY_LENGTH = 2;
var MONTH_LENGTH = 2;
var YEAR_LENGTH = 4;

function getInputsState(_ref) {
  var value = _ref.value;
  var date = value ? moment_default()(value) : moment_default()(null);
  return {
    dayValue: date.isValid() ? date.format('DD') : '',
    monthValue: date.isValid() ? date.format('MM') : '',
    yearValue: date.isValid() ? date.format('YYYY') : ''
  };
}

var InputDate_InputDate = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(InputDate, _Component);

  var _super = _createSuper(InputDate);

  function InputDate(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputDate);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function (inputRef, value, maxLength, nextRef) {
      var _this$props = _this.props,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? lodash["noop"] : _this$props$onChange;

      if (!isReadOnly && !isLoading) {
        _this.setState(Object(defineProperty["a" /* default */])({}, inputRef, value), function () {
          return onChange(_this.props.name || '', _this.getDate());
        });

        if (nextRef && value.length === maxLength) {
          var _this$nextRef;

          // $FlowFixMe
          (_this$nextRef = _this[nextRef]) === null || _this$nextRef === void 0 ? void 0 : _this$nextRef.focus();
        }
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClear", function (e) {
      var _this$props$onClear = _this.props.onClear,
          onClear = _this$props$onClear === void 0 ? lodash["noop"] : _this$props$onClear;

      _this.setState({
        dayValue: '',
        monthValue: '',
        yearValue: ''
      }, function () {
        return onClear(e);
      });
    });

    _this.state = _objectSpread({}, getInputsState(props));
    return _this;
  }

  Object(createClass["a" /* default */])(InputDate, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        this.setState(getInputsState(nextProps));
      }
    }
  }, {
    key: "getDate",
    value: function getDate() {
      var _this$state = this.state,
          dayValue = _this$state.dayValue,
          monthValue = _this$state.monthValue,
          yearValue = _this$state.yearValue;
      var allFields = dayValue.length === DAY_LENGTH && monthValue.length === MONTH_LENGTH && yearValue.length === YEAR_LENGTH;

      if (allFields) {
        var date = moment_default()([parseInt(yearValue, 10), parseInt(monthValue, 10) - 1, parseInt(dayValue, 10)]);
        return date.isValid() ? date.valueOf() : false;
      }

      return null;
    }
  }, {
    key: "getInputOrder",
    value: function getInputOrder(type) {
      var _this$props$dateForma = this.props.dateFormat,
          dateFormat = _this$props$dateForma === void 0 ? '' : _this$props$dateForma;
      return dateFormat.toLowerCase().indexOf(type);
    }
  }, {
    key: "getInputs",
    value: function getInputs() {
      return [{
        ref: 'dayValue',
        placeholder: this.props.placeholderDay || '',
        value: this.state.dayValue,
        order: this.getInputOrder(DAY),
        maxLength: DAY_LENGTH
      }, {
        ref: 'monthValue',
        placeholder: this.props.placeholderMonth || '',
        value: this.state.monthValue,
        order: this.getInputOrder(MONTH),
        maxLength: MONTH_LENGTH
      }, {
        ref: 'yearValue',
        placeholder: this.props.placeholderYear || '',
        value: this.state.yearValue,
        order: this.getInputOrder(YEAR),
        maxLength: YEAR_LENGTH
      }];
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          hasClear = _this$props2.hasClear,
          iconLeft = _this$props2.iconLeft,
          iconRight = _this$props2.iconRight,
          _this$props2$id = _this$props2.id,
          id = _this$props2$id === void 0 ? Object(uniqueId["b" /* generateUniqueId */])([typeof this.props.label === 'string' ? this.props.label : ''], 'InputDate_') : _this$props2$id,
          isDisabled = _this$props2.isDisabled,
          isFilled = _this$props2.isFilled,
          isLoading = _this$props2.isLoading,
          isReadOnly = _this$props2.isReadOnly,
          isRequired = _this$props2.isRequired,
          label = _this$props2.label,
          notes = _this$props2.notes,
          onBlur = _this$props2.onBlur,
          onClick = _this$props2.onClick,
          onFocus = _this$props2.onFocus,
          onKeyDown = _this$props2.onKeyDown,
          onKeyUp = _this$props2.onKeyUp,
          size = _this$props2.size,
          theme = _this$props2.theme,
          validationState = _this$props2.validationState;
      var _this$state2 = this.state,
          dayValue = _this$state2.dayValue,
          monthValue = _this$state2.monthValue,
          yearValue = _this$state2.yearValue;
      var hasValue = Boolean(dayValue) || Boolean(monthValue) || Boolean(yearValue);
      var hasClearEnabled = Boolean(hasClear && hasValue);
      var inputs = Object(lodash["sortBy"])(this.getInputs(), ['order']);

      var _themes$theme = themes[theme](this.props),
          thInput = _themes$theme.thInput,
          thInputWrapper = _themes$theme.thInputWrapper;

      return __jsx(FormControl["a" /* FormControl */], {
        className: className,
        hasClear: hasClearEnabled,
        iconLeft: iconLeft,
        iconRight: iconRight,
        id: id,
        isDisabled: isDisabled,
        isFilled: isFilled && hasValue,
        isLoading: isLoading,
        isReadOnly: isReadOnly,
        isRequired: isRequired,
        label: label,
        notes: notes,
        onClear: this.onClear,
        size: size,
        theme: theme,
        validationState: validationState
      }, inputs.map(function (input, index) {
        var nextRef = index + 1 < inputs.length ? inputs[index + 1].ref : null;
        return __jsx("span", {
          key: index,
          className: thInputWrapper
        }, __jsx("input", Object(esm_extends["a" /* default */])({
          className: thInput,
          "data-testid": input.ref,
          disabled: isDisabled
        }, index === 0 ? {
          id: id
        } : null, {
          maxLength: input.maxLength,
          onBlur: onBlur,
          onChange: function onChange(e) {
            return _this2.onChange(input.ref, e.target.value, input.maxLength, nextRef);
          },
          onClick: onClick,
          onFocus: onFocus,
          onKeyDown: onKeyDown,
          onKeyUp: onKeyUp,
          placeholder: input.placeholder,
          readOnly: Boolean(isReadOnly || isLoading),
          ref: function ref(node) {
            // $FlowFixMe
            _this2[input.ref] = node;
          },
          required: isRequired,
          type: "tel",
          value: input.value
        })));
      }));
    }
  }]);

  return InputDate;
}(react["Component"]);

Object(defineProperty["a" /* default */])(InputDate_InputDate, "defaultProps", {
  dateFormat: 'DDMMYYYY',
  onChange: function onChange() {
    return Promise.resolve();
  },
  size: 'medium',
  theme: 'default'
});
// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-number/InputNumber.jsx + 1 modules
var InputNumber = __webpack_require__("xGYs");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.jsx + 1 modules
var InputSwitch = __webpack_require__("YjXp");

// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-who/filter-who/FilterWho.jsx



var FilterWho_jsx = react_default.a.createElement;

function FilterWho_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function FilterWho_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FilterWho_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FilterWho_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var FilterWho_FilterWho = function FilterWho(_ref) {
  var addChildcareLabel = _ref.addChildcareLabel,
      adultsLabel = _ref.adultsLabel,
      adultsNumber = _ref.adultsNumber,
      _ref$birthdaysErrorMe = _ref.birthdaysErrorMessage,
      birthdaysErrorMessage = _ref$birthdaysErrorMe === void 0 ? '' : _ref$birthdaysErrorMe,
      changeKidsNumber = _ref.changeKidsNumber,
      changeKid = _ref.changeKid,
      dateFormat = _ref.dateFormat,
      dayPlaceholder = _ref.dayPlaceholder,
      hasChildcareSwitch = _ref.hasChildcareSwitch,
      _ref$informationLabel = _ref.informationLabel,
      informationLabel = _ref$informationLabel === void 0 ? '' : _ref$informationLabel,
      isShrink = _ref.isShrink,
      kids = _ref.kids,
      kidsAgeLabel = _ref.kidsAgeLabel,
      kidsAgeLimitLabel = _ref.kidsAgeLimitLabel,
      kidsLabel = _ref.kidsLabel,
      kidsValidationState = _ref.kidsValidationState,
      label = _ref.label,
      _ref$minAdultsNumber = _ref.minAdultsNumber,
      minAdultsNumber = _ref$minAdultsNumber === void 0 ? 1 : _ref$minAdultsNumber,
      monthPlaceholder = _ref.monthPlaceholder,
      setAdultsNumber = _ref.setAdultsNumber,
      validateKidsBirthdate = _ref.validateKidsBirthdate,
      yearPlaceholder = _ref.yearPlaceholder;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useState = Object(react["useState"])(kids.some(function (kid) {
    return kid.childcareIncluded;
  })),
      childcareIncluded = _useState[0],
      setChildcareIncluded = _useState[1];

  var handleKidsNumber = function handleKidsNumber(name, value) {
    if (changeKidsNumber) {
      changeKidsNumber(value);
    }
  };

  var handleKidAge = /*#__PURE__*/function () {
    var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(index, kid) {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!kid.birthdate) {
                _context.next = 4;
                break;
              }

              _context.next = 3;
              return validateKidsBirthdate(index, kid);

            case 3:
              // $FlowFixMe
              if (Object(facetingUtils["g" /* isKidMinor */])(kid.birthdate)) {
                changeKid(index, kid);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleKidAge(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var maxPax = appContext.isSeller ? constants["x" /* MAX_PAX_SELLER */] : constants["w" /* MAX_PAX */];

  var getMaxAdultsAvailable = function getMaxAdultsAvailable() {
    return maxPax - kids.length;
  };

  var getMaxKidsAvailable = function getMaxKidsAvailable() {
    return maxPax - adultsNumber;
  };

  Object(react["useEffect"])(function () {
    kids.forEach(function (kid, index) {
      return changeKid(index, FilterWho_objectSpread(FilterWho_objectSpread({}, kid), {}, {
        childcareIncluded: childcareIncluded
      }));
    });
  }, [childcareIncluded]);
  return FilterWho_jsx("div", {
    "data-testid": "FilterWho",
    className: "FilterWho"
  }, FilterWho_jsx("div", {
    className: "p-px20"
  }, FilterWho_jsx("div", {
    className: "font-bold mb-px20 lg:text-center text-lg"
  }, label), FilterWho_jsx("div", {
    className: "lg:flex lg:items-center text-left"
  }, FilterWho_jsx(InputNumber["a" /* InputNumber */], {
    ariaLabel: adultsLabel,
    attendeeType: "adults",
    className: "lg:flex-auto lg:mx-px20 my-px20 lg:my-0 lg:w-1/2",
    dataTestId: "FilterWho-Adults",
    hasColumnLayout: isShrink,
    label: adultsLabel,
    max: getMaxAdultsAvailable(),
    min: minAdultsNumber,
    onChange: function onChange(name, value) {
      setAdultsNumber(value || 0);
    },
    value: adultsNumber
  }), FilterWho_jsx(InputNumber["a" /* InputNumber */], {
    ariaLabel: kidsLabel,
    attendeeType: "kids",
    className: "lg:flex-auto lg:mx-px20 my-px20 lg:my-0 lg:w-1/2",
    dataTestId: "FilterWho-Children",
    hasColumnLayout: isShrink,
    label: kidsLabel,
    max: getMaxKidsAvailable(),
    notes: kidsAgeLimitLabel,
    onChange: handleKidsNumber,
    value: kids.length
  }))), kids.length > 0 && hasChildcareSwitch && FilterWho_jsx("div", {
    className: "border-gray-light border-t-1 p-px10"
  }, FilterWho_jsx(InputSwitch["a" /* InputSwitch */], {
    inputTestId: "childcare-switch" // $FlowFixMe
    ,
    isChecked: childcareIncluded,
    label: addChildcareLabel,
    labelClassName: "font-bold text-blue",
    onChange: function onChange(name, isChecked) {
      return setChildcareIncluded(isChecked);
    } // $FlowFixMe
    ,
    value: childcareIncluded
  })), kids.length > 0 && FilterWho_jsx("div", {
    className: "border-gray-light border-t-1 p-px10"
  }, FilterWho_jsx("div", {
    className: "mb-px10"
  }, FilterWho_jsx("p", {
    className: "font-bold reset-paragraph text-base text-blue"
  }, kidsAgeLabel), informationLabel && FilterWho_jsx("p", {
    className: "reset-paragraph text-xs"
  }, informationLabel)), Object(kidsValidationStateUtils["c" /* hasKidWithoutAValidBirthdate */])(kidsValidationState) && birthdaysErrorMessage && FilterWho_jsx(FormFeedback["a" /* FormFeedback */], {
    isError: true,
    message: birthdaysErrorMessage
  }), FilterWho_jsx("div", {
    className: !isShrink ? 'lg:flex lg:flex-wrap lg:-mx-px10' : null
  }, kids.map(function (kid, index) {
    return FilterWho_jsx("div", {
      className: !isShrink ? 'flex-none lg:px-px10 w-full lg:w-1/2' : null,
      key: String(kid.birthdate) + String(index)
    }, FilterWho_jsx(InputDate_InputDate, {
      className: "mb-px10",
      dateFormat: dateFormat,
      onChange: function onChange(name, birthdate) {
        return handleKidAge(index, FilterWho_objectSpread(FilterWho_objectSpread({}, kid), {}, {
          birthdate: birthdate
        }));
      },
      placeholderDay: dayPlaceholder,
      placeholderMonth: monthPlaceholder,
      placeholderYear: yearPlaceholder,
      validationState: kidsValidationState[index],
      value: kid.birthdate
    }));
  }))));
};

/***/ }),

/***/ "tX1K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCapitalLetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFirstWord; });
/* unused harmony export getValidString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return titleCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return truncate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return camelCasify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return upperCaseLetterToInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return snakeToCamel; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);


function getCapitalLetters(firstName, lastName) {
  return (firstName ? firstName.charAt(0).toUpperCase() : '') + (lastName ? lastName.charAt(0).toUpperCase() : '');
}

function getFirstWord(str) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isString"])(str) ? str.replace(/\s.*/, '') : '';
}

function getValidString(str) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isString"])(str) ? str.trim() : '';
}

function truncate(str, characters) {
  var preserveWords = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var strTrimed = getValidString(str);

  if (!characters) {
    return strTrimed;
  }

  if (characters < 0) {
    return '';
  }

  if (strTrimed.length > characters) {
    var length = preserveWords ? strTrimed.lastIndexOf(' ', characters) : characters;
    return strTrimed.substring(0, length) + '…';
  }

  return strTrimed;
}

function titleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

function camelCasify(text) {
  return text.split(' ').map(function (word, i) {
    if (i > 0) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }

    return word.toLowerCase();
  }).join('');
}

var upperCaseLetterToInt = function upperCaseLetterToInt(letter) {
  return letter.charCodeAt(0) - 64;
};

function snakeToCamel(s) {
  return s.replace(/(_\w)/g, function (match) {
    return match.toUpperCase().substr(1);
  });
}



/***/ }),

/***/ "tjZu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServicesContext; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
 // $FlowFixMe

var ServicesContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createContext({});

/***/ }),

/***/ "tsZ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

// Adapted from Modernizr
// https://github.com/Modernizr/Modernizr/blob/acb3f0d9/feature-detects/dom/passiveeventlisteners.js#L26-L37
function testPassiveEventListeners() {
  if (!CAN_USE_DOM) {
    return false;
  }

  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
    return false;
  }

  var supportsPassiveOption = false;
  try {
    var opts = Object.defineProperty({}, 'passive', {
      // eslint-disable-next-line getter-return
      get: function () {
        function get() {
          supportsPassiveOption = true;
        }

        return get;
      }()
    });
    var noop = function noop() {};
    window.addEventListener('testPassiveEventSupport', noop, opts);
    window.removeEventListener('testPassiveEventSupport', noop, opts);
  } catch (e) {
    // do nothing
  }

  return supportsPassiveOption;
}

var memoized = void 0;

function canUsePassiveEventListeners() {
  if (memoized === undefined) {
    memoized = testPassiveEventListeners();
  }
  return memoized;
}

function normalizeEventOptions(eventOptions) {
  if (!eventOptions) {
    return undefined;
  }

  if (!canUsePassiveEventListeners()) {
    // If the browser does not support the passive option, then it is expecting
    // a boolean for the options argument to specify whether it should use
    // capture or not. In more modern browsers, this is passed via the `capture`
    // option, so let's just hoist that value up.
    return !!eventOptions.capture;
  }

  return eventOptions;
}

/* eslint-disable no-bitwise */

/**
 * Generate a unique key for any set of event options
 */
function eventOptionsKey(normalizedEventOptions) {
  if (!normalizedEventOptions) {
    return 0;
  }

  // If the browser does not support passive event listeners, the normalized
  // event options will be a boolean.
  if (normalizedEventOptions === true) {
    return 100;
  }

  // At this point, the browser supports passive event listeners, so we expect
  // the event options to be an object with possible properties of capture,
  // passive, and once.
  //
  // We want to consistently return the same value, regardless of the order of
  // these properties, so let's use binary maths to assign each property to a
  // bit, and then add those together (with an offset to account for the
  // booleans at the beginning of this function).
  var capture = normalizedEventOptions.capture << 0;
  var passive = normalizedEventOptions.passive << 1;
  var once = normalizedEventOptions.once << 2;
  return capture + passive + once;
}

function ensureCanMutateNextEventHandlers(eventHandlers) {
  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
    // eslint-disable-next-line no-param-reassign
    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
  }
}

function TargetEventHandlers(target) {
  this.target = target;
  this.events = {};
}

TargetEventHandlers.prototype.getEventHandlers = function () {
  function getEventHandlers(eventName, options) {
    var key = String(eventName) + ' ' + String(eventOptionsKey(options));

    if (!this.events[key]) {
      this.events[key] = {
        handlers: [],
        handleEvent: undefined
      };
      this.events[key].nextHandlers = this.events[key].handlers;
    }

    return this.events[key];
  }

  return getEventHandlers;
}();

TargetEventHandlers.prototype.handleEvent = function () {
  function handleEvent(eventName, options, event) {
    var eventHandlers = this.getEventHandlers(eventName, options);
    eventHandlers.handlers = eventHandlers.nextHandlers;
    eventHandlers.handlers.forEach(function (handler) {
      if (handler) {
        // We need to check for presence here because a handler function may
        // cause later handlers to get removed. This can happen if you for
        // instance have a waypoint that unmounts another waypoint as part of an
        // onEnter/onLeave handler.
        handler(event);
      }
    });
  }

  return handleEvent;
}();

TargetEventHandlers.prototype.add = function () {
  function add(eventName, listener, options) {
    var _this = this;

    // options has already been normalized at this point.
    var eventHandlers = this.getEventHandlers(eventName, options);

    ensureCanMutateNextEventHandlers(eventHandlers);

    if (eventHandlers.nextHandlers.length === 0) {
      eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);

      this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
    }

    eventHandlers.nextHandlers.push(listener);

    var isSubscribed = true;
    var unsubscribe = function () {
      function unsubscribe() {
        if (!isSubscribed) {
          return;
        }

        isSubscribed = false;

        ensureCanMutateNextEventHandlers(eventHandlers);
        var index = eventHandlers.nextHandlers.indexOf(listener);
        eventHandlers.nextHandlers.splice(index, 1);

        if (eventHandlers.nextHandlers.length === 0) {
          // All event handlers have been removed, so we want to remove the event
          // listener from the target node.

          if (_this.target) {
            // There can be a race condition where the target may no longer exist
            // when this function is called, e.g. when a React component is
            // unmounting. Guarding against this prevents the following error:
            //
            //   Cannot read property 'removeEventListener' of undefined
            _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
          }

          eventHandlers.handleEvent = undefined;
        }
      }

      return unsubscribe;
    }();
    return unsubscribe;
  }

  return add;
}();

var EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';

// eslint-disable-next-line import/prefer-default-export
function addEventListener(target, eventName, listener, options) {
  if (!target[EVENT_HANDLERS_KEY]) {
    // eslint-disable-next-line no-param-reassign
    target[EVENT_HANDLERS_KEY] = new TargetEventHandlers(target);
  }
  var normalizedEventOptions = normalizeEventOptions(options);
  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
}




/***/ }),

/***/ "u6DZ":
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__("YpBQ"),
    baseOrderBy = __webpack_require__("eHpp"),
    baseRest = __webpack_require__("R3TX"),
    isIterateeCall = __webpack_require__("R5u7");

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),

/***/ "uGNg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_SELECTED_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SELECT_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectProposal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearSelectedProposal; });
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rJ95");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nv//");
/* harmony import */ var _views_booking_BookingEngine_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("47Eh");




var SELECT_PROPOSAL = 'SELECT_PROPOSAL';
var CLEAR_SELECTED_PROPOSAL = 'CLEAR_SELECTED_PROPOSAL';

function clearSelectedProposal() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(CLEAR_SELECTED_PROPOSAL, {});
}

function selectProposal(proposalId, location, history) {
  var updatedUri = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_2__[/* convertLocationToURI */ "c"])(location).setQuery(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["appQueryParameters"].booking.selectedProposalId, proposalId);
  Object(_views_booking_BookingEngine_utils__WEBPACK_IMPORTED_MODULE_3__[/* navigateInBookingEngine */ "d"])({
    location: updatedUri,
    history: history,
    replace: true
  });
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(SELECT_PROPOSAL, {
    proposalId: proposalId
  });
}



/***/ }),

/***/ "uGjT":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "uRnh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return themes; });
var themes = {
  "default": {
    thRoot: 'cursor-pointer flex items-center font-bold font-sans leading-one no-underline text-sm text-white',
    thIcon: 'rtl:mr-px5',
    thIconWidth: '2.5rem',
    thSText: 'text-base uppercase',
    thCustomText1: 'text-base uppercase'
  },
  black: {
    thRoot: 'flex justify-end items-center font-bold font-sans leading-tight no-underline text-initial text-gray-darker text-md',
    thIcon: 'text-gray-darker mb-px5 sm:mb-0 sm:rtl:mr-px10',
    thIconWidth: '2rem',
    thCustomText2: 'text-booking'
  },
  footerLite: {
    thRoot: 'flex flex-col lg:flex-row items-center text-center lg:text-initial text-blue',
    thIcon: 'lg:flex-shrink-0 mb-px10 lg:mb-0 lg:rtl:mr-px10',
    thIconWidth: '1.5625rem',
    thTexts: 'lg:flex-1 text-gray-darker text-base',
    thCustomText0: 'font-bold text-blue text-md',
    thCustomText1: 'font-bold text-blue text-md'
  },
  contact: {
    thRoot: 'flex flex-col sm:flex-row items-center sm:items-start font-bold font-sans leading-tight no-underline text-center sm:text-initial text-md',
    thIcon: 'text-blue mb-px5 sm:mb-0 sm:rtl:mr-px10',
    thIconWidth: '1.75rem',
    thSText: 'hidden sm:block font-normal text-base text-gray-light'
  },
  contact2: {
    thRoot: 'flex flex-col sm:flex-row items-center sm:items-start font-bold font-sans leading-tight no-underline text-center sm:text-initial text-md',
    thIcon: 'text-blue mb-px5 sm:mb-0 sm:rtl:mr-px10',
    thIconWidth: '3rem',
    thCustomText1: 'font-normal text-base text-gray-light',
    thCustomText2: 'font-normal text-base text-gray-darker'
  },
  smallFooterLite: {
    thRoot: 'cursor-pointer flex flex-col sm:flex-row items-center sm:items-start font-bold font-sans leading-tight no-underline text-center sm:text-initial text-md text-blue',
    thIcon: 'text-blue mb-px5 sm:mb-0 sm:rtl:mr-px10',
    thIconWidth: '1.2rem',
    thSText: 'hidden sm:block font-normal text-base text-gray-darker'
  },
  search: {
    thRoot: 'cursor-pointer items-center font-sans no-underline text-sm text-white'
  }
};

/***/ }),

/***/ "vuE1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("LTtw");
var global = __webpack_require__("HnW7");
var getBuiltIn = __webpack_require__("x90g");
var IS_PURE = __webpack_require__("SRps");
var DESCRIPTORS = __webpack_require__("uGjT");
var NATIVE_SYMBOL = __webpack_require__("wEFx");
var USE_SYMBOL_AS_UID = __webpack_require__("1a7w");
var fails = __webpack_require__("fhLv");
var has = __webpack_require__("DZWw");
var isArray = __webpack_require__("gIGD");
var isObject = __webpack_require__("1YFU");
var anObject = __webpack_require__("ep/x");
var toObject = __webpack_require__("A+R+");
var toIndexedObject = __webpack_require__("dNjr");
var toPrimitive = __webpack_require__("pfAP");
var createPropertyDescriptor = __webpack_require__("OouP");
var nativeObjectCreate = __webpack_require__("Znn2");
var objectKeys = __webpack_require__("X95k");
var getOwnPropertyNamesModule = __webpack_require__("8D46");
var getOwnPropertyNamesExternal = __webpack_require__("Ed3r");
var getOwnPropertySymbolsModule = __webpack_require__("qPLk");
var getOwnPropertyDescriptorModule = __webpack_require__("5h8T");
var definePropertyModule = __webpack_require__("87KK");
var propertyIsEnumerableModule = __webpack_require__("z7Vv");
var createNonEnumerableProperty = __webpack_require__("g51W");
var redefine = __webpack_require__("L1Xj");
var shared = __webpack_require__("8+jV");
var sharedKey = __webpack_require__("mmil");
var hiddenKeys = __webpack_require__("qXr/");
var uid = __webpack_require__("rvZv");
var wellKnownSymbol = __webpack_require__("nJrx");
var wrappedWellKnownSymbolModule = __webpack_require__("9YYj");
var defineWellKnownSymbol = __webpack_require__("oMzG");
var setToStringTag = __webpack_require__("CGO5");
var InternalStateModule = __webpack_require__("9jKB");
var $forEach = __webpack_require__("VrMI").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var isSymbol = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.es/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.es/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.es/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "vv41":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFullPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getOfferNameWithNrrLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPriceCompositionModel; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var accounting__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fCLy");
/* harmony import */ var accounting__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(accounting__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("oL6k");
/* harmony import */ var _utils_resort_resortUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("1qsz");
/* harmony import */ var _utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("L7OA");
/* harmony import */ var _utils_proposal_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("tI+f");
/* harmony import */ var _utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("wz9x");
/* harmony import */ var _components_utils_price_price_util__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("NXDx");
/* harmony import */ var _paid_services_list_paidService_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("VawQ");











var FLEX_RATES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].FLEX_RATES,
    OFFERS = _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].OFFERS;
var getFullPrice = function getFullPrice(price) {
  var symbole = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!Object(lodash__WEBPACK_IMPORTED_MODULE_2__["isNil"])(Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(price, 'value'))) {
    return symbole ? "".concat(symbole, " ").concat(Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(price, 'formattedValue')) : Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(price, 'formattedValue');
  }

  return '';
};

var getAccommodationLabels = function getAccommodationLabels(proposal) {
  var labels = [];
  Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(proposal, 'accommodations', []).map(function (accomm) {
    labels.push(accomm.label);
  });
  return labels.join(' + ');
};

var getJoyviewPackagePricePerAttendee = function getJoyviewPackagePricePerAttendee(_ref) {
  var nbAttendees = _ref.nbAttendees,
      pricePerNightPerAttendee = _ref.pricePerNightPerAttendee,
      context = _ref.context,
      proposal = _ref.proposal;
  var currencyConfig = Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_8__[/* getCurrency */ "c"])(context.locale, Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(pricePerNightPerAttendee, 'currency'));
  var nbNights = proposal.duration;
  var totalPrice = accounting__WEBPACK_IMPORTED_MODULE_1___default.a.formatMoney(nbNights * nbAttendees * Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(pricePerNightPerAttendee, 'value'), currencyConfig);
  return nbAttendees > 0 ? totalPrice : null;
};

var getOfferNameWithNrrLabel = function getOfferNameWithNrrLabel(proposal, i18n) {
  var shouldDisplayOffersDetails = i18n.booking.priceDetails.packagePrice.displayOffersDetails;
  var fallbackOfferName = i18n.booking.priceDetails.packagePrice.reduction;
  var nrrLabel = i18n.booking.priceDetails.packagePrice.nonRefundableRateLabel;
  var price = proposal.price,
      alternativePrice = proposal.alternativePrice;
  var isNrrOfferSelected = price.selectedRate === FLEX_RATES.NRR && alternativePrice;
  var offerName;

  if (shouldDisplayOffersDetails) {
    // Primary discount (NRR & standard) come always first (said by NA team & API team)
    offerName = isNrrOfferSelected ? "".concat( // $FlowFixMe: if it's NRR, it has an alternative price
    alternativePrice.discounts[0].offerName ? // $FlowFixMe
    alternativePrice.discounts[0].offerName : fallbackOfferName, " ").concat(nrrLabel) : price.discounts[0].offerName;
  } else {
    offerName = isNrrOfferSelected ? "".concat( // $FlowFixMe: if it's NRR, it has an alternative price
    alternativePrice.aggregateDiscount.offerName ? // $FlowFixMe
    alternativePrice.aggregateDiscount.offerName : fallbackOfferName, " ").concat(nrrLabel) : price.aggregateDiscount.offerName;
  }

  if (!offerName) {
    return fallbackOfferName;
  }

  return offerName;
};

var groupDiscountsByOfferId = function groupDiscountsByOfferId(proposal, locale) {
  var discounts = proposal.price.discounts.filter(function (_ref2) {
    var offerId = _ref2.offerId;
    return offerId !== OFFERS.PROMO_CODE;
  });
  var result = discounts.reduce(function (groupedOffers, discount) {
    // For NRR offer, the real ID is the one for the first discount on alternative price actually
    var realDiscountOfferId = discount.offerId === FLEX_RATES.NRR && proposal.alternativePrice ? proposal.alternativePrice.discounts[0].offerId : discount.offerId;

    if (groupedOffers[realDiscountOfferId]) {
      var _discount$amount;

      groupedOffers[realDiscountOfferId].amount.value += ((_discount$amount = discount.amount) === null || _discount$amount === void 0 ? void 0 : _discount$amount.value) || 0;
      groupedOffers[realDiscountOfferId].amount.formattedValue = Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_8__[/* formatAmountForLocale */ "b"])(groupedOffers[realDiscountOfferId].amount.value, locale, proposal.price.currency);
    } else {
      groupedOffers[realDiscountOfferId] = discount;
    }

    return groupedOffers;
  }, {}); // $FlowFixMe

  return Object.values(result);
};

var getDiscounts = function getDiscounts(proposal, i18n, context) {
  var shouldDisplayOffersDetails = i18n.booking.priceDetails.packagePrice.displayOffersDetails;
  var _proposal$price = proposal.price,
      aggregateDiscount = _proposal$price.aggregateDiscount,
      hasFlexRates = _proposal$price.hasFlexRates,
      selectedRate = _proposal$price.selectedRate;
  var flexOfferDetails = selectedRate === FLEX_RATES.NRR ? i18n.booking.accommodation.packageContent.nonRefundableRateLegal : i18n.booking.accommodation.packageContent.standardLegal;
  var offersToDisplay = shouldDisplayOffersDetails ?
  /**
   * Sometimes we have the same offer Id multiple times with different amounts
   * It makes no sens to display both, so we need to sum by offer id
   */
  groupDiscountsByOfferId(proposal, context.locale) : [aggregateDiscount];
  return offersToDisplay.map(function (offer, index) {
    var discount = getFullPrice((offer === null || offer === void 0 ? void 0 : offer.amount) || {}, '-');

    if (discount) {
      var offerName = offer.offerName || i18n.booking.priceDetails.packagePrice.reduction;
      return {
        type: _paid_services_list_paidService_constants__WEBPACK_IMPORTED_MODULE_10__[/* PAID_SERVICE */ "a"].DISCOUNT,
        offerName: hasFlexRates && index === 0 // Primary discount (NRR & standard) come always first (said by NA team & API team)
        ? getOfferNameWithNrrLabel(proposal, i18n) : offerName,
        discount: discount,
        details: hasFlexRates && index === 0 ? flexOfferDetails : undefined
      };
    }
  }).filter(Boolean);
};

var getPackagePricePerAttendees = function getPackagePricePerAttendees(_ref3) {
  var i18n = _ref3.i18n,
      proposal = _ref3.proposal,
      packageId = _ref3.packageId,
      context = _ref3.context;
  var allInclusivePackage = Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_4__[/* getPackage */ "k"])(proposal, packageId);
  var nbAdults = Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_4__[/* getAdultsCount */ "d"])(proposal);
  var adultsLabel = nbAdults > 1 ? Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(i18n, 'booking.common.adults') : Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(i18n, 'booking.common.adult');
  var upsellPricePerAdult = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(allInclusivePackage, 'prices.perAdultPerNight');
  var nbChildren = Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_4__[/* getKidsCount */ "j"])(proposal);
  var childrenLabel = nbChildren > 1 ? Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(i18n, 'booking.common.children') : Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(i18n, 'booking.common.child');
  var upsellPricePerKid = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(allInclusivePackage, 'prices.perKidPerNight');
  var attendees = [];
  var parentPrice = getJoyviewPackagePricePerAttendee({
    nbAttendees: nbAdults,
    pricePerNightPerAttendee: upsellPricePerAdult,
    context: context,
    proposal: proposal
  });
  var childrenPrice = getJoyviewPackagePricePerAttendee({
    nbAttendees: nbChildren,
    pricePerNightPerAttendee: upsellPricePerKid,
    context: context,
    proposal: proposal
  });

  if (parentPrice) {
    attendees.push({
      title: "".concat(nbAdults, " ").concat(adultsLabel),
      price: parentPrice
    });
  }

  if (childrenPrice) {
    attendees.push({
      title: "".concat(nbChildren, " ").concat(childrenLabel),
      price: childrenPrice
    });
  }

  return attendees;
};

var getChildcareSubitems = function getChildcareSubitems(i18n, proposal) {
  return proposal.additionalServices.childcares.flatMap(function (_ref4) {
    var pricingInfo = _ref4.pricingInfo,
        productInfo = _ref4.productInfo;
    return pricingInfo.schedules[0].attendees.filter(function (_ref5) {
      var isRented = _ref5.isRented;
      return isRented;
    }).map(function () {
      return {
        title: productInfo.label,
        price: pricingInfo.isIncluded ? i18n.booking.priceDetails.packagePrice.included : getFullPrice(pricingInfo.price, '+'),
        durationDescription: productInfo.durationDescription
      };
    });
  });
};

var getPriceCompositionModel = function getPriceCompositionModel(_ref6) {
  var _find;

  var resort = _ref6.resort,
      i18n = _ref6.i18n,
      proposal = _ref6.proposal,
      context = _ref6.context;
  var price = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(proposal, 'price');
  var isJoyview = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(resort, 'isJoyview');
  var shouldShowReinsuranceSkiPass = Object(_utils_resort_resortUtils__WEBPACK_IMPORTED_MODULE_5__[/* isWinterResort */ "b"])(resort) && Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_6__[/* isFeatureFlipped */ "a"])(context)('booking.reinsuranceSkiPass');
  var shouldShowBestPriceGuaranteed = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(i18n, 'booking.summary.discount.bestRateGuaranteeDisplay');
  var promoCode = getFullPrice(Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(price, 'promoCode.amount'), '-');
  var childcares = getChildcareSubitems(i18n, proposal);
  var includedLabel = i18n.booking.priceDetails.packagePrice.included;
  var priceTransfer = getFullPrice(Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(price, 'transfer'), '+');
  var discounts = getDiscounts(proposal, i18n, context); // ⚠️ the order is important

  return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(shouldShowBestPriceGuaranteed ? [{
    type: _paid_services_list_paidService_constants__WEBPACK_IMPORTED_MODULE_10__[/* PAID_SERVICE */ "a"].BEST_RATE,
    value: Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(i18n, 'booking.summary.discount.bestRateGuarantee')
  }] : []), [{
    type: _paid_services_list_paidService_constants__WEBPACK_IMPORTED_MODULE_10__[/* PAID_SERVICE */ "a"].PACKAGE,
    price: getFullPrice(Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(price, 'initialPrice')),
    accommodationTitle: getAccommodationLabels(proposal)
  }], Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(discounts), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(promoCode ? [{
    type: _paid_services_list_paidService_constants__WEBPACK_IMPORTED_MODULE_10__[/* PAID_SERVICE */ "a"].PROMO_CODE,
    value: promoCode
  }] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(price.fees ? price.fees.map(function (fee) {
    return {
      type: _paid_services_list_paidService_constants__WEBPACK_IMPORTED_MODULE_10__[/* PAID_SERVICE */ "a"].FEES,
      feeType: fee.type,
      price: getFullPrice(Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(fee, 'amount'), '+')
    };
  }) : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(price.donation && price.donation.value > 0 ? [{
    type: _paid_services_list_paidService_constants__WEBPACK_IMPORTED_MODULE_10__[/* PAID_SERVICE */ "a"].DONATION,
    value: getFullPrice({
      value: price.donation.value,
      formattedValue: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_8__[/* formatAmountForLocale */ "b"])(price.donation.value, context.locale, price.currency, {
        precision: 2
      })
    }, '+')
  }] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(price.rental.value ? [{
    type: _paid_services_list_paidService_constants__WEBPACK_IMPORTED_MODULE_10__[/* PAID_SERVICE */ "a"].RENTAL,
    price: getFullPrice(price.rental, '+')
  }] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(price.excursions.value ? [{
    type: _paid_services_list_paidService_constants__WEBPACK_IMPORTED_MODULE_10__[/* PAID_SERVICE */ "a"].EXCURSIONS,
    price: getFullPrice(price.excursions, '+')
  }] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(price.sports.value ? [{
    type: _paid_services_list_paidService_constants__WEBPACK_IMPORTED_MODULE_10__[/* PAID_SERVICE */ "a"].SPORTS,
    price: getFullPrice(price.sports, '+')
  }] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(childcares.length > 0 ? childcares.filter(function (childcare) {
    return childcare.price !== includedLabel;
  }).map(function (childcare) {
    return {
      type: _paid_services_list_paidService_constants__WEBPACK_IMPORTED_MODULE_10__[/* PAID_SERVICE */ "a"].CHILDCARES,
      price: childcare.price,
      title: childcare.title,
      details: childcare.durationDescription || null
    };
  }) : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(priceTransfer && priceTransfer !== includedLabel ? [{
    type: _paid_services_list_paidService_constants__WEBPACK_IMPORTED_MODULE_10__[/* PAID_SERVICE */ "a"].TRANSFER,
    price: priceTransfer,
    details: ((_find = (proposal.additionalServices.transfers || []).find(function (transfer) {
      return transfer.pricingInfo.isFullyRented;
    })) === null || _find === void 0 ? void 0 : _find.productInfo.label) || null
  }] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(proposal.listInsurances ? proposal.listInsurances.map(function (insurance) {
    if (insurance.subscribed) {
      return {
        type: _paid_services_list_paidService_constants__WEBPACK_IMPORTED_MODULE_10__[/* PAID_SERVICE */ "a"].INSURANCE,
        details: insurance.label,
        value: Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(i18n, 'booking.insurance.insuranceLabel'),
        price: getFullPrice(insurance.price, '+')
      };
    }
  }).filter(Boolean) : []), [{
    type: _paid_services_list_paidService_constants__WEBPACK_IMPORTED_MODULE_10__[/* PAID_SERVICE */ "a"].ROOM,
    accommodationTitle: getAccommodationLabels(proposal)
  }], Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(isJoyview && proposal.packageId === _utils_proposal_constants__WEBPACK_IMPORTED_MODULE_7__[/* PACKAGE_ALL_INCLUSIVE */ "f"] ? [{
    type: _paid_services_list_paidService_constants__WEBPACK_IMPORTED_MODULE_10__[/* PAID_SERVICE */ "a"].ALL_INCLUSIVE,
    subItems: getPackagePricePerAttendees({
      i18n: i18n,
      proposal: proposal,
      context: context,
      packageId: _utils_proposal_constants__WEBPACK_IMPORTED_MODULE_7__[/* PACKAGE_ALL_INCLUSIVE */ "f"]
    })
  }] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(proposal.transports ? [{
    type: _paid_services_list_paidService_constants__WEBPACK_IMPORTED_MODULE_10__[/* PAID_SERVICE */ "a"].TRANSPORT,
    transports: proposal.transports
  }, {
    type: _paid_services_list_paidService_constants__WEBPACK_IMPORTED_MODULE_10__[/* PAID_SERVICE */ "a"].TRANSFER,
    price: priceTransfer,
    details: Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(proposal, 'selectedTransfers[0].details.label', null)
  }] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(childcares.length > 0 ? childcares.filter(function (childcare) {
    return childcare.price === includedLabel;
  }).map(function (childcare) {
    return {
      type: _paid_services_list_paidService_constants__WEBPACK_IMPORTED_MODULE_10__[/* PAID_SERVICE */ "a"].CHILDCARES,
      price: childcare.price,
      title: childcare.title,
      details: childcare.durationDescription || null
    };
  }) : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(shouldShowReinsuranceSkiPass ? [{
    type: _paid_services_list_paidService_constants__WEBPACK_IMPORTED_MODULE_10__[/* PAID_SERVICE */ "a"].SKIPASS
  }] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(isJoyview && proposal.packageId === _utils_proposal_constants__WEBPACK_IMPORTED_MODULE_7__[/* PACKAGE_ROOM_ONLY */ "h"] ? [{
    type: _paid_services_list_paidService_constants__WEBPACK_IMPORTED_MODULE_10__[/* PAID_SERVICE */ "a"].BREAKFAST
  }] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(isJoyview && proposal.packageId === _utils_proposal_constants__WEBPACK_IMPORTED_MODULE_7__[/* PACKAGE_FOOD_AND_BEVERAGE */ "g"] ? [{
    type: _paid_services_list_paidService_constants__WEBPACK_IMPORTED_MODULE_10__[/* PAID_SERVICE */ "a"].FFB,
    subItems: getPackagePricePerAttendees({
      i18n: i18n,
      proposal: proposal,
      context: context,
      packageId: _utils_proposal_constants__WEBPACK_IMPORTED_MODULE_7__[/* PACKAGE_FOOD_AND_BEVERAGE */ "g"]
    })
  }] : []), [{
    type: _paid_services_list_paidService_constants__WEBPACK_IMPORTED_MODULE_10__[/* PAID_SERVICE */ "a"].TOTAL_PRICE,
    totalPrice: Object(_components_utils_price_price_util__WEBPACK_IMPORTED_MODULE_9__[/* getTotalPriceWithDonation */ "c"])(proposal.price, context.locale).withDonation.total,
    label: i18n.booking.priceDetails.packagePrice.totalPrice
  }]);
};

/***/ }),

/***/ "wEFx":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__("Y8c0");
var fails = __webpack_require__("fhLv");

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ "wKkN":
/***/ (function(module, exports, __webpack_require__) {

var hiddenKeys = __webpack_require__("qXr/");
var isObject = __webpack_require__("1YFU");
var has = __webpack_require__("DZWw");
var defineProperty = __webpack_require__("87KK").f;
var uid = __webpack_require__("rvZv");
var FREEZING = __webpack_require__("+pJz");

var METADATA = uid('meta');
var id = 0;

// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible = Object.isExtensible || function () {
  return true;
};

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + id++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && meta.REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
  return it;
};

var meta = module.exports = {
  REQUIRED: false,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),

/***/ "wQ38":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRIP_INFORMATION_SET_KIDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRIP_INFORMATION_UPDATE_KID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRIP_INFORMATION_RESET_KIDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_KID_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VALIDATION_STATE_ENUM; });
var TRIP_INFORMATION_SET_KIDS = 'TRIP_INFORMATION_UPDATE_KIDS';
var TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS = 'TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS';
var TRIP_INFORMATION_UPDATE_KID = 'TRIP_INFORMATION_UPDATE_KID';
var TRIP_INFORMATION_RESET_KIDS = 'TRIP_INFORMATION_RESET_KID';
var DEFAULT_KID_VALUE = {
  birthdate: undefined,
  neolid: undefined,
  childcareIncluded: true
};
var VALIDATION_STATE_ENUM = Object.freeze({
  valid: 'IS_VALID',
  invalid: 'IS_INVALID',
  notvalidated: 'NOT_VALIDATED'
});

/***/ }),

/***/ "wRBU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputDatalist_InputDatalist; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /opt/webapp/node_modules/striptags/striptags.js
var striptags = __webpack_require__("47go");
var striptags_default = /*#__PURE__*/__webpack_require__.n(striptags);

// EXTERNAL MODULE: ./src/utils/keyCodes.js
var keyCodes = __webpack_require__("05v4");

// EXTERNAL MODULE: ./src/utils/unique-id/uniqueId.js
var uniqueId = __webpack_require__("m1JM");

// EXTERNAL MODULE: ./src/client/components/utils/form/form.util.js
var form_util = __webpack_require__("1P7A");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/form-control/FormControl.jsx + 1 modules
var FormControl = __webpack_require__("Jcrg");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-text/InputText.themes.js


var themes = {
  "default": function _default(props) {
    return {
      thInput: classnames_default()('reset-input text-md sm:text-base w-full', Object(form_util["a" /* getCursorClass */])(props), {
        'text-white': props.isFilled,
        'text-darker-gray': !props.isFilled,
        'button-medium': props.size === 'medium',
        'button-default': props.size === 'large'
      }),
      thToggler: classnames_default()('reset-button leading-none px-px10 text-base', Object(form_util["a" /* getCursorClass */])(props))
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-text/InputText.jsx








var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }









var InputText_InputText = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(InputText, _Component);

  var _super = _createSuper(InputText);

  function InputText(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputText);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function (e) {
      var _this$props = _this.props,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          _this$props$name = _this$props.name,
          name = _this$props$name === void 0 ? '' : _this$props$name,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? lodash["noop"] : _this$props$onChange;

      if (!isReadOnly && !isLoading) {
        e.persist(); // $FlowFixMe

        var _value = e.target.value;

        _this.setState({
          value: _value
        }, function () {
          return onChange(name, _value);
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onKeyDown", function (e) {
      var _this$props$onKeyDown = _this.props.onKeyDown,
          onKeyDown = _this$props$onKeyDown === void 0 ? lodash["noop"] : _this$props$onKeyDown;
      e.persist();
      onKeyDown(e);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClear", function (e) {
      var _this$props$onClear = _this.props.onClear,
          onClear = _this$props$onClear === void 0 ? lodash["noop"] : _this$props$onClear;

      _this.setState({
        value: ''
      }, function () {
        return onClear(e);
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "toggleType", function () {
      var _this$props2 = _this.props,
          type = _this$props2.type,
          _this$props2$typeTogg = _this$props2.typeToggler,
          typeToggler = _this$props2$typeTogg === void 0 ? {} : _this$props2$typeTogg;

      _this.setState({
        type: _this.state.type !== typeToggler.antiType ? typeToggler.antiType : type
      });
    });

    _this.state = {
      type: props.type || 'text',
      value: props.value || ''
    };
    return _this;
  }

  Object(createClass["a" /* default */])(InputText, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(_ref) {
      var value = _ref.value,
          type = _ref.type;
      this.setState(function (prevState) {
        if (prevState.value !== value || prevState.type !== type) {
          return {
            type: type,
            value: value
          };
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          autoComplete = _this$props3.autoComplete,
          className = _this$props3.className,
          hasClear = _this$props3.hasClear,
          hasTypeToggler = _this$props3.hasTypeToggler,
          hasValidationIcon = _this$props3.hasValidationIcon,
          iconLeft = _this$props3.iconLeft,
          iconRight = _this$props3.iconRight,
          _this$props3$id = _this$props3.id,
          id = _this$props3$id === void 0 ? Object(uniqueId["b" /* generateUniqueId */])([typeof this.props.label === 'string' ? this.props.label : ''], 'InputText_') : _this$props3$id,
          isActive = _this$props3.isActive,
          isDisabled = _this$props3.isDisabled,
          isFilled = _this$props3.isFilled,
          isLoading = _this$props3.isLoading,
          isNotEditable = _this$props3.isNotEditable,
          isReadOnly = _this$props3.isReadOnly,
          isRequired = _this$props3.isRequired,
          label = _this$props3.label,
          maxLength = _this$props3.maxLength,
          minLength = _this$props3.minLength,
          name = _this$props3.name,
          notes = _this$props3.notes,
          onBlur = _this$props3.onBlur,
          onClick = _this$props3.onClick,
          onFocus = _this$props3.onFocus,
          onKeyUp = _this$props3.onKeyUp,
          pattern = _this$props3.pattern,
          placeholder = _this$props3.placeholder,
          size = _this$props3.size,
          _this$props3$theme = _this$props3.theme,
          theme = _this$props3$theme === void 0 ? 'default' : _this$props3$theme,
          _this$props3$typeTogg = _this$props3.typeToggler,
          typeToggler = _this$props3$typeTogg === void 0 ? {} : _this$props3$typeTogg,
          validationState = _this$props3.validationState,
          dataTestId = _this$props3.dataTestId;
      var _this$state = this.state,
          type = _this$state.type,
          value = _this$state.value;
      var hasClearEnabled = Boolean(hasClear && value);
      var hasValue = Boolean(value);

      var _themes$theme = themes[theme](this.props),
          thInput = _themes$theme.thInput,
          thToggler = _themes$theme.thToggler;

      return __jsx(FormControl["a" /* FormControl */], {
        className: className,
        hasClear: hasClearEnabled,
        hasValidationIcon: hasValidationIcon,
        iconLeft: iconLeft,
        iconRight: iconRight,
        id: id,
        isActive: isActive,
        isDisabled: isDisabled,
        isFilled: isFilled && hasValue,
        isLoading: isLoading,
        isReadOnly: isReadOnly,
        isRequired: isRequired,
        label: label,
        notes: notes,
        onClear: this.onClear,
        size: size,
        theme: theme,
        validationState: validationState
      }, __jsx("input", Object(esm_extends["a" /* default */])({
        autoComplete: autoComplete,
        className: thInput,
        disabled: isDisabled,
        "data-testid": dataTestId,
        id: id
      }, Object(lodash["isInteger"])(maxLength) ? {
        maxLength: maxLength
      } : null, Object(lodash["isInteger"])(minLength) ? {
        minLength: minLength
      } : null, name ? {
        name: name
      } : null, {
        onBlur: onBlur,
        onChange: this.onChange,
        onClick: onClick,
        onFocus: onFocus,
        onKeyDown: this.onKeyDown,
        onKeyUp: onKeyUp // $FlowFixMe

      }, pattern ? {
        pattern: pattern
      } : null, placeholder ? {
        placeholder: Object(form_util["b" /* getFormattedLabel */])(placeholder, isRequired)
      } : null, {
        readOnly: Boolean(isReadOnly || isLoading || isNotEditable),
        required: isRequired,
        role: type === 'search' ? 'search' : 'textbox',
        type: type,
        value: value
      })), hasTypeToggler && __jsx("button", {
        className: thToggler,
        disabled: isDisabled,
        onClick: this.toggleType,
        type: "button",
        "data-testid": "InputTextToggler"
      }, __jsx(Icon["a" /* Icon */], {
        name: type === this.props.type ? typeToggler.icon : typeToggler.antiIcon
      })));
    }
  }]);

  return InputText;
}(react["Component"]);

Object(defineProperty["a" /* default */])(InputText_InputText, "defaultProps", {
  autoComplete: 'off',
  size: 'medium',
  theme: 'default',
  type: 'text',
  typeToggler: {
    antiIcon: icons["a" /* ICONS */].CLOSED_EYE_PASSWORD,
    antiType: 'text',
    icon: icons["a" /* ICONS */].EYE_PASSWORD
  }
});
// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/widgets/exclusive-collection-badge/ECBadge.jsx
var ECBadge = __webpack_require__("Itgl");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-datalist/InputDatalist.layouts.jsx
var InputDatalist_layouts_jsx = react_default.a.createElement;





var InputDatalist_layouts_DefaultLayout = function DefaultLayout(_ref) {
  var icon = _ref.icon,
      isActive = _ref.isActive,
      label = _ref.label,
      subLabel1 = _ref.subLabel1,
      subLabel2 = _ref.subLabel2,
      type = _ref.type;

  var _useState = Object(react["useState"])(false),
      hover = _useState[0],
      setHover = _useState[1];

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  if (!label) {
    return null;
  }

  return InputDatalist_layouts_jsx("div", {
    className: classnames_default()('focus:bg-turquoise hover:bg-turquoise cursor-pointer flex items-center overflow-hidden p-px10 focus:text-white hover:text-white transition-colors', {
      'bg-turquoise text-white': isActive
    }),
    onMouseEnter: function onMouseEnter() {
      return isDesktop && setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return isDesktop && setHover(false);
    }
  }, icon ? InputDatalist_layouts_jsx(Icon["a" /* Icon */], {
    className: classnames_default()('flex-shrink-0', {
      'text-blue': !hover && !isActive
    }),
    name: icon,
    width: "1.25rem"
  }) : InputDatalist_layouts_jsx(ECBadge["a" /* ECBadge */], {
    className: "flex-shrink-0",
    height: 30
  }), InputDatalist_layouts_jsx("div", {
    className: "decorator-match flex-1 rtl:ml-px10 text-md"
  }, !!subLabel1 && !!subLabel2 && InputDatalist_layouts_jsx("div", {
    className: classnames_default()('leading-one text-sm', {
      'text-gray-medium': !isActive && !hover,
      'text-current': isActive || hover
    })
  }, !!subLabel1 && InputDatalist_layouts_jsx("span", {
    className: "font-bold uppercase"
  }, subLabel1), !!subLabel1 && !!subLabel2 && InputDatalist_layouts_jsx("span", null, " - "), !!subLabel2 && InputDatalist_layouts_jsx("span", null, subLabel2)), InputDatalist_layouts_jsx("div", {
    className: classnames_default()({
      'font-brand text-md': type === 'resort'
    }) // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: label
    }
  })));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-datalist/InputDatalist.themes.js
var InputDatalist_themes_themes = {
  "default": {
    thRoot: 'relative',
    thDatalist: 'reset-list absolute arrow-up arrow-large arrow-white arrow-bg arrow-bg-blue bg-white border-1 border-blue mt-px20 p-px10 rounded-small shadow-lg top-full w-full z-6'
  },
  pyr: {
    thRoot: 'fixed',
    thDatalist: 'reset-list absolute arrow-up arrow-large arrow-white arrow-bg arrow-bg-blue bg-white border-1 border-blue mt-px20 p-px10 rounded-small shadow-lg top-full w-full z-6'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-datalist/InputDatalist.jsx








var InputDatalist_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function InputDatalist_createSuper(Derived) { var hasNativeReflectConstruct = InputDatalist_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function InputDatalist_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-env browser */








var InputDatalist_InputDatalist = /*#__PURE__*/function (_PureComponent) {
  Object(inherits["a" /* default */])(InputDatalist, _PureComponent);

  var _super = InputDatalist_createSuper(InputDatalist);

  function InputDatalist(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputDatalist);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "dataListElementRef", null);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClickOutside", function (e) {
      var isActive = _this.state.isActive;

      if (!_this.dataListElementRef || !isActive) {
        return;
      }

      var dataListNode = _this.dataListElementRef.current;

      if (!dataListNode || !dataListNode.contains(e.target)) {
        _this.setState({
          isActive: false
        });

        if (_this.props.onClickOutside) {
          _this.props.onClickOutside();
        }
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "openList", function () {
      _this.setState(function (prevState) {
        if (!prevState.isActive) {
          return {
            isActive: true
          };
        }
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onKeyDown", function (e) {
      var _this$props = _this.props,
          _this$props$dataList = _this$props.dataList,
          dataList = _this$props$dataList === void 0 ? [] : _this$props$dataList,
          onClear = _this$props.onClear,
          onKeyDown = _this$props.onKeyDown,
          onValidate = _this$props.onValidate;
      var _this$state = _this.state,
          index = _this$state.index,
          selected = _this$state.selected;

      if (e.keyCode === keyCodes["a" /* ARROW_DOWN */] && index < dataList.length - 1) {
        _this.goToIndex(1);
      } else if (e.keyCode === keyCodes["d" /* ARROW_UP */] && index > 0) {
        _this.goToIndex(-1);
      } else if (e.keyCode === keyCodes["f" /* ENTER */]) {
        var item = dataList[index];

        _this.setState({
          isActive: false
        });

        if (item) {
          _this.onSelect(item);
        } else if (selected === '' && Object(lodash["isFunction"])(onClear)) {
          onClear();
        } else if (Object(lodash["isFunction"])(onValidate)) {
          onValidate();
        }
      }

      if (Object(lodash["isFunction"])(onKeyDown)) {
        onKeyDown(e);
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onFocus", function (e) {
      var onFocus = _this.props.onFocus;

      if (Object(lodash["isFunction"])(onFocus) && !_this.state.isActive) {
        onFocus(e);
      }

      _this.openList();
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function (name, value) {
      _this.setState({
        isActive: true,
        selected: value
      }, function () {
        if (_this.props.onChange) _this.props.onChange(name, value);
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClear", function (e) {
      var _this$props$onClear = _this.props.onClear,
          onClear = _this$props$onClear === void 0 ? lodash["noop"] : _this$props$onClear;

      _this.setState({
        index: -1,
        isActive: false,
        selected: ''
      }, function () {
        return onClear(e);
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClickItem", function (item) {
      return function () {
        return _this.onSelect(item);
      };
    });

    _this.dataListElementRef = /*#__PURE__*/Object(react["createRef"])();
    _this.state = {
      index: -1,
      isActive: false,
      selected: props.value || ''
    };
    return _this;
  }

  Object(createClass["a" /* default */])(InputDatalist, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (true) {
        document.addEventListener('click', this.onClickOutside);
        document.addEventListener('focus', this.onClickOutside);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (true) {
        document.removeEventListener('click', this.onClickOutside);
        document.removeEventListener('focus', this.onClickOutside);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var selected = this.props.value;

      if (!Object(lodash["isUndefined"])(selected) && !prevState.isActive && prevState.selected !== selected) {
        this.setState({
          selected: selected
        });
      }
    }
  }, {
    key: "goToIndex",
    value: function goToIndex(offset) {
      this.setState(function (prevState) {
        var index = prevState.index + offset;
        return {
          index: index
        };
      });
    }
  }, {
    key: "onSelect",
    value: function onSelect(item) {
      var _this$props$onSelect = this.props.onSelect,
          onSelect = _this$props$onSelect === void 0 ? lodash["noop"] : _this$props$onSelect;
      var sanitizedItem = {
        item: item,
        label: striptags_default()(Object(lodash["get"])(item, 'label'))
      };
      this.setState({
        index: -1,
        isActive: false,
        selected: sanitizedItem.label
      });
      onSelect(sanitizedItem);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          dataList = _this$props2.dataList,
          id = _this$props2.id,
          isAnimated = _this$props2.isAnimated,
          isDisabled = _this$props2.isDisabled,
          isLoading = _this$props2.isLoading,
          isReadOnly = _this$props2.isReadOnly,
          itemLayout = _this$props2.itemLayout,
          itemTitle = _this$props2.itemTitle,
          theme = _this$props2.theme;
      var _themes$theme = InputDatalist_themes_themes[theme],
          thDatalist = _themes$theme.thDatalist,
          thRoot = _themes$theme.thRoot;
      var _this$state2 = this.state,
          isActive = _this$state2.isActive,
          selected = _this$state2.selected;
      return InputDatalist_jsx("div", {
        className: thRoot,
        ref: this.dataListElementRef
      }, InputDatalist_jsx(InputText_InputText, Object(esm_extends["a" /* default */])({}, Object(lodash["pick"])(this.props, ['hasClear', 'hasValidationIcon', 'iconLeft', 'iconRight', 'isDisabled', 'isFilled', 'isLoading', 'isReadOnly', 'isRequired', 'label', 'name', 'notes', 'onBlur', 'onClick', 'onKeyUp', 'placeholder', 'size', 'theme', 'validationState']), {
        autoComplete: "off",
        dataTestId: "InputDatalistQuery",
        id: id,
        isActive: isActive && !isReadOnly,
        onChange: this.onChange,
        onClear: this.onClear,
        onFocus: this.onFocus,
        onKeyDown: this.onKeyDown,
        type: "text",
        value: selected
      })), isActive && !isReadOnly && !isDisabled && !isLoading && !!dataList.length && InputDatalist_jsx("ul", {
        className: classnames_default()(thDatalist, {
          fadeIn: isAnimated
        }),
        "data-testid": "InputDatalistList",
        role: "listbox"
      }, !!itemTitle && InputDatalist_jsx("li", {
        className: "decorator-border-bottom-list"
      }, itemTitle), dataList.map(function (item, index) {
        if (!item.label) {
          return null;
        }

        var indexFromState = _this2.state.index;

        var newItem = _objectSpread(_objectSpread({}, item), {}, {
          isActive: index === indexFromState
        });

        var hasCustomLayout = Object(lodash["isFunction"])(itemLayout);
        return InputDatalist_jsx("li", {
          className: "decorator-border-bottom-list",
          "data-testid": item.id,
          key: item.id ? item.id : index,
          onClick: // $FlowFixMe
          _this2.onClickItem(item)
        }, // $FlowFixMe
        hasCustomLayout ? itemLayout(newItem) : InputDatalist_jsx(InputDatalist_layouts_DefaultLayout, newItem));
      })));
    }
  }]);

  return InputDatalist;
}(react["PureComponent"]);

Object(defineProperty["a" /* default */])(InputDatalist_InputDatalist, "defaultProps", {
  dataList: [],
  size: 'medium',
  theme: 'default'
});

/***/ }),

/***/ "whR3":
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__("c72w"),
    copyObject = __webpack_require__("LtXa"),
    createAssigner = __webpack_require__("wpQC"),
    isArrayLike = __webpack_require__("9y2L"),
    isPrototype = __webpack_require__("CbIe"),
    keys = __webpack_require__("BlJA");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),

/***/ "wpQC":
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__("R3TX"),
    isIterateeCall = __webpack_require__("R5u7");

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ "wxLG":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "x90g":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("MaE1");
var global = __webpack_require__("HnW7");

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "xGYs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputNumber_InputNumber; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/utils/unique-id/uniqueId.js
var uniqueId = __webpack_require__("m1JM");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-number/InputNumber.themes.js

var themes = {
  "default": function _default(_ref) {
    var hasColumnLayout = _ref.hasColumnLayout,
        hasValue = _ref.hasValue,
        isDisabled = _ref.isDisabled,
        isReadOnly = _ref.isReadOnly,
        validationState = _ref.validationState;
    return {
      thRoot: hasColumnLayout ? 'flex flex-col text-center' : 'flex items-center justify-between',
      thLabel: classnames_default()('text-base', {
        'rtl:mr-px10': !hasColumnLayout,
        'mb-px5': hasColumnLayout,
        'text-gray-darker': validationState === 'NOT_VALIDATED' && hasValue && !isReadOnly && !isDisabled,
        'text-success': validationState === 'IS_VALID' && hasValue && !isReadOnly && !isDisabled,
        'text-danger': validationState === 'IS_INVALID' && hasValue && !isReadOnly && !isDisabled
      }),
      thNotes: 'text-xs text-gray-medium',
      thInputs: 'flex-shrink-0',
      thInput: classnames_default()('reset-input reset-input-number mx-px5 px-px5 text-center text-base outline-custom', {
        'font-bold': hasValue && !isReadOnly && !isDisabled,
        'text-blue': validationState === 'NOT_VALIDATED' && hasValue && !isReadOnly && !isDisabled,
        'text-success': validationState === 'IS_VALID' && hasValue && !isReadOnly && !isDisabled,
        'text-danger': validationState === 'IS_INVALID' && hasValue && !isReadOnly && !isDisabled
      }),
      thButton: 'reset-button cursor-default bg-gray-light border-gray-light rounded-tiny h-full text-gray-medium transition-colors',
      thButtonEnabled: 'cursor-pointer focus:bg-turquoise hover:bg-turquoise focus:border-turquoise hover:border-turquoise focus:text-white hover:text-white',
      thButtonStyle: {
        height: '1.875rem',
        width: '1.875rem'
      },
      thButtonIconWidth: '0.625rem'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-number/InputNumber.jsx








var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }








var InputNumber_InputNumber = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(InputNumber, _Component);

  var _super = _createSuper(InputNumber);

  function InputNumber(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputNumber);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function (e) {
      var _this$props = _this.props,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          _this$props$name = _this$props.name,
          name = _this$props$name === void 0 ? '' : _this$props$name,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? lodash["noop"] : _this$props$onChange;

      if (!isReadOnly && !isLoading) {
        e.persist(); // $FlowFixMe

        var _value = Number(e.target.value);

        _this.setState({
          value: _value
        }, function () {
          return onChange(name, _value);
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "decrease", function () {
      var _this$props2 = _this.props,
          _this$props2$name = _this$props2.name,
          name = _this$props2$name === void 0 ? '' : _this$props2$name,
          _this$props2$min = _this$props2.min,
          min = _this$props2$min === void 0 ? 0 : _this$props2$min,
          _this$props2$step = _this$props2.step,
          step = _this$props2$step === void 0 ? 1 : _this$props2$step,
          _this$props2$onChange = _this$props2.onChange,
          onChange = _this$props2$onChange === void 0 ? lodash["noop"] : _this$props2$onChange;
      var currentValue = _this.state.value || min;
      var decreasedValue = currentValue - step;
      var nextValue = decreasedValue >= min ? decreasedValue : min;

      _this.setState({
        value: nextValue
      });

      onChange(name, nextValue);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "increase", function () {
      var _this$props3 = _this.props,
          _this$props3$name = _this$props3.name,
          name = _this$props3$name === void 0 ? '' : _this$props3$name,
          _this$props3$min = _this$props3.min,
          min = _this$props3$min === void 0 ? 0 : _this$props3$min,
          _this$props3$max = _this$props3.max,
          max = _this$props3$max === void 0 ? 10 : _this$props3$max,
          _this$props3$step = _this$props3.step,
          step = _this$props3$step === void 0 ? 1 : _this$props3$step,
          _this$props3$onChange = _this$props3.onChange,
          onChange = _this$props3$onChange === void 0 ? lodash["noop"] : _this$props3$onChange;
      var currentValue = _this.state.value || min;
      var increasedValue = currentValue + step;
      var nextValue = increasedValue <= max ? increasedValue : max;

      _this.setState({
        value: nextValue
      });

      onChange(name, nextValue);
    });

    _this.state = {
      value: props.value
    };
    return _this;
  }

  Object(createClass["a" /* default */])(InputNumber, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(_ref) {
      var value = _ref.value;
      this.setState(function (prevState) {
        if (prevState.value !== value) {
          return {
            value: value
          };
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          ariaLabel = _this$props4.ariaLabel,
          autoComplete = _this$props4.autoComplete,
          className = _this$props4.className,
          dataTestId = _this$props4.dataTestId,
          hasColumnLayout = _this$props4.hasColumnLayout,
          _this$props4$id = _this$props4.id,
          id = _this$props4$id === void 0 ? Object(uniqueId["b" /* generateUniqueId */])([typeof this.props.label === 'string' ? this.props.label : ''], 'InputNumber_') : _this$props4$id,
          isDisabled = _this$props4.isDisabled,
          isLoading = _this$props4.isLoading,
          isReadOnly = _this$props4.isReadOnly,
          isRequired = _this$props4.isRequired,
          label = _this$props4.label,
          attendeeType = _this$props4.attendeeType,
          _this$props4$max = _this$props4.max,
          max = _this$props4$max === void 0 ? 10 : _this$props4$max,
          _this$props4$min = _this$props4.min,
          min = _this$props4$min === void 0 ? 1 : _this$props4$min,
          name = _this$props4.name,
          notes = _this$props4.notes,
          onBlur = _this$props4.onBlur,
          onClick = _this$props4.onClick,
          onFocus = _this$props4.onFocus,
          onKeyDown = _this$props4.onKeyDown,
          onKeyUp = _this$props4.onKeyUp,
          placeholder = _this$props4.placeholder,
          step = _this$props4.step,
          theme = _this$props4.theme,
          validationState = _this$props4.validationState;
      var value = this.state.value;
      var hasValue = Boolean(value);
      var decreaseDisabled = isDisabled || isLoading || Number(value) <= min;
      var increaseDisabled = isDisabled || isLoading || Number(value) >= max;

      var _themes$theme = themes[theme]({
        hasColumnLayout: hasColumnLayout,
        hasValue: hasValue,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        validationState: validationState
      }),
          thButton = _themes$theme.thButton,
          thButtonEnabled = _themes$theme.thButtonEnabled,
          thButtonIconWidth = _themes$theme.thButtonIconWidth,
          thButtonStyle = _themes$theme.thButtonStyle,
          thInput = _themes$theme.thInput,
          thInputs = _themes$theme.thInputs,
          thLabel = _themes$theme.thLabel,
          thNotes = _themes$theme.thNotes,
          thRoot = _themes$theme.thRoot;

      return __jsx("div", {
        className: classnames_default()(className, thRoot),
        "data-testid": dataTestId
      }, !!label && __jsx("label", {
        className: thLabel,
        htmlFor: id
      }, label, !!notes && __jsx("div", {
        className: thNotes
      }, notes)), __jsx("div", {
        className: thInputs
      }, !isReadOnly && __jsx("button", {
        className: classnames_default()(thButton, Object(defineProperty["a" /* default */])({}, thButtonEnabled, !decreaseDisabled)),
        disabled: decreaseDisabled,
        onClick: this.decrease,
        style: thButtonStyle,
        type: "button",
        "data-testid": attendeeType ? "".concat(attendeeType, "DecrementButton") : 'DecrementButton'
      }, __jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].MINUS,
        width: thButtonIconWidth
      })), __jsx("input", Object(esm_extends["a" /* default */])({
        "aria-label": ariaLabel,
        autoComplete: autoComplete,
        className: thInput,
        disabled: isDisabled,
        id: id,
        max: max,
        min: min // $FlowFixMe

      }, name ? {
        name: name
      } : null, {
        onBlur: onBlur,
        onChange: this.onChange,
        onClick: onClick,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
      }, placeholder ? {
        placeholder: placeholder
      } : null, {
        readOnly: true,
        required: isRequired,
        step: step,
        style: {
          width: "".concat(max.toString().length + 1, "em"),
          height: '1.875em',
          lineHeight: '1.875em'
        },
        type: "number",
        value: value
      })), !isReadOnly && __jsx("button", {
        className: classnames_default()(thButton, Object(defineProperty["a" /* default */])({}, thButtonEnabled, !increaseDisabled)),
        disabled: increaseDisabled,
        onClick: this.increase,
        style: thButtonStyle,
        type: "button",
        "data-testid": attendeeType ? "".concat(attendeeType, "IncrementButton") : 'IncrementButton'
      }, __jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].PLUS,
        width: thButtonIconWidth
      }))));
    }
  }]);

  return InputNumber;
}(react["Component"]);

Object(defineProperty["a" /* default */])(InputNumber_InputNumber, "defaultProps", {
  autoComplete: 'off',
  max: 10,
  min: 0,
  step: 1,
  theme: 'default',
  validationState: 'NOT_VALIDATED'
});

/***/ }),

/***/ "xGvK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ResortSearchAutoComplete_ResortSearchAutoComplete; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-validator-hoc/validationStates.js
var validationStates = __webpack_require__("45yR");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-datalist/InputDatalist.jsx + 4 modules
var InputDatalist = __webpack_require__("wRBU");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// CONCATENATED MODULE: ./src/client/components/widgets/resort-search-autocomplete/ResortSearchAutoComplete.utils.js


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var MINIMUM_SEARCH_LENGTH = 2;
var mapResortList = Object(lodash["memoize"])(function (resortList) {
  return resortList.map(function (_ref) {
    var id = _ref.id,
        name = _ref.name,
        comfort = _ref.comfort,
        seasonTrad = _ref.seasonTrad,
        destination = _ref.destination,
        offsetSell = _ref.offsetSell,
        openingDates = _ref.openingDates;
    return _objectSpread({
      icon: icons["a" /* ICONS */]["TRIDENT".concat(comfort)],
      id: id,
      label: name + (seasonTrad ? " - ".concat(seasonTrad) : ''),
      subLabel1: destination.country,
      subLabel2: destination.area,
      type: 'resort',
      offsetSell: offsetSell
    }, openingDates && {
      openingDates: openingDates
    });
  });
});
var transformResortList = function transformResortList(resortList, search) {
  if (!search || search.length < MINIMUM_SEARCH_LENGTH) {
    return [];
  }

  var formattedSearch = search.toLowerCase();
  return mapResortList(resortList).filter(function (resort) {
    return resort.label.toLowerCase().includes(formattedSearch) || resort.id.toLowerCase().includes(formattedSearch) || resort.subLabel1.toLowerCase().includes(formattedSearch);
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/resort-search-autocomplete/ResortSearchAutoComplete.jsx





var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






var ResortSearchAutoComplete_ResortSearchAutoComplete = /*#__PURE__*/function (_PureComponent) {
  Object(inherits["a" /* default */])(ResortSearchAutoComplete, _PureComponent);

  var _super = _createSuper(ResortSearchAutoComplete);

  function ResortSearchAutoComplete() {
    Object(classCallCheck["a" /* default */])(this, ResortSearchAutoComplete);

    return _super.apply(this, arguments);
  }

  Object(createClass["a" /* default */])(ResortSearchAutoComplete, [{
    key: "getDataList",
    value: function getDataList() {
      var _this$props = this.props,
          resortList = _this$props.resortList,
          search = _this$props.search,
          onError = _this$props.onError,
          alreadyOnError = _this$props.alreadyOnError;
      var formattedResortList = transformResortList(resortList, search);

      if (formattedResortList.length === 0 && search && search.length >= MINIMUM_SEARCH_LENGTH && onError && !alreadyOnError) {
        onError();
      }

      return formattedResortList;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          autoFocus = _this$props2.autoFocus,
          placeholder = _this$props2.placeholder,
          search = _this$props2.search,
          _onSelect = _this$props2.onSelect,
          _onChange = _this$props2.onChange,
          isValid = _this$props2.isValid,
          onBlur = _this$props2.onBlur,
          inputId = _this$props2.inputId;
      return __jsx(InputDatalist["a" /* InputDatalist */], {
        autoFocus: autoFocus,
        iconLeft: icons["a" /* ICONS */].SEARCH_GLASS,
        dataList: this.getDataList(),
        hasClear: true,
        hasValidationIcon: false,
        isAnimated: true,
        onChange: function onChange(name, value) {
          return _onChange(value);
        },
        onClear: function onClear() {
          return _onChange('');
        },
        onClickOutside: onBlur,
        onSelect: function onSelect(_ref) {
          var item = _ref.item;
          return _onSelect(item);
        },
        placeholder: placeholder,
        size: "large",
        value: search,
        validationState: isValid ? validationStates["b" /* IS_VALID */] : validationStates["c" /* NOT_VALIDATED */] // this id is just for prevent a uniqId to be generated by inputText
        ,
        id: inputId
      });
    }
  }]);

  return ResortSearchAutoComplete;
}(react["PureComponent"]);

/***/ }),

/***/ "xVJP":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "xe/R":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("x90g");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "xfxu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/store/toast/toast.actions.js
var toast_actions = __webpack_require__("7Z8V");

// EXTERNAL MODULE: ./src/client/store/global-loader/globalLoader.action.js
var globalLoader_action = __webpack_require__("R2jv");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/proposals.action.js + 1 modules
var proposals_action = __webpack_require__("AnR0");

// EXTERNAL MODULE: ./src/client/store/booking/selected-proposal-id/selectedProposalId.action.js
var selectedProposalId_action = __webpack_require__("uGNg");

// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/client/store/lead-info/leadInfo.selector.js
var leadInfo_selector = __webpack_require__("8fx4");

// EXTERNAL MODULE: ./src/client/store/cms/cms.actions.js
var cms_actions = __webpack_require__("pP7N");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/components/hoc/errorBoundary/errorBoundary.js
var errorBoundary = __webpack_require__("3B0E");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./src/routes/constants.js
var routes_constants = __webpack_require__("dNxv");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/client/router/withRouter.js
var withRouter = __webpack_require__("MGbB");

// EXTERNAL MODULE: ./logger/logger.js
var logger = __webpack_require__("zytj");

// EXTERNAL MODULE: ./src/utils/context/contextUtils.js
var contextUtils = __webpack_require__("igjW");

// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// EXTERNAL MODULE: ./src/routes/routeBuilder.js
var routeBuilder = __webpack_require__("U2CP");

// EXTERNAL MODULE: ./src/utils/invariant/invariant.js
var invariant = __webpack_require__("UQkB");

// EXTERNAL MODULE: ./src/errors/errors.js + 4 modules
var errors_errors = __webpack_require__("wNDy");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngine.tracking.js
var BookingEngine_tracking = __webpack_require__("Hv+8");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: ./logger/index.js
var logger_0 = __webpack_require__("m0zD");
var logger_default = /*#__PURE__*/__webpack_require__.n(logger_0);

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// CONCATENATED MODULE: ./src/client/components/widgets/proposal-pdf-download-button/ProposalPdfDownloadButton.jsx



var __jsx = react_default.a.createElement;










var downloadBlob = function downloadBlob(_ref) {
  var blob = _ref.blob,
      name = _ref.name;
  var a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = name;
  a.rel = 'noopener';
  a.target = '_blank'; // a.click() doesnt work in Firefox

  a.dispatchEvent(new MouseEvent('click'));
  URL.revokeObjectURL(a.href);
};

var ProposalPdfDownloadButton_useDownloadPdf = function useDownloadPdf(_ref2) {
  var actionGA = _ref2.actionGA,
      i18n = _ref2.i18n,
      product = _ref2.product,
      proposal = _ref2.proposal;
  var dispatch = Object(es["d" /* useDispatch */])();

  var _useContext = Object(react["useContext"])(ReactAppContext["a" /* default */]),
      locale = _useContext.locale;

  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: actionGA,
    categoryGA: 'bookingEngine',
    labelGA: 'CTA_download'
  });

  var downloadPDF = /*#__PURE__*/function () {
    var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var _yield$Promise$all, _yield$Promise$all2, pdf, ProposalPdf, blob;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              dispatch(Object(globalLoader_action["d" /* startLoading */])());
              _context.next = 4;
              return Promise.all([Promise.all(/* import() */[__webpack_require__.e(32), __webpack_require__.e(35), __webpack_require__.e(34), __webpack_require__.e(36), __webpack_require__.e(125)]).then(__webpack_require__.bind(null, "87rY")), Promise.all(/* import() */[__webpack_require__.e(32), __webpack_require__.e(35), __webpack_require__.e(34), __webpack_require__.e(36), __webpack_require__.e(124)]).then(__webpack_require__.bind(null, "y/tW"))]);

            case 4:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = Object(slicedToArray["a" /* default */])(_yield$Promise$all, 2);
              pdf = _yield$Promise$all2[0].pdf;
              ProposalPdf = _yield$Promise$all2[1].ProposalPdf;
              _context.next = 10;
              return pdf(__jsx(ProposalPdf, {
                i18n: i18n,
                proposal: proposal,
                resort: product,
                locale: locale
              })).toBlob();

            case 10:
              blob = _context.sent;
              downloadBlob({
                name: "proposal-".concat(proposal.id),
                blob: blob
              });
              track({});
              _context.next = 18;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](0);
              logger_default.a.error('download error', _context.t0);

            case 18:
              _context.prev = 18;
              dispatch(Object(globalLoader_action["c" /* endLoading */])());
              return _context.finish(18);

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 15, 18, 21]]);
    }));

    return function downloadPDF() {
      return _ref3.apply(this, arguments);
    };
  }();

  return downloadPDF;
};

var ProposalPdfDownloadButton_ProposalPdfDownloadButton = function ProposalPdfDownloadButton(_ref4) {
  var actionGA = _ref4.actionGA,
      i18n = _ref4.i18n,
      product = _ref4.product,
      proposal = _ref4.proposal;
  var downloadPDF = ProposalPdfDownloadButton_useDownloadPdf({
    actionGA: actionGA,
    i18n: i18n,
    product: product,
    proposal: proposal
  });
  return __jsx("button", {
    "data-testid": "pdf-download-button",
    className: "reset-button flex flex-col font-bold items-center mx-px10 text-sm text-turquoise",
    onClick: downloadPDF,
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    className: "h-auto",
    name: icons["a" /* ICONS */].DOWNLOAD,
    width: "1.25rem"
  }), __jsx("span", {
    className: "sr-only md:not-sr-only"
  }, Object(src_i18n["g" /* t */])('seller.downloadPdf.label')));
};
// EXTERNAL MODULE: ./src/client/components/widgets/resort-block-header/ResortBlockHeader.jsx + 1 modules
var ResortBlockHeader = __webpack_require__("bvtl");

// CONCATENATED MODULE: ./src/client/components/widgets/header-lite/HeaderLite.jsx
var HeaderLite_jsx = react_default.a.createElement;










var HeaderLite_HeaderLite = function HeaderLite(_ref) {
  var actions = _ref.actions,
      actionGA = _ref.actionGA,
      i18n = _ref.i18n,
      product = _ref.product,
      proposal = _ref.proposal;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var isJoyview = !!(product === null || product === void 0 ? void 0 : product.isJoyview);

  var goBack = function goBack() {
    return Object(BookingEngine_tracking["c" /* trackNavigation */])(actionGA, 'backResortPage', appContext);
  };

  return HeaderLite_jsx("header", {
    className: "bg-white",
    role: "banner"
  }, HeaderLite_jsx("div", {
    className: "md:flex md:justify-between max-w-site m-auto relative",
    style: {
      height: isDesktop ? 60 : 'auto'
    }
  }, HeaderLite_jsx("div", {
    className: "border-b-1 md:border-b-0 border-gray-light flex items-center py-px10 px-px20 md:rtl:pl-0 relative"
  }, HeaderLite_jsx(ResortBlockHeader["a" /* ResortBlockHeader */], {
    hasBackIcon: true,
    locale: appContext.locale,
    onClick: goBack,
    queryParamsToIgnore: ['proposalIds', 'selectedProposalId'],
    resort: product,
    theme: "headerLite"
  })), HeaderLite_jsx("div", {
    className: "absolute hidden md:block left-1/2 self-center top-1/2 -translate-50"
  }, HeaderLite_jsx(Icon["a" /* Icon */], {
    color: isJoyview ? colors["a" /* COLORS */].WATER_GREEN : colors["a" /* COLORS */].BLUE,
    isNotSquare: true,
    name: isJoyview ? icons["a" /* ICONS */].CLUBMED_JOYVIEW : icons["a" /* ICONS */].CLUBMED,
    width: "9.125rem"
  })), HeaderLite_jsx("div", {
    className: "flex items-center justify-between py-px10 md:py-0 px-px20 md:px-0"
  }, HeaderLite_jsx("p", {
    className: "font-sans font-bold md:px-px20 reset-paragraph text-base truncate"
  }, [Object(src_i18n["g" /* t */])('common.reference'), proposal.id].join(' ')), HeaderLite_jsx("div", {
    className: "md:rtl:border-l-1 border-gray-light flex md:items-center md:px-px10 md:self-stretch"
  }, actions.filter(function (action) {
    return action.display;
  }).map(function (_ref2) {
    var iconName = _ref2.iconName,
        id = _ref2.id,
        label = _ref2.label,
        onClick = _ref2.onClick;
    return HeaderLite_jsx("button", {
      className: "reset-button flex flex-col font-bold items-center mx-px10 text-sm text-turquoise",
      "data-testid": "HeaderLite-action-btn",
      key: id,
      onClick: onClick,
      type: "button"
    }, HeaderLite_jsx(Icon["a" /* Icon */], {
      className: "h-auto",
      name: iconName,
      width: "1.25rem"
    }), HeaderLite_jsx("span", {
      className: "sr-only md:not-sr-only"
    }, label));
  }), ((appContext.isDirectCxo || appContext.isIndirectCxo) && i18n.seller.downloadPdf.displayCxo || appContext.isCmta && i18n.seller.downloadPdf.displayCmta) && HeaderLite_jsx(ProposalPdfDownloadButton_ProposalPdfDownloadButton, {
    actionGA: actionGA,
    i18n: i18n,
    product: product,
    proposal: proposal
  })))));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/next/head.js
var head = __webpack_require__("vpUC");
var head_default = /*#__PURE__*/__webpack_require__.n(head);

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.constants.js
var Portal_constants = __webpack_require__("Yd/I");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.jsx
var Portal = __webpack_require__("3uBn");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-accessible-title/BookingAccessibleTitle.jsx
var BookingAccessibleTitle_jsx = react_default.a.createElement;




var BookingAccessibleTitle_BookingAccessibleTitle = function BookingAccessibleTitle(_ref) {
  var title = _ref.title;
  var titleRef = Object(react["useRef"])(null);
  Object(react["useEffect"])(function () {
    if (titleRef.current) {
      titleRef.current.focus();
    }
  }, [title]);
  return BookingAccessibleTitle_jsx(Portal["a" /* default */], {
    name: Portal_constants["a" /* ACCESSIBLE_TITLE */]
  }, BookingAccessibleTitle_jsx(head_default.a, null, BookingAccessibleTitle_jsx("title", {
    key: "title"
  }, title)), BookingAccessibleTitle_jsx("p", {
    ref: titleRef,
    className: "sr-only",
    tabIndex: "-1"
  }, title));
};
// EXTERNAL MODULE: ./src/client/components/widgets/bottom-navbar-layer/BottomNavbarLayer.jsx + 4 modules
var BottomNavbarLayer = __webpack_require__("Dz6/");

// EXTERNAL MODULE: ./src/client/views/booking/receipt/Receipt.jsx + 15 modules
var Receipt = __webpack_require__("lCzM");

// EXTERNAL MODULE: ./src/client/components/widgets/reserved-services-wrapper/ReservedServicesList.jsx + 3 modules
var ReservedServicesList = __webpack_require__("toM8");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/index.js
var tracking_api = __webpack_require__("d1HQ");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-bottom-navbar/BookingBottomNavbar.tracking.js


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



function BookingBottomNavbar_tracking_trackClickOpenReceipt(actionGA, appContext) {
  tracking_api["b" /* setDataLayer */](_objectSpread(_objectSpread({}, constants["i" /* GA_DEFAULT_PAYLOAD */]), {}, {
    versionBooking: 'responsive',
    categoryGA: 'bookingEngine',
    labelGA: 'openReceipt',
    actionGA: actionGA
  }), appContext);
}
function trackClickEditRentals(actionGA, appContext) {
  tracking_api["b" /* setDataLayer */](_objectSpread(_objectSpread({}, constants["i" /* GA_DEFAULT_PAYLOAD */]), {}, {
    versionBooking: 'responsive',
    categoryGA: 'bookingEngine',
    labelGA: 'openReceipt_editEquipment',
    actionGA: actionGA
  }), appContext);
}
// CONCATENATED MODULE: ./src/client/components/widgets/booking-bottom-navbar/BookingBottomNavbar.jsx
var BookingBottomNavbar_jsx = react_default.a.createElement;













var BookingBottomNavbar_BookingBottomNavbar = function BookingBottomNavbar(_ref) {
  var _i18n$common, _i18n$common2;

  var actionGA = _ref.actionGA,
      continueAction = _ref.continueAction,
      criteriaOpened = _ref.criteriaOpened,
      currentPage = _ref.currentPage,
      editCriteriaMode = _ref.editCriteriaMode,
      hideContinueButton = _ref.hideContinueButton,
      i18n = _ref.i18n,
      isOnLastPage = _ref.isOnLastPage,
      isPriceLoading = _ref.isPriceLoading,
      previousAction = _ref.previousAction,
      price = _ref.price,
      proposal = _ref.proposal,
      resort = _ref.resort,
      toggleEditCriteriaMode = _ref.toggleEditCriteriaMode,
      shouldOpenPanel = _ref.shouldOpenPanel,
      closePanel = _ref.closePanel,
      nextPage = _ref.nextPage,
      previousPage = _ref.previousPage,
      focusedFilterBtn = _ref.focusedFilterBtn,
      focusedModifyBtn = _ref.focusedModifyBtn;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted;

  var _useState = Object(react["useState"])(false),
      shouldCloseAllLayers = _useState[0],
      setShouldCloseAllLayers = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      editCriteriaHasError = _useState2[0],
      setEditCriteriaHasError = _useState2[1];

  var reservedServicesByAttendee = Object(es["e" /* useSelector */])(booking_selector["w" /* getReservedServicesByAttendee */]);
  var layerRef = Object(react["useRef"])();

  if (!isAppMounted) {
    return null;
  }

  return BookingBottomNavbar_jsx(BottomNavbarLayer["a" /* BottomNavbarLayer */], {
    backLabel: !appContext.isCmta ? i18n.common.backNavigation : '',
    closeLabel: i18n.booking.priceDetails.packagePrice.closeReceipt,
    continueAction: continueAction,
    continueLabel: isOnLastPage ? i18n.booking.priceDetails.packagePrice.bookingLabel : i18n.common.continue,
    forwardRef: layerRef,
    hideContinueButton: hideContinueButton,
    isPriceLoading: isPriceLoading,
    nextPage: nextPage,
    onCloseAllLayers: function onCloseAllLayers() {
      return setShouldCloseAllLayers(false);
    },
    openLabel: i18n.booking.priceDetails.packagePrice.openReceipt,
    previousPage: previousPage,
    price: price,
    portalPosition: Portal_constants["c" /* BEFORE_APP */],
    previousAction: previousAction,
    shouldCloseAllLayers: shouldCloseAllLayers,
    showPanel: shouldOpenPanel,
    toggleReceiptPanel: closePanel,
    trackClickOpenReceipt: function trackClickOpenReceipt() {
      BookingBottomNavbar_tracking_trackClickOpenReceipt(actionGA, appContext);
    }
  }, BookingBottomNavbar_jsx(SiteContainer["a" /* SiteContainer */], null, BookingBottomNavbar_jsx(Receipt["a" /* Receipt */], {
    actionGA: actionGA,
    criteriaOpened: criteriaOpened,
    currentPage: currentPage,
    editCriteriaMode: editCriteriaMode,
    focusedFilterBtn: focusedFilterBtn,
    focusedModifyBtn: focusedModifyBtn,
    i18n: i18n,
    isTablet: true,
    notifyParentNoResults: function notifyParentNoResults() {
      return setEditCriteriaHasError(true);
    },
    onEditCriteriaApply: function onEditCriteriaApply() {
      toggleEditCriteriaMode();
      setShouldCloseAllLayers(true);
      closePanel();
    },
    proposal: proposal,
    resort: resort,
    toggleEditCriteriaMode: toggleEditCriteriaMode
  })), reservedServicesByAttendee.length > 0 && !editCriteriaHasError && BookingBottomNavbar_jsx(SiteContainer["a" /* SiteContainer */], {
    size: "small"
  }, BookingBottomNavbar_jsx(Title["a" /* Title */], {
    className: "mb-px10",
    color: colors["a" /* COLORS */].BLUE,
    theme: "title-sans-4"
  }, i18n.booking.activities.myPackage.title), BookingBottomNavbar_jsx(ReservedServicesList["a" /* ReservedServicesList */], {
    currency: proposal.price.currency,
    noEditMode: true,
    reservedServicesByAttendee: reservedServicesByAttendee,
    scrollBackwardLabel: i18n === null || i18n === void 0 ? void 0 : (_i18n$common = i18n.common) === null || _i18n$common === void 0 ? void 0 : _i18n$common.scrollBackward,
    scrollForwardLabel: i18n === null || i18n === void 0 ? void 0 : (_i18n$common2 = i18n.common) === null || _i18n$common2 === void 0 ? void 0 : _i18n$common2.scrollForward
  })));
};
// EXTERNAL MODULE: ./src/client/views/booking/constants.js
var booking_constants = __webpack_require__("taV1");

// EXTERNAL MODULE: ./src/client/components/layouts/footer/footer-contacts/FooterContacts.jsx
var FooterContacts = __webpack_require__("05L9");

// EXTERNAL MODULE: ./src/utils/tracking/footer.js
var footer = __webpack_require__("9sjr");

// EXTERNAL MODULE: ./src/utils/regex/RegexHelper.js
var RegexHelper = __webpack_require__("9BC+");

// EXTERNAL MODULE: ./src/client/components/frameworks/block-link/BlockLink.jsx
var BlockLink = __webpack_require__("Onl6");

// EXTERNAL MODULE: ./src/client/components/frameworks/link/Link.jsx + 1 modules
var Link = __webpack_require__("RZpO");

// CONCATENATED MODULE: ./src/client/components/frameworks/block-with-button/BlockWithButton.tracking.js


function trackClickBlockWithButtonSubmit(actionGA, labelGA, appContext) {
  tracking_api["b" /* setDataLayer */]({
    event: constants["h" /* EVENT_GA */],
    versionBooking: 'responsive',
    categoryGA: 'bookingEngine',
    actionGA: actionGA,
    labelGA: labelGA,
    valueGA: '0',
    nonInteraction: '0'
  }, appContext);
}
// CONCATENATED MODULE: ./src/client/components/frameworks/block-with-button/BlockWithButton.jsx
var BlockWithButton_jsx = react_default.a.createElement;






var BlockWithButton_BlockWithButton = function BlockWithButton(_ref) {
  var actionGA = _ref.actionGA,
      buttonClick = _ref.buttonClick,
      description = _ref.description,
      _ref$iconName = _ref.iconName,
      iconName = _ref$iconName === void 0 ? icons["a" /* ICONS */].OPTION : _ref$iconName,
      labelGA = _ref.labelGA,
      linkLabel = _ref.linkLabel,
      title = _ref.title;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  return BlockWithButton_jsx("div", {
    className: "relative sm:flex sm:m-auto sm:px-px20 sm:py-0 text-center justify-center",
    style: {
      maxWidth: 'calc(800rem / 16)'
    }
  }, BlockWithButton_jsx("div", {
    className: "sm:rtl:pr-px30 sm:rtl:text-right sm:flex-1"
  }, BlockWithButton_jsx(Title["a" /* Title */], {
    className: "m-auto sm:flex-row-reverse sm:justify-between justify-center",
    theme: "title-brand-3"
  }, title), BlockWithButton_jsx("div", {
    className: "inline-block pt-px5 text-base",
    style: {
      maxWidth: 'calc(450rem / 16)'
    }
  }, description)), BlockWithButton_jsx("div", {
    className: "sm:rtl:pl-px30 sm:flex-1 sm:flex sm:items-center"
  }, BlockWithButton_jsx(Link["a" /* Link */], {
    className: "sm:rtl:text-left sm:py-0",
    icon: iconName,
    label: linkLabel,
    onClick: function onClick() {
      trackClickBlockWithButtonSubmit(actionGA, labelGA, appContext);

      if (buttonClick) {
        buttonClick();
      }
    }
  })));
};
// EXTERNAL MODULE: ./src/utils/resort/resortUtils.js
var resortUtils = __webpack_require__("1qsz");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// CONCATENATED MODULE: ./src/client/views/booking/participants/candy-bar/CandyBar.jsx
var CandyBar_jsx = react_default.a.createElement;





var IMAGES = {
  summer: {
    mobile: 'url("https://ns.clubmed.com/it/2019/be/pax/summerMobile.png")',
    desktop: 'url("https://ns.clubmed.com/it/2019/be/pax/summer.png")'
  },
  winter: {
    mobile: 'url("https://ns.clubmed.com/it/2019/be/pax/winterMobile.png")',
    desktop: 'url("https://ns.clubmed.com/it/2019/be/pax/winter.png")'
  }
};
var CandyBar_CandyBar = function CandyBar(_ref) {
  var allInclusive = _ref.allInclusive,
      fidelity = _ref.fidelity,
      spreadPayment = _ref.spreadPayment,
      type = _ref.type;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  return CandyBar_jsx("div", {
    className: "bg-bottom bg-cover bg-no-repeat flex flex-col sm:flex-row font-bold font-sans items-center rounded text-center text-shadow-1 text-white",
    style: {
      backgroundImage: isTablet ? IMAGES[type].desktop : IMAGES[type].mobile,
      height: isTablet ? 'calc(168rem / 16)' : 'calc(572rem / 16)'
    }
  }, CandyBar_jsx("div", {
    className: "flex flex-col sm:flex-row items-center sm:items-end justify-around py-px20 sm:w-7/10"
  }, spreadPayment.number ? CandyBar_jsx("div", {
    className: "py-px15 sm:px-px20 w-2/3 sm:w-auto"
  }, CandyBar_jsx("div", null, CandyBar_jsx("span", {
    className: "font-normal leading-one text-11xl font-brand"
  }, spreadPayment.number), CandyBar_jsx("span", {
    className: "font-normal leading-one text-6xl font-brand"
  }, "\xD7")), CandyBar_jsx("div", {
    className: "w-full"
  }, CandyBar_jsx(TemplateString["a" /* TemplateString */], {
    template: spreadPayment.text,
    values: {
      number: spreadPayment.number
    }
  }))) : null, CandyBar_jsx("div", {
    className: "py-px15 sm:px-px20 relative w-2/3 sm:w-auto"
  }, CandyBar_jsx(Icon["a" /* Icon */], {
    className: "mb-px10",
    isNotSquare: true,
    name: icons["a" /* ICONS */].CLUBMED_GREAT_MEMBERS_WITH_SHADOW,
    width: "6.875rem"
  }), CandyBar_jsx("div", {
    className: "w-full"
  }, fidelity.text)), allInclusive.text ? CandyBar_jsx("div", {
    className: "py-px15 sm:px-px20 w-2/3 sm:w-auto"
  }, CandyBar_jsx(Icon["a" /* Icon */], {
    className: "mb-px10",
    name: icons["a" /* ICONS */].ALL_INCLUSIVE_WITH_SHADOW,
    width: "calc(43rem / 16)"
  }), CandyBar_jsx("div", {
    className: "w-full"
  }, allInclusive.text)) : null));
};
// CONCATENATED MODULE: ./src/client/views/booking/participants/candy-bar/ParticipantsReassurance.jsx
var ParticipantsReassurance_jsx = react_default.a.createElement;



var ParticipantsReassurance_ParticipantsReassurance = function ParticipantsReassurance(_ref) {
  var i18n = _ref.i18n,
      resort = _ref.resort,
      proposal = _ref.proposal;
  return ParticipantsReassurance_jsx(CandyBar_CandyBar, {
    allInclusive: {
      text: (proposal === null || proposal === void 0 ? void 0 : proposal.packageId) === 'RON' ? null : i18n.booking.participants.rassurance.allInclusive
    },
    fidelity: {
      text: i18n.booking.participants.rassurance.fidelity
    },
    spreadPayment: {
      number: i18n.booking.participants.rassurance.paymentHeader,
      text: i18n.booking.participants.rassurance.paymentText
    },
    type: Object(resortUtils["b" /* isWinterResort */])(resort) ? 'winter' : 'summer'
  });
};
// EXTERNAL MODULE: ./src/client/components/widgets/webcallback/WebCallbackBlockLink.jsx
var WebCallbackBlockLink = __webpack_require__("39HS");

// CONCATENATED MODULE: ./src/client/components/widgets/footer-lite/FooterLite.jsx
var FooterLite_jsx = react_default.a.createElement;










var ALLOWED_PAGES = [booking_constants["s" /* PAGES */].ACCOMMODATION, booking_constants["s" /* PAGES */].TRANSPORT, booking_constants["s" /* PAGES */].SERVICES, booking_constants["s" /* PAGES */].ACTIVITIES, booking_constants["s" /* PAGES */].PARTICIPANTS];
var FooterLite_FooterLite = function FooterLite(_ref) {
  var contacts = _ref.contacts,
      currentPage = _ref.currentPage,
      editCriteriaLabels = _ref.editCriteriaLabels,
      i18n = _ref.i18n,
      isEditCriteriaFeatureFlipped = _ref.isEditCriteriaFeatureFlipped,
      proposal = _ref.proposal,
      resort = _ref.resort,
      toggleEditCriterias = _ref.toggleEditCriterias;
  var name = currentPage.name,
      actionGA = currentPage.actionGA;
  var displayEditCriteria = ALLOWED_PAGES.includes(name) && isEditCriteriaFeatureFlipped;
  var isThisPageParticipant = name === booking_constants["s" /* PAGES */].PARTICIPANTS;
  return FooterLite_jsx("footer", {
    className: "FooterLite px-px20 relative",
    "data-testid": "FooterLite",
    role: "contentinfo"
  }, displayEditCriteria && FooterLite_jsx("div", {
    className: "pb-px20 text-center"
  }, FooterLite_jsx(BlockWithButton_BlockWithButton, {
    actionGA: actionGA,
    buttonClick: toggleEditCriterias,
    description: editCriteriaLabels === null || editCriteriaLabels === void 0 ? void 0 : editCriteriaLabels.description,
    iconName: icons["a" /* ICONS */].PEN,
    labelGA: "editCriteria",
    linkLabel: editCriteriaLabels === null || editCriteriaLabels === void 0 ? void 0 : editCriteriaLabels.buttonLabel,
    title: editCriteriaLabels === null || editCriteriaLabels === void 0 ? void 0 : editCriteriaLabels.title,
    type: "submit"
  })), isThisPageParticipant && FooterLite_jsx("div", {
    className: "border-t-1 border-gray-light max-w-site-medium m-auto px-px20 py-px60 relative"
  }, FooterLite_jsx(ParticipantsReassurance_ParticipantsReassurance, {
    i18n: i18n,
    proposal: proposal,
    resort: resort
  })), FooterLite_jsx("div", {
    className: "border-t-1 border-gray-light flex flex-wrap sm:justify-center lg:justify-around max-w-site-medium m-auto pt-px20 md:px-px40"
  }, contacts.filter(function (_ref2) {
    var type = _ref2.type;
    return type !== 'mail';
  }).map(function (_ref3) {
    var type = _ref3.type,
        text = _ref3.text,
        secondaryText = _ref3.secondaryText,
        href = _ref3.href;
    var texts = (text || []).map(function (txt) {
      // the phone number is always written in ltr, even in he-IL (which is rtl)
      return Object(RegexHelper["c" /* isPhoneNumber */])(txt) ? FooterLite_jsx("span", {
        className: "text-gray-darker",
        dir: "ltr"
      }, txt) : txt;
    });
    return (// there can be multiple item of same type
      FooterLite_jsx("div", {
        className: "p-px10 w-1/2 sm:w-1/4",
        key: type + href,
        style: {
          maxWidth: 200
        }
      }, type === FooterContacts["c" /* WEB_CALLBACK_LINK */] && FooterContacts["b" /* WEB_CALLBACK_ENABLED */] ? FooterLite_jsx(WebCallbackBlockLink["a" /* WebCallbackBlockLink */], {
        icon: type,
        texts: texts,
        theme: "footerLite",
        trackingData: {
          actionGA: currentPage.name
        }
      }) : FooterLite_jsx(BlockLink["a" /* BlockLink */], {
        icon: type,
        secondaryTexts: secondaryText,
        texts: texts,
        theme: "footerLite",
        trackingData: {
          actionGA: actionGA,
          categoryGA: 'bookingEngine',
          labelGA: Object(footer["a" /* formatFooterLabelName */])(type),
          versionBooking: 'responsive'
        },
        url: href
      }))
    );
  })));
};
// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/utils/uri/redirectUtils.js
var redirectUtils = __webpack_require__("k9PE");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/Responsive.jsx
var Responsive = __webpack_require__("Gqxm");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/ContactInfoUtils.js + 1 modules
var ContactInfoUtils = __webpack_require__("ZHrn");

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngine.utils.js
var BookingEngine_utils = __webpack_require__("47Eh");

// EXTERNAL MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.jsx + 1 modules
var AsyncLoader = __webpack_require__("4A3Y");

// EXTERNAL MODULE: ./src/client/components/widgets/hero/Hero.jsx + 2 modules
var Hero = __webpack_require__("2B1m");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./src/client/components/frameworks/step-nav/StepNav.themes.js
var themes = function themes(_ref) {
  var color = _ref.color;
  return {
    "default": {
      thRoot: "text-".concat(color),
      thList: 'reset-list flex items-end leading-none text-sm sm:text-md',
      thListItem: 'mx-px5 sm:mx-px10',
      thListButton: 'border-0 border-b-2 border-solid border-transparent leading-none pb-px5 text-current transition-colors',
      thListButtonActive: "border-".concat(color, " text-3xl sm:text-5xl"),
      thListButtonDisabled: 'cursor-default',
      thListButtonVisited: 'text-lg sm:text-2xl',
      thListIconWidth: '0.9em',
      thButtonLabel: 'sr-only',
      thLabels: 'font-brand font-normal leading-one mt-px5 text-base',
      thActiveNumber: 'text-lg sm:text-xl',
      thLabel: 'rtl:ml-px10 text-lg sm:text-xl'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/step-nav/StepNav.jsx

var StepNav_jsx = react_default.a.createElement;





var StepNav_StepNav = function StepNav(_ref) {
  var _ref$activeStep = _ref.activeStep,
      activeStep = _ref$activeStep === void 0 ? 0 : _ref$activeStep,
      _ref$ariaLabel = _ref.ariaLabel,
      ariaLabel = _ref$ariaLabel === void 0 ? 'progress' : _ref$ariaLabel,
      className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref$color,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$lastActiveStep = _ref.lastActiveStep,
      lastActiveStep = _ref$lastActiveStep === void 0 ? 0 : _ref$lastActiveStep,
      _onClick = _ref.onClick,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  if (!items.length) {
    return null;
  }

  var _themes$theme = themes({
    color: color
  })[theme],
      thActiveNumber = _themes$theme.thActiveNumber,
      thButtonLabel = _themes$theme.thButtonLabel,
      thLabel = _themes$theme.thLabel,
      thLabels = _themes$theme.thLabels,
      thList = _themes$theme.thList,
      thListButton = _themes$theme.thListButton,
      thListButtonActive = _themes$theme.thListButtonActive,
      thListButtonDisabled = _themes$theme.thListButtonDisabled,
      thListButtonVisited = _themes$theme.thListButtonVisited,
      thListIconWidth = _themes$theme.thListIconWidth,
      thListItem = _themes$theme.thListItem,
      thRoot = _themes$theme.thRoot;
  return StepNav_jsx("nav", {
    "aria-label": ariaLabel,
    className: classnames_default()(className, thRoot)
  }, StepNav_jsx("ol", {
    className: thList
  }, items.map(function (_ref2, i) {
    var _classnames;

    var iconName = _ref2.iconName,
        id = _ref2.id,
        label = _ref2.label;
    return StepNav_jsx("li", {
      className: thListItem,
      key: id
    }, StepNav_jsx("button", {
      "aria-current": activeStep === i ? 'step' : null,
      className: classnames_default()('reset-button', thListButton, (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, thListButtonActive, activeStep === i), Object(defineProperty["a" /* default */])(_classnames, thListButtonVisited, i <= lastActiveStep && activeStep !== i), Object(defineProperty["a" /* default */])(_classnames, thListButtonDisabled, i > lastActiveStep), _classnames)),
      disabled: i > lastActiveStep,
      onClick: function onClick() {
        return _onClick(i);
      },
      type: "button"
    }, StepNav_jsx(Icon["a" /* Icon */], {
      name: iconName,
      width: thListIconWidth
    }), StepNav_jsx("span", {
      className: thButtonLabel
    }, label)));
  })), StepNav_jsx("p", {
    className: classnames_default()('reset-paragraph', thLabels)
  }, StepNav_jsx("span", {
    className: thActiveNumber
  }, activeStep + 1), "/", items.length, ' ', StepNav_jsx("span", {
    className: thLabel
  }, items[activeStep].label)));
};
// CONCATENATED MODULE: ./src/client/components/widgets/booking-breadcrumb/BookingBreadcrumb.jsx
var BookingBreadcrumb_jsx = react_default.a.createElement;









var BookingBreadcrumb_BookingBreadcrumb = function BookingBreadcrumb(_ref) {
  var activeStep = _ref.activeStep,
      backgroundImageSrc = _ref.backgroundImageSrc,
      className = _ref.className,
      dates = _ref.dates,
      items = _ref.items,
      label = _ref.label,
      lastActiveStep = _ref.lastActiveStep,
      onClickDates = _ref.onClickDates,
      onClickParticipants = _ref.onClickParticipants,
      onClickStep = _ref.onClickStep,
      onClickTransport = _ref.onClickTransport,
      participantsNumber = _ref.participantsNumber,
      transportLabel = _ref.transportLabel;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: items[activeStep].id,
    categoryGA: 'bookingEngine'
  });
  return BookingBreadcrumb_jsx("div", {
    className: "bg-black relative"
  }, BookingBreadcrumb_jsx("div", {
    className: "absolute flex items-center inset-0 overflow-hidden opacity-50"
  }, BookingBreadcrumb_jsx(Hero["a" /* Hero */], {
    className: "flex-1",
    url: backgroundImageSrc
  })), BookingBreadcrumb_jsx(SiteContainer["a" /* SiteContainer */], null, BookingBreadcrumb_jsx("div", {
    className: (className, 'flex flex-col sm:flex-row justify-between py-px10 relative text-white z-1'),
    style: {
      height: isTablet ? 80 : 130
    }
  }, BookingBreadcrumb_jsx(StepNav_StepNav, {
    activeStep: activeStep,
    ariaLabel: label,
    className: "sm:self-end",
    items: items,
    lastActiveStep: lastActiveStep,
    onClick: onClickStep
  }), BookingBreadcrumb_jsx("div", {
    className: "flex justify-between -mx-px10 mb-px20 sm:mb-0 order-first sm:order-last sm:py-px5"
  }, BookingBreadcrumb_jsx("button", {
    className: "border-1 border-solid border-white flex flex-1 sm:flex-none items-center justify-center mx-px10 px-px10 reset-button rounded-tiny text-sm text-white",
    onClick: function onClick() {
      onClickDates();
      track({
        labelGA: 'editCriteriaBreadcrumb_modifyDate'
      });
    },
    style: {
      maxWidth: isTablet ? 'none' : 80,
      minWidth: 80
    },
    type: "button"
  }, BookingBreadcrumb_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].DATE
  }), BookingBreadcrumb_jsx("div", {
    className: "font-bold rtl:ml-px10 underline"
  }, BookingBreadcrumb_jsx("span", {
    className: "block leading-one"
  }, dates.startDate), BookingBreadcrumb_jsx("span", {
    className: "block leading-one"
  }, dates.endDate))), BookingBreadcrumb_jsx("button", {
    className: "border-1 border-solid border-white flex flex-1 sm:flex-none items-center justify-center leading-one mx-px10 px-px10 reset-button rounded-tiny text-sm text-white",
    onClick: function onClick() {
      onClickParticipants();
      track({
        labelGA: 'editCriteriaBreadcrumb_modifyParticipant'
      });
    },
    style: {
      maxWidth: isTablet ? 'none' : 80,
      minWidth: 80
    },
    type: "button"
  }, BookingBreadcrumb_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].USERS
  }), BookingBreadcrumb_jsx("div", {
    className: "font-bold rtl:ml-px10 underline"
  }, participantsNumber)), BookingBreadcrumb_jsx("button", {
    className: "border-1 border-solid border-white flex flex-1 sm:flex-none sm:flex-none items-center justify-center leading-one mx-px10 p-px10 reset-button rounded-tiny text-base text-white",
    onClick: function onClick() {
      onClickTransport();
      track({
        labelGA: 'editCriteriaBreadcrumb_modifyTransport'
      });
    },
    style: {
      maxWidth: isTablet ? 'none' : 80,
      minWidth: 80
    },
    type: "button"
  }, BookingBreadcrumb_jsx(Icon["a" /* Icon */], {
    name: transportLabel ? icons["a" /* ICONS */].TRANSPORT : icons["a" /* ICONS */].NO_TRANSPORT
  }), BookingBreadcrumb_jsx("span", {
    className: "hidden sm:block rtl:ml-px10"
  }, transportLabel || Object(src_i18n["g" /* t */])('booking.priceDetails.packagePrice.noTransport')))))));
};
// CONCATENATED MODULE: ./src/client/views/booking/BookingEngineContext.js
 // $FlowFixMe

var BookingEngineContext = /*#__PURE__*/Object(react["createContext"])(undefined);
// EXTERNAL MODULE: ../domains-service/dist/index.js
var domains_service_dist = __webpack_require__("g/E1");
var domains_service_dist_default = /*#__PURE__*/__webpack_require__.n(domains_service_dist);

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/utils/identifiers/constants.js
var identifiers_constants = __webpack_require__("YZTm");

// EXTERNAL MODULE: ./src/utils/uri/constants.js
var uri_constants = __webpack_require__("Sj1w");

// CONCATENATED MODULE: ./src/client/views/booking/BlockMismatchProposalCountry.jsx

var BlockMismatchProposalCountry_jsx = react_default.a.createElement;













var BlockMismatchProposalCountry_BlockMismatchProposalCountry = function BlockMismatchProposalCountry(_ref) {
  var _URI$addQuery;

  var selectedProposal = _ref.selectedProposal,
      resort = _ref.resort;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  if (!selectedProposal.originalLocale || selectedProposal.originalLocale.split('-')[1] === appContext.country) {
    return null;
  }

  return BlockMismatchProposalCountry_jsx(Modal["a" /* Modal */], {
    ariaLabelledby: identifiers_constants["o" /* ID_MODAL_HEADER__BE__MISMATCH_COUNTRY */],
    ariaLabel: Object(src_i18n["g" /* t */])('booking.participants.mismatchLocalePLE.title'),
    closeLabel: Object(src_i18n["g" /* t */])('common.close'),
    onClose: function onClose() {
      var redirectUrl = new URI_default.a(window.location.href).setQuery({
        locale: selectedProposal.originalLocale
      });

      if (Object(contextUtils["f" /* isStrictlyProductionEnv */])() || Object(contextUtils["g" /* isStrictlyStagingEnv */])()) {
        redirectUrl = redirectUrl.tld(domains_service_dist_default.a.getTldFromLocale(selectedProposal.originalLocale));
      }

      if (appContext.isUserLogged || appContext.isUserQuickLogged) {
        redirectUrl = new URI_default.a(window.location.href).resource(routeBuilder["a" /* buildUrl */]('signout', {}, {
          redirectUri: redirectUrl
        }));
      } // heroku or local env


      window.location.href = redirectUrl.toString();
    }
  }, BlockMismatchProposalCountry_jsx("div", {
    className: "p-px20 text-center"
  }, BlockMismatchProposalCountry_jsx(Title["a" /* Title */], {
    className: "justify-center my-px15",
    hLevel: 1,
    id: identifiers_constants["o" /* ID_MODAL_HEADER__BE__MISMATCH_COUNTRY */],
    theme: "title-brand-2"
  }, Object(src_i18n["g" /* t */])('booking.participants.mismatchLocalePLE.title')), BlockMismatchProposalCountry_jsx("p", {
    className: "reset-paragraph mb-px20"
  }, Object(src_i18n["g" /* t */])('booking.participants.mismatchLocalePLE.label')), BlockMismatchProposalCountry_jsx(Button["a" /* Button */], {
    url: new URI_default.a(resort.href).addQuery((_URI$addQuery = {
      locale: appContext.locale
    }, Object(defineProperty["a" /* default */])(_URI$addQuery, uri_constants["j" /* QUERY_NUMBER_OF_ADULTS */], selectedProposal.adultsCount), Object(defineProperty["a" /* default */])(_URI$addQuery, uri_constants["g" /* QUERY_DURATION */], selectedProposal.duration), Object(defineProperty["a" /* default */])(_URI$addQuery, uri_constants["f" /* QUERY_DEPARTURE_DATE */], selectedProposal.arrivalDate), _URI$addQuery)).removeQuery(dist["appQueryParameters"].booking.selectedProposalId, dist["appQueryParameters"].booking.proposalIds).toString()
  }, Object(src_i18n["g" /* t */])('common.continue'))));
};
// EXTERNAL MODULE: ./src/client/router/useRouter.js
var useRouter = __webpack_require__("7jla");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// CONCATENATED MODULE: ./src/client/views/booking/save-criteria/SaveCriteriaConfirmation.jsx
var SaveCriteriaConfirmation_jsx = react["createElement"];














var SaveCriteriaConfirmation_SaveCriteriaConfirmation = function SaveCriteriaConfirmation(_ref) {
  var i18n = _ref.i18n,
      closeModal = _ref.closeModal,
      newAccount = _ref.newAccount;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location,
      history = _useRouter.history;

  var redirectToPle = function redirectToPle() {
    var builtUrl = routeBuilder["a" /* buildUrl */]('account', {}, Object(lodash["pick"])(location.queryParams, ['locale', 'legacy']));
    var pleUrl = new URI_default.a(builtUrl).toString();
    var newUrl = Object(uriUtils["c" /* convertLocationToURI */])(location).removeQuery(['openSaveConfirmationModal', 'newAccount']); // before redirecting the user into its ple account
    // we need to replace the history in order to get rid of the queryParams
    // so to have clean url if the user click on the back navigation

    Object(BookingEngine_utils["d" /* navigateInBookingEngine */])({
      location: newUrl,
      history: history,
      replace: true
    });
    history.pushRoute(pleUrl);
  };

  var _get = Object(lodash["get"])(i18n, 'booking.saveMyCriteria', {}),
      legalInfo = _get.legalInfo,
      dataProtectionPolicyUrl = _get.dataProtectionPolicyUrl,
      dataProtectionPolicyLabel = _get.dataProtectionPolicyLabel;

  var modalTitle = newAccount ? Object(lodash["get"])(i18n, 'booking.saveMyCriteria.saveConfirmationNewAccount') : Object(lodash["get"])(i18n, 'booking.saveMyCriteria.saveConfirmation');
  return SaveCriteriaConfirmation_jsx(Modal["a" /* Modal */], {
    ariaLabel: modalTitle,
    ariaLabelledby: identifiers_constants["r" /* ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION */],
    closeLabel: Object(lodash["get"])(i18n, 'common.close'),
    onClose: closeModal,
    size: "small"
  }, SaveCriteriaConfirmation_jsx("div", {
    className: "SaveCriteriaLogin--confirmation bg-gray-lighter overflow-hidden"
  }, SaveCriteriaConfirmation_jsx("div", null, SaveCriteriaConfirmation_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CHECK,
    color: colors["a" /* COLORS */].BLUE,
    width: "3rem"
  })), SaveCriteriaConfirmation_jsx("div", {
    className: "SaveCriteria-confirmation",
    id: identifiers_constants["r" /* ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION */]
  }, modalTitle), SaveCriteriaConfirmation_jsx("div", null, SaveCriteriaConfirmation_jsx(Button["a" /* Button */], {
    onClick: closeModal,
    colorBg: colors["a" /* COLORS */].TURQUOISE,
    colorBorder: colors["a" /* COLORS */].TURQUOISE,
    size: "large",
    className: "button--SaveCriteria"
  }, Object(lodash["get"])(i18n, 'booking.saveMyCriteria.continue'))), SaveCriteriaConfirmation_jsx("button", {
    type: "button",
    "data-selector": "SaveCriteria-link",
    className: "reset-button SaveCriteria-link",
    onClick: redirectToPle
  }, SaveCriteriaConfirmation_jsx("span", null, Object(lodash["get"])(i18n, 'booking.saveMyCriteria.accessAccount')), SaveCriteriaConfirmation_jsx(Icon["a" /* Icon */], {
    hasRtl: true,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    width: "1rem"
  })), SaveCriteriaConfirmation_jsx("div", {
    className: "SaveCriteria-popinLegalInfo"
  }, SaveCriteriaConfirmation_jsx("p", {
    className: "reset-paragraph text-center w-full"
  }, legalInfo), SaveCriteriaConfirmation_jsx(DynamicLink["a" /* default */], {
    className: "text-inherit underline",
    url: dataProtectionPolicyUrl
  }, dataProtectionPolicyLabel))));
};
// EXTERNAL MODULE: ./src/utils/ple-utils/index.js + 1 modules
var ple_utils = __webpack_require__("6jSF");

// CONCATENATED MODULE: ./src/client/views/booking/save-criteria/SaveCriteriaLogin.jsx
var SaveCriteriaLogin_jsx = react_default.a.createElement;















function SaveCriteriaLogin(_ref) {
  var closeModal = _ref.closeModal,
      i18n = _ref.i18n,
      handleSaveCriteriaTracking = _ref.handleSaveCriteriaTracking;

  var _useContext = Object(react["useContext"])(ReactAppContext["a" /* default */]),
      locale = _useContext.locale;

  var currentUri = dist["windowWrapper"].getLocation();
  var redirectUri = new URI_default.a(currentUri).addSearch(booking_constants["g" /* BE_SAVE_CRITERIA_QUERY */], 'true').toString();
  var redirectUriSignup = new URI_default.a(currentUri).addSearch(booking_constants["g" /* BE_SAVE_CRITERIA_QUERY */], 'true').addSearch(booking_constants["f" /* BE_SAVE_CRITERIA_NEW_ACCOUNT_QUERY */], 'true').toString();
  return SaveCriteriaLogin_jsx(Modal["a" /* Modal */], {
    ariaLabel: Object(lodash["get"])(i18n, 'account.authentication.newToClubMed'),
    ariaLabelledby: identifiers_constants["s" /* ID_MODAL_HEADER__BE__SAVE_CRITERIA_LOGIN */],
    closeLabel: Object(src_i18n["g" /* t */])('common.close'),
    onClose: closeModal,
    size: "small"
  }, SaveCriteriaLogin_jsx("div", {
    className: "bg-gray-lighter overflow-hidden"
  }, SaveCriteriaLogin_jsx("div", {
    className: "flex items-center px-px10"
  }, SaveCriteriaLogin_jsx(Icon["a" /* Icon */], {
    className: "flex-shrink-0",
    name: icons["a" /* ICONS */].HEART,
    color: colors["a" /* COLORS */].TURQUOISE,
    isNotSquare: true,
    width: "calc(26rem / 16)"
  }), SaveCriteriaLogin_jsx("p", {
    className: "rtl:ml-px10"
  }, Object(lodash["get"])(i18n, 'booking.saveMyCriteria.createAccount'))), SaveCriteriaLogin_jsx("div", {
    className: "bg-white flex flex-col items-center px-px10 py-px40",
    "data-testid": "SaveCriteriaLogin-signin"
  }, SaveCriteriaLogin_jsx(Button["a" /* Button */], {
    target: "_self",
    className: "w-full",
    url: ple_utils["f" /* buildSigninUrl */]({
      redirectUri: redirectUri,
      locale: locale
    }),
    onClick: function onClick() {
      return handleSaveCriteriaTracking(booking_constants["j" /* BE_SIGNIN_CLICK_GA */]);
    },
    colorBg: colors["a" /* COLORS */].TURQUOISE,
    colorBorder: colors["a" /* COLORS */].TURQUOISE,
    dataSelector: "saveCriteriaLogin-member-signIn",
    isExternalLink: true,
    style: {
      maxWidth: 'calc(220rem / 16)'
    }
  }, Object(lodash["get"])(i18n, 'memberSpace.accessButton')), SaveCriteriaLogin_jsx(Button["a" /* Button */], {
    target: "_self",
    className: "mt-px10 w-full",
    iconLeft: {
      name: icons["a" /* ICONS */].FACEBOOK,
      width: '1.5rem'
    },
    url: ple_utils["d" /* buildFacebookConnectUrl */]({
      redirectUri: redirectUri,
      locale: locale
    }),
    onClick: function onClick() {
      return handleSaveCriteriaTracking(booking_constants["b" /* BE_FACEBOOK_CONNECT_CLICK_GA */]);
    },
    colorBg: colors["a" /* COLORS */].TURQUOISE,
    colorBorder: colors["a" /* COLORS */].TURQUOISE,
    dataSelector: "saveCriteriaLogin-member-signIn-facebook",
    isExternalLink: true,
    style: {
      backgroundColor: '#4267b2',
      borderColor: '#4267b2',
      maxWidth: 'calc(220rem / 16)'
    }
  }, Object(lodash["get"])(i18n, 'account.authentication.connectionIncentive.facebookConnectButtonLabel'))), SaveCriteriaLogin_jsx("div", {
    className: "bg-white border-t-1 border-gray-lighter flex flex-col items-center px-px10 py-px25"
  }, SaveCriteriaLogin_jsx(Title["a" /* Title */], {
    theme: "title-sans-4",
    className: "mb-px25",
    color: colors["a" /* COLORS */].BLUE,
    hLevel: 2,
    id: identifiers_constants["s" /* ID_MODAL_HEADER__BE__SAVE_CRITERIA_LOGIN */]
  }, Object(lodash["get"])(i18n, 'account.authentication.newToClubMed')), SaveCriteriaLogin_jsx(Button["a" /* Button */], {
    target: "_self",
    url: ple_utils["h" /* buildSignupUrl */]({
      redirectUri: redirectUriSignup,
      locale: locale
    }),
    onClick: function onClick() {
      return handleSaveCriteriaTracking(booking_constants["k" /* BE_SIGNUP_CLICK_GA */]);
    },
    colorBg: colors["a" /* COLORS */].TURQUOISE,
    colorBorder: colors["a" /* COLORS */].TURQUOISE,
    dataSelector: "saveCriteriaLogin-member-signUp",
    isExternalLink: true,
    style: {
      width: 'calc(266rem / 16)'
    }
  }, Object(lodash["get"])(i18n, 'account.authentication.createAccountLinkLabel')))));
}
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// CONCATENATED MODULE: ./src/client/views/booking/share-context/ShareContext.jsx







var ShareContext_jsx = react["createElement"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }














var ShareContext_ShareContext = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(ShareContext, _React$Component);

  var _super = _createSuper(ShareContext);

  function ShareContext() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ShareContext);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "textInput", /*#__PURE__*/react["createRef"]());

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onCopyLinkClick", function () {
      var _this$props = _this.props,
          i18n = _this$props.i18n,
          displayToastOnContextShare = _this$props.displayToastOnContextShare,
          actionGA = _this$props.actionGA; // $FlowFixMe current should never be undefined

      _this.textInput.current.select();

      document.execCommand('copy');
      Object(BookingEngine_tracking["g" /* trackShareContextDesktopPopin */])(actionGA, _this.context);
      displayToastOnContextShare(Object(lodash["get"])(i18n, 'booking.common.share.linkCopied'));
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleOnNavigatorShareClick", function () {
      if (navigator.share) {
        Object(BookingEngine_tracking["g" /* trackShareContextDesktopPopin */])(_this.props.actionGA, _this.context); // $FlowFixMe

        navigator.share({
          url: dist["windowWrapper"].getLocation()
        }).then(function () {
          _this.props.onToggleModal();
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleMediaLinkClick", function (event) {
      var msg = dist["windowWrapper"].getLocation();
      var media = event.currentTarget.dataset.media;
      Object(BookingEngine_tracking["h" /* trackShareContextMobilePopin */])(_this.props.actionGA, media, _this.context);

      if (media === 'messenger') {
        return window.open("fb-messenger://share/?link=".concat(encodeURIComponent(msg), "&app_id=").concat(config_default.a.get('facebookMessenger.appId')), '_self');
      }

      if (media === 'whatsapp') {
        return window.open("whatsapp://send?text=".concat(encodeURIComponent(msg)), '_self');
      }

      if (media === 'sms') {
        return window.open("sms:?&body=".concat(encodeURIComponent(msg)), '_self');
      }
    });

    return _this;
  }

  Object(createClass["a" /* default */])(ShareContext, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          onToggleModal = _this$props2.onToggleModal,
          i18n = _this$props2.i18n;
      return ShareContext_jsx(Modal["a" /* Modal */], {
        ariaLabel: Object(lodash["get"])(i18n, 'booking.common.share.title'),
        ariaLabelledby: identifiers_constants["t" /* ID_MODAL_HEADER__BE__SHARE_CONTEXT */],
        closeLabel: Object(lodash["get"])(i18n, 'common.close'),
        onClose: onToggleModal,
        size: "small"
      }, ShareContext_jsx("div", {
        className: "bg-gray-lighter overflow-hidden"
      }, ShareContext_jsx("div", {
        className: "flex items-center leading-tight p-px20"
      }, ShareContext_jsx(Icon["a" /* Icon */], {
        color: colors["a" /* COLORS */].BLUE,
        name: icons["a" /* ICONS */].SHARE,
        isNotSquare: true,
        width: "calc(42rem / 16)"
      }), ShareContext_jsx("h1", {
        className: "w-full text-center reset-heading text-blue font-bold font-sans leading-tight text-xl",
        id: identifiers_constants["t" /* ID_MODAL_HEADER__BE__SHARE_CONTEXT */]
      }, Object(lodash["get"])(i18n, 'booking.common.share.title'))), ShareContext_jsx("div", {
        className: "bg-white flex flex-col items-center sm:p-px20"
      }, ShareContext_jsx("input", {
        // ⚠️ this input should not be hidden otherwise the copy func will not work
        style: {
          zIndex: '-1',
          height: 0
        },
        ref: this.textInput,
        value: dist["windowWrapper"].getLocation(),
        readOnly: true,
        "aria-hidden": "true"
      }), this.props.responsive.isTablet ? ShareContext_jsx(react["Fragment"], null, ShareContext_jsx("div", {
        className: "w-9/10"
      }, ShareContext_jsx("p", {
        className: "m-0 text-md"
      }, Object(lodash["get"])(i18n, 'booking.common.share.info')), ShareContext_jsx("p", {
        className: "m-0 text-sm"
      }, Object(lodash["get"])(i18n, 'booking.common.share.copyPaste'))), ShareContext_jsx("div", {
        className: "flex items-center mt-px10 w-9/10",
        "data-testid": "ShareContext-shareLink"
      }, ShareContext_jsx("button", {
        className: "reset-button text-base truncate underline w-full",
        "data-testid": "ShareContext-desktopUrl",
        onClick: this.onCopyLinkClick,
        type: "button"
      }, ShareContext_jsx("span", {
        className: "underline"
      }, dist["windowWrapper"].getLocation())), ShareContext_jsx("button", {
        className: "reset-button cursor-pointer",
        type: "button",
        onClick: this.onCopyLinkClick
      }, ShareContext_jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].SHARE_LINK,
        isNotSquare: true,
        width: "calc(48rem / 16)"
      })))) : ShareContext_jsx("div", {
        className: "flex flex-col w-full",
        "data-testid": "ShareContext-mobileContent"
      }, ShareContext_jsx("div", {
        className: "flex flex-col items-center"
      }, ShareContext_jsx("p", {
        className: "my-px20 text-center text-md"
      }, Object(lodash["get"])(i18n, 'booking.common.share.info')), navigator.share ? ShareContext_jsx("div", {
        className: "mb-px10"
      }, ShareContext_jsx(Button["a" /* Button */], {
        className: "reset-button",
        colorBg: colors["a" /* COLORS */].TURQUOISE,
        colorBorder: colors["a" /* COLORS */].TURQUOISE,
        dataTestId: "ShareContext-shareButton",
        onClick: this.handleOnNavigatorShareClick
      }, Object(lodash["get"])(i18n, 'booking.common.share.label'))) : ShareContext_jsx("div", {
        className: "border-t-1 border-gray-light flex justify-center px-px10 py-px25 w-full"
      }, ShareContext_jsx("button", {
        type: "button",
        className: "reset-button cursor-pointer mx-px10",
        "data-media": "messenger",
        onClick: this.handleMediaLinkClick,
        "data-testid": "ShareContext-messenger"
      }, ShareContext_jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].SHARE_MESSENGER,
        style: {
          color: ' #1984ff'
        },
        width: "calc(48rem / 16)"
      })), ShareContext_jsx("button", {
        type: "button",
        className: "reset-button cursor-pointer mx-px10",
        "data-media": "whatsapp",
        onClick: this.handleMediaLinkClick,
        "data-testid": "ShareContext-whatsapp"
      }, ShareContext_jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].SHARE_WHATSAPP,
        style: {
          color: ' #52cc5d'
        },
        width: "calc(48rem / 16)"
      })), ShareContext_jsx("button", {
        type: "button",
        className: "reset-button cursor-pointer mx-px10",
        "data-media": "sms",
        onClick: this.handleMediaLinkClick,
        "data-testid": "ShareContext-sms"
      }, ShareContext_jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].SHARE_SMS,
        style: {
          color: ' #f69a3f'
        },
        width: "calc(48rem / 16)"
      })), ShareContext_jsx("button", {
        type: "button",
        className: "reset-button cursor-pointer mx-px10",
        onClick: this.onCopyLinkClick
      }, ShareContext_jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].SHARE_LINK,
        width: "calc(48rem / 16)"
      }))))))));
    }
  }]);

  return ShareContext;
}(react["Component"]);

Object(defineProperty["a" /* default */])(ShareContext_ShareContext, "contextType", ReactAppContext["a" /* default */]);

/* harmony default export */ var share_context_ShareContext = (Object(Responsive["a" /* default */])(ShareContext_ShareContext));
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/components/frameworks/countdown/Countdown.jsx + 1 modules
var Countdown = __webpack_require__("mmhe");

// EXTERNAL MODULE: ./src/utils/locale/localeUtils.js
var localeUtils = __webpack_require__("1tzK");

// EXTERNAL MODULE: ./src/client/components/utils/booking/bookingUtils.js
var bookingUtils = __webpack_require__("aWOT");

// EXTERNAL MODULE: ./src/client/components/widgets/overlaid-action-provider/OverlaidActionProvider.jsx
var OverlaidActionProvider = __webpack_require__("mamn");

// CONCATENATED MODULE: ./src/client/views/booking/accommodation/AccommodationView.tracking.js


function AccommodationView_tracking_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function AccommodationView_tracking_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      AccommodationView_tracking_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      AccommodationView_tracking_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var AccommodationView_tracking_trackClickShowMoreRoom = function trackClickShowMoreRoom(_ref) {
  var appContext = _ref.appContext,
      baseProposal = _ref.baseProposal,
      _ref$isTab = _ref.isTab,
      isTab = _ref$isTab === void 0 ? false : _ref$isTab,
      selectedProposal = _ref.selectedProposal;
  var upgradeValue = selectedProposal.price.total.value - baseProposal.price.total.value;
  var categoryId = Object(lodash["get"])(selectedProposal, 'accommodations[0].categoryId');
  var action = "showMeMoreRooms_".concat(constants["q" /* PROPOSAL_CATEGORIES */][categoryId]);
  tracking_api["b" /* setDataLayer */](AccommodationView_tracking_objectSpread(AccommodationView_tracking_objectSpread({}, constants["i" /* GA_DEFAULT_PAYLOAD */]), {}, {
    versionBooking: 'responsive',
    categoryGA: 'bookingEngine',
    actionGA: isTab ? "".concat(action, "_tabButton") : action,
    labelGA: upgradeValue ? upgradeValue : 'included'
  }), appContext);
};
// EXTERNAL MODULE: ./src/client/views/booking/accommodation/AccommodationsTabs.jsx + 3 modules
var AccommodationsTabs = __webpack_require__("FRew");

// EXTERNAL MODULE: ./src/client/views/booking/accommodation/more-rooms/MoreRooms.jsx + 14 modules
var MoreRooms = __webpack_require__("LGTM");

// CONCATENATED MODULE: ./src/client/views/booking/accommodation/AccommodationView.jsx







var AccommodationView_jsx = react["createElement"];

function AccommodationView_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function AccommodationView_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AccommodationView_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AccommodationView_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function AccommodationView_createSuper(Derived) { var hasNativeReflectConstruct = AccommodationView_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function AccommodationView_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
















var ACCOMMODATIONS_LAYER_NAME = 'AdditionalAccommodationsLayer';

var AccommodationView_AccommodationView = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(_AccommodationView, _React$Component);

  var _super = AccommodationView_createSuper(_AccommodationView);

  function _AccommodationView() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, _AccommodationView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      isLoading: false,
      selectedRate: _this.props.selectedProposal.price.selectedRate
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onMoreRoomsClickOpen", function (trackingPayload) {
      return function () {
        _this.props.openLayer(ACCOMMODATIONS_LAYER_NAME);

        AccommodationView_tracking_trackClickShowMoreRoom(trackingPayload);
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onMoreRoomsSelect", function (proposalId) {
      var hasFlexRates = _this.props.selectedProposal.price.hasFlexRates;

      _this.props.closeLayer(!hasFlexRates, proposalId);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "switchOffers", function (offers) {
      _this.setState({
        isLoading: true
      });

      _this.props.switchProposalsOffers(offers, _this.context).finally(function () {
        return _this.setState({
          isLoading: false
        });
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "setSelectedRate", function (rateId) {
      _this.setState({
        selectedRate: rateId
      });
    });

    return _this;
  }

  Object(createClass["a" /* default */])(_AccommodationView, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          closeLayer = _this$props.closeLayer,
          i18n = _this$props.i18n,
          location = _this$props.location,
          proposals = _this$props.proposals,
          renderBottomNavbar = _this$props.renderBottomNavbar,
          resort = _this$props.resort,
          selectedProposal = _this$props.selectedProposal;

      if (Object(lodash["isEmpty"])(Object(proposalUtils["n" /* getResolvedProposals */])(proposals))) {
        return null;
      }

      var buttonProps = {
        label: Object(bookingUtils["b" /* tAlt */])({
          resortKeyPath: 'booking.accommodation.moreRoomsLabel',
          cruiseKeyPath: 'booking.accommodation.moreCabinsLabel',
          resort: resort
        }),
        trackingData: {
          appContext: this.context,
          baseProposal: this.props.proposals[0],
          selectedProposal: this.props.selectedProposal
        }
      };
      var participantCount = Object(lodash["get"])(selectedProposal, 'adultsCount', 0) + Object(lodash["get"])(selectedProposal, 'childrenCount', 0);
      var shouldDisplayMoreRoomsLayer = location.queryParams[dist["appQueryParameters"].openLayer] === ACCOMMODATIONS_LAYER_NAME;
      return selectedProposal ? AccommodationView_jsx(react["Fragment"], null, AccommodationView_jsx(OverlaidActionProvider["a" /* OverlaidActionProvider */], {
        button: {
          label: buttonProps.label,
          onClick: this.onMoreRoomsClickOpen(buttonProps.trackingData)
        },
        dataSelector: "MoreRooms",
        label: Object(lodash["get"])(i18n, 'booking.accommodation.teasingMoreRooms')
      }, AccommodationView_jsx(AccommodationsTabs["a" /* AccommodationsTabs */], {
        button: {
          label: buttonProps.label,
          onClick: this.onMoreRoomsClickOpen(AccommodationView_objectSpread(AccommodationView_objectSpread({}, buttonProps.trackingData), {}, {
            isTab: true
          }))
        },
        proposals: proposals,
        selectedProposal: selectedProposal,
        selectProposal: this.props.selectProposal,
        participantCount: participantCount,
        resort: resort,
        switchOffers: this.switchOffers,
        isLoading: this.state.isLoading,
        selectedRate: this.state.selectedRate,
        setSelectedRate: this.setSelectedRate
      })), shouldDisplayMoreRoomsLayer && AccommodationView_jsx(MoreRooms["a" /* MoreRooms */], {
        onClose: function onClose(proposalId) {
          return closeLayer(false, proposalId);
        } // $FlowFixMe string is compatible with string | AccommodationArrangement
        ,
        onSubmit: this.onMoreRoomsSelect,
        proposal: selectedProposal,
        resort: resort,
        i18n: i18n,
        switchOffers: this.switchOffers
      }), renderBottomNavbar({
        isPriceLoading: this.state.isLoading
      })) : null;
    }
  }]);

  return _AccommodationView;
}(react["Component"]);

Object(defineProperty["a" /* default */])(AccommodationView_AccommodationView, "contextType", ReactAppContext["a" /* default */]);

var mapDispatchToProps = {
  selectProposal: selectedProposalId_action["d" /* selectProposal */],
  switchProposalsOffers: proposals_action["s" /* switchProposalsOffers */]
};
var AccommodationView = Object(withRouter["a" /* withRouter */])(AccommodationView_AccommodationView);
/* harmony default export */ var accommodation_AccommodationView = (Object(es["c" /* connect */])(null, mapDispatchToProps)(AccommodationView));
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: ./src/client/components/widgets/package/alternative-packages/AlternativePackages.jsx
var AlternativePackages = __webpack_require__("De8U");

// EXTERNAL MODULE: ./src/client/components/widgets/childcare/childcare.helper.js
var childcare_helper = __webpack_require__("YVWi");

// EXTERNAL MODULE: ./src/client/components/widgets/childcare/Childcare.jsx + 1 modules
var Childcare = __webpack_require__("BGO8");

// EXTERNAL MODULE: ./src/client/components/widgets/childcare/ChildcareIncludedEquipmentCapsule.jsx
var ChildcareIncludedEquipmentCapsule = __webpack_require__("UnYQ");

// EXTERNAL MODULE: ./src/client/components/widgets/childcare/ChildcareOnDemandEquipmentCapsule.jsx
var ChildcareOnDemandEquipmentCapsule = __webpack_require__("LoHR");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var storeHelper = __webpack_require__("Jsmy");

// CONCATENATED MODULE: ./src/client/views/booking/services/ServicesView.jsx


var ServicesView_jsx = react_default.a.createElement;

function ServicesView_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ServicesView_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ServicesView_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ServicesView_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable clubmed/no-fake-component */















var ServicesView_ServicesView = function ServicesView(_ref) {
  var i18n = _ref.i18n,
      selectedProposal = _ref.selectedProposal,
      resort = _ref.resort,
      renderBottomNavbar = _ref.renderBottomNavbar,
      proposals = _ref.proposals;
  var appContext = react_default.a.useContext(ReactAppContext["a" /* default */]);
  var dispatch = Object(es["d" /* useDispatch */])();

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location,
      history = _useRouter.history;

  var tripInformation = Object(es["e" /* useSelector */])(storeHelper["d" /* tripInformationSelector */]);

  var onAddChildcare = function onAddChildcare(_ref2) {
    var childcareId = _ref2.childcareId,
        attendeeId = _ref2.attendeeId,
        startDate = _ref2.startDate,
        endDate = _ref2.endDate,
        overloadChildcareIdForChalet = _ref2.overloadChildcareIdForChalet;
    return dispatch(Object(proposals_action["b" /* addAdditionalService */])({
      proposalIds: proposals.map(function (_ref3) {
        var id = _ref3.id;
        return id;
      }),
      serviceId: childcareId,
      attendeeIds: attendeeId,
      schedules: [{
        startDate: startDate,
        endDate: endDate
      }],
      overloadForSpecificProposalIds: overloadChildcareIdForChalet,
      appContext: appContext
    }));
  };

  var onDeleteChildcare = function onDeleteChildcare(_ref4) {
    var childcareId = _ref4.childcareId,
        attendeeId = _ref4.attendeeId,
        overloadChildcareIdForChalet = _ref4.overloadChildcareIdForChalet;
    return dispatch(Object(proposals_action["f" /* deleteAdditionalServices */])({
      proposalIds: proposals.map(function (_ref5) {
        var id = _ref5.id;
        return id;
      }),
      serviceIds: [childcareId],
      attendeeIds: attendeeId,
      overloadForSpecificProposalIds: overloadChildcareIdForChalet,
      appContext: appContext
    }));
  };

  var renderJoyView = function renderJoyView() {
    return ServicesView_jsx(AlternativePackages["a" /* AlternativePackages */], {
      selectedProposal: selectedProposal,
      i18n: i18n,
      selectProposal: function selectProposal(proposalId) {
        return dispatch(Object(selectedProposalId_action["d" /* selectProposal */])(proposalId, location, history));
      }
    });
  };

  var renderChildcare = function renderChildcare() {
    var childrenAttendees = Object(lodash["get"])(selectedProposal, 'attendees.children');
    var includedChildrenActivities = resort.childrenActivities.filter(function (activity) {
      return activity.equipments.length > 1;
    });
    var onDemandChildrenActivities = resort.childrenActivities.filter(function (activity) {
      return !activity.isIncluded;
    });
    var shouldShowIncludedEquipments = Object(childcare_helper["h" /* hasChildrenAgedXOrLess */])(childrenAttendees, 6);
    return ServicesView_jsx("div", {
      className: "flex flex-wrap -mx-px10"
    }, ServicesView_jsx("div", {
      className: "p-px10 w-full sm:w-2/3 md:w-3/4"
    }, ServicesView_jsx(Childcare["a" /* Childcare */], {
      childcareAdditionalServices: selectedProposal.additionalServices.childcares,
      proposals: proposals,
      attendees: selectedProposal.attendees.children.map(function (child) {
        var referedChild = Object(childcare_helper["e" /* getCurrentKid */])(tripInformation.kids, child);
        return ServicesView_objectSpread(ServicesView_objectSpread({}, child), {}, {
          lastName: referedChild && referedChild.lastName,
          firstName: referedChild && referedChild.firstName
        });
      }),
      addChildcare: onAddChildcare,
      childrenCount: Object(proposalUtils["j" /* getKidsCount */])(selectedProposal),
      i18n: i18n,
      deleteChildcare: onDeleteChildcare
    })), ServicesView_jsx("div", {
      className: "p-px10 w-full sm:w-1/3 md:w-1/4 sm:order-first"
    }, shouldShowIncludedEquipments && ServicesView_jsx(react["Fragment"], null, ServicesView_jsx(ChildcareIncludedEquipmentCapsule["a" /* ChildcareIncludedEquipmentCapsule */], {
      facilities: [].concat(Object(toConsumableArray["a" /* default */])(includedChildrenActivities), Object(toConsumableArray["a" /* default */])(resort.facilities)),
      i18n: i18n
    }), ServicesView_jsx("br", null)), ServicesView_jsx(ChildcareOnDemandEquipmentCapsule["a" /* ChildcareOnDemandEquipmentCapsule */], {
      activities: onDemandChildrenActivities,
      i18n: i18n
    })));
  };

  return ServicesView_jsx(react["Fragment"], null, resort.isJoyview ? renderJoyView() : renderChildcare(), renderBottomNavbar());
};

/* harmony default export */ var services_ServicesView = (ServicesView_ServicesView);
// EXTERNAL MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js + 115 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: /opt/webapp/node_modules/yup/lib/index.js
var lib = __webpack_require__("luEP");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/FormikInput.jsx + 16 modules
var FormikInput = __webpack_require__("/HC4");

// EXTERNAL MODULE: ./src/client/components/frameworks/capsule/Capsule.jsx + 1 modules
var Capsule = __webpack_require__("jldR");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-feedback/FormFeedback.jsx
var FormFeedback = __webpack_require__("DwNm");

// CONCATENATED MODULE: ./src/client/components/widgets/promo-code/PromoCodeForm.jsx
var PromoCodeForm_jsx = react_default.a.createElement;








var PROMO_CODE_REQUEST_FAILURE = 'failure';
var PROMO_CODE_REQUEST_SUCCESS = 'success';
var PROMO_CODE_MAX_LENGTH = 15;
var PROMO_CODE_VALIDATOR = lib["string"]().min(6).max(PROMO_CODE_MAX_LENGTH).required();
var PromoCodeForm_PromoCodeForm = function PromoCodeForm(_ref) {
  var promoCodeRequestStatus = _ref.promoCodeRequestStatus;

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      isValid = _useFormikContext.isValid,
      setFieldError = _useFormikContext.setFieldError,
      submitForm = _useFormikContext.submitForm,
      values = _useFormikContext.values;

  var isPromoCodeRequestOnError = promoCodeRequestStatus === PROMO_CODE_REQUEST_FAILURE;
  Object(react["useEffect"])(function () {
    if (isPromoCodeRequestOnError) {
      setFieldError('promoCode', 'Request failed');
    }
  }, [isPromoCodeRequestOnError]);
  return PromoCodeForm_jsx(react["Fragment"], null, PromoCodeForm_jsx("div", {
    className: "PromoCode-trigger inline-block"
  }, PromoCodeForm_jsx(FormikInput["a" /* FormikInput */], {
    name: "isUnfolded",
    type: "checkbox",
    label: Object(src_i18n["g" /* t */])('booking.priceDetails.promoCode.triggerText')
  })), values.isUnfolded && PromoCodeForm_jsx("div", {
    className: "mt-px10"
  }, PromoCodeForm_jsx("div", {
    "data-selector": "PromoCode-inputContainer",
    style: {
      maxWidth: 300
    }
  }, PromoCodeForm_jsx(FormikInput["a" /* FormikInput */], {
    hideErrorMessage: true,
    label: Object(src_i18n["g" /* t */])('booking.priceDetails.promoCode.label'),
    maxLength: PROMO_CODE_MAX_LENGTH,
    name: "promoCode",
    type: "text",
    validate: PROMO_CODE_VALIDATOR
  })), promoCodeRequestStatus !== null && PromoCodeForm_jsx(FormFeedback["a" /* FormFeedback */], {
    message: Object(src_i18n["g" /* t */])(isPromoCodeRequestOnError ? 'booking.priceDetails.promoCode.error' : 'booking.priceDetails.promoCode.success'),
    isError: isPromoCodeRequestOnError
  }), PromoCodeForm_jsx(Button["a" /* Button */], {
    className: "mt-px10",
    colorBg: colors["a" /* COLORS */].BOOKING,
    colorBoder: colors["a" /* COLORS */].BOOKING,
    onClick: submitForm,
    isDisabled: !isValid,
    dataTestId: "promoCode-submit"
  }, Object(src_i18n["g" /* t */])('booking.priceDetails.promoCode.apply'))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/promo-code/PromoCode.jsx
var PromoCode_jsx = react_default.a.createElement;












var CODE_CIEL = 'CMCOLL';
var CIEL_VALIDATOR = lib["string"]().required();
var PromoCode_PromoCode = function PromoCode(_ref) {
  var applyPromoCode = _ref.applyPromoCode,
      promoCodeRequestStatus = _ref.promoCodeRequestStatus,
      customerId = _ref.customerId;

  var _useState = Object(react["useState"])(false),
      codeCiel = _useState[0],
      setCodeCiel = _useState[1];

  return PromoCode_jsx("div", null, PromoCode_jsx(Title["a" /* Title */], {
    className: "mb-px10",
    color: colors["a" /* COLORS */].BLUE,
    theme: "title-sans-4"
  }, Object(src_i18n["g" /* t */])('booking.priceDetails.promoCode.title')), PromoCode_jsx(Capsule["a" /* Capsule */], null, PromoCode_jsx("div", {
    className: "p-px20"
  }, PromoCode_jsx(formik_esm["d" /* Formik */], {
    initialValues: {
      isUnfolded: false,
      promoCode: null
    },
    onSubmit: function onSubmit(_ref2) {
      var promoCode = _ref2.promoCode;

      if (promoCode.toUpperCase() === CODE_CIEL) {
        return setCodeCiel(promoCode);
      }

      applyPromoCode({
        promoCode: promoCode,
        customerId: customerId
      });
    }
  }, PromoCode_jsx(PromoCodeForm_PromoCodeForm, {
    promoCodeRequestStatus: promoCodeRequestStatus
  })))), codeCiel && PromoCode_jsx(Modal["a" /* Modal */], {
    ariaLabel: Object(src_i18n["g" /* t */])('booking.summary.cielPopIn.title'),
    ariaLabelledby: identifiers_constants["q" /* ID_MODAL_HEADER__BE__PROMO_CODE */],
    closeLabel: Object(src_i18n["g" /* t */])('common.close'),
    onClose: function onClose() {
      return setCodeCiel(false);
    },
    size: "small"
  }, PromoCode_jsx(formik_esm["d" /* Formik */], {
    initialValues: {
      partnerId: null,
      accessCode: null
    },
    onSubmit: function onSubmit(_ref3) {
      var partnerId = _ref3.partnerId,
          accessCode = _ref3.accessCode;
      applyPromoCode({
        partnerId: partnerId,
        accessCode: accessCode,
        promoCode: codeCiel,
        customerId: customerId
      });
      setCodeCiel(false);
    }
  }, function (formik) {
    return PromoCode_jsx("div", {
      className: "p-px20",
      "data-testid": "promoCodeCielPopIn"
    }, PromoCode_jsx("div", {
      className: "mb-px20 font-bold",
      id: identifiers_constants["q" /* ID_MODAL_HEADER__BE__PROMO_CODE */]
    }, Object(src_i18n["g" /* t */])('booking.summary.cielPopIn.title')), PromoCode_jsx("div", null, PromoCode_jsx(FormikInput["a" /* FormikInput */], {
      type: "text",
      name: "partnerId",
      label: Object(src_i18n["g" /* t */])('booking.summary.cielPopIn.collectivityID'),
      validate: CIEL_VALIDATOR
    })), PromoCode_jsx("div", {
      className: "mt-px10"
    }, PromoCode_jsx(FormikInput["a" /* FormikInput */], {
      type: "text",
      name: "accessCode",
      label: Object(src_i18n["g" /* t */])('booking.summary.cielPopIn.password'),
      validate: CIEL_VALIDATOR
    })), PromoCode_jsx(Button["a" /* Button */], {
      className: "mt-px20",
      colorBg: colors["a" /* COLORS */].BOOKING,
      colorBoder: colors["a" /* COLORS */].BOOKING,
      onClick: formik.submitForm,
      isDisabled: !formik.isValid,
      dataTestId: "promoCode-ciel-submit"
    }, Object(src_i18n["g" /* t */])('booking.common.validate')), PromoCode_jsx("div", {
      className: "mt-px15 text-base"
    }, Object(src_i18n["g" /* t */])('booking.summary.cielPopIn.legalInfo')));
  })));
};
// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: ./src/utils/status-code/statusCode.constants.js
var statusCode_constants = __webpack_require__("PSHn");

// CONCATENATED MODULE: ./src/client/views/booking/summary/insurance/insurance.constantes.js
var ADD_INSURANCE = 'addInsurance';
var DELETE_INSURANCE = 'deleteInsurance';
var INVALID_INSURANCE = 'invalidInsurance';
// EXTERNAL MODULE: ./src/client/components/frameworks/toast/Toast.jsx
var Toast = __webpack_require__("0x7Y");

// CONCATENATED MODULE: ./src/client/views/booking/summary/insurance/InsuranceBody.jsx

var InsuranceBody_jsx = react_default.a.createElement;






var FormatedClause = function FormatedClause(_ref) {
  var clause = _ref.clause;
  var clauseParts = clause.split(':');

  if (clauseParts && clauseParts.length === 2) {
    return InsuranceBody_jsx("p", {
      className: "inline"
    }, InsuranceBody_jsx("span", {
      className: "font-bold"
    }, clauseParts[0], " :"), clauseParts[1]);
  }

  return InsuranceBody_jsx("span", null, clause);
};

var InsuranceBody_FormatedPriceWithLabel = function FormatedPriceWithLabel(_ref2) {
  var price = _ref2.price;
  var priceWithLabel = Object(src_i18n["g" /* t */])('booking.insurance.unitPerTrip', {
    amount: price.formattedValue
  });

  var _priceWithLabel$split = priceWithLabel.split('/'),
      _priceWithLabel$split2 = Object(slicedToArray["a" /* default */])(_priceWithLabel$split, 2),
      formatedPrice = _priceWithLabel$split2[0],
      label = _priceWithLabel$split2[1];

  return InsuranceBody_jsx(react["Fragment"], null, InsuranceBody_jsx("span", {
    className: "text-xl font-bold"
  }, formatedPrice), "/ ", label);
};

function InsuranceBody(_ref3) {
  var company = _ref3.company,
      coverageDescriptions = _ref3.coverageDescriptions,
      label = _ref3.label,
      price = _ref3.price,
      shortDescription = _ref3.shortDescription;
  return InsuranceBody_jsx("div", {
    className: "sm:flex px-px20 mt-px30"
  }, InsuranceBody_jsx("div", {
    className: "max-w-sm rtl:mr-px20"
  }, InsuranceBody_jsx("div", {
    className: "font-brand flex"
  }, InsuranceBody_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].INSURANCE,
    width: "1.8rem",
    color: "blue",
    className: "rtl:mr-px10"
  }), InsuranceBody_jsx("span", {
    className: "text-xl text-blue"
  }, label)), InsuranceBody_jsx("p", {
    className: "font-bold text-md"
  }, shortDescription), InsuranceBody_jsx("ul", {
    className: "list-none rtl:pl-0"
  }, coverageDescriptions.map(function (clause) {
    return InsuranceBody_jsx("li", {
      className: "mb-px10 leading-tight text-base",
      key: clause
    }, InsuranceBody_jsx(Icon["a" /* Icon */], {
      name: icons["a" /* ICONS */].STRAIGHT_CHECK,
      className: "rtl:mr-px10 pt-px5",
      color: colors["a" /* COLORS */].WATER_GREEN
    }), InsuranceBody_jsx(FormatedClause, {
      clause: clause
    }));
  }))), InsuranceBody_jsx("div", {
    className: "flex flex-col-reverse sm:flex-col justify-start items-center rtl:mr-px20"
  }, InsuranceBody_jsx("div", null, company ? InsuranceBody_jsx("img", {
    src: company.logo,
    alt: company.label
  }) : null), InsuranceBody_jsx("div", {
    style: {
      width: '15rem',
      height: '7.5rem'
    },
    className: "mt-px30 mb-px20 bg-skyBlue flex justify-center items-center rounded-tiny px-px20 py-px25"
  }, InsuranceBody_jsx("p", {
    className: "text-blue text-center text-md"
  }, InsuranceBody_jsx(InsuranceBody_FormatedPriceWithLabel, {
    price: price
  }), InsuranceBody_jsx("span", {
    className: "block font-bold"
  }, Object(src_i18n["g" /* t */])('booking.insurance.coverageModality'))))));
}
// EXTERNAL MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx + 1 modules
var TextLink = __webpack_require__("jD8k");

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/constants.js
var proposals_constants = __webpack_require__("UIAR");

// CONCATENATED MODULE: ./src/client/views/booking/summary/insurance/InsuranceCTA.jsx
var InsuranceCTA_jsx = react_default.a.createElement;















var InsuranceCTA_FormatedInformationAndTerms = function FormatedInformationAndTerms(_ref) {
  var attachedDocuments = _ref.attachedDocuments,
      isChecked = _ref.isChecked;
  return InsuranceCTA_jsx(react["Fragment"], null, InsuranceCTA_jsx("span", {
    className: classnames_default()({
      'text-danger': !isChecked
    }, {
      'text-gray': isChecked
    })
  }, Object(src_i18n["g" /* t */])('booking.insurance.termsAndCondition')), ":", attachedDocuments.map(function (_ref2) {
    var label = _ref2.label,
        url = _ref2.url;
    return InsuranceCTA_jsx(TextLink["a" /* TextLink */], {
      theme: "simple",
      color: isChecked ? colors["a" /* COLORS */].GRAY : colors["a" /* COLORS */].RED,
      className: "rtl:pl-px5",
      iconRightName: null,
      key: label,
      label: label,
      url: url
    });
  }));
};

function InsuranceCTA(_ref3) {
  var attachedDocuments = _ref3.attachedDocuments,
      id = _ref3.id,
      insurance = _ref3.insurance,
      isInsuranceTermsChecked = _ref3.isInsuranceTermsChecked,
      isLoading = _ref3.isLoading,
      isNoInsuranceSelected = _ref3.isNoInsuranceSelected,
      isNoThanksChecked = _ref3.isNoThanksChecked,
      onChange = _ref3.onChange,
      setIsInsuranceAddedVisible = _ref3.setIsInsuranceAddedVisible,
      setIsNoInsuranceSelected = _ref3.setIsNoInsuranceSelected,
      toggleInsuranceTerms = _ref3.toggleInsuranceTerms;

  var _useSelector = Object(es["e" /* useSelector */])(booking_selector["q" /* getInsuranceStatus */]),
      isAdded = _useSelector.isAdded,
      isDeleted = _useSelector.isDeleted;

  var dispatch = Object(es["d" /* useDispatch */])();

  var noThanksAction = function noThanksAction() {
    if (!isDeleted) {
      onChange(id, DELETE_INSURANCE, insurance);
    }
  };

  var addInsuranceAction = function addInsuranceAction() {
    if (!isAdded && !insurance.subscribed) {
      onChange(id, ADD_INSURANCE);
    }
  };

  Object(react["useEffect"])(function () {
    setIsInsuranceAddedVisible(isAdded);
    setIsNoInsuranceSelected(isDeleted);
  }, [isAdded, isDeleted]);
  Object(react["useEffect"])(function () {
    if (insurance.subscribed) {
      dispatch(Object(createAction["b" /* default */])(proposals_constants["n" /* INSURANCE_ADDED */]));
    }
  }, [insurance.subscribed]);
  return InsuranceCTA_jsx("div", {
    className: "flex justify-center items-center"
  }, InsuranceCTA_jsx("div", {
    className: "content mx-px20"
  }, InsuranceCTA_jsx(Title["a" /* Title */], {
    color: colors["a" /* COLORS */].BLUE,
    theme: "title-sans-4",
    className: "mb-px15 text-center"
  }, Object(src_i18n["g" /* t */])('booking.insurance.europAssistanceContent')), InsuranceCTA_jsx("div", {
    className: "flex justify-center items-center mb-px20 flex-col sm:flex-row"
  }, InsuranceCTA_jsx(Button["a" /* Button */], {
    dataTestId: "insurance-delete-button",
    className: "mb-px10 w-full sm:mb-0 sm:w-auto sm:rtl:mr-px10",
    size: "small",
    color: isNoInsuranceSelected ? colors["a" /* COLORS */].EMERALD : colors["a" /* COLORS */].TURQUOISE,
    colorBg: colors["a" /* COLORS */].WHITE,
    colorBorder: isNoInsuranceSelected ? colors["a" /* COLORS */].EMERALD : colors["a" /* COLORS */].TURQUOISE,
    isDisabled: isLoading,
    onClick: noThanksAction
  }, Object(src_i18n["g" /* t */])('booking.insurance.noInsuranceButton')), InsuranceCTA_jsx(Button["a" /* Button */], {
    dataTestId: "insurance-add-button",
    className: "w-full sm:w-auto",
    size: "small",
    colorBg: isAdded ? colors["a" /* COLORS */].EMERALD : colors["a" /* COLORS */].TURQUOISE,
    colorBorder: isAdded ? colors["a" /* COLORS */].EMERALD : colors["a" /* COLORS */].TURQUOISE,
    isDisabled: isLoading,
    onClick: addInsuranceAction
  }, Object(src_i18n["g" /* t */])('booking.insurance.addInsuranceButton'))), InsuranceCTA_jsx(formik_esm["d" /* Formik */], {
    initialValues: {
      'insurance-terms-checkbox': isInsuranceTermsChecked
    }
  }, InsuranceCTA_jsx(formik_esm["c" /* Form */], null, InsuranceCTA_jsx(FormikInput["a" /* FormikInput */], {
    className: "inline",
    label: InsuranceCTA_jsx(InsuranceCTA_FormatedInformationAndTerms, {
      attachedDocuments: attachedDocuments,
      isChecked: !isAdded || isInsuranceTermsChecked || isNoThanksChecked
    }),
    name: "insurance-terms-checkbox",
    dataTestId: "insuranceTerms",
    type: "checkbox",
    onChange: function onChange() {
      return toggleInsuranceTerms();
    }
  })))));
}
// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// CONCATENATED MODULE: ./src/client/views/booking/summary/insurance/InsuranceFeedback.jsx
var InsuranceFeedback_jsx = react_default.a.createElement;




var InsuranceFeedback_InsuranceFeedback = function InsuranceFeedback(_ref) {
  var name = _ref.name,
      text = _ref.text,
      type = _ref.type;
  var isError = type === 'error';
  var icon = isError ? icons["a" /* ICONS */].WARNING : icons["a" /* ICONS */].SMALL_CIRCLE_CHECK;
  var color = isError ? colors["a" /* COLORS */].RED : colors["a" /* COLORS */].EMERALD;
  return InsuranceFeedback_jsx(Notification["a" /* Notification */], {
    className: "mt-px20",
    color: color,
    colorBg: "transparent",
    dataTestId: name,
    hasBorder: true,
    icon: icon,
    iconWidth: "1.25rem"
  }, InsuranceFeedback_jsx("p", {
    className: "font-sans leading-normal m-0 text-base text-xxs"
  }, text));
};
// CONCATENATED MODULE: ./src/client/views/booking/summary/insurance/Insurance.jsx
var Insurance_jsx = react_default.a.createElement;













var Insurance_Insurance = function Insurance(_ref) {
  var _insurance$insuranceD, _insurance$insuranceD2;

  var errorMessageCode = _ref.errorMessageCode,
      insurance = _ref.insurance,
      isContinueActionClicked = _ref.isContinueActionClicked,
      isInsuranceTermsChecked = _ref.isInsuranceTermsChecked,
      isLoading = _ref.isLoading,
      isNoThanksChecked = _ref.isNoThanksChecked,
      onChange = _ref.onChange,
      toggleInsuranceTerms = _ref.toggleInsuranceTerms;
  var label = insurance.label,
      id = insurance.id,
      price = insurance.price;

  var _ref2 = (insurance === null || insurance === void 0 ? void 0 : (_insurance$insuranceD = insurance.insuranceDetails) === null || _insurance$insuranceD === void 0 ? void 0 : _insurance$insuranceD[0]) || {},
      _ref2$coverageDescrip = _ref2.coverageDescriptions,
      coverageDescriptions = _ref2$coverageDescrip === void 0 ? [] : _ref2$coverageDescrip,
      _ref2$attachedDocumen = _ref2.attachedDocuments,
      attachedDocuments = _ref2$attachedDocumen === void 0 ? [] : _ref2$attachedDocumen,
      shortDescription = _ref2.shortDescription,
      _ref2$images = _ref2.images,
      images = _ref2$images === void 0 ? [] : _ref2$images,
      company = _ref2.company;

  var labelDetails = (insurance === null || insurance === void 0 ? void 0 : (_insurance$insuranceD2 = insurance.insuranceDetails) === null || _insurance$insuranceD2 === void 0 ? void 0 : _insurance$insuranceD2[0].label) || '';

  var _useSelector = Object(es["e" /* useSelector */])(booking_selector["q" /* getInsuranceStatus */]),
      isAdded = _useSelector.isAdded;

  var _useState = Object(react["useState"])(false),
      isNoInsuranceSelected = _useState[0],
      setIsNoInsuranceSelected = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isInsuranceAddedVisible = _useState2[0],
      setIsInsuranceAddedVisible = _useState2[1];

  var shouldDisplayToast = isAdded && isInsuranceAddedVisible && !isNoInsuranceSelected;
  var shouldDisplayConfirmCgvError = isAdded && isContinueActionClicked && !isInsuranceTermsChecked && !isNoThanksChecked;
  return Insurance_jsx("div", null, Insurance_jsx(Title["a" /* Title */], {
    className: "mb-px10",
    color: colors["a" /* COLORS */].BLUE,
    theme: "title-sans-4"
  }, Object(src_i18n["g" /* t */])('booking.insurance.insuranceLabel')), Insurance_jsx(Capsule["a" /* Capsule */], {
    header: "none"
  }, Insurance_jsx("div", {
    className: "pb-px25"
  }, images.length ? Insurance_jsx("img", {
    src: images[0],
    className: "w-full",
    alt: labelDetails
  }) : null, Insurance_jsx(InsuranceBody, {
    label: label,
    shortDescription: shortDescription,
    coverageDescriptions: coverageDescriptions,
    company: company,
    price: price
  }), Insurance_jsx("hr", {
    className: "h-px bg-gray-light mt-px40 mb-px25"
  }), Insurance_jsx(InsuranceCTA, {
    id: id,
    insurance: insurance,
    isInsuranceTermsChecked: isInsuranceTermsChecked,
    toggleInsuranceTerms: toggleInsuranceTerms,
    isLoading: isLoading,
    onChange: onChange,
    setIsNoInsuranceSelected: setIsNoInsuranceSelected,
    isNoInsuranceSelected: isNoInsuranceSelected,
    setIsInsuranceAddedVisible: setIsInsuranceAddedVisible,
    attachedDocuments: attachedDocuments,
    isNoThanksChecked: isNoThanksChecked
  }))), shouldDisplayToast && Insurance_jsx(Toast["a" /* Toast */], {
    label: Object(src_i18n["g" /* t */])('booking.insurance.insuranceTaken'),
    icon: icons["a" /* ICONS */].SMALL_CIRCLE_CHECK,
    color: colors["a" /* COLORS */].EMERALD,
    visible: isInsuranceAddedVisible,
    onClose: function onClose() {
      return setIsInsuranceAddedVisible(false);
    }
  }), isContinueActionClicked && errorMessageCode === INVALID_INSURANCE && Insurance_jsx(InsuranceFeedback_InsuranceFeedback, {
    name: "insurance-invalid-error",
    text: Object(src_i18n["g" /* t */])('booking.insurance.errorMessage2'),
    type: "error"
  }), isNoInsuranceSelected && !isInsuranceAddedVisible && Insurance_jsx(InsuranceFeedback_InsuranceFeedback, {
    name: "insurance-added",
    text: Object(src_i18n["g" /* t */])('booking.insurance.noInsurance'),
    type: "notice"
  }), shouldDisplayConfirmCgvError && Insurance_jsx(InsuranceFeedback_InsuranceFeedback, {
    name: "insurance-terms-error",
    text: Object(src_i18n["g" /* t */])('booking.insurance.errorMessage3'),
    type: "error"
  }));
};
// CONCATENATED MODULE: ./src/client/views/booking/summary/insurance/insurance.utils.js


var insurance_utils_isValidInsurance = function isValidInsurance(insurance) {
  var price = insurance.price,
      label = insurance.label;

  var _get = Object(lodash["get"])(insurance, 'insuranceDetails[0]', {}),
      _get$coverageDescript = _get.coverageDescriptions,
      coverageDescriptions = _get$coverageDescript === void 0 ? [] : _get$coverageDescript;

  return coverageDescriptions.length && price.formattedValue && label;
};


// CONCATENATED MODULE: ./src/client/views/booking/summary/option-modal/OptionModal.jsx
var OptionModal_jsx = react_default.a.createElement;









var OptionModal_OptionModal = function OptionModal(_ref) {
  var imageUrl = _ref.imageUrl,
      proposalId = _ref.proposalId,
      onClose = _ref.onClose,
      onClick = _ref.onClick,
      _ref$isOptionAllowed = _ref.isOptionAllowed,
      isOptionAllowed = _ref$isOptionAllowed === void 0 ? false : _ref$isOptionAllowed;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var popinDescriptionLabel = appContext.isCmta ? Object(src_i18n["g" /* t */])('booking.partners.summary.option.popinDescription') : Object(src_i18n["g" /* t */])('booking.option.popinDescription');
  return OptionModal_jsx(Modal["a" /* Modal */], {
    ariaLabel: Object(src_i18n["g" /* t */])(isOptionAllowed ? 'booking.option.popin.header' : 'booking.callCenterPopIn.title'),
    ariaLabelledby: identifiers_constants["p" /* ID_MODAL_HEADER__BE__OPTION */],
    closeLabel: Object(src_i18n["g" /* t */])('common.close'),
    onClose: onClose
  }, OptionModal_jsx("div", {
    className: "overflow-hidden",
    "data-testid": "SummaryView-optionModal"
  }, OptionModal_jsx("div", {
    style: {
      height: '14.25rem'
    },
    className: "overflow-hidden relative"
  }, !!imageUrl && OptionModal_jsx("img", {
    src: imageUrl,
    className: "w-full",
    alt: ""
  }), OptionModal_jsx("div", {
    className: "absolute flex items-center justify-center inset-0"
  })), OptionModal_jsx("div", {
    className: "m-px25 text-center"
  }, OptionModal_jsx("div", {
    id: identifiers_constants["p" /* ID_MODAL_HEADER__BE__OPTION */],
    className: "mb-px10 text-2xl text-blue font-brand"
  }, Object(src_i18n["g" /* t */])(isOptionAllowed ? 'booking.option.popin.header' : 'booking.callCenterPopIn.title')), isOptionAllowed ? OptionModal_jsx(react["Fragment"], null, OptionModal_jsx("div", {
    className: "flex justify-center mb-px5"
  }, OptionModal_jsx("p", {
    style: {
      maxWidth: '18rem'
    },
    className: "p-px10 text-md m-0"
  }, Object(src_i18n["g" /* t */])('booking.option.popin.subHeader'))), OptionModal_jsx(Button["a" /* Button */], {
    dataTestId: "pauseOptionModalButton",
    colorBg: colors["a" /* COLORS */].BOOKING,
    colorBorder: colors["a" /* COLORS */].BOOKING,
    onClick: onClick,
    size: "medium",
    className: "text-md uppercase mb-px15",
    style: {
      minWidth: '17rem'
    }
  }, Object(src_i18n["g" /* t */])('booking.option.buttonLabel'))) : OptionModal_jsx(react["Fragment"], null, OptionModal_jsx("p", {
    className: "border-blue border-2 mb-px10 p-px10 inline-flex items-center rounded text-blue"
  }, OptionModal_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].PHONE_BUBBLE,
    width: "2em"
  }), OptionModal_jsx("span", {
    className: "block font-bold"
  }, " ", Object(src_i18n["g" /* t */])('booking.callCenterPopIn.number'))), OptionModal_jsx("span", {
    className: "block text-xs text-gray"
  }, Object(src_i18n["g" /* t */])('booking.callCenterPopIn.cost'))), OptionModal_jsx("div", {
    className: "p-px10 text-md"
  }, isOptionAllowed ? popinDescriptionLabel : Object(src_i18n["g" /* t */])('booking.callCenterPopIn.useProposalIdLabel')), OptionModal_jsx("div", {
    className: "font-bold"
  }, Object(src_i18n["g" /* t */])('common.reference'), " : ", proposalId))));
};
// CONCATENATED MODULE: ./src/client/views/booking/summary/cxo-radio-buttons/CxoRadioButtons.jsx

var CxoRadioButtons_jsx = react_default.a.createElement;






var CxoRadioButtons_CxoRadioButtons = function CxoRadioButtons(_ref) {
  var buttons = _ref.buttons,
      onChange = _ref.onChange;
  var attendees = Object(es["e" /* useSelector */])(booking_selector["i" /* getAttendeesWithInfos */]);
  var isMultiHousehold = new Set([].concat(Object(toConsumableArray["a" /* default */])(attendees.adults), Object(toConsumableArray["a" /* default */])(attendees.children)).map(function (_ref2) {
    var gmNumber = _ref2.gmNumber;
    return gmNumber;
  }).filter(Boolean)).size > 1;
  return CxoRadioButtons_jsx("div", {
    className: "text-center"
  }, buttons.filter(function (_ref3) {
    var value = _ref3.value;
    return !isMultiHousehold || isMultiHousehold && value !== booking_constants["p" /* CXO_STEP */].PAYMENT;
  }).map(function (button, index) {
    return CxoRadioButtons_jsx("div", {
      className: "inline-flex flex-col items-center w-1/3",
      key: button.label
    }, CxoRadioButtons_jsx("input", {
      type: "radio",
      name: "cxoEscapeHatch",
      className: "CxoRadioButton-input",
      id: "".concat(index, "-cxoButton"),
      onChange: onChange,
      value: button.value
    }), CxoRadioButtons_jsx("label", {
      className: "cursor-pointer text-2xl mt-px10 w-4/5",
      "data-testid": "CxoRadioButton-label",
      htmlFor: "".concat(index, "-cxoButton")
    }, CxoRadioButtons_jsx(Button["a" /* Button */], {
      colorBg: colors["a" /* COLORS */].TURQUOISE,
      colorBorder: colors["a" /* COLORS */].TURQUOISE,
      className: "w-full pointer-events-none"
    }, button.label)));
  }));
};
// CONCATENATED MODULE: ./src/client/views/booking/summary/seller-actions/SellerActions.jsx

var SellerActions_jsx = react_default.a.createElement;










var SellerActions_SellerActions = function SellerActions(props) {
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var onChange = props.onChange,
      error = props.error,
      proposal = props.proposal,
      isNrr = props.isNrr;

  if (appContext.isCmta) {
    var cmtaSteps = Object(toConsumableArray["a" /* default */])(proposal.optionAvailable ? [{
      label: Object(src_i18n["g" /* t */])('booking.option.buttonLabel'),
      value: booking_constants["p" /* CXO_STEP */].AFFICHAGE
    }] : []);

    return proposal.optionAvailable ? SellerActions_jsx(react["Fragment"], null, SellerActions_jsx(CxoRadioButtons_CxoRadioButtons, {
      onChange: onChange,
      buttons: cmtaSteps
    }), error ? SellerActions_jsx(FormFeedback["a" /* FormFeedback */], {
      isError: true,
      message: error,
      className: "justify-end"
    }) : null) : SellerActions_jsx(Notification["a" /* Notification */], {
      color: colors["a" /* COLORS */].WARNING,
      colorBg: "transparent",
      hasBorder: true,
      icon: icons["a" /* ICONS */].WARNING,
      iconWidth: "1.5rem"
    }, SellerActions_jsx("p", {
      className: "text-base m-0"
    }, Object(src_i18n["g" /* t */])('booking.summary.partners.optionUnavailable')));
  }

  if (appContext.isDirectCxo || appContext.isIndirectCxo) {
    var cxoSteps = [].concat(Object(toConsumableArray["a" /* default */])(Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('seller.booking.modifyInNA') ? [{
      label: Object(src_i18n["g" /* t */])('booking.cxo.modifyInNA'),
      value: booking_constants["p" /* CXO_STEP */].CONFIGURE
    }] : []), Object(toConsumableArray["a" /* default */])(proposal.optionAvailable && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('seller.booking.takeOption') ? [{
      label: Object(src_i18n["g" /* t */])('booking.option.buttonLabel'),
      value: booking_constants["p" /* CXO_STEP */].AFFICHAGE
    }] : []), Object(toConsumableArray["a" /* default */])(proposal.optionAvailable || isNrr ? [{
      label: Object(src_i18n["g" /* t */])('booking.cxo.confirmAndPay'),
      value: booking_constants["p" /* CXO_STEP */].PAYMENT
    }] : []));
    return SellerActions_jsx(react["Fragment"], null, SellerActions_jsx(CxoRadioButtons_CxoRadioButtons, {
      onChange: onChange,
      buttons: cxoSteps
    }), error ? SellerActions_jsx(FormFeedback["a" /* FormFeedback */], {
      isError: true,
      message: error,
      className: "justify-end"
    }) : null);
  }

  return null;
};
// EXTERNAL MODULE: ./src/client/views/booking/summary/SummaryView.tracking.js
var SummaryView_tracking = __webpack_require__("FuvW");

// CONCATENATED MODULE: ./src/client/views/booking/summary/SummaryView.jsx









var SummaryView_jsx = react_default.a.createElement;

function SummaryView_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function SummaryView_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SummaryView_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SummaryView_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SummaryView_createSuper(Derived) { var hasNativeReflectConstruct = SummaryView_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function SummaryView_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }









































var SummaryView_SummaryView = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(SummaryView, _React$Component);

  var _super = SummaryView_createSuper(SummaryView);

  function SummaryView() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, SummaryView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      sellerError: null,
      sellerPaymentMethod: null,
      insuranceError: _this.getInitialInsuranceState(),
      isLoading: false,
      editCriteriaMode: false,
      promoCodeRequestStatus: null,
      isOptionModalOpened: false,
      hasCheckedOption: false,
      editCriteriaHasError: false,
      isInsuranceTermsChecked: false,
      isContinueActionClicked: false,
      isNoThanksChecked: false
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onCxoPaymentSubmit", function () {
      var _this$props = _this.props,
          selectedProposal = _this$props.selectedProposal,
          location = _this$props.location,
          i18n = _this$props.i18n;

      _this.props.startLoading();

      _this.setState({
        sellerError: null
      });

      tracking_api["b" /* setDataLayer */](SummaryView_objectSpread(SummaryView_objectSpread({}, constants["i" /* GA_DEFAULT_PAYLOAD */]), {}, {
        categoryGA: 'bookingEngine',
        actionGA: 'summary',
        labelGA: booking_constants["q" /* CXO_STEP_GA */][_this.state.sellerPaymentMethod]
      }), _this.context);
      return Object(sellerUtils["k" /* saveCustomerProposalAndSendContextToCxO */])({
        proposalId: selectedProposal.id,
        // $FlowFixMe
        step: _this.state.sellerPaymentMethod,
        appContext: _this.context,
        proposal: selectedProposal,
        location: location,
        salesmanID: _this.props.salesmanID
      }).then(function (response) {
        if (_this.state.sellerPaymentMethod === booking_constants["p" /* CXO_STEP */].AFFICHAGE) {
          redirectUtils["a" /* default */].redirectTo()(Object(routeBuilder["a" /* buildUrl */])('optionConfirmation', {
            status: statusCode_constants["a" /* STATUS_CODE_200 */]
          }, SummaryView_objectSpread(SummaryView_objectSpread({}, location.queryParams), {}, {
            bi: response.bookingId,
            selectedProposalId: selectedProposal.id,
            productId: selectedProposal.productId
          })));
        } else {
          _this.props.endLoading();
        }
      }).catch(function (error) {
        _this.props.endLoading();

        _this.setState({
          sellerError: Object(lodash["get"])(error, 'errors[0].statusCode') === 409 ? i18n.booking.cxo.warning.bookingExists : i18n.booking.cxo.warning.technicalError
        });
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onCmtaPaymentSubmit", function () {
      var i18n = _this.props.i18n;

      _this.props.startLoading();

      return Object(ContactInfoUtils["p" /* submitOption */])(_this.context, _this.props.location, _this.context.isCmta && _this.props.sellerEmail ? _this.props.sellerEmail : undefined)(_this.props.selectedProposal).catch(function (error) {
        _this.props.endLoading();

        _this.setState({
          sellerError: Object(lodash["get"])(error, 'errors[0].statusCode') === 409 ? i18n.booking.cxo.warning.bookingExists : i18n.booking.cxo.warning.technicalError
        });
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onSellerPaymentSubmit", /*#__PURE__*/Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.checkInsurancesFilled();

            case 3:
              if (_this.state.sellerPaymentMethod) {
                _context.next = 6;
                break;
              }

              _this.setState({
                sellerError: _this.props.i18n.booking.cxo.warning.continue
              });

              return _context.abrupt("return", Promise.reject());

            case 6:
              return _context.abrupt("return", _this.context.isCmta ? _this.onCmtaPaymentSubmit() : _this.onCxoPaymentSubmit());

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    })));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "changeSellerPayment", function (e) {
      _this.setState({
        sellerPaymentMethod: e.currentTarget.value
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "checkInsurancesFilled", function () {
      var _this$props$selectedP, _this$props$selectedP2;

      if (_this.props.selectedProposal.price.selectedRate === dist["constants"].FLEX_RATES.NRR) return Promise.resolve();
      var isInsuranceTermsChecked = _this.state.isInsuranceTermsChecked;
      var isNoThanksChecked = _this.state.isNoThanksChecked;
      var hasError = false;

      var insuranceWithError = SummaryView_objectSpread({}, _this.state.insuranceError);

      for (var key in _this.state.insuranceError) {
        if (Object(lodash["isEmpty"])(_this.state.insuranceError[key]) || _this.state.insuranceError[key] === INVALID_INSURANCE) {
          hasError = true;
          insuranceWithError = SummaryView_objectSpread(SummaryView_objectSpread({}, insuranceWithError), {}, Object(defineProperty["a" /* default */])({}, key, INVALID_INSURANCE));
        }
      }

      if (hasError || ((_this$props$selectedP = _this.props.selectedProposal) === null || _this$props$selectedP === void 0 ? void 0 : (_this$props$selectedP2 = _this$props$selectedP.listInsurances) === null || _this$props$selectedP2 === void 0 ? void 0 : _this$props$selectedP2.length) !== 0 && !isNoThanksChecked && !isInsuranceTermsChecked) {
        Object(BookingEngine_tracking["c" /* trackNavigation */])('summary', 'insuranceError', _this.context);
        Object(scrollToElement["a" /* scrollToElement */])('#checkbox-insurance-terms-checkbox');

        _this.setState({
          insuranceError: insuranceWithError,
          isContinueActionClicked: true
        });

        return Promise.reject();
      }

      return Promise.resolve();
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "toggleInsuranceTerms", function () {
      _this.setState({
        isInsuranceTermsChecked: !_this.state.isInsuranceTermsChecked,
        isContinueActionClicked: true
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "setIsContinueActionClicked", function (value) {
      _this.setState({
        isContinueActionClicked: value
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "changeInsurances", function (insuranceId, value, currentInsurance) {
      _this.setState({
        isLoading: true
      });

      var proposalId = Object(lodash["get"])(_this.props, 'selectedProposal.id');
      var lightAttendee = _this.props.selectedProposal.attendees ? _this.props.selectedProposal.attendees.list.map(function (attendee) {
        return {
          id: attendee.id
        };
      }) : [];

      if (value === ADD_INSURANCE) {
        Object(BookingEngine_tracking["c" /* trackNavigation */])('summary', 'insuranceSubscribe', _this.context);

        _this.props.updateInsurances(proposalId, insuranceId, lightAttendee, _this.context).finally(function () {
          _this.setState({
            isLoading: false,
            insuranceError: SummaryView_objectSpread(SummaryView_objectSpread({}, _this.state.insuranceError), {}, Object(defineProperty["a" /* default */])({}, insuranceId, ADD_INSURANCE)),
            isNoThanksChecked: false
          });
        });
      } else {
        Object(BookingEngine_tracking["c" /* trackNavigation */])('summary', 'insuranceNotSubscribe', _this.context); // On ne supprime pas l'assurance si elle n'est deja pas souscrite

        if (currentInsurance === null || currentInsurance === void 0 ? void 0 : currentInsurance.subscribed) {
          _this.props.deleteInsurances(proposalId, insuranceId, _this.context).finally(function () {
            _this.setState({
              isLoading: false,
              insuranceError: SummaryView_objectSpread(SummaryView_objectSpread({}, _this.state.insuranceError), {}, Object(defineProperty["a" /* default */])({}, insuranceId, DELETE_INSURANCE)),
              isNoThanksChecked: true
            });
          });
        } else {
          _this.setState({
            isLoading: false,
            insuranceError: SummaryView_objectSpread(SummaryView_objectSpread({}, _this.state.insuranceError), {}, Object(defineProperty["a" /* default */])({}, insuranceId, DELETE_INSURANCE)),
            isNoThanksChecked: true
          });

          _this.props.setNoInsurances();
        }
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "takeAnOption", function () {
      var _this$props2 = _this.props,
          selectedProposal = _this$props2.selectedProposal,
          location = _this$props2.location;

      if (!_this.state.isLoading) {
        _this.setState({
          isLoading: true
        }, function () {
          Object(SummaryView_tracking["a" /* trackClick */])('saveOption_popin', _this.context);

          _this.props.startLoading();

          Object(ContactInfoUtils["p" /* submitOption */])(_this.context, location, _this.props.sellerEmail, true, _this.props.salesmanID)(selectedProposal);
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "applyPromoCode", /*#__PURE__*/function () {
      var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2(params) {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this.setState({
                  promoCodeRequestStatus: null
                });

                _context2.next = 4;
                return _this.props.setPromoCode(_this.props.selectedProposal.id, params, _this.context);

              case 4:
                _this.setState({
                  promoCodeRequestStatus: PROMO_CODE_REQUEST_SUCCESS
                });

                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);

                _this.setState({
                  promoCodeRequestStatus: PROMO_CODE_REQUEST_FAILURE
                });

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 7]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "shouldShowOptionButton", function () {
      var optionKey = _this.context.isCmta ? 'cmta.booking.takeOption' : 'booking.option';
      return Object(featureFlippingUtils["a" /* isFeatureFlipped */])(_this.context, !Object(lodash["get"])(_this.props, 'responsive.isTablet'))(optionKey) && Object(proposalUtils["w" /* isOptionAllowed */])(_this.props.selectedProposal);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "toggleEditCriteriaMode", function () {
      _this.setState({
        editCriteriaMode: !_this.state.editCriteriaMode
      }, function () {
        var currentPage = _this.props.bookingStep;

        if (_this.state.editCriteriaMode) {
          Object(BookingEngine_tracking["c" /* trackNavigation */])(currentPage, "".concat(currentPage, "_editCriteria"), _this.context);
        }
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "setEditCriteriaHasError", function () {
      _this.setState({
        editCriteriaHasError: true
      });
    });

    return _this;
  }

  Object(createClass["a" /* default */])(SummaryView, [{
    key: "getInitialInsuranceState",
    value: function getInitialInsuranceState() {
      // Insurance is ADD_INSURANCE, DELETE_INSURANCE or ''
      // In case of '' : radio is not selected
      var insuranceError = {};
      var selectedProposal = this.props.selectedProposal;
      selectedProposal.listInsurances ? selectedProposal.listInsurances.forEach(function (ins) {
        if (insurance_utils_isValidInsurance(ins)) {
          insuranceError = SummaryView_objectSpread(SummaryView_objectSpread({}, insuranceError), {}, Object(defineProperty["a" /* default */])({}, ins.id, ins.subscribed ? ADD_INSURANCE : ''));
        }
      }) : [];
      return insuranceError;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.showTimer) {
        var newDateTime = moment_default()().add(15, 'minutes').unix(); // initialize timer only in summary step for chinese locale and proposals with transport

        this.props.setTimerInitialValue(newDateTime);
        sessionStorage.setItem(getChinaTimerSessionKey(this.props.selectedProposal.id), newDateTime.toString());
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          isLoading = _this$state.isLoading,
          editCriteriaMode = _this$state.editCriteriaMode,
          promoCodeRequestStatus = _this$state.promoCodeRequestStatus,
          isOptionModalOpened = _this$state.isOptionModalOpened,
          editCriteriaHasError = _this$state.editCriteriaHasError;
      var _this$props3 = this.props,
          actionGA = _this$props3.actionGA,
          bookingStep = _this$props3.bookingStep,
          i18n = _this$props3.i18n,
          reservedServicesByAttendee = _this$props3.reservedServicesByAttendee,
          resort = _this$props3.resort,
          selectedProposal = _this$props3.selectedProposal;
      var continueActionValue = (Object(featureFlippingUtils["a" /* isFeatureFlipped */])(this.context)('booking.optionHoldOnly') || this.context.isCmta && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(this.context)('booking.cmta.optionHoldOnly')) && selectedProposal.price && selectedProposal.price.currency !== 'MXN' ? function () {
        return _this2.setState({
          isOptionModalOpened: true
        });
      } : null;
      var validationCallbackValue = this.context.isCxo ? this.onSellerPaymentSubmit : this.checkInsurancesFilled;
      return SummaryView_jsx(react["Fragment"], null, SummaryView_jsx(head_default.a, null, SummaryView_jsx("title", {
        key: "title"
      }, Object(lodash["get"])(i18n, 'booking.summary.seo.title'))), SummaryView_jsx(Receipt["a" /* Receipt */], {
        actionGA: actionGA,
        i18n: i18n,
        proposal: selectedProposal,
        resort: this.props.resort,
        editCriteriaMode: editCriteriaMode,
        toggleEditCriteriaMode: this.toggleEditCriteriaMode,
        currentPage: bookingStep,
        isTablet: this.props.responsive.isTablet,
        notifyParentNoResults: this.setEditCriteriaHasError
      }), SummaryView_jsx("div", {
        className: "max-w-site-small mb-px20 mx-auto"
      }, Object(lodash["get"])(i18n, 'booking.priceDetails.promoCode.enabled', false) && !editCriteriaHasError && SummaryView_jsx(PromoCode_PromoCode, {
        applyPromoCode: this.applyPromoCode,
        promoCodeRequestStatus: promoCodeRequestStatus,
        customerId: parseInt(this.props.selectedProposal.attendees.list[0].customerId, 10)
      })), reservedServicesByAttendee.length > 0 && !editCriteriaHasError && SummaryView_jsx("div", {
        className: "max-w-site-small mb-px20 mx-auto"
      }, SummaryView_jsx(Title["a" /* Title */], {
        className: "mb-px10",
        theme: "title-sans-4",
        color: colors["a" /* COLORS */].BLUE
      }, i18n.booking.activities.myPackage.title), SummaryView_jsx(ReservedServicesList["a" /* ReservedServicesList */], {
        reservedServicesByAttendee: reservedServicesByAttendee,
        noEditMode: true,
        currency: this.props.selectedProposal.price.currency,
        scrollBackwardLabel: Object(lodash["get"])(i18n, 'common.scrollBackward'),
        scrollForwardLabel: Object(lodash["get"])(i18n, 'common.scrollForward')
      })), selectedProposal.price.selectedRate !== dist["constants"].FLEX_RATES.NRR ? SummaryView_jsx("div", {
        className: "max-w-site-small mb-px20 mx-auto"
      }, selectedProposal.listInsurances && !editCriteriaHasError ? selectedProposal.listInsurances.map(function (insurance) {
        return insurance_utils_isValidInsurance(insurance) ? SummaryView_jsx(Insurance_Insurance, {
          isLoading: isLoading,
          errorMessageCode: _this2.state.insuranceError[insurance.id],
          key: insurance.id,
          insurance: insurance,
          isInsuranceTermsChecked: _this2.state.isInsuranceTermsChecked,
          isNoThanksChecked: _this2.state.isNoThanksChecked,
          toggleInsuranceTerms: _this2.toggleInsuranceTerms,
          onChange: _this2.changeInsurances,
          isContinueActionClicked: _this2.state.isContinueActionClicked
        }) : null;
      }) : null) : null, SummaryView_jsx("div", {
        className: "max-w-site-small mb-px20 mx-auto"
      }, this.context.isDirectCxo || this.context.isIndirectCxo ? SummaryView_jsx(SellerActions_SellerActions, {
        onChange: this.changeSellerPayment,
        error: this.state.sellerError,
        proposal: selectedProposal,
        isNrr: selectedProposal.price.selectedRate === dist["constants"].FLEX_RATES.NRR
      }) : this.shouldShowOptionButton() && !editCriteriaHasError && SummaryView_jsx(BlockWithButton_BlockWithButton, {
        description: this.context.isCmta ? Object(src_i18n["g" /* t */])('booking.partners.summary.option.popinDescription') : Object(src_i18n["g" /* t */])('booking.option.popinDescription'),
        iconName: icons["a" /* ICONS */].OPTION,
        actionGA: "summary",
        labelGA: "saveOption",
        linkLabel: Object(src_i18n["g" /* t */])('booking.option.buttonLabel'),
        title: Object(src_i18n["g" /* t */])('booking.option.buttonSubLabel'),
        type: "submit",
        buttonClick: function buttonClick() {
          return _this2.setState({
            isOptionModalOpened: true
          });
        }
      })), isOptionModalOpened && SummaryView_jsx(OptionModal_OptionModal, {
        onClose: function onClose() {
          return _this2.setState({
            isOptionModalOpened: false
          });
        },
        imageUrl: resort.image,
        onClick: this.takeAnOption,
        proposalId: Object(lodash["get"])(this.props, 'selectedProposal.id'),
        isOptionAllowed: Object(proposalUtils["w" /* isOptionAllowed */])(selectedProposal)
      }), this.props.renderBottomNavbar({
        validationCallback: validationCallbackValue,
        isPriceLoading: isLoading,
        continueAction: continueActionValue
      }));
    }
  }]);

  return SummaryView;
}(react_default.a.Component);

Object(defineProperty["a" /* default */])(SummaryView_SummaryView, "contextType", ReactAppContext["a" /* default */]);

function SummaryView_mapStateToProps(state) {
  return {
    reservedServicesByAttendee: Object(booking_selector["w" /* getReservedServicesByAttendee */])(state),
    sellerEmail: state.seller.sellerInfo.email,
    salesmanID: state.seller.sellerInfo.salesmanID
  };
}

var SummaryView_mapDispatchToProps = {
  deleteInsurances: proposals_action["g" /* deleteInsurances */],
  endLoading: globalLoader_action["c" /* endLoading */],
  setPromoCode: proposals_action["q" /* setPromoCode */],
  startLoading: globalLoader_action["d" /* startLoading */],
  updateInsurances: proposals_action["u" /* updateInsurances */],
  setNoInsurances: proposals_action["p" /* setNoInsurances */]
};
/* harmony default export */ var summary_SummaryView = (Object(withRouter["a" /* withRouter */])(Object(es["c" /* connect */])(SummaryView_mapStateToProps, SummaryView_mapDispatchToProps)(Object(Responsive["a" /* default */])(SummaryView_SummaryView))));
// EXTERNAL MODULE: ./src/client/components/widgets/activities-layer/ActivitiesContext.js
var ActivitiesContext = __webpack_require__("oMJB");

// EXTERNAL MODULE: ./src/client/components/utils/string/string.util.js
var string_util = __webpack_require__("tX1K");

// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// EXTERNAL MODULE: ./src/client/components/frameworks/tabs/Tabs.jsx + 1 modules
var Tabs = __webpack_require__("4/4b");

// EXTERNAL MODULE: ./src/client/components/frameworks/layer/Layer.jsx + 4 modules
var Layer = __webpack_require__("U2fG");

// EXTERNAL MODULE: ./src/client/components/widgets/layer-header-proposal/LayerHeaderProposal.jsx
var LayerHeaderProposal = __webpack_require__("U/+3");

// CONCATENATED MODULE: ./src/client/components/widgets/continue-layer-bottom-bar/ContinueLayerBottomBar.jsx
var ContinueLayerBottomBar_jsx = react_default.a.createElement;




var ContinueLayerBottomBar_ContinueLayerBottomBar = function ContinueLayerBottomBar(_ref) {
  var continueAction = _ref.continueAction;
  return ContinueLayerBottomBar_jsx("div", {
    className: "ContinueLayerBottomBar",
    "data-testid": "ContinueLayerBottomBar"
  }, ContinueLayerBottomBar_jsx("div", {
    className: "ContinueLayerBottomBar-content"
  }, ContinueLayerBottomBar_jsx("div", {
    className: "flex"
  }, ContinueLayerBottomBar_jsx(Button["a" /* Button */], {
    className: "text-xl font-bold w-full",
    dataTestId: "ContinueLayerBottomBar-Button",
    colorBg: colors["a" /* COLORS */].BOOKING,
    colorBorder: colors["a" /* COLORS */].BOOKING,
    onClick: continueAction,
    size: "large",
    minWidth: "13.725rem"
  }, Object(src_i18n["g" /* t */])('common.continue')))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/activities-layer/ActivitiesLayer.jsx
var ActivitiesLayer = __webpack_require__("K3M/");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// CONCATENATED MODULE: ./src/client/views/booking/activities/ActivityCategoryBlock.jsx
var ActivityCategoryBlock_jsx = react_default.a.createElement;





var ActivityCategoryBlock_ActivityCategoryBlock = function ActivityCategoryBlock(_ref) {
  var activityCategory = _ref.activityCategory,
      onClick = _ref.onClick,
      categoryHasRentedActivity = _ref.categoryHasRentedActivity;
  var includedActivities = activityCategory.activities.filter(function (_ref2) {
    var isIncluded = _ref2.isIncluded;
    return isIncluded;
  });
  var notIncludedActivities = activityCategory.activities.filter(function (_ref3) {
    var isIncluded = _ref3.isIncluded;
    return !isIncluded;
  });
  return ActivityCategoryBlock_jsx("div", {
    className: "py-px25 px-px10",
    "data-testid": 'ActivityCategoryBlock_' + activityCategory.id
  }, ActivityCategoryBlock_jsx("div", {
    className: "rounded-small overflow-hidden flex flex-col flex-shrink-0 h-full",
    style: {
      width: 280
    }
  }, ActivityCategoryBlock_jsx("div", {
    className: "h-full"
  }, ActivityCategoryBlock_jsx(Image["b" /* default */], {
    imageUrl: activityCategory.imageUrl,
    mandatoryWidthAndHeight: {
      w: 280,
      h: 340
    }
  })), ActivityCategoryBlock_jsx("div", {
    className: "p-px20 bg-white flex flex-col justify-between h-full"
  }, ActivityCategoryBlock_jsx("div", null, ActivityCategoryBlock_jsx("div", {
    className: "text-xl font-bold mb-px10"
  }, activityCategory.label || Object(src_i18n["g" /* t */])('booking.activities.otherActivities')), ActivityCategoryBlock_jsx("div", {
    className: "mb-px20"
  }, includedActivities.length !== 0 && ActivityCategoryBlock_jsx("div", {
    className: "flex justify-between font-brand text-blue"
  }, ActivityCategoryBlock_jsx("div", {
    className: "flex items-center text-base"
  }, ActivityCategoryBlock_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ALL_INCLUSIVE,
    className: "rtl:mr-px10"
  }), Object(src_i18n["g" /* t */])('booking.activities.includedActivitiesAmount')), includedActivities.length), notIncludedActivities.length !== 0 && ActivityCategoryBlock_jsx("div", {
    className: "flex justify-between mt-px10 font-brand text-amber"
  }, ActivityCategoryBlock_jsx("div", {
    className: "flex items-center text-base"
  }, ActivityCategoryBlock_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ON_DEMAND,
    className: "rtl:mr-px10"
  }), Object(src_i18n["g" /* t */])('booking.activities.onDemandActivitiesAmount')), notIncludedActivities.length))), ActivityCategoryBlock_jsx("div", {
    className: "flex justify-center"
  }, ActivityCategoryBlock_jsx("span", {
    className: "normal-case underline text-base cursor-pointer",
    onClick: onClick
  }, Object(src_i18n["g" /* t */])(categoryHasRentedActivity ? 'common.modify' : 'booking.activities.seeAllButton'))))));
};
// CONCATENATED MODULE: ./src/client/views/booking/activities/CategoryList.jsx
var CategoryList_jsx = react_default.a.createElement;
















var ACTIVITY_ID_TO_SHOW_FIRST = 'AC_excursions';

var reducer = function reducer(state, action) {
  switch (action.type) {
    case 'set':
      return {
        categoryToShow: action.payload.categoryId,
        activityToShow: action.payload.activityId
      };

    case 'reset':
      return {
        categoryToShow: null,
        activityToShow: null
      };

    default:
      return state;
  }
};

var CategoryList_CategoryList = function CategoryList(_ref) {
  var i18n = _ref.i18n,
      selectedProposal = _ref.selectedProposal,
      filteredActivityCategories = _ref.filteredActivityCategories,
      type = _ref.type;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useReducer = Object(react["useReducer"])(reducer, {
    categoryToShow: null,
    activityToShow: null
  }),
      layerState = _useReducer[0],
      dispatchLayerState = _useReducer[1];

  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: 'activities'
  });
  var bookedActivities = selectedProposal.additionalServices.activities.filter(function (_ref2) {
    var pricingInfo = _ref2.pricingInfo;
    return pricingInfo.isPartiallyRented;
  });
  var previouslyBookedActivities = Object(react["useRef"])(bookedActivities);
  var categories = filteredActivityCategories.filter(function (_ref3) {
    var subCategories = _ref3.subCategories;
    return subCategories.length > 0;
  }).sort(function (_ref4) {
    var id = _ref4.id;
    return id === ACTIVITY_ID_TO_SHOW_FIRST ? -1 : 1;
  });

  var closeActivityLayer = function closeActivityLayer() {
    dispatchLayerState({
      type: 'reset'
    });

    if (JSON.stringify(previouslyBookedActivities.current) !== JSON.stringify(bookedActivities)) {
      Object(scrollToElement["a" /* scrollToElement */])('[data-testid="ReservedServicesWrapper"]');
    }

    previouslyBookedActivities.current = bookedActivities;
    track({
      labelGA: "validate".concat(type, "Layer")
    });
  };

  var categoryListLayerHeaderTitle = Object(src_i18n["g" /* t */])('common.backNavigation');
  return CategoryList_jsx(react["Fragment"], null, CategoryList_jsx(Tabs["a" /* Tabs */], {
    className: "max-w-full",
    isContentUnmountedOnCollapse: true,
    isScrollable: true,
    onTabClick: function onTabClick(headerId, index) {
      var category = categories[index];
      track({
        labelGA: "clickTab_".concat(Object(lodash["camelCase"])(category.id.replace('AC_', '')))
      });
    },
    items: categories.map(function (category) {
      return {
        header: {
          title: category.label,
          style: {
            minWidth: '9rem'
          }
        },
        content: CategoryList_jsx("div", {
          className: "rtl:-ml-px10"
        }, !Object(sellerUtils["g" /* isSeller */])(appContext) && CategoryList_jsx("div", {
          className: "rtl:ml-px10 mt-px10 text-base"
        }, Object(src_i18n["g" /* t */])('booking.activities.bookingMessage')), CategoryList_jsx(Scrollable["a" /* Scrollable */], {
          backwardLabel: Object(src_i18n["g" /* t */])('common.scrollBackward'),
          childrenWrapperClassNames: "flex",
          forwardLabel: Object(src_i18n["g" /* t */])('common.scrollForward'),
          key: category.id,
          hasNoMouseWheelScroll: true,
          navPosition: "center",
          theme: "default"
        }, category.subCategories.map(function (activityCategory) {
          return CategoryList_jsx(ActivityCategoryBlock_ActivityCategoryBlock, {
            key: activityCategory.id,
            activityCategory: activityCategory,
            categoryHasRentedActivity: bookedActivities.some(function (_ref5) {
              var productInfo = _ref5.productInfo;
              return productInfo.parentActivityCategoriesId.includes(activityCategory.id);
            }),
            onClick: function onClick() {
              dispatchLayerState({
                type: 'set',
                payload: {
                  categoryId: category.id,
                  activityId: activityCategory.id
                }
              });
            }
          });
        })))
      };
    }),
    scrollBackwardLabel: Object(src_i18n["g" /* t */])('common.scrollBackward'),
    scrollForwardLabel: Object(src_i18n["g" /* t */])('common.scrollForward'),
    theme: "lite"
  }), layerState.categoryToShow && layerState.activityToShow && CategoryList_jsx(Layer["b" /* Layer */], {
    ariaLabel: categoryListLayerHeaderTitle,
    ariaLabelledby: identifiers_constants["b" /* ID_LAYER_HEADER__BE__CATEGORY_LIST */],
    buttonLeft: {
      label: Object(src_i18n["g" /* t */])('common.backNavigation'),
      iconName: icons["a" /* ICONS */].LEFT_ARROW,
      onClick: closeActivityLayer
    },
    closeLabel: Object(src_i18n["g" /* t */])('common.close'),
    hasContainerHeader: true,
    hasScrollLocked: true,
    header: CategoryList_jsx(LayerHeaderProposal["a" /* LayerHeaderProposal */], {
      id: identifiers_constants["b" /* ID_LAYER_HEADER__BE__CATEGORY_LIST */],
      proposal: selectedProposal,
      layerTitle: categoryListLayerHeaderTitle,
      totalPrice: Object(src_i18n["g" /* t */])('booking.transport.additionalTransports.totalPrice')
    }),
    onClose: closeActivityLayer
  }, CategoryList_jsx(ActivitiesLayer["a" /* ActivitiesLayer */], {
    currentCategoryId: layerState.categoryToShow,
    i18n: i18n,
    initialActivitiesCategoryIdToShow: layerState.activityToShow,
    activitiesCategories: // $FlowFixMe always found
    filteredActivityCategories.find(function (_ref6) {
      var id = _ref6.id;
      return id === layerState.categoryToShow;
    }).subCategories
  }), CategoryList_jsx(ContinueLayerBottomBar_ContinueLayerBottomBar, {
    continueAction: closeActivityLayer
  })));
};
// EXTERNAL MODULE: ./src/client/components/widgets/all-inclusive-list/AllInclusiveList.jsx
var AllInclusiveList = __webpack_require__("X0en");

// CONCATENATED MODULE: ./src/client/views/booking/activities/ActivitiesView.tracking.js


function ActivitiesView_tracking_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function ActivitiesView_tracking_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ActivitiesView_tracking_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ActivitiesView_tracking_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



function trackEditEquipment(appContext) {
  tracking_api["b" /* setDataLayer */](ActivitiesView_tracking_objectSpread(ActivitiesView_tracking_objectSpread({}, constants["i" /* GA_DEFAULT_PAYLOAD */]), {}, {
    categoryGA: 'bookingEngine',
    versionBooking: 'responsive',
    actionGA: 'activities',
    labelGA: 'editEquipment'
  }), appContext);
}
function trackValidateEquipment(appContext) {
  tracking_api["b" /* setDataLayer */](ActivitiesView_tracking_objectSpread(ActivitiesView_tracking_objectSpread({}, constants["i" /* GA_DEFAULT_PAYLOAD */]), {}, {
    categoryGA: 'bookingEngine',
    versionBooking: 'responsive',
    actionGA: 'activities',
    labelGA: 'validateEquipment'
  }), appContext);
}
// EXTERNAL MODULE: ./src/client/components/widgets/services-layer/ServicesLayer.jsx + 8 modules
var ServicesLayer = __webpack_require__("eu64");

// EXTERNAL MODULE: ./src/client/components/widgets/services-layer/ServicesContext.js
var ServicesContext = __webpack_require__("tjZu");

// EXTERNAL MODULE: ./src/client/views/booking/activities/chooseEquipment/ChooseEquipement.utils.js
var ChooseEquipement_utils = __webpack_require__("EgxT");

// CONCATENATED MODULE: ./src/client/views/booking/activities/chooseEquipment/ChooseEquipmentHeader.jsx
var ChooseEquipmentHeader_jsx = react_default.a.createElement;





var ChooseEquipmentHeader_Price = function Price(_ref) {
  var i18n = _ref.i18n,
      proposal = _ref.proposal,
      isTablet = _ref.isTablet;
  return isTablet ? ChooseEquipmentHeader_jsx("div", {
    className: "relative flex items-end md font-bold ChooseEquipment-layerPrice"
  }, ChooseEquipmentHeader_jsx("span", {
    className: "LayerHeaderProposal-totalLabel text-gray-dark"
  }, i18n.booking.accommodation.moreRooms.totalPackagePriceLabel), ChooseEquipmentHeader_jsx("span", {
    className: "LayerHeaderProposal-total"
  }, Object(proposalUtils["o" /* getTotalPriceFormatted */])(proposal))) : null;
};

var ChooseEquipmentHeader_ChooseEquipmentHeader = function ChooseEquipmentHeader(_ref2) {
  var i18n = _ref2.i18n,
      id = _ref2.id,
      proposal = _ref2.proposal,
      isTablet = _ref2.isTablet;
  return ChooseEquipmentHeader_jsx(react_default.a.Fragment, null, ChooseEquipmentHeader_jsx("div", {
    className: "flex items-center leading-one"
  }, ChooseEquipmentHeader_jsx(Title["a" /* Title */], {
    id: id,
    className: "m-auto",
    color: colors["a" /* COLORS */].BLUE,
    theme: "title-sans-4"
  }, i18n.booking.activities.skiEquipment.chooseCTA), ChooseEquipmentHeader_jsx(ChooseEquipmentHeader_Price, {
    proposal: proposal,
    i18n: i18n,
    isTablet: isTablet
  })));
};
// CONCATENATED MODULE: ./src/client/views/booking/activities/chooseEquipment/ChooseEquipment.jsx


var ChooseEquipment_jsx = react_default.a.createElement;

function ChooseEquipment_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ChooseEquipment_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ChooseEquipment_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ChooseEquipment_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


















var ChooseEquipment_ChooseEquipment = function ChooseEquipment(_ref) {
  var i18n = _ref.i18n,
      closeLayer = _ref.closeLayer,
      proposal = _ref.proposal,
      proposals = _ref.proposals;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var responsive = Object(react["useContext"])(responsiveContext["a" /* default */]);
  var dispatch = Object(es["d" /* useDispatch */])();
  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: 'activities',
    categoryGA: 'bookingEngine'
  });
  var attendeesWithInfos = Object(es["e" /* useSelector */])(booking_selector["i" /* getAttendeesWithInfos */]);

  if (proposal.additionalServices.rentals.length === 0) {
    return null;
  }

  var rentalServices = Object(ChooseEquipement_utils["b" /* groupRentalsByCategories */])(proposal.additionalServices.rentals);
  return ChooseEquipment_jsx(Layer["b" /* Layer */], {
    ariaLabel: Object(src_i18n["g" /* t */])('booking.activities.skiEquipment.chooseCTA'),
    ariaLabelledby: identifiers_constants["c" /* ID_LAYER_HEADER__BE__CHOOSE_EQUIPEMENT */],
    buttonLeft: {
      iconName: icons["a" /* ICONS */].LEFT_ARROW,
      label: Object(src_i18n["g" /* t */])('common.backNavigation'),
      onClick: closeLayer
    },
    closeLabel: Object(src_i18n["g" /* t */])('common.close'),
    hasContainerHeader: true,
    hasScrollLocked: true,
    header: ChooseEquipment_jsx(ChooseEquipmentHeader_ChooseEquipmentHeader, {
      i18n: i18n,
      id: identifiers_constants["c" /* ID_LAYER_HEADER__BE__CHOOSE_EQUIPEMENT */],
      isTablet: responsive.isTablet,
      proposal: proposal
    }),
    onClose: responsive.isTablet ? closeLayer : undefined
  }, ChooseEquipment_jsx(ServicesContext["a" /* ServicesContext */].Provider, {
    value: {
      hideAgeServiceSlot: true,
      attendeesList: [].concat(Object(toConsumableArray["a" /* default */])(attendeesWithInfos.adults), Object(toConsumableArray["a" /* default */])(attendeesWithInfos.children.map(function (child) {
        return ChooseEquipment_objectSpread(ChooseEquipment_objectSpread({}, child), {}, {
          isChild: true
        });
      }))),
      updateService: function updateService(attendees, pricingInfo, serviceIds, attendeeIds) {
        // $FlowFixMe always found
        var serviceData = proposal.additionalServices.rentals.find(function (_ref2) {
          var pricingInfosFromProposal = _ref2.pricingInfo;
          return pricingInfosFromProposal.id === pricingInfo.id;
        });
        var labelGASuffix = attendees.length === 0 ? 'deleteRent' : 'validateRent';
        track({
          labelGA: "".concat(ChooseEquipement_utils["a" /* RENTAL_LABELS */][serviceData.productInfo.useCase.id], "_").concat(serviceData.pricingInfo.isPartiallyRented ? 'edit' : 'add', "_").concat(serviceData.productInfo.typeId, "_").concat(labelGASuffix)
        });

        if (attendees.length === 0) {
          return dispatch(Object(proposals_action["f" /* deleteAdditionalServices */])({
            proposalIds: proposals.map(function (_ref3) {
              var id = _ref3.id;
              return id;
            }),
            showNotification: true,
            serviceIds: serviceIds,
            attendeeIds: attendeeIds,
            appContext: appContext
          }));
        }

        return dispatch(Object(proposals_action["c" /* addOrReplaceAdditionalServices */])({
          proposalIds: proposals.map(function (_ref4) {
            var id = _ref4.id;
            return id;
          }),
          showNotification: true,
          attendees: attendees,
          appContext: appContext
        }));
      },
      trackingData: {
        actionGA: 'activities',
        categoryGA: 'bookingEngine'
      },
      currency: proposal.price.currency,
      showRentAllSchedules: true
    }
  }, ChooseEquipment_jsx(ServicesLayer["a" /* ServicesLayer */], {
    i18n: i18n,
    services: rentalServices,
    hasBackgroundMask: false
  })), ChooseEquipment_jsx(ContinueLayerBottomBar_ContinueLayerBottomBar, {
    continueAction: function continueAction() {
      closeLayer();
      trackValidateEquipment(appContext);
    }
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/reserved-services-wrapper/EditButton.jsx
var EditButton_jsx = react_default.a.createElement;



var EditButton_EditButton = function EditButton(_ref) {
  var label = _ref.label,
      onClick = _ref.onClick;
  return EditButton_jsx("div", {
    className: "text-right"
  }, EditButton_jsx("button", {
    type: "button",
    className: "self-end cursor-pointer bg-transparent text-blue-active p-0 flex items-center",
    onClick: onClick
  }, EditButton_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].PEN,
    width: "1.25rem",
    className: "mr-px5"
  }), EditButton_jsx("span", {
    className: "underline align-top"
  }, label)));
};
// CONCATENATED MODULE: ./src/client/views/booking/activities/ReservedServicesWrapper.jsx
var ReservedServicesWrapper_jsx = react_default.a.createElement;


















var CHOOSE_SKI_EQUIPMENT_LAYER = 'chooseSkiEquipment';
var ReservedServicesWrapper_ReservedServicesWrapper = function ReservedServicesWrapper(_ref) {
  var i18n = _ref.i18n,
      proposal = _ref.proposal,
      proposals = _ref.proposals,
      resort = _ref.resort,
      hasActivitiesAvailable = _ref.hasActivitiesAvailable,
      hasWellnessActivitiesAvailable = _ref.hasWellnessActivitiesAvailable,
      handleSkiClick = _ref.handleSkiClick,
      handleActivityClick = _ref.handleActivityClick,
      handleWellnessExperienceClick = _ref.handleWellnessExperienceClick,
      _closeLayer = _ref.closeLayer;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var reservedServicesByAttendee = Object(es["e" /* useSelector */])(booking_selector["w" /* getReservedServicesByAttendee */]);
  var currentResort = Object(es["e" /* useSelector */])(booking_selector["l" /* getCurrentResort */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var isChildcareAvailable = currentResort === null || currentResort === void 0 ? void 0 : currentResort.childcareDetails.some(function (_ref2) {
    var isIncluded = _ref2.isIncluded;
    return isIncluded;
  });
  var isWinterResort = Object(resortUtils["a" /* isWinterMountainResort */])(resort);
  var hasRentedActivities = reservedServicesByAttendee.some(function (_ref3) {
    var rentedServices = _ref3.rentedServices;
    return rentedServices.some(function (_ref4) {
      var services = _ref4.services;
      return services.some(function (service) {
        return ['EXCURSION', 'WATER_SPORT', 'LAND_SPORT', 'WINTER_SPORT', 'WELLNESS'].includes(service.pricingInfo.type);
      });
    });
  });
  var hasRentedEquipments = reservedServicesByAttendee.some(function (_ref5) {
    var rentedServices = _ref5.rentedServices;
    return rentedServices.some(function (_ref6) {
      var services = _ref6.services;
      return services.some(function (service) {
        return service.pricingInfo.type === 'RENTAL';
      });
    });
  });
  var hasRentedWellnessExperiences = reservedServicesByAttendee.some(function (_ref7) {
    var rentedServices = _ref7.rentedServices;
    return rentedServices.some(function (_ref8) {
      var services = _ref8.services;
      return services.some(function (service) {
        return service.pricingInfo.type === 'WELLNESS';
      });
    });
  });
  var allInclusiveListItems = [{
    icon: icons["a" /* ICONS */].SKI,
    title: Object(src_i18n["g" /* t */])('booking.activities.skiPackage.skiPass')
  }, {
    icon: icons["a" /* ICONS */].SKI,
    title: isWinterResort && !isChildcareAvailable ? Object(src_i18n["g" /* t */])('booking.activities.skiPackage.groupLessonsWithoutChildcare') : Object(src_i18n["g" /* t */])('booking.activities.skiPackage.groupLessons')
  }];
  return ReservedServicesWrapper_jsx(react["Fragment"], null, ReservedServicesWrapper_jsx("div", {
    className: "flex flex-col md:flex-row",
    "data-testid": "ReservedServicesWrapper"
  }, isWinterResort && proposal.additionalServices.rentals.length > 0 && ReservedServicesWrapper_jsx("div", {
    className: "flex-shrink-0 mb-px15 md:w-3/10 md:rtl:mr-px15 md:mb-0"
  }, ReservedServicesWrapper_jsx(Title["a" /* Title */], {
    className: "mb-px10",
    theme: "title-sans-4",
    color: colors["a" /* COLORS */].BLUE
  }, Object(src_i18n["g" /* t */])('booking.activities.skiPackage.title')), ReservedServicesWrapper_jsx(AllInclusiveList["a" /* AllInclusiveList */], {
    items: allInclusiveListItems,
    i18n: i18n
  })), ReservedServicesWrapper_jsx("div", {
    className: "w-full"
  }, ReservedServicesWrapper_jsx(Title["a" /* Title */], {
    className: "mb-px10",
    theme: "title-sans-4",
    color: colors["a" /* COLORS */].BLUE
  }, Object(src_i18n["g" /* t */])('booking.activities.myPackage.title')), ReservedServicesWrapper_jsx("div", {
    className: classnames_default()('flex flex-col w-full', {
      '-ml-px10': reservedServicesByAttendee.length > 0
    })
  }, reservedServicesByAttendee.length === 0 ? ReservedServicesWrapper_jsx("div", {
    className: "relative mb-px20 w-full"
  }, ReservedServicesWrapper_jsx("div", {
    className: "flex"
  }, isTablet ? ReservedServicesWrapper_jsx(react["Fragment"], null, isWinterResort && proposal.additionalServices.rentals.length > 0 ? ReservedServicesWrapper_jsx(react["Fragment"], null, ReservedServicesWrapper_jsx("div", {
    className: "AccessSkiEquipment-box"
  }, ReservedServicesWrapper_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].SKI_AND_POLES,
    width: "5rem"
  })), ReservedServicesWrapper_jsx("div", {
    className: "AccessSkiEquipment-box"
  }), ReservedServicesWrapper_jsx("div", {
    className: "AccessSkiEquipment-box"
  }, ReservedServicesWrapper_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].TENNIS,
    width: "5rem",
    isNotSquare: true
  }))) : ReservedServicesWrapper_jsx(react["Fragment"], null, ReservedServicesWrapper_jsx("div", {
    className: "AccessSkiEquipment-box"
  }, ReservedServicesWrapper_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].GOLF,
    width: "4rem",
    isNotSquare: true
  })), ReservedServicesWrapper_jsx("div", {
    className: "AccessSkiEquipment-box"
  }, ReservedServicesWrapper_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].BADMINTON,
    width: "5rem",
    isNotSquare: true
  })), ReservedServicesWrapper_jsx("div", {
    className: "AccessSkiEquipment-box"
  }), ReservedServicesWrapper_jsx("div", {
    className: "AccessSkiEquipment-box"
  }), ReservedServicesWrapper_jsx("div", {
    className: "AccessSkiEquipment-box"
  }, ReservedServicesWrapper_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].BIKE_RENTAL,
    width: "5rem",
    isNotSquare: true
  })), ReservedServicesWrapper_jsx("div", {
    className: "AccessSkiEquipment-box"
  }, isTablet && ReservedServicesWrapper_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].TENNIS,
    width: "5rem",
    isNotSquare: true
  })))) : ReservedServicesWrapper_jsx(react["Fragment"], null, ReservedServicesWrapper_jsx("div", {
    className: "AccessSkiEquipment-box"
  }), ReservedServicesWrapper_jsx("div", {
    className: "AccessSkiEquipment-box"
  }))), ReservedServicesWrapper_jsx("div", {
    className: "AccessSkiEquipment-description text-xl text-center font-bold w-full"
  }, Object(src_i18n["g" /* t */])(isWinterResort && proposal.additionalServices.rentals.length > 0 ? 'booking.activities.skiEquipment.selectEquipmentDescription' : 'booking.activities.selectActivities'))) : ReservedServicesWrapper_jsx(ReservedServicesList["a" /* ReservedServicesList */], {
    isWinterResort: isWinterResort,
    reservedServicesByAttendee: reservedServicesByAttendee,
    currency: proposal.price.currency,
    scrollBackwardLabel: Object(src_i18n["g" /* t */])('common.scrollBackward'),
    scrollForwardLabel: Object(src_i18n["g" /* t */])('common.scrollForward')
  })), ReservedServicesWrapper_jsx("div", {
    className: "flex justify-center items-center flex-col md:flex-row mt-px20"
  }, isWinterResort && proposal.additionalServices.rentals.length > 0 && ReservedServicesWrapper_jsx(react["Fragment"], null, hasRentedEquipments ? ReservedServicesWrapper_jsx(EditButton_EditButton, {
    label: Object(src_i18n["g" /* t */])('booking.activities.skiEquipment.editMyEquipment'),
    onClick: function onClick() {
      return handleSkiClick(true);
    }
  }) : ReservedServicesWrapper_jsx(Button["a" /* Button */], {
    colorBg: colors["a" /* COLORS */].TURQUOISE,
    colorBorder: colors["a" /* COLORS */].TURQUOISE,
    onClick: handleSkiClick
  }, Object(src_i18n["g" /* t */])('booking.activities.skiEquipment.chooseCTA')), hasActivitiesAvailable && ReservedServicesWrapper_jsx("span", {
    className: "text-base text-gray-medium mx-px15 my-px10"
  }, Object(src_i18n["g" /* t */])('booking.common.or'))), hasActivitiesAvailable && (hasRentedActivities ? ReservedServicesWrapper_jsx(EditButton_EditButton, {
    label: Object(src_i18n["g" /* t */])('booking.activities.editActivities'),
    onClick: function onClick() {
      return handleActivityClick(true);
    }
  }) : ReservedServicesWrapper_jsx(Button["a" /* Button */], {
    colorBg: colors["a" /* COLORS */].TURQUOISE,
    colorBorder: colors["a" /* COLORS */].TURQUOISE,
    onClick: handleActivityClick
  }, Object(src_i18n["g" /* t */])('booking.activities.chooseActivities'))), hasWellnessActivitiesAvailable && ReservedServicesWrapper_jsx("span", {
    className: "text-base text-gray-medium mx-4 my-2"
  }, Object(src_i18n["g" /* t */])('booking.common.or')), hasWellnessActivitiesAvailable && (hasRentedWellnessExperiences ? ReservedServicesWrapper_jsx(EditButton_EditButton, {
    className: "text-md font-bold",
    label: Object(src_i18n["g" /* t */])('booking.activities.wellness.editCTA'),
    onClick: function onClick() {
      return handleWellnessExperienceClick(true);
    }
  }) : ReservedServicesWrapper_jsx(Button["a" /* Button */], {
    colorBg: colors["a" /* COLORS */].TURQUOISE,
    colorBorder: colors["a" /* COLORS */].TURQUOISE,
    onClick: handleWellnessExperienceClick
  }, Object(src_i18n["g" /* t */])('booking.activities.wellness.chooseCTA')))))), location.queryParams[dist["appQueryParameters"].openLayer] === CHOOSE_SKI_EQUIPMENT_LAYER && ReservedServicesWrapper_jsx(ChooseEquipment_ChooseEquipment, {
    i18n: i18n,
    closeLayer: function closeLayer() {
      return _closeLayer(false);
    },
    proposal: proposal,
    proposals: proposals
  }));
};
// CONCATENATED MODULE: ./src/client/views/booking/activities/ActivitiesView.jsx



var ActivitiesView_jsx = react_default.a.createElement;

function ActivitiesView_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ActivitiesView_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ActivitiesView_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ActivitiesView_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable no-shadow */















var ActivitiesView_ActivitiesView = function ActivitiesView(_ref) {
  var i18n = _ref.i18n,
      resort = _ref.resort,
      renderBottomNavbar = _ref.renderBottomNavbar,
      openLayer = _ref.openLayer,
      closeLayer = _ref.closeLayer,
      selectedProposal = _ref.selectedProposal,
      proposals = _ref.proposals;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var dispatch = Object(es["d" /* useDispatch */])();
  var activitiesBlock = Object(react["useRef"])();
  var wellnessBlock = Object(react["useRef"])();
  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: 'activities',
    categoryGA: 'bookingEngine'
  });
  var wellnessActivities = selectedProposal.additionalServices.activities.filter(function (activity) {
    return activity.pricingInfo.type === 'WELLNESS';
  });
  var hasWellnessActivitiesAvailable = wellnessActivities.length > 0;
  var hasActivitiesAvailable = selectedProposal.additionalServices.activities.length > 0;
  var attendeesWithInfos = Object(es["e" /* useSelector */])(booking_selector["i" /* getAttendeesWithInfos */]); // without all activities containing the tag activity_tag_rental_equipment ( FOR LAYER ACTIVITIES )

  var filteredActivityCategoriesNotChildrenLayer = resort.activityCategories.leisure.map(function (activityCategory) {
    var subCategories = activityCategory.subCategories.map(function (subCategory) {
      var activities = subCategory.activities.filter(function (activity) {
        return !activity.activityTags.some(function (tag) {
          return tag.id === 'activity_tag_rental_equipment';
        });
      });
      return ActivitiesView_objectSpread(ActivitiesView_objectSpread({}, subCategory), {}, {
        activities: activities
      });
    });
    return ActivitiesView_objectSpread(ActivitiesView_objectSpread({}, activityCategory), {}, {
      subCategories: subCategories
    });
  });
  var filteredWellnessExperiencesCategoriesNotChildrenLayer = resort.activityCategories.wellness.map(function (wellnessExperienceCategory) {
    var subCategories = wellnessExperienceCategory.subCategories.map(function (subCategory) {
      var activities = subCategory.activities.filter(function (activity) {
        return !activity.activityTags.some(function (tag) {
          return tag.id === 'activity_tag_rental_equipment';
        });
      });
      return ActivitiesView_objectSpread(ActivitiesView_objectSpread({}, subCategory), {}, {
        activities: activities
      });
    });
    return ActivitiesView_objectSpread(ActivitiesView_objectSpread({}, wellnessExperienceCategory), {}, {
      subCategories: subCategories
    });
  });
  return ActivitiesView_jsx(react["Fragment"], null, ActivitiesView_jsx(ActivitiesContext["a" /* ActivitiesContext */].Provider, {
    value: {
      attendeesList: [].concat(Object(toConsumableArray["a" /* default */])(attendeesWithInfos.adults), Object(toConsumableArray["a" /* default */])(attendeesWithInfos.children.map(function (child) {
        return ActivitiesView_objectSpread(ActivitiesView_objectSpread({}, child), {}, {
          isChild: true
        });
      }))),
      availableActivities: selectedProposal.additionalServices.activities,
      updateService: function updateService(attendees, pricingInfo, serviceIds, attendeeIds) {
        var labelGA = Object(string_util["d" /* snakeToCamel */])(pricingInfo.type.toLowerCase().replace('rental', 'ski'));

        if (attendees.length === 0) {
          track({
            labelGA: labelGA,
            actionGA: 'removeFromCart'
          });
          return dispatch(Object(proposals_action["f" /* deleteAdditionalServices */])({
            proposalIds: proposals.map(function (_ref2) {
              var id = _ref2.id;
              return id;
            }),
            showNotification: true,
            serviceIds: serviceIds,
            attendeeIds: attendeeIds,
            appContext: appContext
          }));
        }

        track({
          labelGA: labelGA,
          actionGA: 'addToCart'
        });
        return dispatch(Object(proposals_action["c" /* addOrReplaceAdditionalServices */])({
          proposalIds: proposals.map(function (_ref3) {
            var id = _ref3.id;
            return id;
          }),
          showNotification: true,
          attendees: attendees,
          appContext: appContext
        }));
      },
      deleteService: function deleteService(services, attendeeIds) {
        track({
          labelGA: Object(string_util["d" /* snakeToCamel */])(services[0].pricingInfo.type.toLowerCase().replace('rental', 'ski')),
          actionGA: 'removeFromCart'
        }); // find the serviceIds to be deleted

        var serviceIds = services.reduce(function (serviceIds, service) {
          var _service$pricingInfo$ = service.pricingInfo.attendees.filter(function (attendee) {
            return attendee.id === attendeeIds;
          }),
              _service$pricingInfo$2 = Object(slicedToArray["a" /* default */])(_service$pricingInfo$, 1),
              attendee = _service$pricingInfo$2[0];

          return [].concat(Object(toConsumableArray["a" /* default */])(serviceIds), Object(toConsumableArray["a" /* default */])(attendee.schedules.reduce(function (scheduleAccumulator, schedule) {
            return schedule.timeSlots.reduce(function (timeSlotAccumulator, timeSlot) {
              return timeSlotAccumulator.includes(timeSlot.id) ? timeSlotAccumulator : [].concat(Object(toConsumableArray["a" /* default */])(timeSlotAccumulator), [timeSlot.id]);
            }, scheduleAccumulator);
          }, serviceIds)));
        }, []);
        return dispatch(Object(proposals_action["f" /* deleteAdditionalServices */])({
          proposalIds: proposals.map(function (_ref4) {
            var id = _ref4.id;
            return id;
          }),
          showNotification: true,
          serviceIds: serviceIds,
          attendeeIds: attendeeIds,
          appContext: appContext
        }));
      },
      currency: selectedProposal.price.currency,
      trackingData: {
        actionGA: 'activities',
        categoryGA: 'bookingEngine'
      }
    }
  }, ActivitiesView_jsx(ReservedServicesWrapper_ReservedServicesWrapper, {
    i18n: i18n,
    resort: resort,
    closeLayer: closeLayer,
    proposal: selectedProposal,
    proposals: proposals,
    handleSkiClick: function handleSkiClick() {
      var isEditing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      track({
        // isEditing can be an event object
        labelGA: isEditing === true ? 'editEquipment' : 'chooseEquipment'
      });
      openLayer(CHOOSE_SKI_EQUIPMENT_LAYER);
    },
    handleActivityClick: function handleActivityClick() {
      var isEditing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      track({
        // isEditing can be an event object
        labelGA: isEditing === true ? 'editActivity' : 'chooseActivity'
      });
      Object(scrollToElement["a" /* scrollToElement */])(activitiesBlock.current, 200);
    },
    handleWellnessExperienceClick: function handleWellnessExperienceClick() {
      var isEditing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      track({
        // isEditing can be an event object
        labelGA: isEditing === true ? 'editSpaCare' : 'chooseSpaCare'
      });
      Object(scrollToElement["a" /* scrollToElement */])(wellnessBlock.current, 200);
    },
    hasActivitiesAvailable: hasActivitiesAvailable,
    hasWellnessActivitiesAvailable: hasWellnessActivitiesAvailable
  }), hasActivitiesAvailable && ActivitiesView_jsx("div", {
    className: "max-w-site-small mt-px30 mx-auto"
  }, ActivitiesView_jsx(Notification["a" /* Notification */], {
    hasBorder: true,
    icon: icons["a" /* ICONS */].URGENTISATION,
    iconWidth: "2.8rem",
    color: colors["a" /* COLORS */].ORANGE,
    title: Object(src_i18n["g" /* t */])('booking.activities.urgentization')
  })), ActivitiesView_jsx("div", {
    ref: activitiesBlock,
    className: "text-blue mt-px40 mb-px15"
  }, ActivitiesView_jsx("span", {
    className: "font-bold text-lg"
  }, Object(src_i18n["g" /* t */])('booking.activities.title')), "\xA0", "(".concat(Object(src_i18n["g" /* t */])('booking.activities.activitiesIncludedAmount', {
    amount: filteredActivityCategoriesNotChildrenLayer.reduce(function (totalActivitiesNumber, _ref5) {
      var subCategories = _ref5.subCategories;
      return totalActivitiesNumber + subCategories.reduce(function (activitiesNumber, _ref6) {
        var activities = _ref6.activities;
        return activitiesNumber + activities.length;
      }, 0);
    }, 0)
  }), ")")), ActivitiesView_jsx(CategoryList_CategoryList, {
    i18n: i18n,
    selectedProposal: selectedProposal,
    filteredActivityCategories: filteredActivityCategoriesNotChildrenLayer,
    type: "Activities"
  }), ActivitiesView_jsx("div", {
    ref: wellnessBlock,
    className: "text-blue mt-10 mb-4"
  }, ActivitiesView_jsx("span", {
    className: "font-bold text-lg"
  }, Object(src_i18n["g" /* t */])('booking.activities.wellness.title')), "\xA0", "(".concat(Object(src_i18n["g" /* t */])('booking.activities.activitiesIncludedAmount', {
    amount: filteredWellnessExperiencesCategoriesNotChildrenLayer.reduce(function (totalActivitiesNumber, _ref7) {
      var subCategories = _ref7.subCategories;
      return totalActivitiesNumber + subCategories.reduce(function (activitiesNumber, _ref8) {
        var activities = _ref8.activities;
        return activitiesNumber + activities.length;
      }, 0);
    }, 0)
  }), ")")), ActivitiesView_jsx(CategoryList_CategoryList, {
    i18n: i18n,
    selectedProposal: selectedProposal,
    filteredActivityCategories: filteredWellnessExperiencesCategoriesNotChildrenLayer,
    type: "Wellness"
  })), renderBottomNavbar());
};
// EXTERNAL MODULE: /opt/webapp/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("fYnN");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ./src/client/components/widgets/accommodations/BookingAccommodationsUtils.js
var BookingAccommodationsUtils = __webpack_require__("cb6o");

// EXTERNAL MODULE: ./src/utils/payment/constants.js
var payment_constants = __webpack_require__("hi3+");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/constants.js
var contact_info_constants = __webpack_require__("ZOp8");

// CONCATENATED MODULE: ./src/client/components/widgets/del-credere-booking/DelCredereBooking.utils.js


function DelCredereBooking_utils_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function DelCredereBooking_utils_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      DelCredereBooking_utils_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      DelCredereBooking_utils_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}












var DelCredereBooking_utils_getQuery = function getQuery(proposal, appContext, salesmanID) {
  return "\nmutation {\n  bookings(\n    proposalId: \"".concat((proposal === null || proposal === void 0 ? void 0 : proposal.id) || '', "\"\n    bookingStatus: VALIDATED\n    ").concat(appContext.cmta.email ? "sellerEmail: \"".concat(appContext.cmta.email, "\"") : '', "\n    ").concat(salesmanID ? "salesmanID: \"".concat(salesmanID, "\"") : '', "\n  ) {\n    bookingId\n  }\n}\n");
};

var DelCredereBooking_utils_submitDelCredereBooking = function submitDelCredereBooking(_ref) {
  var appContext = _ref.appContext,
      location = _ref.location,
      proposal = _ref.proposal,
      salesmanID = _ref.salesmanID;
  Object(BookingEngine_tracking["b" /* trackDelCredereBanking */])({
    labelGA: 'clickValidateBanking',
    paymentMethod: 'Ducroire',
    orderID_PSP: null
  }, appContext);
  js_cookie_default.a.set("".concat(contact_info_constants["f" /* SALESMAN_ID_WARNING_MESSAGE */], "-").concat(proposal.id), salesmanID === '' ? 'show' : 'hide', {
    secure: !Object(contextUtils["d" /* isStrictlyDevelopmentEnv */])()
  });
  var queryWithSalesmanID = DelCredereBooking_utils_getQuery(proposal, appContext, salesmanID);
  var queryWithoutSalesmanID = DelCredereBooking_utils_getQuery(proposal, appContext);
  var redirect = redirectUtils["a" /* default */].redirectToUri();

  var handleSuccess = function handleSuccess(response) {
    var _response$bookings;

    Object(BookingEngine_tracking["b" /* trackDelCredereBanking */])({
      labelGA: 'validateBanking',
      paymentPlan: 'full payment'
    }, appContext);
    var url = Object(routeBuilder["a" /* buildUrl */])('confirmation', {
      status: statusCode_constants["a" /* STATUS_CODE_200 */]
    }, DelCredereBooking_utils_objectSpread(DelCredereBooking_utils_objectSpread({}, location.queryParams), {}, {
      bi: (response === null || response === void 0 ? void 0 : (_response$bookings = response.bookings) === null || _response$bookings === void 0 ? void 0 : _response$bookings.bookingId) || '',
      paymentStatus: payment_constants["q" /* PAYMENT_STATUS_SUCCESS */]
    }));
    redirect(url)();
  };

  var handleError = function handleError(error) {
    var _error$errors, _error$errors$, _error$errors$$respon, _error$errors2, _error$errors2$, _error$errors2$$respo, _error$errors2$$respo2, _error$errors2$$respo3, _error$errors3, _error$errors3$, _error$errors3$$respo, _error$errors3$$respo2, _error$errors3$$respo3;

    Object(BookingEngine_tracking["b" /* trackDelCredereBanking */])({
      labelGA: 'errorValidateBanking',
      paymentPlan: 'full payment'
    }, appContext);
    var status = (error === null || error === void 0 ? void 0 : (_error$errors = error.errors) === null || _error$errors === void 0 ? void 0 : (_error$errors$ = _error$errors[0]) === null || _error$errors$ === void 0 ? void 0 : (_error$errors$$respon = _error$errors$.responseBody) === null || _error$errors$$respon === void 0 ? void 0 : _error$errors$$respon.status_code) || statusCode_constants["b" /* STATUS_CODE_400 */];
    var error_code = (error === null || error === void 0 ? void 0 : (_error$errors2 = error.errors) === null || _error$errors2 === void 0 ? void 0 : (_error$errors2$ = _error$errors2[0]) === null || _error$errors2$ === void 0 ? void 0 : (_error$errors2$$respo = _error$errors2$.responseBody) === null || _error$errors2$$respo === void 0 ? void 0 : (_error$errors2$$respo2 = _error$errors2$$respo.errors) === null || _error$errors2$$respo2 === void 0 ? void 0 : (_error$errors2$$respo3 = _error$errors2$$respo2[0]) === null || _error$errors2$$respo3 === void 0 ? void 0 : _error$errors2$$respo3.error_code) || 'BOOKING_UNAVAILABLE';
    var error_description = error === null || error === void 0 ? void 0 : (_error$errors3 = error.errors) === null || _error$errors3 === void 0 ? void 0 : (_error$errors3$ = _error$errors3[0]) === null || _error$errors3$ === void 0 ? void 0 : (_error$errors3$$respo = _error$errors3$.responseBody) === null || _error$errors3$$respo === void 0 ? void 0 : (_error$errors3$$respo2 = _error$errors3$$respo.errors) === null || _error$errors3$$respo2 === void 0 ? void 0 : (_error$errors3$$respo3 = _error$errors3$$respo2[0]) === null || _error$errors3$$respo3 === void 0 ? void 0 : _error$errors3$$respo3.error_description;

    if (status === statusCode_constants["b" /* STATUS_CODE_400 */] && error_code === contact_info_constants["i" /* WRONG_SALESMAN_ID */]) {
      js_cookie_default.a.set("".concat(contact_info_constants["f" /* SALESMAN_ID_WARNING_MESSAGE */], "-").concat(proposal.id), 'show', {
        secure: !Object(contextUtils["d" /* isStrictlyDevelopmentEnv */])()
      });
      return graphqlClient["a" /* default */].runNoCacheQuery(queryWithoutSalesmanID, appContext, {
        requestName: requestDictionary["vd" /* PROPOSAL_UPDATE */]
      }).then(handleSuccess)["catch"](handleError);
    }

    var url = Object(routeBuilder["a" /* buildUrl */])('confirmation', {
      error_code: error_code,
      error_description: error_description,
      status: status
    }, DelCredereBooking_utils_objectSpread(DelCredereBooking_utils_objectSpread({}, location.queryParams), {}, {
      paymentStatus: payment_constants["l" /* PAYMENT_STATUS_FAILURE */]
    }));
    redirect(url)();
  };

  return graphqlClient["a" /* default */].runNoCacheQuery(queryWithSalesmanID, appContext, {
    requestName: requestDictionary["vd" /* PROPOSAL_UPDATE */]
  }).then(handleSuccess)["catch"](handleError);
};
// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/payment-form/TermsAndConditions.jsx
var TermsAndConditions = __webpack_require__("LhnV");

// CONCATENATED MODULE: ./src/client/components/widgets/del-credere-booking/DelCrederePaymentForm.jsx
var DelCrederePaymentForm_jsx = react_default.a.createElement;






var DelCrederePaymentForm_DelCrederePaymentForm = function DelCrederePaymentForm(_ref) {
  var i18n = _ref.i18n;
  return DelCrederePaymentForm_jsx(react["Fragment"], null, DelCrederePaymentForm_jsx(Title["a" /* Title */], {
    className: "mb-px10",
    color: colors["a" /* COLORS */].BLUE,
    theme: "title-sans-4"
  }, Object(src_i18n["g" /* t */])('booking.banking.pageTitle')), DelCrederePaymentForm_jsx(Capsule["a" /* Capsule */], {
    className: "mb-px20"
  }, DelCrederePaymentForm_jsx("p", {
    className: "leading-one px-px20 py-px25 reset-paragraph text-base"
  }, Object(src_i18n["g" /* t */])('booking.partners.payment.ducroire'))), DelCrederePaymentForm_jsx(TermsAndConditions["a" /* TermsAndConditions */], {
    i18n: i18n,
    isDisabled: false,
    shouldDisplayDonationTerms: false,
    shouldSubmitFormOnAccept: false
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/del-credere-booking/DelCredereBooking.jsx
var DelCredereBooking_jsx = react_default.a.createElement;









var DelCredereBooking_DelCredereBooking = function DelCredereBooking(_ref) {
  var i18n = _ref.i18n,
      renderBottomNavbar = _ref.renderBottomNavbar,
      selectedProposal = _ref.selectedProposal,
      totalPrice = _ref.totalPrice;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var _useState = Object(react["useState"])(false),
      isCmtaContinueButtonDisabled = _useState[0],
      setIsCmtaContinueButtonDisabled = _useState[1];

  var dispatch = Object(es["d" /* useDispatch */])();
  var salesmanID = Object(es["e" /* useSelector */])(function (state) {
    return state.seller.sellerInfo.salesmanID;
  });
  return DelCredereBooking_jsx(SiteContainer["a" /* SiteContainer */], {
    size: "small"
  }, DelCredereBooking_jsx(formik_esm["d" /* Formik */], {
    initialValues: {
      amountToPay: totalPrice,
      paymentProviderId: '',
      paymentMethodId: '',
      paymentConditionId: '',
      termsAndConditions: {
        cgv: false,
        donation: false
      },
      donation: null
    },
    onSubmit: function onSubmit() {
      DelCredereBooking_utils_submitDelCredereBooking({
        appContext: appContext,
        location: location,
        proposal: selectedProposal,
        salesmanID: salesmanID
      });
    },
    isInitialValid: false
  }, function (formik) {
    return DelCredereBooking_jsx(formik_esm["c" /* Form */], null, DelCredereBooking_jsx(DelCrederePaymentForm_DelCrederePaymentForm, {
      i18n: i18n
    }), renderBottomNavbar({
      validationCallback: function validationCallback() {
        if (appContext.isCmta && formik.values.termsAndConditions.cgv) {
          setIsCmtaContinueButtonDisabled(true);
          dispatch(Object(globalLoader_action["d" /* startLoading */])());
        }

        formik.submitForm();
        return Promise.reject();
      },
      isPriceLoading: isCmtaContinueButtonDisabled
    }));
  }));
};
// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/PaymentInfo.jsx + 26 modules
var PaymentInfo = __webpack_require__("yzIS");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/PaymentInfoContext.js
var PaymentInfoContext = __webpack_require__("lr0Z");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/PaymentInfo.utils.js
var PaymentInfo_utils = __webpack_require__("gX9k");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/payment-form/paymentProvidersUtils.js
var paymentProvidersUtils = __webpack_require__("y5B/");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/PaymentInfo.const.js
var PaymentInfo_const = __webpack_require__("BU6i");

// EXTERNAL MODULE: ./src/client/tracking/tracking-storage-api/index.js
var tracking_storage_api = __webpack_require__("K0Lv");

// EXTERNAL MODULE: ./src/utils/payment/payment.utils.js
var payment_utils = __webpack_require__("aMaj");

// CONCATENATED MODULE: ./src/utils/graphql-query-helper/booking/payment-redirect/paymentRedirectQuery.js









function paymentRedirectMutation(proposalId, appContext, params, location) {
  var callbackUrl = Object(payment_utils["a" /* getCallbackURIFromProvider */])(params.providerId, appContext, location);
  var paymentConditionQuery = params.paymentConditionId ? "paymentConditionId: \"".concat(params.paymentConditionId, "\"") : '';
  var token = params.token ? "token: \"".concat(params.token, "\"") : '';
  var browserInfo = params.browserInfo ? "browserInfo: \"".concat(params.browserInfo, "\"") : '';
  var donationAmount = params.donationAmount ? "donationAmount: ".concat(params.donationAmount) : '';
  var creditCardCvc = params.creditCardCvc ? "creditCardCvc: \"".concat(params.creditCardCvc, "\"") : '';
  var isWrongSalesmanID = js_cookie_default.a.get("".concat(contact_info_constants["f" /* SALESMAN_ID_WARNING_MESSAGE */], "-").concat(proposalId)) === 'show';
  var salesmanID = !isWrongSalesmanID && params.salesmanID ? "salesmanID: \"".concat(params === null || params === void 0 ? void 0 : params.salesmanID, "\"") : '';
  var sellerEmail = params.sellerEmail ? "sellerEmail: \"".concat(params === null || params === void 0 ? void 0 : params.sellerEmail, "\"") : '';

  function getQuery(salesmanIdParam) {
    return "\n    mutation {\n      bookingsPaymentRedirect(\n        ".concat(browserInfo, "\n        ").concat(creditCardCvc, "\n        ").concat(salesmanIdParam, "\n        ").concat(sellerEmail, "\n        callbackUrl: \"").concat(callbackUrl, "\"\n        cancelUrl: \"").concat(Object(payment_utils["b" /* getCancelCallbackURI */])(appContext, location), "\"\n        currency: \"").concat(params.proposalCurrency, "\"\n        deploymentEnv: \"").concat(config_default.a.get('DEPLOYMENT_ENV'), "\"\n        ").concat(donationAmount, "\n        iframeCallbackUrl: \"").concat(Object(payment_utils["c" /* getIframeCallbackUrl */])(location), "\"\n        isIframePayment: ").concat((params.isIframe || false).toString(), "\n        isMobile: ").concat((params.isMobile || false).toString(), "\n        ").concat(paymentConditionQuery, "\n        price: ").concat(params.proposalPrice, "\n        proposalId: \"").concat(proposalId, "\"\n        providerId: \"").concat(params.providerId, "\"\n        shouldUseLegacyTemplate: ").concat(Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext, params.isMobile)('booking.paymentToLegacyTemplate').toString(), "\n        ").concat(token, "\n      ) {\n          method\n          url\n          fields\n          bookingId\n          orderId\n          customerId\n          price {\n            value\n          }\n          donationAmount\n        }\n      }");
  }

  var queryWithSalesmanId = getQuery(salesmanID);
  return graphqlClient["a" /* default */].runNoCacheQuery(queryWithSalesmanId, appContext, {
    requestName: requestDictionary["ed" /* PAYMENT_REDIRECT */]
  })["catch"](function (error) {
    var _error$errors, _error$errors$, _error$errors$$respon, _error$errors$$respon2, _error$errors$$respon3;

    var errorCode = error === null || error === void 0 ? void 0 : (_error$errors = error.errors) === null || _error$errors === void 0 ? void 0 : (_error$errors$ = _error$errors[0]) === null || _error$errors$ === void 0 ? void 0 : (_error$errors$$respon = _error$errors$.responseBody) === null || _error$errors$$respon === void 0 ? void 0 : (_error$errors$$respon2 = _error$errors$$respon.errors) === null || _error$errors$$respon2 === void 0 ? void 0 : (_error$errors$$respon3 = _error$errors$$respon2[0]) === null || _error$errors$$respon3 === void 0 ? void 0 : _error$errors$$respon3.error_code;

    if (errorCode === contact_info_constants["i" /* WRONG_SALESMAN_ID */]) {
      var queryWithoutSalesmanId = getQuery('');
      js_cookie_default.a.set("".concat(contact_info_constants["f" /* SALESMAN_ID_WARNING_MESSAGE */], "-").concat(proposalId), 'show', {
        secure: !Object(contextUtils["d" /* isStrictlyDevelopmentEnv */])()
      });
      return graphqlClient["a" /* default */].runNoCacheQuery(queryWithoutSalesmanId, appContext, {
        requestName: requestDictionary["ed" /* PAYMENT_REDIRECT */]
      });
    }

    throw error;
  });
}


// CONCATENATED MODULE: ./src/client/views/booking/banking/BankingView.utils.js

var BankingView_utils_getPaymentRedirectMutationFunc = function getPaymentRedirectMutationFunc(_ref) {
  var proposal = _ref.proposal,
      appContext = _ref.appContext,
      params = _ref.params;
  return function (_ref2) {
    var amountToPay = _ref2.amountToPay,
        creditCardCvc = _ref2.creditCardCvc,
        donationAmount = _ref2.donationAmount,
        browserInfo = _ref2.browserInfo,
        isIframe = _ref2.isIframe,
        isMobile = _ref2.isMobile,
        location = _ref2.location,
        paymentProviderId = _ref2.paymentProviderId,
        paymentConditionId = _ref2.paymentConditionId,
        token = _ref2.token;
    return paymentRedirectMutation(proposal.id, appContext, {
      browserInfo: browserInfo,
      creditCardCvc: creditCardCvc,
      donationAmount: donationAmount,
      isIframe: isIframe,
      isMobile: isMobile,
      proposalCurrency: proposal.price.currency,
      proposalPrice: amountToPay,
      providerId: paymentProviderId,
      paymentConditionId: paymentConditionId,
      token: token,
      salesmanID: params === null || params === void 0 ? void 0 : params.salesmanID,
      sellerEmail: params === null || params === void 0 ? void 0 : params.sellerEmail
    }, location);
  };
};
// CONCATENATED MODULE: ./src/client/views/booking/banking/Reassurance.jsx
var Reassurance_jsx = react_default.a.createElement;





var Reassurance_Reassurance = function Reassurance(_ref) {
  var className = _ref.className,
      i18n = _ref.i18n;
  return Reassurance_jsx("div", {
    className: classnames_default()(className, 'flex flex-col items-center')
  }, Reassurance_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].PADLOCK,
    color: colors["a" /* COLORS */].BLUE,
    width: "3rem"
  }), Reassurance_jsx("div", {
    className: "text-blue font-bold my-px10"
  }, i18n.booking.banking.reassurance.paymentReassuranceSentence), Reassurance_jsx("div", {
    className: "flex justify-center"
  }, i18n.booking.banking.reassurance.paymentReassuranceLogos.map(function (logo, index) {
    return Reassurance_jsx("img", {
      alt: "",
      className: "block m-px10",
      key: index,
      src: logo,
      styles: {
        height: 'calc(80rem / 16)'
      }
    });
  })));
};
// CONCATENATED MODULE: ./src/client/views/booking/banking/BankingView.jsx




var BankingView_jsx = react_default.a.createElement;

function BankingView_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function BankingView_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { BankingView_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { BankingView_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





























var BankingView_BankingView = function BankingView(_ref) {
  var i18n = _ref.i18n,
      selectedProposal = _ref.selectedProposal,
      renderBottomNavbar = _ref.renderBottomNavbar;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var dispatch = Object(es["d" /* useDispatch */])();
  var entryRoute = Object(es["e" /* useSelector */])(function (state) {
    return state.booking.entryRoute;
  });
  var basePaymentProviders = Object(es["e" /* useSelector */])(booking_selector["t" /* getPaymentProviders */]);
  var hasBasePaymentData = selectedProposal.paymentSchedule && basePaymentProviders.length > 0;
  var sellerProviders = Object(react["useMemo"])(function () {
    var providers = [];

    if (appContext.isCmta && !appContext.cmta.isDelCredere && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('cmta.booking.takeOption')) {
      // "fake" providers, only generate a booking with option status
      if (Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.cmta.bankTransfer')) {
        providers.push({
          description: Object(src_i18n["g" /* t */])('booking.banking.paymentProvider.bankTransfer.title'),
          id: PaymentInfo_const["l" /* NODELCRERE_TRANSFER_PSP_ID */],
          paymentMethods: []
        });
      }

      if (Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.cmta.cheque')) {
        providers.push({
          description: Object(src_i18n["g" /* t */])('booking.banking.paymentProvider.cheque.title'),
          id: PaymentInfo_const["k" /* NODELCRERE_CHEQUE_PSP_ID */],
          paymentMethods: []
        });
      }
    }

    return providers;
  }, [appContext.isCmta, appContext.cmta.isDelCredere]);
  var paymentProviders = Object(react["useMemo"])(function () {
    var hasAnyPaymentMethod = basePaymentProviders.some(function (_ref2) {
      var paymentMethods = _ref2.paymentMethods;
      return paymentMethods.length > 1;
    });

    if (hasAnyPaymentMethod) {
      return [].concat(Object(toConsumableArray["a" /* default */])(sellerProviders), Object(toConsumableArray["a" /* default */])(basePaymentProviders));
    }

    return [].concat(Object(toConsumableArray["a" /* default */])(basePaymentProviders), Object(toConsumableArray["a" /* default */])(sellerProviders));
  }, [basePaymentProviders, sellerProviders]);
  var track = Object(useTracking["a" /* useTracking */])({
    categoryGA: 'bookingEngine',
    actionGA: 'banking'
  });
  var salesmanID = Object(es["e" /* useSelector */])(function (state) {
    return state.seller.sellerInfo.salesmanID;
  });
  var sellerEmail = Object(es["e" /* useSelector */])(function (state) {
    return state.seller.sellerInfo.email;
  });
  var arrivalDate = selectedProposal.transports && selectedProposal.transports.inbound ? selectedProposal.transports.inbound.travelSections[0].departure.date : selectedProposal.arrivalDate;
  var paymentProvidersWithValidMethods = Object(paymentProvidersUtils["g" /* sanitizePaymentProviders */])({
    paymentProviders: paymentProviders,
    arrivalDate: arrivalDate,
    locale: appContext.locale
  });
  var totalPrice = Object(es["e" /* useSelector */])(booking_selector["m" /* getCurrentTotalPrice */]);
  Object(react["useEffect"])(function () {
    var _selectedProposal$pay;

    var _getBestAccommodation = Object(BookingAccommodationsUtils["d" /* getBestAccommodation */])(selectedProposal.accommodations),
        categoryId = _getBestAccommodation.categoryId;

    tracking_storage_api["b" /* set */](BankingView_objectSpread(BankingView_objectSpread({}, tracking_storage_api["a" /* get */](constants["d" /* BE_TRACKING */])), {}, {
      roomType: constants["q" /* PROPOSAL_CATEGORIES */][categoryId],
      insuranceSubscribed: selectedProposal.listInsurances && selectedProposal.listInsurances.some(function (_ref3) {
        var subscribed = _ref3.subscribed;
        return subscribed;
      })
    }));
    var priceHasChanged = ((_selectedProposal$pay = selectedProposal.paymentSchedule) === null || _selectedProposal$pay === void 0 ? void 0 : _selectedProposal$pay.total.value) !== totalPrice; // check for updates in price due to back browser button => re-Fetch the new selectedProposal Price
    // also prevent from double call in refresh for ex

    if (!hasBasePaymentData || priceHasChanged) {
      dispatch(Object(proposals_action["l" /* fetchSelectedProposalPayment */])(selectedProposal, appContext));
    }
  }, []);
  var paymentInfoValue = Object(react["useMemo"])(function () {
    var _selectedProposal$pri, _selectedProposal$pri2;

    return {
      trackPayment: Object(PaymentInfo_utils["c" /* getTrackPaymentFunc */])({
        proposal: selectedProposal,
        track: track,
        donationAmount: ((_selectedProposal$pri = selectedProposal.price.donation) === null || _selectedProposal$pri === void 0 ? void 0 : _selectedProposal$pri.value) || 0
      }),
      paymentRedirectMutation: BankingView_utils_getPaymentRedirectMutationFunc({
        proposal: selectedProposal,
        appContext: appContext,
        params: {
          salesmanID: salesmanID,
          sellerEmail: sellerEmail
        }
      }),
      sellerOptionRedirect: function () {
        var _sellerOptionRedirect = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
          return regenerator_default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return Object(ContactInfoUtils["q" /* submitOptionFromProposal */])(appContext, appContext.cmta.email, selectedProposal.id, selectedProposal.productId, false, salesmanID)(selectedProposal);

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function sellerOptionRedirect() {
          return _sellerOptionRedirect.apply(this, arguments);
        }

        return sellerOptionRedirect;
      }(),
      currency: selectedProposal.price.currency,
      donationAmount: ((_selectedProposal$pri2 = selectedProposal.price.donation) === null || _selectedProposal$pri2 === void 0 ? void 0 : _selectedProposal$pri2.value) || '',
      getPaymentErrorMessagePath: PaymentInfo_utils["b" /* getPaymentErrorMessagePath */],
      onPaymentProgress: function onPaymentProgress(location) {
        // EOgone psp cannot handle long urls (200 char max),
        // we save proposal id as cookie for the confirmation page
        // see buildRedirectionBE
        js_cookie_default.a.set(booking_constants["n" /* BOOKING_SELECTED_RESORT_ID */], selectedProposal.id, {
          sameSite: 'none',
          secure: !Object(contextUtils["d" /* isStrictlyDevelopmentEnv */])()
        }); // The cancelUrl can be too long for the psp so we store in cookies for rehydrate if the user came back #8641

        js_cookie_default.a.set(booking_constants["m" /* BOOKING_QUERY_PARAMS */], Object(uriUtils["g" /* getLocationSearch */])(location), {
          sameSite: 'none',
          secure: !Object(contextUtils["d" /* isStrictlyDevelopmentEnv */])()
        }); // set the enryRoute in case we came from the comparator to use in confirmation page

        js_cookie_default.a.set(booking_constants["l" /* BOOKING_ENTRY_ROUTE */], entryRoute); // Send this click event only when Bank Transfer or Cheque because it's already sent when paying with credit card

        var noDelcpaymentMethodLabel = js_cookie_default.a.get(PaymentInfo_const["n" /* PAYMENT_METHOD_LABEL */]);
        var shouldSendPayementTrackingOnNoDelc = appContext.isCmta && !appContext.cmta.isDelCredere && (noDelcpaymentMethodLabel === PaymentInfo_const["a" /* BANK_TRANSFER_LABEL */] || noDelcpaymentMethodLabel === PaymentInfo_const["b" /* CHEQUE_LABEL */]);

        if (shouldSendPayementTrackingOnNoDelc) {
          track({
            paymentMethod: noDelcpaymentMethodLabel,
            labelGA: 'clickValidateBanking'
          });
          track({
            labelGA: 'validateBanking',
            providerId: '',
            paymentPlan: 'full payment'
          });
        }
      }
    };
  }, [selectedProposal]);
  return appContext.cmta.isDelCredere ? BankingView_jsx(DelCredereBooking_DelCredereBooking, {
    i18n: i18n,
    renderBottomNavbar: renderBottomNavbar,
    selectedProposal: selectedProposal,
    totalPrice: selectedProposal.price.total.value
  }) : BankingView_jsx(react["Fragment"], null, BankingView_jsx(Notification["a" /* Notification */], {
    className: "mb-px40",
    color: colors["a" /* COLORS */].ORANGE,
    hasBorder: true,
    icon: icons["a" /* ICONS */].URGENTISATION,
    iconWidth: "2.8rem",
    title: Object(src_i18n["g" /* t */])('booking.banking.paymentEmergency')
  }), hasBasePaymentData && BankingView_jsx(PaymentInfoContext["a" /* PaymentInfoContext */].Provider, {
    value: paymentInfoValue
  }, BankingView_jsx(PaymentInfo["a" /* PaymentInfo */], {
    i18n: i18n,
    paymentProviders: paymentProvidersWithValidMethods // $FlowFixMe flow can't understand that at this point there is always a paymentSchedule
    ,
    paymentSchedule: selectedProposal.paymentSchedule,
    renderBottomNavbar: renderBottomNavbar,
    totalPrice: selectedProposal.price.total.value
  })), BankingView_jsx(Reassurance_Reassurance, {
    className: "mt-px20",
    i18n: i18n
  }));
};


// EXTERNAL MODULE: ./src/client/session-storage-api/sessionStorageApi.js
var sessionStorageApi = __webpack_require__("9NGo");

// EXTERNAL MODULE: ./src/utils/graphql-client/cacheFront.js
var cacheFront = __webpack_require__("ESA2");

// CONCATENATED MODULE: ./src/hooks/use-layer/useLayer.js



function useLayer(layerName) {
  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location,
      history = _useRouter.history;

  var queryParams = location.queryParams;
  var isLayerOpened = (queryParams === null || queryParams === void 0 ? void 0 : queryParams.openLayer) === layerName;

  var openLayer = function openLayer(e) {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    var nextUri = Object(uriUtils["c" /* convertLocationToURI */])(location).addQuery({
      openLayer: layerName
    });
    history.pushRoute(nextUri.resource(), undefined, {
      shallow: true
    });
  };

  var cleanUrl = function cleanUrl(loc) {
    return Object(uriUtils["c" /* convertLocationToURI */])(loc).clone().removeSearch(['openLayer']).resource();
  };

  var closeLayer = function closeLayer(forceRefreshOnClose) {
    var newUri = cleanUrl(location);

    if (forceRefreshOnClose) {
      Object(cacheFront["a" /* clearAllCacheFront */])();
      window.location = newUri;
    } else {
      history.pushRoute(newUri, undefined, {
        shallow: true
      });
    }
  };

  return {
    isLayerOpened: isLayerOpened,
    openLayer: openLayer,
    closeLayer: closeLayer
  };
}
// EXTERNAL MODULE: ./src/client/store/trip-information/adults/adults.action.js
var adults_action = __webpack_require__("VO7D");

// EXTERNAL MODULE: ./src/client/store/trip-information/kids/kids.action.js
var kids_action = __webpack_require__("1bWg");

// EXTERNAL MODULE: ./src/client/store/user-info/userInfo.selectors.js
var userInfo_selectors = __webpack_require__("apzf");

// CONCATENATED MODULE: ./src/client/store/validation-schema/validationSchema.selectors.js
var getAddressValidationSchema = function getAddressValidationSchema(state) {
  return state.validationSchema['profile.address'];
};


// EXTERNAL MODULE: ./src/utils/legal-information/legalInformationIds.constants.js
var legalInformationIds_constants = __webpack_require__("y5Lu");

// EXTERNAL MODULE: ./src/utils/locale/constants.js
var locale_constants = __webpack_require__("qFX+");

// EXTERNAL MODULE: ./src/client/store/booking/customer-search/customerSearch.reducer.js
var customerSearch_reducer = __webpack_require__("E3ZW");

// CONCATENATED MODULE: ./src/client/store/booking/customer-search/customerSearch.action.js


var customerSearch_action_setCustomerSearchResult = function setCustomerSearchResult(payload) {
  return Object(createAction["b" /* default */])(customerSearch_reducer["a" /* SET_CUSTOMER_SEARCH_RESULT */], payload);
};
// EXTERNAL MODULE: ./src/client/components/widgets/layer/ClosableLayer.jsx
var ClosableLayer = __webpack_require__("FK6w");

// EXTERNAL MODULE: ./src/client/components/utils/common-validator/CommonValidators.js
var CommonValidators = __webpack_require__("cjjV");

// CONCATENATED MODULE: ./src/client/components/widgets/customer-search/validationSearchCustomerForm.js


function validationSearchCustomerForm_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function validationSearchCustomerForm_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      validationSearchCustomerForm_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      validationSearchCustomerForm_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}












var strictNameValidator = lib["string"]().matches(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/);
var baseWordValidator = strictNameValidator.matches(/^[\x20-\xFF]+$/); // ASCII

var validationSearchCustomerForm_getBaseWordValidatorNullable = function getBaseWordValidatorNullable(value) {
  if (!value) {
    return lib["string"]().nullable();
  }

  return baseWordValidator;
};

var civilityField = lib["string"]();

var validationSearchCustomerForm_getBirthdateField = function getBirthdateField(birthdate) {
  if (Number.isNaN(birthdate)) {
    return lib["number"]().typeError('error').required();
  }

  if (!birthdate || Number(birthdate) <= 0) {
    return lib["string"]();
  }

  return lib["date"]().transform(function (value, initialValue) {
    return initialValue ? new Date(initialValue) : initialValue;
  }).max(moment_default()().subtract(contact_info_constants["j" /* YEAR_OF_MAJORITY */], 'y')).min(moment_default()().subtract(contact_info_constants["c" /* MAX_AGE */], 'y'));
};

var validationSearchCustomerForm_getEmailField = function getEmailField(email) {
  return !email ? lib["string"]() : lib["string"]().matches(RegexHelper["a" /* emailRegex */]);
};

var validationSearchCustomerForm_getPhoneField = function getPhoneField(phone, locale) {
  return !phone ? lib["string"]() : lib["string"]().matches(Object(RegexHelper["b" /* getPhoneRegex */])(locale));
};

var firstNameField = baseWordValidator;
var gmNumberField = lib["string"]().matches(CommonValidators["GM_NUMBER_PATTERN"]).max(12);
var lastNameField = baseWordValidator;

function getZipCodeField(addressValidationSchema, zipCode) {
  if (!zipCode) {
    return lib["string"]();
  }

  var validationSchemaZipCode = Object(ContactInfoUtils["d" /* getAddressValidators */])(addressValidationSchema, {
    withRequired: false
  });
  return validationSchemaZipCode === null || validationSchemaZipCode === void 0 ? void 0 : validationSchemaZipCode.zipCode;
}

function yupToFormError(schema, values) {
  var errors = {};

  for (var _i = 0, _Object$keys = Object.keys(values); _i < _Object$keys.length; _i++) {
    var field = _Object$keys[_i];

    try {
      schema.validateSyncAt(field, values);
    } catch (err) {
      errors[field] = err === null || err === void 0 ? void 0 : err.message;
    }
  }

  return errors;
}

function isOnlyFill(field, values) {
  var restIsEmpty = Object(lodash["every"])(validationSearchCustomerForm_objectSpread(validationSearchCustomerForm_objectSpread({}, values), {}, Object(defineProperty["a" /* default */])({}, field, undefined)), function (value) {
    return !value;
  });
  return values[field] && restIsEmpty;
}

function isEveryFieldsEmpty(values) {
  return Object(lodash["every"])(values, function (value) {
    return !value;
  });
}

function isSomeIsFill() {
  var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var values = arguments.length > 1 ? arguments[1] : undefined;
  var valuesFields = fields.map(function (field) {
    return values[field];
  });
  return valuesFields.some(Boolean);
}

function validationSchemaCxo(values, locale, addressValidationSchema) {
  var birthdateField = validationSearchCustomerForm_getBirthdateField(values.birthdate);
  var emailField = validationSearchCustomerForm_getEmailField(values.email);
  var phoneField = validationSearchCustomerForm_getPhoneField(values.phone, locale);
  var zipCodeField = getZipCodeField(addressValidationSchema, values.zipCode);

  if (isOnlyFill('lastName', values)) {
    var _schema = lib["object"]().shape({
      birthdate: birthdateField.required(),
      civility: civilityField.nullable(),
      email: emailField.required(),
      firstName: firstNameField.required(),
      lastName: lastNameField.required(),
      phone: phoneField.required(),
      zipCode: zipCodeField.required(),
      gmNumber: gmNumberField.nullable()
    });

    return yupToFormError(_schema, values);
  }

  if (isSomeIsFill(['birthdate', 'email', 'phone', 'zipCode'], values)) {
    var _schema2 = lib["object"]().shape({
      firstName: firstNameField.required(),
      lastName: lastNameField.required(),
      birthdate: birthdateField.nullable(),
      civility: civilityField.nullable(),
      gmNumber: gmNumberField.nullable(),
      email: emailField.nullable(),
      phone: phoneField.nullable(),
      zipCode: zipCodeField.nullable()
    });

    return yupToFormError(_schema2, values);
  }

  if (isOnlyFill('firstName', values)) {
    var _schema3 = lib["object"]().shape({
      birthdate: birthdateField.required(),
      email: emailField.required(),
      lastName: lastNameField.required(),
      phone: phoneField.required(),
      zipCode: zipCodeField.required(),
      civility: civilityField.nullable(),
      gmNumber: gmNumberField.nullable()
    });

    return yupToFormError(_schema3, values);
  }

  if (isEveryFieldsEmpty(values)) {
    var _schema4 = lib["object"]().shape({
      gmNumber: gmNumberField.required(),
      birthdate: birthdateField.nullable(),
      civility: civilityField.nullable(),
      email: emailField.nullable(),
      firstName: validationSearchCustomerForm_getBaseWordValidatorNullable(values.firstName),
      lastName: validationSearchCustomerForm_getBaseWordValidatorNullable(values.lastName),
      phone: phoneField.nullable(),
      zipCode: zipCodeField.nullable()
    });

    return yupToFormError(_schema4, values);
  }

  var schema = lib["object"]().shape({
    birthdate: birthdateField.nullable(),
    civility: civilityField.nullable(),
    email: emailField.nullable(),
    firstName: validationSearchCustomerForm_getBaseWordValidatorNullable(values.firstName),
    gmNumber: gmNumberField.nullable(),
    lastName: validationSearchCustomerForm_getBaseWordValidatorNullable(values.lastName),
    phone: phoneField.nullable(),
    zipCode: zipCodeField.nullable()
  });
  return yupToFormError(schema, values);
}

function validationSchemaCmta(values, locale, addressValidationSchema) {
  var birthdateField = validationSearchCustomerForm_getBirthdateField(values.birthdate);
  var emailField = validationSearchCustomerForm_getEmailField(values.email);
  var phoneField = validationSearchCustomerForm_getPhoneField(values.phone, locale);
  var zipCodeField = getZipCodeField(addressValidationSchema, values.zipCode);

  if (isOnlyFill('lastName', values)) {
    var _schema5 = lib["object"]().shape({
      gmNumber: gmNumberField.required(),
      civility: civilityField.nullable()
    });

    return yupToFormError(_schema5, values);
  }

  if (isOnlyFill('gmNumber', values)) {
    var _schema6 = lib["object"]().shape({
      lastName: lastNameField.required(),
      birthdate: birthdateField.nullable(),
      civility: civilityField.nullable(),
      email: emailField.nullable(),
      firstName: validationSearchCustomerForm_getBaseWordValidatorNullable(values.firstName),
      gmNumber: gmNumberField.nullable(),
      phone: phoneField.nullable(),
      zipCode: zipCodeField.nullable()
    });

    return yupToFormError(_schema6, values);
  }

  if (isSomeIsFill(['birthdate', 'email', 'phone', 'zipCode'], values)) {
    var _schema7 = lib["object"]().shape({
      lastName: lastNameField.required(),
      firstName: firstNameField.required(),
      birthdate: birthdateField.nullable(),
      civility: civilityField.nullable(),
      gmNumber: gmNumberField.nullable(),
      email: emailField.nullable(''),
      phone: phoneField.nullable(),
      zipCode: zipCodeField.nullable()
    });

    return yupToFormError(_schema7, values);
  }

  if (isOnlyFill('firstName', values)) {
    var _schema8 = lib["object"]().shape({
      birthdate: birthdateField.required(),
      email: emailField.required(),
      lastName: lastNameField.required(),
      phone: phoneField.required(),
      zipCode: zipCodeField.required(),
      civility: civilityField.nullable(),
      firstName: validationSearchCustomerForm_getBaseWordValidatorNullable(values.firstName),
      gmNumber: gmNumberField.nullable()
    });

    return yupToFormError(_schema8, values);
  }

  if (isEveryFieldsEmpty(values)) {
    var _schema9 = lib["object"]().shape({
      gmNumber: gmNumberField.required(),
      lastName: lastNameField.required(),
      civility: civilityField.nullable(),
      birthdate: birthdateField.nullable(),
      email: emailField.nullable(),
      firstName: validationSearchCustomerForm_getBaseWordValidatorNullable(values.firstName),
      phone: phoneField.nullable(),
      zipCode: zipCodeField.nullable()
    });

    return yupToFormError(_schema9, values);
  }

  var schema = lib["object"]().shape({
    civility: civilityField.nullable(),
    birthdate: birthdateField.nullable(),
    email: emailField.nullable(),
    firstName: validationSearchCustomerForm_getBaseWordValidatorNullable(values.firstName),
    gmNumber: gmNumberField.nullable(),
    lastName: validationSearchCustomerForm_getBaseWordValidatorNullable(values.lastName),
    phone: phoneField.nullable(),
    zipCode: zipCodeField.nullable()
  });
  return yupToFormError(schema, values);
}

function useValidationSearchCustomer() {
  var addressValidationSchema = Object(es["e" /* useSelector */])(getAddressValidationSchema);
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var isCxo = appContext.isCxo,
      locale = appContext.locale;
  return function (values) {
    return isCxo ? validationSchemaCxo(values, locale, addressValidationSchema) : validationSchemaCmta(values, locale, addressValidationSchema);
  };
}
// CONCATENATED MODULE: ./src/client/components/widgets/customer-search/CustomerSearchForm.jsx

var CustomerSearchForm_jsx = react_default.a.createElement;












function Input(props) {
  return CustomerSearchForm_jsx("div", {
    className: "flex flex-col mb-px10 sm:w-12/25 w-full"
  }, CustomerSearchForm_jsx(FormikInput["a" /* FormikInput */], Object(esm_extends["a" /* default */])({
    hideErrorMessage: true
  }, props)));
}

function CustomerSearchForm(_ref) {
  var onSubmit = _ref.onSubmit,
      isAdvanced = _ref.isAdvanced;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var isCmta = appContext.isCmta;
  var validate = useValidationSearchCustomer();
  return CustomerSearchForm_jsx(formik_esm["d" /* Formik */], {
    initialValues: {
      birthdate: '',
      email: '',
      firstName: '',
      gmNumber: '',
      lastName: '',
      phone: '',
      zipCode: ''
    },
    validate: validate,
    onSubmit: onSubmit
  }, function (_ref2) {
    var values = _ref2.values;
    var areSecondaryFieldsEmpty = values.birthdate === '' && values.zipCode === '' && values.email === '' && values.phone === '';
    return CustomerSearchForm_jsx(formik_esm["c" /* Form */], {
      "data-testid": "search-customer-form-".concat(isAdvanced ? 'advanced' : 'quick')
    }, CustomerSearchForm_jsx("div", {
      className: "m-px10 flex justify-center w-full"
    }, CustomerSearchForm_jsx("div", {
      style: {
        width: '36.25rem'
      }
    }, CustomerSearchForm_jsx(Capsule["a" /* Capsule */], null, CustomerSearchForm_jsx("div", {
      className: "p-px25"
    }, CustomerSearchForm_jsx("div", {
      className: "flex justify-center relative"
    }, CustomerSearchForm_jsx(Title["a" /* Title */], {
      theme: "title-sans-4",
      color: colors["a" /* COLORS */].BLUE
    }, isAdvanced ? Object(src_i18n["g" /* t */])('booking.partners.traveller.existingCustomer.advancedSearch') : Object(src_i18n["g" /* t */])('booking.partners.traveller.existingCustomer.quickSearch')), CustomerSearchForm_jsx("p", {
      className: "absolute right-0 top-0 font-sans text-xs text-gray"
    }, Object(src_i18n["g" /* t */])('booking.participants.labels.mandatoryField'))), CustomerSearchForm_jsx("div", {
      className: "flex justify-center font-sans text-sm mt-px15 mb-px10 text-turquoise font-bold"
    }, Object(src_i18n["g" /* t */])('booking.partners.traveller.existingCustomer.provideInformation')), CustomerSearchForm_jsx("div", {
      className: classnames_default()('flex', {
        'justify-between': isAdvanced || isCmta
      }, {
        'justify-center': !isAdvanced && !isCmta
      })
    }, isAdvanced ? CustomerSearchForm_jsx(Input, {
      label: Object(src_i18n["g" /* t */])('booking.participants.labels.firstName'),
      name: "firstName",
      isRequired: true,
      type: "text"
    }) : CustomerSearchForm_jsx(Input, {
      name: "gmNumber",
      label: Object(src_i18n["g" /* t */])('booking.partners.traveller.existingCustomer.gmNumber'),
      isRequired: true,
      isValidate: false,
      type: "text"
    }), (isAdvanced || isCmta) && CustomerSearchForm_jsx(Input, {
      name: "lastName",
      label: Object(src_i18n["g" /* t */])('booking.participants.labels.lastName'),
      isRequired: isAdvanced || isCmta,
      type: "text"
    })), isAdvanced && CustomerSearchForm_jsx(react["Fragment"], null, CustomerSearchForm_jsx("div", {
      className: "flex justify-center font-sans text-sm my-px10 text-turquoise font-bold"
    }, Object(src_i18n["g" /* t */])('booking.partners.traveller.existingCustomer.provideInformation2')), CustomerSearchForm_jsx("div", {
      className: "flex justify-between"
    }, CustomerSearchForm_jsx(Input, {
      dataTestId: "birthdate",
      dateFormat: Object(src_i18n["g" /* t */])('booking.form.dateFormat'),
      label: Object(src_i18n["g" /* t */])('booking.participants.labels.birthdate'),
      dayPlaceholder: Object(src_i18n["g" /* t */])('booking.form.dayPlaceholder'),
      monthPlaceholder: Object(src_i18n["g" /* t */])('booking.form.monthPlaceholder'),
      yearPlaceholder: Object(src_i18n["g" /* t */])('booking.form.yearPlaceholder'),
      name: "birthdate",
      type: "birthdate",
      isRequired: areSecondaryFieldsEmpty
    }), CustomerSearchForm_jsx(Input, {
      label: Object(src_i18n["g" /* t */])('common.participants.address.zipCode'),
      name: "zipCode",
      type: "text",
      isRequired: areSecondaryFieldsEmpty
    })), CustomerSearchForm_jsx("div", {
      className: "flex justify-between"
    }, CustomerSearchForm_jsx(Input, {
      label: Object(src_i18n["g" /* t */])('booking.participants.labels.email'),
      name: "email",
      type: "text",
      isRequired: areSecondaryFieldsEmpty
    }), CustomerSearchForm_jsx(Input, {
      label: Object(src_i18n["g" /* t */])('booking.participants.labels.phone'),
      name: "phone",
      type: "text",
      isRequired: areSecondaryFieldsEmpty
    }))))), CustomerSearchForm_jsx("div", {
      className: "mt-px30 flex justify-center w-full"
    }, CustomerSearchForm_jsx(Button["a" /* Button */], {
      dataTestId: "searchCustomerAction".concat(isAdvanced ? 'Advanced' : 'Quick'),
      type: "submit"
    }, Object(src_i18n["g" /* t */])('booking.partners.traveller.existingCustomer.searchAction'))))));
  });
}
// CONCATENATED MODULE: ./src/client/components/widgets/customer-search/useTrackPage.js





function useTrackPage(pageName) {
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var resort = Object(es["e" /* useSelector */])(booking_selector["l" /* getCurrentResort */]);
  var proposals = Object(es["e" /* useSelector */])(booking_selector["u" /* getProposals */]);
  var selectedProposal = Object(es["e" /* useSelector */])(booking_selector["k" /* getCurrentProposal */]);
  var isTrackPageDataAvailable = resort && proposals && selectedProposal;
  return Object(react["useEffect"])(function () {
    isTrackPageDataAvailable && Object(BookingEngine_tracking["d" /* trackPage */])({
      pageName: pageName,
      basePriceLabel: 'basePricePaymentParticipants',
      resort: resort,
      proposals: proposals,
      selectedProposal: selectedProposal,
      customEventName: 'participants'
    }, appContext);
  }, []);
}
// CONCATENATED MODULE: ./src/client/components/widgets/customer-search/CustomerSearchFormGroup.jsx
var CustomerSearchFormGroup_jsx = react_default.a.createElement;






var CustomerSearchFormGroup_CustomerSearchFormGroup = function CustomerSearchFormGroup(_ref) {
  var onSubmit = _ref.onSubmit;
  useTrackPage('participants');
  return CustomerSearchFormGroup_jsx(react["Fragment"], null, CustomerSearchFormGroup_jsx("div", {
    className: "flex justify-center"
  }, CustomerSearchFormGroup_jsx(Title["a" /* Title */], {
    className: "text-4xl mt-px30 mb-px50",
    color: colors["a" /* COLORS */].BLUE,
    theme: "title-sans-4"
  }, Object(src_i18n["g" /* t */])('booking.partners.traveller.existingCustomer.searchCustomer'))), CustomerSearchFormGroup_jsx("div", {
    className: "flex justify-center"
  }, CustomerSearchFormGroup_jsx(CustomerSearchForm, {
    onSubmit: onSubmit
  }), CustomerSearchFormGroup_jsx(CustomerSearchForm, {
    onSubmit: onSubmit,
    isAdvanced: true
  })));
};
// EXTERNAL MODULE: ./src/client/components/widgets/address-form/AddressForm.fragment.js
var AddressForm_fragment = __webpack_require__("tJAy");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/ContactInfo.fragment.js
var ContactInfo_fragment = __webpack_require__("BYx+");

// EXTERNAL MODULE: ./src/utils/graphql-client/use-gql/useGQL.js
var useGQL = __webpack_require__("0JpG");

// CONCATENATED MODULE: ./src/client/components/widgets/customer-search/customerSearchUtils.js



function customerSearchUtils_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function customerSearchUtils_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      customerSearchUtils_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      customerSearchUtils_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}








function useGetCustomerHouseholds() {
  var searchValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _searchValues$birthda = searchValues.birthdate,
      birthdate = _searchValues$birthda === void 0 ? '' : _searchValues$birthda,
      _searchValues$email = searchValues.email,
      email = _searchValues$email === void 0 ? '' : _searchValues$email,
      _searchValues$firstNa = searchValues.firstName,
      firstName = _searchValues$firstNa === void 0 ? '' : _searchValues$firstNa,
      _searchValues$gmNumbe = searchValues.gmNumber,
      gmNumber = _searchValues$gmNumbe === void 0 ? '' : _searchValues$gmNumbe,
      _searchValues$lastNam = searchValues.lastName,
      lastName = _searchValues$lastNam === void 0 ? '' : _searchValues$lastNam,
      _searchValues$phone = searchValues.phone,
      phone = _searchValues$phone === void 0 ? '' : _searchValues$phone,
      _searchValues$zipCode = searchValues.zipCode,
      zipCode = _searchValues$zipCode === void 0 ? '' : _searchValues$zipCode;
  return Object(useGQL["a" /* useGQL */])({
    query: "\n          query {\n            customerHouseholds (\n              birthdate: \"".concat(birthdate ? moment_default()(birthdate).format(apiDate["a" /* API_DATE_FORMAT */]) : '', "\",\n              email: \"").concat(email, "\",\n              firstName: \"").concat(firstName, "\",\n              gmNumber: \"").concat(gmNumber, "\",\n              lastName: \"").concat(lastName, "\",\n              phone: \"").concat(phone, "\",\n              zipCode: \"").concat(zipCode, "\",\n              ) {\n                adults {\n                  ...CommonProfileFields\n                  address {\n                    ...Address\n                  }\n                  email\n                  mobile:mobilePhoneNumber\n                  loyaltyProgram {\n                    status\n                  }\n                  optinClubmedPlus\n                  optinFosun\n                  optinEmail\n                  optinMail\n                  optinPhone\n                  optinSms\n                }\n                children {\n                  ...CommonProfileFields\n                }\n              }\n          }\n        ").concat(AddressForm_fragment["a" /* default */], "\n        ").concat(ContactInfo_fragment["a" /* commonProfileFieldsFragment */], "\n      "),
    queryOptions: {
      requestName: requestDictionary["yb" /* CUSTOMER_BY_HOME */]
    }
  });
}
var customerSearchUtils_buildInitialValuesFromData = function buildInitialValuesFromData(customerHouseholds) {
  var inputNames = {};
  customerHouseholds.forEach(function (_ref) {
    var adults = _ref.adults,
        children = _ref.children;
    [].concat(Object(toConsumableArray["a" /* default */])(adults), Object(toConsumableArray["a" /* default */])(children)).forEach( // gmNumber is actually a household identifier, when the main contact get a gmNumber, it's added automatically to all other travelers
    function (_ref2) {
      var householdId = _ref2.gmNumber,
          attendeeId = _ref2.id,
          civility = _ref2.civility,
          firstName = _ref2.firstName,
          lastName = _ref2.lastName;
      inputNames[// $FlowFixMe householdId (gmNumber) is available from search
      "fullName-".concat(householdId, "_").concat(attendeeId) // $FlowFixMe all this data is available from search
      ] = "".concat(civility, " ").concat(firstName, " ").concat(lastName);
    });
  });
  return customerSearchUtils_objectSpread({
    checkedAttendees: []
  }, inputNames);
}; // type ArgsType = FormSelectedValueType

var customerSearchUtils_buildAttendeesFromFormValues = function buildAttendeesFromFormValues(_ref3, customerHouseholds) {
  var checkedAttendees = _ref3.checkedAttendees;
  var selectedHouseholdId = checkedAttendees[0].index.split('_')[0];
  var selectHousehold = customerHouseholds.find(function (_ref4) {
    var adults = _ref4.adults;
    return adults[0].gmNumber === selectedHouseholdId;
  });
  var selectedAttendees = checkedAttendees.map(function (_ref5) {
    var attendee = _ref5.attendee;
    return attendee;
  });
  var adults = selectedAttendees.filter(dist["attendees"].isAdult).sort(function (adult1, adult2) {
    return (// $FlowFixMe: selectHousehold is always available here
      selectHousehold.adults.indexOf(adult1) - selectHousehold.adults.indexOf(adult2)
    );
  });
  var children = selectedAttendees.filter(dist["attendees"].isKid).sort(function (kid1, kid2) {
    return (// $FlowFixMe: selectHousehold is always available here
      selectHousehold.children.indexOf(kid1) - selectHousehold.children.indexOf(kid2)
    );
  });
  return {
    adults: adults,
    children: children
  };
};
// CONCATENATED MODULE: ./src/client/components/widgets/customer-search/AttendeeField.jsx
var AttendeeField_jsx = react_default.a.createElement;








function AttendeeField_Input(_ref) {
  var isMainContact = _ref.isMainContact,
      name = _ref.name;
  return AttendeeField_jsx("div", {
    className: "relative w-full"
  }, AttendeeField_jsx("div", {
    className: "absolute flex h-full items-center top-0 pointer-events-none px-px10"
  }, AttendeeField_jsx(Icon["a" /* Icon */], {
    className: classnames_default()('text-gray', {
      'text-blue': isMainContact
    }),
    name: icons["a" /* ICONS */].USER,
    width: isMainContact ? '1.3em' : '1em'
  })), AttendeeField_jsx(FormikInput["a" /* FormikInput */], {
    customClasses: classnames_default()('border text-md sm:text-base outline-none p-px10 transition-all w-full rtl:pl-px50 rounded-large h-12 bg-transparent pointer-events-none', {
      'font-bold leading-normal text-blue': isMainContact
    }, {
      'leading-one text-gray-medium-dark': !isMainContact
    }),
    name: name,
    type: "text"
  }));
}

function AttendeeField(_ref2) {
  var attendee = _ref2.attendee,
      checkedAttendees = _ref2.checkedAttendees,
      householdId = _ref2.householdId,
      isMainContact = _ref2.isMainContact,
      onChange = _ref2.onChange;
  var address = attendee.address,
      birthdate = attendee.birthdate,
      email = attendee.email,
      id = attendee.id,
      mobile = attendee.mobile;
  var fullAddress;

  if (address) {
    var streetNumber = address.streetNumber,
        streetName = address.streetName,
        city = address.city,
        zipCode = address.zipCode;
    fullAddress = "".concat(streetNumber || '', " ").concat(streetName || '', " ").concat(city || '', " ").concat(zipCode || '');
  }

  return AttendeeField_jsx("div", {
    className: classnames_default()('flex justify-center items-center', {
      'mb-px40': isMainContact,
      'mb-px20': !isMainContact
    }),
    "data-testid": "participant-".concat(householdId, "_").concat(id),
    style: {
      maxWidth: '32.5rem'
    }
  }, AttendeeField_jsx("div", {
    className: "flex flex-col w-full"
  }, isMainContact && AttendeeField_jsx("span", {
    className: "text-sm text-blue font-bold block rtl:ml-px30"
  }, Object(src_i18n["g" /* t */])('booking.partners.traveller.existingCustomer.mainContact')), AttendeeField_jsx("div", {
    className: "flex items-center"
  }, AttendeeField_jsx(FormikInput["a" /* FormikInput */], {
    checked: checkedAttendees,
    name: "participant-checkbox-".concat(householdId, "_").concat(id),
    onChange: onChange,
    type: "checkbox"
  }), AttendeeField_jsx(AttendeeField_Input, {
    isMainContact: isMainContact,
    name: "fullName-".concat(householdId, "_").concat(id)
  })), birthdate || email || mobile || fullAddress ? AttendeeField_jsx("div", {
    className: "rtl:ml-px30 flex px-px15 py-px10 text-sm text-gray lowercase"
  }, AttendeeField_jsx("p", {
    className: "m-0 w-1/5"
  }, birthdate ? moment_default()(birthdate).format(Object(src_i18n["g" /* t */])('booking.form.dateFormat')) : ''), AttendeeField_jsx("div", {
    className: "flex-1"
  }, AttendeeField_jsx("div", {
    className: "flex"
  }, AttendeeField_jsx("p", {
    className: "flex-1 m-0"
  }, email || ''), AttendeeField_jsx("p", {
    className: "w-1/3 m-0"
  }, mobile || '')), AttendeeField_jsx("p", {
    className: "w-full m-0"
  }, fullAddress || ''))) : null));
}
// CONCATENATED MODULE: ./src/client/components/widgets/customer-search/HouseholdBlock.jsx


var HouseholdBlock_jsx = react_default.a.createElement;

function HouseholdBlock_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function HouseholdBlock_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { HouseholdBlock_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { HouseholdBlock_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













function HouseholdBlock(_ref) {
  var _currentProposal$atte3;

  var dataTestId = _ref.dataTestId,
      household = _ref.household;

  var _useState = Object(react["useState"])(false),
      isSelectionError = _useState[0],
      setIsSelectionError = _useState[1];

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      values = _useFormikContext.values,
      setFieldValue = _useFormikContext.setFieldValue;

  var currentProposal = Object(es["e" /* useSelector */])(booking_selector["k" /* getCurrentProposal */]);
  var checkedAttendeesIndexes = values.checkedAttendees.map(function (_ref2) {
    var index = _ref2.index;
    return index;
  });

  var handleOnChange = function handleOnChange(householdId, attendee) {
    // $FlowFixMe householdId (gmNumber) is available from search
    var searchId = "".concat(householdId, "_").concat(attendee.id);

    if (!checkedAttendeesIndexes.includes(searchId)) {
      setFieldValue('checkedAttendees', [].concat(Object(toConsumableArray["a" /* default */])(values.checkedAttendees), [{
        index: searchId,
        attendee: attendee
      }]));
    } else {
      setFieldValue('checkedAttendees', values.checkedAttendees.filter(function (val) {
        return val.index !== searchId;
      }));
    }
  };

  var checkIfDisabledHousehold = function checkIfDisabledHousehold(householdId) {
    if (checkedAttendeesIndexes.length > 0) {
      return !(householdId === checkedAttendeesIndexes[0].split('_')[0]);
    }

    return false;
  };

  Object(react["useEffect"])(function () {
    var _currentProposal$atte, _currentProposal$atte2;

    var selectedChildrenLength = values.checkedAttendees.filter(function (_ref3) {
      var isChild = _ref3.attendee.isChild;
      return isChild;
    }).length;
    var selectedAdultsLength = values.checkedAttendees.length - selectedChildrenLength;
    var currentProposalChildrenLength = currentProposal === null || currentProposal === void 0 ? void 0 : (_currentProposal$atte = currentProposal.attendees) === null || _currentProposal$atte === void 0 ? void 0 : _currentProposal$atte.children.length;
    var currentProposalAdultslength = currentProposal === null || currentProposal === void 0 ? void 0 : (_currentProposal$atte2 = currentProposal.attendees) === null || _currentProposal$atte2 === void 0 ? void 0 : _currentProposal$atte2.adults.length;
    var currentProposalListLength = currentProposalChildrenLength + currentProposalAdultslength;
    var selectedListLength = selectedChildrenLength + selectedAdultsLength;

    if (currentProposalListLength === selectedListLength && selectedChildrenLength !== currentProposalChildrenLength && selectedAdultsLength !== currentProposalAdultslength) {
      setIsSelectionError(true);
    } else {
      setIsSelectionError(false);
    }
  }, [values]);
  var mainContact = household.adults[0];
  var gmNumber = mainContact.gmNumber,
      lastName = mainContact.lastName,
      loyaltyProgram = mainContact.loyaltyProgram; // gmNumber is actually a household identifier, when the main contact get an gmNumber, it added automatically to all other travelers

  var householdId = gmNumber; // verify that checked attendees count from the current household ,is less than or equal proposal attendees count

  var hasTooManyPeople = values.checkedAttendees.filter(function (checkedAttendee) {
    return checkedAttendee.index.includes(householdId);
  }).length > ((currentProposal === null || currentProposal === void 0 ? void 0 : (_currentProposal$atte3 = currentProposal.attendees) === null || _currentProposal$atte3 === void 0 ? void 0 : _currentProposal$atte3.list) || []).length;
  var noSelectedAttendees = values.checkedAttendees.filter(function (checkedAttendee) {
    return checkedAttendee.index.includes(householdId);
  }).length === 0;
  var status;

  if (loyaltyProgram && loyaltyProgram.status && loyaltyProgram.status !== 'none') {
    status = loyaltyProgram.status;
  }

  return HouseholdBlock_jsx("div", {
    "data-testid": dataTestId,
    className: classnames_default()('mt-px20', {
      'opacity-50 pointer-events-none': checkIfDisabledHousehold(gmNumber)
    }),
    style: {
      width: '36.25rem'
    }
  }, HouseholdBlock_jsx(Capsule["a" /* Capsule */], null, HouseholdBlock_jsx("div", {
    className: "flex justify-between items-center mx-px20"
  }, HouseholdBlock_jsx("p", null, HouseholdBlock_jsx("span", {
    className: "block text-sm leading-one"
  }, Object(src_i18n["g" /* t */])('memberSpace.dashboard.GMNumber')), HouseholdBlock_jsx("span", {
    className: "text-lg text-blue font-bold"
  }, gmNumber)), HouseholdBlock_jsx("p", {
    className: classnames_default()('text-md font-bold text-gray', {
      'rtl:pr-px60 rtl:mr-32': !status
    })
  }, lastName), status && HouseholdBlock_jsx("p", {
    className: "text-md text-blue rtl:pr-px60"
  }, status)), HouseholdBlock_jsx("div", {
    className: "flex flex-col w-full rtl:ml-px40 rtl:mr-px20"
  }, [].concat(Object(toConsumableArray["a" /* default */])(household.adults), Object(toConsumableArray["a" /* default */])(household.children.map(function (child) {
    return HouseholdBlock_objectSpread(HouseholdBlock_objectSpread({}, child), {}, {
      isChild: true
    });
  }))).map(function (attendee, index) {
    return HouseholdBlock_jsx(AttendeeField, {
      attendee: attendee // $FlowFixMe householdId (gmNumber) is available from search
      ,
      checkedAttendees: checkedAttendeesIndexes.includes("".concat(householdId, "_").concat(attendee.id)) // $FlowFixMe householdId (gmNumber) is available from search
      ,
      householdId: householdId,
      isMainContact: index === 0 // main contact is the first adult (customer we've searched for)
      ,
      key: attendee.id,
      onChange: function onChange() {
        return handleOnChange(householdId, attendee);
      }
    });
  })), hasTooManyPeople && HouseholdBlock_jsx("div", {
    className: "flex items-center justify-center"
  }, HouseholdBlock_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].WARNING,
    width: ".75rem",
    className: "text-danger mr-px5"
  }), HouseholdBlock_jsx("span", {
    className: "text-danger text-sm"
  }, Object(src_i18n["g" /* t */])('booking.partners.traveller.existingCustomer.errorPeople'))), isSelectionError && HouseholdBlock_jsx("div", {
    className: "flex items-center justify-center mt-px10"
  }, HouseholdBlock_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].WARNING,
    width: ".75rem",
    className: "text-danger mr-px5"
  }), HouseholdBlock_jsx("span", {
    className: "text-danger text-sm"
  }, Object(src_i18n["g" /* t */])('booking.partners.traveller.existingCustomer.selectionError'))), HouseholdBlock_jsx("div", {
    className: "flex justify-center mb-px20 mt-px30 w-full"
  }, HouseholdBlock_jsx(Button["a" /* Button */], {
    colorBg: colors["a" /* COLORS */].TURQUOISE,
    isDisabled: hasTooManyPeople || noSelectedAttendees || isSelectionError,
    type: "submit"
  }, Object(src_i18n["g" /* t */])('booking.common.add')))));
}
// CONCATENATED MODULE: ./src/client/components/widgets/customer-search/HouseholdListForm.jsx
var HouseholdListForm_jsx = react_default.a.createElement;





var HouseholdListForm_HouseholdListForm = function HouseholdListForm(_ref) {
  var customerHouseholds = _ref.customerHouseholds,
      onSubmit = _ref.onSubmit;
  var initialValues = customerSearchUtils_buildInitialValuesFromData(customerHouseholds);

  var handleSubmit = function handleSubmit(selectedValues) {
    var selectedAttendees = customerSearchUtils_buildAttendeesFromFormValues(selectedValues, customerHouseholds);
    onSubmit(selectedAttendees);
  };

  useTrackPage('participants_layerCustomerResults');
  return HouseholdListForm_jsx(formik_esm["d" /* Formik */], {
    initialValues: initialValues,
    onSubmit: handleSubmit
  }, HouseholdListForm_jsx(formik_esm["c" /* Form */], {
    "data-testid": "results-customer-form"
  }, HouseholdListForm_jsx("div", {
    className: "m-px30 flex flex-col justify-center items-center w-full"
  }, customerHouseholds.map(function (household) {
    var householdId = household.adults[0].gmNumber;
    return HouseholdListForm_jsx(HouseholdBlock // $FlowFixMe householdId (gmNumber) is available from search
    , {
      dataTestId: "household-".concat(householdId),
      household: household,
      key: householdId
    });
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/customer-search/CustomerSearchResults.jsx
var CustomerSearchResults_jsx = react_default.a.createElement;



function CustomerSearchResults(_ref) {
  var onError = _ref.onError,
      onLoadingEnd = _ref.onLoadingEnd,
      onLoadingStart = _ref.onLoadingStart,
      onSelect = _ref.onSelect,
      onSuccess = _ref.onSuccess,
      searchValues = _ref.searchValues;

  var _useGetCustomerHouseh = useGetCustomerHouseholds(searchValues),
      isLoading = _useGetCustomerHouseh.isLoading,
      data = _useGetCustomerHouseh.data,
      error = _useGetCustomerHouseh.error;

  Object(react["useEffect"])(function () {
    if (isLoading && onLoadingStart) {
      onLoadingStart();
    }

    if (!isLoading && onLoadingEnd) {
      onLoadingEnd();
    }
  }, [isLoading]);
  Object(react["useEffect"])(function () {
    if (error && onError) {
      onError(error);
    }

    if (!error && data && onSuccess) {
      onSuccess(data);
    }
  }, [data, error]);

  if (isLoading || error) {
    return null;
  }

  var _ref2 = data || {},
      _ref2$customerHouseho = _ref2.customerHouseholds,
      customerHouseholds = _ref2$customerHouseho === void 0 ? [] : _ref2$customerHouseho;

  return CustomerSearchResults_jsx(HouseholdListForm_HouseholdListForm, {
    customerHouseholds: customerHouseholds,
    onSubmit: onSelect
  });
}
// CONCATENATED MODULE: ./src/client/components/widgets/customer-search/CustomerSearch.jsx
var CustomerSearch_jsx = react_default.a.createElement;



var CustomerSearch_CustomerSearch = function CustomerSearch(_ref) {
  var onError = _ref.onError,
      onLoadingEnd = _ref.onLoadingEnd,
      onLoadingStart = _ref.onLoadingStart,
      onSearch = _ref.onSearch,
      onSelect = _ref.onSelect,
      onSuccess = _ref.onSuccess;

  var _useState = Object(react["useState"])(),
      searchFormValues = _useState[0],
      setSearchFormValues = _useState[1];

  var handleSearchSubmit = function handleSearchSubmit(searchValues) {
    setSearchFormValues(searchValues);

    if (onSearch) {
      onSearch(searchValues);
    }
  };

  if (!searchFormValues) {
    return CustomerSearch_jsx(CustomerSearchFormGroup_CustomerSearchFormGroup, {
      onSubmit: handleSearchSubmit
    });
  }

  return CustomerSearch_jsx(CustomerSearchResults, {
    onError: onError,
    onLoadingEnd: onLoadingEnd,
    onLoadingStart: onLoadingStart,
    onSelect: onSelect,
    onSuccess: onSuccess,
    searchValues: searchFormValues
  });
};
// CONCATENATED MODULE: ./src/client/views/booking/participants/popin-customer/SearchCustomerLayer.jsx
var SearchCustomerLayer_jsx = react_default.a.createElement;











var CUSTOMER_SEARCH_LAYER = 'CUSTOMER_SEARCH_LAYER';
var SearchCustomerLayer_SearchCustomerLayer = function SearchCustomerLayer(_ref) {
  var name = _ref.name,
      onClose = _ref.onClose;
  var dispatch = Object(es["d" /* useDispatch */])();

  var _useLayer = useLayer(CUSTOMER_SEARCH_LAYER),
      closeLayer = _useLayer.closeLayer;

  var _useState = Object(react["useState"])(true),
      isSearchForm = _useState[0],
      setIsSearchForm = _useState[1];

  var track = Object(useTracking["a" /* useTracking */])();

  var onLoadingStart = function onLoadingStart() {
    dispatch(Object(globalLoader_action["d" /* startLoading */])());
  };

  var onLoadingEnd = function onLoadingEnd() {
    dispatch(Object(globalLoader_action["c" /* endLoading */])());
  };

  var handleError = function handleError(error) {
    dispatch(customerSearch_action_setCustomerSearchResult({
      error: error
    }));
    closeLayer();
  };

  var onError = function onError(error) {
    handleError(error);
  };

  var onSelect = function onSelect(selectedHousehold) {
    track({
      actionGA: 'participant',
      categoryGA: 'bookingEngine',
      labelGA: 'layerCTA_AddCustomer'
    });
    dispatch(customerSearch_action_setCustomerSearchResult({
      data: selectedHousehold
    }));
    closeLayer();
  };

  var onSuccess = function onSuccess(data) {
    var _data$customerHouseho;

    if ((data === null || data === void 0 ? void 0 : (_data$customerHouseho = data.customerHouseholds) === null || _data$customerHouseho === void 0 ? void 0 : _data$customerHouseho.length) > 0) {
      setIsSearchForm(false);
    } else {
      var error = new Error('CUSTOMER_NOT_FOUND');
      handleError(error);
    }
  };

  var onSearch = function onSearch() {
    track({
      actionGA: 'participant',
      categoryGA: 'bookingEngine',
      labelGA: 'layerCTA_searchCustomer'
    });
  };

  return SearchCustomerLayer_jsx(ClosableLayer["a" /* ClosableLayer */], {
    backLabel: Object(src_i18n["g" /* t */])('booking.partners.traveller.existingCustomer.back'),
    header: SearchCustomerLayer_jsx(Title["a" /* Title */], {
      className: "ml-px10 text-center",
      theme: "title-brand-3"
    }, isSearchForm ? Object(src_i18n["g" /* t */])('booking.partners.traveller.existingCustomer.findCustomer') : Object(src_i18n["g" /* t */])('booking.partners.traveller.existingCustomer.results')),
    iconName: icons["a" /* ICONS */].BOLDER_ARROW_FORTH_LEFT,
    name: name,
    onClose: onClose
  }, SearchCustomerLayer_jsx(CustomerSearch_CustomerSearch, {
    onError: onError,
    onLoadingStart: onLoadingStart,
    onLoadingEnd: onLoadingEnd,
    onSearch: onSearch,
    onSelect: onSelect,
    onSuccess: onSuccess
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/formik/ScrollToErrorHook.js
var ScrollToErrorHook = __webpack_require__("I7/a");

// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/GmNumberOptionsProvider.jsx
var GmNumberOptionsProvider_jsx = react_default.a.createElement;




var GmNumberOptionsContext = /*#__PURE__*/react_default.a.createContext([]);
var GmNumberOptionsProvider_GmNumberOptionsProvider = function GmNumberOptionsProvider(_ref) {
  var children = _ref.children,
      formik = _ref.formik,
      i18n = _ref.i18n,
      attendeesList = _ref.attendeesList;
  var previousGmNumberOptions = Object(react["useRef"])([]);
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var userIsSeller = Object(sellerUtils["g" /* isSeller */])(appContext);
  var gmNumberOptions = userIsSeller ? Object(ContactInfoUtils["g" /* getGmNumbersOptions */])({
    formik: formik,
    i18n: i18n,
    previousGmNumberOptions: previousGmNumberOptions.current
  }) : [];

  if (previousGmNumberOptions.current.length > gmNumberOptions.length) {
    var newGmNumbersThatDisappeared = previousGmNumberOptions.current.filter(function (_ref2) {
      var value = _ref2.value;
      return !gmNumberOptions.find(function (option) {
        return option.value === value;
      });
    }).map(function (_ref3) {
      var value = _ref3.value;
      return value;
    })[0]; // $FlowFixMe 🤷‍🌊

    attendeesList.forEach(function (_ref4) {
      var _formik$values;

      var _ref4$isChild = _ref4.isChild,
          isChild = _ref4$isChild === void 0 ? false : _ref4$isChild,
          attendeeIndex = _ref4.attendeeIndex;
      var attendeeValueIdentifier = "".concat(isChild ? 'children' : 'adults', "[").concat(attendeeIndex, "].mainContactId");

      if ((formik === null || formik === void 0 ? void 0 : (_formik$values = formik.values) === null || _formik$values === void 0 ? void 0 : _formik$values.attendeeValueIdentifier) === newGmNumbersThatDisappeared) {
        formik.setFieldValue(attendeeValueIdentifier, '');
      }
    });
  }

  previousGmNumberOptions.current = gmNumberOptions;
  return GmNumberOptionsProvider_jsx(GmNumberOptionsContext.Provider, {
    value: gmNumberOptions
  }, children);
};
// EXTERNAL MODULE: ./src/client/store/seller/sellerInfoReducer.js
var sellerInfoReducer = __webpack_require__("+2AQ");

// CONCATENATED MODULE: ./src/client/components/frameworks/contact-info/contact-info-form/SellerEmail.jsx
var SellerEmail_jsx = react_default.a.createElement;








var SellerEmail_SellerEmail = function SellerEmail(_ref) {
  var formik = _ref.formik,
      validators = _ref.validators;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var dispatch = Object(es["d" /* useDispatch */])();
  var salesmanID = formik.values.seller.salesmanID;
  var salesmanIDFromState = Object(es["e" /* useSelector */])(function (state) {
    return state.seller.sellerInfo.salesmanID;
  });
  var isSalesmanIDEnabledForCmta = appContext.isCmta && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.cmta.salesmanID');
  var isSalesmanIDEnabledForCxoDirect = appContext.isDirectCxo && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.cxo.direct.salesmanID');
  var isSalesmanIDEnabledForCxoIndirect = appContext.isIndirectCxo && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.cxo.indirect.salesmanID');
  var shouldRenderSalesmanIDBlock = isSalesmanIDEnabledForCmta || isSalesmanIDEnabledForCxoDirect || isSalesmanIDEnabledForCxoIndirect;
  var hasSellerEmail = appContext.isCmta && formik.values.seller && formik.values.seller.email;
  Object(react["useEffect"])(function () {
    if (salesmanID) {
      dispatch(Object(sellerInfoReducer["c" /* setSalesmanID */])(salesmanID));
    } else {
      dispatch(Object(sellerInfoReducer["d" /* unsetSalesmanID */])());
    }
  }, [salesmanID]);
  Object(react["useEffect"])(function () {
    if (salesmanIDFromState) {
      dispatch(Object(sellerInfoReducer["c" /* setSalesmanID */])(salesmanIDFromState));
    }
  }, []);
  return hasSellerEmail || isSalesmanIDEnabledForCxoDirect || isSalesmanIDEnabledForCxoIndirect ? SellerEmail_jsx(Capsule["a" /* Capsule */], null, SellerEmail_jsx("div", {
    className: "flex mb-px20 p-px20"
  }, SellerEmail_jsx("div", {
    className: "flex-shrink-0 mr-px40 font-bold text-xl text-blue"
  }, Object(src_i18n["g" /* t */])('booking.participants.partnerInfosHeader.title')), SellerEmail_jsx("div", {
    className: "w-full"
  }, shouldRenderSalesmanIDBlock && SellerEmail_jsx("div", {
    className: "mb-4"
  }, SellerEmail_jsx(FormikInput["a" /* FormikInput */], {
    type: "text",
    label: Object(src_i18n["g" /* t */])('booking.partners.participants.salesmanID'),
    name: "seller.salesmanID",
    validate: validators.salesmanID,
    value: salesmanIDFromState
  })), !appContext.isCxo && SellerEmail_jsx(FormikInput["a" /* FormikInput */], {
    type: "email",
    label: Object(src_i18n["g" /* t */])('booking.participants.labels.email'),
    name: "seller.email",
    isDisabled: true
  })))) : null;
};
// EXTERNAL MODULE: ./src/client/components/frameworks/text-see-more/TextSeeMore.jsx
var TextSeeMore = __webpack_require__("VBBE");

// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/contact-info-form/MultiCGUBlock.jsx
var MultiCGUBlock_jsx = react_default.a.createElement;







//CGU ITEM
var MultiCGUBlock_CGUItem = function CGUItem(_ref) {
  var cguItem = _ref.cguItem,
      validators = _ref.validators,
      formik = _ref.formik,
      i18n = _ref.i18n;

  var handleItemChange = function handleItemChange() {
    if (formik.values.adults[0][cguItem.id]) formik.setFieldValue('adults[0].checkAll', false);
  };

  return MultiCGUBlock_jsx("div", {
    className: "mb-px20",
    "data-testid": "multiCGUBlock-cguItem"
  }, MultiCGUBlock_jsx("div", {
    className: "font-bold mb-px10 text-blue text-xl"
  }, cguItem.title), MultiCGUBlock_jsx("div", {
    className: "mb-px10 text-gray-darker whitespace-pre-wrap"
  }, cguItem.description), MultiCGUBlock_jsx(FormikInput["a" /* FormikInput */], {
    label: i18n.booking.participants.agreeButton,
    name: "adults[0].".concat(cguItem.id),
    type: "checkbox",
    additionnalClasses: "text-md",
    onChange: handleItemChange,
    validate: validators.legalAgreement,
    isRequired: cguItem.required
  }));
}; //MULTICGUs BLOCK


var MultiCGUBlock_MultiCGUBlock = function MultiCGUBlock(_ref2) {
  var i18n = _ref2.i18n,
      validators = _ref2.validators,
      idsCGU = _ref2.idsCGU,
      formik = _ref2.formik;

  var handleChange = function handleChange(e) {
    idsCGU.forEach(function (idCGU) {
      formik.setFieldValue("adults[0].".concat(idCGU), e.currentTarget.checked);
    });
  };

  if (!idsCGU || !i18n.bookingProcess) return null;
  var CGUs = i18n.bookingProcess; //filter the CGU to show in the block ( omitting phone/mail optin ... )

  var desiredCGUS = CGUs.filter(function (cguItem) {
    return idsCGU.includes(cguItem.id);
  });

  if (desiredCGUS.length > 1) {
    return MultiCGUBlock_jsx("div", {
      className: "mt-px10 text-sm",
      "data-testid": "multiCGUBlock-checkAll"
    }, MultiCGUBlock_jsx(Capsule["a" /* Capsule */], {
      additionalStyle: {
        content: {
          padding: '1.25rem'
        }
      }
    }, MultiCGUBlock_jsx(FormikInput["a" /* FormikInput */], {
      additionnalClasses: "text-lg mb-px10",
      className: "text-gray-darker text-lg",
      label: i18n.booking.participants.agreeAll,
      name: "adults[0].checkAll",
      onChange: handleChange,
      type: "checkbox"
    }), MultiCGUBlock_jsx("div", {
      className: "mb-px10"
    }, i18n.booking.participants.personalDataIntroduction), desiredCGUS.map(function (desiredCGUItem) {
      return MultiCGUBlock_jsx(MultiCGUBlock_CGUItem, {
        cguItem: desiredCGUItem,
        formik: formik,
        i18n: i18n,
        Key: desiredCGUItem.id,
        validators: validators
      });
    }), MultiCGUBlock_jsx("div", null, i18n.booking.participants.disagreePersonalDataCollection, MultiCGUBlock_jsx(DynamicLink["a" /* default */], {
      target: "_blank",
      url: i18n.booking.participants.personalDataCollectURL
    }, i18n.booking.participants.personalDataCollectLink))));
  } //Existant (EX : 1 GCU Russia CNIL)


  if (desiredCGUS.length === 1) {
    if (desiredCGUS[0].required) {
      return MultiCGUBlock_jsx("div", {
        className: "mt-px10",
        "data-testid": "multiCGUBlock-cguItem"
      }, MultiCGUBlock_jsx(Title["a" /* Title */], {
        className: "mb-px10",
        theme: "title-sans-2"
      }, desiredCGUS[0].label), MultiCGUBlock_jsx(Capsule["a" /* Capsule */], {
        additionalStyle: {
          content: {
            padding: '1.25rem'
          }
        }
      }, MultiCGUBlock_jsx(FormikInput["a" /* FormikInput */], {
        isRequired: true,
        label: desiredCGUS[0].description,
        name: "adults[0].legalAgreement",
        type: "checkbox",
        validate: validators.legalAgreement
      })));
    }

    return MultiCGUBlock_jsx("div", {
      className: "mt-px10",
      "data-testid": "multiCGUBlock-cguItem"
    }, MultiCGUBlock_jsx("div", null, desiredCGUS[0].label), MultiCGUBlock_jsx(TextSeeMore["a" /* TextSeeMore */], {
      text: desiredCGUS[0].description,
      theme: "text-sans-2",
      seeMoreLabel: i18n.booking.participants.legalMessage.seeMoreLabel,
      seeMoreTheme: "gray"
    }));
  }

  return null;
};
// EXTERNAL MODULE: ./src/utils/keyCodes.js
var keyCodes = __webpack_require__("05v4");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/inputsUtils.js
var inputsUtils = __webpack_require__("vpua");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/formik-input/Radio.jsx
var Radio = __webpack_require__("yWv5");

// CONCATENATED MODULE: ./src/client/components/frameworks/formik/RadioGroup.jsx
var RadioGroup_jsx = react_default.a.createElement;





var RadioGroup_RadioGroup = function RadioGroup(_ref) {
  var className = _ref.className,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      name = _ref.name,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      validate = _ref.validate;
  return RadioGroup_jsx("div", {
    className: classnames_default()(className, 'flex -mx-px5')
  }, options.map(function (_ref2) {
    var label = _ref2.label,
        value = _ref2.value;
    var fieldIdentifier = "".concat(name, "-").concat(value);
    return RadioGroup_jsx(formik_esm["a" /* FastField */], {
      key: fieldIdentifier,
      name: name,
      type: "radio",
      validate: validate ? Object(inputsUtils["c" /* getValidateFieldFunction */])(validate) : undefined,
      value: value
    }, function (_ref3) {
      var field = _ref3.field,
          form = _ref3.form;

      var _getValidationStatus = Object(inputsUtils["d" /* getValidationStatus */])(field, form, false),
          isErrored = _getValidationStatus.isErrored;

      return RadioGroup_jsx(Radio["a" /* Radio */], {
        className: classnames_default()('border-1 flex-1 font-bold mx-px5 p-px10 rounded-tiny', {
          'border-gray-dark': !isErrored,
          'border-danger': isErrored && isRequired
        }),
        field: field,
        form: form,
        isRequired: isRequired,
        label: label,
        size: 20
      });
    });
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx + 1 modules
var Text = __webpack_require__("qqKu");

// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/contact-info-form/LegalInfo.jsx
var LegalInfo_jsx = react_default.a.createElement;




var LegalInfo_LegalInfo = function LegalInfo(_ref) {
  var attendeeIdentifier = _ref.attendeeIdentifier,
      dateFormat = _ref.dateFormat,
      dayPlaceholder = _ref.dayPlaceholder,
      expirationDate = _ref.expirationDate,
      identityNumberInformation = _ref.identityNumberInformation,
      isMain = _ref.isMain,
      issuingDate = _ref.issuingDate,
      monthPlaceholder = _ref.monthPlaceholder,
      nationalitiesByLocale = _ref.nationalitiesByLocale,
      nationality = _ref.nationality,
      onKeyDown = _ref.onKeyDown,
      passportInformation = _ref.passportInformation,
      validators = _ref.validators,
      yearPlaceholder = _ref.yearPlaceholder;

  var _useContext = Object(react["useContext"])(ReactAppContext["a" /* default */]),
      isSeller = _useContext.isSeller;

  var hasPassportField = passportInformation && ((passportInformation === null || passportInformation === void 0 ? void 0 : passportInformation.concernedAttendees) === 'all' || isMain);
  var hasExpirationDateField = expirationDate && ((expirationDate === null || expirationDate === void 0 ? void 0 : expirationDate.concernedAttendees) === 'all' || isMain);
  var hasIssuingDateField = issuingDate && ((issuingDate === null || issuingDate === void 0 ? void 0 : issuingDate.concernedAttendees) === 'all' || isMain);
  var hasNationalityField = nationality && nationalitiesByLocale && ((nationality === null || nationality === void 0 ? void 0 : nationality.concernedAttendees) === 'all' || isMain);
  var hasIdentityNumber = identityNumberInformation && ((identityNumberInformation === null || identityNumberInformation === void 0 ? void 0 : identityNumberInformation.concernedAttendees) === 'all' || isMain);

  if (!hasPassportField && !hasExpirationDateField && !hasIssuingDateField && !hasNationalityField && !hasIdentityNumber) {
    return null;
  }

  return LegalInfo_jsx("fieldset", {
    className: "p-px10 mt-px10"
  }, hasPassportField && LegalInfo_jsx("div", {
    className: "p-px10"
  }, LegalInfo_jsx(FormikInput["a" /* FormikInput */], {
    isRequired: (passportInformation === null || passportInformation === void 0 ? void 0 : passportInformation.required) && !isSeller,
    label: passportInformation === null || passportInformation === void 0 ? void 0 : passportInformation.label,
    name: "".concat(attendeeIdentifier, ".passport.documentNumber"),
    onKeyDown: onKeyDown,
    type: "text",
    validate: validators.documentNumber
  }), LegalInfo_jsx(Text["a" /* Text */], {
    text: passportInformation === null || passportInformation === void 0 ? void 0 : passportInformation.description,
    theme: "text-sans-2"
  })), hasExpirationDateField && LegalInfo_jsx("div", {
    className: "p-px10"
  }, LegalInfo_jsx(FormikInput["a" /* FormikInput */], {
    "data-testid": "expirationDate",
    dateFormat: dateFormat,
    dayPlaceholder: dayPlaceholder,
    isRequired: (expirationDate === null || expirationDate === void 0 ? void 0 : expirationDate.required) && !isSeller,
    label: expirationDate === null || expirationDate === void 0 ? void 0 : expirationDate.label,
    monthPlaceholder: monthPlaceholder,
    name: "".concat(attendeeIdentifier, ".passport.expirationDate"),
    onKeyDown: onKeyDown,
    type: "birthdate",
    validate: validators.expirationDate,
    yearPlaceholder: yearPlaceholder
  }), LegalInfo_jsx(Text["a" /* Text */], {
    text: expirationDate === null || expirationDate === void 0 ? void 0 : expirationDate.description,
    theme: "text-sans-2"
  })), hasIssuingDateField && LegalInfo_jsx("div", {
    className: "p-px10"
  }, LegalInfo_jsx(FormikInput["a" /* FormikInput */], {
    "data-testid": "issuingDate",
    dateFormat: dateFormat,
    dayPlaceholder: dayPlaceholder,
    isRequired: (issuingDate === null || issuingDate === void 0 ? void 0 : issuingDate.required) && !isSeller,
    label: issuingDate === null || issuingDate === void 0 ? void 0 : issuingDate.label,
    monthPlaceholder: monthPlaceholder,
    name: "".concat(attendeeIdentifier, ".passport.issuingDate"),
    onKeyDown: onKeyDown,
    type: "birthdate",
    validate: validators.issuingDate,
    yearPlaceholder: yearPlaceholder
  }), LegalInfo_jsx(Text["a" /* Text */], {
    text: issuingDate === null || issuingDate === void 0 ? void 0 : issuingDate.description,
    theme: "text-sans-2"
  })), hasNationalityField && LegalInfo_jsx("div", {
    className: "p-px10"
  }, LegalInfo_jsx(FormikInput["a" /* FormikInput */], {
    "data-testid": "nationalitiesDropDown",
    isRequired: (nationality === null || nationality === void 0 ? void 0 : nationality.required) && !isSeller,
    label: nationality === null || nationality === void 0 ? void 0 : nationality.label,
    name: "".concat(attendeeIdentifier, ".passport.nationality"),
    onKeyDown: onKeyDown,
    options: nationalitiesByLocale && nationalitiesByLocale.map(function (_ref2) {
      var codeIso2 = _ref2.codeIso2,
          country = _ref2.country;
      return {
        name: country,
        value: codeIso2
      };
    }),
    type: "select",
    validate: validators.nationality
  }), LegalInfo_jsx(Text["a" /* Text */], {
    text: nationality === null || nationality === void 0 ? void 0 : nationality.description,
    theme: "text-sans-2"
  })), hasIdentityNumber && LegalInfo_jsx("div", {
    className: "p-px10"
  }, LegalInfo_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "identityNumber_input",
    isRequired: identityNumberInformation === null || identityNumberInformation === void 0 ? void 0 : identityNumberInformation.required,
    label: identityNumberInformation === null || identityNumberInformation === void 0 ? void 0 : identityNumberInformation.label,
    name: "".concat(attendeeIdentifier, ".identityNumber"),
    onKeyDown: onKeyDown,
    type: "text",
    validate: validators.identityNumber
  }), LegalInfo_jsx(Text["a" /* Text */], {
    text: identityNumberInformation === null || identityNumberInformation === void 0 ? void 0 : identityNumberInformation.description,
    theme: "text-sans-2"
  })));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var react_collapse_lib = __webpack_require__("3OwS");

// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/contact-info-form/ContactAddressForm.jsx

var ContactAddressForm_jsx = react_default.a.createElement;










var FIELDS_CLASSES = {
  streetName: 'sm:w-3/4',
  streetNumber: 'w-1/2 sm:w-1/4',
  zipCode: 'w-1/2 sm:w-1/3',
  city: 'sm:w-2/3'
};
var MAIN_FIELDS_NAMES = ['streetNumber', 'streetName', 'zipCode', 'city'];

var ContactAddressForm_AddressInput = function AddressInput(_ref) {
  var attendeeIdentifier = _ref.attendeeIdentifier,
      autoComplete = _ref.autoComplete,
      fieldName = _ref.fieldName,
      i18n = _ref.i18n,
      _ref$isCountry = _ref.isCountry,
      isCountry = _ref$isCountry === void 0 ? false : _ref$isCountry,
      onKeyDown = _ref.onKeyDown,
      required = _ref.required,
      validators = _ref.validators;

  var _useContext = Object(react["useContext"])(ReactAppContext["a" /* default */]),
      locale = _useContext.locale;

  var options = [];

  if (isCountry) {
    var getCountries = function getCountries() {
      return domains_service_dist_default.a.getLocaleCountries(locale).map(function (_ref2) {
        var code = _ref2.code,
            name = _ref2.name;
        return {
          value: code,
          name: name
        };
      });
    };

    options = getCountries();
  }

  return (// $FlowFixMe : flow does not understand fallback
    ContactAddressForm_jsx("div", {
      className: classnames_default()('p-px10', FIELDS_CLASSES[fieldName] || 'w-full')
    }, ContactAddressForm_jsx(FormikInput["a" /* FormikInput */], {
      autoComplete: autoComplete,
      isDisabled: options.length === 1,
      isRequired: !!required,
      label: i18n.common.participants.address[fieldName],
      name: "".concat(attendeeIdentifier, ".address.").concat(fieldName),
      onKeyDown: onKeyDown,
      options: options,
      type: isCountry ? 'select' : 'text',
      validate: validators.address[fieldName]
    }))
  );
};

var ContactAddressForm_ContactAddressForm = function ContactAddressForm(_ref3) {
  var _sortedSchema$find;

  var addressSchema = _ref3.addressSchema,
      attendeeIdentifier = _ref3.attendeeIdentifier,
      i18n = _ref3.i18n,
      onKeyDown = _ref3.onKeyDown,
      validators = _ref3.validators;

  var _useState = Object(react["useState"])(false),
      isExpanded = _useState[0],
      setIsExpanded = _useState[1];

  var showOnlyCountryCode = i18n.booking.participants.postalAddress.displayCountryFieldOnly;
  var sortedSchema = addressSchema.sort(ContactInfoUtils["a" /* addressSchemaSort */]);
  var mainFields = sortedSchema.filter(function (f) {
    return (MAIN_FIELDS_NAMES.includes(f.name) || f.required) && f.name !== 'countryCode';
  });
  var additionnalFields = sortedSchema.filter(function (f) {
    return !MAIN_FIELDS_NAMES.includes(f.name) && f.name !== 'countryCode' && !f.required;
  });
  return ContactAddressForm_jsx(react["Fragment"], null, !showOnlyCountryCode && ContactAddressForm_jsx(react["Fragment"], null, mainFields.map(function (_ref4) {
    var fieldName = _ref4.name,
        required = _ref4.required;
    return ContactAddressForm_jsx(ContactAddressForm_AddressInput, Object(esm_extends["a" /* default */])({}, fieldName === 'streetNumber' ? {
      autoComplete: 'nope'
    } : null, {
      attendeeIdentifier: attendeeIdentifier,
      fieldName: fieldName,
      i18n: i18n,
      key: fieldName,
      onKeyDown: onKeyDown,
      required: required,
      validators: validators
    }));
  }), ContactAddressForm_jsx(react_collapse_lib["UnmountClosed"], {
    isOpened: isExpanded,
    theme: {
      collapse: 'ReactCollapse--collapse w-full',
      content: 'pt-px20'
    }
  }, additionnalFields.map(function (_ref5) {
    var fieldName = _ref5.name,
        required = _ref5.required;
    return ContactAddressForm_jsx(ContactAddressForm_AddressInput, {
      attendeeIdentifier: attendeeIdentifier,
      autoComplete: "nope",
      fieldName: fieldName,
      i18n: i18n,
      key: fieldName,
      onKeyDown: onKeyDown,
      required: required,
      validators: validators
    });
  }))), ContactAddressForm_jsx("button", {
    className: "flex items-center rtl:ml-auto p-px10 pb-0 reset-button text-base text-gray-darker underline",
    onClick: function onClick() {
      return setIsExpanded(!isExpanded);
    },
    type: "button"
  }, isExpanded ? Object(src_i18n["g" /* t */])('common.close') : Object(src_i18n["g" /* t */])('common.participants.address.additionalInformationLegend'), ContactAddressForm_jsx(Icon["a" /* Icon */], {
    className: "rtl:ml-px5",
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH_DOWN,
    rotation: isExpanded ? 180 : 0,
    width: "0.5em"
  })), ContactAddressForm_jsx(ContactAddressForm_AddressInput, {
    attendeeIdentifier: attendeeIdentifier,
    fieldName: "countryCode",
    i18n: i18n,
    isCountry: true,
    required: (_sortedSchema$find = sortedSchema.find(function (f) {
      return f.name === 'countryCode';
    })) === null || _sortedSchema$find === void 0 ? void 0 : _sortedSchema$find.required,
    validators: validators
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/contact-info-form/MainContactInfos.jsx
var MainContactInfos_jsx = react_default.a.createElement;







var MainContactInfos_MainContactInfos = function MainContactInfos(_ref) {
  var addressSchema = _ref.addressSchema,
      attendeeIdentifier = _ref.attendeeIdentifier,
      connectedUserInfo = _ref.connectedUserInfo,
      formik = _ref.formik,
      hasAddress = _ref.hasAddress,
      i18n = _ref.i18n,
      onKeyDown = _ref.onKeyDown,
      userIsSeller = _ref.userIsSeller,
      validators = _ref.validators;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var hasCheckedPhoneOrSmsOptins = Object(lodash["get"])(formik.values, "".concat(attendeeIdentifier, ".optinPhone")) || Object(lodash["get"])(formik.values, "".concat(attendeeIdentifier, ".optinSms"));
  var oneOfEmailAndPhoneReqForDirectCxo = appContext.isDirectCxo && Object(lodash["get"])(formik.values, "".concat(attendeeIdentifier, ".email")) && !hasCheckedPhoneOrSmsOptins;
  return MainContactInfos_jsx(react["Fragment"], null, MainContactInfos_jsx("fieldset", {
    className: "sm:flex sm:flex-wrap p-px10 mt-px10"
  }, MainContactInfos_jsx("div", {
    className: "p-px10 sm:w-1/2"
  }, MainContactInfos_jsx(FormikInput["a" /* FormikInput */], {
    isDisabled: Object(ContactInfoUtils["o" /* shouldHideField */])({
      attendeeIdentifier: attendeeIdentifier,
      connectedUserInfo: connectedUserInfo,
      fieldName: 'email',
      formInitialValues: formik.initialValues,
      userIsSeller: userIsSeller
    }),
    isRequired: appContext.isCmta ? Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('contactInfo.cmta.requiredEmail') : !appContext.isIndirectCxo && !(appContext.isDirectCxo && Object(lodash["get"])(formik.values, "".concat(attendeeIdentifier, ".mobile"))),
    label: i18n.booking.participants.labels.email,
    name: "".concat(attendeeIdentifier, ".email"),
    onKeyDown: onKeyDown,
    type: "email",
    validate: appContext.isCmta && !Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('contactInfo.cmta.requiredEmail') || appContext.isDirectCxo && Object(lodash["get"])(formik.values, "".concat(attendeeIdentifier, ".mobile")) || appContext.isIndirectCxo ? validators.emailNotRequired : validators.email
  })), MainContactInfos_jsx("div", {
    className: "p-px10 sm:w-1/2"
  }, MainContactInfos_jsx(FormikInput["a" /* FormikInput */], {
    isDisabled: Object(ContactInfoUtils["o" /* shouldHideField */])({
      attendeeIdentifier: attendeeIdentifier,
      connectedUserInfo: connectedUserInfo,
      fieldName: 'mobile',
      fieldNameConnectedUserOverride: 'mobilePhoneNumber',
      formInitialValues: formik.initialValues,
      userIsSeller: userIsSeller
    }),
    isRequired: appContext.isCmta ? Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('contactInfo.cmta.requiredMobile') : !appContext.isIndirectCxo && !oneOfEmailAndPhoneReqForDirectCxo,
    label: i18n.booking.participants.labels.phone,
    name: "".concat(attendeeIdentifier, ".mobile"),
    onKeyDown: onKeyDown,
    type: "tel",
    validate: appContext.isCmta && !Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('contactInfo.cmta.requiredMobile') || oneOfEmailAndPhoneReqForDirectCxo || appContext.isIndirectCxo ? validators.mobileNotRequired : validators.mobile
  }))), hasAddress && MainContactInfos_jsx("fieldset", {
    className: "sm:flex sm:flex-wrap p-px10 mt-px10"
  }, MainContactInfos_jsx(ContactAddressForm_ContactAddressForm, {
    addressSchema: addressSchema,
    attendeeIdentifier: attendeeIdentifier,
    i18n: i18n,
    onKeyDown: onKeyDown,
    validators: validators
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/contact-info-form/SellerInfos.jsx
var SellerInfos_jsx = react_default.a.createElement;

 //import { GmNumberOptionsContext } from 'Components/widgets/contact-info/GmNumberOptionsProvider';


var SellerInfos_SellerInfos = function SellerInfos(_ref) {
  var attendeeIdentifier = _ref.attendeeIdentifier,
      formik = _ref.formik,
      i18n = _ref.i18n,
      onKeyDown = _ref.onKeyDown;
  //const gmNumbersOptions = useContext(GmNumberOptionsContext);  temporarily disabled: waiting for clic evolv
  var gmNumber = Object(lodash["get"])(formik.initialValues, "".concat(attendeeIdentifier, ".gmNumber")); //const attendeeIsChild = isChild(attendeeIdentifier);
  // children can't be a new household so we hide this option (it's the last)
  //const options = attendeeIsChild ? gmNumbersOptions.slice(0, -1) : gmNumbersOptions; temporarily disabled: waiting for clic evolv
  // it's temporarily: waiting for clic evolv

  if (!gmNumber) {
    return null;
  }

  return SellerInfos_jsx("div", {
    className: "p-px10 sm:w-full"
  }, SellerInfos_jsx(FormikInput["a" /* FormikInput */], {
    isDisabled: true,
    label: i18n.booking.participants.labels.gmNumber,
    name: "".concat(attendeeIdentifier, ".gmNumber"),
    onKeyDown: onKeyDown,
    type: "text"
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/contact-info-form/Subscriptions.jsx
var Subscriptions_jsx = react_default.a.createElement;








var Subscriptions_Subscriptions = function Subscriptions(_ref) {
  var attendeeIdentifier = _ref.attendeeIdentifier,
      formik = _ref.formik,
      i18n = _ref.i18n;
  var optins = Object(ContactInfoUtils["l" /* getOptinsInfos */])(i18n.bookingProcess);
  var showOptinEmail = Object(lodash["get"])(formik.values, "".concat(attendeeIdentifier, ".optinEmail")) !== undefined;
  var showOptinSms = Object(lodash["get"])(formik.values, "".concat(attendeeIdentifier, ".optinSms")) !== undefined;
  var showOptinMail = Object(lodash["get"])(formik.values, "".concat(attendeeIdentifier, ".optinMail")) !== undefined;
  var showOptinFosun = Object(lodash["get"])(formik.values, "".concat(attendeeIdentifier, ".optinFosun")) !== undefined;
  var showOptinPhone = Object(lodash["get"])(formik.values, "".concat(attendeeIdentifier, ".optinPhone")) !== undefined;
  var showOptinClubmedPlus = Object(lodash["get"])(formik.values, "".concat(attendeeIdentifier, ".optinClubmedPlus")) !== undefined;

  var _useContext = Object(react["useContext"])(ReactAppContext["a" /* default */]),
      isCmta = _useContext.isCmta;

  var subscriptionTitle = isCmta ? Object(src_i18n["g" /* t */])('booking.partners.participants.subscription.title') : Object(src_i18n["g" /* t */])('booking.participants.subscription.title');

  if (!showOptinEmail && !showOptinSms && !showOptinMail && !showOptinFosun && !showOptinPhone && !showOptinClubmedPlus) {
    return null;
  }

  return Subscriptions_jsx("fieldset", {
    className: "py-px15 p-px10 mt-px10"
  }, Subscriptions_jsx("div", {
    className: "font-bold py-px5 px-px10"
  }, subscriptionTitle), showOptinEmail && optins.email && Subscriptions_jsx("div", {
    className: "px-px10 py-px5"
  }, Subscriptions_jsx(FormikInput["a" /* FormikInput */], {
    iconColor: colors["a" /* COLORS */].BLUE,
    iconName: icons["a" /* ICONS */].INTERNET,
    label: optins.email.label,
    name: "".concat(attendeeIdentifier, ".optinEmail"),
    type: "checkbox"
  })), showOptinPhone && optins.phone && Subscriptions_jsx("div", {
    className: "px-px10 py-px5"
  }, Subscriptions_jsx(FormikInput["a" /* FormikInput */], {
    iconColor: colors["a" /* COLORS */].BLUE,
    iconName: icons["a" /* ICONS */].PHONE,
    label: optins.phone.label,
    name: "".concat(attendeeIdentifier, ".optinPhone"),
    type: "checkbox"
  })), showOptinSms && optins.sms && Subscriptions_jsx("div", {
    className: "px-px10 py-px5"
  }, Subscriptions_jsx(FormikInput["a" /* FormikInput */], {
    iconColor: colors["a" /* COLORS */].BLUE,
    iconName: icons["a" /* ICONS */].PHONE,
    label: optins.sms.label,
    name: "".concat(attendeeIdentifier, ".optinSms"),
    type: "checkbox"
  })), showOptinMail && optins.mail && Subscriptions_jsx("div", {
    className: "px-px10 py-px5"
  }, Subscriptions_jsx(FormikInput["a" /* FormikInput */], {
    iconColor: colors["a" /* COLORS */].BLUE,
    iconName: icons["a" /* ICONS */].MAIL,
    label: optins.mail.label,
    name: "".concat(attendeeIdentifier, ".optinMail"),
    type: "checkbox"
  })), showOptinFosun && optins.fosun && Subscriptions_jsx("div", {
    className: "px-px10 py-px5"
  }, Subscriptions_jsx(FormikInput["a" /* FormikInput */], {
    iconColor: colors["a" /* COLORS */].BLUE,
    label: optins.fosun.label,
    name: "".concat(attendeeIdentifier, ".optinFosun"),
    type: "checkbox"
  })), showOptinClubmedPlus && optins.clubmedPlus && Subscriptions_jsx("div", {
    className: "px-px10 py-px5"
  }, Subscriptions_jsx(FormikInput["a" /* FormikInput */], {
    iconColor: colors["a" /* COLORS */].SAND,
    iconName: icons["a" /* ICONS */].CLUBMED_PLUS,
    label: optins.clubmedPlus.label,
    name: "".concat(attendeeIdentifier, ".optinClubmedPlus"),
    type: "checkbox"
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/contact-info-form/UnicodeFields.jsx
var UnicodeFields_jsx = react_default.a.createElement;



var UnicodeFields_UnicodeFields = function UnicodeFields(_ref) {
  var attendeeIdentifier = _ref.attendeeIdentifier,
      connectedUserInfo = _ref.connectedUserInfo,
      formik = _ref.formik,
      i18n = _ref.i18n,
      onKeyDown = _ref.onKeyDown,
      validators = _ref.validators,
      userIsSeller = _ref.userIsSeller;
  return UnicodeFields_jsx(react["Fragment"], null, UnicodeFields_jsx("div", {
    className: "p-px10 sm:w-1/2"
  }, UnicodeFields_jsx(FormikInput["a" /* FormikInput */], {
    isDisabled: Object(ContactInfoUtils["o" /* shouldHideField */])({
      attendeeIdentifier: attendeeIdentifier,
      connectedUserInfo: connectedUserInfo,
      fieldName: 'unicodeFirstName',
      formInitialValues: formik.initialValues,
      userIsSeller: userIsSeller
    }),
    isRequired: true,
    label: i18n.booking.participants.labels.unicodeFirstName,
    name: "".concat(attendeeIdentifier, ".unicodeFirstName"),
    onKeyDown: onKeyDown,
    type: "text",
    validate: validators.unicodeFirstName
  })), UnicodeFields_jsx("div", {
    className: "p-px10 sm:w-1/2"
  }, UnicodeFields_jsx(FormikInput["a" /* FormikInput */], {
    isDisabled: Object(ContactInfoUtils["o" /* shouldHideField */])({
      attendeeIdentifier: attendeeIdentifier,
      connectedUserInfo: connectedUserInfo,
      fieldName: 'unicodeLastName',
      formInitialValues: formik.initialValues,
      userIsSeller: userIsSeller
    }),
    isRequired: true,
    label: i18n.booking.participants.labels.unicodeLastName,
    name: "".concat(attendeeIdentifier, ".unicodeLastName"),
    onKeyDown: onKeyDown,
    type: "text",
    validate: validators.unicodeLastName
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/contact-info-form/PersonInfo.jsx

var PersonInfo_jsx = react_default.a.createElement;




















var ADULT_ATTENDEE_TYPE = 'ADULT';
var CHILD_ATTENDEE_TYPE = 'CHILD';
var MAIN_ATTENDEE_TYPE = 'MAIN';
var PersonInfo_PersonInfo = function PersonInfo(_ref) {
  var addressSchema = _ref.addressSchema,
      adultCivilities = _ref.adultCivilities,
      attendeeIdentifier = _ref.attendeeIdentifier,
      attendeeIndex = _ref.attendeeIndex,
      childCivilities = _ref.childCivilities,
      connectedUserInfo = _ref.connectedUserInfo,
      displayUnicodeFields = _ref.displayUnicodeFields,
      expirationDate = _ref.expirationDate,
      formik = _ref.formik,
      hasAddress = _ref.hasAddress,
      i18n = _ref.i18n,
      id = _ref.id,
      identityNumberInformation = _ref.identityNumberInformation,
      isChild = _ref.isChild,
      isMain = _ref.isMain,
      issuingDate = _ref.issuingDate,
      isValid = _ref.isValid,
      nationalitiesByLocale = _ref.nationalitiesByLocale,
      nationality = _ref.nationality,
      passportInformation = _ref.passportInformation,
      userIsSeller = _ref.userIsSeller,
      validators = _ref.validators;
  var headerTitle = Object(ContactInfoUtils["h" /* getHeaderContactInfoTitle */])({
    attendeeIdentifier: attendeeIdentifier,
    attendeeIndex: attendeeIndex,
    displayUnicodeFields: displayUnicodeFields,
    formValues: formik.values,
    i18n: i18n,
    isChild: isChild,
    isMain: isMain,
    isValid: isValid
  });
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var selectedProposal = Object(es["e" /* useSelector */])(booking_selector["k" /* getCurrentProposal */]);
  var dataForm = "PersonInfo-".concat(id);
  var hasCheckedPhoneOrSmsOptins = Object(lodash["get"])(formik.values, "".concat(attendeeIdentifier, ".optinPhone")) || Object(lodash["get"])(formik.values, "".concat(attendeeIdentifier, ".optinSms"));

  var isChildAboveEleven = function isChildAboveEleven() {
    if (isChild) {
      var childBirthdate = Object(lodash["get"])(formik.values, "".concat(attendeeIdentifier, ".birthdate"));
      var yearsDiff = moment_default()().diff(childBirthdate, 'years', false);
      return yearsDiff >= 11;
    }

    return false;
  };

  var isPhoneVisibleOnChinaLocale = Object(localeUtils["a" /* isChineseLocale */])(appContext.locale) && !isMain && (!isChild || isChildAboveEleven()) && selectedProposal.transports;

  var onKeyDown = function onKeyDown(e) {
    if (e.which === keyCodes["f" /* ENTER */]) {
      var inputs = document.querySelectorAll("[data-form=\"".concat(dataForm, "\"] input, [data-form=\"").concat(dataForm, "\"] select"));

      if (inputs) {
        // $FlowFixMe : flow does not reccognize id key in EventTarget
        var currentIndex = Object(toConsumableArray["a" /* default */])(inputs).findIndex(function (i) {
          return i.name === e.target.name;
        });

        if (currentIndex < inputs.length - 1) {
          var selector = inputs[currentIndex + 1].name;
          var next = document.querySelector("[name=\"".concat(selector, "\"]"));

          if (next) {
            next.focus();
            Object(scrollToElement["a" /* scrollToElement */])("[for=\"".concat(selector, "\"]"), 100);
          }
        }
      }
    }
  };

  return PersonInfo_jsx(react["Fragment"], null, PersonInfo_jsx(Title["a" /* Title */], {
    className: isMain ? '' : 'mb-px10',
    theme: "title-brand-8"
  }, headerTitle), isMain && PersonInfo_jsx("p", {
    className: "mb-px10 reset-paragraph text-base"
  }, i18n.booking.participants.personnalInfosHeader.mainContactDescription), PersonInfo_jsx(Capsule["a" /* Capsule */], null, PersonInfo_jsx("p", {
    className: "sm:absolute mx-px20 mt-px5 reset-paragraph rtl:right-0 text-gray-darker text-right text-sm"
  }, i18n.booking.participants.labels.mandatoryField), PersonInfo_jsx("form", {
    "data-form": dataForm
  }, PersonInfo_jsx("fieldset", {
    className: "flex flex-col sm:flex-row sm:flex-wrap p-px10 pt-px5 sm:pt-px10"
  }, PersonInfo_jsx(RadioGroup_RadioGroup, {
    className: "p-px10 sm:w-2/3",
    isRequired: true,
    name: "".concat(attendeeIdentifier, ".civility"),
    options: isChild ? childCivilities : adultCivilities,
    validate: isChild ? validators.childCivilities : validators.adultCivilities
  }), PersonInfo_jsx("div", {
    className: "p-px10 sm:w-1/2"
  }, PersonInfo_jsx(FormikInput["a" /* FormikInput */], {
    autoComplete: "given-name",
    isDisabled: Object(ContactInfoUtils["o" /* shouldHideField */])({
      attendeeIdentifier: attendeeIdentifier,
      connectedUserInfo: connectedUserInfo,
      fieldName: 'firstName',
      formInitialValues: formik.initialValues,
      userIsSeller: userIsSeller
    }),
    isRequired: true,
    label: i18n.booking.participants.labels.firstName,
    labelAdditionalInfo: i18n.booking.participants.labels.passportInfo,
    name: "".concat(attendeeIdentifier, ".firstName"),
    onKeyDown: onKeyDown,
    type: "text",
    validate: validators.firstName
  })), PersonInfo_jsx("div", {
    className: "p-px10 sm:w-1/2"
  }, PersonInfo_jsx(FormikInput["a" /* FormikInput */], {
    autoComplete: "family-name",
    isDisabled: Object(ContactInfoUtils["o" /* shouldHideField */])({
      attendeeIdentifier: attendeeIdentifier,
      connectedUserInfo: connectedUserInfo,
      fieldName: 'lastName',
      formInitialValues: formik.initialValues,
      userIsSeller: userIsSeller
    }),
    isRequired: true,
    label: i18n.booking.participants.labels.lastName,
    labelAdditionalInfo: i18n.booking.participants.labels.passportInfo,
    name: "".concat(attendeeIdentifier, ".lastName"),
    onKeyDown: onKeyDown,
    type: "text",
    validate: validators.lastName
  })), displayUnicodeFields && PersonInfo_jsx(UnicodeFields_UnicodeFields, {
    attendeeIdentifier: attendeeIdentifier,
    connectedUserInfo: connectedUserInfo,
    formik: formik,
    i18n: i18n,
    onKeyDown: onKeyDown,
    userIsSeller: userIsSeller,
    validators: validators
  }), userIsSeller && PersonInfo_jsx(SellerInfos_SellerInfos, {
    attendeeIdentifier: attendeeIdentifier,
    formik: formik,
    i18n: i18n,
    validators: validators
  }), PersonInfo_jsx("div", {
    className: classnames_default()('p-px10 sm:w-full', {
      'order-first': isChild
    })
  }, PersonInfo_jsx(FormikInput["a" /* FormikInput */], {
    dateFormat: i18n.booking.form.dateFormat,
    dayPlaceholder: i18n.booking.form.dayPlaceholder,
    isDisabled: isChild,
    isRequired: true,
    label: i18n.booking.participants.labels.birthdate,
    labelAdditionalInfo: i18n.booking.participants.labels.passportInfo,
    monthPlaceholder: i18n.booking.form.monthPlaceholder,
    name: "".concat(attendeeIdentifier, ".birthdate"),
    onKeyDown: onKeyDown,
    type: "birthdate",
    validate: isChild ? validators.childBirthDate : validators.adultBirthDate,
    yearPlaceholder: i18n.booking.form.yearPlaceholder
  }))), isPhoneVisibleOnChinaLocale && PersonInfo_jsx("fieldset", {
    className: "p-px10 mt-px10"
  }, PersonInfo_jsx("div", {
    className: "p-px10"
  }, PersonInfo_jsx(FormikInput["a" /* FormikInput */], {
    isDisabled: Object(ContactInfoUtils["o" /* shouldHideField */])({
      attendeeIdentifier: attendeeIdentifier,
      connectedUserInfo: connectedUserInfo,
      fieldName: 'mobile',
      fieldNameConnectedUserOverride: 'mobilePhoneNumber',
      formInitialValues: formik.initialValues,
      userIsSeller: userIsSeller
    }),
    isRequired: !appContext.isCmta && !appContext.isIndirectCxo && !(userIsSeller && Object(lodash["get"])(formik.values, "".concat(attendeeIdentifier, ".email")) && !hasCheckedPhoneOrSmsOptins),
    label: i18n.booking.participants.labels.phone,
    name: "".concat(attendeeIdentifier, ".mobile"),
    onKeyDown: onKeyDown,
    type: "tel",
    validate: userIsSeller && Object(lodash["get"])(formik.values, "".concat(attendeeIdentifier, ".email")) && !hasCheckedPhoneOrSmsOptins || appContext.isCmta || appContext.isIndirectCxo ? validators.mobileNotRequired : validators.mobile
  }))), isMain && PersonInfo_jsx(MainContactInfos_MainContactInfos, {
    addressSchema: addressSchema,
    attendeeIdentifier: attendeeIdentifier,
    connectedUserInfo: connectedUserInfo,
    formik: formik,
    hasAddress: hasAddress,
    i18n: i18n,
    onKeyDown: onKeyDown,
    userIsSeller: userIsSeller,
    validators: validators
  }), PersonInfo_jsx(LegalInfo_LegalInfo, {
    attendeeIdentifier: attendeeIdentifier,
    dateFormat: i18n.booking.form.dateFormat,
    dayPlaceholder: i18n.booking.form.dayPlaceholder,
    expirationDate: expirationDate,
    identityNumberInformation: identityNumberInformation,
    isMain: isMain,
    issuingDate: issuingDate,
    monthPlaceholder: i18n.booking.form.monthPlaceholder,
    nationalitiesByLocale: nationalitiesByLocale,
    nationality: nationality,
    onKeyDown: onKeyDown,
    passportInformation: passportInformation,
    validators: validators,
    yearPlaceholder: i18n.booking.form.yearPlaceholder
  }), isMain && PersonInfo_jsx(Subscriptions_Subscriptions, {
    attendeeIdentifier: attendeeIdentifier,
    formik: formik,
    i18n: i18n
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/ContactInfoForm.jsx
var ContactInfoForm_jsx = react_default.a.createElement;


















var ContactInfoForm_ContactInfoForm = function ContactInfoForm(_ref) {
  var proposal = _ref.proposal,
      addressSchema = _ref.addressSchema,
      attendeesList = _ref.attendeesList,
      connectedUserInfo = _ref.connectedUserInfo,
      formik = _ref.formik,
      hasAddress = _ref.hasAddress,
      i18n = _ref.i18n,
      updateStoreAttendees = _ref.updateStoreAttendees,
      renderBottomNavBar = _ref.renderBottomNavBar;
  // we need a ref for formik for the unmount to have access to the formik bag (the formik bag ref change at every render 😭)
  var formikRef = Object(react["useRef"])();
  formikRef.current = formik;

  var _useState = Object(react["useState"])(false),
      initialValidationDone = _useState[0],
      setInitialValidationDone = _useState[1];

  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  Object(ScrollToErrorHook["a" /* useAutoScrollToError */])(formik);
  var departureDate = proposal.departureDate,
      arrivalDate = proposal.arrivalDate,
      transports = proposal.transports;
  var passportInformation = Object(ContactInfoUtils["k" /* getLegalInputInformation */])(i18n.bookingProcess, legalInformationIds_constants["h" /* PASSPORT_ID */]);
  var expirationDate = Object(ContactInfoUtils["k" /* getLegalInputInformation */])(i18n.bookingProcess, legalInformationIds_constants["g" /* PASSPORT_EXPIRATION_DATE */]);
  var issuingDate = Object(ContactInfoUtils["k" /* getLegalInputInformation */])(i18n.bookingProcess, legalInformationIds_constants["i" /* PASSPORT_ISSUING_DATE */]);
  var nationality = Object(ContactInfoUtils["k" /* getLegalInputInformation */])(i18n.bookingProcess, legalInformationIds_constants["f" /* NATIONALITY */]);
  var identityNumberInformation = Object(ContactInfoUtils["k" /* getLegalInputInformation */])(transports ? i18n.bookingWithTransportProcess : i18n.bookingProcess, legalInformationIds_constants["d" /* IDENTITY_NUMBER */]);
  var userIsSeller = Object(sellerUtils["g" /* isSeller */])(appContext);
  var track = Object(useTracking["a" /* useTracking */])(); // $FlowFixMe

  var adultCivilities = Object(react["useMemo"])(function () {
    return Object(ContactInfoUtils["e" /* getAdultCivilities */])(i18n.booking.participants.civilities.adult, appContext.locale);
  }, []);
  var childCivilities = Object(react["useMemo"])(function () {
    return Object(domains_service_dist["getKidsCivilities"])(appContext.locale);
  }, []);
  var validators = Object(react["useMemo"])(function () {
    return Object(ContactInfoUtils["m" /* getValidators */])({
      passportInformation: passportInformation,
      expirationDate: expirationDate,
      issuingDate: issuingDate,
      departureDate: departureDate,
      arrivalDate: arrivalDate,
      nationality: nationality,
      identityNumberInformation: identityNumberInformation,
      addressSchema: addressSchema,
      locale: appContext.locale,
      adultCivilities: adultCivilities.map(function (_ref2) {
        var value = _ref2.value;
        return value;
      }),
      childCivilities: childCivilities.map(function (_ref3) {
        var value = _ref3.value;
        return value;
      }),
      userIsSeller: userIsSeller
    });
  }, []);
  var nationalitiesByLocale = Object(react["useMemo"])(function () {
    return Object(domains_service_dist["getNationalities"])(appContext.locale);
  }, []); // initial validation to know if a subform is valid
  // on unmount update the store with form values

  Object(react["useEffect"])(function () {
    formik.validateForm().then(function () {
      setInitialValidationDone(true);
    });
    return function () {
      var _formikRef$current;

      //Only update store attendees if we submit participants step
      if ((_formikRef$current = formikRef.current) === null || _formikRef$current === void 0 ? void 0 : _formikRef$current.submitCount) {
        // $FlowFixMe always defined here
        updateStoreAttendees(Object(ContactInfoUtils["b" /* cleanUselessAttendeesValues */])(formikRef.current.values));
      }
    };
  }, []);
  return ContactInfoForm_jsx(GmNumberOptionsProvider_GmNumberOptionsProvider, {
    attendeesList: attendeesList,
    formik: formik,
    i18n: i18n
  }, ContactInfoForm_jsx(SellerEmail_SellerEmail, {
    formik: formik,
    validators: validators
  }), ContactInfoForm_jsx(Notification["a" /* Notification */], {
    className: "mb-px20 mt-px20",
    color: colors["a" /* COLORS */].ORANGE,
    hasBorder: true,
    icon: icons["a" /* ICONS */].WARNING,
    iconWidth: "1.25rem"
  }, ContactInfoForm_jsx("p", {
    className: "reset-paragraph text-base text-current"
  }, appContext.isCmta ? Object(src_i18n["g" /* t */])('booking.partners.participants.personnalInfosHeader.identityPapersMatching') : Object(src_i18n["g" /* t */])('booking.participants.personnalInfosHeader.identityPapersMatching'))), attendeesList.map(function (_ref4, index) {
    var id = _ref4.id,
        _ref4$isMain = _ref4.isMain,
        isMain = _ref4$isMain === void 0 ? false : _ref4$isMain,
        _ref4$isChild = _ref4.isChild,
        isChild = _ref4$isChild === void 0 ? false : _ref4$isChild,
        attendeeIndex = _ref4.attendeeIndex;
    var attendeeIdentifier = "".concat(isChild ? 'children' : 'adults', "[").concat(attendeeIndex, "]");
    var mainContactId = Object(lodash["get"])(formik.values, "".concat(attendeeIdentifier, ".mainContactId"));
    return ContactInfoForm_jsx("div", {
      className: "mt-px20",
      key: id
    }, ContactInfoForm_jsx(PersonInfo_PersonInfo, {
      addressSchema: addressSchema,
      adultCivilities: adultCivilities,
      attendeeIdentifier: attendeeIdentifier,
      attendeeIndex: attendeeIndex,
      childCivilities: childCivilities,
      connectedUserInfo: index === 0 ? connectedUserInfo : undefined,
      displayUnicodeFields: !!appContext.displayUnicodeFields,
      expirationDate: expirationDate,
      formik: formik,
      hasAddress: hasAddress,
      i18n: i18n,
      id: id,
      identityNumberInformation: identityNumberInformation,
      isChild: isChild,
      isMain: isMain || mainContactId < 0 && !isChild && formik.values.adults.findIndex(function (attendee) {
        return attendee.mainContactId === mainContactId;
      }) === attendeeIndex,
      issuingDate: issuingDate,
      isValid: initialValidationDone && !Object(lodash["get"])(formik.errors, attendeeIdentifier, false),
      nationalitiesByLocale: nationalitiesByLocale,
      nationality: nationality,
      passportInformation: passportInformation,
      userIsSeller: userIsSeller,
      validators: validators
    }));
  }), ContactInfoForm_jsx(MultiCGUBlock_MultiCGUBlock, {
    formik: formik,
    i18n: i18n // contains the desired Checkboxes to show
    ,
    idsCGU: [contact_info_constants["a" /* CNIL_LEGAL_MESSAGE_ID */], contact_info_constants["b" /* GENERAL_PERSONAL_INFORMATION */], contact_info_constants["h" /* UNIQUE_IDENTIFICATION_INFORMATION */], contact_info_constants["g" /* THIRD_PARTY_PROVISION */], contact_info_constants["d" /* OVERSEAS_PROVISION */], contact_info_constants["e" /* OVERSEAS_PROVISION_INSURANCE */]],
    validators: validators
  }), renderBottomNavBar({
    validationCallback: function validationCallback() {
      // $FlowFixMe always defined here
      formik.submitForm();
      Object(ContactInfoUtils["r" /* trackAttendeesFormError */])(track, formik);
      return Promise.reject();
    },
    contactInfoSubmit: 'contactInfoSubmit'
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/ContactInfo.jsx


var ContactInfo_jsx = react_default.a.createElement;

function ContactInfo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ContactInfo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ContactInfo_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ContactInfo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




























var ContactInfo_ContactInfo = function _ContactInfo(_ref) {
  var i18n = _ref.i18n,
      proposal = _ref.proposal,
      attendees = _ref.attendees,
      renderBottomNavbar = _ref.renderBottomNavbar,
      setAdults = _ref.setAdults,
      setKids = _ref.setKids,
      updateAttendees = _ref.updateAttendees,
      startLoading = _ref.startLoading,
      endLoading = _ref.endLoading,
      connectedUserInfo = _ref.connectedUserInfo,
      addressSchema = _ref.addressSchema,
      goToNextStep = _ref.goToNextStep;

  var _useState = Object(react["useState"])(),
      errorMessage = _useState[0],
      setErrorMessage = _useState[1];

  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var sellerEmail = Object(es["e" /* useSelector */])(function (state) {
    return state.seller.sellerInfo.email;
  });
  var customerSearchResult = Object(es["e" /* useSelector */])(booking_selector["n" /* getCustomerSearchResult */]);

  var _useLayer = useLayer(CUSTOMER_SEARCH_LAYER),
      openLayer = _useLayer.openLayer;

  var track = Object(useTracking["a" /* useTracking */])();
  var _i18n$booking$partici = i18n.booking.participants.postalAddress,
      activationMobile = _i18n$booking$partici.activationMobile,
      activationDesktop = _i18n$booking$partici.activationDesktop; // passport nationality default 'RU' for Russia, we check the existence of the field before sending the default Value 'RU' in modifyAttendees

  var nationalityFieldRules = Object(ContactInfoUtils["k" /* getLegalInputInformation */])(i18n.bookingProcess, legalInformationIds_constants["f" /* NATIONALITY */]);
  var hasAddress = (!appContext.isCmta || appContext.locale === locale_constants["a" /* LOCALES */].FR_FR) && (!isTablet && activationMobile || isTablet && activationDesktop || i18n.booking.participants.postalAddress.displayCountryFieldOnly);
  var initialAttendeesList = Object(ContactInfoUtils["i" /* getInitialAttendeesList */])({
    attendees: attendees,
    connectedUserInfo: connectedUserInfo
  }); // if initialValues change (the object ref change) that trigger an undesirable validation with initial values

  var initialValues = Object(react["useMemo"])(function () {
    return Object(ContactInfoUtils["j" /* getInitialFormValues */])({
      i18n: i18n,
      initialAttendeesList: initialAttendeesList,
      connectedUserInfo: connectedUserInfo,
      hasAddress: hasAddress,
      nationalityFieldRules: nationalityFieldRules,
      locale: appContext.locale,
      sellerEmail: sellerEmail
    });
  }, []);

  var updateStoreAttendees = function updateStoreAttendees(attendeesValues) {
    setAdults(attendeesValues.adults);

    if (attendeesValues.children.length > 0) {
      setKids(attendeesValues.children);
    }
  };

  var validateAttendees = function validateAttendees(_ref2) {
    var adults = _ref2.adults,
        children = _ref2.children;
    var fieldsOnError = {
      firstName: true,
      lastName: true,
      birthdate: true
    };
    var errors = {
      adults: Array(adults.length),
      children: Array(children.length)
    };
    var adultsDuplicates = Object(ContactInfoUtils["c" /* findDuplicateAttendees */])(adults);
    var childrenDuplicates = Object(ContactInfoUtils["c" /* findDuplicateAttendees */])(children);

    if (!Object(lodash["isEmpty"])(childrenDuplicates) || !Object(lodash["isEmpty"])(adultsDuplicates)) {
      setErrorMessage(i18n.booking.participants.labels.warningNames);
      adultsDuplicates.forEach(function (duplicateIndex) {
        errors.adults[duplicateIndex] = fieldsOnError;
      });
      childrenDuplicates.forEach(function (duplicateIndex) {
        errors.children[duplicateIndex] = fieldsOnError;
      });
      return errors;
    } // Errors management before Submitting updateAttendees


    (adults[0].optinPhone || adults[0].optinSms) && !adults[0].mobile && appContext.isSeller ? setErrorMessage(Object(src_i18n["g" /* t */])('booking.form.errorLabel')) : setErrorMessage(undefined);
  };

  return ContactInfo_jsx(react["Fragment"], null, appContext.isSeller && ContactInfo_jsx("div", {
    className: "text-center"
  }, customerSearchResult.error && ContactInfo_jsx(FormFeedback["a" /* FormFeedback */], {
    className: "justify-center",
    isError: true,
    message: Object(src_i18n["g" /* t */])('booking.partners.traveller.existingCustomer.customerNotFound')
  }), ContactInfo_jsx(Button["a" /* Button */], {
    className: "text-base text-blue underline",
    dataTestId: "existingCustomerSearchButton",
    onClick: function onClick() {
      openLayer();
      track({
        actionGA: 'participant',
        categoryGA: 'bookingEngine',
        labelGA: 'CTA_searchExistingCustomer'
      });
    },
    size: "small",
    theme: "link"
  }, Object(src_i18n["g" /* t */])('booking.partners.traveller.existingCustomer.newSearch'))), ContactInfo_jsx(formik_esm["d" /* Formik */], {
    initialValues: initialValues,
    onSubmit: function onSubmit(attendeesValues, actions) {
      var cleanAttendeesValues = Object(ContactInfoUtils["b" /* cleanUselessAttendeesValues */])(attendeesValues);
      updateStoreAttendees(cleanAttendeesValues);
      actions.setSubmitting(false);
      startLoading();
      updateAttendees({
        appContext: appContext,
        proposalId: proposal.id,
        attendees: [].concat(Object(toConsumableArray["a" /* default */])(cleanAttendeesValues.adults), Object(toConsumableArray["a" /* default */])(cleanAttendeesValues.children.map(function (child) {
          return ContactInfo_objectSpread(ContactInfo_objectSpread({}, child), {}, {
            isChild: true
          });
        })))
      }).then(goToNextStep).catch(function (error) {
        var _error$errors$, _error$errors, _error$errors$2;

        // Redirect to oidc if the statusCode is 401
        if (ple_utils["l" /* hasAuthResponseError */](error)) {
          Object(BookingEngine_utils["e" /* redirectToOidc */])(appContext);
          return;
        } // Some errors are properly handled by graphql. But we don't handle them explicitly
        // We rely on the message to know the source of the error because of babel < 7


        var statusCode = error.message === 'Unhandled field form error' ? statusCode_constants["b" /* STATUS_CODE_400 */] : error === null || error === void 0 ? void 0 : (_error$errors$ = error.errors[0]) === null || _error$errors$ === void 0 ? void 0 : _error$errors$.statusCode;
        setErrorMessage(Object(ContactInfoUtils["n" /* renderErrorUpdatingAttendees */])(statusCode, i18n));
        track({
          categoryGA: 'bookingEngine',
          actionGA: 'participant',
          labelGA: (error === null || error === void 0 ? void 0 : (_error$errors = error.errors) === null || _error$errors === void 0 ? void 0 : (_error$errors$2 = _error$errors[0]) === null || _error$errors$2 === void 0 ? void 0 : _error$errors$2.errorCode) === 'fieldCannotBeModifiedDueToUpcomingBooking' ? 'error_cannotMatchAttendeeNames' : 'error_serverError'
        });
      }).finally(endLoading);
    },
    validate: validateAttendees
  }, function (formik) {
    return ContactInfo_jsx(ContactInfoForm_ContactInfoForm, {
      i18n: i18n,
      proposal: proposal,
      formik: formik,
      attendeesList: initialAttendeesList.all,
      hasAddress: hasAddress,
      connectedUserInfo: connectedUserInfo,
      addressSchema: addressSchema,
      updateStoreAttendees: updateStoreAttendees,
      renderBottomNavBar: renderBottomNavbar
    });
  }), errorMessage && ContactInfo_jsx(FormFeedback["a" /* FormFeedback */], {
    hasAutoScroll: true,
    isError: true,
    message: errorMessage
  }));
};

function getConnectedUserInfo(state) {
  var userInfo = Object(userInfo_selectors["a" /* userInfoSelector */])(state);
  return userInfo.isQuickLoggedIn ? {} : userInfo;
}

var ContactInfo = Object(es["c" /* connect */])(function (state) {
  return {
    attendees: Object(booking_selector["i" /* getAttendeesWithInfos */])(state),
    connectedUserInfo: getConnectedUserInfo(state),
    addressSchema: getAddressValidationSchema(state)
  };
}, {
  setAdults: adults_action["a" /* setAdults */],
  setKids: kids_action["c" /* setKidsWithoutClearProposals */],
  updateAttendees: proposals_action["t" /* updateAttendees */],
  endLoading: globalLoader_action["c" /* endLoading */],
  startLoading: globalLoader_action["d" /* startLoading */]
})(ContactInfo_ContactInfo);
// CONCATENATED MODULE: ./src/client/views/booking/participants/login-to-ple/NotificationLoginToPle.jsx
var NotificationLoginToPle_jsx = react_default.a.createElement;









var NotificationLoginToPle_NotificationLoginToPle = function NotificationLoginToPle(_ref) {
  var className = _ref.className,
      i18n = _ref.i18n,
      isQuickLogged = _ref.isQuickLogged;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var loginUrl = isQuickLogged ? ple_utils["i" /* buildStepupUrl */]({
    redirectUri: dist["windowWrapper"].getLocation(),
    locale: appContext.locale
  }) : ple_utils["f" /* buildSigninUrl */]({
    redirectUri: dist["windowWrapper"].getLocation(),
    locale: appContext.locale
  });
  return NotificationLoginToPle_jsx("aside", {
    className: classnames_default()(className, 'bg-white border-1 border-blue rounded')
  }, NotificationLoginToPle_jsx("div", {
    className: "p-px20"
  }, NotificationLoginToPle_jsx("h3", {
    className: "flex font-brand items-end reset-heading text-base text-blue"
  }, NotificationLoginToPle_jsx(Icon["a" /* Icon */], {
    className: "flex-shrink-0 rtl:mr-px20",
    name: icons["a" /* ICONS */].ICON_45,
    width: "2.5em"
  }), i18n.booking.participants.connectToPLE.message)), NotificationLoginToPle_jsx("div", {
    className: "border-t-1 border-blue p-px20"
  }, NotificationLoginToPle_jsx(Button["a" /* Button */], {
    className: "w-full",
    color: colors["a" /* COLORS */].WHITE,
    colorBg: colors["a" /* COLORS */].TURQUOISE,
    colorBorder: colors["a" /* COLORS */].TURQUOISE,
    isExternalLink: true,
    trackingData: {
      actionGA: 'participant',
      categoryGA: 'bookingEngine',
      labelGA: 'connectionParticipant'
    },
    url: loginUrl
  }, i18n.booking.participants.connectToPLE.buttonLabel)));
};
// CONCATENATED MODULE: ./src/client/views/booking/participants/popin-customer/usePopin.js

function usePopin(initState) {
  var _useState = Object(react["useState"])(initState),
      isOpened = _useState[0],
      setOpenPopin = _useState[1];

  var openPopin = function openPopin(e) {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    setOpenPopin(true);
  };

  var closePopin = function closePopin(e) {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    setOpenPopin(false);
  };

  return {
    isOpened: isOpened,
    openPopin: openPopin,
    closePopin: closePopin
  };
}
// CONCATENATED MODULE: ./src/client/views/booking/participants/popin-customer/PopinCustomer.jsx
var PopinCustomer_jsx = react_default.a.createElement;













var PopinCustomer_PopinCustomer = function PopinCustomer(_ref) {
  var onClose = _ref.onClose;

  var _usePopin = usePopin(true),
      isOpened = _usePopin.isOpened,
      closePopin = _usePopin.closePopin;

  var _useLayer = useLayer(CUSTOMER_SEARCH_LAYER),
      openLayer = _useLayer.openLayer;

  var track = Object(useTracking["a" /* useTracking */])({
    categoryGA: 'bookingEngine',
    actionGA: 'participant'
  });

  var handleClose = function handleClose() {
    closePopin();

    if (onClose) {
      onClose();
    }
  };

  if (!isOpened) {
    return null;
  }

  return PopinCustomer_jsx(Modal["a" /* Modal */], {
    ariaLabel: Object(src_i18n["g" /* t */])('booking.participants.pageTitle'),
    ariaLabelledby: identifiers_constants["n" /* ID_MODAL_HEADER__BE__CUSTOMER */],
    closeLabel: Object(src_i18n["g" /* t */])('common.close'),
    onClose: handleClose,
    size: "small"
  }, PopinCustomer_jsx("div", {
    className: "bg-gray-lighter font-bold p-px20 text-center"
  }, PopinCustomer_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].USER,
    color: colors["a" /* COLORS */].BLUE,
    width: "calc(57rem / 16)",
    isNotSquare: true
  }), PopinCustomer_jsx(Title["a" /* Title */], {
    className: "justify-center mt-px10",
    color: colors["a" /* COLORS */].BLUE,
    hLevel: 1,
    id: identifiers_constants["n" /* ID_MODAL_HEADER__BE__CUSTOMER */],
    theme: "title-sans-4"
  }, Object(src_i18n["g" /* t */])('booking.participants.pageTitle'))), PopinCustomer_jsx("div", {
    className: "pb-px20 pt-px10 text-center"
  }, PopinCustomer_jsx(Button["a" /* Button */], {
    className: "mb-px20 w-3/4",
    colorBg: colors["a" /* COLORS */].TURQUOISE,
    colorBorder: colors["a" /* COLORS */].TURQUOISE,
    onClick: function onClick() {
      openLayer();
      handleClose();
      track({
        labelGA: 'popin_existingCustomer'
      });
    }
  }, Object(src_i18n["g" /* t */])('booking.partners.existingCustomer')), PopinCustomer_jsx(Button["a" /* Button */], {
    className: "mb-px20 w-3/4",
    colorBg: colors["a" /* COLORS */].BLUE,
    colorBorder: colors["a" /* COLORS */].BLUE,
    onClick: function onClick() {
      handleClose();
      track({
        labelGA: 'popin_newCustomer'
      });
    }
  }, Object(src_i18n["g" /* t */])('booking.partners.newCustomer'))));
};
// CONCATENATED MODULE: ./src/client/views/booking/participants/login-to-ple/PopinLoginToPle.jsx
var PopinLoginToPle_jsx = react_default.a.createElement;













var PopinLoginToPle_PopinLoginToPle = function PopinLoginToPle(_ref) {
  var i18n = _ref.i18n,
      onClose = _ref.onClose;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var _i18n$booking$partici = i18n.booking.participants.connectToPLE,
      message = _i18n$booking$partici.message,
      bulletpoint1 = _i18n$booking$partici.bulletpoint1,
      bulletpoint2 = _i18n$booking$partici.bulletpoint2,
      buttonLabel = _i18n$booking$partici.buttonLabel,
      noAccountSentence = _i18n$booking$partici.noAccountSentence,
      noAccount = _i18n$booking$partici.noAccount;
  return PopinLoginToPle_jsx(Modal["a" /* Modal */], {
    ariaLabel: message,
    ariaLabelledby: identifiers_constants["u" /* ID_MODAL_HEADER__PLE__LOGIN */],
    closeLabel: Object(src_i18n["g" /* t */])('common.close'),
    onClose: onClose,
    size: "small"
  }, PopinLoginToPle_jsx("div", {
    className: "font-sans"
  }, PopinLoginToPle_jsx("div", {
    className: "bg-gray-lighter font-bold p-px20 text-center"
  }, PopinLoginToPle_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].USER,
    color: colors["a" /* COLORS */].BLUE,
    width: "calc(57rem / 16)",
    isNotSquare: true
  }), PopinLoginToPle_jsx(Title["a" /* Title */], {
    className: "justify-center mt-px10",
    color: colors["a" /* COLORS */].BLUE,
    hLevel: 1,
    id: identifiers_constants["u" /* ID_MODAL_HEADER__PLE__LOGIN */],
    theme: "title-sans-4"
  }, message)), PopinLoginToPle_jsx("ul", {
    className: "list-none m-0 p-px20"
  }, PopinLoginToPle_jsx("li", null, PopinLoginToPle_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-px10 align-middle",
    color: colors["a" /* COLORS */].BLUE,
    name: icons["a" /* ICONS */].STRAIGHT_CHECK
  }), bulletpoint1), PopinLoginToPle_jsx("li", null, PopinLoginToPle_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-px10 align-middle",
    color: colors["a" /* COLORS */].BLUE,
    name: icons["a" /* ICONS */].STRAIGHT_CHECK
  }), bulletpoint2)), PopinLoginToPle_jsx("div", {
    className: "text-center pb-px20"
  }, PopinLoginToPle_jsx(Button["a" /* Button */], {
    className: "mb-px20 w-3/4",
    colorBg: colors["a" /* COLORS */].TURQUOISE,
    colorBorder: colors["a" /* COLORS */].TURQUOISE,
    onClick: function onClick() {
      tracking_api["b" /* setDataLayer */]({
        actionGA: 'participant',
        categoryGA: 'bookingEngine',
        event: 'eventGA',
        labelGA: 'popin_connectionParticipant',
        nonInteraction: '0',
        valueGA: '0',
        versionBooking: 'responsive'
      }, appContext);
    },
    isExternalLink: true,
    url: ple_utils["f" /* buildSigninUrl */]({
      locale: appContext.locale,
      redirectUri: dist["windowWrapper"].getLocation()
    })
  }, buttonLabel), PopinLoginToPle_jsx("div", {
    className: "px-px20"
  }, PopinLoginToPle_jsx("p", {
    className: "font-bold reset-paragraph"
  }, noAccount), PopinLoginToPle_jsx("p", {
    className: "reset-paragraph"
  }, noAccountSentence)))));
};
// CONCATENATED MODULE: ./src/client/views/booking/participants/ParticipantsView.jsx
var ParticipantsView_jsx = react_default.a.createElement;














var SESSION_STORAGE_ITEM = 'seenProposalsForPopin';

function shouldShowPopin(appContext) {
  var isCmta = appContext.isCmta,
      isCxo = appContext.isCxo;
  var neolIds = Object(sellerUtils["c" /* getNeolids */])();
  var isUnidentified = neolIds.length === 0;
  return isCmta || isCxo && isUnidentified;
}

var ParticipantsView_ParticipantsView = function ParticipantsView(_ref) {
  var _i18n$memberSpace;

  var goToNextStep = _ref.goToNextStep,
      i18n = _ref.i18n,
      proposals = _ref.proposals,
      renderBottomNavbar = _ref.renderBottomNavbar,
      selectedProposal = _ref.selectedProposal;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useLayer = useLayer(CUSTOMER_SEARCH_LAYER),
      isLayerOpened = _useLayer.isLayerOpened;

  var _useState = Object(react["useState"])(false),
      isAlreadySeen = _useState[0],
      setIsAlreadySeen = _useState[1];

  var customerSearchResult = Object(es["e" /* useSelector */])(booking_selector["n" /* getCustomerSearchResult */]);
  var concatProposalIds = proposals.map(function (_ref2) {
    var id = _ref2.id;
    return id;
  }).join('');

  var _useState2 = Object(react["useState"])(Object(sessionStorageApi["b" /* getFromSessionStorage */])(SESSION_STORAGE_ITEM) !== concatProposalIds),
      shouldShowConnectToPlePopin = _useState2[0],
      setShouldShowConnectToPlePopin = _useState2[1];

  Object(react["useEffect"])(function () {
    if (Object(sessionStorageApi["b" /* getFromSessionStorage */])(SESSION_STORAGE_ITEM) !== concatProposalIds) {
      Object(sessionStorageApi["d" /* setInSessionStorage */])(SESSION_STORAGE_ITEM, concatProposalIds);
    }
  }, [concatProposalIds]);
  Object(react["useEffect"])(function () {
    if (customerSearchResult.data) {
      setIsAlreadySeen(true);
    }
  }, [customerSearchResult]);
  var userLogged = appContext.isUserLogged;
  var isPopinPleEnabled = !userLogged && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('connectionPopinPLE.isEnabled');
  var displayNotification = !appContext.isSeller && !userLogged && (i18n === null || i18n === void 0 ? void 0 : (_i18n$memberSpace = i18n.memberSpace) === null || _i18n$memberSpace === void 0 ? void 0 : _i18n$memberSpace.accessButtonLoggedin);

  var closeLoginToPLEModal = function closeLoginToPLEModal() {
    setShouldShowConnectToPlePopin(false);
  };

  var showPopinCustomer = shouldShowPopin(appContext) && !isAlreadySeen;

  if (isLayerOpened) {
    return ParticipantsView_jsx(SearchCustomerLayer_SearchCustomerLayer, {
      name: CUSTOMER_SEARCH_LAYER,
      onClose: function onClose() {
        return setIsAlreadySeen(true);
      }
    });
  }

  return ParticipantsView_jsx("div", {
    className: "flex flex-col sm:flex-row sm:items-start"
  }, showPopinCustomer && ParticipantsView_jsx(PopinCustomer_PopinCustomer, {
    onClose: function onClose() {
      return setIsAlreadySeen(true);
    }
  }), isPopinPleEnabled && shouldShowConnectToPlePopin && ParticipantsView_jsx(PopinLoginToPle_PopinLoginToPle, {
    i18n: i18n,
    onClose: closeLoginToPLEModal
  }), displayNotification && ParticipantsView_jsx("div", {
    className: "sm:flex-none sm:rtl:mr-px20 sm:w-1/4"
  }, ParticipantsView_jsx(NotificationLoginToPle_NotificationLoginToPle, {
    className: "mb-px20",
    i18n: i18n,
    isQuickLogged: appContext.isUserQuickLogged
  })), ParticipantsView_jsx("div", {
    className: classnames_default()('max-w-site-mini', {
      'm-auto': !displayNotification
    })
  }, ParticipantsView_jsx(ContactInfo, {
    goToNextStep: goToNextStep,
    i18n: i18n,
    proposal: selectedProposal,
    renderBottomNavbar: renderBottomNavbar
  })));
};
// EXTERNAL MODULE: ./src/client/components/widgets/package/transfers-section/TransfersSection.jsx + 2 modules
var TransfersSection = __webpack_require__("ptRt");

// EXTERNAL MODULE: ./src/utils/transport/transportUtils.js
var transportUtils = __webpack_require__("pdPG");

// EXTERNAL MODULE: ./src/client/views/booking/transport/TransferSidebar.jsx
var TransferSidebar = __webpack_require__("cuXy");

// CONCATENATED MODULE: ./src/client/components/widgets/reassurance-block/ReassuranceBlock.jsx
var ReassuranceBlock_jsx = react_default.a.createElement;




var ReassuranceBlock_ReassuranceBlock = function ReassuranceBlock(_ref) {
  var bulletPoints = _ref.bulletPoints,
      imageUrl = _ref.imageUrl,
      subtitle = _ref.subtitle,
      title = _ref.title;
  return ReassuranceBlock_jsx("div", {
    className: "w-screen md:w-full pr-px5 md:pr-0"
  }, ReassuranceBlock_jsx(Capsule["a" /* Capsule */], {
    header: "none",
    className: "w-full shadow-sm overflow-hidden h-44 md:h-20"
  }, ReassuranceBlock_jsx("div", {
    className: "flex overflow-x-auto pb-px15 pr-px30 md:pr-0"
  }, ReassuranceBlock_jsx("img", {
    alt: "",
    src: imageUrl,
    className: "w-56 md:w-32 h-44 md:h-20 rounded-tiny shadow-sm"
  }), ReassuranceBlock_jsx("div", {
    className: "block md:flex h-auto md:h-16 my-px10 w-full min-w-content md:min-w-auto pr-px10 md:pr-0"
  }, ReassuranceBlock_jsx("div", {
    className: "self-center pl-px15 pr-px10 flex-grow"
  }, title && ReassuranceBlock_jsx("span", {
    className: "font-bold text-blue text-base max-w-content"
  }, title), subtitle && ReassuranceBlock_jsx("div", {
    className: "text-sm mt-px5 max-w-content"
  }, subtitle)), ReassuranceBlock_jsx("div", {
    className: "block md:flex text-sm self-center px-px10 flex-grow justify-evenly"
  }, bulletPoints && bulletPoints.map(function (_ref2) {
    var icon = _ref2.icon,
        text = _ref2.text,
        className = _ref2.className;
    return ReassuranceBlock_jsx("span", {
      className: "flex items-center mt-px10",
      key: icon,
      "data-testid": "ReassuranceBlockIcon"
    }, ReassuranceBlock_jsx(Icon["a" /* Icon */], {
      name: icon,
      width: "1.2rem",
      color: colors["a" /* COLORS */].BLUE,
      className: "mx-px10"
    }), ReassuranceBlock_jsx("span", {
      className: className
    }, text));
  }))))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/be-transport-details/BeTransportDetails.jsx
var BeTransportDetails = __webpack_require__("a2Xc");

// EXTERNAL MODULE: ./src/client/components/widgets/transport-details/transportUtils.js
var transport_details_transportUtils = __webpack_require__("z8xc");

// EXTERNAL MODULE: ./src/client/views/booking/transport/more-transports/MoreTransports.jsx + 19 modules
var MoreTransports = __webpack_require__("Dbuu");

// CONCATENATED MODULE: ./src/client/views/booking/transport/TransportsSection.jsx
var TransportsSection_jsx = react_default.a.createElement;

/**
 * * Booking search transport page [find transport page]
 * * using fetchProposalsById method to get proposals[0].transports (inbound & outbound)
 */















var PRODUCT_TYPE = {
  CRUISE: 'CRUISE'
};
var TransportsSection_TransportsSection = function TransportsSection(_ref) {
  var _transports$inbound, _selectedProposal$tra, _selectedProposal$tra2;

  var i18n = _ref.i18n,
      resort = _ref.resort,
      selectedProposal = _ref.selectedProposal,
      onMoreTransportsClick = _ref.onMoreTransportsClick,
      closeLayer = _ref.closeLayer,
      shouldShowLayer = _ref.shouldShowLayer;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var dispatch = Object(es["d" /* useDispatch */])();

  var _ref2 = selectedProposal || {},
      transports = _ref2.transports;

  var transportCancellationPolicy = Object(transport_details_transportUtils["f" /* getCancellationPolicyDescription */])(transports, i18n);
  var isSelectedRecommended = Object(proposalUtils["y" /* isRecommendedTransport */])(transports, selectedProposal.id);

  var handleAddTransport = function handleAddTransport(transportId) {
    var transportI18n = i18n.booking.transport;
    Promise.resolve(closeLayer(true, selectedProposal.id)).then(function () {
      if (transportId === selectedProposal.id) {
        // no need to call the addTransportMutation because the recommended flight is selected by default
        setTimeout(function () {
          return dispatch(Object(toast_actions["d" /* openToast */])(transportI18n.newTransportSelection));
        }, 1000);
      } else {
        dispatch(Object(proposals_action["d" /* addTransport */])(transportId, Object(BookingEngine_utils["a" /* getAllProposalsIdWithAlternative */])(selectedProposal), resort.isJoyview, appContext, transportI18n.additionalTransports.loaderLabelUpdate, transportI18n.newTransportSelection));
      }
    });
  };

  var isPlane = Object(transport_details_transportUtils["n" /* hasOnlyPlanes */])(transports === null || transports === void 0 ? void 0 : (_transports$inbound = transports.inbound) === null || _transports$inbound === void 0 ? void 0 : _transports$inbound.travelSections);
  return TransportsSection_jsx(react["Fragment"], null, TransportsSection_jsx("div", {
    "data-testid": "TransportsView-AllInclusiveListTag"
  }, TransportsSection_jsx(ReassuranceBlock_ReassuranceBlock, {
    imageUrl: "https://i.imgur.com/xuEabF1.jpg",
    title: isPlane ? Object(src_i18n["g" /* t */])('common.transport.transfer.information') : Object(src_i18n["g" /* t */])('common.otherTransport.transfer.information'),
    subtitle: Object(src_i18n["g" /* t */])('common.transport.transfer.pickUpDescription'),
    bulletPoints: [{
      icon: icons["a" /* ICONS */].COMPASS,
      text: Object(src_i18n["g" /* t */])('common.transport.transfer.arrivalPickup')
    }, {
      icon: icons["a" /* ICONS */].TRANSFER,
      text: Object(src_i18n["g" /* t */])('common.transport.transfer.included'),
      className: 'font-bold'
    }]
  })), TransportsSection_jsx(OverlaidActionProvider["a" /* OverlaidActionProvider */], {
    label: Object(src_i18n["g" /* t */])('booking.transport.headlineCTA'),
    button: {
      label: Object(src_i18n["g" /* t */])(isPlane ? 'booking.transport.moreTransports' : 'booking.otherTransport'),
      onClick: onMoreTransportsClick
    }
  }, TransportsSection_jsx("div", {
    className: "TransportsView-context md:mt-px20"
  }, TransportsSection_jsx(BeTransportDetails["a" /* BeTransportDetails */], {
    layout: "row",
    i18n: i18n,
    inBoundFlight: selectedProposal === null || selectedProposal === void 0 ? void 0 : (_selectedProposal$tra = selectedProposal.transports) === null || _selectedProposal$tra === void 0 ? void 0 : _selectedProposal$tra.inbound,
    outBoundFlight: selectedProposal === null || selectedProposal === void 0 ? void 0 : (_selectedProposal$tra2 = selectedProposal.transports) === null || _selectedProposal$tra2 === void 0 ? void 0 : _selectedProposal$tra2.outbound,
    isSelectedRecommended: isSelectedRecommended
  }))), shouldShowLayer && TransportsSection_jsx(MoreTransports["a" /* MoreTransports */], {
    i18n: i18n,
    proposal: selectedProposal,
    resort: resort,
    onCloseLayer: closeLayer,
    onSubmit: handleAddTransport
  }), transportCancellationPolicy && TransportsSection_jsx(Notification["a" /* Notification */], {
    hasBorder: true,
    className: "my-px10 mx-auto Notification--transportDetails",
    text: transportCancellationPolicy
  }));
};
// CONCATENATED MODULE: ./src/client/views/booking/transport/TransportsView.tracking.js


function TransportsView_tracking_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function TransportsView_tracking_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      TransportsView_tracking_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      TransportsView_tracking_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



function trackClickShowMoreTransports(appContext) {
  tracking_api["b" /* setDataLayer */](TransportsView_tracking_objectSpread(TransportsView_tracking_objectSpread({}, booking_constants["c" /* BE_GA_DEFAULT_PAYLOAD */]), {}, {
    actionGA: 'transport',
    categoryGA: 'bookingEngine',
    labelGA: 'modify',
    versionBooking: 'responsive'
  }), appContext);
}
function trackAddTransfer(appContext) {
  tracking_api["b" /* setDataLayer */](TransportsView_tracking_objectSpread(TransportsView_tracking_objectSpread({}, booking_constants["c" /* BE_GA_DEFAULT_PAYLOAD */]), {}, {
    actionGA: 'transfer',
    labelGA: 'addTransfer'
  }), appContext);
}
function trackRemoveTransfer(appContext) {
  tracking_api["b" /* setDataLayer */](TransportsView_tracking_objectSpread(TransportsView_tracking_objectSpread({}, booking_constants["c" /* BE_GA_DEFAULT_PAYLOAD */]), {}, {
    actionGA: 'transfer',
    labelGA: 'removeTransfer'
  }), appContext);
}
// CONCATENATED MODULE: ./src/client/views/booking/transport/TransportsView.jsx
var TransportsView_jsx = react_default.a.createElement;

/**
 * * Booking search transport page [find transport page]
 */













var TRANSPORTS_LAYER_NAME = 'AdditionalTransportsLayer';
var TransportsView_TransportsView = function TransportsView(props) {
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var dispatch = Object(es["d" /* useDispatch */])();

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var onAddTransfer = function onAddTransfer(transfer) {
    trackAddTransfer(appContext);

    var _getProposalIdsAndOve = Object(transportUtils["c" /* getProposalIdsAndOverloadForAdditionalServiceQuery */])(props.proposals, transfer),
        proposalIds = _getProposalIdsAndOve.proposalIds,
        overloadForSpecificProposalIds = _getProposalIdsAndOve.overloadForSpecificProposalIds;

    return dispatch(Object(proposals_action["b" /* addAdditionalService */])({
      proposalIds: proposalIds,
      serviceId: transfer.pricingInfo.id,
      schedules: transfer.pricingInfo.schedules.map(function (_ref) {
        var startDate = _ref.startDate,
            endDate = _ref.endDate;
        return {
          startDate: startDate,
          endDate: endDate
        };
      }),
      attendeeIds: transfer.pricingInfo.schedules[0].attendees.map(function (_ref2) {
        var id = _ref2.id;
        return id;
      }),
      overloadForSpecificProposalIds: overloadForSpecificProposalIds,
      appContext: appContext
    }));
  };

  var onRemoveTransfer = function onRemoveTransfer(transfer) {
    trackRemoveTransfer(appContext);

    var _getProposalIdsAndOve2 = Object(transportUtils["c" /* getProposalIdsAndOverloadForAdditionalServiceQuery */])(props.proposals, transfer),
        proposalIds = _getProposalIdsAndOve2.proposalIds,
        overloadForSpecificProposalIds = _getProposalIdsAndOve2.overloadForSpecificProposalIds;

    return dispatch(Object(proposals_action["f" /* deleteAdditionalServices */])({
      proposalIds: proposalIds,
      serviceIds: [transfer.productInfo.id],
      attendeeIds: transfer.pricingInfo.schedules[0].attendees.map(function (attendee) {
        return attendee.id;
      }),
      overloadForSpecificProposalIds: overloadForSpecificProposalIds,
      appContext: appContext
    }));
  };

  var onMoreTransportsClick = function onMoreTransportsClick() {
    props.openLayer(TRANSPORTS_LAYER_NAME);
    trackClickShowMoreTransports(appContext);
  };

  var i18n = props.i18n,
      proposals = props.proposals,
      selectedProposal = props.selectedProposal,
      resort = props.resort;
  return TransportsView_jsx(react["Fragment"], null, TransportsView_jsx(head_default.a, null, TransportsView_jsx("title", {
    key: "title"
  }, Object(lodash["get"])(i18n, props.selectedProposal.transports ? 'booking.transport.seo.title' : 'booking.transport.transfer.seo.title'))), props.selectedProposal.transports ? TransportsView_jsx(TransportsSection_TransportsSection, {
    i18n: i18n,
    proposals: proposals,
    selectedProposal: selectedProposal,
    onMoreTransportsClick: onMoreTransportsClick,
    shouldShowLayer: location.queryParams[dist["appQueryParameters"].openLayer] === TRANSPORTS_LAYER_NAME,
    closeLayer: props.closeLayer,
    resort: resort
  }) : TransportsView_jsx("div", {
    className: "max-w-site-small m-auto"
  }, TransportsView_jsx("div", {
    className: "flex flex-wrap -mx-px10"
  }, TransportsView_jsx("div", {
    className: "w-full sm:w-2/5 p-px10"
  }, TransportsView_jsx(TransferSidebar["a" /* TransferSidebar */], {
    i18n: props.i18n
  })), TransportsView_jsx("div", {
    className: "w-full sm:w-3/5 p-px10"
  }, TransportsView_jsx(TransfersSection["a" /* TransfersSection */], {
    addTransfer: onAddTransfer,
    removeTransfer: onRemoveTransfer,
    availableTransfers: props.selectedProposal.additionalServices.transfers,
    selectedTransfers: (props.selectedProposal.additionalServices.transfers || []).filter(function (transfer) {
      return transfer.pricingInfo.isFullyRented;
    }),
    i18n: props.i18n
  })))), props.renderBottomNavbar());
};
// CONCATENATED MODULE: ./src/client/views/booking/BookingStep.jsx


var BookingStep_jsx = react_default.a.createElement;

function BookingStep_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function BookingStep_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { BookingStep_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { BookingStep_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }























var getChinaTimerSessionKey = function getChinaTimerSessionKey(id) {
  return "china-summary-timer_".concat(id);
};

var BookingStep_BookingStepContent = function BookingStepContent(_ref) {
  var actionGA = _ref.actionGA,
      closeLayer = _ref.closeLayer,
      currentStep = _ref.currentStep,
      goToNextStep = _ref.goToNextStep,
      i18n = _ref.i18n,
      openLayer = _ref.openLayer,
      proposals = _ref.proposals,
      _renderBottomNavbar = _ref.renderBottomNavbar,
      resort = _ref.resort,
      selectedProposal = _ref.selectedProposal,
      shouldShowEditCriteria = _ref.shouldShowEditCriteria,
      showTimer = _ref.showTimer,
      timerInitialValue = _ref.timerInitialValue,
      setTimerInitialValue = _ref.setTimerInitialValue;
  var sharedProps = {
    renderBottomNavbar: function renderBottomNavbar(arg) {
      return _renderBottomNavbar(BookingStep_objectSpread(BookingStep_objectSpread({}, arg), {}, {
        shouldShowEditCriteria: shouldShowEditCriteria
      }));
    },
    i18n: i18n,
    proposals: proposals,
    selectedProposal: selectedProposal,
    resort: resort
  };

  switch (currentStep) {
    case 'accommodation':
      return BookingStep_jsx(accommodation_AccommodationView, Object(esm_extends["a" /* default */])({}, sharedProps, {
        closeLayer: closeLayer,
        openLayer: openLayer
      }));

    case 'transport':
      return BookingStep_jsx(TransportsView_TransportsView, Object(esm_extends["a" /* default */])({}, sharedProps, {
        closeLayer: closeLayer,
        openLayer: openLayer
      }));

    case 'participants':
      return BookingStep_jsx(ParticipantsView_ParticipantsView, Object(esm_extends["a" /* default */])({}, sharedProps, {
        goToNextStep: goToNextStep,
        closeLayer: closeLayer,
        openLayer: openLayer
      }));

    case 'summary':
      return BookingStep_jsx(summary_SummaryView, Object(esm_extends["a" /* default */])({}, sharedProps, {
        bookingStep: currentStep,
        actionGA: actionGA,
        showTimer: showTimer && !timerInitialValue,
        setTimerInitialValue: setTimerInitialValue
      }));

    case 'banking':
      return BookingStep_jsx(BankingView_BankingView, sharedProps);

    case 'services':
      return BookingStep_jsx(services_ServicesView, sharedProps);

    case 'activities':
      return BookingStep_jsx(ActivitiesView_ActivitiesView, Object(esm_extends["a" /* default */])({}, sharedProps, {
        closeLayer: closeLayer,
        openLayer: openLayer
      }));

    default:
      // eslint-disable-next-line no-console
      console.error("The booking engine doesn't know how to handle the step ".concat(currentStep));
      return null;
  }
};

var BookingStep_BookingStep = function BookingStep(props) {
  var currentStep = props.currentStep,
      resort = props.resort,
      selectedProposal = props.selectedProposal;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var _useState = Object(react["useState"])(false),
      redirecting = _useState[0],
      setRedirecting = _useState[1];

  var isChineseLocales = Object(localeUtils["a" /* isChineseLocale */])(appContext.locale);
  var chinaTimerSessionKey = sessionStorage.getItem(getChinaTimerSessionKey(selectedProposal.id));

  var _useState2 = Object(react["useState"])(isChineseLocales ? Number(chinaTimerSessionKey) : 0),
      timerInitialValue = _useState2[0],
      setTimerInitialValue = _useState2[1];

  var showTimer = isChineseLocales && !Object(sellerUtils["g" /* isSeller */])(appContext) && !!(selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.transports);

  var redirectToResort = function redirectToResort() {
    var resortUri = new URI_default.a(resort === null || resort === void 0 ? void 0 : resort.href).query(BookingStep_objectSpread({}, Object(lodash["omit"])(location.queryParams, ['proposalIds', 'selectedProposalId']))).toString();
    setRedirecting(true);
    redirectUtils["a" /* default */].redirectTo()(dist["url"].normalizeUrl(resortUri));
  };

  var bookingStepContentProps = BookingStep_objectSpread(BookingStep_objectSpread({}, props), {}, {
    showTimer: showTimer,
    timerInitialValue: timerInitialValue,
    setTimerInitialValue: setTimerInitialValue
  });

  return BookingStep_jsx(react["Fragment"], null, showTimer && timerInitialValue && BookingStep_jsx("div", {
    style: {
      fontFamily: 'HappinessBeta wf'
    }
  }, BookingStep_jsx(Countdown["a" /* Countdown */], {
    className: "pt-px10",
    color: colors["a" /* COLORS */].WARNING,
    theme: "timer",
    withCloseButton: false,
    dateTimeEnd: moment_default.a.unix(timerInitialValue),
    description: Object(src_i18n["g" /* t */])('booking.transport.countdown.proposalTimeGuaranty'),
    showTimer: currentStep === 'summary' || currentStep === 'banking',
    units: ['minutes', 'seconds'],
    expiredRender: !redirecting && BookingStep_jsx(Modal["a" /* Modal */], {
      size: "small",
      withCloseButton: false
    }, BookingStep_jsx("div", {
      className: "text-center rounded"
    }, BookingStep_jsx("div", {
      className: "bg-gray-lighter p-px10 font-bold"
    }, Object(src_i18n["g" /* t */])('booking.transport.countdown.countdownExpired')), BookingStep_jsx("div", {
      className: "p-px30 font-bold"
    }, "00".concat(Object(src_i18n["g" /* t */])('memberSpace.options.countdownMinute'), " 0").concat(Object(src_i18n["g" /* t */])('memberSpace.options.countdownSecond'))), BookingStep_jsx("div", {
      className: "pt-px10 pb-px20"
    }, Object(src_i18n["g" /* t */])('booking.transport.countdown.countdownExpiredInformation')), BookingStep_jsx(Button["a" /* Button */], {
      color: colors["a" /* COLORS */].WHITE,
      colorBg: colors["a" /* COLORS */].SUCCESS,
      className: "mb-px20",
      onClick: redirectToResort
    }, Object(src_i18n["g" /* t */])('booking.transport.countdown.retryNewProposal')))),
    minutes: Object(src_i18n["g" /* t */])('memberSpace.options.countdownMinute'),
    seconds: Object(src_i18n["g" /* t */])('memberSpace.options.countdownSecond')
  })), BookingStep_jsx(BookingStep_BookingStepContent, bookingStepContentProps));
};
// CONCATENATED MODULE: ./src/client/views/booking/ParallaxBe.jsx

var ParallaxBe_jsx = react_default.a.createElement;




var ParallaxBe_ParallaxBe = function ParallaxBe(_ref) {
  var className = _ref.className,
      color = _ref.color,
      icon = _ref.icon;

  var _useState = Object(react["useState"])(0),
      offset = _useState[0],
      setOffset = _useState[1];

  var handleScroll = function handleScroll() {
    var _document, _document$documentEle;

    return setOffset(window.pageYOffset / (((_document = document) === null || _document === void 0 ? void 0 : (_document$documentEle = _document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.offsetHeight) || 0) * 200);
  };

  Object(react["useEffect"])(function () {
    document.addEventListener('scroll', handleScroll, false);
    return function () {
      document.removeEventListener('scroll', handleScroll, false);
    };
  }, []);

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  return ParallaxBe_jsx("div", {
    className: classnames_default()(className, 'absolute -mx-px25 sm:mx-px25 rtl:right-0 z-0', Object(defineProperty["a" /* default */])({}, "text-".concat(color), color)),
    style: {
      bottom: -150,
      opacity: 0.1,
      transform: "translateY(-".concat(offset, "px)")
    }
  }, ParallaxBe_jsx(Icon["a" /* Icon */], {
    name: icon,
    width: isTablet ? '19.25rem' : '10.25rem'
  }));
};
// CONCATENATED MODULE: ./src/client/views/booking/BookingEngine.jsx








var BookingEngine_jsx = react_default.a.createElement;

function BookingEngine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function BookingEngine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { BookingEngine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { BookingEngine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function BookingEngine_createSuper(Derived) { var hasNativeReflectConstruct = BookingEngine_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function BookingEngine_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }












































var SHOW_LAYER_QUERY_NAME = dist["appQueryParameters"].openLayer;
var TRACKING_BACK_LINK = 'back';
/**
 * Global Wrapper for booking engine purchase process
 * Breadcrumb component display current step
 * Each step represents a component linked to process
 * Button next/back allow users to navigate through step
 */

var BookingEngine_BookingEngine = /*#__PURE__*/function (_React$PureComponent) {
  Object(inherits["a" /* default */])(BookingEngine, _React$PureComponent);

  var _super = BookingEngine_createSuper(BookingEngine);

  function BookingEngine() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, BookingEngine);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      criteriaOpened: null,
      previousSelectedProposalId: _this.props.selectedProposal.id,
      unlockedStep: 0,
      step: 0,
      shouldShowSaveCriteriaConfirmation: false,
      shouldShowSaveCriteriaLogin: false,
      shouldShowEditCriteria: false,
      shouldShowShareContext: false,
      isDataFetched: !_this.shouldFetchData(),
      displayActivities: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(_this.context)('booking.displayActivities'),
      optionHoldOnly: (Object(featureFlippingUtils["a" /* isFeatureFlipped */])(_this.context)('booking.optionHoldOnly') || _this.context.isCmta && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(_this.context)('booking.cmta.optionHoldOnly')) && _this.props.selectedProposal.price && _this.props.selectedProposal.price.currency !== 'MXN',
      shouldOpenPanel: false,
      isSeller: Object(sellerUtils["g" /* isSeller */])(_this.context),
      isCmta: _this.context.isCmta,
      isDelCredere: _this.context.cmta.isDelCredere
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "focusedFilterBtn", /*#__PURE__*/react_default.a.createRef());

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "focusedModifyBtn", /*#__PURE__*/react_default.a.createRef());

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleNoData", function () {
      var _this$props = _this.props,
          proposals = _this$props.proposals,
          selectedProposal = _this$props.selectedProposal,
          history = _this$props.history; // Ideally, this doesn't happen. But who knows why, there can be issues with the API, and you
      // don't have a proposal. It makes no sense to continue

      if (_this.state.isDataFetched && (Object(lodash["isEmpty"])(proposals) || !selectedProposal)) {
        logger["default"].error(new errors_errors["f" /* ProposalNotFound */]());
        return contextUtils["f" /* isStrictlyProductionEnv */]() ? history.pushRoute('/500') : null;
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "getCurrentStepIndex", function () {
      var bookingStep = _this.props.location.urlParams.bookingStep;
      return Object(BookingEngine_utils["c" /* getStepIndex */])(_this.getFilteredBreadcrumbPages(), bookingStep);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "getCurrentPage", function () {
      var bookingStep = _this.props.location.urlParams.bookingStep;

      var currentPage = _this.getFilteredBreadcrumbPages().find(function (page) {
        return page.name === bookingStep;
      });

      Object(invariant["a" /* invariant */])(currentPage, "The step ".concat(bookingStep, " doesn't exist"));
      return currentPage;
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "updateStep", function (newStep, proposalId) {
      var pages = _this.getFilteredBreadcrumbPages();

      var redirectionPromise = _this.changeURI(pages[newStep].name, proposalId);

      redirectionPromise.then(function (response) {
        if (response) {
          _this.trackPage(newStep);
        }
      });

      if (true) {
        // setTimeout mandatory for IE
        setTimeout(function () {
          return window.scrollTo(0, 0);
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "goToNextStep", function (validationCallback) {
      var isSkipped = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return function () {
        var validationPromise = validationCallback ? validationCallback() : Promise.resolve();
        return validationPromise.then(function () {
          var pages = _this.getFilteredBreadcrumbPages();

          var step = Object(BookingEngine_utils["c" /* getStepIndex */])(pages, _this.props.location.urlParams.bookingStep);
          var maxPagesIndex = pages.length - 1;

          if (step === maxPagesIndex) {
            return;
          }

          var newStep = Math.min(maxPagesIndex, step + 1); // Seller (not CMTA): when the next page is banking we need to do nothing, everything have been already done

          if (_this.context.isCxo && pages[newStep].name === 'banking') {
            return Promise.resolve();
          } // Tracking


          var _pages$step = pages[step],
              actionGA = _pages$step.actionGA,
              labelGA = _pages$step.labelGA;
          Object(BookingEngine_tracking["c" /* trackNavigation */])(actionGA, isSkipped ? 'skipThisStep' : labelGA, _this.context);

          _this.setState({
            shouldShowEditCriteria: false
          });

          _this.updateStep(Math.min(maxPagesIndex, step + 1));
        }).catch(function () {
          return null;
        });
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "goToPreviousStep", function () {
      var stepIndex = _this.getCurrentStepIndex();

      _this.setState({
        shouldShowEditCriteria: false
      });

      if (stepIndex > 0) {
        var pages = _this.getFilteredBreadcrumbPages();

        Object(BookingEngine_tracking["c" /* trackNavigation */])(pages[stepIndex].actionGA, TRACKING_BACK_LINK, _this.context);
        return _this.updateStep(stepIndex - 1);
      }

      var _this$props2 = _this.props,
          location = _this$props2.location,
          resort = _this$props2.resort,
          isComingFromComparator = _this$props2.isComingFromComparator;
      var previousUri;

      if (location.queryParams.product || isComingFromComparator) {
        previousUri = new URI_default.a(routeBuilder["b" /* urlPattern */]('comparator')).query(BookingEngine_objectSpread({}, Object(lodash["omit"])(location.queryParams, ['proposalIds', 'selectedProposalId']))).toString();
      } else {
        previousUri = new URI_default.a(Object(lodash["get"])(resort, 'href')).query(BookingEngine_objectSpread({}, Object(lodash["omit"])(location.queryParams, ['proposalIds', 'selectedProposalId']))).toString();
      }

      return redirectUtils["a" /* default */].redirectTo()(dist["url"].normalizeUrl(previousUri));
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "renderBottomNavbar", function () {
      var arg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var validationCallback = arg.validationCallback,
          _arg$hideContinueButt = arg.hideContinueButton,
          hideContinueButton = _arg$hideContinueButt === void 0 ? false : _arg$hideContinueButt,
          _arg$shouldShowEditCr = arg.shouldShowEditCriteria,
          shouldShowEditCriteria = _arg$shouldShowEditCr === void 0 ? _this.state.shouldShowEditCriteria : _arg$shouldShowEditCr,
          _arg$isPriceLoading = arg.isPriceLoading,
          isPriceLoading = _arg$isPriceLoading === void 0 ? false : _arg$isPriceLoading,
          continueAction = arg.continueAction;

      var stepIndex = _this.getCurrentStepIndex();

      var breadCrumbPages = _this.getFilteredBreadcrumbPages();

      var currentPage = breadCrumbPages[_this.state.step];
      var previousPage = stepIndex > 0 ? breadCrumbPages[stepIndex - 1].name : null;
      var nextPage = stepIndex < breadCrumbPages.length - 1 ? breadCrumbPages[stepIndex + 1].name : null;
      var selectedProposalPrice = Object(lodash["get"])(_this.props.selectedProposal, 'price');
      var priceWithDonation = Object(price_util["c" /* getTotalPriceWithDonation */])(selectedProposalPrice, _this.context.locale);
      return BookingEngine_jsx(BookingBottomNavbar_BookingBottomNavbar, {
        criteriaOpened: _this.state.criteriaOpened,
        i18n: _this.props.i18n,
        previousAction: _this.goToPreviousStep,
        price: priceWithDonation.withDonation,
        proposal: _this.props.selectedProposal,
        resort: _this.props.resort,
        actionGA: currentPage.actionGA,
        currentPage: currentPage.name,
        previousPage: previousPage,
        nextPage: nextPage,
        isOnLastPage: _this.isOnLastPage(),
        hideContinueButton: hideContinueButton,
        isPriceLoading: isPriceLoading,
        focusedFilterBtn: _this.focusedFilterBtn,
        focusedModifyBtn: _this.focusedModifyBtn // $FlowFixMe
        ,
        continueAction: continueAction ? continueAction : _this.goToNextStep(validationCallback),
        toggleEditCriteriaMode: _this.toggleEditCriteriaMode,
        editCriteriaMode: shouldShowEditCriteria,
        shouldOpenPanel: _this.state.shouldOpenPanel,
        closePanel: function closePanel() {
          return _this.setState({
            shouldOpenPanel: false,
            shouldShowEditCriteria: false
          });
        }
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "openLayer", function (layerName) {
      var _this$props3 = _this.props,
          history = _this$props3.history,
          location = _this$props3.location;
      Object(BookingEngine_utils["d" /* navigateInBookingEngine */])({
        location: Object(uriUtils["c" /* convertLocationToURI */])(location).addQuery(Object(defineProperty["a" /* default */])({}, SHOW_LAYER_QUERY_NAME, layerName)),
        history: history
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "closeLayer", function (submitted, proposalId) {
      var _this$props4 = _this.props,
          history = _this$props4.history,
          location = _this$props4.location;

      if (submitted) {
        // this function is sometimes plugged directly to a dom element's onClick
        // so we have to use "typeof" to avoid truthy cases with dom-event...
        // if we're in AdditionalTransportsLayer we want to stay in the same step to view the selected transport
        var nextStep = location.queryParams.openLayer === 'AdditionalTransportsLayer' ? _this.state.step : _this.state.step + 1;

        _this.updateStep(nextStep, typeof proposalId === 'string' ? proposalId : undefined);
      } else {
        var newUrl = Object(uriUtils["c" /* convertLocationToURI */])(location).removeQuery(SHOW_LAYER_QUERY_NAME);
        /**
         * This case happens only after selecting an accommodation on more rooms layer, on a proposal with a flex rate
         * When use choose a new room on a proposal with Flex Rate, we should come back to accommodation page,
         * but remove other proposals ids from the url (preserve the selected one only)
         */

        if (proposalId && typeof proposalId === 'string') {
          newUrl.setQuery('proposalIds', Object(BookingEngine_utils["a" /* getAllProposalsIdWithAlternative */])(_this.props.selectedProposal));
        }

        Object(BookingEngine_utils["d" /* navigateInBookingEngine */])({
          location: newUrl,
          history: history
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "hideSaveCriteriaConfirmationModal", function () {
      var _this$props5 = _this.props,
          location = _this$props5.location,
          history = _this$props5.history;

      _this.setState({
        shouldShowSaveCriteriaConfirmation: false
      });

      if (location.queryParams.openSaveConfirmationModal) {
        Object(BookingEngine_utils["d" /* navigateInBookingEngine */])({
          location: Object(uriUtils["c" /* convertLocationToURI */])(location).removeQuery(['openSaveConfirmationModal', 'newAccount']),
          history: history,
          replace: true
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "hideSaveCriteriaLoginModal", function () {
      _this.setState({
        shouldShowSaveCriteriaLogin: false
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleSaveCriteriaTracking", function (labelGA) {
      var step = _this.state.step;

      var pages = _this.getFilteredBreadcrumbPages();

      var actionGA = pages[step].actionGA;
      Object(BookingEngine_tracking["e" /* trackSaveCriteria */])(actionGA, labelGA, _this.context);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "toggleShareContextModal", function () {
      var _this$state = _this.state,
          shouldShowShareContext = _this$state.shouldShowShareContext,
          step = _this$state.step;

      var pages = _this.getFilteredBreadcrumbPages();

      var actionGA = pages[step].actionGA;

      if (!shouldShowShareContext) {
        Object(BookingEngine_tracking["f" /* trackShareContext */])(actionGA, _this.context);
      }

      _this.setState({
        shouldShowShareContext: !shouldShowShareContext
      });

      _this.props.closeToast();
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "showSavedCriteriaPopIn", function () {
      var location = _this.props.location;
      var isUserLogged = _this.context.isUserLogged;

      _this.handleSaveCriteriaTracking(booking_constants["e" /* BE_SAVE_CLICK_GA */]);

      if (isUserLogged) {
        var selectedProposalId = location.queryParams.selectedProposalId;
        var _customerId = _this.context.neolaneId;

        _this.props.saveCustomerProposalsHandler(selectedProposalId, _this.context, _customerId).then(function () {
          _this.setState({
            shouldShowSaveCriteriaConfirmation: true
          });

          _this.handleSaveCriteriaTracking(booking_constants["h" /* BE_SAVE_VALIDATE_GA */]);
        }).catch(function (error) {
          // When the error is indeed an API error, this is the model. But code error would return
          // a native JS Error object, which doesn't have this structure
          if (error && error.errors) {
            var _error$errors = Object(slicedToArray["a" /* default */])(error.errors, 1),
                statusCode = _error$errors[0].statusCode; // catch 401 (bad token) error code
            // display save criteria login modal


            if (statusCode === 401) {
              _this.setState({
                shouldShowSaveCriteriaLogin: true
              });
            }
          }
        });
      } else {
        _this.setState({
          shouldShowSaveCriteriaLogin: true
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "toggleEditCriteriaMode", function () {
      // Setting the timeout allows to check available refs in the DOM (exposed to other non-mounted children themselves)
      !_this.state.shouldShowEditCriteria ? setTimeout(function () {
        _this.focusedFilterBtn.current && _this.focusedFilterBtn.current.focus();
      }, 0) : setTimeout(function () {
        _this.focusedModifyBtn.current && _this.focusedModifyBtn.current.focus();
      }, 0);

      _this.setState(function (state) {
        return {
          shouldShowEditCriteria: !state.shouldShowEditCriteria
        };
      }, function () {
        var currentPage = _this.getTrackingPageName();

        if (_this.state.shouldShowEditCriteria) {
          Object(BookingEngine_tracking["c" /* trackNavigation */])(currentPage, 'openReceipt_editCriteria', _this.context);
        }
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "toggleEditCriteriaModeFromFooterLite", function () {
      var criteriaOpened = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : booking_constants["o" /* CRITERIA_SELECTORS */].PRODUCT;
      return function () {
        _this.setState(function (state) {
          return {
            criteriaOpened: criteriaOpened,
            shouldShowEditCriteria: !state.shouldShowEditCriteria,
            shouldOpenPanel: true
          };
        });
      };
    });

    return _this;
  }

  Object(createClass["a" /* default */])(BookingEngine, [{
    key: "shouldFetchData",
    value: function shouldFetchData() {
      var _this$props6 = this.props,
          proposals = _this$props6.proposals,
          resort = _this$props6.resort,
          i18n = _this$props6.i18n,
          location = _this$props6.location;
      var proposalIds = location.queryParams.proposalIds || [];
      var validProposals = proposals.every(function (_ref) {
        var id = _ref.id;
        return proposalIds.indexOf(id) !== -1;
      });
      var validI18n = ['common', 'filters', 'sorters', 'travelAdvisor', 'booking', 'footer'].every(function (namespace) {
        return !Object(lodash["isNil"])(Object(lodash["get"])(i18n, namespace));
      });
      return Object(lodash["isEmpty"])(proposals) || !validProposals || !resort || !validI18n;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props7 = this.props,
          i18n = _this$props7.i18n,
          getBookingEngineI18n = _this$props7.getBookingEngineI18n,
          location = _this$props7.location,
          history = _this$props7.history,
          startLoading = _this$props7.startLoading;
      Object(BookingEngine_tracking["a" /* resetTrackingStorageBE */])(); // makes sure the user sees the top of the page when landing on it

      if (window.scrollY > 0) {
        window.scrollTo(window.scrollX, 0);
      }

      this.handleNoData();
      var queryParams = location.queryParams;
      var _location$queryParams = location.queryParams,
          proposalIds = _location$queryParams.proposalIds,
          selectedProposalId = _location$queryParams.selectedProposalId,
          openSaveConfirmationModal = _location$queryParams.openSaveConfirmationModal;

      if (!this.state.isDataFetched) {
        startLoading();
        Promise.all([this.props.fetchProposalsById(BookingEngine_objectSpread({
          proposalsId: proposalIds,
          appContext: this.context,
          shouldRequestPayment: this.isOnLastPage()
        }, Object(sellerUtils["g" /* isSeller */])(this.context) ? Object(ContactInfoUtils["f" /* getAllAttendeesIds */])(this.props.tripInformation) : null)), getBookingEngineI18n(this.context)]).then(function (_ref2) {
          var _ref3 = Object(slicedToArray["a" /* default */])(_ref2, 1),
              resp = _ref3[0];

          // The log below aims to investigate the origin of blank page bug
          var proposals = Object(lodash["get"])(resp, 'proposals.proposals');
          var resort = Object(lodash["get"])(resp, 'proposals.resort');

          if (Object(lodash["isEmpty"])(proposals)) {
            return Promise.reject(Error('API response with empty proposals'));
          }

          if (openSaveConfirmationModal && i18n.booking) {
            _this2.showSavedCriteriaPopIn();
          }

          if (Object(lodash["isEmpty"])(proposals) || !resort) {
            logger["default"].error('API response with empty proposals');
            throw new Error('no proposal found for this id');
          }
        }).catch(function (err) {
          logger["default"].error(err);

          if (Object(sellerUtils["g" /* isSeller */])(_this2.context)) {
            Object(sellerUtils["f" /* handle401GraphqlErrorSeller */])(err, _this2.context);
          }

          if (contextUtils["f" /* isStrictlyProductionEnv */]()) {
            history.pushRoute('/500');
          }
        });
        return this.props.selectProposal(selectedProposalId || proposalIds[0], BookingEngine_objectSpread(BookingEngine_objectSpread({}, location), {}, {
          queryParams: queryParams
        }), history);
      }

      this.startABTestIfSummerResort();
      this.trackPage();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this3 = this;

      var _this$props8 = this.props,
          history = _this$props8.history,
          endLoading = _this$props8.endLoading,
          location = _this$props8.location,
          i18n = _this$props8.i18n;
      var openSaveConfirmationModal = location.queryParams.openSaveConfirmationModal;
      this.handleNoData();

      if (!prevState.isDataFetched && this.state.isDataFetched) {
        endLoading(); // This tracking handles user coming from price remote, from edit criteria and using url directly

        if (!Object(lodash["isEmpty"])(this.props.proposals) && this.props.resort && this.props.i18n.booking) {
          this.trackPage();
        }
      }

      if (this.state.isDataFetched && openSaveConfirmationModal && i18n.booking) {
        this.showSavedCriteriaPopIn();
        Object(BookingEngine_utils["d" /* navigateInBookingEngine */])({
          location: Object(uriUtils["c" /* convertLocationToURI */])(location).removeQuery(['openSaveConfirmationModal']),
          history: history,
          replace: true
        });
      }

      if (!this.state.isDataFetched && !this.shouldFetchData()) {
        this.setState({
          isDataFetched: true
        });
      }

      if (typeof this.props.location.queryParams.editCriteriaWarning !== 'undefined') {
        this.setState({
          unlockedStep: 0
        }, function () {
          _this3.startABTestIfSummerResort();

          var url = Object(uriUtils["c" /* convertLocationToURI */])(_this3.props.location);

          if (!url.toString().includes('accommodation')) {
            var newUrl = url.removeSearch('editCriteriaWarning');
            Object(BookingEngine_utils["d" /* navigateInBookingEngine */])({
              location: newUrl,
              history: history,
              replace: true
            });
          }
        });
      } else if (this.props.selectedProposal && this.props.resort && this.props.i18n.booking) {
        // Once the user reached a step, they can always come back to it
        var currentStepIndex = this.getCurrentStepIndex();

        if (currentStepIndex > this.state.unlockedStep) {
          this.setState({
            unlockedStep: currentStepIndex
          });
        }
      }
    }
  }, {
    key: "startABTestIfSummerResort",
    value: function startABTestIfSummerResort() {
      if (!Object(resortUtils["a" /* isWinterMountainResort */])(this.props.resort) && this.state.step === 0 && this.state.unlockedStep === 0 && // There is a corner case where a temporary state has no proposals, which causes an error - do not remove the get
      Object(lodash["get"])(this.props, 'selectedProposal.additionalServices.activities.length') > 0) {
        window.canStartABTestActivities = true;
      }
    }
  }, {
    key: "changeURI",
    value: function changeURI(pageName, proposalId) {
      var _this$props9 = this.props,
          history = _this$props9.history,
          location = _this$props9.location,
          closeToast = _this$props9.closeToast,
          selectedProposal = _this$props9.selectedProposal;
      closeToast();
      var newUrl = Object(uriUtils["c" /* convertLocationToURI */])(location).filename(pageName).removeQuery(SHOW_LAYER_QUERY_NAME); // happens only when the user submit and close a layer

      if (proposalId) {
        newUrl.setQuery('proposalIds', Object(BookingEngine_utils["a" /* getAllProposalsIdWithAlternative */])(selectedProposal));
      }

      return Object(BookingEngine_utils["d" /* navigateInBookingEngine */])({
        location: newUrl,
        history: history
      });
    }
  }, {
    key: "getTrackingPageName",
    value: function getTrackingPageName() {
      var step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getCurrentStepIndex();
      var currentPageData = this.getFilteredBreadcrumbPages()[step] || {};
      return currentPageData.eventPageName || currentPageData.name;
    }
  }, {
    key: "getPageName",
    value: function getPageName() {
      var step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getCurrentStepIndex();
      var currentPageData = this.getFilteredBreadcrumbPages()[step] || {};
      return currentPageData.name;
    }
  }, {
    key: "getTrackingBasePriceLabel",
    value: function getTrackingBasePriceLabel(step) {
      var currentPageData = this.getFilteredBreadcrumbPages()[step] || {};
      return currentPageData.basePriceGALabel;
    }
  }, {
    key: "trackPage",
    value: function trackPage() {
      var stepIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getCurrentStepIndex();

      if (this.state.isDataFetched) {
        var resort = this.props.resort;
        var _this$props10 = this.props,
            selectedProposal = _this$props10.selectedProposal,
            leadScore = _this$props10.leadScore,
            userInfo = _this$props10.userInfo; // check if the associatedResort is there and the selected proposal has the same productId (substitution) >> update the data Layer

        if (resort.associatedResort && selectedProposal && resort.associatedResort.id && selectedProposal.productId === resort.associatedResort.id) {
          resort = BookingEngine_objectSpread(BookingEngine_objectSpread({}, resort), {}, {
            id: resort.associatedResort.id,
            name: resort.associatedResort.name
          });
        }

        var trackingPageName = this.getTrackingPageName(stepIndex);
        var pageName = this.getPageName(stepIndex);

        Object(BookingEngine_tracking["d" /* trackPage */])(BookingEngine_objectSpread(BookingEngine_objectSpread(BookingEngine_objectSpread({
          pageName: trackingPageName,
          basePriceLabel: this.getTrackingBasePriceLabel(stepIndex),
          userInfo: userInfo,
          resort: resort,
          proposals: Object(lodash["get"])(this.props, 'proposals', []),
          selectedProposal: selectedProposal
        }, leadScore ? {
          leadScore: leadScore
        } : null), this.context.isCmta && this.context.cmta.isDelCredere ? {
          customEventName: trackingPageName !== 'banking_Ducroire' && trackingPageName || pageName // keep banking instead of banking_Ducroire as eventName

        } : null), {}, {
          isComingFromComparator: this.props.isComingFromComparator
        }), this.context);
      }
    }
  }, {
    key: "getFilteredBreadcrumbPages",
    value: function getFilteredBreadcrumbPages() {
      var _this$props11 = this.props,
          selectedProposal = _this$props11.selectedProposal,
          resort = _this$props11.resort,
          i18n = _this$props11.i18n;
      return Object(BookingEngine_utils["b" /* getFilteredBreadcrumbPages */])({
        selectedProposal: selectedProposal,
        resort: resort,
        i18n: i18n,
        isActivitiesViewFeatureFlipped: this.state.displayActivities,
        isOptionHoldOnlyFeatureFlipped: this.state.optionHoldOnly,
        isSeller: this.state.isSeller,
        isCmta: this.state.isCmta,
        isDelCredere: this.state.isDelCredere
      });
    }
  }, {
    key: "isOnLastPage",
    value: function isOnLastPage() {
      return Object(uriUtils["c" /* convertLocationToURI */])(this.props.location).filename() === 'banking';
    }
  }, {
    key: "getActions",
    value: function getActions() {
      var step = this.state.step;
      var isTablet = this.props.responsive.isTablet;
      var pages = this.getFilteredBreadcrumbPages();
      var isDisplaySaveFlipped = Object(lodash["get"])(this.props, 'i18n.booking.saveMyCriteria.display');
      var isDisplayShareFlippedMobile = Object(lodash["get"])(this.props, 'i18n.booking.common.share.displayMobile');
      var isDisplayShareFlippedDesktop = Object(lodash["get"])(this.props, 'i18n.booking.common.share.displayDesktop');
      var isDisplayShareFlippedB2B = Object(lodash["get"])(this.props, 'i18n.booking.common.share.display_B2B');
      var shouldDisplaySave = !Object(sellerUtils["g" /* isSeller */])(this.context) && isDisplaySaveFlipped && pages[step].name !== booking_constants["s" /* PAGES */].BANKING;
      var shouldDisplayShareForSeller = Object(sellerUtils["g" /* isSeller */])(this.context) && isDisplayShareFlippedB2B && (isTablet && isDisplayShareFlippedDesktop || !isTablet && isDisplayShareFlippedMobile);
      var shouldDisplayShare = (!Object(sellerUtils["g" /* isSeller */])(this.context) && (isTablet && isDisplayShareFlippedDesktop || !isTablet && isDisplayShareFlippedMobile) || shouldDisplayShareForSeller) && pages[step].name !== booking_constants["s" /* PAGES */].BANKING;
      var actions = [{
        id: booking_constants["d" /* BE_SAVE_ACTION */],
        iconName: icons["a" /* ICONS */].HEART,
        label: Object(lodash["get"])(this.props, 'i18n.booking.common.save'),
        onClick: this.showSavedCriteriaPopIn,
        display: shouldDisplaySave
      }, {
        id: booking_constants["i" /* BE_SHARE_ACTION */],
        iconName: icons["a" /* ICONS */].SHARE,
        label: Object(lodash["get"])(this.props, 'i18n.booking.common.share.label'),
        display: shouldDisplayShare,
        onClick: this.toggleShareContextModal
      }];
      return actions;
    }
  }, {
    key: "render",
    value: function render() {
      var _i18n$booking, _i18n$booking$common, _i18n$booking2, _i18n$booking2$common, _this$props$i18n, _this$props$i18n$book, _this$props$i18n$book2, _selectedProposal$tra, _selectedProposal$tra2, _selectedProposal$tra3, _selectedProposal$tra4, _selectedProposal$tra5, _this$props$i18n2, _this$props$i18n2$boo, _this$props$i18n2$boo2;

      var _this$state2 = this.state,
          shouldShowSaveCriteriaConfirmation = _this$state2.shouldShowSaveCriteriaConfirmation,
          shouldShowSaveCriteriaLogin = _this$state2.shouldShowSaveCriteriaLogin,
          shouldShowShareContext = _this$state2.shouldShowShareContext;
      var _this$props12 = this.props,
          proposals = _this$props12.proposals,
          selectedProposal = _this$props12.selectedProposal,
          resort = _this$props12.resort,
          i18n = _this$props12.i18n,
          closeToast = _this$props12.closeToast,
          displayToastOnContextShare = _this$props12.displayToastOnContextShare,
          _this$props12$locatio = _this$props12.location,
          _this$props12$locatio2 = _this$props12$locatio.queryParams,
          newAccount = _this$props12$locatio2.newAccount,
          editCriteriaWarning = _this$props12$locatio2.editCriteriaWarning,
          currentStep = _this$props12$locatio.urlParams.bookingStep,
          isAppMounted = _this$props12.responsive.isAppMounted; // i18n is initialized to an empty object, so we checked its properties to see if it's loaded

      if (!this.state.isDataFetched || !i18n.booking || !isAppMounted || this.state.isDataFetched && Object(lodash["isEmpty"])(proposals)) return BookingEngine_jsx(AsyncLoader["a" /* AsyncLoader */], {
        className: "min-h-screen"
      }); // currentPage always should be an object since we destructure it on the next line

      var currentPage = this.getCurrentPage() || {};
      var name = currentPage.name,
          actionGA = currentPage.actionGA,
          seoTitle = currentPage.seoTitle,
          icon = currentPage.icon,
          gridSize = currentPage.gridSize;
      var isTransportView = name === booking_constants["s" /* PAGES */].TRANSPORT;
      var isTransferView = isTransportView && Object(lodash["isEmpty"])(selectedProposal.transports);
      var isSkipTestVisible = isTransferView || name === booking_constants["s" /* PAGES */].SERVICES || name === booking_constants["s" /* PAGES */].ACTIVITIES;
      var isJoyview = Object(lodash["get"])(resort, 'isJoyview', false);
      var alertMessageNewProposal = Object(lodash["get"])(i18n, 'booking.editCriteria.alertMessageNewProposal');
      var activeStep = this.getCurrentStepIndex();
      return BookingEngine_jsx(BookingEngineContext.Provider, {
        value: {
          currentStep: currentPage
        }
      }, BookingEngine_jsx(BookingAccessibleTitle_BookingAccessibleTitle, {
        title: seoTitle
      }), BookingEngine_jsx("div", {
        className: "relative"
      }, BookingEngine_jsx(ParallaxBe_ParallaxBe, {
        color: isJoyview ? colors["a" /* COLORS */].WATER_GREEN : colors["a" /* COLORS */].BLUE,
        icon: icon
      }), BookingEngine_jsx(HeaderLite_HeaderLite, {
        actions: this.getActions(),
        actionGA: actionGA,
        i18n: i18n,
        product: resort,
        proposal: selectedProposal
      }), BookingEngine_jsx("main", {
        role: "main"
      }, BookingEngine_jsx(BookingBreadcrumb_BookingBreadcrumb, {
        activeStep: activeStep > 0 ? activeStep : 0,
        backgroundImageSrc: resort.image,
        dates: {
          endDate: Object(apiDate["e" /* formatApiDate */])(selectedProposal.departureDate, i18n === null || i18n === void 0 ? void 0 : (_i18n$booking = i18n.booking) === null || _i18n$booking === void 0 ? void 0 : (_i18n$booking$common = _i18n$booking.common) === null || _i18n$booking$common === void 0 ? void 0 : _i18n$booking$common.condensedDateFormat),
          startDate: Object(apiDate["e" /* formatApiDate */])(selectedProposal.arrivalDate, i18n === null || i18n === void 0 ? void 0 : (_i18n$booking2 = i18n.booking) === null || _i18n$booking2 === void 0 ? void 0 : (_i18n$booking2$common = _i18n$booking2.common) === null || _i18n$booking2$common === void 0 ? void 0 : _i18n$booking2$common.condensedDateFormat)
        },
        items: this.getFilteredBreadcrumbPages().map(function (item) {
          return {
            iconName: item.icon,
            id: item.actionGA,
            label: item.title
          };
        }),
        label: (_this$props$i18n = this.props.i18n) === null || _this$props$i18n === void 0 ? void 0 : (_this$props$i18n$book = _this$props$i18n.booking) === null || _this$props$i18n$book === void 0 ? void 0 : (_this$props$i18n$book2 = _this$props$i18n$book.header) === null || _this$props$i18n$book2 === void 0 ? void 0 : _this$props$i18n$book2.bookingSteps,
        lastActiveStep: this.state.unlockedStep,
        onClickDates: this.toggleEditCriteriaModeFromFooterLite(booking_constants["o" /* CRITERIA_SELECTORS */].DEPARTURE),
        onClickParticipants: this.toggleEditCriteriaModeFromFooterLite(booking_constants["o" /* CRITERIA_SELECTORS */].ATTENDEES),
        onClickStep: this.updateStep,
        onClickTransport: this.toggleEditCriteriaModeFromFooterLite(booking_constants["o" /* CRITERIA_SELECTORS */].TRANSPORT),
        participantsNumber: selectedProposal.adultsCount + selectedProposal.childrenCount,
        transportLabel: (_selectedProposal$tra = selectedProposal.transports) === null || _selectedProposal$tra === void 0 ? void 0 : (_selectedProposal$tra2 = _selectedProposal$tra.inbound) === null || _selectedProposal$tra2 === void 0 ? void 0 : (_selectedProposal$tra3 = _selectedProposal$tra2.travelSections) === null || _selectedProposal$tra3 === void 0 ? void 0 : (_selectedProposal$tra4 = _selectedProposal$tra3[0]) === null || _selectedProposal$tra4 === void 0 ? void 0 : (_selectedProposal$tra5 = _selectedProposal$tra4.departure) === null || _selectedProposal$tra5 === void 0 ? void 0 : _selectedProposal$tra5.label
      }), BookingEngine_jsx("div", {
        className: isTransportView ? 'py-px10' : 'py-px20',
        style: {
          minHeight: '60vh'
        }
      }, BookingEngine_jsx(SiteContainer["a" /* SiteContainer */], {
        size: gridSize ? // $FlowFixMe
        gridSize : 'small'
      }, BookingEngine_jsx("div", {
        className: "flex justify-between relative"
      }, editCriteriaWarning && name === booking_constants["s" /* PAGES */].ACCOMMODATION && alertMessageNewProposal && BookingEngine_jsx("div", {
        className: "flex items-start justify-center mb-px20 text-emerald",
        "data-testid": "BookingEngine-accommodationEditWarning"
      }, BookingEngine_jsx(Icon["a" /* Icon */], {
        className: "flex-shrink-0",
        name: icons["a" /* ICONS */].WARNING,
        width: "1.5rem"
      }), BookingEngine_jsx("span", {
        className: "rtl:ml-px10"
      }, alertMessageNewProposal)), isSkipTestVisible && BookingEngine_jsx("button", {
        className: "flex font-bold items-center justify-center rtl:ml-auto reset-button text-blue",
        "data-selector": "skip-step",
        onClick: this.goToNextStep(undefined, true),
        type: "button"
      }, (_this$props$i18n2 = this.props.i18n) === null || _this$props$i18n2 === void 0 ? void 0 : (_this$props$i18n2$boo = _this$props$i18n2.booking) === null || _this$props$i18n2$boo === void 0 ? void 0 : (_this$props$i18n2$boo2 = _this$props$i18n2$boo.common) === null || _this$props$i18n2$boo2 === void 0 ? void 0 : _this$props$i18n2$boo2.skipThisStepLabel, BookingEngine_jsx(Icon["a" /* Icon */], {
        className: "overflow-visible",
        color: colors["a" /* COLORS */].BLUE,
        hasRtl: true,
        name: icons["a" /* ICONS */].ARROW_FORTH,
        width: "1rem"
      }))), BookingEngine_jsx(BookingStep_BookingStep, {
        actionGA: actionGA,
        closeLayer: this.closeLayer,
        currentStep: currentStep,
        goToNextStep: this.goToNextStep(),
        i18n: i18n,
        openLayer: this.openLayer,
        proposals: proposals,
        renderBottomNavbar: this.renderBottomNavbar,
        resort: resort,
        selectedProposal: selectedProposal,
        shouldShowEditCriteria: this.state.shouldShowEditCriteria
      }), shouldShowSaveCriteriaConfirmation ? BookingEngine_jsx(SaveCriteriaConfirmation_SaveCriteriaConfirmation, {
        closeModal: this.hideSaveCriteriaConfirmationModal,
        newAccount: newAccount,
        i18n: i18n
      }) : null, shouldShowSaveCriteriaLogin ? BookingEngine_jsx(SaveCriteriaLogin, {
        closeModal: this.hideSaveCriteriaLoginModal,
        handleSaveCriteriaTracking: this.handleSaveCriteriaTracking,
        i18n: i18n
      }) : null, shouldShowShareContext ? BookingEngine_jsx(share_context_ShareContext, {
        actionGA: actionGA,
        closeToast: closeToast,
        dataSelector: "ShareContext",
        displayToastOnContextShare: displayToastOnContextShare,
        i18n: i18n,
        onToggleModal: this.toggleShareContextModal
      }) : null)))), Object(sellerUtils["g" /* isSeller */])(this.context) ? BookingEngine_jsx("div", {
        style: {
          height: this.props.responsive.isTablet ? 'calc(100rem / 16)' : 'calc(210rem / 16)'
        }
      }) : BookingEngine_jsx(react_default.a.Fragment, null, BookingEngine_jsx(FooterLite_FooterLite, {
        contacts: Object(lodash["get"])(i18n, 'footer.contactsBar', []),
        currentPage: currentPage,
        editCriteriaLabels: Object(lodash["get"])(i18n, 'booking.editCriteria'),
        i18n: i18n,
        isEditCriteriaFeatureFlipped: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(this.context)('booking.editCriteria'),
        proposal: selectedProposal,
        resort: resort,
        toggleEditCriterias: this.toggleEditCriteriaModeFromFooterLite()
      })), BookingEngine_jsx(BlockMismatchProposalCountry_BlockMismatchProposalCountry, {
        selectedProposal: selectedProposal,
        resort: resort
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (Object(lodash["isEmpty"])(props.proposals) || !props.resort || !props.i18n.booking || !props.selectedProposal) {
        return null;
      }

      var path = props.location.pathname;
      /**
       * For indirect seller, the redirection to option page happens before BookingEngine unmount
       * BookingEngine calculates a wrong state from option url and add transport path to the option url
       * To avoid this behavior we stop calculating state from the option location
       */

      if (state.isCmta && path.includes('option')) {
        return null;
      }

      var availableSteps = Object(BookingEngine_utils["b" /* getFilteredBreadcrumbPages */])({
        selectedProposal: props.selectedProposal,
        resort: props.resort,
        i18n: props.i18n,
        isActivitiesViewFeatureFlipped: state.displayActivities,
        isOptionHoldOnlyFeatureFlipped: state.optionHoldOnly,
        isSeller: state.isSeller,
        isCmta: state.isCmta,
        isDelCredere: state.isDelCredere
      });

      var step = availableSteps.findIndex(function (el) {
        return path === el.path;
      });
      var newStep = Math.max(0, step); // if the user is went further than the contact info page and come back to change the proposal (change the package or the comfort)
      // we disabled any further step to prevent some booking bug #11871

      var newUnlockedStep = !state.previousSelectedProposalId || state.previousSelectedProposalId === props.selectedProposal.id ? Math.max(state.unlockedStep, step) : Math.min(state.unlockedStep, availableSteps.findIndex(function (el) {
        return el.path.includes('participants');
      }));
      return {
        unlockedStep: newUnlockedStep,
        step: newStep,
        previousSelectedProposalId: props.selectedProposal.id
      };
    }
  }]);

  return BookingEngine;
}(react_default.a.PureComponent);

Object(defineProperty["a" /* default */])(BookingEngine_BookingEngine, "contextType", ReactAppContext["a" /* default */]);

/* harmony default export */ var booking_BookingEngine = (Object(Responsive["a" /* default */])(Object(withRouter["a" /* withRouter */])(BookingEngine_BookingEngine)));
// CONCATENATED MODULE: ./src/client/views/booking/BookingEngine.container.js















var BookingEngine_container_mapStateToProps = function mapStateToProps(state) {
  // if there is neolids we have identified attendees so we map the proposals with the attendees datas
  var proposals = (state.seller.neolids.length ? booking_selector["v" /* getProposalsWithMappedAttendees */] : booking_selector["u" /* getProposals */])(state) || [];
  var resort = Object(booking_selector["l" /* getCurrentResort */])(state);
  return {
    proposals: proposals,
    resort: resort,
    userInfo: state.userInfo,
    i18n: state.cms,
    selectedProposal: Object(lodash["find"])(proposals, {
      id: Object(booking_selector["z" /* getSelectedProposalId */])(state)
    }) || Object(proposalUtils["f" /* getDefaultProposal */])(proposals, resort),
    tripInformation: state.tripInformation,
    leadScore: Object(leadInfo_selector["a" /* getLeadScore */])(state),
    isComingFromComparator: state.booking.entryRoute === 'comparator'
  };
};
var BookingEngine_container_mapDispatchToProps = {
  fetchProposalsById: proposals_action["k" /* fetchProposalsById */],
  selectProposal: selectedProposalId_action["d" /* selectProposal */],
  endLoading: globalLoader_action["c" /* endLoading */],
  startLoading: globalLoader_action["d" /* startLoading */],
  closeToast: toast_actions["c" /* closeToast */],
  saveCustomerProposalsHandler: proposals_action["n" /* saveCustomerProposalsHandler */],
  displayToastOnContextShare: proposals_action["h" /* displayToastOnContextShare */],
  getBookingEngineI18n: cms_actions["c" /* getBookingEngineI18n */]
};
var BookingEngineContainer = Object(errorBoundary["a" /* default */])(Object(es["c" /* connect */])(BookingEngine_container_mapStateToProps, BookingEngine_container_mapDispatchToProps, undefined, // because of shallow routing used inside the BE, the page changes without the props changing,
// so redux prevents the re-rendering (why btw? There's a withRouter lower, this is still weird)
{
  pure: false
})(booking_BookingEngine));
BookingEngineContainer.pageId = routes_constants["b" /* BOOKING_ENGINE_PAGE_ID */];
BookingEngineContainer.pageType = constants["w" /* STATIC_PAGE_TYPES */].BE;
BookingEngineContainer.disableFooter = true;
BookingEngineContainer.disableHeader = true;
/* harmony default export */ var BookingEngine_container = (BookingEngineContainer);
// CONCATENATED MODULE: ./pages/booking.js

/* harmony default export */ var booking = __webpack_exports__["default"] = (BookingEngine_container);

/***/ }),

/***/ "y0S3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return composeFiltersAsPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getLocaleFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getFlexibilityDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDepartureDateFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureCityFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDurationFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getProductIdsFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getOfferFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getFacetsFilters; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _client_store_utils_searchHelper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("4+vj");
/* harmony import */ var _faceting_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("sW3P");






var FILTER_PARAM = 'filters';
function composeFiltersAsPayload() {
  for (var _len = arguments.length, filters = new Array(_len), _key = 0; _key < _len; _key++) {
    filters[_key] = arguments[_key];
  }

  var formData = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["flattenDeep"])(filters).reduce(function (acc, _ref) {
    var name = _ref.name,
        value = _ref.value,
        operation = _ref.operation;
    if (value) acc.push("".concat(FILTER_PARAM, "[").concat(name, "][values][]=").concat(urijs__WEBPACK_IMPORTED_MODULE_3___default.a.encode(value)));

    if (value && operation) {
      acc.push("".concat(FILTER_PARAM, "[").concat(name, "][operations][]=").concat(urijs__WEBPACK_IMPORTED_MODULE_3___default.a.encode(operation)));
    }

    return acc;
  }, []);
  return formData.join('&');
}

function buildFilters(_ref2) {
  var name = _ref2.name,
      value = _ref2.value,
      operation = _ref2.operation;
  return value ? [{
    name: name,
    value: value,
    operation: operation
  }] : [];
}

function getLocaleFilters(locale) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* LOCALE_FACET_ID */ "u"],
    value: locale,
    operation: operation
  });
}
var getFlexibilityDates = function getFlexibilityDates(_ref3) {
  var departureDate = _ref3.departureDate,
      flexibility = _ref3.flexibility;

  if (!flexibility || !departureDate) {
    return {
      minDepartureDate: departureDate,
      maxDepartureDate: departureDate
    };
  }

  var minDepartureDate = moment__WEBPACK_IMPORTED_MODULE_2___default()(departureDate).subtract(flexibility, 'days');
  return {
    minDepartureDate: minDepartureDate.isAfter(moment__WEBPACK_IMPORTED_MODULE_2___default()().add(1, 'days')) ? minDepartureDate.valueOf() : moment__WEBPACK_IMPORTED_MODULE_2___default()().add(1, 'days').valueOf(),
    maxDepartureDate: moment__WEBPACK_IMPORTED_MODULE_2___default()(departureDate).add(flexibility, 'days').valueOf()
  };
};
function getDepartureDateFilters(_ref4) {
  var departureDate = _ref4.departureDate,
      _ref4$flexibility = _ref4.flexibility,
      flexibility = _ref4$flexibility === void 0 ? 0 : _ref4$flexibility,
      locale = _ref4.locale,
      _ref4$operation = _ref4.operation,
      operation = _ref4$operation === void 0 ? 'and' : _ref4$operation;

  var _getFlexibilityDates = getFlexibilityDates({
    departureDate: departureDate,
    flexibility: flexibility
  }),
      minDepartureDate = _getFlexibilityDates.minDepartureDate,
      maxDepartureDate = _getFlexibilityDates.maxDepartureDate;

  return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_DATE_MIN_FACET_ID */ "m"],
    value: minDepartureDate && Object(_client_store_utils_searchHelper__WEBPACK_IMPORTED_MODULE_4__[/* formatPertimmDate */ "a"])(moment__WEBPACK_IMPORTED_MODULE_2___default()(minDepartureDate), locale),
    operation: operation
  })), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_DATE_MAX_FACET_ID */ "l"],
    value: maxDepartureDate && Object(_client_store_utils_searchHelper__WEBPACK_IMPORTED_MODULE_4__[/* formatPertimmDate */ "a"])(moment__WEBPACK_IMPORTED_MODULE_2___default()(maxDepartureDate), locale),
    operation: operation
  })));
}
function getDepartureCityFilters(_ref5) {
  var _ref5$facets = _ref5.facets,
      facets = _ref5$facets === void 0 ? [] : _ref5$facets,
      _ref5$defaultValue = _ref5.defaultValue,
      defaultValue = _ref5$defaultValue === void 0 ? '' : _ref5$defaultValue,
      _ref5$operation = _ref5.operation,
      operation = _ref5$operation === void 0 ? 'and' : _ref5$operation;
  var departureCityFacet = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["findLast"])(facets, function (_ref6) {
    var id = _ref6.id;
    return id === _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_CITY_FACET_ID */ "i"];
  }) || {};
  var value = departureCityFacet.name || defaultValue;
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_CITY_FACET_ID */ "i"],
    value: value,
    operation: operation
  });
}
function getDurationFilters(duration) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DURATION_FACET */ "o"],
    value: duration,
    operation: operation
  });
}

function getProductIdFilters(id) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'or';
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* PRODUCT_FACET_ID */ "A"],
    value: id,
    operation: operation
  });
}

function getProductIdsFilters() {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var operation = arguments.length > 1 ? arguments[1] : undefined;
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["flatten"])(ids.map(function (id) {
    return getProductIdFilters(id, operation);
  }));
}
function getOfferFilters(offerId) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* OFFER_ID_FACET_ID */ "y"],
    value: offerId,
    operation: operation
  });
}
var FACETS_TO_OMIT = [_faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_DATE_MIN_FACET_ID */ "m"], _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_DATE_MAX_FACET_ID */ "l"], _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_CITY_FACET_ID */ "i"], _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DURATION_FACET */ "o"], _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* OFFER_ID_FACET_ID */ "y"]];
function getFacetsFilters() {
  var facets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  var filters = facets.filter(function (facet) {
    return !FACETS_TO_OMIT.includes(facet.id);
  }).map(function (facet) {
    return buildFilters({
      name: facet.id,
      value: facet.name,
      operation: operation
    });
  });
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["flatten"])(filters);
}

/***/ }),

/***/ "y316":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ suggest; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ search; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ searchWithFacets; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ getIdsFromProducts; });

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/utils/pertimm-client/filters.js
var filters = __webpack_require__("y0S3");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/axios/index.js
var axios = __webpack_require__("ggb3");

// EXTERNAL MODULE: /opt/webapp/node_modules/error.js/index.js
var error_js = __webpack_require__("x5Ag");
var error_js_default = /*#__PURE__*/__webpack_require__.n(error_js);

// CONCATENATED MODULE: ./src/utils/pertimm-client/request.js



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var PertimmRequestFailed = error_js_default.a.create({
  name: 'PertimmRequestFailed',
  message: 'The Pertimm request failed'
});

var request_getAxiosConfig = function getAxiosConfig() {
  var proxyConfig = config_default.a.get('pertimm.proxy');
  var httpsAgent;

  if (false) {}

  return {
    httpsAgent: httpsAgent,
    proxy: httpsAgent ? false : undefined
  };
};

var START_INDEX_PARAM = 'res_sf';

function recursivePostRequest(_ref) {
  var axiosConfig = _ref.axiosConfig,
      url = _ref.url,
      payload = _ref.payload,
      queryparams = _ref.queryparams,
      acc = _ref.acc;
  return Object(axios["request"])(_objectSpread(_objectSpread({}, axiosConfig), {}, {
    method: 'POST',
    url: url,
    data: payload,
    params: queryparams
  })).then(function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        data = _ref2.data;

    if (!acc) acc = _objectSpread({}, data);else acc.answers = [].concat(Object(toConsumableArray["a" /* default */])(acc.answers), Object(toConsumableArray["a" /* default */])(data.answers || []));
    var nextStart = Number(data.start_answer) + Number(data.returned_answers_count) - 1;
    var hasMoreAnswers = nextStart + 1 < Number(data.available_answers_count);
    return hasMoreAnswers ? recursivePostRequest({
      axiosConfig: axiosConfig,
      url: url,
      payload: payload,
      queryparams: _objectSpread(_objectSpread({}, queryparams), {}, Object(defineProperty["a" /* default */])({}, START_INDEX_PARAM, nextStart)),
      acc: acc
    }) : acc;
  })["catch"](function () {
    var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _error$response = error.response;
    _error$response = _error$response === void 0 ? {} : _error$response;
    var _error$response$statu = _error$response.status,
        status = _error$response$statu === void 0 ? 500 : _error$response$statu,
        _error$response$data = _error$response.data,
        data = _error$response$data === void 0 ? '' : _error$response$data;
    throw new PertimmRequestFailed({
      statusCode: status,
      errors: data
    });
  });
}

function postSearchRequest(_ref3) {
  var _objectSpread3;

  var locale = _ref3.locale,
      _ref3$payload = _ref3.payload,
      payload = _ref3$payload === void 0 ? '' : _ref3$payload,
      _ref3$queryparams = _ref3.queryparams,
      queryparams = _ref3$queryparams === void 0 ? {} : _ref3$queryparams;
  return recursivePostRequest({
    url: config_default.a.get('pertimm.apiUrl'),
    axiosConfig: request_getAxiosConfig(),
    payload: payload,
    queryparams: _objectSpread((_objectSpread3 = {
      enable_interpretation_explanation: true
    }, Object(defineProperty["a" /* default */])(_objectSpread3, START_INDEX_PARAM, 0), Object(defineProperty["a" /* default */])(_objectSpread3, "search_locale", locale), Object(defineProperty["a" /* default */])(_objectSpread3, "user_locale", locale), _objectSpread3), queryparams),
    acc: undefined
  });
}
// CONCATENATED MODULE: ./src/utils/pertimm-client/index.js





var ACTIONS = {
  WORD_WHEEL: 'wordWheel',
  PERTIMM_SEARCH: 'pertimmSearch'
};
var pertimm_client_getApiKey = Object(lodash["memoize"])(function getApiKey(appContext) {
  return config_default.a.get( // eslint-disable-next-line no-nested-ternary
  appContext.isCmta ? 'api.cm_ta_api_key' : Object(sellerUtils["g" /* isSeller */])(appContext) ? 'api.seller.api_key' : 'api.api_key');
});

function suggest(_ref) {
  var appContext = _ref.appContext,
      _ref$criteria = _ref.criteria,
      criteria = _ref$criteria === void 0 ? {} : _ref$criteria;
  var departureDate = criteria.departureDate,
      _criteria$keywords = criteria.keywords,
      keywords = _criteria$keywords === void 0 ? '' : _criteria$keywords,
      flexibility = criteria.flexibility;
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.WORD_WHEEL,
      max_suggests: config_default.a.get('pertimm.max_suggests'),
      enable_interpretation_explanation: 'true',
      query: keywords
    },
    payload: Object(filters["a" /* composeFiltersAsPayload */])(Object(filters["c" /* getDepartureDateFilters */])({
      departureDate: departureDate,
      flexibility: flexibility,
      locale: appContext.locale
    }))
  });
}

function search(_ref2) {
  var appContext = _ref2.appContext,
      _ref2$criteria = _ref2.criteria,
      criteria = _ref2$criteria === void 0 ? {} : _ref2$criteria;
  var departureDate = criteria.departureDate,
      _criteria$keywords2 = criteria.keywords,
      keywords = _criteria$keywords2 === void 0 ? '' : _criteria$keywords2,
      flexibility = criteria.flexibility;
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.PERTIMM_SEARCH,
      max_files: config_default.a.get('pertimm.max_files'),
      format: 'json',
      query: keywords
    },
    payload: Object(filters["a" /* composeFiltersAsPayload */])(Object(filters["c" /* getDepartureDateFilters */])({
      departureDate: departureDate,
      flexibility: flexibility,
      locale: appContext.locale
    }), Object(filters["g" /* getLocaleFilters */])(appContext.locale))
  });
}

function searchWithFacets(_ref3) {
  var _ref3$criteria = _ref3.criteria,
      criteria = _ref3$criteria === void 0 ? {} : _ref3$criteria,
      appContext = _ref3.appContext;
  var departureDate = criteria.departureDate,
      flexibility = criteria.flexibility;
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.PERTIMM_SEARCH,
      max_files: config_default.a.get('pertimm.max_files'),
      format: 'json',
      query: criteria.query || '',
      'contexts[boutique]': criteria.boutique,
      'contexts[screenSize]': criteria.screenSize
    },
    payload: Object(filters["a" /* composeFiltersAsPayload */])(Object(filters["c" /* getDepartureDateFilters */])({
      departureDate: departureDate,
      flexibility: flexibility,
      locale: appContext.locale
    }), Object(filters["g" /* getLocaleFilters */])(appContext.locale), Object(filters["b" /* getDepartureCityFilters */])({
      facets: criteria.filters,
      defaultValue: criteria.defaultDepartureCity
    }), Object(filters["d" /* getDurationFilters */])(criteria.tripDuration), Object(filters["i" /* getProductIdsFilters */])(criteria.productIds), Object(filters["e" /* getFacetsFilters */])(criteria.filters), Object(filters["h" /* getOfferFilters */])(criteria.offerId))
  });
}

function getIdsFromProducts(appContext) {
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.PERTIMM_SEARCH,
      max_files: config_default.a.get('pertimm.max_files'),
      format: 'json',
      disable_catalogs: 1
    },
    payload: Object(filters["a" /* composeFiltersAsPayload */])(Object(filters["g" /* getLocaleFilters */])(appContext.locale))
  }).then(function () {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref4$answers = _ref4.answers,
        answers = _ref4$answers === void 0 ? [] : _ref4$answers;

    return answers.map(function (result) {
      return Object(lodash["get"])(result, 'meta.product_id[0]');
    });
  });
}



/***/ }),

/***/ "y5B/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getEnabledPaymentProviders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return sanitizePaymentProviders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return creditCardExpiryValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return creditCardCVCValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isTransfer; });
/* unused harmony export getTemplateStringTransferOrDebit */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getOrderedPaymentProviders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getPaymentProviderLabel; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("luEP");
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(yup__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_payment_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("hi3+");
/* harmony import */ var _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("BU6i");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("kiXb");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}









var getEnabledPaymentProviders = function getEnabledPaymentProviders(paymentProviders, isMobile, appContext) {
  return (paymentProviders || []).filter(function (provider) {
    var providerId = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(provider, 'id', '').toLowerCase();

    if (appContext.isCmta) {
      // use cmta config if it exist, the "regular" one if not
      var cmtaFilterKey = "psp.".concat(providerId, ".cmta.").concat(isMobile ? 'mobile' : 'desktop');
      var cmtaValue = _config__WEBPACK_IMPORTED_MODULE_4___default.a.get(cmtaFilterKey);

      if (typeof cmtaValue === 'boolean') {
        return cmtaValue;
      }
    }

    var filterKey = "psp.".concat(providerId, ".").concat(isMobile ? 'mobile' : 'desktop'); // TODO: Bug: retourn True pour undefined donc les var d'env non settés
    // attention fixer et corriger (ajouter) les clés CMS impactés... (devant etre True)

    return _config__WEBPACK_IMPORTED_MODULE_4___default.a.get(filterKey) !== false;
  });
};
var sanitizePaymentProviders = function sanitizePaymentProviders(_ref) {
  var paymentProviders = _ref.paymentProviders,
      arrivalDate = _ref.arrivalDate,
      locale = _ref.locale;
  var daysBeforeTravel = moment__WEBPACK_IMPORTED_MODULE_2___default()(arrivalDate, _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__[/* API_DATE_FORMAT */ "a"]).diff(moment__WEBPACK_IMPORTED_MODULE_2___default()(), 'days');
  var filteredPaymentProviders = paymentProviders.filter(function (_ref2) {
    var requiredDelayBeforeDeparture = _ref2.requiredDelayBeforeDeparture;
    return !requiredDelayBeforeDeparture || requiredDelayBeforeDeparture === 0 || requiredDelayBeforeDeparture < daysBeforeTravel;
  });

  if (locale === 'de-DE' && daysBeforeTravel <= 6) {
    return filteredPaymentProviders.map(function (psp) {
      return _objectSpread(_objectSpread({}, psp), {}, {
        paymentMethods: psp.paymentMethods.filter(function (_ref3) {
          var id = _ref3.id;
          return id !== _utils_payment_constants__WEBPACK_IMPORTED_MODULE_6__[/* PAYMENT_METHOD_ID_DIRECT_DEBIT */ "j"];
        })
      });
    });
  }

  return filteredPaymentProviders;
};
var creditCardExpiryValidator = yup__WEBPACK_IMPORTED_MODULE_3__["mixed"]().test('hasCreditCardExpired', 'Credit card has expired', function (value) {
  var expiryDate = moment__WEBPACK_IMPORTED_MODULE_2___default()(value);
  return expiryDate.isValid() && !expiryDate.isBefore(moment__WEBPACK_IMPORTED_MODULE_2___default()(), 'month');
}).required();
var creditCardCVCValidator = yup__WEBPACK_IMPORTED_MODULE_3__["string"]().min(3).max(4).matches(/^[0-9]*$/).required();
var isTransfer = function isTransfer(paymentProvider) {
  return paymentProvider.id === _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_7__[/* ESSPSCT_PSP_ID */ "g"] || paymentProvider.id === _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_7__[/* NODELCRERE_TRANSFER_PSP_ID */ "l"];
};
var getTemplateStringTransferOrDebit = function getTemplateStringTransferOrDebit(paymentProvider, isCmta) {
  var templateKey = '';

  if (isTransfer(paymentProvider)) {
    templateKey = "booking".concat(isCmta ? '.partners' : '', ".banking.paymentProvider.bankTransfer.");
  }

  if (paymentProvider.id === _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_7__[/* ESSPSDD_PSP_ID */ "h"]) {
    templateKey = 'booking.banking.paymentProvider.directDebit.';
  }

  if (paymentProvider.id === _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_7__[/* NODELCRERE_CHEQUE_PSP_ID */ "k"]) {
    templateKey = "booking".concat(isCmta ? '.partners' : '', ".banking.paymentProvider.cheque.");
  }

  return templateKey;
};
var getOrderedPaymentProviders = function getOrderedPaymentProviders(paymentProviders, isTablet) {
  return !isTablet && Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "g"])('booking.banking.paymentProvider.displayOrder.mobile') ? Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "g"])('booking.banking.paymentProvider.displayOrder.mobile').split(',').map(function (id) {
    return paymentProviders.find(function (paymentProvider) {
      return paymentProvider.id === id.trim();
    });
  }).filter(Boolean) : paymentProviders;
};
var getPaymentProviderLabel = function getPaymentProviderLabel(paymentProvider, hasFullAmount, rePaymentSchedule, isCmta) {
  var transferDebitOrChequePspIds = [_PaymentInfo_const__WEBPACK_IMPORTED_MODULE_7__[/* NODELCRERE_TRANSFER_PSP_ID */ "l"], _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_7__[/* NODELCRERE_CHEQUE_PSP_ID */ "k"], _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_7__[/* ESSPSCT_PSP_ID */ "g"], _PaymentInfo_const__WEBPACK_IMPORTED_MODULE_7__[/* ESSPSDD_PSP_ID */ "h"]];
  var creditCardTotalAmount = Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "g"])("booking".concat(isCmta ? '.partners' : '', ".banking.paymentProvider.creditCard.totalAmount"));
  var creditCardDeposit = Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "g"])("booking".concat(isCmta ? '.partners' : '', ".banking.paymentProvider.creditCard.deposit"));

  if (transferDebitOrChequePspIds.includes(paymentProvider.id)) {
    return hasFullAmount || !rePaymentSchedule ? Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "g"])(getTemplateStringTransferOrDebit(paymentProvider, isCmta) + 'totalAmount') : Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "g"])(getTemplateStringTransferOrDebit(paymentProvider, isCmta) + 'deposit');
  }

  return hasFullAmount || !rePaymentSchedule ? creditCardTotalAmount : creditCardDeposit;
};

/***/ }),

/***/ "y5Lu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CNIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EMAIL_OPTIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SMS_OPTIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MAIL_OPTIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PASSPORT_ID; });
/* unused harmony export CGV */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IDENTITY_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PHONE_OPTIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PROFILING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FOSUN_PARTNERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PASSPORT_EXPIRATION_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PASSPORT_ISSUING_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NATIONALITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLUBMED_PLUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return THEO; });
var CNIL = 'CNIL';
var EMAIL_OPTIN = 'EMAIL_OPTIN';
var SMS_OPTIN = 'SMS_OPTIN';
var MAIL_OPTIN = 'MAIL_OPTIN';
var PASSPORT_ID = 'PASSPORT_ID';
var CGV = 'CGV';
var IDENTITY_NUMBER = 'IDENTITY_NUMBER';
var PHONE_OPTIN = 'PHONE_OPTIN';
var PROFILING = 'PROFILING';
var FOSUN_PARTNERS = 'FOSUN_PARTNERS';
var PASSPORT_EXPIRATION_DATE = 'PASSPORT_EXPIRATION_DATE';
var PASSPORT_ISSUING_DATE = 'PASSPORT_ISSUING_DATE';
var NATIONALITY = 'NATIONALITY';
var CLUBMED_PLUS = 'CLUBMED_PLUS';
var THEO = 'WEBTHEO';

/***/ }),

/***/ "yUod":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("ep/x");

module.exports = function (iterator) {
  var returnMethod = iterator['return'];
  if (returnMethod !== undefined) {
    return anObject(returnMethod.call(iterator)).value;
  }
};


/***/ }),

/***/ "yjkv":
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__("S3pA"),
    baseUniq = __webpack_require__("s+R0");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),

/***/ "yvHl":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("DZWw");
var toObject = __webpack_require__("A+R+");
var sharedKey = __webpack_require__("mmil");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("xVJP");

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "yzIS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ PaymentInfo_PaymentInfo; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("fYnN");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js + 115 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/payment-form/paymentProvidersUtils.js
var paymentProvidersUtils = __webpack_require__("y5B/");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/capsule/Capsule.jsx + 1 modules
var Capsule = __webpack_require__("jldR");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-feedback/FormFeedback.jsx
var FormFeedback = __webpack_require__("DwNm");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-process/WeChatTutorial.jsx
var __jsx = react_default.a.createElement;







var WECHAT_TUTORIAL_IMAGE = 'https://ns.clubmed.com/it/2018/be/payment/wechat.png';
var WeChatTutorial_WeChatTutorial = function WeChatTutorial(_ref) {
  var _ref$hasTransactionEx = _ref.hasTransactionExpired,
      hasTransactionExpired = _ref$hasTransactionEx === void 0 ? false : _ref$hasTransactionEx;
  return __jsx("div", {
    className: "WechatTutorial"
  }, __jsx(Title["a" /* Title */], {
    className: "mb-px10",
    theme: "title-sans-2"
  }, Object(src_i18n["g" /* t */])('common.payment.wechat.qrCode.title')), __jsx(Capsule["a" /* Capsule */], null, hasTransactionExpired && __jsx(FormFeedback["a" /* FormFeedback */], {
    className: "WechatPayment-ErrorMessage",
    isError: true,
    message: Object(src_i18n["g" /* t */])('common.payment.wechat.qrCode.expired')
  }), __jsx("div", {
    className: classnames_default()('header', {
      spacing: !hasTransactionExpired
    })
  }, __jsx("div", {
    className: "highlited-text text-blue"
  }, Object(src_i18n["g" /* t */])('common.payment.wechat.qrCode.subtitle')), __jsx("div", {
    className: "subheader"
  }, Object(src_i18n["g" /* t */])('common.payment.wechat.qrCode.label'))), __jsx(Image["b" /* default */], {
    altMsg: "tutorial to use wechat",
    className: "wechat-tutorial",
    imageUrl: WECHAT_TUTORIAL_IMAGE,
    mandatoryWidthAndHeight: {
      h: 313,
      w: 420
    }
  })));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/ScrollToErrorHook.js
var ScrollToErrorHook = __webpack_require__("I7/a");

// EXTERNAL MODULE: ./src/client/components/frameworks/grid-row/Grid.row.jsx
var Grid_row = __webpack_require__("WzQP");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/yup/lib/index.js
var lib = __webpack_require__("luEP");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/FormikInput.jsx + 16 modules
var FormikInput = __webpack_require__("/HC4");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/formik-input/Label.jsx
var Label = __webpack_require__("vJSV");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/FreeDeposit.jsx
var FreeDeposit_jsx = react_default.a.createElement;










var FreeDeposit_FreeDeposit = function FreeDeposit(_ref) {
  var startDate = _ref.startDate,
      price = _ref.price,
      touched = _ref.touched;
  var validateFreeDeposit = lib["number"]().typeError(Object(src_i18n["g" /* t */])('memberSpace.prePaymentPage.splitPayment.paymentField')).positive(Object(src_i18n["g" /* t */])('memberSpace.prePaymentPage.splitPayment.amountError')).max(price.value, Object(src_i18n["g" /* t */])('memberSpace.prePaymentPage.splitPayment.amountError'));
  return FreeDeposit_jsx(react["Fragment"], null, FreeDeposit_jsx(Title["a" /* Title */], {
    className: "mb-px10",
    color: colors["a" /* COLORS */].BLUE,
    theme: "title-sans-4"
  }, Object(src_i18n["g" /* t */])('memberSpace.trips.price.splitPayment')), FreeDeposit_jsx(Capsule["a" /* Capsule */], null, FreeDeposit_jsx("div", {
    className: classnames_default()('flex', 'flex-col', 'text-base', 'pt-px5', 'px-px20')
  }, FreeDeposit_jsx("div", {
    className: classnames_default()('flex', 'flex-col', 'md:flex-row', 'items-baseline', 'lg:items-center')
  }, FreeDeposit_jsx("div", {
    className: classnames_default()('flex', 'flex-grow', 'justify-start', 'flex-col', 'lg:flex-row', 'items-end', 'lg:items-baseline', 'text-blue')
  }, FreeDeposit_jsx("div", {
    className: classnames_default()('font-bold', 'text-lg', 'whitespace-no-wrap')
  }, Object(src_i18n["g" /* t */])('memberSpace.prePaymentPage.splitPayment.totalDue')), FreeDeposit_jsx("div", {
    className: classnames_default()('ml-px5', 'whitespace-no-wrap')
  }, Object(src_i18n["g" /* t */])('memberSpace.prePaymentPage.splitPayment.paymentBefore'), ' ', moment_default()(startDate, 'YYYYMMDD').format(Object(src_i18n["g" /* t */])('booking.form.dateFormat')))), FreeDeposit_jsx("div", {
    className: classnames_default()('ml-px25', 'lg:ml-px15', 'lg:mr-px15', 'text-xl', 'font-bold', 'text-blue', 'whitespace-no-wrap')
  }, price.formattedValue)), FreeDeposit_jsx("div", {
    className: classnames_default()('flex-grow', 'hide-input-type-number-arrows'),
    style: {
      minHeight: 94
    }
  }, FreeDeposit_jsx(Label["a" /* Label */], {
    label: Object(src_i18n["g" /* t */])('memberSpace.prePaymentPage.splitPayment.title'),
    htmlFor: "freeDeposit"
  }), FreeDeposit_jsx(FormikInput["a" /* FormikInput */], {
    validate: validateFreeDeposit,
    type: "number",
    name: "freeDeposit",
    title: Object(src_i18n["g" /* t */])('memberSpace.prePaymentPage.splitPayment.paymentField'),
    placeholder: !touched ? Object(src_i18n["g" /* t */])('memberSpace.prePaymentPage.splitPayment.paymentField') : '',
    onWheel: function onWheel() {
      var _document, _document$activeEleme;

      (_document = document) === null || _document === void 0 ? void 0 : (_document$activeEleme = _document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.blur();
    }
  })))));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/tooltip/Tooltip.jsx
var Tooltip = __webpack_require__("i3Ve");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx + 1 modules
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/proposals.action.js + 1 modules
var proposals_action = __webpack_require__("AnR0");

// EXTERNAL MODULE: ./src/utils/currency-config-for-locale/currencyConfigForLocale.js
var currencyConfigForLocale = __webpack_require__("wz9x");

// CONCATENATED MODULE: ./src/client/components/widgets/donation/Donation.jsx
var Donation_jsx = react_default.a.createElement;















var DONATION_IMAGE_URL = 'https://ns.clubmed.com/it/2019/be/donation.jpg';
var Donation_Donation = function Donation(_ref) {
  var i18n = _ref.i18n,
      isDisabled = _ref.isDisabled,
      currency = _ref.currency,
      formik = _ref.formik;
  var dispatch = Object(es["d" /* useDispatch */])();
  var _i18n$booking$banking = i18n.booking.banking.donation,
      amount1 = _i18n$booking$banking.amount1,
      amount2 = _i18n$booking$banking.amount2,
      amount3 = _i18n$booking$banking.amount3,
      noAmount = _i18n$booking$banking.noAmount,
      title = _i18n$booking$banking.title,
      blockTitle = _i18n$booking$banking.blockTitle,
      popinTitle = _i18n$booking$banking.popinTitle,
      popinDescription = _i18n$booking$banking.popinDescription,
      popinFiscalInfo = _i18n$booking$banking.popinFiscalInfo;

  var _useContext = Object(react["useContext"])(ReactAppContext["a" /* default */]),
      locale = _useContext.locale;

  var _useContext2 = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isTablet = _useContext2.isTablet;

  var options = [{
    value: amount1,
    formattedValue: Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(amount1, locale, currency)
  }, {
    value: amount2,
    formattedValue: Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(amount2, locale, currency)
  }, {
    value: amount3,
    formattedValue: Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(amount3, locale, currency)
  }, {
    value: 0,
    formattedValue: noAmount
  }];
  var modalTitleId = 'ModalTitleId';
  return Donation_jsx(react["Fragment"], null, Donation_jsx(Title["a" /* Title */], {
    className: "mb-px10",
    color: colors["a" /* COLORS */].BLUE,
    theme: "title-sans-4"
  }, title), Donation_jsx("div", {
    className: "Donation"
  }, Donation_jsx("div", {
    className: classnames_default()('Donation-icon p-px20', {
      hidden: !isTablet,
      flex: isTablet
    })
  }, Donation_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].DONATION,
    width: "3rem",
    color: colors["a" /* COLORS */].BLUE,
    className: classnames_default()({
      'self-center': isTablet
    })
  })), Donation_jsx("div", {
    className: "Donation-content p-px20"
  }, Donation_jsx("p", {
    className: "m-0 mb-px15"
  }, blockTitle), Donation_jsx("div", {
    className: classnames_default()('flex', {
      'flex-wrap': !isTablet,
      'justify-between': !isTablet
    })
  }, options.map(function (option) {
    return Donation_jsx("div", {
      className: "Donation-content--option",
      key: option.value
    }, Donation_jsx(FormikInput["a" /* FormikInput */], {
      type: "radio",
      name: "donation",
      value: option.value,
      label: option.formattedValue,
      onChange: function onChange() {
        // when the user change his mind and don't want donate it must reset the donation cgu if already checked
        if (option.value === 0 && formik.values.termsAndConditions.donation) {
          formik.setFieldValue('termsAndConditions.donation', false);
        }

        dispatch(Object(proposals_action["o" /* saveDonationToProposals */])(option));
      },
      isDisabled: isDisabled
    }));
  }))), Donation_jsx("div", {
    className: "Donation-tooltip p-px20 flex"
  }, Donation_jsx("div", {
    className: "items-center flex block"
  }, Donation_jsx(Tooltip["a" /* Tooltip */] // $FlowFixMe does not understand children prop comes from nested cmp
  , {
    modalProps: {
      ariaLabel: popinTitle,
      ariaLabelledby: modalTitleId,
      closeLabel: i18n.common.close,
      size: 'small'
    },
    renderTrigger: function renderTrigger(toggle) {
      return Donation_jsx("button", {
        className: "reset-button",
        onClick: toggle,
        type: "button"
      }, Donation_jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].TOOLTIP,
        width: "1.25rem",
        color: colors["a" /* COLORS */].BLUE
      }));
    }
  }, Donation_jsx("div", null, Donation_jsx(Image["b" /* default */], {
    imageUrl: DONATION_IMAGE_URL,
    ratioKey: "L"
  }), Donation_jsx("div", {
    className: "p-px20"
  }, Donation_jsx(Title["a" /* Title */], {
    className: "mb-px10",
    id: modalTitleId,
    theme: "title-sans-4"
  }, popinTitle), Donation_jsx(Text["a" /* Text */], {
    className: "mb-px10 text-sm",
    text: popinDescription
  }), Donation_jsx(Text["a" /* Text */], {
    className: "text-sm",
    text: popinFiscalInfo
  }))))))));
};
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/HostedField.jsx
var HostedField_jsx = react_default.a.createElement;


var HostedField_HostedField = function HostedField(_ref) {
  var label = _ref.label,
      id = _ref.id,
      _ref$small = _ref.small,
      small = _ref$small === void 0 ? false : _ref$small,
      children = _ref.children,
      _ref$hasError = _ref.hasError,
      hasError = _ref$hasError === void 0 ? false : _ref$hasError,
      _ref$isValid = _ref.isValid,
      isValid = _ref$isValid === void 0 ? false : _ref$isValid;
  return HostedField_jsx("div", {
    className: classnames_default()('HostedField w-full pt-px20 px-px10 pb-px10', {
      'HostedField-small': small
    })
  }, HostedField_jsx("div", {
    className: "HostedField-label mb-px5 pl-px10 text-gray-dark"
  }, label), HostedField_jsx("div", {
    className: classnames_default()('HostedField-input w-full border-b-1', {
      'border-gray-dark': !hasError && !isValid,
      'border-danger': hasError,
      'border-success': isValid
    }),
    id: id
  }, children));
};
// EXTERNAL MODULE: ./src/hooks/use-script-loader/useScriptLoader.js
var useScriptLoader = __webpack_require__("/WwO");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/CybersourceForm.jsx
var CybersourceForm_jsx = react_default.a.createElement;











var CYBERSOURCE_FIELD_FULL_NAME = 'cybersource-card-holder';
var CYBERSOURCE_FIELD_CARD_NUMBER = 'cybersource-card-number';
var CYBERSOURCE_FIELD_EXPIRY_DATE = 'cybersource-card-expiry';
var CYBERSOURCE_FIELD_CVC = 'cybersource-card-cvc';
var CybersourceForm_CyberSourceForm = function CyberSourceForm(_ref) {
  var formik = _ref.formik,
      token = _ref.token;

  var _useScriptLoader = Object(useScriptLoader["a" /* useScriptLoader */])(config_default.a.get('psp.mcybersource.script_url')),
      scriptLoaded = _useScriptLoader.scriptLoaded;

  var _useState = Object(react["useState"])({
    isValid: false,
    isDirty: false
  }),
      creditCardNumberValidation = _useState[0],
      setCreditCardNumberValidation = _useState[1];

  var microformInstanceRef = Object(react["useRef"])();
  Object(react["useEffect"])(function () {
    if (scriptLoaded) {
      var options = {
        keyId: token.value.kid,
        keystore: token.value,
        container: "#".concat(CYBERSOURCE_FIELD_CARD_NUMBER),
        label: '.HostedField-label',
        placeholder: Object(src_i18n["g" /* t */])('common.payment.hipay.placeholderCardNumber'),
        styles: {
          input: {
            'font-size': '14px',
            color: '#000'
          }
        }
      };
      window.FLEX.microform(options, function (error, microformInstance) {
        if (error) {
          throw Error(error.message || 'Could not instantiate microform');
        }

        microformInstanceRef.current = microformInstance;
        microformInstance.on('validationChange', function (_ref2) {
          var valid = _ref2.valid;
          setCreditCardNumberValidation({
            isValid: valid,
            isDirty: true
          });

          if (!valid) {
            formik.setFieldValue('token', '');
          }
        });
      });
    }
  }, [scriptLoaded]);
  Object(react["useEffect"])(function () {
    var shouldRequestToken = microformInstanceRef.current && creditCardNumberValidation.isValid && !formik.errors[CYBERSOURCE_FIELD_EXPIRY_DATE] && !formik.errors[CYBERSOURCE_FIELD_CVC] && !formik.values.token && formik.isSubmitting;

    if (shouldRequestToken) {
      var creditCardExpiryDateObject = new Date(formik.values[CYBERSOURCE_FIELD_EXPIRY_DATE]);
      var expiryMonth = (creditCardExpiryDateObject.getMonth() + 1).toString().padStart(2, '0');
      var expiryYear = creditCardExpiryDateObject.getFullYear().toString(); // $FlowFixMe: microformInstanceRef.current is defined at this point

      microformInstanceRef.current.createToken({
        cardExpirationMonth: expiryMonth,
        cardExpirationYear: expiryYear
      }, function (err, data) {
        if (err) {
          throw Error(err.message || 'Could not generate token');
        }

        formik.setFieldValue('token', data.token);
        setTimeout(formik.submitForm, 0);
      });
    }
    /**
     * If we have a token and the form payment process is on error, we must delete the old token
     * because the user could update his credit card data, so we must request a new token on the next submit
     */


    var shouldDeleteToken = formik.values.token && formik.status && formik.status.paymentProcessOnError;

    if (shouldDeleteToken) {
      formik.setFieldValue('token', '');
    }
  }, [formik.isSubmitting, formik.status]);
  var inputStyle = 'outline-none px-px10 rounded-tiny text-md text-gray-darker transition-all w-full';
  return CybersourceForm_jsx(react["Fragment"], null, CybersourceForm_jsx(FormikInput["a" /* FormikInput */], {
    type: "hidden",
    isRequired: true,
    name: "token"
  }), CybersourceForm_jsx(Title["a" /* Title */], {
    className: classnames_default()('mb-px10', {
      'formik-errored': !formik.values.token
    }),
    color: colors["a" /* COLORS */].BLUE,
    theme: "title-sans-4"
  }, Object(src_i18n["g" /* t */])('common.payment.hipay.cardDetailTitle')), CybersourceForm_jsx(Capsule["a" /* Capsule */], null, CybersourceForm_jsx("div", {
    className: "flex flex-wrap py-px15 px-0"
  }, CybersourceForm_jsx(HostedField_HostedField, {
    label: Object(src_i18n["g" /* t */])('common.payment.hipay.fullNameLabel'),
    id: CYBERSOURCE_FIELD_FULL_NAME,
    hasError: formik.touched[CYBERSOURCE_FIELD_FULL_NAME] && formik.errors[CYBERSOURCE_FIELD_FULL_NAME],
    isValid: formik.touched[CYBERSOURCE_FIELD_FULL_NAME] && !formik.errors[CYBERSOURCE_FIELD_FULL_NAME]
  }, CybersourceForm_jsx(FormikInput["a" /* FormikInput */], {
    name: CYBERSOURCE_FIELD_FULL_NAME,
    type: "text",
    placeholder: Object(src_i18n["g" /* t */])('common.payment.hipay.placeholderFullName'),
    isRequired: true,
    isDisabled: formik.isSubmitting,
    customClasses: inputStyle
  })), CybersourceForm_jsx(HostedField_HostedField, {
    label: Object(src_i18n["g" /* t */])('common.payment.hipay.cardNumberLabel'),
    id: CYBERSOURCE_FIELD_CARD_NUMBER,
    hasError: creditCardNumberValidation.isDirty && !creditCardNumberValidation.isValid,
    isValid: creditCardNumberValidation.isDirty && creditCardNumberValidation.isValid
  }), CybersourceForm_jsx(HostedField_HostedField, {
    label: Object(src_i18n["g" /* t */])('common.payment.hipay.expiryDateLabel'),
    id: CYBERSOURCE_FIELD_EXPIRY_DATE,
    small: true,
    hasError: formik.touched[CYBERSOURCE_FIELD_EXPIRY_DATE] && formik.errors[CYBERSOURCE_FIELD_EXPIRY_DATE],
    isValid: formik.touched[CYBERSOURCE_FIELD_EXPIRY_DATE] && !formik.errors[CYBERSOURCE_FIELD_EXPIRY_DATE]
  }, CybersourceForm_jsx(FormikInput["a" /* FormikInput */], {
    type: "creditCardExpiry",
    name: CYBERSOURCE_FIELD_EXPIRY_DATE,
    className: "w-full",
    dateFormat: Object(src_i18n["g" /* t */])('booking.form.dateFormat'),
    monthPlaceholder: Object(src_i18n["g" /* t */])('booking.form.monthPlaceholder'),
    yearPlaceholder: Object(src_i18n["g" /* t */])('booking.form.yearPlaceholder'),
    validate: paymentProvidersUtils["b" /* creditCardExpiryValidator */],
    isDisabled: formik.isSubmitting
  })), CybersourceForm_jsx(HostedField_HostedField, {
    label: Object(src_i18n["g" /* t */])('common.payment.hipay.cvcLabel'),
    id: CYBERSOURCE_FIELD_CVC,
    small: true,
    hasError: formik.touched[CYBERSOURCE_FIELD_CVC] && formik.errors[CYBERSOURCE_FIELD_CVC],
    isValid: formik.touched[CYBERSOURCE_FIELD_CVC] && !formik.errors[CYBERSOURCE_FIELD_CVC]
  }, CybersourceForm_jsx(FormikInput["a" /* FormikInput */], {
    type: "tel",
    name: CYBERSOURCE_FIELD_CVC,
    placeholder: Object(src_i18n["g" /* t */])('common.payment.hipay.placeholderCvc'),
    className: "w-full",
    validate: paymentProvidersUtils["a" /* creditCardCVCValidator */],
    isDisabled: formik.isSubmitting,
    customClasses: inputStyle
  })))));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/HipayForm.jsx



var HipayForm_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var HIPAY_FIELD_FULL_NAME = 'hipay-card-holder';
var HIPAY_FIELD_CARD_NUMBER = 'hipay-card-number';
var HIPAY_FIELD_EXPIRY_DATE = 'hipay-card-expiry';
var HIPAY_FIELD_CVC = 'hipay-card-cvc';
var HipayForm_HipayForm = function HipayForm(_ref) {
  var formik = _ref.formik;

  var _useScriptLoader = Object(useScriptLoader["a" /* useScriptLoader */])(config_default.a.get('psp.mhipay.script_url')),
      scriptLoaded = _useScriptLoader.scriptLoaded;

  Object(react["useEffect"])(function () {
    if (scriptLoaded) {
      // eslint-disable-next-line new-cap
      var hipay = window.HiPay({
        environment: config_default.a.get('psp.mhipay.environment'),
        password: config_default.a.get('psp.mhipay.password'),
        username: config_default.a.get('psp.mhipay.username')
      });
      var hipayCardCreated = hipay.create('card', {
        multi_use: true,
        fields: {
          cardHolder: {
            placeholder: Object(src_i18n["g" /* t */])('common.payment.hipay.placeholderFullName'),
            selector: HIPAY_FIELD_FULL_NAME
          },
          cardNumber: {
            placeholder: Object(src_i18n["g" /* t */])('common.payment.hipay.placeholderCardNumber'),
            selector: HIPAY_FIELD_CARD_NUMBER
          },
          cvc: {
            placeholder: Object(src_i18n["g" /* t */])('common.payment.hipay.placeholderCvc'),
            selector: HIPAY_FIELD_CVC
          },
          expiryDate: {
            placeholder: Object(src_i18n["g" /* t */])('common.payment.hipay.placeholderExpiryDate'),
            selector: HIPAY_FIELD_EXPIRY_DATE
          }
        }
      });
      hipayCardCreated.on('change', /*#__PURE__*/function () {
        var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref2) {
          var valid, data;
          return regenerator_default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  valid = _ref2.valid;

                  if (valid) {
                    _context.next = 3;
                    break;
                  }

                  return _context.abrupt("return", formik.setFieldValue('token', ''));

                case 3:
                  _context.next = 5;
                  return hipayCardCreated.getPaymentData();

                case 5:
                  data = _context.sent;
                  formik.setValues(_objectSpread(_objectSpread({}, formik.values), {}, {
                    /**
                     * Even if browserInfo is not related to uri state or oidc, this helper is very handy in this case
                     * to store it as form field and send the object to gql as string
                     * */
                    browserInfo: dist["oidc"].toUriEncodedState(data.browser_info),
                    paymentProduct: data.payment_product,
                    token: data.token
                  }));

                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }());
    }
  }, [scriptLoaded]);
  return HipayForm_jsx(react["Fragment"], null, HipayForm_jsx(FormikInput["a" /* FormikInput */], {
    isRequired: true,
    name: "browserInfo",
    type: "hidden"
  }), HipayForm_jsx(FormikInput["a" /* FormikInput */], {
    isRequired: true,
    name: "token",
    type: "hidden"
  }), HipayForm_jsx(FormikInput["a" /* FormikInput */], {
    name: "paymentProduct",
    type: "hidden"
  }), HipayForm_jsx(Title["a" /* Title */], {
    className: classnames_default()('mb-px10', {
      'formik-errored': !formik.values.token
    }),
    color: colors["a" /* COLORS */].BLUE,
    theme: "title-sans-4"
  }, Object(src_i18n["g" /* t */])('common.payment.hipay.cardDetailTitle')), HipayForm_jsx(Capsule["a" /* Capsule */], null, HipayForm_jsx("div", {
    className: "flex flex-wrap py-px20 px-0"
  }, HipayForm_jsx(HostedField_HostedField, {
    id: HIPAY_FIELD_FULL_NAME,
    label: Object(src_i18n["g" /* t */])('common.payment.hipay.fullNameLabel')
  }), HipayForm_jsx(HostedField_HostedField, {
    id: HIPAY_FIELD_CARD_NUMBER,
    label: Object(src_i18n["g" /* t */])('common.payment.hipay.cardNumberLabel')
  }), HipayForm_jsx(HostedField_HostedField, {
    id: HIPAY_FIELD_EXPIRY_DATE,
    label: Object(src_i18n["g" /* t */])('common.payment.hipay.expiryDateLabel'),
    small: true
  }), HipayForm_jsx(HostedField_HostedField, {
    id: HIPAY_FIELD_CVC,
    label: Object(src_i18n["g" /* t */])('common.payment.hipay.cvcLabel'),
    small: true
  }))));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/grid-cell/Grid.cell.jsx
var Grid_cell = __webpack_require__("PCgT");

// EXTERNAL MODULE: ./src/utils/label/labelUtils.js
var labelUtils = __webpack_require__("WGoB");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-method/PaymentFees.jsx
var PaymentFees_jsx = react_default.a.createElement;



var PaymentFees_PaymentFees = function PaymentFees(_ref) {
  var chargePercentage = _ref.chargePercentage;
  return PaymentFees_jsx("div", {
    className: "m-px15 text-base",
    "data-testid": "paymentMethodFees"
  }, PaymentFees_jsx(TemplateString["a" /* TemplateString */], {
    template: Object(src_i18n["g" /* t */])('booking.banking.paymentMethod.percentageChargedDescription'),
    values: {
      percentage_value: "".concat(chargePercentage, "%")
    },
    valuesClassName: {
      percentage_value: 'font-bold text-turquoise'
    }
  }));
};
// EXTERNAL MODULE: ./src/utils/payment/payment.utils.js
var payment_utils = __webpack_require__("aMaj");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-method/PaymentMethodsWithConditions.jsx
var PaymentMethodsWithConditions_jsx = react_default.a.createElement;












var PaymentMethodsWithConditions_PaymentMethodsWithConditions = function PaymentMethodsWithConditions(_ref) {
  var formik = _ref.formik,
      paymentProvider = _ref.paymentProvider,
      requiredRule = _ref.requiredRule;
  Object(react["useEffect"])(function () {
    if (!formik.values.paymentMethodId) {
      formik.setFieldValue('paymentMethodId', paymentProvider.paymentMethods[0].id);
    }
  }, []);

  if (!formik.values.paymentMethodId || !formik.values.paymentConditionId) {
    return null;
  } // $FlowFixMe always found


  var paymentMethodSelected = paymentProvider.paymentMethods.find(function (_ref2) {
    var id = _ref2.id;
    return id === formik.values.paymentMethodId;
  });
  var paymentConditionSelected = paymentMethodSelected.timePaymentConditions.find(function (_ref3) {
    var id = _ref3.id;
    return id === formik.values.paymentConditionId;
  });

  if (!paymentConditionSelected) {
    return null;
  }

  var isIframe = Object(payment_utils["d" /* isIframePayment */])(paymentProvider.id);
  return PaymentMethodsWithConditions_jsx("div", {
    className: "mt-px20"
  }, PaymentMethodsWithConditions_jsx(Title["a" /* Title */], {
    className: "mb-px10",
    color: colors["a" /* COLORS */].BLUE,
    theme: "title-sans-4"
  }, Object(src_i18n["g" /* t */])('booking.banking.paymentMethod.title')), PaymentMethodsWithConditions_jsx(Capsule["a" /* Capsule */], null, PaymentMethodsWithConditions_jsx("div", {
    className: "p-px20"
  }, PaymentMethodsWithConditions_jsx(Grid_row["a" /* GridRow */], null, PaymentMethodsWithConditions_jsx(Grid_cell["a" /* GridCell */], {
    cols: {
      M: 4,
      XS: 12
    }
  }, PaymentMethodsWithConditions_jsx(FormikInput["a" /* FormikInput */], {
    type: "select",
    name: "paymentMethodId",
    label: Object(src_i18n["g" /* t */])('booking.banking.paymentMethod.selectCardTypeLabel'),
    showValidateState: false,
    options: paymentProvider.paymentMethods.map(function (_ref4) {
      var id = _ref4.id,
          label = _ref4.label;
      return {
        name: label,
        value: id
      };
    }),
    validate: requiredRule,
    isRequired: true
  })), PaymentMethodsWithConditions_jsx(Grid_cell["a" /* GridCell */], {
    cols: {
      M: 4,
      XS: 12
    }
  }, PaymentMethodsWithConditions_jsx(FormikInput["a" /* FormikInput */], {
    type: "select",
    name: "paymentConditionId",
    label: Object(src_i18n["g" /* t */])('booking.banking.paymentMethod.selectNumberOfMonthsLabel'),
    showValidateState: false,
    options: paymentMethodSelected.timePaymentConditions.map(function (_ref5) {
      var id = _ref5.id,
          paymentCount = _ref5.paymentCount;
      return {
        name: Object(src_i18n["g" /* t */])(Object(labelUtils["d" /* pluralizeLabel */])('booking.banking.paymentMethod.monthLabel', 'booking.banking.paymentMethod.monthsLabel', paymentCount), {
          month_payment_count: paymentCount
        }),
        value: id
      };
    }),
    validate: requiredRule,
    isRequired: true
  })), isIframe && PaymentMethodsWithConditions_jsx(Grid_cell["a" /* GridCell */], {
    cols: {
      M: 4,
      XS: 12
    },
    className: "mt-px25"
  }, PaymentMethodsWithConditions_jsx(Button["a" /* Button */], {
    type: "submit",
    className: "w-full"
  }, Object(src_i18n["g" /* t */])('booking.common.validate')))), paymentConditionSelected.chargePercentage > 0 && PaymentMethodsWithConditions_jsx(PaymentFees_PaymentFees, {
    chargePercentage: paymentConditionSelected.chargePercentage
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-method/PaymentMethodsCardList.jsx

var PaymentMethodsCardList_jsx = react_default.a.createElement;







var PaymentMethodsCardList_PaymentMethodsCardList = function PaymentMethodsCardList(_ref) {
  var formik = _ref.formik,
      paymentProvider = _ref.paymentProvider,
      requiredRule = _ref.requiredRule,
      shouldSubmitFormOnPaymentChosen = _ref.shouldSubmitFormOnPaymentChosen;
  return PaymentMethodsCardList_jsx("div", {
    className: "mt-px20"
  }, PaymentMethodsCardList_jsx(Title["a" /* Title */], {
    className: "mb-px10",
    color: colors["a" /* COLORS */].BLUE,
    theme: "title-sans-4"
  }, Object(src_i18n["g" /* t */])('common.payment.hipay.cardListTitle')), PaymentMethodsCardList_jsx(Capsule["a" /* Capsule */], null, PaymentMethodsCardList_jsx(FormikInput["a" /* FormikInput */], {
    type: "hidden",
    name: "paymentMethodId",
    validate: requiredRule
  }), PaymentMethodsCardList_jsx(FormikInput["a" /* FormikInput */], {
    type: "hidden",
    name: "paymentConditionId",
    validate: requiredRule
  }), PaymentMethodsCardList_jsx("ul", {
    className: classnames_default()('PaymentMethodList', {
      'formik-errored': formik.errors.paymentMethodId
    })
  }, paymentProvider.paymentMethods.map(function (paymentMethod) {
    var timePaymentCondition = paymentMethod.timePaymentConditions.find(function (condition) {
      return condition.id === paymentMethod.id;
    });
    return PaymentMethodsCardList_jsx("li", {
      key: paymentMethod.id,
      className: classnames_default()('PaymentMethodList-item', {
        'PaymentMethodList-item--with-card-fees': timePaymentCondition
      })
    }, PaymentMethodsCardList_jsx("img", {
      "data-testid": "PaymentMethodsCardList-".concat(paymentMethod.id),
      alt: paymentMethod.label || '',
      className: classnames_default()('PaymentMethodList-image', Object(defineProperty["a" /* default */])({}, 'PaymentMethodList-image--selected', formik.values.paymentMethodId === paymentMethod.id)),
      src: paymentMethod.image,
      onClick: function onClick() {
        formik.setFieldValue('paymentMethodId', paymentMethod.id);

        if (shouldSubmitFormOnPaymentChosen) {
          // should wait for validation to be done
          setTimeout(formik.submitForm, 0);
        }
      }
    }), timePaymentCondition && timePaymentCondition.chargePercentage > 0 ? PaymentMethodsCardList_jsx("p", {
      className: "text-gray-dark m-0 text-xs text-center"
    }, Object(src_i18n["g" /* t */])('booking.banking.paymentMethod.cardFeesLabel'), PaymentMethodsCardList_jsx("span", {
      className: "text-waterGreen font-bold block"
    }, Object(src_i18n["g" /* t */])('booking.banking.paymentMethod.chargePercentage', {
      charge_percentage: timePaymentCondition.chargePercentage
    }))) : null, PaymentMethodsCardList_jsx("span", {
      className: "sr-only"
    }, paymentMethod.label));
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-method/PaymentMethodsCardListPaymentProvider.jsx

var PaymentMethodsCardListPaymentProvider_jsx = react_default.a.createElement;




var PaymentMethodsCardListPaymentProvider_PaymentMethodsCardListPaymentProvider = function PaymentMethodsCardListPaymentProvider(_ref) {
  var formik = _ref.formik,
      paymentProvider = _ref.paymentProvider,
      requiredRule = _ref.requiredRule,
      shouldSubmitFormOnPaymentChosen = _ref.shouldSubmitFormOnPaymentChosen;
  return PaymentMethodsCardListPaymentProvider_jsx("div", {
    className: "mt-px20 flex flex-col"
  }, PaymentMethodsCardListPaymentProvider_jsx("span", {
    className: "text-base"
  }, Object(src_i18n["g" /* t */])('booking.banking.paymentProvider.creditCard.cardList')), PaymentMethodsCardListPaymentProvider_jsx("div", null, PaymentMethodsCardListPaymentProvider_jsx(FormikInput["a" /* FormikInput */], {
    type: "hidden",
    name: "paymentProviderId",
    validate: requiredRule
  }), PaymentMethodsCardListPaymentProvider_jsx(FormikInput["a" /* FormikInput */], {
    type: "hidden",
    name: "paymentMethodId"
  }), PaymentMethodsCardListPaymentProvider_jsx(FormikInput["a" /* FormikInput */], {
    type: "hidden",
    name: "paymentConditionId"
  }), PaymentMethodsCardListPaymentProvider_jsx("ul", {
    className: classnames_default()('PaymentMethodList', {
      'formik-errored': formik.errors.paymentMethodId
    })
  }, paymentProvider.paymentMethods.map(function (paymentMethod) {
    var timePaymentCondition = paymentMethod.timePaymentConditions.find(function (condition) {
      return condition.id === paymentMethod.id;
    });
    var isPaymentMethodSelected = formik.values.paymentProviderId === paymentProvider.id && formik.values.paymentMethodId === paymentMethod.id;
    return PaymentMethodsCardListPaymentProvider_jsx("li", {
      key: paymentMethod.id,
      className: classnames_default()('PaymentMethodList-item', {
        'PaymentMethodList-item--with-card-fees': timePaymentCondition
      })
    }, PaymentMethodsCardListPaymentProvider_jsx("img", {
      "data-testid": "PaymentMethodsCardList-".concat(paymentMethod.id),
      alt: paymentMethod.label || '',
      className: classnames_default()('PaymentMethodList-image', Object(defineProperty["a" /* default */])({}, 'PaymentMethodList-image--selected', isPaymentMethodSelected)),
      src: paymentMethod.image,
      onClick: function onClick() {
        formik.setFieldValue('paymentProviderId', paymentProvider.id);
        formik.setFieldValue('paymentMethodId', paymentMethod.id);

        if (shouldSubmitFormOnPaymentChosen) {
          // should wait for validation to be done
          setTimeout(formik.submitForm, 0);
        }
      }
    }), timePaymentCondition && timePaymentCondition.chargePercentage > 0 ? PaymentMethodsCardListPaymentProvider_jsx("p", {
      className: "text-gray-dark m-0 text-xs text-center"
    }, Object(src_i18n["g" /* t */])('booking.banking.paymentMethod.cardFeesLabel'), PaymentMethodsCardListPaymentProvider_jsx("span", {
      className: "text-waterGreen font-bold block"
    }, Object(src_i18n["g" /* t */])('booking.banking.paymentMethod.chargePercentage', {
      charge_percentage: timePaymentCondition.chargePercentage
    }))) : null, PaymentMethodsCardListPaymentProvider_jsx("span", {
      className: "sr-only"
    }, paymentMethod.label));
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/PaymentMethods.jsx
var PaymentMethods_jsx = react_default.a.createElement;







var PaymentMethods_requiredRule = lib["string"]().required();
var PaymentMethods_PaymentMethods = function PaymentMethods(_ref) {
  var formik = _ref.formik,
      paymentProvider = _ref.paymentProvider,
      showPaymentMethodWithConditions = _ref.showPaymentMethodWithConditions,
      shouldSubmitFormOnPaymentChosen = _ref.shouldSubmitFormOnPaymentChosen,
      _ref$isPaymentProvide = _ref.isPaymentProvider,
      isPaymentProvider = _ref$isPaymentProvide === void 0 ? false : _ref$isPaymentProvide;
  var CardListComponent = isPaymentProvider ? PaymentMethodsCardListPaymentProvider_PaymentMethodsCardListPaymentProvider : PaymentMethodsCardList_PaymentMethodsCardList;
  Object(react["useEffect"])(function () {
    var accordingPaymentMethod = paymentProvider.paymentMethods.find(function (_ref2) {
      var id = _ref2.id;
      return id === formik.values.paymentMethodId;
    });

    if (formik.values.paymentMethodId && accordingPaymentMethod) {
      formik.setFieldValue('paymentConditionId', // $FlowFixMe always found
      accordingPaymentMethod.timePaymentConditions[0].id);
    }
  }, [formik.values.paymentMethodId]);
  return PaymentMethods_jsx(react["Fragment"], null, showPaymentMethodWithConditions ? PaymentMethods_jsx(PaymentMethodsWithConditions_PaymentMethodsWithConditions, {
    formik: formik,
    paymentProvider: paymentProvider,
    requiredRule: PaymentMethods_requiredRule
  }) : PaymentMethods_jsx(CardListComponent, {
    formik: formik,
    paymentProvider: paymentProvider,
    requiredRule: PaymentMethods_requiredRule,
    shouldSubmitFormOnPaymentChosen: shouldSubmitFormOnPaymentChosen
  }), (formik.errors.paymentMethodId && formik.touched.paymentMethodId || formik.errors.paymentConditionId && formik.touched.paymentConditionId) && PaymentMethods_jsx(FormFeedback["a" /* FormFeedback */], {
    isError: true,
    message: Object(src_i18n["g" /* t */])('booking.banking.paymentMethod.errorMessageSelectCardType')
  }));
};
// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/PaymentPlan.jsx
var PaymentPlan_jsx = react_default.a.createElement;









var PaymentPlan_PaymentPlan = function PaymentPlan(_ref) {
  var paymentSchedule = _ref.paymentSchedule,
      isDisabled = _ref.isDisabled,
      setHasFullAmount = _ref.setHasFullAmount;

  var _useContext = Object(react["useContext"])(ReactAppContext["a" /* default */]),
      isCmta = _useContext.isCmta;

  var rePaymentSchedule = paymentSchedule.repaymentSchedules[0];
  var payDepositRegulationsText = Object(src_i18n["g" /* t */])('booking.banking.paymentSchedule.payDepositRegulations');
  var payFullAmountLabel = Object(src_i18n["g" /* t */])('booking.banking.paymentSchedule.payFullAmount');
  var payFullAmountPartnersLabel = Object(src_i18n["g" /* t */])('booking.partners.banking.paymentSchedule.payFullAmount');
  return PaymentPlan_jsx(react["Fragment"], null, PaymentPlan_jsx(Title["a" /* Title */], {
    className: "mb-px10",
    color: colors["a" /* COLORS */].BLUE,
    theme: "title-sans-4"
  }, Object(src_i18n["g" /* t */])('booking.banking.paymentSchedule.selectPaymentSchedule')), PaymentPlan_jsx(Capsule["a" /* Capsule */], null, PaymentPlan_jsx("div", {
    className: "p-px20"
  }, PaymentPlan_jsx(FormikInput["a" /* FormikInput */], {
    type: "radio",
    name: "amountToPay",
    value: paymentSchedule.total.value,
    label: PaymentPlan_jsx("span", null, isCmta ? payFullAmountPartnersLabel : payFullAmountLabel, " :", ' ', PaymentPlan_jsx("span", {
      className: "text-turquoise font-bold"
    }, paymentSchedule.total.formattedValue)),
    onChange: function onChange() {
      setHasFullAmount(true);
    },
    isDisabled: isDisabled
  }), PaymentPlan_jsx("div", {
    className: "mt-px10"
  }, PaymentPlan_jsx(FormikInput["a" /* FormikInput */], {
    type: "radio",
    name: "amountToPay",
    value: paymentSchedule.depositAmount.value,
    label: PaymentPlan_jsx(TemplateString["a" /* TemplateString */], {
      template: Object(src_i18n["g" /* t */])("booking".concat(isCmta ? '.partners' : '', ".banking.paymentSchedule.depositSelected")),
      values: {
        depositAmount: paymentSchedule.depositAmount.formattedValue,
        balanceAmount: rePaymentSchedule.amount.formattedValue,
        balanceDate: Object(apiDate["e" /* formatApiDate */])(rePaymentSchedule.deadline, Object(src_i18n["g" /* t */])('booking.form.dateFormat'))
      },
      valuesClassName: {
        depositAmount: 'font-bold text-turquoise',
        balanceAmount: 'font-bold text-turquoise',
        balanceDate: 'font-bold'
      }
    }),
    onChange: function onChange() {
      setHasFullAmount(false);
    },
    isDisabled: isDisabled
  }), payDepositRegulationsText ? PaymentPlan_jsx("p", {
    className: "text-sm italic",
    "data-testid": "payDepositRegulationsText"
  }, payDepositRegulationsText) : null))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/PaymentInfo.const.js
var PaymentInfo_const = __webpack_require__("BU6i");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/PaymentMethodsWrapper.jsx
var PaymentMethodsWrapper_jsx = react_default.a.createElement;





var PaymentMethodsWrapper_PaymentMethodsWrapper = function PaymentMethodsWrapper(_ref) {
  var formik = _ref.formik,
      paymentProvider = _ref.paymentProvider,
      showPaymentMethodWithConditions = _ref.showPaymentMethodWithConditions,
      shouldAutoSubmitForm = _ref.shouldAutoSubmitForm;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var isCloselyIntegratedPaymentsProvider = paymentProvider.paymentMethods.length > 0;
  var isNoDelcrederePaymentsProvider = paymentProvider.id === PaymentInfo_const["l" /* NODELCRERE_TRANSFER_PSP_ID */] || paymentProvider.id === PaymentInfo_const["k" /* NODELCRERE_CHEQUE_PSP_ID */];

  if (isCloselyIntegratedPaymentsProvider) {
    return PaymentMethodsWrapper_jsx(PaymentMethods_PaymentMethods, {
      formik: formik,
      paymentProvider: paymentProvider,
      showPaymentMethodWithConditions: showPaymentMethodWithConditions,
      shouldSubmitFormOnPaymentChosen: shouldAutoSubmitForm,
      isPaymentProvider: true
    });
  }

  if (isNoDelcrederePaymentsProvider) {
    return PaymentMethodsWrapper_jsx("div", {
      className: "mb-px10 reset-heading text-blue font-bold font-sans leading-tight"
    }, Object(src_i18n["g" /* t */])('booking.banking.paymentProvider.bankTransfer.finalizePayment'));
  }

  if (appContext.isCmta && !appContext.cmta.isDelCredere) {
    // Card payment for seller wich are not del credere
    return null;
  }

  return PaymentMethodsWrapper_jsx("div", {
    className: "flex justify-end mb-px10 text-sm"
  }, PaymentMethodsWrapper_jsx("span", {
    className: "mr-px10 safeDebitNotice"
  }, Object(src_i18n["g" /* t */])('booking.banking.paymentProvider.Safedebit')), PaymentMethodsWrapper_jsx("img", {
    className: "PaymentProvidersSafeDebitLogo",
    alt: paymentProvider.label,
    src: paymentProvider.logo
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/PaymentProvidersLegacy.jsx
var PaymentProvidersLegacy_jsx = react_default.a.createElement;



var PaymentProvidersLegacy_PaymentProvidersLegacy = function PaymentProvidersLegacy(_ref) {
  var orderedPaymentProviders = _ref.orderedPaymentProviders,
      isDisabled = _ref.isDisabled;
  return PaymentProvidersLegacy_jsx(react["Fragment"], null, orderedPaymentProviders.map(function (paymentProvider, index) {
    var position = index % 2 === 0 ? 'left' : 'right';
    return PaymentProvidersLegacy_jsx("label", {
      key: paymentProvider.id,
      "data-testid": "PaymentProviders-".concat(paymentProvider.id),
      className: classnames_default()('PaymentProviders-provider cursor-pointer', "PaymentProviders-provider--".concat(position))
    }, PaymentProvidersLegacy_jsx("div", {
      className: "PaymentProviders-radioContainer"
    }, PaymentProvidersLegacy_jsx(FormikInput["a" /* FormikInput */], {
      className: "PaymentProviders-radioInput",
      type: "radio",
      name: "paymentProviderId",
      value: paymentProvider.id,
      isDisabled: isDisabled
    })), PaymentProvidersLegacy_jsx("div", {
      className: "PaymentProviders-wording"
    }, PaymentProvidersLegacy_jsx("img", {
      className: "PaymentProviders-mainLogo",
      alt: paymentProvider.label,
      src: paymentProvider.logo
    }), paymentProvider.description));
  }));
};
// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/CreditCardPaymentBlock.jsx
var CreditCardPaymentBlock_jsx = react_default.a.createElement;








var CreditCardPaymentBlock_CreditCardContent = function CreditCardContent(_ref) {
  var hasFullAmount = _ref.hasFullAmount,
      rePaymentSchedule = _ref.rePaymentSchedule,
      paymentSchedule = _ref.paymentSchedule,
      totalAmount = _ref.totalAmount;

  var _useContext = Object(react["useContext"])(ReactAppContext["a" /* default */]),
      isCmta = _useContext.isCmta;

  var creditCardTotalAmount = Object(src_i18n["g" /* t */])("booking".concat(isCmta ? '.partners' : '', ".banking.paymentProvider.creditCard.totalAmount"));
  var creditCardDeposit = Object(src_i18n["g" /* t */])("booking".concat(isCmta ? '.partners' : '', ".banking.paymentProvider.creditCard.deposit"));
  return CreditCardPaymentBlock_jsx(TemplateString["a" /* TemplateString */], {
    template: hasFullAmount || !rePaymentSchedule ? creditCardTotalAmount : creditCardDeposit,
    values: !hasFullAmount && rePaymentSchedule ? {
      depositAmount: paymentSchedule.depositAmount.formattedValue,
      balanceAmount: rePaymentSchedule.amount.formattedValue,
      balanceDate: Object(apiDate["e" /* formatApiDate */])(rePaymentSchedule.deadline, Object(src_i18n["g" /* t */])('booking.form.dateFormat'))
    } : {
      totalAmount: totalAmount
    },
    valuesClassName: {
      depositAmount: 'font-bold text-turquoise',
      balanceAmount: 'font-bold text-turquoise',
      totalAmount: 'font-bold text-turquoise',
      balanceDate: 'font-bold'
    }
  });
};

var CreditCardPaymentBlock_FormatedCardsAccepted = function FormatedCardsAccepted() {
  var cardsAccepted = Object(src_i18n["g" /* t */])('booking.banking.paymentProvider.creditCard.cardsAccepted');
  var cardsAcceptedParts = cardsAccepted === null || cardsAccepted === void 0 ? void 0 : cardsAccepted.split(':');

  if (cardsAcceptedParts.length === 2) {
    return CreditCardPaymentBlock_jsx(react["Fragment"], null, CreditCardPaymentBlock_jsx("span", {
      className: "font-bold"
    }, cardsAcceptedParts[0]), ": ", cardsAcceptedParts[1]);
  }

  return CreditCardPaymentBlock_jsx(react["Fragment"], null, cardsAccepted);
};

var CreditCardPaymentBlock_CreditCardPaymentBlock = function CreditCardPaymentBlock(_ref2) {
  var hasFullAmount = _ref2.hasFullAmount,
      isDisabled = _ref2.isDisabled,
      paymentSchedule = _ref2.paymentSchedule,
      rePaymentSchedule = _ref2.rePaymentSchedule,
      totalAmount = _ref2.totalAmount,
      hasNoPaymentMethods = _ref2.hasNoPaymentMethods;

  var renderCreditCardContent = function renderCreditCardContent() {
    return CreditCardPaymentBlock_jsx(CreditCardPaymentBlock_CreditCardContent, {
      hasFullAmount: hasFullAmount,
      rePaymentSchedule: rePaymentSchedule,
      paymentSchedule: paymentSchedule,
      totalAmount: totalAmount
    });
  };

  return CreditCardPaymentBlock_jsx(react["Fragment"], null, hasNoPaymentMethods ? CreditCardPaymentBlock_jsx("div", {
    className: "text-base mt-px5 max-w-full sm:max-w-4/5"
  }, CreditCardPaymentBlock_jsx(FormikInput["a" /* FormikInput */], {
    type: "radio",
    name: "paymentProviderId",
    isDisabled: isDisabled,
    value: PaymentInfo_const["j" /* HIPAY_PSP_ID */],
    label: CreditCardPaymentBlock_jsx("div", {
      className: "max-w-full"
    }, renderCreditCardContent(), CreditCardPaymentBlock_jsx("span", {
      className: "block"
    }, CreditCardPaymentBlock_jsx(CreditCardPaymentBlock_FormatedCardsAccepted, null)))
  })) : CreditCardPaymentBlock_jsx("div", {
    className: "text-base ml-px20 mt-px5"
  }, renderCreditCardContent()));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/DebitOrTransfertPaymentBlock.jsx
var DebitOrTransfertPaymentBlock_jsx = react_default.a.createElement;







var DebitOrTransfertPaymentBlock_DebitOrTransfertPaymentBlock = function DebitOrTransfertPaymentBlock(_ref) {
  var hasFullAmount = _ref.hasFullAmount,
      isDisabled = _ref.isDisabled,
      paymentProvider = _ref.paymentProvider,
      paymentSchedule = _ref.paymentSchedule,
      rePaymentSchedule = _ref.rePaymentSchedule,
      totalAmount = _ref.totalAmount;

  var _useContext = Object(react["useContext"])(ReactAppContext["a" /* default */]),
      isCmta = _useContext.isCmta;

  return DebitOrTransfertPaymentBlock_jsx("div", {
    className: "my-px10"
  }, DebitOrTransfertPaymentBlock_jsx(FormikInput["a" /* FormikInput */], {
    type: "radio",
    name: "paymentProviderId",
    isDisabled: isDisabled,
    value: paymentProvider.id,
    label: DebitOrTransfertPaymentBlock_jsx(TemplateString["a" /* TemplateString */], {
      template: Object(paymentProvidersUtils["e" /* getPaymentProviderLabel */])(paymentProvider, hasFullAmount, rePaymentSchedule, isCmta),
      values: !hasFullAmount && rePaymentSchedule ? {
        depositAmount: paymentSchedule.depositAmount.formattedValue,
        balanceAmount: rePaymentSchedule.amount.formattedValue,
        balanceDate: Object(apiDate["e" /* formatApiDate */])(rePaymentSchedule.deadline, Object(src_i18n["g" /* t */])('booking.form.dateFormat'))
      } : {
        totalAmount: totalAmount
      },
      valuesClassName: {
        depositAmount: 'font-bold text-turquoise',
        balanceAmount: 'font-bold text-turquoise',
        totalAmount: 'font-bold text-turquoise',
        balanceDate: 'font-bold'
      }
    })
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/PaymentProvidersWithDebitOrTransfert.jsx
var PaymentProvidersWithDebitOrTransfert_jsx = react_default.a.createElement;













var PaymentProvidersWithDebitOrTransfert_PaymentProviderTitle = function PaymentProviderTitle(_ref) {
  var paymentProvider = _ref.paymentProvider;
  return PaymentProvidersWithDebitOrTransfert_jsx("label", {
    key: paymentProvider.id,
    "data-testid": "PaymentProviders-".concat(paymentProvider.id),
    className: classnames_default()("PaymentProviders-provider--".concat(paymentProvider.id), 'text-lg', 'font-bold', 'text-gray-darker', 'pb-px10')
  }, paymentProvider.description);
};

var PaymentProvidersWithDebitOrTransfert_BankTransferChecks = function BankTransferChecks(_ref2) {
  var isNotDelCredereCmta = _ref2.isNotDelCredereCmta,
      isFramed = _ref2.isFramed;
  return PaymentProvidersWithDebitOrTransfert_jsx("div", {
    style: {
      width: 'fit-content'
    },
    className: classnames_default()('ml-px15', {
      'border-1 p-px5 border-emerald': isFramed
    })
  }, PaymentProvidersWithDebitOrTransfert_jsx("div", null, PaymentProvidersWithDebitOrTransfert_jsx(Icon["a" /* Icon */], {
    className: "text-emerald",
    name: icons["a" /* ICONS */].CHECK,
    width: "1rem"
  }), PaymentProvidersWithDebitOrTransfert_jsx("span", {
    className: "ml-px10 text-sm"
  }, isNotDelCredereCmta ? Object(src_i18n["g" /* t */])('booking.partners.banking.paymentProvider.firstInformation') : Object(src_i18n["g" /* t */])('booking.banking.paymentProvider.bankTransfer.security'))), PaymentProvidersWithDebitOrTransfert_jsx("div", null, PaymentProvidersWithDebitOrTransfert_jsx(Icon["a" /* Icon */], {
    className: "text-emerald",
    name: icons["a" /* ICONS */].CHECK,
    width: "1rem"
  }), PaymentProvidersWithDebitOrTransfert_jsx("span", {
    className: "ml-px10 text-sm"
  }, isNotDelCredereCmta ? Object(src_i18n["g" /* t */])('booking.partners.banking.paymentProvider.secondInformation') : Object(src_i18n["g" /* t */])('booking.banking.paymentProvider.bankTransfer.paymentCap'))));
};

var PaymentProvidersWithDebitOrTransfert_PaymentProvidersWithDebitOrTransfert = function PaymentProvidersWithDebitOrTransfert(_ref3) {
  var formik = _ref3.formik,
      hasFullAmount = _ref3.hasFullAmount,
      isDisabled = _ref3.isDisabled,
      orderedPaymentProviders = _ref3.orderedPaymentProviders,
      paymentSchedule = _ref3.paymentSchedule,
      rePaymentSchedule = _ref3.rePaymentSchedule,
      shouldAutoSubmitForm = _ref3.shouldAutoSubmitForm,
      showPaymentMethodWithConditions = _ref3.showPaymentMethodWithConditions,
      totalAmount = _ref3.totalAmount;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var isNotDelCredereCmta = appContext.isCmta && !appContext.cmta.isDelCredere;

  var handlePaymentBlockClick = function handlePaymentBlockClick(paymentProvider) {
    if (!isDisabled) {
      formik.setFieldValue('paymentProviderId', paymentProvider.id);
      formik.setFieldValue('paymentMethodId', '');
      setTimeout(function () {
        Object(scrollToElement["a" /* scrollToElement */])('#termsAndConditionsTitleId');
      }, 500);
    }
  };

  var isBankTransferChecksFramed = orderedPaymentProviders[0].id === PaymentInfo_const["j" /* HIPAY_PSP_ID */] && orderedPaymentProviders[0].paymentMethods.length === 0;
  return PaymentProvidersWithDebitOrTransfert_jsx(react["Fragment"], null, orderedPaymentProviders.map(function (paymentProvider, index) {
    var hasNoPaymentMethods = paymentProvider.paymentMethods.length === 0;
    var borderBottom = index + 1 < orderedPaymentProviders.length && 'border-b-1';
    var cursorPointer = hasNoPaymentMethods && 'cursor-pointer';
    var isHipayPaymentProvider = paymentProvider.id === PaymentInfo_const["j" /* HIPAY_PSP_ID */];
    return PaymentProvidersWithDebitOrTransfert_jsx("div", {
      onClick: function onClick() {
        return hasNoPaymentMethods && handlePaymentBlockClick(paymentProvider);
      },
      className: classnames_default()('relative m-0', borderBottom, cursorPointer),
      key: paymentProvider.id
    }, hasNoPaymentMethods && isHipayPaymentProvider && PaymentProvidersWithDebitOrTransfert_jsx(Icon["a" /* Icon */], {
      className: "text-gray-light absolute right-0 mr-px20 hidden sm:block",
      name: icons["a" /* ICONS */].CREDIT_CARD,
      width: "7rem"
    }), PaymentProvidersWithDebitOrTransfert_jsx("div", {
      className: "p-px20"
    }, PaymentProvidersWithDebitOrTransfert_jsx(PaymentProvidersWithDebitOrTransfert_PaymentProviderTitle, {
      paymentProvider: paymentProvider
    }), isHipayPaymentProvider && PaymentProvidersWithDebitOrTransfert_jsx(CreditCardPaymentBlock_CreditCardPaymentBlock, {
      isDisabled: isDisabled,
      hasFullAmount: hasFullAmount,
      hasNoPaymentMethods: hasNoPaymentMethods,
      rePaymentSchedule: rePaymentSchedule,
      paymentSchedule: paymentSchedule,
      totalAmount: totalAmount
    }), Object(paymentProvidersUtils["f" /* isTransfer */])(paymentProvider) && PaymentProvidersWithDebitOrTransfert_jsx(PaymentProvidersWithDebitOrTransfert_BankTransferChecks, {
      isNotDelCredereCmta: isNotDelCredereCmta,
      isFramed: isBankTransferChecksFramed
    }), !isHipayPaymentProvider && PaymentProvidersWithDebitOrTransfert_jsx(DebitOrTransfertPaymentBlock_DebitOrTransfertPaymentBlock, {
      isDisabled: isDisabled,
      paymentProvider: paymentProvider,
      hasFullAmount: hasFullAmount,
      rePaymentSchedule: rePaymentSchedule,
      paymentSchedule: paymentSchedule,
      totalAmount: totalAmount
    }), !hasNoPaymentMethods && PaymentProvidersWithDebitOrTransfert_jsx(PaymentMethodsWrapper_PaymentMethodsWrapper, {
      formik: formik,
      paymentProvider: paymentProvider,
      showPaymentMethodWithConditions: showPaymentMethodWithConditions,
      shouldAutoSubmitForm: shouldAutoSubmitForm
    })));
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-form/PaymentProviders.jsx
var PaymentProviders_jsx = react_default.a.createElement;













var PaymentProviders_PaymentProviders = function PaymentProviders(_ref) {
  var _orderedPaymentProvid;

  var formik = _ref.formik,
      hasDebitTransfertOrChequeProvider = _ref.hasDebitTransfertOrChequeProvider,
      hasFullAmount = _ref.hasFullAmount,
      isDisabled = _ref.isDisabled,
      isFreeDeposit = _ref.isFreeDeposit,
      paymentProviders = _ref.paymentProviders,
      paymentSchedule = _ref.paymentSchedule,
      shouldAutoSubmitForm = _ref.shouldAutoSubmitForm,
      showPaymentMethodWithConditions = _ref.showPaymentMethodWithConditions;

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isTablet = _useContext.isTablet;

  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var isNotDelCredereCmta = appContext.isCmta && !appContext.cmta.isDelCredere;
  var freeDeposit = formik.values.freeDeposit;
  var formatedFreeDeposit = Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(freeDeposit, appContext.locale, undefined, {
    precision: 2
  });
  var totalAmount = '';

  if (isFreeDeposit) {
    totalAmount = freeDeposit ? formatedFreeDeposit : '';
  } else {
    totalAmount = paymentSchedule.total.formattedValue;
  }

  var rePaymentSchedule = paymentSchedule.repaymentSchedules[0];
  var orderedPaymentProviders = Object(paymentProvidersUtils["d" /* getOrderedPaymentProviders */])(paymentProviders, isTablet);
  var isGlobalCollectProvider = (orderedPaymentProviders === null || orderedPaymentProviders === void 0 ? void 0 : (_orderedPaymentProvid = orderedPaymentProviders[0]) === null || _orderedPaymentProvid === void 0 ? void 0 : _orderedPaymentProvid.id) === PaymentInfo_const["f" /* EGLOBALCOLLECT_PSP_ID */];
  var isCmtaGlobalCollectPayment = isGlobalCollectProvider && showPaymentMethodWithConditions && isNotDelCredereCmta;
  var blockTitle = Object(src_i18n["g" /* t */])("booking".concat(appContext.isCmta ? '.partners' : '', ".banking.paymentProvider.blockTitle"));

  if (isCmtaGlobalCollectPayment) {
    return PaymentProviders_jsx(PaymentMethodsWrapper_PaymentMethodsWrapper, {
      formik: formik,
      paymentProvider: orderedPaymentProviders[0],
      showPaymentMethodWithConditions: showPaymentMethodWithConditions,
      shouldAutoSubmitForm: shouldAutoSubmitForm
    });
  }

  return !hasDebitTransfertOrChequeProvider ? PaymentProviders_jsx("div", {
    className: "PaymentProviders"
  }, PaymentProviders_jsx("div", {
    className: "PaymentProviders-container PaymentProviders-container--scrollAnchor"
  }, PaymentProviders_jsx(Title["a" /* Title */], {
    className: "mb-px10",
    color: colors["a" /* COLORS */].BLUE,
    theme: "title-sans-4"
  }, blockTitle), PaymentProviders_jsx(Capsule["a" /* Capsule */], null, PaymentProviders_jsx("div", {
    className: "PaymentProviders-providers"
  }, PaymentProviders_jsx(PaymentProvidersLegacy_PaymentProvidersLegacy, {
    orderedPaymentProviders: orderedPaymentProviders,
    isDisabled: isDisabled
  }))))) : PaymentProviders_jsx("div", {
    className: "PaymentProviders"
  }, PaymentProviders_jsx("div", {
    className: "PaymentProviders-container PaymentProviders-container--scrollAnchor"
  }, PaymentProviders_jsx(Title["a" /* Title */], {
    className: "mb-px10",
    color: colors["a" /* COLORS */].BLUE,
    theme: "title-sans-4"
  }, blockTitle), PaymentProviders_jsx(Capsule["a" /* Capsule */], null, PaymentProviders_jsx("div", {
    className: "PaymentProviders-WithDebitOrTransfertProvider"
  }, PaymentProviders_jsx(PaymentProvidersWithDebitOrTransfert_PaymentProvidersWithDebitOrTransfert, {
    orderedPaymentProviders: orderedPaymentProviders,
    hasFullAmount: hasFullAmount,
    rePaymentSchedule: rePaymentSchedule,
    formik: formik,
    showPaymentMethodWithConditions: showPaymentMethodWithConditions,
    shouldAutoSubmitForm: shouldAutoSubmitForm,
    paymentSchedule: paymentSchedule,
    totalAmount: totalAmount,
    isDisabled: isDisabled
  })))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/payment-form/TermsAndConditions.jsx
var TermsAndConditions = __webpack_require__("LhnV");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/PaymentInfoContext.js
var PaymentInfoContext = __webpack_require__("lr0Z");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/PaymentForm.jsx
var PaymentForm_jsx = react_default.a.createElement;




















var debitTransfertOrChequeProviders = [PaymentInfo_const["h" /* ESSPSDD_PSP_ID */], PaymentInfo_const["g" /* ESSPSCT_PSP_ID */], PaymentInfo_const["l" /* NODELCRERE_TRANSFER_PSP_ID */], PaymentInfo_const["k" /* NODELCRERE_CHEQUE_PSP_ID */]];

var PaymentForm_PaymentProviderForm = function PaymentProviderForm(_ref) {
  var formik = _ref.formik,
      hasNoPaymentMethods = _ref.hasNoPaymentMethods,
      selectedPaymentProvider = _ref.selectedPaymentProvider;
  var paymentProduct = formik.values.paymentProduct;
  Object(react["useEffect"])(function () {
    if (hasNoPaymentMethods && paymentProduct) {
      js_cookie_default.a.set(PaymentInfo_const["n" /* PAYMENT_METHOD_LABEL */], Object(lodash["capitalize"])(paymentProduct));
    }
  }, [hasNoPaymentMethods, paymentProduct]);
  return PaymentForm_jsx(Grid_row["a" /* GridRow */], {
    className: "mt-px20",
    hasTopGutters: false,
    hasLeftGutters: false,
    id: "payment-form-iframe"
  }, selectedPaymentProvider.id === PaymentInfo_const["j" /* HIPAY_PSP_ID */] && PaymentForm_jsx(HipayForm_HipayForm, {
    formik: formik
  }), selectedPaymentProvider.id === PaymentInfo_const["d" /* CYBERSOURCE_PSP_ID */] && // $FlowFixMe: CyberSource provider always has a token
  PaymentForm_jsx(CybersourceForm_CyberSourceForm, {
    formik: formik,
    token: selectedPaymentProvider.token
  }));
};

var PaymentForm_PaymentForm = function PaymentForm(_ref2) {
  var _paymentProviders$;

  var i18n = _ref2.i18n,
      formik = _ref2.formik,
      paymentSchedule = _ref2.paymentSchedule,
      paymentProviders = _ref2.paymentProviders,
      shouldDisableFields = _ref2.shouldDisableFields,
      price = _ref2.price,
      startDate = _ref2.startDate;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useContext = Object(react["useContext"])(PaymentInfoContext["a" /* PaymentInfoContext */]),
      currency = _useContext.currency,
      donationAmount = _useContext.donationAmount,
      isFreeDeposit = _useContext.isFreeDeposit;

  var isNotDelCredereCmta = appContext.isCmta && !appContext.cmta.isDelCredere;

  var _useState = Object(react["useState"])(formik.values.amoutToPay === paymentSchedule.total.value),
      hasFullAmount = _useState[0],
      setHasFullAmount = _useState[1];

  Object(ScrollToErrorHook["a" /* useAutoScrollToError */])(formik);
  Object(react["useEffect"])(function () {
    // validate form on mount to make initial validation
    formik.validateForm();
  }, []); // $FlowFixMe always found

  var selectedPaymentProvider = paymentProviders.find(function (_ref3) {
    var id = _ref3.id;
    return id === formik.values.paymentProviderId;
  });
  var selectedPaymentMethod = selectedPaymentProvider.paymentMethods.find(function (_ref4) {
    var id = _ref4.id;
    return id === formik.values.paymentMethodId;
  });
  var showPaymentMethodWithConditions = selectedPaymentProvider.paymentMethods.some(function (_ref5) {
    var timePaymentConditions = _ref5.timePaymentConditions;
    return timePaymentConditions.length > 1;
  });
  var hasDebitTransfertOrChequeProvider = paymentProviders.some(function (_ref6) {
    var id = _ref6.id;
    return debitTransfertOrChequeProviders.includes(id);
  });
  var hasNoPaymentMethods = selectedPaymentProvider.paymentMethods.length === 0;
  var hasAnyProviderWithPaymentMethods = paymentProviders.some(function (paymentProvider) {
    return paymentProvider.paymentMethods.length !== 0;
  });
  var isHostedField = !!config_default.a.get("psp.".concat(formik.values.paymentProviderId.toLowerCase(), ".hosted_fields"));
  var shouldShowPaymentProviderOfSpecificCard = isHostedField && Object(lodash["isEmpty"])(formik.errors.termsAndConditions) && formik.values.paymentMethodId && formik.values.paymentConditionId && selectedPaymentMethod && selectedPaymentMethod.category === PaymentInfo_const["m" /* PAYMENT_METHOD_CREDIT_CARD_CATEGORY */];
  var shouldShowPaymentProviderWithNoPaymentMethods = !!config_default.a.get("psp.".concat(formik.values.paymentProviderId.toLowerCase(), ".hosted_fields")) && Object(lodash["isEmpty"])(formik.errors.termsAndConditions);
  var shouldShowPaymentProviderForm = hasNoPaymentMethods ? shouldShowPaymentProviderWithNoPaymentMethods : shouldShowPaymentProviderOfSpecificCard;
  var isGlobalCollectProvider = (paymentProviders === null || paymentProviders === void 0 ? void 0 : (_paymentProviders$ = paymentProviders[0]) === null || _paymentProviders$ === void 0 ? void 0 : _paymentProviders$.id) === PaymentInfo_const["f" /* EGLOBALCOLLECT_PSP_ID */];
  var isIframe = Object(payment_utils["d" /* isIframePayment */])(formik.values.paymentProviderId);
  var shouldAutoSubmitForm = (isIframe || isHostedField) && !showPaymentMethodWithConditions && !hasNoPaymentMethods && !isGlobalCollectProvider;
  var shouldDisplayCGUOnTop = appContext.isCmta && hasAnyProviderWithPaymentMethods;

  var renderTermsAndConditions = function renderTermsAndConditions() {
    return PaymentForm_jsx("div", {
      className: "mt-px20"
    }, PaymentForm_jsx(TermsAndConditions["a" /* TermsAndConditions */], {
      i18n: i18n,
      shouldDisplayDonationTerms: !!(donationAmount && donationAmount > 0),
      isDisabled: shouldDisableFields,
      shouldSubmitFormOnAccept: shouldAutoSubmitForm,
      hasNoPaymentMethods: hasNoPaymentMethods
    }));
  };

  return PaymentForm_jsx(formik_esm["c" /* Form */], null, isFreeDeposit && PaymentForm_jsx("div", {
    className: "mb-px20"
  }, PaymentForm_jsx(FreeDeposit_FreeDeposit, {
    startDate: startDate,
    price: price,
    touched: formik.touched.freeDeposit
  })), paymentSchedule.repaymentSchedules.length > 0 && PaymentForm_jsx(PaymentPlan_PaymentPlan, {
    setHasFullAmount: setHasFullAmount,
    paymentSchedule: paymentSchedule,
    isDisabled: shouldDisableFields
  }), shouldDisplayCGUOnTop && renderTermsAndConditions(), paymentProviders.length > 1 && PaymentForm_jsx("div", {
    className: "mt-px20"
  }, PaymentForm_jsx(PaymentProviders_PaymentProviders, {
    formik: formik,
    hasFullAmount: hasFullAmount,
    isDisabled: shouldDisableFields,
    paymentProviders: paymentProviders,
    paymentSchedule: paymentSchedule,
    showPaymentMethodWithConditions: showPaymentMethodWithConditions,
    shouldAutoSubmitForm: shouldAutoSubmitForm,
    hasDebitTransfertOrChequeProvider: hasDebitTransfertOrChequeProvider,
    isFreeDeposit: isFreeDeposit
  })), !isNotDelCredereCmta && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayDonation') && donationAmount !== undefined && PaymentForm_jsx("div", {
    className: "mt-px20"
  }, PaymentForm_jsx(Donation_Donation, {
    i18n: i18n,
    currency: currency,
    isDisabled: shouldDisableFields,
    formik: formik
  })), !shouldDisplayCGUOnTop && renderTermsAndConditions(), selectedPaymentProvider.paymentMethods.length > 0 && !hasDebitTransfertOrChequeProvider && PaymentForm_jsx(PaymentMethods_PaymentMethods, {
    formik: formik,
    paymentProvider: selectedPaymentProvider,
    showPaymentMethodWithConditions: showPaymentMethodWithConditions,
    shouldSubmitFormOnPaymentChosen: shouldAutoSubmitForm
  }), shouldShowPaymentProviderForm && PaymentForm_jsx(PaymentForm_PaymentProviderForm, {
    formik: formik,
    hasNoPaymentMethods: hasNoPaymentMethods,
    selectedPaymentProvider: selectedPaymentProvider
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./logger/index.js
var logger = __webpack_require__("m0zD");
var logger_default = /*#__PURE__*/__webpack_require__.n(logger);

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// EXTERNAL MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.jsx + 1 modules
var AsyncLoader = __webpack_require__("4A3Y");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/ContactInfoUtils.js + 1 modules
var ContactInfoUtils = __webpack_require__("ZHrn");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/dynamic.js
var dynamic = __webpack_require__("hNT8");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);

// EXTERNAL MODULE: ./logger/logger.js
var logger_logger = __webpack_require__("zytj");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-process/WechatTimer.jsx
var WechatTimer_jsx = react_default.a.createElement;



var WechatTimer_WeChatTimer = function WeChatTimer(_ref) {
  var timeout = _ref.timeout;

  var _useState = Object(react["useState"])(timeout),
      timer = _useState[0],
      setTimer = _useState[1];

  var timerInterval = Object(react["useRef"])();
  Object(react["useEffect"])(function () {
    timerInterval.current = setInterval(function () {
      setTimer(function (prevTimer) {
        if (prevTimer === 1) {
          // $FlowFixMe
          clearInterval(timerInterval.current);
        }

        return prevTimer - 1;
      });
    }, 1000);
    return function () {
      clearInterval(timerInterval.current);
    };
  }, []);
  var timerInMinutes = timer / 60;
  var minutes = Math.floor(timerInMinutes % 60);
  var seconds = Math.floor(timer % 60);
  var secondsIn2digits = seconds < 10 ? "0".concat(seconds) : seconds;
  return WechatTimer_jsx("div", {
    className: "timer-bloc text-blue"
  }, WechatTimer_jsx(Icon["a" /* Icon */], {
    className: "scan-icon",
    name: icons["a" /* ICONS */].DURATION,
    width: "1rem"
  }), WechatTimer_jsx("div", {
    className: "scan-text"
  }, minutes, ":", secondsIn2digits));
};
// EXTERNAL MODULE: ./src/utils/polling/polling.js
var polling = __webpack_require__("ICjN");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/utils/payment/constants.js
var constants = __webpack_require__("hi3+");

// EXTERNAL MODULE: ./src/routes/routeBuilder.js
var routeBuilder = __webpack_require__("U2CP");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-process/WeChatQRCode.utils.js


function WeChatQRCode_utils_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function WeChatQRCode_utils_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      WeChatQRCode_utils_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      WeChatQRCode_utils_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}






var BE_LEGACY_KEY = dist["appQueryParameters"].legacy.be,
    WeChatQRCode_utils_LOCALE_KEY = dist["appQueryParameters"].locale;
var WeChatQRCode_utils_handlePspResponse = function handlePspResponse(_ref) {
  var response = _ref.response,
      location = _ref.location,
      customerId = _ref.customerId,
      orderId = _ref.orderId,
      bookingStatus = _ref.bookingStatus;
  var paymentResult = Object(lodash["get"])(response, 'paymentStatus.finalPaymentResponse.payment.paymentStatus');
  var bookingId = Object(lodash["get"])(response, 'paymentStatus.finalPaymentResponse.booking.bookingId');
  var queryParams = location.queryParams;
  var paymentStatus = paymentResult === constants["e" /* API_PAYMENT_STATUS_SUCCESS */] ? constants["q" /* PAYMENT_STATUS_SUCCESS */] : constants["l" /* PAYMENT_STATUS_FAILURE */];
  var confirmationUrl;

  if (bookingStatus) {
    confirmationUrl = new URI_default.a("/account/bookings/".concat(bookingId, "/payment-confirmation")).query(Object(defineProperty["a" /* default */])({
      paymentStatus: paymentStatus,
      bookingStatusBeforePayment: bookingStatus,
      currency: Object(lodash["get"])(response, 'paymentStatus.finalPaymentResponse.payment.currency'),
      amount: Object(lodash["get"])(response, 'paymentStatus.finalPaymentResponse.payment.paymentAmount'),
      provider: Object(lodash["get"])(response, 'paymentStatus.finalPaymentResponse.payment.providerId'),
      t: orderId
    }, WeChatQRCode_utils_LOCALE_KEY, queryParams.locale)).toString();
  } else {
    var params = WeChatQRCode_utils_objectSpread(WeChatQRCode_utils_objectSpread(WeChatQRCode_utils_objectSpread({}, bookingId ? {
      bi: bookingId
    } : null), {}, {
      paymentStatus: paymentStatus
    }, customerId ? {
      ui: customerId
    } : null), {}, Object(defineProperty["a" /* default */])({
      selectedProposalId: queryParams.selectedProposalId
    }, WeChatQRCode_utils_LOCALE_KEY, queryParams.locale), queryParams.hasOwnProperty(BE_LEGACY_KEY) ? Object(defineProperty["a" /* default */])({}, BE_LEGACY_KEY, null) : null);

    confirmationUrl = routeBuilder["a" /* buildUrl */]('confirmation', {}, params);
  }

  window.location.replace(confirmationUrl);
};
// EXTERNAL MODULE: ./src/client/router/useRouter.js
var useRouter = __webpack_require__("7jla");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-process/WechatQRCode.jsx
var WechatQRCode_jsx = react_default.a.createElement;




















var QRCode = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 127).then(__webpack_require__.t.bind(null, "8Zi/", 7));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("8Zi/")];
    },
    modules: ['qrcode.react']
  }
});
var POLLING_CONFIG = config_default.a.get('psp.ewechat.polling');
var WechatQRCode_WeChatQRCode = function WeChatQRCode(_ref) {
  var currency = _ref.currency,
      qrCodeUrl = _ref.qrCodeUrl,
      amountToPay = _ref.amountToPay,
      orderId = _ref.orderId,
      customerId = _ref.customerId,
      timeoutCallback = _ref.timeoutCallback;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var timeoutInSeconds = POLLING_CONFIG.timeout / 1000;

  var _useContext = Object(react["useContext"])(PaymentInfoContext["a" /* PaymentInfoContext */]),
      bookingStatus = _useContext.bookingStatus;

  Object(react["useEffect"])(function () {
    var paymentStatusMutation = "\n      mutation {\n        paymentStatus(paymentId : \"".concat(orderId, "\") {\n          finalPaymentResponse {\n            payment {\n              paymentStatus\n              providerId\n              paymentAmount\n              currency\n            }\n            booking {\n              bookingId\n            }\n          }\n          errors\n        }\n      }\n    ");
    Object(polling["a" /* asyncPolling */])({
      delay: POLLING_CONFIG.frequency,
      // 10 seconds
      timeout: POLLING_CONFIG.timeout,
      // 5 minutes
      pollingFunction: function pollingFunction() {
        return graphqlClient["a" /* default */].runNoCacheQuery(paymentStatusMutation, appContext, {
          requestName: requestDictionary["fd" /* PAYMENT_STATUS_MUTATION */]
        });
      },
      shouldPollAgain: function shouldPollAgain(response) {
        var paymentStatus = Object(lodash["get"])(response, 'paymentStatus.finalPaymentResponse.payment.paymentStatus');
        return paymentStatus === constants["b" /* API_PAYMENT_STATUS_PENDING */];
      },
      onResponse: function onResponse(response) {
        return WeChatQRCode_utils_handlePspResponse({
          response: response,
          customerId: customerId,
          location: location,
          orderId: orderId,
          bookingStatus: bookingStatus
        });
      }
    }).catch(function (e) {
      logger_logger["default"].error(e);
      timeoutCallback();
    });
  }, [orderId, customerId]);
  return WechatQRCode_jsx("div", {
    className: "WechatTutorial"
  }, WechatQRCode_jsx(Title["a" /* Title */], {
    className: "mb-px10",
    theme: "title-sans-2"
  }, Object(src_i18n["g" /* t */])('common.payment.wechat.qrCode.title')), WechatQRCode_jsx(Capsule["a" /* Capsule */], null, WechatQRCode_jsx("div", {
    className: "payment-bloc"
  }, WechatQRCode_jsx("div", {
    className: "payment-cta"
  }, Object(src_i18n["g" /* t */])('common.payment.wechat.qrCode.pay')), WechatQRCode_jsx("div", {
    className: "payment-separator"
  }, ":"), WechatQRCode_jsx("div", {
    className: "payment-amount text-blue"
  }, Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(Math.abs(amountToPay), appContext.locale, currency))), WechatQRCode_jsx(WechatTimer_WeChatTimer, {
    timeout: timeoutInSeconds
  }), WechatQRCode_jsx(QRCode, {
    value: qrCodeUrl,
    size: 239,
    className: "WechatQRCode"
  }), WechatQRCode_jsx("div", {
    className: "scan-bloc"
  }, WechatQRCode_jsx(Icon["a" /* Icon */], {
    className: "scan-icon",
    name: icons["a" /* ICONS */].WECHATPAYMENT,
    width: "1.5rem"
  }), WechatQRCode_jsx("div", {
    className: "scan-text"
  }, Object(src_i18n["g" /* t */])('common.payment.wechat.qrCode.scan')))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-process/WeChatPayment.jsx
var WeChatPayment_jsx = react_default.a.createElement;



var WeChatPayment_WeChatPayment = function WeChatPayment(_ref) {
  var currency = _ref.currency,
      qrCodeUrl = _ref.qrCodeUrl,
      amountToPay = _ref.amountToPay,
      orderId = _ref.orderId,
      customerId = _ref.customerId,
      _timeoutCallback = _ref.timeoutCallback;

  var _useState = Object(react["useState"])(false),
      hasTransactionExpired = _useState[0],
      setHasTransactionExpired = _useState[1];

  if (hasTransactionExpired) {
    return WeChatPayment_jsx(WeChatTutorial_WeChatTutorial, {
      hasTransactionExpired: hasTransactionExpired
    });
  }

  return WeChatPayment_jsx(WechatQRCode_WeChatQRCode, {
    timeoutCallback: function timeoutCallback() {
      _timeoutCallback();

      setHasTransactionExpired(true);
    },
    currency: currency,
    qrCodeUrl: qrCodeUrl,
    orderId: orderId,
    customerId: customerId,
    amountToPay: amountToPay
  });
};
// EXTERNAL MODULE: ./src/client/store/global-loader/globalLoader.action.js
var globalLoader_action = __webpack_require__("R2jv");

// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/utils/status-code/statusCode.constants.js
var statusCode_constants = __webpack_require__("PSHn");

// EXTERNAL MODULE: ./src/utils/ple-utils/index.js + 1 modules
var ple_utils = __webpack_require__("6jSF");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-dom/index.js
var react_dom = __webpack_require__("7nmT");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/PaymentInfo.utils.js
var PaymentInfo_utils = __webpack_require__("gX9k");

// EXTERNAL MODULE: ./src/utils/ple-utils/mapper.js
var mapper = __webpack_require__("aMgh");

// EXTERNAL MODULE: ./src/client/views/iframe-callback/IframeCallbackView.jsx
var IframeCallbackView = __webpack_require__("K7hX");

// EXTERNAL MODULE: ./src/client/views/booking/constants.js
var booking_constants = __webpack_require__("taV1");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-process/IframePayment.jsx


var IframePayment_jsx = react_default.a.createElement;

function IframePayment_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function IframePayment_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { IframePayment_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { IframePayment_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
























var IframePayment_IframePayment = function IframePayment(_ref) {
  var children = _ref.children,
      paymentProviderId = _ref.paymentProviderId;
  var dispatch = Object(es["d" /* useDispatch */])();

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isTablet = _useContext.isTablet;

  var _useState = Object(react["useState"])(false),
      isMounted = _useState[0],
      setIsMounted = _useState[1];

  var iframe = Object(react["useRef"])();

  var makePaymentStatusMutation = function makePaymentStatusMutation(paymentId) {
    return "\n  mutation {\n    paymentStatus(paymentId : \"".concat(paymentId, "\") {\n      finalPaymentResponse {\n        payment {\n          paymentStatus\n          providerId\n          paymentAmount\n          currency\n        }\n        booking {\n          bookingId\n        }\n      }\n      errors\n    }\n  }\n");
  };

  var LOCALE_KEY = dist["appQueryParameters"].locale;

  function buildRedirectionPLE(currency, paymentAmountValue, bookingId, providerId, paymentId, bookingStatus, paymentStatus, locale) {
    var redirectUrl = new URI_default.a("/account/bookings/".concat(bookingId || js_cookie_default.a.get('bookingId'), "/payment-confirmation")).query(Object(defineProperty["a" /* default */])({
      paymentStatus: paymentStatus,
      bookingStatusBeforePayment: Object(mapper["b" /* getStatusFromCode */])(bookingStatus),
      currency: currency,
      amount: paymentAmountValue,
      provider: providerId,
      t: paymentId
    }, LOCALE_KEY, locale));
    return redirectUrl.toString();
  }

  function buildRedirectionBE(currency, paymentAmountValue, bookingId, providerId, paymentId, bookingStatus, paymentStatus, locale) {
    var normalizedPaymentStatus;
    var targetUrl = 'confirmation';

    switch (paymentStatus) {
      case constants["e" /* API_PAYMENT_STATUS_SUCCESS */]:
        normalizedPaymentStatus = constants["q" /* PAYMENT_STATUS_SUCCESS */];
        break;

      case constants["c" /* API_PAYMENT_STATUS_REFUSED_CM */]:
        normalizedPaymentStatus = constants["o" /* PAYMENT_STATUS_REFUSED_CM */].toLowerCase();
        break;

      case constants["d" /* API_PAYMENT_STATUS_REFUSED_PSP */]:
        normalizedPaymentStatus = constants["p" /* PAYMENT_STATUS_REFUSED_PSP */].toLowerCase();
        break;

      case constants["a" /* API_PAYMENT_STATUS_CANCELED */]:
        normalizedPaymentStatus = constants["k" /* PAYMENT_STATUS_CANCELED */].toLowerCase();
        targetUrl = 'banking';
        break;

      default:
        normalizedPaymentStatus = constants["l" /* PAYMENT_STATUS_FAILURE */];
        break;
    }

    var isCmtaInCookies = !!js_cookie_default.a.get('bookingQueryParams').includes('cm_ta');

    var queryParams = IframePayment_objectSpread(IframePayment_objectSpread(IframePayment_objectSpread(IframePayment_objectSpread({}, bookingId ? {
      bi: bookingId
    } : null), {}, {
      paymentStatus: normalizedPaymentStatus
    }, isCmtaInCookies && {
      cm_ta: isCmtaInCookies
    }), {}, {
      selectedProposalId: js_cookie_default.a.get(booking_constants["n" /* BOOKING_SELECTED_RESORT_ID */])
    }, paymentStatus === constants["a" /* API_PAYMENT_STATUS_CANCELED */] ? URI_default.a.parseQuery(js_cookie_default.a.get(booking_constants["m" /* BOOKING_QUERY_PARAMS */])) : null), {}, Object(defineProperty["a" /* default */])({}, LOCALE_KEY, locale));

    return routeBuilder["a" /* buildUrl */](targetUrl, {}, queryParams);
  }

  Object(react["useEffect"])(function () {
    // ⚠️ setTimeout is mandatory for work firefox (we don't know why)
    setTimeout(function () {
      setIsMounted(true);
    }, 0);

    var handleIframePostMessage = function handleIframePostMessage(event) {
      var _event$data;

      if ((event === null || event === void 0 ? void 0 : (_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.eventType) !== IframeCallbackView["a" /* EVENT_TYPE_IFRAME */]) {
        return;
      }

      var _event$data2 = event.data,
          paymentId = _event$data2.paymentId,
          callbackUrl = _event$data2.callbackUrl,
          providerResponse = _event$data2.providerResponse;
      dispatch(Object(globalLoader_action["d" /* startLoading */])());
      var url = new URI_default.a(callbackUrl);

      var _url$segment = url.segment(),
          _url$segment2 = Object(slicedToArray["a" /* default */])(_url$segment, 5),
          locale = _url$segment2[2],
          bookingStatus = _url$segment2[3],
          isCart = _url$segment2[4];

      var isPLE = !!bookingStatus;
      var redirectMethod = isPLE ? buildRedirectionPLE : buildRedirectionBE;
      var bookingId;
      var currency;
      var paymentAmountValue;
      var providerId;
      var paymentStatus;

      if (!Object(payment_utils["e" /* shouldApprovePayment */])(paymentProviderId)) {
        if (paymentProviderId === PaymentInfo_const["e" /* ECYBERSOURCE_PSP_ID */] && !!paymentId) {
          // Poll the server for the notification status only for cybersource
          return Object(polling["a" /* asyncPolling */])({
            delay: 3000,
            // 3 seconds
            timeout: 60 * 1000,
            // 5 minutes
            pollingFunction: function pollingFunction() {
              return graphqlClient["a" /* default */].runNoCacheQuery(makePaymentStatusMutation(paymentId), appContext, {
                requestName: requestDictionary["fd" /* PAYMENT_STATUS_MUTATION */]
              });
            },
            shouldPollAgain: function shouldPollAgain(response) {
              var _response$paymentStat, _response$paymentStat2, _response$paymentStat3, _response$paymentStat4, _response$paymentStat5, _response$paymentStat6, _response$paymentStat7, _response$paymentStat8, _response$paymentStat9, _response$paymentStat10, _response$paymentStat11, _response$paymentStat12;

              bookingId = response === null || response === void 0 ? void 0 : (_response$paymentStat = response.paymentStatus) === null || _response$paymentStat === void 0 ? void 0 : (_response$paymentStat2 = _response$paymentStat.finalPaymentResponse) === null || _response$paymentStat2 === void 0 ? void 0 : (_response$paymentStat3 = _response$paymentStat2.booking) === null || _response$paymentStat3 === void 0 ? void 0 : _response$paymentStat3.bookingId;
              currency = response === null || response === void 0 ? void 0 : (_response$paymentStat4 = response.paymentStatus) === null || _response$paymentStat4 === void 0 ? void 0 : (_response$paymentStat5 = _response$paymentStat4.finalPaymentResponse) === null || _response$paymentStat5 === void 0 ? void 0 : (_response$paymentStat6 = _response$paymentStat5.payment) === null || _response$paymentStat6 === void 0 ? void 0 : _response$paymentStat6.currency;
              paymentAmountValue = response === null || response === void 0 ? void 0 : (_response$paymentStat7 = response.paymentStatus) === null || _response$paymentStat7 === void 0 ? void 0 : (_response$paymentStat8 = _response$paymentStat7.finalPaymentResponse) === null || _response$paymentStat8 === void 0 ? void 0 : (_response$paymentStat9 = _response$paymentStat8.payment) === null || _response$paymentStat9 === void 0 ? void 0 : _response$paymentStat9.paymentAmount;
              paymentStatus = response === null || response === void 0 ? void 0 : (_response$paymentStat10 = response.paymentStatus) === null || _response$paymentStat10 === void 0 ? void 0 : (_response$paymentStat11 = _response$paymentStat10.finalPaymentResponse) === null || _response$paymentStat11 === void 0 ? void 0 : (_response$paymentStat12 = _response$paymentStat11.payment) === null || _response$paymentStat12 === void 0 ? void 0 : _response$paymentStat12.paymentStatus;
              return paymentStatus === constants["b" /* API_PAYMENT_STATUS_PENDING */];
            },
            onResponse: function onResponse(response) {
              var _response$paymentStat13, _response$paymentStat14, _response$paymentStat15, _response$paymentStat16, _response$paymentStat17, _response$paymentStat18, _response$paymentStat19, _response$paymentStat20, _response$paymentStat21, _response$paymentStat22, _response$paymentStat23, _response$paymentStat24, _response$paymentStat25, _response$paymentStat26, _response$paymentStat27;

              bookingId = (response === null || response === void 0 ? void 0 : (_response$paymentStat13 = response.paymentStatus) === null || _response$paymentStat13 === void 0 ? void 0 : (_response$paymentStat14 = _response$paymentStat13.finalPaymentResponse) === null || _response$paymentStat14 === void 0 ? void 0 : (_response$paymentStat15 = _response$paymentStat14.booking) === null || _response$paymentStat15 === void 0 ? void 0 : _response$paymentStat15.bookingId) || '';
              currency = response === null || response === void 0 ? void 0 : (_response$paymentStat16 = response.paymentStatus) === null || _response$paymentStat16 === void 0 ? void 0 : (_response$paymentStat17 = _response$paymentStat16.finalPaymentResponse) === null || _response$paymentStat17 === void 0 ? void 0 : (_response$paymentStat18 = _response$paymentStat17.payment) === null || _response$paymentStat18 === void 0 ? void 0 : _response$paymentStat18.currency;
              paymentAmountValue = response === null || response === void 0 ? void 0 : (_response$paymentStat19 = response.paymentStatus) === null || _response$paymentStat19 === void 0 ? void 0 : (_response$paymentStat20 = _response$paymentStat19.finalPaymentResponse) === null || _response$paymentStat20 === void 0 ? void 0 : (_response$paymentStat21 = _response$paymentStat20.payment) === null || _response$paymentStat21 === void 0 ? void 0 : _response$paymentStat21.paymentAmount;
              providerId = response === null || response === void 0 ? void 0 : (_response$paymentStat22 = response.paymentStatus) === null || _response$paymentStat22 === void 0 ? void 0 : (_response$paymentStat23 = _response$paymentStat22.finalPaymentResponse) === null || _response$paymentStat23 === void 0 ? void 0 : (_response$paymentStat24 = _response$paymentStat23.payment) === null || _response$paymentStat24 === void 0 ? void 0 : _response$paymentStat24.providerId;
              paymentStatus = response === null || response === void 0 ? void 0 : (_response$paymentStat25 = response.paymentStatus) === null || _response$paymentStat25 === void 0 ? void 0 : (_response$paymentStat26 = _response$paymentStat25.finalPaymentResponse) === null || _response$paymentStat26 === void 0 ? void 0 : (_response$paymentStat27 = _response$paymentStat26.payment) === null || _response$paymentStat27 === void 0 ? void 0 : _response$paymentStat27.paymentStatus;
              var redirectUrl = redirectMethod(currency, paymentAmountValue, bookingId, providerId, paymentId, bookingStatus, paymentStatus, locale); // If the payment was successfully completed and it was initiated from the cart :
              // Send a request to the API for cleaning the Cart until the moment that they'll do their job.

              if (isCart) {
                return graphqlClient["a" /* default */].runNoCacheQuery("mutation {\n                      cleanCartService(bookingId : \"".concat(bookingId, "\") { status }\n                    }"), {
                  authenticationToken: js_cookie_default.a.get('ACCESS_TOKEN')
                }, {
                  requestName: requestDictionary["Vc" /* PAYMENT_CLEAN_CART */]
                }).then(function () {
                  return window.parent.location.href = redirectUrl;
                }).catch(function () {
                  return window.parent.location.href = redirectUrl;
                });
              }

              return window.parent.location.href = redirectUrl;
            }
          }).catch(function (e) {
            logger_logger["default"].error(e);
            paymentStatus = constants["c" /* API_PAYMENT_STATUS_REFUSED_CM */];
            var redirectUrl = redirectMethod(currency, paymentAmountValue, bookingId, providerId, paymentId, bookingStatus, paymentStatus, locale);
            return window.parent.location.href = redirectUrl;
          });
        } // redirect to notify server route


        return dist["windowWrapper"].setLocation(new URI_default.a(event.data.callbackUrl).setSearch(event.data.providerResponse).toString());
      } // redirect to approve/notify server route (approve, maybe 3ds, then the ol' classic notify)


      dist["windowWrapper"].setLocation(Object(PaymentInfo_utils["a" /* getApproveRoute */])({
        appContext: appContext,
        location: location,
        eventParams: IframePayment_objectSpread({
          callbackUrl: callbackUrl,
          paymentId: paymentId
        }, providerResponse)
      }));
    };

    window.addEventListener('message', handleIframePostMessage, false);
    return function () {
      return window.removeEventListener('message', handleIframePostMessage, false);
    };
  }, []);
  var height = '';

  switch (paymentProviderId) {
    case 'MOGONE':
      height = '371px';
      break;

    case PaymentInfo_const["f" /* EGLOBALCOLLECT_PSP_ID */]:
      height = '500px';
      break;

    default:
      height = isTablet ? '730px' : '830px';
      break;
  }

  return IframePayment_jsx(react["Fragment"], null, IframePayment_jsx("iframe", {
    "data-testid": "PaymentProcessIframe",
    title: Object(src_i18n["g" /* t */])('booking.banking.pageTitle'),
    ref: iframe,
    className: "w-full border-0",
    style: {
      height: height
    },
    frameBorder: "0"
  }), isMounted && iframe.current && iframe.current.contentDocument &&
  /*#__PURE__*/
  // needed for prevent bug when it's rerender and we no longer had access to the iframe (there has been a redirection)
  // $FlowFixMe
  Object(react_dom["createPortal"])(children, iframe.current.contentDocument.body));
};
// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/payment-process/FormAutoSubmit.jsx

var FormAutoSubmit_jsx = react_default.a.createElement;

var FormAutoSubmit_FormAutoSubmit = function FormAutoSubmit(_ref) {
  var pspData = _ref.pspData;
  var formRef = Object(react["useRef"])();
  Object(react["useEffect"])(function () {
    // $FlowFixMe current is always defined, useEffect is trigger after mount ...
    formRef.current.submit();
  }, []);
  return FormAutoSubmit_jsx("form", {
    ref: formRef,
    id: pspData.id,
    className: "ContactInfoRedirectForm",
    "data-testid": "PaymentProcess-FormAutoSubmit",
    method: pspData.method,
    action: pspData.url
  }, Object.entries(pspData.fields).map(function (_ref2) {
    var _ref3 = Object(slicedToArray["a" /* default */])(_ref2, 2),
        fieldName = _ref3[0],
        fieldValue = _ref3[1];

    return FormAutoSubmit_jsx("input", {
      key: fieldName,
      type: "hidden",
      name: fieldName,
      value: fieldValue
    });
  }));
};
// EXTERNAL MODULE: ./src/hooks/use-previous/usePrevious.js
var usePrevious = __webpack_require__("AbLU");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngine.utils.js
var BookingEngine_utils = __webpack_require__("47Eh");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/PaymentProcess.jsx


var PaymentProcess_jsx = react_default.a.createElement;






























var PaymentProcess_isSellerNoDelcrederePSP = function isSellerNoDelcrederePSP(paymentProviderId) {
  return paymentProviderId === PaymentInfo_const["l" /* NODELCRERE_TRANSFER_PSP_ID */] || paymentProviderId === PaymentInfo_const["k" /* NODELCRERE_CHEQUE_PSP_ID */];
};

var PaymentProcess_isHipayCmtaPSP = function isHipayCmtaPSP(paymentProviderId) {
  return paymentProviderId === PaymentInfo_const["i" /* HIPAY_CMTA_PSP_ID */];
};

var PaymentProcess_PaymentProcess = function PaymentProcess(_ref) {
  var amountToPay = _ref.amountToPay,
      browserInfo = _ref.browserInfo,
      paymentProviderId = _ref.paymentProviderId,
      paymentConditionId = _ref.paymentConditionId,
      token = _ref.token,
      paymentProcessId = _ref.paymentProcessId,
      onErrorCallback = _ref.onErrorCallback,
      paymentMethod = _ref.paymentMethod,
      creditCardCvc = _ref.creditCardCvc;
  var dispatch = Object(es["d" /* useDispatch */])();
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var salesmanID = Object(es["e" /* useSelector */])(function (state) {
    return state.seller.sellerInfo.salesmanID;
  });
  var selectedProposal = Object(es["e" /* useSelector */])(booking_selector["k" /* getCurrentProposal */]);
  var prevPaymentMethod = Object(usePrevious["a" /* usePrevious */])(paymentMethod);

  var _useState = Object(react["useState"])(null),
      errorPaymentMessageKey = _useState[0],
      setErrorPaymentMessageKey = _useState[1];

  var _useState2 = Object(react["useState"])(true),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = Object(react["useState"])(null),
      pspData = _useState3[0],
      setPspData = _useState3[1];

  var elementToScroll = Object(react["useRef"])();

  var _useContext = Object(react["useContext"])(PaymentInfoContext["a" /* PaymentInfoContext */]),
      trackPayment = _useContext.trackPayment,
      paymentRedirectMutation = _useContext.paymentRedirectMutation,
      currency = _useContext.currency,
      getPaymentErrorMessagePath = _useContext.getPaymentErrorMessagePath,
      onPaymentProgress = _useContext.onPaymentProgress,
      donationAmount = _useContext.donationAmount,
      sellerOptionRedirect = _useContext.sellerOptionRedirect;

  var track = Object(useTracking["a" /* useTracking */])();
  var isIframe = paymentMethod.category === PaymentInfo_const["m" /* PAYMENT_METHOD_CREDIT_CARD_CATEGORY */] && Object(payment_utils["d" /* isIframePayment */])(paymentProviderId);
  var isExternalProvider = !isIframe && paymentProviderId !== PaymentInfo_const["o" /* WECHAT_PSP_ID */];
  var explanatoryBillingInfoText = Object(src_i18n["g" /* t */])('booking.banking.billingAdressFilling');
  var shouldShowBillingInfo = isIframe && explanatoryBillingInfoText;
  Object(react["useEffect"])(function () {
    var fetchPaymentInfos = /*#__PURE__*/function () {
      var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _bookingsPaymentRedir;

        var _yield$paymentRedirec, bookingsPaymentRedirect, paymentMethodLabel;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(appContext.isCmta && !appContext.cmta.isDelCredere && PaymentProcess_isHipayCmtaPSP(paymentProviderId))) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return Object(ContactInfoUtils["q" /* submitOptionFromProposal */])(appContext, appContext.cmta.email, selectedProposal.id, selectedProposal.productId, false, salesmanID, true)(selectedProposal);

              case 3:
                _context.next = 5;
                return paymentRedirectMutation({
                  amountToPay: amountToPay,
                  browserInfo: browserInfo,
                  paymentProviderId: paymentProviderId,
                  paymentConditionId: paymentConditionId,
                  isMobile: !isTablet,
                  isIframe: isIframe,
                  token: token,
                  donationAmount: donationAmount || null,
                  creditCardCvc: creditCardCvc,
                  location: location
                });

              case 5:
                _yield$paymentRedirec = _context.sent;
                bookingsPaymentRedirect = _yield$paymentRedirec.bookingsPaymentRedirect;
                paymentMethodLabel = (bookingsPaymentRedirect === null || bookingsPaymentRedirect === void 0 ? void 0 : (_bookingsPaymentRedir = bookingsPaymentRedirect.fields) === null || _bookingsPaymentRedir === void 0 ? void 0 : _bookingsPaymentRedir.pp) ? bookingsPaymentRedirect.fields.pp.split(' ').map(lodash["capitalize"]).join(' ') : paymentMethod.label;
                trackPayment === null || trackPayment === void 0 ? void 0 : trackPayment({
                  orderId: bookingsPaymentRedirect.orderId,
                  bookingId: bookingsPaymentRedirect.bookingId,
                  amountToPay: amountToPay,
                  paymentProviderId: paymentProviderId,
                  paymentMethodLabel: paymentMethodLabel
                });

                if (!(isExternalProvider && bookingsPaymentRedirect.method === 'GET')) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return", window.location.replace(new URI_default.a(bookingsPaymentRedirect.url).addQuery(bookingsPaymentRedirect.fields).toString()));

              case 11:
                setPspData(bookingsPaymentRedirect);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchPaymentInfos() {
        return _ref2.apply(this, arguments);
      };
    }();

    var continuePaymentProcess = /*#__PURE__*/function () {
      var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var errors;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!isLoading) {
                  setIsLoading(true);
                }

                if (errorPaymentMessageKey) {
                  setErrorPaymentMessageKey(null);
                }

                if (isExternalProvider) {
                  dispatch(Object(globalLoader_action["d" /* startLoading */])(Object(src_i18n["g" /* t */])('booking.banking.loadingLabel')));
                }

                if (onPaymentProgress) {
                  onPaymentProgress(location);
                }

                if (!(appContext.isCmta && !appContext.cmta.isDelCredere && PaymentProcess_isSellerNoDelcrederePSP(paymentProviderId))) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 8;
                return sellerOptionRedirect();

              case 8:
                _context2.next = 12;
                break;

              case 10:
                _context2.next = 12;
                return fetchPaymentInfos();

              case 12:
                _context2.next = 24;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](0);
                errors = _context2.t0.errors || [];
                trackPayment === null || trackPayment === void 0 ? void 0 : trackPayment({
                  orderId: null,
                  isErrored: true,
                  amountToPay: amountToPay,
                  paymentProviderId: paymentProviderId,
                  paymentMethodLabel: paymentMethod.label
                });

                if (!ple_utils["l" /* hasAuthResponseError */](_context2.t0)) {
                  _context2.next = 20;
                  break;
                }

                return _context2.abrupt("return", Object(BookingEngine_utils["e" /* redirectToOidc */])(appContext));

              case 20:
                if (isExternalProvider) {
                  dispatch(Object(globalLoader_action["c" /* endLoading */])());
                }

                logger_default.a.error(_context2.t0);
                onErrorCallback();
                setErrorPaymentMessageKey(getPaymentErrorMessagePath({
                  statusCode: Object(lodash["get"])(errors, '[0].statusCode', statusCode_constants["b" /* STATUS_CODE_400 */]),
                  errorCode: Object(lodash["get"])(errors[0], 'responseBody.errors[0].error_code'),
                  track: track
                }));

              case 24:
                _context2.prev = 24;
                setIsLoading(false);
                return _context2.finish(24);

              case 27:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 14, 24, 27]]);
      }));

      return function continuePaymentProcess() {
        return _ref3.apply(this, arguments);
      };
    }();

    continuePaymentProcess();

    if (elementToScroll.current) {
      Object(scrollToElement["a" /* scrollToElement */])(elementToScroll.current);
    }
  }, [paymentProcessId]);
  /**
   * if the paymentMethod change and there is still pspData we don't want to do anything and reset pspData
   * e.g. when the user for EOgone change from visa to paypal we don't want to redirect before the data for paypal are retrieved
   */

  if (prevPaymentMethod !== paymentMethod && pspData) {
    setPspData(null);
    return null;
  }

  if (errorPaymentMessageKey) {
    return PaymentProcess_jsx("div", {
      ref: elementToScroll
    }, PaymentProcess_jsx(FormFeedback["a" /* FormFeedback */], {
      className: "PaymentInfo-errorMessage",
      isError: true,
      message: Object(src_i18n["g" /* t */])(errorPaymentMessageKey)
    }));
  } // external psp with post redirect


  if (isExternalProvider) {
    if (!pspData) {
      return null;
    }

    return PaymentProcess_jsx(FormAutoSubmit_FormAutoSubmit, {
      pspData: pspData
    });
  }

  if (isLoading || !pspData) {
    return PaymentProcess_jsx("div", {
      "data-testid": "PaymentProcess-loader",
      ref: elementToScroll,
      className: "PaymentIframe-asyncLoaderContainer"
    }, PaymentProcess_jsx("div", {
      className: "PaymentIframe-asyncLoader"
    }, PaymentProcess_jsx(AsyncLoader["a" /* AsyncLoader */], null)));
  }

  return PaymentProcess_jsx("div", {
    className: "mt-px20",
    ref: elementToScroll
  }, paymentProviderId === PaymentInfo_const["o" /* WECHAT_PSP_ID */] ? PaymentProcess_jsx(WeChatPayment_WeChatPayment, {
    currency: currency,
    qrCodeUrl: pspData.url,
    orderId: pspData.orderId,
    customerId: pspData.customerId,
    amountToPay: amountToPay,
    timeoutCallback: onErrorCallback
  }) : PaymentProcess_jsx(react["Fragment"], null, shouldShowBillingInfo && PaymentProcess_jsx(Notification["a" /* Notification */], {
    className: "my-px10 w-full py-px5 px-px30",
    color: colors["a" /* COLORS */].ORANGE,
    hasBorder: true,
    icon: icons["a" /* ICONS */].WARNING,
    iconWidth: "1.3rem"
  }, PaymentProcess_jsx("p", {
    className: "text-orange font-sans text-base"
  }, explanatoryBillingInfoText)), PaymentProcess_jsx(IframePayment_IframePayment, {
    paymentProviderId: paymentProviderId
  }, PaymentProcess_jsx(FormAutoSubmit_FormAutoSubmit, {
    pspData: pspData
  }))));
};
// EXTERNAL MODULE: ./src/utils/context/contextUtils.js
var contextUtils = __webpack_require__("igjW");

// EXTERNAL MODULE: ./src/client/local-storage-api/index.js
var local_storage_api = __webpack_require__("1RIK");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// CONCATENATED MODULE: ./src/client/components/widgets/payment-info/PaymentInfo.jsx

var PaymentInfo_jsx = react_default.a.createElement;

function PaymentInfo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function PaymentInfo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PaymentInfo_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PaymentInfo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


















var PaymentInfo_getNoDelcPaymentLabel = function getNoDelcPaymentLabel(paymentProviderId) {
  var mapIdsToLabels = {
    NODELCRERE_TRANSFER: PaymentInfo_const["a" /* BANK_TRANSFER_LABEL */],
    NODELCRERE_CHEQUE: PaymentInfo_const["b" /* CHEQUE_LABEL */]
  };
  return mapIdsToLabels[paymentProviderId] || '';
};

var PaymentInfo_getPaymentMethodLabel = function getPaymentMethodLabel(paymentProviderId) {
  // All paiements methods are credit card by default
  switch (paymentProviderId) {
    case PaymentInfo_const["g" /* ESSPSCT_PSP_ID */]:
    case PaymentInfo_const["l" /* NODELCRERE_TRANSFER_PSP_ID */]:
      return 'Bank Transfer';

    case PaymentInfo_const["h" /* ESSPSDD_PSP_ID */]:
    case PaymentInfo_const["k" /* NODELCRERE_CHEQUE_PSP_ID */]:
      return 'Debit';

    default:
      return 'Credit Card';
  }
};

var PaymentInfo_PaymentInfoFormik = function PaymentInfoFormik(_ref) {
  var i18n = _ref.i18n,
      shouldShowPaymentProcess = _ref.shouldShowPaymentProcess,
      paymentProcessId = _ref.paymentProcessId,
      paymentProcessOnError = _ref.paymentProcessOnError,
      paymentProviders = _ref.paymentProviders,
      availablePaymentProviders = _ref.availablePaymentProviders,
      paymentSchedule = _ref.paymentSchedule,
      totalPrice = _ref.totalPrice,
      formatedPrice = _ref.formatedPrice,
      startDate = _ref.startDate,
      renderBottomNavbar = _ref.renderBottomNavbar,
      dispatch = _ref.dispatch;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var formik = Object(formik_esm["e" /* useFormikContext */])();

  var _useContext = Object(react["useContext"])(PaymentInfoContext["a" /* PaymentInfoContext */]),
      isFreeDeposit = _useContext.isFreeDeposit;

  var paymentInProgress = shouldShowPaymentProcess && !paymentProcessOnError;
  var selectedPaymentProvider = Object(react["useMemo"])(function () {
    return paymentProviders.find(function (_ref2) {
      var id = _ref2.id;
      return id === formik.values.paymentProviderId;
    });
  }, [formik.values.paymentProviderId]);
  var paymentMethod = Object(react["useMemo"])(function () {
    var _selectedPaymentProvi;

    return (selectedPaymentProvider === null || selectedPaymentProvider === void 0 ? void 0 : (_selectedPaymentProvi = selectedPaymentProvider.paymentMethods) === null || _selectedPaymentProvi === void 0 ? void 0 : _selectedPaymentProvi.find(function (_ref3) {
      var id = _ref3.id;
      return id === formik.values.paymentMethodId;
    })) || {
      category: '',
      id: (selectedPaymentProvider === null || selectedPaymentProvider === void 0 ? void 0 : selectedPaymentProvider.id) || '',
      image: (selectedPaymentProvider === null || selectedPaymentProvider === void 0 ? void 0 : selectedPaymentProvider.logo) || '',
      label: PaymentInfo_getPaymentMethodLabel(formik.values.paymentProviderId),
      timePaymentConditions: []
    };
  }, [selectedPaymentProvider === null || selectedPaymentProvider === void 0 ? void 0 : selectedPaymentProvider.id, formik.values.paymentMethodId]);
  var paymentCategory = '';

  switch (formik.values.paymentProviderId) {
    case PaymentInfo_const["d" /* CYBERSOURCE_PSP_ID */]:
    case PaymentInfo_const["j" /* HIPAY_PSP_ID */]:
      paymentCategory = 'Credit card';
      break;

    case PaymentInfo_const["g" /* ESSPSCT_PSP_ID */]:
    case PaymentInfo_const["l" /* NODELCRERE_TRANSFER_PSP_ID */]:
      paymentCategory = 'Bank transfer';
      break;

    case PaymentInfo_const["h" /* ESSPSDD_PSP_ID */]:
      paymentCategory = 'Debit';
      break;

    default:
      paymentCategory = '';
      break;
  }

  Object(local_storage_api["c" /* setInLocalStorage */])(tracking_constants["s" /* SELECTED_PAYMENT_TRACKING */], paymentCategory);
  var isIframe = paymentMethod.category === PaymentInfo_const["m" /* PAYMENT_METHOD_CREDIT_CARD_CATEGORY */] && Object(payment_utils["d" /* isIframePayment */])(formik.values.paymentProviderId);
  var isIframePaymentWithConditions = isIframe && formik.values.paymentProviderId === PaymentInfo_const["f" /* EGLOBALCOLLECT_PSP_ID */];
  var isHipayProvider = formik.values.paymentProviderId === PaymentInfo_const["j" /* HIPAY_PSP_ID */]; // in case of hosted fields we pick the paymentProduct instead
  // if the payment isHipay

  var paymentConditionIdOrCardForHipay = isHipayProvider && formik.values.paymentProduct || formik.values.paymentConditionId;
  var isNotDelCredereCmta = appContext.isCmta && !appContext.cmta.isDelCredere;
  var needToSelectPaymentMethod = isNotDelCredereCmta && (selectedPaymentProvider === null || selectedPaymentProvider === void 0 ? void 0 : selectedPaymentProvider.paymentMethods.length) !== 0 && !formik.values.paymentMethodId;
  var hideContinueButton = paymentInProgress || isIframePaymentWithConditions || needToSelectPaymentMethod;
  return PaymentInfo_jsx(react["Fragment"], null, PaymentInfo_jsx(PaymentForm_PaymentForm, {
    i18n: i18n,
    paymentSchedule: paymentSchedule,
    paymentProviders: availablePaymentProviders,
    formik: formik,
    price: {
      value: totalPrice,
      formattedValue: formatedPrice || ''
    },
    startDate: startDate || '',
    shouldDisableFields: paymentInProgress
  }), shouldShowPaymentProcess ? PaymentInfo_jsx("div", {
    className: "mt-px20"
  }, PaymentInfo_jsx(PaymentProcess_PaymentProcess, {
    amountToPay: isFreeDeposit ? Number(formik.values.freeDeposit) : Number(formik.values.amountToPay),
    browserInfo: formik.values.browserInfo,
    paymentProviderId: formik.values.paymentProviderId,
    paymentConditionId: paymentConditionIdOrCardForHipay,
    token: formik.values.token,
    creditCardCvc: formik.values['cybersource-card-cvc'] // $FlowFixMe paymentProcessId is never null at this point
    ,
    paymentProcessId: paymentProcessId,
    onErrorCallback: function onErrorCallback() {
      dispatch({
        type: 'paymentProcessError'
      });
      formik.setStatus({
        paymentProcessOnError: true
      });
      formik.setSubmitting(false);
    },
    paymentMethod: paymentMethod
  })) : formik.values.paymentProviderId === PaymentInfo_const["o" /* WECHAT_PSP_ID */] && PaymentInfo_jsx(WeChatTutorial_WeChatTutorial, null), renderBottomNavbar({
    validationCallback: function validationCallback() {
      if (isFreeDeposit) {
        formik.values.amountToPay = formik.values.freeDeposit;
      }

      js_cookie_default.a.set(PaymentInfo_const["n" /* PAYMENT_METHOD_LABEL */], PaymentInfo_getNoDelcPaymentLabel(formik.values.paymentProviderId), {
        secure: !Object(contextUtils["d" /* isStrictlyDevelopmentEnv */])()
      });
      formik.submitForm();
      return Promise.reject();
    },
    hideContinueButton: hideContinueButton
  }));
};

var defaultState = {
  shouldShowPaymentProcess: false,
  paymentProcessOnError: false,
  paymentProcessId: null
};

var reducer = function reducer(state, action) {
  switch (action.type) {
    case 'showPaymentProcess':
      return {
        shouldShowPaymentProcess: true,
        paymentProcessOnError: false,
        paymentProcessId: Date.now() // just for trigger the re-fetch of data in payment process

      };

    case 'paymentProcessError':
      return PaymentInfo_objectSpread(PaymentInfo_objectSpread({}, state), {}, {
        paymentProcessOnError: true
      });

    case 'reset':
      return defaultState;

    default:
      throw new Error();
  }
};

var PaymentInfo_PaymentInfo = function PaymentInfo(_ref4) {
  var _availablePaymentProv;

  var i18n = _ref4.i18n,
      paymentSchedule = _ref4.paymentSchedule,
      totalPrice = _ref4.totalPrice,
      formatedPrice = _ref4.formatedPrice,
      startDate = _ref4.startDate,
      paymentProviders = _ref4.paymentProviders,
      renderBottomNavbar = _ref4.renderBottomNavbar;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var _useContext2 = Object(react["useContext"])(PaymentInfoContext["a" /* PaymentInfoContext */]),
      donationAmount = _useContext2.donationAmount;

  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useReducer = Object(react["useReducer"])(reducer, defaultState),
      _useReducer$ = _useReducer[0],
      shouldShowPaymentProcess = _useReducer$.shouldShowPaymentProcess,
      paymentProcessId = _useReducer$.paymentProcessId,
      paymentProcessOnError = _useReducer$.paymentProcessOnError,
      dispatch = _useReducer[1];

  var availablePaymentProviders = Object(paymentProvidersUtils["c" /* getEnabledPaymentProviders */])(paymentProviders, !isTablet, appContext);
  return PaymentInfo_jsx(SiteContainer["a" /* SiteContainer */], {
    size: "small"
  }, PaymentInfo_jsx(formik_esm["d" /* Formik */], {
    initialValues: {
      freeDeposit: '',
      amountToPay: paymentSchedule.depositAmount.value || totalPrice,
      paymentProviderId: (availablePaymentProviders === null || availablePaymentProviders === void 0 ? void 0 : (_availablePaymentProv = availablePaymentProviders[0]) === null || _availablePaymentProv === void 0 ? void 0 : _availablePaymentProv.id) || '',
      paymentMethodId: '',
      paymentConditionId: '',
      termsAndConditions: {
        cgv: false,
        donation: false
      },
      donation: donationAmount
    },
    onSubmit: function onSubmit(_, actions) {
      dispatch({
        type: 'showPaymentProcess'
      });
      actions.setStatus({
        paymentProcessOnError: false
      });
    },
    isInitialValid: false
  }, PaymentInfo_jsx(PaymentInfo_PaymentInfoFormik, {
    i18n: i18n,
    shouldShowPaymentProcess: shouldShowPaymentProcess,
    paymentProcessId: paymentProcessId,
    paymentProcessOnError: paymentProcessOnError,
    paymentProviders: paymentProviders,
    availablePaymentProviders: availablePaymentProviders,
    paymentSchedule: paymentSchedule,
    totalPrice: totalPrice,
    formatedPrice: formatedPrice,
    startDate: startDate,
    renderBottomNavbar: renderBottomNavbar,
    dispatch: dispatch
  })));
};

/***/ }),

/***/ "z7Vv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "z9Jh":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ "zCbR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRACKING_PREFIX_MAPPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTrackingTransport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureCityCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDepartureCityName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isSummer; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _client_tracking_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("829J");



var WITH_TRANSPORT = 'with Transport';
var WITHOUT_TRANSPORT = 'without Transport';
var NO_DEPARTURE_CITY = 'NO';
var TRACKING_PREFIX_MAPPING = {
  ACTIVITIES: 'activities',
  CHILDCARE: 'childcare',
  WELLNESS: 'wellness'
};
function getTrackingTransport(departureCityCode) {
  return departureCityCode && Object(lodash__WEBPACK_IMPORTED_MODULE_0__["toUpper"])(departureCityCode) !== NO_DEPARTURE_CITY ? WITH_TRANSPORT : WITHOUT_TRANSPORT;
}
function getDepartureCityCode(departureCityCode) {
  return departureCityCode && Object(lodash__WEBPACK_IMPORTED_MODULE_0__["toUpper"])(departureCityCode) !== NO_DEPARTURE_CITY ? departureCityCode : WITHOUT_TRANSPORT;
}
function getDepartureCityName(departureCityCode, departureCityName) {
  return departureCityName && departureCityCode && Object(lodash__WEBPACK_IMPORTED_MODULE_0__["toUpper"])(departureCityCode) !== NO_DEPARTURE_CITY ? departureCityName : '';
}
function isSummer(date) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["inRange"])(Number(moment__WEBPACK_IMPORTED_MODULE_1___default()(date).format('MMDD')), _client_tracking_constants__WEBPACK_IMPORTED_MODULE_2__[/* SUMMER_DATE_START */ "y"], _client_tracking_constants__WEBPACK_IMPORTED_MODULE_2__[/* SUMMER_DATE_END */ "x"]);
}

/***/ }),

/***/ "zSnQ":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var fails = __webpack_require__("fhLv");
var toIndexedObject = __webpack_require__("dNjr");
var nativeGetOwnPropertyDescriptor = __webpack_require__("5h8T").f;
var DESCRIPTORS = __webpack_require__("uGjT");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ "zaNA":
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ "zcYo":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("nJrx");
var Iterators = __webpack_require__("oa0l");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "zr3P":
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__("kn3Q");

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ })

},[["bbLz",1,2,3,5,0,4,6,7,8,9,10,11,12,13,16,15,14,18,17,20,19,23,22,24,26]]]);